(function() {
    'use strict';

    angular.module('scope.commons.projects', ['ui.router', 'scope.constants']).config(config);

    config.$inject = ['$stateProvider'];

    var baseProjectUrlParams = [
        'search',
        'ordering',
        'customer_name',
        'project_quality_reviewer',
        'project_financial_quality_reviewer',
        'max_start_date',
        'min_start_date',
        'max_deadline',
        'min_deadline',
        'max_number_of_assessments',
        'min_number_of_assessments',
        'max_completion_percentage',
        'min_completion_percentage',
        'page_size',
        'deal_number'
    ];

    var baseProjectDetailsUrlParams = [
        'search',
        'ordering',
        'assessor_name',
        'min_date',
        'max_date',
        'tool_type',
        'status',
        'language',
        'financial_specialist',
        'quality_reviewer',
        'financial_quality_reviewer',
        'page_size',
        'deal_number'
    ];

    function createUrlWithParams(url, params) {
        return (
            url +
            params.reduce(function(memo, param, index) {
                return memo + param + (params.length - 1 === index ? '' : '&');
            }, '?')
        );
    }

    function config($stateProvider) {
        $stateProvider
            .state('base.projects', {
                url: createUrlWithParams('/projects/{page:[0-9]*}', baseProjectUrlParams),
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectsListView.html',
                        controller: 'projectsListController'
                    }
                }
            })
            .state('base.projects-detail', {
                url: createUrlWithParams('/projects/detail/{id:[0-9]+}/{page:[0-9]*}', baseProjectDetailsUrlParams),
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectDetailView.html'
                    }
                }
            })
            .state('base.projects-create', {
                url: '/projects/create',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectCreateView.html'
                    }
                }
            })
            .state('base.projects-edit', {
                url: '/projects/edit/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectEditView.html',
                        controller: 'projectEditController'
                    }
                }
            })
            .state('base.projects-analytics', {
                url: '/projects/analytics/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/projectAnalyticsView.html',
                        controller: 'projectAnalyticsController'
                    }
                }
            })
            .state('base.projects-analytics.demographic', {
                url: '/demographic',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/demographicsView.html',
                        controller: 'projectAnalyticsDemographicsController'
                    }
                }
            })
            .state('base.projects-analytics.financial', {
                url: '/financial',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/financialView.html',
                        controller: 'projectAnalyticsFinancialController'
                    }
                }
            })
            .state('base.projects-analytics.finance-history', {
                url: '/finance-history',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/financeHistoryView.html',
                        controller: 'projectAnalyticsFinanceHistoryController'
                    }
                }
            })
            .state('base.projects-analytics.production', {
                url: '/production',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/productionSalesView.html',
                        controller: 'projectAnalyticsProductionController'
                    }
                }
            })
            // FR-024. The route exists unconditionally; what the rollout flag
            // gates is the navigation entry and the tab's content. A guarded
            // route would 404 a bookmarked URL in a way that looks like the
            // project is gone, and the endpoint refuses the data anyway.
            .state('base.projects-analytics.data-quality', {
                url: '/data-quality',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/dataQualityView.html',
                        controller: 'projectAnalyticsDataQualityController'
                    }
                }
            })
            // AD-2194. Unconditional route for the same reason as Data Quality;
            // the flag gates the navigation entry and the endpoints. `tab` keeps
            // the sub-tab in the URL without reloading the controller.
            .state('base.projects-analytics.reassessment', {
                url: '/reassessment?tab',
                reloadOnSearch: false,
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/reassessmentView.html',
                        controller: 'projectAnalyticsReassessmentController'
                    }
                }
            })
            // AD-2197. Unconditional like the other analytics routes; the flag
            // gates the navigation entry and the endpoints.
            .state('base.projects-analytics.score-analysis', {
                url: '/score-analysis?view',
                reloadOnSearch: false,
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAnalytics/scoreAnalysisView.html',
                        controller: 'projectAnalyticsScoreAnalysisController'
                    }
                }
            })
            .state('base.projects-add-assessment', {
                url: '/projects/add-assessment/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'projects/templates/projectAddAssessmentView.html',
                        controller: 'projectAddAssessmentController'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('UnassignAssessorController', UnassignAssessorController);

    UnassignAssessorController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'assessment'
    ];

    function UnassignAssessorController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        assessment
    ) {
        console.log('Assessment - ', assessment);
        $rootScope.$broadcast(EVENT_LOADER.hide);

        $scope.assessment = assessment;
        $scope.unassignedAssessors = [];

        $scope.chosenAssessors = $scope.assessment.assessmentinvitations.objects.filter(function(assignment) {
            return assignment.assigned_as !== 'financial_specialist' && assignment.status !== 'declined';
        });

        $scope.chosenSpecialists = $scope.assessment.assessmentinvitations.objects.filter(function(assignment) {
            return assignment.assigned_as === 'financial_specialist' && assignment.status !== 'declined';
        });

        $scope.save = save;
        $scope.cancel = cancel;
        $scope.unassignAssessor = unassignAssessor;
        $scope.isSubmitDisabled = isSubmitDisabled;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function unassignAssessor(assessor, shouldBeAdded) {
            if (shouldBeAdded) {
                $scope.unassignedAssessors.push(assessor.url);
            } else {
                $scope.unassignedAssessors = $scope.unassignedAssessors.filter(function(chosenAssessor) {
                    return chosenAssessor !== assessor.url;
                });
            }
        }

        function save() {
            $uibModalInstance.close($scope.unassignedAssessors);
        }

        function cancel(reason) {
            $uibModalInstance.dismiss(reason);
        }

        function isSubmitDisabled() {
            return !$scope.unassignedAssessors.length;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('unassignAllAssessorsController', unassignAllAssessorsController);

    unassignAllAssessorsController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'assessments'
    ];

    function unassignAllAssessorsController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        assessments
    ) {
        console.log('Assessments - ', assessments);
        $rootScope.$broadcast(EVENT_LOADER.hide);

        $scope.assessments = assessments;
        $scope.unassignedAssessors = [];
        $scope.selectAll = false;

        $scope.chosenAssessors = $scope.assessments.flatMap(assessment =>
            assessment.assessmentinvitations.objects.filter(
                assignment => assignment.assigned_as !== 'financial_specialist' && assignment.status !== 'declined'
            )
        );

        $scope.chosenSpecialists = $scope.assessments.flatMap(assessment =>
            assessment.assessmentinvitations.objects.filter(
                assignment => assignment.assigned_as === 'financial_specialist' && assignment.status !== 'declined'
            )
        );

        $scope.save = save;
        $scope.cancel = cancel;
        $scope.unassignAssessor = unassignAssessor;
        $scope.isSubmitDisabled = isSubmitDisabled;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.chosenAssessors.forEach(assessor => {
            unassignAssessor(assessor, true);
        });

        $scope.chosenSpecialists.forEach(specialist => {
            unassignAssessor(specialist, true);
        });

        //Remove duplicates
        $scope.unassignedAssessors = [...new Set($scope.unassignedAssessors)];

        function unassignAssessor(assessor, shouldBeAdded) {
            if (shouldBeAdded) {
                $scope.unassignedAssessors.push(assessor.url);
            } else {
                $scope.unassignedAssessors = $scope.unassignedAssessors.filter(function(chosenAssessor) {
                    return chosenAssessor !== assessor.url;
                });
            }
        }

        function save() {
            $uibModalInstance.close($scope.unassignedAssessors);
        }

        function cancel(reason) {
            $uibModalInstance.dismiss(reason);
        }

        function isSubmitDisabled() {
            return !$scope.unassignedAssessors.length;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('shareProjectController', shareProjectController);

    shareProjectController.$inject = [
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'EVENT_LOADER',
        'EMAIL_VALID_REGEX',
        '$log',
        'apiUrl',
        '$timeout',
        'siCustomers',
        'project',
        'siHrm'
    ];

    function shareProjectController(
        $rootScope,
        $uibModalInstance,
        $uibModal,
        EVENT_LOADER,
        EMAIL_VALID_REGEX,
        $log,
        apiUrl,
        $timeout,
        siCustomers,
        project,
        siHrm
    ) {
        console.log('Project - ', project);

        const vm = this;

        vm.email = '';
        vm.project = project;
        vm.checkEmailAvailability = checkEmailAvailability;
        vm.cancel = () => $uibModalInstance.dismiss('cancel');
        vm.save = save;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function checkEmailAvailability(email, form) {
            form.email.$setValidity('required', false);
            const isEmailValid = EMAIL_VALID_REGEX.test(email);
            if (isEmailValid) {
                siHrm.checkEmailAvailability(email).then(res => {
                    vm.dashboardAccess = res.dashboard_access;
                    form.email.$setValidity('required', res.dashboard_access);
                });
            }
        }

        function save(email) {
            $uibModalInstance.close(email);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('openAssessmentMessageController', openAssessmentMessageController);

    openAssessmentMessageController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'EVENT_LOADER',
        'assessee',
        'projects'
    ];

    function openAssessmentMessageController($scope, $rootScope, $uibModalInstance, EVENT_LOADER, assessee, projects) {
        $scope.assessee = assessee;
        $scope.projects = projects;

        $scope.cancel = cancel;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function cancel(all) {
            $uibModalInstance.dismiss('cancel');
            if (all) modal1.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('editAssessmentController', editAssessmentController);

    editAssessmentController.$inject = [
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'siCustomers',
        'project',
        'me',
        'LANGUAGES',
        'assessment',
        'qualityReviewers',
        'financialSpecialists',
        'siTooltype',
        'moment',
        'siProjects',
        '$q'
    ];

    function editAssessmentController(
        $rootScope,
        $uibModalInstance,
        $uibModal,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        siCustomers,
        project,
        me,
        LANGUAGES,
        assessment,
        qualityReviewers,
        financialSpecialists,
        siTooltype,
        moment,
        siProjects,
        $q
    ) {
        const vm = this;
        vm.setInitialState = setInitialState; // Assign as a function, do not invoke it here
        vm.customerParams = {
            fields: ['users', 'users__customer_contact'],
            producing_organization: false,
            page_size: 999
        };

        console.log('Assessment - ', assessment);
        console.log('Project - ', project);
        console.log('FS -', financialSpecialists);
        console.log('Project customer members - ', project.customer_members.objects);
        console.log('Project contact - ', project.contact.url);

        const userParams = {
            fields: ['user'],
            is_active: true,
            user__is_active: true,
            page_size: 999
        };
        // Fetch customers
        const customersResourcePromise = siCustomers.getCustomers(vm.customerParams),
            // eslint-disable-next-line indent
            defaultQRPromise = siHrm
                .getDefaultQR({ fields: ['default_quality_reviewer__user'] })
                .then(settings => (settings.default_quality_reviewer || {}).user),
            hrmResourcePromise = siHrm.getEmployees(userParams);
        vm.loading = true;
        $rootScope.$broadcast(EVENT_LOADER.show);
        $q.all([customersResourcePromise, defaultQRPromise, hrmResourcePromise])
            .then(promises => {
                [vm.customers, vm.defaultQR, vm.employees] = promises;
                vm.employees = vm.employees.results
                    .filter(employee => employee.is_active)
                    .map(employee => employee.user)
                    .sort((a, b) => {
                        if (a.last_name < b.last_name) return -1;
                        if (a.last_name > b.last_name) return 1;
                        return 0;
                    });
                vm.clientDashAdmins = Object.assign({}, qualityReviewers);
                return vm.setInitialState(); // Ensure setInitialState() returns a promise
            })
            .catch(err => {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                vm.loading = false;
                console.error('Customers Error:', err);
                toastr.error('Failed to load customers. Please try again.');
            });

        // Controller methods
        vm.cancel = () => $uibModalInstance.dismiss('cancel');
        vm.isPast = date => moment(date).isBefore(moment().format('YYYY-MM-DD')) && date !== vm.originalPlannedDate;
        vm.save = save;
        vm.isValidDate = isValidDate;
        vm.assessment = assessment;
        vm.originalPlannedDate = assessment.date;
        vm.project = project;
        vm.isDashboardUserAdmin = me.isDashboardUserAdmin();
        vm.isEmployee = me.isEmployee();
        vm.languages = LANGUAGES;
        vm.financialQualityReviewers = [];
        vm.financialQualityReviewer = assessment.display_financial_quality_reviewer;
        vm.qualityReviewers = [];
        vm.qualityReviewer = assessment.display_quality_reviewer;
        vm.qualityReviewers = _.uniq(
            vm.project.customer_members.objects
                .concat(vm.project.contact)
                .map(e => e.user)
                .concat(qualityReviewers.results)
                .concat([vm.project.quality_reviewer])
                .concat([vm.project.financial_quality_reviewer])
                .concat(vm.qualityReviewer ? [vm.qualityReviewer] : []),
            'url'
        );

        console.log('editAssessmentView qualityReviewers:', qualityReviewers.results);
        console.log('editAssessmentView qualityReviewer:', vm.qualityReviewer);

        function setInitialState() {
            return updateContacts().then(() => {
                return updateQRList(vm.project.customer_performs_qc);
            });
        }
        function save(assessment) {
            if (vm.isEmployee || (vm.isDashboardUserAdmin && vm.project.customer_performs_qc)) {
                assessment.quality_reviewer = vm.qualityReviewer;
                assessment.financial_quality_reviewer = vm.financialQualityReviewer;
            } else {
                delete assessment.quality_reviewer;
                delete assessment.financial_quality_reviewer;
            }
            $uibModalInstance.close(assessment);
        }

        function isValidDate(d) {
            if (!vm.assessment.assessmentassignments.objects) return true;

            return vm.assessment.assessmentassignments.objects
                .filter(item => item.assessor.expiration_date)
                .every(item => new Date(d) <= new Date(item.assessor.expiration_date));
        }

        function updateQRList(clientPerformsQC) {
            vm.qualityReviewers = siProjects.updateQRList(
                clientPerformsQC,
                vm.clientDashAdmins,
                vm.project.customer.url,
                vm.defaultQR,
                vm.defaultFinancialQR,
                vm.employees
            );
            vm.originalQualityReviewers = Object.assign({}, vm.qualityReviewers);
            console.log('ORIGINAL QUALITY REVIEWERS');
            console.log(vm.originalQualityReviewers);
            updateQualityReviewers();
        }

        function updateQualityReviewers() {
            $timeout(() => {
                vm.qualityReviewers = siProjects.updateQualityReviewers(
                    vm.qualityReviewers,
                    vm.contacts,
                    vm.project.customer_members.objects,
                    vm.project.contact.url
                );
                console.log('QR AFTER RENDER -> ', vm.qualityReviewers.results);
                $rootScope.$broadcast(EVENT_LOADER.hide);
                vm.loading = false;
            });
        }

        function updateContacts() {
            vm.contacts = [];
            console.log('DEBUG:', vm.customers, vm.project.customer.url);
            return siProjects.updateProjectContacts(vm.project.customer.id).then(contacts => (vm.contacts = contacts));
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('duplicateUserController', duplicateUserController);

    duplicateUserController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'EVENT_LOADER',
        'assessee',
        'duplicate',
        'modal1',
        'apiUrl',
        'siScope',
        'assessment',
        '$log',
        'tools'
    ];

    function duplicateUserController(
        $scope,
        $rootScope,
        $uibModalInstance,
        EVENT_LOADER,
        assessee,
        duplicate,
        modal1,
        apiUrl,
        siScope,
        assessment,
        $log,
        tools
    ) {
        $scope.tool = tools.filter(tool => tool.url === assessment.tool).reduce((memo, tool) => tool.title, 'tool');
        $scope.assessee = assessee;
        $scope.assessment = assessment;
        $scope.country = duplicate.display_country;
        $scope.city = duplicate.city;
        $scope.last_assessment = duplicate.last_assessment;
        $scope.last_assessment_type = duplicate.last_assessment_type;
        $scope.save = save;
        $scope.cancel = cancel;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function save(assessee) {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('createPOController', createPOController);

    createPOController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'project',
        '$q',
        'EVENT_LOADER',
        'assessment',
        'toastr'
    ];

    function createPOController($scope, $rootScope, $uibModalInstance, project, $q, EVENT_LOADER, assessment, toastr) {
        $scope.project = project;
        $scope.assessment = assessment;
        $scope.existingPO = '';

        var poPromise = siCustomers.getPOs({ page_size: 9999 });
        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([poPromise])
            .then(function(promises) {
                $scope.producing_organizations = promises[0];
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                toastr.error('Error while getting PO - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        $scope.saveNew = function() {
            var po = {
                assessment: $scope.assessment,
                existingPO: false
            };

            $uibModalInstance.close(po);
        };

        $scope.saveExisting = function() {
            $scope.assessment.producing_organization = $scope.existingPO;
            $scope.assessment.producing_organization_name = $scope.existingPO.name;

            var po = {
                assessment: $scope.assessment,
                existingPO: $scope.existingPO
            };

            $uibModalInstance.close(po);
        };
        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('changeQualityReviewerController', changeQualityReviewerController);

    changeQualityReviewerController.$inject = [
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'siCustomers',
        'project',
        'me',
        'LANGUAGES',
        'assessment',
        'qualityReviewers',
        'financialSpecialists',
        'siTooltype',
        'moment',
        'siProjects',
        '$q',
        'changeMultipleQualityReviewers'
    ];

    function changeQualityReviewerController(
        $rootScope,
        $uibModalInstance,
        $uibModal,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        siCustomers,
        project,
        me,
        LANGUAGES,
        assessment,
        qualityReviewers,
        financialSpecialists,
        siTooltype,
        moment,
        siProjects,
        $q,
        changeMultipleQualityReviewers
    ) {
        const vm = this;
        vm.setInitialState = setInitialState; // Assign as a function, do not invoke it here
        vm.isProTool = siTooltype.isProTool;
        vm.customerParams = {
            fields: ['users', 'users__customer_contact'],
            producing_organization: false,
            page_size: 999
        };

        console.log('Assessment - ', assessment);
        console.log('Project - ', project);
        console.log('FS -', financialSpecialists);
        console.log('Project customer members - ', project.customer_members.objects);
        console.log('Project contact - ', project.contact.url);

        const userParams = {
            fields: ['user'],
            is_active: true,
            user__is_active: true,
            page_size: 999
        };
        // Fetch customers
        const customersResourcePromise = siCustomers.getCustomers(vm.customerParams),
            // eslint-disable-next-line indent
            defaultQRPromise = siHrm
                .getDefaultQR({ fields: ['default_quality_reviewer__user'] })
                .then(settings => (settings.default_quality_reviewer || {}).user),
            hrmResourcePromise = siHrm.getEmployees(userParams);
        vm.loading = true;
        $rootScope.$broadcast(EVENT_LOADER.show);
        $q.all([customersResourcePromise, defaultQRPromise, hrmResourcePromise])
            .then(promises => {
                [vm.customers, vm.defaultQR, vm.employees] = promises;
                vm.employees = vm.employees.results
                    .filter(employee => employee.is_active)
                    .map(employee => employee.user)
                    .sort((a, b) => {
                        if (a.last_name < b.last_name) return -1;
                        if (a.last_name > b.last_name) return 1;
                        return 0;
                    });
                vm.clientDashAdmins = Object.assign({}, qualityReviewers);
                return vm.setInitialState(); // Ensure setInitialState() returns a promise
            })
            .catch(err => {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                vm.loading = false;
                console.error('Customers Error:', err);
                toastr.error('Failed to load customers. Please try again.');
            });

        // Controller methods
        vm.cancel = () => $uibModalInstance.dismiss('cancel');
        vm.isPast = date => moment(date).isBefore(moment().format('YYYY-MM-DD')) && date !== vm.originalPlannedDate;
        vm.save = save;
        vm.assessment = assessment;
        vm.originalPlannedDate = assessment.date;
        vm.project = project;
        vm.isDashboardUserAdmin = me.isDashboardUserAdmin();
        vm.isEmployee = me.isEmployee();
        vm.languages = LANGUAGES;
        vm.financialQualityReviewers = [];
        vm.financialQualityReviewer = changeMultipleQualityReviewers
            ? null
            : assessment.display_financial_quality_reviewer;
        vm.qualityReviewers = [];
        vm.qualityReviewer = changeMultipleQualityReviewers ? null : assessment.display_quality_reviewer;
        vm.qualityReviewers = _.uniq(
            vm.project.customer_members.objects
                .concat(vm.project.contact)
                .map(e => e.user)
                .concat(qualityReviewers.results)
                .concat([vm.project.quality_reviewer])
                .concat([vm.project.financial_quality_reviewer])
                .concat(vm.qualityReviewer ? [vm.qualityReviewer] : []),
            'url'
        );

        console.log('editAssessmentView qualityReviewers:', qualityReviewers.results);
        console.log('editAssessmentView qualityReviewer:', vm.qualityReviewer);

        function setInitialState() {
            return updateContacts().then(() => {
                return updateQRList(vm.project.customer_performs_qc);
            });
        }
        function save(assessment) {
            if (vm.isEmployee || (vm.isDashboardUserAdmin && vm.project.customer_performs_qc)) {
                assessment.quality_reviewer = vm.qualityReviewer;
                assessment.financial_quality_reviewer = vm.financialQualityReviewer;
            } else {
                delete assessment.quality_reviewer;
                delete assessment.financial_quality_reviewer;
            }
            $uibModalInstance.close(assessment);
        }

        function updateQRList(clientPerformsQC) {
            vm.qualityReviewers = siProjects.updateQRList(
                clientPerformsQC,
                vm.clientDashAdmins,
                vm.project.customer.url,
                vm.defaultQR,
                vm.defaultFinancialQR,
                vm.employees
            );
            vm.originalQualityReviewers = Object.assign({}, vm.qualityReviewers);
            console.log('ORIGINAL QUALITY REVIEWERS');
            console.log(vm.originalQualityReviewers);
            updateQualityReviewers();
        }

        function updateQualityReviewers() {
            $timeout(() => {
                vm.qualityReviewers = siProjects.updateQualityReviewers(
                    vm.qualityReviewers,
                    vm.contacts,
                    vm.project.customer_members.objects,
                    vm.project.contact.url
                );
                console.log('QR AFTER RENDER -> ', vm.qualityReviewers.results);
                $rootScope.$broadcast(EVENT_LOADER.hide);
                vm.loading = false;
            });
        }

        function updateContacts() {
            vm.contacts = [];
            console.log('DEBUG:', vm.customers, vm.project.customer.url);
            return siProjects.updateProjectContacts(vm.project.customer.id).then(contacts => (vm.contacts = contacts));
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('addMemberController', addMemberController);

    addMemberController.$inject = ['$scope', '$uibModalInstance', 'siHrm', 'project'];

    function addMemberController($scope, $uibModalInstance, siHrm, project) {
        $scope.project = project;
        siHrm.getEmployees({ fields: ['user'] }).then(employees => {
            $scope.employees = employees;
        });

        $scope.save = member => $uibModalInstance.close(member);
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('addAssessorController', addAssessorController);

    addAssessorController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'project',
        'tools',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'countries',
        'LANGUAGES',
        'assessment',
        'toastr'
    ];

    function addAssessorController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        project,
        tools,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        countries,
        LANGUAGES,
        assessment,
        toastr
    ) {
        console.log('Assessment - ', assessment);

        $scope.tools = tools;
        $scope.project = project;
        $scope.countries = countries.map(function(country) {
            return country.name;
        });
        $scope.assessment = assessment;
        $scope.selectedLanguage = LANGUAGES.find(function(lang) {
            return lang.id === $scope.assessment.language;
        }).name;

        $scope.assessorSearch = '';
        $scope.specialistSearch = '';

        if ($scope.assessment.assignments) {
            $scope.previousChosenAssessor = $scope.assessment.assignments.find(function(assignment) {
                return assignment.assigned_as !== 'financial_specialist';
            });

            $scope.isAssessorChosen = $scope.previousChosenAssessor;

            $scope.previousChosenSpecialist = $scope.assessment.assignments.find(function(assignment) {
                return assignment.assigned_as === 'financial_specialist';
            });

            $scope.isSpecialistChosen = $scope.previousChosenSpecialist;
        } else {
            $scope.isAssessorChosen = false;
            $scope.isSpecialistChosen = false;
        }

        $scope.specialists = [];
        $scope.assessors = [];

        $scope.save = save;
        $scope.cancel = cancel;

        $scope.doAssessorSearch = doAssessorSearch;
        $scope.doSpecialistSearch = doSpecialistSearch;
        $scope.selectSpecialist = selectSpecialist;
        $scope.isSpecialistSelected = isSpecialistSelected;
        $scope.selectAssessor = selectAssessor;
        $scope.isAssessorSelected = isAssessorSelected;
        $scope.isSubmitDisabled = isSubmitDisabled;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isAssessorSelected(assessor) {
            return $scope.chosenAssessor && $scope.chosenAssessor.id === assessor.id;
        }

        function isSpecialistSelected(specialist) {
            return $scope.chosenSpecialist && $scope.chosenSpecialist.id === specialist.id;
        }

        function selectSpecialist(specialist) {
            if ($scope.chosenSpecialist && specialist.id === $scope.chosenSpecialist.id) {
                $scope.chosenSpecialist = null;
            } else {
                $scope.chosenSpecialist = specialist;
            }
        }

        function selectAssessor(assessor) {
            if ($scope.chosenAssessor && assessor.id === $scope.chosenAssessor.id) {
                $scope.chosenAssessor = null;
            } else {
                $scope.chosenAssessor = assessor;
            }
        }

        function doAssessorSearch(assessor) {
            $scope.assessorsNotFound = false;
            $scope.searchingAssessors = true;
            if (!assessor) {
                return;
            }
            let assessorParams = {};
            if ($scope.assessment.tool.type.name === 'SCOPE Rapid') {
                assessorParams = {
                    skills: 'is_data_collector',
                    name: assessor,
                    tools: $scope.assessment.tool.type.name,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user'],
                    is_active: 1
                };
            } else {
                assessorParams = {
                    skills: 'is_assessor',
                    name: assessor,
                    tools: $scope.assessment.tool.type.name,
                    expiration_date: $scope.assessment.date,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user'],
                    is_active: 1
                };
            }
            siHrm
                .getAssessors(assessorParams)
                .then(function(assessors) {
                    $scope.assessors = assessors.results;
                    $scope.searchingAssessors = false;
                    $scope.chosenAssessor = null;
                    if ($scope.assessors.length === 0) $scope.assessorsNotFound = true;
                })
                .catch(function() {
                    toastr.error('Error while searching for Assessors');
                    $scope.searchingAssessors = false;
                });
        }

        function doSpecialistSearch(specialist) {
            $scope.specialistsNotFound = false;
            $scope.searchingSpecialists = true;
            if (!specialist) {
                return;
            }
            siHrm
                .getAssessors({
                    skills: 'financial_specialist',
                    name: specialist,
                    tools: $scope.assessment.tool.type.name,
                    expiration_date: $scope.assessment.date,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user']
                })
                .then(function(specialists) {
                    $scope.specialists = specialists.results;
                    $scope.searchingSpecialists = false;
                    $scope.chosenSpecialist = null;
                    if ($scope.specialists.length === 0) $scope.specialistsNotFound = true;
                })
                .catch(function() {
                    toastr.error('Error while searching for Financial Specialists');
                    $scope.searchingSpecialists = false;
                });
        }

        function save(assessment) {
            var saveObject = {
                url: assessment.url,
                chosenAssessors: $scope.chosenAssessor ? [$scope.chosenAssessor] : [],
                chosenSpecialists: $scope.chosenSpecialist ? [$scope.chosenSpecialist] : [],
                anotherAssessment: $scope.anotherAssessment ? $scope.anotherAssessment : false
            };

            $uibModalInstance.close(saveObject);
        }

        function cancel(reason) {
            // Don't use cancel in step 2, because we need a page refresh even if no assessor is assigned
            $uibModalInstance.dismiss(reason);
        }

        function isSubmitDisabled() {
            var assessorPresent = $scope.chosenAssessor || $scope.isAssessorChosen;
            return !assessorPresent;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('addAssessmentController', addAssessmentController);

    addAssessmentController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'project',
        'tools',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siCustomers',
        'countries',
        'LANGUAGES',
        'assessment',
        'siScope'
    ];

    function addAssessmentController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        project,
        tools,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siCustomers,
        countries,
        LANGUAGES,
        assessment,
        siScope
    ) {
        console.log('Assessment - ', assessment);

        $scope.project = project;
        $scope.tools = tools;
        $scope.countries = countries;
        $scope.assessment = {
            second_party: false,
            producing_organization:
                project.customer && project.customer.producing_organization
                    ? project.customer.producing_organization.url
                    : {}
        };
        $scope.languages = LANGUAGES;
        $scope.showInfo = false;
        $scope.showSearchResults = false;
        $scope.assessee = {};

        $scope.save = save;
        $scope.cancel = cancel;
        $scope.isPast = isPast;
        $scope.doSearch = doSearch;
        $scope.toggleSelectPO = toggleSelectPO;
        $scope.resetSelection = resetSelection;
        $scope.addUser = addUser;
        $scope.isPOSelected = isPOSelected;
        $scope.hasPOSelected = hasPOSelected;
        $scope.getAssessors = getAssessors;

        if (assessment && assessment.id) {
            $scope.assessee = assessment.id
                ? { name: assessment.producing_organization.name, country: assessment.producing_organization.country }
                : {};
            $scope.assessment = assessment;
            doSearch($scope.assessee);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getAssessors(assessor) {
            if ($scope.assessee.country == undefined || $scope.assessee.country == '') {
                return null;
            } else {
                let test = siScope.getItem(`${apiUrl}/customers/producing_organizations/?name=${assessor}`).then(
                    res =>
                        res &&
                        res.results &&
                        res.results
                            .filter(function(iteam) {
                                return iteam.country == $scope.assessee.country;
                            })
                            .map(item => item.name)
                );

                return test;
            }
        }

        $scope.$watch('assessment.tool', function(newVal, oldVal) {
            console.log(oldVal);
            if (newVal) {
                // Find the selected tool object by its URL
                var selectedTool = $scope.tools.find(function(tool) {
                    return tool.url === newVal;
                });
                // Update assessment.tool_type_id with the selected tool's type_id
                if (selectedTool) {
                    $scope.assessment.tool_type_id = selectedTool.type_id;
                }
            } else {
                // Reset tool_type_id if no tool is selected
                $scope.assessment.tool_type_id = null;
            }
        });

        function save(assessment) {
            //timeout as the model from ui-bootstrap is a slow fuck to update

            var matchingLimit = $scope.project.customer.tool_limits_data.find(function(limit) {
                return limit.tool_type_id === assessment.tool_type_id;
            });

            if (matchingLimit && matchingLimit.available <= 0) {
                alert(
                    `You have reached the maximum number of assessments available in your account for tool type: ${matchingLimit.tool_type_name}. To continue using our service, please reach out to your account manager to purchase additional assessments. They will be happy to assist you in finding the best plan for your needs.`
                );
                return; // Exit the function if available is 0 or less
            }

            $timeout(() => {
                if (isPast(assessment.date)) {
                    return;
                }

                var create = {
                    id: assessment.id || false,
                    date: assessment.date,
                    language: assessment.language,
                    url: assessment.url || `${apiUrl}/assessments/assessments/`,
                    producing_organization: assessment.producing_organization.url
                };

                if (!create.id) {
                    delete create.id;
                }

                if ($scope.isUserAdded) {
                    create.isUserAdded = true;
                }

                const assessmentObject = !$scope.assessment.id ? _.extend(create, { tool: assessment.tool }) : create;

                const result = {
                    ax: assessmentObject, // Keep ax as the original assessmentObject
                    tool_type_id: assessment.tool_type_id // Example new parameter (e.g., tool_type_id)
                };

                $uibModalInstance.close(result);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function isPast(d) {
            return moment(d).isBefore(moment().format('YYYY-MM-DD'));
        }

        function isPOSelected(po) {
            return $scope.assessment.producing_organization.id === po.id;
        }

        function toggleSelectPO(po) {
            if (!isPOSelected(po)) {
                if (po.open_assessments_in_projects.length > 0) {
                    $uibModal.open({
                        templateUrl: 'projects/templates/modals/openAssessmentMessageModal.html',
                        controller: 'openAssessmentMessageController',
                        resolve: {
                            assessee: () => po.name,
                            projects: () => po.open_assessments_in_projects
                        }
                    });
                }
            }

            $scope.assessment.producing_organization = isPOSelected(po) ? {} : po;
        }

        function hasPOSelected(assessment) {
            return Object.keys(assessment.producing_organization).length > 0;
        }

        function resetSelection(assessment) {
            $scope.showSearchResults = false;
            assessment.producing_organization = {};
        }

        function addUser() {
            if ($scope.isUserAdded) {
                return ($scope.isUserAdded = false);
            }
            $scope.assessment.producing_organization = {};

            $rootScope.$broadcast(EVENT_LOADER.show);
            siCustomers
                .getPOs({
                    name: $scope.assessee.name,
                    country: $scope.assessee.country,
                    fields: ['customer']
                })
                .then(res => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);

                    if (res && res.results && res.results.length) {
                        duplicateUserModal(res.results[0]);
                    } else {
                        adddUserModal();
                    }
                    //User is new
                });
        }

        function duplicateUserModal(duplicate) {
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/duplicateAssessee.html',
                    controller: 'duplicateUserController',
                    resolve: {
                        tools: () => $scope.tools,
                        assessee: () => Object.assign({}, $scope.assessee),
                        duplicate: () => duplicate,
                        assessment: () => $scope.assessment,
                        modal1: () => $uibModalInstance
                    }
                })
                .result.then(adddUserModal);
        }

        function adddUserModal() {
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/addAssesseeDetailModal(1b).html',
                    controller: 'addAssesseeDetailController',
                    resolve: {
                        assessee: () => Object.assign({}, $scope.assessee),
                        countries: () => $scope.countries,
                        modal1: () => $uibModalInstance
                    }
                })
                .result.then(assessee => {
                    $scope.isUserAdded = true;
                    $scope.assessee = assessee;
                    $scope.assessment.producing_organization = assessee;

                    // Automatically continue to step 2 if step 1 is complete
                    if ($scope.assessmentForm.$valid && hasPOSelected($scope.assessment)) {
                        save($scope.assessment);
                    }
                });
        }

        function doSearch(search) {
            $scope.isUserAdded = false;
            if (!search.country) {
                return;
            }

            const debouncedSearch = _.debounce(
                () => {
                    siCustomers.getPOs(params).then(res => {
                        $scope.showSearchResults = true;
                        $scope.pos = res.results;
                    });
                },
                250,
                { maxWait: 1000 }
            );

            const params = Object.assign(search, {
                fields: ['customer'],
                page_size: 20
            });

            return debouncedSearch();
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('addAssesseeDetailController', addAssesseeDetailController);

    addAssesseeDetailController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'EVENT_LOADER',
        'assessee',
        'countries',
        'modal1',
        'apiUrl',
        'siScope',
        '$log',
        'toastr'
    ];

    function addAssesseeDetailController(
        $scope,
        $rootScope,
        $uibModalInstance,
        EVENT_LOADER,
        assessee,
        countries,
        modal1,
        apiUrl,
        siScope,
        $log,
        toastr
    ) {
        $scope.assessee = assessee;
        $scope.country = countries.find(function(country) {
            return country.name === assessee.country;
        }).display_name;

        $scope.save = save;
        $scope.cancel = cancel;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function save(assessee) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            //Create then a new customer and then the PO
            var createdCustomer,
                customer = {
                    name: assessee.name,
                    email: assessee.email,
                    phone_number: assessee.phone_number
                };
            var customer_url = {
                url: apiUrl + '/customers/customers/'
            };
            var PO_url = {
                url: apiUrl + '/customers/producing_organizations/'
            };
            siScope
                .post(customer_url, customer)
                .then(function(newCustomer) {
                    if (!newCustomer || !newCustomer.url) {
                        throw new Error('Customer creation failed or invalid response.');
                    }
                    createdCustomer = newCustomer;
                    var params = {
                        customer: newCustomer.url,
                        city: assessee.city,
                        country: assessee.country
                    };
                    return siScope.post(PO_url, params);
                })
                .then(function(newPO) {
                    newPO.customer = createdCustomer;
                    newPO.country = newPO.country;
                    $uibModalInstance.close(newPO);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(error) {
                    toastr.error('This assessee already exists!');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    // $scope.error = 'Error Saving Assessee';
                    console.log(error);
                });
        }

        function cancel(all) {
            $uibModalInstance.dismiss('cancel');
            if (all) modal1.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('addAllAssessorsController', addAllAssessorsController);

    addAllAssessorsController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'project',
        'tools',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siHrm',
        'countries',
        'LANGUAGES',
        'assessment',
        'toastr',
        'isProAssessmentSelected'
    ];

    function addAllAssessorsController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        project,
        tools,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siHrm,
        countries,
        LANGUAGES,
        assessment,
        toastr,
        isProAssessmentSelected
    ) {
        console.log('Assessment - ', assessment);

        $scope.tools = tools;
        $scope.project = project;
        $scope.countries = countries.map(function(country) {
            return country.name;
        });
        $scope.assessment = assessment;
        $scope.selectedLanguage = LANGUAGES.find(function(lang) {
            return lang.id === $scope.assessment.language;
        }).name;

        $scope.isProAssessmentSelected = isProAssessmentSelected;
        $scope.assessorSearch = '';
        $scope.specialistSearch = '';

        if ($scope.assessment.assignments) {
            $scope.previousChosenAssessor = $scope.assessment.assignments.find(function(assignment) {
                return assignment.assigned_as !== 'financial_specialist';
            });

            $scope.isAssessorChosen = $scope.previousChosenAssessor;

            $scope.previousChosenSpecialist = $scope.assessment.assignments.find(function(assignment) {
                return assignment.assigned_as === 'financial_specialist';
            });

            $scope.isSpecialistChosen = $scope.previousChosenSpecialist;
        } else {
            $scope.isAssessorChosen = false;
            $scope.isSpecialistChosen = false;
        }

        $scope.specialists = [];
        $scope.assessors = [];

        $scope.save = save;
        $scope.cancel = cancel;

        $scope.doAssessorSearch = doAssessorSearch;
        $scope.doSpecialistSearch = doSpecialistSearch;
        $scope.selectSpecialist = selectSpecialist;
        $scope.isSpecialistSelected = isSpecialistSelected;
        $scope.selectAssessor = selectAssessor;
        $scope.isAssessorSelected = isAssessorSelected;
        $scope.isSubmitDisabled = isSubmitDisabled;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isAssessorSelected(assessor) {
            return $scope.chosenAssessor && $scope.chosenAssessor.id === assessor.id;
        }

        function isSpecialistSelected(specialist) {
            return $scope.chosenSpecialist && $scope.chosenSpecialist.id === specialist.id;
        }

        function selectSpecialist(specialist) {
            if ($scope.chosenSpecialist && specialist.id === $scope.chosenSpecialist.id) {
                $scope.chosenSpecialist = null;
            } else {
                $scope.chosenSpecialist = specialist;
            }
        }

        function selectAssessor(assessor) {
            if ($scope.chosenAssessor && assessor.id === $scope.chosenAssessor.id) {
                $scope.chosenAssessor = null;
            } else {
                $scope.chosenAssessor = assessor;
            }
        }

        function doAssessorSearch(assessor) {
            $scope.assessorsNotFound = false;
            $scope.searchingAssessors = true;
            if (!assessor) {
                return;
            }
            let assessorParams = {};
            if ($scope.assessment.tool.type.name === 'SCOPE Rapid') {
                assessorParams = {
                    skills: 'is_data_collector',
                    name: assessor,
                    tools: $scope.assessment.tool.type.name,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user'],
                    is_active: 1
                };
            } else {
                assessorParams = {
                    skills: 'is_assessor',
                    name: assessor,
                    tools: $scope.assessment.tool.type.name,
                    expiration_date: $scope.assessment.date,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user'],
                    is_active: 1
                };
            }
            siHrm
                .getAssessors(assessorParams)
                .then(function(assessors) {
                    $scope.assessors = assessors.results;
                    $scope.searchingAssessors = false;
                    $scope.chosenAssessor = null;
                    if ($scope.assessors.length === 0) $scope.assessorsNotFound = true;
                })
                .catch(function() {
                    toastr.error('Error while searching for Assessors');
                    $scope.searchingAssessors = false;
                });
        }

        function doSpecialistSearch(specialist) {
            $scope.specialistsNotFound = false;
            $scope.searchingSpecialists = true;
            if (!specialist) {
                return;
            }
            siHrm
                .getAssessors({
                    skills: 'financial_specialist',
                    name: specialist,
                    tools: $scope.assessment.tool.type.name,
                    expiration_date: $scope.assessment.date,
                    available_for_organization: $scope.project.customer.id,
                    page_size: 999,
                    fields: ['user']
                })
                .then(function(specialists) {
                    $scope.specialists = specialists.results;
                    $scope.searchingSpecialists = false;
                    $scope.chosenSpecialist = null;
                    if ($scope.specialists.length === 0) $scope.specialistsNotFound = true;
                })
                .catch(function() {
                    toastr.error('Error while searching for Financial Specialists');
                    $scope.searchingSpecialists = false;
                });
        }

        function save(assessment) {
            var saveObject = {
                url: assessment.url,
                chosenAssessors: $scope.chosenAssessor ? [$scope.chosenAssessor] : [],
                chosenSpecialists: $scope.chosenSpecialist ? [$scope.chosenSpecialist] : [],
                anotherAssessment: $scope.anotherAssessment ? $scope.anotherAssessment : false
            };

            $uibModalInstance.close(saveObject);
        }

        function cancel(reason) {
            // Don't use cancel in step 2, because we need a page refresh even if no assessor is assigned
            $uibModalInstance.dismiss(reason);
        }

        function isSubmitDisabled() {
            var assessorPresent = $scope.chosenAssessor || $scope.isAssessorChosen;
            return !assessorPresent;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.directives', [])
        .constant('EVENT_LOADER', {
            show: 'show-event-loader',
            hide: 'hide-event-loader'
        })
        .constant('COUNTRIES', [
            'Afghanistan',
            'Aland Islands',
            'Albania',
            'Algeria',
            'American Samoa',
            'Andorra',
            'Angola',
            'Anguilla',
            'Antarctica',
            'Antigua And Barbuda',
            'Argentina',
            'Armenia',
            'Aruba',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas',
            'Bahrain',
            'Bangladesh',
            'Barbados',
            'Belarus',
            'Belgium',
            'Belize',
            'Benin',
            'Bermuda',
            'Bhutan',
            'Bolivia, Plurinational State of',
            'Bonaire, Sint Eustatius and Saba',
            'Bosnia and Herzegovina',
            'Botswana',
            'Bouvet Island',
            'Brazil',
            'British Indian Ocean Territory',
            'Brunei Darussalam',
            'Bulgaria',
            'Burkina Faso',
            'Burundi',
            'Cambodia',
            'Cameroon',
            'Canada',
            'Cape Verde',
            'Cayman Islands',
            'Central African Republic',
            'Chad',
            'Chile',
            'China',
            'Christmas Island',
            'Cocos (Keeling) Islands',
            'Colombia',
            'Comoros',
            'Congo',
            'Congo, the Democratic Republic of the',
            'Cook Islands',
            'Costa Rica',
            "Côte d'Ivoire",
            'Croatia',
            'Cuba',
            'Cyprus',
            'Czech Republic',
            'Denmark',
            'Djibouti',
            'Dominica',
            'Dominican Republic',
            'Ecuador',
            'Egypt',
            'El Salvador',
            'Equatorial Guinea',
            'Eritrea',
            'Estonia',
            'Ethiopia',
            'Falkland Islands (Malvinas)',
            'Faroe Islands',
            'Fiji',
            'Finland',
            'France',
            'French Guiana',
            'French Polynesia',
            'French Southern Territories',
            'Gabon',
            'Gambia',
            'Georgia',
            'Germany',
            'Ghana',
            'Gibraltar',
            'Greece',
            'Greenland',
            'Grenada',
            'Guadeloupe',
            'Guam',
            'Guatemala',
            'Guernsey',
            'Guinea',
            'Guinea-Bissau',
            'Guyana',
            'Haiti',
            'Heard Island and McDonald Islands',
            'Holy See (Vatican City State)',
            'Honduras',
            'Hong Kong',
            'Hungary',
            'Iceland',
            'India',
            'Indonesia',
            'Iran, Islamic Republic of',
            'Iraq',
            'Ireland',
            'Isle of Man',
            'Israel',
            'Italy',
            'Jamaica',
            'Japan',
            'Jersey',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Kiribati',
            "Korea, Democratic People's Republic of",
            'Korea, Republic of',
            'Kuwait',
            'Kyrgyzstan',
            "Lao People's Democratic Republic",
            'Latvia',
            'Lebanon',
            'Lesotho',
            'Liberia',
            'Libya',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Macao',
            'Macedonia, The Former Yugoslav Republic Of',
            'Madagascar',
            'Malawi',
            'Malaysia',
            'Maldives',
            'Mali',
            'Malta',
            'Marshall Islands',
            'Martinique',
            'Mauritania',
            'Mauritius',
            'Mayotte',
            'Mexico',
            'Micronesia, Federated States of',
            'Moldova, Republic of',
            'Monaco',
            'Mongolia',
            'Montenegro',
            'Montserrat',
            'Morocco',
            'Mozambique',
            'Myanmar',
            'Namibia',
            'Nauru',
            'Nepal',
            'Netherlands',
            'New Caledonia',
            'New Zealand',
            'Nicaragua',
            'Niger',
            'Nigeria',
            'Niue',
            'Norfolk Island',
            'Northern Mariana Islands',
            'Norway',
            'Oman',
            'Pakistan',
            'Palau',
            'Palestinian Territory, Occupied',
            'Panama',
            'Papua New Guinea',
            'Paraguay',
            'Peru',
            'Philippines',
            'Pitcairn',
            'Poland',
            'Portugal',
            'Puerto Rico',
            'Qatar',
            'Reunion',
            'Romania',
            'Russian Federation',
            'Rwanda',
            'Saint Barthelemy',
            'Saint Helena, Ascension and Tristan da Cunha',
            'Saint Kitts and Nevis',
            'Saint Lucia',
            'Saint Martin (French Part)',
            'Saint Pierre and Miquelon',
            'Saint Vincent and the Grenadines',
            'Samoa',
            'San Marino',
            'Sao Tome and Principe',
            'Saudi Arabia',
            'Senegal',
            'Serbia',
            'Seychelles',
            'Sierra Leone',
            'Singapore',
            'Sint Maarten (Dutch Part)',
            'Slovakia',
            'Slovenia',
            'Solomon Islands',
            'Somalia',
            'South Africa',
            'South Georgia and the South Sandwich Islands',
            'South Sudan',
            'Spain',
            'Sri Lanka',
            'Sudan',
            'Suriname',
            'Svalbard and Jan Mayen',
            'Swaziland',
            'Sweden',
            'Switzerland',
            'Syrian Arab Republic',
            'Taiwan, Province of China',
            'Tajikistan',
            'Tanzania, United Republic of',
            'Thailand',
            'Timor-Leste',
            'Togo',
            'Tokelau',
            'Tonga',
            'Trinidad and Tobago',
            'Tunisia',
            'Turkey',
            'Turkmenistan',
            'Turks and Caicos Islands',
            'Tuvalu',
            'Uganda',
            'Ukraine',
            'United Arab Emirates',
            'United Kingdom',
            'United States',
            'United States Minor Outlying Islands',
            'Uruguay',
            'Uzbekistan',
            'Vanuatu',
            'Venezuela, Bolivarian Republic of',
            'Viet Nam',
            'Virgin Islands, British',
            'Virgin Islands, U.S.',
            'Wallis and Futuna',
            'Western Sahara',
            'Yemen',
            'Zambia',
            'Zimbabwe'
        ]);
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('sliderFilter', {
        bindings: {
            filters: '<',
            search: '&',
            min: '<',
            max: '<',
            maxName: '@',
            minName: '@'
        },
        require: {
            searchFiler: '^searchFilter'
        },
        templateUrl: 'components/search-filters/slider/slider-filter.component.html',
        controller: SliderFilterController
    });

    SliderFilterController.$inject = ['$rootScope', '$timeout', '$scope', '$location', 'SEARCH_FILTERS'];

    function SliderFilterController($rootScope, $timeout, $scope, $location, SEARCH_FILTERS) {
        var vm = this;

        vm.options = {
            floor: 0,
            ceil: 100
        };

        vm.minValue = 0;
        vm.maxValue = 100;

        vm.closeSearch = closeSearch;
        vm.doSearch = doSearch;

        vm.$onChanges = $onChanges;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onChanges(change) {
            if (typeof change.max.currentValue !== 'undefined' && typeof change.min.currentValue !== 'undefined') {
                vm.options.ceil = change.max.currentValue;
                vm.options.floor = change.min.currentValue;
            }

            var searchParams = $location.search();
            vm.minValue = searchParams[vm.minName] || vm.options.floor;
            vm.maxValue = searchParams[vm.maxName] || vm.options.ceil;
        }

        function doSearch(values) {
            $timeout(function() {}, 250);
            var filter = {};
            var filterDisplay = {
                removeKeys: [vm.maxName, vm.minName]
            };

            filter[vm.minName] = values.minValue;
            filter[vm.maxName] = values.maxValue;

            vm.search({ filter: filter, filterDisplay: filterDisplay });

            closeSearch();
        }

        function closeSearch() {
            $rootScope.$broadcast(SEARCH_FILTERS.close);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $rootScope.$on(SEARCH_FILTERS.close, function($event, triggeringElement) {
            // This one makes sure the limit positioning is correct after opening the filter
            if (vm.searchFiler.isOpen) {
                $timeout(function() {
                    $scope.$broadcast('rzSliderForceRender');
                });
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components', []);
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.components')
        .constant('SEARCH_FILTERS', {
            close: 'close-search-filters'
        })
        .component('searchFilter', {
            bindings: {
                name: '@',
                required: '<'
            },
            transclude: true,
            controller: SearchWrapperController,
            templateUrl: 'components/search-filters/search-wrapper/search-wrapper.html'
        });

    SearchWrapperController.$inject = ['$rootScope', '$timeout', '$element', 'SEARCH_FILTERS'];

    function SearchWrapperController($rootScope, $timeout, $element, SEARCH_FILTERS) {
        var vm = this;
        vm.isOpen = false;

        vm.toggle = toggle;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function toggle(isOpen) {
            vm.isOpen = !isOpen;
            $rootScope.$broadcast(SEARCH_FILTERS.close, $element);
        }

        $rootScope.$on(SEARCH_FILTERS.close, function($event, triggeringElement) {
            if (triggeringElement !== $element) {
                vm.isOpen = false;
            }
        });
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .component('searchFilters', {
            transclude: true,
            templateUrl: 'components/search-filters/search-filters/search-filters.html'
        });

}());

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('radioButtonFilter', {
        bindings: {
            search: '&',
            filters: '<',
            name: '@'
        },
        templateUrl: 'components/search-filters/radio-button/radio-button-filter.html',
        controller: RadioFilterController
    });

    RadioFilterController.$inject = ['$rootScope', '$element', '$timeout', '$location', 'SEARCH_FILTERS'];

    function RadioFilterController($rootScope, $element, $timeout, $location, SEARCH_FILTERS) {
        var vm = this;

        vm.doSearch = doSearch;
        vm.closeSearch = closeSearch;
        vm.isFilterSet = isFilterSet;

        vm.$onChanges = $onChanges;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onChanges() {
            var searchParams = $location.search();
            vm.filter = setFilter(searchParams[vm.name]);
        }

        function setFilter(value) {
            return typeof value === 'string' ? parseInt(value, 10) : undefined;
        }

        function doSearch(filterTerm) {
            $timeout(function() {
                var filter = {};

                var filterDisplay = {
                    removeKeys: [vm.name]
                };

                filter[vm.name] = String(filterTerm);

                vm.search({ filter: filter, filterDisplay: filterDisplay });
                vm.filter = null;
                closeSearch();
            }, 250);
        }

        function closeSearch() {
            $rootScope.$broadcast(SEARCH_FILTERS.close);
        }

        function isFilterSet() {
            return typeof vm.filter !== 'undefined';
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('searchFilterChoices', {
        bindings: {
            filters: '<',
            filterOptions: '<',
            removeFilter: '&'
        },
        templateUrl: 'components/search-filters/filter-choices/filter-choices.html',
        controller: FilterChoicesController
    });

    FilterChoicesController.$inject = [];

    function FilterChoicesController() {
        const vm = this;
        vm.getLabel = getLabel;
        vm.$onChanges = $onChanges;

        vm.filters = vm.filters || [];

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getLabel(filter) {
            // Return nothing if the filteroptions are not back from the server yet (don't show anything)
            if (!vm.filterOptions) return;

            // Return the original value if no optionsKey is specified
            if (!filter.optionsKey) return filter.value;

            if (filter.value === 'not_set') return 'Not Set';

            const selected = vm.filterOptions[filter.optionsKey].find(
                item => String(item.value) === String(filter.value)
            );

            return selected ? selected.label : filter.value;
        }

        function $onChanges() {
            if (vm.filterOptions) {
                setupFilters();
            }
        }

        function setupFilters() {
            var filtersCollection = vm.filters
                .filter(filter => _.isArray(filter.value))
                .map(filter => {
                    return filter.value.filter(value => value[Object.keys(value)[0]]).map(value => {
                        return {
                            name: filter.name,
                            removeKeys: filter.removeKeys
                                .map(removeKey => {
                                    const object = {};
                                    object[removeKey] = value;
                                    return object;
                                })
                                .reduce((memo, removeKey) => Object.assign(memo, removeKey), {}),
                            value: vm.filterOptions[filter.optionsKey]
                                .filter(option => option.value === value)
                                .map(option => option.label)
                                .reduce((memo, label) => label, '')
                        };
                    });
                })
                .reduce((memo, filterArray) => memo.concat(filterArray), []);

            vm.filters = vm.filters.filter(filter => !_.isArray(filter.value)).concat(filtersCollection);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('dropdownCheckboxFilter', {
        bindings: {
            search: '&',
            filters: '<',
            name: '@',
            optionsKey: '@',
            searchParams: '<'
        },
        templateUrl: 'components/search-filters/dropdown-checkbox/dropdown-checkbox.html',
        controller: DropdownCheckboxController
    });

    DropdownCheckboxController.$inject = ['$rootScope', '$element', '$timeout', '$location', 'SEARCH_FILTERS'];

    function DropdownCheckboxController($rootScope, $element, $timeout, $location, SEARCH_FILTERS) {
        const vm = this;

        vm.doSearch = doSearch;
        vm.closeSearch = closeSearch;
        vm.isFilterSet = isFilterSet;
        vm.filter = {};
        vm.filters = vm.filters ? vm.filters : [];

        vm.$onChanges = $onChanges;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onChanges() {
            const searchParams = $location.search();

            vm.filter = vm.filters
                .filter(filter => {
                    if (_.isArray(searchParams[vm.optionsKey])) {
                        return searchParams[vm.optionsKey]
                            .filter(param => param === filter.value)
                            .reduce((memo, param) => Boolean(param), false);
                    } else if (_.isString(searchParams[vm.optionsKey])) {
                        return filter.value === searchParams[vm.optionsKey];
                    }
                })
                .map(filter => {
                    const object = {};
                    object[filter.value] = true;
                    return object;
                })
                .reduce((memo, filter) => Object.assign(memo, filter), {});

            vm.filters = vm.filters.filter(filter => filter.value && filter.value);
        }

        function isFilterSet() {
            return vm.filters.filter(filter => vm.filter[filter.value]).reduce((memo, isSet) => Boolean(isSet), false);
        }

        function doSearch() {
            $timeout(function() {
                const filterDisplay = { removeKeys: [vm.optionsKey] };
                const filter = {};

                filter[vm.optionsKey] = vm.filters
                    .filter(filter => vm.filter[filter.value])
                    .map(filter => filter.value);

                vm.search({ filter: filter, filterDisplay: filterDisplay });

                closeSearch();
            }, 250);
        }

        function closeSearch() {
            $rootScope.$broadcast(SEARCH_FILTERS.close);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('dropdownFilter', {
        bindings: {
            search: '&',
            filters: '<',
            name: '@',
            placeholder: '@'
        },
        templateUrl: 'components/search-filters/dropdown/dropdown-filter.component.html',
        controller: DropdownFilterController
    });

    DropdownFilterController.$inject = ['$rootScope', '$element', '$timeout', 'gettext', 'SEARCH_FILTERS'];

    function DropdownFilterController($rootScope, $element, $timeout, gettext, SEARCH_FILTERS) {
        var vm = this;

        vm.doSearch = doSearch;
        vm.closeSearch = closeSearch;
        vm.placeholder = vm.placeholder || gettext('Select an Option');

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function doSearch(filterTerm) {
            $timeout(function() {
                var filter = {};

                var filterDisplay = {
                    removeKeys: [vm.name]
                };

                filter[vm.name] = filterTerm;
                vm.search({ filter: filter, filterDisplay: filterDisplay });
                vm.filter = null;
                closeSearch();
            }, 250);
        }

        function closeSearch() {
            $rootScope.$broadcast(SEARCH_FILTERS.close);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('dateRangeFilter', {
        bindings: {
            search: '&',
            min: '<',
            max: '<',
            maxName: '@',
            minName: '@'
        },
        templateUrl: 'components/search-filters/date-range/date-range-filter.component.html',
        controller: DateRangeFilterController
    });

    DateRangeFilterController.$inject = ['$rootScope', '$element', '$timeout', '$location', 'SEARCH_FILTERS', 'moment'];

    function DateRangeFilterController($rootScope, $element, $timeout, $location, SEARCH_FILTERS, moment) {
        var vm = this;

        vm.doSearch = doSearch;
        vm.closeSearch = closeSearch;
        vm.$onChanges = $onChanges;
        vm.$onInit = $onInit;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function $onInit() {
            vm.options = {
                minName: Date(vm.min),
                maxDate: Date(vm.max),
                startingDate: 1
            };
        }

        function $onChanges() {
            var searchParams = $location.search();
            vm.minDate = searchParams[vm.minName]
                ? moment(searchParams[vm.minName]).format('MM/DD/YYYY')
                : moment(vm.min).format('MM/DD/YYYY');

            vm.maxDate = searchParams[vm.maxName]
                ? moment(searchParams[vm.maxName]).format('MM/DD/YYYY')
                : moment(vm.max).format('MM/DD/YYYY');
        }

        function doSearch(values) {
            $timeout(function() {
                if (values.min && values.max) {
                    var filter = {};

                    var filterDisplay = {
                        removeKeys: [vm.maxName, vm.minName]
                    };

                    filter[vm.minName] = moment(new Date(values.min)).format('YYYY-MM-DD');
                    filter[vm.maxName] = moment(new Date(values.max)).format('YYYY-MM-DD');

                    vm.search({ filter: filter, filterDisplay: filterDisplay });

                    closeSearch();
                }
            }, 250);
        }

        function closeSearch() {
            $rootScope.$broadcast(SEARCH_FILTERS.close);
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.components')
        .component('yesNoBool', {
            templateUrl: 'components/form-elements/yes-no-bool/yesNoBoolTemplate.html',
            bindings: {
                label: '<',
                labelWidth: '@',
                labelSize: '@',
                model: '<',
                canHaveNull: '@',
                canHaveBlank: '@',
                wrapper: '@',
                updateFct: '&',
                emptyString: '<',
                showError: '<',
                yesValue: '@',
                noValue: '@',
                required: '<',
                formName: '@',
                parentForm: '<'
            },
            controller: 'FormElementsController',
        })
}());

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formTextarea', {
        templateUrl: 'components/form-elements/form-textarea/formTextareaTemplate.html',
        bindings: {
            label: '<',
            labelWidth: '@',
            labelSize: '@',
            conditionalLabel1: '<',
            conditionalLabel2: '<',
            conditionalLabel: '&',
            model: '<',
            minlength: '@',
            wrapper: '@',
            required: '<',
            updateFct: '&',
            formName: '@',
            showError: '<',
            assessment: '<',
            infoTextKey: '@'
        },
        controller: 'FormElementsController'
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formSelect', {
        templateUrl: 'components/form-elements/form-select/formSelectTemplate.html',
        bindings: {
            label: '<',
            labelWidth: '@',
            labelSize: '@',
            conditionalLabel1: '<',
            conditionalLabel2: '<',
            conditionalLabel: '&',
            model: '<',
            placeholder: '<',
            options: '<',
            dynamicOptions: '&',
            optionValue: '@',
            wrapper: '@',
            required: '<',
            disabled: '<',
            changeFct: '&',
            updateFct: '&',
            resetFct: '&',
            formName: '@',
            showError: '<',
            assessment: '<',
            infoTextKey: '@',
            displayClearButton: '<'
        },
        controller: 'FormElementsController'
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formNumber', {
        templateUrl: 'components/form-elements/form-number/formNumberTemplate.html',
        bindings: {
            label: '<',
            labelWidth: '@',
            labelSize: '@',
            conditionalLabel1: '<',
            conditionalLabel2: '<',
            conditionalLabel: '&',
            model: '<',
            allowNegative: '<',
            required: '<',
            wrapper: '@',
            shouldValidate: '<',
            showError: '<',
            updateFct: '&',
            isDisabled: '<',
            max: '<',
            min: '<',
            outOfBoundsErrorMsg: '<'
        },
        controller: FormNumberController
    });

    FormNumberController.$inject = ['$document', '$filter', '$rootScope', '$element', '$timeout', 'gettext'];

    function FormNumberController($document, $filter, $rootScope, $element, $timeout, gettext) {
        var vm = this;
        var input;

        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;
        vm.$onDestroy = $onDestroy;
        vm.$postLink = $postLink;
        vm.keydown = keydown;

        vm.focus = focus;
        vm.blur = blur;

        vm.heading = gettext(vm.heading);
        vm.inFocus = false;
        var altHeld = false;
        var shiftHeld = false;
        var lastValidValue;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Method Declarations
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            //Check if shift or alt are pressed
            vm.labelWidth = vm.labelWidth || 12;
            $document.on('keyup keydown', shiftAltPressed);
            vm.model = $filter('cleanNumbers')(vm.model);
            vm.model = $filter('number')(vm.model);
            lastValidValue = $filter('cleanNumbers')(vm.model);
        }

        function $onChanges(changes) {
            // Moved this here from $onInit because the conditionalLabel depends on the assessment most of the times
            // which isn't directly available on page load. Checking it here will update it after vm.model
            // becomes available and thus assessment.
            if (vm.conditionalLabel && vm.conditionalLabel()) {
                vm.label = vm['conditionalLabel' + vm.conditionalLabel()];
            }

            if (changes.showError && typeof changes.showError.currentValue !== 'undefined') {
                vm.shouldShowError = changes.showError.currentValue && isInvalid(input);
            }

            if (!vm.inFocus && !changes.isDisabled) {
                vm.model = $filter('number')(vm.model);
            }
        }

        function $postLink() {
            $timeout(function() {
                input = $element.find('input');
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Event Handlers
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        // Codes for navigation: 8,9,13,35,36,37,39,46
        // Codes for numbers: 48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105
        // Codes for minus: 109,189
        function keydown(event) {
            var key = event.keyCode;
            var codes = [
                8,
                9,
                13,
                35,
                36,
                37,
                39,
                46,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                109,
                189
            ];

            if (shiftHeld || altHeld) {
                return prevent(event);
            }

            var isMinus = key === 189 || key === 109;
            var notFirst = event.target.selectionStart > 0;
            if ((isMinus && notFirst) || (isMinus && !vm.allowNegative)) {
                //check for a first minus
                return prevent(event);
            }

            if (codes.indexOf(key) === -1) {
                return prevent(event);
            }
        }

        function shiftAltPressed(e) {
            altHeld = e.altKey;
            shiftHeld = e.shiftKey;
        }

        /**
         * Convenience method used above
         * @param event
         */
        function prevent(event) {
            vm.isActive = true;
            $timeout(function() {
                vm.isActive = false;
            }, 2000);
            return event.preventDefault();
        }

        function change(newVal) {
            //Clean up and user junk that might have been entered
            let cleanNumber = $filter('cleanNumbers')(newVal);
            cleanNumber = typeof cleanNumber === 'number' ? cleanNumber : undefined;
            //Lets only update everything if the number values differ
            if (vm.model !== cleanNumber) {
                var minValue = typeof vm.min === 'number' ? vm.min : $filter('cleanNumbers')(vm.min);

                if (minValue !== undefined && cleanNumber !== undefined && cleanNumber < minValue) {
                    if (vm.outOfBoundsErrorMsg != undefined) {
                        alert(vm.outOfBoundsErrorMsg);
                    } else {
                        alert('Please enter a valid number!');
                    }
                    vm.model = lastValidValue !== undefined ? $filter('number')(lastValidValue) : '';
                    $element.find('input').val(vm.model);
                    vm.isUnderMin = true;
                    return;
                }

                var maxValue = typeof vm.max === 'number' ? vm.max : $filter('cleanNumbers')(vm.max);

                if (maxValue !== undefined && cleanNumber !== undefined && cleanNumber > maxValue) {
                    if (vm.outOfBoundsErrorMsg != undefined) {
                        alert(vm.outOfBoundsErrorMsg);
                    } else {
                        alert(
                            "The percentage you have entered is greater than 100%. Please note that a percentage value over 100% is not valid and can't be saved."
                        );
                    }
                    vm.model = lastValidValue !== undefined ? $filter('number')(lastValidValue) : '';
                    $element.find('input').val(vm.model);
                    vm.isOverMax = true;
                    return;
                }

                vm.isOverMax = false;
                vm.isUnderMin = false;
                vm.shouldShowError = false;

                // Sačuvaj novu validnu vrednost
                lastValidValue = cleanNumber;

                vm.updateFct({ model: typeof cleanNumber === 'undefined' ? undefined : parseInt(cleanNumber, 10) });
            }
        }

        function focus() {
            vm.inFocus = true;
            vm.model = $filter('cleanNumbers')(vm.model);
        }

        function blur() {
            vm.inFocus = false;
            var newVal = $element.find('input').val();
            change(newVal);
            if (vm.model !== undefined && vm.model !== null && vm.model !== '') {
                vm.model = $filter('number')(vm.model);
            }
        }

        function $onDestroy() {
            //Manually deregister listener because it's not part of component but $document
            $document.off('keyup keydown', shiftAltPressed);
        }

        function isInvalid(input) {
            return input ? input.hasClass('ng-invalid') : false;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formInput', {
        templateUrl: 'components/form-elements/form-input/formInputTemplate.html',
        bindings: {
            label: '<',
            labelWidth: '@',
            labelSize: '@',
            conditionalLabel1: '<',
            conditionalLabel2: '<',
            conditionalLabel: '&',
            model: '<',
            wrapper: '@',
            type: '@',
            min: '@',
            max: '@',
            minlength: '@',
            required: '<',
            disabled: '<',
            updateFct: '&',
            formName: '@',
            isDate: '@',
            showError: '<',
            assessment: '<',
            infoTextKey: '@',
            dateOptions: '<'
        },
        controller: 'FormElementsController'
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formGps', {
        templateUrl: 'components/form-elements/form-gps/formGpsTemplate.html',
        bindings: {
            label: '<',
            labelWidth: '@',
            model: '<',
            wrapper: '@',
            required: '<',
            showError: '<',
            updateFct: '&',
            formName: '@',
            isOffline: '<'
        },
        controller: FormGpsController
    });

    FormGpsController.$inject = ['$element', 'gettext', '$uibModal', '$timeout'];

    function FormGpsController($element, gettext, $uibModal, $timeout) {
        var vm = this;
        var elements = {};

        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;
        vm.$postLink = $postLink;
        vm.onChange = onChange;
        vm.openGPSModal = openGPSModal;
        vm.updateValues = updateValues;
        vm.updateLatitude = updateLatitude;
        vm.updateLongitude = updateLongitude;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            vm.labelWidth = vm.labelWidth || 12;
            console.log(vm.latitude, vm.longitude);
        }

        function updateValues(latitude, longitude) {
            console.log(typeof latitude, longitude);
            vm.updateFct({
                model: `${latitude ? (+latitude).toFixed(6) : ''} ${longitude ? (+longitude).toFixed(6) : ''}`
            });
        }

        function updateLatitude(latitude) {
            const parsed = parseFloat(latitude);
            if (!isNaN(parsed)) {
                vm.latitude = parsed.toFixed(6);
                vm.updateFct({
                    model: `${vm.latitude} ${vm.longitude}`
                });
            } else {
                vm.latitude = '';
            }
        }

        function updateLongitude(longitude) {
            const parsed = parseFloat(longitude);
            if (!isNaN(parsed)) {
                vm.longitude = parsed.toFixed(6);
                vm.updateFct({
                    model: `${vm.latitude} ${vm.longitude}`
                });
            } else {
                vm.longitude = '';
            }
        }
        function $postLink() {
            $timeout(function() {
                elements = {
                    input: $element.find('input'),
                    textArea: $element.find('textarea'),
                    select: $element.find('select')
                };
            });
        }

        function $onChanges(changes) {
            if (vm.model) {
                vm.latitude = vm.model.split(' ')[0];
                vm.longitude = vm.model.split(' ')[1];
            } else {
                vm.latitude = '';
                vm.longitude = '';
            }
        }

        function getElement(elements) {
            var element = Object.keys(elements)
                .filter(function(key) {
                    return elements[key].length;
                })
                .reduce(function(memo, el) {
                    return elements[el];
                }, []);

            return element;
        }

        function isInvalid(elements) {
            var element = getElement(elements);

            switch (element.selector) {
                case 'input':
                    return element.hasClass('ng-invalid');
                case 'select':
                    return element.hasClass('ng-empty');
                case 'textarea':
                    return element.hasClass('ng-invalid');
            }
        }

        function openGPSModal() {
            if (vm.isOffline) {
                return;
            }
            $uibModal
                .open({
                    templateUrl: 'components/form-elements/form-gps/gps-azure-modal.html',
                    windowClass: 'gps__modal',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'lat',
                        'long',
                        function($scope, $uibModalInstance, lat, long) {
                            $scope.dd = {
                                lat,
                                long
                            };
                            let markers = [];
                            $scope.dms = {
                                lat: {},
                                long: {}
                            };

                            $uibModalInstance.opened.then(() => {
                                setTimeout(() => {
                                    initializeMap();
                                }, 1000);
                            });

                            const initializeMap = () => {
                                $scope.map = new atlas.Map('map', {
                                    authOptions: {
                                        authType: 'subscriptionKey',
                                        subscriptionKey: 'A4wrmtG7GHdB_SutCCQTQN3qp-KxCMu6xor77iPht5Q'
                                    },
                                    showFeedbackLink: false,
                                    enableAccessibility: false
                                });

                                $scope.map.events.add('ready', () => {
                                    setUpMapData();
                                });
                            };
                            const setUpMapData = () => {
                                $scope.dataSource = new atlas.source.DataSource();
                                $scope.map.sources.add($scope.dataSource);
                                let layer = new atlas.layer.SymbolLayer($scope.dataSource);
                                $scope.point = new atlas.Shape(new atlas.data.Point([long, lat]));
                                $scope.map.layers.add(layer);
                                $scope.dataSource.add($scope.point);
                                $scope.map.setCamera({
                                    center: [parseFloat(long), parseFloat(lat)],
                                    zoom: 12
                                });
                            };

                            $scope.inputType = lat && long ? 'dd' : '';

                            $scope.saveDD = () => {
                                markers.map(m => m.setMap(null));
                                $uibModalInstance.close($scope.dd);
                            };

                            $scope.saveDMS = () => {
                                const dd = {};
                                dd.lat = ($scope.dms.lat.d + ($scope.dms.lat.m + $scope.dms.lat.s / 60) / 60).toFixed(
                                    6
                                );
                                dd.long = (
                                    $scope.dms.long.d +
                                    ($scope.dms.long.m + $scope.dms.long.s / 60) / 60
                                ).toFixed(6);
                                dd.lat = $scope.dms.lat.direction === 'N' ? dd.lat : -1 * dd.lat;
                                dd.long = $scope.dms.long.direction === 'E' ? dd.long : -1 * dd.long;
                                $uibModalInstance.close(dd);
                            };

                            $scope.cancel = () => {
                                $uibModalInstance.dismiss('cancel');
                            };

                            $scope.updateMap = () => {
                                const myLatLng = { lat: parseFloat($scope.dd.lat), lng: parseFloat($scope.dd.long) };
                                $scope.map.setCamera({
                                    center: [myLatLng.lng, myLatLng.lat],
                                    zoom: 12
                                });
                                $scope.point.setCoordinates([myLatLng.lng, myLatLng.lat]);
                            };

                            $scope.getCoordinatesPrompt = function() {
                                var userInput = prompt('Enter GPS coordinates (latitude,longitude):');
                                if (userInput) {
                                    var [latitude, longitude] = userInput.split(',');
                                    if (latitude && longitude) {
                                        var coordinates = 'Latitude: ' + latitude + '<br>Longitude: ' + longitude;

                                        var marker = new atlas.HtmlMarker({
                                            position: [parseFloat(latitude), parseFloat(longitude)],
                                            htmlContent: '<div class="marker"></div>'
                                        });

                                        map.markers.add(marker);
                                        map.setCamera({
                                            center: [parseFloat(latitude), parseFloat(longitude)],
                                            zoom: 12
                                        });
                                    } else {
                                        alert(
                                            "Invalid coordinates format. Please enter in 'latitude,longitude' format."
                                        );
                                    }
                                }
                            };
                        }
                    ],
                    resolve: {
                        lat: () => vm.latitude,
                        long: () => vm.longitude
                    }
                })
                .result.then(dd => {
                    vm.latitude = dd.lat;
                    vm.longitude = dd.long;
                    vm.updateValues(vm.latitude, vm.longitude);
                });
        }

        function onChange() {
            // Permit using comma instead of full stop
            vm.latitude = vm.latitude ? vm.latitude.replace(',', '.') : '';
            vm.longitude = vm.longitude ? vm.longitude.replace(',', '.') : '';
            vm.model = vm.latitude;

            // Only add comma if longitude exists
            // if (vm.longitude) {
            //     vm.model += ', ' + vm.longitude;
            // }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('formCheckboxes', {
        templateUrl: 'components/form-elements/form-checkbox/formCheckboxTemplate.html',
        bindings: {
            heading: '<',
            headingSize: '@',
            conditionalHeading1: '<',
            conditionalHeading2: '<',
            conditionalHeading: '&',
            formName: '@',
            required: '@',
            checkboxes: '<',
            checkedItems: '<',
            isValid: '<',
            shouldValidate: '<',
            showError: '<',
            updateFct: '&',
            hasOther: '<',
            hasOtherChecked: '<',
            hasOtherUpdateFct: '&',
            assessment: '<',
            infoTextKey: '@'
        },
        controller: FormCheckboxController
    });

    FormCheckboxController.$inject = [
        '$rootScope',
        '$element',
        '$timeout',
        'gettext',
        'COMPLETION_CHECK',
        'PARSENAME_REGEX'
    ];

    function FormCheckboxController($rootScope, $element, $timeout, gettext, COMPLETION_CHECK, PARSENAME_REGEX) {
        var vm = this;

        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;
        vm.$doCheck = $doCheck;
        vm.$postLink = $postLink;
        vm.onChange = onChange;
        vm.onChangeTextArea = onChangeTextArea;
        vm.isChecked = isChecked;
        vm.parseName = parseName;
        vm.showOtherTextarea = () => (vm.showTextArea = true);
        vm.heading = gettext(vm.heading);
        vm.handleOtherCheckbox = handleOtherCheckbox;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            vm.checkedItems = vm.checkedItems || [];
            vm.checkboxes = vm.checkboxes || [];
            vm[vm.formName] = {};
            vm.shouldValidate = !!vm.shouldValidate;
            console.log(vm.checkboxes);
            console.log(vm.checkedItems);
        }

        function $onChanges(changes) {
            if (changes.showError && typeof changes.showError.currentValue !== 'undefined') {
                vm.shouldShowError = changes.showError.currentValue && !vm.isValid;
            }

            if (changes.checkedItems && typeof changes.checkedItems.currentValue !== 'undefined') {
                setValidity(vm.checkedItems.length);
            }

            if (changes.isValid && typeof changes.isValid.currentValue !== 'undefined') {
                setValidity(changes.isValid.currentValue);
            }

            if (changes.shouldValidate && typeof changes.shouldValidate.currentValue !== 'undefined') {
                vm.shouldValidate = changes.shouldValidate.currentValue;
            }

            if (changes.hasOtherChecked && typeof changes.hasOtherChecked.currentValue !== 'undefined') {
                vm.showTextArea = !!vm.hasOtherChecked;
                vm.other = vm.hasOtherChecked;
            }
        }

        //FIXME: still not super happy about having to utilize this.
        //FIXME: if we get performance issues look here first.
        function $doCheck() {
            setValidity(vm.checkedItems.length || (vm.hasOther && vm.showTextArea && vm.other !== ''));
        }

        function handleOtherCheckbox(isChecked) {
            if (!isChecked) {
                onChangeTextArea('');
            } else {
                // vm.checkedItems.push({ name: 'other' });
            }
        }

        function $postLink() {
            $timeout(function() {
                vm[vm.formName].$name = vm.formName;
                vm[vm.formName].$$parentForm[vm.formName] = vm[vm.formName];
                delete vm[vm.formName].$$parentForm['$ctrl[$ctrl.formName]'];
                setValidity(vm.checkedItems.length);
            });
        }

        /**
         * replace spaces with _
         * @param name
         * @returns {*}
         */
        function parseName(name) {
            return name.replace(new RegExp(PARSENAME_REGEX, 'g'), '_');
        }

        /**
         * Sets up the checkbox
         * @param url
         * @returns {*}
         */
        function isChecked(url) {
            return vm.checkedItems
                .filter(function(item) {
                    return item.url === url;
                })
                .reduce(function(memo, isChecked) {
                    return !!isChecked;
                }, false);
        }

        /**
         * Function to get our values outside the component
         * @param url
         */
        function onChange(url) {
            vm.updateFct({ url });
            vm.shouldShowError = vm.checkedItems.length === 0;
        }

        function onChangeTextArea(value) {
            vm.hasOtherUpdateFct({ value });
        }

        /**
         * Checks first whether or not we should even bother with validation. As by default the form is valid.
         * If we decide we should validate or not, we can pass in a boolean for setting the validity.
         * @param validityChecker
         * @returns {*}
         */
        function setValidity(validityChecker) {
            if (!vm.shouldValidate) {
                vm.shouldShowError = false;
                return true;
            }
            return vm.shouldValidate && !_.isEmpty(vm[vm.formName]) ? setFormValidity(!!validityChecker) : false;
        }

        /**
         * Method to set all the checkboxes to either valid or not based on the required attribute - in theory it could be anything.
         * Once its been set we simply fire off the COMPLETION_CHECK updater.
         * @param valid
         */
        function setFormValidity(valid) {
            var parentForm = {};

            vm.checkboxes
                .filter(function(box) {
                    return vm[vm.formName][parseName(box.name)];
                })
                .forEach(function(box) {
                    vm[vm.formName][parseName(box.name)].$setValidity('required', valid);
                });

            parentForm[vm[vm.formName].$$parentForm.$name] = angular.copy(vm[vm.formName].$$parentForm);

            $rootScope.$broadcast(COMPLETION_CHECK.update, parentForm);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.register', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('authentication.register', {
            url: '/register',
            views: {
                'childState@authentication': {
                    templateUrl: 'authentication/register/register.html',
                    controller: 'registerController',
                    controllerAs: 'registerCtrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.authentication.register')
        .controller('createNewAssesseeModalController', createNewAssesseeModalController);

    createNewAssesseeModalController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'EVENT_LOADER',
        'countries',
        // 'modal1',
        'apiUrl',
        'siScope',
        'siProducts',
        'siCustomers',
        '$log',
        'toastr',
        '$q'
    ];

    function createNewAssesseeModalController(
        $scope,
        $rootScope,
        $uibModalInstance,
        EVENT_LOADER,
        countries,
        // modal1,
        apiUrl,
        siScope,
        siProducts,
        siCustomers,
        $log,
        toastr,
        $q
    ) {
        $scope.save = save;
        $scope.cancel = cancel;
        $scope.countries = countries;
        $scope.updateGlobalRegion = updateGlobalRegion;
        $rootScope.$broadcast(EVENT_LOADER.show);

        var statusesPromise = siProducts.getLegalStatusOptions({ noAuth: true }),
            dropdownsPromise = siProducts.getDropDowns({ noAuth: true }),
            sectorsPromise = siCustomers.getSectors({ noAuth: true });

        $q.all([statusesPromise, dropdownsPromise, sectorsPromise]).then(promises => {
            $scope.statuses = promises[0].results;
            $scope.dropdown = promises[1];
            $scope.sectors = promises[2].results;

            $rootScope.$broadcast(EVENT_LOADER.hide);
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function save(assessee) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            //Create then a new customer and then the PO
            var createdCustomer,
                customer = {
                    name: assessee.name,
                    phone_number: assessee.phone_number
                };

            var createdProducingOrganization = {
                legal_status: assessee.legal_status,
                in_operation_since: assessee.in_operation_since,
                year_of_incorporation: assessee.year_of_incorporation,
                sectors: assessee.sectors,
                street: assessee.street,
                city: assessee.city,
                global_region: assessee.global_region,
                country: assessee.country.name,
                region: assessee.region
            };

            var params = {
                customer: customer,
                producing_organization: createdProducingOrganization,
                noAuth: true
            };
            var customer_url = {
                url: apiUrl + '/create_self_assessor_org/'
            };
            siScope
                .post(customer_url, params)
                .then(function(newCustomer) {
                    $uibModalInstance.close(newCustomer);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    toastr.error(err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.error = 'Error Saving Assessee';
                });
        }

        function updateGlobalRegion() {
            var url = $scope.dropdown.countryOptions
                .filter(country => country.display_name === $scope.assessee.country.display_name)
                .reduce((memo, country) => {
                    $scope.regions = country.subdivisions;
                    return country.global_region;
                }, '');
            console.log(url, 'url');
            var selectedOption = $scope.dropdown.continentOptions.filter(function(continent) {
                return continent.url === url;
            });

            $scope.globalRegion = selectedOption.reduce(function(memo, continent) {
                return continent.display_name;
            }, '');

            $scope.assessee.global_region = selectedOption.reduce(function(memo, continent) {
                return continent.name;
            }, '');
        }

        function cancel(all) {
            $uibModalInstance.dismiss('cancel');
            // if (all) modal1.dismiss('cancel');
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.scoreBuilder', [])
        .constant('OPTION', {
            updated: 'option-is-updated',
            deleted: 'option-is-deleted'
        })
        .constant('QUESTION', {
            types: [
                {
                    name: 'Multiple Choice Question',
                    type: 'mpc'
                },
                {
                    name: 'Numeric Question',
                    type: 'numeric'
                },
                {
                    name: 'Check Box Question',
                    type: 'checkbox'
                }
            ],
            created: {
                weight: 'created-question-weight',
                options: 'created-question-options'
            },
            updated: {
                weight: 'updated-question-weight',
                options: 'updated-question-options',
                title: 'updated-question-title',
                description: 'updated-question-description'
            },
            deleted: 'question-deleted'

        });

}());
(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').directive('scoreBuilder', scoreBuilder);

    function scoreBuilder() {
        return {
            restrict: 'E',
            templateUrl: 'score-builder/partials/scoreBuilderView.html',
            controller: 'scoreBuilderController',
            controllerAs: 'scoreBuilderCtrl',
            bindToController: true,
            replace: true
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').directive('questionSelector', questionSelector);

    function questionSelector() {
        return {
            restrict: 'E',
            templateUrl: 'score-builder/partials/questionSelectorView.html',
            scope: {
                question: '=',
                index: '@',
                updateFct: '&',
                questions: '<',
                isCanonicalTree: '<',
                toolTypes: '<',
                canonicalSubquestions: '<',
                canonicalSubquestionOptions: '<'
            },
            controller: 'selectorController',
            controllerAs: 'selectorCtrl',
            bindToController: true,
            replace: true
        };
    }
})();

(function() {
    'use strict';

    /**
     * AD-2095: the "Is conditional on" editor that sits under an answer option in
     * the Canonical Tree.
     *
     * Checking the box reveals Source question, Rule and Source answer option.
     * The option stays visible in the assessment but is locked until the source
     * option is selected. The rule graph is validated on the server - cycles,
     * conflicting conditions and references outside this tool version come back
     * as field errors, which are shown next to the field that caused them.
     */
    angular.module('scope.commons.scoreBuilder').component('optionCondition', {
        templateUrl: 'score-builder/partials/option-condition.html',
        controller: OptionConditionCtrl,
        bindings: {
            // The answer option being configured. Its `condition` field carries the
            // saved rule, or null when the option is unconditional.
            option: '<'
        }
    });

    OptionConditionCtrl.$inject = ['siProducts', '$q'];

    function OptionConditionCtrl(siProducts, $q) {
        const vm = this;

        // Handle on the in-flight condition-sources request; see loadSources().
        let sourcesRequest = null;

        // The only rule AD-2095 exposes. Kept as a list so the select renders the
        // label, and so a second rule can be added without touching the template.
        vm.rules = [{ value: 'is_selected', label: 'Is selected' }];

        // Initialised in the controller body, not in $onInit: AngularJS runs the
        // initial $onChanges(initialChanges) *before* $onInit (angular.js, the
        // elementControllers loop), and both hooks are wrapped in try/catch ->
        // $exceptionHandler. Assigning these in $onInit meant the first $onChanges
        // read vm.questions.length off undefined and threw, silently, once per
        // conditional option per render.
        vm.questions = [];
        vm.errors = {};
        vm.saving = false;
        vm.loadingSources = false;
        vm.pendingSourceChange = false;

        // No $onInit: `option` is a one-way binding that both host templates always
        // supply, so it is in initialChanges and $onChanges always runs first with
        // changes.option set. An $onInit doing readFromOption() + loadSources() was
        // pure duplication of that, and once the TypeError above was fixed it became
        // a second identical condition-sources GET per conditional option.

        vm.$onChanges = changes => {
            if (changes.option) {
                vm.errors = {};
                // A different option means any in-progress edit belonged to the old
                // one; carrying the flag over would show its warning against this one.
                vm.pendingSourceChange = false;
                readFromOption();
                // The host ng-repeat uses `track by $index`, so a refetch of
                // question.options.objects hands this same instance a new option
                // object. Without loading the sources the fields expand against an
                // empty ng-options and Angular renders a blank "unknown option" for
                // a rule that is in fact configured.
                if (vm.enabled) {
                    loadSources();
                }
            }
        };

        vm.toggle = () => {
            if (!vm.enabled) {
                // Unchecking clears the rule right away: leaving a half-configured
                // condition behind would lock the option with no way to unlock it.
                return save({ enabled: false });
            }
            vm.errors = {};
            return loadSources();
        };

        /**
         * Changing the source question does NOT touch the server.
         *
         * A native <select> fires `change` for every item you arrow past, so writing
         * here made merely browsing the list destructive — and clearing eagerly left
         * the option unconditional while the UI still showed it as conditional if the
         * admin never picked an answer option. Instead the stored rule stays in force
         * and the component reports itself as unsaved until the pair is complete;
         * `save()` then replaces the old rule in one write, because write_condition
         * already deletes the option's previous editor rule.
         */
        vm.onSourceQuestionChange = () => {
            vm.sourceOptionId = null;
            vm.errors = {};
            vm.pendingSourceChange = !!(vm.option && vm.option.condition);
            return $q.when();
        };

        /** True while the editor shows an edit that is not yet stored. */
        vm.hasUnsavedChange = () => vm.pendingSourceChange && !vm.sourceOptionId;

        vm.sourceOptions = () => {
            const question = questionById(vm.sourceQuestionId);
            return (question && question.options) || [];
        };

        vm.questionLabel = question =>
            question.display_position ? question.display_position + ' ' + question.title : question.title;

        /**
         * Only saves once all three fields are filled in — a partially configured
         * condition is not something the server should be asked to store.
         */
        vm.save = () => {
            if (!vm.enabled) {
                return save({ enabled: false });
            }
            if (!vm.sourceQuestionId || !vm.rule || !vm.sourceOptionId) {
                return $q.when();
            }
            return save({
                enabled: true,
                rule: vm.rule,
                source_question_id: vm.sourceQuestionId,
                source_option_id: vm.sourceOptionId
            });
        };

        /**
         * The source may be any question of the tool version (FR-003), which is
         * wider than the sibling list the score builder passes around, so ask the
         * server. Fetched lazily so a question with many options does not fire a
         * request per option on page load.
         */
        function loadSources() {
            // Guard on the in-flight request, not just on the resolved array: two
            // callers in the same digest (or a toggle racing the initial $onChanges)
            // would both see vm.questions still empty and both hit the wire. The
            // catch clears the handle so a failed load can be retried — caching the
            // rejection would leave the select permanently empty.
            if (sourcesRequest) {
                return sourcesRequest;
            }
            if (vm.questions.length || !vm.option || !vm.option.id) {
                return $q.when();
            }
            vm.loadingSources = true;
            sourcesRequest = siProducts
                .getOptionConditionSources(vm.option.id)
                .then(questions => {
                    vm.questions = questions || [];
                })
                .catch(() => {
                    vm.errors = { detail: 'Could not load the list of source questions' };
                    sourcesRequest = null;
                })
                .finally(() => {
                    vm.loadingSources = false;
                });
            return sourcesRequest;
        }

        function save(payload) {
            if (!vm.option || !vm.option.id) {
                return $q.when();
            }
            vm.saving = true;
            vm.errors = {};
            return siProducts
                .saveOptionCondition(vm.option.id, payload)
                .then(condition => {
                    vm.option.condition = condition;
                    readFromOption();
                    vm.pendingSourceChange = false;
                })
                .catch(response => {
                    vm.errors = (response && response.data) || {
                        detail: 'Could not save the condition'
                    };
                    // ng-model already flipped the checkbox before toggle() ran, so
                    // a failed clear would otherwise leave the box unticked while the
                    // rule is still active and assessors are still locked out — and
                    // the error itself hidden, because it renders inside the
                    // collapsed fields block. Put the checkbox back where the server
                    // actually is.
                    readFromOption();
                })
                .finally(() => {
                    vm.saving = false;
                });
        }

        function readFromOption() {
            const condition = (vm.option && vm.option.condition) || null;
            vm.enabled = !!condition;
            vm.rule = (condition && condition.rule) || vm.rules[0].value;
            vm.sourceQuestionId = condition ? condition.source_question_id : null;
            vm.sourceOptionId = condition ? condition.source_option_id : null;
        }

        function questionById(id) {
            return (vm.questions || []).filter(question => question.id === id).reduce((memo, q) => q, null);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').directive('numericQuestion', numeric);

    function numeric() {
        return {
            restrict: 'E',
            templateUrl: 'score-builder/partials/score-builder-questions/numeric/numeric.html',
            scope: {
                index: '=',
                question: '=',
                updateFct: '&',
                questions: '<',
                isCanonicalTree: '<',
                toolTypes: '<',
                canonicalSubquestions: '<',
                canonicalSubquestionOptions: '<'
            },
            controller: 'QuestionController',
            controllerAs: 'questionCtrl',
            bindToController: true,
            replace: true
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').directive('multipleChoiceQuestion', multipleChoice);

    function multipleChoice() {
        return {
            restrict: 'E',
            templateUrl: 'score-builder/partials/score-builder-questions/multiple-choice/multiple-choice.html',
            scope: {
                index: '=',
                question: '=',
                updateFct: '&',
                questions: '<',
                isCanonicalTree: '<',
                toolTypes: '<',
                canonicalSubquestions: '<',
                canonicalSubquestionOptions: '<'
            },
            controller: 'QuestionController',
            controllerAs: 'questionCtrl',
            bindToController: true,
            replace: true
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').component('conditionalOn', {
        templateUrl: 'score-builder/partials/conditional-on.html',
        controller: ConditionalOnCtrl,
        bindings: {
            question: '<',
            questions: '<',
            index: '<',
            updateFct: '&'
        }
    });

    ConditionalOnCtrl.$inject = [];

    function ConditionalOnCtrl() {
        const vm = this;

        vm.updateOptions = () => {
            vm.options = vm.selectedQuestion ? vm.selectedQuestion.options : { url: null };
            vm.question.conditional_subquestion = vm.selectedQuestion && vm.selectedQuestion.url;
            vm.updateQuestion('conditional_subquestion');
        };

        vm.updateQuestion = key => {
            const update = {};
            update[key] = vm.question[key] || null;
            if (key === 'is_conditional' && !update[key]) {
                update['conditional_subquestion_option'] = null;
                update['conditional_subquestion'] = null;
                update['is_conditional'] = false;
                vm.selectedQuestion = null;
                vm.question.conditional_subquestion_option = null;
            }

            vm.updateFct()({ question: vm.question, index: vm.index }, update);
        };

        vm.$onChanges = change => {
            if (change.questions.currentValue) {
                vm.questions = []
                    .concat(vm.questions)
                    .splice(0, vm.index)
                    .filter(question => question.type === 'mpc');

                vm.selectedQuestion = vm.questions
                    .filter(question => question.url === vm.question.conditional_subquestion)
                    .reduce((memo, question) => question, {});

                vm.options = vm.selectedQuestion.options;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').directive('checkBoxQuestion', checkbox);

    function checkbox() {
        return {
            restrict: 'E',
            templateUrl: 'score-builder/partials/score-builder-questions/check-box/check-box.html',
            scope: {
                index: '=',
                question: '=',
                updateFct: '&',
                questions: '<',
                isCanonicalTree: '<',
                toolTypes: '<',
                canonicalSubquestions: '<',
                canonicalSubquestionOptions: '<'
            },
            controller: 'QuestionController',
            controllerAs: 'questionCtrl',
            bindToController: true,
            replace: true
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').controller('scoreBuilderController', scoreBuilderController);

    scoreBuilderController.$inject = [
        '$scope',
        '$log',
        '$timeout',
        'siProducts',
        'gettext',
        'QUESTION',
        'OPTION',
        'toastr'
    ];

    function scoreBuilderController($scope, $log, $timeout, siProducts, gettext, QUESTION, OPTION, toastr) {
        var vm = this;

        var displayNames = {
            mpc: gettext('Multiple Choice Question'),
            numeric: gettext('Numeric Question'),
            checkbox: gettext('Check Box Question')
        };

        vm.questionTypes = QUESTION.types.map(function(questionType) {
            questionType.display_name = displayNames[questionType.type];
            return questionType;
        });

        vm.newQuestionType = {
            name: 'Multiple Choice',
            type: 'mpc'
        };
        vm.questions = {
            objects: []
        };
        vm.totalWeight = 0;

        vm.weightOver = false;

        vm.updateQuestion = updateQuestion;
        vm.add = add;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function add() {
            var subQuestion, index;

            if (vm.saveQuestionError || vm.questionTypeError) {
                return;
            }

            subQuestion = {
                type: vm.newQuestionType.type,
                weight: 1,
                title: vm.newQuestionType.name,
                question: $scope.question.url,
                options: { objects: [] }
            };

            index = vm.questions.objects.push(subQuestion);

            siProducts
                .subQuestions()
                .post(subQuestion)
                .then(function(res) {
                    console.log('Created new sub-question - ', res);
                    _.extend(vm.questions.objects[index - 1], res);
                })
                .catch(function(err) {
                    toastr.error('Error creating new sub-question - ', err);
                    vm.addingSubquestion = false;
                });
        }

        function updateWeight() {
            vm.totalWeight = vm.questions.objects
                .filter(function(question) {
                    return question.displayWeight;
                })
                .map(function(question) {
                    return parseInt(question.displayWeight, 10);
                })
                .reduce(function(init, weight) {
                    return init + weight;
                }, 0);

            vm.weightOver = vm.totalWeight > 100;
        }

        function updateQuestion(question, update) {
            siProducts
                .subQuestions()
                .one(question.question.id)
                .patch(update)
                .then(function(res) {
                    //FIXME: we have this issue that occurs then a PATCH of the subquestion and a POST of a new subquestion option occur at the same time
                    if (res.options) {
                        delete res.options;
                    }

                    console.log('Updated Sub-question - ', res);
                    _.extend(vm.questions.objects[question.index], res);
                })
                .catch(function(err) {
                    toastr.error('Error Updating new sub-question - ', err);
                });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * CREATE
         */
        $scope.$on(QUESTION.created.options, function($event, info) {
            siProducts
                .subQuestionOptions()
                .post(info.option)
                .then(function(option) {
                    console.log('SubQuestionOption Created - ', option);
                    vm.questions.objects[info.index].options = vm.questions.objects[info.index].options.objects
                        ? vm.questions.objects[info.index].options
                        : { objects: [] };
                    _.extend(info.option, option);
                    $scope.$broadcast(OPTION.updated, option);
                })
                .catch(function(err) {
                    toastr.error('SubQuestionOption Create Error - ', err);
                });

            console.log('Question Options Created - ', vm.questions);
        });

        /**
         * UPDATE
         */
        $scope.$on(QUESTION.updated.options, function($event, info) {
            vm.scoreInvalid = info.scoreInvalid;

            siProducts
                .subQuestionOptions()
                .one(info.option.id)
                .patch(info.option)
                .then(function(res) {
                    console.log('SubQuestionOption Updated - ', res);
                    _.extend(info.option, res);
                    res.id = info.option.id;
                    $scope.$broadcast(OPTION.updated, res);
                })
                .catch(function(err) {
                    toastr.error('SubQuestionOption Update Err - ', err);
                });

            console.log('Question Options Updated - ', vm.questions);
        });

        /**
         * DELETE
         */
        $scope.$on(QUESTION.deleted.options, function($event, info) {
            siProducts
                .subQuestionOptions()
                .one(info.id)
                .customDELETE()
                .then(function() {
                    console.log('SubQuestionOption Deleted');
                    $scope.$broadcast(OPTION.deleted, info.question);
                })
                .catch(function(err) {
                    toastr.error('SubQuestionOption Delete Error - ', err);
                });

            console.log('Question Options Deleted - ', vm.questions);
        });

        $scope.$on(QUESTION.updated.weight, function($event, question) {
            vm.questions.objects[question.index].weight = question.question.weight;
            updateWeight();
            updateQuestion(question, { weight: question.question.weight });
        });

        $scope.$on(QUESTION.updated.title, function($event, question) {
            vm.questions.objects[question.index].title = question.question.title;
            updateQuestion(question, { title: question.question.title });
        });

        $scope.$on(QUESTION.updated.description, function($event, question) {
            vm.questions.objects[question.index].description = question.question.description;
            updateQuestion(question, { description: question.question.description });
        });

        $scope.$on(QUESTION.updated.none_of_the_above, function($event, question) {
            vm.questions.objects[question.index].none_of_the_above = question.question.none_of_the_above;
            updateQuestion(question, { none_of_the_above: question.question.none_of_the_aboven });
        });

        $scope.$on(QUESTION.updated.none_of_the_above, function($event, question) {
            vm.questions.objects[question.index].none_of_the_above = question.question.none_of_the_above;
            updateQuestion(question, { none_of_the_above: question.question.none_of_the_aboven });
        });

        /**
         * Event handler to grab the index and handle the delete - emitted from the question directive.
         */
        $scope.$on(QUESTION.deleted, function($event, info) {
            //We wait 250ms here in order to wait for the delete animation to finish.
            $timeout(function() {
                //Find the id of the question to delete
                var deleteMe = vm.questions.objects
                    .filter(function(question, index) {
                        return index === parseInt(info.index, 10);
                    })
                    .map(function(deleteMe) {
                        return deleteMe.id;
                    })
                    .reduce(function(deleteMe) {
                        return deleteMe;
                    });

                //Send the delete call to the server
                siProducts
                    .subQuestions()
                    .one(deleteMe)
                    .remove()
                    .then(function() {
                        console.log('SubQuestion Deleted');
                    })
                    .catch(function(err) {
                        toastr.error('SubQuestion Delete Err -', err);
                    });

                //Delete the question locally
                vm.questions.objects = vm.questions.objects.filter(function(question, index) {
                    return index !== parseInt(info.index, 10);
                });

                $scope.question.subquestions.objects = vm.questions.objects;

                //Update the new weight
                updateWeight();
            }, 250);
        });

        $scope.$watch(
            'question',
            function() {
                console.log('$scope.question -', $scope.question);

                vm.saveQuestionError = !($scope.question && $scope.question.url);

                if ($scope.question) {
                    vm.questionTypeError = $scope.question.type !== 'scale';
                    if ($scope.question.subquestions && $scope.question.subquestions.objects) {
                        vm.questions.objects = $scope.question.subquestions.objects;
                        vm.questionRangeError = vm.questions.objects
                            .filter(function(question) {
                                return question.type === 'numeric';
                            })
                            .filter(function(question) {
                                return !question.range_is_valid;
                            })
                            .reduce(function(init, invalid) {
                                return invalid;
                            }, false);

                        updateWeight();
                    }
                }
            },
            true
        );
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').controller('selectorController', selectorController);

    selectorController.$inject = ['$scope', 'QUESTION'];

    function selectorController($scope, QUESTION) {
        var vm = this;
        vm.deleting = false;

        $scope.$on(QUESTION.deleted, function() {
            vm.deleting = true;
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.scoreBuilder').controller('QuestionController', QuestionController);

    QuestionController.$inject = ['$scope', 'siProducts', 'QUESTION', 'OPTION'];

    function QuestionController($scope, siProducts, QUESTION, OPTION) {
        var vm = this;

        vm.question = parseQuestion(vm.question);

        vm.addQuestionOption = addQuestionOption;
        vm.updateQuestionOption = updateQuestionOption;
        vm.removeQuestionOption = removeQuestionOption;
        vm.removeQuestion = removeQuestion;
        vm.updateQuestionTitle = updateQuestionTitle;
        vm.updateQuestionDescription = updateQuestionDescription;
        vm.updateQuestion = updateQuestion;
        vm.updateCanonicalOptions = updateCanonicalOptions;
        vm.canonicalOptions = [];
        vm.$onInit = $onInit;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            updateCanonicalOptions();
        }

        function updateCanonicalOptions() {
            if (vm.canonicalSubquestions && vm.canonicalSubquestions.results) {
                vm.canonicalOptions = vm.canonicalSubquestions.results
                    .filter(q => q.url === vm.question.canonical)
                    .map(q => q.options.objects)
                    .reduce((memo, options) => options, []);

                updateQuestion('canonical');
            }
        }

        function updateQuestion(key, selected = null) {
            var update = {};
            update[key] = vm.question[key];

            if (selected != null && key === 'active_in') {
                let newValue = vm.question.active_in.filter(x => !selected.includes(x));

                if (newValue.length > 0) {
                    for (let i = 0; i < vm.question.options.objects.length; i++) {
                        if (vm.question.options.objects[i].active_in.includes(newValue[0]) == false) {
                            vm.question.options.objects[i].active_in.push(newValue[0]);
                        }
                    }
                }
            }

            vm.updateFct()({ question: vm.question, index: vm.index }, update);
        }

        function parseQuestion(question) {
            question.displayWeight = parseInt(question.weight * 100, 10);

            if (question.type === 'numeric') {
                question.options.objects = question.options.objects.map(function(option) {
                    if (option.range_min === null) {
                        option.isFirst = true;
                        option.isLast = false;
                    } else if (option.range_max === null) {
                        option.isFirst = false;
                        option.isLast = true;
                    } else {
                        option.isFirst = false;
                        option.isLast = false;
                    }
                    return option;
                });
            }

            if (question.canonical) {
                vm.canonicalOptions = vm.canonicalSubquestions.results
                    .filter(q => q.url === question.canonical)
                    .map(q => q.options.objects);
            }

            question.options.objects = question.options.objects.map(function(option) {
                return cleanTrailingZeros(option);
            });

            return question;
        }

        function weight() {
            return vm.question.displayWeight;
        }

        /**
         * CREATE OPTION
         */
        function addQuestionOption() {
            var createdOption = {
                title: 'Question Option',
                subquestion: vm.question.url,
                range_min: 0,
                range_max: 0,
                score: 1,
                disabled: true
            };

            if (!vm.question.url) {
                return;
            }
            vm.question.options.objects = vm.question.options.objects ? vm.question.options.objects : [];
            vm.question.options.objects.push(createdOption);

            $scope.$emit(QUESTION.created.options, {
                index: parseInt(vm.index, 10),
                indexCreated: vm.question.options.objects.length
                    ? vm.question.options.objects.length - 1
                    : vm.question.options.objects.length,
                option: createdOption
            });
        }

        /**
         * UPDATE OPTION
         * @param updatedOption
         * @param optionIndex
         */
        function updateQuestionOption(updatedOption, optionIndex) {
            //Check to make sure the user isnt quickly adding and deleting as we need an id to delete
            //and if the server hasnt yet returned that we can do anything with it
            if (!updatedOption.id) {
                return;
            }

            if (vm.question.type !== 'checkbox') {
                vm.question.options.objects[optionIndex].scoreInvalid = !(
                    parseInt(updatedOption.score, 10) > 0 && parseInt(updatedOption.score, 10) <= 5
                );
            }

            if (vm.question.type === 'numeric') {
                vm.question.options.objects.forEach(function(option, index) {
                    option.range_max = option.range_max === '' ? null : option.range_max;
                    option.range_min = option.range_min === '' ? null : option.range_min;

                    $scope.$emit(QUESTION.updated.options, {
                        index: parseInt(vm.index, 10),
                        option: option,
                        optionIndex: index,
                        scoreInvalid: vm.question.options.objects[optionIndex].scoreInvalid
                    });
                });
            } else {
                $scope.$emit(QUESTION.updated.options, {
                    index: parseInt(vm.index, 10),
                    option: updatedOption,
                    optionIndex: optionIndex,
                    scoreInvalid: vm.question.options.objects[optionIndex].scoreInvalid
                });
            }
        }

        /**
         * DELETE OPTION
         * @param option
         * @param removalIndex
         */
        function removeQuestionOption(option, removalIndex) {
            //Check to make sure the user isnt quickly adding and deleting as we need an id to delete
            //and if the server hasnt yet returned that we can do anything with it
            if (!option.id) {
                return;
            }

            //Need to filter here as well as in the event listener for total
            //removal of the option plus updating of the scope
            vm.question.options.objects = vm.question.options.objects.filter(function(option, index) {
                return index !== removalIndex;
            });

            $scope.$emit(QUESTION.deleted.options, {
                index: parseInt(vm.index, 10),
                id: option.id,
                question: vm.question
            });
        }

        /**
         * DELETE QUESTION
         */
        function removeQuestion() {
            $scope.$emit(QUESTION.deleted, { index: parseInt(vm.index, 10) });
        }

        /**
         * Update Question Title
         */
        function updateQuestionTitle() {
            $scope.$emit(QUESTION.updated.title, { index: vm.index, question: vm.question });
        }

        /**
         * Update Question Description
         */
        function updateQuestionDescription() {
            $scope.$emit(QUESTION.updated.description, { index: vm.index, question: vm.question });
        }

        function cleanTrailingZeros(option) {
            option.score = parseFloat(option.score);
            option.range_max = parseFloat(option.range_max);
            option.range_min = parseFloat(option.range_min);

            return option;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$watch(weight, function(newVal, oldVal) {
            vm.question.displayWeight = vm.question.displayWeight || 100;

            if (parseInt(newVal, 10) !== parseInt(oldVal, 10)) {
                vm.question.weight = vm.question.displayWeight / 100;
                $scope.$emit(QUESTION.updated.weight, { index: vm.index, question: vm.question });
            }
        });

        $scope.$on(OPTION.updated, function($event, updatedOption) {
            vm.question.options.objects.forEach(function(option) {
                //First we make sure that we are updating the right question
                if (option.id === updatedOption.id) {
                    option.disabled = false;

                    //Then we check of the range_is_valid is either true or false and update accordingly
                    if (updatedOption.range_is_valid === true || updatedOption.range_is_valid === false) {
                        vm.question.range_is_valid = updatedOption.range_is_valid;
                    }

                    //Then we check of the score_is_valid is either true or false and update accordingly
                    if (updatedOption.scores_are_valid === true || updatedOption.scores_are_valid === false) {
                        vm.question.scores_are_valid = updatedOption.scores_are_valid;
                    }
                }
            });

            vm.question.options.objects = vm.question.options.objects.map(function(option) {
                return cleanTrailingZeros(option);
            });
        });

        $scope.$on(OPTION.deleted, function($event, question) {
            if (vm.question.id === question.id) {
                siProducts
                    .subQuestions()
                    .one(vm.question.id)
                    .get()
                    .then(function(question) {
                        _.extend(vm.question, question);
                    });
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').factory('siProjects', Projects);

    Projects.$inject = ['Restangular', '$http', 'siHrm', 'usernameFilter', 'apiUrl', 'siScope'];

    function Projects(Restangular, $http, siHrm, usernameFilter, apiUrl, siScope) {
        var service = this,
            configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            });

        var projects = configuredRestangular.all('projects');

        service.projects = getProjects();
        service.draftProjects = getDraftProjects();
        service.project = project();
        service.getProjects_params = getProjects_params;
        service.shareProject = shareProject;
        service.unshareProject = unshareProject;
        service.updateQRList = updateQRList;
        service.updateQualityReviewers = updateQualityReviewers;
        service.updateProjectContacts = updateProjectContacts;
        service.saveNewProject = saveNewProject;
        service.getProjectObjectives = getProjectObjectives;
        service.getAgriGradeProjects = getAgriGradeProjects;
        service.getProjectsData = getProjectsData;
        service.getUsersData = getUsersData;
        service.getOrganizationData = getOrganizationData;
        service.getQuestionareData = getQuestionareData;
        service.getBenchmarkData = getBenchmarkData;
        service.getCashFlowReport = getCashFlowReport;
        service.getProfitLossReport = getProfitLossReport;
        service.getBalanceSheetReport = getBalanceSheetReport;
        service.getFinanceHistory = getFinanceHistory;
        service.getFinanceRatios = getFinanceRatios;
        service.getProjectReport = getProjectReport;
        // From sprint 3
        service.getValuChainReport = getValuChainReport;
        service.getProductioSalesReport = getProductioSalesReport;
        service.getDocumentationReport = getDocumentationReport;
        service.getObservationsReport = getObservationsReport;
        service.getQcReport = getQcReport;
        service.getAdvQuestionareReport = getAdvQuestionareReport;
        service.getFinanceOverview = getFinanceOverview;
        service.getDataSharingReport = getDataSharingReport;

        service.generateProjectsData = generateProjectsData;
        service.generateUsersData = generateUsersData;
        service.generateOrganizationData = generateOrganizationData;
        service.generateQuestionareData = generateQuestionareData;
        service.generateBenchmarkData = generateBenchmarkData;
        service.generateConsolidatedReports = generateConsolidatedReports;
        service.generateProductionData = generateProductionData;

        service.generateCashFlowReport = generateCashFlowReport;
        service.generateProfitLossReport = generateProfitLossReport;
        service.generateBalanceSheetReport = generateBalanceSheetReport;
        service.generateFinanceHistory = generateFinanceHistory;
        service.generateFinanceRatios = generateFinanceRatios;
        service.generateProjectReport = generateProjectReport;

        // From sprint 3
        service.generateValuChainReport = generateValuChainReport;
        service.generateProductioSalesReport = generateProductioSalesReport;
        service.generateDocumentationReport = generateDocumentationReport;
        service.generateObservationsReport = generateObservationsReport;
        service.generateQcReport = generateQcReport;
        service.generateAdvQuestionareReport = generateAdvQuestionareReport;
        service.generateFinanceOverview = generateFinanceOverview;

        service.isScopeEmployee = isScopeEmployee;
        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getProjects() {
            return Restangular.service('projects/projects');
        }

        function getProjects_params(params) {
            params = params ? params : {};
            return projects.one('projects').customGET('', params);
        }

        function getDraftProjects() {
            return configuredRestangular.service('projects/draft_projects');
        }

        function project() {
            return configuredRestangular.service('projects');
        }

        function shareProject(projectId, params) {
            return projects.one('projects/' + projectId + '/share').customPOST(params);
        }

        function unshareProject(projectId, params) {
            return projects.one('projects/' + projectId + '/unshare').customPOST(params);
        }

        function getAgriGradeProjects() {
            const url = `${apiUrl}/projects/projects/agri_grade_projects/`;
            return siScope.getList(url);
        }

        function updateQRList(
            clientPerformsQC,
            clientDashAdmins,
            organization,
            defaultQR,
            defaultFinancialQR,
            employees
        ) {
            let qualityReviewers = { results: [] };

            if (clientPerformsQC) {
                qualityReviewers = Object.assign({}, clientDashAdmins);

                if (organization) {
                    qualityReviewers.results = qualityReviewers.results.filter(qr => qr.organization === organization);
                }
            } else {
                qualityReviewers.results = employees;
            }

            if (defaultQR) {
                qualityReviewers.results = qualityReviewers.results
                    .filter(qr => qr.url !== defaultQR.url)
                    .concat([defaultQR]);
            }

            if (defaultFinancialQR) {
                qualityReviewers.results = qualityReviewers.results
                    .filter(qr => qr.url !== defaultFinancialQR.url)
                    .concat([defaultFinancialQR]);
            }

            return qualityReviewers;
        }

        function updateQualityReviewers(originalQualityReviewers, contacts = [], projectMembers = [], projectContact) {
            let qualityReviewers = { results: [] };

            if (contacts.length) {
                const contactQR = contacts
                    .filter(contact => contact.url === projectContact)
                    .filter(contact => contact.is_customer_user)
                    .map(contact => {
                        contact = Object.assign({}, contact);
                        contact.url = contact.user;
                        return contact;
                    });
                const customerMembersQR = projectMembers
                    .filter(cm => (_.isObject(cm.user) ? cm.user.is_customer_user : cm.is_customer_user))
                    .map(cm => {
                        if (_.isObject(cm.user)) {
                            return cm.user;
                        }
                        return cm;
                    });

                qualityReviewers.results = _.uniq(
                    originalQualityReviewers.results.concat(contactQR.concat(customerMembersQR)),
                    'url'
                );
            }

            return qualityReviewers;
        }

        function updateProjectContacts(customerId, projectId) {
            return siHrm.getProjectContacts(customerId, projectId).then(users => {
                let customerContacts = users.map(user => ({
                    username: usernameFilter(user),
                    url: user.customer_contact || user.url,
                    is_customer_user: user.is_customer_user,
                    user: user.url
                }));
                return customerContacts;
            });
        }

        function saveNewProject(project) {
            const url = `${apiUrl}/projects/projects/`;
            project.quality_reviewer = project.quality_reviewer.url;
            return siScope.post({ url }, project);
        }

        function getProjectObjectives() {
            const url = `${apiUrl}/projects/projectobjectives/`;
            return siScope.getList(url, { params: { page_size: 9999 } });
        }

        function getProjectsData() {
            return $http({
                url: apiUrl + '/reports/reports/projects_users_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'projects_users_report.xlsx');
            });
        }

        function getUsersData(year) {
            if (year == 'All years') {
                return $http({
                    url: apiUrl + '/reports/reports/users_report/export',
                    method: 'GET',
                    responseType: 'arraybuffer'
                }).then(function(res) {
                    var type = res.headers('Content-Type');

                    var blob = new Blob([res.data], { type: type });
                    saveAs(blob, 'users_report.xlsx');
                });
            } else {
                return $http({
                    url: apiUrl + '/reports/reports/' + year + '/export_users_report',
                    method: 'GET',
                    responseType: 'arraybuffer'
                }).then(function(res) {
                    var type = res.headers('Content-Type');

                    var blob = new Blob([res.data], { type: type });
                    saveAs(blob, 'users_report.xlsx');
                });
            }
        }

        function getOrganizationData() {
            return $http({
                url: apiUrl + '/reports/reports/organization_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'organization_report.xlsx');
            });
        }

        /*function getQuestionareType(urlTemp){
            return $http({
                url: urlTemp,
                method: 'GET'
            }).then(function(res) {
                
            });
        }*/
        function isScopeEmployee() {
            return $http({
                url: JSON.parse(localStorage['ngStorage-user']).info.organization,
                method: 'GET',
                responseType: 'application/json'
            }).then(function(res) {
                console.log(res);
            });
        }

        function getQuestionareData(is_scope) {
            return $http({
                url: apiUrl + '/reports/reports/questionnaire_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');
                var extension = is_scope ? 'zip' : 'xlsx';

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'questionnaire_report.' + extension);
            });
        }

        function getBenchmarkData() {
            return $http({
                url: apiUrl + '/reports/reports/benchmark_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'benchmark_report.xlsx');
            });
        }

        function getCashFlowReport() {
            return $http({
                url: apiUrl + '/reports/reports/cash_flow_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'cash_flow_report.xlsx');
            });
        }

        function getProfitLossReport() {
            return $http({
                url: apiUrl + '/reports/reports/profit_loss_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'profit_loss_report.xlsx');
            });
        }

        function getBalanceSheetReport() {
            return $http({
                url: apiUrl + '/reports/reports/balance_sheet_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'balance_sheet_report.xlsx');
            });
        }

        function getFinanceHistory() {
            return $http({
                url: apiUrl + '/reports/reports/finance_history_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'finance_history_report.xlsx');
            });
        }

        function getFinanceRatios() {
            return $http({
                url: apiUrl + '/reports/reports/finance_ratios_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'finance_ratios_report.xlsx');
            });
        }

        function getProjectReport() {
            return $http({
                url: apiUrl + '/reports/reports/projects_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'projects_report.xlsx');
            });
        }

        function getValuChainReport() {
            return $http({
                url: apiUrl + '/reports/reports/value_chain_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'value_chain_report.xlsx');
            });
        }

        function getProductioSalesReport() {
            return $http({
                url: apiUrl + '/reports/reports/production_sales_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'production_sales_report.xlsx');
            });
        }

        function getDocumentationReport() {
            return $http({
                url: apiUrl + '/reports/reports/documentation_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'documentation_report.xlsx');
            });
        }

        function getObservationsReport() {
            return $http({
                url: apiUrl + '/reports/reports/observations_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'observations_report.xlsx');
            });
        }

        function getQcReport() {
            return $http({
                url: apiUrl + '/reports/reports/qc_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'qc_report.xlsx');
            });
        }

        function getAdvQuestionareReport() {
            return $http({
                url: apiUrl + '/reports/reports/advanced_questionnaire_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'advanced_questionnaire_report.zip');
            });
        }

        function getFinanceOverview() {
            return $http({
                url: apiUrl + '/reports/reports/finance_overview_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'finance_overview_report.xlsx');
            });
        }

        function getDataSharingReport() {
            return $http({
                url: apiUrl + '/reports/reports/export_data_sharing_report',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');

                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'export_data_sharing_report.zip');
            });
        }

        // GENERATE REPORT ENDPOINTS

        function generateProjectsData() {
            return $http({
                url: apiUrl + '/reports/reports/projects_users_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateUsersData() {
            return $http({
                url: apiUrl + '/reports/reports/users_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateOrganizationData() {
            return $http({
                url: apiUrl + '/reports/reports/organization_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateQuestionareData() {
            return $http({
                url: apiUrl + '/reports/reports/questionnaire_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateBenchmarkData() {
            return $http({
                url: apiUrl + '/reports/reports/benchmark_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateConsolidatedReports() {
            return $http({
                url: apiUrl + '/reports/reports/consolidated_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateProductionData() {
            return $http({
                url: apiUrl + '/reports/reports/production_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateCashFlowReport() {
            return $http({
                url: apiUrl + '/reports/reports/cash_flow_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateProfitLossReport() {
            return $http({
                url: apiUrl + '/reports/reports/profit_loss_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateBalanceSheetReport() {
            return $http({
                url: apiUrl + '/reports/reports/balance_sheet_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateFinanceHistory() {
            return $http({
                url: apiUrl + '/reports/reports/finance_history_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateFinanceRatios() {
            return $http({
                url: apiUrl + '/reports/reports/finance_ratios_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        function generateProjectReport() {
            return $http({
                url: apiUrl + '/reports/reports/projects_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }

        // from sprint 3
        function generateValuChainReport() {
            return $http({
                url: apiUrl + '/reports/reports/value_chain_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateProductioSalesReport() {
            return $http({
                url: apiUrl + '/reports/reports/production_sales_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateDocumentationReport() {
            return $http({
                url: apiUrl + '/reports/reports/documentation_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateObservationsReport() {
            return $http({
                url: apiUrl + '/reports/reports/observations_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateQcReport() {
            return $http({
                url: apiUrl + '/reports/reports/qc_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateAdvQuestionareReport() {
            return $http({
                url: apiUrl + '/reports/reports/advanced_questionnaire_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
        function generateFinanceOverview() {
            return $http({
                url: apiUrl + '/reports/reports/finance_overview_report/generate',
                method: 'GET'
            }).then(function(res) {});
        }
    }
})();

(function() {
    'use strict';

    /**
     * Data access and selection state for the Detailed Score Analysis tab
     * (AD-2197: AD-2198 / AD-2199 / AD-2200).
     *
     * Spans projects like Reassessment & Progress: the projects are repeated
     * `project` params, each checked on the server. One assessment tool and
     * major version at a time. Every figure comes computed from the server;
     * CSV and formatting helpers are shared with siReassessmentAnalytics.
     */
    angular.module('scope.commons.projects').factory('siScoreAnalysis', ScoreAnalysis);

    ScoreAnalysis.$inject = ['siScope', 'apiUrl', '$window', 'siReassessmentAnalytics'];

    function ScoreAnalysis(siScope, apiUrl, $window, siReassessmentAnalytics) {
        const service = this;
        const STORAGE_PREFIX = 'pad_score_analysis:';
        const LIST_PARAMS = ['country', 'value_chain', 'maturity_level'];

        service.VIEWS = [
            { id: 'explorer', label: 'Hierarchy explorer' },
            { id: 'priorities', label: 'Insights & priorities' },
            { id: 'segments', label: 'Segments' },
            { id: 'heatmap', label: 'FO heatmap' },
            { id: 'progress', label: 'Progress' }
        ];
        service.BAND_COLORS = { weak: '#d95c5c', developing: '#e5b04a', strong: '#8fbc6b', very_strong: '#1f6b4f' };
        service.MATURITY_COLORS = { level_1: '#ee6666', level_2: '#fac858', level_3: '#91cc75', level_4: '#3ba272' };
        service.OPTION_COLORS = ['#ee6666', '#fc8452', '#fac858', '#91cc75', '#3ba272'];

        service.view = view;
        service.defaultSelection = defaultSelection;
        service.loadSelection = loadSelection;
        service.saveSelection = saveSelection;
        service.toParams = toParams;
        service.validate = validate;
        service.getProjects = () => siScope.getItem(url('projects'), {});
        service.getFilterOptions = selection =>
            siScope.getItem(url('filter-options'), { params: { project: selection.projects.slice() } });
        service.get = (resource, selection, extra) =>
            siScope.getItem(url(resource), { params: toParams(selection, extra) });
        service.scale = scale;
        service.downloadCsv = siReassessmentAnalytics.downloadCsv;
        service.signed = siReassessmentAnalytics.signed;
        service.changeClass = siReassessmentAnalytics.changeClass;

        return service;

        function url(resource) {
            return apiUrl + '/projects/projects/score-analysis/' + resource + '/';
        }

        function view(id) {
            return service.VIEWS.filter(v => v.id === id)[0] || service.VIEWS[0];
        }

        function defaultSelection(projectId) {
            return {
                projects: projectId ? [Number(projectId)] : [],
                tool: null,
                version: null,
                startDate: null,
                endDate: null,
                country: [],
                value_chain: [],
                maturity_level: []
            };
        }

        function storage() {
            try {
                return $window.localStorage;
            } catch (e) {
                return null;
            }
        }

        function loadSelection(projectId) {
            const selection = defaultSelection(projectId);
            const store = storage();
            if (store) {
                try {
                    const saved = JSON.parse(store.getItem(STORAGE_PREFIX + projectId) || 'null');
                    if (saved && typeof saved === 'object') {
                        Object.keys(selection).forEach(key => {
                            if (saved[key] !== undefined) {
                                selection[key] = saved[key];
                            }
                        });
                    }
                } catch (e) {
                    // a corrupt entry is replaced on the next save
                }
            }
            if (!selection.projects || !selection.projects.length) {
                selection.projects = defaultSelection(projectId).projects;
            }
            return selection;
        }

        function saveSelection(projectId, selection) {
            const store = storage();
            if (!store) {
                return;
            }
            try {
                store.setItem(STORAGE_PREFIX + projectId, JSON.stringify(selection));
            } catch (e) {
                // storage full or blocked: the selection lives for this visit only
            }
        }

        function dateParam(value) {
            if (!value) {
                return null;
            }
            if (value instanceof Date) {
                const month = ('0' + (value.getMonth() + 1)).slice(-2);
                const dayOfMonth = ('0' + value.getDate()).slice(-2);
                return value.getFullYear() + '-' + month + '-' + dayOfMonth;
            }
            return String(value).slice(0, 10);
        }

        function toParams(selection, extra) {
            const params = { project: selection.projects.slice() };
            if (selection.tool) {
                params.tool = selection.tool;
            }
            if (selection.version !== null && selection.version !== undefined && selection.version !== '') {
                params.version = selection.version;
            }
            const from = dateParam(selection.startDate);
            const to = dateParam(selection.endDate);
            if (from) {
                params.date_from = from;
            }
            if (to) {
                params.date_to = to;
            }
            LIST_PARAMS.forEach(name => {
                const values = (selection[name] || []).filter(v => v !== 'all');
                if (values.length) {
                    params[name] = values.slice();
                }
            });
            return angular.extend(params, extra || {});
        }

        function validate(selection) {
            const errors = [];
            if (!selection.projects.length) {
                errors.push('Select at least one project.');
            }
            const from = dateParam(selection.startDate);
            const to = dateParam(selection.endDate);
            if (from && to && from > to) {
                errors.push('The start date must be on or before the end date.');
            }
            return errors;
        }

        /** A 1-5 score as a 0-100 position, for the bars that start at 1. */
        function scale(value) {
            if (value === null || value === undefined || isNaN(value)) {
                return 0;
            }
            return Math.max(0, Math.min(100, ((value - 1) / 4) * 100));
        }
    }
})();

(function() {
    'use strict';

    /**
     * Data access and selection state for the Reassessment & Progress tab
     * (AD-2194 / AD-2195 / AD-2196).
     *
     * Unlike the other analytics tabs this one spans projects: the selection
     * is a list of project ids, sent as repeated `project` params. The server
     * refuses the whole request if any of them is not a project the user can
     * open, so the browser never needs to filter for permissions itself.
     *
     * Every figure is computed on the server; this service only moves
     * parameters and payloads, and builds CSV from rows it was given.
     */
    angular.module('scope.commons.projects').factory('siReassessmentAnalytics', ReassessmentAnalytics);

    ReassessmentAnalytics.$inject = ['siScope', 'apiUrl', '$window', '$document'];

    function ReassessmentAnalytics(siScope, apiUrl, $window, $document) {
        const service = this;

        // Per entry project: opening the tab from project B never inherits the
        // projects chosen from project A.
        const STORAGE_PREFIX = 'pad_reassessment:';

        const TABS = [
            { id: 'overview', label: 'Overview', resource: 'overview' },
            { id: 'scores', label: 'Scores & Subdimensions', resource: 'scores' },
            { id: 'demographics', label: 'Demographics', resource: 'demographics' },
            { id: 'financials', label: 'Financial Performance', resource: 'financials', money: true },
            { id: 'finance-history', label: 'Finance History', resource: 'finance-history', money: true },
            { id: 'production', label: 'Production & Sales', resource: 'production-sales', money: true },
            { id: 'explorer', label: 'FO-Level Explorer', resource: 'fos' },
            { id: 'coverage', label: 'Coverage & Data Quality', resource: 'coverage' }
        ];

        const LIST_PARAMS = ['country', 'value_chain', 'tool_type', 'maturity_level'];

        service.TABS = TABS;
        service.tab = tab;
        service.defaultSelection = defaultSelection;
        service.loadSelection = loadSelection;
        service.saveSelection = saveSelection;
        service.toParams = toParams;
        service.validate = validate;
        service.getProjects = getProjects;
        service.getFilterOptions = getFilterOptions;
        service.getResource = getResource;
        service.getFoDetail = getFoDetail;
        service.downloadCsv = downloadCsv;
        service.signed = signed;
        service.changeClass = changeClass;

        return service;

        function tab(id) {
            return TABS.filter(t => t.id === id)[0] || TABS[0];
        }

        function defaultSelection(projectId) {
            return {
                projects: projectId ? [Number(projectId)] : [],
                method: 'baseline_latest',
                score_tool: null,
                startDate: null,
                endDate: null,
                currency: 'USD',
                weight_unit: 'kg',
                baseline_year: null,
                comparison_year: null,
                country: [],
                value_chain: [],
                tool_type: [],
                maturity_level: []
            };
        }

        function storage() {
            try {
                return $window.localStorage;
            } catch (e) {
                return null;
            }
        }

        function loadSelection(projectId) {
            const selection = defaultSelection(projectId);
            const store = storage();
            if (!store) {
                return selection;
            }
            try {
                const saved = JSON.parse(store.getItem(STORAGE_PREFIX + projectId) || 'null');
                if (saved && typeof saved === 'object') {
                    Object.keys(selection).forEach(key => {
                        if (saved[key] !== undefined) {
                            selection[key] = saved[key];
                        }
                    });
                }
            } catch (e) {
                // a corrupt entry is replaced on the next save
            }
            if (!selection.projects || !selection.projects.length) {
                selection.projects = defaultSelection(projectId).projects;
            }
            return selection;
        }

        function saveSelection(projectId, selection) {
            const store = storage();
            if (!store) {
                return;
            }
            try {
                store.setItem(STORAGE_PREFIX + projectId, JSON.stringify(selection));
            } catch (e) {
                // storage full or blocked: the selection lives for this visit only
            }
        }

        function dateParam(value) {
            if (!value) {
                return null;
            }
            if (value instanceof Date) {
                const month = ('0' + (value.getMonth() + 1)).slice(-2);
                const dayOfMonth = ('0' + value.getDate()).slice(-2);
                return value.getFullYear() + '-' + month + '-' + dayOfMonth;
            }
            return String(value).slice(0, 10);
        }

        function toParams(selection, extra) {
            const params = {
                project: selection.projects.slice(),
                method: selection.method,
                currency: selection.currency || 'USD',
                weight_unit: selection.weight_unit || 'kg'
            };
            if (selection.score_tool) {
                params.score_tool = selection.score_tool;
            }
            const from = dateParam(selection.startDate);
            const to = dateParam(selection.endDate);
            if (from) {
                params.date_from = from;
            }
            if (to) {
                params.date_to = to;
            }
            if (selection.baseline_year && selection.comparison_year) {
                params.baseline_year = selection.baseline_year;
                params.comparison_year = selection.comparison_year;
            }
            LIST_PARAMS.forEach(name => {
                const values = (selection[name] || []).filter(v => v !== 'all');
                if (values.length) {
                    params[name] = values.slice();
                }
            });
            return angular.extend(params, extra || {});
        }

        /** The errors the server would refuse with, caught before the request. */
        function validate(selection) {
            const errors = [];
            if (!selection.projects.length) {
                errors.push('Select at least one project.');
            }
            const from = dateParam(selection.startDate);
            const to = dateParam(selection.endDate);
            if (from && to && from > to) {
                errors.push('The start date must be on or before the end date.');
            }
            const baseline = Number(selection.baseline_year);
            const comparison = Number(selection.comparison_year);
            if (
                (selection.baseline_year && !selection.comparison_year) ||
                (!selection.baseline_year && selection.comparison_year)
            ) {
                errors.push('Choose both fiscal years, or neither.');
            } else if (baseline && comparison && baseline >= comparison) {
                errors.push('The comparison year must be after the baseline year.');
            }
            return errors;
        }

        function url(resource) {
            return apiUrl + '/projects/projects/reassessment/' + resource + '/';
        }

        function getProjects() {
            return siScope.getItem(url('projects'), {});
        }

        function getFilterOptions(selection) {
            return siScope.getItem(url('filter-options'), { params: { project: selection.projects.slice() } });
        }

        function getResource(tabId, selection) {
            return siScope.getItem(url(tab(tabId).resource), { params: toParams(selection) });
        }

        function getFoDetail(selection, foId) {
            return siScope.getItem(url('fos'), { params: toParams(selection, { fo: foId }) });
        }

        /* Formatting */

        function signed(value, decimals, suffix) {
            if (value === null || value === undefined || isNaN(value)) {
                return '--';
            }
            const places = decimals === undefined ? 1 : decimals;
            const text = Number(value).toLocaleString('en-US', {
                minimumFractionDigits: places,
                maximumFractionDigits: places
            });
            return (value > 0 ? '+' : '') + text + (suffix || '');
        }

        /** `lowerIsBetter` for costs, where a fall is the improvement. */
        function changeClass(value, lowerIsBetter) {
            if (value === null || value === undefined || value === 0) {
                return 'delta--flat';
            }
            const good = lowerIsBetter ? value < 0 : value > 0;
            return good ? 'delta--up' : 'delta--down';
        }

        /* CSV, the same shape as the other analytics exports */

        function csvCell(value) {
            if (value === null || value === undefined) {
                return '';
            }
            const text = String(value);
            return /[",\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }

        function downloadCsv(filename, header, rows) {
            const lines = [header.map(csvCell).join(',')].concat(rows.map(row => row.map(csvCell).join(',')));
            const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
            const href = $window.URL.createObjectURL(blob);
            const anchor = $document[0].createElement('a');
            anchor.href = href;
            anchor.download = filename;
            $document[0].body.appendChild(anchor);
            anchor.click();
            $document[0].body.removeChild(anchor);
            $window.URL.revokeObjectURL(href);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').factory('siProjectDetailDashboard', siProjectDetailDashboard);

    siProjectDetailDashboard.$inject = ['$state', '$http', 'saveAs'];

    function siProjectDetailDashboard($state, $http, saveAs) {
        const service = this;

        service.getBarChartWidth = getBarChartWidth;
        service.gotoAssessment = gotoAssessment;
        service.exportExcel = exportExcel;
        service.exportProjectOverview = exportProjectOverview;
        service.export_to_json = export_to_json;
        service.download_all_reports = download_all_reports;
        service.setQualityReviewer = setQualityReviewer;
        service.setFinancialQualityReviewer = setFinancialQualityReviewer;
        service.setProjectQualityReviewer = setProjectQualityReviewer;
        service.setProjectFinancialQualityReviewer = setProjectFinancialQualityReviewer;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setQualityReviewer(assessments, projectQR = {}) {
            assessments.results = assessments.results.map(assessment => {
                assessment.quality_reviewer = assessment.quality_reviewer || projectQR;
                return assessment;
            });
            return assessments;
        }

        function setFinancialQualityReviewer(assessments, projectFSQR = {}) {
            assessments.results = assessments.results.map(assessment => {
                assessment.financial_quality_reviewer = assessment.financial_quality_reviewer || projectFSQR;
                return assessment;
            });
            return assessments;
        }

        function setProjectQualityReviewer(project, defaultQR) {
            project.quality_reviewer = project.quality_reviewer || defaultQR;
            return project;
        }

        function setProjectFinancialQualityReviewer(project, defaultFSQR) {
            project.financial_quality_reviewer = project.financial_quality_reviewer || defaultFSQR;
            return project;
        }

        function getBarChartWidth(assessments, status) {
            if (!assessments || typeof status === 'undefined') {
                return 0;
            }

            let percent = status < assessments.count ? (status / assessments.count) * 100 : 100;

            return `${percent}%`;
        }

        function gotoAssessment(assessment) {
            switch (assessment.status) {
                case 'qc_assessor':
                case 'qc_quality_review':
                    const { id } = assessment.assessmentassignments.objects[0];
                    return $state.go('base.assessments-assignment-detail.assessment', { id });
                case 'has_draft':
                case 'has_final':
                    if (assessment.tool_type === 'SCOPE Rapid') {
                        const id = assessment.id;
                        return $state.go('base.assessments-rapid-final.summary', { id });
                    }
                    if (assessment.reports.objects.length) {
                        const { id } = assessment.reports.objects[0];
                        return $state.go('base.reports-detail.summary', { id });
                    }
            }
            // OLD
            // if (assessment.status === 'qc_assessor' || assessment.status === 'qc_quality_review') {
            //     const { id } = assessment.assessmentassignments.objects[0];
            //     console.log('attempting to redirect to assignment', id);
            //     return $state.go('base.assessments-assignment-detail.assessment', { id });
            // }
            // if (
            //     (assessment.status === 'has_draft' || assessment.status === 'has_final') &&
            //     assessment.reports.objects.length
            // ) {
            //     console.log('idemo na rapid report');
            //     const { id } = assessment.reports.objects[0];
            //     return $state.go('base.reports-detail.summary', { id });
            // }
        }

        function exportExcel(projectUrl, tool_type) {
            return $http({
                url: `${projectUrl}export/?tool_type=${tool_type}`,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                const type = res.headers('Content-Type');
                const blob = new Blob([res.data], { type: type });
                saveAs(blob, `export-${tool_type}.xlsx`);
            });
        }

        function exportProjectOverview(projectUrl) {
            return $http({
                url: `${projectUrl}export_project_overview/`,
                method: 'GET',
                responseType: 'arraybuffer'
            })
                .then(function(res) {
                    const type = res.headers('Content-Type');
                    const blob = new Blob([res.data], { type: type });
                    saveAs(blob, 'export.xlsx');
                })
                .catch(error => {
                    throw error;
                });
        }

        function export_to_json(projectUrl) {
            return $http({
                url: `${projectUrl}export_to_json/`,
                method: 'GET',
                responseType: 'blob'
            })
                .then(function(res) {
                    const type = res.headers('Content-Type');
                    const blob = new Blob([res.data], { type: type });
                    saveAs(blob, 'export.json');
                })
                .catch(error => {
                    throw error;
                });
        }

        function download_all_reports(projectUrl, projectName) {
            return $http({
                url: `${projectUrl}download_all_reports/`,
                method: 'GET',
                responseType: 'arraybuffer'
            })
                .then(function(res) {
                    const type = res.headers('Content-Type');
                    const blob = new Blob([res.data], { type: type });
                    const fileName = `${projectName}.zip`;
                    saveAs(blob, fileName);
                })
                .catch(error => {
                    throw error;
                });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Data access and shared global-filter state for the project analytics tabs.
     *
     * Uses the internal, session-authenticated endpoints on the projects
     * viewset — never the Open API, which would mean putting a live read key
     * into browser JavaScript.
     *
     * The aggregates come back already computed over the filtered FO
     * population (so KPI denominators, chart values, completeness percentages
     * and sample sizes always agree with each other), while the `records`
     * arrays back the drill-down tables and their local filters without
     * another round trip.
     */
    angular.module('scope.commons.projects').factory('siProjectAnalytics', ProjectAnalytics);

    ProjectAnalytics.$inject = ['siScope', 'apiUrl', '$window', '$rootScope', '$timeout'];

    function ProjectAnalytics(siScope, apiUrl, $window, $rootScope, $timeout) {
        const service = this;

        // Scoped per project. FR-016 / FR-017.
        //
        // This used to be one key for every project, so opening project B
        // silently inherited project A's tool types, countries and dates - and
        // the figures were correct for a population the user had not chosen and
        // could not see they had chosen. The project id is part of the key now,
        // and `LEGACY_FILTER_KEY` is removed on first load so the old shared
        // state cannot leak into the first project opened after this ships.
        const FILTER_KEY_PREFIX = 'pad_global_filters:';
        const LEGACY_FILTER_KEY = 'pad_global_filters';
        const SCORE_FLOOR = 1;
        const SCORE_CEILING = 5;

        // The population filters, as opposed to `currency`, which selects how
        // money is expressed and changes no count (FR-018, FR-019, AC-014).
        const LIST_FILTERS = ['country', 'value_chain', 'tool_type', 'maturity_level'];

        // The quick score filters. Each one selects a maturity level rather
        // than typing its bounds into the score range: the range is inclusive
        // at both ends, so "2 to 3" would also take in the FOs scoring exactly
        // 3.0, which belong to Level 3. The server resolves a level to the
        // same half-open interval the maturity distribution uses (FR-010).
        const MATURITY_LABELS = {
            level_1: 'Level 1',
            level_2: 'Level 2',
            level_3: 'Level 3',
            level_4: 'Level 4'
        };

        // The "Definition" box at the foot of the filter rail: what the tab
        // reports, in a sentence, so the same filters can be read correctly on
        // each of them.
        const TAB_DEFINITIONS = {
            overview:
                'The overview summarises assessment, score and reach fields. Financial Information, ' +
                'Finance History and Production & sales retain their specialist indicators and drill-downs.',
            demographics:
                'Members, management and workforce of the filtered FOs, from the latest finalised ' +
                'assessment of each FO in this project.',
            financials:
                'The latest financial position of the filtered FOs, one record per FO, on the fiscal ' +
                'year most FOs last reported. Reporting currency changes how money is expressed only.',
            'finance-history':
                'Loans, grants and pre-finance recorded for the filtered FOs. Reporting currency ' +
                'changes how money is expressed only.',
            'production-sales':
                'Volumes produced, purchased and sold by the filtered FOs, per product and reporting year.',
            'data-quality': 'How complete and consistent the data behind the other tabs is, for the filtered FOs.'
        };

        service.defaultFilters = defaultFilters;
        service.loadFilters = loadFilters;
        service.saveFilters = saveFilters;
        service.clearFilters = clearFilters;
        service.toParams = toParams;
        service.describeFilters = describeFilters;
        service.validateFilters = validateFilters;
        service.reconcileFilters = reconcileFilters;
        service.activeChips = activeChips;
        service.removeChip = removeChip;
        service.isCurrencyRelevant = isCurrencyRelevant;
        service.bindFilterScope = bindFilterScope;
        service.maturityLabel = maturityLabel;
        service.toDateInput = toDateInput;

        service.getFinancials = getFinancials;
        service.getFinanceHistory = getFinanceHistory;
        service.getProductionSales = getProductionSales;
        service.getDemographics = getDemographics;
        service.getOverview = getOverview;
        service.getDataQuality = getDataQuality;
        service.getDataQualityDrilldown = getDataQualityDrilldown;
        service.getFilterOptions = getFilterOptions;
        service.getRolloutFlags = getRolloutFlags;
        service.ensureRolloutFlags = ensureRolloutFlags;

        service.isSampleThin = isSampleThin;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Global filters
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * The shared portfolio filter state. AD-2106 §10, §11.
         *
         * One object for every analytics tab, so a filter set on one is still
         * set on the next. `tool_type` is a list because the filter is
         * multi-select, like the other population filters the backend accepts.
         */
        function defaultFilters() {
            return {
                currentMinRange: SCORE_FLOOR,
                currentMaxRange: SCORE_CEILING,
                startDate: null,
                endDate: null,
                currency: 'USD',
                tool_type: [],
                country: [],
                value_chain: [],
                maturity_level: []
            };
        }

        function filterKey(projectId) {
            return FILTER_KEY_PREFIX + projectId;
        }

        function loadFilters(projectId) {
            const defaults = defaultFilters();
            try {
                // Drop the pre-FR-016 shared key wherever we find it, so it can
                // never be read again by any project.
                $window.localStorage.removeItem(LEGACY_FILTER_KEY);
                const stored = JSON.parse($window.localStorage.getItem(filterKey(projectId)) || 'null');
                const filters = stored ? angular.extend(defaults, stored) : defaults;
                // `input[type=date]` throws `ngModel:datefmt` on a string model,
                // and JSON hands every stored date back as one.
                filters.startDate = toDateInput(filters.startDate);
                filters.endDate = toDateInput(filters.endDate);
                return filters;
            } catch (error) {
                return defaults;
            }
        }

        function saveFilters(projectId, filters) {
            try {
                // Dates are stored as the calendar day the user picked. A Date
                // serialises as UTC, so a day picked east of Greenwich came
                // back as the day before.
                const stored = angular.extend({}, filters, {
                    startDate: asDateString(filters.startDate),
                    endDate: asDateString(filters.endDate)
                });
                $window.localStorage.setItem(filterKey(projectId), JSON.stringify(stored));
            } catch (error) {
                // a full or disabled localStorage must not break the dashboard
            }
            return filters;
        }

        function clearFilters(projectId) {
            try {
                $window.localStorage.removeItem(filterKey(projectId));
            } catch (error) {
                // ignore
            }
            // FR-021: reporting currency is reset too. It is presented apart
            // from the population filters but it is still a selection the user
            // made, and leaving it behind makes "Clear all" a partial clear.
            return defaultFilters();
        }

        /**
         * Drop stored selections the newly opened project cannot resolve.
         * FR-017, R-16.
         *
         * Silently, and this is the point: a project that has no Pro
         * assessments must not show "Tool type: Pro" as an active filter it
         * cannot offer, and must not warn about it either - the user did not
         * choose it here. What they get is the unfiltered project, which is
         * what they asked for by opening it.
         *
         * `options` is the filter-options payload; a missing list means the
         * project offers nothing on that axis, so every stored value goes.
         */
        function reconcileFilters(filters, options) {
            const reconciled = angular.extend(defaultFilters(), filters || {});
            const available = {
                tool_type: (options && options.tool_types) || [],
                country: (options && options.countries) || [],
                value_chain: (options && options.value_chains) || []
            };
            Object.keys(available).forEach(function(name) {
                const selection = reconciled[name] || [];
                reconciled[name] = selection.filter(function(value) {
                    return available[name].indexOf(value) !== -1;
                });
            });
            const currencies = (options && options.currencies) || [];
            if (reconciled.currency && currencies.length && currencies.indexOf(reconciled.currency) === -1) {
                reconciled.currency = currencies[0];
            }
            return reconciled;
        }

        /**
         * Serialise the global filters into backend query params.
         *
         * Score bounds are only sent when the user has actually narrowed them:
         * the backend filter is `score >= min`, which would also drop
         * assessments whose score is NULL, so sending a no-op 1-5 range would
         * silently shrink the population.
         */
        function toParams(filters) {
            const params = {};
            const active = filters || defaultFilters();

            if (active.startDate) {
                params.date_from = asDateString(active.startDate);
            }
            if (active.endDate) {
                params.date_to = asDateString(active.endDate);
            }
            if (angular.isNumber(active.currentMinRange) && active.currentMinRange > SCORE_FLOOR) {
                params.score_min = active.currentMinRange;
            }
            if (angular.isNumber(active.currentMaxRange) && active.currentMaxRange < SCORE_CEILING) {
                params.score_max = active.currentMaxRange;
            }
            if (active.currency) {
                params.currency = active.currency;
            }
            LIST_FILTERS.forEach(function(name) {
                const selection = active[name];
                if (selection && selection.length) {
                    params[name] = selection;
                }
            });
            return params;
        }

        /**
         * Client-side validation, mirroring the server's. FR-008, FR-009.
         *
         * Returns `{field: message}`, empty when the filters are usable. The
         * server validates too and is the authority - this exists so Apply can
         * be refused without a round trip and, more importantly, so the
         * previous results stay on screen. The server's 400 is the backstop,
         * not the mechanism.
         */
        function validateFilters(filters) {
            const errors = {};
            const active = filters || defaultFilters();
            const from = asDateString(active.startDate);
            const to = asDateString(active.endDate);

            if (from && to && from > to) {
                errors.date_from = 'The start date must be on or before the end date.';
            }
            [
                ['score_min', active.currentMinRange],
                ['score_max', active.currentMaxRange]
            ].forEach(function(pair) {
                const value = pair[1];
                if (angular.isNumber(value) && (value < SCORE_FLOOR || value > SCORE_CEILING)) {
                    errors[pair[0]] = 'Score must be between ' + SCORE_FLOOR + ' and ' + SCORE_CEILING + '.';
                }
            });
            if (
                !errors.score_min &&
                !errors.score_max &&
                angular.isNumber(active.currentMinRange) &&
                angular.isNumber(active.currentMaxRange) &&
                active.currentMinRange > active.currentMaxRange
            ) {
                errors.score_min = 'The minimum score must be less than or equal to the maximum.';
            }
            return errors;
        }

        /**
         * One removable chip per active global filter. FR-022.
         *
         * Currency is included. It is presented apart from the population
         * filters because it changes no count (FR-018), but it is still an
         * active selection and a user who cannot see it cannot undo it.
         */
        function activeChips(filters) {
            const active = filters || defaultFilters();
            const chips = [];

            LIST_FILTERS.forEach(function(name) {
                (active[name] || []).forEach(function(value) {
                    chips.push({ type: name, value: value, label: chipLabel(name, value) });
                });
            });
            if (active.startDate || active.endDate) {
                chips.push({
                    type: 'dates',
                    label:
                        'Date: ' +
                        (asDateString(active.startDate) || '…') +
                        ' to ' +
                        (asDateString(active.endDate) || '…')
                });
            }
            if (active.currentMinRange > SCORE_FLOOR || active.currentMaxRange < SCORE_CEILING) {
                chips.push({
                    type: 'score',
                    label: 'Score: ' + active.currentMinRange + '–' + active.currentMaxRange
                });
            }
            if (active.currency && active.currency !== defaultFilters().currency) {
                chips.push({ type: 'currency', label: 'Currency: ' + active.currency });
            }
            return chips;
        }

        function chipLabel(name, value) {
            const labels = {
                tool_type: 'Tool',
                country: 'Country',
                value_chain: 'Value chain',
                maturity_level: 'Maturity'
            };
            return labels[name] + ': ' + (name === 'maturity_level' ? maturityLabel(value) : value);
        }

        function maturityLabel(value) {
            return MATURITY_LABELS[value] || value;
        }

        /**
         * Remove one chip, returning the filters it leaves behind. FR-022.
         *
         * Returns a new object rather than mutating, so a caller that has not
         * yet pressed Apply still has the applied state to fall back to.
         */
        function removeChip(filters, chip) {
            const next = angular.copy(filters || defaultFilters());
            const defaults = defaultFilters();
            if (!chip) {
                return next;
            }
            if (LIST_FILTERS.indexOf(chip.type) !== -1) {
                next[chip.type] = (next[chip.type] || []).filter(function(value) {
                    return value !== chip.value;
                });
            } else if (chip.type === 'dates') {
                next.startDate = null;
                next.endDate = null;
            } else if (chip.type === 'score') {
                next.currentMinRange = defaults.currentMinRange;
                next.currentMaxRange = defaults.currentMaxRange;
            } else if (chip.type === 'currency') {
                next.currency = defaults.currency;
            }
            return next;
        }

        /**
         * Whether the Reporting Currency control belongs on a tab. FR-018.
         *
         * Only the tabs that show money. It was on Production & Sales, which
         * reports volumes - offering a currency selector there implies the
         * numbers beside it are monetary, and they are not.
         */
        function isCurrencyRelevant(tab) {
            return ['financials', 'finance-history'].indexOf(tab) !== -1;
        }

        function asDateString(value) {
            if (!value) {
                return null;
            }
            if (angular.isString(value)) {
                return value.substring(0, 10);
            }
            const date = new Date(value);
            if (isNaN(date.getTime())) {
                return null;
            }
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            return date.getFullYear() + '-' + month + '-' + day;
        }

        /**
         * A stored date as the local-midnight `Date` that `input[type=date]`
         * binds, or `null`. A `YYYY-MM-DD` string is read as that calendar day
         * - `new Date('2024-01-01')` would be UTC midnight, the previous
         * evening anywhere west of Greenwich.
         */
        function toDateInput(value) {
            if (!value) {
                return null;
            }
            if (angular.isDate(value)) {
                return isNaN(value.getTime()) ? null : value;
            }
            const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
            if (!match) {
                return null;
            }
            return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        }

        /** Human-readable summary of what is currently narrowing the figures. */
        function describeFilters(filters) {
            const parts = [];
            const active = filters || defaultFilters();
            if (active.startDate || active.endDate) {
                parts.push(
                    'assessment date ' +
                        (asDateString(active.startDate) || '…') +
                        ' to ' +
                        (asDateString(active.endDate) || '…')
                );
            }
            if (active.currentMinRange > SCORE_FLOOR || active.currentMaxRange < SCORE_CEILING) {
                parts.push('score ' + active.currentMinRange + '-' + active.currentMaxRange);
            }
            LIST_FILTERS.forEach(function(name) {
                if ((active[name] || []).length) {
                    const values = name === 'maturity_level' ? active[name].map(maturityLabel) : active[name];
                    parts.push(name.replace('_', ' ') + ' ' + values.join('/'));
                }
            });
            return parts.length ? parts.join(', ') : 'no project filters applied';
        }

        /**
         * Wire the shared filter panel onto a tab's scope. FR-001, FR-002.
         *
         * One implementation for all six tabs. Each controller previously
         * repeated its own copy of "load the options, apply, clear, set a score
         * range", which is how the tabs came to disagree about what a filter
         * does - the thing this work package exists to end. The controller keeps
         * ownership of `reload`, because only it knows what its tab fetches.
         *
         * `tab` decides whether Reporting Currency appears (FR-018). `reload` is
         * called whenever the applied population changes, and never when only a
         * drill-down's own controls change (FR-023).
         */
        function bindFilterScope($scope, projectId, tab, reload) {
            let noticeTimer = null;

            $scope.filters = loadFilters(projectId);
            $scope.showCurrencyFilter = isCurrencyRelevant(tab);
            $scope.toolTypeOptions = [];
            $scope.toolTypeCounts = {};
            $scope.countryOptions = [];
            $scope.valueChainOptions = [];
            $scope.maturityLevelOptions = [];
            $scope.quickLevels = [];
            $scope.availableCurrencies = $scope.availableCurrencies || ['USD'];
            $scope.filterErrors = {};
            $scope.filterErrorList = [];
            $scope.filterChips = [];
            $scope.tabDefinition = TAB_DEFINITIONS[tab] || null;
            // Which rail boxes are expanded. Per tab visit, not stored: a
            // collapsed box on one tab must not hide the filters on the next.
            $scope.rail = { filters: true, population: true, definition: true, hints: true };
            $scope.railNotice = false;

            $scope.applyFilters = applyFilters;
            $scope.clearFilters = clearAll;
            $scope.setQuickLevel = setQuickLevel;
            $scope.isQuickLevelActive = isQuickLevelActive;
            $scope.toggleFilterValue = toggleFilterValue;
            $scope.isFilterValueSelected = isFilterValueSelected;
            $scope.toggleRailBox = toggleRailBox;
            $scope.removeFilterChip = removeFilterChip;

            $scope.$on('$destroy', function() {
                if (noticeTimer) {
                    $timeout.cancel(noticeTimer);
                }
            });

            refreshChips();
            // FR-024. The analytics sidebar decides whether to offer the Data
            // Quality entry, and it has no controller of its own, so the flags
            // are published on $rootScope from here. Fetched when an analytics
            // tab opens rather than at app start: the smartclient shares this
            // navigation template and must not make an extra call on launch,
            // where it may well be offline.
            ensureRolloutFlags();
            // The initial fetch belongs here, not in each controller.
            //
            // It has to happen **after** `loadOptions` resolves, because that
            // is where FR-017 discards stored selections the project cannot
            // resolve. Loading first would fetch with a stale filter and then
            // silently show a population the user did not choose.
            //
            // It also has to happen at all. Demographics and Data Quality
            // called `bindFilterScope` and nothing else, so nothing ever
            // fetched and both tabs rendered blank - `reload` was only reachable
            // from Apply and Clear.
            return loadOptions().then(function() {
                return reload();
            });

            function loadOptions() {
                return getFilterOptions(projectId)
                    .then(function(options) {
                        const payload = options || {};
                        $scope.toolTypeOptions = payload.tool_types || [];
                        $scope.toolTypeCounts = payload.tool_type_counts || {};
                        $scope.countryOptions = payload.countries || [];
                        $scope.valueChainOptions = payload.value_chains || [];
                        $scope.maturityLevelOptions = payload.maturity_levels || [];
                        // Built once here, not in the template: an array built
                        // inside `ng-repeat` is a new collection on every digest
                        // and loops it to death (#289).
                        $scope.quickLevels = $scope.maturityLevelOptions
                            .filter(function(option) {
                                return option.value !== 'all';
                            })
                            .map(function(option) {
                                return {
                                    value: option.value,
                                    label: maturityLabel(option.value),
                                    title:
                                        option.label +
                                        ': score ' +
                                        option.score_min +
                                        (option.score_max === SCORE_CEILING ? ' to ' : ' to under ') +
                                        option.score_max
                                };
                            });
                        if (payload.currencies && payload.currencies.length) {
                            $scope.availableCurrencies = payload.currencies;
                        }
                        // FR-017: a stored selection this project cannot resolve
                        // is dropped here, before anything is fetched with it.
                        $scope.filters = reconcileFilters($scope.filters, payload);
                        refreshChips();
                    })
                    .catch(function() {
                        // A missing options endpoint hides the filters; it must
                        // never take the tab down with it, and the tab still
                        // loads - the caller's `reload` runs either way because
                        // this catch resolves rather than rethrows.
                        $scope.toolTypeOptions = [];
                    });
            }

            function refreshChips() {
                $scope.filterChips = activeChips($scope.filters);
                $scope.filterSummary = describeFilters($scope.filters);
            }

            function applyFilters() {
                // An emptied score box binds `null`. It means "no bound", and
                // left as null it reached the chips as "Score: 1–null".
                if (!angular.isNumber($scope.filters.currentMinRange)) {
                    $scope.filters.currentMinRange = SCORE_FLOOR;
                }
                if (!angular.isNumber($scope.filters.currentMaxRange)) {
                    $scope.filters.currentMaxRange = SCORE_CEILING;
                }
                $scope.filterErrors = validateFilters($scope.filters);
                $scope.filterErrorList = Object.keys($scope.filterErrors).map(function(key) {
                    return $scope.filterErrors[key];
                });
                if ($scope.filterErrorList.length) {
                    // FR-008: refused, and the previous results stay on screen.
                    return;
                }
                saveFilters(projectId, $scope.filters);
                refreshChips();
                showNotice();
                return reload();
            }

            /**
             * FR-021. Resets the global selections *and* the reporting
             * currency, and clears the saved state. It deliberately does not
             * touch any tab's drill-down table filters: those are local to a
             * table and clearing them is that table's own control.
             */
            function clearAll() {
                $scope.filters = clearFilters(projectId);
                $scope.filterErrors = {};
                $scope.filterErrorList = [];
                refreshChips();
                showNotice();
                return reload();
            }

            /**
             * The quick score filters. Staged, like every other control in the
             * rail - nothing reloads until Apply - so a user can pick a level
             * and a date range and pay for one load, not two.
             *
             * `null` is "All data": no level and the full score range.
             */
            function setQuickLevel(level) {
                $scope.filters.maturity_level = level ? [level] : [];
                $scope.filters.currentMinRange = SCORE_FLOOR;
                $scope.filters.currentMaxRange = SCORE_CEILING;
            }

            function isQuickLevelActive(level) {
                const levels = $scope.filters.maturity_level || [];
                if (!level) {
                    return (
                        !levels.length &&
                        $scope.filters.currentMinRange === SCORE_FLOOR &&
                        $scope.filters.currentMaxRange === SCORE_CEILING
                    );
                }
                return levels.length === 1 && levels[0] === level;
            }

            /** The tick-box lists (tool type, country, value chain). Staged. */
            function toggleFilterValue(name, value) {
                const selection = ($scope.filters[name] || []).slice();
                const index = selection.indexOf(value);
                if (index === -1) {
                    selection.push(value);
                } else {
                    selection.splice(index, 1);
                }
                $scope.filters[name] = selection;
            }

            function isFilterValueSelected(name, value) {
                return ($scope.filters[name] || []).indexOf(value) !== -1;
            }

            function toggleRailBox(name) {
                $scope.rail[name] = !$scope.rail[name];
            }

            function removeFilterChip(chip) {
                $scope.filters = removeChip($scope.filters, chip);
                return applyFilters();
            }

            function showNotice() {
                $scope.railNotice = true;
                if (noticeTimer) {
                    $timeout.cancel(noticeTimer);
                }
                noticeTimer = $timeout(function() {
                    $scope.railNotice = false;
                }, 1800);
            }
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Endpoints
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function analyticsUrl(projectId, resource) {
            return apiUrl + '/projects/projects/' + projectId + '/analytics/' + resource + '/';
        }

        function getFinancials(projectId, filters) {
            return siScope.getItem(analyticsUrl(projectId, 'financials'), {
                params: toParams(filters)
            });
        }

        function getFinanceHistory(projectId, filters) {
            return siScope.getItem(analyticsUrl(projectId, 'finance-history'), {
                params: toParams(filters)
            });
        }

        function getProductionSales(projectId, filters) {
            return siScope.getItem(analyticsUrl(projectId, 'production-sales'), {
                params: toParams(filters)
            });
        }

        /**
         * The values the filter bar can offer for this project. AD-2106 §10.
         *
         * Deliberately unfiltered: the options describe the project, not the
         * current selection, so narrowing to one tool type does not remove the
         * others from the list and strand the user there.
         */
        function getDemographics(projectId, filters) {
            return siScope.getItem(analyticsUrl(projectId, 'demographics'), {
                params: toParams(filters)
            });
        }

        /**
         * `scoreTool` picks the tool the score analysis runs on. It is a
         * separate argument from the filters on purpose: it is not a
         * population filter, and the snapshot, tool cards and rail must keep
         * reporting every tool the filters let through.
         */
        function getOverview(projectId, filters, scoreTool) {
            const params = toParams(filters);
            if (scoreTool) {
                params.score_tool = scoreTool;
            }
            return siScope.getItem(analyticsUrl(projectId, 'overview'), {
                params: params
            });
        }

        function getDataQuality(projectId, filters) {
            return siScope.getItem(analyticsUrl(projectId, 'data-quality'), {
                params: toParams(filters)
            });
        }

        /**
         * One drill-down page. FR-023.
         *
         * `selection` names the dataset and its own table controls; they are
         * merged on top of the global filters but are deliberately a separate
         * argument, because they must never be mistaken for population filters
         * or written into the saved filter state.
         */
        function getDataQualityDrilldown(projectId, filters, selection) {
            return siScope.getItem(analyticsUrl(projectId, 'data-quality/drill-down'), {
                params: angular.extend(toParams(filters), selection || {})
            });
        }

        /**
         * The platform rollout flags. FR-024.
         *
         * Defaults to everything off when the call fails. A navigation entry
         * that appears because a request errored leads to a tab the server will
         * refuse - better to hide a released feature briefly than to offer an
         * unreleased one.
         */
        function getRolloutFlags() {
            return siScope.getItem(apiUrl + '/products/rolloutflags/', {}).catch(function() {
                return {
                    data_quality_tab_enabled: false,
                    assessee_merge_execution_enabled: false,
                    reassessment_analytics_enabled: false,
                    score_analysis_enabled: false
                };
            });
        }

        /**
         * Publish the rollout flags for the analytics sidebar, once. FR-024.
         *
         * The sidebar decides whether to offer the Data Quality entry and has
         * no controller of its own, so the flags are read from `$rootScope`.
         * **Every analytics controller must call this**, not just the ones that
         * use the shared filter panel: Overview does not use it, Overview is
         * the tab the user lands on, and so the entry was invisible until the
         * user happened to click into another tab first. A flag that is on and
         * a feature nobody can find are the same thing to the person looking.
         *
         * Idempotent and cached on `$rootScope`, so the extra callers cost one
         * request per session rather than one per tab. Still deliberately not
         * at app start: the smartclient shares this navigation template and
         * must not make an extra call on launch, where it may be offline.
         */
        function ensureRolloutFlags() {
            if ($rootScope.rolloutFlags) {
                return;
            }
            getRolloutFlags().then(function(flags) {
                $rootScope.rolloutFlags = flags;
            });
        }

        function getFilterOptions(projectId) {
            return siScope.getItem(analyticsUrl(projectId, 'filter-options'), {});
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Data completeness
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * True when the records behind a figure cover materially less than the
         * filtered FO population, so the UI can warn instead of presenting a
         * thin sample as a portfolio fact.
         */
        function isSampleThin(sampleSize, population, threshold) {
            if (!population || !angular.isNumber(sampleSize)) {
                return false;
            }
            return sampleSize / population < (threshold || 0.8);
        }
    }
})();

(function() {
    'use strict';

    /**
     * The Project Analytics loader's lifecycle. AD-2201.
     *
     * One analytics tab is on screen at a time, and its `<si-analytics-loader>`
     * attaches here. Tabs report three real moments of a load - the request
     * started, the response arrived, the charts were drawn - and this service
     * turns them into the loader's progress:
     *
     *    begin()     -> 4 %, then easing towards 74 % while the request runs
     *    received()  -> 78 %, then easing towards 96 % while the tab renders
     *    finish()    -> 100 %: the loader completes and fades out
     *    fail()      -> the loader fades out at once, without "Ready"
     *
     * The design's middle stages (aggregating, benchmarks) happen on the server
     * inside the one request, so while it runs the progress can only ease
     * towards a cap below the next real moment: the loader never claims a stage
     * the work has not reached.
     *
     * A response that arrives before SHOW_DELAY_MS never shows the overlay.
     * A tab's first load shows the full "Project Analytics Ready" finish; a
     * reload (filter apply, retry) fades straight out once the charts are drawn.
     * The state lives here rather than in the directive, so it does not matter
     * whether a load starts before or after the tab's template is linked.
     */
    angular.module('scope.commons.projects').factory('siAnalyticsLoader', siAnalyticsLoader);

    siAnalyticsLoader.$inject = ['$timeout'];

    function siAnalyticsLoader($timeout) {
        // A load that finishes faster than this never shows the overlay at all.
        const SHOW_DELAY_MS = 150;
        const REQUEST_START = 4;
        const REQUEST_CAP = 74;
        const RECEIVED = 78;
        const RENDER_CAP = 96;

        let engine = null;
        let current = null; // { token, quick, visible, received, progress, cap, outcome }
        let tokens = 0;
        let showTimer = null;

        return {
            begin: begin,
            attach: attach,
            detach: detach
        };

        /**
         * Start a load for `scope`'s tab. Returns the handle the tab reports
         * through. Starting a new load supersedes the previous one: the old
         * handle's calls are ignored, so an earlier request resolving late
         * cannot finish the loader for a later one.
         */
        function begin(scope) {
            const token = ++tokens;
            const quick = !!(scope && scope.$$analyticsLoaderShown);
            if (scope) {
                scope.$$analyticsLoaderShown = true;
            }
            $timeout.cancel(showTimer);
            current = { token: token, quick: quick, visible: false, progress: REQUEST_START, cap: REQUEST_CAP };
            showTimer = $timeout(
                function() {
                    // Only for a request still running: once the response is in,
                    // the rest is local rendering, and showing the overlay then
                    // would only cover charts that are about to appear.
                    if (isCurrent(token) && !current.outcome && !current.received) {
                        current.visible = true;
                        replay();
                    }
                },
                SHOW_DELAY_MS,
                false
            );

            return {
                received: function() {
                    update(token, RECEIVED, RENDER_CAP);
                },
                finish: function() {
                    // After the next digest, so what the tab rendered is on screen.
                    $timeout(
                        function() {
                            end(token, 'done');
                        },
                        0,
                        false
                    );
                },
                fail: function() {
                    end(token, 'failed');
                }
            };
        }

        function isCurrent(token) {
            return current !== null && current.token === token;
        }

        function update(token, progress, cap) {
            if (!isCurrent(token) || current.outcome) {
                return;
            }
            current.received = true;
            current.progress = Math.max(current.progress, progress);
            current.cap = cap;
            if (current.visible && engine) {
                engine.setProgress(current.progress);
                engine.creepTo(current.cap);
            }
        }

        function end(token, outcome) {
            if (!isCurrent(token) || current.outcome) {
                return;
            }
            current.outcome = outcome;
            $timeout.cancel(showTimer);
            if (!current.visible) {
                // Finished before the overlay was due: never show it.
                current = null;
                return;
            }
            if (engine) {
                if (outcome === 'done') {
                    engine.complete(current.quick);
                } else {
                    engine.dismiss();
                }
            }
        }

        function replay() {
            if (!engine || !current || !current.visible) {
                return;
            }
            engine.show();
            engine.setProgress(current.progress);
            engine.creepTo(current.cap);
            if (current.outcome === 'done') {
                engine.complete(current.quick);
            } else if (current.outcome === 'failed') {
                engine.dismiss();
            }
        }

        /** Called by `<si-analytics-loader>` when it links. */
        function attach(api) {
            engine = api;
            replay();
        }

        /** Called when the directive is destroyed (the user left the tab). */
        function detach(api) {
            if (engine === api) {
                engine = null;
            }
        }
    }
})();

(function() {
    'use strict';

    /**
     * Shared rendering and formatting for the project analytics tabs.
     *
     * The Overview and Demographic controllers each carry their own copy of
     * this D3 code; the three new tabs share this one instead. Everything reads
     * its colours from the CSS custom properties on the page, so charts follow
     * the dashboard's light/dark theme without being re-told which theme is on.
     *
     * Missing data is rendered as '--' throughout, never as 0 — the two mean
     * different things in this dashboard.
     */
    angular.module('scope.commons.projects').factory('siAnalyticsCharts', AnalyticsCharts);

    AnalyticsCharts.$inject = ['$window', '$document'];

    function AnalyticsCharts($window, $document) {
        const service = this;

        const MISSING = '--';
        const PALETTE_SIZE = 10;
        // Width of a data label character at 10px, for deciding whether a
        // label fits. An estimate is enough: one that would not fit is left
        // to the tooltip.
        const LABEL_CHAR_WIDTH = 6;

        service.MISSING = MISSING;

        // formatting
        service.num = num;
        service.money = money;
        service.pct = pct;
        service.one = one;
        service.two = two;
        service.isMissing = isMissing;

        // charts
        service.bar = bar;
        service.horizontalBar = horizontalBar;
        service.groupedBar = groupedBar;
        service.donut = donut;
        service.genderSplit = genderSplit;
        service.line = line;
        service.sankey = sankey;
        service.clear = clear;
        service.destroyTooltip = destroyTooltip;

        // table helpers
        service.sorter = sorter;
        service.distinct = distinct;
        service.matchesSelection = matchesSelection;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Formatting
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isMissing(value) {
            return value === null || value === undefined || value === '' || Number.isNaN(value);
        }

        function num(value, decimals) {
            if (isMissing(value)) {
                return MISSING;
            }
            return new Intl.NumberFormat('en-US', {
                maximumFractionDigits: angular.isNumber(decimals) ? decimals : 0
            }).format(value);
        }

        function money(value, currency) {
            if (isMissing(value)) {
                return MISSING;
            }
            const formatted = num(value, 0);
            return currency ? currency + ' ' + formatted : formatted;
        }

        function pct(value, decimals) {
            if (isMissing(value)) {
                return MISSING;
            }
            return value.toFixed(angular.isNumber(decimals) ? decimals : 1) + '%';
        }

        function one(value) {
            return isMissing(value) ? MISSING : value.toFixed(1);
        }

        /** Scores: two decimals (AD-2196, AD-2198). */
        function two(value) {
            return isMissing(value) ? MISSING : Number(value).toFixed(2);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chart plumbing
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function cssVar(name, fallback) {
            const value = $window
                .getComputedStyle($document[0].documentElement)
                .getPropertyValue(name)
                .trim();
            return value || fallback;
        }

        /**
         * Shorten a category name for a direct label. AD-2106 §9.
         *
         * Only the drawn label is shortened - the tooltip and the underlying
         * data keep the full name, so nothing is lost by truncating here.
         */
        function truncate(text, limit) {
            const value = String(text === null || text === undefined ? '' : text);
            return value.length > limit ? value.slice(0, limit - 1) + '…' : value;
        }

        function palette() {
            const fallbacks = [
                '#5470c6',
                '#91cc75',
                '#fac858',
                '#ee6666',
                '#73c0de',
                '#3ba272',
                '#fc8452',
                '#9a60b4',
                '#52c7e0',
                '#fd666d'
            ];
            const colors = [];
            for (let i = 1; i <= PALETTE_SIZE; i++) {
                colors.push(cssVar('--chart-' + i, fallbacks[i - 1]));
            }
            return colors;
        }

        function textColor() {
            return cssVar('--text-primary', '#222222');
        }

        function mutedColor() {
            return cssVar('--text-secondary', '#666666');
        }

        function axisColor() {
            return cssVar('--border-color', 'rgba(0,0,0,0.18)');
        }

        function element(target) {
            if (!target) {
                return null;
            }
            return angular.isString(target) ? $document[0].querySelector('#' + target) : target;
        }

        function clear(target) {
            const el = element(target);
            if (el) {
                el.innerHTML = '';
            }
            return el;
        }

        function prepare(target, options) {
            const el = clear(target);
            if (!el || !$window.d3) {
                return null;
            }
            const opts = options || {};
            const width = el.getBoundingClientRect().width || 640;
            const height = opts.height || 300;
            const svg = $window.d3
                .select(el)
                .append('svg')
                .attr('width', width)
                .attr('height', height);
            return { el: el, d3: $window.d3, svg: svg, width: width, height: height };
        }

        function emptyState(target, message) {
            const el = clear(target);
            if (el) {
                el.innerHTML =
                    '<div style="padding:24px;text-align:center;color:' +
                    mutedColor() +
                    ';font-size:13px;">' +
                    (message || 'No data available for the current filters') +
                    '</div>';
            }
            return null;
        }

        function tooltip(d3) {
            let node = $document[0].querySelector('.si-analytics-tooltip');
            if (!node) {
                node = $document[0].createElement('div');
                node.className = 'si-analytics-tooltip';
                node.style.cssText = [
                    'position:fixed',
                    'pointer-events:none',
                    'opacity:0',
                    'z-index:3000',
                    'padding:8px 10px',
                    'border-radius:6px',
                    'font-size:12px',
                    'white-space:pre-line',
                    'transition:opacity .15s ease'
                ].join(';');
                $document[0].body.appendChild(node);
            }
            node.style.background = cssVar('--bg-card', '#ffffff');
            node.style.color = textColor();
            node.style.border = '1px solid ' + axisColor();
            return {
                show: function(event, text) {
                    node.textContent = text;
                    node.style.opacity = '1';
                    node.style.left = event.clientX + 12 + 'px';
                    node.style.top = event.clientY - 12 + 'px';
                },
                hide: function() {
                    node.style.opacity = '0';
                }
            };
        }

        function destroyTooltip() {
            const node = $document[0].querySelector('.si-analytics-tooltip');
            if (node && node.parentNode) {
                node.parentNode.removeChild(node);
            }
        }

        function styleAxes(group) {
            group
                .selectAll('text')
                .style('fill', mutedColor())
                .style('font-size', '11px');
            group.selectAll('.domain, .tick line').style('stroke', axisColor());
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Data labels (AD-2196, AD-2198)
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function labelWidth(text) {
            return String(text).length * LABEL_CHAR_WIDTH;
        }

        /**
         * A value written on a chart. The halo in the card colour keeps it
         * readable where it crosses a gridline, a bar or another mark.
         */
        function dataLabel(group, x, y, text, options) {
            const opts = options || {};
            const node = group
                .append('text')
                .attr('class', 'si-data-label')
                .attr('x', x)
                .attr('y', y)
                .attr('text-anchor', opts.anchor || 'middle')
                .style('font-size', '10px')
                .style('font-weight', 600)
                .style('fill', opts.color || textColor())
                .style('stroke', cssVar('--bg-card', '#ffffff'))
                .style('stroke-width', '3px')
                .style('paint-order', 'stroke')
                .style('pointer-events', 'none')
                .text(text);
            if (opts.rotate) {
                node.attr('transform', 'rotate(-90,' + x + ',' + y + ')');
            }
            return node;
        }

        /**
         * Labels the bars of a band: horizontal above the bar when it fits the
         * bar's width, turned upright on a bar too narrow for that, and left
         * to the tooltip on a bar too thin to carry text at all. A missing
         * value gets no label: it is not zero.
         */
        function labelBars(group, bars, bandwidth, y, format) {
            bars.forEach(function(d) {
                if (isMissing(d.raw)) {
                    return;
                }
                const text = format(d.raw);
                const top = y(Math.max(0, d.raw));
                const bottom = y(Math.min(0, d.raw));
                const centre = d.x + bandwidth / 2;
                if (labelWidth(text) <= bandwidth + 6) {
                    dataLabel(group, centre, d.raw < 0 ? bottom + 12 : top - 4, text);
                } else if (bandwidth >= 6) {
                    dataLabel(group, centre + 3.5, d.raw < 0 ? bottom + 4 : top - 4, text, {
                        rotate: true,
                        anchor: d.raw < 0 ? 'end' : 'start'
                    });
                }
            });
        }

        /**
         * Headroom above the tallest bar for an upright label, as a factor
         * on the axis maximum.
         */
        function labelHeadroom(data, format, innerH, base) {
            if (!format) {
                return base;
            }
            const longest = data.reduce((most, value) => Math.max(most, labelWidth(format(value))), 0);
            return Math.max(base, 1 + Math.min(0.6, (longest + 8) / Math.max(innerH, 1)));
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Charts
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * data: [{label, value, tooltip}]
         *
         * `labelFormat` writes each value on its bar; the tooltip stays.
         */
        function bar(target, data, options) {
            const opts = options || {};
            if (!data || !data.length) {
                return emptyState(target, opts.emptyMessage);
            }
            const ctx = prepare(target, opts);
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const tip = tooltip(d3);
            const format = opts.labelFormat || null;
            const margin = { top: 18, right: 18, bottom: opts.rotateLabels === false ? 34 : 78, left: 62 };
            const innerW = ctx.width - margin.left - margin.right;
            const innerH = ctx.height - margin.top - margin.bottom;
            const g = ctx.svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            const x = d3
                .scaleBand()
                .domain(data.map(d => d.label))
                .range([0, innerW])
                .padding(0.25);
            const maxValue = d3.max(data, d => d.value) || 1;
            const headroom = labelHeadroom(
                data.filter(d => !isMissing(d.value)).map(d => d.value),
                format && x.bandwidth() < 40 ? format : null,
                innerH,
                1.15
            );
            const y = d3
                .scaleLinear()
                .domain([Math.min(0, d3.min(data, d => d.value) || 0), maxValue * headroom])
                .nice()
                .range([innerH, 0]);

            const xAxis = g
                .append('g')
                .attr('transform', 'translate(0,' + innerH + ')')
                .call(d3.axisBottom(x));
            if (opts.rotateLabels !== false) {
                xAxis
                    .selectAll('text')
                    .attr('transform', 'rotate(38)')
                    .style('text-anchor', 'start');
            }
            styleAxes(xAxis);
            const yAxis = g.append('g').call(
                d3
                    .axisLeft(y)
                    .ticks(5)
                    .tickFormat(d3.format('~s'))
            );
            styleAxes(yAxis);

            g.selectAll('rect')
                .data(data)
                .enter()
                .append('rect')
                .attr('x', d => x(d.label))
                .attr('y', d => y(Math.max(0, d.value)))
                .attr('width', x.bandwidth())
                .attr('height', d => Math.abs(y(d.value) - y(0)))
                .attr('rx', 4)
                .attr('fill', (d, i) => colors[i % colors.length])
                .style('cursor', 'pointer')
                .on('mousemove', function(event, d) {
                    tip.show(event, d.tooltip || d.label + ': ' + (format ? format(d.value) : num(d.value)));
                })
                .on('mouseout', tip.hide);

            if (format) {
                labelBars(
                    g,
                    data.map(d => ({ x: x(d.label), raw: d.value })),
                    x.bandwidth(),
                    y,
                    format
                );
            }

            return ctx;
        }

        /**
         * data: [{label, value, tooltip}] — for long category names.
         *
         * `domain` fixes the value axis (a score's 1-5); bars then start at
         * its lower end. `height: 'auto'` gives every row the same room.
         */
        function horizontalBar(target, data, options) {
            const opts = angular.extend({}, options || {});
            if (!data || !data.length) {
                return emptyState(target, opts.emptyMessage);
            }
            if (opts.height === 'auto') {
                opts.height = Math.max(160, 42 + data.length * 30);
            }
            const ctx = prepare(target, opts);
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const tip = tooltip(d3);
            const margin = { top: 12, right: 60, bottom: 30, left: opts.labelWidth || 160 };
            const innerW = ctx.width - margin.left - margin.right;
            const innerH = ctx.height - margin.top - margin.bottom;
            const g = ctx.svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            const y = d3
                .scaleBand()
                .domain(data.map(d => d.label))
                .range([0, innerH])
                .padding(0.25);
            const x = d3
                .scaleLinear()
                .domain(opts.domain || [0, (d3.max(data, d => d.value) || 1) * 1.15])
                .range([0, innerW]);
            const start = x.domain()[0];
            const barWidth = d => Math.max(0, x(Math.max(start, d.value)) - x(start));

            styleAxes(
                g.append('g').call(
                    d3
                        .axisLeft(y)
                        .tickSize(0)
                        .tickFormat(label => truncate(label, Math.max(12, Math.floor((margin.left - 10) / 6.5))))
                )
            );
            styleAxes(
                g
                    .append('g')
                    .attr('transform', 'translate(0,' + innerH + ')')
                    .call(
                        d3
                            .axisBottom(x)
                            .ticks(4)
                            .tickFormat(d3.format('~s'))
                    )
            );

            g.selectAll('rect')
                .data(data)
                .enter()
                .append('rect')
                .attr('x', 0)
                .attr('y', d => y(d.label))
                .attr('height', y.bandwidth())
                .attr('width', barWidth)
                .attr('rx', 4)
                .attr('fill', (d, i) => (d.color ? d.color : colors[i % colors.length]))
                .style('cursor', 'pointer')
                .on('mousemove', function(event, d) {
                    tip.show(
                        event,
                        d.tooltip || d.label + ': ' + (opts.labelFormat ? opts.labelFormat(d.value) : num(d.value))
                    );
                })
                .on('mouseout', tip.hide);

            g.selectAll('.value-label')
                .data(data)
                .enter()
                .append('text')
                .attr('x', d => barWidth(d) + 6)
                .attr('y', d => y(d.label) + y.bandwidth() / 2 + 4)
                .style('font-size', '11px')
                .style('fill', mutedColor())
                .text(d => (opts.labelFormat ? opts.labelFormat(d.value) : num(d.value)));

            return ctx;
        }

        /**
         * data: [{label, values: [{key, value}]}] — grouped comparison.
         *
         * `labelFormat` writes every series' value on its bar (AD-2196).
         */
        function groupedBar(target, data, keys, options) {
            const opts = options || {};
            if (!data || !data.length || !keys || !keys.length) {
                return emptyState(target, opts.emptyMessage);
            }
            const ctx = prepare(target, opts);
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const tip = tooltip(d3);
            const margin = { top: 18, right: 18, bottom: 74, left: 62 };
            const innerW = ctx.width - margin.left - margin.right;
            const innerH = ctx.height - margin.top - margin.bottom;
            const g = ctx.svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            const x0 = d3
                .scaleBand()
                .domain(data.map(d => d.label))
                .range([0, innerW])
                .padding(0.2);
            const x1 = d3
                .scaleBand()
                .domain(keys)
                .range([0, x0.bandwidth()])
                .padding(0.08);
            const format = opts.labelFormat || null;
            const maxValue = d3.max(data, d => d3.max(keys.map(key => valueFor(d, key) || 0))) || 1;
            const values = [];
            data.forEach(d => keys.forEach(key => values.push(valueFor(d, key))));
            const headroom = labelHeadroom(
                values.filter(v => !isMissing(v)),
                format && x1.bandwidth() < 40 ? format : null,
                innerH,
                1.2
            );
            const y = d3
                .scaleLinear()
                .domain([0, maxValue * headroom])
                .nice()
                .range([innerH, 0]);

            const xAxis = g
                .append('g')
                .attr('transform', 'translate(0,' + innerH + ')')
                .call(d3.axisBottom(x0));
            xAxis
                .selectAll('text')
                .attr('transform', 'rotate(32)')
                .style('text-anchor', 'start');
            styleAxes(xAxis);
            styleAxes(
                g.append('g').call(
                    d3
                        .axisLeft(y)
                        .ticks(5)
                        .tickFormat(d3.format('~s'))
                )
            );

            const rows = g
                .selectAll('.group')
                .data(data)
                .enter()
                .append('g')
                .attr('transform', d => 'translate(' + x0(d.label) + ',0)');

            rows.selectAll('rect')
                .data(d =>
                    keys.map(key => ({ key: key, value: valueFor(d, key) || 0, raw: valueFor(d, key), label: d.label }))
                )
                .enter()
                .append('rect')
                .attr('x', d => x1(d.key))
                .attr('y', d => y(d.value))
                .attr('width', x1.bandwidth())
                .attr('height', d => innerH - y(d.value))
                .attr('rx', 3)
                .attr('fill', d => colors[keys.indexOf(d.key) % colors.length])
                .style('cursor', 'pointer')
                .on('mousemove', function(event, d) {
                    const value = format ? format(d.raw) : num(d.raw);
                    tip.show(event, d.label + '\n' + d.key + ': ' + value);
                })
                .on('mouseout', tip.hide);

            if (format) {
                rows.each(function(d) {
                    labelBars(
                        d3.select(this),
                        keys.map(key => ({ x: x1(key), raw: valueFor(d, key) })),
                        x1.bandwidth(),
                        y,
                        format
                    );
                });
            }

            legend(ctx, keys, colors);
            return ctx;

            function valueFor(row, key) {
                const found = (row.values || []).filter(v => v.key === key)[0];
                return found ? found.value : null;
            }
        }

        /**
         * data: [{label, value}] — shares. Percentages are shown on the labels.
         */
        /**
         * Split a category list into the slices that get their own label and a
         * single "Other" bucket. AD-2106 §9.
         *
         * Grouping is a *labelling* decision, never a data one: percentages are
         * computed from the full set before anything is folded together, so the
         * Other slice is exactly the sum of what it hides and the total is
         * unchanged. The full breakdown stays reachable through the tooltip,
         * which lists what went into Other.
         *
         * The cut-off follows the space actually available rather than a fixed
         * number. Width is the binding constraint in practice: a narrow card has
         * no room for a label column on either side of the ring, however many
         * categories there are. Height still bounds how many labels a side can
         * hold once they are separated.
         */
        function withOtherBucket(data, width, height, explicitMax) {
            const sorted = data.slice().sort((a, b) => b.value - a.value);
            const byWidth = width < 380 ? 4 : width < 520 ? 6 : 8;
            const byHeight = Math.max(2, Math.floor((height - 40) / 16)) * 2;
            const max = explicitMax || Math.max(3, Math.min(8, byWidth, byHeight));
            if (sorted.length <= max) {
                return sorted;
            }
            const kept = sorted.slice(0, max - 1);
            const folded = sorted.slice(max - 1);
            kept.push({
                label: 'Other',
                value: folded.reduce((sum, d) => sum + d.value, 0),
                n: folded.reduce((sum, d) => sum + (d.n || 0), 0),
                isOther: true,
                members: folded
            });
            return kept;
        }

        /**
         * Push labels apart along the y axis so connector lines stay readable.
         *
         * Labels are placed at their slice's centroid, then separated within
         * each side of the chart. Without this, small adjacent slices - which is
         * what a long tail of products is - stack their labels on the same few
         * pixels and the connector lines cross into a hairball.
         */
        function spreadLabels(positions, minGap, limit) {
            positions.sort((a, b) => a.y - b.y);
            for (let i = 1; i < positions.length; i++) {
                const gap = positions[i].y - positions[i - 1].y;
                if (gap < minGap) {
                    positions[i].y = positions[i - 1].y + minGap;
                }
            }
            // Pull the column back inside the box if separation overflowed it.
            const overflow = positions.length ? positions[positions.length - 1].y - limit : 0;
            if (overflow > 0) {
                positions.forEach(p => {
                    p.y -= overflow;
                });
            }
            return positions;
        }

        function donut(target, data, options) {
            const opts = options || {};
            const usable = (data || []).filter(d => d.value > 0);
            if (!usable.length) {
                return emptyState(target, opts.emptyMessage);
            }
            const ctx = prepare(target, opts);
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const tip = tooltip(d3);

            // Percentages come from the full set, before any grouping.
            const total = d3.sum(usable, d => d.value);
            const shown = withOtherBucket(usable, ctx.width, ctx.height, opts.maxLabels);

            const radius = Math.min(ctx.width, ctx.height) / 2 - 56;
            const g = ctx.svg.append('g').attr('transform', 'translate(' + ctx.width / 2 + ',' + ctx.height / 2 + ')');

            const pie = d3
                .pie()
                .value(d => d.value)
                .sort(null);
            const arc = d3
                .arc()
                .innerRadius(radius * 0.58)
                .outerRadius(radius);
            const outer = d3
                .arc()
                .innerRadius(radius * 1.1)
                .outerRadius(radius * 1.1);
            const slices = pie(shown);
            const midAngle = d => d.startAngle + (d.endAngle - d.startAngle) / 2;

            function describe(d) {
                const share = ((d.data.value / total) * 100).toFixed(1);
                const value = opts.valueFormat ? opts.valueFormat(d.data.value) : num(d.data.value);
                let text = d.data.label + '\n' + value + ' (' + share + '%)';
                if (d.data.n !== undefined) {
                    text += '\nN=' + d.data.n;
                }
                if (d.data.isOther) {
                    // The breakdown is not lost, only unlabelled.
                    text +=
                        '\n' +
                        d.data.members
                            .map(m => {
                                const memberShare = ((m.value / total) * 100).toFixed(1);
                                return (
                                    '· ' +
                                    m.label +
                                    ' ' +
                                    (opts.valueFormat ? opts.valueFormat(m.value) : num(m.value)) +
                                    ' (' +
                                    memberShare +
                                    '%)'
                                );
                            })
                            .join('\n');
                }
                return text;
            }

            g.selectAll('path')
                .data(slices)
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', (d, i) => (d.data.isOther ? mutedColor() : colors[i % colors.length]))
                .style('cursor', 'pointer')
                .on('mousemove', function(event, d) {
                    tip.show(event, describe(d));
                })
                .on('mouseout', tip.hide);

            // Lay the labels out per side, then separate them.
            const half = ctx.height / 2;
            const placed = { left: [], right: [] };
            slices.forEach(function(d) {
                const side = midAngle(d) < Math.PI ? 'right' : 'left';
                placed[side].push({ slice: d, y: outer.centroid(d)[1], side: side });
            });
            const laidOut = [];
            ['left', 'right'].forEach(function(side) {
                laidOut.push.apply(laidOut, spreadLabels(placed[side], 15, half - 10));
            });

            const anchorX = d => radius * 1.15 * (d.side === 'right' ? 1 : -1);

            g.selectAll('polyline')
                .data(laidOut)
                .enter()
                .append('polyline')
                .attr('points', function(entry) {
                    const elbow = outer.centroid(entry.slice);
                    return [
                        arc.centroid(entry.slice),
                        [elbow[0], entry.y],
                        [anchorX(entry) - (entry.side === 'right' ? 6 : -6), entry.y]
                    ];
                })
                .style('fill', 'none')
                .style('stroke', axisColor())
                .style('stroke-width', 1);

            g.selectAll('text.slice-label')
                .data(laidOut)
                .enter()
                .append('text')
                .attr('class', 'slice-label')
                .attr('transform', entry => 'translate(' + anchorX(entry) + ',' + entry.y + ')')
                .attr('dy', '0.35em')
                .attr('text-anchor', entry => (entry.side === 'right' ? 'start' : 'end'))
                .style('font-size', '11px')
                .style('fill', textColor())
                .style('cursor', 'pointer')
                .on('mousemove', function(event, entry) {
                    tip.show(event, describe(entry.slice));
                })
                .on('mouseout', tip.hide)
                .text(function(entry) {
                    const d = entry.slice;
                    const share = ((d.data.value / total) * 100).toFixed(1);
                    return truncate(d.data.label, 18) + ' (' + share + '%)';
                });

            return ctx;
        }

        /**
         * data: [{label, value, n}] — a trend over ordered categories (years).
         */
        function line(target, data, options) {
            const opts = options || {};
            const format = opts.labelFormat || null;
            if (!data || !data.length) {
                return emptyState(target, opts.emptyMessage);
            }
            if (data.length === 1) {
                // a single point is not a trend; a bar reads honestly
                return bar(target, data, opts);
            }
            const ctx = prepare(target, opts);
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const tip = tooltip(d3);
            const margin = { top: 20, right: 24, bottom: 36, left: 62 };
            const innerW = ctx.width - margin.left - margin.right;
            const innerH = ctx.height - margin.top - margin.bottom;
            const g = ctx.svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            const x = d3
                .scalePoint()
                .domain(data.map(d => d.label))
                .range([0, innerW]);
            const y = d3
                .scaleLinear()
                .domain([0, (d3.max(data, d => d.value) || 1) * 1.2])
                .nice()
                .range([innerH, 0]);

            styleAxes(
                g
                    .append('g')
                    .attr('transform', 'translate(0,' + innerH + ')')
                    .call(d3.axisBottom(x))
            );
            styleAxes(
                g.append('g').call(
                    d3
                        .axisLeft(y)
                        .ticks(5)
                        .tickFormat(d3.format('~s'))
                )
            );

            g.append('path')
                .datum(data)
                .attr('fill', 'none')
                .attr('stroke', colors[0])
                .attr('stroke-width', 2.5)
                .attr(
                    'd',
                    d3
                        .line()
                        .x(d => x(d.label))
                        .y(d => y(d.value))
                );

            g.selectAll('circle')
                .data(data)
                .enter()
                .append('circle')
                .attr('cx', d => x(d.label))
                .attr('cy', d => y(d.value))
                .attr('r', 5)
                .attr('fill', colors[0])
                .style('cursor', 'pointer')
                .on('mousemove', function(event, d) {
                    tip.show(event, d.tooltip || d.label + ': ' + (format ? format(d.value) : num(d.value)));
                })
                .on('mouseout', tip.hide);

            if (format) {
                // Every point when the labels fit side by side, otherwise
                // every n-th one and the last; the tooltip has the rest.
                const labelled = data.filter(d => !isMissing(d.value));
                const spacing = data.length > 1 ? innerW / (data.length - 1) : innerW;
                const widest = labelled.reduce((most, d) => Math.max(most, labelWidth(format(d.value))), 0);
                const every = Math.max(1, Math.ceil((widest + 6) / Math.max(spacing, 1)));
                labelled.forEach(function(d, index) {
                    if (index % every && index !== labelled.length - 1) {
                        return;
                    }
                    dataLabel(g, x(d.label), y(d.value) - 10, format(d.value));
                });
            }

            return ctx;
        }

        /**
         * Flows between the levels of a transition matrix (AD-2196): the
         * baseline level on the left, the comparison level on the right, each
         * link as wide as its count. Built straight from the matrix the table
         * shows, so the two always reconcile.
         *
         * matrix: {levels: [{key, label}], rows: [{baseline, cells: [{latest, count}]}], n}
         * options: {colors: {key: colour}, unit, labels: {up, down, same, of}}
         */
        function sankey(target, matrix, options) {
            const opts = options || {};
            if (!matrix || !matrix.n) {
                return emptyState(target, opts.emptyMessage);
            }
            const ctx = prepare(target, angular.extend({ height: 340 }, opts));
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const tip = tooltip(d3);
            const levels = matrix.levels;
            const total = matrix.n;
            const labels = opts.labels || {};
            const unit = opts.unit || '';
            const levelColors = opts.colors || {};
            const fallback = palette();
            const colorOf = (key, index) => levelColors[key] || fallback[index % fallback.length];
            const flowColors = {
                up: cssVar('--pa-good-text', '#3ba272'),
                down: cssVar('--pa-bad-text', '#d95c5c'),
                same: mutedColor()
            };

            const sideWidth = Math.min(150, Math.max(96, ctx.width * 0.22));
            const nodeWidth = 14;
            const gap = 10;
            const margin = { top: 24, bottom: 28 };
            const left = sideWidth;
            const right = ctx.width - sideWidth;
            const innerH = ctx.height - margin.top - margin.bottom;
            const active = levels.length;
            const scale = Math.max(0, innerH - gap * (active - 1)) / total;

            const outTotals = matrix.rows.map(row => row.cells.reduce((sum, c) => sum + c.count, 0));
            const inTotals = levels.map((level, j) => matrix.rows.reduce((sum, row) => sum + row.cells[j].count, 0));

            function stack(totals) {
                let y = margin.top;
                return totals.map(value => {
                    const node = { y: y, h: value * scale };
                    y += node.h + gap;
                    return node;
                });
            }
            const leftNodes = stack(outTotals);
            const rightNodes = stack(inTotals);

            const g = ctx.svg.append('g');
            ctx.svg
                .append('text')
                .attr('x', left)
                .attr('y', 14)
                .attr('text-anchor', 'middle')
                .style('font-size', '11px')
                .style('font-weight', 600)
                .style('fill', mutedColor())
                .text(labels.baseline || 'Baseline');
            ctx.svg
                .append('text')
                .attr('x', right)
                .attr('y', 14)
                .attr('text-anchor', 'middle')
                .style('font-size', '11px')
                .style('font-weight', 600)
                .style('fill', mutedColor())
                .text(labels.latest || 'Latest');

            // Links, ordered within each node by the level on the other side,
            // so flows leave and arrive in level order and do not cross more
            // than they must.
            const outOffset = leftNodes.map(() => 0);
            const inOffset = rightNodes.map(() => 0);
            const links = [];
            matrix.rows.forEach(function(row, i) {
                row.cells.forEach(function(cell, j) {
                    if (!cell.count) {
                        return;
                    }
                    links.push({ i: i, j: j, count: cell.count, width: cell.count * scale });
                });
            });
            links.sort((a, b) => a.i - b.i || a.j - b.j);
            links.forEach(function(link) {
                link.y0 = leftNodes[link.i].y + outOffset[link.i] + link.width / 2;
                outOffset[link.i] += link.width;
            });
            links
                .slice()
                .sort((a, b) => a.j - b.j || a.i - b.i)
                .forEach(function(link) {
                    link.y1 = rightNodes[link.j].y + inOffset[link.j] + link.width / 2;
                    inOffset[link.j] += link.width;
                });

            const x0 = left + nodeWidth / 2;
            const x1 = right - nodeWidth / 2;
            const mid = (x0 + x1) / 2;
            const kind = link => (link.j > link.i ? 'up' : link.j < link.i ? 'down' : 'same');
            const share = count => ((count / total) * 100).toFixed(0) + '%';
            const describe = link =>
                levels[link.i].label +
                ' \u2192 ' +
                levels[link.j].label +
                '\n' +
                link.count +
                ' ' +
                unit +
                ' (' +
                share(link.count) +
                ' ' +
                (labels.of || 'of') +
                ' ' +
                total +
                ')\n' +
                (labels[kind(link)] || kind(link));

            g.selectAll('path.si-sankey-link')
                .data(links)
                .enter()
                .append('path')
                .attr('class', 'si-sankey-link')
                .attr(
                    'd',
                    link =>
                        'M' +
                        x0 +
                        ',' +
                        link.y0 +
                        'C' +
                        mid +
                        ',' +
                        link.y0 +
                        ' ' +
                        mid +
                        ',' +
                        link.y1 +
                        ' ' +
                        x1 +
                        ',' +
                        link.y1
                )
                .style('fill', 'none')
                .style('stroke', link => flowColors[kind(link)])
                .style('stroke-opacity', link => (kind(link) === 'same' ? 0.28 : 0.45))
                .style('stroke-width', link => Math.max(1, link.width))
                .style('cursor', 'pointer')
                .on('mousemove', function(event, link) {
                    d3.select(this).style('stroke-opacity', 0.75);
                    tip.show(event, describe(link));
                })
                .on('mouseout', function(event, link) {
                    d3.select(this).style('stroke-opacity', kind(link) === 'same' ? 0.28 : 0.45);
                    tip.hide();
                });

            // Counts on the flows thick enough to carry them, written at the
            // middle of the curve; thin flows keep theirs in the tooltip.
            links.forEach(function(link) {
                if (link.width >= 13) {
                    dataLabel(g, mid, (link.y0 + link.y1) / 2 + 4, String(link.count));
                }
            });

            function drawNodes(nodes, totals, x, side) {
                nodes.forEach(function(node, index) {
                    if (!totals[index]) {
                        return;
                    }
                    const level = levels[index];
                    g.append('rect')
                        .attr('x', x - nodeWidth / 2)
                        .attr('y', node.y)
                        .attr('width', nodeWidth)
                        .attr('height', Math.max(1, node.h))
                        .attr('rx', 2)
                        .attr('fill', colorOf(level.key, index))
                        .on('mousemove', function(event) {
                            tip.show(
                                event,
                                level.label + '\n' + totals[index] + ' ' + unit + ' (' + share(totals[index]) + ')'
                            );
                        })
                        .on('mouseout', tip.hide);
                    const textX = side === 'left' ? x - nodeWidth / 2 - 6 : x + nodeWidth / 2 + 6;
                    const anchor = side === 'left' ? 'end' : 'start';
                    const centre = node.y + node.h / 2;
                    g.append('text')
                        .attr('x', textX)
                        .attr('y', centre - 1)
                        .attr('text-anchor', anchor)
                        .style('font-size', '11px')
                        .style('fill', textColor())
                        .text(truncate(level.label, 18));
                    g.append('text')
                        .attr('x', textX)
                        .attr('y', centre + 11)
                        .attr('text-anchor', anchor)
                        .style('font-size', '10px')
                        .style('font-weight', 600)
                        .style('fill', mutedColor())
                        .text(totals[index] + ' (' + share(totals[index]) + ')');
                });
            }
            drawNodes(leftNodes, outTotals, left, 'left');
            drawNodes(rightNodes, inTotals, right, 'right');

            legend(
                ctx,
                [labels.up || 'Moved up', labels.same || 'Stayed', labels.down || 'Moved down'],
                [flowColors.up, flowColors.same, flowColors.down]
            );
            return ctx;
        }

        /**
         * One 100% bar per row: the female and the male share. AD-2193.
         *
         * rows: [{label, female, male, n, incomplete}] where female and male are
         * counted over the FOs that recorded both (n of them); `incomplete` FOs
         * reported a total with one gender missing and are not in the bar. A row
         * with nobody recorded says so instead of drawing an empty bar, which
         * would read as 0 %.
         */
        function genderSplit(target, rows, options) {
            const opts = options || {};
            if (!rows || !rows.length) {
                return emptyState(target, opts.emptyMessage);
            }
            const rowHeight = 30;
            const barHeight = 16;
            const ctx = prepare(target, { height: 24 + rows.length * rowHeight + 22 });
            if (!ctx) {
                return null;
            }
            const d3 = ctx.d3;
            const colors = palette();
            const femaleColor = colors[1 % colors.length];
            const maleColor = colors[0];
            const tip = tooltip(d3);
            const labels = opts.labels || {};
            const labelWidth = opts.labelWidth || 150;
            const valueWidth = 150;
            const innerW = Math.max(80, ctx.width - labelWidth - valueWidth - 12);
            const g = ctx.svg.append('g').attr('transform', 'translate(' + labelWidth + ',12)');
            const x = d3
                .scaleLinear()
                .domain([0, 1])
                .range([0, innerW]);

            rows.forEach(function(row, index) {
                const y = index * rowHeight;
                const known = (row.female || 0) + (row.male || 0);
                g.append('text')
                    .attr('x', -10)
                    .attr('y', y + barHeight / 2 + 4)
                    .attr('text-anchor', 'end')
                    .style('font-size', '12px')
                    .style('fill', textColor())
                    .text(truncate(row.label, 22));

                if (!known) {
                    g.append('rect')
                        .attr('x', 0)
                        .attr('y', y)
                        .attr('width', innerW)
                        .attr('height', barHeight)
                        .attr('rx', 3)
                        .attr('fill', 'none')
                        .attr('stroke', axisColor())
                        .attr('stroke-dasharray', '3,3');
                    g.append('text')
                        .attr('x', innerW / 2)
                        .attr('y', y + barHeight / 2 + 4)
                        .attr('text-anchor', 'middle')
                        .style('font-size', '11px')
                        .style('fill', mutedColor())
                        .text(labels.noData || 'No gender breakdown reported');
                    return;
                }

                const femaleShare = row.female / known;
                const describe =
                    row.label +
                    '\n' +
                    (labels.female || 'Female') +
                    ': ' +
                    num(row.female) +
                    ' (' +
                    pct(femaleShare * 100) +
                    ')\n' +
                    (labels.male || 'Male') +
                    ': ' +
                    num(row.male) +
                    ' (' +
                    pct((1 - femaleShare) * 100) +
                    ')\nN=' +
                    row.n +
                    (row.incomplete
                        ? '\n' + row.incomplete + ' ' + (labels.incomplete || 'FO(s) without both genders not included')
                        : '');
                [
                    { from: 0, width: femaleShare, color: femaleColor },
                    { from: femaleShare, width: 1 - femaleShare, color: maleColor }
                ].forEach(function(part) {
                    if (part.width <= 0) {
                        return;
                    }
                    g.append('rect')
                        .attr('x', x(part.from))
                        .attr('y', y)
                        .attr('width', x(part.width))
                        .attr('height', barHeight)
                        .attr('fill', part.color)
                        .on('mousemove', function(event) {
                            tip.show(event, describe);
                        })
                        .on('mouseout', tip.hide);
                });
                g.append('text')
                    .attr('x', innerW + 10)
                    .attr('y', y + barHeight / 2 + 4)
                    .style('font-size', '11px')
                    .style('fill', mutedColor())
                    .text(pct(femaleShare * 100) + ' ' + (labels.femaleShort || 'female') + ' \u00b7 N=' + row.n);
            });

            legend(ctx, [labels.female || 'Female', labels.male || 'Male'], [femaleColor, maleColor]);
            return ctx;
        }

        function legend(ctx, keys, colors) {
            const group = ctx.svg.append('g').attr('transform', 'translate(62,' + (ctx.height - 14) + ')');
            // One row: items share the width, so the last ones are never cut off.
            const step = Math.min(170, Math.max(60, (ctx.width - 70) / Math.max(keys.length, 1)));
            const chars = Math.max(4, Math.floor((step - 20) / 6.5));
            keys.forEach(function(key, index) {
                const item = group.append('g').attr('transform', 'translate(' + index * step + ',0)');
                item.append('rect')
                    .attr('width', 10)
                    .attr('height', 10)
                    .attr('fill', colors[index % colors.length]);
                item.append('text')
                    .attr('x', 15)
                    .attr('y', 10)
                    .style('font-size', '11px')
                    .style('fill', mutedColor())
                    .text(truncate(key, chars))
                    .append('title')
                    .text(key);
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Tables
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * Sort state for a table header. Sorts on the raw value in the model,
         * so numeric columns order numerically rather than as formatted text.
         */
        function sorter(initialField, descending) {
            return {
                field: initialField || null,
                descending: descending === true,
                // The comparator is cached per field: `expression()` is called on
                // every digest, and handing orderBy a brand-new function each
                // time would make it re-sort the whole table every cycle.
                _cachedField: undefined,
                _cachedExpression: [],
                toggle: function(field) {
                    if (this.field === field) {
                        this.descending = !this.descending;
                    } else {
                        this.field = field;
                        this.descending = false;
                    }
                },
                expression: function() {
                    if (this._cachedField !== this.field) {
                        this._cachedField = this.field;
                        if (!this.field) {
                            this._cachedExpression = [];
                        } else {
                            const field = this.field;
                            this._cachedExpression = [
                                function(row) {
                                    const value = row[field];
                                    // missing values sort last in both directions
                                    return isMissing(value) ? Number.POSITIVE_INFINITY : value;
                                }
                            ];
                        }
                    }
                    return this._cachedExpression;
                },
                indicator: function(field) {
                    if (this.field !== field) {
                        return '';
                    }
                    return this.descending ? '▼' : '▲';
                }
            };
        }

        function distinct(rows, field) {
            const seen = {};
            const values = [];
            (rows || []).forEach(function(row) {
                const value = row[field];
                if (isMissing(value)) {
                    return;
                }
                const key = String(value);
                if (!seen[key]) {
                    seen[key] = true;
                    values.push(value);
                }
            });
            return values.sort(function(a, b) {
                if (typeof a === 'number' && typeof b === 'number') {
                    return b - a;
                }
                return String(a).localeCompare(String(b));
            });
        }

        /**
         * An empty selection means "no restriction", matching how the global
         * filters behave. Local table filters never hide everything by default.
         */
        function matchesSelection(value, selection) {
            if (!selection || !selection.length) {
                return true;
            }
            return selection.map(String).indexOf(String(value)) !== -1;
        }
    }
})();

(function() {

    "use strict";

    angular.module('scope.commons.projects')
        .directive('projectProgressSteps', projectProgressSteps);

    function projectProgressSteps() {

        return {
            restrict: 'E',
            scope: {
              step: '='
            },
            templateUrl: 'projects/templates/partials/projectProgressSteps.html',
            controller: projectProgressStepsController,
            controllerAs: 'progressCtrl',
            bindToController: true
        }
    }

    projectProgressStepsController.$inject = ['$scope'];
    
    function projectProgressStepsController($scope) {
        var vm = this;

        vm.step = vm.step || 2;
    }

})();

(function() {

    "use strict";

    angular.module('scope.commons.projects')
        .directive('projectDetailWebsite', projectDetailWebsite);

    function projectDetailWebsite() {

        return {
            restrict: 'E',
            templateUrl: 'projects/templates/website/projectDetailWebsite.html',
            controller: 'projectDetailWebsiteController'
        }
    }

})();

(function() {

    "use strict";

    angular.module('scope.commons.projects')
        .directive('projectDetailDashboard', projectDetailDashboard);

    function projectDetailDashboard() {

        return {
            restrict: 'E',
            templateUrl: 'projects/templates/dashboard/projectDetailDashboard.html',
            controller: 'projectDetailDashboardController'
        }
    }

})();

(function() {

    "use strict";

    angular.module('scope.commons.projects')
        .directive('projectCreateWebsite', projectCreateWebsite);

    function projectCreateWebsite() {

        return {
            restrict: 'E',
            templateUrl: 'projects/templates/website/projectCreateWebsite.html',
            controller: 'ProjectCreateWebsiteController'
        }
    }

})();

(function() {

    "use strict";

    angular.module('scope.commons.projects')
        .component('projectCreateDashboard', {
            templateUrl: 'projects/templates/dashboard/projectCreateDashboard.html',
            controller: 'projectCreateController'
        });

})();


(function() {
    'use strict';

    /**
     * `<si-analytics-loader>` - the Project Analytics loader. AD-2201.
     *
     * The design's v6 "brand final" loader (a Canvas 2D scene with a
     * hand-rolled perspective projection, and the progress HUD over it), placed
     * inside a tab's `.analytics-main`. It covers the visible part of the
     * tab's analytics area - the content and the Controls & Insights rail, so
     * filters cannot be changed mid-load - while the app header and the side
     * navigation stay
     * usable - and is driven by `siAnalyticsLoader`, never by a clock: the
     * scene's phases follow the progress the tab reports.
     *
     * Differences from the design file, all deliberate:
     *   - no demo loop and no `window.analyticsLoader` global;
     *   - `creepTo(cap)` eases progress towards a cap while a request runs, and
     *     `complete(quick)` skips the "Ready" hold for a reload;
     *   - the animation frame loop runs only while the loader is visible, and
     *     every window listener is removed when the tab is left;
     *   - the shell scales down to fit a short content area.
     */
    angular.module('scope.commons.projects').directive('siAnalyticsLoader', siAnalyticsLoaderDirective);

    siAnalyticsLoaderDirective.$inject = ['$window', 'gettext', 'gettextCatalog', 'siAnalyticsLoader'];

    function siAnalyticsLoaderDirective($window, gettext, gettextCatalog, siAnalyticsLoader) {
        return {
            restrict: 'E',
            templateUrl: 'projects/templates/projectAnalytics/partials/analyticsLoader.html',
            link: link
        };

        function link(scope, element) {
            const engine = createEngine(element[0], $window, {
                headline: gettextCatalog.getString(gettext('Analyzing Project Data')),
                subcopy: gettextCatalog.getString(
                    gettext('Combining assessments, demographics, financials, and production data')
                ),
                readyHeadline: gettextCatalog.getString(gettext('Project Analytics Ready')),
                readySubcopy: gettextCatalog.getString(gettext('Dashboard data has been analyzed and prepared.')),
                processing: gettextCatalog.getString(gettext('Processing')),
                completed: gettextCatalog.getString(gettext('Completed')),
                stages: [
                    gettextCatalog.getString(gettext('Loading project records')),
                    gettextCatalog.getString(gettext('Aggregating indicators')),
                    gettextCatalog.getString(gettext('Calculating benchmark metrics')),
                    gettextCatalog.getString(gettext('Rendering charts and tables'))
                ],
                sources: [
                    gettextCatalog.getString(gettext('Assessments')),
                    gettextCatalog.getString(gettext('Demographics')),
                    gettextCatalog.getString(gettext('Financials')),
                    gettextCatalog.getString(gettext('Production'))
                ]
            });
            siAnalyticsLoader.attach(engine);
            scope.$on('$destroy', function() {
                siAnalyticsLoader.detach(engine);
                engine.destroy();
            });
        }
    }

    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     The scene (ported from the design)
     ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

    function createEngine(host, win, COPY) {
        const doc = win.document;
        const q = name => host.querySelector('.pa-loader__' + name);
        const root = host.querySelector('.pa-loader');
        // The tab's analytics area: content and filter rail together. Falls
        // back to the content column on a page without the shared shell.
        const area = (host.closest && host.closest('.analytics-shell')) || host.parentElement;
        const shell = q('shell');
        const stageEl = q('stage');
        const hud = q('hud');
        const canvas = q('scene');
        const ctx = canvas.getContext('2d');
        const progressValue = q('value');
        const progressbar = q('core');
        const headline = q('headline');
        const subcopy = q('subcopy');
        const flash = q('flash');
        const stepsWrap = q('steps');
        const srStatus = q('sr');
        const RM = win.matchMedia('(prefers-reduced-motion: reduce)');

        const STAGES = [
            { label: COPY.stages[0], start: 0, end: 26 },
            { label: COPY.stages[1], start: 26, end: 52 },
            { label: COPY.stages[2], start: 52, end: 78 },
            { label: COPY.stages[3], start: 78, end: 100 }
        ];

        /* the four ingestion sources, fixed in camera space (units of sphere radius) */
        const SOURCES = [
            { label: COPY.sources[0], v: [-1.32, -0.86, 0.35], rgb: [0, 161, 175] },
            { label: COPY.sources[1], v: [1.32, -0.86, -0.25], rgb: [88, 192, 208] },
            { label: COPY.sources[2], v: [-1.32, 0.86, -0.3], rgb: [144, 208, 207] },
            { label: COPY.sources[3], v: [1.32, 0.86, 0.3], rgb: [0, 164, 128] }
        ];
        const RGB_CYAN = [0, 161, 175];
        const RGB_OK = [21, 167, 72];

        /* ---------------- helpers ---------------- */
        const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v);
        const smooth = (a, b, v) => {
            const x = clamp((v - a) / (b - a));
            return x * x * (3 - 2 * x);
        };
        const easeOut = x => 1 - Math.pow(1 - x, 3);
        const rgba = (c, a) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;

        function makeSprite(c) {
            const s = doc.createElement('canvas');
            s.width = s.height = 64;
            const g = s.getContext('2d');
            const gr = g.createRadialGradient(32, 32, 0, 32, 32, 32);
            gr.addColorStop(0, 'rgba(255,255,255,1)');
            gr.addColorStop(0.16, rgba(c, 0.95));
            gr.addColorStop(0.42, rgba(c, 0.25));
            gr.addColorStop(1, rgba(c, 0));
            g.fillStyle = gr;
            g.fillRect(0, 0, 64, 64);
            return s;
        }
        const SPR_SRC = SOURCES.map(s => makeSprite(s.rgb));
        const SPR_CYAN = makeSprite(RGB_CYAN);
        const SPR_OK = makeSprite(RGB_OK);
        const SPR_WHITE = makeSprite([215, 250, 255]);

        /* ---------------- steps (DOM) ---------------- */
        const dividers = [];
        const stepEls = STAGES.map((stage, i) => {
            if (i > 0) {
                const d = doc.createElement('div');
                d.className = 'pa-loader__divider';
                stepsWrap.appendChild(d);
                dividers.push(d);
            }
            const el = doc.createElement('div');
            el.className = 'pa-loader__step';
            el.innerHTML =
                '<span class="pa-loader__check"></span><span class="pa-loader__step-label"></span>' +
                '<span class="pa-loader__step-state"></span>';
            el.querySelector('.pa-loader__step-label').textContent = stage.label;
            stepsWrap.appendChild(el);
            return el;
        });
        const ellipsisHTML = '<span>·</span><span>·</span><span>·</span>';

        /* ---------------- scene data ---------------- */
        let W = 0;
        let H = 0;
        let S = 1;
        let R = 178;
        let CAM = 750;
        let cx = 0;
        let cy = 0;
        let small = null;
        let particles = [];
        let order = [];
        let links = [];
        let stars = [];
        let packets = [];
        const rings = [
            { r: 1.3, tx: 1.18, tz: 0.32, spin: 0.3, ph: 0.0 },
            { r: 1.44, tx: -0.92, tz: -0.48, spin: -0.2, ph: 2.1 },
            { r: 1.18, tx: 0.22, tz: 1.22, spin: 0.45, ph: 4.2 }
        ];

        function buildScene() {
            const N = small ? 120 : 220;
            const GA = Math.PI * (3 - Math.sqrt(5));
            particles = [];
            for (let i = 0; i < N; i++) {
                const y = 1 - ((i + 0.5) / N) * 2;
                const r = Math.sqrt(1 - y * y);
                const th = i * GA;
                const ux = Math.cos(th) * r;
                const uz = Math.sin(th) * r;
                const uy = y;
                const j = () => (Math.random() - 0.5) * 0.46;
                particles.push({
                    ux,
                    uy,
                    uz,
                    src: i % 4,
                    jx: j(),
                    jy: j(),
                    jz: j(),
                    a: Math.random() * 19.5, // arrival progress (stage 1)
                    mergeAt: 0.1 + Math.random() * 0.8, // colour unifies during stage 2
                    rendAt: ((1 - uy) / 2) * 0.8, // green sweep during stage 4
                    value: 0.5 + 0.5 * Math.sin(ux * 3.1 + uy * 1.7) * Math.cos(uz * 2.3 - uy * 1.2),
                    hub: i % 29 === 0,
                    phase: Math.random() * 6.283,
                    m: 0,
                    vx: 0,
                    vy: 0,
                    vz: 0,
                    X: 0,
                    Y: 0,
                    k: 1,
                    tX: 0,
                    tY: 0
                });
            }
            order = particles.map((_, i) => i);

            // 2 nearest neighbours per node -> network links (deduplicated)
            links = [];
            const seen = new Set();
            for (let i = 0; i < N; i++) {
                const p = particles[i];
                const best = [];
                for (let k = 0; k < N; k++) {
                    if (k === i) {
                        continue;
                    }
                    const o = particles[k];
                    const d = p.ux * o.ux + p.uy * o.uy + p.uz * o.uz;
                    if (best.length < 2) {
                        best.push([d, k]);
                        best.sort((a, b) => b[0] - a[0]);
                    } else if (d > best[1][0]) {
                        best[1] = [d, k];
                        best.sort((a, b) => b[0] - a[0]);
                    }
                }
                for (const pair of best) {
                    const k = pair[1];
                    const key = i < k ? i * N + k : k * N + i;
                    if (!seen.has(key)) {
                        seen.add(key);
                        links.push({ a: i, b: k, th: Math.random() * 0.85 });
                    }
                }
            }

            stars = Array.from({ length: small ? 45 : 80 }, () => {
                const u = Math.random() * 2 - 1;
                const t2 = Math.random() * 6.283;
                const r = Math.sqrt(1 - u * u);
                const d = 2.6 + Math.random() * 1.2;
                return {
                    x: Math.cos(t2) * r * d,
                    y: u * d,
                    z: Math.sin(t2) * r * d,
                    a: 0.15 + Math.random() * 0.35,
                    s: 0.6 + Math.random() * 0.9
                };
            });
            packets = Array.from({ length: small ? 5 : 10 }, () => ({ l: 0, u: 1, sp: 1 }));
        }

        /**
         * Fix the overlay to the visible part of the analytics area, below a
         * fixed or sticky app header if there is one, and scale the shell down
         * when that area is shorter than the design.
         */
        function place() {
            const rect = area.getBoundingClientRect();
            let topLimit = 0;
            const header = doc.querySelector('[ui-view="headerView"] > *');
            if (header) {
                const position = win.getComputedStyle(header).position;
                if (position === 'fixed' || position === 'sticky') {
                    topLimit = Math.max(0, header.getBoundingClientRect().bottom);
                }
            }
            const top = Math.max(rect.top, topLimit);
            const bottom = win.innerHeight;
            const left = Math.max(rect.left, 0);
            const right = Math.min(rect.right, win.innerWidth);
            root.style.top = top + 'px';
            root.style.left = left + 'px';
            root.style.width = Math.max(0, right - left) + 'px';
            root.style.height = Math.max(0, bottom - top) + 'px';

            const need = shell.scrollHeight || 640;
            const scale = Math.min(1, Math.max(0.5, (bottom - top - 16) / need), Math.max(0.5, (right - left) / 560));
            shell.style.transform = scale < 1 ? 'scale(' + scale.toFixed(3) + ')' : '';
        }

        function resize() {
            const nowSmall = win.innerWidth < 720;
            if (nowSmall !== small) {
                small = nowSmall;
                buildScene();
            }
            place();
            const rect = canvas.getBoundingClientRect();
            const dpr = Math.min(small ? 1.25 : 1.6, win.devicePixelRatio || 1);
            // The bounding rect is scaled with the shell; the canvas works in
            // its own unscaled CSS pixels.
            W = canvas.offsetWidth || rect.width;
            H = canvas.offsetHeight || rect.height;
            canvas.width = Math.round(W * dpr);
            canvas.height = Math.round(H * dpr);
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            S = stageEl.offsetWidth / 480;
            R = 178 * S;
            CAM = R * 4.2;
            cx = W / 2;
            cy = H / 2;
        }

        /* ---------------- 3D math ---------------- */
        let cY = 1;
        let sY = 0;
        let cP = 1;
        let sP = 0;
        const V = [0, 0, 0];
        const Q = [0, 0, 0];
        function toView(x, y, z, o) {
            // object -> camera space (yaw, then pitch)
            const x1 = x * cY + z * sY;
            const z1 = -x * sY + z * cY;
            o[0] = x1;
            o[1] = y * cP - z1 * sP;
            o[2] = y * sP + z1 * cP;
        }
        function project(x, y, z, o) {
            // camera space -> screen; o[2] = scale
            const k = CAM / (CAM + z);
            o[0] = cx + x * k;
            o[1] = cy + y * k;
            o[2] = k;
        }
        const depthLight = z => clamp(0.5 - z / (2 * R)); // 0 = far side, 1 = near side

        function ringPoint(rg, a, rad, o) {
            const x = Math.cos(a) * rad;
            const z = Math.sin(a) * rad;
            const y1 = -z * Math.sin(rg.tx);
            const z1 = z * Math.cos(rg.tx);
            const x2 = x * Math.cos(rg.tz) - y1 * Math.sin(rg.tz);
            const y2 = x * Math.sin(rg.tz) + y1 * Math.cos(rg.tz);
            toView(x2, y2, z1, o);
        }

        /* ---------------- state ---------------- */
        let target = 0;
        let disp = 0;
        let creepCap = 0;
        let t = 0;
        let last = 0;
        let lastDraw = 0;
        const FRAME_MS = 1000 / 30;
        let completeAt = null;
        let quickFinish = false;
        let visible = false;
        let rafId = null;
        let leaveTimer = null;
        let hideTimer = null;
        let flashTimer = null;
        let mx = 0;
        let my = 0;
        let smx = 0;
        let smy = 0;
        let lastInt = -1;
        let rendered = STAGES.map(() => 'pending');

        /* ---------------- UI sync (driven by smoothed progress) ---------------- */
        function syncUI(p) {
            hud.style.setProperty('--p', p.toFixed(2));
            const pi = p >= 100 ? 100 : Math.min(99, Math.floor(p));
            if (pi !== lastInt) {
                lastInt = pi;
                progressValue.textContent = pi;
                progressbar.setAttribute('aria-valuenow', pi);
            }
            STAGES.forEach((stage, i) => {
                const state = p >= stage.end ? 'done' : p >= stage.start ? 'active' : 'pending';
                if (state === rendered[i]) {
                    return;
                }
                const el = stepEls[i];
                const stateEl = el.querySelector('.pa-loader__step-state');
                if (state !== 'pending') {
                    el.classList.add('is-shown');
                    if (i > 0) {
                        dividers[i - 1].classList.add('is-shown');
                    }
                }
                el.classList.toggle('is-active', state === 'active');
                el.classList.toggle('is-done', state === 'done');
                if (state === 'active') {
                    stateEl.innerHTML =
                        COPY.processing + '<span class="pa-loader__ellipsis">' + ellipsisHTML + '</span>';
                    srStatus.textContent = stage.label;
                    progressbar.setAttribute('aria-valuetext', `${stage.label}, ${pi}%`);
                } else if (state === 'done') {
                    stateEl.textContent = COPY.completed;
                }
                rendered[i] = state;
            });
            if (p >= 100 && completeAt === null) {
                complete();
            }
        }

        function complete() {
            completeAt = t;
            root.classList.add('pa-loader--done');
            headline.textContent = COPY.readyHeadline;
            subcopy.textContent = COPY.readySubcopy;
            srStatus.textContent = COPY.readyHeadline;
            progressbar.setAttribute('aria-valuetext', COPY.readyHeadline);
            q('overlay').setAttribute('aria-busy', 'false');
            if (quickFinish) {
                // A reload: no "Ready" hold, just fade out over the drawn charts.
                leaveTimer = setTimeout(leave, 150);
                return;
            }
            flash.classList.add('is-on');
            flashTimer = setTimeout(() => flash.classList.remove('is-on'), 900);
            leaveTimer = setTimeout(leave, 1900);
        }

        function leave() {
            clearTimeout(leaveTimer);
            root.classList.add('pa-loader--leaving');
            hideTimer = setTimeout(stop, quickFinish ? 400 : 750);
        }

        function stop() {
            visible = false;
            root.classList.add('pa-loader--hidden');
            root.classList.remove('pa-loader--leaving');
            if (rafId !== null) {
                win.cancelAnimationFrame(rafId);
                rafId = null;
            }
        }

        function show() {
            clearTimeout(leaveTimer);
            clearTimeout(hideTimer);
            clearTimeout(flashTimer);
            target = disp = creepCap = 0;
            completeAt = null;
            quickFinish = false;
            lastInt = -1;
            rendered = STAGES.map(() => 'pending');
            stepEls.forEach(el => {
                el.className = 'pa-loader__step';
                el.querySelector('.pa-loader__step-state').textContent = '';
            });
            dividers.forEach(d => d.classList.remove('is-shown'));
            headline.textContent = COPY.headline;
            subcopy.textContent = COPY.subcopy;
            flash.classList.remove('is-on');
            root.classList.remove('pa-loader--hidden', 'pa-loader--leaving', 'pa-loader--done', 'pa-loader--quick');
            q('overlay').setAttribute('aria-busy', 'true');
            visible = true;
            resize();
            syncUI(0);
            if (rafId === null) {
                last = win.performance.now();
                lastDraw = 0;
                rafId = win.requestAnimationFrame(frame);
            }
        }

        /* ---------------- render (unchanged from the design) ---------------- */
        function draw(dt) {
            const p = disp;
            const rm = RM.matches;
            ctx.clearRect(0, 0, W, H);

            const yaw = t * (rm ? 0.03 : 0.22) + smx * 0.35;
            const pitch = 0.36 + smy * 0.22;
            cY = Math.cos(yaw);
            sY = Math.sin(yaw);
            cP = Math.cos(pitch);
            sP = Math.sin(pitch);

            const s2 = smooth(26, 52, p);
            const s4 = smooth(78, 100, p);
            const scanAmt = smooth(52, 58, p) * (1 - smooth(78, 88, p));
            const srcAlpha = 1 - smooth(22, 32, p);
            const tc = completeAt === null ? -1 : t - completeAt;
            let sc = rm ? 1 : 1 + 0.012 * Math.sin(t * 1.8);
            if (tc >= 0) {
                sc *= 1 - 0.1 * Math.sin(Math.min(tc / 0.45, 1) * Math.PI);
            }
            const Rs = R * sc;
            const scanY = rm ? 0.2 : Math.sin(t * 1.25) * 0.9;

            ctx.globalCompositeOperation = 'lighter';

            /* core energy */
            const coreRGB = tc >= 0 ? RGB_OK : [25, 169, 255];
            const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, R * 1.3);
            g.addColorStop(0, rgba(coreRGB, 0.07 + (0.13 * p) / 100 + (tc >= 0 ? 0.12 * Math.max(0, 1 - tc) : 0)));
            g.addColorStop(1, rgba(coreRGB, 0));
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, W, H);

            /* far starfield - slower yaw gives parallax depth */
            const cYs = Math.cos(yaw * 0.35);
            const sYs = Math.sin(yaw * 0.35);
            ctx.fillStyle = 'rgb(160,230,245)';
            for (const st of stars) {
                const x1 = (st.x * cYs + st.z * sYs) * R;
                const z1 = (-st.x * sYs + st.z * cYs) * R;
                const y = st.y * R;
                const y2 = y * cP - z1 * sP;
                const z2 = y * sP + z1 * cP;
                if (CAM + z2 < R * 0.8) {
                    continue;
                }
                const k = CAM / (CAM + z2);
                const X = cx + x1 * k;
                const Y = cy + y2 * k;
                if (X < 0 || Y < 0 || X > W || Y > H) {
                    continue;
                }
                ctx.globalAlpha = st.a * clamp(k * 0.7) * (0.7 + 0.3 * Math.sin(t + st.x * 9));
                ctx.fillRect(X, Y, st.s * k * S, st.s * k * S);
            }

            /* source beams */
            if (srcAlpha > 0) {
                ctx.lineWidth = 1 * S;
                SOURCES.forEach(s => {
                    project(s.v[0] * R, s.v[1] * R, s.v[2] * R, Q);
                    const gr = ctx.createLinearGradient(Q[0], Q[1], cx, cy);
                    gr.addColorStop(0, rgba(s.rgb, 0.22 * srcAlpha));
                    gr.addColorStop(1, rgba(s.rgb, 0));
                    ctx.globalAlpha = 1;
                    ctx.strokeStyle = gr;
                    ctx.beginPath();
                    ctx.moveTo(Q[0], Q[1]);
                    ctx.lineTo(cx, cy);
                    ctx.stroke();
                });
            }

            /* particle positions */
            for (const pt of particles) {
                toView(pt.ux * Rs, pt.uy * Rs, pt.uz * Rs, V);
                const m = clamp((p - pt.a) / (rm ? 2 : 6));
                pt.m = m;
                if (m >= 1) {
                    pt.vx = V[0];
                    pt.vy = V[1];
                    pt.vz = V[2];
                } else {
                    const s = SOURCES[pt.src].v;
                    const wob = rm ? 0 : Math.sin(t * 1.4 + pt.phase) * 0.05;
                    const Sx = (s[0] + pt.jx + wob) * R;
                    const Sy = (s[1] + pt.jy) * R;
                    const Sz = (s[2] + pt.jz) * R;
                    const Cx = (Sx + V[0]) * 0.38;
                    const Cy = (Sy + V[1]) * 0.38 - R * 0.2;
                    const Cz = (Sz + V[2]) * 0.38 - R * 0.55;
                    const bez = (e, o) => {
                        const u = 1 - e;
                        const A = u * u;
                        const B = 2 * u * e;
                        const C = e * e;
                        o[0] = A * Sx + B * Cx + C * V[0];
                        o[1] = A * Sy + B * Cy + C * V[1];
                        o[2] = A * Sz + B * Cz + C * V[2];
                    };
                    const e = m * m * (3 - 2 * m);
                    bez(Math.max(0, e - 0.09), Q);
                    project(Q[0], Q[1], Q[2], Q);
                    pt.tX = Q[0];
                    pt.tY = Q[1];
                    bez(e, Q);
                    pt.vx = Q[0];
                    pt.vy = Q[1];
                    pt.vz = Q[2];
                }
                project(pt.vx, pt.vy, pt.vz, Q);
                pt.X = Q[0];
                pt.Y = Q[1];
                pt.k = Q[2];
            }

            /* orbital rings (benchmark comparators) - back halves first */
            const ringAlpha = 0.14 + 0.1 * smooth(0, 20, p) + 0.45 * scanAmt + 0.08 * s4;
            const drawRings = front => {
                ctx.lineWidth = 1.1 * S;
                for (const rg of rings) {
                    const segs = 72;
                    const off = rm ? rg.ph : rg.ph + t * rg.spin;
                    const rad = rg.r * Rs;
                    let px = 0;
                    let py = 0;
                    let pz = 0;
                    for (let i = 0; i <= segs; i++) {
                        ringPoint(rg, off + (i / segs) * 6.283, rad, V);
                        const z = V[2];
                        project(V[0], V[1], V[2], Q);
                        if (i > 0 && i % 6 < 4 && (z + pz) / 2 < 0 === front) {
                            ctx.globalAlpha = ringAlpha * (0.3 + 0.7 * depthLight((z + pz) / 2));
                            ctx.strokeStyle = rgba(scanAmt > 0.01 ? [140, 250, 255] : RGB_CYAN, 1);
                            ctx.beginPath();
                            ctx.moveTo(px, py);
                            ctx.lineTo(Q[0], Q[1]);
                            ctx.stroke();
                        }
                        px = Q[0];
                        py = Q[1];
                        pz = z;
                    }
                    ringPoint(rg, rm ? rg.ph : rg.ph + t * rg.spin * 2.4, rad, V);
                    if (V[2] < 0 === front) {
                        project(V[0], V[1], V[2], Q);
                        const d = (6 + 6 * scanAmt) * S * Q[2];
                        ctx.globalAlpha = 0.5 + 0.5 * depthLight(V[2]);
                        ctx.drawImage(SPR_WHITE, Q[0] - d, Q[1] - d, d * 2, d * 2);
                    }
                }
            };
            drawRings(false);

            /* network links (stage 2), batched into 4 alpha buckets */
            if (s2 > 0) {
                const paths = [new Path2D(), new Path2D(), new Path2D(), new Path2D()];
                for (const l of links) {
                    const la = clamp((s2 - l.th) / 0.12);
                    if (la <= 0) {
                        continue;
                    }
                    const A = particles[l.a];
                    const B = particles[l.b];
                    if (A.m < 1 || B.m < 1) {
                        continue;
                    }
                    const a = la * (0.2 + 0.8 * depthLight((A.vz + B.vz) / 2)) * (1 - 0.35 * s4);
                    if (a < 0.06) {
                        continue;
                    }
                    const pth = paths[Math.min(3, (a * 4) | 0)];
                    pth.moveTo(A.X, A.Y);
                    pth.lineTo(B.X, B.Y);
                }
                ctx.globalAlpha = 1;
                ctx.lineWidth = 0.7 * S;
                paths.forEach((pth, b) => {
                    ctx.strokeStyle = rgba(RGB_CYAN, ((b + 0.6) / 4) * 0.42);
                    ctx.stroke(pth);
                });
            }

            /* radial bars (stage 4) - the sphere becomes a 3D chart */
            if (s4 > 0) {
                const paths = [new Path2D(), new Path2D(), new Path2D()];
                for (const pt of particles) {
                    if (pt.m < 1) {
                        continue;
                    }
                    const grow = easeOut(clamp((s4 - pt.rendAt) / 0.22));
                    if (grow <= 0) {
                        continue;
                    }
                    const len = Rs + (0.06 + pt.value * 0.36) * R * grow;
                    toView(pt.ux * len, pt.uy * len, pt.uz * len, V);
                    project(V[0], V[1], V[2], Q);
                    const pth = paths[Math.min(2, (depthLight(pt.vz) * 3) | 0)];
                    pth.moveTo(pt.X, pt.Y);
                    pth.lineTo(Q[0], Q[1]);
                }
                ctx.globalAlpha = 1;
                ctx.lineWidth = 1.3 * S;
                paths.forEach((pth, b) => {
                    ctx.strokeStyle = rgba(RGB_OK, 0.18 + b * 0.22);
                    ctx.stroke(pth);
                });
            }

            /* nodes, depth-sorted far -> near */
            order.sort((i, j) => particles[j].vz - particles[i].vz);
            ctx.lineWidth = 1 * S;
            for (const idx of order) {
                const pt = particles[idx];
                if (pt.m <= 0) {
                    // queued at its source
                    if (srcAlpha <= 0) {
                        continue;
                    }
                    const d = 3.2 * S * pt.k;
                    ctx.globalAlpha = 0.3 * srcAlpha;
                    ctx.drawImage(SPR_SRC[pt.src], pt.X - d, pt.Y - d, d * 2, d * 2);
                    continue;
                }
                let alpha = 0.28 + 0.72 * depthLight(pt.vz);
                let size = (pt.hub ? 3.0 : 1.7) * S * pt.k;
                let spr = s2 > pt.mergeAt ? SPR_CYAN : SPR_SRC[pt.src];
                if (pt.hub) {
                    spr = SPR_WHITE;
                }

                if (pt.m < 1) {
                    // in flight: draw a streak
                    alpha = Math.max(alpha, 0.85);
                    ctx.globalAlpha = 0.5;
                    ctx.strokeStyle = rgba(SOURCES[pt.src].rgb, 1);
                    ctx.beginPath();
                    ctx.moveTo(pt.tX, pt.tY);
                    ctx.lineTo(pt.X, pt.Y);
                    ctx.stroke();
                } else {
                    const since = p - pt.a - (rm ? 2 : 6);
                    if (since < 2.5) {
                        size *= 1 + (1 - since / 2.5) * 1.3; // arrival flare
                    }
                }
                if (scanAmt > 0) {
                    const d = Math.abs(pt.uy - scanY);
                    if (d < 0.14) {
                        const b = (1 - d / 0.14) * scanAmt;
                        size *= 1 + b * 1.2;
                        alpha = Math.min(1, alpha + b * 0.6);
                        if (b > 0.5) {
                            spr = SPR_WHITE;
                        }
                    }
                }
                if (s4 > pt.rendAt + 0.05) {
                    spr = SPR_OK;
                }
                if (!rm) {
                    alpha *= 0.85 + 0.15 * Math.sin(t * 3 + pt.phase);
                }

                const d = size * 2.6;
                ctx.globalAlpha = alpha;
                ctx.drawImage(spr, pt.X - d, pt.Y - d, d * 2, d * 2);
            }

            /* data packets travelling along links */
            if (s2 > 0.25 && !rm && tc < 0) {
                const cnt = Math.round(packets.length * clamp((s2 - 0.25) / 0.5));
                for (let i = 0; i < cnt; i++) {
                    const pk = packets[i];
                    if (pk.u >= 1) {
                        pk.l = (Math.random() * links.length) | 0;
                        pk.u = 0;
                        pk.sp = 0.9 + Math.random() * 1.4;
                    }
                    pk.u += dt * pk.sp;
                    const L = links[pk.l];
                    const A = particles[L.a];
                    const B = particles[L.b];
                    if (s2 < L.th + 0.12) {
                        pk.u = 1;
                        continue;
                    }
                    const u = Math.min(1, pk.u);
                    const X = A.X + (B.X - A.X) * u;
                    const Y = A.Y + (B.Y - A.Y) * u;
                    const d = 4.5 * S * A.k;
                    ctx.globalAlpha = 0.9 * (0.3 + 0.7 * depthLight(A.vz)) * Math.sin(u * Math.PI);
                    ctx.drawImage(SPR_WHITE, X - d, Y - d, d * 2, d * 2);
                }
            }

            /* benchmark scan plane (stage 3) */
            if (scanAmt > 0.01) {
                const rr = Math.sqrt(1 - scanY * scanY) * Rs * 1.02;
                const segs = 48;
                for (const pass of [
                    [7, 0.12],
                    [1.4, 0.75]
                ]) {
                    ctx.lineWidth = pass[0] * S;
                    let px = 0;
                    let py = 0;
                    for (let i = 0; i <= segs; i++) {
                        const a = (i / segs) * 6.283;
                        toView(Math.cos(a) * rr, scanY * Rs, Math.sin(a) * rr, V);
                        const z = V[2];
                        project(V[0], V[1], V[2], Q);
                        if (i > 0) {
                            ctx.globalAlpha = scanAmt * pass[1] * (0.25 + 0.75 * depthLight(z));
                            ctx.strokeStyle = 'rgb(160,252,255)';
                            ctx.beginPath();
                            ctx.moveTo(px, py);
                            ctx.lineTo(Q[0], Q[1]);
                            ctx.stroke();
                        }
                        px = Q[0];
                        py = Q[1];
                    }
                }
            }

            drawRings(true);

            /* source nodes + labels */
            if (srcAlpha > 0) {
                SOURCES.forEach((s, i) => {
                    project(s.v[0] * R, s.v[1] * R, s.v[2] * R, Q);
                    const d = (13 + 2 * Math.sin(t * 3 + i)) * S * Q[2];
                    ctx.globalCompositeOperation = 'lighter';
                    ctx.globalAlpha = 0.9 * srcAlpha;
                    ctx.drawImage(SPR_SRC[i], Q[0] - d, Q[1] - d, d * 2, d * 2);
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.globalAlpha = 0.85 * srcAlpha;
                    ctx.fillStyle = 'rgb(205,236,244)';
                    ctx.font = `500 ${Math.round(11.5 * Math.max(S, 0.85))}px Inter, "Segoe UI", Arial, sans-serif`;
                    ctx.textAlign = 'center';
                    ctx.fillText(s.label, Q[0], Q[1] + (s.v[1] < 0 ? -d - 6 : d + 14));
                });
                ctx.globalCompositeOperation = 'lighter';
            }

            /* completion shockwave on the equator plane */
            if (tc > 0.2 && tc < 1.7) {
                const k = (tc - 0.2) / 1.5;
                const rad = Rs * (1 + easeOut(k) * 1.1);
                const segs = 56;
                for (const pass of [
                    [8, 0.2],
                    [2, 0.9]
                ]) {
                    ctx.lineWidth = pass[0] * S;
                    let px = 0;
                    let py = 0;
                    for (let i = 0; i <= segs; i++) {
                        const a = (i / segs) * 6.283;
                        toView(Math.cos(a) * rad, 0, Math.sin(a) * rad, V);
                        project(V[0], V[1], V[2], Q);
                        if (i > 0) {
                            ctx.globalAlpha = (1 - k) * pass[1];
                            ctx.strokeStyle = rgba(RGB_OK, 1);
                            ctx.beginPath();
                            ctx.moveTo(px, py);
                            ctx.lineTo(Q[0], Q[1]);
                            ctx.stroke();
                        }
                        px = Q[0];
                        py = Q[1];
                    }
                }
            }

            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = 'source-over';
        }

        function frame(now) {
            rafId = null;
            if (!visible) {
                return;
            }
            // Clamped at both ends: a frame timestamp can be slightly older than
            // the `performance.now()` taken in `show()`, and a negative step ran
            // the progress below zero.
            const dt = Math.max(0, Math.min(0.05, (now - last) / 1000));
            last = now;
            if (!doc.hidden) {
                t += dt;

                // While a request runs there is no finer signal than "still
                // working": ease towards the cap the service set, never past it.
                if (creepCap > target) {
                    target += (creepCap - target) * (1 - Math.exp(-dt / 4));
                }

                // Progress and text stay responsive even when drawing is capped.
                const k = 1 - Math.exp(-dt * (RM.matches ? 12 : 4.2));
                const diff = target - disp;
                disp += Math.sign(diff) * Math.min(Math.abs(diff), Math.max(Math.abs(diff) * k, dt * 9));
                syncUI(disp);

                // The canvas scene is capped at ~30 FPS to spare weaker laptops.
                if (now - lastDraw >= FRAME_MS) {
                    const drawDt = Math.max(0, Math.min(0.05, (now - lastDraw) / 1000 || dt));
                    lastDraw = now;
                    smx += (mx - smx) * Math.min(1, drawDt * 3);
                    smy += (my - smy) * Math.min(1, drawDt * 3);
                    hud.style.transform = RM.matches
                        ? ''
                        : `rotateX(${(-smy * 7).toFixed(2)}deg) rotateY(${(smx * 9).toFixed(2)}deg)`;
                    draw(drawDt);
                }
            }
            rafId = win.requestAnimationFrame(frame);
        }

        function onPointerMove(e) {
            mx = (e.clientX / win.innerWidth) * 2 - 1;
            my = (e.clientY / win.innerHeight) * 2 - 1;
        }
        function onPointerLeave() {
            mx = my = 0;
        }
        function onViewportChange() {
            if (visible) {
                resize();
            }
        }
        function onVisibility() {
            if (!doc.hidden) {
                last = win.performance.now();
                lastDraw = 0;
            }
        }

        win.addEventListener('pointermove', onPointerMove);
        doc.addEventListener('pointerleave', onPointerLeave);
        win.addEventListener('resize', onViewportChange);
        win.addEventListener('scroll', onViewportChange, true);
        doc.addEventListener('visibilitychange', onVisibility);

        /* ---------------- API used by siAnalyticsLoader ---------------- */
        return {
            show: show,
            setProgress: function(v) {
                target = Math.max(target, clamp(+v || 0, 0, 100));
            },
            creepTo: function(cap) {
                creepCap = Math.max(creepCap, clamp(+cap || 0, 0, 100));
            },
            complete: function(quick) {
                quickFinish = !!quick;
                if (quickFinish) {
                    root.classList.add('pa-loader--quick');
                }
                target = 100;
                creepCap = 100;
            },
            dismiss: function() {
                quickFinish = true;
                leave();
            },
            destroy: function() {
                clearTimeout(leaveTimer);
                clearTimeout(hideTimer);
                clearTimeout(flashTimer);
                stop();
                win.removeEventListener('pointermove', onPointerMove);
                doc.removeEventListener('pointerleave', onPointerLeave);
                win.removeEventListener('resize', onViewportChange);
                win.removeEventListener('scroll', onViewportChange, true);
                doc.removeEventListener('visibilitychange', onVisibility);
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('projectsListController', projectsListController)
        //Ordering of nested object MUST be min to max for setting up the proper values!
        .constant('PROJECT_LIST_FILTERS', [
            { 'Project Owner': { customer_name: null }, optionsKey: 'project_owners' },
            { 'Project Quality Reviewer': { project_quality_reviewer: null }, optionsKey: 'project_quality_reviewers' },
            {
                'Project Financial Quality Reviewer': { project_financial_quality_reviewer: null },
                optionsKey: 'project_financial_quality_reviewers'
            },
            { 'Deal Number': { deal_number: null }, optionsKey: 'deal_numbers' },
            { 'Project Start Date Range': { min_start_date: null, max_start_date: null } },
            { 'Project End Date Range': { min_deadline: null, max_deadline: null } },
            { '# of Assessments': { min_number_of_assessments: null, max_number_of_assessments: null } },
            { '% Level of Completion': { min_completion_percentage: null, max_completion_percentage: null } }
        ]);

    projectsListController.$inject = [
        '$scope',
        '$state',
        '$q',
        '$rootScope',
        '$timeout',
        '$log',
        'gettext',
        '$location',
        'siProjects',
        'siFilters',
        'EVENT_LOADER',
        'PROJECT_LIST_FILTERS',
        'toastr'
    ];

    function projectsListController(
        $scope,
        $state,
        $q,
        $rootScope,
        $timeout,
        $log,
        gettext,
        $location,
        siProjects,
        siFilters,
        EVENT_LOADER,
        PROJECT_LIST_FILTERS,
        toastr
    ) {
        var params = {
            fields: ['customer', 'customer__producing_organization', 'members', 'members__user'],
            page: $state.params.page || 1,
            order: '-deadline'
        };

        _.extend(params, $location.search());

        getProjects(params);

        $scope.filters = siFilters.createFilters(PROJECT_LIST_FILTERS, $location.search());
        $scope.goToDetailView = goToDetailView;
        $scope.deleteProject = deleteProject;
        $scope.search = search;
        $scope.removeFilter = removeFilter;
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function goToDetailView(project) {
            var state = project.is_draft ? 'base.projects-draft-detail' : 'base.projects-detail';
            $state.go(state, { id: project.id });
        }

        function deleteProject(deleteProject) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siProjects.draftProjects
                .one(deleteProject.id)
                .remove()
                .then(function() {
                    $rootScope.$broadcast(EVENT_LOADER.hide);

                    $scope.projects.results = $scope.projects.results.filter(function(project) {
                        return deleteProject.id !== project.id;
                    });
                })
                .catch(function(err) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error Deleting Project - ', err);
                });
        }

        function getProjects(params) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siProjects.projects
                .one()
                .get(params)
                .then(function(res) {
                    $scope.projects = res;
                    console.log('Projects - ', res);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    console.log($scope.projects);
                });
        }

        function search(searchParams, displayFilter) {
            return siFilters.search(params, searchParams, displayFilter, getProjects);
        }

        function removeFilter(removeFilter) {
            return siFilters.removeFilter(removeFilter);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('projectEditController', projectEditController);

    projectEditController.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$filter',
        '$uibModal',
        '$q',
        '$log',
        '$stateParams',
        'me',
        'modalFactory',
        'gettext',
        'apiUrl',
        'siScope',
        'siHrm',
        'siCustomers',
        'siProjects',
        'toastr',
        '$timeout',
        'usernameFilter',
        'EVENT_LOADER'
    ];

    function projectEditController(
        $scope,
        $state,
        $rootScope,
        $filter,
        $uibModal,
        $q,
        $log,
        $stateParams,
        me,
        modalFactory,
        gettext,
        apiUrl,
        siScope,
        siHrm,
        siCustomers,
        siProjects,
        toastr,
        $timeout,
        usernameFilter,
        EVENT_LOADER
    ) {
        const projectParams = {
                fields: [
                    'owner',
                    'owner__user',
                    'customer_members',
                    'customer_members__user',
                    'contact',
                    'contact__user',
                    'customer',
                    'quality_reviewer',
                    'financial_quality_reviewer'
                ],
                id: $stateParams.id
            },
            customerParams = {
                fields: ['users', 'users__customer_contact'],
                producing_organization: false,
                page_size: 999
            },
            userParams = {
                fields: ['user'],
                is_active: true,
                user__is_active: true,
                page_size: 999
            };
        const projectsResourcePromise =
                $state.current.name === 'base.projects-edit'
                    ? siProjects.projects.one($stateParams.id).get(projectParams)
                    : siProjects.draftProjects.one($stateParams.id).get(projectParams),
            customersResourcePromise = siCustomers.getCustomers(customerParams),
            clientQrPromise = siHrm.getUsers({
                page_size: 9999,
                roles: 'is_customer_admin'
            }),
            hrmResourcePromise = siHrm.getEmployees(userParams),
            defaultQRPromise = siHrm
                .getDefaultQR({ fields: ['default_quality_reviewer__user'] })
                .then(settings => (settings.default_quality_reviewer || {}).user),
            defaultFinancialQRPromise = siHrm
                .getDefaultFinancialQR({ fields: ['default_financial_quality_reviewer__user'] })
                .then(settings => (settings.default_financial_quality_reviewer || {}).user);

        $rootScope.$broadcast(EVENT_LOADER.show);
        $scope.isPageLoaded = false;
        $q.all([
            projectsResourcePromise,
            customersResourcePromise,
            clientQrPromise,
            hrmResourcePromise,
            defaultQRPromise,
            defaultFinancialQRPromise
        ])
            .then(promises => {
                [
                    $scope.project,
                    $scope.customers,
                    $scope.qualityReviewers,
                    $scope.employees,
                    $scope.defaultQR,
                    $scope.defaultFinancialQR
                ] = promises;
                console.log('projectEditView qualityReviewers:', $scope.qualityReviewers.results);
                $scope.isQualityReviewerAssigned = Boolean($scope.project.quality_reviewer);
                $scope.isFinancialQualityReviewerAssigned = Boolean($scope.project.financial_quality_reviewer);
                $scope.contacts = [];
                $scope.clientDashAdmins = Object.assign({}, $scope.qualityReviewers);
                $scope.employees = $scope.employees.results
                    .filter(employee => employee.is_active)
                    .map(employee => employee.user)
                    .sort((a, b) => {
                        if (a.last_name < b.last_name) return -1;
                        if (a.last_name > b.last_name) return 1;
                        return 0;
                    });

                console.log('Project - ', promises[0]);
                console.log('Default QR - ', $scope.defaultQR);
                console.log('Default Financial QR - ', $scope.defaultFinancialQR);
                console.log('Customers - ', $scope.customers);
                console.log('Employees - ', $scope.employees);
            })
            .then(setInitialState)
            .then(() => {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                $scope.isPageLoaded = true;
                $scope.originalQualityReviewers = Object.assign({}, $scope.qualityReviewers);
                console.log('Contacts - ', $scope.contacts);
            })
            .catch(err => {
                toastr.error('Project Edit Controller Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        $scope.isDashboardUserAdmin = me.isDashboardUserAdmin();
        $scope.isEmployee = me.isEmployee();

        $scope.saveProject = saveProject;
        $scope.deleteProject = deleteProject;
        $scope.assignQualityReviewer = assignQualityReviewer;
        $scope.assignFinancialQualityReviewer = assignFinancialQualityReviewer;
        $scope.updateQualityReviewers = updateQualityReviewers;
        $scope.updateQRList = updateQRList;
        $scope.updateContacts = updateContacts;
        $scope.setInitialState = setInitialState;
        $scope.changeProjectOwner = changeProjectOwner;

        $scope.test = function() {
            return JSON.stringify($scope.contacts);
        };

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarationss
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setInitialState() {
            return updateContacts()
                .then(setDefaultQR)
                .then(setDefaultFinancialQR)
                .then(addProjectQRtoList)
                .then(() => updateQRList($scope.project.customer_performs_qc));
        }

        function changeProjectOwner() {
            //After change of project owner, refresh contact list and reset team lead
            $scope.project.contact.url = '';

            $timeout(function() {
                setInitialState();
            }, 0);
        }

        function addProjectQRtoList() {
            if (!$scope.isQualityReviewerAssigned) {
                const isProjectQRinList = $scope.qualityReviewers.results
                    .map(qr => qr.url)
                    .filter(qrUrl => qrUrl === $scope.project.quality_reviewer.url)
                    .reduce(() => true, false);

                if (!isProjectQRinList) {
                    $scope.qualityReviewers.results.push($scope.project.quality_reviewer);
                }
            }
        }

        function setDefaultQR() {
            if ($scope.defaultQR) {
                $scope.project.quality_reviewer = $scope.project.quality_reviewer || $scope.defaultQR;
                $scope.qualityReviewers.results.push($scope.defaultQR);
            }
        }

        function setDefaultFinancialQR() {
            if ($scope.defaultFinancialQR) {
                $scope.project.financial_quality_reviewer =
                    $scope.project.financial_quality_reviewer || $scope.defaultFinancialQR;
                $scope.qualityReviewers.results.push($scope.defaultFinancialQR);
            }
        }

        function updateQRList(clientPerformsQC) {
            $scope.qualityReviewers = siProjects.updateQRList(
                clientPerformsQC,
                $scope.clientDashAdmins,
                $scope.project.customer.url,
                $scope.defaultQR,
                $scope.defaultFinancialQR,
                $scope.employees
            );
            $scope.originalQualityReviewers = Object.assign({}, $scope.qualityReviewers);
            updateQualityReviewers();
        }

        function updateQualityReviewers() {
            $timeout(() => {
                $scope.qualityReviewers = siProjects.updateQualityReviewers(
                    $scope.originalQualityReviewers,
                    $scope.contacts,
                    $scope.project.customer_members.objects,
                    $scope.project.contact.url
                );
            });
        }

        function updateContacts() {
            $scope.contacts = [];
            console.log('DEBUG:');
            console.log($scope.customers);
            console.log('CUSTOMER CONTACT URL PRE: ' + $scope.project.customer.url);
            $scope.project.customer.id = extractIdFromUrl($scope.project.customer.url);
            return siProjects
                .updateProjectContacts($scope.project.customer.id, $scope.project.id)
                .then(contacts => ($scope.contacts = contacts));
        }

        function extractIdFromUrl(url) {
            // URL format "http://127.0.0.1:8000/customers/customers/328/"
            const matches = url.match(/\/(\d+)\/?$/);
            return matches ? matches[1] : null;
        }

        function assignQualityReviewer(qr) {
            if (!qr) {
                return;
            }

            if ($scope.isQualityReviewerAssigned) {
                modalFactory.ConfirmModal({
                    project: $scope.project,
                    message: gettext(
                        `Please be aware that by changing the Quality Reviewer all assessments will be assigned to this person
                         for Quality Control. A previous Quality Reviewer will be unassigned from the assessments. Assessments
                         who were allocated to a different Quality Reviewer previously will not be reallocated.`
                    ),
                    actions: [
                        {
                            label: gettext('OK'),
                            fn: () => saveQualityReviewer(qr)
                        }
                    ]
                });
            } else {
                saveQualityReviewer(qr);
            }
        }

        function saveQualityReviewer(qr) {
            let patch = {
                url: $scope.project.url,
                quality_reviewer: findUserUrl(qr),
                customer_performs_qc: $scope.project.customer_performs_qc
            };

            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.patch(patch).then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
        }

        function assignFinancialQualityReviewer(qr) {
            if (!qr) {
                return;
            }

            if ($scope.isFinancialQualityReviewerAssigned) {
                modalFactory.ConfirmModal({
                    project: $scope.project,
                    message: gettext(
                        `Please be aware that by changing the Financial Quality Reviewer all assessments will be assigned to this person
                         for Quality Control. A previous Financial Quality Reviewer will be unassigned from the assessments. Assessments
                         who were allocated to a different Quality Reviewer previously will not be reallocated.`
                    ),
                    actions: [
                        {
                            label: gettext('OK'),
                            fn: () => saveFinancialQualityReviewer(qr)
                        }
                    ]
                });
            } else {
                saveFinancialQualityReviewer(qr);
            }
        }

        function saveFinancialQualityReviewer(qr) {
            let patch = {
                url: $scope.project.url,
                financial_quality_reviewer: findUserUrl(qr),
                customer_performs_qc: $scope.project.customer_performs_qc
            };

            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.patch(patch).then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
        }

        function findUserUrl(qr) {
            const userUrlRegex = /(\/users\/)/g;

            if (qr.user) {
                return _.isObject(qr.user) ? qr.user.url : qr.user;
            }

            if (!qr.user) {
                return userUrlRegex.test(qr.url) ? qr.url : new Error('No User Url Found');
            }
        }

        /**
         * Function to delete a project
         */
        function deleteProject() {
            modalFactory.ConfirmModal({
                project: $scope.project,
                message: gettext('Are you sure you want to delete this project?'),
                actions: [
                    {
                        label: gettext('Yes, delete project'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            if ($state.current.name === 'base.project-edit') {
                                siProjects.projects
                                    .one($scope.project.id)
                                    .remove()
                                    .then(() => $state.transitionTo('base.projects'))
                                    .catch(err => {
                                        $rootScope.$broadcast(EVENT_LOADER.hide);
                                        toastr.error(err.detail);
                                        console.log('Error Deleting Project - ', err);
                                    });
                            } else if ($state.current.name === 'base.projects-draft-edit') {
                                siProjects.draftProjects
                                    .one($scope.project.id)
                                    .remove()
                                    .then(() => $state.go('base.projects'))
                                    .catch(err => {
                                        $rootScope.$broadcast(EVENT_LOADER.hide);
                                        toastr.error(err.detail);
                                        console.log('Error Deleting Project - ', err);
                                    });
                            }
                        }
                    }
                ]
            });
        }

        function saveProject() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            const patch = {
                name: $scope.project.name,
                deal_number: $scope.project.deal_number,
                customer: $scope.project.customer.url,
                partner: $scope.project.partner,
                donor: $scope.project.donor,
                contact: $scope.project.contact.url,
                customer_members: { objects: $scope.project.customer_members.objects },
                start_date: $scope.project.start_date,
                deadline: $scope.project.deadline,
                customer_performs_qc: $scope.project.customer_performs_qc,
                quality_reviewer: $scope.project.quality_reviewer.user,
                financial_quality_reviewer: $scope.project.financial_quality_reviewer.user,
                is_agri_grade: $scope.project.is_agri_grade
            };
            siProjects.projects
                .one($scope.project.id)
                .patch(patch)
                .then(() => $state.transitionTo('base.projects-detail', { id: $scope.project.id }))
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error Patching the Project - ', err);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('projectDetailWebsiteController', projectDetailWebsiteController);

    projectDetailWebsiteController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        '$uibModal',
        '$q',
        '$log',
        '$stateParams',
        'modalFactory',
        'gettext',
        'apiUrl',
        'siHrm',
        'siScope',
        'siReports',
        'siProjects',
        'siCustomers',
        'siAssessments',
        'siProducts',
        'toastr',
        'EVENT_LOADER'
    ];

    function projectDetailWebsiteController(
        $scope,
        $rootScope,
        $state,
        $filter,
        $uibModal,
        $q,
        $log,
        $stateParams,
        modalFactory,
        gettext,
        apiUrl,
        siHrm,
        siScope,
        siReports,
        siProjects,
        siCustomers,
        siAssessments,
        siProducts,
        toastr,
        EVENT_LOADER
    ) {
        //Fire the loader right away
        $rootScope.$broadcast(EVENT_LOADER.show);

        //Set up out params for the service calls
        var projectParams = {
                fields: [
                    'owner',
                    'owner__user',
                    'contact',
                    'contact__user',
                    'customer',
                    'customer__producing_organization',
                    'payment_terms',
                    'payment_terms__status',
                    'payment_terms__status__name',
                    'members',
                    'members__user',
                    'draft_assessments',
                    'assessments',
                    'assessments__reports'
                ]
            },
            customerParams = {
                fields: ['contacts', 'contacts__user']
            },
            params_ax = {
                project: $stateParams.id,
                page_size: 20,
                search: '',
                page: $state.params.page || 1,
                ordering: '-date'
            },
            userParams = {
                fields: ['user']
            };

        if ($rootScope.app === 'dashboard') {
            var extras = [
                'draft_assessments__producing_organization',
                'draft_assessments__assessor',
                'draft_assessments__assessor__user',
                'draft_assessments__tool_type',
                'draft_assessments__tool'
            ];
            projectParams.fields = projectParams.fields.concat(extras);
        }

        //Set up our data promises
        var projectResourcesPromise =
                $state.current.name === 'base.projects-draft-detail'
                    ? siProjects.draftProjects.one($stateParams.id).get(projectParams)
                    : siProjects.projects.one($stateParams.id).get(projectParams),
            customersResourcePromise = siCustomers.getCustomers(customerParams),
            hrmResourcePromise = siHrm.getEmployees(userParams),
            dropdownsPromise = siProducts.getDropDowns();

        $q.all([projectResourcesPromise, customersResourcePromise, hrmResourcePromise, dropdownsPromise])
            .then(function(promises) {
                $scope.project = promises[0];
                $scope.customers = promises[1];
                $scope.employees = promises[2];
                $scope.project.step = $scope.project.status_indicator + 1;
                $scope.assessments = { results: $scope.project.draft_assessments.objects };
                $scope.assessments.results = $scope.assessments.results.map(function(assessment) {
                    assessment.global_region = promises[3].continentOptions
                        .filter(function(continent) {
                            return continent.url === assessment.global_region;
                        })
                        .reduce(function(meme, continent) {
                            return continent.name;
                        }, 'Not Specified');
                    return assessment;
                });
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                console.log('Project Detail Controller Data load err - ', err);

                if (err.detail === 'Not found') {
                    $state.go('base.projects-detail', { id: $stateParams.id });
                } else {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                }
            });

        $scope.submitProject = submitProject;
        $scope.addAssessment = addAssessment;
        $scope.deleteProject = deleteProject;
        $scope.acceptProject = acceptProject;
        $scope.declineProject = declineProject;
        $scope.editDraftAssessment = editDraftAssessment;
        $scope.createPO = createPO;
        $scope.submitReportFinalization = submitReportFinalization;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function submitProject() {
            if ($scope.project.step < 2) {
                return false;
            }
            $rootScope.$broadcast(EVENT_LOADER.show);

            siProjects.draftProjects
                .one()
                .post($scope.project.id + '/submit_for_approval')
                .then(function(project) {
                    //TODO: extend object
                    $scope.project.submitted_for_approval = project.submitted_for_approval;
                    $scope.project.step = 3;
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    console.log('Submitted Err - ', err);
                });
        }

        function addAssessment() {
            $state.go('base.add-assessment', { id: $scope.project.id });
        }

        function deleteProject() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siProjects.draftProjects
                .one($scope.project.id)
                .remove()
                .then(function() {
                    $state.go('base.projects');
                })
                .catch(function(err) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error(err.detail);
                    console.log('Error Deleting Project - ', err);
                });
        }

        function declineProject() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            $uibModal
                .open({
                    templateUrl: 'modals/declineReasonView.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.decline = '';
                            $scope.save = function(decline) {
                                $uibModalInstance.close(decline);
                            };
                            $scope.cancel = function() {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                $uibModalInstance.dismiss('cancel');
                            };
                        }
                    ]
                })
                .result.then(function(decline) {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    var post = {
                        declined_reason: decline
                    };

                    siProjects.draftProjects
                        .one($scope.project.id)
                        .one('decline')
                        .customPOST(post)
                        .then(function() {
                            $state.go('base.projects-draft');
                        })
                        .catch(function(err) {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            console.log('Error Declining - ', err);
                        });
                });
        }

        function acceptProject(isNotReady) {
            if (isNotReady) {
                return;
            }

            $rootScope.$broadcast(EVENT_LOADER.show);

            siProjects.draftProjects
                .one($scope.project.id)
                .post('accept')
                .then(function(res) {
                    _.extend($scope.project, res);
                    $state.go('base.projects-draft');
                })
                .catch(function(err) {
                    console.log('Error Accepting - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        /**
         * Edit assessment information
         * @object assessment
         */
        function editDraftAssessment(assessment) {
            $scope.assessmentErrorMessage = false;

            $uibModal
                .open({
                    templateUrl: 'modals/editDraftAssessmentView.html',
                    controller: 'editDraftAssessmentController',
                    resolve: {
                        project: function() {
                            return $scope.project;
                        },
                        assessment: function() {
                            return assessment;
                        },
                        createPO: function() {
                            return createPO;
                        }
                    }
                })
                .result.then(function(assessment) {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    var patch = {
                        producing_organization: assessment.producing_organization.url,
                        producing_organization_name: assessment.producing_organization.name,
                        tool: assessment.tool.url
                    };

                    siAssessments.draftAssessment
                        .one(assessment.id)
                        .patch(patch)
                        .then(function(assessment) {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            siProjects.draftProjects
                                .one($scope.project.id)
                                .get()
                                .then(function(project) {
                                    $scope.project.is_valid = project.is_valid;
                                });
                        })
                        .catch(function(err) {
                            console.log(err);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        });
                });
        }

        /**
         * Add new PO
         * @object assessment
         */
        function createPO(assessment) {
            $scope.assessmentErrorMessage = false;

            $uibModal
                .open({
                    templateUrl: 'modals/createPOView.html',
                    controller: 'createPOController',
                    resolve: {
                        project: function() {
                            return $scope.project;
                        },
                        assessment: function() {
                            return assessment;
                        }
                    }
                })
                .result.then(function(po) {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    if (po.existingPO) {
                        var patch = {
                            producing_organization: po.existingPO.url,
                            producing_organization_name: po.existingPO.name
                        };

                        siAssessments.draftAssessment
                            .one(assessment.id)
                            .patch(patch)
                            .then(function(assessment) {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                siProjects.draftProjects
                                    .one($scope.project.id)
                                    .get(projectParams)
                                    .then(function(project) {
                                        _.extend($scope.project, project);
                                    });
                            })
                            .catch(function(err) {
                                console.log(err);
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                            });
                    } else {
                        //CReate then a new customer and then the PO
                        var createdCustomer,
                            customer = {
                                name: assessment.producing_organization_name,
                                first_name: assessment.producing_organization_contact_first_name,
                                last_name: assessment.producing_organization_contact_last_name,
                                email: assessment.producing_organization_contact_email,
                                phone_number: assessment.producing_organization_contact_phone_number
                            };
                        var customer_url = {
                            url: apiUrl + '/customers/customers/'
                        };
                        var PO_url = {
                            url: apiUrl + '/customers/producing_organizations/'
                        };
                        siScope
                            .post(customer_url, customer)
                            .then(function(newCustomer) {
                                createdCustomer = newCustomer;
                                var params = { customer: newCustomer.url };
                                return siScope.post(PO_url, params);
                            })
                            .then(function(newPO) {
                                var patch = {
                                    producing_organization: newPO.url,
                                    producing_organization_name: newPO.name
                                };
                                po.assessment.producing_organization = newPO;
                                return siAssessments.draftAssessment.one(assessment.id).patch(patch);
                            })
                            .then(function(assessment) {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                return siProjects.draftProjects.one($scope.project.id).get(projectParams);
                            })
                            .then(function(project) {
                                _.extend($scope.project, project);
                            })
                            .catch(function(err) {
                                console.log(err);
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                            });
                    }
                });
        }

        function submitReportFinalization(report) {
            siReports.reports
                .one('report')
                .one(reports.objects[0].id)
                .one('request_finalization')
                .post()
                .catch(function(err) {
                    console.log('Error in report finalization submit - ', err);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('projectDetailDashboardController', projectDetailDashboardController)
        //Ordering of nested object MUST be min to max for setting up the proper values!
        .constant('PROJECT_DETAIL_FILTERS', [
            { Assessor: { assessor_name: null }, optionsKey: 'assessors' },
            {
                'Financial Specialist': { financial_specialist: null },
                optionsKey: 'financial_specialists'
            },
            {
                'Quality Reviewer': { quality_reviewer: null },
                optionsKey: 'quality_reviewers'
            },
            {
                'Financial Quality Reviewer': {
                    financial_quality_reviewer: null
                },
                optionsKey: 'financial_quality_reviewers'
            },
            { 'Assessment Date Range': { min_date: null, max_date: null } },
            { Tools: { tool_type: null }, optionsKey: 'tool_types' },
            { Status: { status: null }, optionsKey: 'statuses' },
            { Language: { language: null }, optionsKey: 'languages' }
        ]);

    projectDetailDashboardController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        '$uibModal',
        '$q',
        '$location',
        'apiUrl',
        '$stateParams',
        'modalFactory',
        'siCustomers',
        'siAssessments',
        'siProducts',
        'siProjects',
        'siScope',
        'siHrm',
        'gettext',
        '$log',
        'toastr',
        'siFilters',
        'me',
        '$localStorage',
        '$http',
        'siProjectDetailDashboard',
        'PROJECT_DETAIL_FILTERS',
        'EVENT_LOADER',
        '$timeout',
        'fsFactory'
    ];

    function projectDetailDashboardController(
        $scope,
        $rootScope,
        $state,
        $filter,
        $uibModal,
        $q,
        $location,
        apiUrl,
        $stateParams,
        modalFactory,
        siCustomers,
        siAssessments,
        siProducts,
        siProjects,
        siScope,
        siHrm,
        gettext,
        $log,
        toastr,
        siFilters,
        me,
        $localStorage,
        $http,
        siProjectDetailDashboard,
        PROJECT_DETAIL_FILTERS,
        EVENT_LOADER,
        $timeout,
        fsFactory
    ) {
        //Fire the loader right away
        $rootScope.$broadcast(EVENT_LOADER.show);

        $scope.sharedWithLimit = 3;

        //Set up out params for the service calls
        let projectParams = {
                id: $stateParams.id,
                fields: [
                    'owner',
                    'owner__user',
                    'contact',
                    'contact__user',
                    'customer',
                    'customer__producing_organization',
                    'customer_members',
                    'customer_members__user',
                    'members',
                    'members__user',
                    'quality_reviewer',
                    'financial_quality_reviewer',
                    'shared_with',
                    'objectives',
                    'partner',
                    'donor'
                ]
            },
            customerParams = {
                fields: ['contacts', 'contacts__user']
            },
            params_ax = {
                project: $stateParams.id,
                page_size: 25,
                search: '',
                page: $state.params.page || 1,
                ordering: '-date',
                fields: [
                    'producing_organization',
                    'tool__type',
                    'assessmentassignments__assessor',
                    'display_quality_reviewer',
                    'display_financial_quality_reviewer',
                    'quality_reviewer',
                    'financial_quality_reviewer',
                    'assessmentassignments',
                    'reports'
                ]
            },
            userParams = {
                page_size: 999,
                is_active: true
            };

        $scope.queryParamsSet = !_.isEmpty($location.search());
        _.extend(params_ax, $location.search());
        //Set up our data promises
        let projectResourcesPromise = siProjects.projects.one($stateParams.id).get(projectParams),
            customersResourcePromise = siCustomers.getCustomers(customerParams),
            assessmentsResourcePromise = siAssessments.getAssessmentsWithParams(params_ax),
            hrmResourcePromise = siHrm.getEmployees(userParams),
            dropdownsPromise = siProducts.getDropDowns(),
            toolsPromise = siProducts.getTools({ page_size: 9999, visible: 1 }),
            allAssessmentsPromise = siAssessments.getAssessmentsWithParams({
                project: $stateParams.id,
                page_size: 999
            }),
            qualityReviewersPromise = siHrm.getUsers({
                page_size: 9999,
                roles: 'is_customer_admin'
            }),
            defaultQRPromise = siHrm
                .getDefaultQR({ fields: ['default_quality_reviewer__user'] })
                .then(settings => (settings.default_quality_reviewer || {}).user),
            defaultFinancialQRPromise = siHrm
                .getDefaultFinancialQR({
                    fields: ['default_financial_quality_reviewer__user']
                })
                .then(settings => (settings.default_financial_quality_reviewer || {}).user),
            projectObjectivesPromise = siProjects.getProjectObjectives();

        $q.all([
            projectResourcesPromise,
            customersResourcePromise,
            assessmentsResourcePromise,
            hrmResourcePromise,
            dropdownsPromise,
            toolsPromise,
            allAssessmentsPromise,
            qualityReviewersPromise,
            defaultQRPromise,
            defaultFinancialQRPromise,
            projectObjectivesPromise
        ])
            .then(promises => {
                $scope.project = promises[0];
                $scope.customers = promises[1];
                $scope.assessments = setHasUnassigned(promises[2]);
                // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                //     $scope.assessments,
                //     $scope.project.quality_reviewer
                // );
                // $scope.assessments = siProjectDetailDashboard.setFinancialQualityReviewer(
                //     $scope.assessments,
                //     $scope.project.financial_quality_reviewer
                // );
                $scope.project = siProjectDetailDashboard.setProjectQualityReviewer(
                    $scope.project,
                    $scope.default_quality_reviewer
                );
                $scope.project = siProjectDetailDashboard.setProjectFinancialQualityReviewer(
                    $scope.project,
                    $scope.default_financial_quality_reviewer
                );
                $scope.assignments = setUpAssignments($scope.assessments);

                $scope.employees = promises[3].results.sort((a, b) => {
                    if (a.last_name < b.last_name) return -1;
                    if (a.last_name > b.last_name) return 1;
                    return 0;
                });
                $scope.dropdowns = promises[4];
                $scope.tools = promises[5].results.sort((a, b) => {
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                });
                $scope.usedTools = [...new Set(promises[6].results.map(ax => ax.tool_type))];
                $scope.qualityReviewers = promises[7];
                $scope.financialSpecialists = promises[7];
                console.log('QUALITY REVIEWERS');
                console.log($scope.qualityReviewers);
                $scope.default_quality_reviewer = promises[8];
                $scope.default_financial_quality_reviewer = promises[9];
                $scope.projectObjectives = promises[10].results;
                console.log('Project - ', $scope.project);
                $scope.projectObjectives.forEach(objective => {
                    objective.isSelected = $scope.project.objectives.objects.some(x => x.id === objective.id);
                });

                $scope.isLoaded = true;
                $rootScope.$broadcast(EVENT_LOADER.hide);
                console.log('Assessments - ', $scope.assessments);
                console.log('Dropdowns - ', $scope.dropdowns);
                console.log('Assignments -', $scope.assignments);
                console.log('Objectives- ', $scope.projectObjectives);
            })
            .catch(err => {
                toastr.error('Project Detail Controller Data load err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        $scope.assessmentErrorMessage = false;
        $scope.otherChecked = false;
        $scope.filters = siFilters.createFilters(PROJECT_DETAIL_FILTERS, $location.search());
        $scope.editAssessment = editAssessment;
        $scope.shareProject = shareProject;
        $scope.unshareProject = unshareProject;
        $scope.addAssessment = addAssessment;
        $scope.deleteProject = deleteProject;
        $scope.deleteAssessmentFromProject = deleteAssessmentFromProject;
        $scope.search = search;
        $scope.removeFilter = removeFilter;
        $scope.openStep2Modal = openStep2Modal;
        $scope.openUnassignModal = openUnassignModal;
        $scope.barchartWidth = status => siProjectDetailDashboard.getBarChartWidth($scope.assessments, status);
        $scope.increaseSharedWithLimit = () => ($scope.sharedWithLimit += 99);
        $scope.gotoAssessment = gotoAssessment;
        $scope.getAssignmentHref = getAssignmentHref;
        $scope.exportToExcel = exportToExcel;
        $scope.export_to_json = export_to_json;
        $scope.download_all_reports = download_all_reports;
        $scope.exportProjectOverview = exportProjectOverview;
        $scope.shouldShowSearch = shouldShowSearch;
        $scope.downloadReports = downloadReports;
        $scope.hasReports = hasReports;
        $scope.selectAllReportsForDownload = selectAllReportsForDownload;
        $scope.numberOfSelectedAssigments = numberOfSelectedAssigments;
        $scope.unassignedAssessmentSelected = unassignedAssessmentSelected;
        $scope.assignedAssessmentSelected = assignedAssessmentSelected;
        $scope.addInWhitelist = addInWhitelist;
        $scope.updateProjectObjectives = updateProjectObjectives;
        $scope.updateOtherObjective = updateOtherObjective;
        $scope.setAiAvailability = setAiAvailability;
        $scope.assignAllSelectedAssessments = assignAllSelectedAssessments;
        $scope.unassignAllSelectedAssessments = unassignAllSelectedAssessments;
        $scope.numberOfDeletableSelectedAssessments = numberOfDeletableSelectedAssessments;
        $scope.changeQualityReviewerForSelectedAssessments = changeQualityReviewerForSelectedAssessments;
        $scope.changeQualityReviewerForAssessment = changeQualityReviewerForAssessment;
        $scope.isDashboardUserAdminOrEmployee = isDashboardUserAdminOrEmployee;
        $scope.deleteSelectedAssessmentsFromProject = deleteSelectedAssessmentsFromProject;
        $scope.numberOfDeletableSelectedAssessments = numberOfDeletableSelectedAssessments;
        $scope.toggleIsAgriGrade = toggleIsAgriGrade;
        $scope.goToAssessmentDashboard = goToAssessmentDashboard;
        $scope.canViewQcDashboard = canViewQcDashboard;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setUpAssignments(assessments) {
            return assessments.results
                .map(assessment => {
                    if (assessment.assignments.length) {
                        return assessment.assignments
                            .sort((a, b) => {
                                if (a.assigned_as < b.assigned_as) return -1;
                                if (a.assigned_as > b.assigned_as) return 1;
                                return 0;
                            })
                            .map((assignment, index) => {
                                assignment.assessment = assessment;
                                if (assessment.assignments.length > 1 && index === 1) {
                                    assignment.isLast = true;
                                }
                                return assignment;
                            });
                    } else {
                        return {
                            assessment,
                            assigned_as: 'assessor',
                            display_status: assessment.status
                        };
                    }
                })
                .reduce((memo, array) => memo.concat(array), []);
        }

        function shouldShowSearch(results) {
            return (
                results ||
                [
                    'search',
                    'ordering',
                    'assessor_name',
                    'min_date',
                    'max_date',
                    'tool_type',
                    'status',
                    'language',
                    'financial_specialist',
                    'quality_reviewer',
                    'financial_quality_reviewer'
                ]
                    .filter(term => $stateParams[term])
                    .reduce((memo, term) => term, false)
            );
        }

        function exportToExcel() {
            if ($scope.usedTools.length > 1) {
                $uibModal
                    .open({
                        templateUrl: 'projects/templates/modals/exportToExcel.html',
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'tools',
                            function($scope, $uibModalInstance, tools) {
                                $scope.tools = tools.filter(x => x !== 'SCOPE Rapid');
                                $scope.cancel = () => $uibModalInstance.dismiss();
                                $scope.save = () => $uibModalInstance.close($scope.chosenProduct);
                            }
                        ],
                        resolve: {
                            tools: () => $scope.usedTools
                        }
                    })
                    .result.then(tool_type => {
                        $rootScope.$broadcast(EVENT_LOADER.show);
                        siProjectDetailDashboard
                            .exportExcel($scope.project.url, tool_type)
                            .then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                    });
            } else if ($scope.usedTools.length === 1) {
                $rootScope.$broadcast(EVENT_LOADER.show);
                siProjectDetailDashboard
                    .exportExcel($scope.project.url, $scope.usedTools[0])
                    .then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
            } else {
                modalFactory.ConfirmModal({
                    message: gettext('Project has no assessments, please create assessments before trying to export.'),
                    actions: [{ label: gettext('OK') }]
                });
            }
        }

        function export_to_json() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siProjectDetailDashboard
                .export_to_json($scope.project.url)
                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                .catch(error => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error while exporting JSON');
                });
        }

        function download_all_reports() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siProjectDetailDashboard
                .download_all_reports($scope.project.url, $scope.project.name)
                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                .catch(error => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error while downloading all reports in zip.');
                });
        }

        function exportProjectOverview() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siProjectDetailDashboard
                .exportProjectOverview($scope.project.url)
                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                .catch(error => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error while exporting Project Overview');
                });
        }

        /**
         * Redirects the user to the appropriate view based on the status of the given assessment assignment.
         *
         * This function evaluates the status of the assessment assignment and performs navigation or opens a modal accordingly.
         *
         * @param {Object} assignment - The assessment assignment object containing information about the assessment.
         * @returns {void} - Navigates to the corresponding view using $state.go or opens a modal.
         */
        function handleAssessmentRedirect(assignment) {
            switch (assignment.status) {
                case 'in_progress':
                    if (assignment.assessment.tool_type.toLowerCase().includes('rapid')) {
                        // If the assessment is in progress and the tool type is "Rapid",
                        // navigate to the assessment assignment detail view.
                        const { id } = assignment;
                        return $state.go('base.assessments-assignment-detail.assessment', { id });
                    } else {
                        // If the assessment is in progress and the tool type is not "Rapid",
                        // open an information modal.
                        return $uibModal.open(infoModal(assignment.assessment));
                    }
                case 'qc_assessor':
                case 'qc_quality_review':
                    // If the assessment is in QC (Quality Control) status, navigate to the assessment assignment detail view.
                    const { id } = assignment;
                    return $state.go('base.assessments-assignment-detail.assessment', { id });
                case 'has_draft':
                case 'has_final':
                    // if (assignment.assessment.tool_type === 'SCOPE Rapid') {
                    //     // If the assessment has a draft or final status and the tool type is "SCOPE Rapid",
                    //     // navigate to the SCOPE Rapid summary view.
                    //     const { id } = assignment.assessment;
                    //     return $state.go('base.assessments-rapid-final.summary', { id });
                    // }
                    if (assignment.assessment.reports.objects.length) {
                        // If the assessment has a draft or final status and there are reports associated,
                        // navigate to the reports detail summary view.
                        const { id } = assignment.assessment.reports.objects[0];
                        return $state.go('base.reports-detail.summary', { id });
                    }
            }
        }

        function getAssignmentHref(assignment) {
            // Only SI users (employee, employee lite, QC reviewer) may open the assignment page.
            // Non-SI dashboard users must land on the report page (Draft/Final only), so that
            // opening a row in a new tab / middle-click cannot bypass the routing in gotoAssessment().
            if (me.isEmployee() || me.isEmployeeLite() || me.isQcOnly()) {
                return $state.href('base.assessments-assignment-detail.assessment', { id: assignment.id });
            }
            const reports =
                assignment.assessment && assignment.assessment.reports && assignment.assessment.reports.objects;
            if (reports && reports.length) {
                return $state.href('base.reports-detail.summary', { id: reports[0].id });
            }
            // Non-SI user with no report yet — nothing they are allowed to open.
            return '';
        }

        function gotoAssessment(assignment) {
            if (me.isDashboardUserAdmin() || me.isEmployee()) {
                handleAssessmentRedirect(assignment);
            }
        }

        function isDashboardUserAdminOrEmployee() {
            if (me.isDashboardUserAdmin() || me.isEmployee()) {
                return true;
            }
            return false;
        }

        function infoModal(assessment) {
            //tiny workaround
            assessment.project = $scope.project;
            return {
                templateUrl: 'assessments/modals/assessmentDetailModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    function($scope, $uibModalInstance, assessment) {
                        $scope.assessment = assessment;
                        $scope.cancel = () => $uibModalInstance.dismiss('close');
                    }
                ],
                resolve: {
                    assessment: function() {
                        return assessment;
                    }
                }
            };
        }

        function search(searchParams, displayFilter) {
            if (displayFilter) {
                displayFilter.removeKeys.forEach(removeKey => delete params_ax[removeKey]);

                $scope.filters = siFilters.createFilters(
                    PROJECT_DETAIL_FILTERS,
                    _.extend($location.search(), searchParams)
                );

                if ($location.path().match(/\//g).length === 4) {
                    let lastSlashIndex = $location.path().lastIndexOf('/');
                    let newPath = $location.path().slice(0, lastSlashIndex + 1);
                    $location.path(newPath);
                }

                return $location.search(_.extend($location.search(), searchParams));
            }

            _.extend(params_ax, searchParams);

            $rootScope.$broadcast(EVENT_LOADER.show);

            siAssessments.getAssessmentsWithParams(params_ax).then(res => {
                $scope.assessments = res;
                console.log('Assessments - ', res);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function removeFilter(removeFilter) {
            let searchParams = siFilters.removeKeys($location.search(), removeFilter.removeKeys);
            $location.search(searchParams);
        }

        /**
         * Edit assessment information
         * @object assessment
         */

        function addAssessment(assessment) {
            $scope.assessmentErrorMessage = false;

            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/addAssessmentView(1).html',
                    controller: 'addAssessmentController',
                    size: 'lg',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        tools: () => $scope.tools,
                        countries: () => $scope.dropdowns.countryOptions
                    }
                })
                .result.then(result => {
                    const { ax, tool_type_id } = result;

                    $rootScope.$broadcast(EVENT_LOADER.show);

                    if (!ax.id) {
                        createNewAssessment(ax, tool_type_id);
                    } else {
                        updateAssessment(ax, assessment, true);
                    }
                });
        }

        function editAssessment(assessment) {
            $scope.assessmentErrorMessage = false;

            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/editAssessmentView.html',
                    controller: 'editAssessmentController',
                    controllerAs: '$ctrl',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        employees: () => $scope.employees,
                        qualityReviewers: () => $scope.qualityReviewers,
                        financialSpecialists: () => $scope.financialSpecialists
                    }
                })
                .result.then(({ url, language, date, quality_reviewer, financial_quality_reviewer }) => {
                    $rootScope.$broadcast(EVENT_LOADER.show);
                    let update = {
                        url,
                        language,
                        date,
                        quality_reviewer,
                        financial_quality_reviewer
                    };
                    updateAssessment(update, assessment, false);
                });
        }

        function shareProject() {
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/shareProject.html',
                    controller: 'shareProjectController',
                    controllerAs: '$ctrl',
                    resolve: {
                        project: () => $scope.project
                    }
                })
                .result.then(email => {
                    modalFactory.ConfirmModal({
                        project: $scope.project,
                        message: gettext(
                            'Are you sure you want to share your project, including assessment details, data and reports?'
                        ),
                        actions: [
                            {
                                label: gettext('OK'),
                                fn: () => {
                                    $rootScope.$broadcast(EVENT_LOADER.show);
                                    siProjects
                                        .shareProject($scope.project.id, {
                                            email: email
                                        })
                                        .then(res => {
                                            $scope.project.shared_with.objects.push({
                                                id: res.customer_id,
                                                name: res.customer_name
                                            });
                                            $rootScope.$broadcast(EVENT_LOADER.hide);
                                        });
                                }
                            }
                        ]
                    });
                });
        }

        function unshareProject(customer) {
            modalFactory.ConfirmModal({
                project: $scope.project,
                message: gettext('Are you sure you want to unshare your project?'),
                actions: [
                    {
                        label: gettext('OK'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            siProjects
                                .unshareProject($scope.project.id, {
                                    customer_id: customer
                                })
                                .then(() => {
                                    $scope.project.shared_with.objects = $scope.project.shared_with.objects.filter(
                                        shared => shared.id !== customer
                                    );
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                });
                        }
                    }
                ]
            });
        }

        function refetchAssessments() {
            return siAssessments
                .getAssessmentsWithParams(params_ax)
                .then(assessments => setHasUnassigned(assessments))
                .then(assessments => {
                    $scope.assessments = assessments;
                    return setUpAssignments(assessments);
                })
                .then(assignments => ($scope.assignments = assignments));
        }

        function updateAssessment(ax, assessment, showNextModal) {
            return siScope
                .patch(ax, null, {
                    params: {
                        fields: ['producing_organization', 'assessmentassignments__assessor']
                    }
                })

                .then(updatedAssessment => {
                    $scope.assessments.results = $scope.assessments.results.map(assessment => {
                        if (assessment.id === updatedAssessment.id) {
                            _.extend(assessment, updatedAssessment);
                        }
                        return assessment;
                    });

                    $scope.assessments = setHasUnassigned($scope.assessments);
                    $scope.assignments = setUpAssignments($scope.assessments);
                    return assessment;
                })
                .then(assessment => {
                    if (showNextModal) {
                        openStep2Modal(assessment);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    } else {
                        refetchAssessments().then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                    }
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error(err.detail);
                });
        }

        function updateMultipleAssessment(ax, assessment, showNextModal) {
            return siScope
                .patch(ax, null, {
                    params: {
                        fields: ['producing_organization', 'assessmentassignments__assessor']
                    }
                })

                .then(updatedAssessment => {
                    $scope.assessments.results = $scope.assessments.results.map(assessment => {
                        if (assessment.id === updatedAssessment.id) {
                            _.extend(assessment, updatedAssessment);
                        }
                        return assessment;
                    });

                    $scope.assessments = setHasUnassigned($scope.assessments);
                    $scope.assignments = setUpAssignments($scope.assessments);
                    return assessment;
                })
                .then(assessment => {
                    if (showNextModal) {
                        openStep2Modal(assessment);
                        //$rootScope.$broadcast(EVENT_LOADER.hide);
                    } else {
                        //refetchAssessments().then();
                    }
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error(err.detail);
                });
        }

        function createNewAssessment(assessment, tool_type_id) {
            assessment.project = $scope.project.url;

            return siScope
                .create(assessment, assessment.url, {
                    params: {
                        fields: ['producing_organization', 'tool', 'tool__type']
                    }
                })
                .then(assessment => {
                    assessment.assignments = [];
                    $scope.assessments.results.push(assessment);
                    $scope.assessments = setHasUnassigned($scope.assessments);
                    // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                    //     $scope.assessments,
                    //     $scope.project.quality_reviewer
                    // );
                    // Manually update the counts to update progress bar.
                    $scope.assessments.count++;
                    $scope.assessments.status_counts.created = $scope.assessments.status_counts.created
                        ? $scope.assessments.status_counts.created + 1
                        : 1;

                    $scope.assignments = setUpAssignments($scope.assessments);
                    lowerLimit(tool_type_id);
                    return assessment;
                })
                .then(assessment => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    openStep2Modal(assessment);
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error(err.detail);
                });
        }

        function lowerLimit(tool_type_id) {
            var matchingLimit = $scope.project.customer.tool_limits_data.find(function(limit) {
                return limit.tool_type_id === tool_type_id;
            });
            if (matchingLimit && matchingLimit.available > 0) {
                matchingLimit.available -= 1; // Decrease the available count
            } else if (matchingLimit && matchingLimit.available <= 0) {
                console.warn('Available limit is already 0 for tool_type_id:', tool_type_id);
            }
        }

        function assignAllSelectedAssessments() {
            let assessment = $scope.assignments.filter(assignment => assignment.reportSelected)[0].assessment;
            const isProAssessmentSelected = $scope.assignments.some(
                assignment =>
                    assignment.reportSelected &&
                    assignment.assessment.tool.type.requires_accountant &&
                    assignment.assessment.hasUnassigned
            );

            console.log(assessment);
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/assignAllAssessors.html',
                    controller: 'addAllAssessorsController',
                    size: 'lg',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        tools: () => $scope.tools,
                        countries: () => $scope.dropdowns.countryOptions,
                        isProAssessmentSelected: () => isProAssessmentSelected
                    }
                })
                .result.then(function(assessment) {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    let promises = [];

                    $scope.assignments
                        .filter(assignment => assignment.reportSelected)
                        .forEach(assignment => {
                            if (assignment.assessment.hasUnassigned) {
                                let assessorPromise = assessment.chosenAssessors.map(assessor => {
                                    //We can select 2 or more assessments where one has unassigned financial specialist...in that case
                                    //we need to check if they have assessors assigned before assigning them selected assessor.
                                    if (assignment.assessment.assignments.length === 0) {
                                        let invite = {
                                            assessment: assignment.assessment.url,
                                            assessor: assessor.url,
                                            assigned_as: 'assessor',
                                            url: apiUrl + '/assessments/assessment_invitations/'
                                        };
                                        return siScope.post(invite);
                                    }
                                });
                                promises.push(...assessorPromise); // Flatten array into `promises`

                                if (assignment.assessment.tool.type.requires_accountant) {
                                    let specialistPromise = assessment.chosenSpecialists.map(assessor => {
                                        //We can not select assessment without assessor so we don't need to check existance of financial specialist.
                                        let invite = {
                                            assessment: assignment.assessment.url,
                                            assessor: assessor.url,
                                            assigned_as: 'financial_specialist',
                                            url: apiUrl + '/assessments/assessment_invitations/'
                                        };
                                        return siScope.post(invite);
                                    });
                                    promises.push(...specialistPromise);
                                }
                            }
                        });

                    $q.all(promises).then(() => {
                        $timeout(() => {
                            siAssessments
                                .getAssessmentsWithParams(params_ax)
                                .then(assessments => {
                                    $scope.assessments = assessments;
                                    $scope.assessments = setHasUnassigned($scope.assessments);
                                    // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                                    //     $scope.assessments,
                                    //     $scope.project.quality_reviewer
                                    // );
                                    $scope.assignments = setUpAssignments($scope.assessments);
                                })
                                .then(() => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    if (assessment.anotherAssessment) {
                                        addAssessment();
                                    }
                                });
                        }, 1000);
                    });
                });
        }

        function unassignAllSelectedAssessments() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/unAssignAllAssessors.html',
                    controller: 'unassignAllAssessorsController',
                    resolve: {
                        assessments: [
                            '$q',
                            function($q) {
                                // Explicit annotation
                                let assessmentPromises = [];
                                let assessmentParams = {
                                    fields: [
                                        'assessmentinvitations',
                                        'assessmentinvitations__assessor__user',
                                        'tool__type'
                                    ]
                                };

                                $scope.assignments
                                    .filter(assignment => assignment.reportSelected && !assignment.hasUnassigned)
                                    .forEach(assignment => {
                                        let retrievedAssessment = siScope.getItem(assignment.assessment.url, {
                                            params: assessmentParams
                                        });
                                        assessmentPromises.push(retrievedAssessment);
                                    });

                                // Return a promise that resolves when all assessments are fetched
                                return $q.all(assessmentPromises);
                            }
                        ]
                    }
                })
                .result.then(unassignedAssessors => {
                    let assessorPromises = unassignedAssessors.map(url => siScope.remove(url));

                    $rootScope.$broadcast(EVENT_LOADER.show);

                    $q.all(assessorPromises)
                        .then(() => siAssessments.getAssessmentsWithParams(params_ax))
                        .then(assessments => {
                            $scope.assessments = assessments;
                            $scope.assessments = setHasUnassigned($scope.assessments);
                            // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                            //     $scope.assessments,
                            //     $scope.project.quality_reviewer
                            // );
                            $scope.assignments = setUpAssignments($scope.assessments);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        })
                        .catch(error => {
                            toastr.error(error);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        });
                });
        }

        function openStep2Modal(assessment) {
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/addAssessorView(2).html',
                    controller: 'addAssessorController',
                    size: 'lg',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        tools: () => $scope.tools,
                        countries: () => $scope.dropdowns.countryOptions
                    }
                })
                .result.then(function(assessment) {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    let assessorPromise = assessment.chosenAssessors.map(assessor => {
                        let invite = {
                            assessment: assessment.url,
                            assessor: assessor.url,
                            assigned_as: 'assessor',
                            url: apiUrl + '/assessments/assessment_invitations/'
                        };

                        return siScope.post(invite);
                    });

                    let specialistPromise = assessment.chosenSpecialists.map(assessor => {
                        let invite = {
                            assessment: assessment.url,
                            assessor: assessor.url,
                            assigned_as: 'financial_specialist',
                            url: apiUrl + '/assessments/assessment_invitations/'
                        };

                        return siScope.post(invite);
                    });

                    $q.all(assessorPromise.concat(specialistPromise)).then(() => {
                        $timeout(() => {
                            siAssessments
                                .getAssessmentsWithParams(params_ax)
                                .then(assessments => {
                                    $scope.assessments = assessments;
                                    $scope.assessments = setHasUnassigned($scope.assessments);
                                    // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                                    //     $scope.assessments,
                                    //     $scope.project.quality_reviewer
                                    // );
                                    $scope.assignments = setUpAssignments($scope.assessments);
                                })
                                .then(() => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    if (assessment.anotherAssessment) {
                                        addAssessment();
                                    }
                                });
                        }, 1000);
                    });
                });
        }

        function openUnassignModal(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/unAssignAssessor.html',
                    controller: 'UnassignAssessorController',
                    resolve: {
                        assessment: () => {
                            let assessmentParams = {
                                fields: ['assessmentinvitations', 'assessmentinvitations__assessor__user', 'tool__type']
                            };

                            return siScope.getItem(assessment.url, {
                                params: assessmentParams
                            });
                        }
                    }
                })
                .result.then(unassignedAssessors => {
                    let assessorPromises = unassignedAssessors.map(url => siScope.remove(url));

                    $rootScope.$broadcast(EVENT_LOADER.show);

                    $q.all(assessorPromises)
                        .then(() => siAssessments.getAssessmentsWithParams(params_ax))
                        .then(assessments => {
                            $scope.assessments = assessments;
                            $scope.assessments = setHasUnassigned($scope.assessments);
                            // $scope.assessments = siProjectDetailDashboard.setQualityReviewer(
                            //     $scope.assessments,
                            //     $scope.project.quality_reviewer
                            // );
                            $scope.assignments = setUpAssignments($scope.assessments);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        })
                        .catch(error => {
                            toastr.error(error);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        });
                });
        }

        /**
         * Function to delete a project
         */
        function deleteProject() {
            modalFactory.ConfirmModal({
                project: $scope.project,
                message: gettext('Are you sure you want to delete this project?'),
                actions: [
                    {
                        label: gettext('Yes, delete project'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            siScope
                                .remove($scope.project.url)
                                .then(() => fsFactory.clearFS())
                                .then(() => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    $state.transitionTo('base.projects');
                                })
                                .catch(err => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    toastr.error(err.detail);
                                    console.log('Error Deleting Project - ', err);
                                });
                        }
                    }
                ]
            });
        }

        function updateProjectObjectives(objective) {
            // Check if the objective is already in the array
            const index = $scope.project.objectives.objects.findIndex(obj => obj.name === objective.name);

            if (index === -1) {
                // Objective is not in the array, add it
                $scope.project.objectives.objects.push(objective);
            } else {
                // Objective is already in the array, remove it
                $scope.project.objectives.objects.splice(index, 1);
            }

            const urls = $scope.project.objectives.objects.map(x => x.url);
            const patch = {
                objectives: urls
            };
            siProjects.projects.one($scope.project.id).patch(patch);
        }

        function updateOtherObjective() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            const patch = {
                objective_other: $scope.project.objective_other
            };
            siProjects.projects
                .one($scope.project.id)
                .patch(patch)
                .then(res => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }
        /**
         * Function to delete an assessment from project
         */
        function deleteAssessmentFromProject(assessment) {
            modalFactory.ConfirmModal({
                assessment: assessment,
                message: gettext('Are you sure you want to delete this assessment? (This might take a while)'),
                actions: [
                    {
                        label: gettext('Yes, delete assessment'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            siScope
                                .remove(assessment.url)
                                .then(() => fsFactory.clearFS())
                                .then(() => $state.reload())
                                .catch(() => {
                                    toastr.error('Error while deleting assessment');
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                });
                        }
                    }
                ]
            });
        }

        function setHasUnassigned(assessments) {
            // Add a boolean to each assessment to determine if we should show the assign action button
            assessments.results = assessments.results.map(assessment => {
                let isAssessorChosen = assessment.assignments.find(
                    assignment => assignment.assigned_as !== 'financial_specialist'
                );

                let isSpecialistChosen = assessment.assignments.find(
                    assignment => assignment.assigned_as === 'financial_specialist'
                );

                assessment.hasUnassigned =
                    !isAssessorChosen || (assessment.tool.type.requires_accountant && !isSpecialistChosen);

                return assessment;
            });

            return assessments;
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function downloadReports() {
            // Show a loader while the reports are being downloaded
            $rootScope.$broadcast(EVENT_LOADER.show);

            // Get unique assignments based on 'assessment.id' and filter those that have 'reportSelected' set to true
            const assignments = _.uniq($scope.assignments, 'assessment.id').filter(
                assignment => assignment.reportSelected
            );

            const all_promises = [];

            // Create an array of promises for downloading reports
            assignments.flatMap(assignment => {
                // Check if the tool name is 'SCOPE Rapid', if so, show a warning and skip downloading
                if (me.isEmployee() == false && assignment.assessment.tool_name === 'SCOPE Rapid') {
                    toastr.warning('Downloading Rapid Report is not possible.');
                    return []; // Return an empty array to skip this assignment
                }

                const reports = assignment.assessment.reports.objects;

                // Find the final report or fallback to the first draft report
                const finalReport = reports.find(report => report.status === 'final');
                const selectedReport = finalReport || reports.find(report => report.status === 'draft');
                if (!selectedReport) {
                    // If no report is found, skip this assignment
                    return [];
                }

                // Create a download promise for the selected report
                const downloadPromise = $http({
                    url: `${selectedReport.url}pdf/`, // URL to download the PDF report
                    method: 'GET',
                    responseType: 'arraybuffer' // Ensure the response is treated as a binary data buffer
                }).then(data => {
                    let url = `${selectedReport.url}pdf/`;
                    console.log(url);
                    // Create a Blob from the downloaded data
                    const blob = new Blob([data.data], { type: 'application/pdf' });
                    // Save the Blob as a file with a formatted name
                    saveAs(
                        blob,
                        `${assignment.assessment.producing_organization_name}.${
                            assignment.assessment.date
                        }.${capitalizeFirstLetter(selectedReport.tool_type)}_Report_${capitalizeFirstLetter(
                            selectedReport.status
                        )}.pdf`
                    );
                });

                all_promises.push(downloadPromise);

                // If the selected report is 'SCOPE Pro' or 'SCOPE Pro SME', download the profile PDF as well
                const profileDownloadPromise =
                    selectedReport.tool_type === 'SCOPE Pro' || selectedReport.tool_type === 'SCOPE Pro SME'
                        ? $http({
                              url: `${selectedReport.url}profile_pdf/`, // URL to download the profile PDF
                              method: 'GET',
                              responseType: 'arraybuffer' // Ensure the response is treated as a binary data buffer
                          }).then(data => {
                              // Create a Blob from the downloaded data
                              let url = `${selectedReport.url}profile_pdf/`;
                              console.log(url);
                              const blob = new Blob([data.data], { type: 'application/pdf' });
                              // Save the Blob as a file with a formatted name
                              saveAs(
                                  blob,
                                  `${assignment.assessment.producing_organization_name}.${
                                      assignment.assessment.date
                                  }.${capitalizeFirstLetter(selectedReport.tool_type)}_Profile_${capitalizeFirstLetter(
                                      selectedReport.status
                                  )}.pdf`
                              );
                          })
                        : null;
                if (profileDownloadPromise) all_promises.push(profileDownloadPromise);
            });

            // Execute all promises and handle the loader when done
            Promise.all(all_promises)
                .then(() => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(error => {
                    console.error('Error downloading reports:', error);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function hasReports(assignment) {
            return assignment && assignment.assessment && _.isArray(assignment.assessment.reports)
                ? assignment.assessment.reports.length
                : assignment.assessment.reports.objects.length;
        }

        function selectAllReportsForDownload(isSelected) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $scope.assignments
                // .filter(assignment => hasReports(assignment))
                .map(assignment => {
                    assignment.reportSelected = !isSelected;
                });
            $rootScope.$broadcast(EVENT_LOADER.hide);
        }

        function numberOfSelectedAssigments() {
            let numberOfSelectedAssigments = $scope.assignments.filter(
                assignment => assignment.reportSelected && assignment.assigned_as === 'assessor'
            ).length;
            return numberOfSelectedAssigments;
        }

        //Number of assessments with at least one part unassigned (regular or financial (for pro assessment))
        function unassignedAssessmentSelected() {
            let numberOfSelectedUnassignedAssigments = $scope.assignments.filter(
                assignment => assignment.reportSelected && assignment.assessment.hasUnassigned
            ).length;
            return numberOfSelectedUnassignedAssigments;
        }

        function assignedAssessmentSelected() {
            let numberOfSelectedAssignedAssigments = $scope.assignments.filter(
                assignment => assignment.reportSelected && !assignment.assessment.hasUnassigned
            ).length;
            return numberOfSelectedAssignedAssigments;
        }

        function numberOfDeletableSelectedAssessments() {
            let numberOfDeletableSelectedAssessments = $scope.assignments.filter(
                assignment => assignment.reportSelected && assignment.assessment.assignments.length === 0
            ).length;
            return numberOfDeletableSelectedAssessments;
        }

        function addInWhitelist() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const patch = {
                is_project_in_whitelist: $scope.project.is_project_in_whitelist
            };
            siProjects.projects
                .one($scope.project.id)
                .patch(patch)
                .then(() => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function setAiAvailability() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const patch = {
                available_for_ta: $scope.project.available_for_ta
            };
            siProjects.projects
                .one($scope.project.id)
                .patch(patch)
                .then(() => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function toggleIsAgriGrade() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const patch = {
                is_agri_grade: $scope.project.is_agri_grade
            };
            siProjects.projects
                .one($scope.project.id)
                .patch(patch)
                .then(() => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function changeQualityReviewerForSelectedAssessments() {
            if ($scope.assignments.filter(assignment => assignment.reportSelected).length === 1) {
                return changeQualityReviewerForAssessment(
                    $scope.assignments.filter(assignment => assignment.reportSelected)[0].assessment
                );
            }
            const assessment = $scope.assignments.some(
                assignment => assignment.reportSelected && assignment.assessment.tool.type.requires_accountant
            )
                ? $scope.assignments.filter(
                      assignment => assignment.reportSelected && assignment.assessment.tool.type.requires_accountant
                  )[0].assessment
                : $scope.assignments.filter(assignment => assignment.reportSelected)[0].assessment;
            //Modal accepts one assessment, if we have financial selected send that one so we can choose financial reviewer, if we don't have financial selected send the first selected
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/changeQualityReviewer.html',
                    controller: 'changeQualityReviewerController',
                    controllerAs: '$ctrl',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        employees: () => $scope.employees,
                        qualityReviewers: () => $scope.qualityReviewers,
                        financialSpecialists: () => $scope.financialSpecialists,
                        changeMultipleQualityReviewers: () => true
                    }
                })
                .result.then(({ url, language, date, quality_reviewer, financial_quality_reviewer }) => {
                    $rootScope.$broadcast(EVENT_LOADER.show);

                    // Create an array of promises
                    let updatePromises = $scope.assignments
                        .filter(x => x.reportSelected)
                        .map(assignment => {
                            let url = assignment.assessment.url;
                            if (financial_quality_reviewer) {
                                let update = {
                                    url,
                                    quality_reviewer,
                                    financial_quality_reviewer
                                };
                                return updateMultipleAssessment(update, assignment.assessment, false); // Return the promise
                            } else {
                                let update = {
                                    url,
                                    quality_reviewer
                                };
                                return updateMultipleAssessment(update, assignment.assessment, false); // Return the promise
                            }
                        });

                    // Wait for all promises to resolve before hiding the loader
                    Promise.all(updatePromises)
                        .then(() => refetchAssessments())
                        .then(() => {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        })
                        .catch(err => {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            toastr.error(err.detail);
                        });
                });
        }

        function deleteSelectedAssessmentsFromProject() {
            modalFactory.ConfirmModal({
                message: gettext(
                    'Are you sure you want to delete selected assessments? (This will delete only unassigned selected assessments!)'
                ),
                actions: [
                    {
                        label: gettext('Yes, delete unassigned assessments'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            // Collect only the delete promises (without internal .catch)
                            let updatePromises = $scope.assignments
                                .filter(assignment => assignment.reportSelected && assignment.assessment.hasUnassigned)
                                .map(assignment => siScope.remove(assignment.assessment.url));

                            // Wait for all deletions to complete
                            Promise.all(updatePromises)
                                .then(() => refetchAssessments())
                                .then(() => fsFactory.clearFS())
                                .then(() => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                })
                                .catch(err => {
                                    // Catch any errors from Promise.all() and show toastr error
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    toastr.error('Error while deleting assessment: ' + (err.detail || err.message));
                                });
                        }
                    }
                ]
            });
        }

        function changeQualityReviewerForAssessment(assessment) {
            $uibModal
                .open({
                    templateUrl: 'projects/templates/modals/changeQualityReviewer.html',
                    controller: 'changeQualityReviewerController',
                    controllerAs: '$ctrl',
                    resolve: {
                        project: () => $scope.project,
                        assessment: () => assessment,
                        employees: () => $scope.employees,
                        qualityReviewers: () => $scope.qualityReviewers,
                        financialSpecialists: () => $scope.financialSpecialists,
                        changeMultipleQualityReviewers: () => false
                    }
                })
                .result.then(({ url, language, date, quality_reviewer, financial_quality_reviewer }) => {
                    $rootScope.$broadcast(EVENT_LOADER.show);
                    let update = {
                        url,
                        quality_reviewer,
                        financial_quality_reviewer
                    };
                    updateAssessment(update, assessment, false);
                });
        }

        function canViewQcDashboard(assignment) {
            // Check if user is dashboard admin
            if (me.isEmployee()) {
                return true;
            }

            // Check if user is the assessor
            var currentUserId = $localStorage.user.info.id;
            var isAssessor =
                assignment.assessment.display_quality_reviewer &&
                assignment.assessment.display_quality_reviewer.id === currentUserId;

            return isAssessor;
        }

        function goToAssessmentDashboard(assignment) {
            console.log('Going to QC Dashboard, assignment:', assignment);
            const assessmentId = assignment.assessment.id;
            console.log('Assessment ID:', assessmentId);

            $state.go('base.qc-dashboard', { id: assessmentId }).then(
                function(success) {
                    console.log('Navigation successful');
                },
                function(error) {
                    console.error('Navigation failed:', error);
                }
            );
        }

        function numberOfDeletableSelectedAssessments() {
            let numberOfDeletableSelectedAssessments = $scope.assignments.filter(
                assignment => assignment.reportSelected && assignment.assessment.assignments.length === 0
            ).length;
            return numberOfDeletableSelectedAssessments;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('ProjectCreateWebsiteController', ProjectCreateWebsiteController);

    ProjectCreateWebsiteController.$inject = [
        '$scope',
        '$rootScope',
        '$q',
        '$log',
        '$state',
        '$timeout',
        'siHrm',
        'siCustomers',
        'siProjects',
        'EVENT_LOADER'
    ];

    function ProjectCreateWebsiteController(
        $scope,
        $rootScope,
        $q,
        $log,
        $state,
        $timeout,
        siHrm,
        siCustomers,
        siProjects,
        EVENT_LOADER
    ) {
        var customerParams = {
                fields: ['contacts', 'contacts__user'],
                page_size: 999,
                producing_organization: false
            },
            userParams = {
                fields: ['user'],
                page_size: 999
            };

        var customersResourcePromise = siCustomers.getCustomers(customerParams),
            hrmResourcePromise = siHrm.getEmployees(userParams);

        $scope.project = {};
        $scope.saveProject = saveProject;
        $scope.updateContacts = updateContacts;

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([customersResourcePromise, hrmResourcePromise])
            .then(function(promises) {
                $scope.customers = promises[0];
                $scope.employees = promises[1];
                $scope.contacts = { results: [] };
                //Lets check if there is only one in the list as we hide it then in the UI so we need to manually set
                //the project.customer and his contacts.
                if ($scope.customers.results.length === 1) {
                    $scope.project.customer = $scope.customers.results[0].url;
                    updateContacts();
                }
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                console.log('Project Create Controller Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function saveProject() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            var project = angular.copy($scope.project);
            project.customer =
                $scope.customers.results.length === 1 ? $scope.customers.results[0].url : $scope.project.customer;
            project.customer_members = $scope.project.customer_members.map(function(member) {
                return member.url;
            });

            siProjects.draftProjects
                .post(angular.toJson(project))
                .then(function(project) {
                    $state.transitionTo('base.projects-add-assessment', { id: project.id });
                })
                .catch(function(err) {
                    console.log(err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function updateContacts() {
            $timeout(function() {
                $scope.contacts.results = $scope.customers.results
                    .filter(function(customer) {
                        return customer.url === $scope.project.customer;
                    })
                    .map(function(customer) {
                        return customer.contacts.objects;
                    })
                    .reduce(function(memo, contacts) {
                        return contacts;
                    }, []);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').controller('projectCreateController', projectCreateController);

    projectCreateController.$inject = [
        '$rootScope',
        '$q',
        '$log',
        '$state',
        '$filter',
        '$uibModal',
        '$timeout',
        'apiUrl',
        'siHrm',
        'siScope',
        'siCustomers',
        'usernameFilter',
        'siProjects',
        'me',
        'EVENT_LOADER',
        'toastr'
    ];

    function projectCreateController(
        $rootScope,
        $q,
        $log,
        $state,
        $filter,
        $uibModal,
        $timeout,
        apiUrl,
        siHrm,
        siScope,
        siCustomers,
        usernameFilter,
        siProjects,
        me,
        EVENT_LOADER,
        toastr
    ) {
        const vm = this;

        const customerParams = {
                page_size: 999,
                fields: ['users', 'users__customer_contact'],
                producing_organization: false
            },
            userParams = {
                is_active: true,
                page_size: 999,
                fields: ['user']
            };

        const customersResourcePromise = siCustomers.getCustomers(customerParams),
            hrmResourcePromise = siHrm.getEmployees(userParams),
            defaultQRPromise = siHrm
                .getDefaultQR({ fields: ['default_quality_reviewer__user'] })
                .then(settings => (settings.default_quality_reviewer || {}).user),
            defaultFinancialQRPromise = siHrm
                .getDefaultFinancialQR({ fields: ['default_financial_quality_reviewer__user'] })
                .then(settings => (settings.default_financial_quality_reviewer || {}).user),
            projectObjectivesPromise = siProjects.getProjectObjectives(),
            clientQrPromise = siHrm.getUsers({
                page_size: 9999,
                roles: 'is_customer_admin'
            });

        vm.project = {};
        vm.projectForm = {};
        vm.isPageLoaded = false;
        vm.saveNewProject = saveNewProject;
        vm.updateContacts = updateContacts;
        vm.updateQualityReviewers = updateQualityReviewers;
        vm.updateQRList = updateQRList;
        vm.updateProjectObjectives = updateProjectObjectives;
        vm.setDate = (date, key) => (vm.project[key] = date);
        vm.isDashboardUserAdmin = me.isDashboardUserAdmin();
        vm.isEmployee = me.isEmployee();

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([
            customersResourcePromise,
            hrmResourcePromise,
            defaultQRPromise,
            defaultFinancialQRPromise,
            clientQrPromise,
            projectObjectivesPromise
        ])
            .then(promises => {
                [
                    vm.customers,
                    vm.employees,
                    vm.defaultQR,
                    vm.defaultFinancialQR,
                    vm.clientDashAdmins,
                    vm.projectObjectives
                ] = promises;
                vm.employees = vm.employees.results
                    .filter(employee => employee.is_active)
                    .map(employee => employee.user)
                    .sort((a, b) => {
                        if (a.last_name < b.last_name) return -1;
                        if (a.last_name > b.last_name) return 1;
                        return 0;
                    });

                vm.qualityReviewers = { results: vm.employees };

                vm.projectObjectives = vm.projectObjectives.results;

                if (vm.defaultQR) {
                    vm.project.quality_reviewer = vm.defaultQR;
                    vm.qualityReviewers.results.push(vm.defaultQR);
                }
                if (vm.defaultFinancialQR) {
                    vm.project.financial_quality_reviewer = vm.defaultFinancialQR;
                    vm.qualityReviewers.results.push(vm.defaultFinancialQR);
                }
                vm.originalQualityReviewers = Object.assign({}, vm.qualityReviewers);

                vm.contacts = { results: [] };
                //Lets check if there is only one in the list as we hide it then in the UI so we need to manually set
                //the project.customer and his contacts.
                if (vm.customers.results.length === 1) {
                    vm.project.customer = vm.customers.results[0];
                    updateContacts();
                }
                vm.project = Object.assign(vm.project, {
                    customer_members: []
                });
                $rootScope.$broadcast(EVENT_LOADER.hide);
                vm.isPageLoaded = true;
                console.log(vm);
            })
            .catch(err => {
                toastr.error('Project Create Controller Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function updateQRList(clientPerformsQC) {
            vm.qualityReviewers = siProjects.updateQRList(
                clientPerformsQC,
                vm.clientDashAdmins,
                vm.project.customer,
                vm.defaultQR,
                vm.defaultFinancialQR,
                vm.employees
            );
            vm.originalQualityReviewers = Object.assign({}, vm.qualityReviewers);
            updateQualityReviewers();
        }

        function updateQualityReviewers() {
            $timeout(() => {
                vm.qualityReviewers = siProjects.updateQualityReviewers(
                    vm.originalQualityReviewers,
                    vm.contacts,
                    vm.project.customer_members,
                    vm.project.contact
                );
            });
        }

        function updateContacts() {
            vm.contacts = [];
            siProjects.updateProjectContacts(vm.project.customer.id).then(contacts => (vm.contacts = contacts));
        }

        function updatePartner() {
            vm.contacts = [];
            siProjects.updateProjectContacts(vm.project.customer.id).then(contacts => (vm.contacts = contacts));
        }

        function updateProjectObjectives(objective) {
            if (!vm.project.objectives) {
                vm.project.objectives = [];
            }
            // Check if the objective is already in the array
            const index = vm.project.objectives.findIndex(obj => obj.name === objective.name);

            if (index === -1) {
                // Objective is not in the array, add it
                vm.project.objectives.push(objective);
            } else {
                // Objective is already in the array, remove it
                vm.project.objectives.splice(index, 1);
            }
        }

        function saveNewProject() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siProjects
                .saveNewProject(vm.project)
                .then(project => $state.transitionTo('base.projects-detail', { id: project.id }))
                .catch(() => {
                    toastr.error('Error while creating a new project');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Detailed Score Analysis (AD-2197: AD-2198 QLA 1, AD-2199 QLA 2, AD-2200 QLA 3).
     *
     * One assessment tool and major version across the selected projects:
     * dimensions, subdimensions and questions (hierarchy explorer and
     * drill-down drawer), insights and priorities, segment comparisons, the FO
     * heatmap and progress between baseline and latest assessments.
     *
     * Every figure arrives computed. Lists the templates repeat over are built
     * here once per change - never as fresh arrays in a watch expression, which
     * never settles (#289).
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsScoreAnalysisController', projectAnalyticsScoreAnalysisController);

    projectAnalyticsScoreAnalysisController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        'gettext',
        'gettextCatalog',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siScoreAnalysis',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsScoreAnalysisController(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $timeout,
        $window,
        $document,
        gettext,
        gettextCatalog,
        toastr,
        siProjects,
        siProjectAnalytics,
        siScoreAnalysis,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;
        const api = siScoreAnalysis;
        const tr = text => gettextCatalog.getString(text);

        $scope.charts = siAnalyticsCharts;
        $scope.api = api;
        $scope.views = api.VIEWS;
        $scope.ui = { darkMode: false, rightbarClosed: false, view: api.view($stateParams.view).id };
        $scope.rail = { selection: true, filters: true, population: true, help: false };
        $scope.isLoading = false;
        $scope.loadFailed = false;

        $scope.applied = api.loadSelection(projectId);
        $scope.staged = angular.copy($scope.applied);
        $scope.options = { projects: [], projectSearch: '', tools: [], versions: [] };
        $scope.errors = [];
        $scope.payloads = {};
        $scope.nodes = {};

        $scope.explorer = {
            mode: 'grouped',
            search: '',
            sort: 'hier',
            show: 'all',
            insight: 'weakest_questions',
            expanded: {},
            rows: [],
            ranked: [],
            matched: 0
        };
        $scope.drawer = { open: false, node: null, payload: null, only: '', page: 0, loading: false };
        $scope.heat = { level: 'subdimension', parent: null, order: 'low', page: 0, pageSize: 25, fos: [], search: '' };
        $scope.segment = { by: 'country', level: 'dimension', fos: [] };
        // Co-occurring weaknesses are sorted and paged on the server (AD-2198).
        $scope.prio = { pairs: 'cross', focus: null, sort: 'fo_count', limit: '10', page: 0 };
        $scope.pairLimits = [
            { value: '10', label: gettext('Top 10') },
            { value: '25', label: gettext('Top 25') },
            { value: '50', label: gettext('Top 50') },
            { value: 'all', label: gettext('All') }
        ];
        $scope.pairSorts = [
            { value: 'fo_count', label: gettext('Most FOs affected') },
            { value: 'pct', label: gettext('Highest co-occurrence percentage') },
            { value: 'lift', label: gettext('Highest Lift') },
            { value: 'phi', label: gettext('Strongest positive Phi') }
        ];
        $scope.profile = { open: false, payload: null };

        $scope.sortOptions = [
            { value: 'hier', label: gettext('Hierarchy order') },
            { value: 'low', label: gettext('Lowest average') },
            { value: 'high', label: gettext('Highest average') },
            { value: 'medianlow', label: gettext('Lowest median') },
            { value: 'weak', label: gettext('Highest weak %') },
            { value: 'strong', label: gettext('Highest strong %') },
            { value: 'nr', label: gettext('Highest Not Relevant %') },
            { value: 'missing', label: gettext('Highest missing %') }
        ];
        $scope.showOptions = [
            { value: 'all', label: gettext('All questions') },
            { value: 'weak', label: gettext('Weak average (below 2.5)') },
            { value: 'strong', label: gettext('Strong average (3 or above)') },
            { value: 'widespread', label: gettext('At least 50% weak FOs') },
            { value: 'nr', label: gettext('High Not Relevant (10%+)') }
        ];
        $scope.insightModes = [
            { value: 'weakest_questions', label: gettext('Weakest') },
            { value: 'strongest_questions', label: gettext('Strongest') },
            { value: 'most_widespread_gaps', label: gettext('Most widespread gaps') },
            { value: 'most_not_relevant', label: gettext('Most Not Relevant') },
            { value: 'most_variable', label: gettext('Highest variability') }
        ];
        $scope.drawerFilters = [
            { value: '', label: gettext('All FOs') },
            { value: 'weak', label: gettext('Weak (below 2.5)') },
            { value: 'strong', label: gettext('Strong (3 or above)') },
            { value: 'not_relevant', label: gettext('Not Relevant') },
            { value: 'missing', label: gettext('Missing') }
        ];
        $scope.changeBuckets = {
            declined_more: gettext('Declined more than 0.5'),
            declined: gettext('Declined up to 0.5'),
            stable: gettext('Unchanged (within ±0.05)'),
            improved: gettext('Improved up to 0.5'),
            improved_more: gettext('Improved more than 0.5')
        };

        // Selection
        $scope.toggleRailBox = key => ($scope.rail[key] = !$scope.rail[key]);
        $scope.visibleProjects = visibleProjects;
        $scope.toggleProject = id => toggleIn($scope.staged.projects, id);
        $scope.isProjectSelected = id => $scope.staged.projects.indexOf(id) > -1;
        $scope.selectAllProjects = all => ($scope.staged.projects = all ? $scope.options.projects.map(p => p.id) : []);
        $scope.toggleValue = (name, value) => toggleIn($scope.staged[name] || ($scope.staged[name] = []), value);
        $scope.isValueSelected = (name, value) => ($scope.staged[name] || []).indexOf(value) > -1;
        $scope.versionsFor = versionsFor;
        $scope.chooseTool = chooseTool;
        $scope.apply = apply;
        $scope.reset = reset;
        $scope.selectView = selectView;

        // Explorer
        $scope.node = id => $scope.nodes[id];
        $scope.toggleNode = toggleNode;
        $scope.expandAll = () => setAllExpanded(true);
        $scope.collapseAll = () => setAllExpanded(false);
        $scope.refreshExplorer = refreshExplorer;
        $scope.openNode = openNode;
        $scope.closeDrawer = () => ($scope.drawer.open = false);
        $scope.loadDrawer = loadDrawer;
        $scope.bandOf = bandOf;
        $scope.bandLabel = bandLabel;
        $scope.maturityLabel = maturityLabel;
        $scope.bandPct = bandPct;
        $scope.bandRange = bandRange;
        $scope.bandCount = (node, key) => (node.stats.bands.filter(b => b.key === key)[0] || { count: 0 }).count;
        $scope.dumbbell = d => {
            const b = api.scale(d.baseline_mean);
            const l = api.scale(d.latest_mean);
            return { left: Math.min(b, l) + '%', width: Math.abs(l - b) + '%' };
        };

        // Other views
        $scope.loadHeatmap = loadHeatmap;
        $scope.toggleHeatFo = id => {
            toggleIn($scope.heat.fos, id);
            $scope.heat.page = 0;
            loadHeatmap();
        };
        $scope.clearHeatFos = () => {
            $scope.heat.fos = [];
            $scope.heat.page = 0;
            loadHeatmap();
        };
        $scope.heatFoOptions = heatFoOptions;
        $scope.loadSegments = loadSegments;
        $scope.toggleSegmentFo = id => toggleIn($scope.segment.fos, id);
        $scope.loadPriorities = loadPriorities;
        $scope.reloadPairs = () => {
            $scope.prio.page = 0;
            loadPriorities();
        };
        $scope.movePairPage = step => {
            const paging = $scope.payloads.priorities.co_occurring_paging;
            $scope.prio.page = Math.min(paging.pages - 1, Math.max(0, paging.page + step));
            loadPriorities();
        };
        $scope.focusPair = pair => ($scope.prio.focus = $scope.prio.focus === pair ? null : pair);
        $scope.openFo = openFo;
        $scope.closeFo = () => ($scope.profile.open = false);
        $scope.assessmentHref = id => $state.href('base.assessments-assignment-detail.assessment', { id: id });
        $scope.exportCsv = exportCsv;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;

        initTheme();
        loadProjectName();
        siProjectAnalytics.ensureRolloutFlags();
        loadProjects();
        loadOptions().finally(load);

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);
        const themeOff = $rootScope.$on('pad-theme-changed', () => $timeout(renderCharts, 250));
        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Selection
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function toggleIn(list, value) {
            const at = list.indexOf(value);
            if (at > -1) {
                list.splice(at, 1);
            } else {
                list.push(value);
            }
        }

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name', 'customer'] })
                .then(project => ($scope.project = project))
                .catch(angular.noop);
        }

        function loadProjects() {
            api.getProjects()
                .then(projects => {
                    $scope.options.projects = projects;
                    const allowed = projects.map(p => p.id);
                    const keep = $scope.applied.projects.filter(id => allowed.indexOf(id) > -1);
                    if (keep.length !== $scope.applied.projects.length) {
                        $scope.applied.projects = keep.length ? keep : [Number(projectId)];
                        $scope.staged.projects = $scope.applied.projects.slice();
                        api.saveSelection(projectId, $scope.applied);
                        loadOptions().finally(reload);
                    }
                })
                .catch(angular.noop);
        }

        function loadOptions() {
            return api
                .getFilterOptions($scope.applied)
                .then(options => {
                    $scope.options.tools = options.tools;
                    $scope.options.countries = options.countries;
                    $scope.options.valueChains = options.value_chains;
                    $scope.options.maturityLevels = options.maturity_levels.filter(l => l.value !== 'all');
                    const names = options.tools.map(t => t.tool_type);
                    if ($scope.applied.tool && names.indexOf($scope.applied.tool) < 0) {
                        $scope.applied.tool = null;
                        $scope.staged.tool = null;
                    }
                })
                .catch(angular.noop);
        }

        function versionsFor(toolType) {
            const tool = ($scope.options.tools || []).filter(t => t.tool_type === toolType)[0];
            return tool ? tool.versions : [];
        }

        /** Choosing a tool applies at once: nothing can be shown without one. */
        function chooseTool() {
            $scope.staged.version = null;
            apply();
        }

        function visibleProjects() {
            const term = ($scope.options.projectSearch || '').toLowerCase();
            return $scope.options.projects.filter(
                p => !term || (p.name + ' ' + (p.customer || '')).toLowerCase().indexOf(term) > -1
            );
        }

        function apply() {
            $scope.errors = api.validate($scope.staged);
            if ($scope.errors.length) {
                return;
            }
            const projectsChanged = !angular.equals($scope.staged.projects, $scope.applied.projects);
            $scope.applied = angular.copy($scope.staged);
            api.saveSelection(projectId, $scope.applied);
            if (projectsChanged) {
                loadOptions().finally(reload);
            } else {
                reload();
            }
        }

        function reset() {
            const tool = $scope.staged.tool;
            $scope.staged = api.defaultSelection(projectId);
            $scope.staged.tool = tool;
            $scope.errors = [];
            apply();
        }

        function reload() {
            $scope.payloads = {};
            $scope.drawer.open = false;
            $scope.profile.open = false;
            $scope.heat.page = 0;
            load();
        }

        function selectView(id) {
            $scope.ui.view = id;
            $state.go('.', { view: id }, { notify: false });
            load();
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function describeError(error) {
            if (error && typeof error === 'object') {
                const messages = Object.keys(error)
                    .map(key => [].concat(error[key]).join(' '))
                    .filter(Boolean);
                if (messages.length) {
                    return messages.join(' ');
                }
            }
            return tr(gettext('Detailed score analysis could not be loaded.'));
        }

        function fetch(resource, extra) {
            const loader = siAnalyticsLoader.begin($scope);
            $scope.isLoading = true;
            $scope.loadFailed = false;
            return api
                .get(resource, $scope.applied, extra)
                .then(payload => {
                    loader.received();
                    $timeout(loader.finish, 300);
                    return payload;
                })
                .catch(error => {
                    loader.fail();
                    $scope.loadFailed = true;
                    toastr.error(describeError(error));
                    throw error;
                })
                .finally(() => ($scope.isLoading = false));
        }

        /** The overview always loads first: KPIs, the hierarchy and the node index. */
        function load() {
            if (!$scope.applied.tool) {
                return;
            }
            const next = () => loadView($scope.ui.view);
            if ($scope.payloads.overview) {
                return next();
            }
            fetch('overview')
                .then(payload => {
                    $scope.payloads.overview = payload;
                    $scope.context = payload.context;
                    indexNodes(payload.nodes);
                    $scope.staged.version = payload.context.version;
                    $scope.applied.version = payload.context.version;
                    refreshExplorer();
                    next();
                })
                .catch(angular.noop);
        }

        function loadView(id) {
            if (id === 'explorer') {
                $timeout(renderCharts, 100);
            } else if (id === 'priorities' && !$scope.payloads.priorities) {
                loadPriorities();
            } else if (id === 'segments' && !$scope.payloads.segments) {
                loadSegments();
            } else if (id === 'heatmap' && !$scope.payloads.heatmap) {
                loadHeatmap();
            } else if (id === 'progress' && !$scope.payloads.progress) {
                fetch('progress')
                    .then(payload => ($scope.payloads.progress = payload))
                    .catch(angular.noop);
            } else {
                $timeout(renderCharts, 100);
            }
        }

        function loadPriorities() {
            const prio = $scope.prio;
            fetch('priorities', {
                pairs: prio.pairs === 'all' ? 'all' : 'cross',
                pair_sort: prio.sort,
                pair_limit: prio.limit,
                pair_page: prio.page
            })
                .then(payload => {
                    $scope.payloads.priorities = payload;
                    $scope.prio.focus = null;
                    $scope.prio.page = payload.co_occurring_paging.page;
                })
                .catch(angular.noop);
        }

        function loadSegments() {
            const extra = { by: $scope.segment.by, level: $scope.segment.level };
            if ($scope.segment.by === 'group') {
                extra.fo = $scope.segment.fos.slice();
            }
            fetch('segments', extra)
                .then(payload => {
                    $scope.payloads.segments = payload;
                    $timeout(renderCharts, 150);
                })
                .catch(angular.noop);
        }

        function loadHeatmap() {
            const h = $scope.heat;
            const extra = { level: h.level, order: h.order, page: h.page, page_size: h.pageSize };
            if (h.level === 'question' && h.parent) {
                extra.parent = h.parent;
            }
            if (h.fos.length) {
                extra.fo = h.fos.slice();
            }
            if (h.sortNode) {
                extra.sort_node = h.sortNode;
            }
            fetch('heatmap', extra)
                .then(payload => {
                    $scope.payloads.heatmap = payload;
                    h.page = payload.page;
                    h.parent = payload.parent || h.parent;
                })
                .catch(angular.noop);
        }

        function heatFoOptions() {
            const payload = $scope.payloads.overview;
            if (!payload) {
                return [];
            }
            const term = ($scope.heat.search || '').toLowerCase();
            if (!term) {
                return payload.fo_options;
            }
            if ($scope.heat._term !== term || $scope.heat._from !== payload) {
                $scope.heat._term = term;
                $scope.heat._from = payload;
                $scope.heat._options = payload.fo_options.filter(
                    fo => (fo.fo_name || '').toLowerCase().indexOf(term) > -1
                );
            }
            return $scope.heat._options;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Hierarchy explorer
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function indexNodes(nodes) {
            const index = {};
            nodes.forEach(node => (index[node.id] = node));
            nodes.forEach(node => {
                node.depth = node.level === 'dimension' ? 0 : node.level === 'subdimension' ? 1 : 2;
                if (node.level === 'question' && index[node.parent] && index[node.parent].level === 'dimension') {
                    node.depth = 1;
                }
            });
            $scope.nodes = index;
            $scope.dimensions = nodes.filter(n => n.level === 'dimension');
            $scope.subdimensions = nodes.filter(n => n.level === 'subdimension');
            $scope.questions = nodes.filter(n => n.level === 'question');
            $scope.subParents = nodes.filter(n => n.level === 'subdimension' && n.children.length);
            $scope.explorer.expanded = {};
            $scope.dimensions.forEach(d => ($scope.explorer.expanded[d.id] = true));
            if (!$scope.heat.parent && $scope.subParents.length) {
                $scope.heat.parent = $scope.subParents[0].id;
            }
        }

        function sortValue(node) {
            const s = node.stats;
            return {
                low: s.mean,
                high: s.mean === null ? null : -s.mean,
                medianlow: s.median,
                weak: s.weak_pct === null ? null : -s.weak_pct,
                strong: s.strong_pct === null ? null : -s.strong_pct,
                nr: s.not_relevant_pct === null ? null : -s.not_relevant_pct,
                missing: s.missing_pct === null ? null : -s.missing_pct
            }[$scope.explorer.sort];
        }

        function sorted(list) {
            if ($scope.explorer.sort === 'hier') {
                return list;
            }
            return list.slice().sort((a, b) => {
                const x = sortValue(a);
                const y = sortValue(b);
                if (x === null && y === null) return 0;
                if (x === null) return 1;
                if (y === null) return -1;
                return x - y;
            });
        }

        function questionMatches(q) {
            const e = $scope.explorer;
            const term = (e.search || '').trim().toLowerCase();
            const parent = $scope.nodes[q.parent];
            const dim = $scope.nodes[q.dimension];
            const text = [q.id, q.title, parent && parent.title, dim && dim.title].join(' ').toLowerCase();
            if (term && text.indexOf(term) < 0) {
                return false;
            }
            const s = q.stats;
            switch (e.show) {
                case 'weak':
                    return s.mean !== null && s.mean < 2.5;
                case 'strong':
                    return s.mean !== null && s.mean >= 3;
                case 'widespread':
                    return s.weak_pct !== null && s.weak_pct >= 50;
                case 'nr':
                    return s.not_relevant_pct !== null && s.not_relevant_pct >= 10;
                default:
                    return true;
            }
        }

        function filtering() {
            return !!($scope.explorer.search || '').trim() || $scope.explorer.show !== 'all';
        }

        /** Rebuilds the rows the question explorer repeats over. */
        function refreshExplorer() {
            const e = $scope.explorer;
            if (!$scope.dimensions) {
                return;
            }
            const matching = $scope.questions.filter(questionMatches);
            e.matched = matching.length;
            e.filtering = filtering();
            e.ranked = sorted(matching);
            const keep = {};
            matching.forEach(q => {
                keep[q.id] = true;
                keep[q.parent] = true;
                keep[q.dimension] = true;
            });
            const rows = [];
            const visit = node => {
                if (e.filtering && !keep[node.id]) {
                    return;
                }
                rows.push(node);
                const open = e.filtering || e.expanded[node.id];
                if (!open) {
                    return;
                }
                sorted(node.children.map(id => $scope.nodes[id])).forEach(child => {
                    if (child.level === 'question' && !questionMatches(child)) {
                        return;
                    }
                    visit(child);
                });
            };
            sorted($scope.dimensions).forEach(visit);
            e.rows = rows;
            const insights = $scope.payloads.overview ? $scope.payloads.overview.insights : {};
            e.insightRows = (insights[e.insight] || []).map(id => $scope.nodes[id]);
        }

        function toggleNode(node, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.explorer.expanded[node.id] = !$scope.explorer.expanded[node.id];
            refreshExplorer();
        }

        function setAllExpanded(open) {
            $scope.dimensions.concat($scope.subdimensions).forEach(n => ($scope.explorer.expanded[n.id] = open));
            refreshExplorer();
        }

        function openNode(id) {
            const node = $scope.nodes[id];
            if (!node) {
                return;
            }
            $scope.drawer.open = true;
            $scope.drawer.node = node;
            $scope.drawer.only = '';
            $scope.drawer.page = 0;
            $scope.drawer.children = sortedByMean(node.children.map(c => $scope.nodes[c]));
            if (node.level !== 'dimension') {
                $scope.heat.parent = node.level === 'subdimension' ? node.id : node.parent;
            }
            loadDrawer();
        }

        function sortedByMean(list) {
            return list.slice().sort((a, b) => {
                if (a.stats.mean === null) return 1;
                if (b.stats.mean === null) return -1;
                return a.stats.mean - b.stats.mean;
            });
        }

        function loadDrawer() {
            const d = $scope.drawer;
            d.loading = true;
            const extra = { node: d.node.id, page: d.page, page_size: 15 };
            if (d.only) {
                extra.only = d.only;
            }
            api.get('fos', $scope.applied, extra)
                .then(payload => {
                    d.payload = payload;
                    d.page = payload.page;
                })
                .catch(error => toastr.error(describeError(error)))
                .finally(() => (d.loading = false));
        }

        function bandOf(value) {
            if (value === null || value === undefined) {
                return null;
            }
            return value < 2.5 ? 'weak' : value < 3 ? 'developing' : value < 4 ? 'strong' : 'very_strong';
        }

        function bandLabel(key) {
            const band = ($scope.context ? $scope.context.bands : []).filter(b => b.key === key)[0];
            return band ? band.label : '--';
        }

        function maturityLabel(key) {
            const level = ($scope.context ? $scope.context.maturity_levels : []).filter(l => l.key === key)[0];
            return level ? level.label : '--';
        }

        /** "1.0 to below 2.5"; the top band includes 5.0. */
        function bandRange(band) {
            const low = Number(band.min).toFixed(1);
            const high = Number(band.max).toFixed(1);
            const last = $scope.context && band === $scope.context.bands[$scope.context.bands.length - 1];
            return last
                ? gettextCatalog.getString('{{low}} to {{high}}', { low: low, high: high })
                : gettextCatalog.getString('{{low}} to below {{high}}', { low: low, high: high });
        }

        /**
         * Share of a node's scored FOs in one score band, for the
         * distribution table: each dimension's column is 100% of its N.
         */
        function bandPct(node, key) {
            const s = node.stats;
            if (!s.n) {
                return null;
            }
            const entry = s.bands.filter(b => b.key === key)[0];
            return entry ? Math.round((entry.count / s.n) * 100) : 0;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Priorities, FO profile
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function openFo(foId) {
            api.get('fos', $scope.applied, { fo: foId })
                .then(payload => {
                    $scope.profile.payload = payload;
                    $scope.profile.open = true;
                })
                .catch(error => toastr.error(describeError(error)));
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Charts
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function renderCharts() {
            if ($scope.ui.view === 'segments' && $scope.payloads.segments) {
                const p = $scope.payloads.segments;
                const groups = p.groups.filter(g => g.values.some(v => v.mean !== null));
                siAnalyticsCharts.groupedBar(
                    'saSegmentsChart',
                    p.nodes.map((node, index) => ({
                        label: node.id + ' ' + (node.title || '').slice(0, 22),
                        values: groups.map(g => ({ key: g.label, value: g.values[index].mean }))
                    })),
                    groups.map(g => g.label),
                    {
                        height: 340,
                        rotateLabels: true,
                        labelFormat: siAnalyticsCharts.two,
                        emptyMessage: tr(gettext('No group has 5 or more scored FOs.'))
                    }
                );
            }
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Export
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function exportCsv(kind) {
            const stamp = new Date().toISOString().slice(0, 10);
            const tool = ($scope.applied.tool || 'tool').replace(/\s+/g, '_');
            api.get('export', $scope.applied, { kind: kind })
                .then(payload => {
                    if (!payload.rows.length) {
                        toastr.info(tr(gettext('Nothing to export.')));
                        return;
                    }
                    api.downloadCsv(
                        'score_analysis_' + tool + '_v' + $scope.applied.version + '_' + kind + '_' + stamp + '.csv',
                        payload.header,
                        payload.rows
                    );
                    toastr.success(tr(gettext('CSV exported.')));
                })
                .catch(error => toastr.error(describeError(error)));
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }
    }
})();

(function() {
    'use strict';

    /**
     * Reassessment & Progress analytics (AD-2194 / AD-2195 / AD-2196).
     *
     * One tab with eight sub-tabs over the same selection: the projects (one,
     * several or all the user can open), the comparison method, the score tool
     * and the shared filters. The selection is staged in the rail and applied
     * together; each sub-tab then loads its own payload, once per selection.
     *
     * Every figure arrives computed - per-FO changes, aggregates and N - so
     * nothing below recalculates a number; it only arranges and charts them.
     * The insight lines (AD-2195) are sentences assembled from those figures.
     *
     * Responses are tagged with the selection they were requested for; one
     * that arrives after the selection changed is dropped, so an old answer
     * never overwrites a newer selection (AD-2195).
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsReassessmentController', projectAnalyticsReassessmentController);

    projectAnalyticsReassessmentController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        '$filter',
        '$parse',
        'gettext',
        'gettextCatalog',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siReassessmentAnalytics',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsReassessmentController(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $timeout,
        $window,
        $document,
        $filter,
        $parse,
        gettext,
        gettextCatalog,
        toastr,
        siProjects,
        siProjectAnalytics,
        siReassessmentAnalytics,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;
        const api = siReassessmentAnalytics;

        $scope.charts = siAnalyticsCharts;
        $scope.fmt = { signed: api.signed, changeClass: api.changeClass };
        // A result over fewer than LOW_N observations is shown, annotated and
        // de-emphasised; it is never hidden or recalculated (AD-2195).
        $scope.LOW_N = 5;
        $scope.lowN = n => n > 0 && n < $scope.LOW_N;
        $scope.tabs = api.TABS;
        $scope.ui = { darkMode: false, rightbarClosed: false, tab: api.tab($stateParams.tab).id };
        $scope.rail = { selection: true, filters: true, population: true, rules: false, definitions: false };
        $scope.isLoading = false;
        $scope.loadFailed = false;

        // Applied selection (what the figures show) and the staged copy the
        // rail edits; Apply copies one over the other.
        $scope.applied = api.loadSelection(projectId);
        $scope.staged = angular.copy($scope.applied);
        $scope.options = { projects: [], projectSearch: '' };
        $scope.errors = [];

        // One payload per sub-tab, dropped whenever the selection changes.
        $scope.payloads = {};
        $scope.insights = {};
        // Bumped on every new selection; a response for an older one is stale.
        let generation = 0;
        $scope.explorer = { search: '', direction: '', detail: null, detailLoading: false };
        $scope.scores = { expanded: {} };
        // Built once: an array literal in `ng-repeat` never settles (#289).
        // No "Progress by project" table: projects have the Score by project
        // chart, an average rather than a comparison (AD-2196).
        $scope.progressGroups = [
            { key: 'by_country', title: gettext('Progress by country') },
            { key: 'by_value_chain', title: gettext('Progress by value chain') }
        ];
        $scope.productionGroups = [
            { key: 'by_project', title: gettext('Sales value by project') },
            { key: 'by_value_chain', title: gettext('Sales value by value chain') }
        ];
        $scope.productMeasures = ['production', 'purchased_members', 'purchased_others', 'sold', 'sold_value'];
        $scope.trendMeasures = [
            { key: 'production', label: gettext('Production') },
            { key: 'purchased_members', label: gettext('Purchased from members') },
            { key: 'purchased_others', label: gettext('Purchased from others') },
            { key: 'sold', label: gettext('Sales volume') }
        ];

        // FO tables: search, sort and pages over the full rows; exports take
        // every filtered row, never only the visible page (AD-2195).
        const PAGE_SIZE = 25;
        $scope.tables = {};
        ['scores', 'demographics', 'financials', 'finance-history', 'production', 'explorer'].forEach(key =>
            table(key)
        );
        $scope.tableRows = tableRows;
        $scope.pageRows = pageRows;
        $scope.pageInfo = pageInfo;
        $scope.movePage = movePage;
        $scope.sortTable = sortTable;
        $scope.sortClass = sortClass;
        $scope.selectTab = selectTab;
        $scope.toggleRailBox = key => ($scope.rail[key] = !$scope.rail[key]);
        $scope.toggleProject = toggleProject;
        $scope.isProjectSelected = id => $scope.staged.projects.indexOf(id) > -1;
        $scope.selectAllProjects = selectAllProjects;
        $scope.visibleProjects = visibleProjects;
        $scope.toggleValue = toggleValue;
        $scope.isValueSelected = (name, value) => ($scope.staged[name] || []).indexOf(value) > -1;
        $scope.apply = apply;
        $scope.reset = reset;
        $scope.projectName = projectName;
        $scope.maturityLabel = maturityLabel;
        $scope.reasonLabel = reasonLabel;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.openFo = openFo;
        $scope.closeFo = () => ($scope.explorer.detail = null);
        $scope.explorerRows = explorerRows;
        $scope.exportCsv = exportCsv;
        // An FO is a customer: its assessee page lists the original assessments.
        $scope.foHref = id => $state.href('base.assessees-detail', { id: id });
        $scope.foInsightsHref = id => $state.href('base.assessees-insights', { id: id });

        initTheme();
        loadProjectName();
        siProjectAnalytics.ensureRolloutFlags();
        loadProjects();
        loadOptions().finally(load);

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);
        const themeOff = $rootScope.$on('pad-theme-changed', () => $timeout(renderCharts, 250));
        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Selection
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name', 'customer'] })
                .then(project => ($scope.project = project))
                .catch(angular.noop);
        }

        function loadProjects() {
            api.getProjects()
                .then(projects => {
                    $scope.options.projects = projects;
                    // A stored project the user can no longer open would fail
                    // every request; drop it rather than strand the tab.
                    const allowed = projects.map(p => p.id);
                    const keep = $scope.applied.projects.filter(id => allowed.indexOf(id) > -1);
                    if (keep.length !== $scope.applied.projects.length) {
                        $scope.applied.projects = keep.length ? keep : [Number(projectId)];
                        $scope.staged.projects = $scope.applied.projects.slice();
                        api.saveSelection(projectId, $scope.applied);
                        reload();
                    }
                })
                .catch(angular.noop);
        }

        function loadOptions() {
            return api
                .getFilterOptions($scope.applied)
                .then(options => {
                    $scope.options.methods = options.methods;
                    $scope.options.tools = options.tool_types;
                    $scope.options.countries = options.countries;
                    $scope.options.valueChains = options.value_chains;
                    $scope.options.maturityLevels = options.maturity_levels.filter(l => l.value !== 'all');
                    $scope.options.currencies = options.currencies.length ? options.currencies : ['USD'];
                    $scope.options.fiscalYears = options.fiscal_years;
                })
                .catch(angular.noop);
        }

        function visibleProjects() {
            const term = ($scope.options.projectSearch || '').toLowerCase();
            return $scope.options.projects.filter(
                p => !term || (p.name + ' ' + (p.customer || '')).toLowerCase().indexOf(term) > -1
            );
        }

        function toggleProject(id) {
            const list = $scope.staged.projects;
            const at = list.indexOf(id);
            if (at > -1) {
                list.splice(at, 1);
            } else {
                list.push(id);
            }
        }

        function selectAllProjects(all) {
            $scope.staged.projects = all ? $scope.options.projects.map(p => p.id) : [];
        }

        function toggleValue(name, value) {
            const list = $scope.staged[name] || ($scope.staged[name] = []);
            const at = list.indexOf(value);
            if (at > -1) {
                list.splice(at, 1);
            } else {
                list.push(value);
            }
        }

        function apply() {
            $scope.errors = api.validate($scope.staged);
            if ($scope.errors.length) {
                return;
            }
            const projectsChanged = !angular.equals($scope.staged.projects, $scope.applied.projects);
            $scope.applied = angular.copy($scope.staged);
            api.saveSelection(projectId, $scope.applied);
            if (projectsChanged) {
                loadOptions().finally(reload);
            } else {
                reload();
            }
        }

        function reset() {
            $scope.staged = api.defaultSelection(projectId);
            $scope.errors = [];
            apply();
        }

        function reload() {
            generation += 1;
            $scope.payloads = {};
            $scope.insights = {};
            $scope.explorer.detail = null;
            Object.keys($scope.tables).forEach(key => ($scope.tables[key].page = 0));
            load();
        }

        function selectTab(id) {
            $scope.ui.tab = id;
            $state.go('.', { tab: id }, { notify: false });
            // Switching sub-tabs keeps the page in place: no overlay, only the
            // inline "Loading" note while the sub-tab's payload arrives.
            load({ overlay: false });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        const NO_OVERLAY = { received: angular.noop, finish: angular.noop, fail: angular.noop };

        function load(options) {
            const tabId = $scope.ui.tab;
            if ($scope.payloads[tabId]) {
                $timeout(renderCharts, 50);
                return;
            }
            const loader = options && options.overlay === false ? NO_OVERLAY : siAnalyticsLoader.begin($scope);
            const requested = generation;
            $scope.isLoading = true;
            $scope.loadFailed = false;
            api.getResource(tabId, $scope.applied)
                .then(payload => {
                    loader.received();
                    if (requested !== generation) {
                        // Asked for an older selection: drop it.
                        return null;
                    }
                    $scope.payloads[tabId] = payload;
                    $scope.insights[tabId] = insight(tabId, payload);
                    $scope.context = payload.context;
                    if (!$scope.applied.score_tool && payload.context && payload.context.score_tool) {
                        // Show the tool the server chose, without pinning it.
                        $scope.staged.score_tool = $scope.staged.score_tool || null;
                    }
                    return $timeout(renderCharts, 250);
                })
                .then(() => loader.finish())
                .catch(error => {
                    loader.fail();
                    if (requested !== generation) {
                        return;
                    }
                    $scope.loadFailed = true;
                    toastr.error(describeError(error));
                })
                .finally(() => {
                    if (requested === generation) {
                        $scope.isLoading = false;
                    }
                });
        }

        function describeError(error) {
            if (error && typeof error === 'object') {
                const messages = Object.keys(error)
                    .map(key => [].concat(error[key]).join(' '))
                    .filter(Boolean);
                if (messages.length) {
                    return messages.join(' ');
                }
            }
            return gettextCatalog.getString(gettext('Reassessment analytics could not be loaded.'));
        }

        function openFo(foId) {
            const requested = generation;
            $scope.explorer.detailLoading = true;
            $scope.explorer.detailFo = foId;
            api.getFoDetail($scope.applied, foId)
                .then(detail => {
                    // A newer selection, or another FO opened meanwhile.
                    if (requested !== generation || $scope.explorer.detailFo !== foId) {
                        return;
                    }
                    $scope.explorer.detail = detail;
                    $timeout(renderFoChart, 100);
                })
                .catch(() => toastr.error(gettextCatalog.getString(gettext('The FO could not be loaded.'))))
                .finally(() => ($scope.explorer.detailLoading = false));
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Labels
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function projectName(id) {
            const match = $scope.options.projects.filter(p => p.id === id)[0];
            return match ? match.name : '#' + id;
        }

        function maturityLabel(key) {
            const match = ($scope.options.maturityLevels || []).filter(l => l.value === key)[0];
            return match ? match.label : key ? key : '--';
        }

        const REASONS = {
            different_tool: gettext('Different assessment tool types'),
            baseline_unscored: gettext('Baseline has no valid score'),
            comparison_unscored: gettext('Comparison assessment has no valid score'),
            tool_version_differs: gettext('Different tool versions (compared)'),
            missing_price: gettext('Volume without a unit price'),
            missing_exchange_rate: gettext('No stored exchange rate'),
            no_conversion_to_reporting_currency: gettext('Not expressible in the reporting currency'),
            sales_reported_on_one_side_only: gettext('Sales reported in one assessment only'),
            assumed_conversion: gettext('Conversion assumed'),
            ambiguous_unit: gettext('Ambiguous unit'),
            unknown_unit: gettext('Unknown unit'),
            unspecified_unit: gettext('Unit not specified'),
            unmapped_dimension: gettext('Not in the canonical taxonomy'),
            duplicate_in_assessment: gettext('Two sections resolve to one in this assessment'),
            reported: gettext('Reported'),
            missing: gettext('Missing'),
            not_applicable: gettext('Not applicable (category of 0)'),
            invalid: gettext('Invalid (outside 0-100%)'),
            single_assessment: gettext('Assessed once'),
            no_score_tool_pair: gettext('Not reassessed with the score tool'),
            baseline_not_reported: gettext('No baseline financial year'),
            comparison_not_reported: gettext('No comparison financial year'),
            no_later_fiscal_year: gettext('No later fiscal year reported')
        };

        function reasonLabel(key) {
            return REASONS[key] ? gettextCatalog.getString(REASONS[key]) : key;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Explorer
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        let explorerCache = null;

        /** The explorer's direction filter; search, order and pages are the table's. */
        function explorerRows() {
            const payload = $scope.payloads.explorer;
            if (!payload) {
                return [];
            }
            const wanted = $scope.explorer.direction;
            if (explorerCache && explorerCache.fos === payload.fos && explorerCache.wanted === wanted) {
                return explorerCache.rows;
            }
            const rows = payload.fos.filter(row => {
                if (wanted === 'not_comparable') {
                    return !row.score_comparable;
                }
                if (wanted === 'version_differs') {
                    return row.tool_version_differs;
                }
                return !wanted || row.direction === wanted;
            });
            explorerCache = { fos: payload.fos, wanted: wanted, rows: rows };
            return rows;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         FO tables
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function table(key) {
            return (
                $scope.tables[key] ||
                ($scope.tables[key] = { search: '', sort: null, desc: false, page: 0, size: PAGE_SIZE, cache: null })
            );
        }

        function searchText(row) {
            return [row.fo_name, row.country, row.value_chain]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();
        }

        /**
         * Every row matching the table's search, in the table's order. The
         * same array comes back while nothing changed, so `ng-repeat` and the
         * pager watch a stable value.
         */
        function tableRows(key, rows) {
            const t = table(key);
            rows = rows || [];
            const c = t.cache;
            if (c && c.rows === rows && c.search === t.search && c.sort === t.sort && c.desc === t.desc) {
                return c.result;
            }
            const term = (t.search || '').toLowerCase().trim();
            let result = term ? rows.filter(row => searchText(row).indexOf(term) > -1) : rows.slice();
            if (t.sort) {
                const get = $parse(t.sort);
                const sign = t.desc ? -1 : 1;
                result.sort((a, b) => {
                    const x = get(a);
                    const y = get(b);
                    // Missing values sort last, whichever the direction.
                    if (x === null || x === undefined) {
                        return y === null || y === undefined ? 0 : 1;
                    }
                    if (y === null || y === undefined) {
                        return -1;
                    }
                    if (typeof x === 'string' || typeof y === 'string') {
                        return sign * String(x).localeCompare(String(y));
                    }
                    return sign * (x - y);
                });
            }
            t.cache = { rows: rows, search: t.search, sort: t.sort, desc: t.desc, result: result, pages: {} };
            return result;
        }

        function pageInfo(key, rows) {
            const t = table(key);
            const total = tableRows(key, rows).length;
            const pages = Math.max(1, Math.ceil(total / t.size));
            if (t.page > pages - 1) {
                t.page = pages - 1;
            }
            return {
                total: total,
                pages: pages,
                page: t.page,
                from: total ? t.page * t.size + 1 : 0,
                to: Math.min(total, (t.page + 1) * t.size)
            };
        }

        function pageRows(key, rows) {
            const all = tableRows(key, rows);
            const t = table(key);
            const info = pageInfo(key, rows);
            const pages = t.cache.pages;
            if (!pages[info.page]) {
                pages[info.page] = all.slice(info.from ? info.from - 1 : 0, info.to);
            }
            return pages[info.page];
        }

        function movePage(key, step, rows) {
            const t = table(key);
            const info = pageInfo(key, rows);
            t.page = Math.min(info.pages - 1, Math.max(0, t.page + step));
        }

        function sortTable(key, field) {
            const t = table(key);
            if (t.sort === field) {
                t.desc = !t.desc;
            } else {
                t.sort = field;
                t.desc = false;
            }
            t.page = 0;
        }

        function sortClass(key, field) {
            const t = table(key);
            if (t.sort !== field) {
                return 'fa-sort rea-sort--idle';
            }
            return t.desc ? 'fa-sort-desc' : 'fa-sort-asc';
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Insights (AD-2195)
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * One lead sentence per sub-tab, put together from figures the payload
         * already holds - no number is derived here - and describing observed
         * change only. Where nothing is comparable it says so instead.
         */
        function insight(tabId, p) {
            const pct = siAnalyticsCharts.pct;
            const num = siAnalyticsCharts.num;
            const pop = p.context.population;
            const period = p.context.period;
            const when = period
                ? gettextCatalog.getString('Baseline assessments {{b1}} – {{b2}}, comparison {{c1}} – {{c2}}.', {
                      b1: period.baseline_from,
                      b2: period.baseline_to,
                      c1: period.comparison_from,
                      c2: period.comparison_to
                  })
                : '';
            const none = text => ({ empty: true, text: gettextCatalog.getString(text) });
            const say = (text, values, n) => ({
                empty: false,
                lowN: $scope.lowN(n),
                text: (gettextCatalog.getString(text, values) + ' ' + when).trim()
            });
            switch (tabId) {
                case 'overview':
                case 'scores': {
                    const s = tabId === 'overview' ? p.kpis.score : p.overall;
                    if (!s.n) {
                        return none(
                            'Not enough comparable information: no FO pair has a valid score in one tool type at both ends.'
                        );
                    }
                    return say(
                        'Over {{n}} comparable pairs ({{fos}} FOs) in {{tool}}, the average overall score went from {{b}} to {{l}} ({{d}}); {{up}} improved and {{down}} declined. {{cv}} of these pairs compare different versions of the tool.',
                        {
                            n: s.n,
                            fos: pop.score_comparable_fo_n,
                            tool: p.context.score_tool,
                            b: siAnalyticsCharts.two(s.baseline_mean),
                            l: siAnalyticsCharts.two(s.latest_mean),
                            d: api.signed(s.mean_change, 2),
                            up: pct(s.improved_pct),
                            down: pct(s.declined_pct),
                            cv: pop.cross_version_pair_n
                        },
                        s.n
                    );
                }
                case 'demographics': {
                    const m = p.indicators[0];
                    if (!m.total.n) {
                        return none(
                            'Not enough comparable information: no pair reports membership in both assessments.'
                        );
                    }
                    return say(
                        'Over {{n}} pairs reporting members in both assessments, members went from {{b}} to {{l}} ({{d}}). Youth share is reported at both ends for {{y}} pairs.',
                        {
                            n: m.total.n,
                            b: num(m.total.baseline_total),
                            l: num(m.total.latest_total),
                            d: api.signed(m.total.total_change_pct, 1, '%'),
                            y: m.youth_pct_pp.n
                        },
                        m.total.n
                    );
                }
                case 'financials': {
                    const r = p.measures.filter(m => m.key === 'revenue')[0];
                    if (!r || !r.n) {
                        return none(
                            'Not enough comparable information: no pair reports turnover for a later fiscal year.'
                        );
                    }
                    return say(
                        'Over {{n}} pairs with a later fiscal year, total turnover went from {{b}} to {{l}} ({{d}}).',
                        {
                            n: r.n,
                            b: siAnalyticsCharts.money(r.baseline_total, p.currency),
                            l: siAnalyticsCharts.money(r.latest_total, p.currency),
                            d: api.signed(r.total_change_pct, 1, '%')
                        },
                        r.n
                    );
                }
                case 'finance-history':
                    if (!p.access.n) {
                        return none('Not enough comparable information: no matched pairs.');
                    }
                    return say(
                        '{{b}} of matched pairs reported a facility at baseline and {{l}} at the comparison assessment (N={{n}}). {{nr}} facilities were newly reported; {{no}} were newly originated, and {{unknown}} have no start date.',
                        {
                            b: pct(p.access.baseline_pct),
                            l: pct(p.access.latest_pct),
                            n: p.access.n,
                            nr: p.newly_reported.count,
                            no: p.newly_originated.count,
                            unknown: p.newly_reported.origination_unknown
                        },
                        p.access.n
                    );
                case 'production':
                    if (!p.sales_value.n) {
                        return none(
                            'Not enough comparable information: no pair has a complete sales value for a later year.'
                        );
                    }
                    return say(
                        'Over {{n}} pairs with a complete sales value, sales went from {{b}} to {{l}} ({{d}}). {{inc}} pairs are left out because a component could not be valued.',
                        {
                            n: p.sales_value.n,
                            b: siAnalyticsCharts.money(p.sales_value.baseline_total, p.currency),
                            l: siAnalyticsCharts.money(p.sales_value.latest_total, p.currency),
                            d: api.signed(p.sales_value.total_change_pct, 1, '%'),
                            inc: p.sales_value_incomplete.fo_pairs
                        },
                        p.sales_value.n
                    );
                case 'explorer':
                    return say(
                        '{{fos}} FOs, {{re}} reassessed; {{cmp}} are comparable on scores in {{tool}}.',
                        {
                            fos: pop.unique_fo_n,
                            re: pop.reassessed_fo_n,
                            cmp: pop.score_comparable_fo_n,
                            tool: p.context.score_tool || '--'
                        },
                        pop.unique_fo_n
                    );
                case 'coverage':
                    return say(
                        '{{re}} of {{fos}} FOs are reassessed; {{cmp}} pairs are comparable on scores. {{ex}} assessments are excluded, {{units}} units need review.',
                        {
                            re: pop.reassessed_fo_n,
                            fos: pop.unique_fo_n,
                            cmp: pop.score_comparable_pair_n,
                            ex: pop.excluded_assessment_n,
                            units: p.unit_review.length
                        },
                        pop.unique_fo_n
                    );
            }
            return null;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Charts
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function tr(text) {
            return gettextCatalog.getString(text);
        }

        function baselineLatest(rows, labelOf, baselineOf, latestOf) {
            return rows.map(row => ({
                label: labelOf(row),
                values: [
                    { key: tr('Baseline'), value: baselineOf(row) },
                    { key: tr('Latest'), value: latestOf(row) }
                ]
            }));
        }

        // Data labels (AD-2196): scores to two decimals, percentages whole,
        // counts as integers, money in whole units.
        const LABELS = {
            score: v => siAnalyticsCharts.two(v),
            pct: v => siAnalyticsCharts.pct(v, 0),
            count: v => siAnalyticsCharts.num(v),
            money: v => compactNumber(v)
        };

        /** Large amounts in short form for a label (12.3k, 4.5M); the tooltip has the rest. */
        function compactNumber(value) {
            if (siAnalyticsCharts.isMissing(value)) {
                return siAnalyticsCharts.MISSING;
            }
            const size = Math.abs(value);
            if (size >= 1e9) {
                return (value / 1e9).toFixed(1) + 'B';
            }
            if (size >= 1e6) {
                return (value / 1e6).toFixed(1) + 'M';
            }
            if (size >= 1e4) {
                return (value / 1e3).toFixed(1) + 'k';
            }
            return siAnalyticsCharts.num(value);
        }

        function labelled(format, options) {
            return angular.extend({ labelFormat: LABELS[format] }, options);
        }

        function renderCharts() {
            const payload = $scope.payloads[$scope.ui.tab];
            if (!payload) {
                return;
            }
            const keys = [tr('Baseline'), tr('Latest')];
            const empty = { emptyMessage: tr('No matched FOs for this comparison.') };
            switch ($scope.ui.tab) {
                case 'overview':
                    // One average per project on the 1-5 scale, not a comparison.
                    siAnalyticsCharts.horizontalBar(
                        'reaOverviewProjects',
                        payload.score_by_project.map(r => ({
                            label: r.name + ' (N=' + r.n + ')',
                            value: r.mean,
                            tooltip:
                                r.name +
                                '\n' +
                                tr('Average SCOPE score') +
                                ': ' +
                                siAnalyticsCharts.two(r.mean) +
                                '\nN=' +
                                r.n +
                                ' ' +
                                tr('FOs, latest eligible assessment in the project')
                        })),
                        {
                            domain: [1, 5],
                            height: 'auto',
                            labelWidth: 200,
                            labelFormat: LABELS.score,
                            emptyMessage: tr('No FO in the selection has a valid score in this tool.')
                        }
                    );
                    siAnalyticsCharts.bar(
                        'reaOverviewDistribution',
                        withData(payload.score_distribution.map(b => ({ label: b.label, value: b.count }))),
                        labelled('count', empty)
                    );
                    siAnalyticsCharts.groupedBar(
                        'reaOverviewMaturity',
                        withData(
                            payload.maturity_distribution.levels.map(l => ({
                                label: l.label,
                                values: [
                                    { key: tr('Baseline'), value: l.baseline },
                                    { key: tr('Latest'), value: l.latest }
                                ]
                            }))
                        ),
                        keys,
                        labelled('count', empty)
                    );
                    siAnalyticsCharts.line(
                        'reaOverviewTrend',
                        payload.score_trend.map(r => ({
                            label: tr('Round') + ' ' + r.round,
                            value: r.mean,
                            tooltip: tr('Round') + ' ' + r.round + ': ' + siAnalyticsCharts.two(r.mean) + '\nN=' + r.n
                        })),
                        labelled('score', empty)
                    );
                    siAnalyticsCharts.sankey('reaOverviewSankey', payload.maturity_transition, {
                        height: 360,
                        colors: MATURITY_COLORS,
                        unit:
                            payload.maturity_transition.fo_n === payload.maturity_transition.n
                                ? tr('FOs')
                                : tr('pairs'),
                        labels: {
                            baseline: tr('Baseline'),
                            latest: tr('Latest'),
                            up: tr('Moved up'),
                            same: tr('Stayed'),
                            down: tr('Moved down'),
                            of: tr('of')
                        },
                        emptyMessage: tr('No matched FOs for this comparison.')
                    });
                    break;
                case 'scores':
                    siAnalyticsCharts.groupedBar(
                        'reaScoresDimensions',
                        baselineLatest(
                            payload.dimensions.filter(r => r.n),
                            r => r.title,
                            r => r.baseline_mean,
                            r => r.latest_mean
                        ),
                        keys,
                        labelled('score', angular.extend({ height: 340 }, empty))
                    );
                    siAnalyticsCharts.line(
                        'reaScoresTrend',
                        payload.overall_trend.map(r => ({
                            label: tr('Round') + ' ' + r.round,
                            value: r.mean,
                            tooltip: tr('Round') + ' ' + r.round + ': ' + siAnalyticsCharts.two(r.mean) + '\nN=' + r.n
                        })),
                        labelled('score', empty)
                    );
                    break;
                case 'demographics':
                    siAnalyticsCharts.groupedBar(
                        'reaDemographicsTotals',
                        baselineLatest(
                            payload.indicators.filter(r => r.total.n),
                            r => tr(r.label),
                            r => r.total.baseline_total,
                            r => r.total.latest_total
                        ),
                        keys,
                        labelled('count', angular.extend({ height: 340 }, empty))
                    );
                    break;
                case 'financials':
                    siAnalyticsCharts.groupedBar(
                        'reaFinancialMeasures',
                        baselineLatest(
                            payload.measures.filter(r => r.n),
                            r => tr(r.label),
                            r => r.baseline_mean,
                            r => r.latest_mean
                        ),
                        keys,
                        labelled('money', empty)
                    );
                    siAnalyticsCharts.line(
                        'reaFinancialTrend',
                        payload.by_year.map(y => ({
                            label: String(y.year),
                            value: y.revenue.average,
                            tooltip:
                                String(y.year) +
                                ': ' +
                                siAnalyticsCharts.money(y.revenue.average, payload.currency) +
                                '\nN=' +
                                y.revenue.n
                        })),
                        labelled('money', empty)
                    );
                    break;
                case 'finance-history':
                    siAnalyticsCharts.groupedBar(
                        'reaFinanceAccess',
                        withData(
                            baselineLatest(
                                payload.types,
                                r => tr(r.label),
                                r => r.access.baseline_pct,
                                r => r.access.latest_pct
                            )
                        ),
                        keys,
                        labelled('pct', empty)
                    );
                    siAnalyticsCharts.groupedBar(
                        'reaFinanceByYear',
                        withData(
                            payload.by_year.map(y => ({
                                label: String(y.year),
                                values: y.types.map(t => ({ key: typeLabel(t.key), value: t.count }))
                            }))
                        ),
                        payload.types.map(t => tr(t.label)),
                        labelled('count', empty)
                    );
                    break;
                case 'production':
                    siAnalyticsCharts.groupedBar(
                        'reaProductionCountries',
                        baselineLatest(
                            payload.by_country,
                            r => r.name + ' (N=' + r.n + ')',
                            r => r.baseline_total,
                            r => r.latest_total
                        ),
                        keys,
                        labelled('money', empty)
                    );
                    break;
                case 'coverage':
                    siAnalyticsCharts.horizontalBar(
                        'reaCoverageDomains',
                        payload.domains.map(d => ({
                            label: tr(d.label),
                            value: d.both_pct || 0,
                            tooltip:
                                tr(d.label) +
                                ': ' +
                                siAnalyticsCharts.pct(d.both_pct, 0) +
                                '\n' +
                                d.both +
                                ' / ' +
                                d.pairs
                        })),
                        { labelWidth: 220, labelFormat: LABELS.pct }
                    );
                    break;
            }
        }

        // The maturity colours of the Detailed Score Analysis tab, so a level
        // looks the same on both tabs.
        const MATURITY_COLORS = { level_1: '#ee6666', level_2: '#fac858', level_3: '#91cc75', level_4: '#3ba272' };

        // Fixed buckets (score bands, maturity levels, finance types) come back
        // even with N=0; all-zero bars would draw an empty axis, so show the
        // empty message instead.
        function withData(rows) {
            return rows.some(r => (r.values || [r]).some(v => v.value)) ? rows : [];
        }

        function typeLabel(key) {
            const payload = $scope.payloads['finance-history'];
            const match = payload.types.filter(t => t.key === key)[0];
            return match ? tr(match.label) : key;
        }

        function renderFoChart() {
            const detail = $scope.explorer.detail;
            if (!detail) {
                return;
            }
            siAnalyticsCharts.line(
                'reaFoScores',
                detail.entries.map(e => ({
                    label: e.date + ' (' + e.tool_type + ')',
                    value: e.score
                })),
                { height: 220, labelFormat: LABELS.score, emptyMessage: tr('No scores recorded.') }
            );
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Export
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        const STAT_HEADER = [
            'N',
            'Baseline mean',
            'Latest mean',
            'Mean change',
            'Baseline total',
            'Latest total',
            'Total change %',
            'Improved',
            'Unchanged',
            'Declined',
            'Caution'
        ];

        function stat(s) {
            return [
                s.n,
                s.baseline_mean,
                s.latest_mean,
                s.mean_change,
                s.baseline_total,
                s.latest_total,
                s.total_change_pct,
                s.improved,
                s.unchanged,
                s.declined,
                lowNNote(s.n)
            ];
        }

        function lowNNote(n) {
            return $scope.lowN(n) ? 'Small sample (N<' + $scope.LOW_N + ')' : '';
        }

        /** Every row the table's search keeps, not only the visible page. */
        function exported(key, rows) {
            return tableRows(key, rows);
        }

        function pairColumns(row) {
            return [
                row.fo_id,
                row.fo_name,
                row.country,
                row.value_chain,
                row.step,
                row.baseline_date,
                row.comparison_date
            ];
        }

        const PAIR_HEADER = ['FO id', 'FO', 'Country', 'Value chain', 'Rounds', 'Baseline date', 'Comparison date'];

        function exportCsv(kind) {
            const payload = $scope.payloads[$scope.ui.tab];
            if (!payload) {
                return;
            }
            const stamp = new Date().toISOString().slice(0, 10);
            const name = 'reassessment_' + $scope.ui.tab + '_' + (kind || 'summary') + '_' + stamp + '.csv';
            let header = [];
            let rows = [];
            switch ($scope.ui.tab + ':' + (kind || 'summary')) {
                case 'overview:summary': {
                    // Projects carry an average, not a comparison (AD-2196):
                    // N and the last column only.
                    header = ['Group', 'Name'].concat(STAT_HEADER, ['Average score (latest assessment per FO)']);
                    const blank = STAT_HEADER.map(() => '');
                    rows = [['All', $scope.context.score_tool].concat(stat(payload.kpis.score), [''])]
                        .concat(
                            payload.score_by_project.map(r =>
                                ['Project', r.name].concat([r.n], blank.slice(1, -1), [lowNNote(r.n), r.mean])
                            )
                        )
                        .concat(payload.by_country.map(r => ['Country', r.name].concat(stat(r), [''])))
                        .concat(payload.by_value_chain.map(r => ['Value chain', r.name].concat(stat(r), [''])));
                    break;
                }
                case 'scores:summary':
                    header = ['Level', 'Key', 'Dimension', 'Subdimension']
                        .concat(STAT_HEADER)
                        .concat(['Only one side scored', 'Mapped', 'Source titles', 'Versions']);
                    rows = [['Overall', '', '', ''].concat(stat(payload.overall)).concat(['', '', '', ''])];
                    payload.dimensions.forEach(d => {
                        const extra = r => [
                            r.one_side_only,
                            r.mapped ? 'yes' : 'no',
                            r.source_titles.join('; '),
                            r.versions.join('; ')
                        ];
                        rows.push(['Dimension', d.key, d.title, ''].concat(stat(d)).concat(extra(d)));
                        d.subdimensions.forEach(s =>
                            rows.push(['Subdimension', s.key, d.title, s.title].concat(stat(s)).concat(extra(s)))
                        );
                    });
                    break;
                case 'scores:fos':
                    header = [
                        'FO id',
                        'FO',
                        'Country',
                        'Value chain',
                        'Rounds',
                        'Baseline date',
                        'Baseline tool',
                        'Baseline score',
                        'Latest date',
                        'Latest tool',
                        'Latest score',
                        'Change',
                        'Comparable',
                        'Reasons',
                        'Tool versions differ'
                    ];
                    rows = exported('scores', payload.fos).map(r => [
                        r.fo_id,
                        r.fo_name,
                        r.country,
                        r.value_chain,
                        r.step,
                        r.baseline.date,
                        r.baseline.tool_type + ' ' + r.baseline.tool_version,
                        r.baseline.score,
                        r.comparison.date,
                        r.comparison.tool_type + ' ' + r.comparison.tool_version,
                        r.comparison.score,
                        r.change,
                        r.score_comparable ? 'yes' : 'no',
                        r.exclusion_reasons.join('; '),
                        r.tool_version_differs ? 'yes' : 'no'
                    ]);
                    break;
                case 'demographics:summary':
                    header = ['Indicator', 'Series'].concat(STAT_HEADER);
                    payload.indicators.forEach(i => {
                        ['total', 'male', 'female'].forEach(series =>
                            rows.push([i.label, series].concat(stat(i[series])))
                        );
                        rows.push([i.label, 'female share (pp)'].concat(stat(i.female_share_pp)));
                        rows.push([i.label, 'youth share (pp)'].concat(stat(i.youth_pct_pp)));
                    });
                    break;
                case 'demographics:fos':
                    header = PAIR_HEADER.slice();
                    payload.indicators.forEach(i =>
                        header.push(
                            i.label + ' baseline',
                            i.label + ' latest',
                            i.label + ' change',
                            i.label + ' youth % baseline',
                            i.label + ' youth % latest',
                            i.label + ' youth change (pp)',
                            i.label + ' youth state baseline',
                            i.label + ' youth state latest'
                        )
                    );
                    rows = exported('demographics', payload.fos).map(r => {
                        const cells = pairColumns(r);
                        payload.indicators.forEach(i => {
                            const v = r[i.key];
                            cells.push(
                                v.baseline,
                                v.latest,
                                v.change,
                                v.youth_baseline,
                                v.youth_latest,
                                v.youth_change_pp,
                                v.youth_state_baseline,
                                v.youth_state_latest
                            );
                        });
                        return cells;
                    });
                    break;
                case 'financials:summary':
                    header = ['Measure', 'Unit'].concat(STAT_HEADER);
                    rows = payload.measures.concat(payload.margins).map(m => [m.label, m.unit].concat(stat(m)));
                    break;
                case 'financials:fos':
                    header = PAIR_HEADER.concat(['Baseline FY', 'Comparison FY', 'Excluded']);
                    payload.measures
                        .concat(payload.margins)
                        .forEach(m => header.push(m.label + ' baseline', m.label + ' latest', m.label + ' change'));
                    rows = exported('financials', payload.fos).map(r => {
                        const cells = pairColumns(r).concat([r.baseline_year, r.comparison_year, r.excluded_reason]);
                        payload.measures
                            .concat(payload.margins)
                            .forEach(m => cells.push(r[m.key].baseline, r[m.key].latest, r[m.key].change));
                        return cells;
                    });
                    break;
                case 'finance-history:summary':
                    header = [
                        'Type',
                        'N (pairs)',
                        'FOs with finance at baseline',
                        'FOs with finance at latest',
                        'Change (pp)',
                        'Newly reported facilities (first recorded in a later assessment)',
                        'Newly reported amount',
                        'Newly originated facilities (start date after baseline, on or before comparison)',
                        'Newly originated amount',
                        'Caution'
                    ];
                    rows = payload.types.map(t => [
                        t.label,
                        t.access.n,
                        t.access.baseline_fos,
                        t.access.latest_fos,
                        t.access.change_pp,
                        t.newly_reported.count,
                        t.newly_reported.amount,
                        t.newly_originated.count,
                        t.newly_originated.amount,
                        lowNNote(t.access.n)
                    ]);
                    break;
                case 'finance-history:fos':
                    header = [
                        'FO id',
                        'FO',
                        'Type',
                        'Financier type',
                        'Financier',
                        'Start date',
                        'Amount (' + payload.currency + ')',
                        'First reported in round',
                        'Originated in round (first round on or after the start date)',
                        'Origination',
                        'Reported in assessments'
                    ];
                    exported('finance-history', payload.histories).forEach(h =>
                        h.facilities.forEach(f =>
                            rows.push([
                                h.fo_id,
                                h.fo_name,
                                f.finance_type_label,
                                f.financier_type,
                                f.financier_name,
                                f.start_date,
                                f.amount,
                                f.first_round,
                                f.origination_round,
                                f.origination_known ? 'start date known' : 'unknown (no start date)',
                                f.reported_in.join(' ')
                            ])
                        )
                    );
                    break;
                case 'production:summary':
                    header = ['Product', 'Category', 'Unit', 'Unit category', 'Reported units', 'Measure'].concat(
                        STAT_HEADER
                    );
                    payload.products.forEach(p =>
                        $scope.productMeasures.forEach(m =>
                            rows.push(
                                [
                                    p.product,
                                    p.category,
                                    p.unit,
                                    p.unit_category,
                                    (p.source_units || []).join('; '),
                                    m
                                ].concat(stat(p[m]))
                            )
                        )
                    );
                    break;
                case 'production:fos':
                    header = PAIR_HEADER.concat([
                        'Products compared',
                        'Products sold',
                        'Sales value complete',
                        'Sales value baseline (' + payload.currency + ')',
                        'Sales value latest (' + payload.currency + ')',
                        'Sales value change %',
                        'Partial subtotal baseline (incomplete)',
                        'Partial subtotal latest (incomplete)',
                        'Components not valued',
                        'Causes'
                    ]);
                    rows = exported('production', payload.fos).map(r =>
                        pairColumns(r).concat([
                            r.products_compared,
                            r.products_sold,
                            r.sales_value_complete ? 'yes' : 'no',
                            r.sales_value_baseline,
                            r.sales_value_latest,
                            r.sales_value_change_pct,
                            r.sales_value_partial ? r.sales_value_partial.baseline : null,
                            r.sales_value_partial ? r.sales_value_partial.latest : null,
                            r.sales_value_missing_components,
                            r.sales_value_causes.map(reasonLabel).join('; ')
                        ])
                    );
                    break;
                case 'production:units':
                    header = ['Reported unit', 'Category', 'Reported as', 'kg per unit', 'Records', 'Review', 'Note'];
                    rows = payload.units.map(u => [
                        u.unit,
                        u.category,
                        u.reported_as,
                        u.kg_factor,
                        u.records,
                        u.review ? reasonLabel(u.review) : '',
                        u.note
                    ]);
                    break;
                case 'explorer:summary':
                    header = [
                        'FO id',
                        'FO',
                        'Country',
                        'Value chain',
                        'Projects',
                        'Rounds',
                        'First assessment',
                        'Latest assessment',
                        'Tools',
                        'Interval (months)',
                        'Baseline score',
                        'Latest score',
                        'Change',
                        'Baseline maturity',
                        'Latest maturity',
                        'Baseline tool version',
                        'Latest tool version',
                        'Issues'
                    ];
                    rows = exported('explorer', explorerRows()).map(r => [
                        r.fo_id,
                        r.fo_name,
                        r.country,
                        r.value_chain,
                        r.projects.join('; '),
                        r.rounds,
                        r.first_date,
                        r.latest_date,
                        r.tools.join('; '),
                        r.interval_months,
                        r.baseline_score,
                        r.latest_score,
                        r.score_change,
                        maturityLabel(r.baseline_maturity),
                        maturityLabel(r.latest_maturity),
                        r.baseline_version,
                        r.latest_version,
                        r.issues
                            .concat(r.tool_version_differs ? ['tool_version_differs'] : [])
                            .map(reasonLabel)
                            .join('; ')
                    ]);
                    break;
                case 'coverage:summary':
                    header = ['Domain', 'Indicator', 'N', 'Caution'];
                    rows = payload.indicators.map(i => [i.domain, i.indicator, i.n, lowNNote(i.n)]);
                    break;
                case 'coverage:review':
                    header = ['Area', 'Item', 'Issue', 'Detail'];
                    rows = payload.unit_review
                        .map(u => [
                            'Unit',
                            u.unit,
                            reasonLabel(u.review),
                            (u.note || '') + ' (' + u.records + ' records)'
                        ])
                        .concat(
                            payload.section_review.map(r => [
                                'Section',
                                r.title,
                                reasonLabel(r.issue),
                                r.assessment_id ? 'Assessment #' + r.assessment_id : (r.source_titles || []).join('; ')
                            ])
                        );
                    break;
                case 'coverage:excluded':
                    header = ['Assessment id', 'FO', 'Project', 'Date', 'Tool', 'Reason'];
                    rows = payload.excluded.map(e => [
                        e.assessment_id,
                        e.fo_name,
                        e.project_name,
                        e.date,
                        e.tool_type,
                        e.label
                    ]);
                    break;
            }
            if (!rows.length) {
                toastr.info(tr('Nothing to export.'));
                return;
            }
            api.downloadCsv(name, header, rows);
            toastr.success(tr('CSV exported.'));
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }
    }
})();

(function() {
    'use strict';

    /**
     * Production & Sales tab of the project analytics dashboard.
     *
     * Volumes are presented per unit and never combined across units: there is
     * no approved conversion table, so kilograms, litres and bags are reported
     * side by side. Input purchases stay on their own axis rather than being
     * added to produce volumes, and primary/secondary products come from the
     * explicit product importance, not from the order products happen to appear in.
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsProductionController', projectAnalyticsProductionController);

    projectAnalyticsProductionController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsProductionController(
        $scope,
        $rootScope,
        $stateParams,
        $timeout,
        $window,
        $document,
        toastr,
        siProjects,
        siProjectAnalytics,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;

        // AD-2106 §7: input purchases are no longer shown in the core
        // Production & Sales table. The backend still returns
        // `input_volume_purchased` and nothing upstream changed - this is a
        // presentation decision, reversible by putting the label back.
        const VOLUME_LABELS = {
            volume_purchased_from_members: 'Purchased from members',
            volume_purchased_from_others: 'Purchased from others',
            volume_sold: 'Produce sold'
        };

        const FLAG_LABELS = {
            missing_unit: 'Unit missing',
            missing_product: 'Product missing',
            missing_reporting_year: 'Reporting year missing',
            negative_volume: 'Negative volume',
            duplicate_fo_product_year_unit: 'Duplicate FO/product/year/unit row',
            mixed_units_for_measure: 'Same measure reported in two units',
            product_role_not_reported: 'Product importance not reported',
            sold_volume_high_vs_sourced: 'Sold volume high relative to sourced'
        };

        $scope.charts = siAnalyticsCharts;
        $scope.volumeLabels = VOLUME_LABELS;
        $scope.volumeFields = Object.keys(VOLUME_LABELS);
        $scope.ui = { darkMode: false, rightbarClosed: false };
        $scope.availableCurrencies = ['USD'];
        $scope.toolTypeOptions = [];
        $scope.isLoading = true;
        $scope.dataQualityHints = [];

        $scope.local = { fo: [], year: [], country: [], product: [], unit: [] };
        $scope.options = { fo: [], year: [], country: [], product: [], unit: [] };
        $scope.sort = siAnalyticsCharts.sorter('volume_sold', true);

        $scope.applyLocalFilters = applyLocalFilters;
        $scope.clearLocalFilters = clearLocalFilters;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.exportCSV = exportCSV;
        $scope.flagLabel = flagLabel;
        $scope.topProductsForUnit = topProductsForUnit;
        $scope.roleLabel = roleLabel;
        $scope.purchaseUnit = purchaseUnit;

        initTheme();
        loadProjectName();
        // `loadFilterOptions` binds the shared filter panel and performs the
        // initial load once the stored filters have been reconciled against
        // this project (FR-017). Calling `load()` here as well fetched twice,
        // and the first of the two used filters that had not been reconciled.
        loadFilterOptions();

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);

        const themeOff = $rootScope.$on('pad-theme-changed', function() {
            $timeout(renderCharts, 250);
        });

        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
        }

        /**
         * The project's tool types, for the shared Tool Type filter.
         * AD-2106 §10. Loaded once: the options describe the project, not the
         * current selection, so they must not shrink as filters are applied.
         */
        /**
         * The one shared filter panel. AD-2116 FR-001, FR-002.
         *
         * `bindFilterScope` owns the filter state, the options, validation,
         * chips, clearing and the score shortcuts, so every tab behaves the
         * same way. This controller keeps `load`, because only it knows what
         * its own tab fetches.
         */
        function loadFilterOptions() {
            return siProjectAnalytics.bindFilterScope($scope, projectId, 'production-sales', load);
        }

        function load() {
            $scope.isLoading = true;
            const loader = siAnalyticsLoader.begin($scope);

            return siProjectAnalytics
                .getProductionSales(projectId, $scope.filters)
                .then(function(data) {
                    loader.received();
                    $scope.data = data;
                    $scope.population = data.population;
                    $scope.byUnit = data.by_unit;
                    $scope.sourcingRatio = data.member_sourcing_ratio;
                    // AD-2106 §8: `fo_products` is one row per FO/product/year
                    // with a unit per measure, so a volume sold in bags can sit
                    // beside one purchased in kilograms. `records` stays the
                    // per-unit basis every total is aggregated over.
                    $scope.records = data.fo_products || data.records;
                    $scope.units = (data.by_unit || []).map(function(entry) {
                        return entry.unit;
                    });

                    buildOptions(data.records);
                    applyLocalFilters();
                    buildHints();

                    $scope.filterSummary = siProjectAnalytics.describeFilters($scope.filters);
                    $scope.isPageLoaded = true;
                    $timeout(renderCharts, 250).finally(loader.finish);
                })
                .catch(function(error) {
                    loader.fail();
                    toastr.error('Could not load production analytics', 'Error');
                    $window.console.error('Production analytics error:', error);
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Drill-down
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function buildOptions(records) {
            $scope.options.fo = siAnalyticsCharts.distinct(records, 'fo_name');
            $scope.options.year = siAnalyticsCharts.distinct(records, 'year');
            $scope.options.country = siAnalyticsCharts.distinct(records, 'country');
            $scope.options.product = siAnalyticsCharts.distinct(records, 'product_name');
            // Units now come from the per-measure columns rather than one
            // column shared by both, so the local filter offers every unit
            // present on either side of the row.
            $scope.options.unit = unitOptions(records);
        }

        function applyLocalFilters() {
            const local = $scope.local;
            $scope.visibleRecords = ($scope.records || []).filter(function(row) {
                return (
                    siAnalyticsCharts.matchesSelection(row.fo_name, local.fo) &&
                    siAnalyticsCharts.matchesSelection(row.year, local.year) &&
                    siAnalyticsCharts.matchesSelection(row.country, local.country) &&
                    siAnalyticsCharts.matchesSelection(row.product_name, local.product) &&
                    matchesUnit(row, local.unit)
                );
            });
        }

        function clearLocalFilters() {
            $scope.local = { fo: [], year: [], country: [], product: [], unit: [] };
            applyLocalFilters();
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Presentation
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function topProductsForUnit(unit) {
            return (($scope.data || {}).top_products || []).filter(function(entry) {
                return entry.unit === unit;
            });
        }

        /** Every unit named anywhere on a row - purchase side or sale side. */
        function rowUnits(row) {
            return [row.purchased_from_members_unit, row.purchased_from_others_unit, row.sold_unit].filter(function(
                unit,
                index,
                all
            ) {
                return unit && all.indexOf(unit) === index;
            });
        }

        function unitOptions(records) {
            const seen = [];
            (records || []).forEach(function(row) {
                rowUnits(row).forEach(function(unit) {
                    if (seen.indexOf(unit) === -1) {
                        seen.push(unit);
                    }
                });
            });
            return seen.sort();
        }

        function matchesUnit(row, selection) {
            if (!selection || !selection.length) {
                return true;
            }
            return rowUnits(row).some(function(unit) {
                return selection.indexOf(unit) !== -1;
            });
        }

        /**
         * The unit the purchase figures are in.
         *
         * The two purchase measures are reported separately and can disagree;
         * when they do both are named rather than one being chosen, because
         * picking one would misattribute the other's volume.
         */
        function purchaseUnit(row) {
            const units = [row.purchased_from_members_unit, row.purchased_from_others_unit].filter(function(
                unit,
                index,
                all
            ) {
                return unit && all.indexOf(unit) === index;
            });
            return units.join(' / ');
        }

        function roleLabel(role) {
            if (!role) {
                return '—';
            }
            return role.charAt(0).toUpperCase() + role.slice(1);
        }

        function flagLabel(flag) {
            return FLAG_LABELS[flag] || flag;
        }

        function buildHints() {
            const hints = [];
            const data = $scope.data || {};

            if (data.excluded_rows) {
                hints.push(
                    data.excluded_rows +
                        ' production row(s) lack a unit or reporting year and are excluded from totals.'
                );
            }
            if (($scope.units || []).length > 1) {
                hints.push(
                    'Volumes span ' +
                        $scope.units.length +
                        ' units (' +
                        $scope.units.join(', ') +
                        ') and are reported separately, never summed.'
                );
            }
            const unspecified = ($scope.records || []).filter(function(row) {
                return row.product_importance === 'unspecified';
            });
            if (unspecified.length) {
                hints.push(unspecified.length + ' row(s) have no explicit primary/secondary product importance.');
            }
            $scope.dataQualityHints = hints;
        }

        function renderCharts() {
            const data = $scope.data || {};

            siAnalyticsCharts.donut(
                'productionPrimaryChart',
                (data.primary_distribution || []).map(function(entry) {
                    return { label: entry.product, value: entry.fo_count };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.num(value) + ' FO(s)';
                    },
                    emptyMessage: 'No primary products reported'
                }
            );

            siAnalyticsCharts.donut(
                'productionSecondaryChart',
                (data.secondary_distribution || []).map(function(entry) {
                    return { label: entry.product, value: entry.fo_count };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.num(value) + ' FO(s)';
                    },
                    emptyMessage: 'No secondary products reported'
                }
            );

            // One grouped chart per unit: comparing across units would be
            // meaningless, so each unit keeps its own axis and its own chart.
            ($scope.units || []).forEach(function(unit, index) {
                const rows = topProductsForUnit(unit).map(function(entry) {
                    return {
                        label: entry.product,
                        values: [
                            {
                                key: VOLUME_LABELS.volume_purchased_from_members,
                                value: entry.volume_purchased_from_members
                            },
                            {
                                key: VOLUME_LABELS.volume_purchased_from_others,
                                value: entry.volume_purchased_from_others
                            },
                            { key: VOLUME_LABELS.volume_sold, value: entry.volume_sold }
                        ]
                    };
                });
                siAnalyticsCharts.groupedBar(
                    'productionTopChart' + index,
                    rows,
                    [
                        VOLUME_LABELS.volume_purchased_from_members,
                        VOLUME_LABELS.volume_purchased_from_others,
                        VOLUME_LABELS.volume_sold
                    ],
                    { emptyMessage: 'No sold volume reported in ' + unit }
                );
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }

        function exportCSV() {
            const headers = [
                'FO',
                'Reporting year',
                'Country',
                'Product',
                'Importance',
                'Purchased from members',
                'Purchased from others',
                'Purchase unit',
                'Sold volume',
                'Sold unit',
                'Data status'
            ];
            const lines = [headers.join(',')];

            ($scope.visibleRecords || []).forEach(function(row) {
                lines.push(
                    [
                        row.fo_name,
                        row.year,
                        row.country,
                        row.product_name,
                        row.product_importance,
                        row.volume_purchased_from_members,
                        row.volume_purchased_from_others,
                        purchaseUnit(row),
                        row.volume_sold,
                        row.sold_unit,
                        (row.data_status || []).join('; ')
                    ]
                        .map(function(value) {
                            const cell = value === null || value === undefined ? '' : value;
                            return '"' + String(cell).replace(/"/g, '""') + '"';
                        })
                        .join(',')
                );
            });

            const blob = new Blob(['﻿' + lines.join('\r\n')], {
                type: 'text/csv;charset=utf-8;'
            });
            const link = $document[0].createElement('a');
            link.href = $window.URL.createObjectURL(blob);
            link.download = 'project-' + projectId + '-production-sales.csv';
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
            $window.URL.revokeObjectURL(link.href);
            toastr.success('Exported ' + ($scope.visibleRecords || []).length + ' rows', '', {
                timeOut: 2000
            });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Financial Information tab of the project analytics dashboard.
     *
     * All figures come pre-computed from
     * `/projects/projects/{id}/analytics/financials/`, which aggregates over the
     * FO population selected by the global filters. This controller only shapes
     * the payload for display and handles the local drill-down filters, so a
     * KPI, its sample size and the table beneath it can never disagree.
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsFinancialController', projectAnalyticsFinancialController);

    projectAnalyticsFinancialController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsFinancialController(
        $scope,
        $rootScope,
        $stateParams,
        $timeout,
        $window,
        $document,
        toastr,
        siProjects,
        siProjectAnalytics,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;

        $scope.charts = siAnalyticsCharts;
        $scope.ui = { darkMode: false, rightbarClosed: false };
        $scope.availableCurrencies = ['USD'];
        $scope.toolTypeOptions = [];
        $scope.isLoading = true;
        $scope.dataQualityHints = [];

        // local drill-down filters — these narrow the table only
        $scope.local = { fo: [], year: [], country: [], value_chain: [], currency: [] };
        $scope.options = { fo: [], year: [], country: [], value_chain: [], currency: [] };
        $scope.sort = siAnalyticsCharts.sorter('turnover', true);

        $scope.applyLocalFilters = applyLocalFilters;
        $scope.clearLocalFilters = clearLocalFilters;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.exportCSV = exportCSV;
        $scope.flagLabel = flagLabel;
        $scope.hasFlag = hasFlag;
        $scope.isThin = isThin;

        const FLAG_LABELS = {
            missing_financial_year: 'Financial year missing',
            missing_currency: 'Currency missing',
            negative_turnover: 'Negative turnover',
            gross_profit_exceeds_turnover: 'Gross profit exceeds turnover',
            zero_turnover_with_gross_profit: 'Zero turnover but gross profit reported',
            zero_turnover_with_net_profit: 'Zero turnover but net profit reported',
            gross_margin_out_of_range: 'Gross margin outside validation range',
            net_margin_out_of_range: 'Net margin outside validation range'
        };

        initTheme();
        loadProjectName();
        // `loadFilterOptions` binds the shared filter panel and performs the
        // initial load once the stored filters have been reconciled against
        // this project (FR-017). Calling `load()` here as well fetched twice,
        // and the first of the two used filters that had not been reconciled.
        loadFilterOptions();

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);

        const themeOff = $rootScope.$on('pad-theme-changed', function() {
            $timeout(renderCharts, 250);
        });

        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
        }

        /**
         * The project's tool types, for the shared Tool Type filter.
         * AD-2106 §10. Loaded once: the options describe the project, not the
         * current selection, so they must not shrink as filters are applied.
         */
        /**
         * The one shared filter panel. AD-2116 FR-001, FR-002.
         *
         * `bindFilterScope` owns the filter state, the options, validation,
         * chips, clearing and the score shortcuts, so every tab behaves the
         * same way. This controller keeps `load`, because only it knows what
         * its own tab fetches.
         */
        function loadFilterOptions() {
            return siProjectAnalytics.bindFilterScope($scope, projectId, 'financials', load);
        }

        function load() {
            $scope.isLoading = true;
            const loader = siAnalyticsLoader.begin($scope);

            return siProjectAnalytics
                .getFinancials(projectId, $scope.filters)
                .then(function(data) {
                    loader.received();
                    $scope.data = data;
                    $scope.population = data.population;
                    $scope.kpis = data.kpis;
                    $scope.byYear = data.by_year;
                    $scope.completeness = data.completeness;
                    $scope.records = data.records;

                    applyCurrencyOptions(data);
                    buildOptions(data.records);
                    applyLocalFilters();
                    buildHints();

                    $scope.filterSummary = siProjectAnalytics.describeFilters($scope.filters);
                    $scope.isPageLoaded = true;
                    $timeout(renderCharts, 250).finally(loader.finish);
                })
                .catch(function(error) {
                    loader.fail();
                    toastr.error('Could not load financial analytics', 'Error');
                    $window.console.error('Financial analytics error:', error);
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Drill-down
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * The reporting currencies offered by the selector. AD-2106 §3.
         *
         * Taken from `available_currencies`, which the backend computes over the
         * whole filtered population rather than over the rows built for the
         * currently selected currency.
         */
        function applyCurrencyOptions(data) {
            $scope.availableCurrencies = (data || {}).available_currencies || ['USD'];
        }

        function buildOptions(records) {
            $scope.options.fo = siAnalyticsCharts.distinct(records, 'fo_name');
            $scope.options.year = siAnalyticsCharts.distinct(records, 'financial_year');
            $scope.options.country = siAnalyticsCharts.distinct(records, 'country');
            $scope.options.value_chain = siAnalyticsCharts.distinct(records, 'value_chain');
            $scope.options.currency = siAnalyticsCharts.distinct(records, 'currency');
        }

        function applyLocalFilters() {
            const local = $scope.local;
            $scope.visibleRecords = ($scope.records || []).filter(function(row) {
                return (
                    siAnalyticsCharts.matchesSelection(row.fo_name, local.fo) &&
                    siAnalyticsCharts.matchesSelection(row.financial_year, local.year) &&
                    siAnalyticsCharts.matchesSelection(row.country, local.country) &&
                    siAnalyticsCharts.matchesSelection(row.value_chain, local.value_chain) &&
                    siAnalyticsCharts.matchesSelection(row.currency, local.currency)
                );
            });
        }

        function clearLocalFilters() {
            $scope.local = { fo: [], year: [], country: [], value_chain: [], currency: [] };
            applyLocalFilters();
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Presentation
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function buildHints() {
            const hints = [];
            const population = $scope.population || {};
            const kpis = $scope.kpis || {};

            if (population.fo_count && kpis.average_turnover && isThin(kpis.average_turnover.n)) {
                hints.push(
                    'Turnover is reported for only ' + kpis.average_turnover.n + ' of ' + population.fo_count + ' FOs.'
                );
            }
            const flagged = ($scope.records || []).filter(function(row) {
                return row.data_status && row.data_status.length;
            });
            if (flagged.length) {
                hints.push(flagged.length + ' statement(s) carry validation warnings.');
            }

            const records = $scope.records || [];
            if (!records.length && population.fo_count) {
                hints.push('No financial statements are available for the filtered FOs.');
            }

            // AD-2106 feedback §2: a statement in another currency is no longer
            // dropped from the tab, so say why its figures are absent from the
            // KPIs and charts instead of leaving an unexplained gap.
            const unconvertible = records.filter(function(row) {
                return !row.reporting_available;
            });
            if (unconvertible.length) {
                hints.push(
                    unconvertible.length +
                        ' statement(s) cannot be expressed in ' +
                        population.currency +
                        ' and are excluded from the KPIs and charts. They stay in the table below, in the ' +
                        'currency they were reported in.'
                );
            }
            if (records.length && kpis.fiscal_year && !kpis.average_turnover.n) {
                hints.push(
                    'No FO reports turnover in ' +
                        population.currency +
                        ' for fiscal year ' +
                        kpis.fiscal_year +
                        '. The reporting currency does not change which fiscal year the KPIs cover.'
                );
            }
            $scope.dataQualityHints = hints;
        }

        function isThin(sampleSize) {
            return siProjectAnalytics.isSampleThin(sampleSize, ($scope.population || {}).fo_count);
        }

        function hasFlag(row, flag) {
            return !!row.data_status && row.data_status.indexOf(flag) !== -1;
        }

        function flagLabel(flag) {
            return FLAG_LABELS[flag] || flag;
        }

        function renderCharts() {
            const currency = ($scope.population || {}).currency;
            const byYear = $scope.byYear || [];

            siAnalyticsCharts.bar(
                'financialTurnoverChart',
                byYear
                    .filter(function(entry) {
                        return !siAnalyticsCharts.isMissing(entry.average_turnover);
                    })
                    .map(function(entry) {
                        return {
                            label: String(entry.year),
                            value: entry.average_turnover,
                            tooltip:
                                entry.year +
                                '\nAverage turnover: ' +
                                siAnalyticsCharts.money(entry.average_turnover, currency) +
                                '\nN=' +
                                entry.turnover_n +
                                ' of ' +
                                entry.fo_population +
                                ' FOs'
                        };
                    }),
                { rotateLabels: false, emptyMessage: 'No turnover reported for the current filters' }
            );

            siAnalyticsCharts.bar(
                'financialGrossProfitChart',
                byYear
                    .filter(function(entry) {
                        return !siAnalyticsCharts.isMissing(entry.average_gross_profit);
                    })
                    .map(function(entry) {
                        return {
                            label: String(entry.year),
                            value: entry.average_gross_profit,
                            // gross profit has its own denominator, not turnover's
                            tooltip:
                                entry.year +
                                '\nAverage gross profit: ' +
                                siAnalyticsCharts.money(entry.average_gross_profit, currency) +
                                '\nN=' +
                                entry.gross_n +
                                ' of ' +
                                entry.fo_population +
                                ' FOs'
                        };
                    }),
                { rotateLabels: false, emptyMessage: 'No gross profit reported for the current filters' }
            );

            siAnalyticsCharts.horizontalBar(
                'financialTopFOsChart',
                (($scope.kpis || {}).top_turnover_fos || []).map(function(entry) {
                    return {
                        label: entry.fo_name || '—',
                        value: entry.turnover,
                        tooltip:
                            entry.fo_name +
                            '\n' +
                            siAnalyticsCharts.money(entry.turnover, entry.currency) +
                            '\nFinancial year ' +
                            entry.financial_year
                    };
                }),
                {
                    height: 220,
                    labelFormat: function(value) {
                        return siAnalyticsCharts.money(value, currency);
                    },
                    emptyMessage: 'No turnover reported for the current filters'
                }
            );
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }

        function exportCSV() {
            const currency = ($scope.population || {}).currency;
            const headers = [
                'FO',
                'Assessment ID',
                'Assessment date',
                'Financial year',
                'Currency',
                'Turnover',
                'Gross profit',
                'Gross margin %',
                'Net profit',
                'Net margin %',
                'Country',
                'Value chain',
                'Data status'
            ];
            const lines = [headers.join(',')];

            ($scope.visibleRecords || []).forEach(function(row) {
                lines.push(
                    [
                        row.fo_name,
                        row.assessment_id,
                        row.assessment_date,
                        row.financial_year,
                        row.currency || currency,
                        row.turnover,
                        row.gross_profit,
                        row.gross_margin_pct,
                        row.net_profit,
                        row.net_margin_pct,
                        row.country,
                        row.value_chain,
                        (row.data_status || []).join('; ')
                    ]
                        .map(function(value) {
                            const cell = value === null || value === undefined ? '' : value;
                            return '"' + String(cell).replace(/"/g, '""') + '"';
                        })
                        .join(',')
                );
            });

            const blob = new Blob(['﻿' + lines.join('\r\n')], {
                type: 'text/csv;charset=utf-8;'
            });
            const link = $document[0].createElement('a');
            link.href = $window.URL.createObjectURL(blob);
            link.download = 'project-' + projectId + '-financial-analytics.csv';
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
            $window.URL.revokeObjectURL(link.href);
            toastr.success('Exported ' + ($scope.visibleRecords || []).length + ' rows', '', {
                timeOut: 2000
            });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Finance History tab of the project analytics dashboard.
     *
     * Loans, grants and pre-finance each get their own KPIs, breakdowns and
     * drill-down table. Facility counts and FO counts are always shown as
     * separate numbers, funding shares are amount-based, and repayment status
     * appears for loans only — grants have no repayment concept.
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsFinanceHistoryController', projectAnalyticsFinanceHistoryController);

    projectAnalyticsFinanceHistoryController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsFinanceHistoryController(
        $scope,
        $rootScope,
        $stateParams,
        $timeout,
        $window,
        $document,
        toastr,
        siProjects,
        siProjectAnalytics,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;

        const TYPES = [
            { key: 'loans', label: 'Loan', plural: 'Loans' },
            { key: 'grants', label: 'Grant', plural: 'Grants' },
            { key: 'pre_finance', label: 'Pre-finance', plural: 'Pre-finance' }
        ];

        $scope.charts = siAnalyticsCharts;
        $scope.types = TYPES;
        $scope.ui = { darkMode: false, rightbarClosed: false };
        $scope.availableCurrencies = ['USD'];
        $scope.toolTypeOptions = [];
        $scope.isLoading = true;
        $scope.dataQualityHints = [];

        // one shared set of local filters across all three tables, as specified
        $scope.local = { fo: [], year: [], financier_type: [] };
        $scope.options = { fo: [], year: [], financier_type: [] };
        $scope.sort = {
            loans: siAnalyticsCharts.sorter('amount', true),
            grants: siAnalyticsCharts.sorter('amount', true),
            pre_finance: siAnalyticsCharts.sorter('amount', true)
        };
        $scope.visible = { loans: [], grants: [], pre_finance: [] };

        $scope.applyLocalFilters = applyLocalFilters;
        $scope.clearLocalFilters = clearLocalFilters;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.exportCSV = exportCSV;
        $scope.yearLabel = yearLabel;

        initTheme();
        loadProjectName();
        // `loadFilterOptions` binds the shared filter panel and performs the
        // initial load once the stored filters have been reconciled against
        // this project (FR-017). Calling `load()` here as well fetched twice,
        // and the first of the two used filters that had not been reconciled.
        loadFilterOptions();

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);

        const themeOff = $rootScope.$on('pad-theme-changed', function() {
            $timeout(renderCharts, 250);
        });

        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
        }

        /**
         * The project's tool types, for the shared Tool Type filter.
         * AD-2106 §10. Loaded once: the options describe the project, not the
         * current selection, so they must not shrink as filters are applied.
         */
        /**
         * The one shared filter panel. AD-2116 FR-001, FR-002.
         *
         * `bindFilterScope` owns the filter state, the options, validation,
         * chips, clearing and the score shortcuts, so every tab behaves the
         * same way. This controller keeps `load`, because only it knows what
         * its own tab fetches.
         */
        function loadFilterOptions() {
            return siProjectAnalytics.bindFilterScope($scope, projectId, 'finance-history', load);
        }

        function load() {
            $scope.isLoading = true;
            const loader = siAnalyticsLoader.begin($scope);

            return siProjectAnalytics
                .getFinanceHistory(projectId, $scope.filters)
                .then(function(data) {
                    loader.received();
                    $scope.data = data;
                    $scope.population = data.population;

                    buildCurrencyOptions(data);
                    buildOptions(data);
                    applyLocalFilters();
                    buildHints();

                    $scope.filterSummary = siProjectAnalytics.describeFilters($scope.filters);
                    $scope.isPageLoaded = true;
                    $timeout(renderCharts, 250).finally(loader.finish);
                })
                .catch(function(error) {
                    loader.fail();
                    toastr.error('Could not load finance history analytics', 'Error');
                    $window.console.error('Finance history analytics error:', error);
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Drill-down
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /** Every facility record across the three finance types. */
        function allRecords(data) {
            let records = [];
            TYPES.forEach(function(type) {
                const block = (data || $scope.data || {})[type.key];
                if (block && block.records) {
                    records = records.concat(block.records);
                }
            });
            return records;
        }

        /**
         * The reporting currencies offered by the selector. AD-2106 §3.
         *
         * `available_currencies` is computed over the filtered population, so it
         * still lists the local currencies while USD is being shown. Reading
         * `original_currency` off the records - as this did - only ever returned
         * currencies that survived conversion into the current selection.
         */
        function buildCurrencyOptions(data) {
            $scope.availableCurrencies = (data || {}).available_currencies || ['USD'];
        }

        function buildOptions(data) {
            const records = allRecords(data);
            $scope.options.fo = siAnalyticsCharts.distinct(records, 'fo_name');
            $scope.options.year = siAnalyticsCharts.distinct(records, 'year');
            $scope.options.financier_type = siAnalyticsCharts.distinct(records, 'financier_type');
        }

        function applyLocalFilters() {
            const local = $scope.local;
            TYPES.forEach(function(type) {
                const block = ($scope.data || {})[type.key];
                const records = block && block.records ? block.records : [];
                $scope.visible[type.key] = records.filter(function(row) {
                    return (
                        siAnalyticsCharts.matchesSelection(row.fo_name, local.fo) &&
                        siAnalyticsCharts.matchesSelection(row.year, local.year) &&
                        siAnalyticsCharts.matchesSelection(row.financier_type, local.financier_type)
                    );
                });
            });
        }

        function clearLocalFilters() {
            $scope.local = { fo: [], year: [], financier_type: [] };
            applyLocalFilters();
        }

        function yearLabel(year) {
            return year === null || year === undefined ? 'Not reported' : year;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Presentation
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function buildHints() {
            const hints = [];
            const data = $scope.data || {};

            if (data.duplicates_dropped) {
                hints.push(
                    data.duplicates_dropped +
                        ' duplicate facility record(s) were excluded (repeated across reassessments).'
                );
            }
            const undated = allRecords().filter(function(row) {
                return row.year === null || row.year === undefined;
            });
            if (undated.length) {
                hints.push(
                    undated.length +
                        ' facility record(s) have no start date, so they are absent from the by-year chart.'
                );
            }
            const unpriced = allRecords().filter(function(row) {
                return row.amount === null || row.amount === undefined;
            });
            if (unpriced.length) {
                hints.push(
                    unpriced.length +
                        ' facility record(s) have no amount in ' +
                        ($scope.population || {}).currency +
                        ' and are excluded from totals.'
                );
            }
            $scope.dataQualityHints = hints;
        }

        function renderCharts() {
            const data = $scope.data || {};
            const currency = ($scope.population || {}).currency;
            const loans = data.loans || {};

            // Task 2.9 — average loan by year, labelled with both counts
            siAnalyticsCharts.line(
                'financeLoanByYearChart',
                (loans.by_year || [])
                    .filter(function(entry) {
                        return entry.year !== null && entry.year !== undefined;
                    })
                    .map(function(entry) {
                        return {
                            label: String(entry.year),
                            value: entry.average_amount,
                            tooltip:
                                entry.year +
                                '\nAverage loan: ' +
                                siAnalyticsCharts.money(entry.average_amount, currency) +
                                '\nLoans: ' +
                                entry.count +
                                '\nFOs receiving loans: ' +
                                entry.fo_count
                        };
                    }),
                { emptyMessage: 'No dated loans for the current filters' }
            );

            // Task 2.10 — amount-based, not count-based
            siAnalyticsCharts.donut(
                'financeFundingTypeChart',
                (data.funding_by_amount_share || []).map(function(entry) {
                    return { label: entry.finance_type, value: entry.total_amount };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.money(value, currency);
                    },
                    emptyMessage: 'No funding amounts for the current filters'
                }
            );

            siAnalyticsCharts.donut(
                'financeLoanPurposeChart',
                (loans.by_purpose || []).map(function(entry) {
                    return { label: entry.label, value: entry.total_amount, n: entry.count };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.money(value, currency);
                    },
                    emptyMessage: 'No loan purposes recorded'
                }
            );

            siAnalyticsCharts.donut(
                'financeFinancierTypeChart',
                (loans.by_financier_type || []).map(function(entry) {
                    return { label: entry.label, value: entry.total_amount, n: entry.count };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.money(value, currency);
                    },
                    emptyMessage: 'No financier types recorded'
                }
            );

            // Task 2.13 — count-based share of loans by repayment status
            siAnalyticsCharts.donut(
                'financeRepaymentChart',
                (loans.by_repayment_status || []).map(function(entry) {
                    return { label: entry.label, value: entry.count };
                }),
                {
                    valueFormat: function(value) {
                        return siAnalyticsCharts.num(value) + ' loan(s)';
                    },
                    emptyMessage: 'No repayment statuses recorded'
                }
            );
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }

        function exportCSV() {
            const headers = [
                'Finance type',
                'FO',
                'Amount',
                'Currency',
                'Original currency',
                'Year',
                'Financier type',
                'Financier name',
                'Purpose',
                'Repayment status',
                'Repayment modality',
                'Cash or in kind'
            ];
            const lines = [headers.join(',')];

            TYPES.forEach(function(type) {
                ($scope.visible[type.key] || []).forEach(function(row) {
                    lines.push(
                        [
                            row.finance_type,
                            row.fo_name,
                            row.amount,
                            row.currency,
                            row.original_currency,
                            row.year === null || row.year === undefined ? 'Not reported' : row.year,
                            row.financier_type,
                            row.financier_name,
                            row.purpose,
                            row.repayment_status,
                            row.repayment_modality,
                            row.in_cash_or_in_kind
                        ]
                            .map(function(value) {
                                const cell = value === null || value === undefined ? '' : value;
                                return '"' + String(cell).replace(/"/g, '""') + '"';
                            })
                            .join(',')
                    );
                });
            });

            const blob = new Blob(['﻿' + lines.join('\r\n')], {
                type: 'text/csv;charset=utf-8;'
            });
            const link = $document[0].createElement('a');
            link.href = $window.URL.createObjectURL(blob);
            link.download = 'project-' + projectId + '-finance-history.csv';
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
            $window.URL.revokeObjectURL(link.href);
            toastr.success('Exported finance history', '', { timeOut: 2000 });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Demographics tab of the project analytics dashboard.
     *
     * AD-2126: built the way the other analytics tabs are - shared page
     * classes, `siAnalyticsCharts` for the charts, the same loading, theme and
     * resize handling - so the tab no longer carries its own stylesheet or its
     * own d3 drawing code.
     *
     * AD-2193: every demographic indicator the assessment collects - nine, in
     * three sections - each with its total, male and female figures, the
     * per-FO minimum, average and maximum, the number of FOs behind each
     * figure, and the gender split over the FOs that recorded both genders.
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsDemographicsController', projectAnalyticsDemographicsController);

    projectAnalyticsDemographicsController.$inject = [
        '$scope',
        '$rootScope',
        '$log',
        '$stateParams',
        '$timeout',
        '$window',
        '$document',
        'gettext',
        'gettextCatalog',
        'toastr',
        'siProjects',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'siAnalyticsCharts'
    ];

    function projectAnalyticsDemographicsController(
        $scope,
        $rootScope,
        $log,
        $stateParams,
        $timeout,
        $window,
        $document,
        gettext,
        gettextCatalog,
        toastr,
        siProjects,
        siProjectAnalytics,
        siAnalyticsLoader,
        siAnalyticsCharts
    ) {
        const projectId = $stateParams.id;

        $scope.charts = siAnalyticsCharts;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.exportDemographicsCSV = exportDemographicsCSV;
        $scope.exportDrilldownCSV = exportDrilldownCSV;
        $scope.applyLocalFilters = applyLocalFilters;
        $scope.clearLocalFilters = clearLocalFilters;

        /**
         * The drill-down table (AD-2126 feedback): one row per FO, in the
         * column order of the Demographics export the table mirrors. Built
         * once - the template repeats over it (#289).
         */
        $scope.drilldownColumns = [
            { key: 'name', label: gettext('Name') },
            { key: 'tool', label: gettext('Tool') },
            { key: 'country', label: gettext('Country') },
            { key: 'city', label: gettext('City') },
            { key: 'legal_status', label: gettext('Legal status') },
            { key: 'year_of_incorporation', label: gettext('Inc year'), numeric: true, plain: true },
            { key: 'assessment_date', label: gettext('Assessment date') },
            { key: 'total_score', label: gettext('Total score'), numeric: true, score: true },
            { key: 'male_members', label: gettext('Male Members'), numeric: true },
            { key: 'female_members', label: gettext('Female Members'), numeric: true },
            { key: 'active_male_members', label: gettext('Active Male Members'), numeric: true },
            { key: 'active_female_members', label: gettext('Active Female Members'), numeric: true },
            { key: 'male_outgrowers', label: gettext('Male Outgrowers'), numeric: true },
            { key: 'female_outgrowers', label: gettext('Female Outgrowers'), numeric: true },
            { key: 'active_male_outgrowers', label: gettext('Active Male Outgrowers'), numeric: true },
            { key: 'active_female_outgrowers', label: gettext('Active Female Outgrowers'), numeric: true },
            { key: 'male_fulltime_employees', label: gettext('Male Full-Time Employees'), numeric: true },
            { key: 'female_fulltime_employees', label: gettext('Female Full-Time Employees'), numeric: true },
            { key: 'male_parttime_employees', label: gettext('Male Part-Time Employees'), numeric: true },
            { key: 'female_parttime_employees', label: gettext('Female Part-Time Employees'), numeric: true },
            { key: 'male_managers', label: gettext('Male Managers'), numeric: true },
            { key: 'female_managers', label: gettext('Female Managers'), numeric: true },
            { key: 'member_cooperatives', label: gettext('Member Cooperatives'), numeric: true },
            { key: 'member_unions', label: gettext('Member Unions'), numeric: true }
        ];
        $scope.records = [];
        $scope.visibleRecords = [];
        $scope.local = { name: [], country: [], tool: [], legal_status: [] };
        $scope.options = { name: [], country: [], tool: [], legal_status: [] };
        $scope.sort = siAnalyticsCharts.sorter('name', false);

        $scope.ui = { darkMode: false, rightbarClosed: false };
        $scope.isLoading = true;
        $scope.isPageLoaded = false;
        $scope.loadFailed = false;

        $scope.demographics = {
            totalAssessments: 0,
            numberOfFOs: 0,
            countries: '',
            countryList: [],
            averageScore: null
        };

        /**
         * The nine indicators in the sections the tab shows them in (AD-2193).
         * Built once: the template repeats over these arrays, and a fresh
         * literal per digest would never settle (#289). `applyPayload` fills
         * each indicator's `data` and `rows` in place.
         */
        $scope.sections = [
            {
                key: 'board',
                title: gettext('Board and Management'),
                chartId: 'demographicsBoardChart',
                indicators: [
                    { payloadKey: 'board_members', label: gettext('Board members') },
                    { payloadKey: 'management', label: gettext('Managers') }
                ]
            },
            {
                key: 'employees',
                title: gettext('Employees'),
                chartId: 'demographicsEmployeesChart',
                indicators: [
                    { payloadKey: 'employees_fulltime', label: gettext('Full-time employees') },
                    { payloadKey: 'employees_parttime', label: gettext('Part-time employees') },
                    { payloadKey: 'employees_seasonal', label: gettext('Seasonal employees') }
                ]
            },
            {
                key: 'membership',
                title: gettext('Membership and Outgrowers'),
                chartId: 'demographicsMembershipChart',
                indicators: [
                    { payloadKey: 'membership', label: gettext('Members') },
                    { payloadKey: 'active_membership', label: gettext('Active members') },
                    { payloadKey: 'outgrowers', label: gettext('Outgrowers') },
                    { payloadKey: 'active_outgrowers', label: gettext('Active outgrowers') }
                ]
            }
        ];
        const INDICATORS = {};
        $scope.sections.forEach(section =>
            section.indicators.forEach(indicator => {
                indicator.data = null;
                indicator.rows = [];
                INDICATORS[indicator.payloadKey] = indicator;
            })
        );

        /**
         * The headline cards beside FOs, countries and score: three, so the
         * row of six cards stays two even rows. Managers are in their section.
         */
        $scope.headlines = ['membership', 'outgrowers', 'employees_fulltime'].map(key => INDICATORS[key]);

        const SERIES = [
            { key: 'total', label: gettext('Total') },
            { key: 'male', label: gettext('Male') },
            { key: 'female', label: gettext('Female') }
        ];

        initTheme();
        loadProjectName();
        // The shared filter panel owns the filters and performs the initial
        // load once the stored filters are reconciled; this tab owns `load`.
        siProjectAnalytics.bindFilterScope($scope, projectId, 'demographics', load);

        let resizeTimer = null;
        function handleResize() {
            if (resizeTimer) {
                $timeout.cancel(resizeTimer);
            }
            resizeTimer = $timeout(renderCharts, 200);
        }
        $window.addEventListener('resize', handleResize);

        const themeOff = $rootScope.$on('pad-theme-changed', function() {
            $timeout(renderCharts, 250);
        });

        $scope.$on('$destroy', function() {
            $window.removeEventListener('resize', handleResize);
            themeOff();
            siAnalyticsCharts.destroyTooltip();
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function loadProjectName() {
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name', 'customer'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
        }

        /**
         * FR-013 / AC-007. Demographics is served from the shared population:
         * the same `eligible_assessments` as every other tab, latest finalised
         * assessment per FO, filters applied on the server. The aggregation is
         * the server's too - nothing below recomputes a total, a percentage or
         * a spread.
         */
        function load() {
            $scope.isLoading = true;
            $scope.loadFailed = false;
            const loader = siAnalyticsLoader.begin($scope);

            return siProjectAnalytics
                .getDemographics(projectId, $scope.filters)
                .then(function(payload) {
                    loader.received();
                    $scope.payload = payload;
                    applyPayload(payload);
                    $scope.isPageLoaded = true;
                    $timeout(renderCharts, 250).finally(loader.finish);
                })
                .catch(function(error) {
                    loader.fail();
                    $scope.loadFailed = true;
                    $scope.isPageLoaded = false;
                    toastr.error('Could not load demographics', 'Error');
                    $log.error('Demographics analytics error:', error);
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /**
         * Map the server payload onto the view model.
         *
         * A mapping, not a calculation. Every number here is read straight from
         * the response; a figure nobody reported stays `null` rather than
         * becoming a confident zero, and a reported zero stays zero.
         */
        function applyPayload(payload) {
            const data = payload || {};
            const groups = data.demographics || {};
            const population = data.population || {};
            const distributions = data.distributions || {};

            $scope.demographics.totalAssessments = population.assessment_count;
            $scope.demographics.numberOfFOs = population.fo_count;
            $scope.demographics.countryList = (distributions.country || []).map(entry => entry.name);
            $scope.demographics.countries = $scope.demographics.countryList.join(', ') || '--';
            // Server-computed, and left null when nothing is scored rather than
            // shown as 0.0 - an average of zero is a statement about how the
            // FOs performed, and there is nothing here to make it about.
            $scope.demographics.averageScore =
                data.average_score === null || angular.isUndefined(data.average_score) ? null : data.average_score;

            Object.keys(INDICATORS).forEach(key => {
                const indicator = INDICATORS[key];
                indicator.data = groups[key] || null;
                indicator.rows = buildRows(indicator.data);
            });
            applyRecords(data.records);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Drill-down table
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function applyRecords(records) {
            $scope.records = records || [];
            Object.keys($scope.options).forEach(key => {
                $scope.options[key] = siAnalyticsCharts.distinct($scope.records, key);
            });
            applyLocalFilters();
        }

        /** Table filters narrow the rows only; the rail rebuilds the tab. */
        function applyLocalFilters() {
            const local = $scope.local;
            $scope.visibleRecords = $scope.records.filter(row =>
                Object.keys(local).every(key => siAnalyticsCharts.matchesSelection(row[key], local[key]))
            );
        }

        function clearLocalFilters() {
            $scope.local = { name: [], country: [], tool: [], legal_status: [] };
            applyLocalFilters();
        }

        function exportDrilldownCSV() {
            const cell = value =>
                '"' + (value === null || angular.isUndefined(value) ? '' : String(value)).replace(/"/g, '""') + '"';
            const columns = $scope.drilldownColumns;
            const rows = [columns.map(column => cell(gettextCatalog.getString(column.label))).join(',')];
            $scope.visibleRecords.forEach(row => rows.push(columns.map(column => cell(row[column.key])).join(',')));
            const blob = new Blob(['\ufeff' + rows.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
            const url = $window.URL.createObjectURL(blob);
            const a = $document[0].createElement('a');
            a.href = url;
            a.download = `project_${projectId}_demographics_drilldown_${new Date().toISOString().split('T')[0]}.csv`;
            $document[0].body.appendChild(a);
            a.click();
            $document[0].body.removeChild(a);
            $window.URL.revokeObjectURL(url);
            toastr.success(gettextCatalog.getString(gettext('Demographics table exported')), '', {
                timeOut: 2000,
                progressBar: true
            });
        }

        /**
         * Total, male and female rows of one indicator. A series no FO
         * reported is `null` - the server sums nothing to 0, and 0 would read
         * as "these FOs have none".
         */
        function buildRows(group) {
            const spread = (group && group.spread) || {};
            return SERIES.map((series, index) => {
                const values = spread[series.key] || {};
                const reported = values.fo_count || 0;
                return {
                    first: index === 0,
                    series: series.label,
                    value: reported && group ? group[series.key] : null,
                    n: reported,
                    min: values.min,
                    avg: values.average,
                    max: values.max
                };
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Charts
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * One gender-split chart per section. The split is over the FOs that
         * recorded both genders (`gender`), not over the total: where one
         * gender is missing, those people's gender is unknown.
         */
        function renderCharts() {
            if (!$scope.isPageLoaded) {
                return;
            }
            const labels = {
                female: gettextCatalog.getString('Female'),
                male: gettextCatalog.getString('Male'),
                femaleShort: gettextCatalog.getString('female'),
                noData: gettextCatalog.getString('No gender breakdown reported'),
                incomplete: gettextCatalog.getString('FO(s) without both genders not included')
            };
            $scope.sections.forEach(section => {
                siAnalyticsCharts.genderSplit(
                    section.chartId,
                    section.indicators.map(indicator => {
                        const gender = (indicator.data && indicator.data.gender) || {};
                        return {
                            label: gettextCatalog.getString(indicator.label),
                            female: gender.female || 0,
                            male: gender.male || 0,
                            n: gender.fo_count || 0,
                            incomplete: gender.incomplete_fo_count || 0
                        };
                    }),
                    { labels: labels, labelWidth: 150 }
                );
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
            $timeout(renderCharts, 300);
        }

        function exportDemographicsCSV() {
            const cell = value =>
                '"' + (value === null || angular.isUndefined(value) ? '' : String(value)).replace(/"/g, '""') + '"';
            const line = values => values.map(cell).join(',');
            const rows = [
                line([
                    'Section',
                    'Indicator',
                    'Series',
                    'Total',
                    'FOs reporting',
                    'Min per FO',
                    'Avg per FO',
                    'Max per FO',
                    'Female share (FOs with both genders)',
                    'FOs with both genders',
                    'FOs missing a gender'
                ])
            ];

            rows.push(line(['Overview', 'Total Assessments', '', $scope.demographics.totalAssessments]));
            rows.push(line(['Overview', 'Number of FOs', '', $scope.demographics.numberOfFOs]));
            rows.push(line(['Overview', 'Countries', '', $scope.demographics.countries]));
            rows.push(line(['Overview', 'Average Score', '', $scope.demographics.averageScore]));

            $scope.sections.forEach(section => {
                section.indicators.forEach(indicator => {
                    const gender = (indicator.data && indicator.data.gender) || {};
                    indicator.rows.forEach(row => {
                        rows.push(
                            line([
                                section.title,
                                indicator.label,
                                row.series,
                                row.value,
                                row.n,
                                row.min,
                                row.avg,
                                row.max,
                                row.first ? gender.female_share : null,
                                row.first ? gender.fo_count : null,
                                row.first ? gender.incomplete_fo_count : null
                            ])
                        );
                    });
                });
            });

            const csv = '﻿' + rows.join('\r\n');

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = $window.URL.createObjectURL(blob);
            const a = $document[0].createElement('a');
            a.href = url;
            a.download = `demographics_export_${new Date().toISOString().split('T')[0]}.csv`;
            $document[0].body.appendChild(a);
            a.click();
            $document[0].body.removeChild(a);
            $window.URL.revokeObjectURL(url);

            toastr.success('Demographics data exported successfully', '', {
                timeOut: 2000,
                progressBar: true
            });
        }
    }
})();

(function() {
    'use strict';

    /**
     * Data Quality & Completeness. AD-2115, FR-024 … FR-050.
     *
     * The controller does no arithmetic. Every KPI, coverage figure, quality
     * count and percentage arrives already computed from
     * `/analytics/data-quality/`, and this file renders exactly what it is
     * given (NFR-003, AC-058). That is a requirement, not a style preference:
     * the moment a percentage is recomputed here, this tab and the endpoint can
     * disagree, and the one on screen is the one that gets believed.
     *
     * In particular there is no `|| 0` anywhere near a percentage. A null
     * coverage means "no applicable FOs" and must render as that phrase in the
     * value position (BR-007, FR-027); coercing it to zero states that nobody
     * reported, which is a different and false claim.
     */
    angular
        .module('scope.commons.projects')
        .controller('projectAnalyticsDataQualityController', ProjectAnalyticsDataQualityController);

    ProjectAnalyticsDataQualityController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$window',
        '$document',
        '$timeout',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'siProjects'
    ];

    function ProjectAnalyticsDataQualityController(
        $scope,
        $rootScope,
        $stateParams,
        $window,
        $document,
        $timeout,
        siProjectAnalytics,
        siAnalyticsLoader,
        siProjects
    ) {
        const projectId = $stateParams.id;

        $scope.ui = { darkMode: false, rightbarClosed: false };
        $scope.isLoading = true;
        $scope.loadFailed = false;
        $scope.data = null;
        $scope.availabilitySections = [];
        $scope.yesNoRows = [];
        $scope.drilldown = null;

        $scope.openDrilldown = openDrilldown;
        $scope.closeDrilldown = closeDrilldown;
        $scope.coverageLabel = coverageLabel;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;

        activate();

        function activate() {
            initTheme();
            // `siProjects` has no `getProject`. It exposes the Restangular
            // collection as `siProjects.projects`, and every other analytics
            // tab reads the project name through it. Calling a method that
            // does not exist threw a TypeError while the controller was being
            // instantiated, which aborted the state transition *inside* a
            // digest - so the tab never rendered and the next `$apply`
            // anywhere in the app died with `$digest already in progress`.
            // That is why one click on this tab froze the whole dashboard
            // until a reload, not just this page.
            //
            // `.catch` could never have helped: the throw is synchronous and
            // happens before there is a promise to attach it to.
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
            // The shared filter panel owns the filters; this tab owns `load`.
            siProjectAnalytics.bindFilterScope($scope, projectId, 'data-quality', load);
        }

        function load() {
            $scope.isLoading = true;
            $scope.loadFailed = false;
            const loader = siAnalyticsLoader.begin($scope);
            return siProjectAnalytics
                .getDataQuality(projectId, $scope.filters)
                .then(function(payload) {
                    loader.received();
                    $scope.data = payload;
                    // The shared rail reads `population` off the tab's scope;
                    // this tab never set it, so its Population box showed dashes.
                    $scope.population = payload.population;
                    buildSectionLists(payload);
                    loader.finish();
                })
                .catch(function() {
                    loader.fail();
                    // FR-050: a load failure is not an empty population. The
                    // template keeps them apart, because "this project has no
                    // data" and "we could not fetch it" call for different
                    // actions from the reader.
                    $scope.data = null;
                    $scope.population = null;
                    $scope.availabilitySections = [];
                    $scope.yesNoRows = [];
                    $scope.loadFailed = true;
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /**
         * Build the two repeated lists **once per load**, not per digest.
         *
         * These were array literals inside `ng-repeat`. AngularJS re-evaluates
         * the expression on every digest, so the literal produced brand-new
         * objects each time, `ng-repeat` saw a changed collection every pass,
         * and the page died with `[$rootScope:infdig] 10 $digest() iterations
         * reached` - a blank tab, not a subtle mis-render.
         *
         * Built here the identity is stable between digests and the loop
         * settles. The alternative, `track by`, would silence the symptom while
         * still rebuilding both arrays on every digest.
         */
        function buildSectionLists(payload) {
            const data = payload || {};
            $scope.availabilitySections = [
                {
                    key: 'financial',
                    title: 'Financial information',
                    rows: (data.financial || {}).years || []
                },
                {
                    key: 'production',
                    title: 'Production',
                    rows: (data.production || {}).years || []
                }
            ];
            $scope.yesNoRows = [
                { label: 'Collateral', data: data.collateral },
                { label: 'Insurance', data: data.insurance }
            ];
        }

        /**
         * FR-027, BR-007. A null percentage is *No applicable FOs*, rendered in
         * the value position rather than as `0%`.
         */
        function coverageLabel(percentage) {
            return percentage === null || angular.isUndefined(percentage) ? 'No applicable FOs' : percentage + '%';
        }

        /**
         * FR-035 … FR-047. A drill-down narrows its own table and nothing else:
         * it never touches `$scope.data`, so no KPI, chart or population count
         * can move while one is open (FR-023).
         */
        function openDrilldown(dataset, selection, openedFrom) {
            $scope.drilldown = {
                dataset: dataset,
                selection: selection || {},
                openedFrom: openedFrom || null,
                page: 1,
                isLoading: true,
                failed: false,
                result: null
            };
            return loadDrilldownPage(1).then(revealDrilldown);
        }

        /**
         * The drill-down renders below the quality checks, out of view from
         * every link that opens it, so a click looked like it did nothing.
         * Scrolled to and focused once its rows are in - focused for keyboard
         * and screen-reader users, who would otherwise stay on the link.
         */
        function revealDrilldown() {
            $timeout(function() {
                const panel = $document[0].getElementById('dq-drilldown');
                if (!panel) {
                    return;
                }
                if (panel.scrollIntoView) {
                    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                panel.focus({ preventScroll: true });
            });
        }

        function loadDrilldownPage(page) {
            const state = $scope.drilldown;
            state.isLoading = true;
            state.failed = false;
            return siProjectAnalytics
                .getDataQualityDrilldown(
                    projectId,
                    $scope.filters,
                    angular.extend({ dataset: state.dataset, page: page }, state.selection)
                )
                .then(function(result) {
                    state.result = result;
                    state.page = page;
                })
                .catch(function() {
                    // A table-level error, leaving the tab beneath it untouched.
                    state.failed = true;
                })
                .finally(function() {
                    state.isLoading = false;
                });
        }
        $scope.loadDrilldownPage = loadDrilldownPage;

        /** FR-047: focus returns to the control that opened it. */
        function closeDrilldown() {
            const openedFrom = $scope.drilldown && $scope.drilldown.openedFrom;
            $scope.drilldown = null;
            if (openedFrom && document.getElementById(openedFrom)) {
                document.getElementById(openedFrom).focus();
            }
        }

        /*
         * The same theme handling as the other tabs. This one only flipped the
         * flag, so the button relabelled itself and nothing else changed, and
         * a dark theme chosen elsewhere was not restored on opening the tab.
         */
        function initTheme() {
            try {
                $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            } catch (error) {
                $scope.ui.darkMode = false;
            }
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            try {
                $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            } catch (error) {
                // the theme still changes for this visit
            }
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
        }
    }
})();

(function() {
    'use strict';

    /**
     * Project Analytics - Overview.
     *
     * Renders `/analytics/overview/` and computes nothing of its own. This tab
     * used to fetch every assessment in the project with all its responses,
     * rebuild the population in the browser and average the scores there, so it
     * could disagree with the other five tabs about the very figures they share.
     * Every count, average, distribution and coverage figure now comes from the
     * server, over the same filtered population as every other tab (FR-051).
     *
     * Two selections, deliberately kept apart:
     *
     * * the **filters** in the Controls & Insights rail, shared with every tab
     *   through `bindFilterScope`, which decide the population;
     * * the **score tool** (the tool cards), which decides which tool's scores
     *   the performance sections show. Scores from different tools are never
     *   combined (FR-052), so exactly one is selected, visibly, and changing it
     *   never changes the population.
     */
    angular.module('scope.commons.projects').controller('projectAnalyticsController', projectAnalyticsController);

    projectAnalyticsController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$window',
        '$document',
        'siProjects',
        'siProjectAnalytics',
        'siAnalyticsLoader',
        'toastr'
    ];

    const LAYOUT_KEY = 'pad_overview_layout';

    const DEFAULT_LAYOUT = {
        totalScore: true,
        a2fScore: true,
        dimensionChart: true,
        subdimensions: true,
        maturityReach: true
    };

    // Maturity levels, lowest first, in the design's colours.
    const LEVEL_COLOURS = {
        level_1: '#db5d62',
        level_2: '#ee7e43',
        level_3: '#5470c6',
        level_4: '#3ba272'
    };

    const LEVEL_NAMES = {
        level_1: 'Level 1',
        level_2: 'Level 2',
        level_3: 'Level 3',
        level_4: 'Level 4'
    };

    function projectAnalyticsController(
        $scope,
        $rootScope,
        $stateParams,
        $window,
        $document,
        siProjects,
        siProjectAnalytics,
        siAnalyticsLoader,
        toastr
    ) {
        const projectId = $stateParams.id;

        $scope.ui = { darkMode: false, rightbarClosed: false, customizeOpen: false };
        $scope.isLoading = true;
        $scope.loadFailed = false;
        $scope.overview = null;
        $scope.population = null;
        $scope.scoreTool = { name: null };
        $scope.toolCards = [];
        $scope.dimensions = [];
        $scope.selectedDimension = null;
        $scope.selectedSubdimensions = [];
        $scope.maturityLevels = [];
        $scope.coverageMetrics = [];
        $scope.assessees = [];
        $scope.assesseeSearch = { text: '' };
        $scope.layout = loadLayout();

        $scope.selectTool = selectTool;
        $scope.selectDimension = selectDimension;
        $scope.matchesAssesseeSearch = matchesAssesseeSearch;
        $scope.formatScore = formatScore;
        $scope.formatNumber = formatNumber;
        $scope.toolSymbol = toolSymbol;
        $scope.exportCSV = exportCSV;
        $scope.toggleDarkMode = toggleDarkMode;
        $scope.toggleRightbar = toggleRightbar;
        $scope.openCustomize = openCustomize;
        $scope.closeCustomize = closeCustomize;
        $scope.saveLayout = saveLayout;
        $scope.resetLayout = resetLayout;

        activate();

        function activate() {
            initTheme();
            siProjects.projects
                .one(projectId)
                .get({ fields: ['name', 'customer'] })
                .then(function(project) {
                    $scope.project = project;
                })
                .catch(angular.noop);
            // The shared rail owns the filters and the first load; this tab
            // owns `load`. It also publishes the rollout flags (FR-024).
            siProjectAnalytics.bindFilterScope($scope, projectId, 'overview', load);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Loading
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * `isRetry` marks the one automatic reload below, so a tool that keeps
         * coming back unavailable cannot loop.
         */
        function load(isRetry) {
            if (!$scope.scoreTool.name) {
                $scope.scoreTool.name = defaultTool();
            }
            $scope.isLoading = true;
            $scope.loadFailed = false;
            const loader = siAnalyticsLoader.begin($scope);

            return siProjectAnalytics
                .getOverview(projectId, $scope.filters, $scope.scoreTool.name)
                .then(function(payload) {
                    loader.received();
                    // The selected tool fell out of the population (the filters
                    // dropped it), or none could be chosen before the first load.
                    // Move to the largest tool that is there, once, rather than
                    // show an empty analysis the user did not ask for. The card
                    // highlight moves with it, so this is never a silent swap.
                    const largest = payload.tool_counts && payload.tool_counts[0];
                    if (
                        !isRetry &&
                        payload.tool_state !== 'tool_selected' &&
                        largest &&
                        largest.name !== $scope.scoreTool.name
                    ) {
                        $scope.scoreTool.name = largest.name;
                        return load(true);
                    }
                    apply(payload);
                    loader.finish();
                })
                .catch(function() {
                    loader.fail();
                    // A load failure is not an empty population; the template
                    // keeps the two apart.
                    $scope.overview = null;
                    $scope.population = null;
                    $scope.loadFailed = true;
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        }

        /**
         * The tool preselected on open: the one with the most assessments in
         * the project, among those the tool filter lets through.
         */
        function defaultTool() {
            const allowed = ($scope.filters && $scope.filters.tool_type) || [];
            const counts = $scope.toolTypeCounts || {};
            const candidates = ($scope.toolTypeOptions || []).filter(function(name) {
                return !allowed.length || allowed.indexOf(name) !== -1;
            });
            candidates.sort(function(a, b) {
                return (counts[b] || 0) - (counts[a] || 0);
            });
            return candidates[0] || null;
        }

        /**
         * Everything the template repeats over is built here, once per load.
         * An array built inside an `ng-repeat` expression is a new collection
         * on every digest, and loops the page into `infdig` (#289).
         */
        function apply(payload) {
            $scope.overview = payload;
            $scope.population = payload.population;
            $scope.scoreTool.name = payload.selected_tool || $scope.scoreTool.name;

            const counts = {};
            (payload.tool_counts || []).forEach(function(entry) {
                counts[entry.name] = entry.assessment_count;
            });
            const names = ($scope.toolTypeOptions || []).slice();
            Object.keys(counts).forEach(function(name) {
                if (names.indexOf(name) === -1) {
                    names.push(name);
                }
            });
            $scope.toolCards = names.map(function(name) {
                return { name: name, count: counts[name] || 0 };
            });
            $scope.toolBreakdown = $scope.toolCards
                .map(function(card) {
                    return shortToolName(card.name) + ' ' + card.count;
                })
                .join(' · ');

            $scope.dimensions = payload.dimensions || [];
            const keep =
                $scope.selectedDimension &&
                $scope.dimensions.filter(function(dimension) {
                    return dimension.subdimension === $scope.selectedDimension.subdimension;
                })[0];
            selectDimension(keep || $scope.dimensions[0] || null);

            const distribution = payload.maturity_distribution;
            $scope.maturityLevels = distribution
                ? distribution.levels.map(function(level) {
                      return {
                          key: level.level,
                          name: (LEVEL_NAMES[level.level] || level.level) + ' ' + level.label,
                          count: level.fo_count,
                          percentage: level.percentage,
                          colour: LEVEL_COLOURS[level.level] || '#888'
                      };
                  })
                : [];

            $scope.coverageMetrics = payload.data_coverage ? payload.data_coverage.metrics : [];
            $scope.assessees = payload.assessees || [];
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Selections
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /** A tool card. A tool with nothing in the population is not selectable. */
        function selectTool(card) {
            if (!card || !card.count || card.name === $scope.scoreTool.name || $scope.isLoading) {
                return;
            }
            $scope.scoreTool.name = card.name;
            $scope.selectedDimension = null;
            load();
        }

        function selectDimension(dimension) {
            $scope.selectedDimension = dimension;
            $scope.selectedSubdimensions = dimension
                ? ($scope.overview.subdimensions || []).filter(function(item) {
                      return item.dimension === dimension.subdimension;
                  })
                : [];
        }

        function matchesAssesseeSearch(row) {
            const text = ($scope.assesseeSearch.text || '').trim().toLowerCase();
            if (!text) {
                return true;
            }
            return [row.name, row.country, row.city].some(function(value) {
                return (
                    value &&
                    String(value)
                        .toLowerCase()
                        .indexOf(text) !== -1
                );
            });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Formatting
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /** A score on the 1-5 scale, or a dash. Never 0.0 for "not scored". */
        function formatScore(value) {
            return value === null || angular.isUndefined(value) ? '–' : Number(value).toFixed(1);
        }

        function formatNumber(value) {
            return value === null || angular.isUndefined(value) ? '–' : Number(value).toLocaleString('en-US');
        }

        function shortToolName(name) {
            return String(name || '').replace(/^scope\s+/i, '');
        }

        function toolSymbol(name) {
            return shortToolName(name)
                .charAt(0)
                .toUpperCase();
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Export
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * The assessee list as CSV, with each FO's dimension scores. Built from
         * the rows on screen (search applied), which are the server's rows: the
         * file can never disagree with the averages above the table.
         */
        function exportCSV() {
            const rows = $scope.assessees.filter(matchesAssesseeSearch);
            if (!rows.length) {
                toastr.warning('There are no assessees to export for the current filters.');
                return;
            }
            const dimensions = $scope.dimensions.map(function(dimension) {
                return dimension.subdimension;
            });
            const headers = [
                'Name',
                'Tool',
                'Country',
                'City',
                'Legal status',
                'Inc year',
                'Assessment date',
                'Total score',
                'A2F score',
                'Members',
                'Active members'
            ].concat(dimensions);

            const lines = [headers.map(csvCell).join(',')];
            rows.forEach(function(row) {
                const scores = row.dimension_scores || {};
                lines.push(
                    [
                        row.name,
                        row.tool,
                        row.country,
                        row.city,
                        row.legal_status,
                        row.year_of_incorporation,
                        row.assessment_date,
                        csvScore(row.total_score),
                        csvScore(row.a2f_score),
                        row.number_of_members,
                        row.number_of_active_members
                    ]
                        .concat(
                            dimensions.map(function(title) {
                                return csvScore(scores[title]);
                            })
                        )
                        .map(csvCell)
                        .join(',')
                );
            });

            const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
            const url = $window.URL.createObjectURL(blob);
            const link = $document[0].createElement('a');
            link.href = url;
            link.download = 'project_' + projectId + '_overview_' + new Date().toISOString().split('T')[0] + '.csv';
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
            $window.URL.revokeObjectURL(url);

            toastr.success('Exported ' + rows.length + ' assessees to CSV', '', { timeOut: 2000 });
        }

        function csvScore(value) {
            return value === null || angular.isUndefined(value) ? '' : Number(value).toFixed(1);
        }

        function csvCell(value) {
            if (value === null || angular.isUndefined(value)) {
                return '';
            }
            const text = String(value);
            return /[",\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Customize overview
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * Which optional panels this viewer shows. A per-browser convenience,
         * so `localStorage` - and an unavailable one simply means the default.
         */
        function loadLayout() {
            try {
                const stored = JSON.parse($window.localStorage.getItem(LAYOUT_KEY) || 'null');
                return angular.extend({}, DEFAULT_LAYOUT, stored || {});
            } catch (error) {
                return angular.extend({}, DEFAULT_LAYOUT);
            }
        }

        function saveLayout() {
            try {
                $window.localStorage.setItem(LAYOUT_KEY, JSON.stringify($scope.layout));
            } catch (error) {
                // a full or disabled localStorage only loses the preference
            }
        }

        function resetLayout() {
            $scope.layout = angular.extend({}, DEFAULT_LAYOUT);
            saveLayout();
        }

        function openCustomize() {
            $scope.ui.customizeOpen = true;
        }

        function closeCustomize() {
            $scope.ui.customizeOpen = false;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Page chrome
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initTheme() {
            try {
                $scope.ui.darkMode = $window.localStorage.getItem('pad_theme') === 'dark';
            } catch (error) {
                $scope.ui.darkMode = false;
            }
            applyTheme();
        }

        function applyTheme() {
            $document[0].documentElement.setAttribute('data-theme', $scope.ui.darkMode ? 'dark' : 'light');
        }

        function toggleDarkMode() {
            $scope.ui.darkMode = !$scope.ui.darkMode;
            try {
                $window.localStorage.setItem('pad_theme', $scope.ui.darkMode ? 'dark' : 'light');
            } catch (error) {
                // the theme still changes for this visit
            }
            applyTheme();
            $rootScope.$broadcast('pad-theme-changed');
        }

        function toggleRightbar() {
            $scope.ui.rightbarClosed = !$scope.ui.rightbarClosed;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.projects')
        .controller('projectAddAssessmentController', projectsAddAssessmentController);

    projectsAddAssessmentController.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$filter',
        '$uibModal',
        '$q',
        '$log',
        '$sce',
        '$stateParams',
        'me',
        'modalFactory',
        'gettext',
        'apiUrl',
        'siHrm',
        'siCustomers',
        'siAssessments',
        'siProjects',
        'siProducts',
        'siScope',
        'EVENT_LOADER',
        'toastr'
    ];

    function projectsAddAssessmentController(
        $scope,
        $state,
        $rootScope,
        $filter,
        $uibModal,
        $q,
        $log,
        $sce,
        $stateParams,
        me,
        modalFactory,
        gettext,
        apiUrl,
        siHrm,
        siCustomers,
        siAssessments,
        siProjects,
        siProducts,
        siScope,
        EVENT_LOADER,
        toastr
    ) {
        $rootScope.$broadcast(EVENT_LOADER.show);

        var projectParams = {
                id: $stateParams.id,
                fields: [
                    'owner',
                    'owner__user',
                    'contact',
                    'contact__user',
                    'customer',
                    'customer__producing_organization',
                    'payment_terms',
                    'payment_terms__status',
                    'payment_terms__status__name',
                    'members',
                    'members__user'
                ]
            },
            assessorParams = {
                fields: ['user', 'skills', 'expiration_date_assessor'],
                page_size: 9999
            },
            accountantParams = {
                fields: ['user', 'skills', 'expiration_date_financial_specialist'],
                page_size: 9999,
                accountant: 1
            };

        $scope.assessment = {};

        var projectResourcesPromise = siProjects.draftProjects.one($stateParams.id).get(projectParams),
            producingOrganziationPromise = siCustomers.getPOs({ page_size: 9999 }),
            toolTypePromise = siProducts.product.one('tool_types').get(),
            assessorsPromise = siHrm.getAssessors(assessorParams),
            acccountantPromise = siHrm.getAssessors(accountantParams),
            dropdownsPromise = siProducts.getDropDowns();

        $q.all([
            projectResourcesPromise,
            producingOrganziationPromise,
            toolTypePromise,
            assessorsPromise,
            acccountantPromise,
            dropdownsPromise
        ])
            .then(function(promises) {
                $scope.project = promises[0];
                $scope.producing_organizations = promises[1];
                $scope.tools = promises[2];
                $scope.assessors = promises[3];
                $scope.accountants = promises[4];
                $scope.dropdown = promises[5];
                $rootScope.$broadcast(EVENT_LOADER.hide);
                $scope.assessment.project = $scope.project.url;
                $scope.tools.results = $scope.tools.results.map(function(tool) {
                    tool.description = $sce.trustAsHtml(tool.description);
                    return tool;
                });
                $scope.producing_organizations.results = _.sortBy($scope.producing_organizations.results, 'name');
                $scope.assessors.results = _.sortBy($scope.assessors.results, 'user.first_name');
                $scope.languages = [
                    { name: 'Français', id: 'fr' },
                    { name: 'Español', id: 'es' },
                    { name: 'English', id: 'en' }
                ];
                console.log('Add Assessment Controller Data - ', promises);
            })
            .catch(function(err) {
                toastr.error('Add Assessment Ctrl Err - ', err);
            });

        $scope.addAssessment = addAssessment;
        $scope.isToolPro = isToolPro;
        $scope.updateGlobalRegion = updateGlobalRegion;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function addAssessment() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siAssessments
                .createDraftAssessment()
                .post($scope.assessment)
                .then(function() {
                    $state.go('base.projects-draft-detail', { id: $scope.project.id });
                })
                .catch(function(err) {
                    toastr.error('Create Draft Assessment Err - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function isToolPro(tool) {
            tool = _.isObject(tool) ? tool : { requires_accountant: false };

            if (!tool.requires_accountant) {
                $scope.assessment.accountant = null;
            }
            return ($scope.requiresAccountant = tool.requires_accountant);
        }

        function updateGlobalRegion() {
            var globalRegion = $scope.dropdown.countryOptions
                .filter(function(country) {
                    return country.display_name === $scope.assessment.country;
                })
                .reduce(function(memo, country) {
                    return $scope.dropdown.continentOptions
                        .filter(function(continent) {
                            return continent.url === country.global_region;
                        })
                        .reduce(function(memo, continent) {
                            return continent.name;
                        }, '');
                }, '');

            $scope.assessment.global_region = globalRegion;
            $scope.globalRegion = globalRegion;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.hrm', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    var baseUsersUrlParams = [
        'search',
        'ordering',
        'organization',
        'country',
        'languages_spoken',
        'tools',
        'min_date',
        'max_date',
        'is_active',
        'skills',
        'roles'
    ];

    function createUrlWithParams(url, params) {
        return (
            url +
            params.reduce(function(memo, param, index) {
                return memo + param + (params.length - 1 === index ? '' : '&');
            }, '?')
        );
    }

    function config($stateProvider) {
        $stateProvider
            .state('base.hrm-users', {
                url: createUrlWithParams('/hrm/users/{page:[0-9]*}', baseUsersUrlParams),
                views: {
                    'contentView@base': {
                        templateUrl: 'hrm/hrmUsersListView.html',
                        controller: 'hrmUsersListController'
                    }
                }
            })
            .state('base.hrm-user', {
                url: '/hrm/user/:id',
                views: {
                    'contentView@base': {
                        templateUrl: 'hrm/hrmUserView.html',
                        controller: 'hrmUserController'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.hrm').factory('siHrmUsers', siHrmUsers);

    siHrmUsers.$inject = ['siScope', 'siHrm', '$q', 'siCustomers'];

    function siHrmUsers(siScope, siHrm, $q, siCustomers) {
        const service = this;

        service.updateUser = updateUser;
        service.handleAssessorCRUD = handleAssessorCRUD;
        service.handleContactCreation = handleContactCreation;
        service.updateDashboardRole = updateDashboardRole;
        service.updateAssessorSkills = updateAssessorSkills;
        service.handleEmployeeCreation = handleEmployeeCreation;
        service.isAuthorized = isAuthorized;
        service.setActiveStates = setActiveStates;
        service.updateAssessorTools = updateAssessorTools;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function handleAssessorCRUD(assessor, user) {
            return assessor.url ? siScope.patch(assessor) : handleAssessorCreation(user, assessor);
        }

        function updateUser(user) {
            user.allowed_frontends = user.allowed_frontends ? angular.toJson(user.allowed_frontends) : '';

            return siScope.patch(user).then(updatedUser => {
                user = Object.assign(user, updatedUser);

                if (user.allowed_frontends) {
                    user.allowed_frontends = angular.fromJson(user.allowed_frontends);
                }
                if (user.languages_spoken) {
                    user.languages_spoken = user.languages_spoken ? Array.from(user.languages_spoken) : [];
                }
                return user;
            });
        }

        function setActiveStates(user) {
            user.allowed_frontends = user.allowed_frontends ? user.allowed_frontends : [];

            var promises = [
                { type: 'employee', app: 'dashboard' },
                { type: 'assessor', app: 'smartclient' },
                { type: 'customer_contact', app: 'dashboard' }
            ]
                .filter(role => user[role.type])
                .map(role => {
                    user[role.type].is_active =
                        user.allowed_frontends.map(allowedFrontend => allowedFrontend.app).indexOf(role.app) !== -1;

                    return siScope.patch({ url: user[role.type].url, is_active: user[role.type].is_active });
                });

            return $q.all(promises).then(() => user);
        }

        function handleAssessorCreation(user, assessor) {
            if (isAuthorized(user.allowed_frontends, 'smartclient')) {
                const newAssessor = Object.assign(assessor, { user: user.url });
                return siHrm.createAssessor(newAssessor);
            } else {
                return $q.resolve(assessor);
            }
        }

        function isAuthorized(allowedFrontEnds, application) {
            allowedFrontEnds = allowedFrontEnds || [];
            return allowedFrontEnds
                .filter(frontend => frontend.app === application)
                .reduce((memo, isAllowed) => Boolean(isAllowed), false);
        }

        function handleContactCreation(user) {
            var temp = user.organization + '';
            if (!user.customer_contact) {
                if (isAuthorized(user.allowed_frontends, 'dashboard') || temp.split('/')[5] == '328') {
                    const newContact = {
                        user: user.url,
                        customers: [user.organization]
                    };
                    return siCustomers.createContact(newContact).then(createdContact => {
                        user.customer_contact = createdContact;
                        return user;
                    });
                } else if (isUserDashboardUserAdmin(user)) {
                    return createContactWithDashboardAccess(user, user.roles.dashboard.name);
                } else {
                    return $q.resolve(user);
                }
            }

            return $q.resolve(user);
        }

        function createContactWithDashboardAccess(user, role) {
            const newContact = {
                user: user.url,
                customers: [user.organization],
                access_to_dashboard: role.indexOf('User') !== -1 ? 'customer_user' : 'customer_admin'
            };
            return siCustomers
                .createContact(newContact)
                .then(createdContact => {
                    user.customer_contact = createdContact;
                    return setRole(user, role);
                })
                .then(user => updateUser(angular.copy(user)));
        }

        function updateDashboardRole(user, role) {
            //If the new role is not Dashboard User or Dashboard Admin
            // We check if the user was previously a dash user/admin and if so
            //kill that user, if not we just update the dashboard role
            if (!isDashboardUserAdminRole(role.name)) {
                if (user.is_customer_admin || user.is_customer_user || user.customer_contact) {
                    return siScope
                        .remove(user.customer_contact)
                        .then(() => {
                            user.customer_contact = null;
                            user.is_customer_user = false;
                            user.is_customer_admin = false;
                            return user;
                        })
                        .then(() => siHrm.updateDashboardRole(user, role));
                } else {
                    return siHrm.updateDashboardRole(user, role);
                }
            } else if (user.is_employee || user.is_quality_reviewer) {
                //If the new role is Dashboard User/Admin and the user is an employee or quality reviewer
                //We kill the user as an employee cuz a dash user/admin cannot be an employee
                return siScope
                    .remove(user.employee.url)
                    .then(() => {
                        user.employee = null;
                        user.is_employee = false;
                        return user;
                    })
                    .then(user => createContactWithDashboardAccess(user, role.name));
            } else if (user.is_customer_admin || user.is_customer_user || user.customer_contact) {
                //If the new role is dash user/admin and the user already is one of these we swap them around
                var patch = {
                    url: user.customer_contact.url,
                    access_to_dashboard: getRole(role.name),
                    is_active: true
                };
                return siScope.patch(patch).then(() => setRole(user, role.name));
            } else {
                return createContactWithDashboardAccess(user, role.name);
            }
        }

        function setRole(user, name) {
            if (name === 'Dashboard User') {
                user.is_customer_user = true;
                user.is_customer_admin = false;
            } else if (name === 'Dashboard Admin' || name === 'Dashboard Administrator') {
                user.is_customer_admin = true;
                user.is_customer_user = false;
            } else {
                user.is_customer_admin = false;
                user.is_customer_user = false;
            }
            return user;
        }

        function isDashboardUserAdminRole(name) {
            const roles = {
                'Dashboard User': true,
                'Dashboard Admin': true,
                'Dashboard Administrator': true,
                'No Access': true
            };

            return Boolean(roles[name]);
        }

        function getRole(name) {
            const roles = {
                'Dashboard User': 'customer_user',
                'Dashboard Admin': 'customer_admin',
                'Dashboard Administrator': 'customer_admin',
                'No Access': ''
            };

            return roles[name];
        }

        function updateAssessorSkills(assessor, selectedSkills = []) {
            if (assessor.url) {
                const patch = { url: assessor.url };

                ['is_assessor', 'financial_specialist', 'data_collector', 'self_assessor']
                    .filter(skill => {
                        return selectedSkills.map(skill => skill.key).indexOf(skill) === -1;
                    })
                    .forEach(skill => (patch[skill] = false));

                selectedSkills.forEach(skill => (patch[skill.key] = true));

                return siScope.patch(patch);
            } else {
                selectedSkills.forEach(skill => (assessor[skill.key] = true));
                return $q.resolve(assessor);
            }
        }

        function updateAssessorTools(url, tools) {
            return url ? siScope.patch({ url, tools }) : $q.resolve({ tools });
        }

        function handleEmployeeCreation(user) {
            if (isAuthorized(user.allowed_frontends, 'dashboard') && !isUserDashboardUserAdmin(user)) {
                const employee = {
                    user: user.url,
                    qc_only: user.roles.dashboard.name === 'SI Quality Reviewer',
                    employee_lite: user.roles.dashboard.name === 'SI Employee Lite'
                };
                return siHrm.createEmployee(employee).then(newEmployee => {
                    user.employee = newEmployee;
                    user.is_employee = true;
                    return user;
                });
            } else {
                return $q.resolve(user);
            }
        }

        function isUserDashboardUserAdmin(user) {
            return (
                user.roles &&
                user.roles.dashboard &&
                user.roles.dashboard.name &&
                user.roles.dashboard.name !== 'No Access' &&
                isDashboardUserAdminRole(user.roles.dashboard.name)
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.hrm')
        .controller('hrmUsersListController', hrmUsersListController)
        .constant('USER_LIST_FILTERS', [
            { Organization: { organization: null }, optionsKey: 'organization' },
            { Country: { country: null }, optionsKey: 'country' },
            { 'Languages spoken': { languages_spoken: null }, optionsKey: 'languages_spoken' },
            { Tools: { tools: null }, optionsKey: 'tools' },
            { Skills: { skills: null }, optionsKey: 'skills' },
            { 'User role': { roles: null }, optionsKey: 'roles' },
            { 'Expiration Date': { min_date: null, max_date: null } },
            { Active: { is_active: null }, optionsKey: 'is_active' }
        ]);

    hrmUsersListController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$timeout',
        'modalFactory',
        '$log',
        '$location',
        'gettext',
        'siScope',
        'siHrm',
        'siFilters',
        'toastr',
        'EVENT_LOADER',
        'USER_LIST_FILTERS'
    ];

    function hrmUsersListController(
        $rootScope,
        $scope,
        $state,
        $timeout,
        modalFactory,
        $log,
        $location,
        gettext,
        siScope,
        siHrm,
        siFilters,
        toastr,
        EVENT_LOADER,
        USER_LIST_FILTERS
    ) {
        var params = {
            fields: ['organization'],
            page: $state.params.page || 1
        };

        search($location.search());

        $scope.filters = siFilters.createFilters(USER_LIST_FILTERS, $location.search());
        $scope.deleteUser = deleteUser;
        $scope.description = gettext('You can search by first name, last name or a combination of those.');
        $scope.search = search;
        $scope.removeFilter = removeFilter;
        $scope.isScopeEmploye = isScopeEmploye;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function isScopeEmploye() {
            return JSON.parse(localStorage.getItem('ngStorage-user')).info.is_scope_employee;
        }

        function search(searchParams, displayFilter) {
            console.log('DEBUG');
            console.log(searchParams);
            console.log(displayFilter);
            console.log('DEBUG');
            return siFilters.search(params, searchParams, displayFilter, getUsers);
        }

        function removeFilter(removeFilter) {
            return siFilters.removeFilter(removeFilter);
        }

        function getUsers(params) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            console.log(params);
            if (!isScopeEmploye()) {
                params.is_active = '1';
            }
            console.log(params);
            siHrm
                .getUsers(params)
                .then(function(users) {
                    $scope.users = users;

                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    toastr.error('Error Fetching Users - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function deleteUser(user) {
            modalFactory.ConfirmModal({
                message: gettext('Remove this user?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            siScope
                                .remove(user.url)
                                .then(function() {
                                    getUsers(params);
                                    toastr.success('User Successfully Deleted');
                                })
                                .catch(function(err) {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    toastr.error('Error Deleting Employee - ', err);
                                });
                        }
                    }
                ]
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.hrm').controller('hrmUserController', hrmUserController);

    hrmUserController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$timeout',
        '$q',
        '$uibModal',
        'modalFactory',
        '$log',
        'gettext',
        'gettextCatalog',
        'siScope',
        'siHrm',
        'apiUrl',
        'siAccounts',
        'siCustomers',
        'siProducts',
        'siProjects',
        'toastr',
        'me',
        'siHrmUsers',
        'EMAIL_VALID_REGEX',
        'COUNTRIES',
        'EVENT_LOADER',
        'fsFactory'
    ];

    function hrmUserController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $timeout,
        $q,
        $uibModal,
        modalFactory,
        $log,
        gettext,
        gettextCatalog,
        siScope,
        siHrm,
        apiUrl,
        siAccounts,
        siCustomers,
        siProducts,
        siProjects,
        toastr,
        me,
        siHrmUsers,
        EMAIL_VALID_REGEX,
        COUNTRIES,
        EVENT_LOADER,
        fsFactory
    ) {
        //Check right away to be sure we dont navigate to the state without a proper id being set
        //Here we are assuming an empty id means a creation state.
        if (!$stateParams.id) {
            $state.go('base.hrm-user', { id: 'create' });
        }

        $rootScope.$broadcast(EVENT_LOADER.show);

        const promises = [siCustomers.getCustomersDropdown(), siProducts.product.one('tool_types').get(), me.getMe()];

        //If we are not on a creation state then lets grab the user data as well.
        if ($stateParams.id !== 'create') {
            promises.push(siHrm.getUser($stateParams.id, { fields: ['assessor', 'employee', 'customer_contact'] }));
        }

        promises.push(siProjects.getAgriGradeProjects());

        $scope.isDashboardAdmin = false;
        $scope.user = {};

        //Get the juicy data
        $q.all(promises)
            .then(promises => {
                if ($stateParams.id !== 'create' && promises[3].assessor && promises[3].assessor.id) {
                    siHrm
                        .getAllAssessorTraining(promises[3].assessor.id)
                        .then(trainings => ($scope.allAssessorTrainings = trainings));
                }
                if ($stateParams.id !== 'create') {
                    siHrm.getPortalLicenses(promises[3].id).then(res => ($scope.portalLicenses = res.results));
                }
                return promises;
            })
            .then(function(promises) {
                $scope.customers = promises[0];
                $scope.tools = promises[1];
                $scope.isDashboardAdmin = promises[2].is_customer_admin;
                $scope.agriGradeProjects = promises[promises.length - 1];
                $scope.allAssessorTrainings = {
                    assessor: [],
                    financial_specialist: []
                };
                if ($stateParams.id !== 'create') {
                    initUser(promises[3]);
                    if ($scope.user.assessor) {
                        $scope.assessor = $scope.user.assessor;
                        $scope.selectedSkills = $scope.skills.filter(skill => $scope.assessor[skill.key]);
                        $scope.isAssessor = $scope.selectedSkills.map(skill => skill.name).includes('Assessor');
                        $scope.isFinancialSpecialist = $scope.selectedSkills
                            .map(skill => skill.name)
                            .includes('Financial Specialist');
                    }

                    if ($scope.isDashboardAdmin) {
                        let containsDashboard = $scope.user.allowed_frontends
                            .filter(allowedFrontend => allowedFrontend.app === 'dashboard')
                            .reduce(() => true, false);

                        if (!containsDashboard) {
                            $scope.user.allowed_frontends.push({
                                app: 'dashboard',
                                name: gettextCatalog.getString('SCOPE Dashboard')
                            });
                        }

                        $scope.dashboardRoles = [
                            { name: gettext('Dashboard Administrator') },
                            { name: gettext('Dashboard User') },
                            { name: gettext('No Access') }
                        ];
                    }
                }

                if ($stateParams.id === 'create' && promises[2].is_customer_admin) {
                    $scope.user = {
                        organization: promises[2].organization,
                        allowed_frontends: [{ app: 'dashboard', name: gettextCatalog.getString('SCOPE Dashboard') }]
                    };
                    $scope.dashboardRoles = [
                        { name: gettext('Dashboard Administrator') },
                        { name: gettext('Dashboard User') },
                        { name: gettext('No Access') }
                    ];
                }

                console.log('Assessor - ', $scope.assessor);
                console.log('Customers - ', $scope.customers);
                console.log('Tools - ', $scope.tools);
                console.log('User - ', $scope.user);
                console.log('Skills - ', $scope.skills);
                console.log('All Assessor Trainings - ', $scope.allAssessorTrainings);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                toastr.error('User Edit Controller Data Retrieval Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        //Define Scoped Variables
        $scope.languages = [
            { name: 'Francais', code: 'fr' },
            { name: 'Espanol', code: 'es' },
            { name: 'English', code: 'en' }
        ];
        $scope.languages_spoken = ['Francais', 'Espanol', 'English'];
        $scope.dashboardRoles = [
            { name: gettext('SI Employee') },
            { name: gettext('SI Employee Lite') },
            { name: gettext('SI Quality Reviewer') },
            { name: gettext('Dashboard Administrator') },
            { name: gettext('Dashboard User') },
            { name: gettext('No Access') }
        ];
        $scope.skills = [
            { name: gettext('Assessor'), key: 'is_assessor' },
            { name: gettext('Financial Specialist'), key: 'financial_specialist' },
            { name: gettext('Data Collector'), key: 'data_collector' },
            { name: gettext('Self Assessor'), key: 'self_assessor' }
        ];
        $scope.createUser = $stateParams.id === 'create';
        $scope.applications = [
            { app: 'smartclient', name: gettextCatalog.getString('SCOPE App') },
            { app: 'dashboard', name: gettextCatalog.getString('SCOPE Dashboard') },
            { app: 'website', name: gettextCatalog.getString('SCOPE Portal') }
        ];

        $scope.userForm = {};
        $scope.assessor = {};
        $scope.countries = COUNTRIES;
        $scope.deleteUser = deleteUser;
        $scope.crudUser = crudUser;
        $scope.requestPasswordReset = requestPasswordReset;
        $scope.updateAssessorSkills = updateAssessorSkills;
        $scope.updateApplications = updateApplications;
        $scope.updateAssessorTools = updateAssessorTools;
        $scope.updateSpokenLanguage = updateSpokenLanguage;
        $scope.isAuthorized = siHrmUsers.isAuthorized;
        $scope.updateDashboardRole = updateDashboardRole;
        $scope.updateLanguage = updateLanguage;
        $scope.checkEmailAvailability = checkEmailAvailability;
        $scope.sendToTraining = sendToTraining;
        $scope.graduate = graduate;
        $scope.hideUser = hideUser;
        $scope.createTraining = createTraining;
        $scope.deleteTraining = deleteTraining;
        $scope.updateTraining = updateTraining;
        $scope.createLicense = createLicense;
        $scope.deleteLicense = deleteLicense;
        $scope.updateLicense = updateLicense;
        $scope.registerAtLearnworlds = registerAtLearnworlds;
        $scope.toggleAgriGradeUser = toggleAgriGradeUser;
        $scope.updateAgriProjects = updateAgriProjects;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initUser(user) {
            $scope.user = user;
            $scope.user.allowed_frontends = $scope.user.allowed_frontends
                ? angular.fromJson($scope.user.allowed_frontends)
                : [];
            $scope.user.roles = siHrm.setUserRoles($scope.user);
            if ($scope.user.assessor) {
                $scope.assessor = $scope.user.assessor;
            }
            return $scope.user;
        }

        function toggleAgriGradeUser(isAgriUser) {
            if (!$scope.createUser && $scope.user.url) {
                $rootScope.$broadcast(EVENT_LOADER.show);

                return siScope
                    .patch({
                        url: $scope.user.url,
                        is_agri_grade_user: isAgriUser
                    })
                    .then(() => {
                        if (!isAgriUser) {
                            $scope.user.agri_grade_projects = [];
                            return updateAgriProjects($scope.user.url);
                        }
                    })
                    .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                    .catch(err => toastr.error('Error updating agri grade flag - ', err));
            }
        }

        function updateAgriProjects(userUrl) {
            if (!$scope.createUser && userUrl) {
                $rootScope.$broadcast(EVENT_LOADER.show);

                const projectIds = $scope.user.agri_grade_projects
                    ? $scope.user.agri_grade_projects.map(project => project.id)
                    : [];

                const userId = userUrl
                    .split('/')
                    .filter(x => x)
                    .pop();

                return siScope
                    .post({
                        url: `${apiUrl}/accounts/users/${userId}/update_agri_projects/`,
                        project_ids: projectIds || []
                    })
                    .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                    .catch(console.log('Error occured, please try again!'));
            }
        }

        function getAllAssessorTraining() {
            return siHrm
                .getAllAssessorTraining($scope.user.assessor.id)
                .then(trainings => {
                    $scope.allAssessorTrainings = trainings;
                    return siHrm.getUser($stateParams.id, { fields: ['assessor', 'employee', 'customer_contact'] });
                })
                .then(user => {
                    initUser(user);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function registerAtLearnworlds(user) {
            siScope
                .post({ url: `${apiUrl}/accounts/users/${user.id}/register_learnworks_user/` })
                .then(res => {
                    toastr.success(res);
                })
                .catch(error => {
                    toastr.error(`The learnworlds server returned the following error: ${error.error}`);
                });
        }

        function getPortalLicenses() {
            return siHrm
                .getPortalLicenses($scope.user.id)
                .then(licenses => {
                    $scope.portalLicenses = licenses.results;
                    return siHrm.getUser($stateParams.id, { fields: ['assessor', 'employee', 'customer_contact'] });
                })
                .then(user => {
                    initUser(user);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function deleteTraining(training) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.remove(training.url).then(getAllAssessorTraining);
        }

        function createTraining(training) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            training.assessor = $scope.assessor.url;
            const url = apiUrl + training.url;
            return siScope.create(training, url).then(getAllAssessorTraining);
        }

        function updateTraining(training) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.patch(training).then(getAllAssessorTraining);
        }

        function deleteLicense(license) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.remove(license.url).then(getPortalLicenses);
        }

        function createLicense(license) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            license.user = $scope.user.url;
            const url = apiUrl + license.url;
            return siScope.create(license, url).then(getPortalLicenses);
        }

        function updateLicense(license) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope.patch(license).then(getPortalLicenses);
        }

        function hideUser(user) {
            return modalFactory.ConfirmModal({
                message: gettext(
                    'Hiding a user has consequenses. Hidden user will make this user invisible in all lists, unavailable for any projects or assessments. Are you sure you want to hide this user?'
                ),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            return siScope
                                .patch({ url: apiUrl + '/accounts/users/' + user.id + '/', display_in_list: false })
                                .catch(err => toastr.error('Error Hiding User - ', err))
                                .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                        }
                    }
                ]
            });
        }

        function updateApplications(user) {
            if (!$scope.createUser) {
                return siHrmUsers
                    .setActiveStates(user)
                    .then(user => ($scope.user = Object.assign($scope.user, user)))
                    .catch(err => toastr.error('Error setting active state - ', err));
            }
        }

        function crudUser(user, form = { $invalid: false }) {
            if (form.$invalid) {
                return;
            }
            $rootScope.$broadcast(EVENT_LOADER.show);
            return $scope.createUser ? createUser(user) : updateUser(user);
        }

        function updateUser(user) {
            return siHrmUsers
                .updateUser(angular.copy(user))
                .then(user => angular.merge($scope.user, user))
                .then(handleAssessorCRUD)
                .then(handleContactCreation)
                .then(() => siHrm.getUser($stateParams.id, { fields: ['assessor', 'employee', 'customer_contact'] }))
                .then(user => initUser(user))
                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Employee Update Err - ', err);
                });
        }

        function handleContactCreation(user) {
            return siHrmUsers.handleContactCreation(user).then(user => angular.merge($scope.user, user));
        }

        function handleAssessorCRUD(user) {
            return siHrmUsers.handleAssessorCRUD(angular.copy($scope.assessor), angular.copy(user)).then(assessor => {
                $scope.assessor = angular.merge($scope.assessor, assessor);
                $scope.user.assessor = assessor;
                return $scope.user;
            });
        }

        function updateDashboardRole(newRole) {
            if (!$scope.createUser) {
                siHrmUsers.updateDashboardRole($scope.user, newRole).then(user => angular.merge($scope.user, user));
            }
        }

        function updateSpokenLanguage(languages_spoken, url) {
            if (!$scope.createUser) {
                return siScope.patch({ url, languages_spoken });
            }
        }

        function updateAssessorTools(tools, url) {
            return siHrmUsers
                .updateAssessorTools(url, tools)
                .then(assessor => angular.merge($scope.assessor, assessor));
        }

        function requestPasswordReset(email) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siAccounts.requestPasswordReset(email).then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
        }

        function createUser(createdUser) {
            const user = angular.copy(createdUser);

            const agriProjectIds = user.agri_grade_projects ? user.agri_grade_projects.map(project => project.id) : [];

            const create = {
                is_active: true,
                display_in_list: true,
                first_name: user.first_name,
                last_name: user.last_name,
                organization: user.organization,
                email: user.email,
                city: user.city,
                country: user.country,
                languages_spoken: user.languages_spoken,
                language: user.language,
                allowed_frontends: angular.toJson(user.allowed_frontends),
                is_agri_grade_user: user.is_agri_grade_user
            };

            return siHrm
                .createUser(create)
                .then(handleUserCreation)
                .then(handleEmployeeCreation)
                .then(handleAssessorCRUD)
                .then(user => siHrmUsers.handleContactCreation(user))
                .then(user => {
                    // After creation of user save his projects
                    if (user.is_agri_grade_user && agriProjectIds.length > 0) {
                        return siScope
                            .post({
                                url: `${apiUrl}/accounts/users/${user.id}/update_agri_projects/`,
                                project_ids: agriProjectIds
                            })
                            .then(() => {
                                return user;
                            });
                    }
                    return user;
                })
                .then(user => $state.go('base.hrm-user', { id: user.id }))
                .catch(err => {
                    toastr.error('Error creating user - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    throw {
                        name: 'UserError',
                        error: {
                            data: err.data
                        },
                        noCurl: true
                    };
                });
        }

        function handleUserCreation(newUser) {
            newUser.allowed_frontends = angular.fromJson(newUser.allowed_frontends);
            newUser.languages_spoken = angular.fromJson(newUser.languages_spoken);
            angular.merge($scope.user, newUser);
            $scope.createUser = false;
            return $scope.user;
        }

        function handleEmployeeCreation(user) {
            return siHrmUsers.handleEmployeeCreation(user).then(user => angular.merge($scope.user, user));
        }

        function deleteUser(user) {
            modalFactory.ConfirmModal({
                message: gettext('Remove this user?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            siScope
                                .remove(user)
                                .then(() => {
                                    toastr.success('User Successfully Deleted');
                                    $state.go('base.hrm-users', {}, { reload: true });
                                })
                                .catch(err => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    toastr.error('Error Deleting User - ', err);
                                });
                        }
                    }
                ]
            });
        }

        // GET responses are cached in IndexedDB and revalidated with an
        // If-Modified-Since header, so a user changed through a custom action
        // (send to training, graduate) can still be served from that cache after a
        // reload. Dropping the cached user responses forces the next fetch to hit
        // the server, so fields like "Access to Trainee" show the current value.
        function invalidateUsersCache() {
            return $q
                .when(fsFactory.unlinkByPrefixFromFs('responses', apiUrl + '/accounts/users/'))
                .catch(err => $log.warn('Could not clear cached user responses - ', err));
        }

        function sendToTraining(user) {
            modalFactory.ConfirmModal({
                message: gettext('Send this user to trainee environment?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            const data = {},
                                url = {
                                    url: apiUrl + '/accounts/users/' + user.id + '/send_to_training/'
                                };

                            siScope
                                .post(url, data)
                                .then(() => invalidateUsersCache())
                                .then(() => {
                                    toastr.success('User Successfully Moved to Trainee Environment');
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    $state.reload();
                                })
                                .catch(err => {
                                    toastr.error('Error Moving User - ', err);
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                });
                        }
                    }
                ]
            });
        }

        function graduate(user) {
            modalFactory.ConfirmModal({
                message: gettext('Open access to production environment?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            const data = {},
                                url = {
                                    url: apiUrl + '/accounts/users/' + user.id + '/graduate/'
                                };

                            siScope
                                .post(url, data)
                                .then(() => invalidateUsersCache())
                                .then(() => {
                                    toastr.success('User Successfully Moved to Production Environment');
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    $state.reload();
                                })
                                .catch(err => {
                                    toastr.error('Error Moving User - ', err);
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                });
                        }
                    }
                ]
            });
        }

        function updateAssessorSkills(selectedSkills = []) {
            $scope.isAssessor = selectedSkills.map(skill => skill.name).includes('Assessor');
            $scope.isFinancialSpecialist = selectedSkills.map(skill => skill.name).includes('Financial Specialist');
            $scope.isDataCollector = selectedSkills.map(skill => skill.name).includes('Data Collector');
            $scope.isSelfAssessor = selectedSkills.map(skill => skill.name).includes('Self Assessor');

            return siHrmUsers
                .updateAssessorSkills(angular.copy($scope.assessor), selectedSkills)
                .then(assessor => angular.merge($scope.assessor, assessor));
        }

        function updateLanguage(language, url) {
            if (!$scope.createUser) {
                return siScope.patch({ url, language });
            }
        }

        function checkEmailAvailability(email, form) {
            const isEmailValid = EMAIL_VALID_REGEX.test(email);
            $scope.emailValid = isEmailValid;
            $scope.emailAvailable = null;
            if (isEmailValid) {
                return siHrm.checkEmailAvailability(email).then(res => {
                    $scope.emailAvailable = res.is_available;
                    form.email.$setValidity('required', res.is_available);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.hrm').controller('hrmCreateUsersController', hrmCreateUsersController);

    hrmCreateUsersController.$inject = ['$rootScope', '$scope', '$state', '$log', 'siHrm', 'toastr', 'EVENT_LOADER'];

    function hrmCreateUsersController($rootScope, $scope, $state, $log, siHrm, toastr, EVENT_LOADER) {
        var vm = this;

        vm.user = {};

        vm.createUser = createUser;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function createUser(user) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            siHrm
                .createUser(user)
                .then(function(newUser) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.success('User Successfully Created');
                    $state.go('base.hrm-users-edit', { id: newUser.id });
                })
                .catch(function(err) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('Error Creating User');
                    console.log('Create User Error - ', err);

                    // TO-DO: fix this. Generic error message is good for now

                    // var message = Object.keys(err.data)
                    //     .map(function (key) {
                    //         return err.data[key]
                    //             .reduce(function (memo, msg) {
                    //                 return msg;
                    //             }, '');
                    //     })
                    //     .reduce(function (memo, msg) {
                    //         return msg.charAt(0).toUpperCase() + msg.slice(1);
                    //     }, '');
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.hrm').component('trainingTable', {
        templateUrl: 'hrm/component/trainingTableComponent.html',
        bindings: {
            tableData: '<',
            addButton: '@',
            tableType: '@',
            createTraining: '&',
            deleteTraining: '&',
            updateTraining: '&'
        },
        controller: TableCompController
    });

    TableCompController.$inject = ['$uibModal', 'gettext'];

    function TableCompController($uibModal, gettext) {
        var vm = this;

        vm.dealNumberText = gettext('Invoiced Under Deal Number');

        vm.deleteRow = training => {
            vm.deleteTraining({ training });
        };

        vm.$doCheck = () => {
            switch (vm.tableType) {
                case 'financial':
                    vm.addButton =
                        vm.tableData && vm.tableData.financial_specialist && vm.tableData.financial_specialist.length
                            ? gettext('Refresher Training')
                            : gettext('Add Financial Specialist Training');
                    break;
                case 'portal':
                    vm.addButton =
                        vm.tableData && vm.tableData && vm.tableData.length
                            ? gettext('Refresh Portal License')
                            : gettext('Add Portal License');
                    break;
                case 'assessor':
                    vm.addButton =
                        vm.tableData && vm.tableData.assessor && vm.tableData.assessor.length
                            ? gettext('Refresher Training')
                            : gettext('Add Assessor Training');
                    break;
                case 'dashboard':
                    vm.addButton = 
                        vm.tableData && vm.tableData && vm.tableData.length
                            ? gettext('Refresh Dashboard Licnese')
                            : gettext('Add Dashboard Licnese')
                    break;
            }
            // vm.addButton = vm.isFinancial
            //     ? vm.tableData && vm.tableData.financial_specialist && vm.tableData.financial_specialist.length
            //         ? gettext('Refresher Training')
            //         : gettext('Add Financial Specialist Training')
            //     : vm.tableData && vm.tableData.assessor && vm.tableData.assessor.length
            //     ? gettext('Refresher Training')
            //     : gettext('Add Assessor Training');

            // vm.addButton =
        };

        vm.updateRow = row => {
            $uibModal
                .open({
                    templateUrl: 'hrm/modals/addTraining.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'row',
                        'gettext',
                        'tableType',
                        function($scope, $uibModalInstance, row, gettext, tableType) {
                            switch (tableType) {
                                case 'financial':
                                    $scope.startDateText = 'Initial F.S. Training Date';
                                    break;
                                case 'assessor':
                                    $scope.startDateText = 'Initial Assessor Training Date';
                                    break;
                                case 'portal':
                                    $scope.startDateText = 'Portal Subscription Start Date';
                                    break;
                                case 'dashboard':
                                    $scope.startDateText = 'Dashboard License Start Date';
                            }
                            // $scope.startDateText = isFinancial
                            //     ? 'Initial F.S. Training Date'
                            //     : 'Initial Assessor Training Date';
                            $scope.dealNumberText = vm.dealNumberText;

                            $scope.training = _.extend(row, {
                                deal_number: parseInt(row.deal_number)
                            });
                            $scope.cancel = () => $uibModalInstance.dismiss('close');
                            $scope.save = () => {
                                $uibModalInstance.close($scope.training);
                            };
                        }
                    ],
                    resolve: {
                        row: () => row,
                        tableType: () => vm.tableType
                    }
                })
                .result.then(training => vm.updateTraining({ training }));
        };

        vm.openModal = () => {
            $uibModal
                .open({
                    templateUrl: 'hrm/modals/addTraining.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'gettext',
                        'tableType',
                        function($scope, $uibModalInstance, gettext, tableType) {
                            switch (tableType) {
                                case 'financial':
                                    $scope.startDateText = 'Initial F.S. Training Date';
                                    break;
                                case 'assessor':
                                    $scope.startDateText = 'Initial Assessor Training Date';
                                    break;
                                case 'portal':
                                    $scope.startDateText = 'Portal Subscription Start Date';
                                    break;
                                case 'dashboard':
                                    $scope.startDateText = 'Dashboard License Start Date';
                            }
                            $scope.dealNumberText = vm.dealNumberText;
                            $scope.training = {};
                            $scope.cancel = () => $uibModalInstance.dismiss('close');
                            $scope.save = () => {
                                $uibModalInstance.close($scope.training);
                            };
                        }
                    ],
                    resolve: {
                        tableType: () => vm.tableType
                    }
                })
                .result.then(training => {
                    switch (vm.tableType) {
                        case 'financial':
                            training.url = '/hrm/financial_specialist_trainings/';
                            break;
                        case 'assessor':
                            training.url = '/hrm/assessor_trainings/';
                            break;
                        case 'portal':
                            training.url = '/hrm/portal_licenses/';
                            break;
                        case 'dashboard':
                            training.url = '/hrm/dashboard_licenses/';
                            break;
                        default:
                            training.url = '/hrm/assessor_trainings/';
                            break;
                    }

                    vm.createTraining({ training });
                });
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.filters', []);

}());
(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('username', username);


    /*
     * @input user object
     * outputs firstname + lastname, or email
     */
    function username() {
      return function (input) {
        if (!input) return '';

        var firstname = input.first_name,
          lastname = input.last_name;

        return (firstname && lastname) ? firstname + ' ' + lastname : input.email;
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('percentage', percentage);

    function percentage() {
      return function (input) {
        if (!input) return '';

        return input + '%';
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('orderObjectBy', orderObjectBy);

    function orderObjectBy() {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });
            if (reverse) filtered.reverse();
            return filtered;
        }
    }

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('name', name);

    /*
     * @input user object
     * outputs firstname + lastname
     */
    function name() {
      return function (input) {
        if (!input) return '';

        var firstname = input.first_name || '',
          lastname = input.last_name || '';

        return firstname + ' ' +lastname;
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('language', language);

    language.$inject = ['gettext'];

    function language(gettext) {
      return function (input) {

          switch(input) {
              case  'en':
                  return gettext('English');
              case 'es':
                  return gettext('Spanish');
              case 'fr':
                  return gettext('French');
          }
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('getType', getType);

    getType.$inject = [];

    function getType() {
      return function (input) {
          return typeof input;
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('filename', filename);


    function filename() {
      return function (input) {
        return input ? input.replace(/^.*[\\\/]/, '') : ''
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('facet_display', facetDisplay);


    /*
     * @input user object
     * outputs firstname + lastname, or email
     */
    function facetDisplay() {
      return function (input) {
        if (parseInt(input) ){
          var d = new Date(input);
          return d.toDateString();
        }
        else if ( input == "" ) {
          return "--";
        }
        return input;
      };
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.filters').filter('cleanNumbers', cleanNumbers);

    function cleanNumbers() {
        return function(input) {
            if (typeof input === 'undefined' || input === null) {
                return;
            } else if (input === '') {
                return input;
            } else {
                input = typeof input === 'string' ? input : input.toString();
                const decimalIndex = input.indexOf('.');
                input = decimalIndex > -1 ? input.slice(0, decimalIndex) : input;
                const match = input.match(/([-]*?[^\s|^\D]+)/g) || [];
                const result = match.reduce((memo, number) => `${memo}${number}`);

                return parseInt(result, 10);
            }
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.filters')
        .filter('capitalize', capitalize);

    function capitalize() {
      return function (input) {
        if (typeof input === 'string') {
          return input.charAt(0).toUpperCase() + input.slice(1);
        }
      };
    };

}());
(function() {
    'use strict';

    angular.module('scope.commons.directives').component('yearDropdown', {
        template: `
                <select
                    chosen
                    ng-class="{'form-elements--error': $ctrl.hasError()}"
                    name="$ctrl.name"
                    ng-required="$ctrl.required"
                    ng-model="$ctrl.ngModel"
                    ng-disabled="$ctrl.isDisabled"
                    ng-change="$ctrl.update({year: $ctrl.ngModel})"
                    data-placeholder-text-single="'Select a Year' | translate"
                    ng-options="year disable when $ctrl.disabledYears.length && $ctrl.disabledYears.indexOf(year) !== -1 for year in $ctrl.years track by year"
                    ng-model-options="{'updateOn': 'default blur'}"
                    start-year="$ctrl.startYear"
                    symmetric-range="$ctrl.symmetricRange"
                    future-range="$ctrl.futureRange"
                    default-range="$ctrl.defaultRange"
                    last-fiscal="$ctrl.lastFiscal"
                    is-old-to-new="$ctrl.isOldToNew"
                    range="$ctrl.range">
                    <option></option>
                </select>`,
        bindings: {
            ngModel: '=',
            startYear: '<',
            symmetricRange: '<',
            futureRange: '<',
            defaultRange: '<',
            lastFiscal: '<',
            range: '<',
            update: '&',
            isDisabled: '<',
            name: '@',
            required: '<',
            isOldToNew: '<',
            showError: '<',
            disabledYears: '<'
        },
        controller: YearController
    });

    YearController.$inject = [];

    function YearController() {
        var vm = this;

        vm.update = typeof vm.update === 'function' ? vm.update : angular.noop;
        vm.years = getYears(vm.startYear);
        vm.hasError = () => {
            return vm.showError && vm.required && vm.ngModel === null;
        };
        vm.$onInit = () => {
            vm.name = vm.name || 'yearDropdown';
            vm.years = getYears(vm.startYear);

            if (vm.ngModel && vm.years.indexOf(vm.ngModel) === -1) {
                vm.years.push(vm.ngModel);
                if (vm.isOldToNew) {
                    vm.years.sort((a, b) => a - b);
                } else {
                    vm.years.sort((a, b) => b - a);
                }
            }
            // console.log(vm);
        };
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                  Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getYears(startYear) {
            startYear = startYear || new Date().getFullYear();
            if (vm.lastFiscal) {
                startYear = new Date().getFullYear() - 1;
            }
            const futureYear = startYear + (vm.range || 10),
                pastYear = startYear - (vm.range || 10),
                range = vm.range || 10;

            let years = [],
                i;

            if (vm.defaultRange) {
                // Default: from 1900 till (present - 1)
                for (i = 1900; i < startYear + 1; i++) {
                    years.push(i);
                }
            } else if (vm.futureRange) {
                for (i = startYear; i < futureYear + 1; i++) {
                    years.push(i);
                }
            } else if (vm.symmetricRange) {
                startYear = startYear - range;
                for (i = startYear; i < futureYear + 1; i++) {
                    years.push(i);
                }
            } else {
                for (i = pastYear; i < startYear + 1; i++) {
                    years.push(i);
                }
            }

            if (vm.isOldToNew) {
                return years;
            } else {
                // Default: from current to oldest
                return years.reverse();
            }
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('widthWatcher', widthWatcher);

    widthWatcher.$inject = ['$window'];

    function widthWatcher($window) {
        return {
            restrict: 'A',
            scope: {
                toggle: '@'
            },

            link: function (scope, element) {

                if($window.innerWidth <= 1140) {
                    element.addClass(scope.toggle);
                }


                $window.addEventListener('resize', function (event) {
                    if (event.target.innerWidth <= 1140) {
                        element.addClass(scope.toggle);
                    } else {
                        element.removeClass(scope.toggle)
                    }
                })

            }
        };
    };
}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('uiSrefDisabled', uiSrefDisabled);

    uiSrefDisabled.$inject = ['$timeout']

    function uiSrefDisabled($timeout) {
        return {
            restrict: 'A',
            scope: {
                isDisabled: '&uiSrefDisabled'
            },
            link: function (scope, element) {
                if (scope.isDisabled()) {
                    $timeout(() => {
                        element.removeAttr('href');
                        element.removeAttr('ui-sref');
                        element.css({'pointer-events': 'none'});
                    })
                }
            }
        };
    };

}());

//(function () {
//
//    'use strict';
//
//    angular.module('scope.commons.directives')
//        .directive('toFixed', toFixed);
//
//    function toFixed() {
//      return {
//        restrict: 'A',
//        require: 'ngModel',
//        link: function ($scope, $element, $attrs, ngModel) {
//          var fixed = parseInt($attrs.toFixed) || 0;
//
//          ngModel.$formatters.push(function(modelValue) {
//            return parseFloat(modelValue);
//          });
//
//          ngModel.$parsers.push(function(viewValue) {
//            return sprintf('%.'+fixed+'f', viewValue);
//          });
//        }
//      };
//    };
//
//}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('textareaHeight', textareaHeight);


    function textareaHeight() {
      return {
        restrict: 'A',
        link: function(scope, element) {
          var clone;
          clone = $("<div></div>");
          clone.addClass('calculateTextarea');
          element.parent().append(clone);

          element.on('keyup focus', function() {
            var content = $(this).val();
            content = content.replace(/\n/g, '<br>');
            content = content + '<br>';
            clone.html(content);
            clone.show();
            $(this).css('height', clone.height() + 20);
            clone.hide();
            console.log($(this).css('height'));
          });
        }
      };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('tabTrigger', tabTrigger);


    function tabTrigger() {
      return {
        restrict: 'A',
        link: function(scope, element) {
          var $element = $(element);
          $element.on('click', function(e) {
            e.preventDefault();
            $(this).tab('show');
          });
        }
      }
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('tabComments', {
        bindings: {
            assessment: '<',
            state: '<',
            assignment: '<'
        },
        template:
            '\
                        <p ng-repeat="feedback in $ctrl.assessment[$ctrl.currentTab].objects" style="display:flex; flex-direction:column;margin-bottom:15px;">\
                            <span style:"display: flex; flex-direction: row;">\
                                <span style="display:flex; flex-direction: row; justify-content: space-between;">\
                                <i ng-bind="feedback.contents" style="font-size:14px; line-height: 14px; padding-right:10px; word-break: break-word;" ng-if="!feedback.editing"></i>\
                                <textarea ng-model="feedback.editedComment" ng-if="feedback.editing"  style="overflow: hidden;" ng-change="adjustTextarea($event)" ng-init="adjustTextarea($event)"></textarea>\
                                <span style="display:flex; flex-direction: row; gap:5px;">\
                            <i class="fa fa-trash" style="cursor: pointer; height: min-content;" ng-click="$ctrl.deleteFeedback(feedback)" ng-if="!feedback.editing && feedback.user.id == $ctrl.currentUserId && !$ctrl.isCommentBoxDisabled($ctrl.state, $ctrl.assignment.assigned_as)"></i>\
                            <i class="fa fa-check" style="cursor: pointer; height: min-content;" ng-click="$ctrl.confirmEditFeedback(feedback)" ng-if="feedback.editing && feedback.user.id == $ctrl.currentUserId && !$ctrl.isCommentBoxDisabled($ctrl.state, $ctrl.assignment.assigned_as)"></i>\
                            <i class="fa fa-pencil" style="cursor: pointer; height: min-content;" ng-if="!feedback.editing && feedback.user.id == $ctrl.currentUserId && !$ctrl.isCommentBoxDisabled($ctrl.state, $ctrl.assignment.assigned_as)" ng-click="$ctrl.onEditClick(feedback)"></i>\
                            <i class="fa fa-close" style="cursor: pointer; height: min-content;" ng-if="feedback.editing && feedback.user.id == $ctrl.currentUserId && !$ctrl.isCommentBoxDisabled($ctrl.state, $ctrl.assignment.assigned_as)" ng-click="$ctrl.onDiscardClick(feedback)"></i>\
                            </span>\
                            </span>\
                            <span style="display: flex; flex-direction: column; line-height:10px;font-size:11px; margin-top:5px; gap: 2px">\
                                <span>\
                                    <translate">on</translate>\
                                    <span ng-bind="feedback.created_at | date"></span>\
                                </span>\
                                <span style="font-size:11px">\
                                    <translate >by</translate>\
                                    <a href="#" ng-bind="feedback.user | username "></a>\
                                </span>\
                                <span style="font-size:11px" ng-if="feedback.created_at != feedback.modified_at">\
                                    <translate >Last modified: </translate>\
                                    <span ng-bind="feedback.modified_at | date"></span>\
                                </span>\
                            </span>\
                        </p>',
        controller: TabCommentsController
    });

    TabCommentsController.$inject = [
        '$element',
        '$filter',
        '$timeout',
        '$scope',
        '$state',
        '$rootScope',
        '$uibModal',
        'siScope',
        'EVENT_LOADER'
    ];

    function TabCommentsController(
        $element,
        $filter,
        $timeout,
        $scope,
        $state,
        $rootScope,
        $uibModal,
        siScope,
        EVENT_LOADER
    ) {
        var vm = this;
        var allTabComments = {
            'base.assessments-assignment-detail.assessment': 'assessmenttabcomments',
            'base.assessments-assignment-detail.organization': 'organisationaltabcomments',
            'base.assessments-assignment-detail.valuechain': 'valuechaintabcomments',
            'base.assessments-assignment-detail.finance': 'financetabcomments',
            'base.assessments-assignment-detail.profit-loss': 'profitlosstabcomments',
            'base.assessments-assignment-detail.balancesheet': 'balancesheettabcomments',
            'base.assessments-assignment-detail.cashflow': 'cashflowtabcomments',
            'base.assessments-assignment-detail.financial-performance': 'financialperformancetabcomments',
            'base.assessments-assignment-detail.production': 'productiontabcomments',
            'base.assessments-assignment-detail.production_monthly': 'monthlyproductiontabcomments',
            'base.assessments-assignment-detail.governance': 'governancetabcomments',
            'base.assessments-assignment-detail.observations': 'observationstabcomments',
            'base.assessments-assignment-detail.finance-product': 'financetabcomments',
            'base.assessments-assignment-detail.documentation': 'documentationtabcomments',
            'base.assessments-assignment-detail.terms': 'termsandconditionstabcomments',
            'base.assessments-assignment-detail.finance-overview': 'financialoverviewtabcomments',
            'base.assessments-assignment-detail.finance-history': 'financialhistorytabcomments',
            'base.assessments-assignment-detail.finance-production': 'financialproductiontabcomments'
        };

        vm.$onInit = onInit;
        vm.on$Destroy = onDestroy;
        vm.deleteFeedback = deleteFeedback;
        vm.adjustTextarea = adjustTextarea;
        vm.onEditClick = onEditClick;
        vm.confirmEditFeedback = confirmEditFeedback;
        vm.onDiscardClick = onDiscardClick;
        vm.currentUserId = $rootScope.me.id;
        vm.$onChanges = onChanges; // Add this lin
        vm.isCommentBoxDisabled = isCommentBoxDisabled;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function onInit() {
            console.log($rootScope.me.id);
            vm.currentTab = allTabComments[$state.current.name];
        }

        function onDestroy() {
            unlisten();
        }

        function deleteFeedback(feedback) {
            $uibModal
                .open({
                    templateUrl: 'modals/templates/confirm-modal/confirmModalView.html',
                    size: 'm',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.$uibModalInstance = $uibModalInstance;
                            $scope.message = 'Are you sure you want to delete the comment?'; // Fixed extra parenthesis

                            $scope.actions = [
                                {
                                    isDefault: true,
                                    fn: false,
                                    label: 'Cancel'
                                },
                                {
                                    isDefault: false,
                                    fn: true,
                                    label: 'Yes'
                                }
                            ];

                            $scope.applyAction = function(fn) {
                                if (fn) {
                                    return $uibModalInstance.close();
                                }
                                return $uibModalInstance.dismiss();
                            };
                        }
                    ]
                })
                .result.then(function() {
                    $rootScope.$broadcast(EVENT_LOADER.show);
                    siScope.remove(feedback.url).then(function() {
                        vm.assessment[vm.currentTab].objects.splice(
                            vm.assessment[vm.currentTab].objects.indexOf(feedback),
                            1
                        );
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        var unlisten = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            var name = toState.name;

            if (allTabComments[name] !== vm.currentTab) {
                vm.currentTab = allTabComments[name];
            }
        });

        function adjustTextarea(event) {
            if (!event || !event.target) return;
            var textarea = event.target;
            textarea.style.height = 'auto'; // Reset height
            textarea.style.height = textarea.scrollHeight + 'px'; // Expand dynamically
        }

        // Watch for changes in feedback.editing
        function onEditClick(feedback) {
            // Close any other open feedback before opening a new one
            vm.assessment[vm.currentTab].objects.forEach(f => {
                if (f !== feedback) f.editing = false;
            });

            // Use $timeout to ensure the DOM is updated before adjusting the textarea
            $timeout(function() {
                var textarea = $element[0].querySelector('textarea[ng-model="feedback.editedComment"]');
                if (textarea) {
                    adjustTextarea({ target: textarea });
                }
            }, 0);
            feedback.editing = true;
            feedback.editedComment = feedback.contents;
        }

        function confirmEditFeedback(feedback) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            // Delay execution slightly to ensure the model is fully updated
            $timeout(function() {
                const patch = { url: feedback.url, contents: feedback.editedComment };

                siScope
                    .patch(patch)
                    .then(res => {
                        feedback.contents = feedback.editedComment;
                        feedback.modified_at = res.modified_at;
                        feedback.editing = false;
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    })
                    .catch(error => {
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                        console.error('Error updating feedback:', error);
                        alert('An error occurred while updating feedback. Please try again.');
                    });
            }, 500); // 100ms delay to allow model binding to complete
        }

        function onDiscardClick(feedback) {
            feedback.editing = false;
            feedback.editedComment = feedback.contents;
        }

        function onChanges(changes) {
            if (vm.assignment) console.log(vm.isCommentBoxDisabled(vm.state, vm.assignment.assigned_as));
        }

        function isCommentBoxDisabled(state, assignedAs) {
            const fsUrls = ['profit-loss', 'balance-sheet', 'cashflow', 'financial-performance'];
            if (assignedAs === 'financial_specialist') {
                return fsUrls.indexOf(state.url.slice(1)) === -1;
            }

            if (assignedAs === 'assessor') {
                return fsUrls.indexOf(state.url.slice(1)) !== -1;
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('svgtextreplace', svgtextreplace);

    // Module-level cache keyed by SVG URL. Populated on first fetch; reused on
    // every subsequent tab visit so scores appear synchronously without a round-trip.
    var svgTextCache = {};

    function svgtextreplace() {
        return {
            scope: {
                scores: '=',
                totalScore: '='
            },
            link: function(scope, element, attrs) {
                var inlineSvgRoot = null;
                var destroyed = false;

                scope.$on('$destroy', function() {
                    destroyed = true;
                });

                function resolveScores() {
                    if (angular.isDefined(scope.scores)) {
                        return scope.scores;
                    }
                    if (attrs.dataScores) {
                        return scope.$parent.$eval(attrs.dataScores);
                    }
                    return undefined;
                }

                function resolveTotalScore() {
                    if (angular.isDefined(scope.totalScore)) {
                        return scope.totalScore;
                    }
                    if (attrs.dataTotalScore) {
                        return scope.$parent.$eval(attrs.dataTotalScore);
                    }
                    return undefined;
                }

                function writeScoresToSvg() {
                    var scores = resolveScores();

                    if (!inlineSvgRoot || !scores) {
                        return false;
                    }

                    function setSvgText(id, value) {
                        var target = inlineSvgRoot.querySelector('#' + id);
                        if (target) {
                            target.textContent = value;
                        }
                    }

                    _.map(scores, function(value, key) {
                        if (key.toLowerCase() === 'production_base') {
                            key = 'supply';
                        }
                        if (key.toLowerCase() === 'enabling_environment') {
                            key = 'enablers';
                        }
                        setSvgText(key.toLowerCase(), value);
                        return null;
                    });

                    var totalScore = resolveTotalScore();
                    if (angular.isDefined(totalScore)) {
                        setSvgText('financial_performance', totalScore);
                    }

                    return true;
                }

                function injectInlineSvg(rawSvg) {
                    if (destroyed) {
                        return;
                    }

                    var parser = new window.DOMParser();
                    var parsed = parser.parseFromString(rawSvg, 'image/svg+xml');
                    var parsedSvg = parsed && parsed.documentElement;

                    if (!parsedSvg || parsedSvg.nodeName.toLowerCase() !== 'svg') {
                        return;
                    }

                    // Remove external @import rules before inlining — they trigger
                    // CSP font-src violations when the SVG is part of the main document.
                    Array.prototype.forEach.call(parsedSvg.querySelectorAll('style'), function(styleEl) {
                        styleEl.textContent = styleEl.textContent.replace(/@import\s+url\([^)]*\)\s*;?/g, '');
                    });

                    var inlineContainer = angular.element('<div class="svgtextreplace-inline"></div>');
                    inlineContainer.css('max-width', '100%');
                    inlineContainer[0].appendChild(document.importNode(parsedSvg, true));

                    inlineSvgRoot = inlineContainer[0].querySelector('svg');
                    element.after(inlineContainer);
                    element.css('display', 'none');

                    writeScoresToSvg();
                }

                // Always load the SVG as inline content — never rely on getSVGDocument(),
                // which returns null until the <object> sub-document fully loads and is
                // accessible, something that fails unpredictably under CSP restrictions.
                function loadSvg() {
                    var svgUrl = attrs.data || attrs.src;
                    if (!svgUrl) {
                        return;
                    }

                    if (svgTextCache[svgUrl]) {
                        injectInlineSvg(svgTextCache[svgUrl]);
                        return;
                    }

                    window
                        .fetch(svgUrl, { credentials: 'same-origin' })
                        .then(function(response) {
                            if (!response.ok) {
                                throw new Error('SVG load failed: ' + response.status);
                            }
                            return response.text();
                        })
                        .then(function(rawSvg) {
                            svgTextCache[svgUrl] = rawSvg;
                            injectInlineSvg(rawSvg);
                        });
                }

                loadSvg();

                // Scores may arrive after the SVG is injected (slow API) or
                // the SVG may be injected after scores arrive (cache miss). Both
                // orderings are handled: writeScoresToSvg() is a no-op until both
                // inlineSvgRoot and scores are set.
                scope.$watch(
                    resolveScores,
                    function(newVal) {
                        if (newVal) {
                            writeScoresToSvg();
                        }
                    },
                    true
                );

                scope.$watch(resolveTotalScore, function() {
                    if (resolveScores()) {
                        writeScoresToSvg();
                    }
                });
            }
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('stringToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        return '' + value;
                    });
                    ngModel.$formatters.push(function (value) {
                        return parseFloat(value);
                    });
                }
            };
        });

})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('sortColumn', sortColumn);

    sortColumn.$inject = ['$location', '$timeout'];

    function sortColumn($location, $timeout) {
      return {
        restrict: 'A',
        scope: {
          sortName: '@'
        },
        link: function ($scope, element) {
            var updated;
            var $element = $(element);
            $scope.$watch(function() { return $location.search()['ordering']; }, function() {
                var current = $location.search()['ordering'] || '';
                var isNegative = current[0] === '-';
                current = isNegative ? current.substr(1) : current;

                $element.css('cursor', 'pointer');


                if(current !== $scope.sortName) {
                    updated = $scope.sortName;
                    setClass($element, 'sorting');
                } else if(isNegative) {
                    updated = $scope.sortName;
                    setClass($element, 'sorting_desc');
                } else {
                    updated = '-' + $scope.sortName;
                    setClass($element, 'sorting_asc');
                }
            });

            $element.on('click', function(e) {
                e.preventDefault();

                // wrapped in timeout because of this problem: https://github.com/angular/angular.js/issues/1417
                $timeout(function() {
                    $location.search('ordering', updated);
                }, 200);
            });

            function setClass($element, cssClass) {
                $element.removeClass('sorting');
                $element.removeClass('sorting_asc');
                $element.removeClass('sorting_desc');
                $element.addClass(cssClass);
            }
        }
      };
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('sideNavigation', sideNavigation);

    function sideNavigation() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Call the metsiMenu plugin and plug it to sidebar navigation
                angular.element(element).metisMenu();
            }
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('popover', popover);


    function popover() {
      return {
        restrict: 'A',
        link: function (scope, element) {
          var options = {},
            $element = $(element);
          options.placement = $element.attr('data-placement') || 'left';
          options.title = $element.attr('data-title');
          options.content = $element.attr('popover');
          options.trigger = $element.attr('data-trigger') || 'click';
          options.delay = { 'show': 0, 'hide': 200 };
          $element.popover(options);
        }
      };
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('paginated', paginated);

    paginated.$inject = ['$state', '$stateParams', '$q', 'gettext'];

    function paginated($state, $stateParams, $q, gettext) {
        return {
            restrict: 'E',
            scope: {
                items: '=',
                itemsPerPage: '=',
                pageParam: '@'
            },
            templateUrl: 'directives/paginated/paginated-component.html',
            link: function($scope) {
                $scope.pageParam = $scope.pageParam || 'page';

                $scope.first = gettext('First');
                $scope.last = gettext('Last');

                // if items change we promise we reset it
                $scope.$watch('items', items => {
                    if (!items) return;
                    // raw http $promise of $resource
                    if (items.$promise) {
                        $q.when(items.$promise).then(objects => {
                            $scope.currentPage = $stateParams[$scope.pageParam] || 1;
                            $scope.totalItems = objects && objects.count ? objects.count : 0;
                            $scope.itemsPerPage = $scope.itemsPerPage || 10;
                            $scope.hasPages = $scope.totalItems > $scope.itemsPerPage;
                            $scope.numPages = $scope.totalItems / $scope.itemsPerPage;
                        });
                    } else {
                        $scope.currentPage = $stateParams[$scope.pageParam] || 1;
                        $scope.totalItems = items && items.count ? items.count : 0;
                        $scope.itemsPerPage = $scope.itemsPerPage || 10;
                        $scope.hasPages = $scope.totalItems > $scope.itemsPerPage;
                        $scope.numPages = $scope.totalItems / $scope.itemsPerPage;
                    }
                });

                $scope.pageChange = () => {
                    $stateParams[$scope.pageParam] = $scope.currentPage;
                    $state.transitionTo($state.current.name, $stateParams, { reload: true });
                };
            }
        };
    }
})();

(function() {
    ('use strict');

    angular.module('scope.commons.directives').component('monthDropdown', {
        template: `
                <select 
                    chosen 
                    ng-model="$ctrl.ngModel"                    
                    data-placeholder-text-single="$ctrl.placeholder | translate" 
                    ng-disabled="$ctrl.isDisabled"
                    ng-options="month.number as (month.display | translate) for month in $ctrl.month_list" 
                    ng-model-options="{'updateOn': 'default blur'}">
                        <option></option>
                    </select>`,
        bindings: {
            ngModel: '=',
            update: '&',
            placeholder: '<',
            isDisabled: '<'
        },
        controller: MonthDropDownController
    });

    MonthDropDownController.$inject = ['$scope', 'gettext'];

    function MonthDropDownController($scope, gettext) {
        var vm = this;
        vm.month_list = getMonths();

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getMonths() {
            return [
                { display: gettext('January'), number: 1 },
                { display: gettext('February'), number: 2 },
                { display: gettext('March'), number: 3 },
                { display: gettext('April'), number: 4 },
                { display: gettext('May'), number: 5 },
                { display: gettext('June'), number: 6 },
                { display: gettext('July'), number: 7 },
                { display: gettext('August'), number: 8 },
                { display: gettext('September'), number: 9 },
                { display: gettext('October'), number: 10 },
                { display: gettext('November'), number: 11 },
                { display: gettext('December'), number: 12 }
            ];
        }

        function model() {
            return vm.ngModel;
        }

        $scope.$watch(model, function(newVal, oldVal) {
            if (newVal !== oldVal) {
                vm.update();
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('minimalizeSidebar', minimalizeSidebar);

    minimalizeSidebar.$inject = ['$rootScope', '$timeout'];
    function minimalizeSidebar($rootScope, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem) {
                elem.bind('click', function() {
                    $('body').toggleClass('mini-navbar');
                    var isMini = $('body').hasClass('mini-navbar');
                    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        $('#side-menu').hide();
                        // For smoothly turn on menu
                        setTimeout(function() {
                            $('#side-menu').fadeIn(500);
                            $timeout(function() {
                                $rootScope.$broadcast('sidebar:toggled', {
                                    isMini: isMini
                                });
                            }, 100); // Mali delay nakon fadeIn
                        }, 100);
                    } else if ($('body').hasClass('fixed-sidebar')) {
                        $('#side-menu').hide();
                        setTimeout(function() {
                            $('#side-menu').fadeIn(500);
                            $timeout(function() {
                                $rootScope.$broadcast('sidebar:toggled', {
                                    isMini: isMini
                                });
                            }, 100);
                        }, 300);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        $('#side-menu').removeAttr('style');

                        $timeout(function() {
                            $rootScope.$broadcast('sidebar:toggled', {
                                isMini: isMini
                            });
                        }, 50);
                    }
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('minValue', minValue);

    function minValue() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                function enforceMin(value) {
                    var min = parseFloat(attrs.minValue);
                    var numValue = parseFloat(value);

                    if (!isNaN(numValue) && numValue < min) {
                        return min;
                    }
                    return value;
                }

                // Live enforcement during input
                element.on('input', function() {
                    var value = element.val();
                    var enforcedValue = enforceMin(value);
                    if (value !== enforcedValue) {
                        ngModelCtrl.$setViewValue(enforcedValue);
                        ngModelCtrl.$render();
                    }
                });

                // Validation for forms
                ngModelCtrl.$validators.minValue = function(modelValue) {
                    return isNaN(modelValue) || modelValue >= parseFloat(attrs.minValue);
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('maxValue', maxValue);

    function maxValue() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                function enforceMax(value) {
                    var max = parseFloat(attrs.maxValue);
                    var numValue = parseFloat(value);

                    if (!isNaN(numValue) && numValue > max) {
                        return max;
                    }
                    return value;
                }

                // Live enforcement during input
                element.on('input', function() {
                    var value = element.val();
                    var enforcedValue = enforceMax(value);
                    if (value !== enforcedValue) {
                        ngModelCtrl.$setViewValue(enforcedValue);
                        ngModelCtrl.$render();
                    }
                });

                // Validation for forms
                ngModelCtrl.$validators.maxValue = function(modelValue) {
                    return isNaN(modelValue) || modelValue <= parseFloat(attrs.maxValue);
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('maxDecimalPoints', maxDecimalPoints);

    maxDecimalPoints.$inject = [];

    function maxDecimalPoints() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                // Get max decimal points from attribute or default to 3
                var maxDecimalPoints = attrs.maxDecimalPoints ? parseInt(attrs.maxDecimalPoints) : 3;

                // Format the displayed value
                ngModelCtrl.$formatters.push(function(value) {
                    if (value === undefined || value === null) return value;
                    return formatDecimalPoints(value.toString(), maxDecimalPoints);
                });

                // Parse the input value
                ngModelCtrl.$parsers.push(function(value) {
                    if (value === undefined || value === null) return value;
                    return formatDecimalPoints(value.toString(), maxDecimalPoints);
                });

                // Handle input events
                element.on('input', function() {
                    var value = element.val();
                    var formattedValue = formatDecimalPoints(value, maxDecimalPoints);
                    if (value !== formattedValue) {
                        ngModelCtrl.$setViewValue(formattedValue);
                        ngModelCtrl.$render();
                    }
                });

                // Helper function to format decimal points
                function formatDecimalPoints(value, max) {
                    var decimalIndex = value.indexOf('.');

                    if (decimalIndex !== -1) {
                        var decimalPart = value.substring(decimalIndex + 1);
                        if (decimalPart.length > max) {
                            return value.substring(0, decimalIndex + 1 + max);
                        }
                    }

                    // Remove multiple decimal points
                    var parts = value.split('.');
                    if (parts.length > 2) {
                        return parts[0] + '.' + parts.slice(1).join('');
                    }

                    return value;
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('scopeEventLoader', scopeEventLoader);

    scopeEventLoader.$inject = ['$rootScope', '$timeout', '$state', 'EVENT_LOADER'];

    function scopeEventLoader($rootScope, $timeout, $state, EVENT_LOADER) {
        return {
            restrict: 'E',
            link: linker,
            template:
                ' <article class="loader loader--simple">\
                           <div class="loader__svg">\
                                    <svg height="230" width="230">\
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(10,10)">\
                                            <g id="logo">\
                                                <path d="M99.073,157.837 L121.776,138.919 L165.513,157.803 L99.073,157.837" id="Fill-1" fill="#201F4B"></path>\
                                                <path d="M96.125,157.244 L130.864,128.178 L46.444,115.148 L96.125,157.244" id="Fill-2" fill="#00A1AF"></path>\
                                                <path d="M129.823,125.566 L46.069,112.703 L76.196,78.403 L129.823,125.566" id="Fill-3" fill="#58C0D0"></path>\
                                                <path d="M78.649,31.988 L88.539,13.444 L62.344,0.056 L78.649,31.988" id="Fill-6" fill="#00A480"></path>\
                                                <path d="M65.773,65.867 L133.272,125.279 L139.212,69.186 L65.773,65.867" id="Fill-4" fill="#90D0CF"></path>\
                                                <path d="M63.861,63.595 L100.035,65.32 L90.584,15.013 L63.861,63.595" id="Fill-5" fill="#15A748"></path>\
                                                <path d="M2.05,193.459 C2.231,197.08 4.528,198.592 8.09,198.592 C11.47,198.592 13.979,196.844 13.979,194.221 C13.979,187.636 1.148,191.74 1.148,183.344 C1.148,179.422 4.985,177.88 8,177.88 C11.653,177.88 14.429,179.088 15.673,182.684 L13.767,183.71 C12.891,180.899 10.686,179.756 8,179.756 C5.792,179.756 3.2,180.986 3.2,183.344 C3.2,189.719 16.031,185.608 16.031,193.883 C16.031,198.118 13.076,200.465 8.09,200.465 C3.773,200.465 0.786,198.866 0,194.518 L2.05,193.459" id="Fill-7" stroke="#FFFFFF" fill="#FFFFFF"></path>\
                                                <path d="M29.228,179.756 C24.424,179.756 22.04,183.53 22.04,189.174 C22.04,196.028 25.211,198.592 29.558,198.592 C32.939,198.592 34.628,196.844 35.599,194.035 L37.56,195.092 C36.045,198.955 33.147,200.465 29.169,200.465 C24.061,200.465 19.989,197.261 19.989,189.174 C19.989,181.022 24.335,177.88 29.014,177.88 C33.273,177.88 35.869,179.393 37.56,183.438 L35.504,184.465 C34.602,181.476 33.095,179.756 29.228,179.756 Z" id="Fill-8" stroke="#FFFFFF" fill="#FFFFFF"></path>\
                                                <path d="M50.183,198.592 C55.284,198.592 57.423,193.644 57.423,189.174 C57.423,184.708 55.284,179.756 50.183,179.756 C45.079,179.756 42.941,184.708 42.941,189.174 C42.941,193.644 45.079,198.592 50.183,198.592 M50.183,177.88 C56.554,177.88 59.482,183.463 59.482,189.174 C59.482,194.877 56.554,200.465 50.183,200.465 C43.812,200.465 40.888,194.877 40.888,189.174 C40.888,183.463 43.812,177.88 50.183,177.88" id="Fill-9" stroke="#FFFFFF" fill="#FFFFFF"></path>\
                                                <path d="M65.301,188.3 L72.126,188.3 C75.632,188.3 77.376,187.004 77.376,184.28 C77.376,183.01 77.167,180.297 72.975,180.297 L65.301,180.297 L65.301,188.3 L65.301,188.3 Z M63.248,178.424 L73.849,178.424 C78.076,178.424 79.435,181.537 79.435,184.28 C79.435,188.481 76.78,190.168 72.911,190.168 L65.301,190.168 L65.301,199.924 L63.248,199.924 L63.248,178.424 L63.248,178.424 Z" id="Fill-10" stroke="#FFFFFF" fill="#FFFFFF"></path>\
                                                <path d="M83.155,178.424 L97.225,178.424 L97.225,180.297 L85.206,180.297 L85.206,187.909 L96.047,187.909 L96.047,189.78 L85.206,189.78 L85.206,198.047 L97.859,198.047 L97.859,199.924 L83.155,199.924 L83.155,178.424" id="Fill-11" stroke="#FFFFFF" fill="#FFFFFF"></path>\
                                                <path d="M111.729,170.635 C112.913,170.635 113.881,171.604 113.881,172.784 C113.881,173.969 112.913,174.942 111.729,174.942 C110.536,174.942 109.571,173.969 109.571,172.784 C109.571,171.604 110.536,170.635 111.729,170.635 M106.65,196.369 C106.353,197.17 106.563,197.805 107.035,197.805 C107.92,197.805 109.143,196.586 110.536,194.384 L111.936,194.384 C110.032,198.063 107.416,200.345 105.297,200.345 C103.439,200.345 102.717,198.274 103.523,195.944 L106.904,186.054 C107.369,184.664 107.456,183.649 106.65,183.649 C105.636,183.649 104.368,184.962 103.356,186.987 L102.046,186.987 C104.031,183.01 106.103,181.157 108.515,181.157 C109.861,181.157 110.71,182.037 110.71,183.435 C110.71,183.947 110.365,185.55 110.119,186.36 L106.65,196.369" id="Fill-12" fill="#FFFFFF"></path>\
                                                <path d="M128.879,196.326 C128.499,197.381 128.833,197.893 129.34,197.893 C130.099,197.893 131.202,196.793 132.595,194.758 L133.868,194.758 C131.796,198.405 129.935,200.345 127.53,200.345 C126.083,200.345 125.197,199.579 125.197,198.317 C125.197,197.729 125.458,196.586 125.875,195.357 L129.467,184.879 C129.848,183.776 129.379,182.934 128.582,182.934 C126.083,182.934 118.307,193.625 117.168,199.926 L113.997,199.926 L118.307,185.764 C118.688,184.451 118.477,183.86 117.668,183.86 C116.871,183.86 115.819,185.086 114.758,186.522 L113.279,186.522 C115.6,182.934 117.759,181.157 119.788,181.157 C121.863,181.157 122.45,182.887 121.097,186.773 L119.407,191.594 L119.49,191.685 C123.466,184.962 126.594,181.157 130.149,181.157 C133.272,181.157 133.399,183.819 132.298,186.697 L128.879,196.326" id="Fill-13" fill="#FFFFFF"></path>\
                                                <path d="M145.341,194.899 C145.341,198.063 142.677,200.345 139.046,200.345 C136.47,200.345 134.481,199.035 134.481,197.293 C134.481,196.285 135.155,195.484 136.046,195.484 C138.239,195.484 137.608,198.774 140.101,198.774 C141.497,198.774 142.847,197.678 142.847,196.543 C142.847,193.709 137.776,190.241 137.776,186.522 C137.776,182.934 140.354,181.157 143.483,181.157 C145.892,181.157 147.452,182.208 147.452,183.86 C147.452,184.918 146.864,185.594 145.931,185.594 C144.034,185.594 144.538,182.72 142.085,182.72 C140.907,182.72 140.101,183.562 140.101,184.744 C140.101,187.074 145.341,190.748 145.341,194.899" id="Fill-14" fill="#FFFFFF"></path>\
                                                <path d="M158.608,170.635 C159.786,170.635 160.763,171.604 160.763,172.784 C160.763,173.969 159.786,174.942 158.608,174.942 C157.417,174.942 156.448,173.969 156.448,172.784 C156.448,171.604 157.417,170.635 158.608,170.635 M153.524,196.369 C153.231,197.17 153.448,197.805 153.913,197.805 C154.798,197.805 156.028,196.586 157.417,194.384 L158.812,194.384 C156.913,198.063 154.294,200.345 152.179,200.345 C150.317,200.345 149.603,198.274 150.394,195.944 L153.782,186.054 C154.251,184.664 154.333,183.649 153.524,183.649 C152.517,183.649 151.247,184.962 150.231,186.987 L148.921,186.987 C150.909,183.01 152.981,181.157 155.394,181.157 C156.747,181.157 157.581,182.037 157.581,183.435 C157.581,183.947 157.247,185.55 156.997,186.36 L153.524,196.369" id="Fill-15" fill="#FFFFFF"></path>\
                                                <path d="M164.896,188.975 C164.896,190.875 165.999,192.146 167.603,192.146 C170.175,192.146 172.29,189.396 172.29,185.978 C172.29,184.067 171.022,182.72 169.249,182.72 C166.503,182.72 164.896,186.315 164.896,188.975 M159.062,203.731 C159.062,205.547 161.05,206.557 164.554,206.557 C168.187,206.557 170.218,205.547 170.218,203.731 C170.218,200.723 165.483,200.77 162.911,199.926 C160.116,201.191 159.062,202.206 159.062,203.731 M169.921,181.157 C171.022,181.157 171.78,181.327 172.757,181.748 C173.603,181.537 174.321,181.368 174.915,181.284 C175.503,181.196 175.976,181.157 176.269,181.157 C177.659,181.157 178.378,181.748 178.378,182.934 C178.378,184.194 178.21,184.581 177.536,184.581 C175.884,184.581 176.392,182.553 174.321,182.971 C175.167,183.907 175.548,185.002 175.548,186.315 C175.548,190.198 171.821,193.709 167.685,193.709 C167.261,193.709 166.757,193.625 165.911,193.625 C163.626,194.511 163.034,195.063 163.034,195.694 C163.034,198.107 172.925,196.713 172.925,202.627 C172.925,205.246 170.813,208 163.962,208 C158.177,208 156.612,205.457 156.612,203.814 C156.612,202.162 157.966,200.723 161.339,199.077 C160.577,198.528 160.204,197.849 160.204,197.047 C160.204,195.528 161.22,194.181 164.265,193.035 C162.526,192.063 161.724,190.796 161.724,189.102 C161.724,186.522 164.05,181.157 169.921,181.157" id="Fill-16" fill="#FFFFFF"></path>\
                                                <path d="M191.933,196.326 C191.677,197.047 191.888,197.604 192.313,197.604 C193.151,197.604 194.38,196.369 195.487,194.511 L196.921,194.511 C195.614,197.639 192.44,200.345 190.153,200.345 C188.554,200.345 187.829,198.822 188.591,196.63 L192.479,185.423 C192.899,184.241 192.694,183.101 191.806,183.101 C191.003,183.101 190.237,183.479 188.591,185.129 C185.419,188.3 181.073,194.979 179.931,199.926 L176.755,199.926 L184.534,174.517 C185.085,172.743 184.491,172.529 181.026,172.529 L181.489,171.088 C184.704,171.088 186.78,171.049 188.419,170.635 L188.845,170.635 L182.55,191.086 L182.636,191.177 C186.729,184.067 189.817,181.157 193.118,181.157 C194.81,181.157 196.032,182.295 196.032,183.947 C196.032,184.581 195.821,185.467 195.487,186.436 L191.933,196.326" id="Fill-17" fill="#FFFFFF"></path>\
                                                <path d="M202.261,196.035 C201.923,197.131 201.97,198.107 203.11,198.107 C204.165,198.107 205.599,197.047 207.292,194.979 L208.903,194.979 C206.36,198.528 203.657,200.389 201.085,200.389 C199.089,200.389 198.331,198.822 199.218,195.868 L202.892,183.649 L199.347,183.649 L199.892,181.954 C202.478,181.618 204.464,180.522 205.729,178.66 L207.55,178.66 L206.571,181.954 L210.421,181.954 L209.872,183.649 L206.022,183.649 L202.261,196.035" id="Fill-18" fill="#FFFFFF"></path>\
                                            </g>\
                                        </g>\
                                    </svg>\
                            </div>\
                        </article>'
        };

        function linker(scope, element) {
            var loader = element.find('.loader'),
                overlay,
                hideTimeout,
                showTimeout,
                showing = false;

            loader.hide();

            /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             Event Listeners
             ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

            $rootScope.$on('$stateChangeSuccess', () => {
                if (arguments[1].name === 'login') {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                }
            });

            $rootScope.$on(EVENT_LOADER.show, showLoaderEvent);

            $rootScope.$on(EVENT_LOADER.hide, hideLoader);

            /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             Method Declarations
             ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

            function showLoaderEvent($event, { fullScreen } = {}) {
                if (showing || !$event.targetScope.appready) {
                    return;
                }

                showing = true;

                if (hideTimeout) {
                    hideTimeout.then(() => {
                        showLoader(fullScreen);
                    });
                } else {
                    showLoader(fullScreen);
                }
            }

            function showLoader(fullScreen) {
                element.prepend('<div class="loader__overlay hide"></div>');
                overlay = element.find('.loader__overlay');
                loader.show();
                $timeout(
                    () => {
                        overlay.removeClass('hide');
                        loader.removeClass('scale-down');
                        fullScreen && overlay.addClass('loader__overlay--fullscreen');
                    },
                    100,
                    false
                );
            }

            function hideLoader() {
                showing = false;

                overlay = element.find('.loader__overlay');

                loader.addClass('scale-down');
                overlay.addClass('hide');
                hideTimeout = $timeout(
                    () => {
                        loader.hide();
                        overlay.remove();
                        hideTimeout = false;
                    },
                    500,
                    false
                );
            }
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('largerThan', largerThan);

    function largerThan() {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ctrl) {
                var validate = function (viewValue) {
                    var comparisonModel = $attrs.largerThan,
                        comparisonFn = eval($attrs.largerThanComparisonFunction) || parseInt;

                    if (!viewValue || !comparisonModel) {
                        ctrl.$setValidity('largerThan', true);
                        return viewValue;
                    }

                    var largerThan,
                        orEqual = !!$attrs.orEqual,
                        lhValue = comparisonFn(viewValue),
                        rhValue = comparisonFn(comparisonModel);

                    if (orEqual) {
                        largerThan = lhValue <= rhValue;
                    } else {
                        largerThan = lhValue < rhValue;
                    }

                    ctrl.$setValidity('largerThan', largerThan);
                    return viewValue;
                };

                ctrl.$parsers.unshift(validate);
                ctrl.$formatters.push(validate);

                $attrs.$observe('largerThan', function () {
                    return validate(ctrl.$viewValue);
                });
            }
        };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('hideIfOffline', hideIfOffline);

    function hideIfOffline() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function ($scope, $element, $attrs, ngModel) {
                var initialize = function () {
                    var modelValue = ngModel.$modelValue;

                    // hide element if model has isOffline property set to true
                    if (modelValue && modelValue.isOffline) {
                        $element.hide();
                    }
                };

                $scope.$watch(ngModel, initialize);
            }
        };
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.directives').directive('formToTabValidator', formToTabValidator);

    formToTabValidator.$inject = ['$timeout', '$rootScope', 'COMPLETION_CHECK'];

    function formToTabValidator($timeout, $rootScope, COMPLETION_CHECK) {
        return {
            restrict: 'A',
            scope: {
                name: '<',
                assessment: '<',
                isAccepted: '<',
                isNotValid: '<'
            },
            link: linker
        };

        function linker(scope) {
            var killWatcher = scope.$watch('assessment', function() {
                if (scope.assessment) {
                    $timeout(function() {
                        var name = scope.name.$name;
                        var form =
                            scope.isAccepted && scope.assessment.submitted_at_least_once
                                ? { $valid: true, $invalid: false }
                                : angular.copy(scope.name);
                        var formObject = {};

                        if (scope.isNotValid) {
                            form = { $invalid: true, $valid: false };
                        }

                        formObject[name] = form;

                        $rootScope.$broadcast(COMPLETION_CHECK.update, formObject);
                        killWatcher();
                    });
                }
            });
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('expandableTreeItem', expandableTreeItem);

    function expandableTreeItem() {
        function toggleCollapsed($element, isCollapsed) {
            var addClass = isCollapsed ? 'collapsed' : 'expanded';
            var removeClass = !isCollapsed ? 'collapsed' : 'expanded';
            $element
                .removeClass(removeClass)
                .addClass(addClass);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModel) {
                // initialize collapsed with optional expanded attribute
                ngModel.isCollapsed = _.isUndefined($attrs.expanded);
                toggleCollapsed($element, ngModel.isCollapsed);

                // switch collapsed and expanded classes
                $element.click(function () {
                    toggleCollapsed($element, ngModel.isCollapsed = !ngModel.isCollapsed);
                });
            }
        }
    };

}());

// (function() {
//     'use strict';

//     angular.module('scope.commons.directives').directive('draggable', draggable);
//     draggable.$inject = ['$rootScope', 'toastr' /*'dragulaService'*/];

//     function draggable($rootScope, toastr /*dragulaService*/) {
//         return {
//             restrict: 'A',
//             scope: {
//                 draggableItems: '<',
//                 dragName: '@'
//             },
//             link: function(scope, elem, attrs) {
//                 var canMove = true;
//                 var draggable;
//                 var dragulaScope = scope.$parent;
//                 var container = elem[0];
//                 var drake;
//                 var name = scope.dragName;
//                 var handlerBound;
//                 var bag = dragulaService.find(dragulaScope, name);

//                 if (bag) {
//                     drake = bag.drake;
//                     drake.containers.push(container);
//                 } else {
//                     drake = dragula({
//                         containers: [container],
//                         moves: function(el, source, handle) {
//                             return canMove && handle.classList.contains('fa-th');
//                         }
//                     });
//                     dragulaService.add(dragulaScope, name, drake);
//                 }

//                 /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//                 		Watchers
//                  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

//                 scope.$watch(
//                     'draggableItems',
//                     function(newValue, oldValue) {
//                         if (!newValue) {
//                             return;
//                         }

//                         draggable = elem.children('.draggable');

//                         if (handlerBound) {
//                             draggable.unbind('mouseenter').unbind('mouseout');

//                             draggable
//                                 .mouseenter(function() {
//                                     angular
//                                         .element(this)
//                                         .children('.draggable-handle')
//                                         .css({ display: 'inline-block' });
//                                 })
//                                 .mouseleave(function() {
//                                     angular
//                                         .element(this)
//                                         .children('.draggable-handle')
//                                         .css({ display: 'none' });
//                                 });
//                         } else {
//                             draggable
//                                 .mouseenter(function() {
//                                     angular
//                                         .element(this)
//                                         .children('.draggable-handle')
//                                         .css({ display: 'inline-block' });
//                                 })
//                                 .mouseleave(function() {
//                                     angular
//                                         .element(this)
//                                         .children('.draggable-handle')
//                                         .css({ display: 'none' });
//                                 });

//                             handlerBound = true;
//                         }

//                         if (drake.models) {
//                             var modelIndex = oldValue ? drake.models.indexOf(oldValue) : -1;
//                             if (modelIndex >= 0) {
//                                 drake.models.splice(modelIndex, 1, newValue);
//                             } else {
//                                 drake.models.push(newValue);
//                             }
//                         } else {
//                             drake.models = [newValue];
//                         }

//                         dragulaService.handleModels(dragulaScope, drake);
//                     },
//                     true
//                 );

//                 /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//                 		Event Listeners
//                  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

//                 var saving = $rootScope.$on('saving-move', function($event, el) {
//                     canMove = false;

//                     Array.prototype.slice
//                         .call(elem.children())
//                         .filter(function(child) {
//                             return child.isEqualNode(el[0]);
//                         })
//                         .reduce(function() {
//                             toastr.warning('Saving Move...');
//                         }, false);

//                     draggable.unbind('mouseenter').unbind('mouseout');
//                 });

//                 var doneSaving = $rootScope.$on('move-saved', function($event, el) {
//                     canMove = true;

//                     Array.prototype.slice
//                         .call(elem.children())
//                         .filter(function(child) {
//                             return child.isEqualNode(el[0]);
//                         })
//                         .reduce(function() {
//                             toastr.success('Move Saved!');
//                         }, false);

//                     draggable
//                         .mouseenter(function() {
//                             angular
//                                 .element(this)
//                                 .children('.draggable-handle')
//                                 .css({ display: 'inline-block' });
//                         })
//                         .mouseleave(function() {
//                             angular
//                                 .element(this)
//                                 .children('.draggable-handle')
//                                 .css({ display: 'none' });
//                         });
//                 });

//                 //Be good boyscout and unind the million handlers we have
//                 scope.$on('$destroy', function() {
//                     saving();
//                     doneSaving();
//                 });
//             }
//         };
//     }
// })();

(function() {
    ('use strict');

    angular.module('scope.commons.directives').component('dataSourceDropdown', {
        template: `
                <select 
                    chosen 
                    ng-model="$ctrl.ngModel"                    
                    data-placeholder-text-single="$ctrl.placeholder | translate" 
                    ng-disabled="$ctrl.isDisabled"
                    ng-options="option.number as (option.display | translate) for option in $ctrl.options" 
                    ng-model-options="{'updateOn': 'default blur'}">
                        <option></option>
                    </select>`,
        bindings: {
            ngModel: '=',
            update: '&',
            placeholder: '<',
            isDisabled: '<'
        },
        controller: DataSourceDropdownController
    });

    DataSourceDropdownController.$inject = ['$scope', 'gettext'];

    function DataSourceDropdownController($scope, gettext) {
        var vm = this;
        vm.options = getMonths();
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getMonths() {
            return [
                { display: gettext('January'), number: 1 },
                { display: gettext('February'), number: 2 },
                { display: gettext('March'), number: 3 },
                { display: gettext('April'), number: 4 },
                { display: gettext('May'), number: 5 },
                { display: gettext('June'), number: 6 },
                { display: gettext('July'), number: 7 },
                { display: gettext('August'), number: 8 },
                { display: gettext('September'), number: 9 },
                { display: gettext('October'), number: 10 },
                { display: gettext('November'), number: 11 },
                { display: gettext('December'), number: 12 }
            ];
        }
        function model() {
            return vm.ngModel;
        }

        $scope.$watch(model, function(newVal, oldVal) {
            if (newVal !== oldVal) {
                vm.update();
            }
        });
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('countriesList', countriesList)

    countriesList.$inject = ['$parse', 'COUNTRIES'];

    function countriesList($parse, COUNTRIES) {
        var countries = COUNTRIES;

        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
              selectedCountry: '='
            },
            link: function (scope, elem, attrs, ngModel) {

                angular.forEach(countries, function (c) {
                    elem.append(angular.element('<option value="' + c + '">' + c + '</option>'));
                });


                ngModel.$render = function () {
                    elem.val(ngModel.$viewValue);
                };
            }
        };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('changeClassColor', changeClassColor);

    function changeClassColor() {
        return {
            restrict: 'A',
            scope: {
                addClass: '@',
                removeClass: '@',
                innerText: '@',
                innerTextSelector: '@',
                killAfterClick: '@'
            },
            link: function (scope, elem) {
                scope.innerTextSelector = scope.innerTextSelector || elem;

                elem.on('click', function () {
                    elem.removeClass(scope.removeClass).addClass(scope.addClass);
                    elem.find(scope.innerTextSelector).html(scope.innerText);
                    if (scope.killAfterClick) {
                        elem.attr("disabled", "disabled");
                    }

                });


            }
        };
    };

}());

(function () {

    'use strict';

    angular.module('scope.commons.directives')
        .directive('blur', blur);

    function blur() {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                blur: '=',
                question: '=',
                assessment: '='
            },
            link: function (scope, element, attrs, ngModel) {
                $(element).on('blur', function () {
                    scope.blur($(element).val(), scope.question ? scope.question : scope.assessment);
                })
            }
        }
    };

}());

(function() {
    'use strict';

    angular.module('scope.commons.components').component('tableFinancialStrategy', {
        templateUrl: 'components/table-financial-strategy/table-financial-strategy.html',
        bindings: {
            assessment: '<',
            markTableDone: '&',
            markRowNoInfo: '&',
            updateForm: '&',
            updateFormElement: '&'
        },
        controller: TableFSController
    });

    TableFSController.$inject = ['gettext', 'siProducts', 'siFormElement'];

    function TableFSController(gettext, siProducts, siFormElement) {
        const vm = this;
        vm.$onInit = () => {
            var toolParams = {
                fields: ['financetab_noinfo_options']
            };
            var assessment = vm.assessment.tool.id;
            return siProducts.getNestedToolOptions(assessment, toolParams).then(dropdown => {
                vm.dropdown =
                    dropdown && dropdown.financetab_noinfo_options && dropdown.financetab_noinfo_options.objects;
                console.log('DEBUG');
                console.log(dropdown);
                console.log(vm.dropdown);
            });
        };

        vm.update = (key, val) => {
            const value = val ? val : null;
            const originalValue = vm.assessment.financial_strategy[key];
            // Normalize originalValue to a number (strip trailing zeros)
            const normalizedOriginalValue = originalValue !== null ? parseFloat(originalValue) : '';
            console.log(
                `Updating ${key}: Attempting to set ${value}, original: ${originalValue}, normalized: ${normalizedOriginalValue}`
            );

            // Create temporary copy for validation
            const tempStrategy = angular.copy(vm.assessment.financial_strategy);
            tempStrategy[key] = value;

            // Calculate potential total
            const potentialTotal = vm.rows.reduce((sum, row) => {
                const rowValue = row.model === key ? value : tempStrategy[row.model];
                return sum + (rowValue ? parseInt(rowValue, 10) : 0);
            }, 0);

            // Validation check
            if (potentialTotal > 100) {
                alert('Total must not exceed 100%!');

                // Revert the model
                vm.assessment.financial_strategy[key] = originalValue; // Keep original format for model
                console.log(`Model reverted ${key} to: ${vm.assessment.financial_strategy[key]}`);

                // Find the input element inside form-number
                const formNumberElement = document.querySelector(`form-number[name="${key}"]`);
                const inputElement = formNumberElement ? formNumberElement.querySelector('input') : null;

                if (inputElement) {
                    // Use $timeout to ensure DOM update happens after current execution
                    const $timeout = angular.injector(['ng']).get('$timeout');
                    $timeout(() => {
                        // Update the DOM value to normalized number
                        inputElement.value = normalizedOriginalValue;
                        console.log(`DOM input for ${key} set to: ${inputElement.value}`);

                        // Update ng-model controller if available
                        const ngModelCtrl = angular.element(inputElement).controller('ngModel');
                        if (ngModelCtrl) {
                            ngModelCtrl.$setViewValue(normalizedOriginalValue);
                            ngModelCtrl.$render();
                            console.log(`ngModel view value for ${key} set to: ${ngModelCtrl.$viewValue}`);
                        } else {
                            // Fallback: Trigger input event
                            const inputEvent = new Event('input', { bubbles: true });
                            inputElement.dispatchEvent(inputEvent);
                            console.log(`Dispatched input event for ${key}`);
                        }

                        // Prevent focus from restoring invalid or formatted value
                        const preventInvalidFocus = () => {
                            if (inputElement.value !== String(normalizedOriginalValue)) {
                                inputElement.value = normalizedOriginalValue;
                                if (ngModelCtrl) {
                                    ngModelCtrl.$setViewValue(normalizedOriginalValue);
                                    ngModelCtrl.$render();
                                }
                                console.log(`Focus handler reverted ${key} to: ${inputElement.value}`);
                            }
                        };

                        // Add focus listener
                        inputElement.addEventListener('focus', preventInvalidFocus, { once: true });

                        // Log post-digest value
                        console.log(`After digest, DOM input for ${key}: ${inputElement.value}`);
                    }, 0);
                } else {
                    console.warn(`Input element for ${key} not found`);
                }

                return Promise.reject('Total exceeds 100%');
            }

            // Proceed with backend update
            return vm.updateForm({ obj: vm.assessment.financial_strategy, key, val: value }).then(() => {
                vm.assessment.financial_strategy[key] = value;
                console.log(`Updated ${key} to: ${value}`);
            });
        };

        vm.$doCheck = () => {
            vm.financeStrategyForm.hidden &&
                vm.financeStrategyForm.hidden.$setValididty(
                    'required',
                    vm.assessment.financial_strategy_no_information_available ||
                        vm.assessment.financial_strategy_completed
                );
            vm.hiddenForm =
                vm.assessment.financial_strategy_no_information_available || vm.assessment.financial_strategy_completed
                    ? 'valid'
                    : null;
        };

        vm.getTotal = rows =>
            rows
                .map(row => row.model)
                .reduce(
                    (count, model) =>
                        count +
                        (vm.assessment.financial_strategy[model]
                            ? parseInt(vm.assessment.financial_strategy[model], 10)
                            : 0),
                    0
                );

        vm.financeStrategyForm = {};

        vm.updateFormElement = (object, key, value, form, callback) => {
            if (callback) {
                callback(value);
            }
            return siFormElement.update(object, key, value, form).then(res => _.extend(object, res));
        };

        vm.areValuesDefined = () =>
            ['business_surplus', 'grant', 'loan', 'member_fee_capital', 'other', 'pre_finance']
                .filter(item => vm.assessment.financial_strategy[item] !== null)
                .reduce(() => true, false);

        vm.areValuesNull = () =>
            ['business_surplus', 'grant', 'loan', 'member_fee_capital', 'other', 'pre_finance']
                .filter(
                    item =>
                        vm.assessment.financial_strategy[item] === null &&
                        !vm.assessment.financial_strategy[`${item}_no_information_available`]
                )
                .reduce(() => true, false);

        vm.rows = [
            {
                name: gettext('Business surplus'),
                model: 'business_surplus',
                noInfo: 'business_surplus_no_information_available'
            },
            {
                name: gettext('Member fee/capital'),
                model: 'member_fee_capital',
                noInfo: 'member_fee_capital_no_information_available'
            },
            { name: gettext('Loan'), model: 'loan', noInfo: 'loan_no_information_available' },
            { name: gettext('Pre-finance'), model: 'pre_finance', noInfo: 'pre_finance_no_information_available' },
            { name: gettext('Grant'), model: 'grant', noInfo: 'grant_no_information_available' },
            { name: gettext('Other'), model: 'other', noInfo: 'other_no_information_available' }
        ];

        vm.isFinancialStrategyOver = () =>
            vm.assessment.financial_strategy && vm.assessment.financial_strategy.total > 100;

        vm.getLiveTotal = () => {
            return vm.rows.reduce((total, row) => {
                const inputValue = vm.assessment.financial_strategy[row.model];
                const parsed = parseInt(inputValue, 10);
                return total + (isNaN(parsed) ? 0 : parsed);
            }, 0);
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('tableCompBasicProfitLoss', {
        templateUrl: 'components/table-comp-basic-profit-loss/tableCompBasicProfitLossTemplate.html',
        bindings: {
            assessment: '<',
            tableData: '<',
            objectsExist: '<',
            noInfo: '@',
            tableComplete: '@',
            showError: '<',
            createFct: '&',
            updateFct: '&',
            updateForm: '&',
            globalCurrency: '<',
            updateCurrency: '&',
            noInfoReason: '@',
            noInfoReasonKey: '@',
            sourceOfDataDropdownOptions: '<'
        },
        controller: TableCompBasicProfitLossController
    });

    TableCompBasicProfitLossController.$inject = [
        '$rootScope',
        '$timeout',
        'siScope',
        'siProducts',
        'siFormElement',
        'currencies',
        'EVENT_LOADER',
        'siAssessments'
    ];

    function TableCompBasicProfitLossController(
        $rootScope,
        $timeout,
        siScope,
        siProducts,
        siFormElement,
        currencies,
        EVENT_LOADER,
        siAssessments
    ) {
        const vm = this;
        vm.filesStatus = {
            hasFiles: false,
            isRequired: false
        };
        vm.basicProfitLossForm = {};
        vm.innerForm = {};
        vm.$postLink = $postLink;
        vm.$doCheck = $doCheck;
        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;
        vm.markDone = markDone;
        vm.updateRow = updateRow;
        vm.createRow = createRow;
        vm.changeYear = changeYear;
        vm.isRequired = isRequired;
        vm.years = getYears();
        vm.updateFormElement = updateFormElement;
        vm.basicProfitLossExists = basicProfitLossExists;
        vm.currencies = currencies;
        vm.global_currency = vm.assessment.currency;
        vm.usedYears = [];
        vm.canComplete = canComplete;
        vm.isNetProfitOverflow = checkNetProfitOverflow();
        vm.deleteColumn = deleteColumn;
        vm.updateSourceOfData = updateSourceOfData;
        vm.threeYearPlanAvailable = threeYearPlanAvailable;
        vm.shouldShowSourceOfData = shouldShowSourceOfData;
        vm.noInfoDisabled = noInfoDisabled;
        vm.noInfoReasonDisabled = noInfoReasonDisabled;
        vm.clearSourceOfData = clearSourceOfData;
        vm.questionnaierShouldDisableNoInfo = questionnaierShouldDisableNoInfo;
        vm.getPreviousYearData = getPreviousYearData;
        vm.getYoYPercentageChange = getYoYPercentageChange;
        vm.isYoYHighlighted = isYoYHighlighted;
        vm.yoyComparisons = [];

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        // Default thresholds, overridden by values from /assessments/qcthresholds/ API
        var YOY_THRESHOLDS = {
            turnover: { increase: 100, decrease: -60 },
            gross_profit: { increase: 100, decrease: -30 },
            cost_of_sales: { increase: 30, decrease: -50 },
            net_profit: { increase: 100, decrease: -30 }
        };

        siAssessments
            .getQCThresholds()
            .then(function(data) {
                if (!Array.isArray(data)) {
                    vm.yoyComparisons = getYoYComparisons();
                    return;
                }

                var thresholdMap = {};
                data.forEach(function(item) {
                    thresholdMap[item.name] = item.value;
                });
                if (thresholdMap.hasOwnProperty('turnover_increase_pct')) {
                    YOY_THRESHOLDS.turnover.increase = thresholdMap['turnover_increase_pct'];
                }
                if (thresholdMap.hasOwnProperty('turnover_decrease_pct')) {
                    YOY_THRESHOLDS.turnover.decrease = thresholdMap['turnover_decrease_pct'];
                }
                if (thresholdMap.hasOwnProperty('cost_of_sales_increase_pct')) {
                    YOY_THRESHOLDS.cost_of_sales.increase = thresholdMap['cost_of_sales_increase_pct'];
                }
                vm.yoyComparisons = getYoYComparisons();
            })
            .catch(function() {
                vm.yoyComparisons = getYoYComparisons();
            });

        function getPreviousYearData(currentYear) {
            if (!currentYear || !vm.tableData) return null;
            for (var i = 0; i < vm.tableData.length; i++) {
                if (vm.tableData[i].year === currentYear - 1 && vm.tableData[i].id) {
                    return vm.tableData[i];
                }
            }
            return null;
        }

        function getYoYPercentageChange(currentValue, previousValue) {
            currentValue = parseFloat(currentValue);
            previousValue = parseFloat(previousValue);
            if (!previousValue || previousValue === 0 || isNaN(currentValue) || isNaN(previousValue)) return null;
            return ((currentValue - previousValue) / previousValue) * 100;
        }

        function isYoYHighlighted(field, currentValue, previousValue) {
            var pctChange = getYoYPercentageChange(currentValue, previousValue);
            if (pctChange === null) return false;
            var threshold = YOY_THRESHOLDS[field];
            if (!threshold) return false;
            return pctChange > threshold.increase || pctChange < threshold.decrease;
        }

        function getYoYComparisons() {
            var indicatorMap = {
                Turnover: { label: 'Turnover', comparisons: [] },
                'Gross Profit': { label: 'Gross Profit', comparisons: [] },
                'Net Profit': { label: 'Net Profit', comparisons: [] }
            };

            if (!vm.tableData)
                return Object.keys(indicatorMap).map(function(key) {
                    return indicatorMap[key];
                });

            var sorted = vm.tableData
                .filter(function(d) {
                    return d.year && d.id;
                })
                .sort(function(a, b) {
                    return a.year - b.year;
                });

            for (var i = 1; i < sorted.length; i++) {
                var curr = sorted[i];
                var prev = sorted[i - 1];
                if (curr.year !== prev.year + 1) continue;
                var periodLabel = curr.year + ' vs ' + prev.year;

                var turnoverChange = getYoYPercentageChange(
                    curr.turnover && curr.turnover.amount,
                    prev.turnover && prev.turnover.amount
                );
                indicatorMap['Turnover'].comparisons.push({
                    period: periodLabel,
                    change: turnoverChange,
                    highlighted:
                        turnoverChange !== null &&
                        isYoYHighlighted('turnover', curr.turnover.amount, prev.turnover.amount)
                });

                var currGP =
                    ((curr.turnover && curr.turnover.amount) || 0) -
                    ((curr.cost_of_sales && curr.cost_of_sales.amount) || 0);
                var prevGP =
                    ((prev.turnover && prev.turnover.amount) || 0) -
                    ((prev.cost_of_sales && prev.cost_of_sales.amount) || 0);
                var gpChange = getYoYPercentageChange(currGP, prevGP);
                indicatorMap['Gross Profit'].comparisons.push({
                    period: periodLabel,
                    change: gpChange,
                    highlighted: gpChange !== null && isYoYHighlighted('gross_profit', currGP, prevGP)
                });

                var currNP = currGP - ((curr.operational_costs && curr.operational_costs.amount) || 0);
                var prevNP = prevGP - ((prev.operational_costs && prev.operational_costs.amount) || 0);
                var npChange = getYoYPercentageChange(currNP, prevNP);
                indicatorMap['Net Profit'].comparisons.push({
                    period: periodLabel,
                    change: npChange,
                    highlighted: npChange !== null && isYoYHighlighted('net_profit', currNP, prevNP)
                });
            }

            return Object.keys(indicatorMap).map(function(key) {
                return indicatorMap[key];
            });
        }

        vm.inputValidationLimits = vm.assessment.input_validation_limits.filter(
            element => element.name === 'net_profit_usd' || element.name === 'turnover_usd'
        );

        vm.handleFilesChange = function(files, fileType, isRequired, hasFiles) {
            vm.filesStatus = {
                hasFiles: hasFiles,
                isRequired: isRequired
            };

            console.log('Production files changed:', vm.filesStatus);
        };

        function clearSourceOfData() {
            if (
                !vm.assessment.financial_information_source_of_data_source ||
                vm.assessment.financial_information_source_of_data_source.length === 0
            ) {
                return;
            }

            var patch = {
                url: vm.assessment.url,
                id: vm.assessment.id,
                financial_information_source_of_data_source: '',
                financial_information_source_of_data_selected: false
            };

            $rootScope.$broadcast(EVENT_LOADER.show);
            siScope
                .patch(patch)
                .then(res => {
                    console.log(res);
                    vm.assessment.financial_information_source_of_data_source = '';
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    console.error('Error:', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    alert('Error has occured.');
                });
        }

        function isYearComplete(profit) {
            if (!profit || !profit.id) return false;

            const requiredFields = ['turnover', 'cost_of_sales', 'operational_costs'];

            return requiredFields.every(field => {
                return (
                    profit[field] &&
                    profit[field].amount !== null &&
                    profit[field].amount !== undefined &&
                    profit[field].amount !== ''
                );
            });
        }

        function hasAnyFieldFilled(profit) {
            if (!profit || !profit.id) return false;

            const fields = ['turnover', 'cost_of_sales', 'operational_costs'];

            return fields.some(field => {
                return (
                    profit[field] &&
                    profit[field].amount !== null &&
                    profit[field].amount !== undefined &&
                    profit[field].amount !== ''
                );
            });
        }

        /*
        function isRequired(profit, current, compare) {
            if (
                !profit.id ||
                (!profit[current] && !profit[compare]) ||
                (profit[current] && !profit[current].amount && profit[compare] && !profit[compare].amount)
            ) {
                // console.log('vracamo false', profit, current, compare);
                return false;
            }
            console.log(
                profit[current] &&
                    ((profit[compare] && typeof profit[compare].amount === 'undefined') || !profit[compare]),
                'IS REQUIRED'
            );
            return (
                profit[current] &&
                ((profit[compare] && typeof profit[compare].amount === 'undefined') || !profit[compare])
            );
        }
        */

        function isRequired(profit, current) {
            if (!profit.id) return false;

            const threeYearPlan = threeYearPlanAvailable();

            if (threeYearPlan) {
                return true;
            } else {
                return hasAnyFieldFilled(profit);
            }
        }

        function shouldShowSourceOfData() {
            if (!vm.objectsExist) return false;

            const threeYearPlan = threeYearPlanAvailable();
            let dataValidation = false;

            if (threeYearPlan) {
                const yearsWithData = vm.tableData.filter(row => row.id);

                if (yearsWithData.length !== 3) return false;

                return yearsWithData.every(row => isYearComplete(row));
            } else {
                const yearsWithId = vm.tableData.filter(row => row.id);

                if (yearsWithId.length === 0) {
                    dataValidation = false;
                } else {
                    dataValidation = yearsWithId.every(row => {
                        const hasData = hasAnyFieldFilled(row);
                        const isComplete = isYearComplete(row);

                        //Every column either complete or empty (No partialy filled columns allowed)
                        return !hasData || isComplete;
                    });
                    return dataValidation;
                }
            }
        }

        function changeYear(data, year) {
            if (!year) return;
            data.year = year;
            if (data.id) {
                updateRow(data, 'year');
            } else {
                createRow(data);
            }
            vm.usedYears = vm.tableData.map(d => d.year).filter(d => d);
        }

        function getYears() {
            const startYear = 1900;

            const currentYear = new Date().getFullYear(),
                futureYear = currentYear + 6,
                years = [];

            for (var i = startYear; i < futureYear; i++) {
                years.push(i);
            }
            return years;
        }

        var _lastYoySnapshot = null;

        function $postLink() {}

        function $doCheck() {
            setHiddenFormValidity();
            var snapshot = _getYoySnapshot();
            if (snapshot !== _lastYoySnapshot) {
                _lastYoySnapshot = snapshot;
                vm.yoyComparisons = getYoYComparisons();
            }
        }

        function _getYoySnapshot() {
            if (!vm.tableData) return '';
            return vm.tableData
                .map(function(d) {
                    return [
                        d.year || '',
                        d.id || '',
                        (d.turnover && d.turnover.amount) || '',
                        (d.cost_of_sales && d.cost_of_sales.amount) || '',
                        (d.operational_costs && d.operational_costs.amount) || ''
                    ].join(',');
                })
                .join('|');
        }

        function createData(data) {
            let amount = 3 - data.length;
            let created = [];
            while (amount > 0) {
                created.push({});
                amount--;
            }

            return data.concat(created);
        }

        function isYearDisabled(data, current, year) {
            return (
                data
                    .filter(d => d.year !== current.year)
                    .map(d => d.year)
                    .indexOf(year) !== -1
            );
        }

        function setDisabledYears(data) {
            return data.map(d => {
                d.years = vm.years.map(yr => {
                    const year = {};
                    year.disabled = isYearDisabled(vm.tableData, d, yr);
                    year.name = yr;
                    return year;
                });
                return d;
            });
        }

        function threeYearPlanAvailable() {
            try {
                if (!vm.assessment || !vm.assessment.section_responses || !vm.assessment.section_responses.objects) {
                    return false;
                }

                const section = vm.assessment.section_responses.objects.find(
                    x => x.section_title === 'Financial Management'
                );
                if (!section || !section.children || !section.children.objects) {
                    return false;
                }

                const sub_section = section.children.objects.find(
                    x => x.section_title === 'Financial Reporting and Monitoring'
                );
                if (!sub_section || !sub_section.responses || !sub_section.responses.objects) {
                    return false;
                }

                const question = sub_section.responses.objects.find(x => x.question_title === 'Financial reporting');
                if (!question || !question.subresponses || !question.subresponses.objects) {
                    return false;
                }

                const sub_question = question.subresponses.objects.find(
                    x =>
                        x.subquestion &&
                        x.subquestion.title === "What is the quality of the organization's financial reports?"
                );
                if (!sub_question || !sub_question.checked_options || !sub_question.checked_options.objects) {
                    return false;
                }

                const hasThreeYearPlan = sub_question.checked_options.objects.find(
                    x => x.title === 'At least 3 years’ annual accounts are available'
                );

                return !!hasThreeYearPlan;
            } catch (error) {
                return false;
            }
        }

        function noInfoDisabled() {
            try {
                if ($rootScope.app == 'dashboard' && vm.assessment.finance_overview_tab_accepted) {
                    return true;
                }
                if (vm.assessment.basic_profit_loss_no_information_available) {
                    return false;
                }
                let questionnaierShouldDisableNoInfo = vm.questionnaierShouldDisableNoInfo();
                return questionnaierShouldDisableNoInfo;
            } catch (error) {
                return false;
            }
        }

        function noInfoReasonDisabled() {
            // Only disable the reason dropdown on the dashboard when QC has accepted the tab.
            // On smartclient the assessor must always be able to select a reason.
            return $rootScope.app === 'dashboard' && vm.assessment.finance_overview_tab_accepted;
        }

        function questionnaierShouldDisableNoInfo() {
            try {
                // Check if assessment and section_responses exist
                if (!vm.assessment || !vm.assessment.section_responses || !vm.assessment.section_responses.objects) {
                    return false;
                }

                const section = vm.assessment.section_responses.objects.find(
                    x => x.section_title === 'Financial Management'
                );
                if (!section || !section.children || !section.children.objects) {
                    return false;
                }

                const sub_section = section.children.objects.find(
                    x => x.section_title === 'Financial Reporting and Monitoring'
                );
                if (!sub_section || !sub_section.responses || !sub_section.responses.objects) {
                    return false;
                }

                const question = sub_section.responses.objects.find(x => x.question_title === 'Financial reporting');
                if (!question || !question.subresponses || !question.subresponses.objects) {
                    return false;
                }

                const sub_question = question.subresponses.objects.find(
                    x =>
                        x.subquestion &&
                        x.subquestion.title === "What is the quality of the organization's financial reports?"
                );
                if (!sub_question || !sub_question.checked_options || !sub_question.checked_options.objects) {
                    return false;
                }

                const hasInvalidOption = sub_question.checked_options.objects.find(
                    x =>
                        x.title === 'Reports are audited externally' ||
                        x.title === 'At least 3 years’ annual accounts are available'
                );

                return !!hasInvalidOption;
            } catch (error) {
                return false;
            }
        }

        function basicProfitLossExists() {
            return (
                vm.assessment.basicprofitlossstatements &&
                vm.assessment.basicprofitlossstatements.objects &&
                vm.assessment.basicprofitlossstatements.objects.length !== 0
            );
        }

        function processTableData(rawData) {
            var data = Array.isArray(rawData) ? rawData : [];
            data = data.length >= 3 ? data : createData(data);
            vm.tableData = data;
            data = setDisabledYears(data);
            data = initNullMoneyFields(data);
            return data;
        }

        function initNullMoneyFields(data) {
            return data.map(function(item) {
                ['turnover', 'cost_of_sales', 'operational_costs', 'net_profit'].forEach(function(key) {
                    if (item[key] === null) {
                        item[key] = { currency: undefined, amount: null };
                    }
                });
                return item;
            });
        }

        function $onChanges(changes) {
            if (changes.tableData && !changes.tableData.isFirstChange()) {
                var incoming = changes.tableData.currentValue;
                if (Array.isArray(incoming)) {
                    // Only fix null money fields in place — do NOT replace vm.tableData
                    // to preserve object references used by updateRow/createRow.
                    initNullMoneyFields(incoming);
                }
            }
        }

        function $onInit() {
            vm.tableData = processTableData(vm.tableData);
            var toolParams = {
                fields: ['financetab_noinfo_options']
            };
            var assessment = vm.assessment && vm.assessment.tool && vm.assessment.tool.id;
            vm.usedYears = vm.tableData.map(d => d.year).filter(d => d);
            if (!assessment) {
                vm.dropdown = [];
                return;
            }

            return siProducts
                .getNestedToolOptions(assessment, toolParams)
                .then(dropdown => {
                    vm.dropdown =
                        (dropdown &&
                            dropdown.financetab_noinfo_options &&
                            dropdown.financetab_noinfo_options.objects) ||
                        [];
                })
                .catch(function() {
                    vm.dropdown = [];
                });

            // siScope.remove(vm.tableData[0].url);
            // siScope.remove(vm.tableData[1].url);
            // siScope.remove(vm.tableData[2].url);
        }

        function updateRow(row, key) {
            if (row[key] && row[key].amount !== null && row[key].amount !== undefined) {
                const value = parseFloat(row[key].amount);

                if (value < 0) {
                    row[key].amount = null;
                    alert('Negative value not allowed. Value reset!');
                    return;
                }
            }
            vm.updateFct({ row, key })
                .then(res => {
                    _.extend(row, res);
                    vm.tableData = setDisabledYears(vm.tableData);
                    vm.isNetProfitOverflow = checkNetProfitOverflow();
                })
                .then(resetCompletion);
        }

        function createRow(data) {
            vm.createFct({ year: data.year })
                .then(res => {
                    _.extend(data, res);
                    vm.tableData = setDisabledYears(vm.tableData);
                })
                .then(resetCompletion);
        }

        function deleteColumn(profit) {
            $timeout(function() {
                vm.tableData = vm.tableData.map(x => {
                    return x.id === profit.id ? {} : x;
                });
                siScope
                    .remove(profit.url)
                    .then(() => {
                        if (
                            vm.assessment.basicprofitlossstatements &&
                            vm.assessment.basicprofitlossstatements.objects
                        ) {
                            const index = vm.assessment.basicprofitlossstatements.objects.findIndex(
                                x => x.id === profit.id
                            );
                            if (index !== -1) {
                                vm.assessment.basicprofitlossstatements.objects.splice(index, 1);
                            }
                        }

                        vm.tableData = vm.tableData.map(x => {
                            return x.id === profit.id ? {} : x;
                        });

                        vm.tableData = setDisabledYears(vm.tableData);
                        vm.usedYears = vm.tableData.map(d => d.year).filter(d => d);

                        vm.objectsExist = basicProfitLossExists();
                    })
                    .then(resetCompletion);
            }, 0);
        }

        function resetCompletion() {
            vm.isFormValid = false;
            // Don't do anything if complete and no_info are already false
            if (!vm.assessment[vm.tableComplete] && !vm.assessment[vm.noInfo]) return;
            return vm
                .updateForm({ obj: vm.assessment, key: vm.tableComplete, val: false })
                .then(() => vm.updateForm({ obj: vm.assessment, key: vm.noInfo, val: false }))
                .then(() => {
                    setHiddenFormValidity();
                });
        }

        function canSelectSourceOfData() {
            if (vm.assessment.basic_profit_loss_completed) {
                return true;
            }

            const threeYearPlan = threeYearPlanAvailable();

            let dataValidation = false;

            if (threeYearPlan) {
                const yearsWithData = vm.tableData.filter(row => row.id);
                dataValidation = yearsWithData.length === 3 && yearsWithData.every(row => isYearComplete(row));
            } else {
                const yearsWithSomeData = vm.tableData.filter(row => hasAnyFieldFilled(row));
                dataValidation = yearsWithSomeData.length > 0 && yearsWithSomeData.every(row => isYearComplete(row));
            }

            const selected = vm.assessment.financial_information_source_of_data_source;

            return (
                vm.global_currency &&
                vm.globalCurrency &&
                !vm.innerForm.$invalid &&
                dataValidation &&
                selected &&
                selected.length > 0 &&
                vm.sourceOfDataDropdownOptions.some(option => option.display_name === selected)
            );
        }

        function canComplete() {
            if (vm.assessment.basic_profit_loss_completed) {
                return true;
            }

            const threeYearPlan = threeYearPlanAvailable();

            let dataValidation = false;

            if (threeYearPlan) {
                const yearsWithData = vm.tableData.filter(row => row.id);
                dataValidation = yearsWithData.length === 3 && yearsWithData.every(row => isYearComplete(row));
            } else {
                const yearsWithId = vm.tableData.filter(row => row.id);

                if (yearsWithId.length === 0) {
                    dataValidation = false;
                } else {
                    dataValidation = yearsWithId.every(row => {
                        const hasData = hasAnyFieldFilled(row);
                        const isComplete = isYearComplete(row);

                        //Every column either complete or empty (No partialy filled columns allowed)
                        return !hasData || isComplete;
                    });
                }
            }

            const selected = vm.assessment.financial_information_source_of_data_source;

            const filesValid = !vm.filesStatus.isRequired || vm.filesStatus.hasFiles;

            return (
                vm.global_currency &&
                vm.globalCurrency &&
                dataValidation &&
                selected &&
                selected.length > 0 &&
                filesValid &&
                vm.sourceOfDataDropdownOptions.some(option => option.display_name === selected)
            );
        }

        function checkNetProfitOverflow() {
            try {
                return vm.assessment.basicprofitlossstatements.objects.some(
                    x => +x.net_profit.amount > +x.gross_profit.amount
                );
            } catch (e) {
                return false;
            }
        }

        function setHiddenFormValidity() {
            if (vm.assessment && !_.isEmpty(vm.basicProfitLossForm)) {
                if (!vm.basicProfitLossForm.hidden) return;
                const isValid =
                    (vm.assessment[vm.noInfo] && vm.assessment[vm.noInfoReasonKey]) || vm.assessment[vm.tableComplete];
                vm.basicProfitLossForm.hidden.$setValidity('required', isValid);
                vm.hiddenForm = isValid ? 'valid' : null;
                vm.isFormValid = isValid;
            }
        }

        function markDone(doneType) {
            // Toggle the selected doneType
            vm.assessment[doneType] = !vm.assessment[doneType];

            // If toggling off noInfo, reset the reason
            if (!vm.assessment[vm.noInfo]) {
                vm.assessment[vm.noInfoReasonKey] = '';
            }

            // Update form validity states
            vm.basicProfitLossForm.hidden.$setValidity('required', vm.assessment[doneType]);
            vm.hiddenForm = vm.assessment[doneType] ? 'valid' : null;
            vm.isFormValid = vm.assessment[doneType];

            // Uncheck the opposite toggle if needed
            const otherDoneType = vm.tableComplete === doneType ? vm.noInfo : vm.tableComplete;
            if (vm.assessment[otherDoneType]) {
                vm.assessment[otherDoneType] = false;
            }

            var financial_information_source_of_data_selected =
                vm.assessment.financial_information_source_of_data_source &&
                vm.assessment.financial_information_source_of_data_source.length > 0
                    ? true
                    : false;

            var patch = {
                url: vm.assessment.url,
                id: vm.assessment.id,
                [doneType]: vm.assessment[doneType],
                [otherDoneType]: vm.assessment[otherDoneType],
                [vm.noInfoReasonKey]: vm.assessment[vm.noInfoReasonKey],
                financial_information_source_of_data_source: vm.assessment.financial_information_source_of_data_source,
                financial_information_source_of_data_selected: financial_information_source_of_data_selected,
                finance_overview_tab_completed: vm.assessment.finance_overview_tab_completed
            };

            // Send patch manually
            siScope.patch(patch).then(res => {
                console.log(res);
                // Optionally show toast or handle success
            });
        }

        function updateFormElement(object, key, value, form, callback) {
            if (callback) {
                callback(value);
            }
            return siFormElement.update(object, key, value, form).then(res => {
                _.extend(object, res);
            });
        }

        function updateSourceOfData(model) {
            if (model) {
                vm.assessment.financial_information_source_of_data_source = model;
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('tableComp', {
        templateUrl: 'components/table-comp/tableCompTemplate.html',
        bindings: {
            heading: '@',
            assessment: '<',
            tableData: '<',
            tabTitle: '@',
            isFlat: '@',
            key: '@',
            fieldMap: '<',
            noInfo: '@',
            tableComplete: '@',
            showError: '<',
            createFct: '&',
            updateFct: '&',
            deleteFct: '&',
            updateForm: '&',
            infoTextKey: '@',
            noInfoReason: '@',
            noInfoReasonKey: '@',
            tabAcceptedField: '@',
            isTableDisabled: '@',
            isDisabled: '<'
        },
        controller: TableCompController
    });

    TableCompController.$inject = ['$scope', '$filter', '$parse', 'siProducts', 'siFormElement', '$rootScope'];

    function TableCompController($scope, $filter, $parse, siProducts, siFormElement, $rootScope) {
        var vm = this;
        var form = {};
        vm.$onInit = $onInit;
        vm.$postLink = $postLink;
        vm.$onChanges = $onChanges;

        vm.getValue = getValue;
        vm.showField = showField;
        vm.markDone = markDone;
        vm.deleteRow = deleteRow;
        vm.updateRow = updateRow;
        vm.createRow = createRow;
        vm.updateNoInfoReason = updateNoInfoReason;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            var toolParams = {
                fields: ['financetab_noinfo_options']
            };
            var assessment = vm.assessment.tool.id;
            return siProducts.getNestedToolOptions(assessment, toolParams).then(dropdown => {
                vm.dropdown =
                    dropdown && dropdown.financetab_noinfo_options && dropdown.financetab_noinfo_options.objects;
            });
        }

        function $postLink() {
            form = $scope[vm.key];
            setHiddenFormValidity(vm.tableData);
        }

        function $onChanges(changes) {
            if (changes.tableData && typeof changes.tableData.currentValue !== 'undefined') {
                setHiddenFormValidity(changes.tableData.currentValue);
            }
        }

        function updateNoInfoReason(obj, key, val) {
            vm.updateForm({ obj, key, val });
        }

        function deleteRow(row) {
            vm.deleteFct({ row: row }).then(resetCompletion);
        }

        function updateRow(row) {
            vm.updateFct({ row: row }).then(resetCompletion);
        }

        function createRow() {
            vm.createFct().then(resetCompletion);
        }

        function setHiddenFormValidity(tableData) {
            if (tableData && !_.isEmpty(form)) {
                if (!form.hidden) return;
                var isValid = tableData[vm.noInfo] || tableData[vm.tableComplete];
                form.hidden.$setValidity('required', isValid);
                vm.hiddenForm = isValid ? 'valid' : null;
                vm.isFormValid = isValid;
            }
        }

        function resetCompletion() {
            vm.isFormValid = false;

            // Don't do anything if complete and no_info are already false
            if (!vm.tableData[vm.tableComplete] && !vm.tableData[vm.noInfo]) return;
            return vm
                .updateForm({ obj: vm.tableData, key: vm.tableComplete, val: false })
                .then(() => vm.updateForm({ obj: vm.tableData, key: vm.noInfo, val: false }))
                .then(() => setHiddenFormValidity(vm.tableData));
        }

        function markDone(doneType) {
            vm.tableData[doneType] = !vm.tableData[doneType];
            // Reset no info reason when resetting No Info
            if (!vm.tableData[vm.noInfo]) {
                vm.updateForm({ obj: vm.tableData, key: vm.noInfoReasonKey, val: '' });
            }
            form.hidden.$setValidity('required', vm.tableData[doneType]);
            vm.hiddenForm = vm.tableData[doneType] ? 'valid' : null;
            vm.isFormValid = vm.tableData[doneType];
            vm.updateForm({ obj: vm.tableData, key: doneType, val: vm.tableData[doneType] }).then(() => {
                const otherDoneType = vm.tableComplete === doneType ? vm.noInfo : vm.tableComplete;
                if (vm.assessment[otherDoneType]) {
                    vm.updateForm({ obj: vm.tableData, key: otherDoneType, val: false });
                }
            });
        }

        function getValue(field, row) {
            if (field.key.indexOf('.') === -1) return row[field.key];

            var parse = $parse(field.key);
            var value = parse({ row });

            if (field.valueIfNot && !value) {
                value = field.valueIfNot;
            }

            if (field.valueMap) {
                value = field.valueMap[String(value)];
            }

            if (value && value.objects) {
                value = value.objects.map(val => val.display_name).join(', ');
            }

            return applyFilter(value, field, row);
        }

        function applyFilter(value, field, row) {
            if (!field.filter) return value;

            var parse = $parse(field.filter);
            return parse({ value: value, row: row });
        }

        function showField(field, row) {
            if (!field.showIf) return true;

            var parse = $parse(field.showIf);
            return parse({ row: row, assessment: vm.assessment });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('stepCircles', {
        templateUrl: 'components/step-circles/step-circles.html',
        bindings: {
            steps: '<',
            active: '@'
        }
    });
})();

(function () {

    'use strict';

    angular.module('scope.commons.components')
        .component('siSidebar', {
            templateUrl: 'components/sidebar/sidebar.html',
            transclude: {
                'content': 'siCommentBox',
            },
            controller: siSidebarController
    });

    siSidebarController.$inject = ['$element', '$timeout', '$window']

    function siSidebarController($element, $timeout, $window) {

        var vm = this;

        var window = angular.element($window);
        var commentBox;

        vm.$postLink = $postLink;
        vm.$onDestroy = $onDestroy;

        function $postLink() {
            $timeout(function() {
                commentBox = $element.find('si-comment-box');
                window.on('scroll', scrollHandler);
            });
        }

        function $onDestroy() {
            window.off('scroll', scrollHandler)
        }

        function scrollHandler() {
            var offsetTop = $element[0].offsetTop;
            var scrollHeight = $window.scrollY;
            if(scrollHeight > offsetTop) {
                commentBox.css({'margin-top': scrollHeight-offsetTop})
            } else {
                commentBox.css({'margin-top': 0})
            }
        }

    }

}());

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siProductTypeOptions', {
        templateUrl: 'components/si-product-type-options/si-product-type-options.html',
        bindings: { optionsList: '<', addCategory: '&', editCategory: '&', removeCategory: '&' },
        controller: siProductTypeOptionsController,
        transclude: true
    });

    siProductTypeOptionsController.$inject = [
        '$rootScope',
        '$timeout',
        'siScope',
        'apiUrl',
        '$uibModal',
        'EVENT_LOADER'
    ];

    function siProductTypeOptionsController($rootScope, $timeout, siScope, apiUrl, $uibModal, EVENT_LOADER) {
        var vm = this;

        vm.addItem = addItem;
        vm.removeItem = removeItem;
        vm.addNewCategory = addNewCategory;
        vm.openEditModal = openEditModal;

        vm.$onInit = () => {
            vm.loadRelatedList(vm.optionsList[0].name);
        };

        vm.loadRelatedList = name => {
            vm.mainListName = name;

            vm.relatedList = vm.optionsList
                .filter(o => o.name === name)
                .map(o => o.product_per_type_options.objects)
                .reduce((memo, option) => memo.concat(option), []);

            vm.createUrl = vm.optionsList
                .filter(o => o.name === name)
                .map(o => o.product_per_type_options.links.create)
                .reduce((memo, url) => url, '');

            vm.category = vm.optionsList.filter(o => o.name === name).reduce((memo, category) => category, {});

            vm.productType = vm.category.url;
        };

        function openEditModal() {
            const modalOptions = {
                templateUrl: 'components/si-product-type-options/edit-category-modal.html',
                resolve: {
                    name: () => vm.mainListName,
                    canDelete: () => vm.relatedList.length === 0,
                    id: () =>
                        vm.optionsList
                            .filter(o => o.name === vm.mainListName)
                            .map(o => o.id)
                            .reduce((memo, id) => id, '')
                },
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'name',
                    'canDelete',
                    'id',
                    function($scope, $uibModalInstance, name, canDelete, id) {
                        $scope.name = name;
                        $scope.canDelete = canDelete;
                        $scope.save = () => $uibModalInstance.close({ name: $scope.name, id });
                        $scope.cancel = () => $uibModalInstance.dismiss();
                        $scope.delete = () => $uibModalInstance.close({ delete: true, name, id });
                    }
                ]
            };

            return $uibModal.open(modalOptions).result.then(action => {
                if (action.delete) {
                    vm.removeCategory({
                        name: action.name,
                        id: action.id
                    });
                    vm.loadRelatedList(vm.optionsList[0].name);
                }

                if (action.name !== vm.mainListName) {
                    vm.editCategory({ name: action.name, id: action.id });
                    vm.mainListName = action.name;
                }
            });
        }

        function addNewCategory(name) {
            return vm.addCategory({ name }).then(() => {
                vm.newCategory = '';
                $timeout(() => vm.loadRelatedList(name), 200);
            });
        }

        function addItem() {
            if (!vm.newItem) {
                return;
            }
            vm.isDefined =
                vm.relatedList && vm.relatedList.filter(item => item.name === vm.newItem).reduce(() => true, false);

            if (vm.isDefined) {
                vm.newItem = '';
                return $timeout(() => (vm.isDefined = false), 2000);
            }

            $rootScope.$broadcast(EVENT_LOADER.show);

            var createObject = { title: vm.newItem, name: vm.newItem, product_type: vm.productType };

            siScope.create(createObject, vm.createUrl).then(createdObject => {
                vm.relatedList.push(createdObject);
                vm.newItem = '';
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function removeItem(item) {
            siScope.remove(item.url);
            vm.relatedList.splice(vm.relatedList.indexOf(item), 1);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siPage', {
        templateUrl: 'components/si-page/si-page.html',
        transclude: true,
        bindings: {
            isColumnar: '<',
            search: '<',
            background: '@'
        }
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siInfoText', {
        templateUrl: 'components/si-info-text/si-info-text.html',
        bindings: { tool: '<', saveInfoText: '&' },
        controller: siInfoTextController
    });

    siInfoTextController.$inject = ['siInfoText', '$scope'];

    function siInfoTextController(siInfoText, $scope) {
        var vm = this;

        vm.section = {};
        vm.tabs = siInfoText.tabs;
        vm.setInfoText = setInfoText;
        vm.save = save;
        vm.shouldShowSection = shouldShowSection;
        vm.shouldShowTab = shouldShowTab;

        $scope.wysiwig_options = {
            height: 500,
            toolbar: [
                ['font', ['fontname', 'fontsize', 'color', 'bold', 'italic', 'underline', 'clear']],
                ['misc', ['undo', 'redo']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'table', 'hr']]
            ]
        };

        function shouldShowTab(tab) {
            return tab.sections.filter(section => shouldShowSection(section)).reduce((memo, section) => section, false);
        }

        function shouldShowSection(section) {
            if (typeof vm.tool === 'undefined') return;
            return section.tools.filter(tool => vm.tool.type[tool]).reduce((memo, tool) => tool, false);
        }

        function setInfoText(section) {
            // debugger;
            vm.infoText = vm.tool[section.key];
            vm.section = section;
        }

        function save() {
            const patch = {
                url: vm.tool.url
            };
            patch[vm.section.key] = vm.infoText;
            vm.tool[vm.section.key] = vm.infoText;
            return vm.saveInfoText({ patch });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siInfoTextDisplay', {
        templateUrl: 'components/si-info-text/si-info-text-display.html',
        bindings: { assessment: '<', key: '@', hardcodedtext: '=' },
        controller: siInfoTextDisplayController,
        transclude: true
    });

    siInfoTextDisplayController.$inject = ['$sce'];

    function siInfoTextDisplayController($sce) {
        var vm = this;

        vm.$onChanges = change => {
            if (change && change.assessment && change.assessment.currentValue) {
                if (vm.hardcodedtext) {
                    vm.text = vm.hardcodedtext;
                    vm.text = $sce.trustAsHtml(vm.text);
                } else {
                    vm.text = vm.assessment && vm.assessment.tool && vm.assessment.tool[`display_${vm.key}`];
                    vm.text = $sce.trustAsHtml(vm.text);
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siGlobalDropdown', {
        templateUrl: 'components/si-global-dropdown/si-global-dropdown.html',
        bindings: {
            label: '@',
            optionsList: '<',
            path: '<'
        },
        controller: siGlobalDropdown,
        transclude: true
    });

    siGlobalDropdown.$inject = ['$scope', '$rootScope', '$timeout', 'siScope', 'EVENT_LOADER', 'apiUrl', 'toastr'];

    function siGlobalDropdown($scope, $rootScope, $timeout, siScope, EVENT_LOADER, apiUrl, toastr) {
        var vm = this;
        console.log(vm.path);
        var createUrl = apiUrl + vm.path;

        vm.addItem = addItem;
        vm.removeItem = removeItem;
        vm.mouseEnter = mouseEnter;
        vm.mouseLeave = mouseLeave;
        vm.movedIteam = movedIteam;
        vm.selected = null;
        vm.hover = null;

        function mouseEnter(item) {
            vm.hover = item;
        }

        function mouseLeave(item) {
            vm.hover = null;
        }

        function movedIteam($index, item) {
            vm.optionsList.splice($index, 1);
            vm.hover = null;
            let position = 0;

            for (let i = 0; i < vm.optionsList.length; i++) {
                if (vm.optionsList[i].url == item.url) {
                    position = i;
                    break;
                }
            }

            siScope.patch(item, { position: position, url: item.url });
        }

        function addItem() {
            if (!vm.newItem) {
                return;
            }
            vm.isDefined =
                vm.optionsList && vm.optionsList.filter(item => item.name === vm.newItem).reduce(() => true, false);

            if (vm.isDefined) {
                vm.newItem = '';
                return $timeout(() => (vm.isDefined = false), 2000);
            }

            $rootScope.$broadcast(EVENT_LOADER.show);

            var createObject = { title: vm.newItem, name: vm.newItem };

            siScope.create(createObject, createUrl).then(function(createdObject) {
                vm.optionsList.push(createdObject);
                vm.newItem = '';
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function removeItem(item) {
            siScope.remove(item.url);
            vm.optionsList.splice(vm.optionsList.indexOf(item), 1);
        }

        $scope.$on('item.drop-model', (e, el) => {
            $rootScope.$broadcast('saving-move', el);

            vm.optionsList.forEach((item, index) => {
                item.position = index;
            });

            //We need this to be in a timeout so we get the updated data-position based on the new digest cycle
            $timeout(function() {
                var position = el.attr('data-position') || 0;

                var patch = {
                    url: vm.optionsList[position].url,
                    position
                };

                siScope
                    .patch(patch)
                    .catch(function(err) {
                        toastr.error('Error Patching - ', err);
                    })
                    .finally(function() {
                        $rootScope.$broadcast('move-saved', el);
                    });
            });
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siDatepicker', {
        templateUrl: 'components/si-datepicker/si-datepicker.html',
        require: {
            ngModelCtrl: '^ngModel'
        },
        bindings: {
            ngModel: '<',
            isDisabled: '<',
            onChange: '&',
            isRequired: '@',
            name: '@',
            placeholder: '@',
            options: '<',
            minDate: '<',
            maxDate: '<'
        },
        controller: DatePickerController
    });

    DatePickerController.$inject = ['moment', 'uibDateParser'];

    function DatePickerController(moment, uibDateParser) {
        var vm = this;

        vm.format = 'dd/MM/yyyy';

        vm.open = $event => {
            $event.preventDefault();
            $event.stopPropagation();
            vm.opened = true;
        };

        vm.$onInit = () => {
            vm.name = vm.name || 'date-picker';
            vm.options = vm.options || {};

            // Initialize options with min/max dates if provided
            if (vm.minDate) {
                vm.options.minDate = moment(vm.minDate).toDate();
            }
            if (vm.maxDate) {
                vm.options.maxDate = moment(vm.maxDate).toDate();
            }

            if (vm.options.initDate) {
                vm.options.initDate = moment(vm.options.initDate).format('DD/MM/YYYY');
            }

            vm.ngModel = vm.ngModel
                ? uibDateParser.parse(vm.ngModel, vm.format)
                : vm.options && vm.options.initDate
                ? uibDateParser.parse(vm.options.initDate, vm.format)
                : null;
        };

        vm.$onChanges = changes => {
            if (changes.ngModel && changes.ngModel.currentValue) {
                vm.ngModel = uibDateParser.parse(moment(changes.ngModel.currentValue).toDate(), vm.format);
            }

            // Handle min/max date changes
            if (changes.minDate) {
                vm.options = vm.options || {};
                vm.options.minDate = changes.minDate.currentValue
                    ? moment(changes.minDate.currentValue).toDate()
                    : null;
            }

            if (changes.maxDate) {
                vm.options = vm.options || {};
                vm.options.maxDate = changes.maxDate.currentValue
                    ? moment(changes.maxDate.currentValue).toDate()
                    : null;
            }
        };

        vm.formatDate = () => {
            //This is our pseudo hack to get the view value set again outside the scope of the
            //component. It will trigger a change above and then transform the value back into
            //something the component likes but since its single way binding it wont go back out of
            //the component as the backend expects the below format but the datepicker doesnt like it.
            //TODO: Could be something to fix at a later date...
            const formattedDate = moment(vm.ngModel).format('YYYY-MM-DD');
            vm.ngModelCtrl.$setViewValue(formattedDate);

            if (vm.onChange) {
                vm.onChange({ date: formattedDate });
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siContacts', {
        templateUrl: 'components/si-contacts/si-contacts.html',
        bindings: {
            contacts: '<',
            isContactPerson: '<',
            isOrganizationTab: '<',
            addContact: '&',
            editContact: '&',
            deleteContact: '&'
        },
        controller: siContactsController
    });

    siContactsController.$inject = [];

    function siContactsController() {
        const vm = this;
        console.log(vm.contacts);
        vm.displayContacts = [];

        vm.$doCheck = () => {
            const contacts = (vm.contacts && vm.contacts.objects) || [];
            vm.displayContacts = vm.isContactPerson
                ? contacts.filter(c => c && c.is_contact_person)
                : contacts.filter(c => c && !c.is_contact_person);
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siConditionalQuestion', {
        template:
            '<style>fieldset:disabled {background-color: #dddddd; opacity:.3}</style><fieldset ng-disabled="!$ctrl.shouldShow"><ng-transclude/></fieldset>',
        bindings: {
            question: '<',
            questions: '<',
            updateFct: '&',
            resetFct: '&'
        },
        transclude: true,
        controller: siConditionalQuestionController
    });

    siConditionalQuestionController.$inject = [];

    function siConditionalQuestionController() {
        const vm = this;
        vm.shouldShow = false;

        vm.$doCheck = () => {
            if (vm.question && vm.question.subquestion.is_conditional) {
                vm.shouldShow = vm.questions
                    .filter(question => question.subquestion.url === vm.question.subquestion.conditional_subquestion)
                    .filter(
                        question => question.selected_option === vm.question.subquestion.conditional_subquestion_option
                    )
                    .reduce(() => true, false);

                if (!vm.shouldShow) {
                    resetQuestion(vm.question);
                }
            } else {
                vm.shouldShow = true;
            }
        };

        const resetQuestion = question => {
            const type = question.subquestion.type;

            const resetMPC = question => {
                if (question.selected_option || question.not_relevant) {
                    question.subquestion.checked = null;
                    question.not_relevant = false;
                    return vm.resetFct({ question });
                }
            };

            const resetCheckbox = question => {
                const hasChecked = question.subquestion.options.objects
                    .filter(option => option.checked)
                    .reduce(() => true, false);

                if (hasChecked || question.none_of_the_above || question.not_relevant) {
                    question.subquestion.options.objects = question.subquestion.options.objects.map(option => {
                        option.checked = false;
                        return option;
                    });
                    question.none_of_the_above = false;
                    question.not_relevant = false;
                    return vm.resetFct({ question });
                }
            };

            const resetNumeric = question => {
                if (question.value || question.invalidRange) {
                    question.value = '';
                    return vm.resetFct({ question });
                }
            };

            switch (type) {
                case 'mpc':
                    return resetMPC(question);
                case 'checkbox':
                    return resetCheckbox(question);
                case 'numeric':
                    return resetNumeric(question);
                default:
                    return;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siCompareValues', {
        templateUrl: 'components/si-compare-values/si-compare-values.html',
        bindings: {
            compareTo: '<',
            value: '<'
        },
        controller: CompareValuesController
    });

    CompareValuesController.$inject = [];

    function CompareValuesController() {
        var vm = this;

        vm.$onChanges = () => {
            vm.difference = parseInt(vm.compareTo, 10) - parseInt(vm.value, 10);
            vm.success = vm.difference === 0;
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siAssesseeImageUpload', {
        templateUrl: 'components/si-assessee-image-upload/si-assessee-image-upload.html',
        bindings: {
            images: '<',
            assessment: '<',
            addImage: '&',
            editImage: '&',
            isOffline: '<'
        },
        controller: ImageUploadController
    });

    ImageUploadController.$inject = ['$uibModal', 'siScope', 'toastr'];

    function ImageUploadController($uibModal, siScope, toastr) {
        var vm = this;

        vm.remove = ({ url }) =>
            siScope.remove(url).then(() => {
                vm.images = vm.images.filter(image => image.url !== url);
            });
        vm.expand = image => {
            const modalOptions = {
                templateUrl: 'components/si-assessee-image-upload/si-assessee-image-upload-modal-edit.html',
                resolve: {
                    image: () => image,
                    editImage: () => vm.editImage
                },
                controllerAs: '$ctrl',
                controller: [
                    '$uibModalInstance',
                    '$q',
                    '$timeout',
                    'siScope',
                    'image',
                    'editImage',
                    function($uibModalInstance, $q, $timeout, siScope, image, editImage) {
                        const vm = this;
                        vm.save = save;
                        vm.cancel = () => $uibModalInstance.dismiss('cancel');
                        vm.image = image;

                        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                         Method Declarations
                         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

                        function save() {
                            vm.isUploading = true;
                            editImage({ image: vm.image })
                                .then(() => (vm.isUploading = false))
                                .then(() => $uibModalInstance.close());
                        }
                    }
                ]
            };

            $uibModal.open(modalOptions);
        };
        vm.openAddImageModal = () => {
            const modalOptions = {
                templateUrl: 'components/si-assessee-image-upload/si-assessee-image-upload-modal.html',
                controllerAs: '$ctrl',
                resolve: {
                    assessment: () => vm.assessment,
                    addImage: () => vm.addImage
                },
                controller: [
                    '$uibModalInstance',
                    'assessment',
                    '$q',
                    '$timeout',
                    'addImage',
                    function($uibModalInstance, assessment, $q, $timeout, addImage) {
                        const vm = this;
                        vm.save = save;
                        vm.cancel = () => $uibModalInstance.dismiss('cancel');

                        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                         Method Declarations
                         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
                        $timeout(() => {
                            const input = angular.element('#upload-image-input');
                            input.on('change', documentsChanged);
                        }, 200);

                        function readAsBinaryString(file) {
                            var deferred = $q.defer();
                            var fileReader = new FileReader();

                            fileReader.onload = function(e) {
                                deferred.resolve({
                                    file: file,
                                    data: e.target.result
                                });
                            };

                            fileReader.onabort = fileReader.onerror = function() {
                                deferred.reject();
                            };

                            fileReader.readAsDataURL(file);
                            return deferred.promise;
                        }

                        function documentsChanged() {
                            // set post data with relation e.g. data['response'] =
                            var data = {};
                            var allowedExtensions = ['jpg', 'jpeg', 'png'];

                            var fileReaderPromises = _.map(this.files, readAsBinaryString);

                            $q.allSettled(fileReaderPromises).then(files => {
                                const fileUploadPromises = _.chain(files)
                                    .filter(file => file.state === 'fulfilled')
                                    .map(file => {
                                        if (
                                            allowedExtensions.includes(
                                                file.value.file.name
                                                    .toLowerCase()
                                                    .split('.')
                                                    .pop()
                                            )
                                        ) {
                                            // extend post data with file props
                                            data = _.extend(data, {
                                                file_name: file.value.file.name,
                                                file: file.value.data
                                            });

                                            vm.image = data;
                                        } else {
                                            toastr.error('File is not an image.');
                                            angular.element('#upload-image-input').val('');
                                        }
                                    })
                                    .value();

                                return $q.allSettled(fileUploadPromises);
                            });
                        }

                        function save() {
                            vm.isUploading = true;
                            vm.image.title = vm.title;
                            return addImage({ image: vm.image, assessment })
                                .then(() => (vm.isUploading = false))
                                .then(() => $uibModalInstance.close());
                        }
                    }
                ]
            };

            $uibModal.open(modalOptions);
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.components')
        .component('search', {
            templateUrl: 'components/search/searchTemplate.html',
            transclude: true,
            controller: SearchController
        });

    SearchController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$location',
        '$timeout',
        'EVENT_LOADER'];

    function SearchController($rootScope,
                              $scope,
                              $state,
                              $location,
                              $timeout,
                              EVENT_LOADER) {

        var vm = this;
        vm.search = $location.search().search || '';
        vm.isOffline = $rootScope.isOffline;
        vm.searchFct = vm.searchFct ? vm.searchFct : setSearchTerm;

        vm.getResults = getResults;
        vm.clearSearch = clearSearch;


        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function clearSearch() {
            vm.search = '';
            vm.searchFct({search: ''});
        }

        function getResults() {
            if (vm.isOffline) {
                return false;
            }
            vm.searchFct({search: vm.search});
        }

        function setSearchTerm() {
            if (!vm.search && vm.search !== '') return true;
            var params = {
                search: vm.search,
                // Set page to 1 since we don't know how many pages the result will have
                page: 1
            };
            $state.go($state.current.name, params);
        }

        $rootScope.$watch('isOffline', function (newVal) {
            vm.isOffline = newVal;
        });

    }
}());

(function() {
    'use strict';

    angular.module('scope.commons.components').component('rating', {
        templateUrl: 'components/rating/rating.html',
        transclude: true,
        bindings: {
            ngModel: '=',
            isDisabled: '<',
            onChange: '&',
            isRequired: '@',
            name: '@'
        },
        controller: RatingController
    });

    RatingController.$inject = [];

    function RatingController() {
        const vm = this;

        vm.hoveringOver = function(value) {
            vm.overStar = value;
            vm.percent = 100 * (value / vm.max);
        };

        vm.$onInit = () => {
            vm.name = vm.name || 'rating';
            vm.rating = vm.rating || 0;
            vm.max = vm.max || 5;
            vm.ngModel = vm.ngModel;
        };

        vm.$onChanges = change => {
            vm.ngModel = (change && change.ngModel) || vm.ngModel;
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('qcReviewTab', {
        bindings: {
            isAccepted: '@',
            isCompleted: '@',
            assessment: '<',
            form: '<',
            updateFct: '&',
            isDisabled: '<',
            showTabWarnings: '&',
            name: '@',
            acceptedText: '@',
            reopenText: '@'
        },
        templateUrl: 'components/qc-review-tab/qc-review-tab.html',
        controller: QCReviewTabController
    });

    QCReviewTabController.$inject = ['$uibModal', '$rootScope', 'gettext'];

    function QCReviewTabController($uibModal, $rootScope, gettext) {
        var vm = this;

        vm.updateTab = updateTab;

        vm.acceptedText = vm.acceptedText || gettext('Accept Tab');
        vm.reopenText = vm.reopenText || gettext('Re-open Tab');

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function updateTab(isMarked) {
            // Show warning if button is disabled and we are locking the tab and we're not in trainee env and no info is not selected
            if (vm.isDisabled && isMarked && !$rootScope.isTrainee) {
                vm.showTabWarnings();
                return $uibModal.open({
                    templateUrl: 'components/qc-review-tab/qc-review-tab-modal.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'name',
                        function($scope, $uibModalInstance, name) {
                            $scope.name = name;
                            $scope.ok = function() {
                                $uibModalInstance.close();
                            };
                        }
                    ],
                    resolve: {
                        name: function() {
                            return vm.name;
                        }
                    }
                });
            }

            if (vm.assessment[vm.isAccepted] === isMarked) {
                return;
            }

            vm.assessment[vm.isAccepted] = isMarked;
            vm.updateFct({ name: vm.isAccepted, value: isMarked });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('moneyField', {
        templateUrl: 'components/money-field/money-field-template.html',
        controller: moneyFieldController,
        bindings: {
            disableCurrency: '<',
            defaultCurrency: '<',
            min: '<',
            max: '<',
            update: '&',
            parent: '<',
            isRequired: '<',
            ngModel: '=',
            isDisabled: '<',
            name: '@',
            grossProfit: '<'
        }
    });

    moneyFieldController.$inject = ['$filter', '$timeout', 'currencies'];

    function moneyFieldController($filter, $timeout, currencies) {
        const vm = this;

        vm.currencies = currencies;
        vm.amountOnly = !!vm.disableCurrency;
        vm.isCurrencyRequired = false;
        vm.getName = (k, v) => (v.name ? `${k} - ${v.name}` : '-');
        vm.moneyField = {};
        vm.focus = focus;
        vm.keydown = keydown;
        vm.updateCurrency = updateCurrency;
        vm.updateAmount = updateAmount;
        vm.form = {};
        vm.name = vm.name || 'moneyField';
        vm.form[vm.name] = {};
        vm.checkAmountRequired = checkAmountRequired;
        vm.checkCurrencyRequired = checkCurrencyRequired;

        vm.$onInit = () => {
            vm.update = vm.update || angular.noop;
            vm.ngModel = vm.ngModel ? vm.ngModel : {};
            vm.currency = vm.ngModel.currency || '-';
            vm.ngModel.currency = vm.currency;
            vm.amount = $filter('number')(vm.ngModel.amount) || null;
            vm.hiddenCurrency = !!vm.amount;
            vm.isAMinus = vm.amount === '-';
        };

        vm.$postLink = () => {
            vm.moneyField.$setValidity && vm.moneyField.$setValidity('required', true);
        };

        vm.$doCheck = () => {
            const isVaid = vm.isCurrencyRequired ? false : vm.isAmountRequired ? false : true;
            vm.form &&
                vm.form[vm.name] &&
                vm.form[vm.name].$setValidity &&
                vm.form[vm.name].$setValidity('required', isVaid);
        };

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Method Declarations
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function checkAmountRequired() {
            if (vm.isRequired) {
                return true;
            }

            return vm.currency && vm.currency !== '-' && !vm.amountOnly;
        }

        function checkCurrencyRequired() {
            if (vm.isRequired) {
                return true;
            }
            return !vm.disableCurrency && vm.amount;
        }

        function keydown(event) {
            var key = event.keyCode;
            var codes = [
                8,
                9,
                13,
                35,
                36,
                37,
                39,
                46,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                109,
                189
            ];

            if ((key === 189 || key === 109) && event.target.selectionStart > 0) {
                //check for a first minus
                return prevent(event);
            }

            if (codes.indexOf(key) === -1) {
                return prevent(event);
            }
        }

        /**
         * Convenience method used above
         * @param event
         */
        function prevent(event) {
            vm.isActive = true;
            $timeout(function() {
                vm.isActive = false;
            }, 2000);
            return event.preventDefault();
        }

        function updateCurrency() {
            vm.ngModel = vm.ngModel ? vm.ngModel : {};
            vm.ngModel.currency = vm.currency;
            vm.isCurrencyRequired = !!(vm.currency === '-' && vm.amount);
            vm.isAmountRequired = (vm.currency !== '-' && vm.amount === null) || vm.amount === undefined;
            vm.hiddenCurrency = !vm.isCurrencyRequired;
            $timeout(() => (vm.disableCurrency || !vm.isCurrencyRequired) && !vm.isAmountRequired && vm.update());
        }

        function updateAmount() {
            const amount = (vm.amount && vm.amount.replace(new RegExp(',', 'g'), '')) || null;
            vm.ngModel = vm.ngModel ? vm.ngModel : {};
            // Check if the input is just a minus sign
            if (amount === '-') {
                vm.amount = amount;
                vm.isAMinus = true;
            } else {
                vm.amount = $filter('number')(amount);
                vm.ngModel.amount = $filter('cleanNumbers')(amount) || null;
                vm.isAMinus = false;
            }
            vm.isCurrencyRequired = !!(vm.currency === '-' && vm.amount);
            vm.isAmountRequired =
                (!vm.disableCurrency && vm.currency !== '-' && vm.amount === null) || vm.amount === undefined;
            vm.hiddenCurrency = !vm.isCurrencyRequired;
            // test fix, TODO: refactor the entire money field functionality
            if (vm.grossProfit && amount > +vm.grossProfit.amount) {
                vm.ngModel.amount = null;
                vm.amount = null;
                alert('Net Profit cannot exceed Gross Profit. Please correct the entry.');
            }
            $timeout(
                () =>
                    (vm.disableCurrency || !vm.isCurrencyRequired) &&
                    !vm.isAmountRequired &&
                    !vm.isAMinus &&
                    vm.update()
            );
        }

        function focus() {
            try {
                vm.amount = $filter('cleanNumbers')(vm.amount);
            } catch (e) {
                console.log(vm.amount, 'minus', e);
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.header', []);
})();

(function() {
    'use strict';

    angular.module('scope.commons.header').controller('headerController', headerController);

    headerController.$inject = [
        '$rootScope',
        '$scope',
        '$localStorage',
        '$window',
        'authenticationService',
        'offline',
        'translationFactory',
        'gettext',
        '$uibModal',
        'gettextCatalog',
        'modalFactory',
        'fsFactory',
        'IDB',
        '$log',
        '$timeout',
        '$state',
        'siTranslations',
        'siCustomers',
        'siHrm',
        'SW',
        'me',
        'EVENT_LOADER',
        '$sce',
        '$location',
        'padThemeService'
    ];

    function headerController(
        $rootScope,
        $scope,
        $localStorage,
        $window,
        authenticationService,
        offline,
        translationFactory,
        gettext,
        $uibModal,
        gettextCatalog,
        modalFactory,
        fsFactory,
        IDB,
        $log,
        $timeout,
        $state,
        siTranslations,
        siCustomers,
        siHrm,
        SW,
        me,
        EVENT_LOADER,
        $sce,
        $location,
        padThemeService
    ) {
        $scope.shouldUseDarkTheme = shouldUseDarkTheme;

        function shouldUseDarkTheme() {
            return padThemeService.shouldUseDarkTheme();
        }

        $scope.$on('pad-theme-changed', function() {
            $scope.$applyAsync();
        });

        $scope.$on('$locationChangeSuccess', function() {
            $scope.$applyAsync();
        });

        $scope.languages = translationFactory.languages;
        $scope.logout = logout;
        $scope.clearFileCache = clearFileCache;
        $scope.changeLanguage = changeLanguage;
        $scope.syncErrorsModal = syncErrorsModal;
        $scope.impersonate = impersonate;
        $scope.undoImpersonate = undoImpersonate;
        $scope.impersonated = $localStorage.user.impersonated;
        $scope.bannerText = 'xdxdxdxdxdxdxdxdxdxdxd';

        // the method name is weird because the settings object used to be a lot smaller
        siHrm.getDefaultQR().then(result => {
            $scope.bannerText = result.banner_text;
            $scope.tBannerText = $sce.trustAsHtml($scope.bannerText);
            $scope.bannerEnabled = result.banner_enabled;
        });

        IDB.count('failed').then(fails => ($scope.syncErrors = fails));

        let impersonatedUser;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function changeLanguage(languageCode) {
            siTranslations.changeLanguage(languageCode);
        }

        function logout() {
            modalFactory.ConfirmModal({
                message: gettextCatalog.getString(
                    'You are about to logout. This will delete all cached objects and pending requests on your local machine. Are you sure you would like to continue?'
                ),
                actions: [
                    {
                        label: gettextCatalog.getString('Yes, logout'),
                        fn: authenticationService.logout
                    }
                ]
            });
        }

        function clearFileCache() {
            fsFactory.clearFS();
        }

        function syncErrorsModal() {
            $uibModal
                .open({
                    templateUrl: 'modals/templates/sync-errors/sync-errors.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        '$q',
                        function($scope, $uibModalInstance, $q) {
                            $scope.$uibModalInstance = $uibModalInstance;

                            var failedReq;

                            IDB.getCollection('failed').then(failedRequests => {
                                failedReq = failedRequests;

                                var failedRequestPromises = _.map(failedRequests, request => {
                                    var time = parseInt(request.key);
                                    return fsFactory.readFromFs('failed', time);
                                });

                                $q.all(failedRequestPromises).then(failed => {
                                    $scope.failed = failed;
                                    console.log('Failed Req - ', failed);
                                });
                            });

                            $scope.remove = remove;
                            $scope.save = save;

                            function save() {
                                $uibModalInstance.dismiss();
                            }

                            function remove() {
                                _.map(failedReq, request => fsFactory.unlinkFromFs('failed', request.key));

                                $uibModalInstance.close();
                            }
                        }
                    ]
                })
                .result.then(() => ($scope.syncErrors = false));
        }

        const syncErrors = $rootScope.$on('sync-errors', () => {
            $scope.syncErrors = true;
            syncErrorsModal();
        });

        const syncAlert = $rootScope.$on('sync-errors-alert', () => {
            $scope.syncErrors = true;
        });

        $scope.$on('$destroy', () => {
            syncAlert();
            syncErrors();
        });

        function impersonate() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            $uibModal
                .open({
                    templateUrl: 'modals/templates/see-as-user/see-as-user.html',
                    controller: [
                        '$rootScope',
                        '$scope',
                        '$uibModalInstance',
                        '$q',
                        'clients',
                        function($rootScope, $scope, $uibModalInstance, $q, clients) {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            $scope.$uibModalInstance = $uibModalInstance;
                            $scope.clients = clients.results;
                            $scope.isSmartClient = $rootScope.isSmartClient;

                            $scope.updateUserList = updateUserList;
                            $scope.switchUser = switchUser;
                            $scope.cancel = cancel;

                            function updateUserList(client) {
                                if (!client.users) {
                                    $scope.users = [];
                                    return;
                                }

                                if ($rootScope.isSmartClient) {
                                    $scope.users =
                                        client.users &&
                                        client.users
                                            .filter(
                                                user =>
                                                    user.is_assessor ||
                                                    user.is_financial_specialist ||
                                                    user.is_data_collector ||
                                                    user.is_self_assessor
                                            )
                                            .filter(user => user.is_active);
                                } else {
                                    $scope.users =
                                        client.users &&
                                        client.users
                                            .filter(user => {
                                                // Some try catches because some users have badly formatted JSON in the allowed_frontends.
                                                // Not sure if this is needed in production, but on dev it is
                                                var json = [];
                                                try {
                                                    json = JSON.parse(user.allowed_frontends);
                                                } catch (err) {
                                                    json = [];
                                                }

                                                try {
                                                    return json.find(function(item) {
                                                        return item.app === 'dashboard';
                                                    });
                                                } catch (err) {
                                                    return false;
                                                }
                                            })
                                            .filter(user => user.is_active);
                                    //.filter(user => user.is_active);
                                }
                            }

                            function switchUser(user) {
                                $uibModalInstance.close(user);
                            }

                            function cancel() {
                                $uibModalInstance.dismiss();
                            }
                        }
                    ],
                    resolve: {
                        clients: () => {
                            return siCustomers.getCustomers({
                                fields: ['users'],
                                page_size: 99999
                            });
                        }
                    }
                })
                .result.then(user => {
                    impersonatedUser = user;
                    return siHrm.impersonateUser(user);
                })
                .then(res => authenticationService.setToken(res))
                .then(() => {
                    $localStorage.user.impersonated = true;
                    $localStorage.user.info = impersonatedUser;
                    clearFileCache();
                    $state.go(setHomeState(), {}, { reload: true });
                });
        }

        function undoImpersonate() {
            $localStorage.user.impersonated = false;
            authenticationService.obtainToken().then(() => {
                clearFileCache();
                $state.go(setHomeState(), {}, { reload: true });
            });
        }

        //TODO: refactor this and other occurance as well
        function setHomeState() {
            if (me.isEmployee()) {
                return $rootScope.app === 'dashboard' && $localStorage.user.info.employee.is_quality_controller
                    ? 'base.assessments-list'
                    : 'base.home';
            }

            if (me.isDashboardUserAdmin()) {
                return 'base.alerts';
            }

            return 'base.home';
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Watchers
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        // watch isOffline of provider to toggle offline functionality
        $scope.$watch(
            function() {
                return offline.numberPendingRequests;
            },
            function(numberPendingRequests) {
                $scope.numberPendingRequests = numberPendingRequests;
            }
        );

        $scope.$on('$destroy', function() {
            // Listeners are automatically cleaned up by Angular
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').controller('FormElementsController', FormElementsController);

    FormElementsController.$inject = ['$element', '$timeout', '$scope'];

    function FormElementsController($element, $timeout, $scope) {
        var vm = this;
        var elements = {};
        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;
        vm.$postLink = $postLink;
        vm.$doCheck = $doCheck;
        vm.onChange = onChange;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onInit() {
            vm.emptyString = typeof vm.emptyString !== 'undefined' ? vm.emptyString : '';
            vm.labelWidth = vm.labelWidth || 12;
        }

        $scope.$on('scanner-started', function(event, args) {
            setTimeout(function() {
                $scope.$applyAsync();
            });
        });

        function $onChanges(changes) {
            // Moved this here from $onInit because the conditionalLabel depends on the assessment most of the times
            // which isn't directly available on page load. Checking it here will update it after vm.model
            // becomes available and thus assessment.
            if (vm.conditionalLabel && vm.conditionalLabel()) {
                vm.label = vm['conditionalLabel' + vm.conditionalLabel()];
            }

            if (changes.showError && typeof changes.showError.currentValue !== 'undefined') {
                vm.shouldShowError = changes.showError.currentValue && isInvalid(elements);
            }
        }

        function $postLink() {
            $timeout(function() {
                elements = {
                    input: $element.find('input'),
                    textArea: $element.find('textarea'),
                    select: $element.find('select')
                };
            });
        }

        function $doCheck() {
            vm.showTooltip = isInvalid(elements) && isDirty(elements) && vm.type === 'number';
            if (vm.showError) {
                vm.shouldShowError = isInvalid(elements);
            }
        }

        function getElement(elements) {
            var element = Object.keys(elements)
                .filter(function(key) {
                    return elements[key].length;
                })
                .reduce(function(memo, el) {
                    return elements[el];
                }, []);

            return element;
        }

        function isInvalid(elements) {
            var element = getElement(elements);

            switch (element.selector) {
                case 'input':
                    return element.hasClass('ng-invalid');
                case 'select':
                    return element.hasClass('ng-empty');
                case 'textarea':
                    return element.hasClass('ng-invalid');
            }
        }

        function isDirty(elements) {
            var element = getElement(elements);

            return element.hasClass('ng-dirty');
        }

        function onChange(change) {
            const model = change || vm.model;
            vm.shouldShowError = false;
            vm.updateFct({ model });
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.footer', []);

}());

(function() {
    'use strict';

    angular.module('scope.commons.footer').controller('footerController', footerController);

    footerController.$inject = ['$scope', '$location', 'padThemeService'];

    function footerController($scope, $location, padThemeService) {
        $scope.date = new Date().getFullYear();

        $scope.shouldUseDarkTheme = function() {
            return padThemeService.shouldUseDarkTheme();
        };

        $scope.$on('pad-theme-changed', function() {
            $scope.$applyAsync();
        });

        $scope.$on('$locationChangeSuccess', function() {
            $scope.$applyAsync();
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('fileUploadComponent', {
        templateUrl: 'components/file-upload-component/file-upload-component.html',
        bindings: {
            assessmentId: '<',
            fileType: '@',
            sourceOfData: '<',
            isDisabled: '<',

            // Optional UI texts
            title: '@?',
            uploadButtonText: '@?',
            downloadButtonText: '@?',
            noFileMessage: '@?',
            acceptedFileTypes: '@?',
            fileInputId: '@?',

            // Callbacks (optional)
            onUploadSuccess: '&?',
            onUploadError: '&?',
            onDeleteSuccess: '&?',
            onDeleteError: '&?',
            onDownloadSuccess: '&?',
            onDownloadError: '&?',
            onFilesChange: '&?',

            // Custom fns (optional overrides)
            customUploadFn: '&?',
            customListFn: '&?',
            customDeleteFn: '&?',
            customDownloadFn: '&?'
        },
        controller: FileUploadController
    });

    FileUploadController.$inject = ['siAssessments', 'toastr', '$timeout', 'EVENT_LOADER', '$rootScope', '$element'];

    function FileUploadController(siAssessments, toastr, $timeout, EVENT_LOADER, $rootScope, $element) {
        const vm = this;
        function notifyFilesChange() {
            if (vm.onFilesChange) {
                vm.onFilesChange({
                    files: vm.files,
                    fileType: vm.fileType,
                    isRequired: vm.isRequired,
                    hasFiles: vm.files.length > 0
                });
            }
        }

        vm.$onInit = () => {
            vm.title = vm.title || 'Source of Data Files';
            vm.uploadButtonText = vm.uploadButtonText || 'Upload';
            vm.downloadButtonText = vm.downloadButtonText || 'Download';
            vm.noFileMessage = vm.noFileMessage || 'No files uploaded yet.';
            vm.acceptedFileTypes = vm.acceptedFileTypes || '*';
            vm.fileInputId = vm.fileInputId || 'fileInput_' + vm.fileType + '_' + vm.assessmentId;

            vm.files = [];
            vm.selectedFiles = [];
            vm.isUploading = false;
            vm.uploadProgress = 0;
            vm.isDownloading = false;
            vm.isDeleting = {}; // map: filename -> boolean
            vm.loadingFiles = true;
            vm.evaluateIsRequired();

            vm.refreshList();
        };

        vm.$onChanges = function(changesObj) {
            if (changesObj.sourceOfData && !changesObj.sourceOfData.isFirstChange()) {
                vm.evaluateIsRequired();
            }
        };

        vm.evaluateIsRequired = function() {
            vm.isRequired = vm.sourceOfData !== 'Verbal' && vm.sourceOfData !== 'No Report Available';
            console.log('IS FILE REQUIRED:' + vm.isRequired + ' (sourceOfData: ' + vm.sourceOfData + ')');

            notifyFilesChange();
        };

        vm.$postLink = function() {
            $timeout(function() {
                const input = $element.find('#' + vm.fileInputId);
                if (input.length > 0) {
                    input.on('change', vm.uploadFiles);
                }
            });
        };

        vm.refreshList = function() {
            vm.loadingFiles = true;
            if (vm.customListFn) {
                // Allow external override
                vm.customListFn({
                    assessmentId: vm.assessmentId,
                    fileType: vm.fileType
                });
                return;
            }

            if (!navigator.onLine) {
                vm.files = [];
                vm.loadingFiles = false;
                notifyFilesChange();
                return;
            }

            siAssessments
                .listSourceOfDataFiles(vm.assessmentId, vm.fileType)
                .then(function(data) {
                    vm.files = (data && data.files) || [];
                    vm.loadingFiles = false;
                    notifyFilesChange();
                })
                .catch(function(err) {
                    console.error('List files error', err);
                    if (navigator.onLine) {
                        toastr.error('Failed to list files');
                    }
                    vm.files = [];
                    vm.loadingFiles = false;
                    notifyFilesChange();
                });
        };

        let progressTimeout = null;

        vm.uploadFiles = function() {
            const fileInput = document.getElementById(vm.fileInputId);
            const files = fileInput.files;

            if (!files.length) {
                toastr.warning('Please select at least one file.');
                return;
            }

            vm.isUploading = true;
            vm.uploadProgress = 0;

            $rootScope.$broadcast(EVENT_LOADER.show);

            siAssessments
                .uploadFiles(files, vm.fileType, vm.assessmentId, function(pct) {
                    if (progressTimeout) $timeout.cancel(progressTimeout);
                    progressTimeout = $timeout(function() {
                        vm.uploadProgress = pct;
                    });
                })
                .then(function(res) {
                    toastr.success('Upload completed');
                    vm.selectedFiles = [];
                    if (vm.onUploadSuccess) vm.onUploadSuccess({ response: res, fileType: vm.fileType });
                    vm.refreshList();
                })
                .catch(function(err) {
                    console.error('Upload error', err);
                    toastr.error('Upload failed');
                    if (vm.onUploadError) vm.onUploadError({ error: err, fileType: vm.fileType });
                })
                .finally(function() {
                    if (progressTimeout) $timeout.cancel(progressTimeout);
                    vm.isUploading = false;
                    vm.uploadProgress = 0;
                    var el = document.getElementById(vm.fileInputId);
                    if (el) el.value = null;
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        vm.downloadFile = function(fileName) {
            if (vm.customDownloadFn) {
                vm.customDownloadFn({
                    fileName: fileName,
                    fileType: vm.fileType,
                    assessmentId: vm.assessmentId
                });
                return;
            }
            siAssessments
                .downloadSourceOfDataFile(vm.assessmentId, vm.fileType, fileName)
                .then(function(res) {
                    if (vm.onDownloadSuccess)
                        vm.onDownloadSuccess({ response: res, fileName: fileName, fileType: vm.fileType });
                })
                .catch(function(err) {
                    console.error('Download error', err);
                    toastr.error('Download failed');
                    if (vm.onDownloadError)
                        vm.onDownloadError({ error: err, fileName: fileName, fileType: vm.fileType });
                })
                .finally(function() {});
        };

        vm.deleteFile = function(fileName) {
            if (!confirm('Delete "' + fileName + '"? This cannot be undone.')) return;

            vm.isDeleting[fileName] = true;

            if (vm.customDeleteFn) {
                vm.customDeleteFn({
                    fileName: fileName,
                    fileType: vm.fileType,
                    assessmentId: vm.assessmentId
                });
                vm.isDeleting[fileName] = false;
                vm.refreshList();
                return;
            }

            siAssessments
                .deleteSourceOfDataFile(vm.assessmentId, vm.fileType, fileName)
                .then(function(res) {
                    if (vm.onDeleteSuccess)
                        vm.onDeleteSuccess({ response: res, fileName: fileName, fileType: vm.fileType });
                    vm.refreshList();
                })
                .catch(function(err) {
                    console.error('Delete error', err);
                    toastr.error('Delete failed');
                    if (vm.onDeleteError) vm.onDeleteError({ error: err, fileName: fileName, fileType: vm.fileType });
                })
                .finally(function() {
                    vm.isDeleting[fileName] = false;
                });
        };
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.exceptionHandler', []);

}());
(function() {
    'use strict';

    angular.module('scope.commons.exceptionHandler').factory('$exceptionHandler', $exceptionHandler);

    $exceptionHandler.$inject = ['$injector'];

    function $exceptionHandler($injector) {
        return function(exception) {
            // send exception to Sentry
            if (navigator.onLine) {
                Raven.captureException(JSON.stringify(exception));
            }

            if (
                $injector.get('$state').is('login') ||
                ($injector.get('$state').current.name === 'authentication.login' && exception.name != 'UserError')
            ) {
                throw exception; // do not show any error modals when in login state but just throw to error console
            }

            if (exception.name === 'SyncError') {
                throw exception;
            }

            if (!exception.name) {
                throw exception; // just some JS exception throw to error console
            }

            if (exception.name.indexOf('ResourceError') === -1 && exception.name.indexOf('UserError') === -1) {
                throw exception; // not a resource from our backend, do not continue but just throw to error console
            }

            if (exception.name === 'ApiTokenAuthResourceError') {
                throw exception; // auth errors are handled at login
            }
            $injector.get('$uibModal').open({
                templateUrl: 'components/exception-handler/exceptionHandlerView.html',
                controller: exceptionModalController,
                resolve: { exception: () => exception }
            });

            exceptionModalController.$inject = ['$scope', '$uibModalInstance', 'exception'];

            function exceptionModalController($scope, $uibModalInstance, exception) {
                'use strict';
                $scope.isCollapsed = true;
                let problem = exception.error.data;
                exception.error.data = [];
                exception.error.data[0] = problem;
                $scope.exception = exception;
                $scope.$uibModalInstance = $uibModalInstance;
                $scope.toggleCurl = toggleCurl;

                function toggleCurl() {
                    $scope.isCollapsed = !$scope.isCollapsed;
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('curl', {
        bindings: {
            exception: '<'
        },
        templateUrl: 'components/exception-handler/curl-template.html',
        controller: CurlController
    });

    CurlController.$inject = [];

    function CurlController() {
        const vm = this;

        vm.$onInit = () => {
            if (vm.exception && vm.exception.error && vm.exception.error.config && vm.exception.error.config.data) {
                vm.data = Object.keys(vm.exception.error.config.data).map(key => ({
                    key: key,
                    value: JSON.stringify(vm.exception.error.config.data[key])
                }));
            }

            if (vm.exception && !vm.exception.error && vm.exception.status === 500) {
                vm.is500 = true;
                vm.exception = { error: vm.exception };
                vm.data = Object.keys(vm.exception.error.config.data).map(key => ({
                    key: key,
                    value: JSON.stringify(vm.exception.error.config.data[key])
                }));
            }

            vm.origin = window.location.origin;
            window.exception = vm.exception;
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('editOptionsList', {
        bindings: {
            label: '@',
            listName: '@',
            tool: '<',
            deleteFunction: '=',
            createFunction: '=',
            createUrl: '@',
            sortFunction: '&'
        },
        templateUrl: 'components/edit-options-list/edit-options-list.html',
        controller: EditOptionsController
    });

    EditOptionsController.$inject = [
        '$scope',
        '$rootScope',
        'EVENT_LOADER',
        'apiUrl',
        '$timeout',
        'siScope',
        '$log',
        'toastr'
    ];

    function EditOptionsController($scope, $rootScope, EVENT_LOADER, apiUrl, $timeout, siScope, $log, toastr) {
        var vm = this;

        vm.addItem = addItem;
        vm.movedIteam = movedIteam;
        vm.removeItem = removeItem;
        vm.$onChanges = $onChanges;
        vm.toggleSortAlpha = toggleSortAlpha;
        vm.mouseEnter = mouseEnter;
        vm.mouseLeave = mouseLeave;
        vm.selected = null;
        vm.hover = null;

        function mouseEnter(item) {
            vm.hover = item;
        }

        function mouseLeave(item) {
            vm.hover = null;
        }

        function movedIteam($index, item) {
            vm.list.splice($index, 1);
            vm.hover = null;
            let position = 0;

            for (let i = 0; i < vm.list.length; i++) {
                if (vm.list[i].url == item.url) {
                    position = i;
                    break;
                }
            }

            siScope.patch(item, { position: position, url: item.url });
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function $onChanges(changesObj) {
            if (changesObj.tool.currentValue) {
                vm.list =
                    typeof vm.tool && vm.tool[vm.listName] && vm.tool[vm.listName].objects !== 'undefined'
                        ? vm.tool[vm.listName].objects
                        : vm.tool[vm.listName];
                vm.createUrl = vm.createUrl ? apiUrl + vm.createUrl : vm.tool[vm.listName].links.create;
                if (vm.tool.optionsConfig) {
                    vm.sortModel = vm.tool.optionsConfig[`sort_${vm.listName}`] || false;
                }
            }
        }

        function toggleSortAlpha(shouldSortAlpha) {
            const patch = {};
            patch[`sort_${vm.listName}`] = shouldSortAlpha;
            return vm.sortFunction({ patch });
        }

        /**
         * Push a newly created item to the api and into the list
         */
        function addItem() {
            if (!vm.newItem) {
                return;
            }
            vm.isDefined =
                vm.list &&
                vm.list
                    .filter(function(item) {
                        return item.name === vm.newItem;
                    })
                    .reduce(function() {
                        return true;
                    }, false);

            if (vm.isDefined) {
                vm.newItem = '';
                return $timeout(function() {
                    vm.isDefined = false;
                }, 2000);
            }

            $rootScope.$broadcast(EVENT_LOADER.show);

            var createObject = { title: vm.newItem, name: vm.newItem };
            createObject = Object.assign(createObject, vm.tool ? { tool: vm.tool.url } : {});

            vm.createFunction(createObject, vm.createUrl).then(function(createdObject) {
                vm.list.push(createdObject);
                vm.newItem = '';
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        /**
         * Remove an item from the list
         * @param item option from list
         */
        function removeItem(item) {
            vm.deleteFunction(item.url);
            vm.list.splice(vm.list.indexOf(item), 1);
        }

        $scope.$on('item.drop-model', (e, el) => {
            $rootScope.$broadcast('saving-move', el);

            vm.list.forEach((item, index) => {
                item.position = index;
            });

            //We need this to be in a timeout so we get the updated data-position based on the new digest cycle
            $timeout(function() {
                var position = el.attr('data-position') || 0;

                var patch = {
                    url: vm.list[position].url,
                    position
                };

                siScope
                    .patch(patch)
                    .catch(function(err) {
                        toastr.error('Error Patching - ', err);
                    })
                    .finally(function() {
                        $rootScope.$broadcast('move-saved', el);
                    });
            });
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('confirmNavigation', {
        template: '<div><ng-transclude></ng-transclude></div>',
        controller: ConfirmController,
        transclude: true,
        bindings: {
            checkValue: '<',
            saveFct: '&',
            saveText: '@'
        }
    });

    ConfirmController.$inject = ['$rootScope', 'modalFactory', 'gettext', '$state'];

    function ConfirmController($rootScope, modalFactory, gettext, $state) {
        const vm = this;
        let initialValue;
        let stateChangeInProgress = false;

        vm.$onChanges = ({ checkValue }) => {
            return (initialValue = checkValue.currentValue);
        };

        vm.handleStateChange = (toState, toParams) => {
            stateChangeInProgress = true;
            vm.saveFct();
            $state.go(toState.name, toParams);
            stateChangeInProgress = false;
        };

        const stateStartListener = $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
            if (initialValue && !stateChangeInProgress) {
                event.preventDefault();
                modalFactory.ConfirmModal({
                    message: vm.saveText,
                    actions: [
                        {
                            label: gettext('Confirm'),
                            fn: () => vm.handleStateChange(toState, toParams)
                        }
                    ]
                });
            }
        });

        vm.$onDestroy = () => stateStartListener();
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('siBreadcrumbs', {
        bindings: {
            breadcrumbs: '<'
        },
        templateUrl: 'components/breadcrumbs/breadcrumbs.html',
        controller: BreadCrumbsController
    });

    BreadCrumbsController.$inject = [];

    function BreadCrumbsController() {
        const vm = this;
        const home = {name: 'Home', url: 'base.home'};

        vm.breadcrumbs = [];

        vm.$onChanges = () => {
            if(vm.breadcrumbs.length && vm.breadcrumbs[0].name !== 'Home') {
                vm.breadcrumbs.unshift(home);
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.components').component('baseSixtyFourDocumentUpload', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            label: '@',
            asterisk: '<',
            offlineLabel: '@',
            ngMultiple: '<',
            createFunction: '&',
            isDisabled: '<'
        },
        templateUrl: 'components/basesixtyfour-document-upload/basesixtyfour-document-upload.html',
        controller: [
            '$element',
            '$q',
            'gettext',
            function($element, $q, gettext) {
                const vm = this;

                vm.$onInit = () => {
                    vm.label = vm.label || gettext('Add Documents');
                    vm.isUploading = false;

                    if (typeof vm.createFunction !== 'function') {
                        throw new Error('Directive basesixtyfour-document-upload requires a document create function');
                    }

                    if (!vm.ngModelCtrl.$name) {
                        throw new Error('Directive basesixtyfour-document-upload requires a name');
                    }
                };

                vm.$postLink = () => {
                    const input = $element.find('#upload-file-input');
                    input.on('change', documentsChanged);
                };

                /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                    Event Listeners
                ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

                function readAsBinaryString(file) {
                    var deferred = $q.defer();
                    var fileReader = new FileReader();

                    fileReader.onload = function(e) {
                        deferred.resolve({
                            file: file,
                            data: e.target.result
                        });
                    };

                    fileReader.onabort = fileReader.onerror = function() {
                        deferred.reject();
                    };

                    fileReader.readAsDataURL(file);
                    return deferred.promise;
                }

                function documentsChanged() {
                    // set post data with relation e.g. data['response'] =
                    var data = {};
                    data[vm.ngModelCtrl.$name] = vm.ngModelCtrl.$viewValue.url;

                    var fileReaderPromises = _.map(this.files, readAsBinaryString);

                    $q
                        .allSettled(fileReaderPromises)
                        .then(files => {
                            vm.isUploading = true;

                            const fileUploadPromises = _.chain(files)
                                .filter(file => file.state === 'fulfilled')
                                .map(file => {
                                    // extend post data with file props
                                    data = _.extend(data, {
                                        file_name: file.value.file.name,
                                        file: file.value.data
                                    });

                                    return vm.createFunction({ data });
                                })
                                .value();

                            return $q.allSettled(fileUploadPromises);
                        })
                        .finally(() => {
                            vm.isUploading = false;
                            $element.find('form')[0].reset();
                        });
                }
            }
        ]
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.directives').component('axrCompleteTab', {
        bindings: {
            isCompleted: '@',
            isDisabled: '<',
            isFormCompleted: '<',
            assessment: '<',
            updateFct: '&'
        },
        controller: AxrCompleteTabController
    });

    AxrCompleteTabController.$inject = [];

    function AxrCompleteTabController() {
        var vm = this;

        var debouncedUpdateTab = _.debounce(updateTab, 500);

        vm.updateTab = updateTab;
        vm.$onChanges = $onChanges;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function $onChanges(change) {
            if (change.isFormCompleted && typeof change.isFormCompleted.currentValue !== 'undefined') {
                if (vm.assessment) {
                    debouncedUpdateTab(change.isFormCompleted.currentValue);
                }
            }
        }

        function updateTab(isMarked) {
            if (vm.assessment[vm.isCompleted] === isMarked) {
                return;
            }

            vm.assessment[vm.isCompleted] = isMarked;
            vm.updateFct({ name: vm.isCompleted, value: isMarked });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.set', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('authentication.set', {
            url: '/set-password?token',
            views: {
                'childState@authentication': {
                    templateUrl: 'authentication/set/set.html',
                    controller: 'setController',
                    controllerAs: 'setCtrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.set').controller('setController', setController);

    setController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$timeout',
        '$stateParams',
        '$log',
        '$interval',
        'siAccounts',
        'authenticationService',
        'EVENT_LOADER'
    ];

    function setController(
        $rootScope,
        $scope,
        $state,
        $timeout,
        $stateParams,
        $log,
        $interval,
        siAccounts,
        authenticationService,
        EVENT_LOADER
    ) {
        const vm = this;
        let progressInterval;

        vm.isLoaded = false;
        vm.validToken = false;

        $rootScope.$broadcast(EVENT_LOADER.show, { fullScreen: true });
        siAccounts
            .validateToken($stateParams.token)
            .then(res => {
                vm.isLoaded = true;
                if (res.token_valid) {
                    vm.validToken = true;
                }
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(() => {
                vm.isLoaded = true;
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        vm.logo_file = $rootScope.app === 'smartclient' ? 'logo_black.svg' : 'logo_white.svg';
        vm.confirm = '';
        vm.password = '';
        vm.error = '';
        vm.resetForm = {};
        vm.isFormInvalid = false;
        vm.form = {
            password: {
                type: 'password',
                isVisible: false
            },
            confirm: {
                type: 'password',
                isVisible: false
            }
        };

        $rootScope.appready = true;

        vm.showLogin = showLogin;
        vm.sendPassword = sendPassword;
        vm.checkValidity = checkValidity;
        vm.flipVisibility = flipVisibility;
        vm.parsePassword = parsePassword;
        vm.requestToken = requestToken;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Event Watchers
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$watchGroup([() => vm.confirm, () => vm.password], () => delete vm.error);

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                 Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function parsePassword(password) {
            //We use this function to remove any regex reserved characters in the pattern that is returned for matching purposes
            return password ? password.replace(/[\[\\\^\$\.\|\?\*\+\(\)\{}]/g, match => '\\' + match) : '';
        }

        function flipVisibility(input) {
            vm.form[input].type = vm.form[input].type === 'password' ? 'text' : 'password';
            vm.form[input].isVisible = !vm.form[input].isVisible;
        }

        function checkValidity(password) {
            const testNumericAndCharacters = /(\d)|(@|#|\$)/g;
            const testLowerCase = /[a-z]+/g;
            const testUpperCase = /[A-Z]+/g;

            vm.resetForm.password.$setValidity('specialCharacters', testNumericAndCharacters.test(password));
            vm.resetForm.password.$setValidity(
                'caseCharacters',
                testLowerCase.test(password) && testUpperCase.test(password)
            );
        }

        function requestToken() {
            $state.go('authentication.reset');
        }

        function showLogin() {
            $state.go('authentication.login');
        }

        function sendPassword() {
            startLoginProgress();

            siAccounts
                .applyPasswordReset(vm.password, $stateParams.token)
                .then(() => {
                    authenticationService.logout();
                    vm.progress = 0;
                    return $interval.cancel(progressInterval);
                })
                .catch(err => {
                    vm.error = Object.keys(err.error.data)
                        .map(key => err.error.data[key])
                        .reduce((memo, msg) => msg, 'Server error occurred please try again.');
                    vm.progress = 0;
                    $timeout(() => {
                        vm.error = false;
                    }, 5000);
                    return $interval.cancel(progressInterval);
                });
        }

        function startLoginProgress() {
            vm.progress = 0;

            progressInterval = $interval(() => {
                if (vm.progress < 50) {
                    vm.progress += 0.3;
                } else if (vm.progress >= 50 && vm.progress < 80) {
                    vm.progress += 0.2;
                } else if (vm.progress >= 80 && vm.progress < 95) {
                    vm.progress += 0.05;
                } else if (vm.progress >= 95 && vm.progress < 99) {
                    vm.progress += 0.01;
                }
            }, 100);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.register').controller('registerController', registerController);

    registerController.$inject = [
        '$rootScope',
        '$scope',
        '$q',
        '$state',
        '$log',
        '$localStorage',
        '$interval',
        '$timeout',
        'siAccounts',
        'jwtHelper',
        'authenticationService',
        'gettext',
        'EVENT_LOADER',
        'me',
        'siCustomers',
        'COUNTRIES',
        'siHrm',
        'EMAIL_VALID_REGEX',
        'toastr',
        '$uibModal',
        'modalFactory'
    ];

    function registerController(
        $rootScope,
        $scope,
        $q,
        $state,
        $log,
        $localStorage,
        $interval,
        $timeout,
        siAccounts,
        jwtHelper,
        authenticationService,
        gettext,
        EVENT_LOADER,
        me,
        siCustomers,
        COUNTRIES,
        siHrm,
        EMAIL_VALID_REGEX,
        toastr,
        $uibModal,
        modalFactory
    ) {
        var vm = this;
        var progressInterval;

        vm.logo_file = $rootScope.app === 'smartclient' ? 'logo_black.svg' : 'logo_white.svg';
        vm.email = '';
        vm.password = '';
        vm.error = '';
        $rootScope.appready = true;
        $rootScope.$broadcast(EVENT_LOADER.hide);
        $scope.countries = COUNTRIES;
        //Define Scoped Variables
        $scope.languages = [
            { name: 'Francais', code: 'fr' },
            { name: 'Espanol', code: 'es' },
            { name: 'English', code: 'en' }
        ];
        $scope.languages_spoken = ['Francais', 'Espanol', 'English'];

        $scope.goToLogin = goToLogin;

        $scope.register = register;
        $scope.checkEmailAvailability = checkEmailAvailability;
        $scope.createNewAssessee = createNewAssessee;
        $scope.openAssesseeWarningModal = openAssesseeWarningModal;
        $scope.getOrganizations = getOrganizations;
        $scope.user = {};
        $scope.userForm = {};

        // const promises = [];

        // $q.all(promises)
        //     .then(function(promises) {
        //         $scope.customers = promises[0];

        //         //console.log('Customers - ', $scope.customers);
        //     })
        //     .catch(function(err) {
        //     });
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Watchers
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$watchGroup(
            [
                () => vm.email,
                () => vm.password,
                () => $scope.user.first_name,
                () => $scope.user.last_name,
                () => $scope.user.passwordConfirm,
                () => $scope.user.organization,
                () => $scope.user.city,
                () => $scope.user.country,
                () => $scope.user.email,
                () => $scope.user.language
            ],
            () => delete vm.error
        );

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function checkEmailAvailability(email, form) {
            const isEmailValid = EMAIL_VALID_REGEX.test(email);
            $scope.emailValid = isEmailValid;
        }

        $scope.test = () => {
            console.log($scope.user.organization);
        };

        function register() {
            siHrm
                .registerUser($scope.user, { noAuth: true })
                .then(res => {
                    toastr.success('Successfully registered, redirecting to Login page.');
                    goToLogin();
                })
                .catch(err => {
                    vm.error = gettext(err.error.data);
                    return $interval.cancel(progressInterval);
                });
        }

        function goToLogin(form) {
            $state.go('authentication.login');
        }

        function getOrganizations() {
            try {
                siCustomers.getCustomersDropdownLogin({ noAuth: true, country: $scope.user.country }).then(res => {
                    $scope.customers = res;
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
            } catch (err) {
                console.log('User Edit Controller Data Retrieval Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            }
        }

        function isUserAllowed(user) {
            var frontends = user.allowed_frontends ? angular.fromJson(user.allowed_frontends) : [];
            $rootScope.me = user;
            $localStorage.user.info = user;
            var homeState = setHomeState();

            const allowedFrontends = frontends
                .filter(frontend => frontend.app === $rootScope.app)
                .reduce((memo, frontend) => {
                    return frontend;
                }, 'notAllowed');

            if (allowedFrontends === 'notAllowed') {
                authenticationService.logout();
                $timeout(() => {
                    vm.error = gettext('Not Authorized for this Application');
                    vm.progress = 0;
                });
            } else {
                $state.go(homeState, {}, { reload: true });
                vm.progress = 100;
                Raven.setUserContext({
                    email: $localStorage.user.info.email,
                    id: $localStorage.user.info.id
                });
            }

            return $interval.cancel(progressInterval);
        }

        function openAssesseeWarningModal() {
            modalFactory.ConfirmModal({
                message: `
                If your organization is not listed, you can create a profile for it.
                Please make sure to search first to prevent creating a duplicate profile.
                If your organization has undergone a SCOPE assessment previously, it should already be available
                in the list.
                If you're uncertain about this, please reach out to our support team at support@scopeinsight.com
                and hey will assist you throughout the process.`,
                actions: [
                    {
                        label: gettext('I understand'),
                        fn: createNewAssessee
                    }
                ]
            });
        }

        function createNewAssessee() {
            $uibModal
                .open({
                    templateUrl: 'authentication/register/createNewAssesseeModal/createNewAssesseeModal.html',
                    controller: 'createNewAssesseeModalController',
                    size: 'xl',
                    resolve: {
                        countries: () => $scope.countries
                    }
                })
                .result.then(assessee => {
                    siCustomers.getCustomersDropdownLogin({ noAuth: true }).then(res => {
                        $scope.customers = res;
                        $scope.user.organization = assessee.organization.id;
                    });
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.reset', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('authentication.reset', {
            url: '/reset',
            views: {
                'childState@authentication': {
                    templateUrl: 'authentication/login/reset.html',
                    controller: 'loginController',
                    controllerAs: 'loginCtrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.login', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('authentication.login', {
            url: '/login',
            views: {
                'childState@authentication': {
                    templateUrl: 'authentication/login/login.html',
                    controller: 'loginController',
                    controllerAs: 'loginCtrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.login').controller('loginController', loginController);

    loginController.$inject = [
        '$rootScope',
        '$scope',
        '$q',
        '$state',
        '$log',
        '$localStorage',
        '$interval',
        '$timeout',
        'siAccounts',
        'jwtHelper',
        'authenticationService',
        'gettext',
        'gettextCatalog',
        'EVENT_LOADER',
        'me',
        'siCustomers',
        'COUNTRIES',
        'siHrm',
        'EMAIL_VALID_REGEX'
    ];

    function loginController(
        $rootScope,
        $scope,
        $q,
        $state,
        $log,
        $localStorage,
        $interval,
        $timeout,
        siAccounts,
        jwtHelper,
        authenticationService,
        gettext,
        gettextCatalog,
        EVENT_LOADER,
        me,
        siCustomers,
        COUNTRIES,
        siHrm,
        EMAIL_VALID_REGEX
    ) {
        var vm = this;
        var progressInterval;

        // Login failure messages by the backend's error code (AD-2205)
        var LOGIN_ERRORS = {
            invalid_credentials: gettext(
                'Invalid email address or password. Please check your credentials and try again.'
            ),
            license_inactive: gettext(
                'Your license has expired or is no longer active. Please contact SCOPEinsight Support for assistance.'
            ),
            server_error: gettext(
                "We're experiencing a technical issue and couldn't complete your login. Please try again later. If the problem persists, contact support."
            )
        };

        vm.logo_file = $rootScope.app === 'smartclient' ? 'logo_black.svg' : 'logo_white.svg';
        vm.email = '';
        vm.password = '';
        vm.error = '';
        $rootScope.appready = true;
        $rootScope.$broadcast(EVENT_LOADER.hide);
        $scope.countries = COUNTRIES;
        //Define Scoped Variables
        $scope.languages = [
            { name: 'Francais', code: 'fr' },
            { name: 'Espanol', code: 'es' },
            { name: 'English', code: 'en' }
        ];
        $scope.languages_spoken = ['Francais', 'Espanol', 'English'];
        $scope.hideSignup = true;

        $scope.register = register;
        $scope.checkEmailAvailability = checkEmailAvailability;
        $scope.user = {};
        $scope.userForm = {};

        vm.login = login;
        vm.forgotPassword = forgotPassword;
        vm.sendResetLink = sendResetLink;
        vm.showLogin = showLogin;

        const promises = [siCustomers.getCustomersDropdownLogin({ noAuth: true })];

        $q.all(promises)
            .then(function(promises) {
                $scope.customers = promises[0];
            })
            .catch(function(err) {
                console.log('User Edit Controller Data Retrieval Err - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Watchers
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$watchGroup(
            [
                () => vm.email,
                () => vm.password,
                () => $scope.user.first_name,
                () => $scope.user.last_name,
                () => $scope.user.passwordConfirm,
                () => $scope.user.organization,
                () => $scope.user.city,
                () => $scope.user.country,
                () => $scope.user.email,
                () => $scope.user.language
            ],
            () => delete vm.error
        );

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function checkEmailAvailability(email, form) {
            const isEmailValid = EMAIL_VALID_REGEX.test(email);
            $scope.emailValid = isEmailValid;
        }

        function register() {
            siHrm
                .registerUser($scope.user, { noAuth: true })
                .then(res => {
                    goToRegister();
                })
                .catch(err => {
                    vm.error = gettext(err.error.data);
                    return $interval.cancel(progressInterval);
                });
        }

        function sendResetLink(form) {
            siAccounts.requestPasswordReset(vm.email);
            vm.isPasswordResetSent = true;
            vm.email = '';
            form.$setPristine();
            setTimeout(showLogin, 3000);
        }

        function forgotPassword() {
            $state.go('authentication.reset');
        }

        function showLogin() {
            $state.go('authentication.login');
        }

        function login() {
            startLoginProgress();

            authenticationService
                .login(vm.email, vm.password)
                .then(handleLogin)
                .then(me.getMe)
                .then(isUserAllowed)
                .catch(err => {
                    console.log('login err - ', err);
                    authenticationService.logout();
                    vm.progress = 0;
                    vm.error = gettextCatalog.getString(loginErrorMessage(err));
                    return $interval.cancel(progressInterval);
                });
        }

        /**
         * Rejections reach here as the $http response for 400/401/500, and as an Error or
         * undefined when a 429, 502-504 or network failure resolves past the interceptor.
         */
        function loginErrorMessage(err) {
            var data = (err && err.data) || {};
            if (LOGIN_ERRORS[data.code]) {
                return LOGIN_ERRORS[data.code];
            }
            if (err && err.status === 401) {
                return LOGIN_ERRORS.invalid_credentials;
            }
            return LOGIN_ERRORS.server_error;
        }

        function handleLogin(authenticated) {
            if (authenticated.non_field_errors) {
                vm.error = gettextCatalog.getString(authenticated.non_field_errors[0]);
                vm.progress = 0;
                return $interval.cancel(progressInterval);
            }
        }

        function isUserAllowed(user) {
            var frontends = user.allowed_frontends ? angular.fromJson(user.allowed_frontends) : [];
            $rootScope.me = user;
            $localStorage.user.info = user;
            var homeState = setHomeState();

            const allowedFrontends = frontends
                .filter(frontend => frontend.app === $rootScope.app)
                .reduce((memo, frontend) => {
                    return frontend;
                }, 'notAllowed');

            if (allowedFrontends === 'notAllowed') {
                authenticationService.logout();
                $timeout(() => {
                    vm.error = gettextCatalog.getString(gettext('Not Authorized for this Application'));
                    vm.progress = 0;
                });
            } else {
                $state.go(homeState, {}, { reload: true });
                vm.progress = 100;
                Raven.setUserContext({
                    email: $localStorage.user.info.email,
                    id: $localStorage.user.info.id
                });
            }

            return $interval.cancel(progressInterval);
        }

        function setHomeState() {
            if (me.isEmployee()) {
                return $rootScope.app === 'dashboard' && $localStorage.user.info.employee.is_quality_controller
                    ? 'base.assessments-list'
                    : 'base.home';
            }

            if (me.isDashboardUserAdmin()) {
                return 'base.alerts';
            } else return 'base.home';
        }

        function startLoginProgress() {
            vm.progress = 0;

            progressInterval = $interval(() => {
                if (vm.progress < 50) {
                    vm.progress += 0.3;
                } else if (vm.progress >= 50 && vm.progress < 80) {
                    vm.progress += 0.2;
                } else if (vm.progress >= 80 && vm.progress < 95) {
                    vm.progress += 0.05;
                } else if (vm.progress >= 95 && vm.progress < 99) {
                    vm.progress += 0.01;
                }
            }, 100);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments', [
            'ui.router',
            'ui.bootstrap',
            'gettext',
            'ngStorage',
            'angular-jwt',
            'toastr',
            'scope.commons',
            'scope.constants'
        ])
        .config(config);

    config.$inject = ['$stateProvider'];

    const baseAssessmentsUrlParams = [
        'search',
        'ordering',
        'status',
        'countries',
        'project_name',
        'min_date',
        'max_date',
        'tool_type',
        'language',
        'assessor_name',
        'financial_specialist',
        'quality_reviewer',
        'financial_quality_reviewer',
        'page_size'
    ];

    var baseAssessmentLogUrlParams = ['assessment_id', 'search', 'ordering', 'status_changes'];

    function createUrlWithParams(url, params) {
        return (
            url +
            params.reduce((memo, param, index) => {
                return memo + param + (params.length - 1 === index ? '' : '&');
            }, '?')
        );
    }

    const assessmentListStateObject = {
        url: createUrlWithParams('/assessments/{page:[0-9]*}', baseAssessmentsUrlParams),
        views: {
            'contentView@base': {
                templateUrl: 'assessments/assessmentListView.html',
                controller: 'assessmentListController'
            }
        }
    };

    function config($stateProvider) {
        $stateProvider
            .state('base.assessments-list', assessmentListStateObject)
            .state(
                'base.assessments-list-final',
                Object.assign({}, assessmentListStateObject, {
                    url: createUrlWithParams('/assessments/final/{page:[0-9]*}', baseAssessmentsUrlParams)
                })
            )
            .state('base.assessments-assignments', {
                url: '/assessments/assignments/{page:[0-9]*}?search&ordering',
                views: {
                    'contentView@base': {
                        controller: [
                            '$state',
                            function($state) {
                                $state.go('base.assessments-list');
                            }
                        ]
                    }
                }
            })
            .state('base.assessments-rapid-final', {
                url: '/assessments/rapid/summary/{id:[0-9]+}',
                abstract: true,
                views: {
                    'contentView@base': {
                        templateUrl: 'assessments/assessmentRapidSummaryView.html',
                        controller: 'assessmentRapidSummaryController'
                    }
                },
                redirectTo: 'assessmemts-rapid-final.summary'
            })
            .state('base.assessments-rapid-final.summary', {
                url: '', //make this the default tab
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/summaryRapidFinalTabView.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.documentation', {
                url: '/documentation', //make this the default tab
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/dashboardDocumentationTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.dashboard-documentation', {
                url: '/dashboard-documentation',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/dashboardUsersDocumentationTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.dashboard-attachments', {
                url: '/dashboard-attachments',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/dashboardUsersAttachmentsTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.section', {
                url: '/section/{section:[0-9]+}',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/rapidQuestionnaireTabView.html',
                        controller: 'rapidSummarySectionController'
                    }
                }
            })
            .state('base.assessments-rapid-final.organizational', {
                url: '/organizational',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/organizationalTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.valuechain', {
                url: '/valuechain',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/valueChainTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.finance', {
                url: '/finance',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/financeTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.production', {
                url: '/production',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/productionTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.monthly-production', {
                url: '/monthly-production',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/monthlyProductionTab.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.governance', {
                url: '/governance',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/governanceTabView.html'
                    }
                }
            })
            .state('base.assessments-rapid-final.terms', {
                url: '/terms',
                views: {
                    tabContent: {
                        templateUrl: 'assessments/partials/rapid/termsTab.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail', {
                abstract: true,
                url: '/assessments/assignment/detail/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'assessments/assessmentAssignmentDetailView.html',
                        controller: 'assessmentAssignmentDetailController'
                    }
                },
                redirectTo: 'assessments-assignment-detail.assessment'
            })
            .state('base.assessments-assignment-aitabuilder', {
                url: '/aitabuilder/:id',
                views: {
                    'contentView@base': {
                        templateUrl: 'assessments/assessmentAITABuilder.html',
                        controller: 'assessmentAITABuidlerController'
                    }
                }
            })
            .state('base.assessments-assignment-detail.assessment', {
                url: '', //make this the default tab
                views: {
                    tabContent: {
                        controller: 'tabAssessmentController',
                        templateUrl: 'assessments/partials/assessmentTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.organization', {
                url: '/organization',
                views: {
                    tabContent: {
                        controller: 'tabOrganizationController',
                        templateUrl: 'assessments/partials/organizationalTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.valuechain', {
                url: '/value-chain',
                views: {
                    tabContent: {
                        controller: 'tabValueChainController',
                        templateUrl: 'assessments/partials/valueChainTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.finance-history', {
                url: '/finance-history',
                views: {
                    tabContent: {
                        controller: 'tabFinanceHistoryController',
                        templateUrl: 'assessments/partials/financeHistoryTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.finance-overview', {
                url: '/finance-overview',
                views: {
                    tabContent: {
                        controller: 'tabFinanceOverviewController',
                        templateUrl: 'assessments/partials/financeOverviewTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.financial-performance', {
                url: '/financial-performance',
                views: {
                    tabContent: {
                        controller: 'tabFinancialPerformanceController',
                        templateUrl: 'assessments/partials/financialPerformanceTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.profit-loss', {
                url: '/profit-loss',
                views: {
                    tabContent: {
                        controller: 'tabProfitLossController',
                        templateUrl: 'assessments/partials/profitLossTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.balancesheet', {
                url: '/balance-sheet',
                views: {
                    tabContent: {
                        controller: 'tabBalancesheetController',
                        templateUrl: 'assessments/partials/balanceSheetTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.cashflow', {
                url: '/cashflow',
                views: {
                    tabContent: {
                        controller: 'tabCashflowController',
                        templateUrl: 'assessments/partials/cashflowStatementTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.production', {
                url: '/production',
                views: {
                    tabContent: {
                        controller: 'tabProductionController',
                        templateUrl: 'assessments/partials/productionTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.observations', {
                url: '/observations',
                views: {
                    tabContent: {
                        controller: 'tabObservationsController',
                        templateUrl: 'assessments/partials/observationsTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.questionnaire', {
                url: '/questionnaire',
                views: {
                    tabContent: {
                        controller: 'tabQuestionnaireController',
                        templateUrl: 'assessments/partials/questionnaireTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.documentation', {
                url: '/documentation',
                views: {
                    tabContent: {
                        controller: 'tabDocumentationController',
                        templateUrl: 'assessments/partials/documentationTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.terms', {
                url: '/terms',
                views: {
                    tabContent: {
                        controller: 'tabTermsController',
                        templateUrl: 'assessments/partials/termsTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.qc-logs', {
                url: createUrlWithParams('/qc-logs/?{page:[0-9]*}', baseAssessmentLogUrlParams),
                views: {
                    tabContent: {
                        controller: 'tabQCLogController',
                        templateUrl: 'assessments/partials/qcLogTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.finance-product', {
                url: '/finance-product',
                views: {
                    tabContent: {
                        controller: 'tabFinanceProductController',
                        templateUrl: 'assessments/partials/financeProductTabView.html'
                    }
                }
            })
            .state('base.qc-dashboard', {
                url: '/assessments/{id}/qc-dashboard',
                views: {
                    'contentView@base': {
                        controller: 'tabQCDashboardController',
                        templateUrl: 'assessments/partials/qcDashboardTabView.html'
                    }
                }
            })
            .state('base.assessments-assignment-detail.qc-dashboard', {
                url: '/qc-dashboard',
                views: {
                    tabContent: {
                        controller: 'tabQCDashboardController',
                        templateUrl: 'assessments/partials/qcDashboardTabView.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabValueChainController', tabValueChainController);

    tabValueChainController.$inject = [
        '$rootScope',
        '$scope',
        '$uibModal',
        'gettext',
        'COMPLETION_CHECK',
        'extendDisplayValues',
        'siScope'
    ];

    function tabValueChainController(
        $rootScope,
        $scope,
        $uibModal,
        gettext,
        COMPLETION_CHECK,
        extendDisplayValues,
        siScope
    ) {
        $scope.valueChainForm = {};
        $scope.savePlayer = savePlayer;
        $scope.removePlayer = removePlayer;
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;

        function isFormDisabled() {
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.valueChainForm.$invalid) return false;
            return (
                $scope.assessment.value_chain_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.valuechainPlayerRows = [
            {
                label: 'Name',
                key: 'row.customer'
            },
            {
                label: gettext('Organizational type'),
                key: 'row.display_customer_type'
            },
            {
                label: gettext('Relation'),
                key: 'row.display_relation_to_producing_organization'
            },
            {
                label: gettext('Number years in relation'),
                key: 'row.number_of_years_in_relation'
            },
            {
                label: gettext('Contract in place'),
                key: 'row.display_contract_in_place'
            },
            {
                label: gettext('Contract start year'),
                key: 'row.contract_start_year',
                showIf: 'row.contract_in_place == "Yes"'
            },
            {
                label: gettext('Contract end year'),
                key: 'row.contract_end_year',
                showIf: 'row.contract_in_place == "Yes"'
            },
            {
                label: gettext('Description of agreement/relation'),
                key: 'row.description_of_agreement'
            }
        ];

        $scope.enablingPlayerRows = [
            {
                label: gettext('Name'),
                key: 'row.customer'
            },
            {
                label: gettext('Organizational type'),
                key: 'row.display_customer_type'
            },
            {
                label: gettext('Relation'),
                key: 'row.display_relation_to_producing_organization'
            },
            {
                label: gettext('Number years in relation'),
                key: 'row.number_of_years_in_relation'
            },
            {
                label: gettext('Contract in place'),
                key: 'row.contract_in_place'
            },
            {
                label: gettext('Contract start year'),
                key: 'row.contract_start_year'
            },
            {
                label: gettext('Contract end year'),
                key: 'row.contract_end_year'
            },
            {
                label: gettext('Description of agreement/relation'),
                key: 'row.description_of_agreement'
            }
        ];

        $scope.supplierRows = [
            {
                label: 'Name',
                key: 'row.customer'
            },
            {
                label: gettext('Type of supplier'),
                key: 'row.display_customer_type'
            },
            {
                label: gettext('Number years in relation'),
                key: 'row.number_of_years_in_relation'
            },
            {
                label: gettext('Contract in place'),
                key: 'row.display_contract_in_place'
            },
            {
                label: gettext('Contract start date'),
                key: 'row.contract_start_year',
                showIf: 'row.contract_in_place == "Yes"'
            },
            {
                label: gettext('Contract end date'),
                key: 'row.contract_end_year',
                showIf: 'row.contract_in_place == "Yes"'
            },
            {
                label: gettext('Payment method'),
                key: 'row.display_payment_method'
            },
            {
                label: gettext('Description of agreement'),
                key: 'row.description_of_agreement'
            },
            {
                label: gettext('Amount purchased in most recent full year'),
                key: 'row.amount_purchased.amount',
                filter: 'value|currency:row.amount_purchased.currency+" ":0'
            },
            {
                label: gettext('Product types purchased'),
                key: 'row.product_types_purchased'
            }
        ];

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function playerModal(url, editPlayer, assessment, relationDropdown) {
            return {
                templateUrl: url,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'editPlayer',
                    'dropdown',
                    'productTypes',
                    function($scope, $uibModalInstance, assessment, editPlayer, dropdown, productTypes) {
                        $scope.assessment = assessment;
                        $scope.player = editPlayer
                            ? editPlayer
                            : {
                                  assessment: assessment.url,
                                  product_types_purchased: { objects: [] }
                              };

                        $scope.relationdropdown = dropdown[relationDropdown].objects;
                        $scope.dropdown = dropdown;
                        $scope.productTypes = productTypes;
                        $scope.save = player => $uibModalInstance.close(player);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.shouldValidate = false;
                        $scope.addUrlToProductTypes = object => {
                            if ($scope.isChecked(object.url)) {
                                $scope.player.product_types_purchased.objects = $scope.player.product_types_purchased.objects.filter(
                                    product => product.url !== object.url
                                );
                            } else {
                                $scope.player.product_types_purchased.objects.push(object);
                            }
                        };
                        $scope.isChecked = url =>
                            $scope.player.product_types_purchased.objects &&
                            $scope.player.product_types_purchased.objects.map(type => type.url).indexOf(url) > -1;
                    }
                ],
                resolve: {
                    dropdown: () => $scope.dropdown,
                    assessment: () => $scope.assessment,
                    editPlayer: () => editPlayer,
                    productTypes: () => $scope.dropdown.producttype_options.objects
                }
            };
        }

        function savePlayer(name, editPlayer) {
            let relationDropdown;
            let templateUrl = 'assessments/modals/editValueChainPlayer.html';
            if (name === 'enablingplayers') {
                relationDropdown = 'ngorelationtype_options';
                templateUrl = 'assessments/modals/editValueChainPlayerSupportingOrganization.html';
            } else if (name === 'valuechainplayers') {
                relationDropdown = 'customerrelationtype_options';
            } else if (name === 'suppliers') {
                relationDropdown = 'customerrelationtype_options';
            }

            return $uibModal
                .open(playerModal(templateUrl, editPlayer, $scope.assessment, relationDropdown))
                .result.then(function(player) {
                    if (name === 'suppliers' && player.amount_purchased.currency === '-') {
                        delete player.amount_purchased;
                    }

                    if (player.id) {
                        siScope.patch(player).then(res => extendDisplayValues.extend(player, res));
                    } else {
                        var createLink = $scope.assessment[name].links.create;

                        siScope.create(player, createLink).then(newPlayer => {
                            if ($rootScope.isOffline) {
                                newPlayer.display_customer_type = newPlayer.customer_type;
                                newPlayer.display_relation_to_producing_organization =
                                    newPlayer.relation_to_producing_organization;
                                newPlayer.display_contract_in_place = newPlayer.contract_in_place;
                            }
                            $scope.assessment[name].objects.push(newPlayer);
                        });
                    }
                });
        }

        function removePlayer(name, player) {
            $scope.assessment[name].objects = $scope.assessment[name].objects.filter(function(item) {
                return item.id !== player.id;
            });

            return siScope.remove(player.url);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabTermsController', tabTermsController);

    tabTermsController.$inject = ['$scope', 'siScope', 'gettext', 'toastr'];

    function tabTermsController($scope, siScope, gettext, toastr) {
        $scope.termsForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;

        function isFormDisabled() {
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.termsForm.$invalid) return false;
            return (
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required &&
                ($scope.assessment.data_sharing_consent_tab_accepted ||
                    $scope.assessment.terms_and_conditions_tab_accepted)
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.agreementText = gettext(
            'I agree that I have explained the Data Sharing Consent(s) to the assessee and I have uploaded the signed document.'
        );

        $scope.termsAvailabilityResponseDocumentCreate = function(obj) {
            var allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'docx'];
            var file_name = obj.file_name;
            var fileExtension = file_name
                .toLowerCase()
                .split('.')
                .pop();
            if (allowedExtensions.indexOf(fileExtension) === -1) {
                toastr.error('File is not of the approipriate format.\nAllowed extensions: jpg, jpeg, png, pdf, docx.');
                angular.element('#termsavailabilityresponse').val('');
                return;
            }
            obj.assessment = $scope.assessment;
            return siScope
                .create(obj, $scope.assessment.terms_and_conditions.links.create)
                .then(res => $scope.assessment.terms_and_conditions.objects.push(res));
        };

        // Only the deleted document leaves the list (AD-2191: every document is
        // now shown, so clearing the list would hide the ones still stored).
        $scope.removeTermsDoc = url =>
            siScope
                .remove(url)
                .then(
                    () =>
                        ($scope.assessment.terms_and_conditions.objects = $scope.assessment.terms_and_conditions.objects.filter(
                            item => item.url !== url
                        ))
                );

        $scope.toggleSigned = ({ url, signed }) => siScope.patch({ url, signed: !!signed });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabQuestionnaireController', tabQuestionnaireController);

    tabQuestionnaireController.$inject = [
        '$rootScope',
        '$scope',
        '$log',
        'siAssessments',
        'apiUrl',
        'modalFactory',
        'gettext',
        'gettextCatalog',
        'siScope',
        'siQuestionnaire',
        'toastr',
        '$uibModal',
        '$timeout',
        'EVENT_LOADER'
    ];

    function tabQuestionnaireController(
        $rootScope,
        $scope,
        $log,
        siAssessments,
        apiUrl,
        modalFactory,
        gettext,
        gettextCatalog,
        siScope,
        siQuestionnaire,
        toastr,
        $uibModal,
        $timeout,
        EVENT_LOADER
    ) {
        $scope.saveResponse = saveResponse;
        $scope.saveSubResponse = saveSubResponse;
        $scope.saveNullResponse = saveNullResponse;
        $scope.parseDecimals = parseShittyDecimals;
        $scope.removeResponseDocument = removeResponseDocument;
        $scope.toggleAcceptResponse = toggleAcceptResponse;
        $scope.saveNoneAboveResponse = saveNoneAboveResponse;
        $scope.acceptAllModal = acceptAllModal;
        $scope.reopenAllModal = reopenAllModal;
        $scope.toggleAcceptDeclineAll = toggleAcceptDeclineAll;
        $scope.shouldShowDocuments = shouldShowDocuments;
        $scope.responseInView = responseInView;
        $scope.saveQuestionExplanationComment = saveQuestionExplanationComment;
        $scope.initializeQuestion = initializeQuestion;
        $scope.isFormDisabled = isFormDisabled;
        $scope.isPercentageQuestion = isPercentageQuestion;
        $scope.quesTrans = quesTrans;
        $scope.isOptionDisabled = isOptionDisabled;
        $scope.isQuestionLocked = isQuestionLocked;
        $scope.getDisableReason = getDisableReason;
        $scope.getQuestionLockReason = getQuestionLockReason;
        $scope.handleOptionChange = handleOptionChange;
        $scope.handleNotRelevantChange = handleNotRelevantChange;
        $scope.refreshDependentQuestions = refreshDependentQuestions;
        $scope.refreshSubQuestionOptions = refreshSubQuestionOptions;
        $scope.findDependentSubresponses = findDependentSubresponses;
        $scope.isDependentOn = isDependentOn;
        $scope.cacheValidationRules = cacheValidationRules;
        $scope.findSubresponseByQuestionId = findSubresponseByQuestionId;
        $scope.extractIdFromUrl = extractIdFromUrl;
        $scope.evaluateOptionNotChecked = evaluateOptionNotChecked;
        $scope.evaluateValidationRulesLocally = evaluateValidationRulesLocally;
        $scope.reEvaluateAllOptionsLocally = reEvaluateAllOptionsLocally;
        $scope.saveNotRelevantOffline = saveNotRelevantOffline;

        $scope.validationRulesCache = {};

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$onInit = function() {
            console.log('Initializing tabQuestionnaireController...');

            // Cache validation rules
            if ($scope.assessment) {
                cacheValidationRules();
            }
        };

        function safeApply(fn) {
            $scope.$evalAsync(fn);
        }

        function cacheValidationRules() {
            const cache = {};

            $scope.assessment.section_responses.objects.forEach(function(section) {
                section.children.objects.forEach(function(child) {
                    child.responses.objects.forEach(function(response) {
                        response.subresponses.objects.forEach(function(subresponse) {
                            if (subresponse.subquestion.options && subresponse.subquestion.options.objects) {
                                subresponse.subquestion.options.objects.forEach(function(option) {
                                    if (option.validation_rules && option.validation_rules.length > 0) {
                                        cache[option.id] = option.validation_rules;
                                    }
                                });
                            }
                        });
                    });
                });
            });

            $scope.validationRulesCache = cache;

            try {
                localStorage.setItem('validation_rules_' + $scope.assessment.id, JSON.stringify(cache));
                console.log('Saved to localStorage');
            } catch (e) {
                console.warn('Could not save to localStorage:', e);
            }

            return cache;
        }
        function findSubresponseByQuestionId(questionId) {
            let found = null;

            if (!$scope.assessment || !$scope.assessment.section_responses) {
                return null;
            }

            $scope.assessment.section_responses.objects.forEach(function(section) {
                if (!section.children || !section.children.objects) return;

                section.children.objects.forEach(function(child) {
                    if (!child.responses || !child.responses.objects) return;

                    child.responses.objects.forEach(function(response) {
                        if (!response.subresponses || !response.subresponses.objects) return;

                        response.subresponses.objects.forEach(function(sr) {
                            if (sr.subquestion.id === questionId) {
                                found = sr;
                            }
                        });
                    });
                });
            });

            return found;
        }
        function extractIdFromUrl(url) {
            if (!url) return null;

            // url template: "http://127.0.0.1:8000/products/subquestionoptions/118639/"
            const parts = url.split('/');

            const id = parts[parts.length - 2];

            return id || null;
        }

        function evaluateOptionNotChecked(rule) {
            const dependentQuestionId = rule.dependent_question_id;
            const requiredOptionIds = rule.required_option_ids || [];

            //console.log('Evaluating rule:', rule.id, 'dependent_question:', dependentQuestionId);

            if (!dependentQuestionId || requiredOptionIds.length === 0) {
                //console.log('No dependent question or required options → DISABLE');
                return { disabled: true };
            }

            const dependentSubresponse = findSubresponseByQuestionId(dependentQuestionId);

            if (!dependentSubresponse) {
                //console.log('Dependent question not found → DISABLE');
                return { disabled: true };
            }

            //console.log('Found dependent subresponse, type:', dependentSubresponse.subquestion.type);

            if (dependentSubresponse.subquestion.type === 'checkbox') {
                const checkedOptionIds = (dependentSubresponse.checked_options.objects || [])
                    .map(function(opt) {
                        if (typeof opt === 'string') {
                            return extractIdFromUrl(opt);
                        }
                        return String(opt.id);
                    })
                    .filter(function(id) {
                        return id !== null && id !== undefined;
                    });

                //console.log('Checked option IDs:', checkedOptionIds);
                //console.log('Required option IDs:', requiredOptionIds);
                //console.log('Logic operator:', rule.logic_operator);

                // Check if rule uses OR logic or AND logic
                const isOrLogic = rule.logic_operator === 'OR';

                let hasRequired;
                if (isOrLogic) {
                    // OR logic: AT LEAST ONE required option must be checked
                    hasRequired = requiredOptionIds.some(function(reqId) {
                        return checkedOptionIds.includes(String(reqId));
                    });
                    //console.log('Using OR logic - at least one required:', hasRequired);
                } else {
                    // AND logic (default): ALL required options must be checked
                    hasRequired = requiredOptionIds.every(function(reqId) {
                        return checkedOptionIds.includes(String(reqId));
                    });
                    //console.log('Using AND logic - all required:', hasRequired);
                }

                return { disabled: !hasRequired };
            }

            if (dependentSubresponse.subquestion.type === 'mpc') {
                const selectedOptionId = dependentSubresponse.selected_option
                    ? extractIdFromUrl(dependentSubresponse.selected_option)
                    : null;

                console.log('Selected option ID:', selectedOptionId);
                console.log('Required option IDs:', requiredOptionIds);
                console.log('Logic operator:', rule.logic_operator);

                if (!selectedOptionId) {
                    console.log('No selection → DISABLE');
                    return { disabled: true };
                }

                // For MPC (single selection), OR and AND logic have the same effect
                // Check if the selected option is one of the required options
                const hasRequired = requiredOptionIds.includes(String(selectedOptionId));
                console.log('Selected option matches required:', hasRequired);

                return { disabled: !hasRequired };
            }

            //console.log('Unknown question type → ENABLE');
            return { disabled: false };
        }

        function evaluateValidationRulesLocally(option) {
            if (!option.validation_rules || option.validation_rules.length === 0) {
                //console.log('No validation rules → ENABLE');
                return { disabled: false, reasons: [] };
            }

            let disabled = false;
            const reasons = [];

            //console.log('Found', option.validation_rules.length, 'validation rules');

            option.validation_rules.forEach(function(rule) {
                if (!rule.is_active) {
                    //console.log('Rule', rule.id, 'is not active → SKIP');
                    return;
                }

                //console.log('Evaluating rule', rule.id, 'type:', rule.rule_type);

                if (rule.rule_type === 'option_not_checked') {
                    const result = evaluateOptionNotChecked(rule);

                    if (result.disabled) {
                        disabled = true;
                        reasons.push(rule.error_message || 'This option is disabled');
                    }
                } else {
                    //console.log('Unknown rule type, skipping');
                }
            });
            return { disabled: disabled, reasons: reasons };
        }

        function reEvaluateAllOptionsLocally() {
            let updatedCount = 0;
            let needsCascade = false;

            $scope.assessment.section_responses.objects.forEach(function(section) {
                if (!section.children || !section.children.objects) return;

                section.children.objects.forEach(function(child) {
                    if (!child.responses || !child.responses.objects) return;

                    child.responses.objects.forEach(function(response) {
                        if (!response.subresponses || !response.subresponses.objects) return;

                        response.subresponses.objects.forEach(function(subresponse) {
                            if (!subresponse.subquestion.options || !subresponse.subquestion.options.objects) return;

                            let allDisabled = true;
                            let hasValidationRules = false;
                            let hasUncheckedOptions = false;

                            subresponse.subquestion.options.objects.forEach(function(option) {
                                if (option.validation_rules && option.validation_rules.length > 0) {
                                    hasValidationRules = true;

                                    const result = evaluateValidationRulesLocally(option);

                                    option.is_disabled = result.disabled;
                                    option.disable_reasons = result.reasons;

                                    // OFFLINE: Auto-uncheck options that became disabled
                                    if (result.disabled && option.checked) {
                                        /*
                                        console.log(
                                            '  → OFFLINE: Auto-unchecking disabled option',
                                            option.id,
                                            option.title.substring(0, 30)
                                        );
                                        */
                                        option.checked = false;
                                        hasUncheckedOptions = true;
                                        needsCascade = true;
                                    }

                                    if (!result.disabled) {
                                        allDisabled = false;
                                    }

                                    updatedCount++;
                                } else {
                                    allDisabled = false;
                                }
                            });

                            // Update checked_options array if we unchecked any options
                            if (hasUncheckedOptions && subresponse.subquestion.type === 'checkbox') {
                                //console.log('Updating checked_options for Q', subresponse.subquestion.id);
                                subresponse.checked_options.objects = subresponse.subquestion.options.objects.filter(
                                    function(opt) {
                                        return opt.checked;
                                    }
                                );

                                // Save to offline queue
                                const patch = {
                                    url: subresponse.url,
                                    checked_options: subresponse.checked_options.objects.map(function(opt) {
                                        return opt.url;
                                    })
                                };
                                siScope.patch(patch);
                            }

                            if (hasValidationRules && subresponse.subquestion.can_be_not_relevant) {
                                if (allDisabled && !subresponse.not_relevant) {
                                    //console.log('Auto-setting not_relevant for Q', subresponse.subquestion.id);

                                    subresponse.not_relevant = true;
                                    subresponse.score = 0;

                                    if (subresponse.subquestion.type === 'checkbox') {
                                        subresponse.subquestion.options.objects.forEach(function(opt) {
                                            opt.checked = false;
                                        });
                                        subresponse.checked_options = { objects: [] };
                                    } else if (subresponse.subquestion.type === 'mpc') {
                                        subresponse.selected_option = null;
                                        subresponse.subquestion.checked = null;
                                    }

                                    subresponse.none_of_the_above = false;
                                    subresponse.value = null;

                                    saveNotRelevantOffline(subresponse);
                                }
                            }
                        });
                    });
                });
            });

            //console.log('Re-evaluated', updatedCount, 'options');

            // OFFLINE: Cascade - if we unchecked any options, re-evaluate again for recursion
            if (needsCascade) {
                //console.log('OFFLINE: Cascading re-evaluation...');
                $timeout(function() {
                    reEvaluateAllOptionsLocally();
                }, 50);
            } else {
                // Force Angular digest only if no cascade needed
                safeApply();
            }
        }

        function saveNotRelevantOffline(subresponse) {
            const patch = {
                url: subresponse.url,
                not_relevant: true,
                checked_options: [],
                selected_option: null,
                none_of_the_above: false,
                value: null
            };

            // Automatically goes to queue as we are offline(maybe not necessery as not_relevant will also be set on backend for
            // dependant question but keep for now!)
            siScope.patch(patch).then(function() {
                console.log('Not Relevant queued for sync');
            });
        }

        function isPercentageQuestion(subresponse) {
            if (subresponse.value < 0) {
                return true;
            }
            if (!subresponse.subquestion.title.includes('percent')) {
                return false;
            } else if (subresponse.value < 0) {
                return true;
            } else if (subresponse.value > 100) {
                return true;
            } else {
                return false;
            }
        }

        function isFormDisabled() {
            if (
                $scope.assignment.assigned_as === 'financial_specialist' ||
                $scope.assignment.ax_can_view_assignment_read_only
            )
                return true;
            return (
                $scope.assessment.assessment_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function shouldShowDocuments(assessmentSubmittedOnce, isResponseAccepted) {
            if (!assessmentSubmittedOnce && isResponseAccepted) {
                return true;
            }

            if (!assessmentSubmittedOnce && !isResponseAccepted) {
                return true;
            }

            if (assessmentSubmittedOnce && isResponseAccepted) {
                return false;
            }

            if (assessmentSubmittedOnce && !isResponseAccepted) {
                return true;
            }
        }

        function responseInView(response, $inview, $viewpart) {
            $rootScope.active_response = !$inview && $viewpart !== 'both' ? undefined : response;
        }

        /**
         * Save questionnaire explanatory comment on a question
         * not the same as a conversational comment!
         * @param comment comment
         * @param obj response object
         */
        function saveQuestionExplanationComment(comment, obj) {
            if (typeof obj !== 'undefined') {
                siScope.patch({ url: obj.url, comment }).then(res => {
                    updateResponseIsDone(obj, res.comment);
                });
            } else {
                const post = {
                    url: obj.url,
                    assessment: $scope.assignment.assessment.url,
                    assessor: $scope.me.assessor.url,
                    question: obj.question.url,
                    comment
                };
                siScope.post(post);
            }
        }

        function toggleAcceptResponse(response) {
            const isResponseDone = siQuestionnaire.isResponseDone(response);

            if (!isResponseDone && !response.accepted) {
                return $uibModal.open({
                    templateUrl: 'modals/templates/question-not-done.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.ok = function() {
                                $uibModalInstance.close();
                            };
                        }
                    ]
                });
            }
            $rootScope.$broadcast(EVENT_LOADER.show);

            const patch = {
                url: response.url,
                accepted: !response.accepted,
                quality_controller: $scope.me.url
            };

            siScope.patch(patch).then(() => {
                response.accepted = !response.accepted;
                response.quality_controller = $scope.me.url;
                setParentResponseAccepted();
                if (siQuestionnaire.isQuestionnaireAccepted($scope.assessment)) {
                    $scope.showTabWarnings = false;
                }
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function acceptAllModal() {
            if (siQuestionnaire.isQuestionnaireAccepted($scope.assessment)) {
                return;
            }

            if (!siQuestionnaire.isQuestionnaireDone($scope.assessment)) {
                $scope.showTabWarnings = true;

                return $uibModal.open({
                    templateUrl: 'modals/templates/questionnaire-not-done.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.ok = function() {
                                $uibModalInstance.close();
                            };
                        }
                    ]
                });
            }

            modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to accept all questions?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $scope.showTabWarnings = false;
                            $scope.toggleAcceptDeclineAll('accept');
                        }
                    }
                ]
            });
        }

        function reopenAllModal() {
            if (!$scope.assessment.all_accepted) {
                return;
            }

            modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to re-open all questions?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $scope.toggleAcceptDeclineAll('reopen');
                        }
                    }
                ]
            });
        }

        function initializeQuestion(option, subresponse) {
            option.checked = false; // default value
            if (subresponse && subresponse.checked_options && subresponse.checked_options.objects) {
                option.checked =
                    subresponse.checked_options.objects
                        .map(function(opt) {
                            return typeof opt === 'object' ? opt.url : opt;
                        })
                        .indexOf(option.url) > -1;
            }
        }

        function toggleAcceptDeclineAll(type) {
            const assessmentURL = $scope.assessment.url;

            const accept = {
                url: assessmentURL + 'accept_all_responses/'
            };
            const decline = {
                url: assessmentURL + 'decline_all_responses/'
            };

            if (type === 'accept') {
                $scope.assessment.all_accepted = true;
            } else {
                $scope.assessment.all_accepted = false;
            }

            const updatePromise = $scope.assessment.all_accepted ? siScope.post(accept) : siScope.post(decline);
            let sections = $scope.assessment.section_responses.objects;

            $rootScope.$broadcast(EVENT_LOADER.show);

            updatePromise
                .then(() => {
                    const state = $scope.assessment.all_accepted;

                    sections = sections.map(function(section) {
                        section.accepted = state;

                        section.children.objects = section.children.objects.map(child => {
                            child.accepted = state;

                            child.responses.objects = child.responses.objects.map(res => {
                                res.accepted = state;
                                return res;
                            });

                            return child;
                        });

                        return section;
                    });
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    console.log('Error accepting all - ', err);
                    toastr.error(err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function setParentResponseAccepted() {
            function recurseChildSections(section) {
                _.each(section.children.objects, function(childSection) {
                    if (childSection.children) recurseChildSections(childSection);

                    childSection.accepted = _.every(childSection.responses.objects, function(response) {
                        return response.accepted;
                    });
                });
                section.accepted = _.every(section.children.objects, function(childSection) {
                    return childSection.accepted;
                });
            }

            _.each($scope.assessment.section_responses.objects, recurseChildSections);
        }

        /**
         * Function to add a document form a question response
         * @param document
         */

        $scope.responseDocumentCreate = obj => {
            const url = $scope.assessment.responses.objects[0].documents.links.create;

            return siScope.create(obj, url).then(doc => {
                $scope.assessment.section_responses.objects.forEach(res => {
                    res.children.objects.forEach(child => {
                        child.responses.objects.forEach(response => {
                            if (response.url === obj.response) {
                                response.documents.objects.push(doc);
                            }
                        });
                    });
                });
            });
        };

        /**
         * Function to remove a document form a question response
         * @param document
         */
        function removeResponseDocument(document, documents, index) {
            siScope.remove(document.url).then(() => documents.splice(index, 1));
        }

        function parseShittyDecimals(subresponses) {
            return (subresponses = subresponses.map(function(subresponse) {
                subresponse.weight = parseFloat(subresponse.weight);
                subresponse.value = parseFloat(subresponse.value);

                return subresponse;
            }));
        }

        /**
         * Save questionnaire response value
         * @param val value between 1 and 5
         * @param obj response object for response
         */

        function saveResponse(val, obj) {
            val = val === 0 ? null : val;

            if (typeof obj !== 'undefined') {
                var save_Response = {
                    url: apiUrl + '/assessments/responses/' + obj.id + '/'
                };
                siScope.patch(save_Response, { score: val });
            } else {
                const create_Response = {
                        url: apiUrl + '/assessments/responses/'
                    },
                    post_obj = {
                        assessment: $scope.assignment.assessment.url,
                        assessor: $scope.me.assessor.url,
                        question: obj.question.url,
                        score: val
                    };
                siScope.post(create_Response, post_obj);
            }
        }

        function saveSubResponse(subresponse) {
            const patch = {
                url: subresponse.url,
                not_relevant: false,
                none_of_the_above: false
            };

            subresponse.not_relevant = false;
            subresponse.none_of_the_above = false;

            if (subresponse.subquestion.type === 'checkbox') {
                subresponse.checked_options.objects = subresponse.subquestion.options.objects.filter(
                    option => option.checked
                );

                patch.checked_options = subresponse.checked_options.objects.map(option => option.url);
                subresponse.isDone = !!subresponse.checked_options.objects.length;
            }

            if (subresponse.subquestion.type === 'mpc') {
                subresponse.subquestion.notApplicable = false;

                subresponse.selected_option = subresponse.subquestion.options.objects
                    .filter(option => option.title === subresponse.subquestion.checked)
                    .map(option => option.url)
                    .reduce((memo, url) => url, null);

                patch.selected_option = subresponse.selected_option;
                subresponse.isDone = !!subresponse.selected_option;
            }

            if (subresponse.subquestion.type === 'numeric') {
                const isMinDefined = typeof subresponse.min_value === 'string';
                const isMaxDefined = typeof subresponse.max_value === 'string';
                const min = isMinDefined ? parseInt(subresponse.min_value, 10) : -100000000,
                    max = isMaxDefined ? parseInt(subresponse.max_value, 10) : 100000000,
                    value = parseInt(subresponse.value, 10);

                subresponse.isDone = false;

                if (min <= value && value <= max) {
                    subresponse.invalidRange = false;
                    patch.value = subresponse.value;
                    subresponse.isDone = true;
                } else if (subresponse.value === '') {
                    patch.value = null;
                    subresponse.invalidRange = false;
                } else {
                    return (subresponse.invalidRange = true);
                }
            }

            //Check if At least 3 years’ annual accounts are available or
            // Reports are audited externally selected from 2.3.1.1 and hide/reset financial information no info
            let hasForbiddenActivity = false;
            try {
                hasForbiddenActivity = subresponse.subquestion.options.objects.find(
                    x =>
                        (x.title === 'At least 3 years’ annual accounts are available' ||
                            x.title === 'Reports are audited externally') &&
                        x.checked
                );
                console.log(hasForbiddenActivity);
            } catch (error) {
                return false;
            }

            const promises = [siScope.patch(patch)];

            if (hasForbiddenActivity) {
                const assessmentPatch = {
                    url: $scope.assessment.url,
                    finance_overview_tab_accepted: false,
                    basic_profit_loss_no_information_available: false,
                    basic_profit_loss_no_info_reason: ''
                };

                promises.push(siScope.patch(assessmentPatch));
            }

            return Promise.all(promises)
                .then(results => {
                    if (hasForbiddenActivity) {
                        $scope.assessment.finance_overview_tab_accepted = false;
                        $scope.assessment.basic_profit_loss_no_information_available = false;
                        $scope.assessment.basic_profit_loss_no_info_reason = '';
                    }

                    const res = results[0]; // Prvi result je od subresponse patch-a

                    //Check if we received real response or fake from cacheIntercepter.
                    const isRealResponse = res && res.modified_at;

                    if (isRealResponse) {
                        console.log('SubResponse saved to backend');

                        subresponse = _.extend(subresponse, {
                            modified_at: res.modified_at,
                            selected_option: res.selected_option ? res.selected_option : subresponse.selected_option,
                            score: res.score
                        });

                        return $timeout(function() {
                            refreshDependentQuestions(subresponse);
                        }, 100);
                    } else {
                        console.log('OFFLINE: Saved to queue, re-evaluating locally...');
                        reEvaluateAllOptionsLocally();
                    }
                })
                .catch(err => toastr.error('Error Patching SubResponse - ', err));
        }

        function refreshDependentQuestions(changedSubresponse) {
            const changedQuestionId = changedSubresponse.subquestion.id;

            //console.log('Question changed:', changedQuestionId, 'Finding dependent questions...');

            const dependentSubresponses = findDependentSubresponses(changedQuestionId);

            //console.log('Found', dependentSubresponses.length, 'dependent subresponses to refresh');

            dependentSubresponses.forEach(function(subresponse) {
                //console.log('Refreshing options for dependent question:', subresponse.subquestion.id);
                refreshSubQuestionOptions(subresponse);
            });
        }

        function findDependentSubresponses(changedQuestionId) {
            const dependentSubresponses = [];

            if (!$scope.assessment || !$scope.assessment.section_responses) {
                return dependentSubresponses;
            }

            //console.log('findDependentSubresponses');
            //console.log('Changed question ID:', changedQuestionId);

            $scope.assessment.section_responses.objects.forEach(function(section) {
                if (!section.children || !section.children.objects) return;

                section.children.objects.forEach(function(child) {
                    if (!child.responses || !child.responses.objects) return;

                    child.responses.objects.forEach(function(response) {
                        if (!response.subresponses || !response.subresponses.objects) return;

                        response.subresponses.objects.forEach(function(subresponse) {
                            if (isDependentOn(subresponse.subquestion, changedQuestionId)) {
                                /*
                                console.log('ADDED TO DEPENDENT LIST:', {
                                    id: subresponse.subquestion.id,
                                    display_position: subresponse.subquestion.display_position,
                                    title: subresponse.subquestion.title.substring(0, 50)
                                });
                                */
                                dependentSubresponses.push(subresponse);
                            }
                        });
                    });
                });
            });

            //console.log('Total dependent subresponses found:', dependentSubresponses.length);
            //console.log('=================================');

            return dependentSubresponses;
        }

        function isDependentOn(subquestion, changedQuestionId) {
            /*
            console.log(
                'Checking if question',
                subquestion.id,
                '(' + (subquestion.display_position || 'no pos') + ')',
                'depends on',
                changedQuestionId
            );
            */

            if (subquestion.dependencies && subquestion.dependencies.length > 0) {
                //console.log('Checking dependencies array:', subquestion.dependencies);

                const hasDependency = subquestion.dependencies.some(function(dep) {
                    const matches = dep.dependent_question_id === changedQuestionId;
                    //console.log('Dep:', dep.dependent_question_id, 'matches?', matches);
                    return matches;
                });

                if (hasDependency) {
                    /*
                    console.log(
                        'Question',
                        subquestion.id,
                        '(' + (subquestion.display_position || 'no pos') + ')',
                        'has dependency on',
                        changedQuestionId
                    );
                    console.log('  REASON: Has QuestionDependency');
                    */
                    return true;
                }
            }

            if (subquestion.lock_info && subquestion.lock_info.dependent_question_id) {
                //console.log('Checking lock_info:', subquestion.lock_info);

                if (subquestion.lock_info.dependent_question_id === changedQuestionId) {
                    /*
                    console.log(
                        'Question',
                        subquestion.id,
                        '(' + (subquestion.display_position || 'no pos') + ')',
                        'has lock dependency on',
                        changedQuestionId
                    );
                    console.log('  REASON: lock_info.dependent_question_id matches');
                    */
                    return true;
                }
            }

            // Check if any options have validation rules that depend on the changed question
            if (subquestion.options && subquestion.options.objects) {
                //console.log('Checking', subquestion.options.objects.length, 'options for validation rules');
                //console.log('Changed question ID:', changedQuestionId);

                const hasValidationRule = subquestion.options.objects.some(function(option) {
                    //FALLBACK, IF NO QUESTION DEPENDENCY, LEAVE OPTION DEPENDENCY CHECK...
                    if (option.validation_rules && option.validation_rules.length > 0) {
                        /*
                        console.log(
                            '  Checking option',
                            option.id,
                            'with',
                            option.validation_rules.length,
                            'validation rules'
                        );
                        */
                        const dependsOnChanged = option.validation_rules.some(function(rule) {
                            console.log(
                                '    Rule',
                                rule.id,
                                '- dependent_question_id:',
                                rule.dependent_question_id,
                                'required_option_ids:',
                                rule.required_option_ids
                            );
                            // Check if dependent_question_id matches
                            if (rule.dependent_question_id === changedQuestionId) {
                                /*
                                console.log(
                                    'Option',
                                    option.id,
                                    'has validation_rules depending on question',
                                    changedQuestionId,
                                    '(via dependent_question_id)'
                                );
                                */
                                return true;
                            }

                            // Also check if any required_option belongs to the changed question
                            if (rule.required_option_ids && rule.required_option_ids.length > 0) {
                                //console.log('Checking required_option_ids:', rule.required_option_ids);
                                const dependsViaOption = rule.required_option_ids.some(function(reqOptionId) {
                                    // Find the option in the changed question
                                    const changedSubresponse = findSubresponseByQuestionId(changedQuestionId);
                                    //console.log('changedSubresponse found:', !!changedSubresponse);
                                    if (
                                        changedSubresponse &&
                                        changedSubresponse.subquestion.options &&
                                        changedSubresponse.subquestion.options.objects
                                    ) {
                                        /*
                                        console.log(
                                            '      Checking if option',
                                            reqOptionId,
                                            'is in changed question options'
                                        );
                                        */
                                        const hasOption = changedSubresponse.subquestion.options.objects.some(function(
                                            opt
                                        ) {
                                            //console.log('Comparing', opt.id, 'with', reqOptionId);
                                            return opt.id === reqOptionId;
                                        });
                                        if (hasOption) {
                                            /*
                                            console.log(
                                                'Option',
                                                option.id,
                                                'has validation_rules depending on question',
                                                changedQuestionId,
                                                '(via required_option_ids containing option',
                                                reqOptionId,
                                                ')'
                                            );
                                            */
                                            return true;
                                        }
                                    }
                                    return false;
                                });
                                if (dependsViaOption) {
                                    return true;
                                }
                            }

                            return false;
                        });
                        if (dependsOnChanged) {
                            return true;
                        }
                    }

                    // Legacy: check direct dependent_question_id (for backwards compatibility)
                    if (option.dependent_question_id === changedQuestionId) {
                        //console.log('Option', option.id, 'depends on question', changedQuestionId);
                        return true;
                    }

                    return false;
                });

                if (hasValidationRule) {
                    /*
                    console.log(
                        'Question',
                        subquestion.id,
                        '(' + (subquestion.display_position || 'no pos') + ')',
                        'has validation rules (checking options)'
                    );
                    console.log('  REASON: Has validation_rules array with matching dependent_question_id');
                    */
                    return true;
                }
            }

            /*
            console.log(
                'Question',
                subquestion.id,
                '(' + (subquestion.display_position || 'no pos') + ')',
                'does NOT depend on',
                changedQuestionId
            );
            */
            return false;
        }

        function refreshSubQuestionOptions(subresponse) {
            const subQuestionId = subresponse.subquestion.id;
            const assessmentId = $scope.assessment.id;

            const url = subresponse.url + '?_=' + Date.now(); // Cache buster

            //console.log('Fetching fresh subresponse:', subresponse.id);

            siScope
                .getItem(url)
                .then(function(freshSubResponse) {
                    /*
                    console.log('=== FRESH SUBRESPONSE FROM BACKEND ===');
                    console.log('URL fetched:', url);
                    console.log('freshSubResponse.id:', freshSubResponse.id);
                    console.log('freshSubResponse.checked_options (RAW):', freshSubResponse.checked_options);
                    console.log('Type:', typeof freshSubResponse.checked_options);
                    console.log('Is Array?', Array.isArray(freshSubResponse.checked_options));
                    console.log(
                        'Length:',
                        freshSubResponse.checked_options ? freshSubResponse.checked_options.length : 'N/A'
                    );
                    console.log('======================================');

                    console.log('BEFORE UPDATE:');
                    console.log('subresponse.not_relevant:', subresponse.not_relevant);
                    console.log('subresponse object:', subresponse);
                    */
                    subresponse.not_relevant = freshSubResponse.not_relevant;

                    subresponse.checked_options = freshSubResponse.checked_options;

                    subresponse.selected_option = freshSubResponse.selected_option;

                    subresponse.none_of_the_above = freshSubResponse.none_of_the_above;

                    subresponse.score = freshSubResponse.score;

                    /*
                    console.log('AFTER UPDATE:');
                    console.log('subresponse.not_relevant:', subresponse.not_relevant);
                    console.log('freshSubResponse.not_relevant:', freshSubResponse.not_relevant);
                    */

                    if (freshSubResponse.subquestion && freshSubResponse.subquestion.options) {
                        let freshOptions =
                            freshSubResponse.subquestion.options.objects || freshSubResponse.subquestion.options;

                        if (freshOptions && freshOptions.length > 0) {
                            //console.log('Found', freshOptions.length, 'fresh options');

                            const oldOptions = subresponse.subquestion.options.objects || [];
                            let hasUncheckedOptions = false;
                            let uncheckedOptionIds = [];

                            /*
                            console.log('=== DEBUGGING CHECKED OPTIONS ===');
                            console.log('freshSubResponse.checked_options:', freshSubResponse.checked_options);
                            console.log('Type:', typeof freshSubResponse.checked_options);
                            console.log('Is Array?', Array.isArray(freshSubResponse.checked_options));
                            */
                            if (freshSubResponse.checked_options) {
                                console.log('checked_options.objects:', freshSubResponse.checked_options.objects);
                            }

                            // Handle both formats: {objects: [...]} and direct array [...]
                            const checkedOptionsArray = freshSubResponse.checked_options
                                ? freshSubResponse.checked_options.objects || freshSubResponse.checked_options
                                : [];

                            const freshCheckedOptionUrls = checkedOptionsArray.map(function(opt) {
                                return typeof opt === 'object' ? opt.url : opt;
                            });

                            /*
                            console.log('checkedOptionsArray:', checkedOptionsArray);
                            console.log('freshCheckedOptionUrls:', freshCheckedOptionUrls);
                            console.log('================================');
                            */
                            freshOptions.forEach(function(freshOption) {
                                const oldOption = oldOptions.find(function(opt) {
                                    return opt.id === freshOption.id;
                                });

                                // Set checked status based on fresh response from backend
                                const shouldBeChecked = freshCheckedOptionUrls.indexOf(freshOption.url) > -1;
                                freshOption.checked = shouldBeChecked;

                                // Track if option was unchecked by backend
                                if (oldOption && oldOption.checked && !shouldBeChecked) {
                                    //console.log('Option', freshOption.id, 'was unchecked by backend');
                                    hasUncheckedOptions = true;
                                    uncheckedOptionIds.push(freshOption.id);
                                }
                            });

                            subresponse.subquestion.options.objects = freshOptions;

                            //console.log('=== AFTER REPLACING OPTIONS ===');
                            freshOptions.forEach(function(opt) {
                                /*
                                console.log('Option', opt.id, ':', {
                                    title: opt.title.substring(0, 30),
                                    is_disabled: opt.is_disabled,
                                    checked: opt.checked
                                });
                                */
                            });
                            //console.log('================================');

                            const disabledCount = freshOptions.filter(function(o) {
                                return o.is_disabled;
                            }).length;

                            /*
                            console.log(
                                'Updated subresponse:',
                                subresponse.id,
                                '| not_relevant:',
                                subresponse.not_relevant,
                                '| Options - Disabled:',
                                disabledCount,
                                '| Enabled:',
                                freshOptions.length - disabledCount
                            );
                            */

                            // If options were automatically unchecked by backend, cascade the refresh
                            if (hasUncheckedOptions) {
                                //console.log('=== CASCADE REFRESH ===');
                                /*
                                console.log(
                                    'Detected',
                                    uncheckedOptionIds.length,
                                    'options were unchecked:',
                                    uncheckedOptionIds
                                );
                                console.log(
                                    'Backend already handled the reset, now cascading to dependent questions...'
                                );
                                */

                                // Cascade to dependent questions without saving (backend already did it)
                                $timeout(function() {
                                    //console.log('Cascading to dependent questions of', subresponse.subquestion.id);
                                    refreshDependentQuestions(subresponse);
                                }, 100);
                            }
                        }
                    }

                    console.log('Calling safeApply()...');
                    safeApply();
                    console.log('safeApply() finished');
                })
                .catch(function(err) {
                    console.error('Error refreshing subresponse:', err);
                });
        }

        function getDisableReason(option) {
            if (!option.disable_reasons || option.disable_reasons.length === 0) {
                return '';
            }
            return option.disable_reasons[0];
        }

        function saveNoneAboveResponse(subresponse, response) {
            subresponse.checked_options = [];
            subresponse.selected_option = null;
            subresponse.value = null;
            subresponse.not_relevant = false;

            subresponse.isDone = subresponse.subquestion.comment_mandatory
                ? subresponse.none_of_the_above && response.comment !== ''
                : subresponse.none_of_the_above;

            subresponse.subquestion.options.objects = subresponse.subquestion.options.objects.map(option => {
                option.checked = false;
                return option;
            });

            const patch = {
                checked_options: [],
                selected_option: null,
                value: null,
                not_relevant: false
            };

            patch.none_of_the_above = subresponse.subquestion.type === 'mpc' ? true : subresponse.none_of_the_above;
            subresponse.none_of_the_above = patch.none_of_the_above;

            siAssessments
                .subResponses()
                .one(subresponse.id)
                .patch(patch)
                .then(function(res) {
                    _.extend(subresponse, { modified_at: res.modified_at });
                    console.log(subresponse);
                    const isRealResponse = res && res.modified_at;
                    if (isRealResponse) {
                        $timeout(function() {
                            refreshDependentQuestions(subresponse);
                        }, 100);
                    } else {
                        //console.log('OFFLINE: None of the Above - re-evaluating locally...');
                        reEvaluateAllOptionsLocally();
                    }
                })
                .catch(function(err) {
                    toastr.error('Error Patching SubResponse - ', err);
                });
        }

        function saveNullResponse(subresponse, response) {
            if (!subresponse.subquestion.conditional_subquestion) {
                subresponse.checked_options = [];
            }
            subresponse.selected_option = null;
            subresponse.value = null;
            subresponse.none_of_the_above = false;

            subresponse.isDone = subresponse.not_relevant;

            subresponse.subquestion.options.objects = subresponse.subquestion.options.objects.map(function(option) {
                option.checked = false;
                return option;
            });

            const patch = {
                checked_options: [],
                selected_option: null,
                value: null,
                none_of_the_above: false,
                not_relevant: true
            };

            siAssessments
                .subResponses()
                .one(subresponse.id)
                .patch(patch)
                .then(res => {
                    _.extend(subresponse, {
                        modified_at: res.modified_at,
                        score: res.score
                    });
                    console.log(subresponse);
                })
                .catch(err => toastr.error('Error Patching SubResponse - ', err));
        }

        function updateResponseIsDone(response, comment) {
            _.forEach(response.subresponses.objects, function(subresponse) {
                if (subresponse.none_of_the_above) {
                    _.extend(subresponse, {
                        isDone: subresponse.subquestion.comment_mandatory
                            ? subresponse.none_of_the_above && comment !== ''
                            : subresponse.none_of_the_above
                    });
                } else if (subresponse.not_relevant) {
                    _.extend(subresponse, {
                        isDone: subresponse.subquestion.comment_mandatory
                            ? subresponse.not_relevant && comment !== ''
                            : subresponse.not_relevant
                    });
                }
            });
        }

        function isOptionDisabled(option, subresponse, response) {
            if ($scope.assignment.submitted_at_least_once && response.accepted) {
                return true;
            }

            if ($scope.isOffline) {
                //console.log('OFFLINE mode - using local validation for option:', option.id);

                const localResult = evaluateValidationRulesLocally(option);

                option.disable_reasons = localResult.reasons;

                //console.log('Local validation result:', localResult.disabled);

                return localResult.disabled;
            }

            return option.is_disabled || false;
        }

        function isQuestionLocked(subresponse) {
            return subresponse.subquestion.is_locked || false;
        }

        function getDisableReason(option) {
            if (!option.disable_reasons || option.disable_reasons.length === 0) {
                return '';
            }
            return option.disable_reasons[0];
        }

        function getQuestionLockReason(subresponse) {
            if (!subresponse.subquestion.lock_info) {
                return '';
            }
            return subresponse.subquestion.lock_info.reason || '';
        }

        function handleOptionChange(option, subresponse, response) {
            if (option.checked) {
                subresponse.not_relevant = false;
            }

            var alerts = [];
            if (option.is_disabled && option.checked) {
                if (option.disable_reasons && option.disable_reasons.length > 0) {
                    alerts = option.disable_reasons;
                }
            }

            if (alerts.length > 0) {
                option.checked = false;
                modalFactory.AlertModal({
                    message: alerts.join('\n'),
                    title: gettext('Validation Error')
                });
                return;
            }

            saveSubResponse(subresponse);
        }

        function handleNotRelevantChange(subresponse, response) {
            if (subresponse.not_relevant) {
                if (subresponse.subquestion.type === 'checkbox') {
                    subresponse.subquestion.options.objects.forEach(function(option) {
                        option.checked = false;
                    });
                }
                subresponse.none_of_the_above = false;
            }

            saveNullResponse(subresponse, response);
        }
    }

    function quesTrans(value) {
        try {
            return {
                'financial planning': {
                    en: 'Financial Planning',
                    fr: 'Planification financière',
                    es: 'Planificación financiera'
                },
                'collection from members': {
                    en: 'Collection from members',
                    fr: 'Collecte auprès des membres',
                    es: 'Colección de miembros'
                },
                storage: { en: 'Storage', fr: 'Stockage', es: 'Almacenamiento' },
                'financial services': {
                    en: 'Financial services',
                    fr: 'Services financiers',
                    es: 'Servicios financieros'
                },
                logistics: { en: 'Logistics', fr: 'Logistique', es: 'Logística' },
                'internal management': { en: 'Internal management', fr: 'Gestion interne', es: 'Gestión interna' },
                'internal organization': {
                    en: 'Internal organization',
                    fr: 'Organisation interne',
                    es: 'Organización interna'
                },
                'outgrowers base strength': {
                    en: 'Outgrowers base strength',
                    fr: 'Force de base des cultivateurs',
                    es: 'Fuerza base de cultivadores externos'
                },
                operations: { en: 'Operations', fr: 'Opérations', es: 'Operaciones' },
                'record keeping & monitoring': {
                    en: 'Record keeping & monitoring',
                    fr: 'Tenue de dossiers et suivi',
                    es: 'Mantenimiento y seguimiento de registros'
                },
                'gap knowledge': { en: 'GAP knowledge', fr: 'Connaissance des lacunes', es: 'Conocimiento de GAP' },
                'producer oversight & training unions/federations': {
                    en: 'Producer oversight & training unions/federations',
                    fr: 'Surveillance des producteurs et formation des syndicats/fédérations',
                    es: 'Sindicatos/federaciones de supervisión y formación de productores'
                },
                'farmer oversight & training': {
                    en: 'Farmer oversight & training',
                    fr: 'Surveillance et formation des agriculteurs',
                    es: 'Supervisión y capacitación de agricultores'
                },
                'third party': { en: 'Third party', fr: 'Tierce partie', es: 'Terceros' },
                'strength of production base': {
                    en: 'Strength of production base',
                    fr: 'Force de la base de production',
                    es: 'Fuerza de base de producción'
                },
                'financial administration': {
                    en: 'Financial Administration',
                    fr: 'Administration financière',
                    es: 'Administración financiera'
                },
                'provision of inputs': {
                    en: 'Provision of inputs',
                    fr: "Fourniture d'intrants",
                    es: 'Provisión de insumos'
                },
                'service providers': {
                    en: 'Service Providers',
                    fr: 'Les fournisseurs de services',
                    es: 'Proveedores de servicio'
                },
                'supplier oversight & training': {
                    en: 'Supplier oversight & training',
                    fr: 'Surveillance & formation des fournisseurs',
                    es: 'Supervisión y formación de proveedores'
                },
                'market related risks': {
                    en: 'Market Related Risks',
                    fr: 'Risques liés au marché',
                    es: 'Riesgos relacionados con el mercado'
                },
                'sector organizations': {
                    en: 'Sector Organizations',
                    fr: 'Organisations sectorielles',
                    es: 'Organizaciones sectoriales'
                },
                government: { en: 'Government', fr: 'Gouvernement', es: 'Gobierno' },
                'additional ra questions': {
                    en: 'Additional RA Questions',
                    fr: 'Questions supplémentaires sur la RA',
                    es: 'Preguntas adicionales de RA'
                },
                enablers: { en: 'Enablers', fr: 'Facilitateurs', es: 'Facilitadores' },
                'member base strength': {
                    en: 'Member base strength',
                    fr: 'Force de base des membres',
                    es: 'Fuerza de la base de miembros'
                },
                'governance - non-executives': {
                    en: 'Governance - non-executives',
                    fr: 'Gouvernance - non-cadres',
                    es: 'Gobernanza: no ejecutivos'
                },
                'storage and inventory management': {
                    en: 'Storage and Inventory Management',
                    fr: 'Stockage et gestion des stocks',
                    es: 'Gestión de almacenamiento e inventario'
                },
                'business planning': {
                    en: 'Business planning',
                    fr: 'Planification des activités',
                    es: 'Planificación de negocios'
                },
                'sector organisations': {
                    en: 'Sector organisations',
                    fr: 'Organisations sectorielles',
                    es: 'Organizaciones sectoriales'
                },
                'procurement of inputs': {
                    en: 'Procurement of inputs',
                    fr: 'Approvisionnement en matières premières',
                    es: 'Adquisición de suministros'
                },
                'rapid specific questions': {
                    en: 'Rapid Specific Questions',
                    fr: 'Rapid questions spécifiques',
                    es: 'Rapid preguntas específicas'
                },
                'weather and natural risks': {
                    en: 'Weather and Natural Risks',
                    fr: 'Météo et risques naturels',
                    es: 'Clima y riesgos naturales'
                },
                'capacity builders and ngos': {
                    en: 'Capacity Builders and NGOs',
                    fr: 'Renforceurs de capacités et ONG',
                    es: 'Constructores de capacidad y ONG'
                },
                'inbound logistics': { en: 'Inbound logistics', fr: 'Logistique amont', es: 'Logística de entrada' },
                'mitigation strategies': {
                    en: 'Mitigation strategies',
                    fr: "Stratégies d'atténuation des risques",
                    es: 'Estrategias de mitigación'
                },
                'strength of supplier base': {
                    en: 'Strength of supplier base',
                    fr: 'Force de la base de fournisseurs',
                    es: 'Fortaleza de la base de proveedores'
                },
                'afio draft questions': {
                    en: 'AFIO Draft Questions',
                    fr: "Questions préliminaires de l'AFIO",
                    es: 'Preguntas sobre el borrador de AFIO'
                },
                'financial reporting & monitoring': {
                    en: 'Financial reporting & monitoring',
                    fr: 'Reporting financier et suivi',
                    es: 'Supervisión e informes financieros'
                },
                'marketing strategies': {
                    en: 'Marketing strategies',
                    fr: 'Stratégies marketing',
                    es: 'Estrategias de marketing'
                },
                'strength of membership base': {
                    en: 'Strength of membership base',
                    fr: 'Force de la base de membres',
                    es: 'Fortaleza de la base de miembros'
                },
                'biological and environmental': {
                    en: 'Biological and environmental',
                    fr: 'Biologique et environnemental',
                    es: 'Biológica y ambiental'
                },
                'member oversight & training': {
                    en: 'Member oversight & training',
                    fr: 'Suivi & formation des membres',
                    es: 'Supervisión y capacitación de los miembros'
                },
                'financial services to clients': {
                    en: 'Financial Services to Clients',
                    fr: 'Services financiers aux clients',
                    es: 'Servicios financieros para clientes'
                },
                'government and regulations': {
                    en: 'Government and regulations',
                    fr: 'Gouvernement et réglementation',
                    es: 'Gobierno y regulaciones'
                },
                'forestry processing specifics': {
                    en: 'Forestry processing specifics',
                    fr: 'Spécificités de la transformation forestière',
                    es: 'Detalles específicos del procesamiento forestal'
                },
                'reliability and quality of supply': {
                    en: 'Reliability and quality of supply',
                    fr: "Fiabilité et qualité d'approvisionnement",
                    es: 'Fiabilidad y calidad de suministro'
                },
                'external risk': { en: 'External Risk', fr: 'Risque Externe', es: 'Riesgo externo' },
                'capacity builders & ngos': {
                    en: 'Capacity Builders & NGOs',
                    fr: 'Renforceurs de capacités et ONG',
                    es: 'Constructores de capacidad y ONGs'
                },
                'role & responsibilities': {
                    en: 'Role & responsibilities',
                    fr: 'Rôle et responsabilités',
                    es: 'Rol y responsabilidades'
                },
                'financial services to members or outgrowers': {
                    en: 'Financial services to members or outgrowers',
                    fr: 'Services financiers aux membres ou aux cultivateurs sous-traitants',
                    es: 'Servicios financieros para miembros o cultivadores subcontratados'
                },
                processing: { en: 'Processing', fr: 'Traitement', es: 'Procesamiento' },
                'financial management': {
                    en: 'Financial management',
                    fr: 'Gestion financière',
                    es: 'Gestión financiera'
                },
                'producer oversight & training coops & outgrowers': {
                    en: 'Producer oversight & training coops & outgrowers',
                    fr: 'Surveillance des producteurs et formation des coopératives et des sous-traitants',
                    es: 'Supervisión de productores y capacitación de cooperativas y cultivadores externos'
                },
                'forest protection': {
                    en: 'Forest protection',
                    fr: 'Protection des forêts',
                    es: 'Protección forestal'
                },
                suitability: { en: 'Suitability', fr: 'Pertinence', es: 'Idoneidad' },
                'external risks': { en: 'External risks', fr: 'Risques externes', es: 'Riesgos externos' },
                sustainability: { en: 'Sustainability', fr: 'Durabilité', es: 'Sostenibilidad' },
                'environmental issues': {
                    en: 'Environmental Issues',
                    fr: 'Problèmes environnementaux',
                    es: 'Cuestiones ambientales'
                },
                community: { en: 'Community', fr: 'Communauté', es: 'Comunidad' },
                'extension services': {
                    en: 'Extension Services',
                    fr: 'Services de vulgarisation',
                    es: 'Servicios de extensión'
                },
                'financial services to suppliers': {
                    en: 'Financial services to suppliers',
                    fr: 'Services financiers rendus aux fournisseurs',
                    es: 'Servicios financieros a los proveedores'
                },
                market: { en: 'Market', fr: 'Marché', es: 'Mercado' },
                budgeting: { en: 'Budgeting', fr: 'Une budgétisation', es: 'Presupuestos' },
                governance: { en: 'Governance', fr: 'Gouvernance', es: 'Gobernanza' },
                'marketing strategy': {
                    en: 'Marketing Strategy',
                    fr: 'Stratégie Commerciale',
                    es: 'Estrategia de Mercado'
                },
                'financial planning, budgeting & sourcing': {
                    en: 'Financial planning, budgeting & sourcing',
                    fr: 'Planification financière, budgétisation et sourcing',
                    es: 'Planificación financiera, elaboración de presupuestos y abastecimiento'
                },
                'production base': { en: 'Production base', fr: 'Base de production', es: 'Base de producción' },
                'animal husbandry': { en: 'Animal husbandry', fr: 'Élevage', es: 'La cría de animales' },
                'supply from members': {
                    en: 'Supply from members',
                    fr: 'Approvisionnement des membres',
                    es: 'Suministro de miembros'
                },
                'afio questions': { en: 'AFIO Questions', fr: 'Questions de la FAO', es: 'AFIO Preguntas' },
                supply: { en: 'Supply', fr: 'Approvisionnements', es: 'Suministro' },
                'good forestry practices': {
                    en: 'Good forestry practices',
                    fr: 'Bonnes pratiques forestières',
                    es: 'Buenas prácticas forestales'
                },
                'financial services to farmers': {
                    en: 'Financial services to farmers',
                    fr: 'Services financiers aux agriculteurs',
                    es: 'Servicios financieros para agricultores'
                },
                'forest supplies': { en: 'Forest supplies', fr: 'Forest supplies', es: 'Suministros forestales' },
                'membership management': {
                    en: 'Membership management',
                    fr: 'Gestion des membres',
                    es: 'Gestión de membresía'
                },
                'awareness of external risks': {
                    en: 'Awareness of external risks',
                    fr: 'Conscience des risques externes',
                    es: 'Conciencia de los riesgos externos'
                },
                'supplier oversight': {
                    en: 'Supplier oversight',
                    fr: 'Surveillance des fournisseurs',
                    es: 'Supervisión de proveedores'
                },
                certification: { en: 'Certification', fr: 'Certification', es: 'Certificación' },
                "capacity builders & ngo's": {
                    en: "Capacity builders & NGO's",
                    fr: 'Renforceurs de capacités et ONG',
                    es: 'Constructores de capacidad y ONG'
                },
                'internal organisation': {
                    en: 'Internal organisation',
                    fr: 'Organisation interne',
                    es: 'Organización interna'
                },
                'produce from members': {
                    en: 'Produce from members',
                    fr: 'Produire des membres',
                    es: 'Producir de miembros'
                },
                'technical knowledge': {
                    en: 'Technical Knowledge',
                    fr: 'Connaissance technique',
                    es: 'Conocimientos técnicos'
                },
                'social issues': { en: 'Social issues', fr: 'Problèmes sociaux', es: 'Problemas sociales' },
                'security of supply from members or outgrowers': {
                    en: 'Security of supply from members or outgrowers',
                    fr: "Sécurité d'approvisionnement des membres ou des sous-traitants",
                    es: 'Seguridad del suministro de miembros o cultivadores subcontratados'
                },
                'record keeping': { en: 'Record keeping', fr: 'Archivage', es: 'Mantenimiento de registros' },
                'management of biological and weather-related risks': {
                    en: 'Management of biological ,and weather-related risks',
                    fr: 'Gestion des risques biologiques et météorologiques',
                    es: 'Gestión de riesgos biológicos y meteorológicos'
                },
                'financial reporting and monitoring': {
                    en: 'Financial Reporting and Monitoring',
                    fr: 'Rapports financiers et suivi',
                    es: 'Supervisión e informes financieros'
                },
                'storage, logistics & technology': {
                    en: 'Storage, logistics & technology',
                    fr: 'Stockage, logistique et technologie',
                    es: 'Almacenamiento, logística y tecnología'
                },
                'good agricultural practices': {
                    en: 'Good agricultural practices',
                    fr: 'Bonnes pratiques agricoles',
                    es: 'Buenas prácticas agrícolas'
                },
                'producer oversight & training': {
                    en: 'Producer oversight & training',
                    fr: 'Surveillance et formation des producteurs',
                    es: 'Supervisión y capacitación de productores'
                },
                'security of supply': {
                    en: 'Security of supply',
                    fr: "Sécurité d'approvisionnement",
                    es: 'Seguridad de suministro'
                },
                'outbound logistics': { en: 'Outbound logistics', fr: 'Logistique aval', es: 'Logística de salida' },
                'enabling environment': {
                    en: 'Enabling environment',
                    fr: 'Environnement habilitant',
                    es: 'Ambiente apto'
                },
                'logistics, storage and technology': {
                    en: 'Logistics, storage and technology',
                    fr: 'Logistique, stockage et technologie',
                    es: 'Logística, almacenamiento y tecnología'
                },
                'added value to members/outgrowers': {
                    en: 'Added value to members/outgrowers',
                    fr: 'Valeur ajoutée pour les membres/petits producteurs',
                    es: 'Valor agregado para miembros/cultivadores subcontratados'
                },
                'planning, budgeting & sourcing': {
                    en: 'Planning, budgeting & sourcing',
                    fr: 'Planification, budgétisation et sourcing',
                    es: 'Planificación, elaboración de presupuestos y abastecimiento'
                },
                'questions for triangulation with village chief or other important figure heads in the community': {
                    en:
                        'Questions for triangulation with village chief or other important figure heads in the community',
                    fr:
                        "Questions pour la triangulation avec le chef de village ou d'autres personnalités importantes de la communauté",
                    es:
                        'Preguntas para la triangulación con el jefe de la aldea u otras figuras importantes de la comunidad'
                },
                production: { en: 'Production', fr: 'Production', es: 'Producción' }
            }[value.toLowerCase().trim()][JSON.parse(localStorage.getItem('ngStorage-user'))['info']['language']];
        } catch (e) {
            console.log(e);
            return value;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('tabQCLogController', tabQCLogController)
        .constant('QCLOG_LIST_FILTERS', [{ 'Status changes': { status_changes: null }, optionsKey: 'status_changes' }]);

    tabQCLogController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$location',
        'siScope',
        'siAssessments',
        'siFilters',
        'gettext',
        '$log',
        'QCLOG_LIST_FILTERS',
        'EVENT_LOADER',
        'toastr'
    ];

    function tabQCLogController(
        $rootScope,
        $scope,
        $state,
        $location,
        siScope,
        siAssessments,
        siFilters,
        gettext,
        $log,
        QCLOG_LIST_FILTERS,
        EVENT_LOADER,
        toastr
    ) {
        $scope.filters = siFilters.createFilters(QCLOG_LIST_FILTERS, $location.search());
        $scope.search = search;
        $scope.removeFilter = removeFilter;

        var params = {
            assessment_id: $scope.assessment.id,
            page: $state.params.page || 1,
            fields: ['actor']
        };

        _.extend(params, $location.search());

        getQcLogs(params);

        $scope.statusChangesText = gettext('Status changes');

        function search(searchParams, displayFilter) {
            return siFilters.search(params, searchParams, displayFilter, getQcLogs);
        }

        function removeFilter(removeFilter) {
            return siFilters.removeFilter(removeFilter);
        }

        function getQcLogs(params) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siAssessments
                .getQcLogInfo(params)
                .then(function(qcLogs) {
                    $scope.qcLogs = qcLogs;
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    toastr.error('Error Fetching Logs - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabQCDashboardController', tabQCDashboardController);

    tabQCDashboardController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$location',
        'siScope',
        'siAssessments',
        'siFilters',
        'gettext',
        '$log',
        'QCLOG_LIST_FILTERS',
        'EVENT_LOADER',
        'toastr',
        '$localStorage',
        'me',
        'offline'
    ];

    function tabQCDashboardController(
        $rootScope,
        $scope,
        $state,
        $location,
        siScope,
        siAssessments,
        siFilters,
        gettext,
        $log,
        QCLOG_LIST_FILTERS,
        EVENT_LOADER,
        toastr,
        $localStorage,
        me,
        offline
    ) {
        $scope.standalonePage = false;
        $scope.error = null;
        $rootScope.$broadcast(EVENT_LOADER.show);
        $scope.loading = true;

        $scope.summary = {
            warnings: 0,
            errors: 0,
            critical: 0
        };

        $scope.filters = {
            severity: 'All',
            category: 'All',
            qcType: 'All',
            searchText: ''
        };

        $scope.categories = ['All'];
        $scope.qcTypes = ['All', 'Trend', 'Coherence', 'Fraud'];

        $scope.categoriesData = [];
        $scope.hasPreviousAssessment = false;
        $scope.currentAssessment = null;
        $scope.previousAssessment = null;

        $scope.filterBySeverity = filterBySeverity;
        $scope.filterByCategory = filterByCategory;
        $scope.filterByQcType = filterByQcType;
        $scope.applyFilters = applyFilters;
        $scope.isCheckVisible = isCheckVisible;
        $scope.isCategoryVisible = isCategoryVisible;
        $scope.getCategoryStats = getCategoryStats;

        // Initialize
        init();

        function init() {
            if (offline.isOffline || !navigator.onLine) {
                $scope.error = 'QC Dashboard is not available in offline mode.';
                $rootScope.$broadcast(EVENT_LOADER.hide);
                $scope.loading = false;
                return;
            }

            if (!$scope.assessment) {
                $scope.standalonePage = true;

                var assessmentId = $state.params.id;

                if (!assessmentId) {
                    $scope.error = 'No assessment ID provided';
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loading = false;
                    return;
                }

                loadAssessment(assessmentId);
            } else {
                var assessmentId = $scope.assessment.id;

                if (!assessmentId) {
                    $scope.error = 'No assessment ID provided';
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loading = false;
                    return;
                }

                loadQcComparison(assessmentId);
            }
        }

        function loadAssessment(assessmentId) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $scope.loading = true;

            siAssessments
                .getAssessment(assessmentId)
                .then(function(response) {
                    $scope.assessment = response;
                    /*
                    if (!hasAccess()) {
                        $scope.error = 'You do not have permission to view this QC Dashboard';
                        toastr.error('Access denied');
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                        $scope.loading = false;
                        $scope.shouldShowUnauthorizedMsg = true;
                        return;
                    }
                    */
                    loadQcComparison(assessmentId);
                })
                .catch(function(error) {
                    $log.error('Error loading assessment:', error);
                    toastr.error('Failed to load assessment');
                    $scope.error = 'Failed to load assessment';
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loading = false;
                });
        }

        /*
        function hasAccess() {
            if (me.isEmployee()) {
                return true;
            }

            var currentUserId = $localStorage.user.info.id;
            var isQualityReviewer =
                $scope.assessment.display_quality_reviewer &&
                $scope.assessment.display_quality_reviewer.id === currentUserId;

            return isQualityReviewer;
        }
        */

        function loadQcComparison(assessmentId) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $scope.loading = true;

            siAssessments
                .getQcComparison(assessmentId)
                .then(function(response) {
                    if (!response) {
                        $scope.error = 'QC comparison data is not available offline.';
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                        $scope.loading = false;
                        return;
                    }
                    $scope.hasPreviousAssessment = response.has_previous;
                    $scope.currentAssessment = response.current;
                    $scope.previousAssessment = response.previous;

                    if (response.comparisons && response.comparisons.length > 0) {
                        processComparisonData(response.comparisons);
                    } else {
                        $scope.error =
                            'No QC checks generated. This may be the first assessment for this organization.';
                    }
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loading = false;
                })
                .catch(function(error) {
                    $log.error('Error loading QC comparison:', error);
                    toastr.error('Failed to load QC comparison data');
                    $scope.error = 'Failed to load QC data';
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loading = false;
                });
        }

        function processComparisonData(checks) {
            var groupedChecks = {};
            var allCategories = new Set(['All']);

            checks.forEach(function(check) {
                if (!groupedChecks[check.category]) {
                    groupedChecks[check.category] = {
                        name: check.category,
                        description: getCategoryDescription(check.category),
                        checks: []
                    };
                }

                groupedChecks[check.category].checks.push({
                    indicator: check.indicator,
                    qcType: check.qc_type,
                    observed: check.observed,
                    severity: check.severity,
                    category: check.category,
                    previousValue: check.previous_value,
                    currentValue: check.current_value,
                    changePercentage: check.change_percentage
                });

                allCategories.add(check.category);
            });

            $scope.categoriesData = Object.values(groupedChecks);
            $scope.categories = Array.from(allCategories);

            calculateSummary(checks);
        }

        function calculateSummary(checks) {
            $scope.summary = {
                warnings: 0,
                errors: 0,
                critical: 0
            };

            checks.forEach(function(check) {
                if (check.severity === 'warning') {
                    $scope.summary.warnings++;
                } else if (check.severity === 'error') {
                    $scope.summary.errors++;
                } else if (check.severity === 'critical') {
                    $scope.summary.critical++;
                }
            });
        }

        function getCategoryDescription(categoryName) {
            var descriptions = {
                Employees:
                    'Trend and plausibility checks for full time, part time, seasonal staff and consistency with turnover.',
                'Finance loans': 'Looks at loan portfolio trends, outliers and repeated loan amounts across FOs.',
                Membership: 'Tracks large changes in membership and repeated totals for total and active members.',
                Volumes:
                    'Trend checks on purchased volume and plausibility of unit price against commodity reference bands.',
                Turnover: 'Focuses on turnover volatility, consistency with volumes and repeated turnover values.',
                'Gross margin': 'Checks plausibility of gross margin versus turnover and cost of sales.',
                'Cost of sales': 'Checks cost of sales trends and unusual repetition of values across FOs.'
            };

            return descriptions[categoryName] || 'Quality checks for ' + categoryName;
        }

        function filterBySeverity(severity) {
            $scope.filters.severity = severity;
            applyFilters();
        }

        function filterByCategory(category) {
            $scope.filters.category = category;
            applyFilters();
        }

        function filterByQcType(type) {
            $scope.filters.qcType = type;
            applyFilters();
        }

        function applyFilters() {
            // Filters are applied in the view through isCheckVisible
        }

        function isCheckVisible(check) {
            var severityMatch = $scope.filters.severity === 'All' || check.severity === $scope.filters.severity;
            var categoryMatch = $scope.filters.category === 'All' || check.category === $scope.filters.category;
            var qcTypeMatch =
                $scope.filters.qcType === 'All' ||
                check.qcType.toLowerCase().indexOf($scope.filters.qcType.toLowerCase()) !== -1;

            var searchMatch = true;
            if ($scope.filters.searchText) {
                var searchLower = $scope.filters.searchText.toLowerCase();
                searchMatch =
                    check.indicator.toLowerCase().indexOf(searchLower) !== -1 ||
                    check.qcType.toLowerCase().indexOf(searchLower) !== -1 ||
                    check.observed.toLowerCase().indexOf(searchLower) !== -1;
            }

            return severityMatch && categoryMatch && qcTypeMatch && searchMatch;
        }

        function isCategoryVisible(category) {
            return category.checks.some(function(check) {
                return $scope.isCheckVisible(check);
            });
        }

        function getCategoryStats(category) {
            var stats = {
                warning: 0,
                error: 0,
                critical: 0
            };

            category.checks.forEach(function(check) {
                if (stats.hasOwnProperty(check.severity)) {
                    stats[check.severity]++;
                }
            });

            var parts = [];
            if (stats.warning > 0) parts.push(stats.warning + ' warning' + (stats.warning > 1 ? 's' : ''));
            if (stats.error > 0) parts.push(stats.error + ' error' + (stats.error > 1 ? 's' : ''));
            if (stats.critical > 0) parts.push(stats.critical + ' critical');

            return parts.join(', ');
        }
    }

    angular.module('scope.commons.assessments').filter('capitalize', function() {
        return function(input) {
            return input ? input.charAt(0).toUpperCase() + input.slice(1) : '';
        };
    });
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabProfitLossController', tabProfitLossController);

    tabProfitLossController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'me',
        '$timeout',
        '$q',
        '$log',
        'modalFactory',
        'EVENT_LOADER',
        'gettext',
        'siAssessments',
        'siFormElement'
    ];

    function tabProfitLossController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        me,
        $timeout,
        $q,
        $log,
        modalFactory,
        EVENT_LOADER,
        gettext,
        siAssessments,
        siFormElement
    ) {
        $scope.filesStatus = {
            hasFiles: false,
            isRequired: false
        };
        $scope.profitLossForm = {};
        $scope.new_cost_of_sales = '';
        $scope.new_expenses = '';
        $scope.dropdown = $scope.dropdowns.sourceOfDataOptions;
        $scope.selected;

        $scope.addPLYear = addYears;
        $scope.addNonPLStatement = addNonPLStatement;
        $scope.removePLYear = removeYears;
        $scope.removeRow = removeRow;
        $scope.updatePLStatements = updatePLStatements;
        $scope.updateNonPLStatements = updateNonPLStatements;
        $scope.saveProfitLossStatements = saveProfitLossStatements;
        $scope.saveProfitLossStatement = saveProfitLossStatement;
        $scope.saveAllCostsOfSales = saveAllCostsOfSales;
        $scope.saveAllExpenses = saveAllExpenses;
        $scope.addCostOfSales = addCostOfSales;
        $scope.addExpense = addExpense;
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.canConfirm = canConfirm;
        $scope.toggleAudited = ({ url, audited }) => siScope.patch({ url, audited });

        $scope.handleFilesChange = function(files, fileType, isRequired, hasFiles) {
            $scope.filesStatus = {
                hasFiles: hasFiles,
                isRequired: isRequired
            };

            console.log('Production files changed:', $scope.filesStatus);
        };

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as !== 'financial_specialist' && $rootScope.app !== 'dashboard') return true;
            if ($scope.profitLossForm.$invalid) return false;
            return (
                $scope.assessment.profit_loss_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.markProfitLossTabDone = type => {
            var value = !$scope.assessment[type];
            $scope.assessment[type] = value;

            $scope.profitLossForm.hidden.$setValidity('required', value);

            var form = value ? $scope.profitLossForm : { $invalid: true, $valid: false };

            $scope.assessment.profit_loss_source_of_data_selected =
                $scope.assessment.profit_loss_source_of_data_source.length > 0 ? true : false;

            var patch = {
                url: $scope.assessment.url,
                id: $scope.assessment.id,
                [type]: value,
                profit_loss_source_of_data_source: $scope.assessment.profit_loss_source_of_data_source,
                profit_loss_source_of_data_selected: $scope.assessment.profit_loss_source_of_data_selected
            };

            // Broadcast manually to trigger validation if needed
            $rootScope.$broadcast('COMPLETION_CHECK.update', form);

            // Send patch manually using siScope directly
            siScope.patch(patch).then(res => {
                _.extend($scope.assessment, res);
                // show toast here if needed
            });
        };

        function addCostOfSales(name) {
            const costModal = $uibModal.open({
                templateUrl: 'assessments/modals/add-cost-of-sales.html',
                controllerAs: '$ctrl',
                controller: [
                    '$uibModalInstance',
                    'costOfSales',
                    function($uibModalInstance, costOfSales = '') {
                        var vm = this;
                        vm.costOfSales = costOfSales;
                        vm.save = () => $uibModalInstance.close(vm.costOfSales);
                        vm.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    costOfSales: () => name
                }
            });

            costModal.result.then(newCostOfSales => {
                name
                    ? updateCostOfSalesName(newCostOfSales, name)
                    : addNonPLStatement($scope.assessment, newCostOfSales, 'all_costs_of_sales');
            });
        }

        function updateCostOfSalesName(newName, oldName) {
            const newCostOfSale = {};
            newCostOfSale[newName] = [].concat($scope.assessment.all_costs_of_sales[oldName]);
            $scope.assessment.all_costs_of_sales = Object.assign($scope.assessment.all_costs_of_sales, newCostOfSale);
            delete $scope.assessment.all_costs_of_sales[oldName];
            updateNonPLStatements('all_costs_of_sales');
        }

        function addExpense(name) {
            const expenseModal = $uibModal.open({
                templateUrl: 'assessments/modals/add-expenses.html',
                controllerAs: '$ctrl',
                controller: [
                    '$uibModalInstance',
                    'expenses',
                    function($uibModalInstance, expenses = '') {
                        var vm = this;
                        vm.expenses = expenses;
                        vm.save = () => $uibModalInstance.close(vm.expenses);
                        vm.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    expenses: () => name
                }
            });

            expenseModal.result.then(newExpense => {
                name
                    ? updateExpensesName(newExpense, name)
                    : addNonPLStatement($scope.assessment, newExpense, 'all_expenses');
            });
        }

        function updateExpensesName(newName, oldName) {
            const newExpense = {};
            newExpense[newName] = $scope.assessment.all_expenses[oldName];
            $scope.assessment.all_expenses = Object.assign($scope.assessment.all_expenses, newExpense);
            delete $scope.assessment.all_expenses[oldName];
            updateNonPLStatements('all_expenses');
        }

        function addYears(location) {
            siAssessments
                .addYears(location, $scope.assessment, $scope.assignment)
                .then(assessment => angular.merge($scope.assessment, assessment));
        }

        function removeYears(location) {
            siAssessments
                .removeYears(location, $scope.assessment)
                .then(assessment => angular.merge($scope.assessment, assessment));
        }

        /**
         * Save all changes to the PL tab.
         * @param: objects: current list of PL's including related expenses and cost of sales
         */
        function saveProfitLossStatements(plStatements) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            var promises = plStatements.map(function(statement) {
                return siScope.patch(statement).then(function(updated) {
                    _.extend(statement, updated);
                });
            });
            var cos = updateNonPLStatements('all_costs_of_sales');
            var expenses = updateNonPLStatements('all_expenses');

            promises.push(cos);
            promises.push(expenses);

            $q.all(promises).finally(() => $rootScope.$broadcast(EVENT_LOADER.hide));
        }

        function saveProfitLossStatement(plSheet, value, name) {
            const patch = {
                id: plSheet.id,
                url: plSheet.url
            };

            if (
                plSheet.manual_net_profit_usd >
                $scope.assessment.input_validation_limits.find(e => (e.name = 'net_profit_usd'))
            ) {
                alert(
                    "Whoops! We noticed that the number entered is higher than the typical range we've seen for this field. Could you please verify if it is accurate? If it is correct, you may proceed to the next step."
                );
            }

            plSheet[name] = plSheet[name] ? plSheet[name] : { currency: $scope.assessment.currency, amount: 0 };
            plSheet[name] = typeof value === 'undefined' ? null : _.extend(plSheet[name], { amount: value });
            patch[name] = plSheet[name];

            siScope.patch(patch).then(update => {
                $scope.assessment.profitlossstatements.objects = $scope.assessment.profitlossstatements.objects.map(
                    pl => {
                        if (pl.url === plSheet.url) {
                            return _.extend(pl, update);
                        }
                        return pl;
                    }
                );
            });
        }

        function saveAllCostsOfSales(allCostsOfSales, value, name, index) {
            allCostsOfSales[name][index].value = { amount: value };
            return updateNonPLStatements('all_costs_of_sales');
        }

        function saveAllExpenses(allExpenses, value, name, index) {
            allExpenses[name][index].value = { amount: value };
            return updateNonPLStatements('all_expenses');
        }

        function addNonPLStatement(assessment, name, section) {
            const names = Object.keys($scope.assessment[section]);

            //Make sure we dont try and push to a name that already exists or an empty name.
            if (!name && names.indexOf(name) !== -1) {
                return;
            }

            $scope.assessment[section][name] = assessment.profitlossstatements.objects.map(statement => {
                const currency =
                    statement.direct_sales && statement.direct_sales.currency ? statement.direct_sales.currency : 'EUR';

                return {
                    year: statement.year,
                    value: {
                        currency: currency,
                        amount: null
                    }
                };
            });

            $scope.new_expenses = '';
            $scope.new_cost_of_sales = '';

            updateNonPLStatements(section);
        }

        function updateNonPLStatements(section) {
            const updateSection = { url: $scope.assessment.url };
            updateSection[section] = angular.copy($scope.assessment[section]);

            return siScope
                .patch(updateSection, updateSection, {
                    params: {
                        fields: ['profitlossstatements', 'all_costs_of_sales', 'all_expenses']
                    }
                })
                .then(update => {
                    delete update[section];
                    _.extend($scope.assessment, update);
                });
        }

        function updatePLStatements(pl) {
            siScope
                .patch(pl, null, {
                    params: {
                        fields: ['profitlossstatements', 'all_costs_of_sales', 'all_expenses']
                    }
                })
                .then(updated => _.extend(pl, updated));
        }

        function removeRow(arr, name) {
            return modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to remove this entry?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            delete arr[name];

                            const obj = {
                                all_costs_of_sales: $scope.assessment.all_costs_of_sales,
                                all_expenses: $scope.assessment.all_expenses,
                                url: $scope.assessment.url
                            };

                            siScope
                                .patch(obj, null, {
                                    params: {
                                        fields: ['profitlossstatements', 'all_costs_of_sales', 'all_expenses']
                                    }
                                })
                                .then(update => _.extend($scope.assessment, update));
                        }
                    }
                ]
            });
        }

        function canConfirm() {
            if ($rootScope.app === 'dashboard' && $scope.assessment.profit_loss_tab_accepted) return false;
            if ($scope.assessment.profit_loss_tab_completed) return true;

            const selected = $scope.assessment.profit_loss_source_of_data_source;

            const filesValid = !$scope.filesStatus.isRequired || $scope.filesStatus.hasFiles;

            return selected && filesValid && $scope.dropdown.some(option => option.display_name === selected);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabProductionController', tabProductionController);

    tabProductionController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        '$timeout',
        'apiUrl',
        '$q',
        'siScope',
        'me',
        'modalFactory',
        'gettext',
        'gettextCatalog',
        'fsFactory',
        'siAssessments',
        'siFormElement',
        'extendDisplayValues',
        'COMPLETION_CHECK',
        'EVENT_LOADER',
        'siProducts'
    ];

    function tabProductionController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        $timeout,
        apiUrl,
        $q,
        siScope,
        me,
        modalFactory,
        gettext,
        gettextCatalog,
        fsFactory,
        siAssessments,
        siFormElement,
        extendDisplayValues,
        COMPLETION_CHECK,
        EVENT_LOADER,
        siProducts
    ) {
        $scope.filesStatus = {
            hasFiles: false,
            isRequired: false
        };
        $scope.productionForm = {};
        $scope.innerProductionForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.canConfirm = canConfirm;
        $scope.updateNoInfoReason = updateNoInfoReason;
        $scope.updateFormElement = updateFormElement;
        $scope.organizationHasForbiddenActivity = organizationHasForbiddenActivity;
        $scope.shouldShowNoInfoButton = shouldShowNoInfoButton;
        $scope.active = 0;
        $scope.source_of_data_dropdown = $scope.dropdowns.sourceOfDataOptions;

        $scope.handleFilesChange = function(files, fileType, isRequired, hasFiles) {
            $scope.filesStatus = {
                hasFiles: hasFiles,
                isRequired: isRequired
            };

            console.log('Production files changed:', $scope.filesStatus);
        };

        function isFormDisabled() {
            // console.log($scope.assignment.ax_can_view_assignment_read_only);
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.productionForm.$invalid) return false;
            return (
                $scope.assessment.production_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        function shouldShowNoInfoButton() {
            if (!$scope.assessment) return false;
            if (!$scope.assessment.products || !$scope.assessment.products.objects) return false;

            const hasNoProducts = $scope.assessment.products.objects.length === 0;
            const completionCheckRequired = $scope.assessment.full_completion_check_required;
            const alreadyMarkedAsNoInfo = $scope.assessment.products_no_information_available;
            const hasProductionActivities = organizationHasForbiddenActivity();

            return hasNoProducts && completionCheckRequired && (alreadyMarkedAsNoInfo || !hasProductionActivities);
        }

        function organizationHasForbiddenActivity() {
            if (
                !$scope.assessment ||
                !$scope.assessment.producing_organization_details ||
                !$scope.assessment.producing_organization_details.services ||
                !$scope.assessment.producing_organization_details.services.objects
            ) {
                return false;
            }

            const productionActivities = [
                'trading',
                'storage',
                'primary production',
                'plantation management',
                'collective marketing',
                'exporting'
            ];

            if (
                !$scope.assessment.producing_organization ||
                !$scope.assessment.producing_organization.activities ||
                !$scope.assessment.producing_organization.activities.objects
            ) {
                return false;
            }

            return $scope.assessment.producing_organization.activities.objects.some(
                activity => activity.display_name && productionActivities.includes(activity.display_name.toLowerCase())
            );
        }

        //TODO: move to constants
        $scope.productionPurchaseInfoRows = [
            { label: gettext('Year'), key: 'row.year' },
            {
                label: gettext('Unit'),
                key: 'row.unit',
                filter: 'value|capitalize'
            },
            {
                label: gettext('Volume'),
                key: 'row.volume',
                filter: 'value|number'
            },
            {
                label: gettext('% certified'),
                key: 'row.percent_certified',
                filter: 'value|number'
            },
            {
                label: gettext('Price'),
                key: 'row.price.amount',
                filter: 'value|currency:row.price.currency+" ":0'
            }
        ];

        $scope.productionFiguresRows = [
            { label: gettext('Year'), key: 'row.year' },
            {
                label: gettext('Unit'),
                key: 'row.unit',
                filter: 'value|capitalize'
            },
            {
                label: gettext('Volume'),
                key: 'row.volume',
                filter: 'value|number'
            },
            {
                label: gettext('% certified'),
                key: 'row.percent_certified',
                filter: 'value|number'
            },
            {
                label: gettext('% loss'),
                key: 'row.percent_loss',
                filter: 'value|number'
            }
        ];

        $scope.productionSalesRows = [
            { label: gettext('Year'), key: 'row.year' },
            {
                label: gettext('Unit'),
                key: 'row.unit',
                filter: 'value|capitalize'
            },
            {
                label: gettext('Volume'),
                key: 'row.volume',
                filter: 'value|number'
            },
            {
                label: gettext('% certified'),
                key: 'row.percent_certified',
                filter: 'value|number'
            },
            {
                label: gettext('% exported'),
                key: 'row.percent_exported',
                filter: 'value|number'
            },
            {
                label: gettext('Gross margin (%)'),
                key: 'row.gross_margin',
                showIf: 'assessment.tool.type.input_retailer'
            },
            {
                label: gettext('Price'),
                conditionalLabel: gettext('Price per unit'),
                key: 'row.price.amount',
                filter: 'value|currency:row.price.currency+" ":0'
            }
        ];

        $scope.productionMarginsRows = [
            { label: gettext('Year'), key: 'row.year' },
            { label: gettext('Currency'), key: 'row.margin.currency' },
            { label: gettext('Margin'), key: 'row.margin.amount' }
        ];

        $scope.productionInputPurchasesRows = [
            { label: gettext('Year'), key: 'row.year' },
            { label: gettext('Name'), key: 'row.name' },
            {
                label: gettext('Unit'),
                key: 'row.unit',
                filter: 'value|capitalize'
            },
            {
                label: gettext('Volume'),
                key: 'row.volume',
                filter: 'value|number'
            },
            {
                label: gettext('Price'),
                key: 'row.price.amount',
                filter: 'value|currency:row.price.currency+" ":0'
            },
            {
                label: gettext('% certified'),
                key: 'row.percent_certified',
                filter: 'value|number'
            }
        ];

        $scope.productionSoldToFarmersRows = [
            { label: gettext('Product Sub-Type'), key: 'row.product_subtype' },
            {
                label: gettext('Product Specification'),
                key: 'row.specification'
            },
            {
                label: gettext('Sales Amount'),
                key: 'row.sales_amount.amount',
                filter: 'value|currency:row.sales_amount.currency+" ":0'
            },
            { label: gettext('Sales Trend'), key: 'row.sales_trend' }
        ];

        $scope.productionSoldToFarmersRowsNoSub = [
            {
                label: gettext('Product Specification'),
                key: 'row.specification'
            },
            {
                label: gettext('Sales Amount'),
                key: 'row.sales_amount.amount',
                filter: 'value|currency:row.sales_amount.currency+" ":0'
            },
            { label: gettext('Sales Trend'), key: 'row.sales_trend' }
        ];

        $scope.hasSubType = product => {
            return !!$scope.dropdown[product.name];
        };

        //TODO: move to constants
        var productionUnitList = [
            gettextCatalog.getString('hectare'),
            gettextCatalog.getString('kg'),
            gettextCatalog.getString('liter'),
            gettextCatalog.getString('meter')
        ];

        //TODO: move to constants
        $scope.months = [
            'january',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december'
        ];

        $scope.saveProduct = saveProduct;
        $scope.markProductTabDone = markProductTabDone;
        $scope.isProductionTabNotValid = isProductionTabNotValid;

        $scope.$watch('assessment', function() {
            if ($scope.assessment) {
                console.log($scope.assessment);
                $scope.titles = {
                    productionFigures: $scope.assessment.tool.type.basic_sme
                        ? gettext('Production/Processing Figures')
                        : gettext('Production figures'),
                    inputPurchases: $scope.assessment.tool.type.basic_sme
                        ? gettext('Raw materials')
                        : gettext('Inputs Purchased')
                };
            }
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isProductionTabNotValid(assessment) {
            if (!assessment) {
                return false;
            }

            if (
                assessment.products_no_information_available &&
                assessment.productionsales_no_product_no_info_reason &&
                assessment.productionsales_no_product_no_info_reason.length > 0
            ) {
                return false;
            }

            if (assessment.products.objects.length > 0 && !$scope.productionForm.$invalid) {
                return false;
            }
            return true;
        }

        function markProductTabDone(type) {
            var value = ($scope.assessment[type] = !$scope.assessment[type]);

            //No information changed to false, reset reason dropdown menu and uncomplete tab
            if (!value && type == 'products_no_information_available') {
                $scope.assessment.productionsales_no_product_no_info_reason = undefined;
                $scope.assessment.production_tab_completed = false;
            }

            //No information changed to true, and reason exists, should complete tab
            if (
                value &&
                type == 'products_no_information_available' &&
                $scope.assessment.productionsales_no_product_no_info_reason &&
                $scope.assessment.productionsales_no_product_no_info_reason.length > 0
            ) {
                $scope.assessment.production_tab_completed = true;
            }

            if (value) {
                $scope.assessment.products.objects.forEach(function(product) {
                    $scope.innerProductionForm[$scope.parseName(product.name)].$setValidity('required', true);
                    product.hiddenForm = 'valid';
                });
            }

            $scope.productionForm.hidden.$setValidity('required', value);

            var form = value ? $scope.productionForm : { $invalid: true, $valid: false };

            $scope.assessment.production_and_sales_source_of_data_selected =
                $scope.assessment.production_and_sales_source_of_data_source.length > 0 ? true : false;

            var patch = {
                url: $scope.assessment.url,
                id: $scope.assessment.id,
                [type]: value,
                production_and_sales_source_of_data_source:
                    $scope.assessment.production_and_sales_source_of_data_source,
                production_and_sales_source_of_data_selected:
                    $scope.assessment.production_and_sales_source_of_data_selected,
                productionsales_no_product_no_info_reason: $scope.assessment.productionsales_no_product_no_info_reason,
                production_tab_completed: $scope.assessment.production_tab_completed
            };
            /*
            siFormElement
                .update($scope.assessment, type, value, {
                    productionForm: form
                })
                .then(res => {
                    _.extend($scope.assessment, res);

                    // Flip complete bool if no_info bool is flipped
                    if (type === 'products_no_information_available') {
                        return siFormElement.update($scope.assessment, 'production_tab_completed', value);
                    }
                })
                .then(res => _.extend($scope.assessment, res));
                */

            siScope.patch(patch).then(res => {
                _.extend($scope.assessment, res);
                // show toast here if needed
            });
        }

        /**
         * Function to add product to assessment/PO
         */
        function saveProduct(assessment, product) {
            var productModalOptions = {
                templateUrl: 'assessments/modals/addProductInfo.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'siProducts',
                    'assessment',
                    'product',
                    'dropdown',
                    'months',
                    function($scope, $uibModalInstance, siProducts, assessment, product, dropdown, months) {
                        $scope.productInfoForm = {};
                        $scope.months = months;
                        $scope.dropdown = angular.copy(dropdown);
                        $scope.dropdown = checkForPrimary($scope.dropdown, product);
                        $scope.relatedList = {};
                        $scope.globalProductTypes = [];
                        let globalProductTypesPromise = siProducts.getDropDowns();
                        $q.all([globalProductTypesPromise]).then(function(promises) {
                            $scope.globalProductTypes = promises[0].globalProductTypeOptions;
                        });

                        var newProduct = {
                            assessment: assessment.url,
                            certifications: {
                                objects: []
                            },
                            operational_months: []
                        };
                        $scope.product = product ? product : newProduct;

                        // operational_months comes back capitalized from server. This makes sure that
                        // existing items are preselected in multiselect
                        $scope.product.operational_months = $scope.product.operational_months.map(function(item) {
                            return item.toLowerCase();
                        });

                        $scope.assessment = assessment;
                        $scope.getRelatedList = getRelatedList;
                        $scope.addCertification = addCertification;
                        $scope.removeCertification = removeCertification;
                        $scope.save = save;
                        $scope.cancel = cancel;

                        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                         Method Declarations
                         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

                        function getRelatedList(selectedGlobalProductType, globalProductTypes = []) {
                            if (!selectedGlobalProductType) {
                                return;
                            }

                            return globalProductTypes
                                .filter(o => o.name === selectedGlobalProductType)
                                .map(o => o.product_per_type_options.objects)
                                .reduce((memo, option) => memo.concat(option), []);
                        }

                        function addCertification() {
                            var certification = {
                                name: '',
                                start_year: '',
                                end_year: ''
                            };

                            $scope.product.certifications.objects.push(certification);
                        }

                        function cancel() {
                            $uibModalInstance.dismiss('cancel');
                        }

                        function save(saveProduct) {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            product = angular.copy(saveProduct);
                            product.total_prod_members = parseInt(product.total_prod_members, 10);

                            var certifications = angular.copy(product.certifications);

                            if (product.id) {
                                //We just remove the ceritifcations from the patch for the offline errors they might cause and
                                //since we dont update them based on the product it doesnt matter
                                delete product.certifications;

                                siScope
                                    .patch(product, false, {
                                        params: {
                                            fields: [
                                                'certifications',
                                                'productionfigures',
                                                'productionmargins',
                                                'productionpurchases',
                                                'otherproductionpurchases',
                                                'productionsales',
                                                'input_purchases',
                                                'sold_to_farmers'
                                            ]
                                        }
                                    })
                                    .then(updatedProduct => {
                                        //Reset the certs to be such
                                        product.certifications = {
                                            objects: certifications.objects
                                        };
                                        product.active = true;

                                        //Update the product with all the juicy returns.
                                        extendDisplayValues.extend(product, updatedProduct);

                                        var createPromises = certPromisesCreate(certifications.objects, product);
                                        var patchPromises = certPromisesPatch(certifications.objects, product);

                                        $q.all(createPromises)
                                            .then(createCerts => {
                                                product.certifications.objects = product.certifications.objects
                                                    .filter(cert => cert.id)
                                                    .concat(createCerts);
                                                return $q.all(patchPromises);
                                            })
                                            .then(patchCerts => {
                                                product.certifications.objects = product.certifications.objects.map(
                                                    cert => {
                                                        patchCerts
                                                            .filter(patchCert => patchCert.id === cert.id)
                                                            .reduce(
                                                                (memo, patchCert) =>
                                                                    memo ? _.extend(cert, patchCert) : memo,
                                                                false
                                                            );
                                                        return cert;
                                                    }
                                                );
                                            })
                                            .then(() => {
                                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                                $uibModalInstance.close(product);
                                            });
                                    });
                            } else {
                                //We reset the certs to be just an empty array as we will create them later on below.
                                //since we have cloned the certs above at the start of the save function we wont mutate the original goodies.
                                product.certifications = [];
                                product.display_land_unit = product.land_unit;
                                product.display_production_unit = product.production_unit;

                                //Lets create the new product
                                siScope
                                    .create(product, $scope.assessment.products.links.create, {
                                        params: {
                                            fields: [
                                                'certifications',
                                                'productionfigures',
                                                'productionmargins',
                                                'productionpurchases',
                                                'otherproductionpurchases',
                                                'productionsales',
                                                'input_purchases',
                                                'sold_to_farmers'
                                            ]
                                        }
                                    })
                                    .then(updatedProduct => {
                                        //START: For offline Product Creation - we need this so if we add these things offline the data  structures exist
                                        updatedProduct.display_name = updatedProduct.display_name
                                            ? updatedProduct.display_name
                                            : updatedProduct.name;
                                        updatedProduct.input_purchases = updatedProduct.input_purchases
                                            ? updatedProduct.input_purchases
                                            : { objects: [] };
                                        updatedProduct.productionfigures = updatedProduct.productionfigures
                                            ? updatedProduct.productionfigures
                                            : { objects: [] };
                                        updatedProduct.productionmargins = updatedProduct.productionmargins
                                            ? updatedProduct.productionmargins
                                            : { objects: [] };
                                        updatedProduct.otherproductionpurchases = updatedProduct.otherproductionpurchases
                                            ? updatedProduct.otherproductionpurchases
                                            : { objects: [] };
                                        updatedProduct.productionsales = updatedProduct.productionsales
                                            ? updatedProduct.productionsales
                                            : { objects: [] };
                                        updatedProduct.productionpurchases = updatedProduct.productionpurchases
                                            ? updatedProduct.productionpurchases
                                            : { objects: [] };
                                        //END: For offline Product Creation
                                        updatedProduct.active = true;
                                        //This is where we will deal with the cert creations
                                        $q.all(certPromisesCreate(certifications.objects, updatedProduct)).then(
                                            certs => {
                                                updatedProduct.certifications = {
                                                    objects: certifications.objects.map((cert, index) =>
                                                        _.extend(cert, certs[index])
                                                    )
                                                };
                                                $scope.assessment.products.objects.push(updatedProduct);
                                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                                $uibModalInstance.close(updatedProduct);
                                            }
                                        );
                                    });
                            }
                        }

                        function certPromisesCreate(certifications, product) {
                            return certifications
                                .filter(cert => cert.name && !cert.id)
                                .map(cert => {
                                    var createUrl = apiUrl + '/assessments/certifications/';
                                    cert.product = {
                                        id: product.id,
                                        url: product.url
                                    };
                                    return siScope.create(cert, createUrl);
                                });
                        }

                        function certPromisesPatch(certifications, product) {
                            return certifications
                                .filter(cert => cert.name && cert.id)
                                .map(cert => {
                                    cert.product = {
                                        id: product.id,
                                        url: product.url
                                    };
                                    return siScope.patch(cert);
                                });
                        }

                        function removeCertification(index) {
                            var cert = $scope.product.certifications.objects[index];

                            //Lets check if we have created this first and then we can kill in the backend
                            //otherwise we just chop it from the UI.
                            if (cert.id) {
                                siScope.remove(cert.url);
                            }
                            $scope.product.certifications.objects = $scope.product.certifications.objects.filter(
                                function(cert, certIndex) {
                                    return index !== certIndex;
                                }
                            );
                        }
                    }
                ],
                resolve: {
                    dropdown: function() {
                        return $scope.dropdown;
                    },
                    assessment: function() {
                        return $scope.assessment;
                    },
                    product: function() {
                        return product;
                    },
                    months: function() {
                        return $scope.months;
                    }
                }
            };

            return $uibModal.open(productModalOptions).result.then(updatedProduct => {
                let currentIndex = 0;
                $scope.assessment.products.objects = $scope.assessment.products.objects.map((product, index) => {
                    if (product.url === updatedProduct.url) {
                        _.extend(product, updatedProduct);
                        currentIndex = index;
                    }

                    return product;
                });
                $timeout(() => ($scope.active = currentIndex));
            });
        }

        // helper function for modifying the dropdown object
        function checkForPrimary(dropdown, product) {
            if (product && product.priority === 'Primary') {
                return dropdown;
            } else if ($scope.assessment.products.objects.some(x => x.priority === 'Primary')) {
                let temp = angular.copy(dropdown.priority_options.objects).filter(x => x.name !== 'Primary');
                dropdown.priority_options.objects = temp;
                return dropdown;
            }
            return dropdown;
        }

        /**
         * Remove Product object
         * @param o Product object
         */
        $scope.removeProduct = function(delProduct) {
            return modalFactory.ConfirmModal({
                message: gettext('Remove this product?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $scope.assessment.products.objects = $scope.assessment.products.objects.filter(function(
                                product
                            ) {
                                return product.url !== delProduct.url;
                            });

                            //if we have no products we need to reset the completion check
                            if (!$scope.assessment.products.objects.length) {
                                siScope.patch({
                                    url: $scope.assessment.url,
                                    products_completed: false,
                                    products_no_information_available: false
                                });
                                $rootScope.$broadcast(COMPLETION_CHECK, {
                                    productionForm: {
                                        $invalid: true,
                                        $valid: false
                                    }
                                });
                            }
                            siScope.remove(delProduct.url);
                        }
                    }
                ]
            });
        };

        /**
         * product detail modal configuration
         * @param template template url
         * @param assessment assessment objhect
         * @param product product object for detail
         * @param object optional object to edit
         */
        var productDetailModal = function(template, assessment, product, object) {
            return {
                templateUrl: template,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'product',
                    'object',
                    'dropdown',
                    'months',
                    function($scope, $uibModalInstance, assessment, product, object, dropdown, months) {
                        $scope.dropdown = dropdown;
                        $scope.getDropdown = productType => {
                            const productMap = {
                                'aquaculture essentials': dropdown.aquacultureessentials_options.objects,
                                'crop essentials': dropdown.cropessentials_options.objects,
                                'livestock essentials': dropdown.livestockessentials_options.objects
                            };
                            return productMap[productType.toLowerCase()] || [];
                        };
                        $scope.product = product;
                        $scope.productionUnits = productionUnitList;
                        $scope.object = object ? JSON.parse(JSON.stringify(object)) : { product };
                        $scope.months = months;

                        $scope.save = function(updatedObject) {
                            //updatedObject.name = 'test';
                            if (updatedObject.price) {
                                if (updatedObject.price.currency === '-') {
                                    delete updatedObject.price;
                                }
                            } else if (updatedObject.sales_amount) {
                                if (updatedObject.sales_amount.currency === '-') {
                                    delete updatedObject.sales_amount;
                                }
                            }
                            $uibModalInstance.close(updatedObject);
                        };
                        $scope.cancel = function() {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }
                ],
                resolve: {
                    dropdown: function() {
                        return $scope.dropdown;
                    },
                    assessment: function() {
                        return $scope.assessment;
                    },
                    product: function() {
                        return product;
                    },
                    object: function() {
                        return object;
                    },
                    months: function() {
                        return $scope.months;
                    }
                }
            };
        };

        /**
         * Function to add production figures
         */
        $scope.saveProductionInfo = function(assessment, product, o) {
            return $uibModal
                .open(productDetailModal('assessments/modals/addProductionInfo.html', assessment, product, o))
                .result.then(function(object) {
                    var saveProductionInfo = apiUrl + '/assessments/production_figures/';
                    if (object.id) {
                        siScope.patch(object).then(res => {
                            _.extend(o, res);
                        });
                    } else {
                        siScope.create(object, saveProductionInfo).then(function(productionFigures) {
                            //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                            productionFigures.product =
                                typeof productionFigures.product === 'string'
                                    ? productionFigures.product
                                    : { id: productionFigures.product.id };
                            product.productionfigures.objects.push(productionFigures);
                        });
                    }
                });
        };

        /**
         * Remove ProductionInfo object
         * @param o ProductionInfo object
         */
        $scope.removeProductionInfo = function(product, deleteInfo) {
            product.productionfigures.objects = product.productionfigures.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add production purchase information
         */
        $scope.saveProductionPurchaseInfo = function(assessment, product, o) {
            return $uibModal
                .open(productDetailModal('assessments/modals/addProductionPurchaseInfo.html', assessment, product, o))
                .result.then(function(object) {
                    if (object.id) {
                        siScope.patch(object).then(res => {
                            _.extend(o, res);
                        });
                    } else {
                        var createUrl = apiUrl + '/assessments/production_purchases/';
                        siScope.create(object, createUrl).then(function(productPurchases) {
                            //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                            productPurchases.product =
                                typeof productPurchases.product === 'string'
                                    ? productPurchases.product
                                    : { id: productPurchases.product.id };

                            product.productionpurchases.objects.push(productPurchases);
                        });
                    }
                });
        };

        /**
         * Remove ProductionPurchaseInfo object
         * @param o ProductionPurchaseInfo object
         */
        $scope.removeProductionPurchaseInfo = function(product, deleteInfo) {
            product.productionpurchases.objects = product.productionpurchases.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add production purchase information
         */
        $scope.saveOtherProductionPurchaseInfo = function(assessment, product, o) {
            return $uibModal
                .open(
                    productDetailModal('assessments/modals/addOtherProductionPurchaseInfo.html', assessment, product, o)
                )
                .result.then(function(object) {
                    if (object.id) {
                        siScope.patch(object).then(res => {
                            _.extend(o, res);
                        });
                    } else {
                        var createUrl = apiUrl + '/assessments/other_production_purchases/';
                        siScope.create(object, createUrl).then(function(otherProductPurchases) {
                            //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                            otherProductPurchases.product =
                                typeof otherProductPurchases.product === 'string'
                                    ? otherProductPurchases.product
                                    : {
                                          id: otherProductPurchases.product.id
                                      };
                            product.otherproductionpurchases.objects.push(otherProductPurchases);
                        });
                    }
                });
        };

        /**
         * Remove ProductionPurchaseInfo object
         * @param o ProductionPurchaseInfo object
         */
        $scope.removeOtherProductionPurchaseInfo = function(product, deleteInfo) {
            product.otherproductionpurchases.objects = product.otherproductionpurchases.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add production sales information
         */
        $scope.saveProductionSalesInfo = function(assessment, product, o) {
            return $uibModal
                .open(productDetailModal('assessments/modals/addProductionSalesInfo.html', assessment, product, o))
                .result.then(function(object) {
                    if (object.id) {
                        siScope.patch(object).then(res => {
                            _.extend(o, res);
                        });
                    } else {
                        var createUrl = apiUrl + '/assessments/production_sales/';
                        siScope.create(object, createUrl).then(function(productionSales) {
                            //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                            productionSales.product =
                                typeof productionSales.product === 'string'
                                    ? productionSales.product
                                    : { id: productionSales.product.id };
                            product.productionsales.objects.push(productionSales);
                        });
                    }
                });
        };

        /**
         * Remove ProductionSales object
         * @param o ProductionSales object
         */
        $scope.removeProductionSalesInfo = function(product, deleteInfo) {
            product.productionsales.objects = product.productionsales.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add SoldToFarmers info
         */
        $scope.saveSoldToFarmersInfo = function(assessment, product, o) {
            var inputModal = productDetailModal('assessments/modals/addSoldToFarmersInfo.html', assessment, product, o);

            return $uibModal.open(inputModal).result.then(function(object) {
                if (object.id) {
                    siScope.patch(object).then(res => {
                        _.extend(o, res);
                    });
                } else {
                    var createUrl = apiUrl + '/assessments/sold_to_farmers/';
                    siScope.create(object, createUrl).then(function(soldToFarmers) {
                        //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                        soldToFarmers.product =
                            typeof soldToFarmers.product === 'string'
                                ? soldToFarmers.product
                                : { id: soldToFarmers.product.id };
                        product.sold_to_farmers.objects.push(soldToFarmers);
                    });
                }
            });
        };

        /**
         * Remove SoldToFarmers object
         * @param o SoldToFarmers object
         */
        $scope.removeSoldToFarmersInfo = function(product, deleteInfo) {
            product.sold_to_farmers.objects = product.sold_to_farmers.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add input purchase info
         */
        $scope.saveInputPurchaseInfo = function(assessment, product, o) {
            var inputModal = productDetailModal('assessments/modals/addInputPurchaseInfo.html', assessment, product, o);

            return $uibModal.open(inputModal).result.then(function(object) {
                if (object.price && object.price.currency === '-') {
                    delete object.price;
                }
                if (object.id) {
                    siScope.patch(object).then(res => {
                        _.extend(o, res);
                    });
                } else {
                    var createUrl = apiUrl + '/assessments/input_purchases/';
                    siScope.create(object, createUrl).then(function(inputPurchase) {
                        //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                        inputPurchase.product =
                            typeof inputPurchase.product === 'string'
                                ? inputPurchase.product
                                : { id: inputPurchase.product.id };
                        product.input_purchases.objects.push(inputPurchase);
                    });
                }
            });
        };

        /**
         * Remove InputPurchase object
         * @param o InputPurchase object
         */
        $scope.removeInputPurchaseInfo = function(product, deleteInfo) {
            product.input_purchases.objects = product.input_purchases.objects.filter(function(info) {
                return info.id !== deleteInfo.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        /**
         * Function to add production sales information
         */
        $scope.saveMarginInfo = function(assessment, product, o) {
            return $uibModal
                .open(productDetailModal('assessments/modals/addMarginInfo.html', assessment, product, o))
                .result.then(function(object) {
                    if (object.id) {
                        siScope.patch(object).then(res => {
                            _.extend(o, res);
                        });
                    } else {
                        var createUrl = apiUrl + '/assessments/production_margins/';
                        siScope.create(object, createUrl).then(function(productionMargin) {
                            //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                            productionMargin.product =
                                typeof productionMargin.product === 'string'
                                    ? productionMargin.product
                                    : { id: productionMargin.product.id };
                            product.productionmargins.objects.push(productionMargin);
                        });
                    }
                });
        };

        /**
         * Remove ProductionSales object
         * @param o ProductionSales object
         */
        $scope.removeMarginInfo = function(product, deleteInfo) {
            product.productionmargins.objects = product.productionmargins.objects.filter(function(item) {
                return deleteInfo.id !== item.id;
            });

            return siScope.remove(deleteInfo.url);
        };

        function canConfirm() {
            if ($scope.assessment.production_tab_accepted && $rootScope.isDashboard) {
                return false;
            }

            if ($scope.assessment.production_tab_completed) {
                return true;
            }

            const selected = $scope.assessment.production_and_sales_source_of_data_source;

            const filesValid = !$scope.filesStatus.isRequired || $scope.filesStatus.hasFiles;

            return (
                !$scope.innerProductionForm.$invalid &&
                selected &&
                filesValid &&
                $scope.source_of_data_dropdown.some(option => option.display_name === selected)
            );
        }

        function updateNoInfoReason(assessment, noInfoKey, model) {
            updateForm({ assessment, noInfoKey, model });
        }

        function updateFormElement(object, key, value, form, callback) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            if (callback) {
                callback(value);
            }
            return siFormElement.update(object, key, value, form).then(res => {
                if (res && res.start_date) {
                    res.start_date = moment(res.start_date);
                }
                _.extend(object, res);

                if (key === 'productionsales_no_product_no_info_reason') {
                    var patch = {
                        url: $scope.assessment.url,
                        production_tab_completed: true
                    };
                    return siScope.patch(patch).then(patchRes => {
                        _.extend($scope.assessment, patchRes);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                }

                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabOrganizationController', tabOrganizationController);

    tabOrganizationController.$inject = [
        '$rootScope',
        '$state',
        '$scope',
        '$uibModal',
        'apiUrl',
        'siScope',
        'toastr',
        '$timeout',
        '$log',
        'gettext',
        'fsFactory',
        'siFormElement',
        'moment',
        'gettextCatalog',
        'modalFactory',
        'COMPLETION_CHECK',
        'PARSENAME_REGEX',
        'EVENT_LOADER'
    ];

    function tabOrganizationController(
        $rootScope,
        $state,
        $scope,
        $uibModal,
        apiUrl,
        siScope,
        toastr,
        $timeout,
        $log,
        gettext,
        fsFactory,
        siFormElement,
        moment,
        gettextCatalog,
        modalFactory,
        COMPLETION_CHECK,
        PARSENAME_REGEX,
        EVENT_LOADER
    ) {
        $scope.isGenerated = isGenerated;
        $scope.updateRelatedFarmers = updateRelatedFarmers;
        $scope.updateGlobalRegion = updateGlobalRegion;
        $scope.years = getYears();
        $scope.organizationForm = {};
        $scope.addImage = addImage;
        $scope.editImage = editImage;
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.addRepresentative = addRepresentative;
        $scope.editRepresentative = contact => addRepresentative(contact);
        $scope.deleteRepresentative = deleteRepresentative;
        $scope.updateGovernanceSet = updateGovernanceSet;
        $scope.addGovernanceStructure = addGovernanceStructure;
        $scope.editGovernanceStructure = editGovernanceStructure;
        $scope.addGovernance = addGovernance;
        $scope.removeGovernance = removeGovernance;
        $scope.markGovernanceStructureDone = markGovernanceStructureDone;
        $scope.governanceStructures = {};
        $scope.governanceStructure = {};
        $scope.disableCountry = disableCountry;
        $scope.percentMin = 0;
        $scope.percentMax = 100;
        $scope.inputValidationLimits = $scope.assessment.input_validation_limits;
        let validationWarning = `Whoops! We noticed that the number entered is higher than the typical range we've seen for this field. Could you please verify if it is accurate? If it is correct, you may proceed to the next step.`;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        // Validation observers
        // Not proud of this// Function to handle validation and alert
        function validateAndAlert(newValues, oldValues, limit, validationWarning) {
            if (newValues > limit && oldValues !== newValues) {
                alert(validationWarning);
            }
        }

        // Function to handle group validation and alert
        function validateGroupAndAlert(newValues, oldValues, limit, validationWarning) {
            if (
                newValues[0] + newValues[1] > limit &&
                (oldValues[0] !== newValues[0] || oldValues[1] !== newValues[1])
            ) {
                alert(validationWarning);
            }
        }

        // Individual watches
        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_full_time_employees',
                'assessment.producing_organization_details.number_of_female_full_time_employees'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(element => element.name === 'full_time_employees')
                    .value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);
            }
        );

        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_part_time_employees',
                'assessment.producing_organization_details.number_of_female_part_time_employees'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(element => element.name === 'part_time_employees')
                    .value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);
            }
        );

        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_outgrowers',
                'assessment.producing_organization_details.number_of_female_outgrowers'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(element => element.name === 'number_of_outgrowers')
                    .value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);
            }
        );

        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_active_outgrowers',
                'assessment.producing_organization_details.number_of_female_active_outgrowers'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(
                    element => element.name === 'number_of_active_outgrowers'
                ).value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);

                if (
                    $scope.assessment.producing_organization_details.number_of_active_outgrowers >
                    $scope.assessment.producing_organization_details.number_of_outgrowers
                ) {
                    alert(
                        'The total Number of Active Outgrowers cannot exceed the total number of outgrowers. Please correct the entry.'
                    );
                    $scope.updateFormElement(
                        $scope.assessment.producing_organization_details,
                        'number_of_male_active_outgrowers',
                        null,
                        { organizationForm: $scope.organizationForm }
                    );
                    $scope.updateFormElement(
                        $scope.assessment.producing_organization_details,
                        'number_of_female_active_outgrowers',
                        null,
                        { organizationForm: $scope.organizationForm }
                    );
                }
            }
        );

        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_active_members',
                'assessment.producing_organization_details.number_of_female_active_members'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(element => element.name === 'number_of_active_members')
                    .value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);

                if (
                    $scope.assessment.producing_organization_details.number_of_active_members >
                    $scope.assessment.producing_organization_details.number_of_members
                ) {
                    alert(
                        'The total Number of Active Members cannot exceed the total number of members. Please correct the entry.'
                    );
                    $scope.updateFormElement(
                        $scope.assessment.producing_organization_details,
                        'number_of_male_active_members',
                        null,
                        { organizationForm: $scope.organizationForm }
                    );
                    $scope.updateFormElement(
                        $scope.assessment.producing_organization_details,
                        'number_of_female_active_members',
                        null,
                        { organizationForm: $scope.organizationForm }
                    );
                }
            }
        );

        // Group watches
        $scope.$watchGroup(
            [
                'assessment.producing_organization_details.number_of_male_members',
                'assessment.producing_organization_details.number_of_female_members'
            ],
            (newValues, oldValues) => {
                const limit = $scope.inputValidationLimits.find(element => element.name === 'number_of_members').value;
                validateGroupAndAlert(newValues, oldValues, limit, validationWarning);
            }
        );

        // $scope.$watchGroup(
        //     [
        //         'assessment.producing_organization_details.number_of_male_active_members',
        //         'assessment.producing_organization_details.number_of_female_active_members'
        //     ],
        //     (newValues, oldValues) => {
        //         const limit = $scope.inputValidationLimits.find(element => element.name === 'number_of_active_members')
        //             .value;
        //         validateGroupAndAlert(newValues, oldValues, limit, validationWarning);
        //     }
        // );

        function disableCountry(param) {
            return param || JSON.parse(localStorage.getItem('ngStorage-user')).info.is_assessor;
        }

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.organizationForm.$invalid) return false;
            return !$scope.assessment.tool.type.agent
                ? $scope.assessment.organizational_tab_accepted &&
                      $scope.assignment.submitted_at_least_once &&
                      $scope.assessment.full_completion_check_required
                : $scope.assessment.agent_tab_accepted &&
                      $scope.assignment.submitted_at_least_once &&
                      $scope.assessment.full_completion_check_required;
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        function addImage(image, assessment) {
            const post = Object.assign(image, {
                url: `${apiUrl}/assessments/images/`,
                assessment
            });

            return siScope
                .post(post)
                .then(function() {
                    _.extend($scope.assessment.images.objects, post);
                    $state.reload();
                })
                .catch(err => {
                    toastr.error('Error Saving Image - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function editImage({ url, title }) {
            const patch = {
                url,
                title
            };

            return siScope.patch(patch).then(image => {
                $scope.assessment.images.objects = $scope.assessment.images.objects.map(i => {
                    if (i.url === image.url) {
                        return Object.assign(i, image);
                    }
                    return i;
                });
            });
        }

        function updateGlobalRegion(chosenCountry) {
            return $scope.dropdown.countryOptions
                .filter(function(country) {
                    return country.display_name === chosenCountry;
                })
                .reduce(function(memo, country) {
                    return $scope.dropdown.continentOptions
                        .filter(function(continent) {
                            return continent.url === country.global_region;
                        })
                        .reduce(function(memo, continent) {
                            return continent.name;
                        }, '');
                }, '');
        }

        function isGenerated(email) {
            return /@scopeinsight\.com/g.test(email);
        }

        function updateRelatedFarmers(organization, field) {
            var updated = {};
            updated[field] = organization[field];

            var url = {
                url:
                    apiUrl +
                    '/assessments/producing_organization_detailss/' +
                    $scope.assessment.producing_organization_details.id +
                    '/'
            };
            siScope.patch(url, updated);
        }

        function getYears() {
            const startYear = new Date().getFullYear(),
                years = [];
            for (var i = 1900; i < startYear + 1; i++) {
                years.push({ display_name: String(i), name: i });
            }
            return years.reverse();
        }

        function addRepresentative(contact) {
            var contactModal = $uibModal.open({
                templateUrl: 'assessments/modals/addContact.html',
                controller: addContactCtrl,
                resolve: {
                    customer: () => $scope.assessment.producing_organization.customer,
                    contact: () => contact || { user: {} }
                }
            });

            addContactCtrl.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'customer', 'contact'];

            function addContactCtrl($rootScope, $scope, $uibModalInstance, customer, contact) {
                $scope.customer = customer;
                $scope.contact = contact;
                $scope.save = contact => $uibModalInstance.close(contact);
                $scope.cancel = () => $uibModalInstance.dismiss('cancel');
            }

            contactModal.result.then(contact => {
                if (contact.url) {
                    // PATCH the contact
                    siScope.patch(contact);
                } else {
                    contact.is_contact_person = true;
                    contact.organization = $scope.assessment.producing_organization.customer.url;
                    var representatives_url = {
                        url: apiUrl + '/customers/representatives/'
                    };
                    siScope
                        .post(representatives_url, contact)
                        .then(function(contact) {
                            $scope.assessment.producing_organization.customer.representatives.objects.push(contact);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        })
                        .catch(function(err) {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            toastr.error('Contact Creation Error - ', err.detail);
                        });
                }
            });
        }

        function deleteRepresentative(deleteContact) {
            $scope.assessment.producing_organization.customer.representatives.objects = $scope.assessment.producing_organization.customer.representatives.objects.filter(
                contact => contact.id !== deleteContact.id
            );

            return siScope.remove(deleteContact.url);
        }

        $scope.tabTableRows = [
            {
                label: gettext('Name'),
                key: 'row.name'
            },
            {
                label: gettext('Function'),
                key: 'row.function'
            },
            {
                label: gettext('Gender'),
                key: 'row.male_female'
            },
            {
                label: gettext('Years in Function'),
                key: 'row.years_in_function'
            },
            {
                label: gettext('Years in Organization'),
                key: 'row.years_in_organization'
            },
            {
                label: gettext('Years in Sector'),
                key: 'row.years_in_sector'
            },
            {
                label: gettext('Year of Birth'),
                key: 'row.year_of_birth'
            },
            {
                label: gettext('End of Term'),
                key: 'row.end_of_term'
            },
            {
                label: gettext('Shareholder of Organization'),
                key: 'row.shareholder'
            },
            {
                label: gettext('Qualifications'),
                key: 'row.qualifications'
            }
        ];

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function markGovernanceStructureDone(type) {
            const value = ($scope.assessment[type] = !$scope.assessment[type]);

            siFormElement
                .update($scope.assessment, type, value, { governanceForm: $scope.governanceForm })
                .then(res => _.extend($scope.assessment, res));
        }

        function updateGovernanceSet(index, update) {
            $rootScope.$broadcast(COMPLETION_CHECK.update, { governanceForm: $scope.governanceForm });

            if ($scope.assessment.governance_set.objects[index].id) {
                var patch = _.extend(
                    {
                        url: $scope.assessment.governance_set.objects[index].url,
                        id: $scope.assessment.governance_set.objects[index].id
                    },
                    update
                );

                return siScope
                    .patch(patch)
                    .then(updated => _.extend($scope.assessment.governance_set.objects[index], updated));
            } else {
                update.assessment = $scope.assessment.url;
                update.name = $scope.assessment.governance_set.objects[index].name;
                update.present = $scope.assessment.governance_set.objects[index].present;
                update.number_of_people = $scope.assessment.governance_set.objects[index].number_of_people;
                update.description = $scope.assessment.governance_set.objects[index].description;

                const url = apiUrl + '/assessments/governances/';
                return siScope
                    .create(update, url)
                    .then(updated => _.extend($scope.assessment.governance_set.objects[index], updated));
            }
        }

        function addGovernance(templateUrl) {
            return {
                templateUrl: 'assessments/modals/' + templateUrl,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    function($scope, $uibModalInstance) {
                        $scope.object = {};
                        $scope.add = object => $uibModalInstance.close(object);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ]
            };
        }

        function editGovernance(templateUrl, structure) {
            return {
                templateUrl: 'assessments/modals/' + templateUrl,
                controller: [
                    '$scope',
                    'structure',
                    '$uibModalInstance',
                    function($scope, structure, $uibModalInstance) {
                        $scope.object = structure;
                        $scope.add = object => $uibModalInstance.close(object);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    structure: () => structure
                }
            };
        }

        function removeGovernance(structure) {
            if (structure.auto_created) {
                return;
            }
            modalFactory.ConfirmModal({
                message: gettextCatalog.getString('Remove this Governance structure?'),
                actions: [
                    {
                        label: gettextCatalog.getString('Yes'),
                        fn: function() {
                            $scope.assessment.governance_set.objects.splice(
                                $scope.assessment.governance_set.objects.indexOf(structure),
                                1
                            );

                            return siScope.remove(structure.url);
                        }
                    }
                ]
            });
        }

        function addGovernanceStructure() {
            $uibModal.open(addGovernance('addGovernanceStructure.html')).result.then(object => {
                if (!$scope.assessment.governance_set.objects.auto_created) {
                    $scope.assessment.governance_set.objects.push(object);

                    const obj = { assessment: $scope.assessment.url, name: object.name };

                    siScope
                        .create(obj, $scope.assessment.governance_set.links.create)
                        .then(o => _.extend(object, o))
                        .catch(err => toastr.error('Error Adding new governance - ', err.detail));
                } else {
                    const data = {};
                    data[object.name] = ['Governance is already defined.'];

                    throw {
                        name: 'UserError',
                        error: {
                            data: data
                        },
                        noCurl: true
                    };
                }
            });
        }

        function editGovernanceStructure(structure) {
            $uibModal.open(editGovernance('addGovernanceStructure.html', structure)).result.then(structure => {
                siScope
                    .patch(structure)
                    .then(o => _.extend(structure, o))
                    .catch(err => toastr.error('Error editing governance - ', err.detail));
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabObservationsController', tabObservationsController);

    tabObservationsController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        '$q',
        'apiUrl',
        'siScope',
        'me',
        'modalFactory',
        'gettext',
        'fsFactory',
        'siFormElement',
        'EVENT_LOADER',
        'COMPLETION_CHECK',
        '$timeout',
        '$http',
        'toastr'
    ];

    function tabObservationsController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        $q,
        apiUrl,
        siScope,
        me,
        modalFactory,
        gettext,
        fsFactory,
        siFormElement,
        EVENT_LOADER,
        COMPLETION_CHECK,
        $timeout,
        $http,
        toastr
    ) {
        $scope.observationsForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.generateWithAi = generateWithAi;
        $scope.formatObservation = formatObservation;

        function isFormDisabled() {
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.observationsForm.$invalid) return false;
            return (
                $scope.assessment.observations_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        function generateWithAi(title, section) {
            modalFactory.ConfirmModal({
                message: gettext(
                    '**Important Notice:** Using the AI Observations Autocomplete feature will replace the existing text. If you wish to keep your current text click Cancel to prevent any loss. You can also copy your text and add (paste) to the text box later.'
                ),
                actions: [
                    {
                        label: gettext('OK'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            $http
                                .post(`${apiUrl}/assessments/assessments/ai_observations/`, {
                                    id: $scope.assessment.id,
                                    section: title
                                })
                                .then(res => {
                                    $scope.updateFormElement(
                                        section.unscored_responses.objects[0],
                                        'answer',
                                        $scope.formatObservation(res.data.risks.toString()),
                                        { observationsForm: observationsForm }
                                    );
                                    $scope.updateFormElement(
                                        section.unscored_responses.objects[1],
                                        'answer',
                                        $scope.formatObservation(res.data.strengths.toString()),
                                        { observationsForm: observationsForm }
                                    );
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                })
                                .catch(error => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    toastr.error('AI Services are temporarily unavailable, please try again later');
                                });
                        }
                    }
                ]
            });
        }

        $scope.$watch('assessment', function() {
            if ($scope.assessment) {
                $timeout(function() {
                    $rootScope.$broadcast(COMPLETION_CHECK.update, {
                        observationsForm: angular.copy($scope.observationsForm)
                    });
                });
            }
        });

        $scope.observationsInfoKeys = {
            'Internal Management': 'info_observations_tab_internal_management',
            Operations: 'info_observations_tab_operations',
            Supply: 'info_observations_tab_supply',
            Market: 'info_observations_tab_market',
            Enablers: 'info_observations_tab_enablers',
            'External Risks': 'info_observations_tab_external_risks',
            'Financial Management': 'info_observations_tab_financial_management',
            Sustainability: 'info_observations_tab_sustainability'
        };

        var init = function() {
            if ($scope.assessment.tool.type.is_rapid) {
                $state.go('base.assessments-list', {});
            }
        };

        init();

        function formatObservation(observation) {
            if (!observation) return '';

            const sentences = observation.split('.,').map(s => s.trim());

            const bulleted = sentences.map(s => {
                const sentence = s.endsWith('.') ? s : s + '.';
                return `${sentence}` + '\n';
            });
            var result = bulleted.join('\n');
            return result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('tabFinancialPerformanceController', tabFinancialPerformanceController);

    tabFinancialPerformanceController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'me',
        'modalFactory',
        'gettextCatalog',
        'fsFactory',
        'EVENT_LOADER',
        '$log',
        'siFormElement',
        'toastr'
    ];

    function tabFinancialPerformanceController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        me,
        modalFactory,
        gettextCatalog,
        fsFactory,
        EVENT_LOADER,
        $log,
        siFormElement,
        toastr
    ) {
        $scope.financialPerformanceForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as !== 'financial_specialist' && $rootScope.app !== 'dashboard') return true;
            if ($scope.financialPerformanceForm.$invalid) return false;
            return (
                $scope.assessment.finance_performance_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.markFinancialPerformanceTabDone = type => {
            var value = ($scope.assessment[type] = !$scope.assessment[type]);

            $scope.financialPerformanceForm.hidden.$setValidity('required', value);

            var form = value ? $scope.financialPerformanceForm : { $invalid: true, $valid: false };

            siFormElement
                .update($scope.assessment, type, value, {
                    financialPerformanceForm: form
                })
                .then(res => _.extend($scope.assessment, res));
        };

        $scope.dropdowns = [
            {
                name: gettextCatalog.getString('not available/not good'),
                value: 0
            },
            {
                name: gettextCatalog.getString('potential issue/pay attention'),
                value: 1
            },
            {
                name: gettextCatalog.getString('no issue, is available'),
                value: 2
            }
        ];

        $scope.setYear = yr => {
            if (yr) {
                return yr;
            }
            return (
                $scope.assessment.financial_ratios.objects
                    .map(bs => bs.year)
                    .filter(year => year)
                    .reduce((a, b) => Math.min(a, b)) - 1
            );
        };

        /**
         *
         * @param financial_scores individually
         */
        $scope.saveFinancialPerformance = item => {
            //Lets make sure both trend and volatility are filled in so the backend doesnt cry
            if (item.trend && !item.volatility) {
                return;
            }

            if (!item.trend && item.volatility) {
                return;
            }

            Object.keys(item).forEach(key => {
                item[key] = typeof item[key] === 'undefined' ? null : item[key];
            });

            siScope
                .patch(item)
                .then(update => _.extend(item, update))
                .catch(err => toastr.error('Error updating financial scores - ', err.detail));
        };

        /**
         *
         * @param general_checks
         */
        $scope.saveGeneralChecks = function(item, key) {
            var object = {
                id: item.id
            };

            object[key] = item[key];

            var id = item.id;
            var save_GeneralChecks = {
                url: apiUrl + '/assessments/general_checks/' + id + '/'
            };

            siScope.patch(save_GeneralChecks, object).catch(function(err) {
                toastr.error('Error updating financial scores - ', err.detail);
            });
        };

        $scope.saveRatioScores = function(item) {
            var id = item.id;
            var save_RatioScores = {
                url: apiUrl + '/assessments/ratio_scoress/' + id + '/'
            };

            siScope
                .patch(save_RatioScores, item)
                .then(function(updated) {
                    _.extend(item, updated);
                })
                .catch(function(err) {
                    toastr.error('Error updating financial scores - ', err.detail);
                });
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabFinanceProductController', tabFinanceProductController);

    tabFinanceProductController.$inject = [
        '$rootScope',
        '$scope',
        '$uibModal',
        'modalFactory',
        '$log',
        'apiUrl',
        'siScope',
        'siFormElement',
        'gettext',
        'gettextCatalog',
        'EVENT_LOADER',
        'COMPLETION_CHECK',
        '$timeout',
        'toastr'
    ];

    function tabFinanceProductController(
        $rootScope,
        $scope,
        $uibModal,
        modalFactory,
        $log,
        apiUrl,
        siScope,
        siFormElement,
        gettext,
        gettextCatalog,
        EVENT_LOADER,
        COMPLETION_CHECK,
        $timeout,
        toastr
    ) {
        $scope.financeProductionForm = {};

        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.financeProductionForm.$invalid) return false;
            return (
                $scope.assessment.finance_product_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.agentIncomeRows = [
            { label: gettext('Year'), key: 'row.year' },
            { label: gettext('Price'), key: 'row.income.amount', filter: 'value|currency:row.income.currency+" ":0' }
        ];

        $scope.agentProduceSoldRows = [
            { label: gettext('Year'), key: 'row.year' },
            { label: gettext('Unit'), key: 'row.unit', filter: 'value|capitalize' },
            { label: gettext('Volume'), key: 'row.volume' },
            { label: gettext('Price'), key: 'row.price.amount', filter: 'value|currency:row.price.currency+" ":0' }
        ];

        $scope.markProductsDone = markProductsDone;
        $scope.saveBankAccountLoanHistory = saveBankAccountLoanHistory;
        $scope.saveIncomefromAgent = saveIncomefromAgent;
        $scope.removeIncomefromAgent = removeIncomefromAgent;
        $scope.addProduct = addProduct;
        $scope.saveProduceSold = saveProduceSold;
        $scope.removeProduct = removeProduct;
        $scope.removeProduceSold = removeProduceSold;

        var productionUnitList = [
            gettextCatalog.getString('acre'),
            gettextCatalog.getString('bag 50kg'),
            gettextCatalog.getString('bag 55kg'),
            gettextCatalog.getString('bag 60kg'),
            gettextCatalog.getString('board feet/foot'),
            gettextCatalog.getString('feet'),
            gettextCatalog.getString('gallon'),
            gettextCatalog.getString('hectare'),
            gettextCatalog.getString('inch'),
            gettextCatalog.getString('inch2'),
            gettextCatalog.getString('kg'),
            gettextCatalog.getString('kilometer'),
            gettextCatalog.getString('liter'),
            gettextCatalog.getString('m2'),
            gettextCatalog.getString('m3'),
            gettextCatalog.getString('manzana'),
            gettextCatalog.getString('meter'),
            gettextCatalog.getString('metric tonnes'),
            gettextCatalog.getString('mile'),
            gettextCatalog.getString('minibag'),
            gettextCatalog.getString('ounce (oz)'),
            gettextCatalog.getString('pounds (lbs)'),
            gettextCatalog.getString('quintal'),
            gettextCatalog.getString('tons'),
            gettextCatalog.getString('vara'),
            gettextCatalog.getString('Other'),
            gettextCatalog.getString('N/A'),
            gettextCatalog.getString('NR'),
            gettextCatalog.getString('None')
        ];

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function markProductsDone(type) {
            var value = ($scope.assessment[type] = !$scope.assessment[type]);
            var form = value ? $scope.financeProductionForm : { $invalid: true, $valid: false };
            $scope.financeProductionForm.$setValidity('required', value);

            siFormElement.update($scope.assessment, type, value).then(function(res) {
                _.extend($scope.assessment, res);
            });
        }

        /**
         * Function to save bank account and loan history
         */
        function saveBankAccountLoanHistory(row, form) {
            $rootScope.$broadcast(COMPLETION_CHECK.update, form);

            if (!$scope.assessment.agent_bank_account_loan_history) {
                $scope.assessment.agent_bank_account_loan_history = {
                    url: apiUrl + '/assessments/agentbankaccountloanhistories/'
                };
            }

            var object = {
                assessment: $scope.assessment.url
            };

            if ($scope.assessment.agent_bank_account_loan_history.id) {
                return siScope
                    .patch($scope.assessment.agent_bank_account_loan_history, _.extend(object, row))
                    .then(function(res) {
                        _.extend($scope.assessment.agent_bank_account_loan_history, res);
                    });
            } else {
                return siScope
                    .post($scope.assessment.agent_bank_account_loan_history, _.extend(object, row))
                    .then(function(res) {
                        _.extend($scope.assessment.agent_bank_account_loan_history, res);
                    });
            }
        }

        /**
         *
         * Function to open and handle modal for adding income from agent
         */
        function getIncomefromAgent(template, assessment, object) {
            return {
                templateUrl: template,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'object',
                    'dropdown',
                    function($scope, $uibModalInstance, assessment, object, dropdown) {
                        $scope.assessment = assessment;
                        $scope.object = object ? object : { assessment: assessment.url };
                        $scope.dropdown = dropdown;
                        $scope.IncomefromAgentForm = {};
                        $scope.save = () => $timeout(() => $uibModalInstance.close($scope.object), 500);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    assessment: () => $scope.assessment,
                    object: () => object,
                    dropdown: () => $scope.dropdown
                }
            };
        }

        /**
         * Function for saving income from agent
         */
        function saveIncomefromAgent(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            var modal = getIncomefromAgent('assessments/modals/addIncomeFromAgent.html', assessment, object);

            return $uibModal.open(modal).result.then(
                object => {
                    object.income =
                        _.isEmpty(object.income) || object.income.currency === '-'
                            ? { currency: 'EUR', amount: 0 }
                            : object.income;

                    if (!$scope.assessment.agent_income) {
                        $scope.assessment.agent_income = { url: apiUrl + '/assessments/agentincome/' };
                    }

                    if (object.id) {
                        return siScope.patch(object).then(update => _.extend(object, update));
                    } else {
                        siScope
                            .create(object, $scope.assessment.agent_income.links.create)
                            .then(res => {
                                _.extend(object, res);
                                $scope.assessment.agent_income.objects.push(object);
                            })
                            .catch(err => toastr.error('Error saving income data - ', err.detail));
                    }
                },
                () => ($scope.assessment = cleanCopy)
            );
        }

        /**
         * Remove income from agent
         * TODO: refactor this like above
         */
        function removeIncomefromAgent(row) {
            $scope.assessment.agent_income.objects = $scope.assessment.agent_income.objects.filter(
                object => object.id !== row.id
            );
            const url = apiUrl + '/assessments/agentincome/' + row.id + '/';
            return siScope.remove(url);
        }

        /**
         * Product Modal
         * @param template
         * @param assessment
         * @returns {{templateUrl: *, controller: *[], resolve: {dropdown: resolve.dropdown, assessment: resolve.assessment, product: resolve.product}}}
         */
        function productModal(template) {
            return {
                templateUrl: template,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'dropdown',
                    function($scope, $uibModalInstance, assessment, dropdown) {
                        $scope.assessment = assessment;
                        $scope.dropdown = dropdown;
                        $scope.productionUnits = productionUnitList;
                        $scope.save = () => $timeout(() => $uibModalInstance.close($scope.product), 500);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    dropdown: () => $scope.dropdown,
                    assessment: () => $scope.assessment
                }
            };
        }

        /**
         * Produce Sold Modal
         * @param template
         * @param assessment
         * @param product
         * @returns {{templateUrl: *, controller: *[], resolve: {dropdown: resolve.dropdown, assessment: resolve.assessment, product: resolve.product}}}
         */
        function produceSoldModal(template, assessment, product, row) {
            return {
                templateUrl: template,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'product',
                    'row',
                    'dropdown',
                    function($scope, $uibModalInstance, assessment, product, row, dropdown) {
                        $scope.assessment = assessment;
                        $scope.dropdown = dropdown;
                        $scope.productionUnits = productionUnitList;
                        $scope.product = product;
                        $scope.row = row || {};

                        $scope.save = function() {
                            $timeout(function() {
                                $uibModalInstance.close($scope.row);
                            }, 500);
                        };
                        $scope.cancel = function() {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }
                ],
                resolve: {
                    dropdown: function() {
                        return $scope.dropdown;
                    },
                    assessment: function() {
                        return $scope.assessment;
                    },
                    product: function() {
                        return product;
                    },
                    row: function() {
                        return row;
                    }
                }
            };
        }

        /**
         * Function to add production sales information
         */
        function addProduct(assessment) {
            var cleanCopy = angular.copy(assessment);
            var produceSoldObject;

            return $uibModal
                .open(productModal('assessments/modals/addProductAgent.html', assessment))
                .result.then(function(productDetails) {
                    if (!$scope.assessment.products) {
                        $scope.assessment.products = { links: { create: apiUrl + '/assessments/products/' } };
                    }

                    var create = {
                        name: productDetails.name,
                        assessment: $scope.assessment.url
                    };

                    return siScope
                        .create(create, $scope.assessment.products.links.create)
                        .then(function(createdProduct) {
                            createdProduct.display_name = createdProduct.display_name
                                ? createdProduct.display_name
                                : createdProduct.name;
                            createdProduct.productionsales = {
                                links: { create: apiUrl + '/assessments/production_sales/' },
                                objects: []
                            };

                            $scope.assessment.products.objects.push(createdProduct);
                            return createdProduct;
                        });
                })
                .catch(function(err) {
                    toastr.error('Save Produce Sold Error - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.assessment = cleanCopy;
                });
        }

        /**
         * Function to add production sales information
         */
        function saveProduceSold(assessment, product, row) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(produceSoldModal('assessments/modals/addProduceSoldAgent.html', assessment, product, row))
                .result.then(function(productionsalesObject) {
                    if (productionsalesObject.id) {
                        siScope.patch(productionsalesObject).then(function(productionSales) {
                            _.extend(productionsalesObject, productionSales);
                        });
                    } else {
                        productionsalesObject.product = product;
                        return siScope
                            .create(productionsalesObject, product.productionsales.links.create)
                            .then(function(productionSales) {
                                product.productionsales.objects.push(productionSales);
                                //This weird code is for dealing with offline creation of a product that doesnt exist yet.
                                productionSales.product =
                                    typeof productionSales.product === 'string'
                                        ? productionSales.product
                                        : { id: productionSales.product.id };
                            });
                    }
                })
                .catch(function(err) {
                    toastr.error('Save Produce Sold Error - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.assessment = cleanCopy;
                });
        }

        /**
         * Remove Product object
         * @param o Product object
         */
        function removeProduct(delProduct) {
            return modalFactory.ConfirmModal({
                message: gettext('Remove this product?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $scope.assessment.products.objects = $scope.assessment.products.objects.filter(function(
                                product
                            ) {
                                return product.url !== delProduct.url;
                            });

                            //if we have no products we need to reset the completion check
                            if (!$scope.assessment.products.objects.length) {
                                siScope.patch({
                                    url: $scope.assessment.url,
                                    products_completed: false,
                                    products_no_information_available: false
                                });
                                $rootScope.$broadcast(COMPLETION_CHECK, {
                                    financeProductionForm: { $invalid: true, $valid: false }
                                });
                            }

                            siScope.remove(delProduct.url);
                        }
                    }
                ]
            });
        }

        /**
         * Remove ProductionSales object
         * @param o ProductionSales object
         */
        function removeProduceSold(product, row) {
            return siScope.remove(row.url).then(function(res) {
                product.productionsales.objects = _.filter(product.productionsales.objects, function(item) {
                    return item.url !== row.url;
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('tabFinanceOverviewController', tabFinanceOverviewController);

    tabFinanceOverviewController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'siFormElement',
        'me',
        '$log',
        '$q',
        'modalFactory',
        'gettextCatalog',
        'gettext',
        'fsFactory',
        'extendDisplayValues',
        'EVENT_LOADER',
        'COMPLETION_CHECK',
        '$timeout',
        'offline',
        'toastr'
    ];

    function tabFinanceOverviewController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        siFormElement,
        me,
        $log,
        $q,
        modalFactory,
        gettextCatalog,
        gettext,
        fsFactory,
        extendDisplayValues,
        EVENT_LOADER,
        COMPLETION_CHECK,
        $timeout,
        offline,
        toastr
    ) {
        $scope.financeForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.basicProfitLossExists = basicProfitLossExists;
        $scope.markFinancialStrategyFieldsDone = markFinancialStrategyFieldsDone;
        $scope.markFinancialStrategyDone = markFinancialStrategyDone;
        $scope.saveBasicProfitLoss = saveBasicProfitLoss;
        $scope.createBasicProfitLoss = createBasicProfitLoss;
        $scope.reloadTables = true;
        $scope.dropdown = $scope.dropdowns.sourceOfDataOptions;

        $scope.inputValidationLimits = $scope.assessment.input_validation_limits.filter(
            element => element.name === 'net_profit_usd' || element.name === 'turnover_usd'
        );

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        const unbindDisableAssessment = $rootScope.$on('dissable-assessment', function() {
            $scope.reloadTables = !$scope.reloadTables;
            $scope.$evalAsync(function() {
                $scope.reloadTables = !$scope.reloadTables;
                $scope.displayErrorMsg = false;
            });
        });

        $scope.$on('$destroy', function() {
            unbindDisableAssessment();
        });

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.financeForm.$invalid) return false;
            return (
                $scope.assessment.finance_overview_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        function basicProfitLossExists() {
            return (
                $scope.assessment.basicprofitlossstatements &&
                $scope.assessment.basicprofitlossstatements.objects &&
                $scope.assessment.basicprofitlossstatements.objects.length !== 0
            );
        }

        function markFinancialStrategyFieldsDone(type, model) {
            const value = ($scope.assessment.financial_strategy[type] = !$scope.assessment.financial_strategy[type]);
            $scope.assessment.financial_strategy[model] = null;

            const noInfoAvailable = value => {
                if (value !== $scope.assessment.financial_strategy_no_information_available) {
                    $scope.assessment.financial_strategy_no_information_available = value;
                    siFormElement.update($scope.assessment, 'financial_strategy_no_information_available', value, {
                        financeForm: $scope.financeForm
                    });
                }
            };

            [
                'business_surplus_no_information_available',
                'grant_no_information_available',
                'loan_no_information_available',
                'member_fee_capital_no_information_available',
                'other_no_information_available',
                'pre_finance_no_information_available'
            ]
                .filter(item => !$scope.assessment.financial_strategy[item])
                .reduce(() => [() => noInfoAvailable(false)], [() => noInfoAvailable(true)])
                .map(flipMain => flipMain());

            siFormElement
                .update($scope.assessment.financial_strategy, type, value, {
                    financeForm: $scope.financeForm
                })
                .then(res => !offline.isOffline && _.extend($scope.assessment, res));

            siFormElement
                .update($scope.assessment.financial_strategy, model, null, {
                    financeForm: $scope.financeForm
                })
                .then(res => !offline.isOffline && _.extend($scope.assessment, res));
        }

        function markFinancialStrategyDone(type, other) {
            $scope.assessment[type] = !$scope.assessment[type];
            const value = $scope.assessment[type];

            if (type === 'financial_strategy_completed' && $scope.assessment.financial_strategy_completed) {
                $scope.assessment.financial_strategy_no_information_available = false;
            }
            if (
                type === 'financial_strategy_no_information_available' &&
                $scope.assessment.financial_strategy_no_information_available
            ) {
                $scope.assessment.financial_strategy_completed = false;
            }
            $scope.updateFormElement($scope.assessment, other, false, {
                financeForm: $scope.financeForm
            });

            if (type === 'financial_strategy_no_information_available') {
                ['business_surplus', 'grant', 'loan', 'member_fee_capital', 'other', 'pre_finance']
                    .map(item => {
                        $scope.assessment.financial_strategy[item] = null;
                        return `${item}_no_information_available`;
                    })
                    .map(item => {
                        $scope.assessment.financial_strategy[item] = value;
                        return siFormElement.update($scope.assessment.financial_strategy, item, value, {
                            financeForm: $scope.financeForm
                        });
                    });
            }
            // Reset no info reason when resetting No Info
            if (!value && $scope.assessment.financial_strategy_no_info_reason !== '') {
                $scope.updateFormElement($scope.assessment, 'financial_strategy_no_info_reason', '', {
                    financeForm: $scope.financeForm
                });
            }

            siFormElement
                .update($scope.assessment, type, value, { financeForm: $scope.financeForm })
                .then(res => _.extend($scope.assessment, res));
        }
        function createBasicProfitLoss(assessment, object) {
            const newBasicProfitLossSheet = {
                assessment: assessment.url,
                assessor: assessment.assessmentassignments.objects[0].assessor,
                year: object.year,
                net_profit: {},
                operational_costs: {},
                turnover: {},
                cost_of_sales: {}
            };

            return siScope
                .create(newBasicProfitLossSheet, assessment.basicprofitlossstatements.links.create)
                .then(basicProfitLossStatement => {
                    $scope.assessment.basicprofitlossstatements.objects.push(basicProfitLossStatement);
                    return basicProfitLossStatement;
                })
                .catch(err => toastr.error('Basic PL Sheet Creation Error - ', err.detail));
        }

        function saveBasicProfitLoss(assessment, object, key) {
            const patch = {
                url: object.url,
                id: object.id
            };
            patch[key] = object[key];

            assessment.basicprofitlossstatements.objects.forEach(element => {
                if (element.net_profit_usd > $scope.inputValidationLimits[0].value) {
                    alert(
                        "Whoops! We noticed that the number entered is higher than the typical range we've seen for this field. Could you please verify if it is accurate? If it is correct, you may proceed to the next step."
                    );
                }
                if (element.turnover_usd > $scope.inputValidationLimits[1].value) {
                    alert(
                        "Whoops! We noticed that the number entered is higher than the typical range we've seen for this field. Could you please verify if it is accurate? If it is correct, you may proceed to the next step."
                    );
                }
            });

            if (key === 'net_profit') {
                if (+patch[key].amount > +object.turnover.amount - +object.cost_of_sales.amount) {
                    alert('Net Profit cannot exceed Gross Profit. Please correct the entry.');
                    patch[key].amount = null;
                    object[key].amount = null;
                }
            }

            if (key !== 'year') {
                patch[key].currency = patch[key].currency ? assessment.currency : patch[key].currency;
            }

            if (patch[key].amount === '') {
                patch[key].amount = null;
            }

            if (patch.url) {
                return siScope.patch(patch).then(res => res);
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabFinanceHistoryController', tabFinanceHistoryController);

    tabFinanceHistoryController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'siFormElement',
        'me',
        '$log',
        '$q',
        'modalFactory',
        'gettextCatalog',
        'gettext',
        'fsFactory',
        'extendDisplayValues',
        'EVENT_LOADER',
        'COMPLETION_CHECK',
        '$timeout'
    ];

    function tabFinanceHistoryController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        siFormElement,
        me,
        $log,
        $q,
        modalFactory,
        gettextCatalog,
        gettext,
        fsFactory,
        extendDisplayValues,
        EVENT_LOADER,
        COMPLETION_CHECK,
        $timeout
    ) {
        $scope.financeForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.reloadTables = true;
        $scope.inputValidationLimits = $scope.assessment.input_validation_limits.filter(e => {
            return e.name == 'loan_amount_usd';
        });
        const unbindDisableAssessment = $rootScope.$on('dissable-assessment', function() {
            $scope.reloadTables = !$scope.reloadTables;
            $scope.$evalAsync(function() {
                $scope.reloadTables = !$scope.reloadTables;
                $scope.displayErrorMsg = false;
            });
        });

        $scope.$on('$destroy', function() {
            unbindDisableAssessment();
        });

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.financeForm.$invalid) return false;
            return (
                $scope.assessment.finance_history_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.bankAccountsRows = [
            {
                label: gettext('Bank'),
                key: 'row.bank'
            },
            {
                label: gettext('Type'),
                key: 'row.display_bank_type'
            },
            {
                label: gettext('Active since'),
                key: 'row.active_since'
            },
            {
                label: gettext('Current balance'),
                key: 'row.current_balance.amount',
                filter: 'value|currency:row.current_balance.currency+" ":0'
            },
            {
                label: gettext("Shareholder's Equity"),
                key: 'row.shareholders_equity.amount',
                showIf: 'assessment.tool.type.basic_sme',
                filter: 'value|currency:row.shareholders_equity.currency+" ":0'
            }
        ];

        $scope.collateralAssetsRows = [
            {
                label: gettext('Type'),
                key: 'row.display_type'
            },
            {
                label: gettext('Description'),
                key: 'row.description'
            },
            {
                label: gettext('Age'),
                key: 'row.age_in_years',
                valueIfNot: 'N.A.'
            },
            {
                label: gettext('Estimated Value'),
                key: 'row.estimated_value.amount',
                filter: 'value|currency:row.estimated_value.currency+" ":0'
            },
            {
                label: gettext('External valuation done?'),
                key: 'row.external_valuation_done'
            },
            {
                label: gettext('External valuation by'),
                key: 'row.external_valuation_by',
                valueIfNot: 'N.A.'
            },
            {
                label: gettext('Valuation proof available?'),
                key: 'row.valuation_proof_available',
                valueMap: { true: 'Yes', false: 'No' }
            }
        ];

        $scope.loanHistoriesRows = [
            {
                label: gettext('Loan amount'),
                key: 'row.amount.amount',
                filter: 'value|currency:row.amount.currency+" ":0'
            },
            {
                label: gettext('Financier'),
                showIf: '!assessment.is_new_basic_tool',
                key: 'row.financier'
            },
            {
                label: gettext('Type of financier'),
                showIf: 'assessment.is_new_basic_tool',
                key: 'row.financier'
            },
            {
                label: gettext('Name of financier'),
                showIf: 'assessment.is_new_basic_tool',
                key: 'row.financier_name'
            },
            {
                label: gettext('Start date'),
                key: "row.start_date|date:'dd-MM-yyyy'",
                filter: 'value|date'
            },
            {
                label: gettext('End date'),
                key: "row.end_date|date:'dd-MM-yyyy'",
                showIf: '!assessment.is_new_basic_tool',
                filter: 'value|date'
            },
            {
                label: gettext('Duration (months)'),
                key: 'row.duration',
                showIf: 'assessment.is_new_basic_tool'
            },
            {
                label: gettext('Annual interest rate'),
                key: 'row.annual_interest_rate',
                filter: 'value|number'
            },
            {
                label: gettext('Repayment status'),
                key: 'row.display_repayment_status'
            },
            {
                label: gettext('Purpose'),
                key: 'row.display_purpose'
            },
            {
                label: gettext('Comment'),
                key: 'row.comment'
            }
        ];

        $scope.preFinanceHistoriesRows = [
            {
                label: gettext('Amount'),
                key: 'row.amount.amount',
                filter: 'value|currency:row.amount.currency+" ":0'
            },
            {
                label: gettext('Type of provider'),
                key: 'row.display_provider'
            },
            {
                label: gettext('Name of provider'),
                key: 'row.provider_name'
            },
            {
                label: gettext('Start date'),
                key: "row.start_date|date:'dd-MM-yyyy'",
                filter: 'value|date'
            },
            {
                label: gettext('Duration (months)'),
                key: 'row.duration',
                filter: 'value|number'
            },
            {
                label: gettext('Annual interest rate'),
                key: 'row.annual_interest_rate',
                filter: 'value|number'
            },
            {
                label: gettext('Repayment modality'),
                key: 'row.display_repayment_modality'
            },
            {
                label: gettext('Purpose'),
                key: 'row.display_purpose'
            },
            {
                label: gettext('Comment'),
                key: 'row.comment'
            }
        ];

        $scope.grantHistoriesRows = [
            {
                label: gettext('Grant amount'),
                key: 'row.amount.amount',
                filter: 'value|currency:row.amount.currency+" ":0'
            },
            {
                label: gettext('In cash / in kind'),
                key: 'row.display_in_cash_in_kind'
            },
            {
                label: gettext('Name of funder'),
                key: 'row.funder'
            },
            {
                label: gettext('Funder type'),
                key: 'row.display_funder_type'
            },
            {
                label: gettext('Start date'),
                key: "row.start_date|date:'dd-MM-yyyy'",
                filter: 'value|date'
            },
            {
                label: gettext('Purpose'),
                key: 'row.purpose'
            },
            {
                label: gettext('Comment'),
                key: 'row.comment'
            }
        ];

        $scope.insurancesRows = [
            {
                label: gettext('Type'),
                key: 'row.type'
            },
            {
                label: gettext('Company'),
                key: 'row.insurance_company'
            },
            {
                label: gettext('Policy effective date'),
                key: "row.policy_effictive_date|date:'dd-MM-yyyy'",
                filter: 'value|date'
            },
            {
                label: gettext('Policy end date'),
                key: "row.policy_end_date|date:'dd-MM-yyyy'",
                filter: 'value|date'
            },
            {
                label: gettext('Indemnity limit'),
                key: 'row.indemnity_limit.amount',
                filter: 'value|currency:row.indemnity_limit.currency+" ":0'
            },
            {
                label: gettext('Comment'),
                key: 'row.comment'
            }
        ];

        $scope.saveBankAccount = saveBankAccount;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         *
         * Function to open and handle modal for adding financial information
         */
        function getFinancialModal(templateUrl, assessment, object) {
            return {
                templateUrl,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    'object',
                    'dropdown',
                    function($scope, $uibModalInstance, assessment, object, dropdown) {
                        $scope.assessment = assessment;
                        $scope.object = object ? object : { assessment: assessment.url };
                        $scope.dropdown = dropdown;
                        $scope.external_valuation_done = [
                            gettextCatalog.getString('Yes'),
                            gettextCatalog.getString('No'),
                            gettextCatalog.getString('In process')
                        ];
                        $scope.save = () => {
                            if ($scope.object.estimated_value && $scope.object.estimated_value.currency === '-') {
                                delete $scope.object.estimated_value;
                            }
                            $timeout(() => {
                                $uibModalInstance.close($scope.object);
                            }, 500);
                        };
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    assessment: () => Object.assign({}, $scope.assessment),
                    object: () => Object.assign({}, object),
                    dropdown: () => $scope.dropdown
                }
            };
        }

        /**
         * Function to open and handle modal for adding bank account
         */
        function saveBankAccount(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(getFinancialModal('assessments/modals/addBankAccount.html', assessment, object))
                .result.then(
                    function(object) {
                        object.assessment = assessment.url;
                        if (object.current_balance && object.current_balance.currency === '-') {
                            delete object.current_balance;
                        }
                        if (object.id) {
                            siScope.patch(object).then(function(res) {
                                extendDisplayValues.extend(object, res);
                                $scope.assessment.bank_accounts.objects = $scope.assessment.bank_accounts.objects.map(
                                    o => {
                                        if (o.id === object.id) {
                                            _.extend(o, object);
                                        }
                                        return o;
                                    }
                                );
                            });
                        } else {
                            object.display_bank_type = object.bank_type;
                            $scope.assessment.bank_accounts.objects.push(object);
                            siScope
                                .create(object, $scope.assessment.bank_accounts.links.create)
                                .then(function(newAcct) {
                                    _.extend(object, newAcct);
                                });
                        }
                    },
                    function() {
                        $scope.assessment = cleanCopy;
                    }
                );
        }

        /**
         * Remove BankAccount object
         * @param o BankAccount object
         */
        $scope.removeBankAccount = function(delAcct) {
            $scope.assessment.bank_accounts.objects = $scope.assessment.bank_accounts.objects.filter(function(acct) {
                return acct.id !== delAcct.id;
            });

            return siScope.remove(delAcct.url);
        };

        /**
         * Function to open and handle modal for adding collateral asset
         */
        $scope.saveCollateralAsset = function(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            var modal = getFinancialModal('assessments/modals/addCollateralAsset.html', assessment, object);

            return $uibModal.open(modal).result.then(
                function(object) {
                    object.assessment = assessment.url;
                    if (object.id) {
                        siScope.patch(object).then(function(res) {
                            extendDisplayValues.extend(object, res);
                            $scope.assessment.collateral_assets.objects = $scope.assessment.collateral_assets.objects.map(
                                o => {
                                    if (o.id === object.id) {
                                        _.extend(o, object);
                                    }
                                    return o;
                                }
                            );
                        });
                    } else {
                        object.display_type = object.type;
                        siScope.create(object, $scope.assessment.collateral_assets.links.create).then(function(o) {
                            $scope.assessment.collateral_assets.objects.push(o);
                        });
                    }
                },
                function() {
                    $scope.assessment = cleanCopy;
                }
            );
        };

        /**
         * Remove CollateralAsset object
         * @param o CollateralAsset object
         */
        $scope.removeCollateralAsset = function(delCol) {
            $scope.assessment.collateral_assets.objects = $scope.assessment.collateral_assets.objects.filter(function(
                coll
            ) {
                return coll.id !== delCol.id;
            });

            return siScope.remove(delCol.url);
        };

        /**
         * Function to open and handle modal for adding loan history
         */
        $scope.saveLoanHistory = function(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(getFinancialModal('assessments/modals/addLoanHistory.html', assessment, object))
                .result.then(
                    function(object) {
                        object.assessment = assessment.url;
                        if (object.amount && object.amount.currency === '-') {
                            delete object.amount;
                        }
                        if (object.id) {
                            siScope.patch(object).then(function(res) {
                                extendDisplayValues.extend(object, res);
                                $scope.assessment.loan_histories.objects = $scope.assessment.loan_histories.objects.map(
                                    o => {
                                        if (o.id === object.id) {
                                            _.extend(o, object);
                                        }
                                        return o;
                                    }
                                );
                            });
                        } else {
                            object.display_financier = object.financier;
                            object.display_repayment_status = object.repayment_status;
                            object.display_purpose = object.purpose;
                            siScope.create(object, $scope.assessment.loan_histories.links.create).then(function(o) {
                                $scope.assessment.loan_histories.objects.push(o);
                                if (o.amount_usd > $scope.inputValidationLimits[0].value) {
                                    alert(
                                        `Whoops! We noticed that the number entered is higher than the typical range we've seen for this field. Could you please verify if it is accurate? If it is correct, you may proceed to the next step.`
                                    );
                                }
                            });
                        }
                    },
                    function() {
                        $scope.assessment = cleanCopy;
                    }
                );
        };

        /**
         * Remove LoanHistory object
         * @param o LoanHistory object
         */
        $scope.removeLoanHistory = function(deleteHistory) {
            $scope.assessment.loan_histories.objects = $scope.assessment.loan_histories.objects.filter(function(
                history
            ) {
                return history.id !== deleteHistory.id;
            });

            return siScope.remove(deleteHistory.url);
        };

        /**
         * Function to open and handle modal for adding PreFinanceHistory
         */
        $scope.savePreFinanceHistory = function(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(getFinancialModal('assessments/modals/addPreFinanceHistory.html', assessment, object))
                .result.then(
                    function(object) {
                        object.assessment = assessment.url;
                        if (object.amount && object.amount.currency === '-') {
                            delete object.amount;
                        }
                        if (object.id) {
                            siScope.patch(object).then(function(res) {
                                extendDisplayValues.extend(object, res);
                                $scope.assessment.pre_finance_histories.objects = $scope.assessment.pre_finance_histories.objects.map(
                                    o => {
                                        if (o.id === object.id) {
                                            _.extend(o, object);
                                        }
                                        return o;
                                    }
                                );
                            });
                        } else {
                            object.display_financier = object.financier;
                            object.display_repayment_status = object.repayment_status;
                            object.display_purpose = object.purpose;
                            siScope
                                .create(object, $scope.assessment.pre_finance_histories.links.create)
                                .then(function(o) {
                                    $scope.assessment.pre_finance_histories.objects.push(o);
                                });
                        }
                    },
                    function() {
                        $scope.assessment = cleanCopy;
                    }
                );
        };

        /**
         * Remove PreFinanceHistory object
         * @param o PreFinanceHistory object
         */
        $scope.removePreFinanceHistory = function(deleteHistory) {
            $scope.assessment.pre_finance_histories.objects = $scope.assessment.pre_finance_histories.objects.filter(
                function(history) {
                    return history.id !== deleteHistory.id;
                }
            );

            return siScope.remove(deleteHistory.url);
        };

        /**
         * Function to open and handle modal for adding grant history
         */
        $scope.saveGrantHistory = function(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(getFinancialModal('assessments/modals/addGrantHistory.html', assessment, object))
                .result.then(
                    function(object) {
                        object.assessment = assessment.url;
                        if (object.amount && object.amount.currency === '-') {
                            delete object.amount;
                        }
                        if (object.id) {
                            siScope.patch(object).then(function(res) {
                                extendDisplayValues.extend(object, res);
                                $scope.assessment.grant_histories.objects = $scope.assessment.grant_histories.objects.map(
                                    o => {
                                        if (o.id === object.id) {
                                            _.extend(o, object);
                                        }
                                        return o;
                                    }
                                );
                            });
                        } else {
                            object.display_in_cash_in_kind = object.in_cash_in_kind;
                            object.display_funder_type = object.funder_type;
                            siScope.create(object, $scope.assessment.grant_histories.links.create).then(function(o) {
                                $scope.assessment.grant_histories.objects.push(o);
                            });
                        }
                    },
                    function() {
                        $scope.assessment = cleanCopy;
                    }
                );
        };

        /**
         * Remove GrantHistory object
         * @param o GrantHistory object
         */
        $scope.removeGrantHistory = function(deleteHistory) {
            $scope.assessment.grant_histories.objects = $scope.assessment.grant_histories.objects.filter(function(
                history
            ) {
                return history.id !== deleteHistory.id;
            });

            return siScope.remove(deleteHistory.url);
        };

        /**
         * Function to open and handle modal for adding loan history
         */
        $scope.saveInsurance = function(assessment, object) {
            var cleanCopy = JSON.parse(JSON.stringify(assessment));
            return $uibModal
                .open(getFinancialModal('assessments/modals/addInsurance.html', assessment, object))
                .result.then(
                    function(object) {
                        object.assessment = assessment.url;
                        if (object.indemnity_limit && object.indemnity_limit.currency === '-') {
                            delete object.indemnity_limit;
                        }
                        if (object.id) {
                            siScope.patch(object).then(function(res) {
                                extendDisplayValues.extend(object, res);
                                $scope.assessment.insurances.objects = $scope.assessment.insurances.objects.map(o => {
                                    if (o.id === object.id) {
                                        _.extend(o, object);
                                    }
                                    return o;
                                });
                            });
                        } else {
                            siScope.create(object, $scope.assessment.insurances.links.create).then(function(o) {
                                $scope.assessment.insurances.objects.push(o);
                            });
                        }
                    },
                    function() {
                        $scope.assessment = cleanCopy;
                    }
                );
        };

        /**
         * Remove Insurance object
         * @param o Insurance object
         */
        $scope.removeInsurance = function(deleteInsurance) {
            $scope.assessment.insurances.objects = $scope.assessment.insurances.objects.filter(function(insurance) {
                return insurance.id !== deleteInsurance.id;
            });

            return siScope.remove(deleteInsurance.url);
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabDocumentationController', tabDocumentationController);

    tabDocumentationController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'me',
        'modalFactory',
        'gettext',
        'fsFactory',
        'COMPLETION_CHECK'
    ];

    function tabDocumentationController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        me,
        modalFactory,
        gettext,
        fsFactory,
        COMPLETION_CHECK
    ) {
        $scope.documentationForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.documentationForm.$invalid) return false;
            return (
                $scope.assessment.documents_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        /**
         * Function to save document availability comments
         */
        $scope.saveDocumentAvailabilityComment = (comment, { url }) => siScope.patch({ comment, url });

        /**
         * Function to save document availability choice
         */
        $scope.saveDocumentAvailability = (update, document, form) => {
            $rootScope.$broadcast(COMPLETION_CHECK.update, form);
            return siScope
                .patch({ available: update.available, url: update.url })
                .then(updatedDocument => _.extend(document, updatedDocument));
        };

        /**
         * Function to remove a document
         * @param document
         */
        $scope.removeDocumentAvailabilityResponseDocument = (document, documents) => {
            documents.splice(document, 1);
            return siScope.remove(document.url);
        };

        $scope.documentAvailabilityResponseDocumentCreate = obj => {
            const createUrl = $scope.assessment.document_availability_responses.objects
                .filter(doc => doc.url === obj.documentavailabilityresponse)
                .reduce((memo, doc) => doc.documents.links.create, '');

            return siScope.create(obj, createUrl).then(res => {
                $scope.assessment.document_availability_responses.objects.forEach(doc => {
                    if (doc.url === obj.documentavailabilityresponse) {
                        doc.documents.objects.push(res);
                    }
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabCashflowController', tabCashflowController);

    tabCashflowController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        '$log',
        'apiUrl',
        'siScope',
        'siFormElement'
    ];

    function tabCashflowController($rootScope, $scope, $state, $uibModal, $log, apiUrl, siScope, siFormElement) {
        $scope.filesStatus = {
            hasFiles: false,
            isRequired: false
        };
        $scope.saveCashflowStatements = saveCashflowStatements;
        $scope.saveCashFlowStatement = saveCashFlowStatement;
        $scope.cashflowForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.canConfirm = canConfirm;
        $scope.dropdown = $scope.dropdowns.sourceOfDataOptions;

        $scope.handleFilesChange = function(files, fileType, isRequired, hasFiles) {
            $scope.filesStatus = {
                hasFiles: hasFiles,
                isRequired: isRequired
            };

            console.log('Production files changed:', $scope.filesStatus);
        };

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as !== 'financial_specialist' && $rootScope.app !== 'dashboard') return true;
            if ($scope.cashflowForm.$invalid) return false;
            return (
                $scope.assessment.cash_flow_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.markCashFlowTabDone = type => {
            var value = ($scope.assessment[type] = !$scope.assessment[type]);

            $scope.assessment.cashflow_source_of_data_selected =
                $scope.assessment.cashflow_source_of_data_source.length > 0 ? true : false;

            $scope.cashflowForm.hidden.$setValidity('required', value);

            var form = value ? $scope.cashflowForm : { $invalid: true, $valid: false };

            var patch = {
                url: $scope.assessment.url,
                id: $scope.assessment.id,
                [type]: value,
                cashflow_source_of_data_source: $scope.assessment.cashflow_source_of_data_source,
                cashflow_source_of_data_selected: $scope.assessment.cashflow_source_of_data_selected
            };

            siScope.patch(patch).then(res => {
                _.extend($scope.assessment, res);
                // show toast here if needed
            });
        };

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                    Method Declarations
             ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * Save all changes to the cashflow statements tab.
         * @param: objects: current list of cashflow statements
         */
        function saveCashflowStatements(objects) {
            _.each(objects, function(obj) {
                siScope.patch(obj).then(function(o) {
                    _.extend(obj, o);
                });
            });
        }

        function saveCashFlowStatement(statement, value, name) {
            var id = statement.id;

            var save_CF = {
                url: apiUrl + '/assessments/cash_flow_statements/' + id + '/'
            };

            var patch = {
                id: statement.id
            };

            statement[name] = statement[name] ? statement[name] : { currency: $scope.assessment.currency, amount: 0 };
            statement[name] = typeof value === 'undefined' ? null : _.extend(statement[name], { amount: value });
            patch[name] = statement[name];

            siScope.patch(save_CF, patch).then(function(updatedStatement) {
                _.extend(statement, updatedStatement);
            });
        }

        function canConfirm() {
            if ($rootScope.app === 'dashboard' && $scope.assessment.cash_flow_tab_accepted) return false;
            if ($scope.assessment.cash_flow_tab_completed) return true;

            const selected = $scope.assessment.cashflow_source_of_data_source;

            const filesValid = !$scope.filesStatus.isRequired || $scope.filesStatus.hasFiles;

            return selected && filesValid && $scope.dropdown.some(option => option.display_name === selected);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabBalancesheetController', tabBalancesheetController);

    tabBalancesheetController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        'apiUrl',
        'siScope',
        'me',
        '$log',
        'modalFactory',
        'EVENT_LOADER',
        '$q',
        'siFormElement',
        'toastr'
    ];

    function tabBalancesheetController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        apiUrl,
        siScope,
        me,
        $log,
        modalFactory,
        EVENT_LOADER,
        $q,
        siFormElement,
        toastr
    ) {
        $scope.filesStatus = {
            hasFiles: false,
            isRequired: false
        };
        $scope.balanceSheetForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.canConfirm = canConfirm;
        $scope.dropdown = $scope.dropdowns.sourceOfDataOptions;

        $scope.handleFilesChange = function(files, fileType, isRequired, hasFiles) {
            $scope.filesStatus = {
                hasFiles: hasFiles,
                isRequired: isRequired
            };

            console.log('Production files changed:', $scope.filesStatus);
        };

        function isFormDisabled() {
            // if ($scope.assignment.ax_can_view_assignment_read_only) return true;
            if ($scope.assignment.assigned_as !== 'financial_specialist' && $rootScope.app !== 'dashboard') return true;
            if ($scope.balanceSheetForm.$invalid) return false;
            return (
                $scope.assessment.balance_sheet_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        $scope.markBalanceSheetTabDone = type => {
            var value = ($scope.assessment[type] = !$scope.assessment[type]);

            $scope.assessment.balance_sheet_source_of_data_selected =
                $scope.assessment.balance_sheet_source_of_data_source.length > 0 ? true : false;

            $scope.balanceSheetForm.hidden.$setValidity('required', value);

            var form = value ? $scope.balanceSheetForm : { $invalid: true, $valid: false };

            var patch = {
                url: $scope.assessment.url,
                id: $scope.assessment.id,
                [type]: value,
                balance_sheet_source_of_data_source: $scope.assessment.balance_sheet_source_of_data_source,
                balance_sheet_source_of_data_selected: $scope.assessment.balance_sheet_source_of_data_selected
            };

            siScope.patch(patch).then(res => {
                _.extend($scope.assessment, res);
                // show toast here if needed
            });
        };

        $scope.setYear = yr => {
            if (yr) {
                return yr;
            }
            return (
                $scope.assessment.balancesheets.objects
                    .map(bs => bs.year)
                    .filter(year => year)
                    .reduce((a, b) => Math.min(a, b)) - 1
            );
        };
        $scope.addValues = values => values.reduce((memo, value) => memo + parseInt(value, 10), 0);
        $scope.subtractValues = values => parseInt(values[0], 10) - parseInt(values[1], 10);
        /**
         * Save all changes to the Balancesheets tab.
         * @param: objects: current list of Balancesheets
         */
        $scope.saveBalanceSheets = function(balanceSheets) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            var promises = balanceSheets.map(bsYear => {
                return siScope.patch(bsYear).then(updatedYear => {
                    _.extend(bsYear, updatedYear);
                    updateBsYears(updatedYear.next);
                });
            });

            $q.all(promises)
                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide))
                .catch(err => {
                    toastr.error('Error Saving - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        $scope.saveBalanceSheet = function(balanceSheet, value, name) {
            const patch = {
                url: balanceSheet.url
            };

            patch[name] = balanceSheet[name] || {
                currency: $scope.assessment.currency,
                amount: 0
            };
            patch[name] = typeof value === 'undefined' ? null : _.extend(patch[name], { amount: value });

            siScope.patch(patch).then(updatedYear => {
                _.extend(balanceSheet, updatedYear);
                updateBsYears(updatedYear.next, getNextYear(balanceSheet.year));
            });
        };

        function getNextYear(currentYear) {
            return $scope.assessment.balancesheets.objects
                .filter(bs => bs.year > currentYear)
                .map(bs => bs.year)
                .reduce((a, b) => Math.min(a, b), Date(), currentYear);
        }

        function updateBsYears(updatedYear, nextYr) {
            if (!updatedYear) {
                return;
            }

            $scope.assessment.balancesheets.objects = $scope.assessment.balancesheets.objects.map(bsYear => {
                if (bsYear.year === nextYr) {
                    bsYear = _.extend(bsYear, updatedYear);
                }

                return bsYear;
            });
        }

        function canConfirm() {
            if ($rootScope.app === 'dashboard' && $scope.assessment.balance_sheet_tab_accepted) return false;
            if ($scope.assessment.balance_sheet_tab_completed) return true;

            const selected = $scope.assessment.balance_sheet_source_of_data_source;

            const filesValid = !$scope.filesStatus.isRequired || $scope.filesStatus.hasFiles;

            return selected && filesValid && $scope.dropdown.some(option => option.display_name === selected);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').controller('tabAssessmentController', tabAssessmentController);

    tabAssessmentController.$inject = [
        '$rootScope',
        '$scope',
        'siScope',
        '$uibModal',
        'PARSENAME_REGEX',
        'apiUrl',
        'toastr',
        'EVENT_LOADER'
    ];

    function tabAssessmentController(
        $rootScope,
        $scope,
        siScope,
        $uibModal,
        PARSENAME_REGEX,
        apiUrl,
        toastr,
        EVENT_LOADER
    ) {
        $scope.assessmentForm = {};
        $scope.isFormDisabled = isFormDisabled;
        $scope.canViewOnly = canViewOnly;
        $scope.addRepresentative = addRepresentative;
        $scope.editRepresentative = contact => addRepresentative(contact);
        $scope.deleteRepresentative = deleteRepresentative;

        function isFormDisabled() {
            if ($scope.assignment.assigned_as === 'financial_specialist') return true;
            if ($scope.assessmentForm.$invalid) return false;
            return (
                $scope.assessment.assessment_tab_accepted &&
                $scope.assignment.submitted_at_least_once &&
                $scope.assessment.full_completion_check_required
            );
        }

        function canViewOnly() {
            if ($scope.assignment.ax_can_view_assignment_read_only) return true;
        }

        function addRepresentative(contact) {
            var contactModal = $uibModal.open({
                templateUrl: 'assessments/modals/addRepresentative.html',
                controller: addContactCtrl,
                resolve: {
                    customer: () => $scope.assessment.producing_organization.customer,
                    contact: () => contact || { user: {} }
                }
            });

            addContactCtrl.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'customer', 'contact'];

            function addContactCtrl($rootScope, $scope, $uibModalInstance, customer, contact) {
                $scope.customer = customer;
                $scope.contact = contact;
                $scope.save = contact => $uibModalInstance.close(contact);
                $scope.cancel = () => $uibModalInstance.dismiss('cancel');
            }

            contactModal.result.then(contact => {
                if (contact.url) {
                    // PATCH the contact and keep local list immediately in sync (including offline mode)
                    const reps = $scope.assessment.producing_organization.customer.representatives.objects || [];
                    const existing = reps.find(rep => rep.id === contact.id || rep.url === contact.url);
                    if (existing) {
                        angular.extend(existing, contact);
                    }

                    siScope.patch(contact).then(updatedContact => {
                        if (existing && updatedContact) {
                            angular.extend(existing, updatedContact);
                        }
                    });
                } else {
                    contact.is_contact_person = false;
                    contact.organization = $scope.assessment.producing_organization.customer.url;
                    var representatives_url = {
                        url: apiUrl + '/customers/representatives/'
                    };
                    siScope
                        .post(representatives_url, contact)
                        .then(function(contact) {
                            $scope.assessment.producing_organization.customer.representatives.objects.push(contact);
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                        })
                        .catch(function(err) {
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            toastr.error('Contact Creation Error - ', err.detail);
                        });
                }
            });
        }

        function deleteRepresentative(deleteContact) {
            $scope.assessment.producing_organization.customer.representatives.objects = $scope.assessment.producing_organization.customer.representatives.objects.filter(
                contact => contact.id !== deleteContact.id
            );

            return siScope.remove(deleteContact.url);
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.utils', []);

}());

(function() {
    'use strict';

    angular.module('scope.commons.utils').factory('requestHelpers', requestHelpers);

    function requestHelpers() {
        var service = this;

        service.isHtml = isHtml;
        service.isAuth = isAuth;
        service.isResetPassword = isResetPassword;
        service.isTranslation = isTranslation;
        service.getUrlWithParams = getUrlWithParams;
        service.isResource = isResource;
        service.isValidToken = isValidToken;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isHtml(url) {
            return url.indexOf('.html') > -1;
        }

        function isAuth(url) {
            return url.indexOf('api-token-auth') > -1 || url.indexOf('api/token') > -1;
        }

        function isResetPassword(url) {
            return (
                url.indexOf('request_password_reset') > -1 ||
                url.indexOf('apply_password_reset') > -1 ||
                url.indexOf('check_reset_token') > -1
            );
        }

        function isTranslation(url) {
            return /translations\/[a-z]+\.json/.test(url);
        }

        function getUrlWithParams(url, params) {
            var queryParams = _.reduce(
                params,
                function(memo, value, param) {
                    if (Array.isArray(value)) {
                        _.each(value, function(val) {
                            memo.push(param + '=' + val);
                        });
                    } else {
                        memo.push(param + '=' + value);
                    }

                    return memo;
                },
                []
            ).join('&');

            return url + (queryParams ? '?' + queryParams : '');
        }

        function isResource(url) {
            return !(isHtml(url) || isAuth(url) || isResetPassword(url) || isTranslation(url));
        }

        function isValidToken(token) {
            return !!token && !!token.token && !!token.decoded;
            // we don't check expiry client side due to offline capabilities. Tokens might expire, but server
            // side deals with that. Also, when expired token occurs, a new token must be fetched from the server.
            // && token.decoded.exp * 1000 > Date.now();
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.utils')
        .factory('replaceDeep', replaceDeep);

    function replaceDeep() {

        var service = this;

        service.replace = replace;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/


        function replace(items, oldValue, newvalue) {

            function tryReplace(val, key, obj) {
                if (oldValue[key] === val) {
                    return (obj[key] = newvalue);
                }
            }

            function traverse(value) {
                _.each(value, function (val, key, obj) {

                    if (key === '$promise' || _.isFunction(val)) {
                        return true;
                    } //If we are replacing object that have been modified by the $resource service - $promise object creates a circular ref.

                    if (val && !_.isObject(val) && !_.isArray(val)) {
                        return tryReplace(val, key, obj);
                    } else if (val && (_.isObject(val) || _.isArray(val))) {
                        return traverse(val);
                    }

                });

            }

            return traverse(items);

        };

    }

}());

(function () {

    'use strict';

    angular.module('scope.commons.utils')
        .factory('jsonToBlobSerializer', jsonToBlobSerializer);

    function jsonToBlobSerializer() {

        var service = this;

        service.serialize = serialize;
        service.deserialize = deserialize;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function serialize(value) {

            var json;

            try {
                json = JSON.parse(value);
            } catch (e) {
                json = JSON.stringify(value);
            }

            return new Blob([json]);
        }

        function deserialize(value) {

            try {
                JSON.parse(value);
            } catch (e) {
                return value;
            }

            return angular.fromJson(value);
        }


    }

}());

(function () {

    'use strict';

    angular.module('scope.commons.utils')
        .factory('siHelpers', siHelpers);

    function siHelpers() {

        var service = this;

        service.uid = uid;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function uid(length) {
            length = length || 7;
            return Math.random().toString(35).substr(2, length);
        }

    }

}());

(function() {
    'use strict';

    angular.module('scope.commons.utils').factory('extendDisplayValues', extendDisplayValues);

    function extendDisplayValues() {
        var service = this;

        service.extend = extend;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function extend(oldObj, newObj) {
            _.extend(oldObj, newObj);

            // HOTFIX: update display_... values in offline mode
            // TODO: Not very elegant, better solution welcome
            var displayPrefix = 'display_';
            _.each(newObj, function(val, key) {
                if (key.indexOf(displayPrefix) === -1) return true;

                var originalKey = key.substring(displayPrefix.length);
                var originalVal = oldObj[originalKey];
                if (val !== oldObj[originalKey]) {
                    oldObj[key] = originalVal;
                }
            });
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.translations', []);

}());

(function() {
    'use strict';

    angular.module('scope.commons.translations').factory('translationFactory', translationFactory);

    translationFactory.$inject = [
        '$timeout',
        'gettextCatalog',
        '$rootScope',
        'me',
        '$log',
        'amMoment',
        'siScope',
        'apiUrl',
        '$localStorage',
        '$state',
        'EVENT_LOADER'
    ];

    function translationFactory(
        $timeout,
        gettextCatalog,
        $rootScope,
        me,
        $log,
        amMoment,
        siScope,
        apiUrl,
        $localStorage,
        $state,
        EVENT_LOADER
    ) {
        var service = {};

        if (!_.isEmpty($localStorage.user.data)) {
            me.getMe().then(function(user) {
                $rootScope.me = user || $localStorage.user.info || {};
                $localStorage.user.info = $rootScope.me;
                if (!$rootScope.isOffline && user && user.language) {
                    amMoment.changeLocale(user.language);
                    gettextCatalog.setCurrentLanguage(user.language);
                    return user.language === 'en'
                        ? true
                        : gettextCatalog.loadRemote('translations/' + user.language + '.json');
                }
            });
        }

        service.languages = languages();
        service.setLanguage = setLanguage;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function languages() {
            return {
                en: 'English',
                fr: 'Français',
                es: 'Español'
            };
        }

        function setLanguage(me, language) {
            if (language !== me.language) {
                $rootScope.$broadcast(EVENT_LOADER.show);

                var url = {
                    url: apiUrl + '/accounts/users/' + me.id + '/'
                };
                siScope
                    .patch(url, { language: language })
                    .then(function(userLanguage) {
                        _.extend($rootScope.me, userLanguage);
                        $rootScope.me.language = language;
                        $localStorage.user.info = $rootScope.me;
                        amMoment.changeLocale(language);
                        gettextCatalog.setCurrentLanguage(language);
                        return language === 'en'
                            ? true
                            : gettextCatalog.loadRemote('translations/' + language + '.json');
                    })
                    .then(function() {
                        $timeout(function() {
                            $('*[chosen]').trigger('chosen:updated');
                            $rootScope.$broadcast(EVENT_LOADER.hide);
                            $state.go($state.current, {}, { reload: true });
                        }, 1000);
                    })
                    .catch(function(err) {
                        toastr.error('Error Updating User Language - ', err);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').factory('validationRulesService', validationRulesService);

    validationRulesService.$inject = [];

    function validationRulesService() {
        var service = {
            isOptionDisabled: isOptionDisabled,
            isQuestionLocked: isQuestionLocked,
            getDisabledOptions: getDisabledOptions
        };

        return service;

        function isOptionDisabled(option) {
            return option.is_disabled || false;
        }

        function isQuestionLocked(subquestion) {
            return subquestion.is_locked || false;
        }

        function getDisabledOptions(subquestion) {
            if (!subquestion.options || !subquestion.options.objects) {
                return [];
            }

            return subquestion.options.objects
                .filter(function(option) {
                    return option.is_disabled;
                })
                .map(function(option) {
                    return option.id;
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services', ['ui.router', 'restangular', 'scope.constants']);
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siTranslations', siTranslations);

    siTranslations.$inject = [
        '$uibModal',
        '$rootScope',
        'fsFactory',
        'gettext',
        'gettextCatalog',
        'translationFactory'
    ];

    function siTranslations($uibModal, $rootScope, fsFactory, gettext, gettextCatalog, translationFactory) {
        var service = this;

        service.changeLanguage = changeLanguage;
        service.setLanguage = setLanguage;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setLanguage(language) {
            if (['en', 'fr', 'es'].indexOf(language) !== -1) {
                gettextCatalog.setCurrentLanguage(language);
                return language === 'en' ? true : gettextCatalog.loadRemote('translations/' + language + '.json');
            }
            gettextCatalog.setCurrentLanguage('en');
            return true;
        }

        function changeLanguage(languageCode) {
            if ($rootScope.isOffline) {
                return $uibModal.open({
                    templateUrl: 'modals/templates/offline/offline-modal.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.ok = function() {
                                $uibModalInstance.dismiss();
                            };
                        }
                    ]
                });
            }

            $uibModal
                .open({
                    templateUrl: 'modals/templates/confirm-modal/confirmModalView.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.$uibModalInstance = $uibModalInstance;
                            $scope.message = gettext(
                                'You are about to change languages. This will delete all cached objects and pending requests on your local machine. Are you sure you would like to continue?'
                            );

                            $scope.actions = [
                                {
                                    isDefault: false,
                                    fn: true,
                                    label: gettext('Yes')
                                },
                                {
                                    isDefault: true,
                                    fn: false,
                                    label: gettext('Cancel')
                                }
                            ];
                            $scope.applyAction = function(fn) {
                                if (fn) {
                                    return $uibModalInstance.close();
                                }
                                return $uibModalInstance.dismiss();
                            };
                        }
                    ]
                })
                .result.then(function() {
                    fsFactory.clearFS();
                    translationFactory.setLanguage($rootScope.me, languageCode);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siTooltype', siTooltype);

    siTooltype.$inject = ['TOOL_TYPES'];

    function siTooltype(TOOL_TYPES) {
        const service = this;
        let TOOL_TYPE = '';

        service.setTooltype = setTooltype;
        service.isTabShown = tab => TOOL_TYPES[TOOL_TYPE][tab];
        service.isSectionShown = isSectionShown;
        service.isProTool = isProTool;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setTooltype(tooltype = {}) {
            //console.log("---DEBUG---")
            //console.log(tooltype)
            TOOL_TYPE = getTooltype(tooltype);
        }

        function getTooltype(tooltype = {}) {
            return ['pro', 'basic', 'basic_sme', 'pro_sme', 'agent', 'input_retailer', 'is_rapid', 'is_sacco']
                .filter(type => tooltype[type])
                .reduce((memo, type) => type, '');
        }

        function isSectionShown(section) {
            const tool = Object.assign({}, TOOL_TYPES[TOOL_TYPE]);
            return section.split('.').reduce((tool, key) => {
                return tool[key] || false;
            }, tool);
        }

        function isProTool(assessment) {
            return ['SCOPE Pro', 'SCOPE Pro SME'].indexOf(assessment.tool_type) !== -1;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siServiceWorker', serviceWorker);

    serviceWorker.$inject = ['$rootScope', '$log', '$timeout', 'SW', 'toastr', 'fsFactory'];

    function serviceWorker($rootScope, $log, $timeout, SW, toastr, fsFactory) {
        var service = this;

        service.startWorking = startWorking;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function startWorking() {
            if ('serviceWorker' in navigator) {
                // Your service-worker.js *must* be located at the top-level directory relative to your site.
                // It won't be able to control pages unless it's located at the same level or higher than them.
                // *Don't* register service worker file in, e.g., a scripts/ sub-directory!
                // See https://github.com/slightlyoff/ServiceWorker/issues/468
                navigator.serviceWorker
                    .register('service-worker.js')
                    .then(function(registration) {
                        console.log('The service worker has been registered ', registration);

                        if (navigator.online) {
                            toastr.warning('Offline Mode', 'Application Status');
                        }

                        // updatefound is fired if service-worker.js changes.
                        registration.onupdatefound = function() {
                            // The updatefound event implies that reg.installing is set; see
                            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
                            var installingWorker = registration.installing;

                            installingWorker.onstatechange = function() {
                                switch (installingWorker.state) {
                                    case 'installed':
                                        if (navigator.serviceWorker.controller) {
                                            // At this point, the old content will have been purged and the fresh content will
                                            // have been added to the cache.
                                            // It's the perfect time to display a "New content is available; please refresh."
                                            // message in the page's interface.
                                            toastr.info(
                                                'Application has been updated, please refresh this page for the most recent version'
                                            );
                                            $timeout(function() {
                                                fsFactory.clearFS().then(function() {
                                                    location.reload();
                                                });
                                            });
                                            caches.delete('scope-dynamic').then(function() {
                                                console.log('Killed the dynamic cache!');
                                            });
                                            console.log('New or updated content is available.');
                                        } else {
                                            // At this point, everything has been precached.
                                            // It's the perfect time to display a "Content is cached for offline use." message.
                                            toastr.success('Content is cached for offline use.', 'Application Status');
                                            console.log('Content is now available offline!');
                                        }
                                        break;

                                    case 'redundant':
                                        $log.error('The installing service worker became redundant.');
                                        break;
                                }
                            };
                        };
                    })
                    .catch(function(e) {
                        $log.error('Error during service worker registration:', e);
                    });

                //Add Controller Change Event Listener
                navigator.serviceWorker.addEventListener('controllerchange', function(event) {
                    console.log(
                        '[controllerchange] A "controllerchange" event has happened within navigator.serviceWorker: ',
                        event
                    );

                    navigator.serviceWorker.controller.addEventListener('statechange', function() {
                        console.log('[controllerchange][statechange] A "statechange" has occured: ', this.state);

                        if (this.state === 'activated') {
                            console.log('[controllerchange][activated] Ready for Offline!');
                        }
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siFilters', siFilters);

    siFilters.$inject = ['$location', '$state'];

    function siFilters($location, $state) {
        const service = this;

        service.createFilters = createFilters;
        service.removeKeys = removeKeys;
        service.search = search;
        service.removeFilter = removeFilter;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function removeKeys(searchParams, removeKeys) {
            if (_.isArray(removeKeys)) {
                removeKeys.forEach(removeKey => delete searchParams[removeKey]);
            } else {
                Object.keys(removeKeys).forEach(key => {
                    if (_.isArray(searchParams[key])) {
                        searchParams[key] = searchParams[key].filter(param => param !== removeKeys[key]);
                        if (!searchParams[key].length) {
                            delete searchParams[key];
                        }
                    } else if (_.isString(searchParams[key])) {
                        if (searchParams[key] === removeKeys[key]) {
                            delete searchParams[key];
                        }
                    }
                });
            }
            return searchParams;
        }

        function search(currentParams, searchParams, displayFilter, searchFct) {
            if (displayFilter != null) {
                if (displayFilter.removeKeys != null) {
                    if (displayFilter.removeKeys[0] != null) {
                        if (displayFilter.removeKeys[0] == 'page_size') {
                            searchParams.page_size = searchParams.page_size[0];
                        }
                    }
                }
            }

            if (displayFilter) {
                return $location.search(_.extend($location.search(), searchParams, { page: 1 }));
            }

            return searchFct(_.extend(currentParams, searchParams));
        }

        function removeFilter(removeFilter) {
            let searchParams = removeKeys($location.search(), removeFilter.removeKeys);
            $location.search(_.extend(searchParams, { page: 1 }));
        }

        function resetFilteredParams(params) {
            if (params.page === 1) {
                delete params.page;
                $state.go($state.current.name, { page: 1 });
            }

            return params;
        }

        /**
         * We iterate over the filters that are passed in matching up param keys with the filters inner object (1),
         * Then we remove any values from the filter that remain null - meaning they are not being passed in as a query param (2)
         * Finally we transform this into the data structure that the filter display component expects. (3)
         * @param filters
         * Example of the data structure we are iterating over aka - @filter
         *  [
         *      {'Project Owner': {'customer_name': null}},
         *      {'Project Start Date Range': {min_start_date: null, max_start_date: null}},
         *      {'Project End Date Range': {min_deadline: null, max_deadline: null}},
         *      {'# of Assessments': {min_number_of_assessments: null, max_number_of_assessments: null}},
         *      {'% Level of Completion': {'min_completion_percentage': null, 'max_completion_percentage': null}}
         *  ]
         * @param params
         *  Example of the params - these are the query params - @oaram
         *  {
         *      customer_name: 'Test Owner'
         *  }
         * @returns {*}
         *   Example of the data structure we are creating - @return array
         *  [{
         *      name: 'Project Owner,
         *      value: 'Test Owner',
         *      removeKeys: ['customer_name']
         *  }]
         */
        function createFilters(filters, params) {
            params = resetFilteredParams(params);

            return (
                filters
                    //1) We map over the filters here and replace their null values with the searchParams values passed in
                    .map(filter => {
                        let filterNames = filter[Object.keys(filter)[0]];

                        Object.keys(filterNames).forEach(
                            filterName => (filterNames[filterName] = params[filterName] ? params[filterName] : null)
                        );

                        return filter;
                    })
                    //2) If the the values still contain null we assume they were not part of the searchParams passed in and we remove them from the array
                    .filter(filter => {
                        let filterNames = filter[Object.keys(filter)[0]];

                        return Object.keys(filterNames)
                            .filter(filterName => filterNames[filterName])
                            .reduce(() => true, false);
                    })
                    //3) We remove any null values that might be left over
                    .map(filter => {
                        let filterNames = filter[Object.keys(filter)[0]];

                        Object.keys(filterNames)
                            .filter(filterName => !filterNames[filterName])
                            .forEach(filter => delete filterNames[filter]);

                        return filter;
                    })
                    //4) Finally we transform the left over items into the form that the search filter choices component expects
                    .map(filter => {
                        let filterDisplay = {
                            name: '',
                            value: '',
                            removeKeys: [],
                            optionsKey: ''
                        };

                        let name = Object.keys(filter)[0];

                        filterDisplay.name = name;
                        filterDisplay.optionsKey = filter.optionsKey;

                        filterDisplay.value = Object.keys(filter[filterDisplay.name])
                            .map(key => filter[filterDisplay.name][key])
                            .reduce((memo, value) => {
                                if (memo === null) {
                                    memo = 0;
                                }
                                if (memo.toString().match(/\w{4}-\w{2}-\w{2}/)) {
                                    memo = moment(new Date(memo)).format('DD-MM-YYYY');
                                    value = moment(new Date(value)).format('DD-MM-YYYY');
                                }

                                return memo + ' - ' + value;
                            });

                        filterDisplay.removeKeys = Object.keys(filter[filterDisplay.name]).map(key => key);

                        return filterDisplay;
                    })
            );
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siScope', Scope);

    Scope.$inject = ['$http', '$q'];

    function Scope($http, $q) {
        const service = this;

        service.create = create;
        service.post = post;
        service.getList = getList;
        service.getItem = getItem;
        service.patch = patch;
        service.remove = remove;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isUrlString(url, data) {
            if (typeof url !== 'string') {
                throw {
                    name: 'UserError',
                    error: { data },
                    noCurl: true
                };
            }
            return true;
        }

        function getList(url, config) {
            return $http.get(url, config).then((res = { data: {} }) => {
                if (res.status >= 400) {
                    return $q.reject(res.data);
                }
                return res.data;
            });
        }

        function getItem(url, config) {
            return $http.get(url, config).then((res = { data: {} }) => {
                if (res.status >= 400) {
                    return $q.reject(res.data);
                }
                return res.data;
            });
        }

        function patch(item, data, config) {
            if (!data) {
                data = item;
            }

            config = config ? config : {};

            if (isUrlString(item.url, data)) {
                console.log(item);
                console.log(data);
                console.log(config);
                return $http.patch(item.url, data, config).then(res => {
                    console.log('DEBUG');
                    console.log('DEBUG');
                    console.log('DEBUG');
                    if (res.status >= 400) {
                        return $q.reject(res.data);
                    }
                    return res.data;
                });
            } else {
                return $q.reject('Url Error');
            }
        }

        function post(item, data, config) {
            if (!data) {
                data = item;
            }

            config = config ? config : {};
            if (isUrlString(item.url, data)) {
                return $http.post(item.url, data, config).then(res => {
                    if (res.status >= 400) {
                        return $q.reject(res.data);
                    }
                    return res.data;
                });
            } else {
                return $q.reject('Url Error');
            }
        }

        function create(item, url, config) {
            if (!url && typeof url !== 'string') {
                throw Error('create function needs a place to create aka a url');
            }
            item.url = url;
            return post(item, false, config);
        }

        function remove(url, config) {
            config = config ? config : {};
            url = typeof url === 'object' ? url.url : url;

            if (isUrlString(url, { isDeleteReq: true })) {
                return $http.delete(url, config).then(res => {
                    if (res.status >= 400) {
                        return $q.reject(res.data);
                    }
                    return res.data;
                });
            } else {
                return $q.reject('Url Error');
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siReports', siReports);

    siReports.$inject = ['Restangular', '$q', '$state', 'siScope', 'apiUrl'];

    function siReports(Restangular, $q, $state, siScope, apiUrl) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var reports = configuredRestangular.all('reports');

        service.reports = reports;
        service.getReports = getReports;
        service.send_report = send_report;
        service.getReport_Id = getReport_Id;
        service.getReports_Website = getReports_Website;
        service.generateDraftReport = generateDraftReport;
        service.patchReport = patchReport;
        service.generate_ta_build_report_pdf = generate_ta_build_report_pdf;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        //More generic use case for simple calls that we might need to build off the url
        function reports(params) {
            return configuredRestangular.service('reports').customGET('', params);
        }

        function getReports(params) {
            params = params ? params : {};
            return reports.one('reports').customGET('', params);
        }

        function getReports_Website(params) {
            params = params ? params : {};
            return reports.one('search').customGET('', params);
        }

        function getReport_Id(params) {
            params = params ? params : {};
            return reports.one('reports/' + $state.params.id).customGET('', params);
        }

        function send_report(id) {
            return configuredRestangular.service('reports/reports/' + id + '/send_report/');
        }

        function generateDraftReport(assessment) {
            let report = {
                url: apiUrl + '/reports/reports/',
                assessment: assessment.url
            };

            if (assessment.tool_name == 'SCOPE Rapid') {
                report.status = 'final';
            }

            return siScope.post(report);
        }

        function patchReport(assessment, report_url) {
            const report = {
                url: report_url,
                assessment: assessment.url
            };

            return siScope.patch(report);
        }

        function generate_ta_build_report_pdf(params) {
            return reports
                .one('reports/' + $state.params.id)
                .withHttpConfig({
                    responseType: 'arraybuffer'
                })
                .customPOST(params, 'generate_ta_build_report_pdf');
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siProducts', siProducts);

    siProducts.$inject = ['Restangular', '$q', '$http', '$state', 'apiUrl', 'siScope'];

    function siProducts(Restangular, $q, $http, $state, apiUrl, siScope) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var products = configuredRestangular.all('products');

        service.subQuestions = subQuestions;
        service.subQuestionOptions = subQuestionOptions;
        service.getDropDowns = getDropDowns;
        service.product = product();
        service.getGlobalOptionsConfig = getGlobalOptionsConfig;
        service.getToolOptions = getToolOptions;
        service.getTools = getTools;
        service.getScales = getScales;
        service.getServiceOptions = getServiceOptions;
        service.getLegalStatusOptions = getLegalStatusOptions;
        service.getProductTypeOptions = getProductTypeOptions;
        service.updateProductTypes = updateProductTypes;
        service.getNestedToolOptions = getNestedToolOptions;
        service.duplicateTool = duplicateTool;
        service.getTranslations = getTranslations;
        service.saveOptionCondition = saveOptionCondition;
        service.getOptionConditionSources = getOptionConditionSources;
        service.copyToolConditions = copyToolConditions;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        //base.canonical-tree
        function subQuestions() {
            return configuredRestangular.service(
                $state.current.name === 'base.canonical-tree'
                    ? 'canonical/canonical_subquestions'
                    : 'products/subquestions'
            );
        }

        function subQuestionOptions() {
            return configuredRestangular.service(
                $state.current.name === 'base.canonical-tree'
                    ? 'canonical/canonical_subquestionoptions'
                    : 'products/subquestionoptions'
            );
        }

        //More generic use case for simple calls that we might need to build off the url
        function product() {
            return configuredRestangular.service('products');
        }

        function getGlobalOptionsConfig(params = {}) {
            return products.one('globaloptionsconfig').customGET('', params);
        }

        function getToolOptions(id) {
            return $http.get(apiUrl + '/products/tools/' + id + '/option_lists/').then(function(res) {
                return res.data;
            });
        }

        function getTools(params) {
            params = params ? params : {};
            if (params.id) {
                return products
                    .one('tools')
                    .one(params.id)
                    .customGET('', params);
            } else {
                return products.one('tools').customGET('', params);
            }
        }

        function getNestedToolOptions(tool_id, params) {
            return products.one('tools/' + tool_id).customGET('', params);
        }

        function duplicateTool(id) {
            return $http.get(apiUrl + '/products/tools/' + id + '/duplicate/').then(function(res) {
                return res.data;
            });
        }

        /**
         * The two condition calls below deliberately do NOT branch on
         * `base.canonical-tree` the way subQuestionOptions() does.
         *
         * Conditions are stored per tool version (FR-005, BR-2095-05) as
         * OptionValidationRules, and that model's `option` FK points at
         * products.SubQuestionOption. CanonicalSubQuestionOption is a separate
         * table with its own AUTO pk and cannot hold a rule, so posting a canonical
         * pk here would resolve an unrelated answer option in a live tool version
         * and silently give it a condition. The editor is therefore mounted only
         * when `isCanonicalTree` is false; this guard makes a future miswiring fail
         * loudly instead of corrupting methodology data.
         */
        function assertToolVersionScope(action) {
            if ($state.current.name === 'base.canonical-tree') {
                return $q.reject({
                    data: {
                        detail: 'Answer-option conditions are configured per tool version, not on the Canonical Tree.'
                    },
                    canonicalScopeError: action
                });
            }
            return null;
        }

        /**
         * AD-2095: save or clear the "Is conditional on" rule of an answer option.
         *
         * `condition` is `{enabled: false}` to clear it, otherwise
         * `{enabled: true, rule: 'is_selected', source_question_id, source_option_id}`.
         * Rejects with the DRF field-error object so the editor can show it inline;
         * the server owns cycle / conflict / out-of-tool validation.
         */
        function saveOptionCondition(optionId, condition) {
            return (
                assertToolVersionScope('save') ||
                $http
                    .post(apiUrl + '/products/subquestionoptions/' + optionId + '/condition/', condition)
                    .then(res => res.data.condition)
            );
        }

        /**
         * AD-2095: questions of this option's tool version that can be a condition
         * source, each with its answer options. FR-003 allows any question of the
         * tool version, which is wider than the sibling list the score builder holds.
         */
        function getOptionConditionSources(optionId) {
            return (
                assertToolVersionScope('load sources') ||
                $http
                    .get(apiUrl + '/products/subquestionoptions/' + optionId + '/condition-sources/')
                    .then(res => res.data.questions)
            );
        }

        /**
         * AD-2105: copy the answer-option conditions of `fromToolId` onto `toolId`.
         * The source version is left untouched.
         */
        function copyToolConditions(toolId, fromToolId) {
            return $http
                .post(apiUrl + '/products/tools/' + toolId + '/copy-conditions/', { from: fromToolId })
                .then(res => res.data);
        }

        function getScales(params) {
            params = params ? params : {};
            return products.one('scale_types').customGET('', params);
        }

        function getLegalStatusOptions(params) {
            params = params ? params : {};
            params.page_size = '999';
            return products.one('legal_status_options').customGET('', params);
        }

        function getServiceOptions(params) {
            params = params ? params : {};
            return products.one('serviceoptions').customGET('', params);
        }

        function getProductTypeOptions(params) {
            params = params ? params : {};
            return products.one('product_type_options').customGET('', params);
        }

        function updateProductTypes(url, productTypes) {
            return url ? siScope.patch({ url, productTypes }) : $q.resolve({ productTypes });
        }

        function getTranslations(params) {
            params = params ? params : {};
            return products.one('translations').customGET('', params);
        }

        // TODO: rework the way the authorization is skipped when regisering a user
        function getDropDowns(params) {
            var globalRegionPromise = product()
                    .one('continent_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false }),
                countryPromise = product()
                    .one('country_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false }),
                regionPromise = product()
                    .one('region_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false }),
                legalStatusPromise = product()
                    .one('legal_status_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false }),
                globalProductTypeOptions = product()
                    .one('global_product_type_options')
                    .get({
                        page_size: 9999,
                        fields: ['product_per_type_options'],
                        noAuth: params ? params.noAuth : false
                    }),
                globalQualityIssuesOption = product()
                    .one('global_quality_issues_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false }),
                sourceOfDataOptionsPromise = product()
                    .one('source_of_data_options')
                    .get({ page_size: 9999, noAuth: params ? params.noAuth : false });

            return $q
                .all([
                    globalRegionPromise,
                    countryPromise,
                    regionPromise,
                    legalStatusPromise,
                    globalProductTypeOptions,
                    globalQualityIssuesOption,
                    sourceOfDataOptionsPromise
                ])
                .then((promises = []) => {
                    return promises.length
                        ? {
                              continentOptions: promises[0].results,
                              countryOptions: promises[1].results,
                              regionOptions: promises[2].results,
                              legalStatusOptions: promises[3].results,
                              globalProductTypeOptions: promises[4].results,
                              globalQualityIssuesOption: promises[5].results,
                              sourceOfDataOptions: promises[6].results
                          }
                        : {};
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.projects').factory('padThemeService', padThemeService);

    padThemeService.$inject = ['$location', '$window'];

    function padThemeService($location, $window) {
        const service = {
            shouldUseDarkTheme: shouldUseDarkTheme,
            setTheme: setTheme,
            getTheme: getTheme
        };

        return service;

        function shouldUseDarkTheme() {
            const currentUrl = $location.path();
            const isPadPage = currentUrl.includes('/projects/analytics/');
            const isDarkMode = $window.localStorage.getItem('pad_theme') === 'dark';

            return isPadPage && isDarkMode;
        }

        function setTheme(isDark) {
            $window.localStorage.setItem('pad_theme', isDark ? 'dark' : 'light');
        }

        function getTheme() {
            return $window.localStorage.getItem('pad_theme') || 'light';
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.services')
        .factory('siMessages', siMessages);

    siMessages.$inject = ['Restangular', '$state'];

    function siMessages(Restangular, $state) {

        const
            configuredRestangular = Restangular.withConfig(config => config.restangularFields.options = 'restangularOptions'),
            service = this,
            messaging = configuredRestangular.all('messaging');

        service.getMessages = (params = {}) => messaging.one('messages').customGET('', params);
        service.getMessageTypes = (params = {}) => messaging.one('message_types').customGET('', params);
        service.getMessage = (params = {}) => messaging.one(`messages/${$state.params.id}`).customGET('', params);

        return service;

    }

}());

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siInfoText', siInfoText);

    siInfoText.$inject = ['gettext'];

    function siInfoText(gettext) {
        const service = this;

        const tabs = [
            {
                name: gettext('Assessment'),
                sections: [
                    {
                        name: gettext('Assessment start date'),
                        key: 'info_assessment_tab_assessment_start_date',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on assessment'),
                        key: 'info_assessment_tab_assessor_notes',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Purpose of Assessment'),
                        key: 'info_assessment_tab_purpose_of_assessment',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessee Background'),
                        key: 'info_assessment_tab_assessee_background',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Staff Present and Positions'),
                        key: 'info_assessment_tab_staff_present_and_positions',
                        tools: ['input_retailer']
                    },
                    {
                        name: gettext('Representatives Present and Positions'),
                        key: 'info_assessment_tab_representatives_present_and_positions',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Agent/Organizational'),
                sections: [
                    {
                        name: gettext('Basic and contact details'),
                        key: 'info_organizational_tab_basic_and_contact_details',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Affiliated Organization Name'),
                        key: 'info_affiliated_organization_name',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Sectors'),
                        key: 'info_organizational_tab_sectors_and_activities',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Services/Activities'),
                        key: 'info_organizational_tab_services_activities',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Related farmers'),
                        key: 'info_organizational_tab_related_farmers',
                        tools: ['agent']
                    },
                    {
                        name: gettext('Additional details'),
                        key: 'info_organizational_tab_additional_details',
                        tools: ['agent']
                    },
                    {
                        name: gettext('Services offered'),
                        key: 'info_organizational_tab_services_offered',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Infrastructure information'),
                        key: 'info_organizational_tab_infrastructure_information',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on organization'),
                        key: 'info_organizational_tab_assessor_notes',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Employees'),
                        key: 'info_organizational_tab_employees',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Contacts'),
                        key: 'info_organizational_tab_contacts',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Incorporation'),
                        key: 'info_organizational_tab_incorporation',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Mission'),
                        key: 'info_organizational_tab_mission',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Vision'),
                        key: 'info_organizational_tab_vision',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessee Image'),
                        key: 'info_organizational_tab_assessee_image',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Board and management'),
                        key: 'info_organizational_tab_board_and_management',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Members'),
                        key: 'info_organizational_tab_members',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Sharecroppers'),
                        key: 'info_organizational_tab_sharecroppers',
                        tools: ['basic', 'pro']
                    },
                    {
                        name: gettext('Outgrowers'),
                        key: 'info_organizational_tab_outgrowers',
                        tools: ['basic', 'pro']
                    },
                    {
                        name: gettext('Umbrella/Representing Organization'),
                        key: 'info_organizational_tab_umbrella_representing_organization',
                        tools: ['pro']
                    }
                ]
            },

            {
                name: gettext('Balance Sheet'),
                sections: [
                    {
                        name: gettext('Balance Sheet main'),
                        key: 'info_balance_sheet_tab_main',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Cashflow'),
                sections: [
                    {
                        name: gettext('Cashflow main'),
                        key: 'info_cashflow_tab_main',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Documentation'),
                sections: [
                    {
                        name: gettext('Documentation main'),
                        key: 'info_documentation_tab_main',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on documentation'),
                        key: 'info_documentation_tab_assessor_notes',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Finance'),
                sections: [
                    {
                        name: gettext('Financial Data'),
                        key: 'info_finance_tab_financial_data',
                        tools: ['input_retailer', 'basic', 'basic_sme']
                    },
                    {
                        name: gettext('Financial Strategy'),
                        key: 'info_finance_tab_financial_strategy',
                        tools: ['basic', 'basic_sme']
                    },
                    {
                        name: gettext('Financial Information'),
                        key: 'info_finance_tab_basic_profitloss',
                        tools: ['basic', 'basic_sme']
                    },
                    {
                        name: gettext('Bank Accounts'),
                        key: 'info_finance_tab_bank_accounts',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Loan History'),
                        key: 'info_finance_tab_loan_history',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Comments'),
                        key: 'info_finance_tab_comments',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Grant History'),
                        key: 'info_finance_tab_grant_history',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Pre-Finance History'),
                        key: 'info_finance_tab_pre_finance_history',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Name of Auditing Firm'),
                        key: 'info_finance_tab_name_of_auditing_firm',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Collateral'),
                        key: 'info_finance_tab_collateral',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Loan requirements'),
                        key: 'info_finance_tab_loan_requirements',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Loan Applications'),
                        key: 'info_finance_tab_loan_applications',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Capital requirements'),
                        key: 'info_finance_tab_capital_requirements',
                        tools: ['pro_sme']
                    },
                    {
                        name: gettext('Insurance'),
                        key: 'info_finance_tab_insurance',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Principal Shareholders'),
                        key: 'info_finance_tab_principal_shareholders',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Finance & Product'),
                sections: [
                    {
                        name: gettext('Bank account & loan history'),
                        key: 'info_finance_product_tab_bank_account_loan_history',
                        tools: ['agent']
                    },
                    {
                        name: gettext('Income from Agent role'),
                        key: 'info_finance_product_tab_income_from_agent_role',
                        tools: ['agent']
                    },
                    {
                        name: gettext('Products'),
                        key: 'info_finance_product_tab_products',
                        tools: ['agent']
                    },
                    {
                        name: gettext('Assessor notes on finance and product'),
                        key: 'info_finance_product_tab_assessor_notes',
                        tools: ['agent']
                    }
                ]
            },
            {
                name: gettext('Financial Performance'),
                sections: [
                    {
                        name: gettext('Financial Ratios'),
                        key: 'info_financial_performance_tab_financial_ratios',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Governance'),
                sections: [
                    {
                        name: gettext('Management Team'),
                        key: 'info_governance_tab_management_team',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Board of Directors'),
                        key: 'info_governance_tab_board_of_directors',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Governance Structure'),
                        key: 'info_governance_tab_governance_structure',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on governance'),
                        key: 'info_governance_tab_assessor_notes',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Monthly Production'),
                sections: [
                    {
                        name: gettext('Activity Timeline'),
                        key: 'info_monthly_production_tab_activity_timeline',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Monthly Cash Flow Projections'),
                        key: 'info_monthly_production_tab_monthly_cash_flow_projections',
                        tools: ['pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on monthly production'),
                        key: 'info_monthly_production_tab_assessor_notes',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Observations'),
                sections: [
                    {
                        name: gettext('Observations main'),
                        key: 'info_observations_tab_main',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Internal Management'),
                        key: 'info_observations_tab_internal_management',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Operations'),
                        key: 'info_observations_tab_operations',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Sustainability'),
                        key: 'info_observations_tab_sustainability',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Market'),
                        key: 'info_observations_tab_market',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Financial Management'),
                        key: 'info_observations_tab_financial_management',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on observations'),
                        key: 'info_observations_tab_assessor_notes',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('External Risks'),
                        key: 'info_observations_tab_external_risks',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Enablers'),
                        key: 'info_observations_tab_enablers',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Supply'),
                        key: 'info_observations_tab_supply',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Products Sold / Production'),
                sections: [
                    {
                        name: gettext('Production main'),
                        key: 'info_production_tab_main',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Sales to Farmers'),
                        key: 'info_production_tab_sales_to_farmers',
                        tools: ['input_retailer', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on products'),
                        key: 'info_production_tab_assessor_notes',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Product Information'),
                        key: 'info_production_tab_product_information',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Produce purchased from members'),
                        key: 'info_production_tab_produce_purchased',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Produce purchased from others'),
                        key: 'info_production_tab_other_produce_purchased',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Production figures'),
                        key: 'info_production_tab_production_figures',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Produce sold'),
                        key: 'info_production_tab_produce_sold',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Inputs Purchased'),
                        key: 'info_production_tab_inputs_purchased',
                        tools: ['basic', 'pro']
                    }
                ]
            },
            {
                name: gettext('Profit / Loss'),
                sections: [
                    {
                        name: gettext('Profit / Loss main'),
                        key: 'info_profit_loss_tab_main',
                        tools: ['pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Questionnaire'),
                sections: [
                    {
                        name: gettext('Questionnaire main'),
                        key: 'info_questionnaire_tab_main',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Terms and Conditions'),
                sections: [
                    {
                        name: gettext('Terms and Conditions main'),
                        key: 'info_terms_and_conditions_tab_main',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Assessor notes on terms and conditions'),
                        key: 'info_terms_and_conditions_tab_assessor_notes',
                        tools: ['agent', 'input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            },
            {
                name: gettext('Value Chain'),
                sections: [
                    {
                        name: gettext('Supplier'),
                        key: 'info_value_chain_tab_supplier',
                        tools: ['input_retailer']
                    },
                    {
                        name: gettext('Assessor notes on value chain'),
                        key: 'info_value_chain_tab_assessor_notes',
                        tools: ['input_retailer', 'basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Clients'),
                        key: 'info_value_chain_tab_clients',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    },
                    {
                        name: gettext('Service providers and Supporting organizations'),
                        key: 'info_value_chain_tab_service_providers',
                        tools: ['basic', 'basic_sme', 'pro', 'pro_sme']
                    }
                ]
            }
        ];

        service.tabs = tabs;
        return service;
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siHrm', siHrm);

    siHrm.$inject = ['Restangular', 'apiUrl', '$http', '$state', 'siScope', '$q'];

    function siHrm(Restangular, apiUrl, $http, $state, siScope, $q) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var hrm = configuredRestangular.all('/hrm/');
        var assessors = configuredRestangular.all('/hrm/assessors/');
        var employees = configuredRestangular.all('/hrm/employees/');
        var users = configuredRestangular.all('/accounts/users/');
        var registerUsers = configuredRestangular.all('/register');

        service.getAssessorSkills = getAssessorSkills;
        service.getAssessors = getAssessors;
        service.getAssessor = getAssessor;
        service.getEmployees = getEmployees;
        service.getEmployee = getEmployee;
        service.createUser = createUser;
        service.registerUser = registerUser;
        service.impersonateUser = impersonateUser;
        service.createAssessor = createAssessor;
        service.createEmployee = createEmployee;
        service.getUser = getUser;
        service.getUsers = getUsers;
        service.toggleAssessorSkill = toggleAssessorSkill;
        service.updateAssessorSkills = updateAssessorSkills;
        service.skillInList = skillInList;
        service.updateDashboardRole = updateDashboardRole;
        service.setUserRoles = setUserRoles;
        service.checkEmailAvailability = checkEmailAvailability;
        service.getDefaultQR = getDefaultQR;
        service.getDefaultFinancialQR = getDefaultFinancialQR;
        service.getAllAssessorTraining = getAllAssessorTraining;
        service.getPortalLicenses = getPortalLicenses;
        service.getDashboardLicenses = getDashboardLicenses;
        service.getProjectContacts = getProjectContacts;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getProjectContacts(customerId, projectId) {
            let params = {
                page_size: 9999,
                organization_id: customerId,
                roles: ['is_customer_admin', 'is_customer_user']
            };

            // Add project_id if editing existing project
            if (projectId) {
                params.project_id = projectId;
            }

            //Customer SCOPEInsight
            if (customerId == 328) {
                params.roles.push('is_employee');
            }

            return users.one('project_contacts').customGET('', params);
        }

        function getAllAssessorTraining(assessor) {
            const params = { assessor };
            return $q
                .all([
                    hrm.one('assessor_trainings').customGET('', params),
                    hrm.one('financial_specialist_trainings').customGET('', params)
                ])
                .then(trainings => ({
                    assessor: trainings[0].results,
                    financial_specialist: trainings[1].results
                }))
                .catch(() => ({ assessor: [], financial_specialist: [], portal_license: [] }));
        }

        function getPortalLicenses(user) {
            const params = { user };
            return hrm.one('portal_licenses').customGET('', params);
        }

        function getDashboardLicenses(customer) {
            const params = { customer };
            return hrm.one('dashboard_licenses').customGET('', params);
        }

        function getDefaultQR(params = {}) {
            return hrm.one('settings').customGET('', params);
        }

        function getDefaultFinancialQR(params = {}) {
            return hrm.one('settings').customGET('', params);
        }

        function getAssessorSkills(params) {
            params = params ? params : {};
            return hrm.one('assessment_skill_types').customGET('', params);
        }

        function getAssessors(params) {
            params = params ? params : {};
            return assessors.customGET('', params);
        }

        function getAssessor(params) {
            params = params ? params : {};
            return assessors.one($state.params.id).customGET('', params);
        }

        function getEmployees(params) {
            params = params ? params : {};
            return employees.customGET('', params);
        }

        function getEmployee(params) {
            params = params ? params : {};
            return employees.one($state.params.id).customGET('', params);
        }

        function getUsers(params) {
            params = params ? params : {};
            return users.one('').customGET('', params);
        }

        function getUser(id, params) {
            params = params ? params : {};
            return users.one(id).customGET('', params);
        }

        function createUser(user, params) {
            params = params ? params : {};
            return users.post(user, params);
        }

        function registerUser(user, params) {
            params = params ? params : {};
            return registerUsers.post(user, params);
        }

        function impersonateUser(user) {
            return users.customPOST(user, 'impersonate');
        }

        function createAssessor(assessor, params) {
            params = params ? params : {};
            return assessors.post(assessor, params);
        }

        function createEmployee(employee, params) {
            params = params ? params : {};
            return employees.post(employee, params);
        }

        /**
         * Function to toggle an m2m relation between assessor and skilltype
         * @param assessor object
         * @param skill object
         */
        function toggleAssessorSkill(assessor, skill) {
            var patch = {};

            //Set up patch to remove the skill
            if (skillInList(assessor.skills.objects, skill)) {
                patch = {
                    url: assessor.url,
                    user: assessor.user.url,
                    skills: assessor.skills.objects
                        .filter(function(currentSkill) {
                            return currentSkill.url !== skill.url;
                        })
                        .map(function(skill) {
                            return skill.url;
                        })
                };
                //Set up patch to add the skill
            } else {
                patch = {
                    url: assessor.url,
                    user: assessor.user.url,
                    skills: assessor.skills.objects.map(function(skill) {
                        return skill.url;
                    })
                };

                patch.skills.push(skill.url);
            }

            return siScope.patch(patch);
        }

        function updateAssessorSkills(assessor, skills) {
            var patch = {
                url: assessor.url,
                user: assessor.user,
                skills: skills
            };

            return siScope.patch(patch);
        }

        /**
         * Function to check if a skilltype exists in a list of m2m skills
         * @param list list of skills (m2m)
         * @param skill skilltype object
         * @returns filtered list of skills
         */
        function skillInList(list, skill) {
            return list
                .filter(function(item) {
                    return item.url === skill.url;
                })
                .reduce(function() {
                    return true;
                }, false);
        }

        function updateDashboardRole(user, newRole) {
            if (!_.isEmpty(user.employee)) {
                var patch;
                if (newRole.name === 'SI Employee') {
                    patch = { qc_only: false, employee_lite: false };
                } else if (newRole.name === 'SI Employee Lite') {
                    patch = { qc_only: false, employee_lite: true };
                } else {
                    patch = { qc_only: true, employee_lite: false };
                }
                patch.url = user.employee.url;
                return siScope.patch(patch).then(function(employeeRoles) {
                    _.extend(user.employee, employeeRoles);
                    return user;
                });
            } else {
                return createEmployee({ user: user.url }).then(function(newEmployee) {
                    user.employee = newEmployee;
                    user.is_employee = true;
                    return updateDashboardRole(user, newRole);
                });
            }
        }

        /**
         *
         * @param user
         * @returns {{app: *, dashboard: *}}
         */
        function setUserRoles(user) {
            var dashboardRoles = [
                user.is_employee ? 'SI Employee' : false,
                user.is_employee_lite ? 'SI Employee Lite' : false,
                user.is_quality_reviewer ? 'SI Quality Reviewer' : false,
                user.is_customer_admin ? 'Dashboard Administrator' : false,
                user.is_customer_user ? 'Dashboard User' : false,
                !user.is_employee &&
                !user.is_employee_lite &&
                !user.is_quality_reviewer &&
                !user.is_customer_admin &&
                !user.is_customer_user
                    ? 'No Access'
                    : false
            ]
                .filter(role => role)
                .map(role => ({ name: role }))
                .reduce((memo, role) => role, { name: '' });

            var appSkills = [
                user.is_assessor ? 'is_assessor' : false,
                user.is_financial_specialist ? 'is_financial_specialist' : false
            ]
                .filter(role => role)
                .map(role => ({ name: role }))
                .reduce((memo, role) => role, { name: '' });

            return Object.assign(
                {},
                appSkills.name ? { app: appSkills } : {},
                dashboardRoles.name ? { dashboard: dashboardRoles } : {}
            );
        }

        function checkEmailAvailability(email, params) {
            params = params || {};
            params['email'] = email;
            return users.one('check_email_availability').customGET('', params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siFormElement', siFormElement);

    siFormElement.$inject = ['$rootScope', 'siScope', 'moment', 'COMPLETION_CHECK'];

    function siFormElement($rootScope, siScope, moment, COMPLETION_CHECK) {
        var service = this;

        service.update = update;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function update(obj, key, value, form) {
            var patch = {
                url: obj.url,
                id: obj.id
            };

            form = form || {};

            if (typeof value === 'undefined') {
                if (typeof obj[key] === 'number') {
                    value = null;
                } else {
                    value = '';
                }
            }

            patch[key] = value instanceof Date ? moment(value).format('YYYY-MM-DD') : value;

            $rootScope.$broadcast(COMPLETION_CHECK.update, form);

            return siScope.patch(patch);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siCustomers', siCustomers);

    siCustomers.$inject = ['Restangular', 'apiUrl', '$http', '$state'];

    function siCustomers(Restangular, apiUrl, $http, $state) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var customersRegister = configuredRestangular.all('fetch_customers');
        var customers = configuredRestangular.all('customers');
        var contacts = configuredRestangular.all('customers/contacts');

        service.getActivities = getActivities;
        service.getSectors = getSectors;
        service.getContacts = getContacts;
        service.getCustomers = getCustomers;
        service.getCustomersDropdown = getCustomersDropdown;
        service.getPOs = getPOs;
        service.getCustomerStates = getCustomerStates;
        service.getCustomers_Id = getCustomers_Id;
        service.getContact = getContact;
        service.createContact = createContact;
        service.getCustomersDropdownLogin = getCustomersDropdownLogin;
        service.getCustomerProfileDashboard = getCustomerProfileDashboard;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getActivities(params) {
            params = params ? params : {};
            return customers.one('activitys').customGET('', params);
        }

        function getSectors(params) {
            params = params ? params : {};
            return customers.one('sectors').customGET('', params);
        }

        function getContacts(params) {
            params = params ? params : {};
            return customers.one('contacts').customGET('', params);
        }

        function getContact(params) {
            params = params ? params : {};
            return customers
                .one('contacts')
                .one(params.id)
                .get();
        }

        function createContact(contact, params) {
            params = params ? params : {};
            return contacts.post(contact, params);
        }

        function getCustomers(params) {
            params = params ? params : {};
            return customers.one('customers').customGET('', params);
        }

        function getCustomersDropdown(params) {
            params = params ? params : {};
            return customers.one('customers/dropdown').customGET('', params);
        }
        function getCustomersDropdownLogin(params) {
            params = params ? params : {};
            return customersRegister.one('').customGET('', params);
        }

        function getCustomers_Id(params) {
            params = params ? params : {};
            console.log($state.params);
            return customers.one('customers/' + (params ? params.id : $state.params.id)).customGET('', params);
        }

        function getCustomerStates(params) {
            params = params ? params : {};
            return customers.one('customer_states').customGET('', params);
        }

        function getPOs(params) {
            params = params ? params : {};
            return customers.one('producing_organizations').customGET('', params);
        }

        function getCustomerProfileDashboard(customerId, currentAssessmentId, previousAssessmentId, params) {
            params = params || {};

            // Додај assessment IDs као query параметре
            if (currentAssessmentId) {
                params.current_assessment_id = currentAssessmentId;
            }
            if (previousAssessmentId) {
                params.previous_assessment_id = previousAssessmentId;
            }

            return customers.one('customers/' + customerId).customGET('profile-dashboard', params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siCompletionCheck', siCompletionCheck);

    siCompletionCheck.$inject = [];

    function siCompletionCheck() {
        const service = this;

        const valid = { $valid: true, $invalid: false };
        const invalid = { $valid: false, $invalid: true };
        const pristine = { $valid: false, $invalid: false, $dirty: false };

        const proAssessmentTabs = [
            {
                isCompleted: 'assessment_tab_completed',
                isAccepted: 'assessment_tab_accepted',
                form: 'assessmentForm'
            },
            {
                isCompleted: 'organizational_tab_completed',
                isAccepted: 'organizational_tab_accepted',
                form: 'organizationForm'
            },
            {
                isCompleted: 'value_chain_tab_completed',
                isAccepted: 'value_chain_tab_accepted',
                form: 'valueChainForm'
            },
            {
                isCompleted: 'finance_history_tab_completed',
                isAccepted: 'finance_history_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'profit_loss_tab_completed',
                isAccepted: 'profit_loss_tab_accepted',
                form: 'profitLossForm'
            },
            {
                isCompleted: 'balance_sheet_tab_completed',
                isAccepted: 'balance_sheet_tab_accepted',
                form: 'balanceSheetForm'
            },
            {
                isCompleted: 'cash_flow_tab_completed',
                isAccepted: 'cash_flow_tab_accepted',
                form: 'cashflowForm'
            },
            {
                isCompleted: 'finance_performance_tab_completed',
                isAccepted: 'finance_performance_tab_accepted',
                form: 'financialPerformanceForm'
            },
            {
                isCompleted: 'production_tab_completed',
                isAccepted: 'production_tab_accepted',
                form: 'productionForm'
            },
            {
                isCompleted: 'observations_tab_completed',
                isAccepted: 'observations_tab_accepted',
                form: 'observationsForm'
            },
            {
                isCompleted: 'documents_tab_completed',
                isAccepted: 'documents_tab_accepted',
                form: 'documentationForm'
            }
        ];

        const basicAssessmentTab = [
            {
                isCompleted: 'assessment_tab_completed',
                isAccepted: 'assessment_tab_accepted',
                form: 'assessmentForm'
            },
            {
                isCompleted: 'organizational_tab_completed',
                isAccepted: 'organizational_tab_accepted',
                form: 'organizationForm'
            },
            {
                isCompleted: 'value_chain_tab_completed',
                isAccepted: 'value_chain_tab_accepted',
                form: 'valueChainForm'
            },
            {
                isCompleted: 'finance_history_tab_completed',
                isAccepted: 'finance_history_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'finance_overview_tab_completed',
                isAccepted: 'finance_overview_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'production_tab_completed',
                isAccepted: 'production_tab_accepted',
                form: 'productionForm'
            },
            {
                isCompleted: 'observations_tab_completed',
                isAccepted: 'observations_tab_accepted',
                form: 'observationsForm'
            },
            {
                isCompleted: 'documents_tab_completed',
                isAccepted: 'documents_tab_accepted',
                form: 'documentationForm'
            }
        ];

        const saccoAssessmentTab = [
            {
                isCompleted: 'assessment_tab_completed',
                isAccepted: 'assessment_tab_accepted',
                form: 'assessmentForm'
            },
            {
                isCompleted: 'organizational_tab_completed',
                isAccepted: 'organizational_tab_accepted',
                form: 'organizationForm'
            },
            {
                isCompleted: 'finance_history_tab_completed',
                isAccepted: 'finance_history_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'finance_overview_tab_completed',
                isAccepted: 'finance_overview_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'observations_tab_completed',
                isAccepted: 'observations_tab_accepted',
                form: 'observationsForm'
            },
            {
                isCompleted: 'documents_tab_completed',
                isAccepted: 'documents_tab_accepted',
                form: 'documentationForm'
            }
        ];

        const agentTabs = [
            {
                isCompleted: 'assessment_tab_completed',
                isAccepted: 'assessment_tab_accepted',
                form: 'assessmentForm'
            },
            {
                isCompleted: 'agent_tab_completed',
                isAccepted: 'agent_tab_accepted',
                form: 'organizationForm'
            },
            {
                isCompleted: 'finance_product_tab_completed',
                isAccepted: 'finance_product_tab_accepted',
                form: 'financeProductionForm'
            },
            {
                isCompleted: 'documents_tab_completed',
                isAccepted: 'documents_tab_accepted',
                form: 'documentationForm'
            }
        ];

        const rapidAssessmentTabs = [
            {
                isCompleted: 'assessment_tab_completed',
                isAccepted: 'assessment_tab_accepted',
                form: 'assessmentForm'
            },
            {
                isCompleted: 'organizational_tab_completed',
                isAccepted: 'organizational_tab_accepted',
                form: 'organizationForm'
            },
            // {
            //     isCompleted: 'value_chain_tab_completed',
            //     isAccepted: 'value_chain_tab_accepted',
            //     form: 'valueChainForm'
            // },
            {
                isCompleted: 'finance_history_tab_completed',
                isAccepted: 'finance_history_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'finance_overview_tab_completed',
                isAccepted: 'finance_overview_tab_accepted',
                form: 'financeForm'
            },
            {
                isCompleted: 'production_tab_completed',
                isAccepted: 'production_tab_accepted',
                form: 'productionForm'
            }
            // {
            //     isCompleted: 'documents_tab_completed',
            //     isAccepted: 'documents_tab_accepted',
            //     form: 'documentationForm'
            // }
        ];

        const tabCompletionBooleans = {
            pro: proAssessmentTabs,
            basic: basicAssessmentTab,
            is_sacco: saccoAssessmentTab,
            basic_sme: basicAssessmentTab,
            pro_sme: proAssessmentTabs,
            agent: agentTabs,
            input_retailer: basicAssessmentTab,
            is_rapid: rapidAssessmentTabs
        };

        const toolTypes = ['pro', 'basic', 'basic_sme', 'pro_sme', 'agent', 'is_rapid', 'input_retailer', 'is_sacco'];
        const financeTabs = ['profitLossForm', 'balanceSheetForm', 'cashflowForm', 'financialPerformanceForm'];
        const completionCheck = {};

        service.setupInitialCompletionCheck = setupInitialCompletionCheck;
        service.update = update;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function isFinancialSpecialist(assignment) {
            return assignment.assigned_as === 'financial_specialist';
        }

        function update(completionCheck, update, assignment) {
            const formName = Object.keys(update)[0];

            if (isFinancialSpecialist(assignment)) {
                if (financeTabs.indexOf(formName) !== -1) {
                    return _.extend(completionCheck, update);
                } else {
                    return completionCheck;
                }
            }

            if (!isFinancialSpecialist(assignment)) {
                if (financeTabs.indexOf(formName) === -1) {
                    return _.extend(completionCheck, update);
                } else {
                    return completionCheck;
                }
            }
        }

        function setupInitialCompletionCheck(assessment, assignment) {
            return assignment.submitted_at_least_once
                ? assessmentSubmittedOnce(assessment, isFinancialSpecialist(assignment))
                : assessmentNotSubmittedOnce(assessment, isFinancialSpecialist(assignment));
        }

        function assessmentSubmittedOnce(assessment, isFinancialSpecialist) {
            toolTypes
                .filter(type => assessment.tool.type[type])
                .forEach(name => {
                    tabCompletionBooleans[name]
                        .filter(({ form }) => (form === 'termsForm' ? assessment.with_terms_and_conditions : true))
                        .filter(({ form }) =>
                            isFinancialSpecialist ? financeTabs.indexOf(form) !== -1 : financeTabs.indexOf(form) === -1
                        )
                        .forEach(({ form, isCompleted, isAccepted }) => {
                            completionCheck[form] = {};

                            if (assessment[isCompleted] || assessment[isAccepted]) {
                                _.extend(completionCheck[form], valid);
                            } else {
                                _.extend(completionCheck[form], pristine);
                            }
                        });
                });
            // there is an issue where rapid and SACCO tools are marked as both "basic" and ther respective type ("rapid" and "sacco" respectively)
            // that results in the above function checking both the basic and the tools respective "completion forms"
            // the below checks are a workaround for that issue, by explicitly removing the excess forms from the completionCheck object
            if (assessment.tool.type['is_rapid']) {
                // const a = _.omit(completionCheck, ['observationsForm']);
                return _.omit(completionCheck, ['observationsForm', 'valueChainForm', 'documentationForm']);
            }
            if (assessment.tool.type['is_sacco']) {
                return _.omit(completionCheck, ['valueChainForm']);
            }
            return completionCheck;
        }

        function assessmentNotSubmittedOnce(assessment, isFinancialSpecialist) {
            toolTypes
                .filter(type => {
                    return assessment.tool.type[type];
                })
                .forEach(name => {
                    tabCompletionBooleans[name]
                        .filter(({ form }) => (form === 'termsForm' ? assessment.with_terms_and_conditions : true))
                        //Filter the form to have in the completion check based on the users status as a FS
                        .filter(({ form }) =>
                            isFinancialSpecialist ? financeTabs.indexOf(form) !== -1 : financeTabs.indexOf(form) === -1
                        )
                        .forEach(({ form, isCompleted, isAccepted }) => {
                            completionCheck[form] = {};

                            if (assessment[isAccepted] && assessment[isCompleted]) {
                                _.extend(completionCheck[form], valid);
                            } else if (assessment[isCompleted]) {
                                _.extend(completionCheck[form], valid);
                            } else {
                                _.extend(completionCheck[form], invalid);
                            }
                        });
                });
            // there is an issue where rapid and SACCO tools are marked as both "basic" and ther respective type ("rapid" and "sacco" respectively)
            // that results in the above function checking both the basic and the tools respective "completion forms"
            // the below checks are a workaround for that issue, by explicitly removing the excess forms from the completionCheck object
            if (assessment.tool.type['is_rapid']) {
                // const a = _.omit(completionCheck, ['observationsForm']);
                return _.omit(completionCheck, ['observationsForm', 'valueChainForm', 'documentationForm']);
            }
            if (assessment.tool.type['is_sacco']) {
                return _.omit(completionCheck, ['valueChainForm']);
            }
            return completionCheck;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siCanonical', siCanonical);

    siCanonical.$inject = ['Restangular'];

    function siCanonical(Restangular) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var canonical = configuredRestangular.all('canonical');
        service.subQuestions = subQuestions;
        service.subQuestionOptions = subQuestionOptions;
        service.getCanonicalSections = getCanonicalSections;
        service.getCanonicalQuestions = getCanonicalQuestions;
        service.getCanonicalSubquestions = getCanonicalSubquestions;
        service.createNewTool = createNewTool;
        service.getTree = getTree;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getTree(params) {
            return canonical.one('canonical_tool').customGET('', params);
        }

        function getCanonicalSections() {
            return canonical.one('canonical_sections').customGET('', { page_size: 9999 });
        }

        function getCanonicalQuestions() {
            return canonical.one('canonical_questions').customGET('', { page_size: 9999 });
        }

        function getCanonicalSubquestions(params) {
            return canonical.one('canonical_subquestions').customGET('', params);
        }

        function subQuestions() {
            return canonical.one('canonical_subquestions').customGET('');
        }

        function subQuestionOptions() {
            return canonical.one('canonical_subquestionoptions').customGET('');
        }
        function createNewTool(data, params = {}) {
            return canonical.one('create_tool').post('', data, params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siAssessments', siAssessments);

    siAssessments.$inject = [
        'Restangular',
        'apiUrl',
        '$http',
        'saveAs',
        '$state',
        'siAssessmentUtilities',
        '$localStorage'
    ];

    function siAssessments(Restangular, apiUrl, $http, saveAs, $state, siAssessmentUtilities, $localStorage) {
        var configuredRestangular = Restangular.withConfig(function(config) {
                config.restangularFields.options = 'restangularOptions';
            }),
            service = this;

        var assessment = configuredRestangular.all('assessments');

        service.subResponses = subResponses;
        service.createDraftAssessment = createDraftAssessment;
        service.draftAssessment = draftAssessment();
        service.certifications = certifications;
        service.productionmargins = productionmargins;
        service.valuechainplayers = valuechainplayers;
        service.enablingplayers = enablingplayers;
        service.getPurposes = getPurposes;
        service.getAssignment = getAssignment;
        service.getAssessment = getAssessment;
        service.getFinancialRatiosForAssessment = getFinancialRatiosForAssessment;
        service.getCachedAssessment = getCachedAssessment;
        service.getConsolidatedReports = getConsolidatedReports;
        service.getProductionData = getProductionData;
        service.getAssessments = getAssessments;
        service.getAssessmentsWithParams = getAssessmentsWithParams;
        service.getAssessments_Params = getAssessments_Params;
        service.getAssessmentInvitations = getAssessmentInvitations;
        service.addYears = addYears;
        service.removeYears = removeYears;
        service.getQcLogInfo = getQcLogInfo;
        service.getInputValidationLimits = getInputValidationLimits;
        service.getQCThresholds = getQCThresholds;
        service.aiSpellcheck = aiSpellcheck;
        service.aiTaBuilder = aiTaBuilder;
        service.loadBuildFromAzure = loadBuildFromAzure;
        service.saveBuilderToAzure = saveBuilderToAzure;
        service.checkIfBuilderExists = checkIfBuilderExists;
        service.finalizeRapid = finalizeRapid;
        service.uploadFiles = uploadFiles;
        service.downloadSourceOfDataFile = downloadSourceOfDataFile;
        service.deleteSourceOfDataFile = deleteSourceOfDataFile;
        service.listSourceOfDataFiles = listSourceOfDataFiles;

        service.isUserAllowedGenerateFinalize = isUserAllowedGenerateFinalize;
        service.getQcComparison = getQcComparison;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function finalizeRapid(params) {
            return assessment.one('assessments/' + params.id + '/finalize_rapid').customGET('', {});
        }
        function isUserAllowedGenerateFinalize() {
            let temp = JSON.parse(localStorage['ngStorage-user']).info;

            return true;
            /*if (temp.is_superuser) {
                return true;
            } else if (temp.is_assessor) {
                return true;
            } elseif (
                temp.is_financial_specialist &&
                !temp.is_quality_reviewer &&
                !temp.is_superuser &&
                !temp.is_scope_employee &&
                !temp.is_customer_admin
            ) {
                return false;
            } */
        }

        function getQcLogInfo(params) {
            params = params ? params : {};
            return assessment.one('assessmentlogs').customGET('', params);
        }

        function getAssessments(params) {
            params = params ? params : {};
            return assessment.one('assessment_assignments').customGET('', params);
        }

        function getAssessment(id) {
            // Add cache-busting parameter to ensure fresh data after resubmission
            var cacheBuster = '_t=' + Date.now();
            return $http.get(apiUrl + '/assessments/assessments/' + id + '/?' + cacheBuster).then(function(res) {
                return res.data;
            });
        }

        function getAssessmentsWithParams(params) {
            params = params ? params : {};
            return assessment.one('assessments').customGET('', params);
        }

        function getAssessments_Params(params) {
            params = params ? params : {};
            return assessment.one('assessments/' + $state.params.id).customGET('', params);
        }

        function getPurposes(params) {
            params = params ? params : {};
            return assessment.one('assessment_purposes').customGET('', params);
        }

        function getAssignment(id) {
            // Use a stable URL (no cache-buster in the query string) so the offline
            // cache interceptor can match previously-cached responses when the device
            // is offline.  Freshness when online is handled by the interceptor's
            // If-Modified-Since header.
            return $http.get(`${apiUrl}/assessments/assessment_assignments/${id}/`).then(({ data }) => data);
        }

        function getAssessmentInvitations(params) {
            params = params ? params : {};
            return assessment.one('assessment_invitations').customGET('', params);
        }

        function getFinancialRatiosForAssessment(assessmentId) {
            return $http
                .get(apiUrl + '/assessments/financial_ratios/?assessment_id=' + assessmentId)
                .then(function(res) {
                    return res.data;
                });
        }

        function getCachedAssessment(id) {
            return fetch(apiUrl + '/assessments/assessments/' + id + '/', {
                headers: { 'x-cache-only': 1 }
            });
        }

        function subResponses() {
            return configuredRestangular.service('assessments/subresponses');
        }

        //TODO: refactor this and its usages to use the more generic below version
        function createDraftAssessment() {
            return configuredRestangular.service('assessments/draft_assessments');
        }

        function draftAssessment() {
            return configuredRestangular.service('assessments/draft_assessments');
        }

        function certifications() {
            return configuredRestangular.service('assessments/certifications');
        }

        function productionmargins() {
            return configuredRestangular.service('assessments/production_margins');
        }

        function valuechainplayers() {
            return configuredRestangular.service('assessments/value_chain_players');
        }

        function enablingplayers() {
            return configuredRestangular.service('assessments/enabling_players');
        }

        function suppliers() {
            return configuredRestangular.service('assessments/suppliers');
        }

        function getInputValidationLimits() {
            return $http({
                url: apiUrl + '/assessments/inputvalidationlimits/',
                method: 'GET'
            }).then(res => {
                let data = res.data.results;
                data.forEach(element => {
                    element.name = element.name.replaceAll('_', ' ');
                    element.name = element.name.charAt(0).toUpperCase() + element.name.slice(1);
                });
                return data;
            });
        }

        function getQCThresholds() {
            return $http({
                url: apiUrl + '/assessments/qcthresholds/',
                method: 'GET'
            }).then(function(res) {
                return res.data;
            });
        }

        function getConsolidatedReports() {
            return $http({
                url: apiUrl + '/reports/reports/consolidated_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');
                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'consolidated_report.xlsx');
            });
        }

        function getProductionData() {
            return $http({
                url: apiUrl + '/reports/reports/production_report/export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(res) {
                var type = res.headers('Content-Type');
                var blob = new Blob([res.data], { type: type });
                saveAs(blob, 'production_report.xlsx');
            });
        }

        function addYears(location, assessment, assignment) {
            return siAssessmentUtilities.addYears(location, assessment, assignment);
        }

        function removeYears(location, assessment, assignment) {
            return siAssessmentUtilities.removeYears(location, assessment, assignment);
        }

        function aiSpellcheck(text) {
            return $http({
                url: apiUrl + '/assessments/assessments/ai_spell_check/',
                method: 'POST',
                data: {
                    text: text
                }
            }).then(function(res) {
                return res;
            });
        }

        function aiTaBuilder(id) {
            return $http({
                url: apiUrl + '/reports/reports/' + id + '/generate_ai_ta_build',
                method: 'GET'
            }).then(function(res) {
                return res;
            });
        }

        function loadBuildFromAzure(original = false) {
            return $http({
                url: apiUrl + '/reports/reports/' + $state.params.id + '/load_build_from_azure',
                method: 'GET',
                params: { original: original }
            }).then(function(res) {
                return res;
            });
        }

        function saveBuilderToAzure(build, currency, isMerged) {
            return $http({
                url: apiUrl + '/reports/reports/' + $state.params.id + '/upload_build_to_azure/',
                method: 'POST',
                data: {
                    build: build,
                    currency: currency,
                    isMerged: isMerged
                }
            }).then(function(res) {
                return res;
            });
        }

        function checkIfBuilderExists(original = false) {
            return $http({
                url: apiUrl + '/reports/reports/' + $state.params.id + '/check_if_ta_ai_builder_exists/',
                method: 'GET',
                params: { original: original }
            }).then(function(res) {
                return res.data;
            });
        }

        function uploadFiles(files, fileType, assessmentId, onProgress) {
            return new Promise(function(resolve, reject) {
                if (!files || !files.length) {
                    reject({ error: 'No files provided' });
                    return;
                }
                var formData = new FormData();
                formData.append('file_type', fileType);
                Array.from(files).forEach(f => formData.append('files', f));

                var xhr = new XMLHttpRequest();
                var url = apiUrl + '/assessments/assessments/' + assessmentId + '/upload_files/';

                xhr.open('POST', url, true);

                // Auth header (bearer or raw token depending on your backend)
                var authToken = $localStorage.user && $localStorage.user.jwt && $localStorage.user.jwt.token;
                if (authToken) xhr.setRequestHeader('Authorization', authToken);

                // Progress (aggregated)
                xhr.upload.onprogress = function(evt) {
                    if (!onProgress) return;
                    if (evt.lengthComputable) {
                        var pct = Math.round((evt.loaded / evt.total) * 100);
                        onProgress(pct);
                    }
                };

                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            resolve(JSON.parse(xhr.response));
                        } catch (e) {
                            resolve({ raw: xhr.response });
                        }
                    } else {
                        reject({ status: xhr.status, data: xhr.response, statusText: xhr.statusText });
                    }
                };

                xhr.onerror = function() {
                    reject({ status: 0, error: 'Network error' });
                };
                xhr.send(formData);
            });
        }

        // In your service file (e.g., assessmentService.js)
        function downloadSourceOfDataFile(assessmentId, fileType, fileName) {
            return new Promise(function(resolve, reject) {
                if (!assessmentId || !fileType || !fileName) {
                    reject({ error: 'assessmentId, fileType and fileName are required' });
                    return;
                }
                var downloadUrl =
                    apiUrl +
                    '/assessments/assessments/' +
                    assessmentId +
                    '/download_file/?file_type=' +
                    encodeURIComponent(fileType) +
                    '&file_name=' +
                    encodeURIComponent(fileName);

                var xhr = new XMLHttpRequest();
                xhr.open('GET', downloadUrl, true);

                var authToken = $localStorage.user && $localStorage.user.jwt && $localStorage.user.jwt.token;
                if (authToken) xhr.setRequestHeader('Authorization', authToken);

                xhr.responseType = 'blob';
                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        var blob = xhr.response;
                        if (!blob || blob.size === 0) {
                            reject({ status: xhr.status, error: 'Empty file received' });
                            return;
                        }
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.href = url;
                        a.download = fileName;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        setTimeout(function() {
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        }, 100);
                        resolve({ success: true, fileName: fileName, fileSize: blob.size });
                    } else {
                        var reader = new FileReader();
                        reader.onload = function() {
                            try {
                                var errorData = JSON.parse(reader.result);
                                reject({
                                    status: xhr.status,
                                    statusText: xhr.statusText,
                                    error: errorData.error || 'Download failed'
                                });
                            } catch (e) {
                                reject({ status: xhr.status, statusText: xhr.statusText, error: 'Download failed' });
                            }
                        };
                        reader.readAsText(xhr.response);
                    }
                };
                xhr.onerror = function() {
                    reject({ status: 0, error: 'Network error during download' });
                };
                xhr.timeout = 30000;
                xhr.send();
            });
        }

        function deleteSourceOfDataFile(assessmentId, fileType, fileName) {
            var url = apiUrl + '/assessments/assessments/' + assessmentId + '/delete_file/';
            return $http.delete(url, { params: { file_type: fileType, file_name: fileName } }).then(r => r.data);
        }

        function listSourceOfDataFiles(assessmentId, fileType) {
            return $http
                .get(apiUrl + '/assessments/assessments/' + assessmentId + '/list_files' + '?file_type=' + fileType)
                .then(function(response) {
                    return response.data; // array of file metadata
                });
        }

        function getQcComparison(assessmentId) {
            // Add cache-busting parameter to bypass stale cache on resubmission
            var cacheBuster = '_t=' + Date.now();
            return $http({
                url: apiUrl + '/assessments/assessments/' + assessmentId + '/qc-comparison/?' + cacheBuster,
                method: 'GET'
            }).then(function(res) {
                return res.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siAssessmentUtilities', siAssessmentUtilities);

    siAssessmentUtilities.$inject = [
        'siScope',
        '$log',
        'modalFactory',
        'gettext',
        '$q',
        '$rootScope',
        'EVENT_LOADER',
        'toastr'
    ];

    function siAssessmentUtilities(siScope, $log, modalFactory, gettext, $q, $rootScope, EVENT_LOADER, toastr) {
        const service = this;

        service.addYears = addYears;
        service.removeYears = removeYears;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function addYears(location, assessment, assignment) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return addPLYear(location, assessment, assignment)
                .then(assessment => addYearBalanceSheet(location, assessment, assignment))
                .then(assessment => addYearCashflowStatement(location, assessment, assignment))
                .catch(() => {
                    toastr.error('Error adding years');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function removeYears(location, assessment) {
            const deferred = $q.defer();

            modalFactory.ConfirmModal({
                message: gettext(`
                Warning: You are removing a financial year.

                This will remove all data associated with this year from the Profit / Loss, Balancesheet, and Cashflow statements, and remove any data you may have previously entered on these tabs.

                Are you sure you wish to remove this year?`),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            return removePLYear(location, assessment)
                                .then(assessment => removeYearBalanceSheet(location, assessment))
                                .then(assessment => removeYearCashflowStatement(location, assessment))
                                .then(assessment => {
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    deferred.resolve(assessment);
                                })
                                .catch(err => {
                                    deferred.reject(err);
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                });
                        }
                    }
                ]
            });

            return deferred.promise;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            Private Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setYearLocation(location, assessment, objectName) {
            let previous, year;

            if (!location) {
                throw 'setting a year must have a location defined.';
            }

            if (location === 'lowest') {
                previous = assessment[objectName].objects[assessment[objectName].objects.length - 1];
                if (previous.year == 0) {
                    previous = assessment[objectName].objects[assessment[objectName].objects.length - 2];
                    year = previous.year - 1;
                } else {
                    year = previous.year - 1;
                }
            } else if (location === 'highest') {
                previous = assessment[objectName].objects[0];
                year = previous.year + 1;
            }

            return year;
        }

        function addYearCashflowStatement(location, assessment, assignment) {
            const newCashFlowSheet = {
                assessment: assessment.url,
                assessor: assignment.assessor,
                year: setYearLocation(location, assessment, 'cashflowstatements')
            };

            return siScope
                .create(newCashFlowSheet, assessment.cashflowstatements.links.create)
                .then(cashflowStatement => {
                    assessment.cashflowstatements.objects.push(cashflowStatement);

                    //Sort the newly added PL sheet
                    assessment.cashflowstatements.objects = assessment.cashflowstatements.objects.sort((a, b) => {
                        if (a.year < b.year) return 1;
                        if (a.year > b.year) return -1;
                        return 0;
                    });

                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return assessment;
                })
                .catch(err => {
                    toastr.error('CF Sheet Creation Err - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function addYearBalanceSheet(location, assessment, assignment) {
            const newBalanceSheet = {
                assessment: assessment.url,
                assessor: assignment.assessor,
                year: setYearLocation(location, assessment, 'balancesheets')
            };

            return siScope
                .create(newBalanceSheet, assessment.balancesheets.links.create)
                .then(balanceSheet => {
                    assessment.balancesheets.objects.push(balanceSheet);

                    // Sort the newly added BS sheet
                    assessment.balancesheets.objects = assessment.balancesheets.objects.sort((a, b) => {
                        if (a.year < b.year) return 1;
                        if (a.year > b.year) return -1;
                        return 0;
                    });

                    return assessment;
                })
                .catch(err => toastr.error('Balance Sheet Creation Err - ', err));
        }

        function addPLYear(location, assessment, assignment) {
            const newProfitLossSheet = {
                assessment: assessment.url,
                assessor: assignment.assessor,
                year: setYearLocation(location, assessment, 'profitlossstatements')
            };

            return siScope
                .create(newProfitLossSheet, assessment.profitlossstatements.links.create)
                .then(profitLossStatement => {
                    assessment.profitlossstatements.objects.push(profitLossStatement);

                    //Sort the newly added PL sheet
                    assessment.profitlossstatements.objects = assessment.profitlossstatements.objects.sort((a, b) => {
                        if (a.year < b.year) return 1;
                        if (a.year > b.year) return -1;
                        return 0;
                    });

                    const newYear = {
                        year: profitLossStatement.year,
                        value: {
                            currency: 'EUR',
                            amount: null
                        }
                    };

                    //For both the following each loops we need to decide where to append the new yr.
                    //append year to all expenses
                    Object.keys(assessment.all_expenses).forEach(key => {
                        assessment.all_expenses[key] =
                            location === 'lowest'
                                ? assessment.all_expenses[key].concat([_.clone(newYear)])
                                : [_.clone(newYear)].concat(assessment.all_expenses[key]);
                    });

                    //append year to all costs of sales
                    Object.keys(assessment.all_costs_of_sales).forEach(key => {
                        assessment.all_costs_of_sales[key] =
                            location === 'lowest'
                                ? assessment.all_costs_of_sales[key].concat([_.clone(newYear)])
                                : [_.clone(newYear)].concat(assessment.all_costs_of_sales[key]);
                    });

                    return assessment;
                })
                .catch(err => toastr.error('PL Sheet Creation Err - ', err));
        }

        function getRemoveYear(location, assessment, objectName) {
            return location === 'lowest'
                ? assessment[objectName].objects[assessment[objectName].objects.length - 1]
                : assessment[objectName].objects[0];
        }

        /**
         * Remove PL form assessment
         */

        function removePLYear(location, assessment) {
            const plSheet = getRemoveYear(location, assessment, 'profitlossstatements');

            assessment.profitlossstatements.objects = assessment.profitlossstatements.objects.filter(
                year => year.id !== plSheet.id
            );

            //delete year to all expenses
            Object.keys(assessment.all_expenses).forEach(function(key) {
                assessment.all_expenses[key] = assessment.all_expenses[key].filter(item => item.year !== plSheet.year);
            });

            //delete year to all costs of sales
            Object.keys(assessment.all_costs_of_sales).forEach(function(key) {
                assessment.all_costs_of_sales[key] = assessment.all_costs_of_sales[key].filter(
                    item => item.year !== plSheet.year
                );
            });

            return siScope
                .remove(plSheet.url)
                .then(() => assessment)
                .catch(err => {
                    toastr.error('Error Deleting PL year - ', err);
                    return $q.reject();
                });
        }

        /**
         * Remove balancesheet form assessment
         */
        function removeYearBalanceSheet(location, assessment) {
            const balanceSheet = getRemoveYear(location, assessment, 'balancesheets');

            //Manually remove the year from the BS.
            assessment.balancesheets.objects = assessment.balancesheets.objects.filter(
                year => year.id !== balanceSheet.id
            );

            return siScope
                .remove(balanceSheet.url)
                .then(() => assessment)
                .catch(err => toastr.error('Error Deleting BS year - ', err));
        }

        /**
         * Remove CashflowStatement form assessment
         */
        function removeYearCashflowStatement(location, assessment) {
            const cfSheet = getRemoveYear(location, assessment, 'cashflowstatements');

            assessment.cashflowstatements.objects = assessment.cashflowstatements.objects.filter(
                statement => statement.id !== cfSheet.id
            );

            return siScope
                .remove(cfSheet.url)
                .then(() => assessment)
                .catch(err => toastr.error('Error Deleting CF year - ', err));
        }
    }
})();

(function() {
    'use strict';

    /**
     * Assessee merge API. AD-2110.
     *
     * Two calls, kept apart on purpose. `preview` is read-only and safe to
     * repeat; `execute` is irreversible and is the only one that carries the
     * confirmation. Folding them into one call with a flag would make the
     * dangerous one reachable by changing a parameter.
     */
    angular.module('scope.commons.services').factory('siAssesseeMerge', AssesseeMerge);

    AssesseeMerge.$inject = ['siScope', 'apiUrl'];

    function AssesseeMerge(siScope, apiUrl) {
        const service = this;
        const base = apiUrl + '/customers/assessee-merge/';

        service.preview = preview;
        service.execute = execute;
        service.emptyConfirmation = emptyConfirmation;
        service.isFullyConfirmed = isFullyConfirmed;
        service.errorPayload = errorPayload;
        service.mergedIntoId = mergedIntoId;

        return service;

        /**
         * FR-067's three acknowledgements live here rather than in the
         * controller, because the karma harness loads `commons/` and not
         * `apps/` - logic left in the controller is logic no test can reach,
         * and this is the gate in front of an irreversible operation.
         */
        function emptyConfirmation() {
            return {
                duplicate_confirmed: false,
                retained_confirmed: false,
                direction_confirmed: false
            };
        }

        /** All three, and only against a comparison the server returned. */
        function isFullyConfirmed(comparison, confirmation) {
            const given = confirmation || {};
            return !!(comparison && given.duplicate_confirmed && given.retained_confirmed && given.direction_confirmed);
        }

        /**
         * The assessee this record was merged into, or `null`. FR-073.
         *
         * **The discriminator is both fields, and that is a judgement worth
         * reviewing.** `duplicate_of` is an older feature: a record can be
         * marked a duplicate by hand without ever having been merged, and
         * redirecting away from those would change behaviour this sprint was
         * not asked to touch. A merge sets `duplicate_of` *and* `is_active`
         * false, so both are required here.
         *
         * A record marked duplicate by hand and separately deactivated is
         * indistinguishable from a merged one, and would redirect. If that
         * matters, the merge needs its own marker - flagged rather than
         * assumed away.
         */
        function mergedIntoId(customer) {
            if (!customer || customer.is_active !== false) {
                return null;
            }
            const duplicateOf = customer.duplicate_of;
            if (!duplicateOf) {
                return null;
            }
            return angular.isObject(duplicateOf) ? duplicateOf.id || null : duplicateOf;
        }

        /**
         * Normalise a rejection. Two shapes reach a caller: `$http` rejects a
         * 4xx with the whole response, whose payload is on `.data`, while
         * `siScope.post` rejects with the payload itself when it sees a >=400
         * inside a resolved promise. Handling one shape turns a readable field
         * error into a generic failure message.
         */
        function errorPayload(rejection) {
            return (rejection && rejection.data) || rejection || {};
        }

        // `siScope.post` takes `{ url }`, not a URL string: given a string it
        // throws synchronously and no request is made.
        function preview(sourceId, targetId) {
            return siScope.post(
                { url: base + 'preview/' },
                {
                    source_id: sourceId,
                    target_id: targetId
                }
            );
        }

        /**
         * The confirmation travels in the payload because the server requires
         * it there (FR-067). The screen can be bypassed by anything that can
         * POST, and this is the one operation on the platform with no way back.
         */
        function execute(sourceId, targetId, confirmation) {
            return siScope.post(
                { url: base + 'execute/' },
                {
                    source_id: sourceId,
                    target_id: targetId,
                    confirmation: confirmation
                }
            );
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.services')
        .factory('siAllocations', siAllocations);

    siAllocations.$inject = ['Restangular', 'apiUrl', '$http'];

    function siAllocations(Restangular, apiUrl, $http) {

        var service = this;
        var invitations = Restangular.all('assessments')

        service.getInvitations = getInvitations;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getInvitations(params) {
            params = params ? params : {};
            return invitations.one('assessment_invitations').customGET('', params);
        }

    }

}());

(function() {
    'use strict';

    angular.module('scope.commons.services').factory('siAccounts', siAccounts);

    siAccounts.$inject = ['Restangular', 'apiUrl', '$http'];

    function siAccounts(Restangular, apiUrl, $http) {
        var service = this;

        var UserAccounts = Restangular.all('accounts');
        var isTrainee = location.href.indexOf('trainee') > -1;
        var isDev = location.href.indexOf('dev') > -1;
        var isTest = location.href.indexOf('test') > -1;

        service.requestPasswordReset = requestPasswordReset;
        service.applyPasswordReset = applyPasswordReset;
        service.getMe = getMe;
        service.DashboardGet = DashboardGet;
        service.validateToken = validateToken;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function getMe(params) {
            params = params ? params : {};
            return UserAccounts.one('users/me').customGET('', params);
        }

        function validateToken(token) {
            return UserAccounts.one('users/check_reset_token').customPOST({ token });
        }

        function DashboardGet(params) {
            params = params ? params : {};
            return UserAccounts.one('dashboard').customGET('', params);
        }

        function requestPasswordReset(email) {
            // To hide #SSO , uncomment and copy else as last line in this function
            // To debug, modify corresponding condition with `|| isLocal`
            if (isDev) {
                return $http.post(
                    'https://dev.api.scope.stamkracht.com/accounts/users/request_password_reset/',
                    { email },
                    {}
                );
            } else if (isTest) {
                return $http.post(
                    'https://api.scope.stamkracht.com/accounts/users/request_password_reset/',
                    { email },
                    {}
                );
            } else if (isTrainee) {
                return $http.post('https://api.scopeinsight.com/accounts/users/request_password_reset/', { email }, {});
            } else {
                return UserAccounts.one('users/request_password_reset/').customPOST({ email });
            }
        }

        function applyPasswordReset(password, token) {
            return UserAccounts.one('users/apply_password_reset/').customPOST({ token: token, password: password });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('base.reports', {
                url: '/reports/{page:[0-9]*}?search&ordering',
                views: {
                    'contentView@base': {
                        controller: [
                            '$state',
                            function($state) {
                                $state.go('base.assessments-list');
                            }
                        ]
                    }
                }
            })
            .state('base.reports-create', {
                url: '/reports/create',
                views: {
                    'contentView@base': {
                        templateUrl: 'reports/reportsCreateView.html',
                        controller: 'reportsController'
                    }
                }
            })
            .state('base.reports-detail', {
                abstract: true,
                url: '/reports/detail/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'reports/reportsDetailView.html',
                        controller: 'reportsDetailController'
                    }
                },
                redirectTo: 'reports-detail.summary'
            })
            .state('base.reports-detail.summary', {
                url: '', //default
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/summaryTab.html'
                    }
                }
            })
            .state('base.reports-detail.benchmarking', {
                url: '/benchmarking',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/benchmarkingTab.html'
                    }
                }
            })
            .state('base.reports-detail.scores', {
                url: '/scores',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/scoreSummaryTab.html'
                    }
                }
            })
            .state('base.reports-detail.observations', {
                url: '/observations',
                views: {
                    tabContent: {
                        controller: 'observationsTabController',
                        templateUrl: 'reports/reports-tabs/observationsTab.html'
                    }
                }
            })
            .state('base.reports-detail.section', {
                url: '/section/{section:[0-9]+}',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/questionnaireSectionTab.html',
                        controller: 'reportSectionController'
                    }
                }
            })
            .state('base.reports-detail.organizational', {
                url: '/organizational',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/organizationalTab.html'
                    }
                }
            })
            .state('base.reports-detail.valuechain', {
                url: '/valuechain',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/valueChainTab.html'
                    }
                }
            })
            .state('base.reports-detail.finance', {
                url: '/finance',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/financeTab.html'
                    }
                }
            })
            .state('base.reports-detail.financial-performance', {
                url: '/financial-performance',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/financialPerformanceTab.html'
                    }
                }
            })
            .state('base.reports-detail.profit-loss', {
                url: '/profit-loss',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/profitLossTab.html'
                    }
                }
            })
            .state('base.reports-detail.balancesheet', {
                url: '/balancesheet',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/balanceSheetTab.html'
                    }
                }
            })
            .state('base.reports-detail.cashflow', {
                url: '/cashflow',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/cashflowStatementTab.html'
                    }
                }
            })
            .state('base.reports-detail.monthly-production', {
                url: '/monthly-production',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/monthlyProductionTab.html'
                    }
                }
            })
            .state('base.reports-detail.governance', {
                url: '/governance',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/governanceTabView.html'
                    }
                }
            })
            .state('base.reports-detail.production', {
                url: '/production',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/productionTab.html'
                    }
                }
            })
            .state('base.reports-detail.documentation', {
                url: '/documentation',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/documentationTab.html'
                    }
                }
            })
            .state('base.reports-detail.finance-product', {
                url: '/finance-product',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/financeProductTabView.html'
                    }
                }
            })
            .state('base.reports-detail.dashboard-documentation', {
                url: '/dashboard-documentation',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/dashboardUsersDocumentationTab.html'
                    }
                }
            })
            .state('base.reports-detail.terms', {
                url: '/terms',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/termsTab.html'
                    }
                }
            })
            .state('base.reports-detail.dashboard-attachments', {
                url: '/dashboard-attachments',
                views: {
                    tabContent: {
                        templateUrl: 'reports/reports-tabs/dashboardUsersAttachmentsTab.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports').controller('reportsDetailController', reportsDetailController);

    reportsDetailController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$uibModal',
        '$timeout',
        '$log',
        '$q',
        '$http',
        'modalFactory',
        'apiUrl',
        'me',
        'siScope',
        'siReports',
        'siCustomers',
        'gettext',
        'gettextCatalog',
        '$stateParams',
        'moment',
        '$location',
        'EVENT_LOADER',
        '$window',
        'toastr',
        'siAssessments',
        'DataService'
    ];

    function reportsDetailController(
        $scope,
        $rootScope,
        $state,
        $uibModal,
        $timeout,
        $log,
        $q,
        $http,
        modalFactory,
        apiUrl,
        me,
        siScope,
        siReports,
        siCustomers,
        gettext,
        gettextCatalog,
        $stateParams,
        moment,
        $location,
        EVENT_LOADER,
        $window,
        toastr,
        siAssessments,
        DataService
    ) {
        var params = {
            id: $state.params.id,
            fields: [
                'assessment',
                'assessment__tool',
                'assessment__tool__type',
                'assessment__assessmentassignments',
                'assessment__assessmentassignments__assessor',
                'assessment__assessmentassignments__assessor__user',
                'assessment__unscored_section_responses',
                'assessment__section_responses',
                'assessment__section_responses__children',
                'assessment__section_responses__children__responses',
                'assessment__section_responses__children__responses__comment',
                'assessment__section_responses__children__responses__question',
                'assessment__section_responses__children__responses__subresponses',
                'assessment__section_responses__children__responses__subresponses__checked_options',
                'assessment__section_responses__children__responses__subresponses__selected_option',
                'assessment__section_responses__children__responses__subresponses__subquestion',
                'assessment__section_responses__children__responses__subresponses__subquestion__options',
                'assessment__section_responses__children__responses__documents',
                'assessment__section_responses__unscored_responses',
                'assessment__producing_organization',
                'assessment__producing_organization__customer',
                'assessment__producing_organization__activities',
                'assessment__producing_organization__sectors',
                'assessment__producing_organization__customer__representatives',
                'assessment__producing_organization__customer__contacts',
                'assessment__producing_organization__customer__contacts__user',
                'assessment__producing_organization__legal_status',
                'assessment__producing_organization_details',
                'assessment__producing_organization_details__services',
                'assessment__valuechainplayers',
                'assessment__valuechainplayers__relation_to_producing_organization',
                'assessment__enablingplayers',
                'assessment__enablingplayers__relation_to_producing_organization',
                'assessment__basic_financial_infos',
                'assessment__bank_accounts',
                'assessment__bank_accounts__bank_type',
                'assessment__collateral_assets',
                'assessment__loan_histories',
                'assessment__loan_histories__financier',
                'assessment__loan_histories__repayment_status',
                'assessment__loan_histories__purpose',
                'assessment__loan_requirements',
                'assessment__grant_histories',
                'assessment__grant_histories__in_cash_in_kind',
                'assessment__grant_histories__funder_type',
                'assessment__monthlyexpensesprojection_set',
                'assessment__monthlyincomeprojection_set',
                'assessment__products',
                'assessment__products__type',
                'assessment__products__productionfigures',
                'assessment__products__productionpurchases',
                'assessment__products__otherproductionpurchases',
                'assessment__products__productionsales',
                'assessment__products__certifications',
                'assessment__document_availability_responses',
                'assessment__document_availability_responses__question',
                'assessment__document_availability_responses__documents',
                'assessment__profitlossstatements',
                'assessment__balancesheets',
                'assessment__cashflowstatements',
                'assessment__financial_ratios',
                'assessment__financial_scores',
                'assessment__ratio_scores',
                'assessment__report_revision_reason',
                'assessment__general_checks',
                'assessment__executive_set',
                'assessment__nonexecutive_set',
                'assessment__governance_set',
                'assessment__responses',
                'assessment__responses__documents',
                'assessment__project',
                'assessment__terms_and_conditions',
                'assessment__is_invalidated',
                'assessment__invalidation_reason',
                'customers',
                'customers__contacts',
                'customers__contacts__user'
            ]
        };

        $scope.months = [
            gettext('jan'),
            gettext('feb'),
            gettext('mrt'),
            gettext('apr'),
            gettext('may'),
            gettext('jun'),
            gettext('jul'),
            gettext('aug'),
            gettext('sep'),
            gettext('oct'),
            gettext('nov'),
            gettext('dec')
        ];

        const months = [
            { value: 'january', display: gettextCatalog.getString('january') },
            { value: 'february', display: gettextCatalog.getString('february') },
            { value: 'march', display: gettextCatalog.getString('march') },
            { value: 'april', display: gettextCatalog.getString('april') },
            { value: 'may', display: gettextCatalog.getString('may') },
            { value: 'june', display: gettextCatalog.getString('june') },
            { value: 'july', display: gettextCatalog.getString('july') },
            { value: 'august', display: gettextCatalog.getString('august') },
            { value: 'september', display: gettextCatalog.getString('september') },
            { value: 'october', display: gettextCatalog.getString('october') },
            { value: 'november', display: gettextCatalog.getString('november') },
            { value: 'december', display: gettextCatalog.getString('december') }
        ];

        $scope.translateMonth = translateMonth;
        $scope.language = language;
        $scope.openCustomPDFModal = openCustomPDFModal;
        function language() {
            return JSON.parse(localStorage['ngStorage-user']).info.language;
        }
        function translateMonth(month) {
            return months.filter(item => item.value === month)[0].display;
        }

        $scope.benchMarkUrl = apiUrl + '/media/reports/graphs/benchmark_' + $stateParams.id + '.png';
        $scope.poUrl = apiUrl + '/media/reports/graphs/po_' + $stateParams.id + '.png';
        $scope.isDashboardUserAdmin = me.isDashboardUserAdmin() || $rootScope.app === 'smartclient';
        $scope.isEmployee = me.isEmployee();
        $scope.stepCircles =
            $scope.isDashboardUserAdmin || $rootScope.app === 'smartclient'
                ? [gettext('assessment'), gettext('draft'), gettext('finalized')]
                : [gettext('assessment'), gettext('draft'), gettext('finalized'), gettext('published (optional)')];

        isUserAllowedOnState();

        $scope.$on('$stateChangeStart', ($event, toState) => isUserAllowedOnState(toState));

        $rootScope.$broadcast(EVENT_LOADER.show);

        const customersParams = {
            producing_organization: false,
            page_size: 9999
        };

        $scope.testing = function(data) {
            console.log('MADE IT');
            console.log(data);
        };

        $scope.taDropdownFunc = () => {
            $scope.taDropdown = !$scope.taDropdown;
        };

        const customersPromise = siCustomers.getCustomers(customersParams),
            reportsPromise = siReports.getReport_Id(params);

        $q.all([customersPromise, reportsPromise])
            .then(promises => {
                [$scope.customers, $scope.report] = promises;

                $scope.documents = $scope.report.assessment.responses.objects
                    .filter(response => response.documents.objects.length)
                    .map(response => {
                        return response.documents.objects
                            .map(document => ({ response, document }))
                            .reduce((memo, object) => object, {});
                    })
                    .sort((a, b) => {
                        if (a.response.question_display_position > b.response.question_display_position) return 1;
                        if (a.response.question_display_position < b.response.question_display_position) return -1;
                        return 0;
                    });

                $scope.breadcrumbs = [
                    {
                        name: me.isDashboardUserAdmin() ? gettext('Assessments') : gettext('Reports'),
                        url: me.isDashboardUserAdmin() ? 'base.assessments-list' : 'base.reports'
                    },
                    { name: me.isDashboardUserAdmin() ? gettext('Summary') : gettext('Report'), id: $scope.report.id }
                ];

                $scope.report.scores = {
                    score_total_text:
                        $scope.report && $scope.report.assessment
                            ? parseFloat($scope.report.assessment.score).toFixed(1)
                            : ''
                };

                $scope.ax_invalidated = $scope.report.assessment.is_invalidated;

                _.each($scope.report.assessment.section_responses.objects, section => {
                    $scope.report.scores[section.section_title.replace(' ', '_')] = section.score
                        ? parseFloat(section.score).toFixed(1)
                        : 0;
                });

                $scope.activeStep = setActiveStep($scope.report.status);
                if (
                    $scope.report.report_published ||
                    $scope.report.profile_published ||
                    $scope.report.summary_published
                ) {
                    $scope.activeStep = setActiveStep('published');
                }

                $rootScope.$broadcast(EVENT_LOADER.hide);
                console.log('Report - ', $scope.report);
            })
            .catch(err => {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                toastr.error('An Error has occurred while fetching the Report, please contact administration.');
            });

        $scope.togglePublish = togglePublish;
        $scope.reviseModal = reviseModal;
        $scope.adminMode = adminMode;
        $scope.invalidateAssessment = invalidateAssessment;
        $scope.validateAssessment = validateAssessment;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isUserAllowedOnState(toState = {}) {
            const state = toState.name || $state.current.name;

            const dashboardUserAllowedStates = [
                'base.reports-detail.summary',
                'base.reports-detail.dashboard-documentation',
                'base.reports-detail.dashboard-attachments'
            ];

            if ($scope.isDashboardUserAdmin) {
                const isUserAllowedOnState = dashboardUserAllowedStates
                    .filter(stateName => state === stateName)
                    .reduce(() => true, false);

                if (!isUserAllowedOnState) {
                    //Chop the path to be the summmary url of the report page.
                    $location.path($location.path().slice(0, $location.path().lastIndexOf('/')));
                }
            }
        }

        function togglePublish(type) {
            var patch = {
                url: $scope.report.url
            };

            patch[type + '_published'] = $scope.report[type + '_published'];

            siScope.patch(patch).then(res => {
                _.extend($scope.report, res);
                if (res.report_published || res.profile_published || res.summary_published) {
                    $scope.activeStep = setActiveStep('published');
                } else {
                    $scope.activeStep = setActiveStep('final');
                }
            });
        }

        function reviseModal(report) {
            const reviseModal = {
                templateUrl: 'reports/modals/reviseModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    function($scope, $uibModalInstance) {
                        $scope.report_revision_reason = '';

                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.revise = () => $uibModalInstance.close($scope.report_revision_reason);
                    }
                ]
            };
            return $uibModal.open(reviseModal).result.then(report_revision_reason => {
                const obj = {
                    url: `${apiUrl}/assessments/assessments/${report.assessment.id}/`,
                    report_revision_reason,
                    rapid_finalized: false
                };
                console.log(obj);
                $rootScope.$broadcast(EVENT_LOADER.show);
                siScope
                    .patch(obj)
                    .then(function() {
                        $scope.removeReport($scope.report);
                    })
                    .catch(() => {
                        toastr.error('Error while revising report');
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            });
        }

        function adminMode(report) {
            if ($scope.isEmployee) {
                var patch = {
                    url: report.url,
                    in_edit: true
                };

                siScope
                    .patch(patch)
                    .then(res => {
                        _.extend($scope.report, res);
                    })
                    .then(function() {
                        $state.go('base.assessments-assignment-detail.assessment', {
                            id: report.assessment.assessmentassignments.objects[0].id
                        });
                    })
                    .catch(() => {
                        toastr.error('Error while accessing admin mode');
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            }
        }

        function openCustomPDFModal(report) {
            var customPDFModal = {
                templateUrl: 'reports/modals/customPDFModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'report',
                    function($scope, $uibModalInstance, report) {
                        $scope.report = report;
                        console.log($scope.report, '------------------------------------');
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.generateReport = () => $uibModalInstance.close($scope.report);
                    }
                ],
                resolve: {
                    report: () => report
                }
            };
            return $uibModal.open(customPDFModal).result.then(updatedReport => {
                $rootScope.$broadcast(EVENT_LOADER.show);
                // render the PDF using the servers capabilities
                $http({
                    url: apiUrl + '/reports/reports/' + updatedReport.id + '/render_modular_report/',
                    method: 'GET',
                    responseType: 'arraybuffer',
                    params: {
                        report_sections: JSON.stringify(updatedReport.report_sections)
                    }
                })
                    .then(function(data) {
                        function capitalizeFirstLetter(string) {
                            return string.charAt(0).toUpperCase() + string.slice(1);
                        }
                        var blob = new Blob([data.data], { type: 'application/pdf' });
                        saveAs(
                            blob,
                            updatedReport.assessment.producing_organization.customer.name +
                                '.' +
                                updatedReport.assessment.start_date +
                                '.' +
                                capitalizeFirstLetter(updatedReport.assessment.tool.type.name) +
                                '_MODULAR_' +
                                capitalizeFirstLetter(updatedReport.status) +
                                '.pdf'
                        );
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    })
                    .catch(function(err) {
                        toastr.error('Error DL PDF - ', err);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            });
        }

        function invalidateAssessment(report) {
            var invalidateAssessmentModal = {
                templateUrl: 'reports/modals/invalidateAssessmentModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'report',
                    function($scope, $uibModalInstance, report) {
                        $scope.report = report;

                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.invalidate = () => $uibModalInstance.close($scope.report);
                    }
                ],
                resolve: {
                    report: () => report
                }
            };
            return $uibModal.open(invalidateAssessmentModal).result.then(updatedReport => {
                var obj = {
                    url: apiUrl + '/assessments/assessments/' + report.assessment.id + '/',
                    invalidation_reason: updatedReport.assessment.invalidation_reason,
                    is_invalidated: true
                };
                siScope.patch(obj);
                $scope.ax_invalidated = true;
            });
        }

        function validateAssessment(report) {
            $scope.report = report;
            var obj = {
                url: apiUrl + '/assessments/assessments/' + report.assessment.id + '/',
                invalidation_reason: ' ',
                is_invalidated: false
            };

            siScope
                .patch(obj)
                .then(function() {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    _.extend($scope.report.assessment, obj);
                })
                .catch(err => {
                    toastr.error('Error Invalidating Assessment - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
            $scope.ax_invalidated = false;
        }

        function setActiveStep(status) {
            if (status === 'draft') {
                return status;
            }

            if (status === 'final') {
                return 'finalized';
            }

            if (status === 'published') {
                return 'published (optional)';
            }
        }

        /**
         * Function to get the proper response for a given question from the list of responses
         * @param question assessment question object
         * @param responses assessment response object
         * @returns response object for given question
         */
        $scope.responseForQuestion = function(question, responses) {
            for (var r in responses) {
                if (responses[r].question.id == question.id) {
                    return responses[r];
                }
            }
        };

        /**
         * Function to get the proper report template for the given tool
         * @param tool assessment tool object
         * @returns string location of the report template
         */
        $scope.getReportTemplate = function(tool) {
            return tool ? 'reports/tool/' + tool.type.name + 'Report.html' : '';
        };

        /**
         * Function to delete the given report
         * @param report object
         */
        $scope.deleteReport = function(report) {
            siScope.remove(report.url).then(function() {
                $state.transitionTo('base.reports');
            });
        };

        /**
         * Function to change the report state into final
         */
        $scope.finalizeReport = function(report) {
            var obj = {
                url: apiUrl + '/reports/reports/' + report.id + '/',
                status: 'final'
            };
            $rootScope.$broadcast(EVENT_LOADER.show);
            siScope.patch(obj).then(function() {
                report.status = 'final';
                if (report.report_published || report.profile_published || report.summary_published) {
                    $scope.activeStep = setActiveStep('published');
                }
                $scope.activeStep = setActiveStep('final');
                $window.location.reload();
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        };

        /**
         * Remove report from API
         * @param report remove the selected report from the list
         */
        $scope.removeReport = function(report) {
            var url = apiUrl + '/reports/reports/' + report.id + '/';
            siScope.remove(url).then(function() {
                $state.go('base.assessments-assignment-detail.assessment', {
                    id: report.assessment.assessmentassignments.objects[0].id
                });
            });
        };

        $scope.downloadActionPlan = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/ta_plan/',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(data => {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    console.log('Error while Generating Action Plan - ', data);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while Generating Action Plan - ', data);
                }

                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    report.assessment.producing_organization.customer.name +
                        '.' +
                        report.assessment.start_date +
                        '.' +
                        report.assessment.tool.type.name +
                        '_Action_Plan_' +
                        report.status +
                        '.pdf'
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        };

        $scope.exportToJSON = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            report.assessment.project.assessments = [];
            report.assessment.producing_organization.customer.assessments = [];
            //const dataStr = JSON.stringify(report.assessment, null, 4); // Pretty-print JSON
            const filteredData = JSON.stringify($scope.generateJSON(report.assessment), null, 4);
            var blob = new Blob([filteredData], { type: 'application/pdf' });
            saveAs(
                blob,
                report.assessment.producing_organization.customer.name +
                    '.' +
                    report.assessment.start_date +
                    '.' +
                    report.assessment.tool.type.name +
                    '_A2f_Plan_' +
                    report.status +
                    '.json'
            );
            $rootScope.$broadcast(EVENT_LOADER.hide);
        };

        $scope.AITABuilder = function(report) {
            $location.path('/aitabuilder/' + report.id);
        };

        $scope.downloadA2fPlan = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $http({
                url: apiUrl + '/customers/producing_organizations/export_orgs_pdf/',
                method: 'GET',
                params: {
                    status: 'has_final',
                    ids: report.assessment.producing_organization.id,
                    is_a2f_html: true
                },
                responseType: 'arraybuffer'
            }).then(data => {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    console.log('Error while Generating Action Plan - ', data);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while Generating Action Plan - ', data);
                }

                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    report.assessment.producing_organization.customer.name +
                        '.' +
                        report.assessment.start_date +
                        '.' +
                        report.assessment.tool.type.name +
                        '_A2f_Plan_' +
                        report.status +
                        '.pdf'
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        };

        /**
         * Render report to pdf
         */
        // `style` (AD-2202): 'classic' or 'v2' picks one design of the report; without it the
        // server sends the default the rollout flags select.
        $scope.toPDF = function(report, style) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            // render the PDF using the servers capabilities
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/pdf/',
                method: 'GET',
                params: style ? { style: style } : undefined,
                responseType: 'arraybuffer'
            }).then(function(data) {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    console.log('Error while downloading PDF - ', data);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while downloading PDF - ', data);
                }
                console.log(data, 'this is the data');
                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    report.assessment.producing_organization.customer.name +
                        '.' +
                        report.assessment.start_date +
                        '.' +
                        capitalizeFirstLetter(report.assessment.tool.type.name) +
                        '_Report_' +
                        capitalizeFirstLetter(report.status) +
                        (style === 'v2' ? '_New_Design' : style === 'classic' ? '_Classic' : '') +
                        '.pdf'
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
            // .catch(function(err) {
            //     console.log('Error DL PDF - ', err);
            //     toastr.error('lalalalalallalalalal');
            //     $rootScope.$broadcast(EVENT_LOADER.hide);
            // });
        };

        $scope.toSummarizedPDF = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            var summarySections = [
                'ch1_assessment-details',
                'ch2-1_organizational-details',
                'ch2-2_organizational-details',
                'ch3_assessment-results',
                'summary',
                'benchmarking',
                'ch4_business-performance',
                'products-sections',
                'documentation'
            ];
            report.report_sections.forEach(x => {
                if (summarySections.includes(x.name)) {
                    x.value = true;
                }
            });
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/render_modular_report/',
                method: 'GET',
                responseType: 'arraybuffer',
                params: {
                    report_sections: JSON.stringify(report.report_sections)
                }
            })
                .then(function(data) {
                    function capitalizeFirstLetter(string) {
                        return string.charAt(0).toUpperCase() + string.slice(1);
                    }
                    var blob = new Blob([data.data], { type: 'application/pdf' });
                    saveAs(
                        blob,
                        report.assessment.producing_organization.customer.name +
                            '.' +
                            report.assessment.start_date +
                            '.' +
                            capitalizeFirstLetter(report.assessment.tool.type.name) +
                            '_MODULAR_' +
                            capitalizeFirstLetter(report.status) +
                            '.pdf'
                    );
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    toastr.error('Error DL PDF - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        $scope.toExecutiveSummaryPDF = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            // render the PDF using the servers capabilities
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/summary_pdf/',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(data) {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while downloading Summary PDF');
                }
                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    report.assessment.producing_organization.customer.name +
                        '.' +
                        report.assessment.start_date +
                        '.' +
                        capitalizeFirstLetter(report.assessment.tool.type.name) +
                        '_Summary_' +
                        capitalizeFirstLetter(report.status) +
                        '.pdf'
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
            // .catch(function(err) {
            //     console.log('Error DL PDF - ', err);
            //     $rootScope.$broadcast(EVENT_LOADER.hide);
            // });
        };

        $scope.toAmharicSummaryPDF = report => {
            $rootScope.$broadcast(EVENT_LOADER.show);

            // render the PDF using the servers capabilities
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/render_amharic_pdf/',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(data) {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while downloading Amharic PDF');
                }
                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    report.assessment.producing_organization.customer.name +
                        '.' +
                        report.assessment.start_date +
                        '.' +
                        capitalizeFirstLetter(report.assessment.tool.type.name) +
                        '_Summary_Amharic_' +
                        capitalizeFirstLetter(report.status) +
                        '.pdf'
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
            // .catch(function(err) {
            //     console.log('Error DL PDF - ', err);
            //     $rootScope.$broadcast(EVENT_LOADER.hide);
            // });
        };

        $scope.toProfilePDF = function(report) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            // render the PDF using the servers capabilities
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/profile_pdf/',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(data) {
                if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error('Error while downloading Profile PDF');
                }
                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }

                var blob = new Blob([data.data], { type: 'application/pdf' });
                saveAs(
                    blob,
                    `${report.assessment.producing_organization.customer.name}.${
                        report.assessment.start_date
                    }.${capitalizeFirstLetter(report.assessment.tool.type.name)}_Profile_${capitalizeFirstLetter(
                        report.status
                    )}.pdf`
                );
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
            // .catch(function(err) {
            //     console.log('Error DL profile PDF - ', err);
            //     $rootScope.$broadcast(EVENT_LOADER.hide);
            // });
        };

        /**
         * Function to check if a response is applicable for the current PO,
         * this depends on the customizations in the tool (available on
         * conditions in the response object) and the current settings of a
         * PO on:
         * - Activities
         * - Sector
         * - po type
         * - country
         * - products
         *
         * @param response    question response object with conditionals
         * @param assessment  assessment object with nested information
         * @returns boolean   true if all conditions are met, otherwise returns false
         */
        $scope.responseApplicable = function(response, assessment) {
            //Check if the conditions object is empty,
            //which means we have no customizations, thus simply return true
            //otherwise go further onto the nasty boolean below

            if (_.isEmpty(response.conditions)) {
                return true;
            }

            //Looks like conditions is not empty so lets check our values
            //The first check is always to be sure our condition arrays children have a populated array.
            //The second check looks if the conditions specified actually exist on the assessment

            if (
                !response.conditions.sectors.length &&
                _.intersection(response.conditions.sectors, assessment.producing_organization.sectors.objects).length
            )
                return true;
            else if (
                !response.conditions.po_types.length &&
                _.filter(response.conditions.po_types, function(type) {
                    return type.url === assessment.producing_organization.legal_status;
                }).length
            )
                return true;
            else if (
                !response.conditions.countries.length &&
                _.intersection(response.conditions.countries, [assessment.producing_organization.country]).length
            )
                return true;
            else if (
                !response.conditions.activities.length &&
                _.intersection(response.conditions.activities, assessment.producing_organization.activities.objects)
                    .length
            )
                return true;
            else if (
                !response.conditions.products.length &&
                _.intersection(response.conditions.products, _.pluck(assessment.products.objects, 'type')).length
            )
                return true;
            else return false;

            /*

            var shouldBeShown =
                //Check that our activity conditions are in the assessment
                (!response.conditions.activities.length ||
                    _.intersection(response.conditions.activities, assessment.producing_organization.activities.objects)
                        .length) &&
                //Check that our sectors conditions are in the assessment
                (!response.conditions.sectors.length ||
                    _.intersection(response.conditions.sectors, assessment.producing_organization.sectors.objects)
                        .length) &&
                //Check that our po_types conditions match the po customer type
                (!response.conditions.po_types.length ||
                    _.filter(response.conditions.po_types, function(type) {
                        return type.url === assessment.producing_organization.legal_status;
                    }).length) &&
                //Check that our countries conditions match the po country
                (!response.conditions.countries.length ||
                    _.intersection(response.conditions.countries, [assessment.producing_organization.country])
                        .length) &&
                //check that the product conditions are in the assessment products of type
                (!response.conditions.products.length ||
                    _.intersection(response.conditions.products, _.pluck(assessment.products.objects, 'type')).length);

            return !!shouldBeShown;
            */
        };

        $scope.generateJSON = function(assessment) {
            const sections = assessment.section_responses.objects;
            return {
                fo_name: assessment.producing_organization.name,
                fo_location: assessment.producing_organization.country,
                legal_structure: assessment.producing_organization.legal_status.display_name,
                tool:
                    assessment.tool_name +
                    ' ' +
                    assessment.tool_version_major +
                    '.' +
                    assessment.tool_version_minor +
                    '.' +
                    assessment.tool_version_revision,
                language: assessment.language,
                assessment_date: assessment.date,
                total_score: parseFloat(assessment.score),
                number_of_members: {
                    active: assessment.producing_organization_details.number_of_active_members,
                    total: assessment.producing_organization_details.number_of_members
                },
                dimensions: sections.map(section => ({
                    dimension: section.section_title,
                    dimension_weight: section.weight,
                    dimension_score: parseFloat(section.score),
                    sub_dimensions: section.children.objects.map(sub_section => ({
                        sub_dimension: sub_section.section_title,
                        sub_dimension_score: parseFloat(sub_section.score),
                        sections: sub_section.responses.objects.map(response => ({
                            section: response.question_display_position + ' ' + response.question.title,
                            questions: response.subresponses.objects.map(subresponse => {
                                // Check if it's a checkbox/multiple choice question
                                if (subresponse.subquestion.type === 'checkbox') {
                                    return {
                                        question: subresponse.subquestion.title,
                                        question_score: parseFloat(subresponse.score),
                                        answer_options: [
                                            ...subresponse.subquestion.options.objects.map(option => ({
                                                option: option.title,
                                                checked:
                                                    subresponse.checked_options.objects.findIndex(
                                                        item => item.id === option.id
                                                    ) > -1
                                            })),
                                            ...(subresponse.can_be_none_of_the_above
                                                ? [
                                                      {
                                                          option: 'None of the above',
                                                          checked: subresponse.none_of_the_above
                                                      }
                                                  ]
                                                : []),
                                            ...(subresponse.can_be_not_relevant
                                                ? [
                                                      {
                                                          option: 'Not relevant',
                                                          checked: subresponse.not_relevant
                                                      }
                                                  ]
                                                : [])
                                        ]
                                    };
                                } else if (subresponse.subquestion.type === 'mpc') {
                                    return {
                                        question: subresponse.subquestion.title,
                                        question_score: parseFloat(subresponse.score),
                                        answer_options: [
                                            ...subresponse.subquestion.options.objects.map(option => ({
                                                option: option.title,
                                                checked: subresponse.selected_option
                                                    ? subresponse.selected_option.id === option.id
                                                    : false
                                            })),
                                            ...(subresponse.can_be_none_of_the_above
                                                ? [
                                                      {
                                                          option: 'None of the above',
                                                          checked: subresponse.none_of_the_above
                                                      }
                                                  ]
                                                : []),
                                            ...(subresponse.can_be_not_relevant
                                                ? [
                                                      {
                                                          option: 'Not relevant',
                                                          checked: subresponse.not_relevant
                                                      }
                                                  ]
                                                : [])
                                        ]
                                    };
                                } else {
                                    // Format for non-checkbox/non-multiple choice questions (e.g., numeric, text)
                                    const result = {
                                        question: subresponse.subquestion.title,
                                        question_score: parseFloat(subresponse.score),
                                        answer: subresponse.value || subresponse.text || 'N/A'
                                    };
                                    if (subresponse.can_be_not_relevant) {
                                        result.not_relevant = subresponse.not_relevant;
                                    }
                                    return result;
                                }
                            })
                        }))
                    }))
                }))
            };
        };

        /*
        $scope.generateJSONForAITABuilder = function(assessment) {
            const sections = assessment.section_responses.objects;
            return {
                fo_name: assessment.producing_organization.name,
                fo_location: assessment.producing_organization.country,
                legal_structure: assessment.producing_organization.legal_status.display_name,
                tool:
                    assessment.tool_name +
                    ' ' +
                    assessment.tool_version_major +
                    '.' +
                    assessment.tool_version_minor +
                    '.' +
                    assessment.tool_version_revision,
                language: assessment.language,
                assessment_date: assessment.date,
                total_score: assessment.score,
                number_of_members: {
                    active: assessment.producing_organization_details.number_of_active_members,
                    total: assessment.producing_organization_details.number_of_members
                },
                dimensions: sections
                    .map(section => ({
                        dimension: section.section_title,
                        dimension_weight: section.weight,
                        dimension_score: section.score,
                        sub_dimensions: section.children.objects
                            .map(sub_section => ({
                                sub_dimension: sub_section.section_title,
                                sub_dimension_score: sub_section.score,
                                sections: sub_section.responses.objects.map(response => ({
                                    section: response.question_display_position + ' ' + response.question.title,
                                    questions: response.subresponses.objects
                                        .map(subresponse => {
                                            if (subresponse.subquestion.type === 'checkbox') {
                                                return {
                                                    question: subresponse.subquestion.title,
                                                    question_score: subresponse.score,
                                                    answer_options: [
                                                        ...subresponse.subquestion.options.objects.map(option => ({
                                                            option: option.title,
                                                            checked:
                                                                subresponse.checked_options.objects.findIndex(
                                                                    item => item.id === option.id
                                                                ) > -1
                                                        })),
                                                        ...(subresponse.can_be_none_of_the_above
                                                            ? [
                                                                  {
                                                                      option: 'None of the above',
                                                                      checked: subresponse.none_of_the_above
                                                                  }
                                                              ]
                                                            : []),
                                                        ...(subresponse.can_be_not_relevant
                                                            ? [
                                                                  {
                                                                      option: 'Not relevant',
                                                                      checked: subresponse.not_relevant
                                                                  }
                                                              ]
                                                            : [])
                                                    ]
                                                };
                                            } else if (subresponse.subquestion.type === 'mpc') {
                                                return {
                                                    question: subresponse.subquestion.title,
                                                    question_score: subresponse.score,
                                                    answer_options: [
                                                        ...subresponse.subquestion.options.objects.map(option => ({
                                                            option: option.title,
                                                            checked: subresponse.selected_option
                                                                ? subresponse.selected_option.id === option.id
                                                                : false
                                                        })),
                                                        ...(subresponse.can_be_none_of_the_above
                                                            ? [
                                                                  {
                                                                      option: 'None of the above',
                                                                      checked: subresponse.none_of_the_above
                                                                  }
                                                              ]
                                                            : []),
                                                        ...(subresponse.can_be_not_relevant
                                                            ? [
                                                                  {
                                                                      option: 'Not relevant',
                                                                      checked: subresponse.not_relevant
                                                                  }
                                                              ]
                                                            : [])
                                                    ]
                                                };
                                            } else {
                                                const result = {
                                                    question: subresponse.subquestion.title,
                                                    question_score: subresponse.score,
                                                    answer: subresponse.value || subresponse.text || 'N/A'
                                                };
                                                if (subresponse.can_be_not_relevant) {
                                                    result.not_relevant = subresponse.not_relevant;
                                                }
                                                return result;
                                            }
                                        })
                                        .sort((a, b) => a.question_score - b.question_score) // 🔹 sort questions ASC
                                }))
                            }))
                            .sort((a, b) => a.sub_dimension_score - b.sub_dimension_score) // 🔹 sort sub-dimensions ASC
                    }))
                    .sort((a, b) => a.dimension_score - b.dimension_score) // 🔹 sort dimensions ASC
            };
        };
        */
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports').controller('reportsController', reportsController);

    reportsController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$uibModal',
        '$q',
        '$timeout',
        'modalFactory',
        'me',
        'apiUrl',
        'siScope',
        'siReports',
        'siCustomers',
        'gettext',
        '$location',
        'moment',
        'EVENT_LOADER'
    ];

    function reportsController(
        $scope,
        $rootScope,
        $state,
        $uibModal,
        $q,
        $timeout,
        modalFactory,
        me,
        apiUrl,
        siScope,
        siReports,
        siCustomers,
        gettext,
        $location,
        moment,
        EVENT_LOADER
    ) {
        var customersParams = {
            producing_organization: false,
            page_size: 9999
        };
        var reportParams = {
            ordering: '-modified_at',
            search: $scope.search,
            page: $state.params.page || 1,
            page_size: 20
        };

        _.extend(reportParams, $location.search());

        var customersPromise = siCustomers.getCustomers(customersParams),
            reportsPromise = siReports.getReports(reportParams);

        $rootScope.$broadcast(EVENT_LOADER.show);

        $scope.description = gettext('You can search by country, PO name, project name or a combination of those.');

        $scope.isValid = isValid;
        $scope.removeReport = removeReport;
        $scope.save = save;

        $q.all([customersPromise, reportsPromise])
            .then(function(promises) {
                $scope.customers = promises[0];
                $scope.reports = promises[1];
                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                console.log('Reports Controller err -', err);
            });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function save(report) {
            // FIXME: old uploading unit
            var url = { url: apiUrl + '/reports/reports/' };
            siScope
                .post(url, report)
                // reportsResourceervice.ReportCreate(report,
                .then(function(error, data) {
                    $state.transitionTo('reports-detail.summary', { id: data.id });
                });
        }

        function isValid(report) {
            return moment(report.modified_at).isAfter(moment().subtract(1, 'year'));
        }

        /**
         * Remove report from API
         * @param report remove the selected report from the list
         */
        function removeReport(report) {
            modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to delete this report?'),
                actions: [
                    {
                        label: gettext('Yes, revise report'),
                        fn: function() {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            var url = apiUrl + '/reports/reports/' + report.id + '/';
                            siScope.remove(url).then(function() {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                                $scope.reports.results.splice($scope.reports.results.indexOf(report), 1);
                            });
                        }
                    }
                ]
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports').controller('reportSectionController', reportSectionController);

    reportSectionController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$uibModal',
        '$timeout',
        'modalFactory',
        'me',
        'EVENT_LOADER',
        '$log',
        'siReports',
        'toastr'
    ];

    function reportSectionController(
        $scope,
        $rootScope,
        $state,
        $uibModal,
        $timeout,
        modalFactory,
        me,
        EVENT_LOADER,
        $log,
        siReports,
        toastr
    ) {
        $scope.depth = 16;

        var params = {
            id: $state.params.id,
            fields: [
                'assessment',
                'assessment__section_responses',
                'assessment__section_responses__children',
                'assessment__section_responses__children__responses',
                'assessment__section_responses__children__responses__subresponses',
                'assessment__section_responses__children__responses__documents',
                'assessment__section_responses__unscored_responses',
                'assessment__producing_organization',
                'assessment__producing_organization__customer',
                'assessment__products'
            ]
        };

        $rootScope.$broadcast(EVENT_LOADER.show);

        siReports
            .getReport_Id(params)
            .then(function(report) {
                $scope.report = report;

                report.assessment.section_responses.objects.forEach(function(section) {
                    section.children.objects = _.sortBy(section.children.objects, function(child) {
                        return parseFloat(child.section_display_position);
                    });
                });

                //get the current section
                $scope.section = _.find(report.assessment.section_responses.objects, function(item) {
                    return item.id === parseInt($state.params.section);
                });

                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                toastr.error('Error Fetching Report - ', err);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports').controller('observationsTabController', observationsTabController);

    observationsTabController.$inject = ['$scope', '$sce'];

    function observationsTabController($scope, $sce) {
        $scope.formatObservation = formatObservation;

        function formatObservation(observation) {
            if (!observation) return '';
            const withBreaks = observation.replace(/\n/g, '<br>');
            return $sce.trustAsHtml(withBreaks);
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.commons.modals', [])
      .config(config);

    config.$inject = ['$injector', 'modalProvider'];

    function config($injector, modalProvider) {
      var gettext = $injector.get('gettext');

      modalProvider.addDefaultAction({
        label: gettext('Cancel')
      });
    }

}());

(function() {
    'use strict';

    angular.module('scope.commons.modals').provider('modal', modalProvider);

    function modalProvider() {
        var defaultActions = [];

        this.addDefaultAction = function(action) {
            action = _.extend(action, { isDefault: true });
            defaultActions.push(action);
        };

        this.$get = get;

        get.$inject = ['$uibModal'];

        function get($uibModal) {
            return function(templateUrl, context) {
                return $uibModal.open({
                    templateUrl: templateUrl,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'context',
                        function($scope, $uibModalInstance, context) {
                            $scope.$uibModalInstance = $uibModalInstance;

                            context.actions = (context.actions || []).concat(defaultActions);

                            // make context bindable in views
                            _.extend($scope, context);

                            $scope.applyAction = function(fn) {
                                if (_.isFunction(fn)) {
                                    var fnResult = fn.apply(this, [$scope]);
                                    return $uibModalInstance.close(fnResult);
                                }
                                return $uibModalInstance.dismiss();
                            };
                        }
                    ],
                    resolve: {
                        context: function() {
                            if (!_.isObject(context)) throw Error('Expecting an object for context');
                            return context;
                        }
                    }
                });
            };
        }
    }
})();

(function() {
    'use strict';
    angular.module('scope.commons.modals').factory('modalFactory', modalFactory);

    modalFactory.$inject = ['modal'];

    function modalFactory(modal) {
        return {
            ConfirmModal: context => modal('modals/templates/confirm-modal/confirmModalView.html', context)
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.faq', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('base.faq', {
            url: '/faq/',
            views: {
                'contentView@base': {
                    templateUrl: 'faq/faqView.html'
                    // controller: 'faqController'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.faq').controller('faqController', faqController);

    faqController.$inject = [];

    function faqController() {}
})();

(function () {

    'use strict';

    angular.module('scope.commons.comments', [
      'ui.bootstrap',
      'ui.router'
    ]);

}());
(function() {
    'use strict';

    angular.module('scope.commons.cache', ['ui.router', 'ui.bootstrap', 'scope.commons', 'angular-md5']).run(run);

    run.$inject = [
        '$rootScope',
        '$q',
        '$log',
        '$http',
        '$state',
        '$uibModal',
        '$interval',
        '$window',
        'fsFactory',
        'offline',
        'authenticationService',
        'toastr',
        'siScope',
        'apiUrl',
        '$localStorage',
        '$timeout',
        'IDB',
        'APP'
    ];

    function run(
        $rootScope,
        $q,
        $log,
        $http,
        $state,
        $uibModal,
        $interval,
        $window,
        fsFactory,
        offline,
        authenticationService,
        toastr,
        siScope,
        apiUrl,
        $localStorage,
        $timeout,
        IDB,
        APP
    ) {
        let numberOfRequests = 0;
        let pollPromise;
        let connectivityCheckPromise;
        let syncModal = { dismiss: () => {} };
        let onlineTimeoutPromise = undefined;
        let syncStartInFlight = false;
        let syncModalOpen = false;

        function isBackendReachable() {
            // Use /accounts/users/me/ — a lightweight authenticated GET endpoint
            // that returns 200 when the backend is reachable.
            // Cache-busting param prevents the interceptor from serving stale data.
            return $http({
                method: 'GET',
                url: `${apiUrl}/accounts/users/me/?_check=` + Date.now(),
                timeout: 5000
            })
                .then(function(response) {
                    return !!(response && response.status && response.status >= 200 && response.status < 400);
                })
                .catch(function() {
                    return false;
                });
        }

        offline.startEventListeners();
        offline.updatePendingRequestNumber();

        // Periodic connectivity check: the browser 'online' event is unreliable
        // (e.g. WiFi connected but no internet, or Chrome DevTools offline mode).
        // This polls the backend every 15s while we think we're offline to detect
        // when connectivity is actually restored, then triggers the sync flow.
        function startConnectivityCheck() {
            stopConnectivityCheck();
            connectivityCheckPromise = $interval(function() {
                if (!offline.isOffline) {
                    stopConnectivityCheck();
                    return;
                }
                // Use /accounts/users/me/ — returns 200 when backend is reachable.
                // Cache-busting param prevents stale cached responses.
                $http({
                    method: 'GET',
                    url: `${apiUrl}/accounts/users/me/?_check=` + Date.now(),
                    timeout: 5000
                })
                    .then(function(response) {
                        if (response && response.status && response.status >= 200 && response.status < 400) {
                            offline.isOffline = false;
                            stopConnectivityCheck();
                            $rootScope.$broadcast(APP.online);
                        }
                    })
                    .catch(function() {
                        // Still offline
                    });
            }, 15000);
        }

        function stopConnectivityCheck() {
            if (connectivityCheckPromise) {
                $interval.cancel(connectivityCheckPromise);
                connectivityCheckPromise = null;
            }
        }

        // Start the connectivity check if we're already offline at init
        // or if the interceptor has set offline.isOffline = true
        IDB.count('requests').then(function(count) {
            if (count > 0 && offline.isOffline) {
                startConnectivityCheck();
            }
        });

        // Also start/stop the check when offline state changes
        $rootScope.$on(APP.offline, function() {
            IDB.count('requests').then(function(count) {
                if (count > 0) {
                    startConnectivityCheck();
                }
            });
        });

        $rootScope.$on(APP.online, function() {
            stopConnectivityCheck();
        });

        // On init: if a sync job already exists, resume polling.
        // Otherwise, if there are pending requests, start a new sync job.
        // These are mutually exclusive paths to prevent double-submission.
        if ($localStorage.offlineSync && !offline.isOffline && navigator.onLine) {
            // A sync job exists — validate it's still active, then resume polling
            siScope
                .getItem($localStorage.offlineSync)
                .then(syncStatus => {
                    if (syncStatus && syncStatus.length > 0) {
                        // Check if all requests are done
                        var completed = syncStatus.filter(r => r.response && r.response.status).length;
                        if (completed === syncStatus.length && syncStatus.length > 0) {
                            // Job finished while we were away — clean up
                            var failed = syncStatus.filter(
                                r => r.response && r.response.status && r.response.status >= 400
                            );
                            if (failed && failed.length) {
                                failed.map(err => fsFactory.writeToFs('failed', Date.now(), err));
                                toastr.error('There were some errors in the syncing of the application', null, {
                                    timeOut: 30000,
                                    closeButton: true
                                });
                            }
                            syncStatus.map(r => fsFactory.unlinkFromFs('requests', r.key));
                            IDB.clearRequests();
                            $localStorage.offlineSync = null;
                            return;
                        }
                        // Job still running — resume polling
                        numberOfRequests = syncStatus.length;
                        if (authenticationService.isLoggedIn()) {
                            openSynModal();
                        }
                        return;
                    }
                    // Empty response — job doesn't exist anymore
                    $localStorage.offlineSync = null;
                    initiateNewSync();
                })
                .catch(err => {
                    console.error('Error validating sync status:', err);
                    // Don't clear the marker on network error — the job may still
                    // be running. Only clear if we got a definitive "not found".
                    if (err && err.status && err.status === 404) {
                        $localStorage.offlineSync = null;
                        initiateNewSync();
                    }
                });
        } else if (!offline.isOffline && navigator.onLine) {
            initiateNewSync();
        }

        function initiateNewSync() {
            if (syncStartInFlight || $localStorage.offlineSync) {
                return;
            }
            IDB.getCollection('requests')
                .then((pendingRequests = []) => {
                    numberOfRequests = pendingRequests.length;
                    offline.updatePendingRequestNumber();
                    if (!pendingRequests.length || offline.isOffline || syncStartInFlight) {
                        return;
                    }

                    if ($localStorage.offlineSync) {
                        return;
                    }

                    syncStartInFlight = true;
                    return isBackendReachable().then(reachable => {
                        if (!reachable) {
                            syncStartInFlight = false;
                            // Backend not reachable — start polling for connectivity
                            if (!offline.isOffline) {
                                offline.isOffline = true;
                            }
                            startConnectivityCheck();
                            return;
                        }
                        return siScope.post({ url: `${apiUrl}/offline_sync/` }, JSON.stringify(pendingRequests));
                    });
                })
                .then(res => {
                    syncStartInFlight = false;
                    if (res && res.status_url) {
                        $localStorage.offlineSync = `${apiUrl}${res.status_url}`;
                    }

                    if (numberOfRequests && authenticationService.isLoggedIn() && !offline.isOffline) {
                        openSynModal();
                    }
                })
                .catch(err => {
                    syncStartInFlight = false;
                    console.error('Error initiating offline sync:', err);
                    // The sync POST failed — we're likely offline.
                    // Set offline state and start connectivity polling so
                    // sync auto-triggers when connection is restored.
                    if (!offline.isOffline) {
                        offline.isOffline = true;
                        startConnectivityCheck();
                    }
                    toastr.error(
                        'Failed to initiate offline sync. Your data has been saved offline and will sync when connection is restored.',
                        null,
                        {
                            timeOut: 30000,
                            closeButton: true
                        }
                    );
                });
        }

        function pollOfflineSync($uibModalInstance) {
            let pollStartTime = Date.now();
            const MINUTE = 60 * 1000;
            const POLL_TIMEOUT = 120 * MINUTE; // allow large sync jobs to finish
            const POLL_TIMEOUT_MINUTES = POLL_TIMEOUT / MINUTE;

            pollPromise = $interval(() => {
                if (offline.isOffline || !navigator.onLine || !$localStorage.offlineSync) {
                    $interval.cancel(pollPromise);
                    $uibModalInstance.dismiss();
                    return;
                }

                // Safety check: if polling has been running too long, close it rather than hang
                if (Date.now() - pollStartTime > POLL_TIMEOUT) {
                    $interval.cancel(pollPromise);
                    // SPRINT-59-CR FR-023. Both messages carry the duration, and
                    // both derive it from POLL_TIMEOUT rather than restating it -
                    // restating it is what produced the original wrong number.
                    //
                    // "Silent errors" was one of the three causes of the A7.6
                    // production data-loss incident, and the assessor is the person
                    // who needs to know: they are on a tablet in the field and will
                    // never open devtools, so a corrected console line reaches only
                    // whoever reads a support-forwarded log. The last clause of the
                    // toast is the one that matters most under that framing - the
                    // failure that lost data was an assessor concluding their work
                    // was gone. `dismiss('timeout')` and the retained
                    // $localStorage.offlineSync mean it is not, but nothing on
                    // screen said so.
                    console.error(`Offline sync polling timeout after ${POLL_TIMEOUT_MINUTES} minutes`);
                    toastr.error(
                        `Offline sync has been running for over ${POLL_TIMEOUT_MINUTES} minutes. It will continue in the background — please refresh later to check progress. Your data is still saved on this device.`,
                        null,
                        { timeOut: 30000, closeButton: true }
                    );
                    // Use dismiss (not close) so the success handler does NOT fire.
                    // Keep $localStorage.offlineSync so we resume polling on next load
                    // instead of re-submitting the same data.
                    syncModalOpen = false;
                    $uibModalInstance.dismiss('timeout');
                    return;
                }

                siScope
                    .getItem($localStorage.offlineSync)
                    .then(res => {
                        if (!res || !res.length) return;

                        $rootScope.max = res.length;
                        $rootScope.value = res.filter(
                            r => r.response && r.response.status && r.response.status >= 200
                        ).length;

                        offline.numberPendingRequests = $rootScope.max - $rootScope.value;

                        if ($rootScope.max === $rootScope.value && $rootScope.max > 0) {
                            const failed =
                                res && res.filter(r => r.response && r.response.status && r.response.status >= 400);
                            if (failed && failed.length) {
                                failed.map(err => fsFactory.writeToFs('failed', Date.now(), err));
                                $rootScope.$broadcast('sync-errors');
                                $rootScope.$broadcast('sync-errors-alert');
                                toastr.error('There were some errors in the syncing of the application', null, {
                                    timeOut: 30000,
                                    closeButton: true
                                });
                            }

                            // Only delete requests from queue AFTER job completion is confirmed
                            if (res) {
                                res.map(r => fsFactory.unlinkFromFs('requests', r.key));
                            }

                            IDB.clearRequests().then(() => {
                                syncModalOpen = false;
                                $uibModalInstance.close();
                                $interval.cancel(pollPromise);
                                $localStorage.offlineSync = null;
                            });
                        }
                    })
                    .catch(err => {
                        console.error('Error polling offline sync status:', err);
                        // Don't close modal or cancel polling on transient errors
                        // Job will continue in background and we'll retry polling
                    });
            }, 2500);
        }

        function openSynModal() {
            if (offline.isOffline || !navigator.onLine || !$localStorage.offlineSync || syncModalOpen) {
                return;
            }
            syncModalOpen = true;

            syncModal = $uibModal.open({
                templateUrl: 'modals/templates/request-modal/requestModalView.html',
                controller: [
                    '$scope',
                    '$rootScope',
                    '$uibModalInstance',
                    function($scope, $rootScope, $uibModalInstance) {
                        $scope.$uibModalInstance = $uibModalInstance;

                        $rootScope.max = numberOfRequests;
                        $rootScope.value = 0;

                        pollOfflineSync($uibModalInstance);
                    }
                ],
                keyboard: false,
                backdrop: 'static'
            });

            syncModal.result.then(() => {
                var notifyModal = $uibModal.open({
                    templateUrl: 'modals/templates/notify-modal/notifyModalView.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.ok = function() {
                                $uibModalInstance.close();
                            };
                        }
                    ],
                    keyboard: false,
                    backdrop: 'static'
                });

                $localStorage.offlineSync = null;

                notifyModal.result.then(() => {
                    fsFactory.clearAssessments().then(() => {
                        $window.location.reload();
                    });
                });
            });
        }

        $rootScope.$on(APP.offline, () => {
            syncStartInFlight = false;
            syncModalOpen = false;

            if (onlineTimeoutPromise) {
                $timeout.cancel(onlineTimeoutPromise);
            }

            $interval.cancel(pollPromise);
            syncModal.dismiss();
        });

        $rootScope.$on(APP.online, function() {
            onlineTimeoutPromise = $timeout(() => {
                if ($localStorage.offlineSync) {
                    // Existing sync job — validate and resume polling
                    siScope
                        .getItem($localStorage.offlineSync)
                        .then(syncStatus => {
                            if (syncStatus && syncStatus.length > 0) {
                                numberOfRequests = syncStatus.length;
                                openSynModal();
                            } else {
                                $localStorage.offlineSync = null;
                                initiateNewSync();
                            }
                        })
                        .catch(err => {
                            console.error('Error validating sync status on reconnect:', err);
                            if (err && err.status && err.status === 404) {
                                $localStorage.offlineSync = null;
                                initiateNewSync();
                            }
                        });
                    return;
                }

                initiateNewSync();
            }, 5000);
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.cache').decorator('$q', qWithAllSettled);

    qWithAllSettled.$inject = ['$delegate'];

    // Implementation of allSettled function from Kris Kowal's Q:
    // https://github.com/kriskowal/q/wiki/API-Reference#promiseallsettled
    function qWithAllSettled($delegate) {
        var $q = $delegate;

        $q.allSettled =
            $q.allSettled ||
            function allSettled(promises) {
                var wrapped = _.isArray(promises) ? [] : {};

                _.each(promises, function(promise, key) {
                    if (!wrapped.hasOwnProperty(key)) {
                        wrapped[key] = wrap(promise);
                    }
                });

                return $q.all(wrapped);

                function wrap(promise) {
                    return $q.when(promise).then(
                        function(value) {
                            return { state: 'fulfilled', value: value };
                        },
                        function(reason) {
                            return { state: 'rejected', reason: reason };
                        }
                    );
                }
            };
        return $q;
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.cache').factory('offline', offline);

    offline.$inject = ['requestHelpers', '$rootScope', '$log', 'IDB', 'APP'];

    function offline(requestHelpers, $rootScope, $log, IDB, APP) {
        return {
            isOffline: !navigator.onLine,
            numberPendingRequests: 0,

            updatePendingRequestNumber: function() {
                IDB.count('requests').then(requests => (this.numberPendingRequests = requests));
            },
            startEventListeners: function() {
                window.addEventListener('online', () => {
                    $rootScope.$broadcast(APP.online);
                    this.isOffline = !navigator.onLine;
                    console.log('APP-STATUS - Application is Online');
                });

                window.addEventListener('offline', () => {
                    $rootScope.$broadcast(APP.offline);
                    this.isOffline = !navigator.onLine;
                    console.log('APP-STATUS - Application is Offline');
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.cache').factory('fsFactory', fsFactory);

    fsFactory.$inject = ['IDB'];

    function fsFactory(IDB) {
        const service = this;

        service.writeToFs = writeToFs;
        service.readFromFs = readFromFs;
        service.unlinkFromFs = unlinkFromFs;
        service.unlinkByPrefixFromFs = unlinkByPrefixFromFs;
        service.exists = exists;
        service.clearFS = clearFS;
        service.clearAssessments = clearAssessments;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function unlinkFromFs(root, key) {
            return IDB.remove(root, key);
        }

        function unlinkByPrefixFromFs(root, prefix) {
            return IDB.removeByPrefix(root, prefix);
        }

        function writeToFs(root, key, value) {
            return IDB.write(root, key, value);
        }

        function readFromFs(root, key) {
            return IDB.read(root, key);
        }

        function exists(root, key) {
            return IDB.exists(root, key);
        }

        function clearFS() {
            return IDB.clearAll();
        }

        function clearAssessments() {
            return IDB.clearAssessments();
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.cache').factory('cacheInterceptor', cacheInterceptor);

    cacheInterceptor.$inject = [
        '$rootScope',
        '$q',
        'fsFactory',
        'offline',
        '$timeout',
        'saveAs',
        'siHelpers',
        '$injector',
        'gettext',
        'requestHelpers'
    ];

    function cacheInterceptor(
        $rootScope,
        $q,
        fsFactory,
        offline,
        $timeout,
        saveAs,
        siHelpers,
        $injector,
        gettext,
        requestHelpers
    ) {
        var serverDown;
        $rootScope.currentRequests = 0;

        $rootScope.$on('$stateChangeStart', function(event, fromState, fromParams, toState) {
            if ($rootScope.currentRequests > 0 && toState.name !== 'authentication.login') {
                $injector.get('toastr').warning('Update requests in progress');
                event.preventDefault();
            }
        });

        $rootScope.$on('$stateChangeSuccess', function(event, fromState) {
            if (fromState.name === 'authentication.login') {
                $rootScope.currentRequests = 0;
            }
        });

        function compressData(data) {
            data = angular.copy(data);

            Object.keys(data).forEach(function(key) {
                if (_.isArray(data[key]) && data[key][0]) {
                    if (typeof data[key][0] !== 'string' && typeof data[key][0].url !== 'undefined') {
                        data[key] = data[key]
                            .filter(function(object) {
                                return object.url;
                            })
                            .map(function(object) {
                                return object.url;
                            });
                    }
                } else if (_.isObject(data[key])) {
                    data[key] = typeof data[key].url === 'string' ? data[key].url : data[key];

                    if (typeof data[key] !== 'string') {
                        data[key] = compressData(data[key]);
                    }
                }

                return data[key];
            });

            return data;
        }

        function isBinaryDocument(contentType) {
            if (!contentType) {
                return false;
            }
            return (
                contentType.indexOf('application/pdf') > -1 ||
                contentType.indexOf('image/') === 0 ||
                contentType.indexOf('application/octet-stream') > -1 ||
                contentType.indexOf('application/vnd.openxmlformats-officedocument') > -1 ||
                contentType.indexOf('application/msword') > -1
            );
        }

        function isUpdateMethod(method) {
            return method === 'POST' || method === 'UPDATE' || method === 'PATCH' || method === 'DELETE';
        }

        return {
            /**
             * Request interceptor
             *
             * Retrieves local version of cached object to attach modified since header. This results in an
             * updated object from the server if the cache should be invalidated. Otherwise it returns a 301
             * status message indicating we can pull all data from the cached response to minimize data
             * transfer.
             *
             * @param request full request body
             * @returns promise
             */
            request: function(request) {
                if (isUpdateMethod(request.method)) {
                    $rootScope.currentRequests += 1;
                }

                // only appnd to GET and non template/auth requests
                if (request.method !== 'GET' || !requestHelpers.isResource(request.url)) {
                    if (request.data && navigator.onLine) {
                        request.data = compressData(request.data);
                    }

                    return $q.when(request);
                }

                var key = requestHelpers.getUrlWithParams(request.url, request.params);
                var deferred = $q.defer();

                // get cached object for modified header
                fsFactory
                    .readFromFs('responses', key)
                    .then(function(cachedResponse) {
                        if (typeof cachedResponse.data !== 'string') {
                            if (cachedResponse && cachedResponse.data && cachedResponse.data._requested_at) {
                                _.extend(request.headers || {}, {
                                    'If-Modified-Since': new Date(cachedResponse.data._requested_at).toUTCString()
                                });
                            }
                        }
                        return deferred.resolve(request);
                    })
                    .catch(function() {
                        return deferred.resolve(request);
                    });

                return deferred.promise;
            },

            /**
             * intercept response
             *
             * Sets the toaster value for storage calls (POST UPDATE PATCH DELETE)
             * Writes the response to the local storage in case of GET requests for offline usage
             *
             * @param response
             * @returns response
             */
            response: function(response) {
                if (isUpdateMethod(response.config.method)) {
                    $rootScope.currentRequests -= 1;

                    if ($rootScope.currentRequests === 0 && navigator.onLine) {
                        var changedSaved = gettext('Changes saved successfully...');
                        $injector.get('toastr').success(changedSaved);
                    }
                }

                if (!requestHelpers.isResource(response.config.url)) return $q.when(response);

                if (offline.isOffline) return $q.reject(response);

                // bypass csv, not cached but served as downloadable
                if (
                    response.headers &&
                    response.headers('content-type') &&
                    response.headers('content-type').indexOf('text/csv') > -1
                ) {
                    var blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
                    saveAs(blob, 'dataexport_' + Date.now().toString() + '.csv');
                    return $q.when(response);
                }

                // bypass binary documents (PDF, images, Office files, octet-stream):
                // they are previewed or downloaded, never cached for offline use
                // (AD-2191 - consent documents shown inline in the Data Sharing tab)
                if (response.headers && isBinaryDocument(response.headers('content-type'))) {
                    return $q.when(response);
                }

                if (response.config.method === 'GET') {
                    if (typeof response.data !== 'string') {
                        response.data._requested_at = response.headers('date');
                    } else {
                    }

                    if (response.status === 304) {
                        // resource is not modified
                        return $q.reject(response);
                    }
                    var key = requestHelpers.getUrlWithParams(response.config.url, response.config.params);
                    var deferred = $q.defer();

                    delete response.config.headers; // remove headers for future

                    fsFactory
                        .writeToFs('responses', key, response)
                        .then(() => deferred.resolve(response))
                        .catch(() => deferred.resolve(response));

                    return deferred.promise;
                } else {
                    return $q.when(response);
                }
            },

            /**
             * Response error interceptor
             *
             * This decides based on the situation if the request can be pulled from the offline cache, if
             * an explicit reject should be thrown, or a fallthrough error should be passed
             *
             * @param response http response object
             * @returns {*} either a promise or a reject
             */
            responseError: function(response) {
                if (isUpdateMethod(response.config.method)) {
                    $rootScope.currentRequests -= 1;
                }

                if (response.config === undefined) return $q.reject(response);
                if (requestHelpers.isAuth(response.config.url)) return $q.reject(response);
                if (requestHelpers.isHtml(response.config.url)) return $q.when(response);
                // Never queue offline_sync requests — they are the sync mechanism itself
                if (response.config.url && response.config.url.indexOf('offline_sync') !== -1)
                    return $q.reject(response);

                var deferred;

                // We want to explicitly reject expired or unauthorized calls when we're online, so the
                // auth interceptor can reauthorize by fetching a new token.
                if (!offline.isOffline && [401, 403].indexOf(response.status) > -1) return $q.reject(response);

                // If any 5xx response received say that server is down for maintenance
                if (response.status > 500 && !serverDown) {
                    serverDown = true;
                    $timeout(function() {
                        throw {
                            name: 'ResourceError',
                            error: {
                                config: {},
                                data: {
                                    message: 'Server down for maintenance!'
                                }
                            }
                        };
                    }, 500);
                }

                // In other cases, when GETting information, retrieve information from the cache
                if (response.config.method === 'GET') {
                    if (response.status === 404) {
                        return response;
                    }
                    var key = requestHelpers.getUrlWithParams(response.config.url, response.config.params);
                    deferred = $q.defer();

                    fsFactory
                        .readFromFs('responses', key)
                        .then(function(cachedResponse) {
                            if (cachedResponse) {
                                deferred.resolve(cachedResponse);
                            } else {
                                deferred.resolve(response);
                            }
                        })
                        .catch(function() {
                            deferred.reject(response);
                        });
                    return deferred.promise;

                    // POST, PUT, UPDATE should be queued when offline or on network error
                } else {
                    if (offline.isOffline || !navigator.onLine || response.status <= 0) {
                        if (response.status <= 0 && !offline.isOffline) {
                            // Network failed despite navigator.onLine being true;
                            // mark offline so subsequent requests are also queued.
                            offline.isOffline = true;
                            $rootScope.$broadcast('application-is-offline');
                        }
                        deferred = $q.defer();

                        // create reference for new objects
                        if (
                            response.config.method === 'POST' &&
                            response.config.data &&
                            typeof response.config.data === 'object'
                        ) {
                            response.config.data.id = response.config.data.id || siHelpers.uid(); // use same config id if existing
                            fsFactory.writeToFs('refs', response.config.data.id, { id: null, url: null });
                        }

                        var request = {
                            url: response.config.url,
                            method: response.config.method,
                            //data: compressData(response.config.data),
                            data: response.config.data,
                            params: response.config.params
                        };

                        // write the response to the queue for later handling
                        fsFactory
                            .writeToFs('requests', Date.now(), request)
                            .then(function() {
                                offline.updatePendingRequestNumber();
                                // fake a resolved response; copy request data to response data and resolve
                                response.data = request.data || {};
                                var changedSaved = gettext('Saved for offline sync...');
                                $timeout(
                                    function() {
                                        $injector.get('toastr').warning(changedSaved);
                                    },
                                    0,
                                    false
                                );

                                // Update the responses cache so that GET requests on
                                // reload return the latest offline-edited data instead
                                // of stale server snapshots.
                                if (
                                    (request.method === 'PATCH' || request.method === 'PUT') &&
                                    request.data &&
                                    typeof request.data === 'object'
                                ) {
                                    var cacheKey = requestHelpers.getUrlWithParams(request.url, request.params);
                                    fsFactory.readFromFs('responses', cacheKey).then(function(cached) {
                                        if (cached && cached.data && typeof cached.data === 'object') {
                                            angular.extend(cached.data, request.data);
                                            fsFactory.writeToFs('responses', cacheKey, cached);
                                        }
                                    });
                                }

                                response = updatePostUrl(response);
                                deferred.resolve(response);

                                function updatePostUrl(response) {
                                    if (response.config.method === 'POST' && response.config.data) {
                                        var data = response.config.data;
                                        var objectId = data.id;
                                        var baseUrl =
                                            typeof data.url === 'string' && data.url.length
                                                ? data.url
                                                : response.config.url;

                                        if (!objectId || typeof baseUrl !== 'string' || !baseUrl.length) {
                                            return response;
                                        }

                                        var indexOfQP = baseUrl.indexOf('/?');
                                        if (indexOfQP !== -1) {
                                            data.url =
                                                baseUrl.slice(0, indexOfQP - 1) +
                                                '/' +
                                                objectId +
                                                baseUrl.slice(indexOfQP);
                                        } else if (baseUrl.charAt(baseUrl.length - 1) === '/') {
                                            data.url = baseUrl + objectId + '/';
                                        } else {
                                            data.url = baseUrl + '/' + objectId + '/';
                                        }
                                    }

                                    return response;
                                }
                            })
                            .catch(function(err) {
                                console.log('Error Writing Requests to FS - ', err);
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    }

                    // fallthrough: response failed, reject response for further handling
                    return $q.reject(response);
                }
            }
        };
    }
})();

// (function() {
//     'use strict';

//     angular.module('scope.commons.cache', ['ui.router', 'ui.bootstrap', 'scope.commons', 'angular-md5']).run(run);

//     run.$inject = [
//         '$rootScope',
//         '$q',
//         '$log',
//         '$http',
//         '$state',
//         '$uibModal',
//         '$interval',
//         '$window',
//         'fsFactory',
//         'offline',
//         'authenticationService',
//         'toastr',
//         'IDB',
//         'APP',
//         'OFFLINE_REQUESTS'
//     ];

//     function run(
//         $rootScope,
//         $q,
//         $log,
//         $http,
//         $state,
//         $uibModal,
//         $interval,
//         $window,
//         fsFactory,
//         offline,
//         authenticationService,
//         toastr,
//         IDB,
//         APP,
//         OFFLINE_REQUESTS
//     ) {
//         var numberOfRequests = 0;

//         offline.startEventListeners();
//         offline.updatePendingRequestNumber();

//         IDB.getCollection('requests')
//             .then((pendingRequests = []) => {
//                 numberOfRequests = pendingRequests.length;
//                 offline.updatePendingRequestNumber();
//             })
//             .then(function() {
//                 if (numberOfRequests && authenticationService.isLoggedIn() && !offline.isOffline) {
//                     //If we got req waiting open the modal to pause user interaction
//                     var syncModal = $uibModal.open({
//                         templateUrl: 'modals/templates/request-modal/requestModalView.html',
//                         controller: [
//                             '$scope',
//                             '$rootScope',
//                             '$uibModalInstance',
//                             function($scope, $rootScope, $uibModalInstance) {
//                                 $scope.$uibModalInstance = $uibModalInstance;
//                                 $scope.max = numberOfRequests;
//                                 $scope.value = 0;

//                                 $rootScope.$on(OFFLINE_REQUESTS.process, function($event, number) {
//                                     $scope.value = $scope.max - number;
//                                     if (parseInt(number, 10) === 0) {
//                                         $uibModalInstance.close();
//                                     }
//                                 });
//                             }
//                         ],
//                         keyboard: false,
//                         backdrop: 'static'
//                     });

//                     syncModal.result.then(function() {
//                         var notifyModal = $uibModal.open({
//                             templateUrl: 'modals/templates/notify-modal/notifyModalView.html',
//                             controller: [
//                                 '$scope',
//                                 '$uibModalInstance',
//                                 function($scope, $uibModalInstance) {
//                                     $scope.ok = function() {
//                                         $uibModalInstance.close();
//                                     };
//                                 }
//                             ],
//                             keyboard: false,
//                             backdrop: 'static'
//                         });

//                         notifyModal.result.then(function() {
//                             fsFactory.clearAssessments().then(function() {
//                                 $window.location.reload();
//                             });
//                         });
//                     });

//                     //Start firing the requests
//                     processRequests();
//                 }
//             });

//         $rootScope.$on(APP.online, function() {
//             IDB.getCollection('requests').then(pendingRequests => {
//                 numberOfRequests = pendingRequests.length;

//                 if (numberOfRequests) {
//                     //If we got req waiting open the modal to pause user interaction
//                     var syncModal = $uibModal.open({
//                         templateUrl: 'modals/templates/request-modal/requestModalView.html',
//                         controller: [
//                             '$scope',
//                             '$rootScope',
//                             '$uibModalInstance',
//                             function($scope, $rootScope, $uibModalInstance) {
//                                 $scope.$uibModalInstance = $uibModalInstance;
//                                 $scope.max = numberOfRequests;
//                                 $scope.value = 0;

//                                 $rootScope.$on(OFFLINE_REQUESTS.process, function($event, number) {
//                                     $scope.value = $scope.max - number;
//                                     if (parseInt(number, 10) === 0) {
//                                         $uibModalInstance.close();
//                                     }
//                                 });
//                             }
//                         ],
//                         keyboard: false,
//                         backdrop: 'static'
//                     });

//                     syncModal.result.then(function() {
//                         var notifyModal = $uibModal.open({
//                             templateUrl: 'modals/templates/notify-modal/notifyModalView.html',
//                             controller: [
//                                 '$scope',
//                                 '$uibModalInstance',
//                                 function($scope, $uibModalInstance) {
//                                     $scope.ok = function() {
//                                         $uibModalInstance.close();
//                                     };
//                                 }
//                             ],
//                             keyboard: false,
//                             backdrop: 'static'
//                         });

//                         notifyModal.result.then(function() {
//                             fsFactory.clearAssessments().then(function() {
//                                 $window.location.reload();
//                             });
//                         });
//                     });

//                     //Start firing the requests
//                     processRequests();
//                 }
//             });
//         });

//         /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//          Method Declarations
//          ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

//         /**
//          * Meat and Potatoes - Handles all the processing of the offline made requests
//          */
//         function processRequests() {
//             if (!authenticationService.isLoggedIn()) return;

//             IDB.getCollection('requests').then(pendingRequests => {
//                 //Check if we have any pending requests
//                 if (!_.size(pendingRequests)) {
//                     return console.log(new Date(), 'SYNC: Nothing to be done');
//                 }

//                 // map all pending requests from FS, removes requests (if they fail a new entry is created)
//                 var pendingRequestPromises = _.map(pendingRequests, request => {
//                     var deferred = $q.defer(),
//                         time = parseInt(request.key, 10);

//                     fsFactory.readFromFs('requests', time).then(config => {
//                         deferred.resolve({
//                             time: time,
//                             config: config
//                         });
//                     });

//                     return deferred.promise;
//                 });

//                 // once all request content is there we start sorting on time attr
//                 // retry stored http request and write response.id and response.url to refs entry
//                 $q.allSettled(pendingRequestPromises).then(pendingRequests => {
//                     //Once we have all the requests we sort them by the time they were fired and cut out the good parts - aka the value.
//                     const requests = _.chain(pendingRequests)
//                         .sortBy(pendingRequest => pendingRequest.value.time)
//                         .map(pendingRequest => pendingRequest.value)
//                         .value();

//                     numberOfRequests = requests.length;

//                     console.log(new Date(), 'SYNC: Syncing all failed HTTP requests');

//                     completeHttpRequests(requests, 0);
//                 });
//             });
//         }

//         /**
//          * Fires of the Http Requests we have saved up
//          * @param requests
//          * @param index
//          */
//         console.log(' ');
//         function completeHttpRequests(requests, index) {
//             var request = requests[index];

//             //Requests have all been made, lets also deal with the failed ones.
//             if (index === requests.length || index > request.length) {
//                 //Update the last one from the counter
//                 offline.updatePendingRequestNumber();
//                 $rootScope.$broadcast(OFFLINE_REQUESTS.process, 0);

//                 //Deal with failed requests
//                 IDB.getCollection('failed').then(fails => {
//                     if (fails.length) {
//                         $rootScope.$broadcast('sync-errors');
//                         toastr.error('There were some errors in the syncing of the application', null, {
//                             timeOut: 30000,
//                             closeButton: true
//                         });
//                     }
//                 });

//                 return;
//             }

//             replaceReferences(request.config).then(data => {
//                 if (request.config.method === 'DELETE') {
//                     _.extend(request.config, data);
//                 } else {
//                     request.config.data = data;
//                     request.config.url = data.url ? data.url : request.config.url;
//                 }

//                 const httpConfig = getHttpConfig(request.config);

//                 if (!httpConfig.url) {
//                     console.log(
//                         'Error - Seems there is no url on the config object - request - ',
//                         request,
//                         'data - ',
//                         data
//                     );
//                     Raven.captureException(
//                         `Error - Seems there is no url on the config object - request - ${JSON.stringify(
//                             request
//                         )} data - ${JSON.stringify(data)}`
//                     );
//                     return fsFactory.unlinkFromFs('requests', requests[index].time);
//                 }

//                 console.log(
//                     new Date(),
//                     'SYNC: Retrying request from',
//                     request.time,
//                     httpConfig.method,
//                     'on',
//                     httpConfig.url
//                 );

//                 function next() {
//                     completeHttpRequests(requests, index + 1);
//                 }

//                 $http(httpConfig)
//                     .then(response => {
//                         //Once we have processed the request we unlink it
//                         fsFactory.unlinkFromFs('requests', requests[index].time).then(() => {
//                             numberOfRequests -= 1;
//                             $rootScope.$broadcast(OFFLINE_REQUESTS.process, numberOfRequests);

//                             if (httpConfig.method === 'POST' && response.status !== 0) {
//                                 fsFactory
//                                     .writeToFs('refs', httpConfig.data.id, {
//                                         id: response.data.id,
//                                         url: response.data.url
//                                     })
//                                     .then(next);
//                             } else {
//                                 next();
//                             }
//                         });
//                     })
//                     .catch(err => {
//                         console.log('Failed Sync - ', err);
//                         Raven.captureException(JSON.stringify(err));
//                         //Shove the failed request into the FS
//                         fsFactory.writeToFs('failed', Date.now(), err);
//                         $rootScope.$broadcast('sync-errors-alert');

//                         removeDependentCalls(requests, index)
//                             .then(removedRequests => {
//                                 const removedPromises = removedRequests.map(remove =>
//                                     fsFactory.unlinkFromFs('requests', remove.time)
//                                 );

//                                 removedPromises.push(fsFactory.unlinkFromFs('requests', requests[index].time));

//                                 requests = requests.filter(req => {
//                                     return removedRequests
//                                         .filter(remove => remove.time === req.time)
//                                         .reduce(() => false, true);
//                                 });

//                                 return $q.allSettled(removedPromises);
//                             })
//                             .then(() => {
//                                 numberOfRequests -= 1;
//                                 $rootScope.$broadcast(OFFLINE_REQUESTS.process, numberOfRequests);
//                             })
//                             .catch(err => {
//                                 console.log('Something bad happened - ', err);
//                             })
//                             .finally(() => next());
//                     })
//                     .finally(() => offline.updatePendingRequestNumber());
//             });
//         }

//         function removeDependentCalls(requests, index) {
//             const id = requests[index].config.data.id || false;
//             const deferred = $q.defer();

//             const removed = requests
//                 .filter(request => {
//                     return request.time !== requests[index].time;
//                 })
//                 .filter(request => {
//                     if (request.config && request.config.data) {
//                         return Object.keys(request.config.data)
//                             .filter(key => (request.config.data[key] ? hasId(request.config.data[key], id) : false))
//                             .reduce(() => true, false);
//                     } else {
//                         return false;
//                     }
//                 });

//             deferred.resolve(removed);

//             return deferred.promise;
//         }

//         function hasId(object, id) {
//             return Object.keys(object)
//                 .filter(key => {
//                     if (typeof object[key] === 'object') {
//                         return !_.isEmpty(object[key]) ? hasId(object[key], id) : false;
//                     } else {
//                         return object[key] === id;
//                     }
//                 })
//                 .reduce(() => true, false);
//         }

//         /**
//          * Return a config object
//          * @param config
//          * @returns {{url: *, method: string, data: *, params: (config.params|{})}}
//          */
//         function getHttpConfig(config) {
//             return {
//                 url: config.url,
//                 method: config.method,
//                 data: config.data,
//                 params: config.params
//             };
//         }

//         /**
//          * function retrieves POST/DELETE references from FS and then tries to replace all values
//          * @param object
//          * @returns {deferred.promise|{then, catch, finally}}
//          */
//         function replaceReferences(object) {
//             var deferred = $q.defer();

//             if (object.method === 'DELETE') {
//                 object = {
//                     url: object.url,
//                     //Matches from the end of the url with or without the trailing slash ie '/'
//                     //and grabs what should be the id as we cannot add it to the delete request object in any meaningful place.
//                     id: /([\w]+?)[\/]?$/.exec(object.url)[1]
//                 };
//             } else {
//                 object = object.data;
//             }

//             IDB.getCollection('refs').then(createReferences => {
//                 const createReferencePromises = _.reduce(
//                     createReferences,
//                     (memo, reference) => {
//                         //Lets create an array of objects with ref.name as the key for ex: {0dcnd5: refFromFS}
//                         memo[reference.key] = fsFactory.readFromFs('refs', reference.key);
//                         return memo;
//                     },
//                     {}
//                 );

//                 $q.allSettled(createReferencePromises).then(createReferences => {
//                     const references = _.pick(createReferences, reference => reference.value.id !== null);

//                     function replace(object) {
//                         _.each(object, (value, key) => {
//                             const reference = references[value];

//                             if (typeof value === 'object') {
//                                 object[key] = replace(value);
//                             } else if (!_.isUndefined(reference)) {
//                                 object.id = reference.value.id;
//                                 object.url = reference.value.url;
//                             }
//                         });

//                         return object;
//                     }

//                     deferred.resolve(replace(object));
//                 });
//             });

//             return deferred.promise;
//         }
//     }
// })();

(function() {
    'use strict';

    angular.module('scope.commons.cache').factory('IDB', IDB);

    IDB.$inject = ['$q', '$log', '$rootScope', '$window', 'md5', 'requestHelpers', 'Dexie'];

    function IDB($q, $log, $rootScope, $window, md5, requestHelpers, Dexie) {
        const service = this;

        let db;

        create();

        service.create = create;
        service.read = read;
        service.write = write;
        service.exists = exists;
        service.clearAll = clearAll;
        service.clearAssessments = clearAssessments;
        service.count = count;
        service.getCollection = getCollection;
        service.remove = remove;
        service.removeByPrefix = removeByPrefix;
        service.deleteDB = deleteDB;
        service.clearRequests = clearRequests;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function count(root) {
            var deferredCount = $q.defer();

            db[root]
                .count()
                .then(count => deferredCount.resolve(count))
                .catch(err => {
                    deferredCount.resolve([]);
                    console.log(`${root} count error - ${err}`);
                });

            return deferredCount.promise;
        }
        //maximum ipc message size exceeded
        function create() {
            db = new Dexie('scope');

            db.version(1).stores({
                refs: '&key',
                assessments: '&key',
                responses: '&key',
                requests: '&key',
                failed: '&key'
            });

            $window.db = db;

            return db
                .open()
                .then(db => {
                    console.log('Scope IDB Opened Successfully');
                    console.log('Database version: ' + db.verno);
                })
                .catch(e => console.log('Oh uh: ' + e));
        }

        function getCollection(collection) {
            var deferredGet = $q.defer();
            const results = [];

            db[collection]
                .each(row => results.push(row))
                .then(() => deferredGet.resolve(results))
                .catch(err => {
                    deferredGet.resolve([]);
                    console.log('Get Collection Error - ', err);
                });

            return deferredGet.promise;
        }

        function read(root, key) {
            key = key.toString();
            return db[root]
                .get(key)
                .then(res => (res ? angular.fromJson(res.value) : false))
                .catch(err => console.log('Dexie Read Error - ', err));
        }

        function write(root, key, value) {
            key = key.toString();
            return db[root]
                .put({ key, value: angular.toJson(value) })
                .catch(err => console.log('Dexie Write Error - ', err));
        }

        function exists(root, key) {
            key = key.toString();
            return db[root].get(key).catch(err => console.log('Dexie Exists Error - ', err));
        }

        function clearAll() {
            return $q
                .all([clearAssessments(), clearResponses()])
                .then(() => console.log('Cleared Assessments and Responses'))
                .then(() => $rootScope.$broadcast('fsCleared'))
                .catch(err => console.log('Clear All Error - ', err));
        }

        function clearAssessments() {
            return db.assessments
                .where('key')
                .startsWith('http')
                .delete()
                .then(() => {
                    console.log('Deleted Assessments');
                    $rootScope.$broadcast('fsCleared');
                })
                .catch(err => console.log('Clear Assessments Error - ', err));
        }

        function clearResponses() {
            return db.responses
                .where('key')
                .startsWith('http')
                .delete()
                .then(() => {
                    console.log('Deleted Responses');
                    $rootScope.$broadcast('fsCleared');
                })
                .catch(err => console.log('Clear Responses Error - ', err));
        }

        function clearRequests() {
            return db.requests
                .where('key')
                .notEqual(0)
                .delete()
                .then(() => {
                    console.log('Deleted Requests');
                    return $rootScope.$broadcast('fsCleared');
                })
                .catch(err => console.log('Clear Responses Error - ', err));
        }

        function remove(root, key) {
            key = key.toString();
            return db[root]
                .where('key')
                .equals(key)
                .delete()
                .catch(err => console.log('Remove Error - ', err));
        }

        // Removes every entry whose key starts with the given prefix. Cached GET
        // responses are keyed by url + query params, so this drops all cached
        // variants of a resource (?fields=..., ?page=..., ...) in one go.
        function removeByPrefix(root, prefix) {
            prefix = prefix.toString();
            return db[root]
                .where('key')
                .startsWith(prefix)
                .delete()
                .catch(err => console.log('Remove By Prefix Error - ', err));
        }

        function deleteDB() {
            return db
                .delete()
                .then(create)
                .catch(err => console.log('Delete DB Error - ', err));
        }
    }
})();

(function() {
    'use strict';

    const CUSTOMER_USER_ADMIN_STATES = [
        'base.alerts',
        'base.alerts-news',
        'base.news-detail',
        'base.alerts-filter',
        'base.alert-detail',
        'base.alerts-filter',
        'base.projects',
        'base.projects-detail',
        'base.projects-edit',
        'base.assessments-list',
        'base.hrm-users',
        'base.admin-export',
        'base.qc-dashboard',
        { abstract: 'base.assessments-assignment-detail' },
        { abstract: 'base.assessments-rapid-final' },
        { abstract: 'base.reports-detail' }
    ];

    angular
        .module('scope.commons.authentication', [
            'scope.commons.authentication.login',
            'scope.commons.authentication.reset',
            'scope.commons.authentication.set',
            'scope.commons.authentication.register'
        ])
        .config(config)
        .constant('USER_TYPES', {
            /**
             * In this object you can determine the permissions per app type (dashboard, website & smartclient) and
             * user type. There are various user type booleans defined on the user info object returned
             * from the server (is_assessor, is_employee, etc.). Per user type you can define the allowed states.
             * Every time a state change has started, the 'toState.name' will be matched to this list with an indexOf.
             * This means that if you define an allowed state of 'base', all states are allowed (assuming all logged in
             * state names start with 'base.'). The order of the user types in the array per app type matter,
             * because the first match found for the current user will be used to determine the permissions. This basically
             * means that the user type with most permissions should be mentioned first. Also, per app type you only
             * need to mention the relevant user types, since we still do the 'checkFrontendPermission' elsewhere.
             * The key 'home_state' can be used if the default home state of 'base.home' does not apply
             * (for now only relevant for is_quality_reviewer).
             */
            dashboard: [
                {
                    name: 'is_employee',
                    allowed_all: true
                },
                {
                    name: 'is_employee_lite',
                    allowed_all: true,
                    denied_states: [
                        'base.products',
                        'base.products-tool-type',
                        'base.products-type-options',
                        'base.canonical-tree',
                        'base.admin-settings',
                        'base.admin-global-dropdown-options',
                        'base.admin-regenerate-report',
                        'base.admin-commands',
                        'base.admin-api-management',
                        'base.admin-set-input-limits',
                        'base.admin-assessee-merge'
                    ]
                },
                {
                    name: 'is_quality_reviewer',
                    home_state: 'base.alerts',
                    allowed_states: [
                        'base.alerts',
                        'base.alerts-filter',
                        'base.alert-detail',
                        'base.alerts-news',
                        'base.news-detail',
                        'base.assessments-list',
                        'base.qc-dashboard',
                        { abstract: 'base.assessments-assignment-detail' },
                        { abstract: 'base.reports-detail' }
                    ]
                },
                {
                    home_state: 'base.alerts',
                    name: 'is_customer_user',
                    allowed_states: CUSTOMER_USER_ADMIN_STATES
                },
                {
                    home_state: 'base.alerts',
                    name: 'is_customer_admin',
                    allowed_states: CUSTOMER_USER_ADMIN_STATES.concat([
                        'base.hrm-user',
                        'base.projects-create',
                        'base.developer-api-access',
                        'base.developer-guide',
                        'base.developer-webhooks'
                    ])
                }
            ],
            website: [
                {
                    // for now use is_active, because this will always be a match.
                    // With allowed_state 'base' we make sure all active users have access to all states
                    name: 'is_active',
                    allowed_all: true
                }
            ],
            smartclient: [
                {
                    // for now use is_active, because this will always be a match.
                    // With allowed_state 'base' we make sure all active users have access to all states
                    name: 'is_active',
                    allowed_all: true
                }
            ]
        })
        .value('defaultLocalStorageValue', {
            user: {
                data: {},
                jwt: {},
                info: {}
            }
        });

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('authentication', {
            abstract: true,
            url: '',
            views: {
                '': {
                    templateUrl: 'authentication/authentication/authentication.html',
                    controller: 'authenticationController',
                    controllerAs: 'authCtrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication').factory('me', meService);

    meService.$inject = ['Restangular', '$localStorage', 'gettextCatalog'];

    function meService(Restangular, $localStorage, gettextCatalog) {
        var userParams = { fields: ['employee', 'assessor'] };
        var service = {};

        service.setParams = setParams;
        service.getMe = getMe;
        service.isDashboardUserAdmin = isDashboardUserAdmin;
        service.setMyLanguage = setMyLanguage;
        service.isEmployee = isEmployee;
        service.isEmployeeLite = isEmployeeLite;
        service.isQcOnly = isQcOnly;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function setParams(params) {
            userParams = params;
        }

        /**
         * Finally somebody gets me ;)
         * @param selfesteem
         * @returns promise might result in existential crisis or motivational boost
         */
        function getMe(selfesteem) {
            selfesteem = selfesteem || userParams;
            return Restangular.one('accounts/users/me/')
                .get(selfesteem)
                .then(me => {
                    Raven.setExtraContext({ user: me });
                    return me;
                });
        }

        function isDashboardUserAdmin() {
            return $localStorage.user.info.is_customer_admin || $localStorage.user.info.is_customer_user;
        }

        function isEmployee() {
            return $localStorage.user.info.is_employee;
        }

        function isEmployeeLite() {
            return $localStorage.user.info.is_employee_lite;
        }

        function isQcOnly() {
            return $localStorage.user.info.is_quality_reviewer;
        }

        function setMyLanguage(user) {
            gettextCatalog.setCurrentLanguage(user.language);
            user.language === 'en' ? true : gettextCatalog.loadRemote('translations/' + user.language + '.json');
            return user;
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication').factory('authenticationService', authenticationService);

    authenticationService.$inject = [
        '$localStorage',
        '$rootScope',
        '$injector',
        'jwtHelper',
        'defaultLocalStorageValue',
        '$q',
        'IDB',
        'requestHelpers',
        '$log',
        '$timeout',
        'USER_TYPES'
    ];

    function authenticationService(
        $localStorage,
        $rootScope,
        $injector,
        jwtHelper,
        defaultLocalStorageValue,
        $q,
        IDB,
        requestHelpers,
        $log,
        $timeout,
        USER_TYPES
    ) {
        var service = this;

        service.login = login;
        service.obtainToken = obtainToken;
        service.refreshAccessToken = refreshAccessToken;
        service.setToken = setToken;
        service.logout = logout;
        service.isLoggedIn = isLoggedIn;
        service.startListeners = startListeners;
        service.isUserAllowedOnState = isUserAllowedOnState;

        var _refreshPromise = null;

        return service;

        /**
         * Refresh the access token using the stored refresh token.
         * Falls back to full re-authentication if no refresh token is available.
         * Deduplicates concurrent calls — all callers share one in-flight request.
         * @return promise
         */
        function refreshAccessToken() {
            if (_refreshPromise) {
                return _refreshPromise;
            }

            _refreshPromise = _doRefresh()['finally'](function() {
                _refreshPromise = null;
            });

            return _refreshPromise;
        }

        function _doRefresh() {
            var refreshToken = $localStorage.user && $localStorage.user.jwt && $localStorage.user.jwt.refreshToken;
            if (!refreshToken) {
                // No refresh token available, fall back to full login
                return obtainToken();
            }
            var tokenRefresh = $injector.get('Restangular').all('api/token/refresh/');
            return tokenRefresh
                .post({ refresh: refreshToken })
                .then(function(response) {
                    var accessToken = response.access;
                    if (accessToken) {
                        $localStorage.user.jwt.decoded = jwtHelper.decodeToken(accessToken);
                        $localStorage.user.jwt.token = 'JWT ' + accessToken;
                        // If server rotates refresh tokens, store the new one
                        if (response.refresh) {
                            $localStorage.user.jwt.refreshToken = response.refresh;
                        }
                        return response;
                    }
                    // Refresh failed, fall back to full login
                    return obtainToken();
                })
                .catch(function() {
                    // Refresh token expired or invalid, fall back to full login
                    return obtainToken();
                });
        }

        /**
         * Login method saves the user object in local storage
         * @param email string emailaddress
         * @param password string password for user
         * @param cb function callback
         * @returns calls obtaintoken function with optional callback
         */
        function login(email, password) {
            $localStorage.user.data = {
                email,
                password
            };

            return obtainToken();
        }

        /**
         * Function to get an auth token from the apitoken resource provider
         * @return promise
         */
        function obtainToken() {
            var tokenAuth = $injector.get('Restangular').all('api-token-auth/');
            if (!$localStorage.user.data) {
                $injector.get('$state').go('authentication.login');
            }
            return tokenAuth.post($localStorage.user.data).then(function(authenticated) {
                return setToken(authenticated);
            });
        }

        function setToken(authenticated) {
            if (authenticated && !authenticated.non_field_errors) {
                // reset user.info so this will be obtained freshly from /me
                $localStorage.user.info = {};
                // SimpleJWT returns 'access' and 'refresh' tokens, plus 'token' for backward compat
                var accessToken = authenticated.access || authenticated.token;
                $localStorage.user.jwt.decoded = jwtHelper.decodeToken(accessToken);
                $localStorage.user.jwt.token = accessToken ? 'JWT ' + accessToken : undefined;
                // Store refresh token for token renewal
                if (authenticated.refresh) {
                    $localStorage.user.jwt.refreshToken = authenticated.refresh;
                }

                return authenticated;
            } else {
                $injector.get('$state').go('authentication.login');
                const errors = authenticated && new Error(authenticated.non_field_errors);
                return $q.reject(errors);
            }
        }

        /**
         * Logout method
         */
        function logout() {
            // Attempt to blacklist the refresh token server-side (best effort)
            var refreshToken = $localStorage.user && $localStorage.user.jwt && $localStorage.user.jwt.refreshToken;
            if (refreshToken) {
                try {
                    var Restangular = $injector.get('Restangular');
                    Restangular.all('api/token/blacklist/').post({ refresh: refreshToken });
                } catch (e) {
                    // Ignore errors during logout cleanup
                }
            }
            var localStorage = {
                user: {
                    data: {},
                    jwt: {},
                    info: {}
                }
            };
            $localStorage.$reset(localStorage);
            IDB.deleteDB();
            $rootScope.unreadAlerts = { results: [] };
            $rootScope.HOME = 'base.home';
            $injector.get('$state').go('authentication.login');
        }

        /**
         * Function to check if there are any credentials present
         * @returns boolean
         */
        function hasCredentials() {
            return (
                $localStorage.user &&
                $localStorage.user.data &&
                $localStorage.user.data.email &&
                $localStorage.user.data.password
            );
        }

        /**
         * Function to check if user is logged in
         * @returns boolean
         */
        function isLoggedIn() {
            return $localStorage.user && requestHelpers.isValidToken($localStorage.user.jwt);
        }

        function checkFrontendPermission(user) {
            if (!user) {
                return;
            }

            var frontends = user.allowed_frontends ? angular.fromJson(user.allowed_frontends) : [];
            $rootScope.me = user;
            $localStorage.user.info = user;
            var allowedFrontends = frontends
                .filter(function(frontend) {
                    return frontend.app === $rootScope.app;
                })
                .reduce(function(memo, frontend) {
                    return frontend;
                }, 'notAllowed');

            allowedFrontends === 'notAllowed' ? logout() : '';
        }

        function isUserAllowedOnState(toStateName) {
            if (!$localStorage.user.info) return false;

            // To show "Users" on nav menu on trainee env, comment out 2 lines below. #SSO
            if ($rootScope.isTrainee && (toStateName == 'base.hrm-users' || toStateName == 'base.hrm-user'))
                return false;

            return USER_TYPES[$rootScope.app]
                .filter(role => $localStorage.user.info[role.name])
                .reduce((memo, role) => {
                    if (
                        role.allowed_all &&
                        $localStorage.user.info.is_scope_employee &&
                        toStateName == 'base.admin-generate'
                    )
                        return true;
                    if (
                        role.allowed_all &&
                        !$localStorage.user.info.is_scope_employee &&
                        toStateName == 'base.admin-generate'
                    )
                        return false;
                    // Check denied_states for roles that have allowed_all but restricted pages
                    if (role.allowed_all && role.denied_states) {
                        var isDenied = role.denied_states.some(function(deniedState) {
                            return toStateName === deniedState || toStateName.indexOf(deniedState + '.') === 0;
                        });
                        if (isDenied) return false;
                        return true;
                    }
                    return (
                        role.allowed_all ||
                        role.allowed_states
                            .filter(allowedState =>
                                _.isObject(allowedState)
                                    ? toStateName.indexOf(allowedState.abstract) !== -1
                                    : toStateName === allowedState
                            )
                            .reduce(() => {
                                return true;
                            }, false)
                    );
                }, false);
        }

        function startListeners() {
            var stateChangeInProgress = false;
            var $state = $injector.get('$state');
            var me = $injector.get('me');

            $rootScope.$on('$stateChangeStart', function($event, toState) {
                if (stateChangeInProgress) {
                    return;
                }

                stateChangeInProgress = true;

                if (
                    !isLoggedIn() &&
                    toState.name !== 'authentication.set' &&
                    toState.name !== 'authentication.reset' &&
                    toState.name !== 'authentication.register'
                ) {
                    $event.preventDefault();
                    return $state.go('authentication.login', {}, { reload: true });
                }

                if (isLoggedIn()) {
                    var userType = USER_TYPES[$rootScope.app].find(item => $localStorage.user.info[item.name]) || {};
                    var homeState = userType.home_state || 'base.home';

                    // If user is logged in and tries to go to login page, redirect to home
                    if (toState.name === 'authentication.login') {
                        $event.preventDefault();
                        return $state.go(homeState, {}, { reload: true });
                    }

                    if (_.isEmpty($localStorage.user.info)) {
                        return me
                            .getMe()
                            .then(me.setMyLanguage)
                            .then(checkFrontendPermission)
                            .then(function() {
                                if (!isUserAllowedOnState(toState.name)) {
                                    stateChangeInProgress = false;
                                    $event.preventDefault();
                                    return $state.go(homeState, {}, { reload: true });
                                }
                            })
                            .catch(function() {
                                console.log('me fetch error');
                            });
                    } else {
                        if (
                            $rootScope.app === 'website' &&
                            !$localStorage.user.info.can_create_projects &&
                            toState.name !== 'base.home'
                        ) {
                            $injector.get('toastr').error('User cannot create projects', 'Update User Abilities');
                            $state.go(toState.name);
                            logout();
                            return $event.preventDefault();
                        }
                        checkFrontendPermission($localStorage.user.info);
                        if (!isUserAllowedOnState(toState.name)) {
                            stateChangeInProgress = false;
                            $event.preventDefault();
                            return $state.go(homeState, {}, { reload: true });
                        }
                    }
                }
            });

            $rootScope.$on('$stateChangeSuccess', function($event, toState, toParams, fromState) {
                stateChangeInProgress = false;
                if (!fromState.name) {
                    $rootScope.$previousState = { name: '$root', isRoot: true };
                } else {
                    $rootScope.$previousState = fromState;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication.login').config(config);

    config.$inject = ['$httpProvider'];

    function config($httpProvider) {
        $httpProvider.interceptors.push(authenticationInterceptor);
    }

    authenticationInterceptor.$inject = [
        '$localStorage',
        '$injector',
        '$q',
        '$timeout',
        'requestHelpers',
        'authenticationService'
    ];

    function authenticationInterceptor($localStorage, $injector, $q, $timeout, requestHelpers, authenticationService) {
        return {
            /**
             * Add request interceptor function to append an Authorization header to the request.
             *
             * @param request
             * @returns {*}
             */
            request: function(request) {
                var noAuth = false;
                if (request.params !== undefined) {
                    noAuth = request.params.noAuth;
                }

                if (request.data && request.data.noAuth) {
                    noAuth = request.data.noAuth;
                }

                if (!noAuth) {
                    if (!requestHelpers.isResource(request.url)) {
                        return $q.when(request); // do not fill Authorization header
                    }

                    var isValidToken = requestHelpers.isValidToken($localStorage.user.jwt);

                    // if we do not have a valid token, try refresh first, then full re-auth
                    if (!isValidToken) {
                        return authenticationService.refreshAccessToken().then(function() {
                            request.headers.Authorization = $localStorage.user.jwt.token;
                            return request;
                        });
                    } else {
                        // we're good, set header
                        request.headers.Authorization = $localStorage.user.jwt.token;
                        return $q.when(request);
                    }
                }
                // request.params = undefined;
                return request;
            },

            /**
             * Add response interceptor for catching expired token calls
             *
             * @param response
             */
            responseError: function(response) {
                var deferred = $q.defer();

                //TODO: fix this mild hack...
                if (
                    response.data &&
                    response.data.detail === 'This project has been submitted for approval, deleting is not allowed'
                ) {
                    return response;
                }

                // If any 5xx response received say that server is down for maintenance
                if (response.status > 500) {
                    $timeout(function() {
                        throw {
                            name: 'ResourceError',
                            error: {
                                config: {},
                                data: {
                                    message: 'Server down for maintenance!'
                                }
                            }
                        };
                    }, 500);
                }

                switch (response.status) {
                    case 400:
                        if (
                            response.config.url.indexOf('api-token-auth') === -1 &&
                            response.config.url.indexOf('api/token') === -1
                        ) {
                            throw {
                                name: 'UserError',
                                error: response,
                                noCurl: true
                            };
                        }
                        return $q.reject(response);
                    case 401:
                        // Don't retry refresh/auth endpoints — let the promise chain handle fallback
                        if (
                            response.config.url.indexOf('api/token') > -1 ||
                            response.config.url.indexOf('api-token-auth') > -1
                        ) {
                            return $q.reject(response);
                        }
                        authenticationService
                            .refreshAccessToken()
                            .then(function() {
                                var $http = $injector.get('$http');
                                $http(response.config)
                                    .then(function(response) {
                                        deferred.resolve(response);
                                    })
                                    .catch(function(err) {
                                        deferred.reject(err);
                                    });
                            })
                            .catch(function(err) {
                                deferred.reject(err);
                            });
                        return deferred.promise;
                    case 403:
                        response.data = Object.assign(response.data, {
                            'User Permissions Error':
                                'User does not have permissions for this operation - Please contact info@scopeinsight.com'
                        });
                        return $q.reject(response);
                    case 500:
                        response.data = { 'Server Error': 'Please contact info@scopeinsight.com' };
                        return $q.reject(response);
                    default:
                        //Handle Nothing just return it
                        return response;
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.authentication').controller('authenticationController', authenticationController);

    authenticationController.$inject = ['translationFactory', 'siTranslations', '$location', '$state'];

    function authenticationController(translationFactory, siTranslations, $location, $state) {
        var vm = this;
        vm.languages = translationFactory.languages;
        vm.language;
        vm.chosenLanguage;

        vm.changeLanguage = changeLanguage;
        vm.isLogin = isLogin;
        vm.goToRegister = goToRegister;

        init();

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function init() {
            if (window.navigator.language) {
                vm.language = parseLanguage(navigator.language);
                siTranslations.setLanguage(vm.language);
                vm.chosenLanguage = setLanguage(vm.language);
            }
        }

        function parseLanguage(rawLanguage) {
            return /([a-z]+)/.exec(rawLanguage)[0];
        }

        function goToRegister() {
            $state.go('authentication.register');
        }

        function changeLanguage(code) {
            vm.language = code;
            vm.chosenLanguage = setLanguage(code);
            siTranslations.setLanguage(code);
        }

        function isLogin() {
            return $location.path() === '/login';
        }

        function setLanguage(language) {
            if (['en', 'fr', 'es'].indexOf(language) !== -1) {
                return vm.languages[language];
            }
            return vm.languages['en'];
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.reports').controller('rapidSummarySectionController', rapidSummarySectionController);

    rapidSummarySectionController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$uibModal',
        '$timeout',
        'modalFactory',
        'me',
        'EVENT_LOADER',
        '$log',
        'siAssessments',
        'toastr'
    ];

    function rapidSummarySectionController(
        $scope,
        $rootScope,
        $state,
        $uibModal,
        $timeout,
        modalFactory,
        me,
        EVENT_LOADER,
        $log,
        siAssessments,
        toastr
    ) {
        $scope.depth = 16;

        var params = {
            id: $state.params.id,
            fields: [
                'assessment',
                'assessment__section_responses',
                'assessment__section_responses__children',
                'assessment__section_responses__children__responses',
                'assessment__section_responses__children__responses__subresponses',
                'assessment__section_responses__children__responses__documents',
                'assessment__section_responses__unscored_responses',
                'assessment__producing_organization',
                'assessment__producing_organization__customer',
                'assessment__products'
            ]
        };

        $rootScope.$broadcast(EVENT_LOADER.show);

        siAssessments
            .getAssessment(params.id)
            .then(function(assessment) {
                $scope.assessment = assessment;

                assessment.section_responses.objects.forEach(function(section) {
                    section.children.objects = _.sortBy(section.children.objects, function(child) {
                        return parseFloat(child.section_display_position);
                    });
                });

                //get the current section
                $scope.section = _.find(assessment.section_responses.objects, function(item) {
                    return item.id === parseInt($state.params.section);
                });

                $rootScope.$broadcast(EVENT_LOADER.hide);
            })
            .catch(function(err) {
                toastr.error('Error Fetching Assessment - ', err.detail);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').factory('siQuestionnaire', siQuestionnaire);

    siQuestionnaire.$inject = ['$rootScope'];

    function siQuestionnaire($rootScope) {
        var service = this;

        service.setQuestionnaireDone = setQuestionnaireDone;
        service.isQuestionnaireDone = isQuestionnaireDone;
        service.isResponseDone = isResponseDone;
        service.isQuestionnaireAccepted = isQuestionnaireAccepted;
        service.parseResponses = parseResponses;
        service.getQuestionnaireStatus = getQuestionnaireStatus;
        service.setResponseScore = setResponseScore;
        service.setParentResponseAccepted = setParentResponseAccepted;
        service.initializeQuestionnaire = initializeQuestionnaire;
        service.responseApplicable = responseApplicable;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function initializeQuestionnaire(assessment) {
            assessment = setParentResponseAccepted(assessment);
            assessment = setResponseScore(assessment);
            assessment = parseResponses(assessment);

            return assessment;
        }

        function getQuestionnaireStatus(assessment, assignment) {
            //If we have this boolean on the assessment then we can fire a whole bunch of checks.
            if (assessment.completion_check_required) {
                assessment.section_responses.objects = setQuestionnaireDone(assessment);
                assessment.isQuestionnaireDone = isFinancialSpecialist(assignment)
                    ? true
                    : isQuestionnaireDone(assessment, $rootScope.app);
                assessment.isQuestionnaireAccepted = isQuestionnaireAccepted(assessment);
            }

            return assessment;
        }

        /**
         * Method to set a questionnaire done state
         * @param assessment
         * @returns {*}
         */
        function setQuestionnaireDone(assessment) {
            //Represents the top level headers
            return assessment.section_responses.objects.map(sectionResponse => {
                //Second level header
                sectionResponse.children.objects = sectionResponse.children.objects.map(isChildDone);

                if (sectionResponse.shouldCheckCompletion) {
                    sectionResponse.isDone = sectionResponse.children.objects
                        .map(function(child) {
                            return Boolean(child.isDone);
                        })
                        .reduce(function(memo, child, index) {
                            if (index === 0) {
                                memo = true;
                            }
                            return memo && child;
                        }, false);
                } else {
                    sectionResponse.isDone = true;
                }

                return sectionResponse;
            });
        }

        /**
         * Method to determine a questionnaire done state
         * @param assessment
         * @param app
         * @returns {*}
         */
        function isQuestionnaireDone(assessment, app) {
            switch (app) {
                case 'smartclient':
                    return areAllSectionsDone(assessment);
                case 'dashboard':
                    return areAllSectionsAccepted(assessment);
                default:
                    return areAllSectionsDone(assessment);
            }
        }

        function isResponseDone(response) {
            return response.subresponses.objects.every(subresponse => {
                if (subresponse.subquestion.is_conditional) {
                    const isShown = response.subresponses.objects
                        .filter(sr => sr.subquestion.url === subresponse.subquestion.conditional_subquestion)
                        .some(sr => sr.selected_options === subresponse.subquestion.conditional_subquestion_option);
                    return isShown ? subresponse.isDone : true;
                } else {
                    return subresponse.isDone;
                }
            });
        }

        function isQuestionnaireAccepted(assessment) {
            return areAllSectionsAccepted(assessment);
        }

        function setResponseScore(assessment) {
            assessment.section_responses.objects.forEach(section => processChildResponses(section));
            return assessment;
        }

        function setParentResponseAccepted(assessment = { section_responses: { objects: [] } }) {
            const recurseChildSections = section => {
                _.each(section.children.objects, childSection => {
                    if (childSection.children) {
                        recurseChildSections(childSection);
                    }

                    childSection.accepted = _.every(childSection.responses.objects, response => response.accepted);
                });

                section.accepted = _.every(section.children.objects, childSection => childSection.accepted);
            };

            assessment.section_responses.objects.forEach(recurseChildSections);

            return assessment;
        }

        function processChildResponses(section) {
            const processResponse = response => (response.score = response.score === null ? 0 : response.score);

            if (section.children.objects) {
                section.children.objects.forEach(childSection => {
                    if (childSection.children) {
                        processChildResponses(childSection, processResponse);
                    }

                    childSection.responses.objects.forEach(processResponse);
                });
            }
        }

        function parseResponses(assessment) {
            assessment.section_responses.objects = assessment.section_responses.objects
                .map(responses => {
                    responses.children.objects = responses.children.objects.map(section => {
                        section.isShown = section.responses.objects
                            .map(response => responseApplicable(response, assessment))
                            .filter(shouldShow => shouldShow)
                            .reduce((memo, shouldShow) => shouldShow, false);

                        return section;
                    });
                    return responses;
                })
                //We make a final filter iteration to be sure that one of the children.objects is actually being shown
                //otherwise we kill the entire section so we dont have any confusion in completion checks.
                .map(responses => {
                    responses.shouldCheckCompletion = responses.children.objects
                        .filter(section => section.isShown)
                        .reduce((memo, isShown) => Boolean(isShown), false);

                    return responses;
                });

            return assessment;
        }

        /**
         * Function to check if a response is applicable for the current PO,
         * this depends on the customizations in the tool (available on
         * conditions in the response object) and the current settings of a
         * PO on:
         * - Activities
         * - Sector
         * - po type
         * - country
         * - products
         *
         * @param response    question response object with conditionals
         * @param assessment  assessment object with nested information
         * @returns boolean   true if all conditions are met, otherwise returns false
         */
        function responseApplicable(response, assessment) {
            //Check if the conditions object is empty,
            //which means we have no customizations, thus simply return true
            //otherwise go further onto the nasty boolean below
            if (_.isEmpty(response.conditions)) {
                return true;
            }

            //Looks like conditions is not empty so lets check our values
            //The first check is always to be sure our condition arrays children have a populated array.
            //The second check looks if the conditions specified actually exist on the assessment

            const shouldBeShown =
                //Check that our activity conditions are in the assessment
                (!response.conditions.activities.length ||
                    _.intersection(
                        response.conditions.activities,
                        assessment.producing_organization.activities.objects.map(activity => activity.url)
                    ).length) &&
                //Check that our sectors conditions are in the assessment
                (!response.conditions.sectors.length ||
                    _.intersection(
                        response.conditions.sectors,
                        assessment.producing_organization.sectors.objects.map(sector => sector.url)
                    ).length) &&
                //Check that our po_types conditions match the po customer type
                (!response.conditions.po_types.length ||
                    response.conditions.po_types.filter(
                        type => type.url === assessment.producing_organization.legal_status
                    ).length) &&
                //Check that our countries conditions match the po country
                (!response.conditions.countries.length ||
                    _.intersection(response.conditions.countries, [assessment.producing_organization.country])
                        .length) &&
                //check that the product conditions are in the assessment products of type
                (!response.conditions.products.length ||
                    _.intersection(
                        response.conditions.products,
                        assessment.products.objects.map(product => product.type)
                    ).length);

            response.isShown = Boolean(shouldBeShown);

            return Boolean(shouldBeShown);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Private Methods
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isConditionalShown(subquestion, response) {
            return response.subresponses.objects
                .filter(question => question.subquestion.url === subquestion.conditional_subquestion)
                .filter(question => question.selected_option === subquestion.conditional_subquestion_option)
                .reduce(() => true, false);
        }

        /**
         * Helper function to determine if the child section is done
         * @param child
         * @returns {*}
         */
        function isChildDone(child) {
            child.isDone = child.responses.objects
                .map(response => {
                    if (response.subresponses.objects.length && response.isShown !== false) {
                        return response.subresponses.objects
                            .filter(subresponse => {
                                return subresponse.subquestion.is_conditional
                                    ? isConditionalShown(subresponse.subquestion, response)
                                    : true;
                            })
                            .map(subresponse => {
                                if (typeof subresponse.isDone === 'undefined') {
                                    subresponse.isDone = isSubresponseDone(subresponse);
                                }

                                return subresponse.isDone;
                            })
                            .reduce((memo, isDone, index) => {
                                if (index === 0) {
                                    memo = true;
                                }
                                return memo && isDone;
                            }, false);
                    } else {
                        return true;
                    }
                })
                .reduce(function(memo, isDone, index) {
                    if (index === 0) {
                        memo = true;
                    }
                    return memo && isDone;
                }, false);

            child.isDone = child.isShown ? child.isDone : true;

            return child;
        }

        // Ovde ce se raditi nesto
        function isSubresponseDone(subresponse) {
            if (isCommentMandatoryMissing(subresponse)) {
                return false;
            } else {
                switch (subresponse.subquestion.type) {
                    case 'checkbox':
                        return isCheckboxDone(subresponse);
                    case 'mpc':
                        return isMpcDone(subresponse);
                    case 'numeric':
                        return isNumericDone(subresponse);
                    default:
                        return true;
                }
            }
        }

        // Function to check if a mandatory comment is missing
        function isCommentMandatoryMissing(subresponse) {
            return (
                subresponse.subquestion.comment_mandatory &&
                (subresponse.not_relevant || subresponse.none_of_the_above) &&
                subresponse.comment === ''
            );
        }

        // smisliti sta treba
        function isCheckboxDone(subresponse) {
            // Handle both formats: {objects: [...]} and plain array [...]
            var checkedOptionsLength = 0;
            if (subresponse.checked_options) {
                if (subresponse.checked_options.objects) {
                    checkedOptionsLength = subresponse.checked_options.objects.length;
                } else if (Array.isArray(subresponse.checked_options)) {
                    checkedOptionsLength = subresponse.checked_options.length;
                }
            }
            return Boolean(checkedOptionsLength || subresponse.not_relevant || subresponse.none_of_the_above);
        }

        function isMpcDone(subresponse) {
            return Boolean(subresponse.selected_option || subresponse.not_relevant || subresponse.none_of_the_above);
        }

        function isNumericDone(subresponse) {
            return isNaN(subresponse.value) || subresponse.value === null
                ? subresponse.not_relevant || subresponse.none_of_the_above
                : typeof subresponse.value === 'number';
        }

        function areAllSectionsDone(assessment) {
            return assessment.section_responses.objects
                .map(sectionResponses => (sectionResponses.shouldCheckCompletion ? sectionResponses.isDone : true))
                .reduce(function(memo, child, index) {
                    if (index === 0) {
                        memo = true;
                    }
                    return memo && child;
                }, false);
        }

        function areAllSectionsAccepted(assessment) {
            return assessment.section_responses.objects
                .map(function(sectionResponses) {
                    return sectionResponses.accepted;
                })
                .reduce(function(memo, child, index) {
                    if (index === 0) {
                        memo = true;
                    }
                    return memo && child;
                }, false);
        }

        function isFinancialSpecialist(assignment) {
            return assignment.assigned_as === 'financial_specialist';
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').factory('DataService', DataService);

    DataService.$inject = [];

    function DataService() {
        let aiData = [];

        return {
            setData: data => (aiData = data),
            getData: () => aiData
        };
    }
})();

(function() {
    'use strict';

    /**
     * `<consent-document-preview>` - a consent document shown inline in the
     * Data Sharing tab. AD-2191.
     *
     * PDF (PDF.js, with page navigation), JPG, JPEG and PNG render in place
     * with zoom; any other type, and any preview that fails, shows a message
     * and still offers the download.
     *
     * The bytes come from the API's `terms_and_conditions/<id>/content/`, not
     * from the storage URL: the request carries the user's normal
     * authorisation, so the document is reachable exactly by whoever may read
     * the record (finalised assessments included), and the browser needs no
     * CORS on the blob storage to render it.
     *
     * The viewing controls are links, not buttons: the tab wraps this in a
     * fieldset that is disabled once the tab is accepted or locked, and a
     * disabled fieldset disables every button inside it. Viewing must keep
     * working then; deleting is a real button and is disabled as before.
     */
    angular.module('scope.commons.assessments').directive('consentDocumentPreview', consentDocumentPreview);

    consentDocumentPreview.$inject = ['$http', '$q', '$timeout', '$window', '$document', 'gettext', 'gettextCatalog'];

    function consentDocumentPreview($http, $q, $timeout, $window, $document, gettext, gettextCatalog) {
        const PDFJS_VERSION = '3.11.174';
        const PDFJS_BASE = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VERSION + '/';
        const ZOOM_STEPS = [0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3];
        const IMAGE_TYPES = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png' };
        let pdfjsPromise = null;

        return {
            restrict: 'E',
            scope: {
                document: '<',
                onDelete: '&',
                isOffline: '<'
            },
            templateUrl: 'assessments/partials/consentDocumentPreview.html',
            link: link
        };

        /** PDF.js, loaded once and only when a PDF is shown. */
        function loadPdfjs() {
            if ($window.pdfjsLib) {
                return $q.resolve($window.pdfjsLib);
            }
            if (!pdfjsPromise) {
                pdfjsPromise = $q(function(resolve, reject) {
                    const script = $document[0].createElement('script');
                    script.src = PDFJS_BASE + 'pdf.min.js';
                    script.async = true;
                    script.onload = function() {
                        if (!$window.pdfjsLib) {
                            reject(new Error('PDF.js did not initialise'));
                            return;
                        }
                        $window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + 'pdf.worker.min.js';
                        resolve($window.pdfjsLib);
                    };
                    script.onerror = function() {
                        reject(new Error('PDF.js could not be loaded'));
                    };
                    $document[0].head.appendChild(script);
                }).catch(function(error) {
                    pdfjsPromise = null; // allow a later retry, e.g. after going back online
                    return $q.reject(error);
                });
            }
            return pdfjsPromise;
        }

        function extensionOf(name) {
            const match = /\.([a-z0-9]+)$/i.exec(name || '');
            return match ? match[1].toLowerCase() : '';
        }

        function link(scope, element) {
            const ui = (scope.ui = {
                state: 'loading', // loading | ready | unsupported | error
                kind: null, // pdf | image | other
                zoom: 1,
                page: 1,
                pages: 0,
                imageUrl: null,
                errorMessage: ''
            });
            let blob = null;
            let pdf = null;
            let renderTask = null;
            let rendering = false;
            let renderAgain = false;
            let loadToken = 0;

            scope.fileName = fileName;
            scope.typeLabel = typeLabel;
            scope.zoomIn = () => setZoom(nextZoom(1));
            scope.zoomOut = () => setZoom(nextZoom(-1));
            scope.canZoomIn = () => ui.zoom < ZOOM_STEPS[ZOOM_STEPS.length - 1];
            scope.canZoomOut = () => ui.zoom > ZOOM_STEPS[0];
            scope.previousPage = () => goTo(ui.page - 1);
            scope.nextPage = () => goTo(ui.page + 1);
            scope.download = download;
            scope.toggleFullscreen = toggleFullscreen;
            scope.retry = load;
            scope.onKey = function($event, action) {
                if ($event.keyCode === 13 || $event.keyCode === 32) {
                    $event.preventDefault();
                    action();
                }
            };

            scope.$watch('document.url', function(url, previous) {
                if (url && url !== previous) {
                    load();
                } else if (url && ui.state === 'loading') {
                    load();
                }
            });
            scope.$on('$destroy', cleanup);

            function fileName() {
                const doc = scope.document || {};
                return doc.original_file_name || doc.file_name || gettextCatalog.getString(gettext('Consent document'));
            }

            function storedName() {
                const doc = scope.document || {};
                return doc.file_name || doc.original_file_name || doc.file || '';
            }

            function typeLabel() {
                const ext = extensionOf(storedName()) || extensionOf(fileName());
                const label = ext ? ext.toUpperCase() : gettextCatalog.getString(gettext('File'));
                if (ui.kind === 'pdf' && ui.pages) {
                    return label + ' · ' + gettextCatalog.getPlural(ui.pages, '1 page', '{{$count}} pages', {});
                }
                return label;
            }

            function contentUrl(download) {
                const url = scope.document.url.replace(/\/?$/, '/') + 'content/';
                return download ? url + '?download=1' : url;
            }

            function fetchBlob(download) {
                return $http
                    .get(contentUrl(download), { responseType: 'blob', cache: false })
                    .then(response => response.data);
            }

            function load() {
                const token = ++loadToken;
                cleanup();
                ui.state = 'loading';
                ui.page = 1;
                ui.pages = 0;
                ui.zoom = 1;
                const ext = extensionOf(storedName()) || extensionOf(fileName());
                ui.kind = ext === 'pdf' ? 'pdf' : IMAGE_TYPES[ext] ? 'image' : 'other';

                if (ui.kind === 'other') {
                    ui.state = 'unsupported';
                    return $q.resolve();
                }
                if (scope.isOffline) {
                    fail(gettext('The preview is not available offline.'));
                    return $q.resolve();
                }

                return fetchBlob(false)
                    .then(function(data) {
                        if (token !== loadToken) {
                            return;
                        }
                        blob = data;
                        if (ui.kind === 'image') {
                            ui.imageUrl = $window.URL.createObjectURL(blob);
                            ui.state = 'ready';
                            return;
                        }
                        return showPdf(token);
                    })
                    .catch(function() {
                        if (token === loadToken) {
                            fail(gettext('The document preview could not be loaded.'));
                        }
                    });
            }

            function showPdf(token) {
                return $q
                    .all([loadPdfjs(), readBytes(blob)])
                    .then(function(results) {
                        const pdfjsLib = results[0];
                        return $q.when(pdfjsLib.getDocument({ data: results[1] }).promise);
                    })
                    .then(function(document) {
                        if (token !== loadToken) {
                            document.destroy();
                            return;
                        }
                        pdf = document;
                        ui.pages = document.numPages;
                        ui.state = 'ready';
                        // The canvas exists once the ready state has rendered.
                        return $timeout(renderPage, 0);
                    });
            }

            function readBytes(data) {
                return $q(function(resolve, reject) {
                    const reader = new $window.FileReader();
                    reader.onload = () => resolve(new Uint8Array(reader.result));
                    reader.onerror = () => reject(reader.error);
                    reader.readAsArrayBuffer(data);
                });
            }

            /**
             * One render at a time. PDF.js refuses a second render() on a canvas
             * that is still being drawn, and a quick "next page" then "zoom in"
             * did exactly that: the second call started before the first had a
             * render task to cancel. A request made while a render runs cancels
             * it and is replayed once it settles, with the state current then.
             */
            function renderPage() {
                if (rendering) {
                    renderAgain = true;
                    if (renderTask) {
                        renderTask.cancel();
                    }
                    return $q.resolve();
                }
                rendering = true;
                return drawPage().finally(function() {
                    rendering = false;
                    renderTask = null;
                    if (renderAgain) {
                        renderAgain = false;
                        renderPage();
                    }
                });
            }

            function drawPage() {
                if (!pdf) {
                    return $q.resolve();
                }
                const canvas = element[0].querySelector('.consent-preview__canvas');
                const viewport = element[0].querySelector('.consent-preview__viewport');
                if (!canvas || !viewport) {
                    return $q.resolve();
                }
                const pageNumber = ui.page;
                return $q
                    .when(pdf.getPage(pageNumber))
                    .then(function(page) {
                        // 100 % is "fit to the preview's width"; zoom scales from there.
                        const natural = page.getViewport({ scale: 1 });
                        const available = Math.max(200, viewport.clientWidth - 32);
                        const scale = (available / natural.width) * ui.zoom;
                        const ratio = $window.devicePixelRatio || 1;
                        const view = page.getViewport({ scale: scale * ratio });
                        canvas.width = Math.floor(view.width);
                        canvas.height = Math.floor(view.height);
                        canvas.style.width = Math.floor(view.width / ratio) + 'px';
                        canvas.style.height = Math.floor(view.height / ratio) + 'px';
                        renderTask = page.render({ canvasContext: canvas.getContext('2d'), viewport: view });
                        return $q.when(renderTask.promise);
                    })
                    .catch(function(error) {
                        if ((error && error.name === 'RenderingCancelledException') || renderAgain) {
                            return;
                        }
                        fail(gettext('The document preview could not be loaded.'));
                    });
            }

            function nextZoom(direction) {
                const index = ZOOM_STEPS.indexOf(ui.zoom);
                const next = Math.min(ZOOM_STEPS.length - 1, Math.max(0, index + direction));
                return ZOOM_STEPS[next];
            }

            function setZoom(zoom) {
                if (zoom === ui.zoom) {
                    return;
                }
                ui.zoom = zoom;
                if (ui.kind === 'pdf') {
                    renderPage();
                }
            }

            function goTo(page) {
                if (!pdf || page < 1 || page > ui.pages || page === ui.page) {
                    return;
                }
                ui.page = page;
                renderPage();
            }

            function download() {
                const name = fileName();
                const saving = blob ? $q.resolve(blob) : fetchBlob(true);
                return saving
                    .then(function(data) {
                        const url = $window.URL.createObjectURL(data);
                        const anchor = $document[0].createElement('a');
                        anchor.href = url;
                        anchor.download = name;
                        $document[0].body.appendChild(anchor);
                        anchor.click();
                        $document[0].body.removeChild(anchor);
                        $timeout(() => $window.URL.revokeObjectURL(url), 1000, false);
                    })
                    .catch(function() {
                        // Last resort: the storage link the tab offered before.
                        if (scope.document && scope.document.file) {
                            $window.open(scope.document.file, '_blank');
                        }
                    });
            }

            function toggleFullscreen() {
                const doc = $document[0];
                const target = element[0].querySelector('.consent-preview');
                const active = doc.fullscreenElement || doc.webkitFullscreenElement;
                if (active) {
                    (doc.exitFullscreen || doc.webkitExitFullscreen).call(doc);
                    return;
                }
                const request = target.requestFullscreen || target.webkitRequestFullscreen;
                if (request) {
                    request.call(target);
                }
            }

            function onFullscreenChange() {
                if (ui.kind === 'pdf' && pdf) {
                    $timeout(renderPage, 50);
                }
            }
            $document[0].addEventListener('fullscreenchange', onFullscreenChange);
            $document[0].addEventListener('webkitfullscreenchange', onFullscreenChange);
            scope.$on('$destroy', function() {
                $document[0].removeEventListener('fullscreenchange', onFullscreenChange);
                $document[0].removeEventListener('webkitfullscreenchange', onFullscreenChange);
            });

            function fail(message) {
                ui.state = 'error';
                ui.errorMessage = gettextCatalog.getString(message);
            }

            function cleanup() {
                if (renderTask) {
                    renderTask.cancel();
                    renderTask = null;
                }
                if (pdf) {
                    pdf.destroy();
                    pdf = null;
                }
                if (ui.imageUrl) {
                    $window.URL.revokeObjectURL(ui.imageUrl);
                    ui.imageUrl = null;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').factory('assessmentService', assessmentService);

    function assessmentService() {
        var service = this;
        var ASSESSMENT_URL;
        var ASSIGNMENT_LIST = [];

        service.getYears = getYears;
        service.setAssessmentUrl = setAssessmentUrl;
        service.getAssessmentUrl = getAssessmentUrl;
        service.getAssignmentList = getAssignmentList;
        service.setAssignmentList = setAssignmentList;
        service.getAssessmentByID = getAssessmentByID;
        service.push = push;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getYears(startYear) {
            startYear = startYear || 2000;

            var currentYear = new Date().getFullYear(),
                years = [];

            while (startYear <= currentYear) {
                years.push(new Date(startYear++, 0, 1).getFullYear());
            }
            return years;
        }

        function setAssessmentUrl(url) {
            ASSESSMENT_URL = url;
        }

        function getAssessmentUrl() {
            return ASSESSMENT_URL;
        }

        function setAssignmentList(list) {
            ASSIGNMENT_LIST = list;
        }

        function getAssignmentList() {
            return ASSIGNMENT_LIST;
        }

        function push(assigmnent) {
            if (!assigmnent) {
                return false;
            }
            const isAssessmentInList = getAssessmentByID(assigmnent.assessment.id);
            return isAssessmentInList ? false : ASSIGNMENT_LIST.push(assigmnent);
        }

        function getAssessmentByID(id) {
            id = typeof id === 'number' ? id : parseInt(id);

            return ASSIGNMENT_LIST.filter(function(assignment) {
                return assignment.assessment.id === id;
            }).reduce(function(memo, assignment) {
                return assignment.assessment;
            }, false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('assessmentRapidSummaryController', assessmentRapidSummaryController);

    assessmentRapidSummaryController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$uibModal',
        '$timeout',
        '$log',
        '$q',
        '$http',
        'modalFactory',
        'apiUrl',
        'me',
        'siScope',
        'siAssessments',
        'siAssessmentDetail',
        'siCustomers',
        'siProducts',
        'gettext',
        'gettextCatalog',
        '$stateParams',
        'moment',
        '$location',
        'EVENT_LOADER',
        '$window',
        'toastr'
    ];

    function assessmentRapidSummaryController(
        $scope,
        $rootScope,
        $state,
        $uibModal,
        $timeout,
        $log,
        $q,
        $http,
        modalFactory,
        apiUrl,
        me,
        siScope,
        siAssessments,
        siAssessmentDetail,
        siCustomers,
        siProducts,
        gettext,
        gettextCatalog,
        $stateParams,
        moment,
        $location,
        EVENT_LOADER,
        $window,
        toastr
    ) {
        var params = {
            id: $state.params.id,
            fields: [
                'assessment',
                'assessment__tool',
                'assessment__tool__type',
                'assessment__assessmentassignments',
                'assessment__assessmentassignments__assessor',
                'assessment__assessmentassignments__assessor__user',
                'assessment__unscored_section_responses',
                'assessment__section_responses',
                'assessment__section_responses__children',
                'assessment__section_responses__unscored_responses',
                'assessment__producing_organization',
                'assessment__producing_organization__customer',
                'assessment__producing_organization',
                'assessment__producing_organization__customer',
                'assessment__producing_organization__activities',
                'assessment__producing_organization__sectors',
                'assessment__producing_organization__customer__representatives',
                'assessment__producing_organization__customer__contacts',
                'assessment__producing_organization__customer__contacts__user',
                'assessment__producing_organization__legal_status',
                'assessment__producing_organization_details',
                'assessment__producing_organization_details__services',
                'assessment__valuechainplayers',
                'assessment__valuechainplayers__relation_to_producing_organization',
                'assessment__enablingplayers',
                'assessment__enablingplayers__relation_to_producing_organization',
                'assessment__basic_financial_infos',
                'assessment__bank_accounts',
                'assessment__bank_accounts__bank_type',
                'assessment__collateral_assets',
                'assessment__loan_histories',
                'assessment__loan_histories__financier',
                'assessment__loan_histories__repayment_status',
                'assessment__loan_histories__purpose',
                'assessment__loan_requirements',
                'assessment__grant_histories',
                'assessment__grant_histories__in_cash_in_kind',
                'assessment__grant_histories__funder_type',
                'assessment__monthlyexpensesprojection_set',
                'assessment__monthlyincomeprojection_set',
                'assessment__products',
                'assessment__products__type',
                'assessment__products__productionfigures',
                'assessment__products__productionpurchases',
                'assessment__products__otherproductionpurchases',
                'assessment__products__productionsales',
                'assessment__products__certifications',
                'assessment__document_availability_responses',
                'assessment__document_availability_responses__question',
                'assessment__document_availability_responses__documents',
                'assessment__profitlossstatements',
                'assessment__balancesheets',
                'assessment__cashflowstatements',
                'assessment__financial_ratios',
                'assessment__financial_scores',
                'assessment__ratio_scores',
                'assessment__report_revision_reason',
                'assessment__general_checks',
                'assessment__executive_set',
                'assessment__nonexecutive_set',
                'assessment__governance_set',
                'assessment__responses',
                'assessment__responses__documents',
                'assessment__project',
                'assessment__terms_and_conditions',
                'assessment__is_invalidated',
                'assessment__invalidation_reason',
                'customers',
                'customers__contacts',
                'customers__contacts__user'
            ]
        };

        $scope.months = [
            gettext('jan'),
            gettext('feb'),
            gettext('mrt'),
            gettext('apr'),
            gettext('may'),
            gettext('jun'),
            gettext('jul'),
            gettext('aug'),
            gettext('sep'),
            gettext('oct'),
            gettext('nov'),
            gettext('dec')
        ];

        const months = [
            { value: 'january', display: gettextCatalog.getString('january') },
            { value: 'february', display: gettextCatalog.getString('february') },
            { value: 'march', display: gettextCatalog.getString('march') },
            { value: 'april', display: gettextCatalog.getString('april') },
            { value: 'may', display: gettextCatalog.getString('may') },
            { value: 'june', display: gettextCatalog.getString('june') },
            { value: 'july', display: gettextCatalog.getString('july') },
            { value: 'august', display: gettextCatalog.getString('august') },
            { value: 'september', display: gettextCatalog.getString('september') },
            { value: 'october', display: gettextCatalog.getString('october') },
            { value: 'november', display: gettextCatalog.getString('november') },
            { value: 'december', display: gettextCatalog.getString('december') }
        ];

        $scope.translateMonth = translateMonth;
        $scope.language = language;
        $scope.pdfDropdown = false;
        // $scope.openCustomPDFModal = openCustomPDFModal;
        function language() {
            return JSON.parse(localStorage['ngStorage-user']).info.language;
        }
        function translateMonth(month) {
            return months.filter(item => item.value === month)[0].display;
        }

        $scope.benchMarkUrl = apiUrl + '/media/reports/graphs/benchmark_' + $stateParams.id + '.png';
        $scope.poUrl = apiUrl + '/media/reports/graphs/po_' + $stateParams.id + '.png';
        $scope.isDashboardUserAdmin = me.isDashboardUserAdmin() || $rootScope.app === 'smartclient';
        $scope.isEmployee = me.isEmployee();
        $scope.stepCircles =
            $scope.isDashboardUserAdmin || $rootScope.app === 'smartclient'
                ? [gettext('assessment'), gettext('draft'), gettext('finalized')]
                : [gettext('assessment'), gettext('draft'), gettext('finalized'), gettext('published (optional)')];

        isUserAllowedOnState();

        $scope.$on('$stateChangeStart', ($event, toState) => isUserAllowedOnState(toState));

        $rootScope.$broadcast(EVENT_LOADER.show);

        const customersParams = {
            producing_organization: false,
            page_size: 9999
        };

        $scope.testing = function(data) {};

        $q.all([siAssessments.getAssessment($state.params.id), siCustomers.getSectors(), siProducts.getDropDowns()])
            .then(promises => {
                [$scope.assessment, $scope.flarg, $scope.dropdowns] = promises;
                $scope.assignment = $scope.assessment.assessmentassignments.objects[0];
                // $scope.documents = $scope.assignment.assessment.responses.objects
                //     .filter(response => response.documents.objects.length)
                //     .map(response => {
                //         return response.documents.objects
                //             .map(document => ({ response, document }))
                //             .reduce((memo, object) => object, {});
                //     })
                //     .sort((a, b) => {
                //         if (a.response.question_display_position > b.response.question_display_position) return 1;
                //         if (a.response.question_display_position < b.response.question_display_position) return -1;
                //         return 0;
                //     });

                $scope.breadcrumbs = [
                    {
                        name: me.isDashboardUserAdmin() ? gettext('Assessments') : gettext('Assessment'),
                        url: me.isDashboardUserAdmin() ? 'base.assessments-list' : 'base.assessments-list'
                    },
                    {
                        name: me.isDashboardUserAdmin() ? gettext('Summary') : gettext('Assessment'),
                        id: $scope.assessment.id
                    }
                ];

                $scope.assignment.scores = {
                    score_total_text:
                        $scope.assignment && $scope.assignment.assessment
                            ? parseFloat($scope.assignment.assessment.score).toFixed(1)
                            : ''
                };

                $scope.ax_invalidated = $scope.assessment.is_invalidated;

                // _.each($scope.assignment.assessment.section_responses.objects, section => {
                //     $scope.assignment.scores[section.section_title.replace(' ', '_')] = section.score
                //         ? parseFloat(section.score).toFixed(1)
                //         : 0;
                // });

                $scope.activeStep = setActiveStep($scope.assignment.status);
                if (
                    $scope.assignment.report_published ||
                    $scope.assignment.profile_published ||
                    $scope.assignment.summary_published
                ) {
                    $scope.activeStep = setActiveStep('published');
                }

                $scope.assessment.producing_organization.legal_status = $scope.dropdowns.legalStatusOptions.find(x => {
                    return x.url === $scope.assessment.producing_organization.legal_status;
                });

                $rootScope.$broadcast(EVENT_LOADER.hide);
                console.log('Report - ', $scope.assessment);
                console.log('Documents - ', $scope.documents);
            })
            .catch(err => {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                toastr.error('Error fetching rapid summary -', err.detail);
            });

        $scope.togglePublish = togglePublish;
        $scope.reviseModal = reviseModal;
        $scope.adminMode = adminMode;
        $scope.invalidateAssessment = invalidateAssessment;
        // $scope.validateAssessment = validateAssessment;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function isUserAllowedOnState(toState = {}) {
            const state = toState.name || $state.current.name;

            const dashboardUserAllowedStates = [
                'base.assessments-rapid-final.summary',
                'base.assessments-rapid-final.production',
                'base.assessments-rapid-final.dashboard-documentation',
                'base.assessments-rapid-final.dashboard-attachments',
                'base.assessments-rapid-final.finance'
            ];

            if ($scope.isDashboardUserAdmin) {
                const isUserAllowedOnState = dashboardUserAllowedStates
                    .filter(stateName => state === stateName)
                    .reduce(() => true, false);

                if (!isUserAllowedOnState) {
                    //Chop the path to be the summmary url of the report page.
                    $location.path($location.path().slice(0, $location.path().lastIndexOf('/')));
                }
            }
        }

        function togglePublish(type) {
            var patch = {
                url: $scope.assignment.url
            };

            patch[type + '_published'] = $scope.assignment[type + '_published'];

            siScope.patch(patch).then(res => {
                _.extend($scope.assignment, res);
                if (res.report_published || res.profile_published || res.summary_published) {
                    $scope.activeStep = setActiveStep('published');
                } else {
                    $scope.activeStep = setActiveStep('final');
                }
            });
        }

        function reviseModal(assessment) {
            const reviseModal = {
                templateUrl: 'reports/modals/reviseModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    function($scope, $uibModalInstance) {
                        $scope.assignment_revision_reason = '';

                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.revise = () => $uibModalInstance.close($scope.assignment_revision_reason);
                    }
                ]
            };
            return $uibModal.open(reviseModal).result.then(report_revision_reason => {
                const obj = {
                    url: `${apiUrl}/assessments/assessments/${assessment.id}/`,
                    report_revision_reason,
                    rapid_finalized: false
                };
                $rootScope.$broadcast(EVENT_LOADER.show);
                siScope
                    .patch(obj)
                    .then(function() {
                        $state.go('base.assessments-assignment-detail.assessment', {
                            id: assessment.assessmentassignments.objects[0].id
                        });
                    })
                    .catch(() => $rootScope.$broadcast(EVENT_LOADER.hide));
            });
        }

        function adminMode(assessment) {
            let report = assessment.reports.objects[0];
            if ($scope.isEmployee) {
                var patch = {
                    url: report.url,
                    in_edit: true
                };

                siScope
                    .patch(patch)
                    .then(res => {
                        _.extend($scope.assignment, res);
                    })
                    .then(function() {
                        $state.go('base.assessments-assignment-detail.assessment', {
                            id: assessment.assessmentassignments.objects[0].id
                        });
                    })
                    .catch(() => {
                        toastr.error('Error entering admin mode');
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            }
        }

        // function openCustomPDFModal(report) {
        //     var customPDFModal = {
        //         templateUrl: 'reports/modals/customPDFModal.html',
        //         controller: [
        //             '$scope',
        //             '$uibModalInstance',
        //             'report',
        //             function($scope, $uibModalInstance, report) {
        //                 $scope.assignment = report;
        //                 $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        //                 $scope.generateReport = () => $uibModalInstance.close($scope.assignment);
        //             }
        //         ],
        //         resolve: {
        //             report: () => report
        //         }
        //     };
        //     return $uibModal.open(customPDFModal).result.then(updatedReport => {
        //         $rootScope.$broadcast(EVENT_LOADER.show);
        //         // render the PDF using the servers capabilities
        //         $http({
        //             url: apiUrl + '/reports/reports/' + updatedReport.id + '/render_modular_report/',
        //             method: 'GET',
        //             responseType: 'arraybuffer',
        //             params: {
        //                 report_sections: JSON.stringify(updatedReport.report_sections)
        //             }
        //         })
        //             .then(function(data) {
        //                 function capitalizeFirstLetter(string) {
        //                     return string.charAt(0).toUpperCase() + string.slice(1);
        //                 }
        //                 var blob = new Blob([data.data], { type: 'application/pdf' });
        //                 saveAs(
        //                     blob,
        //                     updatedReport.assessment.producing_organization.customer.name +
        //                         '.' +
        //                         updatedReport.assessment.start_date +
        //                         '.' +
        //                         capitalizeFirstLetter(updatedReport.assessment.tool.type.name) +
        //                         '_MODULAR_' +
        //                         capitalizeFirstLetter(updatedReport.status) +
        //                         '.pdf'
        //                 );
        //                 $rootScope.$broadcast(EVENT_LOADER.hide);
        //             })
        //             .catch(function(err) {
        //                 console.log('Error DL PDF - ', err);
        //                 $rootScope.$broadcast(EVENT_LOADER.hide);
        //             });
        //     });
        // }

        function invalidateAssessment(report) {
            var invalidateAssessmentModal = {
                templateUrl: 'reports/modals/invalidateAssessmentModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'report',
                    function($scope, $uibModalInstance, report) {
                        $scope.assignment = report;

                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                        $scope.invalidate = () => $uibModalInstance.close($scope.assignment);
                    }
                ],
                resolve: {
                    report: () => report
                }
            };
            return $uibModal.open(invalidateAssessmentModal).result.then(updatedReport => {
                var obj = {
                    url: apiUrl + '/assessments/assessments/' + report.assessment.id + '/',
                    invalidation_reason: updatedReport.assessment.invalidation_reason,
                    is_invalidated: true
                };
                siScope.patch(obj);
                $scope.ax_invalidated = true;
            });
        }

        // function validateAssessment(report) {
        //     $scope.assignment = report;
        //     var obj = {
        //         url: apiUrl + '/assessments/assessments/' + report.assessment.id + '/',
        //         invalidation_reason: ' ',
        //         is_invalidated: false
        //     };

        //     siScope
        //         .patch(obj)
        //         .then(function() {
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //             _.extend($scope.assignment.assessment, obj);
        //         })
        //         .catch(err => {
        //             console.log('Error Invalidating Assessment - ', err);
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         });
        //     $scope.ax_invalidated = false;
        // }

        function setActiveStep(status) {
            if (status === 'draft') {
                return status;
            }

            if (status === 'final') {
                return 'finalized';
            }

            if (status === 'published') {
                return 'published (optional)';
            }
        }

        /**
         * Function to get the proper response for a given question from the list of responses
         * @param question assessment question object
         * @param responses assessment response object
         * @returns response object for given question
         */
        $scope.responseForQuestion = function(question, responses) {
            for (var r in responses) {
                if (responses[r].question.id == question.id) {
                    return responses[r];
                }
            }
        };

        /**
         * Function to get the proper report template for the given tool
         * @param tool assessment tool object
         * @returns string location of the report template
         */
        $scope.getReportTemplate = function(tool) {
            return tool ? 'reports/tool/' + tool.type.name + 'Report.html' : '';
        };

        /**
         * Function to delete the given report
         * @param report object
         */
        $scope.deleteReport = function(report) {
            siScope.remove(report.url).then(function() {
                $state.transitionTo('base.reports');
            });
        };

        /**
         * Function to change the report state into final
         */
        $scope.finalizeReport = function(report) {
            var obj = {
                url: apiUrl + '/reports/reports/' + report.id + '/',
                status: 'final'
            };
            siScope.patch(obj).then(function() {
                report.status = 'final';
                if (report.report_published || report.profile_published || report.summary_published) {
                    $scope.activeStep = setActiveStep('published');
                }
                $scope.activeStep = setActiveStep('final');
                $window.location.reload();
            });
        };

        /**
         * Remove report from API
         * @param report remove the selected report from the list
         */
        $scope.removeReport = function(report) {
            var url = apiUrl + '/reports/reports/' + report.id + '/';
            siScope.remove(url).then(function() {
                $state.go('base.assessments-assignment-detail.assessment', {
                    id: report.assessment.assessmentassignments.objects[0].id
                });
            });
        };

        /**
         * Render report to pdf
         */
        $scope.toPDF = function(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            let report = assessment.reports.objects[0];
            // render the PDF using the servers capabilities
            $http({
                url: apiUrl + '/reports/reports/' + report.id + '/pdf/',
                method: 'GET',
                responseType: 'arraybuffer'
            })
                .then(function(data) {
                    function capitalizeFirstLetter(string) {
                        return string.charAt(0).toUpperCase() + string.slice(1);
                    }
                    var blob = new Blob([data.data], { type: 'application/pdf' });
                    saveAs(
                        blob,
                        report.customer_name +
                            '.' +
                            assessment.start_date +
                            '.' +
                            capitalizeFirstLetter(assessment.tool.type.name) +
                            '_Report_' +
                            capitalizeFirstLetter(report.status) +
                            '.pdf'
                    );
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(function(err) {
                    console.log('Error DL PDF - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        // $scope.toExecutiveSummaryPDF = function(report) {
        //     $rootScope.$broadcast(EVENT_LOADER.show);

        //     // render the PDF using the servers capabilities
        //     $http({
        //         url: apiUrl + '/reports/reports/' + report.id + '/summary_pdf/',
        //         method: 'GET',
        //         responseType: 'arraybuffer'
        //     })
        //         .then(function(data) {
        //             function capitalizeFirstLetter(string) {
        //                 return string.charAt(0).toUpperCase() + string.slice(1);
        //             }
        //             var blob = new Blob([data.data], { type: 'application/pdf' });
        //             saveAs(
        //                 blob,
        //                 report.assessment.producing_organization.customer.name +
        //                     '.' +
        //                     report.assessment.start_date +
        //                     '.' +
        //                     capitalizeFirstLetter(report.assessment.tool.type.name) +
        //                     '_Summary_' +
        //                     capitalizeFirstLetter(report.status) +
        //                     '.pdf'
        //             );
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         })
        //         .catch(function(err) {
        //             console.log('Error DL PDF - ', err);
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         });
        // };

        // $scope.toAmharicSummaryPDF = report => {
        //     $rootScope.$broadcast(EVENT_LOADER.show);

        //     // render the PDF using the servers capabilities
        //     $http({
        //         url: apiUrl + '/reports/reports/' + report.id + '/render_amharic_pdf/',
        //         method: 'GET',
        //         responseType: 'arraybuffer'
        //     })
        //         .then(function(data) {
        //             function capitalizeFirstLetter(string) {
        //                 return string.charAt(0).toUpperCase() + string.slice(1);
        //             }
        //             var blob = new Blob([data.data], { type: 'application/pdf' });
        //             saveAs(
        //                 blob,
        //                 report.assessment.producing_organization.customer.name +
        //                     '.' +
        //                     report.assessment.start_date +
        //                     '.' +
        //                     capitalizeFirstLetter(report.assessment.tool.type.name) +
        //                     '_Summary_Amharic_' +
        //                     capitalizeFirstLetter(report.status) +
        //                     '.pdf'
        //             );
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         })
        //         .catch(function(err) {
        //             console.log('Error DL PDF - ', err);
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         });
        // };

        // $scope.toProfilePDF = function(report) {
        //     $rootScope.$broadcast(EVENT_LOADER.show);

        //     // render the PDF using the servers capabilities
        //     $http({
        //         url: apiUrl + '/reports/reports/' + report.id + '/profile_pdf/',
        //         method: 'GET',
        //         responseType: 'arraybuffer'
        //     })
        //         .then(function(data) {
        //             function capitalizeFirstLetter(string) {
        //                 return string.charAt(0).toUpperCase() + string.slice(1);
        //             }

        //             var blob = new Blob([data.data], { type: 'application/pdf' });
        //             saveAs(
        //                 blob,
        //                 `${report.assessment.producing_organization.customer.name}.${
        //                     report.assessment.start_date
        //                 }.${capitalizeFirstLetter(report.assessment.tool.type.name)}_Profile_${capitalizeFirstLetter(
        //                     report.status
        //                 )}.pdf`
        //             );
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         })
        //         .catch(function(err) {
        //             console.log('Error DL profile PDF - ', err);
        //             $rootScope.$broadcast(EVENT_LOADER.hide);
        //         });
        // };

        /**
         * Function to check if a response is applicable for the current PO,
         * this depends on the customizations in the tool (available on
         * conditions in the response object) and the current settings of a
         * PO on:
         * - Activities
         * - Sector
         * - po type
         * - country
         * - products
         *
         * @param response    question response object with conditionals
         * @param assessment  assessment object with nested information
         * @returns boolean   true if all conditions are met, otherwise returns false
         */
        $scope.responseApplicable = function(response, assessment) {
            //Check if the conditions object is empty,
            //which means we have no customizations, thus simply return true
            //otherwise go further onto the nasty boolean below

            if (_.isEmpty(response.conditions)) {
                return true;
            }

            //Looks like conditions is not empty so lets check our values
            //The first check is always to be sure our condition arrays children have a populated array.
            //The second check looks if the conditions specified actually exist on the assessment

            if (
                !response.conditions.sectors.length &&
                _.intersection(response.conditions.sectors, assessment.producing_organization.sectors.objects).length
            )
                return true;
            else if (
                !response.conditions.po_types.length &&
                _.filter(response.conditions.po_types, function(type) {
                    return type.url === assessment.producing_organization.legal_status;
                }).length
            )
                return true;
            else if (
                !response.conditions.countries.length &&
                _.intersection(response.conditions.countries, [assessment.producing_organization.country]).length
            )
                return true;
            else if (
                !response.conditions.activities.length &&
                _.intersection(response.conditions.activities, assessment.producing_organization.activities.objects)
                    .length
            )
                return true;
            else if (
                !response.conditions.products.length &&
                _.intersection(response.conditions.products, _.pluck(assessment.products.objects, 'type')).length
            )
                return true;
            else return false;

            /*

            var shouldBeShown =
                //Check that our activity conditions are in the assessment
                (!response.conditions.activities.length ||
                    _.intersection(response.conditions.activities, assessment.producing_organization.activities.objects)
                        .length) &&
                //Check that our sectors conditions are in the assessment
                (!response.conditions.sectors.length ||
                    _.intersection(response.conditions.sectors, assessment.producing_organization.sectors.objects)
                        .length) &&
                //Check that our po_types conditions match the po customer type
                (!response.conditions.po_types.length ||
                    _.filter(response.conditions.po_types, function(type) {
                        return type.url === assessment.producing_organization.legal_status;
                    }).length) &&
                //Check that our countries conditions match the po country
                (!response.conditions.countries.length ||
                    _.intersection(response.conditions.countries, [assessment.producing_organization.country])
                        .length) &&
                //check that the product conditions are in the assessment products of type
                (!response.conditions.products.length ||
                    _.intersection(response.conditions.products, _.pluck(assessment.products.objects, 'type')).length);

            return !!shouldBeShown;
            */
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('assessmentListController', assessmentListController)
        .constant('ASSESSMENT_LIST_FILTERS', [
            { 'Page size': { page_size: null }, optionsKey: 'page_size' },
            { Status: { status: null }, optionsKey: 'statuses' },
            { Country: { countries: null }, optionsKey: 'countries' },
            { Project: { project_name: null }, optionsKey: 'project' },
            { 'Assessment Date Range': { min_date: null, max_date: null } },
            { Tools: { tool_type: null }, optionsKey: 'tool_types' },
            { Language: { language: null }, optionsKey: 'languages' },
            { Assessor: { assessor_name: null }, optionsKey: 'assessors' },
            {
                'Financial Specialist': { financial_specialist: null },
                optionsKey: 'financial_specialists'
            },
            {
                'Quality Reviewer': { quality_reviewer: null },
                optionsKey: 'quality_reviewers'
            },
            {
                'Financial Quality Reviewer': { financial_quality_reviewer: null },
                optionsKey: 'financial_quality_reviewers'
            }
        ]);

    assessmentListController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$log',
        '$location',
        '$uibModal',
        'siAssessments',
        'siFilters',
        'me',
        '$http',
        'saveAs',
        'fsFactory',
        'offline',
        'toastr',
        'siScope',
        '$localStorage',
        '$q',
        'gettext',
        'EVENT_LOADER',
        'ASSESSMENT_LIST_FILTERS'
    ];

    function assessmentListController(
        $scope,
        $rootScope,
        $state,
        $log,
        $location,
        $uibModal,
        siAssessments,
        siFilters,
        me,
        $http,
        saveAs,
        fsFactory,
        offline,
        toastr,
        siScope,
        $localStorage,
        $q,
        gettext,
        EVENT_LOADER,
        ASSESSMENT_LIST_FILTERS
    ) {
        const params = {
            fields: ['project', 'assessmentassignments', 'reports', 'assessmentassignments__assessor'],
            page_size: 25,
            search: '',
            page: $state.params.page || 1,
            ordering: '-date'
        };

        let status = {};
        gettext('Assessment Date Range');

        if ($rootScope.app === 'smartclient') {
            status = $state.current.name === 'base.assessments-list-final' ? { final: 1 } : { final: 0 };
        }
        _.extend(params, status);
        _.extend(params, $location.search());
        $scope.queryParamsSet = !_.isEmpty($location.search());

        getAssessments(params);

        $scope.filters = siFilters.createFilters(ASSESSMENT_LIST_FILTERS, $location.search());
        $scope.search = search;
        $scope.removeFilter = removeFilter;
        $scope.clickRow = clickRow;
        $scope.getAssignmentHref = getAssignmentHref;
        $scope.downloadPDF = downloadPDF;
        $scope.downloadProfile = downloadProfile;
        $scope.isAssessmentLocked = isAssessmentLocked;
        $scope.downloadReports = downloadReports;
        $scope.hasReports = hasReports;
        $scope.selectAllReportsForDownload = selectAllReportsForDownload;
        $scope.transferAssessments = transferAssessments;
        $scope.isEmployee = me.isEmployee();
        $scope.getNameToShow = getNameToShow;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getNameToShow(assesment) {
            if (!assesment.producing_organization_duplicate_name) return assesment.producing_organization_name;
            else return assesment.producing_organization_duplicate_name;
        }
        function transferAssessmentsModal() {
            const selected = _.uniq($scope.assignments, 'assessment.id').filter(
                assignment => assignment.reportSelected
            );
            const projects = _.uniq(selected, 'assessment.project.id').map(
                assignments => assignments.assessment.project
            );
            const allProjects = _.uniq($scope.assignments, 'assessment.project.id').map(
                assignments => assignments.assessment.project
            );

            return {
                templateUrl: 'assessments/modals/transferAssessments.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'selected',
                    'projects',
                    'allProjects',
                    function($scope, $uibModalInstance, selected, projects, allProjects) {
                        $scope.selected = selected;

                        $scope.projects = projects;
                        $scope.allProjects = allProjects;
                        $scope.cancel = () => $uibModalInstance.dismiss('close');
                        $scope.save = () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            const patches = $scope.selected
                                .filter(s => s.new_project)
                                .map(s => ({
                                    project: s.new_project,
                                    url: s.assessment.url
                                }))
                                .map(s => siScope.patch(s));

                            $q.all(patches).then(() => {
                                $uibModalInstance.close();
                                getAssessments(params);
                            });
                        };
                    }
                ],
                resolve: {
                    selected: () => selected,
                    projects: () => projects,
                    allProjects: () => allProjects
                }
            };
        }

        function transferAssessments() {
            $uibModal.open(transferAssessmentsModal());
        }

        function getAssessments(params) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siAssessments.getAssessmentsWithParams(params).then((assessments = { results: [] }) => {
                if (assessments.results.length === 0 && offline.isOffline) {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return toastr.error(
                        'You are working currently offline and information on this page has not been downloaded.'
                    );
                }

                $scope.assessments = assessments;
                $scope.assessments.filters.page_size = [
                    { label: '20', value: '20' },
                    { label: '50', value: '50' },
                    { label: '100', value: '100' }
                ];
                $scope.assignments = [];
                $scope.assessments.results = assessments.results.map(assessment => {
                    assessment.offline = false;

                    fsFactory.exists('assessments', assessment.url).then(doesExist => {
                        if (doesExist) {
                            $scope.$on('fsCleared', () => (assessment.offline = false));
                            return (assessment.offline = !assessment.locked);
                        }
                        // Also check the responses cache (covers assessments that were
                        // viewed but not yet edited — still available offline)
                        return fsFactory.exists('responses', assessment.url).then(inResponses => {
                            if (inResponses) {
                                $scope.$on('fsCleared', () => (assessment.offline = false));
                                assessment.offline = !assessment.locked;
                            }
                        });
                    });

                    return assessment;
                });

                if ($rootScope.app === 'smartclient') {
                    $scope.assignments = $scope.assessments.results
                        .map(assessment => {
                            return assessment.assessmentassignments.objects.map(object => {
                                object.assessment = assessment;
                                return object;
                            });
                        })
                        .reduce((memo, array) => memo.concat(array), []);
                } else {
                    $scope.assignments = $scope.assessments.results
                        .map(assessment => {
                            if (assessment.assignments.length) {
                                return assessment.assignments
                                    .sort((a, b) => {
                                        if (a.assigned_as < b.assigned_as) return -1;
                                        if (a.assigned_as > b.assigned_as) return 1;
                                        return 0;
                                    })
                                    .map((assignment, index) => {
                                        assignment.assessment = assessment;
                                        if (assessment.assignments.length > 1 && index === 1) {
                                            assignment.isLast = true;
                                        }
                                        return assignment;
                                    });
                            } else {
                                return {
                                    assessment,
                                    assigned_as: 'assessor',
                                    display_status: assessment.status
                                };
                            }
                        })
                        .reduce((memo, array) => memo.concat(array), []);
                }

                console.log('Assessments - ', $scope.assessments);
                console.log('Assignments - ', $scope.assignments);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function search(searchParams, displayFilter) {
            return siFilters.search(params, searchParams, displayFilter, getAssessments);
        }

        function removeFilter(removeFilter) {
            return siFilters.removeFilter(removeFilter);
        }

        function infoModal(assessment) {
            return {
                templateUrl: 'assessments/modals/assessmentDetailModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'assessment',
                    function($scope, $uibModalInstance, assessment) {
                        $scope.assessment = assessment;
                        $scope.cancel = () => $uibModalInstance.dismiss('close');
                    }
                ],
                resolve: {
                    assessment: function() {
                        return assessment;
                    }
                }
            };
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function downloadPDF(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            assessment.reports.forEach(report => {
                // render the PDF using the servers capabilities
                $http({
                    url: `${report}pdf/`,
                    method: 'GET',
                    responseType: 'arraybuffer'
                }).then(function(data) {
                    if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                        console.log('Error while downloading PDF - ', data);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                        return toastr.error('Error while downloading PDF - ', data.status);
                    }

                    var blob = new Blob([data.data], {
                        type: 'application/pdf'
                    });
                    saveAs(
                        blob,
                        `${assessment.producing_organization_name}.${assessment.date}.${capitalizeFirstLetter(
                            assessment.tool_name
                        )}_Report.${capitalizeFirstLetter(assessment.status)}.pdf`
                    );
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
                // .catch(function(err) {
                //     toastr.error('Error DL PDF - ', err.detail);
                //     $rootScope.$broadcast(EVENT_LOADER.hide);
                // });
            });
        }

        function downloadProfile(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            assessment.reports.forEach(report => {
                // render the PDF using the servers capabilities
                $http({
                    url: `${report}profile_pdf/`,
                    method: 'GET',
                    responseType: 'arraybuffer'
                }).then(function(data) {
                    if (data.status.toString().startsWith('4') || data.status.toString().startsWith('5')) {
                        console.log('Error while downloading PDF - ', data.status);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                        return toastr.error('Error while downloading PDF - ', data.status);
                    }

                    var blob = new Blob([data.data], {
                        type: 'application/pdf'
                    });
                    saveAs(
                        blob,
                        `${assessment.producing_organization_name}.${assessment.date}.${capitalizeFirstLetter(
                            assessment.tool_name
                        )}_Profile.${capitalizeFirstLetter(assessment.status)}.pdf`
                    );
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
                // .catch(function(err) {
                //     toastr.error('Error DL PDF - ', err.detail);
                //     $rootScope.$broadcast(EVENT_LOADER.hide);
                // });
            });
        }

        function isAssessmentLocked(assessment = {}) {
            if ($rootScope.isSmartClient) {
                if (assessment.locked_for_assessor) {
                    return true;
                } else if (
                    !assessment.locked_for_assessor &&
                    (assessment.status === 'has_draft' || assessment.status === 'has_final')
                ) {
                    return true;
                } else return false;
            }

            if ($rootScope.isDashboard) {
                if (assessment.locked_for_employee) {
                    return true;
                } else if (
                    !assessment.locked_for_employee &&
                    (assessment.status === 'has_draft' || assessment.status === 'has_final')
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        function handleReportRedirect(assessment) {
            // if (assessment.tool_type === 'SCOPE Rapid') {
            //     $state.go('base.assessments-rapid-final.summary', { id: assessment.id });
            // } else {
            const url = assessment.reports.objects[0].url;
            const id = /(\d+)(?!.*\d)/.exec(url)[1];
            // Statuses Draft & Final
            //SOme hacky code to fix assessments that might have been "hacked" unlocked.
            if (!assessment.locked_for_employee || !assessment.locked_for_assessor) {
                siScope.patch({
                    url: assessment.url,
                    locked_for_employee: true,
                    locked_for_assessor: true
                });
            }

            $state.go('base.reports-detail.summary', { id: id });
            // }
        }

        function getAssignmentHref(assignment) {
            // Only SI users (employee, employee lite, QC reviewer) may open the assignment page.
            // Non-SI dashboard users must land on the report page (Draft/Final only), so that
            // opening a row in a new tab / middle-click cannot bypass the routing in clickRow().
            if (me.isEmployee() || me.isEmployeeLite() || me.isQcOnly()) {
                return $state.href('base.assessments-assignment-detail.assessment', { id: assignment.id });
            }
            const reports =
                assignment.assessment && assignment.assessment.reports && assignment.assessment.reports.objects;
            if (reports && reports.length) {
                const reportId = /(\d+)(?!.*\d)/.exec(reports[0].url)[1];
                return $state.href('base.reports-detail.summary', { id: reportId });
            }
            // Non-SI user with no report yet — nothing they are allowed to open.
            return '';
        }

        function clickRow(assignment) {
            const { status, id } = assignment;
            if ($rootScope.app === 'smartclient') {
                if (status === 'has_final' || status === 'has_draft') {
                    return handleReportRedirect(assignment.assessment);
                }

                return $state.go('base.assessments-assignment-detail.assessment', {
                    id
                });
            }

            // if (assignment.assessment.tool_type.toLowerCase().includes('rapid')) {
            //     if (status === 'in_progress') {
            //         $state.go('base.assessments-assignment-detail.assessment', {
            //             id
            //         });
            //     } else if (status === 'has_final') {
            //         return handleReportRedirect(assignment.assessment);
            //     }
            /*} else */ if (
                (status === 'qc_quality_review' || status === 'qc_assessor' || status === 2) &&
                (assignment.assessment.project.can_edit_assessments || assignment.ax_can_view_assignment_read_only)
            ) {
                // Status QC
                $state.go('base.assessments-assignment-detail.assessment', {
                    id
                });
            } else if (
                !assignment.assessment.can_edit_assessments &&
                $rootScope.me.is_customer_admin &&
                status === 'qc_quality_review'
            ) {
                $state.go('base.assessments-assignment-detail.assessment', {
                    id
                });
            } else if (assignment.assessment.reports.objects.length > 0) {
                handleReportRedirect(assignment.assessment);
            } else {
                // Statuses Created & In progress
                $uibModal.open(infoModal(assignment.assessment));
            }
        }

        function downloadReports() {
            // Show a loader while the reports are being downloaded
            $rootScope.$broadcast(EVENT_LOADER.show);

            // Get unique assignments based on 'assessment.id' and filter those that have 'reportSelected' set to true
            const assignments = _.uniq($scope.assignments, 'assessment.id').filter(
                assignment => assignment.reportSelected
            );

            // Create an array of promises for downloading reports
            const promises = assignments.flatMap(assignment => {
                // Check if the tool name is 'SCOPE Rapid', if so, show a warning and skip downloading
                if (me.isEmployee() == false && assignment.assessment.tool_name === 'SCOPE Rapid') {
                    toastr.warning('Downloading Rapid Report is not possible.');
                    return []; // Return an empty array to skip this assignment
                }

                const reports = assignment.assessment.reports.objects;

                // Create download promises for the main reports
                const downloadPromises = reports.map(report => {
                    return $http({
                        url: `${report.url}pdf/`, // URL to download the PDF report
                        method: 'GET',
                        responseType: 'arraybuffer' // Ensure the response is treated as a binary data buffer
                    }).then(data => {
                        // Create a Blob from the downloaded data
                        const blob = new Blob([data.data], { type: 'application/pdf' });
                        // Save the Blob as a file with a formatted name
                        saveAs(
                            blob,
                            `${assignment.assessment.producing_organization_name}_${capitalizeFirstLetter(
                                report.tool_type
                            )}_Report_${capitalizeFirstLetter(report.status)}.pdf`
                        );
                    });
                });

                // Create download promises for the profile PDFs if the tool type is 'SCOPE Pro' or 'SCOPE Pro SME'
                const profileDownloadPromises = reports
                    .filter(report => report.tool_type === 'SCOPE Pro' || report.tool_type === 'SCOPE Pro SME')
                    .map(report => {
                        return $http({
                            url: `${report.url}profile_pdf/`, // URL to download the profile PDF
                            method: 'GET',
                            responseType: 'arraybuffer' // Ensure the response is treated as a binary data buffer
                        }).then(data => {
                            // Create a Blob from the downloaded data
                            const blob = new Blob([data.data], { type: 'application/pdf' });
                            // Save the Blob as a file with a formatted name
                            saveAs(
                                blob,
                                `${assignment.assessment.producing_organization_name}_${capitalizeFirstLetter(
                                    report.tool_type
                                )}_Profile_${capitalizeFirstLetter(report.status)}.pdf`
                            );
                        });
                    });

                // Combine the main report promises and profile download promises into a single array
                return [...downloadPromises, ...profileDownloadPromises];
            });

            // Wait for all download promises to complete, then hide the loader
            $q.all(promises).then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
        }

        function hasReports(assignment) {
            return (
                assignment &&
                assignment.assessment &&
                assignment.assessment.reports &&
                assignment.assessment.reports.objects.length
            );
        }

        function selectAllReportsForDownload(isSelected, assignments) {
            return (
                assignments
                    //.filter(assignment => hasReports(assignment))
                    .map(assignment => {
                        assignment.reportSelected = !isSelected;
                    })
            );
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.assessments').factory('siAssessmentDetail', siAssessmentDetail);

    siAssessmentDetail.$inject = [
        '$rootScope',
        'gettext',
        '$log',
        'assessmentService',
        '$state',
        'fsFactory',
        '$stateParams',
        'siAssessments',
        '$q',
        'toastr',
        'IDB'
    ];

    function siAssessmentDetail(
        $rootScope,
        gettext,
        $log,
        assessmentService,
        $state,
        fsFactory,
        $stateParams,
        siAssessments,
        $q,
        toastr,
        IDB
    ) {
        const service = this;

        service.getAssessmentLocksMessage = getAssessmentLocksMessage;
        service.canSubmitAssessment = canSubmitAssessment;
        service.getSubmissionBlockReason = getSubmissionBlockReason;
        service.getOfflineAssessment = getOfflineAssessment;
        service.getAssessment = getAssessment;
        service.confirmAssignment = confirmAssignment;
        service.isRapidFinalizeBlocked = isRapidFinalizeBlocked;
        service.rapidFinalizeOfflineMessage = rapidFinalizeOfflineMessage;

        return service;

        /**
         * Whether finalizing this assessment must be refused right now. AD-2111.
         *
         * Rapid only, and offline only. Finalizing a Rapid assessment needs
         * server-side validation and synchronisation; doing it offline leaves
         * the assessment finalized locally and unsynchronised on the server,
         * which is the inconsistency the ticket exists to prevent.
         *
         * The rule lives here rather than in the controller for one practical
         * reason: `assessmentAssignmentDetailController` takes 36 dependencies
         * and cannot be instantiated in a spec without mocking all of them, so a
         * rule written there is a rule no test reaches. This is the gate in
         * front of an irreversible status change.
         *
         * Defaults to **not blocked** when the tool type is unknown. A missing
         * `tool.type` means this is not a Rapid assessment as far as anything
         * else in the app is concerned, and blocking finalization for every tool
         * whose payload happened to be thin would be a worse failure than the
         * one being prevented.
         */
        function isRapidFinalizeBlocked(assessment, isOffline) {
            if (!isOffline) {
                return false;
            }
            const type = assessment && assessment.tool && assessment.tool.type;
            return Boolean(type && type.is_rapid);
        }

        /** The one wording, so the tooltip, the note and the toast agree. */
        function rapidFinalizeOfflineMessage() {
            return gettext('Connect to the internet to finalize this Rapid assessment.');
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        		Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getAssessmentLocksMessage(newLocks, oldLocks) {
            const lockBoth = newLocks.locked_for_employee && newLocks.locked_for_assessor,
                unlockBoth = !newLocks.locked_for_employee && !newLocks.locked_for_assessor,
                lockEmployee = newLocks.locked_for_employee && !oldLocks.locked_for_employee,
                unLockEmployee = !newLocks.locked_for_employee && oldLocks.locked_for_employee,
                lockAssessor = newLocks.locked_for_assessor && !oldLocks.locked_for_assessor,
                unLockAssessor = !newLocks.locked_for_assessor && oldLocks.locked_for_assessor;

            let message = '';

            if (lockBoth)
                message = gettext(
                    'You are about to lock this assessment. This will disable assessment editing for Assessors and Quality Control Employees. Are you sure you want to continue?'
                );
            if (unlockBoth)
                message = gettext(
                    'You are about to unlock this assessment. This will enable assessment editing for Assessors and Quality Control Employees. Are you sure you want to continue?'
                );
            if (lockEmployee)
                message = gettext(
                    'You are about to lock this assessment. This will disable assessment editing for Quality Control Employees, and enable editing for Assessors. Are you sure you want to continue?'
                );
            if (unLockEmployee)
                message = gettext(
                    'You are about to unlock this assessment. This will disable assessment editing for Assessors, and enable editing for Quality Control Employees. Are you sure you want to continue?'
                );
            if (lockAssessor && $rootScope.app === 'smartclient')
                message = gettext(
                    'Sending the assessment to Quality Control means you can no longer make updates to the assessment. Are you sure you want to continue?'
                );
            // if (unLockAssessor)
            //     message = gettext(
            //         'You are about to unlock this assessment. This will disable assessment editing for Quality Control Employees, and enable editing for Assessors. Are you sure you want to continue?'
            //     );

            if (!lockBoth && !unlockBoth && !lockEmployee && !unLockEmployee && !lockAssessor && !unLockAssessor) {
                return;
            }

            return message;
        }

        function canSubmitAssessment(completionCheck, assessment) {
            var isAssessmentComplete = Object.keys(completionCheck)
                .map(key => {
                    if (completionCheck[key].$invalid) {
                        console.log('Not Completed Section - ', key);
                        console.log('Form - ', completionCheck[key]);
                    }
                    return completionCheck[key].$valid;
                })
                .filter(isDone => !isDone)
                .reduce(() => false, true);
            let assessmentPercentagesOverflow = checkOrganizationPercentageOverflow(assessment);
            return (
                $rootScope.isTrainee ||
                (isAssessmentComplete && assessment.isQuestionnaireDone && !assessmentPercentagesOverflow) ||
                (!assessment.full_completion_check_required &&
                    assessment.isQuestionnaireDone &&
                    !assessmentPercentagesOverflow) ||
                (!assessment.full_completion_check_required && !assessment.completion_check_required)
            );
        }

        function getSubmissionBlockReason(completionCheck, assessment) {
            if (checkOrganizationPercentageOverflow(assessment)) {
                return 'percentage_overflow';
            }
            var hasIncompleteTabs = Object.keys(completionCheck).some(key => !completionCheck[key].$valid);
            if (hasIncompleteTabs) {
                return 'incomplete_tabs';
            }
            if (!assessment.isQuestionnaireDone) {
                return 'questionnaire_incomplete';
            }
            return 'unknown';
        }

        function getOfflineAssessment(assignment) {
            const assessmentUrl = _.isObject(assignment.assessment) ? assignment.assessment.url : assignment.assessment;

            return fsFactory
                .readFromFs('assessments', assessmentUrl)
                .then(function(assessment) {
                    // readFromFs resolves with false for missing keys (not a rejection),
                    // so we need to check explicitly and try the responses cache fallback
                    if (assessment) {
                        // The assessments bucket already has the latest state
                        // (updated by $watch in the controller on every change).
                        // No need to replay queued requests — doing so would corrupt
                        // structured fields like sectors.objects with flat URL arrays.
                        return assessment;
                    }
                    return fsFactory.readFromFs('responses', assessmentUrl).then(function(cachedResponse) {
                        if (cachedResponse && cachedResponse.data) {
                            // Responses cache has stale server data — mark it so we
                            // replay pending requests on top below.
                            cachedResponse.data._fromResponsesCache = true;
                            return cachedResponse.data;
                        }
                        return false;
                    });
                })
                .catch(function() {
                    // Last resort: try responses cache on any read error
                    return fsFactory.readFromFs('responses', assessmentUrl).then(function(cachedResponse) {
                        if (cachedResponse && cachedResponse.data) {
                            cachedResponse.data._fromResponsesCache = true;
                        }
                        return cachedResponse && cachedResponse.data ? cachedResponse.data : false;
                    });
                })
                .then(function(assessment) {
                    if (!assessment) {
                        return assessment;
                    }
                    // Only replay pending requests when using stale responses cache data.
                    // The assessments bucket already contains the up-to-date state.
                    if (!assessment._fromResponsesCache) {
                        return assessment;
                    }
                    delete assessment._fromResponsesCache;
                    // Apply any pending offline changes from the queue
                    return IDB.getCollection('requests')
                        .then(function(rawRows) {
                            // getCollection returns raw Dexie rows {key, value} where value
                            // is a JSON string — parse them into usable request objects
                            var pendingRequests = [];
                            if (rawRows && rawRows.length) {
                                rawRows.forEach(function(row) {
                                    try {
                                        var parsed = row.value ? angular.fromJson(row.value) : row;
                                        if (parsed && parsed.method) {
                                            pendingRequests.push(parsed);
                                        }
                                    } catch (e) {
                                        // skip malformed entries
                                    }
                                });
                            }

                            if (pendingRequests.length === 0) {
                                return assessment;
                            }

                            pendingRequests.forEach(function(req) {
                                applyPendingRequestToAssessment(assessment, req);
                            });

                            return assessment;
                        })
                        .catch(function() {
                            return assessment;
                        });
                })
                .catch(function() {
                    toastr.error('Error while fetching assessment');
                    $state.go('base.assessments-assignments');
                });
        }

        function applyPendingRequestToAssessment(assessment, request) {
            if (!assessment || !request || !request.data || !request.method) {
                return;
            }

            var targetUrl = request.data.url || request.url;
            var target = findObjectByUrl(assessment, targetUrl) || (assessment.url === targetUrl ? assessment : null);

            if (!target && !requestAffectsAssessment(assessment, request)) {
                return;
            }

            if (request.method === 'PATCH' || request.method === 'UPDATE') {
                angular.extend(target || assessment, sanitizeQueuedData(request.data));
                return;
            }

            if (request.method === 'POST') {
                mergePostedData(assessment, request);
            }
        }

        function sanitizeQueuedData(data) {
            var sanitized = angular.copy(data || {});
            delete sanitized.url;
            delete sanitized.id;
            return sanitized;
        }

        function requestAffectsAssessment(assessment, request) {
            if (!request || !request.url) {
                return false;
            }

            return (
                request.url.indexOf(assessment.url) !== -1 ||
                (assessment.id && request.url.indexOf('/' + assessment.id + '/') !== -1)
            );
        }

        function mergePostedData(assessment, request) {
            var data = sanitizeQueuedData(request.data);

            Object.keys(data).forEach(function(key) {
                var value = data[key];

                if (!value || !value.url) {
                    return;
                }

                var existingItem = findObjectByUrl(assessment, value.url);
                if (existingItem) {
                    angular.extend(existingItem, value);
                    return;
                }

                var listContainer = assessment[key];
                if (listContainer && listContainer.objects && Array.isArray(listContainer.objects)) {
                    listContainer.objects.push(value);
                }
            });
        }

        function findObjectByUrl(source, targetUrl) {
            if (!source || !targetUrl) {
                return null;
            }

            var visited = [];

            function walk(value) {
                if (!value || typeof value !== 'object') {
                    return null;
                }

                if (visited.indexOf(value) !== -1) {
                    return null;
                }
                visited.push(value);

                if (value.url === targetUrl) {
                    return value;
                }

                if (Array.isArray(value)) {
                    for (var i = 0; i < value.length; i++) {
                        var arrayMatch = walk(value[i]);
                        if (arrayMatch) {
                            return arrayMatch;
                        }
                    }
                    return null;
                }

                var keys = Object.keys(value);
                for (var j = 0; j < keys.length; j++) {
                    var childMatch = walk(value[keys[j]]);
                    if (childMatch) {
                        return childMatch;
                    }
                }

                return null;
            }

            return walk(source);
        }

        function checkOrganizationPercentageOverflow(assessment) {
            // do not let the user submit if any of the following fields are above 100
            // the fields mathematically shouldn't even be able to be above 100 since they are percentages
            // returns true if none are above 100
            let percentageOverflow =
                assessment.producing_organization_details.percent_of_active_members_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_active_sharecroppers_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_active_outgrowers_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_executives_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_full_time_employees_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_members_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_non_executives_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_outgrowers_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_part_time_employees_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_seasonal_employees_under_30 > 100 ||
                assessment.producing_organization_details.percent_of_sharecroppers_under_30 > 100;
            return percentageOverflow;
        }

        function getAssessment(assignment) {
            const id = assignment.assessment.id;
            return siAssessments.getAssessment(id);
        }

        function confirmAssignment(assignment) {
            //We check to see if the assignment has an assessment, if not this is indicative of the fact that
            //another assignment had the same assessment url but this current assignment hasnt been filled with
            //nummy data, doesnt matter as we just need the url for finding the assessment in the FS, this we
            //set in the list view when we navigated to this deatil view.

            if (!assignment) {
                assignment = assessmentService.getAssessmentByID($stateParams.id);
                if (!assignment) {
                    return $q.reject();
                }
                assignment.assessment = { url: assignment.assessment };
            }

            if (
                assignment.detail === 'Not found.' ||
                assignment.detail === 'No encontrado.' ||
                assignment.detail === 'Pas trouvé.'
            ) {
                return $q.reject();
            }
            assessmentService.push(assignment);

            return $q.when(assignment);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('assessmentAssignmentDetailController', assessmentAssignmentDetailController);

    assessmentAssignmentDetailController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModal',
        '$log',
        '$q',
        'me',
        'apiUrl',
        'modalFactory',
        '$localStorage',
        'gettextCatalog',
        'gettext',
        '$stateParams',
        'fsFactory',
        'siScope',
        'siTooltype',
        'currencies',
        'siProducts',
        'siCustomers',
        'siAssessments',
        'assessmentService',
        'EVENT_LOADER',
        'COMPLETION_CHECK',
        'PARSENAME_REGEX',
        'offline',
        'siFormElement',
        'toastr',
        'siReports',
        'siCompletionCheck',
        'siQuestionnaire',
        'siAssessmentDetail',
        'replaceDeep',
        'APP',
        'moment',
        '$window',
        'amMoment'
    ];

    function assessmentAssignmentDetailController(
        $rootScope,
        $scope,
        $state,
        $uibModal,
        $log,
        $q,
        me,
        apiUrl,
        modalFactory,
        $localStorage,
        gettextCatalog,
        gettext,
        $stateParams,
        fsFactory,
        siScope,
        siTooltype,
        currencies,
        siProducts,
        siCustomers,
        siAssessments,
        assessmentService,
        EVENT_LOADER,
        COMPLETION_CHECK,
        PARSENAME_REGEX,
        offline,
        siFormElement,
        toastr,
        siReports,
        siCompletionCheck,
        siQuestionnaire,
        siAssessmentDetail,
        replaceDeep,
        APP,
        moment,
        $window,
        amMoment
    ) {
        let killAssessmentChecker = angular.noop;

        // set all accordion-groups to open
        $scope.user = { comments: '' };
        $scope.open = true;
        $scope.isLoaded = false;
        $scope.showTabWarnings = false;
        $scope.completionCheck = {};
        $scope.regions = [];
        $scope.global_currency = '-';
        $scope.genders = [
            { display_name: gettextCatalog.getString('male'), value: 'male' },
            {
                display_name: gettextCatalog.getString('female'),
                value: 'female'
            }
        ];
        $scope.purposesDisabled = false;
        $scope.currencies = currencies;
        $scope.isDashboardUserAdmin = me.isDashboardUserAdmin();
        $scope.isQcOnly = me.isQcOnly();
        $scope.isEmployee = me.isEmployee();
        $scope.qcLogs = [];
        // AD-2111. One definition of "offline now", read by both the flag the
        // template binds to and the guard in `confirmSendFeedbackToQualityControllers`.
        // Two readings would let the button enable itself while the guard still
        // refused, which looks like a broken button rather than a refusal.
        function isOfflineNow() {
            return Boolean(offline.isOffline || !navigator.onLine);
        }
        $scope.isOfflineNow = isOfflineNow;
        $scope.isOffline = isOfflineNow();
        // The template asks the same question the guard does, through the same
        // function, so a disabled button and a refused click cannot disagree.
        $scope.isRapidFinalizeBlocked = () =>
            siAssessmentDetail.isRapidFinalizeBlocked($scope.assessment, isOfflineNow());
        $scope.rapidFinalizeOfflineMessage = siAssessmentDetail.rapidFinalizeOfflineMessage;

        $rootScope.$broadcast(EVENT_LOADER.show);
        $scope.financialTabs = {
            reopenText: gettext('Re-open'),
            acceptedText: gettext('Completed')
        };

        console.time('Loading assessment page took');
        $q.all([
            siCustomers.getSectors(),
            siAssessments.getPurposes(),
            siAssessments.getAssignment($state.params.id),
            siProducts.getDropDowns(),
            siProducts.getProductTypeOptions(),
            siCustomers.getActivities({ ordering: 'name', page_size: 999 })
        ])
            .then(promises => {
                [
                    $scope.sectors,
                    $scope.purposes,
                    $scope.assignment,
                    $scope.dropdowns,
                    $scope.productTypes,
                    $scope.activities
                ] = promises;

                console.log('Activities - ', $scope.activities);
                console.log('Dropdowns - ', $scope.dropdowns);

                return $scope.assignment;
            })
            .then(siAssessmentDetail.confirmAssignment)
            .then(getAssessmentFromAssignment)
            .then(getQcLogs)
            .then(renderAssessment)
            .then(getToolOptions)
            .then(watchAssessmentForChanges)
            .then(finalizeLoadingOfPage)
            .catch(function() {
                $state.go('base.assessments-assignments');
                toastr.error('Error while setting up assessment');
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        //Method assignments on the scope
        $scope.updateRatiosAndGoToTab = updateRatiosAndGoToTab;
        $scope.updateCurrency = updateCurrency;
        $scope.isNumber = isNumber;
        $scope.generateNewDraftReport = generateNewDraftReport;
        $scope.generateDraftReport = generateDraftReport;
        $scope.canGenerateDraftReport = canGenerateDraftReport;
        $scope.draftReportBlockedReason = draftReportBlockedReason;
        $scope.toggleChecklist = toggleChecklist;
        $scope.parseName = parseName;
        $scope.responseApplicable = (response, assessment) => siQuestionnaire.responseApplicable(response, assessment);
        $scope.shouldShowTab = shouldShowTab;
        $scope.shouldShowSection = shouldShowSection;
        $scope.updateAssessment = updateAssessment;
        $scope.updateFormElement = updateFormElement;
        $scope.updateTextareas = updateTextareas;
        $scope.toggleTabWarnings = toggleTabWarnings;
        $scope.confirmSendFeedbackToQualityControllers = confirmSendFeedbackToQualityControllers;
        $scope.confirmSendFeedbackToAssessors = confirmSendFeedbackToAssessors;
        $scope.saveResponseComment = saveResponseComment;
        $scope.saveQCfeedback = saveQCfeedback;
        $scope.updateAssessmentLocks = updateAssessmentLocks;
        $scope.patchAssessment = patchAssessment;
        $scope.isAssessmentLocked = isAssessmentLocked;
        $scope.isDashboardUserAdmin = me.isDashboardUserAdmin();
        $scope.toggleNoData = ({ url, no_data }) => siScope.patch({ url, no_data });
        $scope.patchFinancialTab = patchFinancialTab;
        $scope.getRegions = getRegions;
        $scope.isCommentBoxDisabled = isCommentBoxDisabled;
        $scope.changeUser = changeUser;
        $scope.canUserSwitchAssignments = canUserSwitchAssignments;
        $scope.isViewOnly = isViewOnly;
        $scope.isAssessmentInGodMode = isAssessmentInGodMode;
        $scope.updateExistingReport = updateExistingReport;
        $scope.ratingModal = ratingModal;
        $scope.isUserAllowed = isUserAllowed;
        $scope.finalizeRapid = finalizeRapid;
        $scope.exitRapid = exitRapid;
        $scope.aiSpellcheckComment = aiSpellcheckComment;
        $scope.aiSpellcheckFeedback = aiSpellcheckFeedback;
        $scope.hideQCLogTab = hideQCLogTab();
        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Watchers
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $rootScope.$on(
            COMPLETION_CHECK.update,
            ($event, update) =>
                ($scope.completionCheck = siCompletionCheck.update($scope.completionCheck, update, $scope.assignment))
        );
        $scope.$on('$destroy', () => killAssessmentChecker());
        $rootScope.$on(APP.online, () => ($scope.isOffline = false));
        $rootScope.$on(APP.offline, () => ($scope.isOffline = true));

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function exitRapid() {
            $state.go('home', {}, { reload: true });
        }

        function hideQCLogTab() {
            var allowedFrontends = JSON.parse($scope.me.allowed_frontends);
            var onlyAssessor = false;
            if (allowedFrontends.length === 1) {
                if (allowedFrontends[0].app === 'smartclient' && $scope.me.is_assessor) {
                    onlyAssessor = true;
                }
            }
            console.log(
                !$localStorage.user.impersonated,
                onlyAssessor,
                !$localStorage.user.impersonated && onlyAssessor,
                'aaaaaaaaaaaaaaaaa'
            );
            return !$localStorage.user.impersonated && onlyAssessor;
        }

        function finalizeRapid(assessment) {
            const message =
                'Are you sure you want to finalize Rapid assesment? After finalization no more changes will be avaivable!';

            modalFactory.ConfirmModal({
                message: gettext(message),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            siAssessments.finalizeRapid({ id: assessment.id }).then(res => {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                            });
                        }
                    }
                ]
            });
        }

        function isUserAllowed() {
            return siAssessments.isUserAllowedGenerateFinalize();
        }
        function canUserSwitchAssignments() {
            if (!$scope.isLoaded) return;
            if ($scope.assessment.tool.type.pro || $scope.assessment.tool.type.pro_sme) {
                if (
                    ($rootScope.me.employee || $scope.assessment.project.can_edit_assessments) &&
                    $rootScope.app !== 'smartclient'
                )
                    return true;
                return $scope.assessment.assessmentassignments.objects.length === 2;
            }
        }

        function getQcLogs(assessment) {
            siAssessments
                .getQcLogInfo({ assessment_id: assessment.id, page: $state.params.page || 1, fields: ['actor'] })
                .then(qcLogs => ($scope.qcLogs = qcLogs));
            return assessment;
        }

        function getAssessmentFromAssignment(assignment) {
            var assessmentUrl = _.isObject(assignment.assessment) ? assignment.assessment.url : assignment.assessment;

            // When offline, use locally cached data (with pending request replay)
            if (offline.isOffline || !navigator.onLine) {
                return siAssessmentDetail.getOfflineAssessment(assignment);
            }

            // When online, check if there are pending offline requests that haven't synced yet.
            // If so, use the local copy to avoid losing unsynced edits.
            // Otherwise always fetch fresh data from the server so edits by other
            // parties (QC reviewer / assessor) are visible immediately.
            if (offline.numberPendingRequests > 0) {
                return fsFactory.readFromFs('assessments', assessmentUrl).then(function(localAssessment) {
                    if (localAssessment) {
                        return siAssessmentDetail.getOfflineAssessment(assignment);
                    }
                    return siScope.getItem(assessmentUrl).catch(function() {
                        return siAssessmentDetail.getOfflineAssessment(assignment);
                    });
                });
            }

            // No pending requests — always fetch fresh from server and clear stale local copy
            fsFactory.unlinkFromFs('assessments', assessmentUrl);
            fsFactory.unlinkFromFs('responses', assessmentUrl);
            return siScope.getItem(assessmentUrl).catch(function() {
                return siAssessmentDetail.getOfflineAssessment(assignment);
            });
        }

        function isViewOnly(assignment) {
            if (!$scope.isLoaded) return;
            return !assignment.ax_can_edit && assignment.ax_can_view_assignment_read_only;
        }

        /**
         * AD-2041: a quality reviewer may only generate a draft report once every
         * required part of the assessment has been submitted to QC. The rule itself
         * lives on the server (Assessment.draft_report_blocked_reason) so that the
         * dashboard cannot drift from it: this only reads the two flags the
         * assessment serializer exposes.
         *
         * Both flags are missing from payloads that predate them, e.g. an assessment
         * restored from the offline cache. Those are treated as allowed — the server
         * rejects the POST if the rule does not hold, and hiding the button on a
         * payload that simply lacks the field would break Basic and Rapid too.
         */
        function canGenerateDraftReport(assessment) {
            return !assessment || assessment.can_generate_draft_report !== false;
        }

        function draftReportBlockedReason(assessment) {
            return (assessment && assessment.draft_report_blocked_reason) || null;
        }

        /**
         * Function to render the assessment, retrieve option lists etcetera
         */
        function renderAssessment(assessment) {
            if (!assessment || !assessment.project) {
                toastr.warning('User does not have rights to see the assessment. Assessment corrupted.');
                $state.go('base.assessments-list');
                return;
            }

            if (
                !$rootScope.me.is_customer_admin &&
                !$scope.assignment.ax_can_edit &&
                !$scope.assignment.ax_can_view_assignment_read_only
            ) {
                toastr.warning('User does not have rights to see the assessment.');
                $state.go('base.assessments-list');
            }
            if ((!assessment.in_edit && assessment.status === 'has_final') || assessment.status === 'has_draft') {
                if (assessment.reports.length > 0) {
                    // Statuses Draft & Final
                    const url = assessment.reports;
                    const id = /(\d+)(?!.*\d)/.exec(url)[1];
                    if (!assessment.locked_for_employee || !assessment.locked_for_assessor) {
                        return siScope.patch(
                            { url: assessment.url },
                            {
                                locked_for_employee: true,
                                locked_for_assessor: true
                            }
                        );
                    }
                    if ($rootScope.app === 'dashboard') {
                        $state.go('base.reports-detail.summary', { id });
                    }
                }
            }

            try {
                $scope.assessment = siQuestionnaire.initializeQuestionnaire(assessment);
            } catch (error) {
                toastr.error('Error while setting up assessment - ', error);
                $state.go('base.assessments-list');
                return;
            }

            if (offline.isOffline || !navigator.onLine) {
                let selected_language = 'es';

                if ($localStorage.user != null) {
                    if ($localStorage.user.info != null) {
                        selected_language = $localStorage.user.info.language;
                    }
                }

                if (selected_language == 'undefined') selected_language = 'en';

                amMoment.changeLocale(selected_language);
                gettextCatalog.setCurrentLanguage(selected_language);
                gettextCatalog.loadRemote('translations/' + selected_language + '.json');
            }

            $scope.assessment.start_date = $scope.assessment.start_date ? new Date($scope.assessment.start_date) : null;
            $scope.global_currency = $scope.assessment.currency;
            getRegions($scope.assessment.producing_organization.country);
            // debugger;
            $scope.completionCheck = siCompletionCheck.setupInitialCompletionCheck(
                $scope.assessment,
                $scope.assignment
            );
            $scope.otherActivities = { display_name: gettext('other'), name: 'other' };

            fsFactory
                .writeToFs('assessments', $scope.assessment.url, $scope.assessment)
                .catch(err => console.error('renderAssessment: failed to persist assessment to IDB', err));
            setQuestionnaireStatus();

            console.log('Assessment - ', $scope.assessment);
            console.log('Assignment - ', $scope.assignment);

            return $scope.assessment;
        }

        function getToolOptions(assessment) {
            var toolParams = {
                fields: [
                    'access_roads_options',
                    'aquacultureessentials_options',
                    'assessorrelation_options',
                    'assettype_options',
                    'banktype_options',
                    'buspartnerrelationtype_options',
                    'buspartnertype_options',
                    'capitalrequirementssharetype_options',
                    'capitalrequirementsstatus_options',
                    'repaymentmodality_options',
                    'prefinancepurpose_options',
                    'typeofprovider_options',
                    'cashkind_options',
                    'certification_options',
                    'certificationstatus_options',
                    'computeraccess_options',
                    'cropessentials_options',
                    'customerrelationtype_options',
                    'customertype_options',
                    'demonstration_plot_options',
                    'distance_to_hub_options',
                    'elevation_options',
                    'frequency_options',
                    'internet_options',
                    'irrigationtype_options',
                    'landunit_options',
                    'leadsource_options',
                    'livestockessentials_options',
                    'loanapplicationstatus_options',
                    'loanpurpose_options',
                    'mobilenetworkcoverage_options',
                    'monthlyactivity_options',
                    'most_used_country_region_options',
                    'ngorelationtype_options',
                    'ngotype_options',
                    'paymentmethod_options',
                    'personaltransportation_options',
                    'power_options',
                    'product_options',
                    'productionunit_options',
                    'producttype_options',
                    'publictransportation_options',
                    'repaymentstatus_options',
                    'runningwater_options',
                    'salestrend_options',
                    'service_options',
                    'shareholderrelationtype_options',
                    'slope_options',
                    'supplierrelationtype_options',
                    'suppliertype_options',
                    'training_space_options',
                    'unit_options',
                    'warehousing_options',
                    'financetab_noinfo_options',

                    'agrochemical_options',
                    'serviceprovider_options',
                    'client_options',
                    'priority_options',

                    'landunderproduction_options'
                ]
            };

            return siProducts.getNestedToolOptions(assessment.tool.id, toolParams).then(dropdown => {
                $scope.dropdown = dropdown;
                $scope.noInfoReasonDropdown =
                    dropdown && dropdown.financetab_noinfo_options && dropdown.financetab_noinfo_options.objects;
                console.log('Dropdown Values - ', $scope.dropdown);
                return assessment;
            });
        }

        function watchAssessmentForChanges() {
            /**
             * watch the assessment on the scope and write changes to local copy when needed
             * @all to prevent this from being fired on every key stroke, click, or blur ng-model-options="{debounce: {'default': 500}}"
             * has been placed on the root of the app on the html tag - ng-app="scopeFrontend.webapps.scopeDashboard"
             */
            killAssessmentChecker = $scope.$watch(
                'assessment',
                (newAssessment, oldAssessment) => {
                    if (newAssessment !== oldAssessment) {
                        setQuestionnaireStatus();
                        fsFactory.writeToFs('assessments', newAssessment.url, newAssessment);
                    }
                },
                true
            );
        }

        function finalizeLoadingOfPage() {
            $scope.isLoaded = true;
            $rootScope.$broadcast(EVENT_LOADER.hide);
            // console.log(
            //     $scope.assessment.section_responses.objects[0].children.objects[0].responses.objects[0].subresponses
            //         .objects
            // );
            console.timeEnd('Loading assessment page took');
        }

        function getRegions(country) {
            $scope.regions = $scope.dropdowns.countryOptions
                .filter(c => c.name === country)
                .map(c =>
                    c.subdivisions.map(sd => {
                        sd.display_name = sd.label;
                        return sd;
                    })
                )
                .reduce((memo, regions) => memo.concat(regions), []);
        }

        function shouldShowTab(tabName) {
            return $scope.isLoaded
                ? siTooltype.isTabShown(tabName, $scope.assessment.with_terms_and_conditions)
                : false;
        }

        function shouldShowSection(section) {
            return $scope.isLoaded ? siTooltype.isSectionShown(section) : false;
        }

        function generateNewDraftReport(assessment) {
            modalFactory.ConfirmModal({
                message: gettext('This will delete the old report, are you sure?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => $scope.generateDraftReport(assessment)
                    }
                ]
            });
        }

        function setQuestionnaireStatus() {
            $scope.assessment = siQuestionnaire.getQuestionnaireStatus($scope.assessment, $scope.assignment);
            $scope.showQuestionnaireWarning = $scope.assessment.completion_check_required
                ? !$scope.assessment.isQuestionnaireDone
                : false;

            siTooltype.setTooltype($scope.assessment.tool.type);
        }

        function updateCurrency(currency) {
            if (!currency) {
                return;
            }

            return modalFactory.ConfirmModal({
                message:
                    $scope.assessment.tool.type === 'pro' || $scope.assessment.tool.type === 'pro_sme'
                        ? gettext(
                              'Updating Currency will affect - Balancesheet, Cashflow, Monthly Production and Profit & Loss tabs. '
                          )
                        : gettext('This will update the global currency.'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            const currencyUpdate = {
                                id: $scope.assessment.id,
                                url: $scope.assessment.url,
                                currency
                            };
                            siScope.patch(currencyUpdate);
                            replaceDeep.replace($scope.assessment, { currency: $scope.global_currency }, currency);
                            _.extend($scope.assessment, { currency });
                            $scope.global_currency = currency;
                        }
                    }
                ]
            });
        }

        function isAssessmentLocked(
            { locked_for_assessor, status, locked_for_employee } = {},
            { tool_name, rapid_finalized } = {}
        ) {
            if ($rootScope.isSmartClient) {
                if (locked_for_assessor) {
                    return true;
                } else if (!locked_for_assessor && (status === 'has_draft' || status === 'has_final')) {
                    return true;
                } else if (tool_name == 'SCOPE Rapid' && rapid_finalized) {
                    return true;
                } else return false;
            }

            if ($rootScope.isDashboard) {
                if (locked_for_employee) {
                    return true;
                } else if (!locked_for_employee && (status === 'has_draft' || status === 'has_final')) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        function isAssessmentInGodMode(assessment) {
            if (!$scope.isLoaded) return;
            if ($rootScope.isDashboard && $scope.isEmployee) {
                return assessment.in_edit || assessment.tool_name.toLowerCase().includes('rapid');
            } else {
                return false;
            }
        }

        /**
         * Rapid assessments follow a different workflow: the report is generated
         * automatically on submission and never goes through QC, so they are never
         * rated. `tool.type.is_rapid` is not present on every payload, hence the
         * fallback on the tool name.
         */
        function isRapidAssessment(assessment) {
            if (!assessment) {
                return false;
            }
            if (assessment.tool && assessment.tool.type && assessment.tool.type.is_rapid) {
                return true;
            }
            return (assessment.tool_name || '').toLowerCase().includes('rapid');
        }

        function ratingModal(assessment) {
            const ratingModal = {
                templateUrl: 'assessments/modals/ratingModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    function($scope, $uibModalInstance) {
                        // Work on a copy so a cancelled modal leaves no half-filled
                        // criteria behind on the next open.
                        $scope.evaluation = angular.copy(assessment.evaluation);
                        $scope.ratingForm = {};

                        // Kept in sync with AssessmentEvaluation.MAIN_ISSUE_CHOICES
                        // in the backend.
                        $scope.mainIssueOptions = [
                            { value: 'no_major_issue', label: 'No major issue' },
                            { value: 'inconsistency', label: 'Inconsistency' },
                            {
                                value: 'qc_feedback_not_incorporated',
                                label: 'QC feedback not incorporated'
                            },
                            {
                                value: 'suspicious_data_entry',
                                label: 'Suspicious data entry'
                            },
                            { value: 'delayed_response', label: 'Delayed response' },
                            {
                                value: 'incomplete_assessment',
                                label: 'Incomplete assessment'
                            },
                            {
                                value: 'insufficient_notes_or_evidence',
                                label: 'Insufficient notes or evidence'
                            },
                            { value: 'accuracy_issues', label: 'Accuracy issues' },
                            { value: 'other', label: 'Other' }
                        ];

                        // The two auto-calculated criteria arrive from the
                        // backend on the evaluation object; the reviewer fills
                        // in the three manual criteria below.
                        //
                        // Response timeliness is deliberately not required. It is
                        // the one criterion that can be unmeasurable - a QC round
                        // is recorded but our logs cannot date it - and requiring
                        // it left Save & Continue permanently disabled, so the
                        // reviewer could not finish the rating and therefore could
                        // not issue the report at all. The backend applies the
                        // same rule in compute_final_score.
                        $scope.isComplete = function() {
                            const e = $scope.evaluation;
                            return (
                                e.qc_rounds_score != null &&
                                e.incorporation_of_qc_feedback != null &&
                                e.notes_context_evidence_score != null &&
                                e.accuracy_completeness_score != null &&
                                !!e.main_issue_identified
                            );
                        };

                        // Whether the auto-calculated response time could be
                        // measured at all. Distinguishes "no QC round happened"
                        // from "a round happened but we cannot date it", which the
                        // modal previously showed with the same wording.
                        $scope.timelinessMeasured = function() {
                            return $scope.evaluation.response_timeliness_score != null;
                        };

                        $scope.hadQcRounds = function() {
                            return Number($scope.evaluation.qc_rounds) > 0;
                        };

                        // Averaged over the criteria that apply, so an
                        // unmeasurable response time is left out rather than
                        // scored as a 5 or a 1. Mirrors compute_final_score.
                        $scope.previewScore = function() {
                            const e = $scope.evaluation;
                            if (!$scope.isComplete()) return null;
                            const criteria = [
                                e.qc_rounds_score,
                                e.incorporation_of_qc_feedback,
                                e.notes_context_evidence_score,
                                e.accuracy_completeness_score
                            ];
                            if (e.response_timeliness_score != null) {
                                criteria.push(e.response_timeliness_score);
                            }
                            const sum = criteria.reduce((total, value) => total + Number(value), 0);
                            return (sum / criteria.length).toFixed(1);
                        };

                        $scope.cancel = function() {
                            return $uibModalInstance.dismiss('cancel');
                        };
                        $scope.submit = function() {
                            return $uibModalInstance.close($scope.evaluation);
                        };
                    }
                ]
            };
            return $uibModal.open(ratingModal).result.then(evaluation => {
                const obj = {
                    url: `${apiUrl}/assessments/assessment_evaluation/${assessment.evaluation.id}/`,
                    incorporation_of_qc_feedback: evaluation.incorporation_of_qc_feedback,
                    notes_context_evidence_score: evaluation.notes_context_evidence_score,
                    accuracy_completeness_score: evaluation.accuracy_completeness_score,
                    main_issue_identified: evaluation.main_issue_identified,
                    additional_comments:
                        evaluation.main_issue_identified === 'other' ? evaluation.additional_comments : ''
                };

                return siScope
                    .patch(obj)
                    .then(function(updated) {
                        // The backend returns the persisted auto scores and the
                        // computed final_score; keep the local copy in sync.
                        if (updated) {
                            _.extend(assessment.evaluation, updated);
                        }
                        return true;
                    })
                    .catch(err => {
                        toastr.error('Error Saving Rating - ', err && err.detail);
                        return false;
                    });
            });
        }

        /**
         * Ask for the Assessor Performance Rating before continuing with `next`.
         *
         * Rapid assessments skip the rating entirely. For every other assessment
         * the modal is shown on each attempt, and `next` only runs once the rating
         * has actually been saved — dismissing the modal or a failed save aborts
         * the whole flow.
         */
        function withRating(assessment, next) {
            if (isRapidAssessment(assessment)) {
                return $q.when(next());
            }

            if (!assessment.evaluation || !assessment.evaluation.id) {
                // No evaluation record to patch — don't block the user on a data issue.
                $log.warn('No evaluation found for assessment', assessment.id, '- skipping rating modal');
                return $q.when(next());
            }

            return ratingModal(assessment).then(
                saved => (saved ? next() : false),
                () => false // modal dismissed
            );
        }

        /**
         * Entry point for the "Generate Draft Report" button: always rate first
         * (except for rapid assessments), then generate.
         */
        function generateDraftReport(assessment) {
            // The button renders as .disabled, which does not stop a click on an
            // anchor — stop it here as well so no rating modal is opened for a
            // request the server is going to refuse (AD-2041).
            if (!canGenerateDraftReport(assessment)) {
                toastr.warning(draftReportBlockedReason(assessment));
                return $q.when(false);
            }
            return withRating(assessment, () => runGenerateDraftReport(assessment));
        }

        /**
         * Function to generate a draft report
         */
        function runGenerateDraftReport(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            var obj = {
                url: assessment.url,
                report_revision_reason: ' '
            };
            siScope
                .patch(obj)
                .then(function() {
                    _.extend($scope.assessment, obj);
                })
                .catch(err => {
                    toastr.error('Error Saving Assessment - ', err.detail);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });

            return siReports
                .generateDraftReport(assessment)
                .then(report => {
                    updateAssessmentLocks(
                        {
                            locked_for_employee: true,
                            locked_for_assessor: true
                        },
                        () => {
                            if (assessment.tool_name === 'SCOPE Rapid') {
                                $state.transitionTo('base.assessments-rapid-final.summary', {
                                    id: assessment.id
                                });
                            } else {
                                $state.transitionTo('base.reports-detail.summary', {
                                    id: report.id
                                });
                            }
                        }
                    ); // lock assessment for both once we generate report
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    // Show the server's reason (e.g. the AD-2041 refusal) when it
                    // sends one, so a stale page explains itself. $http rejects with
                    // the whole response, so the detail is at err.data.detail; the
                    // bare err.detail fallback covers siScope's own rejections.
                    const detail = (err && ((err.data && err.data.detail) || err.detail)) || null;
                    toastr.error(detail || 'Error while generating draft report');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        /**
         * Function to update existing report
         */
        function updateExistingReport(assessment) {
            return withRating(assessment, () => triggerUpdateExistingReport(assessment));
        }

        function triggerUpdateExistingReport(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const reports = assessment.reports && assessment.reports.objects;
            const report_url = reports && reports.length > 0 ? reports[0].url : undefined;
            if (report_url) {
                const report_id = /(\d+)(?!.*\d)/.exec(report_url)[1];
                return siReports
                    .patchReport(assessment, report_url)
                    .then(rep => {
                        $rootScope.$broadcast(EVENT_LOADER.show);
                        var patch = {
                            url: report_url,
                            in_edit: false
                        };
                        siScope
                            .patch(patch)
                            .then(function() {
                                if (assessment.tool_name === 'SCOPE Rapid') {
                                    $state.go('base.assessments-rapid-final.summary', { id: assessment.id });
                                } else {
                                    $state.go('base.reports-detail.summary', { id: report_id });
                                }
                            })
                            .then(function() {
                                $rootScope.$broadcast(EVENT_LOADER.hide);
                            });
                    })
                    .catch(() => {
                        toastr.error('Error while updating report');
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            } else {
                // The rating has already been handled by the caller.
                return runGenerateDraftReport(assessment);
            }
        }

        function updateRatiosAndGoToTab(id) {
            siAssessments.getFinancialRatiosForAssessment($scope.assessment.id).then(data => {
                if (data) {
                    $scope.assessment.financial_ratios.objects = data.results;
                }
                $state.go('base.assessments-assignment-detail.financial-performance', id);
            });
        }

        function isNumber(data) {
            const value = parseInt(data);
            if (_.isNaN(value)) {
                return gettext('Enter a number');
            }

            if (value < 0) {
                return gettext('Expected > 0');
            }
        }

        function toggleChecklist(newToggle, objects, name, url, disabled) {
            // Trick for slow response times, can set all checkboxes disabled if necessary
            // so not more than one patch can be in process
            $scope[disabled] = true;

            const patch = { url },
                isCurrentlySelected = objects.filter(item => item.url === newToggle.url).reduce(() => true, false);

            if (isCurrentlySelected) {
                const index = _.findIndex(objects, item => item.url === newToggle.url);
                objects.splice(index, 1);
            } else {
                //If we are adding activities (organization tab), add entire activity from preloaded list
                //so we can use display_name in Production & Sales tab to check if assessment contains
                //specific activies in order to hide No Info. Without this, only urls are added and check can't be done.
                if (name === 'activities' && $scope.activities && $scope.activities.results) {
                    const fullActivity = $scope.activities.results.find(act => act.url === newToggle.url);
                    objects.push(fullActivity || newToggle);
                } else {
                    objects.push(newToggle);
                }
            }

            patch[name] = objects.map(item => item.url);

            const promises = [siScope.patch(patch)];

            if (name === 'activities') {
                let containsActivity = false;
                let activities = [
                    'trading',
                    'storage',
                    'primary production',
                    'plantation management',
                    'collective production',
                    'exporting'
                ];

                for (let activity of activities) {
                    if (objects.find(act => act.display_name === activity || act.name === activity)) {
                        containsActivity = true;
                        break;
                    }
                }

                // If one of the activities has been selected, and no info was selected for production & sales,
                // make it false, and clear reason and tab completion.
                if (containsActivity && $scope.assessment.products_no_information_available) {
                    $scope.assessment.products_no_information_available = false;
                    $scope.assessment.production_tab_completed = false;
                    $scope.assessment.productionsales_no_product_no_info_reason = '';
                    $scope.assessment.production_tab_accepted = false;
                    const assessmentPatch = {
                        url: $scope.assessment.url,
                        products_no_information_available: false,
                        production_tab_completed: false,
                        productionsales_no_product_no_info_reason: '',
                        production_tab_accepted: false
                    };

                    promises.push(siScope.patch(assessmentPatch));
                }
            }

            Promise.all(promises).then(() => {
                $scope[disabled] = false;
            });
        }

        /**
         * Function to update a singular field for the assessment like observations
         * @param field string of fieldname that will be updated
         */
        function updateAssessment(field) {
            const updated = { url: $scope.assessment.url };
            updated[field] = $scope.assessment[field];

            siScope.patch(updated).then(res => {
                _.extend($scope.assessment, res);
            });
        }

        function updateFormElement(object, key, value, form, callback) {
            if (callback) {
                callback(value);
            }
            return siFormElement.update(object, key, value, form).then(res => {
                if (res && res.start_date) {
                    res.start_date = moment(res.start_date);
                }
                _.extend(object, res);
                return fsFactory
                    .writeToFs('assessments', $scope.assessment.url, $scope.assessment)
                    .then(function() {
                        return res;
                    })
                    .catch(function() {
                        return res;
                    });
            });
        }

        function updateTextareas(val, name, assessment) {
            const patch = { url: assessment.url };
            patch[name] = val;
            siScope.patch(patch).then(res => {
                _.extend($scope.assessment, res);
                return fsFactory
                    .writeToFs('assessments', $scope.assessment.url, $scope.assessment)
                    .catch(err => console.error('updateTextareas: failed to persist assessment to IDB', err));
            });
        }

        function parseName(name) {
            return name && name.replace(new RegExp(PARSENAME_REGEX, 'g'), '_');
        }

        function toggleTabWarnings() {
            $scope.showTabWarnings = true;
        }
        //52.08278267

        /**
         * Send the assessment to QC
         */
        function confirmSendFeedbackToQualityControllers() {
            if ($rootScope.currentRequests > 0) {
                return toastr.warning('Update requests in progress');
            }
            // AD-2111. `ng-disabled` already stops the click, so this is the
            // second lock rather than the first - and it is the one that holds
            // when the connection drops *between* the render and the tap, which
            // on a field device is the likely case rather than the exotic one.
            // Finalizing offline would leave the assessment finalized locally
            // and unsynchronised on the server, which is the inconsistency the
            // ticket exists to prevent.
            //
            // Rapid only. Every other tool's finalize path is unchanged.
            if (siAssessmentDetail.isRapidFinalizeBlocked($scope.assessment, isOfflineNow())) {
                $scope.isOffline = true;
                return toastr.warning(siAssessmentDetail.rapidFinalizeOfflineMessage());
            }
            let messageText = 'Sent';
            if ($scope.assessment.tool.type.is_rapid) {
                // $scope.completionCheck.observationsForm.$valid = true;
                messageText = 'The assessment has been successfully finalized.';
            } else {
                messageText = 'The assesment has been successfully sent to review.';
            }

            //console.log("Completion :");
            //console.log($scope.completionCheck);

            if ($scope.assessment.is_sacco) {
                if ($scope.completionCheck.productionForm != null) {
                    $scope.completionCheck.productionForm.$invalid = false;
                    $scope.completionCheck.productionForm.$valid = true;
                }
            }

            //console.log("Assesment : ");
            //console.log($scope.assessment);

            //Deal with the fact that the completion check it not required
            if (siAssessmentDetail.canSubmitAssessment($scope.completionCheck, $scope.assessment)) {
                if ($scope.assessment.tool.type.is_rapid) {
                    $rootScope.$broadcast(EVENT_LOADER.show);
                    // $window.location.reload();
                    siAssessments.finalizeRapid({ id: $scope.assessment.id }).then(res => {
                        console.log(res);
                        // Rapid reports are generated automatically on submission,
                        // without a QC round, so no rating is asked for here.
                        runGenerateDraftReport($scope.assessment);
                        // $rootScope.$broadcast(EVENT_LOADER.hide);
                        return;
                    });
                } else {
                    modalFactory.ConfirmModal({
                        message: gettext(messageText),
                        actions: [
                            {
                                label: gettext('OK'),
                                fn: angular.noop
                            }
                        ]
                    });
                    return updateAssessmentLocks({
                        locked_for_employee: false,
                        locked_for_assessor: true
                    });
                }
            } else {
                $scope.showTabWarnings = true;

                var blockReason = siAssessmentDetail.getSubmissionBlockReason(
                    $scope.completionCheck,
                    $scope.assessment
                );
                var errorMessage;
                if (blockReason === 'percentage_overflow') {
                    errorMessage =
                        'The assessment cannot be submitted. One or more percentage fields on the Organization tab exceed 100%. Please correct them before submitting.';
                } else {
                    errorMessage =
                        'The assessment is not yet complete. Please ensure all mandatory fields are completed - these are now marked in red.';
                }

                modalFactory.ConfirmModal({
                    message: gettext(errorMessage),
                    actions: [
                        {
                            label: gettext('OK'),
                            fn: angular.noop
                        }
                    ]
                });

                Object.keys($scope.completionCheck).forEach(key => {
                    if (isTabIncomplete($scope.completionCheck[key])) {
                        return ($scope.completionCheck[key] = {
                            $invalid: true
                        });
                    }
                    return $scope.completionCheck[key];
                });
            }

            function isTabIncomplete(tab) {
                return Object.getOwnPropertyNames(tab).length === 0;
            }
        }

        function confirmSendFeedbackToAssessors() {
            updateAssessmentLocks({
                locked_for_employee: true,
                locked_for_assessor: false
            });
        }

        function aiSpellcheckComment(comment, obj) {
            if (comment === '') {
                alert('The comment box is empty');
                return;
            }
            $rootScope.$broadcast(EVENT_LOADER.show);
            siAssessments
                .aiSpellcheck(comment)
                .then(res => {
                    var newComment = res.data;
                    siScope.patch({ url: obj.url, comment: newComment }).then(res => {
                        _.extend(obj, {
                            comment: res.comment
                        });
                    });
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function aiSpellcheckFeedback(object, key, value, form, callback) {
            if (value === '') {
                alert('The feedback box is empty');
                return;
            }
            $rootScope.$broadcast(EVENT_LOADER.show);
            siAssessments
                .aiSpellcheck(value)
                .then(res => {
                    var newValue = res.data;
                    updateFormElement(object, key, newValue, form, callback).then(() => {
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function saveResponseComment(active_response, contents) {
            if (!contents) {
                return;
            }

            const comment = {
                    user: $scope.me.url,
                    response: active_response.url,
                    contents
                },
                url = {
                    url: apiUrl + '/assessments/response_comments/'
                };

            siScope.post(url, comment).then(comment => {
                comment.user = $scope.me;
                $scope.user.comments = '';
                active_response.comments.objects.push(comment);
            });
        }

        function saveQCfeedback(assessment, contents) {
            if (!contents) {
                return;
            }

            const allTabComments = {
                    'base.assessments-assignment-detail.assessment': 'assessmenttabcomments',
                    'base.assessments-assignment-detail.organization': 'organisationaltabcomments',
                    'base.assessments-assignment-detail.valuechain': 'valuechaintabcomments',
                    'base.assessments-assignment-detail.finance': 'financetabcomments',
                    'base.assessments-assignment-detail.profit-loss': 'profitlosstabcomments',
                    'base.assessments-assignment-detail.balancesheet': 'balancesheettabcomments',
                    'base.assessments-assignment-detail.cashflow': 'cashflowtabcomments',
                    'base.assessments-assignment-detail.financial-performance': 'financialperformancetabcomments',
                    'base.assessments-assignment-detail.finance-overview': 'financialoverviewtabcomments',
                    'base.assessments-assignment-detail.finance-product': 'financetabcomments',
                    'base.assessments-assignment-detail.production': 'productiontabcomments',
                    'base.assessments-assignment-detail.production_monthly': 'monthlyproductiontabcomments',
                    'base.assessments-assignment-detail.governance': 'governancetabcomments',
                    'base.assessments-assignment-detail.observations': 'observationstabcomments',
                    'base.assessments-assignment-detail.finance-production': 'financialproductiontabcomments',
                    'base.assessments-assignment-detail.documentation': 'documentationtabcomments',
                    'base.assessments-assignment-detail.finance-history': 'financialhistorytabcomments',
                    'base.assessments-assignment-detail.terms': 'termsandconditionstabcomments'
                },
                thisTab = allTabComments[$state.current.name],
                url = {
                    url: apiUrl + '/assessments/' + thisTab + '/'
                },
                feedback = {
                    assessment: $scope.assignment.assessment,
                    contents,
                    user: $scope.me.url
                };

            siScope.post(url, feedback).then(response => {
                $scope.user.comments = '';
                _.extend(response, { user: $scope.me });
                assessment[thisTab].objects.push(response);
            });
        }

        /**
         * Function to set editing lock on assessment
         */
        function updateAssessmentLocks(newLocks, callback) {
            const { locked_for_employee, locked_for_assessor, url } = $scope.assignment;

            const oldLocks = {
                locked_for_employee,
                locked_for_assessor
            };

            const message = siAssessmentDetail.getAssessmentLocksMessage(newLocks, oldLocks);

            if ($scope.assessment.tool_name === 'SCOPE Rapid') {
                if (callback) {
                    callback();
                }
                return;
            }
            modalFactory.ConfirmModal({
                message: gettext(message),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);
                            siScope
                                .patch({ url }, newLocks)
                                .then(response => {
                                    _.extend($scope.assignment, newLocks);
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    if (callback) {
                                        callback();
                                    }
                                    if (response.counter_QR_to_assessor !== undefined) {
                                        $scope.assessment.counter_QR_to_assessor = response.counter_QR_to_assessor;
                                    }
                                })
                                .catch(() => {
                                    toastr.error('Error while locking assessment');
                                    $rootScope.$broadcast(EVENT_LOADER.hide);
                                    _.extend($scope.assignment, oldLocks);
                                });
                        }
                    }
                ]
            });
        }

        function patchAssessment(name, value) {
            const patch = { url: $scope.assessment.url };
            patch[name] = _.isObject(value) ? value.value : value;

            let result = name.includes('_tab_accepted');
            if (result) $rootScope.$broadcast('dissable-assessment');

            return siScope
                .patch(patch)
                .then(updatedAssessment => angular.extend($scope.assessment, updatedAssessment))
                .catch(err => toastr.error('Assessment Update Failed', err.data));
        }

        function patchFinancialTab(name, value, completedName) {
            const patch = { url: $scope.assessment.url };
            patch[name] = value;
            patch[completedName] = value;

            return siScope
                .patch(patch)
                .then(updatedAssessment => angular.extend($scope.assessment, updatedAssessment))
                .catch(err => toastr.error('Assessment Update Failed', err.data));
        }

        function isCommentBoxDisabled(state, assignedAs) {
            const fsUrls = ['profit-loss', 'balance-sheet', 'cashflow', 'financial-performance'];
            if (assignedAs === 'financial_specialist') {
                return fsUrls.indexOf(state.url.slice(1)) === -1;
            }

            if (assignedAs === 'assessor') {
                return fsUrls.indexOf(state.url.slice(1)) !== -1;
            }
        }

        function changeUser(user) {
            const id = $scope.assessment.assessmentassignments.objects
                .filter(assignment => assignment.assigned_as === user)
                .map(assignment => assignment.id)[0];

            $state.go('base.assessments-assignment-detail.assessment', {
                id
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.assessments')
        .controller('assessmentAITABuidlerController', assessmentAITABuidlerController);

    assessmentAITABuidlerController.$inject = [
        '$scope',
        'DataService',
        '$timeout',
        'modalFactory',
        'EVENT_LOADER',
        'siAssessments',
        '$rootScope',
        '$state',
        '$q',
        'toastr',
        'currencies',
        '$filter',
        'siReports'
    ];

    function assessmentAITABuidlerController(
        $scope,
        DataService,
        $timeout,
        modalFactory,
        EVENT_LOADER,
        siAssessments,
        $rootScope,
        $state,
        $q,
        toastr,
        currencies,
        $filter,
        siReports
    ) {
        $scope.selectAll = false;
        $scope.isLoading = false;
        $scope.jsonPreview = null;
        $scope.sortColumn = 'dimension';
        $scope.sortReverse = false;
        $scope.alerts = [];
        $scope.data = angular.copy(DataService.getData());
        $scope.loaded = false;
        $scope.reportId = $state.params.id;
        $scope.global_currency = '-';
        $scope.currencies = currencies;
        $scope.global_loader = false;
        $scope.builder_exists = false;
        $scope.filters = {
            internalManagement: false,
            financialManagement: false,
            sustainability: false,
            operations: false,
            productionBase: false,
            market: false,
            externalRisk: false,
            enablingEnvironment: false
        };
        $scope.merged = false;

        $scope.filterOptions = [
            { key: 'internalManagement', label: 'Internal Management' },
            { key: 'financialManagement', label: 'Financial Management' },
            { key: 'sustainability', label: 'Sustainability' },
            { key: 'operations', label: 'Operations' },
            { key: 'productionBase', label: 'Production Base' },
            { key: 'market', label: 'Market' },
            { key: 'externalRisk', label: 'External Risk' },
            { key: 'enablingEnvironment', label: 'Enabling Environment' }
        ];

        var sampleData = [
            {
                dimension: 'Market',
                subdimension: 'Marketing Strategy',
                problem: 'Lack of a comprehensive marketing strategy',
                activity: 'Conduct a marketing strategy workshop and develop a strategic marketing plan',
                expected_outcome: 'A documented and actionable marketing strategy',
                dimension_score: 4,
                subdimension_score: 4
            },
            {
                dimension: 'Market',
                subdimension: 'Market Related Risks',
                problem: 'Inadequate identification and mitigation of market-related risks',
                activity: 'Conduct a market risk assessment and create a risk management plan',
                expected_outcome: 'A detailed market risk management plan',
                dimension_score: 4,
                subdimension_score: 4
            },
            {
                dimension: 'Financial Management',
                subdimension: 'Financial Services',
                problem: 'Lack of access to adequate financial services',
                activity:
                    'Identify and establish partnerships with financial institutions to provide necessary services',
                expected_outcome: 'Partnership agreements with financial institutions',
                dimension_score: 4,
                subdimension_score: 4
            },
            {
                dimension: 'Financial Management',
                subdimension: 'Financial Planning',
                problem: 'Insufficient financial planning processes',
                activity: 'Conduct financial planning training and develop a financial planning framework',
                expected_outcome: 'A comprehensive financial planning framework',
                dimension_score: 4,
                subdimension_score: 4
            },
            {
                dimension: 'Financial Management',
                subdimension: 'Financial Administration',
                problem: 'Weak financial administration practices',
                activity: 'Implement financial administration best practices training and system improvements',
                expected_outcome: 'Enhanced financial administration procedures and systems',
                dimension_score: 4,
                subdimension_score: 4
            }
        ];

        // Store original data for filtering
        $rootScope.$broadcast(EVENT_LOADER.show);

        var tableDataPromise = siAssessments.checkIfBuilderExists(false);

        $q.all([tableDataPromise])
            .then(function(promises) {
                $scope.input = promises[0];
                $scope.builder_exists = $scope.input.exists;
                $rootScope.$broadcast(EVENT_LOADER.hide);
                $scope.global_loader = true;
            })
            .catch(function() {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                toastr.error('An Error has occurred while fetching the Report, please contact administration.');
            });

        $scope.generate = function() {
            var tableDataPromise = siAssessments.aiTaBuilder($scope.reportId);

            $rootScope.$broadcast(EVENT_LOADER.show);

            $q.all([tableDataPromise])
                .then(function(promises) {
                    $scope.input = promises[0];
                    $scope.tableData = processData($scope.input.data.data);
                    $scope.global_currency = $scope.input.data.currency;
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loaded = true;
                })
                .catch(function() {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('An Error has occurred while fetching the Report, please contact administration.');
                });

            /*       
            $scope.tableData = processData(sampleData);
            $rootScope.$broadcast(EVENT_LOADER.hide);
            $scope.loaded = true;
            */
        };

        $scope.addRow = function() {
            const newId = Date.now();
            if ($scope.merged) {
                $scope.mergedData.push({
                    dimension: '',
                    subdimension: '',
                    activity: '',
                    expected_outcome: '',
                    problem: '',
                    selected: false,
                    manuallyAdded: true,
                    shouldDisplay: true,
                    id: newId
                });
            } else {
                $scope.tableData.push({
                    dimension: '',
                    subdimension: '',
                    activity: '',
                    expected_outcome: '',
                    problem: '',
                    selected: false,
                    manuallyAdded: true,
                    shouldDisplay: true,
                    id: newId
                });
            }
        };

        $scope.removeSelected = function() {
            $scope.tableData = $scope.tableData.filter(item => !item.selected);
        };

        $scope.showAlert = (type, title, message, timeout) => {
            var alert = {
                type: type,
                title: title,
                message: message
            };

            $scope.alerts.push(alert);

            if (timeout) {
                $timeout(() => {
                    var index = $scope.alerts.indexOf(alert);
                    if (index !== -1) {
                        $scope.alerts.splice(index, 1);
                    }
                }, timeout);
            }
        };

        function processData(data) {
            console.log('Processing data:', data);

            if (!Array.isArray(data)) {
                console.error('Data is not an array:', data);
                $scope.showAlert('danger', 'Error:', 'Invalid data format. Expected an array.', 5000);
                return [];
            }

            return data.map((item, index) => ({
                id: index,
                dimension: item.dimension || '',
                dimension_score: item.dimension_score ? roundToDecimalPoints(Number(item.dimension_score), 1) : '',
                subdimension: item.subdimension || '',
                subdimension_score: item.dimension_score
                    ? roundToDecimalPoints(Number(item.subdimension_score), 1)
                    : '',
                problem: item.problem || '',
                activity: item.activity || '',
                expected_outcome: item.expected_outcome || '',
                selected: false,
                manuallyAdded: item.manuallyAdded || false,
                start_date: item.start_date || '',
                end_date: item.end_date || '',
                cost: item.cost || '',
                shouldDisplay: true
            }));
        }

        function processMergedData(data) {
            data.forEach(item => {
                item.selected = false;
                item.shouldDisplay = true;
            });
            return data;
        }

        function roundToDecimalPoints(number, numberOfDecimalPoints) {
            return number.toFixed(numberOfDecimalPoints);
        }

        $scope.updateCell = (id, field, event) => {
            const row = $scope.tableData.find(item => item.id === id);
            if (row) {
                row[field] = event.target.textContent;
            }
        };

        $scope.toggleSelectAll = () => {
            $scope.selectAll = !$scope.selectAll;
            if ($scope.merged) {
                angular.forEach($scope.mergedData, row => {
                    if (row.shouldDisplay) row.selected = $scope.selectAll;
                });
            } else {
                angular.forEach($scope.tableData, row => {
                    if (row.shouldDisplay) row.selected = $scope.selectAll;
                });
            }
        };

        $scope.getSelectedCount = () => {
            if ($scope.merged) return $scope.mergedData.filter(row => row.selected).length;
            else return $scope.tableData.filter(row => row.selected).length;
        };

        $scope.getTotalElements = () => {
            if ($scope.merged) return $scope.mergedData.length;
            else return $scope.tableData.length;
        };

        $scope.getSelectedRows = (isMerged = false) => {
            var dataSource;
            if (!isMerged) dataSource = $scope.tableData;
            else dataSource = $scope.mergedData;

            var selectedRows = dataSource.filter(row => row.selected);
            return selectedRows.length > 0 ? selectedRows : dataSource;
        };

        $scope.applyFilters = function() {
            // Get selected filter labels
            var selectedFilters = $scope.filterOptions
                .filter(filter => $scope.filters[filter.key])
                .map(filter => filter.label);

            if (selectedFilters.length === 0) {
                $scope.tableData.forEach(row => {
                    row.shouldDisplay = true;
                });
                $scope.mergedData.forEach(row => {
                    row.shouldDisplay = true;
                });
            } else {
                $scope.tableData.forEach(row => {
                    if (selectedFilters.includes(row.dimension)) row.shouldDisplay = true;
                    else row.shouldDisplay = false;
                });
                $scope.mergedData.forEach(row => {
                    if (selectedFilters.includes(row.dimension)) row.shouldDisplay = true;
                    else row.shouldDisplay = false;
                });
            }
        };

        $scope.toggleFilter = function(key, value) {
            console.log(key + ': ' + (value ? 'Checked' : 'Unchecked'));
            $scope.filters[key] = value;
            $scope.applyFilters();
        };

        $scope.exportToExcel = () => {
            if ($scope.tableData.length === 0) {
                $scope.showAlert('warning', 'Warning:', 'No data to export.', 5000);
                return;
            }

            var rows = $scope.getSelectedRows();

            var XLSX = window.XLSX;
            if (typeof XLSX === 'undefined') {
                console.error('XLSX library is not loaded.');
                $scope.showAlert(
                    'danger',
                    'Error:',
                    'XLSX library is not loaded. Please check your internet connection and try again.',
                    5000
                );
                return;
            }

            var wb = XLSX.utils.book_new();
            var wsInfo = XLSX.utils.aoa_to_sheet([
                ['Technical Assistance Builder'],
                ['Generated on: ' + $scope.formatToday()],
                ['', '']
            ]);

            const headers = [
                'Dimension',
                'Dimension score',
                'Subdimension',
                'Subdimension score',
                'Problem',
                'Activity',
                'Expected Outcome',
                'Start date',
                'End date',
                'Cost'
            ];

            const data = rows.map(row => ({
                Dimension: row.dimension,
                'Dimension score': row.dimension_score,
                Subdimension: row.subdimension,
                'Subdimension score': row.subdimension_score,
                Problem: row.problem,
                Activity: row.activity,
                'Expected Outcome': row.expected_outcome,
                'Start date': row.start_date ? $scope.formatDate(row.start_date) : '',
                'End date': row.end_date ? $scope.formatDate(row.end_date) : '',
                Cost: row.cost ? row.cost + ' ' + $scope.global_currency : ''
            }));

            const colWidths = headers.map((header, index) => {
                let maxWidth = header.length;
                data.forEach(row => {
                    const value = Object.values(row)[index] || '';
                    const valueLength = value.toString().length;
                    maxWidth = Math.max(maxWidth, valueLength);
                });
                return { wch: maxWidth };
            });

            var wsData = XLSX.utils.json_to_sheet(data);
            wsData['!cols'] = colWidths;
            XLSX.utils.book_append_sheet(wb, wsInfo, 'Info');
            XLSX.utils.book_append_sheet(wb, wsData, 'Project Data');
            var fileName = 'Project_Planning_' + new Date().toISOString().slice(0, 10) + '.xlsx';
            XLSX.writeFile(wb, fileName);
            $scope.showAlert('success', 'Success:', 'Excel file exported successfully.', 5000);
        };

        $scope.exportToHTML = () => {
            if ($scope.tableData.length === 0) {
                $scope.showAlert('warning', 'Warning:', 'No data to export.', 5000);
                return;
            }

            var rows = $scope.getSelectedRows();

            var html = `
            <!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Project Planning Data</title>
                <style>
                    body {
                        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                        color: #333;
                        line-height: 1.6;
                        padding: 20px;
                        width: 90%;
                        margin: 0 auto;
                    }
                    .header {
                        text-align: center;
                        margin-bottom: 30px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #eee;
                    }
                    h1 {
                        color: #4361ee;
                        margin: 0;
                        font-weight: 600;
                    }
                    .date {
                        color: #666;
                        font-size: 14px;
                        margin-top: 5px;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 20px 0;
                        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
                    }
                    th {
                        background-color: #4361ee;
                        color: white;
                        font-weight: 500;
                        text-align: left;
                        padding: 12px 15px;
                        max-width: 155px;
                        white-space: normal;
                        word-wrap: break-word;
                    }
                    td {
                        padding: 10px 15px;
                        border-bottom: 1px solid #eee;
                        max-width: 155px;
                        white-space: normal;
                        word-wrap: break-word;
                        vertical-align: top;
                    }
                    tr:nth-child(even) {
                        background-color: #f9f9f9;
                    }
                    tr:hover {
                        background-color: #f1f5ff;
                    }
                    .footer {
                        margin-top: 30px;
                        text-align: center;
                        font-size: 14px;
                        color: #666;
                        padding-top: 20px;
                        border-top: 1px solid #eee;
                    }
                    @media print {
                        body { padding: 0; }
                        table { box-shadow: none; }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <h1>Technical Assistance Builder</h1>
                    <p class="date">Generated on: ${$scope.formatToday()}</p>
                </div>
                
                <table>
                    <thead>
                        <tr>
                            <th>Dimension</th>
                            <th>Dimension score</th>
                            <th>Subdimension</th>
                            <th>Subdimension score</th>
                            <th>Problem</th>
                            <th>Activity</th>
                            <th>Expected Outcome</th>
                            <th>Start date</th>
                            <th>End date</th>
                            <th>Cost</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            rows.forEach(row => {
                html += '<tr>';
                html += '<td>' + (row.dimension || '') + '</td>';
                html += '<td>' + (row.dimension_score || '') + '</td>';
                html += '<td>' + (row.subdimension || '') + '</td>';
                html += '<td>' + (row.subdimension_score || '') + '</td>';
                html += '<td>' + (row.problem || '') + '</td>';
                html += '<td>' + (row.activity || '') + '</td>';
                html += '<td>' + (row.expected_outcome || '') + '</td>';
                html += '<td>' + (row.start_date ? $scope.formatDate(row.start_date) : '') + '</td>';
                html += '<td>' + (row.end_date ? $scope.formatDate(row.end_date) : '') + '</td>';
                html += '<td>' + (row.cost ? row.cost + ' ' + $scope.global_currency : '') + '</td>';
                html += '</tr>';
            });

            html += `
            </tbody>
            </table>
            <div class="footer">
                <p>© 2025 Technical Assistance Builder</p>
            </div>
            </body>
            </html>
            `;

            var blob = new Blob([html], { type: 'text/html' });
            var link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Project_Planning_' + new Date().toISOString().slice(0, 10) + '.html';
            link.click();
            $scope.showAlert('success', 'Success:', 'HTML file exported successfully.', 5000);
        };

        $scope.exportToPDF = () => {
            if ($scope.tableData.length === 0) {
                $scope.showAlert('warning', 'Warning:', 'No data to export.', 5000);
                return;
            }

            var rows = $scope.getSelectedRows();

            if (typeof window.jspdf === 'undefined') {
                console.error('jsPDF library is not loaded.');
                $scope.showAlert(
                    'danger',
                    'Error:',
                    'jsPDF library is not loaded. Please check your internet connection and try again.',
                    5000
                );
                return;
            }

            try {
                var { jsPDF } = window.jspdf;
                var doc = new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });

                doc.setFont('helvetica', 'bold');
                doc.setFontSize(18);
                doc.setTextColor(67, 97, 238);
                doc.text('Technical Assistance Builder', 40, 20);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10);
                doc.setTextColor(100, 100, 100);
                doc.text('Generated on: ' + $scope.formatToday(), 40, 25);

                var tableData = rows.map(row => [
                    row.dimension || '',
                    row.dimension_score || '',
                    row.subdimension || '',
                    row.subdimension_score || '',
                    row.problem || '',
                    row.activity || '',
                    row.expected_outcome || '',
                    row.start_date ? $scope.formatDate(row.start_date) : '',
                    row.end_date ? $scope.formatDate(row.end_date) : '',
                    row.cost ? row.cost + ' ' + $scope.global_currency : ''
                ]);

                doc.autoTable({
                    head: [
                        [
                            'Dimension',
                            'Dimension score',
                            'Subdimension',
                            'Subdimension score',
                            'Problem',
                            'Activity',
                            'Expected outcome',
                            'Start date',
                            'End date',
                            'Cost'
                        ]
                    ],
                    body: tableData,
                    startY: 35,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [67, 97, 238],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold',
                        halign: 'left'
                    },
                    styles: {
                        fontSize: 9,
                        cellPadding: 3,
                        lineColor: [220, 220, 220]
                    },
                    alternateRowStyles: {
                        fillColor: [248, 248, 248]
                    },
                    columnStyles: {
                        0: { cellWidth: 30 },
                        1: { cellWidth: 25, overflow: 'linebreak' },
                        2: { cellWidth: 30 },
                        3: { cellWidth: 30, overflow: 'linebreak' },
                        4: { cellWidth: 30 },
                        5: { cellWidth: 30 },
                        6: { cellWidth: 30 },
                        7: { cellWidth: 25 },
                        8: { cellWidth: 25 },
                        9: { cellWidth: 32 }
                    },
                    margin: { top: 35, right: 5, bottom: 15, left: 5 }
                });

                var pageCount = doc.internal.getNumberOfPages();
                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(8);
                    doc.setTextColor(150, 150, 150);
                }

                doc.save('Project_Planning_' + new Date().toISOString().slice(0, 10) + '.pdf');
                $scope.showAlert('success', 'Success:', 'PDF file exported successfully.', 5000);
            } catch (error) {
                console.error('Error generating PDF:', error);
                $scope.showAlert('danger', 'Error:', 'Failed to generate PDF: ' + error.message, 5000);
            }
        };

        $scope.roundToThreeDecimals = function(row, field) {
            if (row[field] != null) {
                row[field] = Number(row[field].toFixed(3));
            }
        };

        $scope.formatToday = () => {
            var date = new Date();
            return $scope.formatDate(date);
        };

        $scope.formatDate = function(date) {
            var date = new Date(date);
            var day = date
                .getDate()
                .toString()
                .padStart(2, '0');
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var year = date
                .getFullYear()
                .toString()
                .slice(-2);
            return day + '/' + month + '/' + year;
        };

        $scope.deleteRow = function(id) {
            let message = 'Are you sure you want to remove this record?';
            modalFactory.ConfirmModal({
                message: message,
                actions: [
                    {
                        label: 'Yes',
                        fn: () => {
                            $scope.$broadcast(EVENT_LOADER.show);
                            $scope.tableData = $scope.tableData.filter(item => item.id !== id);
                            toastr.success('Record has been successfully deleted!');
                        }
                    }
                ]
            });
        };

        $scope.changeSort = function(column) {
            if ($scope.sortColumn === column) {
                $scope.sortReverse = !$scope.sortReverse;
            } else {
                $scope.sortColumn = column;
                $scope.sortReverse = false;
            }
        };

        $scope.updateCurrency = function(currency) {
            $scope.global_currency = currency;
        };

        $scope.keydown = function(event) {
            var key = event.keyCode;
            var codes = [
                8,
                9,
                13,
                35,
                36,
                37,
                39,
                46,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                109,
                189
            ];

            if ((key === 189 || key === 109) && event.target.selectionStart > 0) {
                return event.preventDefault();
            }

            if (codes.indexOf(key) === -1) {
                return event.preventDefault();
            }
        };

        $scope.updateAmount = function(row) {
            const amount = (row.cost && row.cost.replace(new RegExp(',', 'g'), '')) || null;
            if (amount === '-') {
                row.cost = amount;
            } else {
                row.cost = $filter('number')(amount);
            }
        };

        $scope.uploadToAzure = function() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            var data = $scope.getSelectedRows($scope.merged);
            if (!$scope.merged) {
                siAssessments
                    .saveBuilderToAzure(data, $scope.global_currency, $scope.merged)
                    .then(res => {
                        console.log(res);
                        $scope.tableData = data;
                        $scope.tableData.forEach(obj => {
                            obj.selected = false;
                        });
                        const grouped = $scope.createMergedDictionary();
                        $scope.mergedData = Object.values(grouped);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    })
                    .catch(err => {
                        console.log('ERROR OCCURRED!', err);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            } else {
                siAssessments
                    .saveBuilderToAzure(data, $scope.global_currency, $scope.merged)
                    .then(res => {
                        console.log(res);
                        $scope.mergedData = data;
                        $scope.mergedData.forEach(obj => {
                            obj.selected = false;
                        });
                        $scope.tableData = $scope.createUnmergedList();
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    })
                    .catch(err => {
                        console.log('ERROR OCCURRED!', err);
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
            }
        };

        $scope.checkIfBuilderExists = function() {
            siAssessments
                .checkIfBuilderExists()
                .then(res => {
                    console.log(res);
                    return res;
                })
                .catch(err => {
                    console.log('ERROR OCCURRED!', err);
                });
        };

        $scope.loadFromAzure = function(original) {
            var dataPromise = siAssessments.loadBuildFromAzure(original);

            $rootScope.$broadcast(EVENT_LOADER.show);

            $q.all([dataPromise])
                .then(function(promises) {
                    $scope.input = promises[0];
                    $scope.global_currency = $scope.input.data.currency;
                    $scope.merged = $scope.input.data.isMerged ? $scope.input.data.isMerged : false;
                    if (original || !$scope.merged) $scope.tableData = processData($scope.input.data.data);
                    else {
                        $scope.mergedData = processMergedData($scope.input.data.data);

                        //Had to transform to unmerged list and revert back, otherways doesn't display it
                        $scope.tableData = $scope.createUnmergedList();
                    }
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    $scope.loaded = true;
                })
                .catch(function() {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error('An Error has occurred while fetching the Report, please contact administration.');
                });
        };

        $scope.getVisibleCount = function() {
            return $scope.tableData.filter(function(x) {
                return x.shouldDisplay;
            }).length;
        };

        $scope.unselectAll = function() {
            $scope.selectAll = false;
        };

        $scope.renderTable = function() {
            $scope.unselectAll();
            $scope.merged = !$scope.merged;

            if ($scope.merged) {
                if (!$scope.mergedData) {
                    const grouped = $scope.createMergedDictionary();
                    $scope.mergedData = Object.values(grouped);
                }
            } else {
                if (!$scope.tableData) {
                    $scope.tableData = $scope.createUnmergedList();
                    return $scope.tableData;
                }
            }
        };

        $scope.getRange = function(count) {
            if (!count || count <= 1) return [];
            return new Array(count - 1);
        };

        $scope.updateProblem = function(row, event) {
            row.problem = event.target.textContent;
        };

        $scope.updateActivity = function(row, event) {
            row.activity = event.target.textContent;
        };

        $scope.updateOutcome = function(row, event) {
            row.outcome = event.target.textContent;
        };

        $scope.range = function(n) {
            return new Array(n);
        };

        $scope.updateCellNewRowWhenMerged = function(row, field, event) {
            row[field] = event.target.textContent;
            const existing = $scope.mergedData.find(
                x => x.dimension == row.dimension && x.subdimension == row.subdimension && x.id != row.id
            );

            if (existing) {
                existing.problem = existing.problem + '\r\n' + '• ' + row.problem;
                existing.activity = existing.activity + '\r\n' + '• ' + row.activity;
                existing.outcome = existing.outcome + '\r\n' + '• ' + row.expected_outcome;
                existing.cost =
                    parseInt(existing.cost ? existing.cost.replaceAll(',', '') : 0) +
                    parseInt(row.cost ? row.cost.replaceAll(',', '') : 0);
                const index = $scope.mergedData.indexOf(row);
                if (index !== -1) {
                    $scope.mergedData.splice(index, 1);
                }

                if (row.start_date < existing.start_date) {
                    existing.start_date = row.start_date;
                }
                if (row.end_date > existing.end_date) {
                    existing.end_date = row.end_date;
                }

                existing.ids.push(row.id);
                existing.problems.push(row.problem);
                existing.activities.push(row.activity);
                existing.outcomes.push(row.expected_outcome);
                existing.costs.push(row.cost);
                existing.start_dates.push(row.start_date);
                existing.end_dates.push(row.end_date);
            }
        };

        $scope.updateProblemNewlyCreated = function(row, event) {
            row.problem = event.target.textContent;
        };

        $scope.updateActivityNewlyCreated = function(row, event) {
            row.activity = event.target.textContent;
        };

        $scope.updateOutcomeNewlyCreated = function(row, event) {
            row.expected_outcome = event.target.textContent;
        };

        $scope.createMergedDictionary = function() {
            const grouped = {};

            $scope.tableData.forEach(item => {
                const key = item.dimension + '||' + item.subdimension;
                if (!grouped[key]) {
                    grouped[key] = {
                        dimension: item.dimension,
                        dimension_score: item.dimension_score,
                        subdimension: item.subdimension,
                        subdimension_score: item.subdimension_score,
                        problems: [],
                        activities: [],
                        outcomes: [],
                        start_date: item.start_date,
                        end_date: item.end_date,
                        shouldDisplay: item.shouldDisplay,
                        manuallyAdded: false,
                        cost: 0,
                        costs: [],
                        ids: [],
                        start_dates: [],
                        end_dates: [],
                        problem: '',
                        activity: '',
                        outcome: ''
                    };
                }
                grouped[key].problems.push(item.problem ? item.problem : '');
                grouped[key].activities.push(item.activity ? item.activity : '');
                grouped[key].outcomes.push(item.expected_outcome ? item.expected_outcome : '');
                if (
                    item.start_date &&
                    (!grouped[key].start_date || item.start_date < grouped[key].start_date) &&
                    (!grouped[key].end_date || item.start_date < grouped[key].end_date)
                ) {
                    grouped[key].start_date = item.start_date;
                }

                if (item.end_date > grouped[key].end_date && item.end_date > grouped[key].start_date)
                    grouped[key].end_date = item.end_date;

                grouped[key].cost =
                    parseInt(grouped[key].cost) + parseInt(item.cost ? item.cost.replaceAll(',', '') : 0);

                grouped[key].costs.push(item.cost ? item.cost : '');
                grouped[key].ids.push(item.id);
                grouped[key].start_dates.push(item.start_date);
                grouped[key].end_dates.push(item.end_date);
                grouped[key].problem =
                    grouped[key].problem.length > 0
                        ? grouped[key].problem + '\r\n' + '• ' + item.problem
                        : '• ' + item.problem;
                grouped[key].activity =
                    grouped[key].activity.length > 0
                        ? grouped[key].activity + '\r\n' + '• ' + item.activity
                        : '• ' + item.activity;
                grouped[key].outcome =
                    grouped[key].outcome.length > 0
                        ? grouped[key].outcome + '\r\n' + '• ' + item.expected_outcome
                        : '• ' + item.expected_outcome;
            });

            return grouped;
        };

        $scope.createUnmergedList = function() {
            const unmergedItems = [];

            $scope.mergedData.forEach(group => {
                // Check if this is a merged group (has problems array)
                if (group.problems && Array.isArray(group.problems)) {
                    // For each problem in the group, create a separate row
                    group.problems.forEach((problem, index) => {
                        unmergedItems.push({
                            dimension: group.dimension,
                            dimension_score: group.dimension_score,
                            subdimension: group.subdimension,
                            subdimension_score: group.subdimension_score,
                            problem: group.problems[index] || '',
                            activity: group.activities[index] || '',
                            expected_outcome: group.outcomes[index] || '',
                            start_date: group.start_dates[index],
                            end_date: group.end_dates[index],
                            cost: group.costs[index],
                            shouldDisplay: group.shouldDisplay,
                            manuallyAdded: group.manuallyAdded,
                            // Generate a new ID or use index
                            id: group.ids[index]
                        });
                    });
                } else {
                    // If it's not a merged group, add as-is
                    unmergedItems.push(group);
                }
            });
            return unmergedItems;
        };

        $scope.addRowToMergedDictionary = function(grouped, row) {
            const key = row.dimension + '||' + row.subdimension;
            grouped[key].problems.push(row.problem ? '• ' + row.problem : '');
            grouped[key].activities.push(row.activity ? '• ' + row.activity : '');
            grouped[key].outcomes.push(row.expected_outcome ? '• ' + row.expected_outcome : '');
            if (row.start_date < grouped[key].start_date) grouped[key].start_date = row.start_date;
            if (row.end_date > grouped[key].end_date) grouped[key].end_date = row.end_date;
            grouped[key].cost = parseInt(grouped[key].cost) + parseInt(row.cost ? row.cost.replaceAll(',', '') : 0);
            grouped[key].costs.push(row.cost ? row.cost : '');
            // Preserve selection state
            grouped[key].selected = grouped[key].selected || row.selected;
            grouped[key].ids.push(row.id);
            grouped[key].start_dates.push(row.start_date);
            grouped[key].end_dates.push(row.end_date);
        };

        $scope.updateAmountForMergedRow = function(row) {
            const amount = (row.cost && row.cost.replace(new RegExp(',', 'g'), '')) || null;
            if (amount === '-') {
                row.cost = amount;
            } else {
                row.cost = $filter('number')(amount);
            }
        };

        $scope.updateAmountForMergedNewlyAddedRow = function(row) {
            const amount = (row.cost && row.cost.replace(new RegExp(',', 'g'), '')) || null;
            if (amount === '-') {
                row.cost = amount;
            } else {
                row.cost = $filter('number')(amount);
            }
        };

        $scope.deleteMegredRow = function(index) {
            let message = 'Are you sure you want to remove this record?';
            modalFactory.ConfirmModal({
                message: message,
                actions: [
                    {
                        label: 'Yes',
                        fn: () => {
                            $scope.$broadcast(EVENT_LOADER.show);
                            $scope.mergedData = $scope.mergedData.filter(item => item !== $scope.mergedData[index]);
                            toastr.success('Record has been successfully deleted!');
                        }
                    }
                ]
            });
        };

        $scope.shouldDisplayFilter = function(filter) {
            const data = $scope.isMerged ? $scope.mergedData : $scope.tableData;
            return data.some(item => item.dimension === filter);
        };

        $scope.downloadTAReport = function() {
            $scope.loading = true;
            const payload = {
                data: $scope.merged ? $scope.mergedData : $scope.tableData,
                currency: $scope.global_currency,
                isMerged: $scope.merged
            };
            siReports
                .generate_ta_build_report_pdf(payload)
                .then(function(response) {
                    $scope.loading = false;

                    // Create blob from response data
                    var blob = new Blob([response], { type: 'application/pdf' });

                    // Create download link
                    var url = window.URL.createObjectURL(blob);
                    var link = document.createElement('a');
                    link.href = url;
                    link.download = 'Technical Assistance Plan.pdf';

                    // Trigger download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Clean up
                    window.URL.revokeObjectURL(url);

                    console.log('PDF downloaded successfully');
                })
                .catch(function(error) {
                    $scope.loading = false;
                    console.error('Error:', error);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons.alerts', ['ui.bootstrap', 'ui.router', 'scope.commons', 'scope.constants', 'toastr'])
        .config(config)
        .run(run);

    run.$inject = ['siAlerts'];

    function run(siAlerts) {
        siAlerts.startAlertEvents();
    }

    config.$inject = ['$stateProvider', '$provide'];

    function config($stateProvider) {
        $stateProvider
            .state('base.alerts', {
                url: '/alerts/{page:[0-9]*}',
                views: {
                    'contentView@base': {
                        templateUrl: 'alerts/alertsListView.html',
                        controller: 'alertsListController'
                    }
                }
            })
            .state('base.alerts-news', {
                url: '/news/read/{type:.+}/{page:[0-9]*}',
                views: {
                    'contentView@base': {
                        templateUrl: 'alerts/newsListView.html',
                        controller: 'newsListController'
                    }
                }
            })
            .state('base.alerts-filter', {
                url: '/alerts/read/{type:.+}/{page:[0-9]*}',
                views: {
                    'contentView@base': {
                        templateUrl: 'alerts/alertsListView.html',
                        controller: 'alertsListController'
                    }
                }
            })
            .state('base.alert-detail', {
                url: '/alerts/detail/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'alerts/alertDetailView.html',
                        controller: 'alertDetailController'
                    }
                }
            })
            .state('base.news-detail', {
                url: '/news/detail/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'alerts/newsDetailView.html',
                        controller: 'newsDetailController'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.alerts').controller('newsListController', newsListController);

    newsListController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$log',
        '$q',
        'toastr',
        'offline',
        'apiUrl',
        'siScope',
        'gettext',
        'modalFactory',
        'siMessages',
        'siAlerts',
        'me',
        'EVENT_LOADER',
        'ALERTS',
        'APP'
    ];

    function newsListController(
        $rootScope,
        $scope,
        $state,
        $log,
        $q,
        toastr,
        offline,
        apiUrl,
        siScope,
        gettext,
        modalFactory,
        siMessages,
        siAlerts,
        me,
        EVENT_LOADER,
        ALERTS,
        APP
    ) {
        $scope.type = $state.params.type || '';

        $scope.messages = { allSelected: false };
        $scope.refresh = refresh;
        $scope.toggleAllSelected = toggleAllSelected;
        $scope.checkAllSelected = checkAllSelected;
        $scope.markAsRead = markAsRead;
        $scope.markAsUnread = markAsUnread;
        $scope.archiveSelected = archiveSelected;
        $scope.updateEmailNotifications = updateEmailNotifications;

        $scope.refresh();
        me.getMe().then(me => ($scope.user = me));
        const alertTypesPromise = siMessages.getMessageTypes();

        $q.all([alertTypesPromise]).then(promises => {
            $scope.alertTypes = [];
            promises[0].results.forEach(type => {
                let contains =
                    $scope.alertTypes.map(alertType => alertType.display_name).indexOf(type.display_name) !== -1;
                if (!contains) {
                    $scope.alertTypes.push(type);
                }
            });

            console.log('Alerts - ', promises);
            $rootScope.$broadcast(EVENT_LOADER.hide);
        });

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function updateEmailNotifications() {
            return siScope.patch({ url: $scope.user.url, email_notifications_on: $scope.user.email_notifications_on });
        }

        function refresh() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            return siScope
                .getList(`${apiUrl}/blogs/blogsets/?fields=blogs&fields=read_by&fields=archived_by`)
                .then(({ results }) => {
                    $scope.news = {
                        results: results
                            .filter(
                                item => item.archived_by.objects.map(user => user.url).indexOf($rootScope.me.url) === -1
                            )
                            .map(item => {
                                item.read_by_user =
                                    item.read_by.objects.map(user => user.url).indexOf($rootScope.me.url) !== -1;
                                return item;
                            })
                    };
                    console.log($scope.news);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .then(checkAllSelected);
        }

        function toggleAllSelected(allSelected) {
            [$scope.news, $scope.messagesSelected] = siAlerts.toggleAllSelected(
                allSelected,
                $scope.news,
                $scope.messagesSelected
            );
        }

        function checkAllSelected() {
            [$scope.messages.allSelected, $scope.messagesSelected] = siAlerts.checkAllSelected($scope.news);
        }

        function markAsRead() {
            const promises = $scope.news.results
                .filter(item => item.selected)
                .map(item => siScope.post({ url: `${item.url}mark_as_read/` }));

            $q.all(promises).then(refresh);
        }

        function markAsUnread() {
            const promises = $scope.news.results
                .filter(item => item.selected)
                .map(item => siScope.post({ url: `${item.url}mark_as_unread/` }));
            $q.all(promises).then(refresh);
            // TODO: determine this
        }

        function archiveSelected() {
            const promises = $scope.news.results
                .filter(item => item.selected)
                .map(item => siScope.post({ url: `${item.url}mark_as_archived/` }));

            $q.all(promises).then(refresh);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$on(APP.online, function() {
            $scope.isOffline = false;
        });

        $scope.$on(APP.offline, function() {
            $scope.isOffline = true;
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.alerts').controller('newsDetailController', newsDetailController);

    newsDetailController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        'apiUrl',
        'siScope',
        'siMessages',
        '$log',
        '$q',
        'toastr',
        '$sce',
        'offline',
        'modalFactory',
        'gettext',
        '$stateParams',
        'EVENT_LOADER'
    ];

    function newsDetailController(
        $rootScope,
        $scope,
        $state,
        apiUrl,
        siScope,
        siMessages,
        $log,
        $q,
        toastr,
        $sce,
        offline,
        modalFactory,
        gettext,
        $stateParams,
        EVENT_LOADER
    ) {
        if (offline.isOffline) {
            return toastr.error(
                'You are working currently offline and information on this page has not been downloaded.',
                null,
                { closeBtn: true }
            );
        }

        const alertTypesPromise = siMessages.getMessageTypes(),
            newsPromise = siScope.getItem(
                `${apiUrl}/blogs/blogsets/${$state.params.id}/?fields=blogs&fields=read_by&fields=archived_by`
            );

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([alertTypesPromise, newsPromise]).then(promises => {
            $scope.alertTypes = [];
            promises[0].results.forEach(type => {
                let contains =
                    $scope.alertTypes.map(alertType => alertType.display_name).indexOf(type.display_name) !== -1;
                if (!contains) {
                    $scope.alertTypes.push(type);
                }
            });
            $scope.news = promises[1];

            $scope.news.blog = $scope.news.blogs.objects
                .filter(blog => blog.language === $rootScope.me.language)
                .reduce((memo, blog) => blog, {});

            $scope.news.blog.body = $sce.trustAsHtml($scope.news.blog.body);
            $scope.news.archived_by_user =
                $scope.news.archived_by.objects.map(user => user.url).indexOf($rootScope.me.url) !== -1;
            $scope.news.read_by_user =
                $scope.news.read_by.objects.map(user => user.url).indexOf($rootScope.me.url) !== -1;

            console.log('Alerts - ', promises);

            if (!$scope.news.read_by_user) {
                siScope.post({ url: `${$scope.news.url}mark_as_read/` });
            }

            $rootScope.$broadcast(EVENT_LOADER.hide);
        });

        $scope.archive = archive;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * Function to toggle archive status of message
         */
        function archive() {
            modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to delete the message?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            siScope
                                .post({ url: `${$scope.news.url}mark_as_archived/` })
                                .then(() => ($scope.news.archived_by_user = true))
                                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                        }
                    }
                ]
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.alerts').controller('alertsListController', alertsListController);

    alertsListController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$log',
        '$q',
        'toastr',
        'offline',
        'apiUrl',
        'siScope',
        'gettext',
        'modalFactory',
        'siMessages',
        'siAlerts',
        'me',
        'EVENT_LOADER',
        'ALERTS',
        'APP'
    ];

    function alertsListController(
        $rootScope,
        $scope,
        $state,
        $log,
        $q,
        toastr,
        offline,
        apiUrl,
        siScope,
        gettext,
        modalFactory,
        siMessages,
        siAlerts,
        me,
        EVENT_LOADER,
        ALERTS,
        APP
    ) {
        $scope.type = $state.params.type || '';
        $scope.user = {};

        $scope.messages = { allSelected: false };
        $scope.refresh = refresh;
        $scope.toggleAllSelected = toggleAllSelected;
        $scope.checkAllSelected = checkAllSelected;
        $scope.markAsRead = markAsRead;
        $scope.markAsUnread = markAsUnread;
        $scope.archiveSelected = archiveSelected;
        $scope.updateEmailNotifications = updateEmailNotifications;

        siMessages.getMessageTypes().then((alertTypes = { results: [] }) => {
            $scope.alertTypes = [];

            if (offline.isOffline && alertTypes.results.length === 0) {
                return toastr.error(
                    'You are working currently offline and information on this page has not been downloaded.'
                );
            }

            alertTypes.results.forEach(type => {
                let contains =
                    $scope.alertTypes.map(alertType => alertType.display_name).indexOf(type.display_name) !== -1;
                if (!contains) {
                    $scope.alertTypes.push(type);
                }
            });
            console.log('Alert Types - ', $scope.alertTypes);
        });

        $scope.refresh();

        me.getMe().then(me => ($scope.user = me));

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function updateEmailNotifications() {
            return siScope.patch({ url: $scope.user.url, email_notifications_on: $scope.user.email_notifications_on });
        }

        function refresh() {
            return siAlerts
                .refresh($scope.search)
                .then(alerts => ($scope.alerts = alerts))
                .then(checkAllSelected);
        }

        function toggleAllSelected(allSelected) {
            [$scope.alerts, $scope.messagesSelected] = siAlerts.toggleAllSelected(
                allSelected,
                $scope.alerts,
                $scope.messagesSelected
            );
        }

        function checkAllSelected() {
            [$scope.messages.allSelected, $scope.messagesSelected] = siAlerts.checkAllSelected($scope.alerts);
        }

        function markAsRead() {
            siAlerts.markAsRead($scope.alerts, true).then(refresh);
        }

        function markAsUnread() {
            siAlerts.markAsRead($scope.alerts, false).then(refresh);
        }

        function archiveSelected() {
            siAlerts.archiveSelected($scope.alerts).then(refresh);
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$on(APP.online, function() {
            $scope.isOffline = false;
        });

        $scope.$on(APP.offline, function() {
            $scope.isOffline = true;
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.alerts').controller('alertDetailController', alertDetailController);

    alertDetailController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        'apiUrl',
        'siScope',
        'siMessages',
        '$log',
        '$q',
        'toastr',
        '$sce',
        'offline',
        'modalFactory',
        'gettext',
        '$stateParams',
        'EVENT_LOADER',
        'ALERTS'
    ];

    function alertDetailController(
        $rootScope,
        $scope,
        $state,
        apiUrl,
        siScope,
        siMessages,
        $log,
        $q,
        toastr,
        $sce,
        offline,
        modalFactory,
        gettext,
        $stateParams,
        EVENT_LOADER,
        ALERTS
    ) {
        const params = {
            id: $state.params.id,
            fields: ['from_user', 'to_user'],
            page: $stateParams.page || 1
        };

        if (offline.isOffline) {
            return toastr.error(
                'You are working currently offline and information on this page has not been downloaded.',
                null,
                { closeBtn: true }
            );
        }

        const alertTypesPromise = siMessages.getMessageTypes(),
            alertsPromise = siMessages.getMessage(params);

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([alertTypesPromise, alertsPromise]).then(promises => {
            $scope.alertTypes = [];
            promises[0].results.forEach(type => {
                let contains =
                    $scope.alertTypes.map(alertType => alertType.display_name).indexOf(type.display_name) !== -1;
                if (!contains) {
                    $scope.alertTypes.push(type);
                }
            });
            $scope.alert = promises[1];
            $scope.alert.body = $sce.trustAsHtml($scope.alert.body);
            $scope.alert.from_user = $scope.alert.from_user ? $scope.alert.from_user : { email: 'SCOPEinsight' };

            console.log('Alerts - ', promises);

            if (!$scope.alert.read_by_to_user) {
                siScope
                    .patch({ url: $scope.alert.url, read_by_to_user: true })
                    .then(() => $rootScope.$broadcast(ALERTS.decrement, $scope.alert));
            }

            $rootScope.$broadcast(EVENT_LOADER.hide);
        });

        $scope.archive = archive;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        /**
         * Function to toggle archive status of message
         */
        function archive() {
            modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to delete the message?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            siScope
                                .patch({
                                    url: $scope.alert.url,
                                    archived_by_to_user: !$scope.alert.archived_by_to_user
                                })
                                .then(alert => _.extend($scope.alert, alert))
                                .then(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                        }
                    }
                ]
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.commons.alerts').factory('siAlerts', siAlerts);

    siAlerts.$inject = [
        '$rootScope',
        'siMessages',
        '$stateParams',
        '$log',
        'siScope',
        '$q',
        'modalFactory',
        'gettext',
        'authenticationService',
        'offline',
        '$interval',
        '$state',
        'apiUrl',
        'EVENT_LOADER',
        'ALERTS',
        'toastr'
    ];

    function siAlerts(
        $rootScope,
        siMessages,
        $stateParams,
        $log,
        siScope,
        $q,
        modalFactory,
        gettext,
        authenticationService,
        offline,
        $interval,
        $state,
        apiUrl,
        EVENT_LOADER,
        ALERTS,
        toastr
    ) {
        const service = this;

        service.refresh = refresh;
        service.toggleAllSelected = toggleAllSelected;
        service.checkAllSelected = checkAllSelected;
        service.archiveSelected = archiveSelected;
        service.archiveSelectedModalFct = archiveSelectedModalFct;
        service.markAsRead = markAsRead;
        service.getUnreadAlerts = getUnreadAlerts;
        service.startAlertEvents = startAlertEvents;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
               Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function refresh(search = '') {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const params = {
                fields: ['from_user', 'to_user'],
                received: true,
                archived: $stateParams.type === 'archive',
                ordering: '-created_at',
                page: $stateParams.page || 1,
                type: ($stateParams.type || '') === 'archive' ? '' : $stateParams.type || '',
                search: search
            };

            return siMessages
                .getMessages(params)
                .then((alerts = { results: [] }) => {
                    alerts.results = alerts.results.map(alert => {
                        alert.from_user = alert.from_user ? alert.from_user : { email: 'SCOPEinsight' };
                        return alert;
                    });
                    console.log('Alerts - ', alerts);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    return alerts;
                })
                .catch(err => {
                    toastr.error('Alerts Error - ', err.detail);
                    if (err.detail === 'Invalid page.') {
                        $state.go($state.current.name, { page: 1 });
                    }
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function toggleAllSelected(selectAll, alerts, messagesSelected) {
            if (selectAll) {
                messagesSelected = true;
                alerts.results = alerts.results.map(alert => {
                    alert.selected = true;
                    return alert;
                });
            } else {
                messagesSelected = false;
                alerts.results = alerts.results.map(alert => {
                    alert.selected = false;
                    return alert;
                });
            }

            return [alerts, messagesSelected];
        }

        function checkAllSelected(alerts = { results: [] }) {
            const numberOfSelected = alerts.results.filter(alert => alert.selected).length;
            return [numberOfSelected === alerts.results.length, numberOfSelected > 0];
        }

        function markAsRead(alerts = {}, isMarkedAsRead) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const promises = alerts.results
                .filter(alert => alert.selected)
                .filter(alert => alert.read_by_to_user !== isMarkedAsRead)
                .map(alert => siScope.patch({ url: alert.url, read_by_to_user: isMarkedAsRead }));

            alerts.results
                .filter(alert => alert.selected)
                .filter(alert => alert.read_by_to_user !== isMarkedAsRead)
                .map(alert =>
                    isMarkedAsRead
                        ? $rootScope.$broadcast(ALERTS.decrement, alert)
                        : $rootScope.$broadcast(ALERTS.increment, alert)
                );

            return $q.all(promises);
        }

        function broadcastDecrementAlert(alert) {
            $rootScope.$broadcast(ALERTS.decrement, alert);
            return alert;
        }

        function archiveSelected(alerts = {}) {
            return modalFactory.ConfirmModal({
                message: gettext('Are you sure you want to delete the message?'),
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: () => archiveSelectedModalFct(alerts)
                    }
                ]
            }).result;
        }

        function archiveSelectedModalFct(alerts) {
            $rootScope.$broadcast(EVENT_LOADER.show);

            const promises = alerts.results
                .filter(alert => alert.selected)
                .map(alert => broadcastDecrementAlert(alert))
                .map(alert => siScope.patch({ url: alert.url, archived_by_to_user: true }));

            return $q.all(promises);
        }

        function getUnreadAlerts() {
            const alertsParams = {
                page_size: 999
            };

            if (!authenticationService.isLoggedIn() || offline.isOffline) {
                return;
            }

            siMessages.getMessages(alertsParams).then(
                (messages = { results: [] }) =>
                    ($rootScope.unreadAlerts = {
                        results: messages.results.filter(
                            message => !message.archived_by_to_user && !message.read_by_to_user
                        )
                    })
            );

            siScope.getList(`${apiUrl}/blogs/blogsets/?fields=blogs&fields=read_by`).then(({ results = [] }) => {
                $rootScope.unreadNews = {
                    results: results.filter(
                        item => item.read_by.objects.map(user => user.url).indexOf($rootScope.me.url) === -1
                    )
                };
            });
        }

        function startAlertEvents() {
            $rootScope.unreadAlerts = { results: [] };

            $rootScope.$on(ALERTS.decrement, (event, alert) => {
                $rootScope.unreadAlerts.results = $rootScope.unreadAlerts.results.filter(
                    unreadAlert => unreadAlert.url !== alert.url
                );
            });

            $rootScope.$on(ALERTS.increment, (event, alert) => {
                $rootScope.unreadAlerts.results.push(alert);
            });

            getUnreadAlerts();

            $interval(getUnreadAlerts, ALERTS.interval);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.commons', [
            //3rd Party
            'ui.router',
            'gettext',
            'toastr',
            'ngStorage',
            'angular-jwt',
            'ngMap',

            //Constants
            'scope.ngConstants',
            'scope.constants',

            //Common modules
            'scope.commons.alerts',
            'scope.commons.assessments',
            'scope.commons.authentication',
            'scope.commons.cache',
            'scope.commons.comments',
            'scope.commons.components',
            'scope.commons.directives',
            'scope.commons.exceptionHandler',
            'scope.commons.faq',
            'scope.commons.filters',
            'scope.commons.footer',
            'scope.commons.header',
            'scope.commons.hrm',
            'scope.commons.modals',
            'scope.commons.projects',
            'scope.commons.reports',
            'scope.commons.scoreBuilder',
            'scope.commons.services',
            'scope.commons.translations',
            'scope.commons.utils'
        ])
        .config(config);

    config.$inject = ['$httpProvider', 'toastrConfig'];

    function config($httpProvider, toastrConfig) {
        $httpProvider.interceptors.push('cacheInterceptor');
        angular.extend(toastrConfig, {
            autoDismiss: true,
            preventOpenDuplicates: true,
            timeOut: 1000
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.constants', [])
        .constant('moment', moment)
        .constant('saveAs', saveAs)
        .constant('Dexie', Dexie)
        .constant('COMPLETION_CHECK', {
            update: 'update-completion-check'
        })
        .constant('APP', {
            online: 'application-is-online',
            offline: 'application-is-offline'
        })
        .constant('OFFLINE_REQUESTS', {
            process: 'processing-offline-request'
        })
        .constant('LANGUAGES', [
            { name: 'French', id: 'fr' },
            { name: 'Spanish', id: 'es' },
            { name: 'English', id: 'en' }
        ])
        .constant(
            'EMAIL_VALID_REGEX',
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        .constant('PARSENAME_REGEX', '[^a-zA-Z0-9d]')
        .constant('currencies', {
            AED: {
                name: 'UAE Dirham',
                countries: ['AE']
            },
            AFN: {
                name: 'Afghani',
                countries: ['AF']
            },
            ALL: {
                name: 'Lek',
                countries: ['AL']
            },
            AMD: {
                name: 'Armenian Dram',
                countries: ['AM']
            },
            ANG: {
                name: 'Netherlands Antillean Guilder',
                countries: ['CW', 'SX']
            },
            AOA: {
                name: 'Kwanza',
                countries: ['AO']
            },
            ARS: {
                name: 'Argentine Peso',
                countries: ['AR']
            },
            AUD: {
                name: 'Australian Dollar',
                countries: ['AU', 'CX', 'CC', 'HM', 'KI', 'NR', 'NF', 'TV']
            },
            AWG: {
                name: 'Aruban Florin',
                countries: ['AW']
            },
            AZN: {
                name: 'Azerbaijanian Manat',
                countries: ['AZ']
            },
            BAM: {
                name: 'Convertible Mark',
                countries: ['BA']
            },
            BBD: {
                name: 'Barbados Dollar',
                countries: ['BB']
            },
            BDT: {
                name: 'Taka',
                countries: ['BD']
            },
            BGN: {
                name: 'Bulgarian Lev',
                countries: ['BG']
            },
            BHD: {
                name: 'Bahraini Dinar',
                countries: ['BH']
            },
            BIF: {
                name: 'Burundi Franc',
                countries: ['BI']
            },
            BMD: {
                name: 'Bermudian Dollar',
                countries: ['BM']
            },
            BND: {
                name: 'Brunei Dollar',
                countries: ['BN']
            },
            BOB: {
                name: 'Boliviano',
                countries: ['BO']
            },
            BRL: {
                name: 'Brazilian Real',
                countries: ['BR']
            },
            BSD: {
                name: 'Bahamian Dollar',
                countries: ['BS']
            },
            BTN: {
                name: 'Ngultrum',
                countries: ['BT']
            },
            BWP: {
                name: 'Pula',
                countries: ['BW']
            },
            BYR: {
                name: 'Belarussian Ruble',
                countries: ['BY']
            },
            BZD: {
                name: 'Belize Dollar',
                countries: ['BZ']
            },
            CAD: {
                name: 'Canadian Dollar',
                countries: ['CA']
            },
            CDF: {
                name: 'Congolese Franc',
                countries: ['CD']
            },
            CHF: {
                name: 'Swiss Franc',
                countries: ['LI', 'CH']
            },
            CLP: {
                name: 'Chilean Peso',
                countries: ['CL']
            },
            CNY: {
                name: 'Yuan Renminbi',
                countries: ['CN']
            },
            COP: {
                name: 'Colombian Peso',
                countries: ['CO']
            },
            CRC: {
                name: 'Costa Rican Colon',
                countries: ['CR']
            },
            CUC: {
                name: 'Peso Convertible',
                countries: ['CU']
            },
            CUP: {
                name: 'Cuban Peso',
                countries: ['CU']
            },
            CVE: {
                name: 'Cape Verde Escudo',
                countries: ['CV']
            },
            CZK: {
                name: 'Czech Koruna',
                countries: ['CZ']
            },
            DJF: {
                name: 'Djibouti Franc',
                countries: ['DJ']
            },
            DKK: {
                name: 'Danish Krone',
                countries: ['DK', 'FO', 'GL']
            },
            DOP: {
                name: 'Dominican Peso',
                countries: ['DO']
            },
            DZD: {
                name: 'Algerian Dinar',
                countries: ['DZ']
            },
            EGP: {
                name: 'Egyptian Pound',
                countries: ['EG']
            },
            ERN: {
                name: 'Nakfa',
                countries: ['ER']
            },
            ETB: {
                name: 'Ethiopian Birr',
                countries: ['ET']
            },
            EUR: {
                name: 'Euro',
                countries: [
                    'AX',
                    'AD',
                    'AT',
                    'BE',
                    'CY',
                    'EE',
                    'FI',
                    'FR',
                    'GF',
                    'TF',
                    'DE',
                    'GR',
                    'GP',
                    'IE',
                    'IT',
                    'LU',
                    'MT',
                    'MQ',
                    'YT',
                    'MC',
                    'ME',
                    'NL',
                    'PT',
                    'RE',
                    'BL',
                    'MF',
                    'PM',
                    'SM',
                    'SK',
                    'SI',
                    'ES',
                    'VA'
                ]
            },
            FJD: {
                name: 'Fiji Dollar',
                countries: ['FJ']
            },
            FKP: {
                name: 'Falkland Islands Pound',
                countries: ['FK']
            },
            GBP: {
                name: 'Pound Sterling',
                countries: ['GG', 'IM', 'JE', 'GB']
            },
            GEL: {
                name: 'Lari',
                countries: ['GE']
            },
            GHS: {
                name: 'Ghana Cedi',
                countries: ['GH']
            },
            GIP: {
                name: 'Gibraltar Pound',
                countries: ['GI']
            },
            GMD: {
                name: 'Dalasi',
                countries: ['GM']
            },
            GNF: {
                name: 'Guinea Franc',
                countries: ['GN']
            },
            GTQ: {
                name: 'Quetzal',
                countries: ['GT']
            },
            GYD: {
                name: 'Guyana Dollar',
                countries: ['GY']
            },
            HKD: {
                name: 'Hong Kong Dollar',
                countries: ['HK']
            },
            HNL: {
                name: 'Lempira',
                countries: ['HN']
            },
            HRK: {
                name: 'Croatian Kuna',
                countries: ['HR']
            },
            HTG: {
                name: 'Gourde',
                countries: ['HT']
            },
            HUF: {
                name: 'Forint',
                countries: ['HU']
            },
            IDR: {
                name: 'Rupiah',
                countries: ['ID']
            },
            ILS: {
                name: 'New Israeli Sheqel',
                countries: ['IL']
            },
            INR: {
                name: 'Indian Rupee',
                countries: ['BT', 'IN']
            },
            IQD: {
                name: 'Iraqi Dinar',
                countries: ['IQ']
            },
            IRR: {
                name: 'Iranian Rial',
                countries: ['IR']
            },
            ISK: {
                name: 'Iceland Krona',
                countries: ['IS']
            },
            JMD: {
                name: 'Jamaican Dollar',
                countries: ['JM']
            },
            JOD: {
                name: 'Jordanian Dinar',
                countries: ['JO']
            },
            JPY: {
                name: 'Yen',
                countries: ['JP']
            },
            KES: {
                name: 'Kenyan Shilling',
                countries: ['KE']
            },
            KGS: {
                name: 'Som',
                countries: ['KG']
            },
            KHR: {
                name: 'Riel',
                countries: ['KH']
            },
            KMF: {
                name: 'Comoro Franc',
                countries: ['KM']
            },
            KPW: {
                name: 'North Korean Won',
                countries: ['KP']
            },
            KRW: {
                name: 'Won',
                countries: ['KR']
            },
            KWD: {
                name: 'Kuwaiti Dinar',
                countries: ['KW']
            },
            KYD: {
                name: 'Cayman Islands Dollar',
                countries: ['KY']
            },
            KZT: {
                name: 'Tenge',
                countries: ['KZ']
            },
            LAK: {
                name: 'Kip',
                countries: ['LA']
            },
            LBP: {
                name: 'Lebanese Pound',
                countries: ['LB']
            },
            LKR: {
                name: 'Sri Lanka Rupee',
                countries: ['LK']
            },
            LRD: {
                name: 'Liberian Dollar',
                countries: ['LR']
            },
            LSL: {
                name: 'Loti',
                countries: ['LS']
            },
            LTL: {
                name: 'Lithuanian Litas',
                countries: ['LT']
            },
            LVL: {
                name: 'Latvian Lats',
                countries: ['LV']
            },
            LYD: {
                name: 'Libyan Dinar',
                countries: ['LY']
            },
            MAD: {
                name: 'Moroccan Dirham',
                countries: ['MA', 'EH']
            },
            MDL: {
                name: 'Moldovan Leu',
                countries: ['MD']
            },
            MGA: {
                name: 'Malagasy Ariary',
                countries: ['MG']
            },
            MKD: {
                name: 'Denar',
                countries: ['MK']
            },
            MMK: {
                name: 'Kyat',
                countries: ['MM']
            },
            MNT: {
                name: 'Tugrik',
                countries: ['MN']
            },
            MOP: {
                name: 'Pataca',
                countries: ['MO']
            },
            MRO: {
                name: 'Ouguiya',
                countries: ['MR']
            },
            MUR: {
                name: 'Mauritius Rupee',
                countries: ['MU']
            },
            MVR: {
                name: 'Rufiyaa',
                countries: ['MV']
            },
            MWK: {
                name: 'Kwacha',
                countries: ['MW']
            },
            MXN: {
                name: 'Mexican Peso',
                countries: ['MX']
            },
            MYR: {
                name: 'Malaysian Ringgit',
                countries: ['MY']
            },
            MZN: {
                name: 'Mozambique Metical',
                countries: ['MZ']
            },
            NAD: {
                name: 'Namibia Dollar',
                countries: ['NA']
            },
            NGN: {
                name: 'Naira',
                countries: ['NG']
            },
            NIO: {
                name: 'Cordoba Oro',
                countries: ['NI']
            },
            NOK: {
                name: 'Norwegian Krone',
                countries: ['BV', 'NO', 'SJ']
            },
            NPR: {
                name: 'Nepalese Rupee',
                countries: ['NP']
            },
            NZD: {
                name: 'New Zealand Dollar',
                countries: ['CK', 'NZ', 'NU', 'PN', 'TK']
            },
            OMR: {
                name: 'Rial Omani',
                countries: ['OM']
            },
            PAB: {
                name: 'Balboa',
                countries: ['PA']
            },
            PEN: {
                name: 'Nuevo Sol',
                countries: ['PE']
            },
            PGK: {
                name: 'Kina',
                countries: ['PG']
            },
            PHP: {
                name: 'Philippine Peso',
                countries: ['PH']
            },
            PKR: {
                name: 'Pakistan Rupee',
                countries: ['PK']
            },
            PLN: {
                name: 'Zloty',
                countries: ['PL']
            },
            PYG: {
                name: 'Guarani',
                countries: ['PY']
            },
            QAR: {
                name: 'Qatari Rial',
                countries: ['QA']
            },
            RON: {
                name: 'New Romanian Leu',
                countries: ['RO']
            },
            RSD: {
                name: 'Serbian Dinar',
                countries: ['RS']
            },
            RUB: {
                name: 'Russian Ruble',
                countries: ['RU']
            },
            RWF: {
                name: 'Rwanda Franc',
                countries: ['RW']
            },
            SAR: {
                name: 'Saudi Riyal',
                countries: ['SA']
            },
            SBD: {
                name: 'Solomon Islands Dollar',
                countries: ['SB']
            },
            SCR: {
                name: 'Seychelles Rupee',
                countries: ['SC']
            },
            SDG: {
                name: 'Sudanese Pound',
                countries: ['SD']
            },
            SEK: {
                name: 'Swedish Krona',
                countries: ['SE']
            },
            SGD: {
                name: 'Singapore Dollar',
                countries: ['SG']
            },
            SHP: {
                name: 'Saint Helena Pound',
                countries: ['SH']
            },
            SLL: {
                name: 'Leone',
                countries: ['SL']
            },
            SOS: {
                name: 'Somali Shilling',
                countries: ['SO']
            },
            SRD: {
                name: 'Surinam Dollar',
                countries: ['SR']
            },
            SSP: {
                name: 'South Sudanese Pound',
                countries: ['SS']
            },
            STD: {
                name: 'Dobra',
                countries: ['ST']
            },
            SVC: {
                name: 'El Salvador Colon',
                countries: ['SV']
            },
            SYP: {
                name: 'Syrian Pound',
                countries: ['SY']
            },
            SZL: {
                name: 'Lilangeni',
                countries: ['SZ']
            },
            THB: {
                name: 'Baht',
                countries: ['TH']
            },
            TJS: {
                name: 'Somoni',
                countries: ['TJ']
            },
            TMT: {
                name: 'Turkmenistan New Manat',
                countries: ['TM']
            },
            TND: {
                name: 'Tunisian Dinar',
                countries: ['TN']
            },
            TOP: {
                name: "Pa'anga",
                countries: ['TO']
            },
            TRY: {
                name: 'Turkish Lira',
                countries: ['TR']
            },
            TTD: {
                name: 'Trinidad and Tobago Dollar',
                countries: ['TT']
            },
            TWD: {
                name: 'New Taiwan Dollar',
                countries: ['TW']
            },
            TZS: {
                name: 'Tanzanian Shilling',
                countries: ['TZ']
            },
            UAH: {
                name: 'Hryvnia',
                countries: ['UA']
            },
            UGX: {
                name: 'Uganda Shilling',
                countries: ['UG']
            },
            USD: {
                name: 'US Dollar',
                countries: [
                    'AS',
                    'BQ',
                    'IO',
                    'EC',
                    'SV',
                    'GU',
                    'HT',
                    'MH',
                    'FM',
                    'MP',
                    'PW',
                    'PA',
                    'PR',
                    'TL',
                    'TC',
                    'US',
                    'UM',
                    'VG',
                    'VI'
                ]
            },
            UYU: {
                name: 'Peso Uruguayo',
                countries: ['UY']
            },
            UZS: {
                name: 'Uzbekistan Sum',
                countries: ['UZ']
            },
            VEF: {
                name: 'Bolivar',
                countries: ['VE']
            },
            VND: {
                name: 'Dong',
                countries: ['VN']
            },
            VUV: {
                name: 'Vatu',
                countries: ['VU']
            },
            WST: {
                name: 'Tala',
                countries: ['WS']
            },
            XAF: {
                name: 'CFA Franc BEAC',
                countries: ['CM', 'CF', 'TD', 'CG', 'GQ', 'GA']
            },
            XCD: {
                name: 'East Caribbean Dollar',
                countries: ['AI', 'AG', 'DM', 'GD', 'MS', 'KN', 'LC', 'VC']
            },
            XOF: {
                name: 'CFA Franc BCEAO',
                countries: ['BJ', 'BF', 'CI', 'GW', 'ML', 'NE', 'SN', 'TG']
            },
            XPF: {
                name: 'CFP Franc',
                countries: ['PF', 'NC', 'WF']
            },
            YER: {
                name: 'Yemeni Rial',
                countries: ['YE']
            },
            ZAR: {
                name: 'Rand',
                countries: ['LS', 'NA', 'ZA']
            },
            ZMW: {
                name: 'Zambian Kwacha',
                countries: ['ZM']
            },
            ZWL: {
                name: 'Zimbabwe Dollar',
                countries: ['ZW']
            }
        })
        .constant('ALERTS', {
            decrement: 'alerts-decrement',
            increment: 'alerts-increment',
            interval: 30000
        })
        .constant('SW', {
            newContent: 'sw-new-content-available',
            offlineReady: 'sw-offline-ready'
        })
        .constant('TOOL_TYPES', {
            agent: {
                assessment_tab: true,
                organizational_tab: {
                    basic_contact: {
                        gender: true,
                        age: true,
                        household_members: true,
                        languages_spoken: true
                    },
                    additional_details: true,
                    related_farmers: true,
                    personal_transportation: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: false,
                    computer_access: true,
                    infrastructure_information: true
                },
                finance_and_product_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            basic: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: true,
                    members_suppliers: {
                        number_of_female_active_members: true,
                        number_of_male_active_members: true
                    },
                    employees: true,
                    sharecroppers: false,
                    outgrowers: true,
                    board_and_management: true,
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: true
                },
                value_chain_tab: {
                    value_chain_players: true,
                    enabling_players: true,
                    supplier: false
                },
                finance_history_tab: true,
                finance_overview_tab: true,
                production_tab: {
                    quality: true,
                    certifications: true,
                    percent_of_members_or_outgrowers_production_sold_to_producing_organization: true,
                    productionpurchases: true,
                    otherproductionpurchases: true,
                    productionfigures: false,
                    productionsales: true,
                    productionmargins: false,
                    sold_to_farmers: false,
                    input_purchases: true // || assessment.with_margins_raw_materials
                },
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            is_sacco: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: true,
                    members_suppliers: {
                        number_of_female_active_members: true,
                        number_of_male_active_members: true
                    },
                    employees: true,
                    sharecroppers: false,
                    outgrowers: true,
                    board_and_management: true,
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: true
                },
                // value_chain_tab: {
                //     value_chain_players: false,
                //     enabling_players: false,
                //     supplier: false
                // },
                finance_history_tab: true,
                finance_overview_tab: true,
                production_tab: false,
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            is_rapid: {
                assessment_tab: {
                    purposes: false,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: true,
                    members_suppliers: {
                        number_of_female_active_members: true,
                        number_of_male_active_members: true
                    },
                    employees: true,
                    sharecroppers: false,
                    outgrowers: true,
                    board_and_management: true,
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: false
                },
                // value_chain_tab: {
                //     value_chain_players: true,
                //     enabling_players: true,
                //     supplier: false
                // },
                finance_history_tab: false,
                finance_overview_tab: true,
                production_tab: {
                    quality: true,
                    certifications: false,
                    percent_of_members_or_outgrowers_production_sold_to_producing_organization: true,
                    productionpurchases: true,
                    otherproductionpurchases: true,
                    productionfigures: false,
                    productionsales: true,
                    productionmargins: false,
                    sold_to_farmers: false,
                    input_purchases: false // || assessment.with_margins_raw_materials
                },
                // observations_tab: false,
                questionnaire_tab: true,
                // documentation_tab: true,
                terms_tab: true,
                qc_tab: false
            },
            basic_sme: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: {
                        number_of_shareholders: false // && !assessment.with_management_body
                    },
                    members_suppliers: true,
                    outgrowers: false,
                    employees: true,
                    board_and_management: true,
                    management_body: false, // && assessment.with_management_body
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: true
                },
                value_chain_tab: {
                    value_chain_players: true,
                    enabling_players: true,
                    supplier: false
                },
                finance_history_tab: true,
                finance_overview_tab: true,
                production_tab: {
                    primary_production: true,
                    productionpurchases: true,
                    otherproductionpurchases: true,
                    productionfigures: false,
                    productionsales: true,
                    sold_to_farmers: false,
                    input_purchases: false,
                    productionmargins: true // && assessment.with_margins_raw_materials
                },
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            input_retailer: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: true,
                        website: true
                    },
                    contacts: true,
                    incorporation: {
                        number_of_shareholders: false,
                        in_operation_since: false
                    },
                    members_suppliers: false,
                    activities: false,
                    mission_vision: false,
                    board_and_management: false,
                    employees: true,
                    access_roads: false,
                    distance_to_hub: false,
                    demonstration_plot: true,
                    training_space: true,
                    warehousing: true,
                    public_transportation: false,
                    infrastructure_information: true
                },
                value_chain_tab: {
                    value_chain_players: false,
                    enabling_players: false,
                    supplier: true
                },
                finance_history_tab: true,
                finance_overview_tab: true,
                production_tab: {
                    productionpurchases: false,
                    otherproductionpurchases: false,
                    productionfigures: false,
                    productionsales: false,
                    productionmargins: false,
                    input_purchases: false,
                    sold_to_farmers: true
                },
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            pro: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: true,
                    representing_organization: true,
                    members_suppliers: {
                        number_of_female_active_members: true,
                        number_of_male_active_members: true
                    },
                    employees: true,
                    sharecroppers: false,
                    outgrowers: true,
                    board_and_management: true,
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: true
                },
                value_chain_tab: {
                    value_chain_players: true,
                    enabling_players: true,
                    supplier: false
                },
                finance_history_tab: true,
                finance_overview_tab: false,
                profit_loss_tab: true,
                balancesheet_tab: true,
                cashflow_tab: true,
                financial_performance_tab: true,
                production_tab: {
                    quality: true,
                    primary_production: true,
                    certifications: true,
                    productionpurchases: true,
                    otherproductionpurchases: true,
                    productionfigures: false,
                    productionsales: true,
                    productionmargins: false,
                    sold_to_farmers: false,
                    input_purchases: true // || assessment.with_margins_raw_materials
                },
                monthly_production_tab: true,
                governance_tab: true,
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            },
            pro_sme: {
                assessment_tab: {
                    purposes: true,
                    description: true,
                    representatives: true
                },
                organizational_tab: {
                    basic_contact: {
                        abbreviation: true,
                        name_owner: false,
                        website: true
                    },
                    contacts: true,
                    incorporation: true,
                    members_suppliers: true,
                    outgrowers: false,
                    employees: true,
                    board_and_management: true,
                    mission_vision: true,
                    activities: true,
                    access_roads: true,
                    distance_to_hub: true,
                    demonstration_plot: false,
                    training_space: false,
                    warehousing: true,
                    public_transportation: true,
                    infrastructure_information: true
                },
                value_chain_tab: {
                    value_chain_players: true,
                    enabling_players: true,
                    supplier: false
                },
                finance_history_tab: true,
                finance_overview_tab: false,
                profit_loss_tab: true,
                balancesheet_tab: true,
                cashflow_tab: true,
                financial_performance_tab: true,
                production_tab: {
                    quality: true,
                    certifications: true,
                    percent_of_members_or_outgrowers_production_sold_to_producing_organization: true,
                    productionpurchases: true,
                    otherproductionpurchases: true,
                    productionfigures: false,
                    productionsales: true,
                    productionmargins: false,
                    sold_to_farmers: false,
                    input_purchases: false
                },
                monthly_production_tab: true,
                governance_tab: true,
                observations_tab: true,
                questionnaire_tab: true,
                documentation_tab: true,
                terms_tab: true,
                qc_tab: true
            }
        });
})();

angular.module("scope.templates", []).run(["$templateCache", function($templateCache) {$templateCache.put("modals/allocations/declineModal.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Your confirmation is needed</h3></div><div class=\"modal-body\"><p><translate>Are you sure you want to decline the invite for the following assessment?</translate>{{invite.producing_organization_name}} ({{invite.tool}})</p><div class=\"row\"><label class=\"col-sm-2 control-label\" translate=\"\">Reason</label><div class=\"col-sm-10\"><textarea type=\"text\" class=\"form-control\" ng-model=\"invite.status_reason\"></textarea></div></div></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" value=\"{{ \'Decline\' | translate }}\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("allocations/allocationsView.html","<si-page class=\"allocations\" search=\"true\" background=\"grey\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\">Invitations</h2></header><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h5 translate=\"\">Pending Invitations</h5></header><div class=\"si-page__main__content\"><p class=\"well\" ng-if=\"pendingInvitations.results.length == 0\" translate=\"\">There are no invitations at this time.</p><table class=\"table\" ng-if=\"pendingInvitations.results.length > 0\"><thead><tr><th>&nbsp;</th><th class=\"sorting\" translate=\"\">Producing Organization</th><th class=\"sorting\" translate=\"\">Tool</th><th class=\"sorting\" translate=\"\">Planned Assessment Date</th><th class=\"text-right\" translate=\"\">Actions</th></tr></thead><tbody><tr ng-repeat=\"invite in pendingInvitations.results | orderBy:\'-id\'\"><td><span ng-if=\"invite.assigned_as === \'assessor\'\" class=\"badge text-success\"><i class=\"fa fa-user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Assessor\' | translate}}\"></i></span> <span ng-if=\"invite.assigned_as === \'financial_specialist\'\" class=\"badge text-info\"><i class=\"fa fa-dollar\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Financial Specialist\' | translate}}\"></i></span></td><td>{{ invite.producing_organization_name }}</td><td>{{ invite.tool_type }}</td><td>{{ invite.deadline|date:\'dd-MM-yyyy\' }}</td><td class=\"text-right\"><button ng-disabled=\"isOffline\" class=\"btn btn-xs btn-primary\" ng-click=\"acceptInvite(invite)\"><i class=\"fa fa-check\"></i><translate>Accept</translate></button> <button ng-disabled=\"isOffline\" class=\"btn btn-xs btn-danger\" ng-click=\"declineInvite(invite)\"><i class=\"fa fa-times\"></i><translate>Decline</translate></button></td></tr></tbody></table></div></main><main class=\"si-page__main allocations__past\"><header class=\"si-page__main__header\"><h5 translate=\"\">Past Invitations</h5></header><div class=\"si-page__main__content\"><p class=\"well\" ng-if=\"pastInvitations.results.length == 0\" translate=\"\">There are no invitations at this time.</p><table class=\"table\" ng-if=\"pastInvitations.results.length > 0\"><thead><tr><th class=\"sorting\" translate=\"\">Producing Organization</th><th class=\"sorting\" translate=\"\">Tool</th><th class=\"sorting\" translate=\"\">Planned Assessment Date</th><th class=\"sorting\" translate=\"\">Status</th><th class=\"sorting text-center\" translate=\"\">Reason</th></tr></thead><tbody><tr ng-repeat=\"invite in pastInvitations.results | orderBy:\'-id\'\"><td>{{ invite.producing_organization_name }}</td><td>{{ invite.tool_type }}</td><td>{{ invite.deadline|date:\'dd-MM-yyyy\' }}</td><td>{{ invite.display_status }}</td><td>{{ invite.status_reason }}</td></tr></tbody></table><paginated items=\"assignments\" items-per-page=\"10\"></paginated></div></main></div></si-page>");
$templateCache.put("base/base.html","<div ng-show=\"appready\" class=\"scope__smartclient\"><div id=\"wrapper\" class=\"main-wrapper\"><div ui-view=\"navigationView\"></div><div id=\"page-wrapper\" class=\"gray-bg {{ $state.current.name}}\"><div ui-view=\"headerView\"></div><div ui-view=\"contentView\" id=\"content-view\"></div><div ui-view=\"footerView\"></div></div></div></div>");
$templateCache.put("downloads/downloads-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Choose document language.</h3></div><div class=\"modal-body\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document Name</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-repeat=\"document in $ctrl.document.objects\"><td ng-bind=\"document.title\"></td><td><a class=\"btn btn-primary\" ng-click=\"$ctrl.download(document)\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td><td><p ng-bind=\"document.comment\"></p></td></tr></table></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("downloads/downloads-view.html","<si-page search=\"true\" background=\"grey\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\">Downloads</h2></header><main class=\"si-page__main\"><div class=\"si-page__main__content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document Name</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-show=\"document.displayFile\" ng-repeat=\"document in $ctrl.documents\"><td ng-bind=\"document.displayFile.title\"></td><td><a class=\"btn btn-primary\" ng-click=\"$ctrl.download(document.files)\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td><td><p ng-bind=\"document.displayFile.comment\"></p></td></tr></table></div></main></div></si-page>");
$templateCache.put("home/homeView.html","<si-page search=\"true\" background=\"grey\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\" style=\"display: flex; justify-content: space-between; align-items: center\"><h2 translate=\"\">Home</h2><div ng-if=\"me.is_self_assessor\"><button class=\"btn btn-primary\" ng-click=\"addSelfAssessment()\">Create Rapid Check</button></div></header><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h5 translate=\"\">Pending Invitations</h5></header><div class=\"si-page__main__content\"><p class=\"well\" ng-if=\"pendingInvitations.results.length == 0\" translate=\"\">There are no invitations at this time.</p><table class=\"table\" ng-if=\"pendingInvitations.results.length > 0\"><thead><tr><th>&nbsp;</th><th class=\"sorting\" translate=\"\">Producing Organization</th><th class=\"sorting\" translate=\"\">Tool</th><th class=\"sorting\" translate=\"\">Planned Assessment Date</th><th class=\"text-right\" translate=\"\">Actions</th></tr></thead><tbody><tr ng-repeat=\"invite in pendingInvitations.results | orderBy:\'-id\'\"><td><span ng-if=\"invite.assigned_as === \'assessor\'\" class=\"badge text-success\"><i class=\"fa fa-user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Assessor\' | translate}}\"></i></span> <span ng-if=\"invite.assigned_as === \'financial_specialist\'\" class=\"badge text-info\"><i class=\"fa fa-dollar\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Financial Specialist\' | translate}}\"></i></span></td><td>{{ invite.producing_organization_name }}</td><td>{{ invite.tool_type }}</td><td>{{ invite.deadline|date:\'dd-MM-yyyy\' }}</td><td class=\"text-right\"><button ng-disabled=\"isOffline\" class=\"btn btn-xs btn-primary\" ng-click=\"acceptInvite(invite)\"><i class=\"fa fa-check\"></i><translate>Accept</translate></button> <button ng-disabled=\"isOffline\" class=\"btn btn-xs btn-danger\" ng-click=\"declineInvite(invite)\"><i class=\"fa fa-times\"></i><translate>Decline</translate></button></td></tr></tbody></table></div></main><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h5 translate=\"\">Your Upcoming Assessments</h5></header><div class=\"si-page__main__content\"><table class=\"table\"><thead><tr><th class=\"sorting\" translate=\"\">Producing Organization</th><th class=\"sorting\" translate=\"\">Address</th><th class=\"sorting\" translate=\"\">Tool</th><th class=\"sorting\" translate=\"\">Planned Assessment Date</th></tr></thead><tbody><tr style=\"cursor: pointer\" ng-repeat=\"assignment in assignments.results | orderBy:\'-id\' track by $index\" ng-click=\"clickRow(assignment)\"><td>{{ assignment.producing_organization_name }}</td><td>{{ assignment.address }}</td><td>{{ assignment.tool_type }}</td><td>{{ assignment.deadline|date:\'dd-MM-yyyy\' }}</td><td></td></tr></tbody></table><paginated items=\"assignments\" items-per-page=\"10\"></paginated></div></main></div></si-page>");
$templateCache.put("navigation/navigationView.html","<nav class=\"navbar-default navbar-static-side ng-scope\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"dropdown profile-element\"><div class=\"dropdown profile-element text-center\"><a ui-sref=\"base.home\"><img alt=\"image\" style=\"height:100px\" src=\"assets/img/logo_black.svg\"></a></div><div class=\"logo-element\">IN+</div></div></li><li ng-class=\"{ \'active\': $state.current.name === \'base.home\' }\"><a ui-sref=\"base.home\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\" translate=\"\">Home</span></a></li><li ng-class=\"{ \'active\': $state.current.name === \'base.alerts\'}\"><a ui-sref=\"base.alerts\"><i class=\"fa fa-bell\"></i> <span class=\"nav-label\" translate=\"\">Alerts</span> <span class=\"label label-success pull-right\" ng-if=\"unreadAlerts.results.length > 0 || unreadNews.results.length > 0\">{{ unreadAlerts.results.length }}</span></a></li><li ng-class=\"{ \'active-state active\': $state.current.name === \'base.alerts-news\' }\"><a ui-sref=\"base.alerts-news({type:\'news\'})\" ng-class=\"{\'active\': type == \'news\'}\"><i class=\"fa fa-inbox\"></i> <span class=\"nav-label\" translate=\"\">News</span> <span class=\"label label-success pull-right\" ng-if=\"unreadNews.results.length > 0\">{{ unreadNews.results.length }}</span></a></li><li ng-class=\"{ \'active\': $state.current.name === \'base.assessments-list\'}\"><a ui-sref=\"base.assessments-list\"><i class=\"fa fa-list-alt\"></i> <span class=\"nav-label\" translate=\"\">Assessments</span></a></li><li ng-class=\"{ \'active\': $state.current.name === \'base.assessments-list-final\'}\"><a ui-sref=\"base.assessments-list-final\"><i class=\"fa fa-list-alt\"></i> <span class=\"nav-label\" translate=\"\">Completed</span></a></li><li ng-if=\"me.is_self_assessor\" ng-class=\"{ \'active\': $state.current.name === \'base.organization-history\'}\"><a ui-sref=\"base.organization-history\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\" translate=\"\">Organization History</span></a></li><li ng-if=\"me.is_self_assessor\" ng-class=\"{ \'active\': $state.current.name === \'base.organization-details\'}\"><a ui-sref=\"base.organization-details\"><i class=\"fa fa-list-alt\"></i> <span class=\"nav-label\" translate=\"\">Organization Details</span></a></li><li ng-class=\"{ \'active\': $state.current.name === \'base.allocations\' }\"><a ui-sref=\"base.allocations\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\" translate=\"\">Invitations</span></a></li><li ng-class=\"{ \'active\': $state.current.name === \'base.downloads\' }\"><a ui-sref=\"base.downloads\"><i class=\"fa fa-download\"></i> <span class=\"nav-label\" translate=\"\">Downloads</span></a></li></ul></div></nav>");
$templateCache.put("organization/historyView.html","<div class=\"profile-content\"><div class=\"well\" ng-if=\"customer.reports.objects.length === 0\"><translate>Your Organization has no reports yet..</translate></div><div class=\"well\" ng-if=\"customer.reports.objects.length > 0\"><h3>Organization report history</h3><table class=\"table table-bordered table-hover dataTable\"><thead><tr><th class=\"text-center sorting_asc\" translate=\"\">Project</th><th class=\"sorting\" translate=\"\">Assessment date</th><th class=\"sorting\" translate=\"\">Tool</th><th class=\"sorting\" translate=\"\">Final date</th><th class=\"sorting\" translate=\"\">Assessor</th><th class=\"sorting\" translate=\"\">Status</th></tr></thead><tbody><tr ng-repeat=\"report in customer.reports.objects\" ui-sref=\"base.reports-detail.summary({ id: report.id })\" style=\"cursor: pointer\"><td class=\"text-center\">{{ report.project_name }}</td><td>{{ report.assessment_date | date:\'dd-MM-yyyy\' }}</td><td>{{ report.tool }}</td><td>{{ report.finalized_at | date:\'dd-MM-yyyy\' }}</td><td>{{ report.assessor_name }}</td><td>{{ report.status }}</td></tr></tbody></table></div></div>");
$templateCache.put("organization/organizationDetailsView.html","<si-page search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 ng-if=\"customer.producing_organization\" translate=\"\">Organization Profile</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ng-if=\"customer.producing_organization\" translate=\"\">Organization</a> <a ng-if=\"!customer.producing_organization\" translate=\"\">Details</a></li><li class=\"active\"><strong>{{ customer.name }}</strong></li></ol></header><main class=\"si-page__main\" style=\"background: white\"><uib-tabset><uib-tab><uib-tab-heading translate=\"\">General</uib-tab-heading><form name=\"clientForm\" class=\"form form-horizontal\"><div class=\"profile-content\"><fieldset ng-disabled=\"true\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Active account</translate></label><div class=\"col-sm-3\"><input type=\"checkbox\" class=\"single-checkbox\" ng-model=\"customer.is_active\" name=\"is_active\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Full name</translate><label class=\"text-danger\" ng-show=\"clientForm.name.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"customer.name\" name=\"name\" required=\"\"></div></div><div ng-if=\"customer.producing_organization\" class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Assessee ID</translate></label><div style=\"margin-top:7px\" class=\"col-sm-9\"><span>{{ customer.id }}</span></div></div><div ng-if=\"customer.producing_organization\" class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Scope ID</translate></label><div style=\"margin-top:7px\" class=\"col-sm-9\"><span>{{ customer.producing_organization.scope_id }}</span></div></div><div ng-if=\"customer.flo_id\" class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>FLO ID</translate></label><div style=\"margin-top:7px\" class=\"col-sm-9\"><span>{{ customer.flo_id }}</span></div></div><div ng-if=\"customer.iso_id\" class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>ISO Certificate ID</translate></label><div style=\"margin-top:7px\" class=\"col-sm-9\"><span>{{ customer.iso_id }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Abbreviation</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"customer.abbreviation\" name=\"abbreviation\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Website</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"customer.website\" name=\"website\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Email</translate></label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" ng-model=\"customer.email\" name=\"email\"> <b><small class=\"text-danger\" ng-show=\"clientForm.email.$invalid\" translate=\"\">Invalid email</small></b></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Phone</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"customer.phone_number\" name=\"phone_number\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Description</translate></label><div class=\"col-sm-9\"><textarea class=\"form-control\" ng-model=\"customer.description\">\n                                            {{ customer.description }}</textarea></div></div></fieldset><div class=\"form-group\" ng-if=\"customer.producing_organization\" ng-show=\"customer.duplicate_bool\"><label class=\"col-sm-3 control-label\"><translate>Active Assessee ID</translate><label ng-if=\"customer.duplicate_bool\" class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"customer.duplicate_of.id\" ng-disabled=\"customer.has_duplicates\" name=\"duplicate_of\" ng-required=\"customer.duplicate_bool\"></div></div></div></form></uib-tab><uib-tab ng-if=\"customer.producing_organization\" heading=\"{{ \'Organization\' | translate }}\"><ng-include src=\"\'organization/partials/producingOrganizationTabView.html\'\"></ng-include></uib-tab><uib-tab ng-if=\"customer.producing_organization\" heading=\"{{ \'Users\' | translate }}\"><ng-include src=\"\'organization/partials/contactsTabView.html\'\"></ng-include></uib-tab></uib-tabset></main></div></si-page>");
$templateCache.put("home/modals/addSelfAssessmentView.html","<div class=\"add-assessment-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Add Rapid Check</translate></h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Tool</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"tool\" chosen=\"\" data-placeholder-text-single=\"\'Select a Tool\' | translate\" ng-options=\"tool.url as (tool.title | capitalize) for tool in tools track by tool.url\" ng-model=\"assessment.tool\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Report Language</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"language\" chosen=\"\" data-placeholder-text-single=\"\'Select a Language\' | translate\" ng-options=\"language.id as (language.name | translate) for language in languages\" ng-model=\"assessment.language.id\" required=\"\" disabled=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>(Planned) Assessment Date</translate><span class=\"text-danger\">*</span> <small class=\"text-danger\" ng-show=\"isPast(assessment.date)\" translate=\"\">Date is in past</small></label><div class=\"col-sm-7\"><si-datepicker name=\"date\" ng-model=\"assessment.date\" is-required=\"true\"></si-datepicker></div></div><hr><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Project</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"project\" chosen=\"\" data-placeholder-text-single=\"\'Select Project\' | translate\" ng-options=\"project as (project.name | capitalize) for project in projects\" ng-model=\"assessment.project\" required=\"\"><option value=\"\"></option></select></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"assessmentForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessment)\" value=\"{{ \'Create Rapid Check\' | translate }}\" ng-disabled=\"assessmentForm.$invalid || !hasProjectSelected(assessment) || isPast(assessment.date)\"></div></div>");
$templateCache.put("organization/partials/contactsTabView.html","<div><div><div class=\"well\" ng-if=\"customer.users.length === 0\"><translate>This customer has no users yet.</translate></div></div><table class=\"table table-hover dataTable\" ng-if=\"customer.users.length > 0\"><thead><tr><th sort-column=\"\" sort-name=\"last_name\" translate=\"\">Last name</th><th sort-column=\"\" sort-name=\"first_name\" translate=\"\">First name</th><th sort-column=\"\" sort-name=\"country\" translate=\"\">Country</th><th sort-column=\"\" sort-name=\"email\" translate=\"\">Email</th><th sort-column=\"\" sort-name=\"license_validity\" translate=\"\">Licnese validity</th><th sort-column=\"\" sort-name=\"is_active\" translate=\"\">Active</th><th sort-column=\"\" sort-name=\"roles\" translate=\"\">Roles</th></tr></thead><tbody><tr ng-repeat=\"user in customer.users\" style=\"cursor: pointer\"><td>{{ user.last_name }}</td><td>{{ user.first_name }}</td><td>{{ user.country }}</td><td>{{ user.email }}</td><td>{{ user.assessor_license_validity | date: \'dd-MM-yyyy\'}}</td><td style=\"padding-left: 25px\"><i class=\"fa\" ng-class=\"{\'fa-check\': user.is_active}\"></i></td><td>{{ user.roles }}</td></tr></tbody></table><div class=\"clearfix\"></div></div>");
$templateCache.put("organization/partials/producingOrganizationTabView.html","<div class=\"profile-content\"><form name=\"producingOrganizationForm\" class=\"form form-horizontal\"><fieldset ng-disabled=\"true\"><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Legal Status</label><div class=\"col-md-9\"><select class=\"form-control\" ng-disabled=\"customer.duplicate_bool\" ng-model=\"customer.producing_organization.legal_status\" chosen=\"\" ng-options=\"status.url as (status.display_name | capitalize) for status in statuses.results\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Specification</label><div class=\"col-md-9\"><input class=\"form-control\" ng-model=\"customer.producing_organization.legal_status_specification\"></div></div><hr><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">In operation since</label><div class=\"col-md-9\"><year-dropdown default-range=\"true\" ng-model=\"customer.producing_organization.in_operation_since\" is-disabled=\"customer.duplicate_bool\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Year of incorporation</label><div class=\"col-md-9\"><year-dropdown default-range=\"true\" ng-model=\"customer.producing_organization.year_of_incorporation\" is-disabled=\"customer.duplicate_bool\"></year-dropdown></div></div><hr><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Sectors</label><div class=\"col-md-9\"><select class=\"form-control\" ng-disabled=\"customer.duplicate_bool\" data-placeholder-text-single=\"\'Select sector(s)\' | translate\" ng-model=\"customer.producing_organization.sectors\" chosen=\"\" multiple=\"\" ng-options=\"sector.url as (sector.display_name | capitalize) for sector in sectors.results\"><option></option></select></div><hr><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Registration/Business license number</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.business_license_number\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Tax identification number</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.tax_identification_number\"></div></div><hr><div class=\"form-group\"><label class=\"col-md-3 control-label\"><translate>FLO ID</translate><div class=\"text-danger\" ng-show=\"producingOrganizationForm.flo_id.$error.maxlength\" translate=\"\">Max length of ID is 30 characters</div></label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"30\" name=\"flo_id\" ng-model=\"customer.flo_id\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><translate>ISO Certificate ID</translate><div class=\"text-danger\" ng-show=\"producingOrganizationForm.iso_id.$error.maxlength\" translate=\"\">Max length of ID is 30 characters</div></label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"30\" name=\"iso_id\" ng-model=\"customer.iso_id\"></div></div><hr><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Street</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.street\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Number</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.street_number\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Zipcode</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.zipcode\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">City</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" ng-model=\"customer.producing_organization.city\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Global Region (Auto Filled)</label><div class=\"col-md-9\"><div class=\"form-control\" ng-bind=\"globalRegion\"></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" translate=\"\">Country</label><div class=\"col-md-9\"><select chosen=\"\" class=\"form-control\" ng-options=\"option.name as (option.display_name | capitalize) for option in dropdown.countryOptions\" ng-change=\"updateGlobalRegion()\" ng-model=\"customer.producing_organization.country\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-disabled=\"customer.producing_organization.country\"><label class=\"col-md-3 control-label\" translate=\"\">Region (ISO)</label><div class=\"col-md-9\"><select chosen=\"\" class=\"form-control\" ng-disabled=\"customer.duplicate_bool\" ng-options=\"option.value as (option.label | capitalize) for option in regions\" ng-model=\"customer.producing_organization.region\"><option value=\"\"></option></select></div></div></div></fieldset></form></div>");
$templateCache.put("assessments/partials/rapid/dashboardDocumentationTab.html","<p translate=\"\">Below list indicates what kind of documentation the organization has available.</p><div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document type</th><th style=\"width:10%\" translate=\"\">Availability</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-show=\"row.available !== null\" ng-repeat=\"row in assessment.document_availability_responses.objects\"><td>{{ row.question_title }}</td><td><span class=\"label label-success\" ng-show=\"row.available === true\" translate=\"\">Yes</span> <span class=\"label label-warning\" ng-show=\"row.available === false\" translate=\"\">No</span> <span class=\"label\" ng-show=\"row.available === null\" translate=\"\">N/R</span></td><td><p>{{ row.comment }}</p></td></tr></table></div>");
$templateCache.put("assessments/partials/rapid/dashboardUsersAttachmentsTab.html","<section class=\"reports-attachments\"><p translate=\"\">Below list contains all assessment attachments.</p><div class=\"tab-content\"><table class=\"table table-striped reports-attachments__table\"><thead class=\"reports-attachments__table-header\"><tr><th translate=\"\">Question</th><th translate=\"\">Filename</th><th translate=\"\">Action</th></tr></thead><tbody><tr ng-repeat=\"document in documents\"><td>{{ document.response.question_display_position }} {{ document.response.question_title }}</td><td>{{ document.document.file_name }}</td><td><a class=\"btn btn-primary\" ng-href=\"{{ document.document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td></tr></tbody></table></div></section>");
$templateCache.put("assessments/partials/rapid/dashboardUsersDocumentationTab.html","<p translate=\"\">Below list indicates what kind of documentation the organization has available.</p><div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Question</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-repeat=\"row in assessment.document_availability_responses.objects\"><td ng-bind=\"row.question_title\"></td><td><div ng-repeat=\"document in row.documents.objects track by $index\"><a class=\"btn btn-primary\" ng-href=\"{{ document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></div></td><td><p>{{ row.comment }}</p></td></tr></table></div>");
$templateCache.put("assessments/partials/rapid/financeTab.html","<p translate=\"\">Here you see some key financial information provided by the organization.</p><div class=\"tab-content\"><h3 translate=\"\">Financial Data</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Turnover</th><th translate=\"\">Cost of sales</th><th translate=\"\">Net profit</th><th translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Shareholder\'s Equity</th></tr><tr ng-repeat=\"row in assessment.basicprofitlossstatements.objects\"><td>{{ row.year }}</td><td>{{ row.turnover.amount | currency:row.turnover.currency+\" \":0 }}</td><td>{{ row.cost_of_sales.amount | currency:row.cost_of_sales.currency+\" \":0 }}</td><td>{{ row.net_profit.amount | currency:row.net_profit.currency+\" \":0 }}</td><td ng-if=\"assessment.tool.type.basic_sme\">{{ row.shareholders_equity.amount | currency:row.shareholders_equity.currency+\" \":0 }}</td></tr></table><hr><h3 translate=\"\">Bank Accounts</h3><table class=\"table table-striped\"><tr><th translate=\"\">Bank</th><th translate=\"\">Type</th><th translate=\"\">Active since</th><th translate=\"\">Current balance</th></tr><tr ng-repeat=\"row in assessment.bank_accounts.objects\"><td>{{ row.bank }}</td><td>{{ row.display_bank_type }}</td><td>{{ row.active_since }}</td><td>{{ row.current_balance.amount | currency:row.current_balance.currency+\" \":0 }}</td></tr></table><hr><h3 translate=\"\">Comments</h3><p>{{ assessment.assessor_comments_finance }}</p></div>");
$templateCache.put("assessments/partials/rapid/governanceTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><h3 translate=\"\">Executives</h3><div class=\"well text-right\" ng-if=\"assessment.executive_set.objects.length == 0\"><span class=\"pull-left\" translate=\"\">No records were found..</span></div><uib-tabset class=\"tabs-left\" ng-if=\"assessment.executive_set.objects.length !== 0\"><uib-tab ng-repeat=\"executive in assessment.executive_set.objects\" active=\"$first\"><tab-heading>{{ executive.name }} <i class=\"pull-right fa fa-chevron-right\"></i><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped\"><tr><th width=\"20%\" translate=\"\">Name</th><td ng-bind=\"executive.name\"></td></tr><tr><th translate=\"\">Function</th><td ng-bind=\"executive.function\"></td></tr><tr><th translate=\"\">Gender</th><td ng-bind=\"executive.male_female\"></td></tr><tr><th translate=\"\">Years in Function</th><td ng-bind=\"executive.years_in_function\"></td></tr><tr><th translate=\"\">Years in Organization</th><td ng-bind=\"executive.years_in_organization\"></td></tr><tr><th translate=\"\">Years in Sector</th><td ng-bind=\"executive.years_in_sector\"></td></tr><tr><th translate=\"\">Year of Birth</th><td ng-bind=\"executive.year_of_birth\"></td></tr><tr><th translate=\"\">End of Term</th><td ng-bind=\"executive.end_of_term\"></td></tr><tr><th translate=\"\">Shareholder of Organization</th><td ng-bind=\"executive.shareholder\"></td></tr><tr><th translate=\"\">Qualifications</th><td ng-bind=\"executive.qualifications\"></td></tr></table></div></div></tab-heading></uib-tab></uib-tabset><hr><h3 translate=\"\">Non-Executives</h3><div class=\"well text-right\" ng-if=\"assessment.nonexecutive_set.objects.length == 0\"><span class=\"pull-left\" translate=\"\">No records were found...</span></div><uib-tabset class=\"tabs-left\" ng-if=\"assessment.nonexecutive_set.objects.length !== 0\"><uib-tab ng-repeat=\"nonexecutive in assessment.nonexecutive_set.objects\" active=\"$first\"><tab-heading>{{ nonexecutive.name }} <i class=\"pull-right fa fa-chevron-right\"></i><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped\"><tr><th width=\"20%\" translate=\"\">Name</th><td ng-bind=\"nonexecutive.name\"></td></tr><tr><th translate=\"\">Function</th><td ng-bind=\"nonexecutive.function\"></td></tr><tr><th translate=\"\">Gender</th><td ng-bind=\"nonexecutive.male_female\"></td></tr><tr><th translate=\"\">Years in Function</th><td ng-bind=\"nonexecutive.years_in_function\"></td></tr><tr><th translate=\"\">Years in Organization</th><td ng-bind=\"nonexecutive.years_in_organization\"></td></tr><tr><th translate=\"\">Years in Sector</th><td ng-bind=\"nonexecutive.years_in_sector\"></td></tr><tr><th translate=\"\">Year of Birth</th><td ng-bind=\"nonexecutive.year_of_birth\"></td></tr><tr><th translate=\"\">End of Term</th><td ng-bind=\"nonexecutive.end_of_term\"></td></tr><tr><th translate=\"\">Shareholder of Organization</th><td ng-bind=\"nonexecutive.shareholder\"></td></tr><tr><th translate=\"\">Qualifications</th><td ng-bind=\"nonexecutive.qualifications\"></td></tr></table></div></div></tab-heading></uib-tab></uib-tabset><hr><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 translate=\"\">Governance Structure</h3><table class=\"table table-striped\"><thead><tr><th></th><th translate=\"\">Present</th><th translate=\"\">Nr of People</th><th translate=\"\">Description</th></tr></thead><tbody><tr ng-repeat=\"gov in assessment.governance_set.objects\"><th width=\"20%\">{{gov.name | translate}}</th><td><span ng-if=\"gov.present === true\"><translate>Yes</translate></span> <span ng-if=\"gov.present === false\"><translate>No</translate></span></td><td ng-bind=\"gov.number_of_people\"></td><td ng-bind=\"gov.description\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("assessments/partials/rapid/monthlyProductionTab.html","<div class=\"panel-body\"><div class=\"tab-content\"><form><h3 translate=\"\">Monthly Cash Flow Projections</h3><table class=\"table table-bordered financial flow\"><tr><th translate=\"\">Income</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr ng-repeat=\"item in assessment.monthlyincomeprojection_set.objects\"><td style=\"width: 150px;\"><span ng-bind=\"item.activity\" translate=\"\"></span> <span ng-bind=\"item.year\" translate=\"\"></span></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.january.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.february.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.march.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.april.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.may.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.june.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.july.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.august.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.september.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.october.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.november.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.december.amount\"></td></tr><tr><td translate=\"\">Total Cash In</td><td class=\"text-center\" ng-repeat=\"sub in subTotal.income track by $index\" ng-bind=\"sub\"></td></tr><tr><th style=\"min-width: 150px\" translate=\"\">Expense</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr ng-repeat=\"item in assessment.monthlyexpensesprojection_set.objects\"><td style=\"width: 150px;\"><span ng-bind=\"item.activity\" translate=\"\"></span> <span ng-bind=\"item.year\" translate=\"\"></span></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.january.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.february.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.march.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.april.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.may.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.june.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.july.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.august.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.september.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.october.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.november.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.december.amount\"></td></tr><tr><td translate=\"\">Total Cash Out</td><td class=\"text-center\" ng-repeat=\"sub in subTotal.expenses track by $index\" ng-bind=\"sub\"></td></tr><tr><th style=\"min-width: 150px\" translate=\"\">Net Cash In (Out)</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr><td translate=\"\">Net Cash</td><td class=\"text-center\" ng-repeat=\"net in subTotal.net track by $index\" ng-bind=\"net\"></td></tr></table></form></div></div>");
$templateCache.put("assessments/partials/rapid/organizationalTab.html","<form><div class=\"panel-body\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-lg-6\"><h3 translate=\"\">Basic and Contact Details</h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Name</label><div class=\"col-md-9\"><span>{{ assessment.producing_organization.customer.name }}</span></div></div><div class=\"row\" ng-if=\"!assessment.tool.type.agent\"><label class=\"col-md-3\" translate=\"\">Abbreviation</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.abbreviation\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Street</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.street\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Street no.</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.street_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Zipcode</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.zipcode\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">City</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.city\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Global Region</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.display_global_region\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Region</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.global_region\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Country</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.display_country\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">GPRS Code</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.gps_location\"></span></div></div><div class=\"row\"><label class=\"col-md-3 control-label\" ng-bind=\"assessment.tool.type.agent ? \'Phone Number\' : \'Office Phone Number\' | translate\"></label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.phone_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.email\"></span></div></div><div class=\"row\" ng-if=\"assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Gender</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.gender\"></span></div></div><div class=\"row\" ng-if=\"assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Age</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.age\"></span></div></div><div class=\"row\" ng-if=\"assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\"># of Household Members</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.household_members\"></span></div></div><div class=\"row\" ng-if=\"assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Languages spoken</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.languages_spoken\"></span></div></div><div class=\"row\" ng-if=\"!assessment.tool.type.agent\"><label class=\"col-md-3\" translate=\"\">Website</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.website\"></span></div></div><hr><div ng-if=\"assessment.tool.type.agent\"><hr><h3 translate=\"\">Additional details</h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.member_of_cooperative\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.duration_of_cooperative_membership\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.member_of_other_group\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.duration_of_other_group_membership\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.owner_of_farmland\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.name_of_buyers\"></span></div></div></div><div ng-repeat=\"contact in assessment.producing_organization.customer.contacts.objects\" ng-if=\"!assessment.tool.type.agent\"><h3><translate>Contact Person</translate><span ng-bind=\"$index + 1\"></span></h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Position</label><div class=\"col-md-9\"><span ng-bind=\"contact.position\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Phone Number</label><div class=\"col-md-9\"><span ng-bind=\"contact.user.phone_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"contact.user.email\"></span></div></div><hr ng-if=\"!$last\"></div><hr><div ng-if=\"!assessment.tool.type.agent\"><h3 translate=\"\">Incorporation</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Legal Status</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.legal_status.display_name\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Specification</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.legal_status_specification\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Year of incorporation</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.year_of_incorporation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">In operation since</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.in_operation_since\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Registration/Business license number</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.business_license_number\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Tax identification number</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.tax_identification_number\"></span></div></div><div class=\"row\" ng-if=\"assessment.tool.type.basic_sme\"><label class=\"col-md-6\" translate=\"\">For Profit?</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.for_profit ? \'Yes\' : \'No\'\"></span></div></div></div><section ng-if=\"assessment.tool.type.basic_sme\"><hr><h3 translate=\"\">Management body</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Founder</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.founder\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Entrepreneur</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.entrepreneur\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Managing Director</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.managing_director\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of Shareholders</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization.number_of_shareholders\"></span></div></div></section><hr><h3 translate=\"\">Umbrella/Representing Organization</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Cooperative</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.cooperative\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Union</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.union\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Federation</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.federation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Apex Organization</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.apex_organization\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">SACCO</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.sacco\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Other</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.other_representing_organizations\"></span></div></div><hr><div ng-if=\"!assessment.tool.type.agent\"><h3 ng-if=\"!assessment.tool.type.basic_sme\" translate=\"\">Members</h3><h3 ng-if=\"assessment.tool.type.basic_sme\" translate=\"\">Suppliers</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Female members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Female Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Male members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Male Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Active female members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Active Female Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_active_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Active male members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Active Male Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_active_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Member cooperatives</label> <label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Suppliers Cooperatives</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_member_cooperatives\"></span></div></div><div class=\"row\"><label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Member unions</label> <label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Suppliers Unions</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_member_unions\"></span></div></div></div></div><div class=\"col-lg-6\"><h3 translate=\"\">Sectors and activities</h3><h3 translate=\"\">Sectors</h3><ul><li ng-repeat=\"sector in assessment.producing_organization.sectors.objects\" ng-bind=\"sector.display_name\"></li></ul><hr><h3 translate=\"\">Activities</h3><ul><li ng-repeat=\"activity in assessment.producing_organization.activities.objects\" ng-bind=\"activity.display_name\"></li></ul><div ng-if=\"assessment.tool.type.agent\"><h3 translate=\"\">Related farmers</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of male farmers under supervision</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_farmers_under_supervision\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of female farmers under supervision</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_farmers_under_supervision\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of potential male farmers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_potential_male_farmers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of potential female farmers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_potential_female_farmers\"></span></div></div></div><div ng-if=\"!assessment.tool.type.agent\"><hr><h3 translate=\"\">Mission</h3><textarea class=\"form-control\" disabled=\"\" ng-model=\"assessment.producing_organization_details.mission\">\n                        </textarea><hr><h3 translate=\"\">Vision</h3><textarea class=\"form-control\" disabled=\"\" ng-model=\"assessment.producing_organization_details.vision\">\n                        </textarea><hr><h3 translate=\"\">Officials</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male executives</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female executives</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male non-executives</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_non_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female non-executives</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_non_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male Advisors</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_advisors\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female Advisors</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_advisors\"></span></div></div><hr><h3 translate=\"\">Employees</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of male full-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_full_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female full-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_full_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male part-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_part_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female part-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_part_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male seasonal employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_seasonal_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female seasonal employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_seasonal_employees\"></span></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><h3 translate=\"\">Sharecroppers</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of female sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active female sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_active_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active male sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_active_sharecroppers\"></span></div></div><hr><h3 ng-if=\"!assessment.tool.type.basic_sme\" translate=\"\">Services to members/outgrowers</h3><h3 ng-if=\"assessment.tool.type.basic_sme\" translate=\"\">Services to Suppliers</h3><ul><li ng-repeat=\"service in assessment.producing_organization_details.services.objects\" ng-bind=\"service.display_name\"></li></ul></div><div class=\"col-md-6\"><div ng-if=\"!assessment.tool.type.agent\"><h3 translate=\"\">Outgrowers</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of female outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active female outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_active_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active male outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_active_outgrowers\"></span></div></div><hr></div><h3 translate=\"\">Infrastructure Information</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Access roads</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_access_roads\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Distance to hub</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.distance_to_hub\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Demonstration plot</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.demonstration_plot\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Training space</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.training_space\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Warehousing</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.warehousing\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Public transportation</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_public_transportation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Power / electricity</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_power_electricity\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Internet access</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_internet_access\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Mobile network coverage</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_mobile_network_coverage\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Running water</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.display_running_water\"></span></div></div></div></div></div></div></form>");
$templateCache.put("assessments/partials/rapid/productionTab.html","<p translate=\"\">Here you find some key production related information provided by the organization.</p><div class=\"tab-content\"><h2 translate=\"\">Production Information</h2><div ng-repeat=\"product in assessment.products.objects\"><h2>{{ product.display_type | capitalize}}</h2><h3 translate=\"\">Product Information</h3><div class=\"row\"><div class=\"col-md-6\"><dl class=\"dl-vertical\"><dt translate=\"\">Product:</dt><dd>{{ product.display_name }}</dd><dt ng-hide=\"app === \'smartclient\'\" translate=\"\">Type:</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.display_type }}</dd><div ng-if=\"!assessment.tool.type.basic_sme\" ng-hide=\"app === \'smartclient\'\"><dt translate=\"\">Quality</dt><dd>{{ product.quality }}</dd></div><dt ng-hide=\"app === \'smartclient\'\" translate=\"\">Land used for product</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.land_used_for_product }}</dd><dt ng-hide=\"app === \'smartclient\'\" translate=\"\">Land unit</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.display_land_unit }}</dd><dt ng-hide=\"app === \'smartclient\'\"><translate>Production unit</translate>**</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.type.production_unit }}</dd><dt ng-hide=\"app === \'smartclient\'\" translate=\"\"># of production units</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.number_of_production_units }}</dd><dt ng-hide=\"app === \'smartclient\'\"><translate>Avg. age production unit</translate>(<translate>years</translate>)**</dt><dd ng-hide=\"app === \'smartclient\'\">{{ product.average_age_of_production_unit }}</dd></dl></div><div ng-hide=\"app === \'smartclient\'\" class=\"col-md-6\"><dl class=\"dl-vertical\"><dt><translate>Avg. production unit lifetime</translate>(<translate>years</translate>)**:</dt><dd>{{ product.average_production_unit_lifetime }}</dd><dt><translate>Dead/Diseased production units</translate>** (%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_dead_diseased_production_units }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_dead_diseased_production_units }}</dd><dt ng-if=\"assessment.tool.type.basic_sme\" translate=\"\">Operational months</dt><dd ng-if=\"assessment.tool.type.basic_sme\"><span class=\"label\" ng-repeat=\"month in product.operational_months\">{{ translateMonth(month) }}</span></dd><dt>#<translate>harvest cycles per year</translate></dt><dd>{{ product.number_of_harvest_cycles_per_year }}</dd><dt><translate>Irrigated</translate>(%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_irrigated }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_irrigated }}</dd><dt translate=\"\">Sustainable production?</dt><dd>{{ product.sustainable_production ? \'Yes\' : product.sustainable_production == false ? \'No\' : \'N/A\' | translate }}</dd><div ng-if=\"!assessment.tool.type.basic_sme\"><dt translate=\"\">Certification(s)</dt><dd ng-if=\"product.certifications.objects.length\" ng-repeat=\"certification in product.certifications.objects\" ng-bind=\"certification.name\"></dd><dd ng-if=\"!product.certifications.objects.length\" translate=\"\">None</dd></div><dt translate=\"\">Estimated % of member/outgrower production sold to P.O.</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization }}</dd></dl></div></div><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Produce purchased from members</h3><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Produce Purchased From Suppliers</h3><table ng-hide=\"app === \'smartclient\'\" class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.productionpurchases.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}%</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Produce purchased from others</h3><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Produce Purchased From Suppliers</h3><table ng-hide=\"app === \'smartclient\'\" class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.otherproductionpurchases.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}%</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr ng-hide=\"app === \'smartclient\'\"><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Production figures</h3><h3 ng-hide=\"app === \'smartclient\'\" translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Production/Processing Figures</h3><table ng-hide=\"app === \'smartclient\'\" class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">% loss</th></tr><tr ng-repeat=\"row in product.productionfigures.objects\"><td>{{ row.year }}</td><td>{{ row.unit | capitalize}}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}</td><td>{{ row.percent_loss }}</td></tr></table><hr ng-hide=\"app === \'smartclient\'\"><h3 translate=\"\" ng-if=\"!assessment.tool.type.basic_sme\">Production sales</h3><h3 translate=\"\" ng-if=\"assessment.tool.type.basic_sme\">Produce Sold</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.productionsales.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr ng-hide=\"app === \'smartclient\'\"><div ng-hide=\"app === \'smartclient\'\" ng-if=\"assessment.tool.type.basic_sme\"><h3 translate=\"\">Margins</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Currency</th><th translate=\"\">Margin</th></tr><tr ng-repeat=\"row in product.productionmargins.objects\"><td>{{ row.year }}</td><td>{{ row.margin.currency }}</td><td>{{ row.margin.amount }}</td></tr></table><hr></div><hr></div></div>");
$templateCache.put("assessments/partials/rapid/rapidQuestionnaireSectionView.html","<table class=\"table\" ng-if=\"section.section_title.length > 0\" ng-style=\"{\'margin-bottom\': 0}\"><tr><th style=\"width: 4%;\" ng-bind=\"section.section_display_position\"></th><th style=\"width: 50%\" ng-style=\"{\'font-size\': depth}\" ng-bind=\"section.section_title\"></th><th style=\"width: 46%\"><span class=\"pull-right\" ng-if=\"section.score\"><i class=\"fa fa-star\"></i> {{ section.score | number:1 }}</span></th></tr></table><ng-include src=\"\'assessments/partials/rapid/rapidQuestionnaireSectionView.html\'\" ng-init=\"depth = tmpDepth - 2\" ng-repeat=\"section in section.children.objects\"></ng-include><table class=\"table table-striped\" ng-if=\"section.responses.objects.length > 0\"><thead><tr><th style=\"width: 4%\"></th><th style=\"width: 50%\" translate=\"\">Topic</th><th style=\"width: 5%\" translate=\"\">Score</th><th style=\"width: 41%\" translate=\"\">Comments</th></tr></thead><tbody><tr ng-repeat=\"response in section.responses.objects\" ng-if=\"responseApplicable(response, assessment)\"><td>{{ response.question_display_position }}</td><td>{{ response.question_title }} <a class=\"btn btn-xs btn-default pull-right\" ng-click=\"response.show_info = !response.show_info\"><i class=\"fa fa-info\"></i></a><div ng-show=\"response.show_info\"><hr><p style=\"white-space: pre-wrap\">{{ response.question_explanation }}</p><hr></div><div ng-if=\"response.subresponses.objects.length > 0\" ng-repeat=\"subresponse in response.subresponses.objects\"><div><br><h5 style=\"font-style: italic;\">{{ subresponse.subquestion.title }}</h5><p><translate>Score</translate>:<span class=\"label label-primary\" ng-bind=\"subresponse.score | number: 0\"></span></p><p>{{ subresponse.subquestion.description }}</p><div ng-if=\"subresponse.subquestion.type === \'checkbox\'\"><div class=\"checkbox\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><span class=\"fa\" ng-class=\"subresponse.checked_options.objects.indexOf(option.url) > -1 ? \'fa-check-square\' : \'fa-square-o\'\"></span> {{option.title}}</div><div ng-if=\"subresponse.not_relevant\"><div class=\"checkbox\"><span class=\"fa fa-check-square\" translate=\"\">N/R</span></div></div></div><div ng-if=\"subresponse.subquestion.type === \'mpc\'\"><div class=\"checkbox\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><span class=\"fa\" ng-class=\"subresponse.selected_option === option.url ? \'fa-check-circle\' : \'fa-circle-o\'\"></span> {{option.title}}</div><div ng-if=\"!subresponse.selected_option\"><div class=\"checkbox\"><span class=\"fa fa-check-circle\" translate=\"\">N/R</span></div></div></div><div ng-if=\"subresponse.subquestion.type === \'numeric\'\"><p ng-if=\"!subresponse.not_relevant\"><span class=\"badge badge-info\">{{ subresponse.value | number }}</span></p><p ng-if=\"subresponse.not_relevant\"><span class=\"badge badge-info\" translate=\"\">N/R</span></p></div></div></div></td><td><div><span class=\"label label-primary\" ng-show=\"response.score\">{{ response.score | number:1 }}</span> <span class=\"label\" ng-show=\"!response.score\" translate=\"\">N/A</span> <span class=\"label\" ng-show=\"response.score === 0\" translate=\"\">N/R</span></div></td><td>{{ response.comment }}<div ng-show=\"response.documents.objects.length > 0\"><h5 translate=\"\">Evidence</h5><ul class=\"list-unstyled\" ng-repeat=\"document in response.documents.objects track by document.url\"><li class=\"\"><a ng-href=\"{{ document.file }}\"><i class=\"fa fa-paperclip\"></i> {{ document.file_name }}</a></li></ul></div></td></tr></tbody></table>");
$templateCache.put("assessments/partials/rapid/rapidQuestionnaireTabView.html","<p translate=\"\">Below you see all the details of this chapter: scores, comments and requirements per question of the assessment, based on information and survey responses provided by the organization.</p><div class=\"ibox\"><ng-include src=\"\'assessments/partials/rapid/rapidQuestionnaireSectionView.html\'\"></ng-include></div>");
$templateCache.put("assessments/partials/rapid/summaryRapidFinalTabView.html","<div class=\"row\"><div class=\"col-sm-8\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ assessment.producing_organization.customer.name }}</h5></div><div class=\"ibox-content no-padding\"><div class=\"row\"><div class=\"col-sm-4\"><table class=\"table\"><tr><th translate=\"\">Location</th></tr><tr><td><p>{{ assessment.producing_organization.street }} {{ assessment.producing_organization.street_number }}<br>{{ assessment.producing_organization.zipcode }}<br>{{ assessment.producing_organization.city }}<br>{{ assessment.producing_organization.display_country }}</p></td></tr><tr><th translate=\"\">Activities</th></tr><tr><td><div ng-repeat=\"activity in assessment.producing_organization.activities.objects\"><span class=\"fa fa-check\"></span> {{ activity.display_name }}</div></td></tr></table></div><div class=\"col-sm-8\"><table class=\"table table-hover\"><tr><th translate=\"\">Legal Status</th><td><p>{{ assessment.producing_organization.legal_status.display_name }}</p></td></tr><tr><th>#<translate>of Members</translate></th><td><p>{{ assessment.producing_organization_details.number_of_members }}</p></td></tr><tr><th translate=\"\">Products</th><td><p ng-repeat=\"p in assessment.products.objects\">{{ p.display_name | capitalize}}</p></td></tr><tr><th translate=\"\">Assessors</th><td><p ng-repeat=\"a in assessment.assessmentassignments.objects\">{{ a.assessor.user | username }}</p></td></tr><tr><th translate=\"\">Assessment Date</th><td><p>{{ assessment.date | date:\'dd-MM-yyyy\' }}</p></td></tr><tr><th translate=\"\">Finalization Date</th><td><p ng-if=\"assessment.status === \'has_final\'\">{{ assessment.reports.objects[0].finalized_at | date:\'dd-MM-yyyy\' }}</p><p ng-if=\"assessment.status !== \'has_final\'\">-</p></td></tr><tr><th translate=\"\">Assessment ID</th><td><p>{{ assessment.id }}</p></td></tr><tr><th translate=\"\">SCOPE ID</th><td><p>{{ assessment.producing_organization.scope_id }}</p></td></tr></table></div></div></div></div></div><div class=\"col-sm-4\"><div class=\"widget lazur-bg m-t-none\"><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-shield fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span translate=\"\">Assignment Version</span><h2 class=\"font-bold\">{{ assessment.tool.type.name | capitalize }} {{ assessment.tool_version_major }}.{{ assessment.tool_version_minor }}.{{ assessment.tool_version_revision }}</h2></div></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">General comments by assessor</h5></div><div class=\"ibox-content\"><p ng-repeat=\"comment in assessment.tool_responses\">{{ comment.answer }}</p></div></div><div class=\"ibox\" ng-show=\"asssessment.tool.type.basic\"><div class=\"ibox-content\"><img src=\"/assets/img/ifc_logo.jpg\" style=\"max-width: 100%\"></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\"><div class=\"ibox-title\"><translate>PO Representatives</translate></div><div class=\"ibox-content\"><p class=\"prewrap\">{{ assessment.present_representatives }}</p></div></div><div class=\"ibox\"><div class=\"ibox-title\"><translate>Level Summary</translate></div><div class=\"ibox-content\"><table class=\"table table-striped\"><thead><tr><th style=\"width: 85%\" translate=\"\">Level</th><th style=\"width: 15%\" class=\"text-right\" translate=\"\">{{ assessment.rapid_level }}</th></tr></thead></table></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\"><div class=\"ibox-title\"><translate>PO Contacts</translate></div><div class=\"ibox-content\"><table class=\"table table-striped\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Contactdetails</th></tr></thead><tbody><tr ng-repeat=\"contact in assessment.producing_organization.customer.contacts.objects\"><td>{{ contact.user | username }}</td><td><span ng-if=\"contact.user.email.endsWith(\'@scopeinsight.com\') == true\">-</span> <span ng-if=\"contact.user.email.endsWith(\'@scopeinsight.com\') == false\">{{ contact.user.email }}</span><br>{{ contact.user.phone_number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("assessments/partials/rapid/termsTab.html","<div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document Name</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-show=\"assessment.terms_and_conditions.objects[0]\"><td>{{ assessment.terms_and_conditions.objects[0].original_file_name || assessment.terms_and_conditions.objects[0].file_name }}</td><td><a class=\"btn btn-primary\" ng-href=\"{{ assessment.terms_and_conditions.objects[0].file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td><td><p translate=\"\">The assessor has explained the Terms and Conditions to the assessee and uploaded the signed document.</p></td></tr></table></div>");
$templateCache.put("assessments/partials/rapid/valueChainTab.html","<p translate=\"\">This page provides information about the organization\'s value chain partners, as provided by the organization.</p><div class=\"tab-content\"><h2 translate=\"\">Value Chain</h2><h3 translate=\"\">Customers, Clients, Offtakers, and Agents</h3><table class=\"table table-striped\"><tr><th translate=\"\">Name</th><th translate=\"\">Relation to PO</th><th translate=\"\">Description of relation</th><th>#<translate>years in relation</translate></th><th ng-if=\"assessment.tool.type.basic_sme\">&percnt;<translate>sold to customer</translate></th></tr><tr ng-repeat=\"player in assessment.valuechainplayers.objects\"><td>{{ player.customer === \'OTHER\' ? player.other : player.customer }}</td><td>{{ player.display_relation_to_producing_organization }}</td><td>{{ player.description_of_relation }}</td><td>{{ player.number_of_years_in_relation }}</td><td ng-if=\"assessment.tool.type.basic_sme\">{{ player.percent_sold_to_customer }}</td></tr></table><hr><h3 translate=\"\">Promotor, NGO, Capacity Builder, BDS provider</h3><table class=\"table table-striped\"><tr><th translate=\"\">Name</th><th translate=\"\">Relation to PO</th><th translate=\"\">Description of relation</th><th>#<translate>years in relation</translate></th></tr><tr ng-repeat=\"player in assessment.enablingplayers.objects\"><td>{{ player.customer === \'OTHER\' ? player.other : player.customer }}</td><td>{{ player.display_relation_to_producing_organization }}</td><td>{{ player.description_of_relation }}</td><td>{{ player.number_of_years_in_relation }}</td></tr></table></div>");
$templateCache.put("authentication/register/createNewAssesseeModal/createNewAssesseeModal.html","<div class=\"add-assessor-modal\"><div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Add Organization Details</h3></div><div class=\"modal-body\"><form name=\"assesseeForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Organization Name</translate><label class=\"text-danger\" ng-show=\"assesseeForm.name.$error.required\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"assessee.name\" required=\"\"></div><strong><span ng-if=\"error\" class=\"text-danger\" ng-bind=\"error\"></span></strong></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Phone Number</translate><label class=\"text-danger\" ng-show=\"assesseeForm.phoneNumber.$error.required\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"phoneNumber\" class=\"form-control\" ng-model=\"assessee.phone_number\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Legal Status</translate><label class=\"text-danger\" ng-show=\"assesseeForm.legalStatus.$error.required\">*</label></label><div class=\"col-sm-8\"><select class=\"form-control\" name=\"legalStatus\" ng-model=\"assessee.legal_status\" chosen=\"\" ng-options=\"status.url as (status.display_name | capitalize) for status in statuses\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>In Operation Since</translate><label class=\"text-danger\" ng-show=\"assesseeForm.inOperationSince.$error.required\">*</label></label><div class=\"col-sm-8\"><year-dropdown name=\"inOperationSince\" id=\"inOperationSince\" default-range=\"true\" ng-model=\"assessee.in_operation_since\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year of Incorporation</translate><label class=\"text-danger\" ng-show=\"assesseeForm.yearOfIncorporation.$error.required\">*</label></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"assessee.year_of_incorporation\" required=\"\" name=\"yearOfIncorporation\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Sectors</translate><label class=\"text-danger\" ng-show=\"assesseeForm.sectors.$error.required\">*</label></label><div class=\"col-sm-8\"><select class=\"form-control\" data-placeholder-text-single=\"\'Select sector(s)\' | translate\" ng-model=\"assessee.sectors\" chosen=\"\" multiple=\"\" ng-options=\"sector.url as (sector.display_name | capitalize) for sector in sectors\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Street</translate><label class=\"text-danger\" ng-show=\"assesseeForm.street.$error.required\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"street\" class=\"form-control\" ng-model=\"assessee.street\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>City</translate><label class=\"text-danger\" ng-show=\"assesseeForm.city.$error.required\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"assessee.city\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Country</translate><label class=\"text-danger\" ng-show=\"assesseeForm.country.$error.required\">*</label></label><div class=\"col-sm-8\"><select chosen=\"\" name=\"country\" class=\"form-control\" ng-options=\"option as (option.name | capitalize ) for option in dropdown.countryOptions\" ng-change=\"updateGlobalRegion()\" ng-model=\"assessee.country\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Region (ISO)</translate><label class=\"text-danger\" ng-show=\"assesseeForm.region.$error.required\">*</label></label><div class=\"col-sm-8\"><select chosen=\"\" name=\"region\" class=\"form-control\" ng-options=\"option.value as (option.value | capitalize) for option in regions\" ng-model=\"assessee.region\"><option value=\"\"></option></select></div></div></form></div><div class=\"modal-footer\"><div ng-show=\"assesseeForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></div><span><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessee)\" ng-disabled=\"assesseeForm.$invalid\"><span ng-bind=\"\'Save & Next\' | translate\"></span></button></span></div></div>");
$templateCache.put("comments/partials/assessment-comment/commentCreateView.html","");
$templateCache.put("comments/partials/assessment-comment/commentDetailView.html","");
$templateCache.put("comments/partials/assessment-comment/commentsListView.html","");
$templateCache.put("comments/partials/assessment-comment-document/commentCreateView.html","");
$templateCache.put("comments/partials/assessment-comment-document/commentDetailView.html","");
$templateCache.put("comments/partials/assessment-comment-document/commentsListView.html","");
$templateCache.put("comments/partials/response-comment/commentCreateView.html","");
$templateCache.put("comments/partials/response-comment/commentDetailView.html","");
$templateCache.put("comments/partials/response-comment/commentsListView.html","");
$templateCache.put("comments/partials/response-comment-document/commentCreateView.html","");
$templateCache.put("comments/partials/response-comment-document/commentDetailView.html","");
$templateCache.put("comments/partials/response-comment-document/commentsListView.html","");
$templateCache.put("comments/partials/response-comment-document/commentsView.html","");
$templateCache.put("comments/partials/unscored-section-comment/commentCreateView.html","");
$templateCache.put("comments/partials/unscored-section-comment/commentDetailView.html","");
$templateCache.put("comments/partials/unscored-section-comment/commentsListView.html","");
$templateCache.put("comments/partials/unscored-tool-comment/commentCreateView.html","");
$templateCache.put("comments/partials/unscored-tool-comment/commentDetailView.html","");
$templateCache.put("comments/partials/unscored-tool-comment/commentsListView.html","");
$templateCache.put("components/form-elements/form-checkbox/formCheckboxTemplate.html","<div ng-form=\"\" name=\"$ctrl[$ctrl.formName]\" class=\"form-elements\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><h3 class=\"form-elements__header\" ng-class=\"{\'form-elements__header--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.heading\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"{{$ctrl.infoTextKey}}\"><span><span ng-bind=\"$ctrl.heading | translate\"></span> <span class=\"asterisk text-danger\" ng-if=\"$ctrl.required\">*</span></span></si-info-text-display></h3><div style=\"padding-left: 20px\"><div class=\"custom-parent-wrapper\"><label class=\"checkbox\" ng-form=\"\" name=\"{{$ctrl.parseName(checkbox.name)}}\" ng-repeat=\"checkbox in $ctrl.checkboxes\"><input type=\"checkbox\" name=\"checkbox\" ng-required=\"$ctrl.required\" value=\"{{ checkbox.url }}\" ng-click=\"$ctrl.onChange(checkbox.url)\" ng-checked=\"$ctrl.isChecked(checkbox.url)\"> <span ng-bind=\"checkbox.display_name\"></span></label> <label class=\"checkbox\" ng-if=\"$ctrl.hasOther\" ng-form=\"\" name=\"other\"><input type=\"checkbox\" name=\"checkbox\" value=\"other\" ng-change=\"$ctrl.handleOtherCheckbox($ctrl.showTextArea)\" ng-model=\"$ctrl.showTextArea\"> <span ng-bind=\"$ctrl.hasOther.display_name\"></span></label> <textarea ng-if=\"$ctrl.showTextArea\" class=\"form-control\" name=\"other\" ng-model=\"$ctrl.hasOtherChecked\" ng-change=\"$ctrl.onChangeTextArea($ctrl.hasOtherChecked)\" required=\"\">\n            </textarea></div></div></div>");
$templateCache.put("components/form-elements/form-gps/formGpsTemplate.html","<div ng-form=\"\" name=\"$ctrl[$ctrl.formName]\" class=\"form-elements {{$ctrl.wrapper}} gps\"><label class=\"col-sm-{{$ctrl.labelWidth}} control-label\" ng-if=\"$ctrl.label\"><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span> <i class=\"fa fa-question-circle-o\" tooltip=\"{{\'Click for help.\'|translate}}\" tooltip-placement=\"right\" ng-click=\"$ctrl.openGPSModal()\"></i></label><div ng-form=\"\" name=\"{{$ctrl.formName}}\" class=\"form-group col-sm-{{12-$ctrl.labelWidth}}\"><div class=\"row\"><div class=\"col-sm-4\"><input id=\"latitude\" type=\"text\" name=\"input\" class=\"form-control\" ng-model=\"$ctrl.latitude\" ng-blur=\"$ctrl.updateLatitude($ctrl.latitude)\" ng-required=\"$ctrl.required\" ng-pattern=\"/^-?\\d+(\\.\\d+)?$/\"> <span translate=\"\">Latitude</span></div><div class=\"col-sm-4\"><input id=\"longitude\" type=\"text\" name=\"input\" class=\"form-control\" ng-model=\"$ctrl.longitude\" ng-blur=\"$ctrl.updateLongitude($ctrl.longitude)\" ng-required=\"$ctrl.required\" ng-pattern=\"/^-?\\d+(\\.\\d+)?$/\"> <span translate=\"\">Longitude</span></div><div class=\"col-sm-4\"><button id=\"showMoreGPS\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.openGPSModal()\" translate=\"\" ng-disabled=\"$ctrl.isOffline\">Check on map</button></div></div></div></div>");
$templateCache.put("components/form-elements/form-gps/gps-azure-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">GPS</h3><br><p translate=\"\">Please use Google maps or another tool to find the location of the Assessee, and copy and paste the location here. The location should be in the DD (decimal degrees) format, which looks like this: \"Latitude: 8.460555, Longitude: -11.779889.\"</p></div><div class=\"modal-body\"><p translate=\"\">If you already have the GPS locations in the DMS (degrees, minutes, seconds) format, please use the tool below to convert and save the location.</p><h3><label for=\"dms\"><translate>DMS (degrees, minutes, seconds)</translate></label> <input type=\"radio\" id=\"dms\" value=\"dms\" ng-model=\"inputType\" ng-model-options=\"{debounce: 0}\"></h3><form name=\"forms.DMS\" class=\"form form-horizontal\" ng-if=\"inputType === \'dms\'\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Latitude</translate></label><div class=\"col-sm-9 gps__modal__input\"><input name=\"n-lat\" type=\"radio\" ng-model=\"dms.lat.direction\" value=\"N\" required=\"\"> <label for=\"n-lat\">N</label> <input name=\"s-lat\" type=\"radio\" ng-model=\"dms.lat.direction\" value=\"S\" required=\"\"> <label for=\"s-lat\">S</label> <span class=\"dms\"><input type=\"number\" placeholder=\"D\" name=\"lat_d\" ng-model=\"dms.lat.d\" min=\"0\" max=\"90\" required=\"\">&#176; <input type=\"number\" placeholder=\"Min\" ng-model=\"dms.lat.m\" min=\"0\" required=\"\">\' <input type=\"number\" placeholder=\"Sec\" ng-model=\"dms.lat.s\" min=\"0\" required=\"\">\"</span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Longitutde</translate></label><div class=\"col-sm-9 gps__modal__input\"><input name=\"w-long\" type=\"radio\" ng-model=\"dms.long.direction\" value=\"W\" required=\"\"> <label for=\"w-long\">W</label> <input name=\"e-long\" type=\"radio\" ng-model=\"dms.long.direction\" value=\"E\" required=\"\"> <label for=\"e-long\">E</label> <span class=\"dms\"><input type=\"number\" placeholder=\"D\" name=\"long_d\" ng-model=\"dms.long.d\" min=\"0\" max=\"180\" required=\"\">&#176; <input type=\"number\" placeholder=\"Min\" ng-model=\"dms.long.m\" min=\"0\" required=\"\">\' <input type=\"number\" placeholder=\"Sec\" ng-model=\"dms.long.s\" min=\"0\" required=\"\">\"</span></div></div><ng-messages for=\"forms.DMS.lat_d.$error\" ng-if=\"!forms.DMS.lat_d.$untouched && forms.DMS.lat_d.$invalid\"><ng-message when=\"max\"><translate>Latitude degrees must be less than or equal to 90</translate>&#176;.</ng-message><ng-message when=\"min\"><translate>Latitude degrees must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.lat_m.$error\" ng-if=\"!forms.DMS.lat_m.$untouched && forms.DMS.lat_m.$invalid\"><ng-message when=\"min\"><translate>Latitude minutes must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.lat_s.$error\" ng-if=\"!forms.DMS.lat_s.$untouched && forms.DMS.lat_s.$invalid\"><ng-message when=\"min\"><translate>Latitude seconds must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_s.$error\" ng-if=\"!forms.DMS.long_s.$untouched && forms.DMS.long_s.$invalid\"><ng-message when=\"min\"><translate>Latitude seconds must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_m.$error\" ng-if=\"!forms.DMS.long_m.$untouched && forms.DMS.long_m.$invalid\"><ng-message when=\"min\"><translate>Latitude minutes must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_d.$error\" ng-if=\"!forms.DMS.long_d.$untouched && forms.DMS.long_d.$invalid\"><ng-message when=\"max\"><translate>Longitude degrees must be less than or equal to 180</translate>&#176;.</ng-message><ng-message when=\"min\"><translate>Latitude degrees must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages></form><hr><p translate=\"\">If you have the GPS locations in the DD (decimal degrees) format, please use the tool below to save the location, should be a minumum of 4 decimals and maximum of 6 decimal places.</p><h3><label for=\"dd\"><translate>DD (decimal degrees)</translate></label> <input type=\"radio\" id=\"dd\" value=\"dd\" ng-model=\"inputType\" ng-model-options=\"{debounce: 0}\"></h3><form name=\"forms.DD\" class=\"form form-horizontal\" ng-if=\"inputType === \'dd\'\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Latitude</translate></label><div class=\"col-sm-9 gps__modal__input\"><input type=\"text\" id=\"latitude\" name=\"latitude\" placeholder=\"latitude\" ng-pattern=\"/^(\\+|-)?(?:90(?:(?:\\.0{4,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{4,6})?))$/\" ng-model-options=\"{debounce: 500}\" ng-change=\"updateMap()\" required=\"\" ng-model=\"dd.lat\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Longitutde</translate></label><div class=\"col-sm-9 gps__modal__input\"><input type=\"text\" id=\"longitude\" name=\"longitude\" ng-pattern=\"/^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$/\" placeholder=\"longitude\" ng-model-options=\"{debounce: 500}\" ng-change=\"updateMap()\" required=\"\" ng-model=\"dd.long\"></div></div><ng-messages for=\"forms.DD.latitude.$error\" ng-if=\"!forms.DD.latitude.$untouched && forms.DD.latitude.$invalid\"><ng-message when=\"ngPattern\"><translate>Latitude must be a value of 0 - (+/-)90</translate>&#176;,<translate>and decimal places 4-6 in length.</translate></ng-message></ng-messages><ng-messages for=\"forms.DD.longitude.$error\" ng-if=\"!forms.DD.longitude.$untouched && forms.DD.longitude.$invalid\"><ng-message when=\"ngPattern\"><translate>Longitude must be a value of 0 - (+/-)180</translate>&#176;,<translate>and decimal places 4-6 in length.</translate></ng-message></ng-messages></form><div id=\"coordinates\">Coordinates will be checked on map.</div><div id=\"map\"></div></div><div class=\"modal-footer\" ng-if=\"inputType === \'dd\'\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveDD()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"forms.DD.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div><div class=\"modal-footer\" ng-if=\"inputType === \'dms\'\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveDMS()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"forms.DMS.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("components/form-elements/form-gps/gps-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">GPS</h3><br><p translate=\"\">Please use Google maps or another tool to find the location of the Assessee, and copy and paste the location here. The location should be in the DD (decimal degrees) format, which looks like this: \"Latitude: 8.460555, Longitude: -11.779889.\"</p></div><div class=\"modal-body\"><p translate=\"\">If you already have the GPS locations in the DMS (degrees, minutes, seconds) format, please use the tool below to convert and save the location.</p><h3><label for=\"dms\"><translate>DMS (degrees, minutes, seconds)</translate></label> <input type=\"radio\" id=\"dms\" value=\"dms\" ng-model=\"inputType\" ng-model-options=\"{debounce: 0}\"></h3><form name=\"forms.DMS\" class=\"form form-horizontal\" ng-if=\"inputType === \'dms\'\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Latitude</translate></label><div class=\"col-sm-9 gps__modal__input\"><input name=\"n-lat\" type=\"radio\" ng-model=\"dms.lat.direction\" value=\"N\" required=\"\"> <label for=\"n-lat\">N</label> <input name=\"s-lat\" type=\"radio\" ng-model=\"dms.lat.direction\" value=\"S\" required=\"\"> <label for=\"s-lat\">S</label> <span class=\"dms\"><input type=\"number\" placeholder=\"D\" name=\"lat_d\" ng-model=\"dms.lat.d\" min=\"0\" max=\"90\" required=\"\">&#176; <input type=\"number\" placeholder=\"Min\" ng-model=\"dms.lat.m\" min=\"0\" required=\"\">\' <input type=\"number\" placeholder=\"Sec\" ng-model=\"dms.lat.s\" min=\"0\" required=\"\">\"</span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Longitutde</translate></label><div class=\"col-sm-9 gps__modal__input\"><input name=\"w-long\" type=\"radio\" ng-model=\"dms.long.direction\" value=\"W\" required=\"\"> <label for=\"w-long\">W</label> <input name=\"e-long\" type=\"radio\" ng-model=\"dms.long.direction\" value=\"E\" required=\"\"> <label for=\"e-long\">E</label> <span class=\"dms\"><input type=\"number\" placeholder=\"D\" name=\"long_d\" ng-model=\"dms.long.d\" min=\"0\" max=\"180\" required=\"\">&#176; <input type=\"number\" placeholder=\"Min\" ng-model=\"dms.long.m\" min=\"0\" required=\"\">\' <input type=\"number\" placeholder=\"Sec\" ng-model=\"dms.long.s\" min=\"0\" required=\"\">\"</span></div></div><ng-messages for=\"forms.DMS.lat_d.$error\" ng-if=\"!forms.DMS.lat_d.$untouched && forms.DMS.lat_d.$invalid\"><ng-message when=\"max\"><translate>Latitude degrees must be less than or equal to 90</translate>&#176;.</ng-message><ng-message when=\"min\"><translate>Latitude degrees must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.lat_m.$error\" ng-if=\"!forms.DMS.lat_m.$untouched && forms.DMS.lat_m.$invalid\"><ng-message when=\"min\"><translate>Latitude minutes must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.lat_s.$error\" ng-if=\"!forms.DMS.lat_s.$untouched && forms.DMS.lat_s.$invalid\"><ng-message when=\"min\"><translate>Latitude seconds must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_s.$error\" ng-if=\"!forms.DMS.long_s.$untouched && forms.DMS.long_s.$invalid\"><ng-message when=\"min\"><translate>Latitude seconds must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_m.$error\" ng-if=\"!forms.DMS.long_m.$untouched && forms.DMS.long_m.$invalid\"><ng-message when=\"min\"><translate>Latitude minutes must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages><ng-messages for=\"forms.DMS.long_d.$error\" ng-if=\"!forms.DMS.long_d.$untouched && forms.DMS.long_d.$invalid\"><ng-message when=\"max\"><translate>Longitude degrees must be less than or equal to 180</translate>&#176;.</ng-message><ng-message when=\"min\"><translate>Latitude degrees must be greater than or equal to 0</translate>&#176;.</ng-message></ng-messages></form><hr><p translate=\"\">If you have the GPS locations in the DD (decimal degrees) format, please use the tool below to save the location, should be a minumum of 4 decimals and maximum of 6 decimal places.</p><h3><label for=\"dd\"><translate>DD (decimal degrees)</translate></label> <input type=\"radio\" id=\"dd\" value=\"dd\" ng-model=\"inputType\" ng-model-options=\"{debounce: 0}\"></h3><form name=\"forms.DD\" class=\"form form-horizontal\" ng-if=\"inputType === \'dd\'\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Latitude</translate></label><div class=\"col-sm-9 gps__modal__input\"><input type=\"text\" id=\"latitude\" name=\"latitude\" placeholder=\"latitude\" ng-pattern=\"/^(\\+|-)?(?:90(?:(?:\\.0{4,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{4,6})?))$/\" ng-model-options=\"{debounce: 500}\" ng-change=\"updateMap()\" required=\"\" ng-model=\"dd.lat\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Longitutde</translate></label><div class=\"col-sm-9 gps__modal__input\"><input type=\"text\" id=\"longitude\" name=\"longitude\" ng-pattern=\"/^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$/\" placeholder=\"longitude\" ng-model-options=\"{debounce: 500}\" ng-change=\"updateMap()\" required=\"\" ng-model=\"dd.long\"></div></div><ng-messages for=\"forms.DD.latitude.$error\" ng-if=\"!forms.DD.latitude.$untouched && forms.DD.latitude.$invalid\"><ng-message when=\"ngPattern\"><translate>Latitude must be a value of 0 - (+/-)90</translate>&#176;,<translate>and decimal places 4-6 in length.</translate></ng-message></ng-messages><ng-messages for=\"forms.DD.longitude.$error\" ng-if=\"!forms.DD.longitude.$untouched && forms.DD.longitude.$invalid\"><ng-message when=\"ngPattern\"><translate>Longitude must be a value of 0 - (+/-)180</translate>&#176;,<translate>and decimal places 4-6 in length.</translate></ng-message></ng-messages></form><div map-lazy-load=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyD5IupOl0ngYHtOhFjyNMmq-b9rRaLiYdk&callback=initMap\"><ng-map zoom=\"11\"></ng-map></div></div><div class=\"modal-footer\" ng-if=\"inputType === \'dd\'\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveDD()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"forms.DD.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div><div class=\"modal-footer\" ng-if=\"inputType === \'dms\'\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveDMS()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"forms.DMS.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("components/form-elements/form-input/formInputTemplate.html","<div class=\"form-elements {{ $ctrl.wrapper }}\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><label class=\"col-sm-{{ $ctrl.labelWidth }} control-label\" ng-class=\"{\'control-label--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.label\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"{{ $ctrl.infoTextKey }}\"><span><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span></span></si-info-text-display></label><div ng-form=\"\" name=\"{{ $ctrl.formName }}\" class=\"form-group col-sm-{{ 12 - $ctrl.labelWidth }}\"><input ng-if=\"!$ctrl.isDate\" type=\"{{ $ctrl.type }}\" name=\"input\" class=\"form-control\" ng-disabled=\"$ctrl.disabled\" ng-model=\"$ctrl.model\" ng-min=\"$ctrl.min\" ng-max=\"$ctrl.max\" ng-minlength=\"$ctrl.minlength\" ng-change=\"$ctrl.onChange()\" ng-required=\"$ctrl.required\"> <span class=\"tooltip__numbers active\" ng-if=\"$ctrl.showTooltip\">Only whole numbers are allowed</span><si-datepicker ng-if=\"$ctrl.isDate\" ng-model=\"$ctrl.model\" is-disabled=\"$ctrl.disabled\" on-change=\"$ctrl.onChange(date)\" options=\"$ctrl.dateOptions\" is-required=\"$ctrl.required\"></si-datepicker></div></div>");
$templateCache.put("components/form-elements/form-number/formNumberTemplate.html","<div class=\"form-elements {{$ctrl.wrapper}}\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><label class=\"col-sm-{{$ctrl.labelWidth}} control-label\" ng-class=\"{\'control-label--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.label\"><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span></label><div ng-form=\"\" name=\"{{$ctrl.formName}}\" class=\"form-group col-sm-{{12-$ctrl.labelWidth}} number-presentation\"><input type=\"text\" autocomplete=\"off\" name=\"input\" class=\"form-control\" ng-model=\"$ctrl.model\" ng-model-options=\"{updateOn: \'blur\'}\" ng-focus=\"$ctrl.focus()\" ng-blur=\"$ctrl.blur()\" ng-keydown=\"$ctrl.keydown($event)\" ng-disabled=\"$ctrl.isDisabled\" ng-required=\"$ctrl.required\"> <span class=\"tooltip__numbers\" ng-class=\"{active: $ctrl.isActive}\"><translate>Only whole numbers are allowed</translate></span> <span ng-if=\"$ctrl.max\" class=\"tooltip__max\" ng-class=\"{active: $ctrl.isOverMax}\"><translate>Expected <</translate>&nbsp;{{ $ctrl.max }}</span> <span ng-if=\"$ctrl.min\" class=\"tooltip__max\" ng-class=\"{active: $ctrl.isUnderMin}\"><translate>Expected >=</translate>&nbsp;{{ $ctrl.min }}</span></div></div>");
$templateCache.put("components/form-elements/form-select/formSelectTemplate.html","<div class=\"form-elements selector {{$ctrl.wrapper}}\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><label class=\"col-sm-{{$ctrl.labelWidth}} control-label\" ng-class=\"{\'control-label--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.label\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"{{$ctrl.infoTextKey}}\"><span><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span></span></si-info-text-display></label><fieldset><div ng-form=\"\" name=\"{{$ctrl.formName}}\" class=\"form-group col-sm-{{12-$ctrl.labelWidth}}\"><select chosen=\"\" name=\"select\" class=\"form-control\" data-placeholder-text-single=\"$ctrl.placeholder | translate\" ng-options=\"option[$ctrl.optionValue] as (option.display_name | capitalize) for option in $ctrl.options\" ng-model=\"$ctrl.model\" ng-change=\"$ctrl.onChange()\" ng-required=\"$ctrl.required\" ng-disabled=\"$ctrl.disabled\"><option></option></select></div></fieldset><span style=\"cursor: pointer; border-radius: 25px; background-color: rgb(228, 102, 102); color:white; padding: 1px 5px; margin-left: 2px;\" ng-if=\"$ctrl.model && $ctrl.displayClearButton\" ng-click=\"$ctrl.resetFct()\" ng-class=\"{\'disabled-span\': $ctrl.disabled}\">X</span></div>");
$templateCache.put("components/form-elements/form-textarea/formTextareaTemplate.html","<div class=\"form-elements {{$ctrl.wrapper}}\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><label class=\"col-sm-{{$ctrl.labelWidth}} control-label\" ng-class=\"{\'control-label--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.label\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"{{$ctrl.infoTextKey}}\"><span><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span></span></si-info-text-display></label><div ng-form=\"\" name=\"{{$ctrl.formName}}\" class=\"form-group col-sm-{{12-$ctrl.labelWidth}}\"><textarea name=\"input\" class=\"form-control\" ng-model=\"$ctrl.model\" ng-model-options=\"{debounce: 1500}\" ng-change=\"$ctrl.onChange()\" ng-minlength=\"$ctrl.minlength\" ng-required=\"$ctrl.required\" spellcheck=\"true\">\n        </textarea></div></div>");
$templateCache.put("components/form-elements/yes-no-bool/yesNoBoolTemplate.html","<div class=\"form-elements {{$ctrl.wrapper}}\" ng-form=\"\" name=\"{{$ctrl.formName}}\" ng-class=\"{\'form-elements--error\': $ctrl.shouldShowError}\"><label class=\"col-sm-{{$ctrl.labelWidth}} control-label\" ng-class=\"{\'control-label--large\': $ctrl.labelSize === \'large\'}\" ng-if=\"$ctrl.label\"><span ng-bind=\"$ctrl.label | translate\"></span> <span class=\"text-danger\" ng-if=\"$ctrl.required\">*</span></label><div class=\"col-sm-{{12-$ctrl.labelWidth}}\"><div class=\"custom-parent-wrapper\"><label><input type=\"radio\" name=\"{{$ctrl.formName}}\" ng-model=\"$ctrl.model\" ng-value=\"$ctrl.yesValue || true\" ng-required=\"$ctrl.required\" ng-change=\"$ctrl.onChange()\"><translate>Yes</translate></label> <label><input type=\"radio\" name=\"{{$ctrl.formName}}\" ng-model=\"$ctrl.model\" ng-value=\"$ctrl.noValue || false\" ng-required=\"$ctrl.required\" ng-change=\"$ctrl.onChange()\"><translate>No</translate></label> <label ng-if=\"$ctrl.canHaveNull\"><input type=\"radio\" name=\"{{$ctrl.formName}}\" ng-model=\"$ctrl.model\" ng-value=\"null\" ng-required=\"$ctrl.required\" ng-change=\"$ctrl.onChange()\"><translate>N/A</translate></label> <label ng-if=\"$ctrl.canHaveBlank\"><input type=\"radio\" name=\"{{$ctrl.formName}}\" ng-model=\"$ctrl.model\" ng-value=\"$ctrl.emptyString\" ng-required=\"$ctrl.required\" ng-change=\"$ctrl.onChange()\"><translate>N/R</translate></label></div></div></div>");
$templateCache.put("components/search-filters/date-range/date-range-filter.component.html","<div class=\"input-group input-daterange input-daterange--verticle\"><si-datepicker placeholder=\"{{ \'From\' | translate }}\" ng-model=\"$ctrl.minDate\" min=\"$ctrl.min\"></si-datepicker><si-datepicker placeholder=\"{{ \'To\' | translate }}\" ng-model=\"$ctrl.maxDate\" options=\"$ctrl.options\"></si-datepicker><button class=\"btn btn-success\" type=\"button\" ng-if=\"$ctrl.maxDate && $ctrl.minDate\" ng-click=\"$ctrl.doSearch({max: $ctrl.maxDate, min: $ctrl.minDate})\">{{ \'Confirm\' | translate }}</button> <button class=\"btn btn-warning\" ng-if=\"!$ctrl.maxDate || !$ctrl.minDate\" type=\"button\" ng-click=\"$ctrl.closeSearch()\">{{ \'Close\' | translate }}</button></div>");
$templateCache.put("components/search-filters/dropdown/dropdown-filter.component.html","<div class=\"dropdown-filter\"><select chosen=\"\" name=\"select\" class=\"form-control\" data-placeholder-text-single=\"$ctrl.placeholder | translate\" ng-options=\"filter.value as (filter.label | capitalize) for filter in $ctrl.filters\" ng-model=\"$ctrl.filter\"><option></option></select><button class=\"btn btn-success\" ng-if=\"$ctrl.filter\" type=\"button\" ng-click=\"$ctrl.doSearch($ctrl.filter)\">{{ \'Confirm\' | translate }}</button> <button class=\"btn btn-warning\" ng-if=\"!$ctrl.filter\" type=\"button\" ng-click=\"$ctrl.closeSearch()\">{{ \'Close\' | translate }}</button></div>");
$templateCache.put("components/search-filters/dropdown-checkbox/dropdown-checkbox.html","<div class=\"dropdown-checkbox-filter\"><label class=\"dropdown-checkbox-filter__search\" ng-if=\"$ctrl.filters.length > 8\"><input class=\"form-control\" ng-model=\"$ctrl.searchText\"><i class=\"fa fa-search\"></i></label><ul><li ng-repeat=\"filter in $ctrl.filters | filter:$ctrl.searchText\" class=\"dropdown-checkbox-filter__item\"><label><input type=\"checkbox\" ng-model=\"$ctrl.filter[filter.value]\"> <span ng-bind=\"filter.label\"></span></label></li></ul><button class=\"btn btn-success\" ng-if=\"$ctrl.filter\" type=\"button\" ng-click=\"$ctrl.doSearch($ctrl.filter)\">{{ \'Confirm\' | translate }}</button> <button ng-if=\"!$ctrl.filter\" class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.closeSearch()\">{{ \'Close\' | translate }}</button></div>");
$templateCache.put("components/search-filters/filter-choices/filter-choices.html","<ul class=\"filter-choices\" ng-show=\"$ctrl.filterOptions\"><li class=\"filter-choices__item\" ng-repeat=\"filter in $ctrl.filters\"><span ng-bind=\"filter.name | translate\"></span> <span ng-bind=\"$ctrl.getLabel(filter) | translate\"></span> <i ng-click=\"$ctrl.removeFilter({filter: filter})\" class=\"fa fa-close\"></i></li></ul>");
$templateCache.put("components/search-filters/radio-button/radio-button-filter.html","<div class=\"dropdown-filter\"><label ng-repeat=\"filter in $ctrl.filters\"><input type=\"radio\" ng-model=\"$ctrl.filter\" name=\"filter.label\" ng-value=\"filter.value\"> <span ng-bind=\"filter.label\"></span></label> <button class=\"btn btn-success\" ng-if=\"$ctrl.isFilterSet()\" type=\"button\" ng-click=\"$ctrl.doSearch($ctrl.filter)\">{{ \'Confirm\' | translate }}</button> <button class=\"btn btn-warning\" ng-if=\"!$ctrl.isFilterSet()\" type=\"button\" ng-click=\"$ctrl.closeSearch()\">{{ \'Close\' | translate }}</button></div>");
$templateCache.put("components/search-filters/search-filters/search-filters.html","<article><h3><i class=\"fa fa-filter\"></i>&nbsp;<translate>Filters</translate></h3><ng-transclude></ng-transclude></article>");
$templateCache.put("components/search-filters/search-wrapper/search-wrapper.html","<article class=\"search-wrapper\" ng-class=\"{\'search-wrapper--open\': $ctrl.isOpen}\"><header class=\"search-wrapper__header\" ng-click=\"$ctrl.toggle($ctrl.isOpen)\"><span><b ng-bind=\"$ctrl.name\"></b>&nbsp;<span ng-if=\"$ctrl.required\" class=\"text-danger\">*</span></span> <i class=\"fa fa-lg\" ng-class=\"{\'fa-angle-down\': !$ctrl.isOpen, \'fa-angle-up\': $ctrl.isOpen}\"></i></header><main class=\"search-wrapper__main\"><ng-transclude></ng-transclude></main></article>");
$templateCache.put("components/search-filters/slider/slider-filter.component.html","<div class=\"slider-filter\"><rzslider rz-slider-model=\"$ctrl.minValue\" rz-slider-high=\"$ctrl.maxValue\" rz-slider-options=\"$ctrl.options\"></rzslider><div class=\"slider-filter__values\"><input type=\"text\" ng-model=\"$ctrl.minValue\"> - <input type=\"text\" ng-model=\"$ctrl.maxValue\"></div><button class=\"btn btn-success\" type=\"button\" ng-if=\"$ctrl.minValue || $ctrl.maxValue\" ng-click=\"$ctrl.doSearch({maxValue: $ctrl.maxValue, minValue: $ctrl.minValue})\">{{ \'Confirm\' | translate }}</button> <button class=\"btn btn-warning\" ng-if=\"!$ctrl.minValue && !$ctrl.maxValue\" type=\"button\" ng-click=\"$ctrl.closeSearch()\">{{ \'Close\' | translate }}</button></div>");
$templateCache.put("modals/templates/confirm-modal/confirmModalView.html","<div class=\"confirm-modal\"><div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Your confirmation is needed</h3></div><div class=\"modal-body\"><span>{{message | translate}}</span> <span ng-bind=\"details\"></span><div ng-if=\"highlight\" class=\"well well-sm text-center\" ng-bind=\"highlight\"></div></div><div class=\"modal-footer\" ng-include=\"\'modals/templates/partials/modalActionButtonView.html\'\"></div></div>");
$templateCache.put("modals/templates/offline/offline-modal.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Your confirmation is needed</h3></div><div class=\"modal-body\"><p translate=\"\">Application is offline, changing of languages is disabled.</p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("modals/templates/partials/modalActionButtonView.html","<button ng-repeat=\"action in actions\" class=\"btn\" ng-class=\"{\'btn-primary\': !action.isDefault, \'btn-default\': action.isDefault}\" ng-disabled=\"!action.isDefault && form.$invalid\" ng-click=\"applyAction(action.fn)\">{{ action.label | capitalize | translate}}</button>");
$templateCache.put("modals/templates/request-modal/requestModalView.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Offline Requests Processing</h3></div><div class=\"modal-body\"><uib-progressbar value=\"value\" max=\"max\"></uib-progressbar></div>");
$templateCache.put("modals/templates/see-as-user/see-as-user.html","<div class=\"modal-header\"><h3 class=\"modal-title\" style=\"display: inline-block;\"><span ng-if=\"!isSmartClient\"><translate>See dashboard as user</translate></span> <span ng-if=\"isSmartClient\"><translate>See app as assessor</translate></span></h3></div><div class=\"modal-body\"><div class=\"form-group row\"><label class=\"col-sm-5 control-label\"><translate>Client</translate></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"client\" chosen=\"\" data-placeholder-text-single=\"\'Select a Client\' | translate\" ng-options=\"client as client.name for client in clients\" ng-model=\"selectedClient\" ng-change=\"updateUserList(selectedClient)\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group row\"><label class=\"col-sm-5 control-label\"><translate>User</translate></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"client\" chosen=\"\" data-placeholder-text-single=\"\'Select a User\' | translate\" ng-options=\"user as (user.first_name + \' \' + user.last_name) for user in users\" ng-model=\"selectedUser\" ng-disabled=\"!selectedClient\" required=\"\"><option value=\"\"></option></select></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"switchUser(selectedUser)\" ng-disabled=\"!selectedUser\">Switch</button></div>");
$templateCache.put("modals/templates/sync-errors/sync-errors.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Synchronisation Error</h3></div><div class=\"modal-body\"><p translate=\"\">The syncing of the data that was entered off-line has resulted in some errors. This means that some of the data fields could not be synced correctly.</p><p translate=\"\">Below you will find the details of the error. Please copy the error text and send this to support@scopeinsight.com who can advise you on further action.</p><p translate=\"\">When you click \'Save\' the incorrectly entered data that could not be synced will remain. When you click \'Remove\' the data will be removed and will need to be entered again.</p><p class=\"text-center\">------ (<translate>Copy and send everything below this line to</translate><a href=\"mailto:support@scopeinsight.com\">support@scopeinsight.com</a>) ------</p><curl ng-repeat=\"fail in failed\" exception=\"fail\"></curl></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"save()\">Save</button> <button class=\"btn btn-primary\" ng-click=\"remove()\">Remove</button></div>");
$templateCache.put("modals/templates/text-messages-modal/textMessagesModal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ content.title | capitalize }}</h3></div><div class=\"modal-body\"><p ng-class=\"message.type\" ng-repeat=\"message in content.messages\">{{ message.content }}</p></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"dismiss()\"><translate>Dismiss</translate></button></div>");
$templateCache.put("modals/templates/notify-modal/notifyModalView.html","<div class=\"modal-header\"><i class=\"text-success fa fa-2x fa-check-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Synchronization Complete</h3></div><div class=\"modal-body\"><p>The synchronization of the data you entered offline is complete.</p><p>The application will now reload so you can continue working online.</p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("projects/templates/dashboard/projectCreateDashboard.html","<div class=\"col-lg-10\" ng-if=\"$ctrl.isPageLoaded\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">New Project</h5><div class=\"ibox-tools\"><span class=\"label label-danger\" translate=\"\">Draft</span></div></div><div class=\"ibox-content\"><form name=\"$ctrl.projectForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Project name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.project.name\" name=\"name\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"!$ctrl.isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Deal number</translate></label><div class=\"col-sm-9\"><input type=\"number\" name=\"deal\" class=\"form-control\" ng-model=\"$ctrl.project.deal_number\"></div></div><div class=\"form-group\" ng-if=\"!$ctrl.isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Project owner</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" name=\"projectOwner\" ng-model=\"$ctrl.project.customer\" ng-options=\"customer as customer.name for customer in $ctrl.customers.results\" style=\"width: 100%\" ng-change=\"$ctrl.updateContacts()\" required=\"\"><option></option></select></div></div><div class=\"form-group\" ng-if=\"!$ctrl.isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Project Partner</translate></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" data-placeholder-text-single=\"\'Select Project Partner\' | translate\" style=\"width: 100%\" ng-model=\"$ctrl.project.partner\" ng-options=\"customer.url as customer.name for customer in $ctrl.customers.results\"></select></div></div><div class=\"form-group\" ng-if=\"!$ctrl.isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Project Donor</translate></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" data-placeholder-text-single=\"\'Select Project Donor\' | translate\" style=\"width: 100%\" ng-model=\"$ctrl.project.donor\" ng-options=\"customer.url as customer.name for customer in $ctrl.customers.results\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Project lead</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" name=\"projectLead\" data-placeholder-text-single=\"\'Select Project Lead\' | translate\" ng-model=\"$ctrl.project.contact\" ng-options=\"contact.url as contact.username for contact in $ctrl.contacts\" style=\"width: 100%\" ng-disabled=\"!$ctrl.project.customer\" ng-change=\"$ctrl.updateQualityReviewers()\" required=\"\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Project members</label><div class=\"col-sm-9\"><select data-testid=\"project_members\" chosen=\"\" multiple=\"\" data-placeholder-text-single=\"\'Select members\' | translate\" ng-options=\"contact as contact.username for contact in $ctrl.contacts\" ng-model=\"$ctrl.project.customer_members\" ng-disabled=\"!$ctrl.project.customer\" ng-change=\"$ctrl.updateQualityReviewers()\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>(Planned) start date</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><si-datepicker ng-model=\"$ctrl.project.start_date\" is-required=\"true\" on-change=\"$ctrl.setDate(date, \'deadline\')\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>(Planned) end date</translate></label><div class=\"col-sm-9\"><si-datepicker ng-model=\"$ctrl.project.deadline\" on-change=\"$ctrl.setDate(date, \'deadline\')\"></si-datepicker></div></div><div class=\"form-group\" ng-if=\"$ctrl.isEmployee\"><label class=\"col-sm-3 control-label\"><translate>Client performs QC</translate></label><div class=\"col-sm-9\"><div class=\"input-group\"><input type=\"checkbox\" name=\"clientQC\" ng-model=\"$ctrl.project.customer_performs_qc\" ng-disabled=\"!$ctrl.project.customer || !$ctrl.project.contact\" ng-change=\"$ctrl.updateQRList($ctrl.project.customer_performs_qc)\" ng-checked=\"$ctrl.project.customer_performs_qc\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Quality Reviewer</label><div class=\"col-sm-9\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers.results track by reviewer.url\" ng-model=\"$ctrl.project.quality_reviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Financial Quality Reviewer</label><div class=\"col-sm-9\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Financial Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers.results track by reviewer.url\" ng-model=\"$ctrl.project.financial_quality_reviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Project Objectives</label><div style=\"display: flex; flex-wrap: wrap;\"><span ng-repeat=\"objective in $ctrl.projectObjectives track by $index\" style=\"white-space: nowrap; margin-left: 5px;\"><input type=\"checkbox\" ng-change=\"$ctrl.updateProjectObjectives(objective)\" ng-model=\"objective.isSelected\"> {{ objective.name }}</span> <span style=\"white-space: nowrap; margin-left: 5px;\"><input type=\"checkbox\" ng-model=\"$ctrl.otherChecked\"> Other</span></div></div><div class=\"form-group\" ng-show=\"$ctrl.otherChecked\"><label class=\"col-sm-3 control-label\" translate=\"\">Other Project Objectives</label><div class=\"col-sm-9\"><input class=\"form-control\" style=\"margin-right: 20px;\" type=\"text\" ng-model=\"$ctrl.project.objective_other\"></div></div></form><div class=\"form-group\"><div class=\"col-sm-9 col-sm-offset-2\"><span ng-show=\"$ctrl.projectForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" value=\"{{ \'Save\' | translate }}\" ng-click=\"$ctrl.saveNewProject()\" ng-disabled=\"$ctrl.projectForm.$invalid\"> <a class=\"btn btn-default\" ui-sref=\"base.projects\" translate=\"\">Cancel</a></div></div></div></div></div></div></div></div>");
$templateCache.put("projects/templates/dashboard/projectDetailDashboard.html","<si-page class=\"project-detail-dashboard\" ng-if=\"isLoaded\" search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\">Project Detail</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li class=\"active\"><strong>{{ project.name | capitalize }}</strong></li></ol></header><main class=\"project-detail-dashboard__header\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row project-detail-dashboard__header__actions\"><h2>{{ project.name | capitalize }}</h2><div><div style=\"margin-bottom: 10px\"><a ng-if=\"project.can_edit\" ng-hide=\"assessments.results.length\" ng-click=\"deleteProject()\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i><translate>Delete project</translate></a><a ng-if=\"project.can_edit\" ui-sref=\"base.projects-edit({id: project.id})\" class=\"btn btn-info btn-xs\"><i class=\"fa fa-edit\"></i><translate>Edit Project</translate></a><button ng-hide=\"usedTools.length === 1 && usedTools[0] === \'SCOPE Rapid\'\" class=\"btn btn-info btn-xs\" ng-click=\"exportToExcel()\"><i class=\"fa fa-sign-out\"></i><translate>Export to Excel</translate></button><button class=\"btn btn-info btn-xs\" ng-click=\"exportProjectOverview()\"><i class=\"fa fa-\"></i><translate>Export Project Overview</translate></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"base.projects-analytics({id: project.id})\"><i class=\"fa fa-\"></i><translate>Project Analytics</translate></button></div><div style=\"margin-bottom: 10px\"><button class=\"btn btn-info btn-xs\" ng-click=\"downloadReports()\"><i class=\"fa fa-download\"></i><translate>Download Selected Reports</translate></button><button ng-if=\"me.is_employee\" class=\"btn btn-info btn-xs\" ng-click=\"export_to_json()\"><i class=\"fa fa-download\"></i><translate>Export to Json</translate></button><button class=\"btn btn-info btn-xs\" ng-click=\"download_all_reports()\"><i class=\"fa fa-download\"></i><tranlate>Download all reports</tranlate></button></div></div></div><div class=\"row\"><div class=\"col-xs-7\"><dl class=\"dl-horizontal dl-horizontal--left\"><dt><translate>Project Owner</translate>:</dt><dd><span>{{ project.customer.name | capitalize }}</span></dd><dt><translate>Project Partner</translate>:</dt><dd><div class=\"col-sm-8\"><span>{{ project.partner.name | capitalize }}</span></div></dd><dt><translate>Project Donor</translate>:</dt><dd><div class=\"col-sm-8\"><span>{{ project.donor.name | capitalize }}</span></div></dd><dt><translate>Deal Number</translate>:</dt><dd><span>{{ project.deal_number }}</span></dd><dt><translate>Project Lead</translate>:</dt><dd><span>{{ project.contact.user | username }}</span></dd><dt><translate>Project Members</translate>:</dt><dd ng-if=\"project.customer_members.objects.length\"><span ng-repeat=\"member in project.customer_members.objects\">{{ member.user | username }} <span ng-if=\"!$last\">,&nbsp;</span></span></dd><dd ng-if=\"!project.customer_members.objects.length\"></dd><dt translate=\"\">(Planned) Start Date:</dt><dd>{{ project.start_date | date:\'dd-MM-yyyy\' }}</dd><dt translate=\"\">(Planned) End Date:</dt><dd>{{ project.deadline | date:\'dd-MM-yyyy\' }}</dd><dt translate=\"\">Quality Reviewer:</dt><dd><span>{{ project.quality_reviewer | username}}</span></dd><dt translate=\"\">Financial Quality Reviewer:</dt><dd><span>{{ project.financial_quality_reviewer | username}}</span></dd></dl></div><div class=\"col-xs-5\"><div class=\"project-detail-dashboard__share\"><header class=\"project-detail-dashboard__share-header\"><h4><translate>This project is shared with</translate>:</h4><button class=\"btn btn-primary\" ng-click=\"shareProject()\" ng-if=\"project.can_share\" translate=\"\">Share</button></header><main class=\"project-detail-dashboard__share-body\"><header><h4>Organization</h4><h4 ng-if=\"project.can_share\">Actions</h4></header><ul><li ng-repeat=\"customer in project.shared_with.objects | limitTo: sharedWithLimit\"><span ng-bind=\"customer.name\"></span> <span ng-if=\"project.can_share\">&nbsp; <a class=\"btn btn-danger btn-xs\" ng-click=\"unshareProject(customer.id)\"><translate>Unshare</translate></a></span></li><li ng-if=\"sharedWithLimit < project.shared_with.objects.length\"><a ng-click=\"increaseSharedWithLimit()\"><translate>More...</translate></a></li></ul><div ng-if=\"project.shared_with.objects.length === 0\"><translate>This project is not shared.</translate></div></main></div><div class=\"row\" ng-if=\"false\"><div class=\"col-xs-6\"><div class=\"font-bold\"><translate>This project is outsourced with</translate>:</div><div><ul><li ng-repeat=\"share in outsourcedProject\"></li></ul><div>This project is not outsourced.</div></div></div><div class=\"col-xs-6\"><button class=\"btn btn-primary\">Outsource</button></div></div></div><div class=\"col-xs-7\" ng-if=\"me.is_employee\"><input type=\"checkbox\" id=\"portal\" name=\"checkbox\" ng-change=\"addInWhitelist()\" ng-model=\"project.is_project_in_whitelist\" ng-checked=\"project.is_project_in_whitelist\"> <label translate=\"\" class=\"font-bold\" style=\"margin-left: 5px\">Whitelist for Self-Assessment</label></div><div class=\"col-xs-5\" ng-if=\"me.is_employee\"><input type=\"checkbox\" id=\"portal\" name=\"checkbox\" ng-change=\"setAiAvailability()\" ng-model=\"project.available_for_ta\" ng-checked=\"project.available_for_ta\"> <label translate=\"\" class=\"font-bold\" style=\"margin-left: 5px\">Available for TA</label></div><div class=\"col-xs-7\" ng-if=\"me.is_employee\"><input type=\"checkbox\" id=\"portal\" name=\"checkbox\" ng-change=\"toggleIsAgriGrade()\" ng-model=\"project.is_agri_grade\" ng-checked=\"project.is_agri_grade\"> <label translate=\"\" class=\"font-bold\" style=\"margin-left: 5px\">AgriGRADE Project</label></div></div><hr><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><div class=\"panel white-bg no-borders\"><div class=\"panel-heading no-padding\"><ng-include src=\"\'projects/templates/assessmentTabView.html\'\"></ng-include></div></div></div></div></div></div></main></div><search ng-show=\"shouldShowSearch(assessments.results.length)\"><search-filters><search-filter ng-if=\"assessments.filters.assessors.length >= 1\" name=\"{{\'Assessor\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"assessor_name\" filters=\"assessments.filters.assessors\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.financial_specialists.length >= 1\" name=\"{{\'Financial Specialist\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"financial_specialist\" filters=\"assessments.filters.financial_specialists\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.quality_reviewers.length > 1\" name=\"{{\'Quality Reviewer\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"quality_reviewer\" filters=\"assessments.filters.quality_reviewers\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.financial_quality_reviewers.length > 1\" name=\"{{\'Financial Quality Reviewer\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"financial_quality_reviewer\" filters=\"assessments.filters.financial_quality_reviewers\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.results.length > 1\" name=\"{{\'Assessment Date Range\' | translate}}\"><date-range-filter display-name=\"Assessment Date Range\" max=\"assessments.filters.date.max\" min=\"assessments.filters.date.min\" max-name=\"max_date\" min-name=\"min_date\" search=\"search(filter, filterDisplay)\"></date-range-filter></search-filter><search-filter ng-if=\"assessments.filters.tool_types.length > 1\" name=\"{{\'Tools\' | translate}}\"><dropdown-checkbox-filter options-key=\"tool_type\" filters=\"assessments.filters.tool_types\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.statuses.length > 1\" name=\"{{\'Status\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"status\" filters=\"assessments.filters.statuses\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.languages.length > 1\" name=\"{{\'Language\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"language\" filters=\"assessments.filters.languages\"></dropdown-checkbox-filter></search-filter><search-filter-choices remove-filter=\"removeFilter(filter)\" filter-options=\"assessments.filters\" filters=\"filters\"></search-filter-choices></search-filters></search></si-page>");
$templateCache.put("projects/templates/modals/addAssesseeDetailModal(1b).html","<div class=\"add-assessor-modal\"><div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Add Assessee Details</h3></div><div class=\"modal-body\"><form name=\"assesseeForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate><label class=\"text-danger\" ng-show=\"assesseeForm.name.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"assessee.name\" required=\"\"></div><strong><span ng-if=\"error\" class=\"text-danger\" ng-bind=\"error\"></span></strong></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>City</translate><label class=\"text-danger\" ng-show=\"assesseeForm.city.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"city\" class=\"form-control\" ng-model=\"assessee.city\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Country</translate><label class=\"text-danger\" ng-show=\"assesseeForm.country.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"country\" disabled=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Phone Number</translate><label class=\"text-danger\" ng-show=\"assesseeForm.phoneNumber.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"phoneNumber\" class=\"form-control\" ng-model=\"assessee.phone_number\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Email</translate></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"assessee.email\"></div></div></div></form></div><div class=\"modal-footer\"><div ng-show=\"assesseeForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></div><span><button class=\"btn btn-danger\" ng-click=\"cancel(true)\"><translate>Cancel Adding Assessment</translate></button> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessee)\" ng-disabled=\"assesseeForm.$invalid\"><span ng-bind=\"\'Save & Next\' | translate\"></span></button></span></div></div>");
$templateCache.put("projects/templates/modals/addAssessmentView(1).html","<div class=\"add-assessment-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Add Assessment - Step 1</translate>&nbsp;- {{ project.name | capitalize }}</h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Tool</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"tool\" chosen=\"\" data-placeholder-text-single=\"\'Select a Tool\' | translate\" ng-options=\"tool.url as (tool.title | capitalize) for tool in tools track by tool.url\" ng-model=\"assessment.tool\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Report Language</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"language\" chosen=\"\" data-placeholder-text-single=\"\'Select a Language\' | translate\" ng-options=\"language.id as (language.name | translate) for language in languages\" ng-model=\"assessment.language\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>(Planned) Assessment Date</translate><span class=\"text-danger\">*</span> <small class=\"text-danger\" ng-show=\"isPast(assessment.date)\" translate=\"\">Date is in past</small></label><div class=\"col-sm-7\"><si-datepicker name=\"date\" ng-model=\"assessment.date\" is-required=\"true\"></si-datepicker></div></div><hr><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Country</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"country\" chosen=\"\" data-placeholder-text-single=\"\'Select a Country\' | translate\" ng-options=\"country.name as (country.display_name | capitalize) for country in countries\" ng-model=\"assessee.country\" ng-change=\"doSearch({name:assessee.name, country:assessee.country})\" ng-disabled=\"isUserAdded\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Assessee</translate></label><div class=\"col-sm-7 add-assessment-modal__typeahead\"><input type=\"text\" ng-model=\"assessee.name\" uib-typeahead=\"assessors for assessors in getAssessors($viewValue)\" typeahead-loading=\"loadingAssessors\" typeahead-no-results=\"noResults\" class=\"form-control\"> <i ng-show=\"loadingAssessors\" class=\"fa fa-circle-o-notch fa-spin\"></i><div ng-show=\"noResults\"><i class=\"glyphicon glyphicon-remove\"></i> No Results Found</div></div></div><div class=\"add-assessment-modal__search-button\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"doSearch({name:assessee.name, country:assessee.country})\" ng-disabled=\"!assessee.country || isUserAdded\" translate=\"\">Search</button></div><article ng-if=\"showSearchResults\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">City</th><th translate=\"\">Country</th><th translate=\"\">Phone</th><th translate=\"\">Email</th><th translate=\"\">Last Assessment Tool Version</th><th translate=\"\">Last Assessment</th><th></th></tr></thead><tbody><tr ng-if=\"pos.length === 0\"><td colspan=\"6\" class=\"not-found\" translate=\"\">Sorry, no matches were found. If you are certain about the assessee\'s details, please click on +Add to proceed.</td></tr><tr class=\"add-assessment-modal__search-results\" ng-repeat=\"po in pos | filter: { is_duplicate: \'False\' }\"><td ng-bind=\"po.name\"></td><td ng-bind=\"po.city\"></td><td ng-bind=\"po.display_country\"></td><td ng-bind=\"po.customer.phone_number\"></td><td ng-bind=\"po.customer.email\"></td><td ng-bind=\"po.last_assessment_type\"></td><td ng-class=\"{\'text-warning\': po.last_assessment_status !== \'has_final\'}\">{{ po.last_assessment | date:\'dd-MM-yyyy\' }}</td><td><button class=\"btn\" ng-class=\"{ \'btn-primary\': !isPOSelected(po), \'btn-success\': isPOSelected(po)}\" type=\"button\" ng-disabled=\"isUserAdded\" ng-click=\"toggleSelectPO(po)\"><translate>Select</translate><i ng-if=\"isPOSelected(po)\" class=\"fa fa-check\"></i></button></td></tr></tbody></table><div><p><b>Before adding the assessee name to the SCOPE database, kindly perform a search to ensure it is not already listed.<b></b></b></p><p><b>If the Assessee\'s name is not found in the search results, proceed with adding it to the system by writing the name and clicking add.<b></b></b></p></div><table class=\"table add-assessment-modal__add-user\"><tbody><tr><td ng-bind=\"assessee.name\"></td><td ng-bind=\"assessee.city\"></td><td ng-bind=\"assessee.display_country || assessee.country\"></td><td ng-bind=\"assessee.customer.phone_number\"></td><td ng-bind=\"assessee.customer.email\"></td><td>{{ assessee.last_assessment | date:\'dd-MM-yyyy\' }}</td><td><button class=\"btn\" ng-class=\"{ \'btn-default\': !isUserAdded, \'btn-success\': isUserAdded}\" type=\"button\" ng-disabled=\"isUserAdded\" ng-click=\"addUser(assessee)\"><i ng-if=\"!isUserAdded\" class=\"fa fa-plus\"></i><translate>Add</translate><i ng-if=\"isUserAdded\" class=\"fa fa-check\"></i></button></td></tr></tbody></table></article></form></div><div class=\"modal-footer\"><span ng-show=\"assessmentForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessment)\" value=\"{{ \'Save & Next\' | translate }}\" ng-disabled=\"assessmentForm.$invalid || !hasPOSelected(assessment) || isPast(assessment.date)\"></div></div>");
$templateCache.put("projects/templates/modals/addAssessorView(2).html","<div class=\"add-assessor-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Add Assessment - Step 2</translate>&nbsp;- {{ project.name | capitalize }}</h3></div><div class=\"modal-body\"><form name=\"assessorForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Tool</translate></label><div class=\"col-sm-7\"><input type=\"text\" name=\"assessee\" class=\"form-control\" ng-value=\"assessment.tool.title | capitalize\" disabled=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Report Language</translate></label><div class=\"col-sm-7\"><input type=\"text\" name=\"assessee\" class=\"form-control\" ng-value=\"selectedLanguage | translate\" disabled=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>(Planned) Assessment Date</translate></label><div class=\"col-sm-7\"><si-datepicker name=\"date\" ng-model=\"assessment.date\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Assessee</translate></label><div class=\"col-sm-7\"><input type=\"text\" name=\"assessee\" class=\"form-control\" ng-model=\"assessment.producing_organization.name\" disabled=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Country</translate></label><div class=\"col-sm-7\"><input type=\"text\" name=\"country\" class=\"form-control\" ng-model=\"assessment.producing_organization.country\" disabled=\"\"></div></div></form><hr><form ng-if=\"isAssessorChosen\" class=\"form form-horizontal add-assessor-modal__chosen-assessors\"><label class=\"col-sm-5 control-label\"><translate>Assessor</translate></label><ul class=\"col-sm-7\"><li ng-bind=\"previousChosenAssessor.name\"></li></ul></form><div ng-if=\"!isAssessorChosen\"><div class=\"add-assessor-modal__search-button\"><form ng-submit=\"doAssessorSearch(assessor)\" name=\"choseAssessor\"><div class=\"form-group\"><label class=\"col-sm-12 control-label\" for=\"assessor\"><translate>Assign Assessor</translate><label class=\"text-danger\" ng-show=\"!chosenAssessor\">*</label></label><div class=\"col-sm-12\"><input type=\"text\" id=\"assessor\" name=\"assessor\" class=\"form-control\" ng-model=\"assessorSearch\" required=\"\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"doAssessorSearch(assessorSearch)\" ng-disabled=\"!assessorSearch\" translate=\"\">Search</button></form></div><article class=\"search-table\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Country</th><th translate=\"\">Email</th><th translate=\"\">Expiration Date</th><th translate=\"\"></th></tr></thead><tbody><tr ng-if=\"searchingAssessors\"><td colspan=\"5\" class=\"not-found\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></td></tr><tr ng-if=\"assessorsNotFound\"><td colspan=\"5\" class=\"not-found\" translate=\"\">Sorry, no matches were found</td></tr><tr class=\"add-assessment-modal__search-results\" ng-repeat=\"assessor in assessors\"><td><span ng-bind=\"assessor.user.first_name\"></span>&nbsp;<span ng-bind=\"assessor.user.last_name\"></span></td><td ng-bind=\"assessor.user.country\"></td><td ng-bind=\"assessor.user.email\"></td><td ng-bind=\"assessor.expiration_date_assessor\"></td><td><button class=\"btn\" ng-class=\"{\'btn-primary\': !isAssessorSelected(assessor), \'btn-success\': isAssessorSelected(assessor)}\" type=\"button\" ng-click=\"selectAssessor(assessor)\"><translate>Select</translate><i ng-if=\"isAssessorSelected(assessor)\" class=\"fa fa-check\"></i></button></td></tr></tbody></table></article></div><hr><form ng-if=\"assessment.tool.type.requires_accountant && isSpecialistChosen\" class=\"form form-horizontal add-assessor-modal__chosen-assessors\"><label class=\"col-sm-5 control-label\"><translate>Financial Specialist</translate></label><ul class=\"col-sm-7\"><li ng-bind=\"previousChosenSpecialist.name\"></li></ul></form><div ng-if=\"assessment.tool.type.requires_accountant && !isSpecialistChosen\"><div class=\"add-assessor-modal__search-button\"><form ng-submit=\"doSpecialistSearch(specialist)\"><div class=\"form-group\"><label class=\"col-sm-12 control-label\" for=\"specialist\"><translate>Assign Financial Specialist</translate></label><div class=\"col-sm-12\"><input type=\"text\" id=\"specialist\" name=\"specialist\" class=\"form-control\" ng-model=\"specialistSearch\" ng-model-options=\"{default}\" required=\"\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"doSpecialistSearch(specialistSearch)\" ng-disabled=\"!specialistSearch\" translate=\"\">Search</button></form></div><article class=\"search-table\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Country</th><th translate=\"\">Email</th><th translate=\"\">Expiration Date</th><th translate=\"\"></th></tr></thead><tbody><tr ng-if=\"searchingSpecialists\"><td colspan=\"5\" class=\"not-found\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></td></tr><tr ng-if=\"specialistsNotFound\"><td colspan=\"5\" class=\"not-found\" translate=\"\">Sorry, no matches were found</td></tr><tr class=\"add-assessment-modal__search-results\" ng-repeat=\"specialist in specialists\"><td><span ng-bind=\"specialist.user.first_name\"></span>&nbsp;<span ng-bind=\"specialist.user.last_name\"></span></td><td ng-bind=\"specialist.user.country\"></td><td ng-bind=\"specialist.user.email\"></td><td ng-bind=\"specialist.expiration_date_financial_specialist\"></td><td><button class=\"btn\" ng-class=\"{\'btn-primary\': !isSpecialistSelected(specialist), \'btn-success\': isSpecialistSelected(specialist)}\" type=\"button\" ng-click=\"selectSpecialist(specialist)\"><translate>Select</translate><i ng-if=\"isSpecialistSelected(specialist)\" class=\"fa fa-check\"></i></button></td></tr></tbody></table></article></div></div><div class=\"modal-footer\"><span><span><span>Add another Assessment</span> <input type=\"checkbox\" id=\"anotherAssessment\" name=\"anotherAssessment\" ng-model=\"anotherAssessment\"></span> <span ng-show=\"assessorForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"save(assessment)\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessment)\" value=\"{{ \'Send Invitation\' | translate }}\" ng-disabled=\"isSubmitDisabled()\"></span></div></div>");
$templateCache.put("projects/templates/modals/addMemberView.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Add new member to</translate>{{ project.name | capitalize }}<translate>project</translate></h3></div><div class=\"modal-body\"><form class=\"form form-horizontal\"><h3 translate=\"\">Select Existing Employee</h3><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"employee\" translate=\"\">Employee</label><div class=\"col-sm-9\"><select placeholder=\"Select an employee\" id=\"employee\" ng-options=\"e.url as ((e.user.first_name | capitalize) + \' \' + (e.user.last_name | capitalize)) for e in employees.results\" ng-model=\"newUser.url\" chosen=\"\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"save(newUser)\"><translate>Save</translate></button> <button class=\"btn btn-default\" ng-click=\"cancel()\"><translate>Cancel</translate></button></div>");
$templateCache.put("projects/templates/modals/assignAllAssessors.html","<div class=\"add-assessor-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Add Assessment - Step 2</translate>&nbsp;- {{ project.name | capitalize }}</h3></div><div class=\"modal-body\"><form name=\"assessorForm\" class=\"form form-horizontal\"></form><div><div class=\"add-assessor-modal__search-button\"><form ng-submit=\"doAssessorSearch(assessor)\" name=\"choseAssessor\"><div class=\"form-group\"><label class=\"col-sm-12 control-label\" for=\"assessor\"><translate>Assign Assessor</translate><label class=\"text-danger\" ng-show=\"!chosenAssessor\">*</label></label><div class=\"col-sm-12\"><input type=\"text\" id=\"assessor\" name=\"assessor\" class=\"form-control\" ng-model=\"assessorSearch\" required=\"\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"doAssessorSearch(assessorSearch)\" ng-disabled=\"!assessorSearch\" translate=\"\">Search</button></form></div><article class=\"search-table\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Country</th><th translate=\"\">Email</th><th translate=\"\">Expiration Date</th><th translate=\"\"></th></tr></thead><tbody><tr ng-if=\"searchingAssessors\"><td colspan=\"5\" class=\"not-found\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></td></tr><tr ng-if=\"assessorsNotFound\"><td colspan=\"5\" class=\"not-found\" translate=\"\">Sorry, no matches were found</td></tr><tr class=\"add-assessment-modal__search-results\" ng-repeat=\"assessor in assessors\"><td><span ng-bind=\"assessor.user.first_name\"></span>&nbsp;<span ng-bind=\"assessor.user.last_name\"></span></td><td ng-bind=\"assessor.user.country\"></td><td ng-bind=\"assessor.user.email\"></td><td ng-bind=\"assessor.expiration_date_assessor\"></td><td><button class=\"btn\" ng-class=\"{\'btn-primary\': !isAssessorSelected(assessor), \'btn-success\': isAssessorSelected(assessor)}\" type=\"button\" ng-click=\"selectAssessor(assessor)\"><translate>Select</translate><i ng-if=\"isAssessorSelected(assessor)\" class=\"fa fa-check\"></i></button></td></tr></tbody></table></article></div><hr><div ng-if=\"isProAssessmentSelected\"><div class=\"add-assessor-modal__search-button\"><form ng-submit=\"doSpecialistSearch(specialist)\"><div class=\"form-group\"><label class=\"col-sm-12 control-label\" for=\"specialist\"><translate>Assign Financial Specialist</translate></label><div class=\"col-sm-12\"><input type=\"text\" id=\"specialist\" name=\"specialist\" class=\"form-control\" ng-model=\"specialistSearch\" ng-model-options=\"{default}\" required=\"\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"doSpecialistSearch(specialistSearch)\" ng-disabled=\"!specialistSearch\" translate=\"\">Search</button></form></div><article class=\"search-table\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Country</th><th translate=\"\">Email</th><th translate=\"\">Expiration Date</th><th translate=\"\"></th></tr></thead><tbody><tr ng-if=\"searchingSpecialists\"><td colspan=\"5\" class=\"not-found\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></td></tr><tr ng-if=\"specialistsNotFound\"><td colspan=\"5\" class=\"not-found\" translate=\"\">Sorry, no matches were found</td></tr><tr class=\"add-assessment-modal__search-results\" ng-repeat=\"specialist in specialists\"><td><span ng-bind=\"specialist.user.first_name\"></span>&nbsp;<span ng-bind=\"specialist.user.last_name\"></span></td><td ng-bind=\"specialist.user.country\"></td><td ng-bind=\"specialist.user.email\"></td><td ng-bind=\"specialist.expiration_date_financial_specialist\"></td><td><button class=\"btn\" ng-class=\"{\'btn-primary\': !isSpecialistSelected(specialist), \'btn-success\': isSpecialistSelected(specialist)}\" type=\"button\" ng-click=\"selectSpecialist(specialist)\"><translate>Select</translate><i ng-if=\"isSpecialistSelected(specialist)\" class=\"fa fa-check\"></i></button></td></tr></tbody></table></article></div></div><div class=\"modal-footer\"><span><span><span>Add another Assessment</span> <input type=\"checkbox\" id=\"anotherAssessment\" name=\"anotherAssessment\" ng-model=\"anotherAssessment\"></span> <span ng-show=\"assessorForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"save(assessment)\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessment)\" value=\"{{ \'Send Invitation\' | translate }}\" ng-disabled=\"isSubmitDisabled()\"></span></div></div>");
$templateCache.put("projects/templates/modals/changeQualityReviewer.html","<div class=\"add-assessment-modal\" ng-if=\"!$ctrl.loading\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Change Quality Reviewer</translate></h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-5 control-label\" translate=\"\">Quality Reviewer</label><div class=\"col-sm-7\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers.results track by reviewer.url\" ng-model=\"$ctrl.qualityReviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin && !$ctrl.project.customer_performs_qc\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\" ng-if=\"$ctrl.isProTool($ctrl.assessment)\"><label class=\"col-sm-5 control-label\" translate=\"\">Financial Quality Reviewer</label><div class=\"col-sm-7\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Financial Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers.results track by reviewer.url\" ng-model=\"$ctrl.financialQualityReviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin && !$ctrl.project.customer_performs_qc\" style=\"width: 100%\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><a class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.save($ctrl.assessment)\" value=\"{{ \'Save\' | translate }}\"></div></div>");
$templateCache.put("projects/templates/modals/createPOView.html","<div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Create New Producing Organization</h3><h3 translate=\"\" class=\"modal-title\">Or Choose Existing PO</h3></div><div class=\"modal-body\"><form name=\"poForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate><label class=\"text-danger\" ng-show=\"poForm.poName.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"poName\" class=\"form-control\" ng-model=\"assessment.producing_organization_name\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contact First Name</translate><label class=\"text-danger\" ng-show=\"poForm.contactFirstName.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"contactFirstName\" class=\"form-control\" ng-model=\"assessment.producing_organization_contact_first_name\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contact Last Name</translate><label class=\"text-danger\" ng-show=\"poForm.contactLastName.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"contactLastName\" class=\"form-control\" ng-model=\"assessment.producing_organization_contact_last_name\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contact Email</translate><label class=\"text-danger\" ng-show=\"poForm.conactEmail.$error.required\">*</label></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"email\" name=\"conactEmail\" class=\"form-control\" ng-model=\"assessment.producing_organization_contact_email\" required=\"\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contact Phone Number</translate></label><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" name=\"contactPhone\" class=\"form-control\" style=\"width: 100%\" ng-model=\"assessment.producing_organization_contact_phone_number\"></div></div></div><div class=\"form-group\" ng-class=\"{match: isMatching}\"><label class=\"col-sm-4 control-label\"><translate>Choose an Existing Producer Organizations</translate></label><div class=\"col-sm-8\"><select class=\"form-control\" name=\"producing_organization\" chosen=\"\" data-placeholder-text-single=\"\'Choose an Existing Producing Organisation\' | translate\" ng-model=\"existingPO\" ng-options=\"po as po.name for po in producing_organizations.results track by po.url\" style=\"width: 100%\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"poForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveNew()\" value=\"{{ \'Create New PO\' | translate }}\" ng-disabled=\"poForm.$invalid\"> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveExisting()\" value=\"{{ \'Use Existing PO\' | translate }}\" ng-disabled=\"!existingPO\"> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("projects/templates/modals/declineReasonView.html","<div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Reason for Decling the Project?</h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Reason for decline</translate></label><div class=\"col-sm-8\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-close\"></i></span> <input type=\"text\" name=\"text\" class=\"form-control\" ng-model=\"decline\" required=\"\"></div></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"assessmentForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(decline)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"assessmentForm.$invalid\"> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("projects/templates/modals/duplicateAssessee.html","<div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Duplicate Assessee</h3></div><div class=\"modal-body\"><form class=\"form form-horizontal\"><p translate=\"\">A similar assessee in {{country}} has already been registered and a SCOPE assessment was conducted. Please check the the search results before adding a new assessee to avoid creating a duplicate assesee profile.<br><br>Are you sure you want to add a new assessee?</p></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-default\" ng-click=\"save()\" value=\"{{ \'Add Anyway\' | translate }}\" ng-disabled=\"assessmentForm.$invalid\"> <a class=\"btn btn-primary\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("projects/templates/modals/editAssessmentView.html","<div class=\"add-assessment-modal\" ng-if=\"!$ctrl.loading\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Edit Assessment</translate>&nbsp;-&nbsp;{{ $ctrl.project.name | capitalize }}</h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>Report Language</translate><label class=\"text-danger\" ng-show=\"$ctrl.assessmentForm.language.$error.required\">*</label></label><div class=\"col-sm-7\"><select class=\"form-control\" name=\"language\" chosen=\"\" data-placeholder-text-single=\"\'Select a Language\' | translate\" ng-options=\"language.id as (language.name | translate) for language in $ctrl.languages\" ng-model=\"$ctrl.assessment.language\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\"><translate>(Planned) Assessment Date</translate><label class=\"text-danger\" ng-show=\"$ctrl.assessmentForm.date.$error.required\">*</label> <small class=\"text-danger\" ng-show=\"$ctrl.isPast($ctrl.assessment.date)\" translate=\"\">Date is in past</small> <small class=\"text-danger\" ng-show=\"!$ctrl.isValidDate($ctrl.assessment.date)\" translate=\"\">You cannot choose a date after the certificate of the assessor has expired</small></label><div class=\"col-sm-7\"><si-datepicker name=\"date\" ng-model=\"$ctrl.assessment.date\" is-required=\"true\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-5 control-label\" translate=\"\">Quality Reviewer</label><div class=\"col-sm-7\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers.results track by reviewer.url\" ng-model=\"$ctrl.qualityReviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin && !$ctrl.project.customer_performs_qc\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\" ng-if=\"$ctrl.isProTool($ctrl.assessment)\"><label class=\"col-sm-5 control-label\" translate=\"\">Financial Quality Reviewer</label><div class=\"col-sm-7\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Financial Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in $ctrl.qualityReviewers track by reviewer.url\" ng-model=\"$ctrl.financialQualityReviewer\" ng-disabled=\"$ctrl.isDashboardUserAdmin && !$ctrl.project.customer_performs_qc\" style=\"width: 100%\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"$ctrl.assessmentForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.save($ctrl.assessment)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"!$ctrl.isValidDate($ctrl.assessment.date) || $ctrl.isPast($ctrl.assessment.date)\"></div></div>");
$templateCache.put("projects/templates/modals/editDraftAssessmentView.html","<div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Edit Draft Assessment</h3></div><div class=\"modal-body\"><form name=\"assessmentForm\" class=\"form form-horizontal\"><div class=\"form-group\" ng-if=\"assessment.producing_organization\"><label class=\"col-sm-4 control-label\"><translate>Producer Organization</translate><label class=\"text-danger\" ng-show=\"assessmentForm.producing_organization.$error.required\">*</label></label><div class=\"col-sm-8\"><select class=\"form-control\" name=\"producing_organization\" chosen=\"\" data-placeholder-text-single=\"\'Select a Producing Organisation\'|translate\" ng-model=\"assessment.producing_organization\" required=\"\" ng-options=\"po as (po.name | capitalize) for po in producing_organizations.results track by po.url\" style=\"width: 100%\"><option></option></select></div></div><div ng-if=\"!assessment.producing_organization\"><a class=\"text-danger\" ng-click=\"createPO(assessment)\"><translate>New PO suggested, click to add/check!</translate></a></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Tool</translate><label class=\"text-danger\" ng-show=\"assessmentForm.tool.$error.required\">*</label></label><div class=\"col-sm-8\"><select class=\"form-control\" name=\"tool\" chosen=\"\" data-placeholder-text-single=\"\'Select a Tool\' | translate\" ng-options=\"tool as (tool.title | capitalize) for tool in tools.results track by tool.url\" ng-model=\"assessment.tool\" required=\"\" style=\"width: 100%\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"assessmentForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(assessment)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"assessmentForm.$invalid || !assessment.producing_organization\"> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("projects/templates/modals/exportToExcel.html","<article><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Export to Excel</translate></h3></div><div class=\"modal-body\"><form class=\"form form-horizontal\" name=\"exportForm\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Products</translate><label class=\"text-danger\" ng-show=\"exportForm.tool.$error.required\">*</label></label><div class=\"col-sm-8\"><select class=\"form-control\" name=\"tool\" chosen=\"\" data-placeholder-text-single=\"\'Select a Product\'|translate\" ng-model=\"chosenProduct\" required=\"\" ng-options=\"tool as (tool | capitalize) for tool in tools\" style=\"width: 100%\"><option></option></select></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\"><translate>Cancel</translate></button> <button class=\"btn btn-danger\" ng-click=\"save()\"><translate>Export</translate></button></div></article>");
$templateCache.put("projects/templates/modals/openAssessmentMessageModal.html","<div class=\"modal-header\"><h3 translate=\"\" class=\"modal-title\">Open Assessment For Assessee</h3></div><div class=\"modal-body\"><form class=\"form form-horizontal\"><p translate=\"\" ng-if=\"projects.length == 1\">We’ve noticed that the organization \'{{assessee}}\' currently has an ongoing assessment in the project \'{{projects[0]}}\'.<br>Please contact support at <span><a href=\"mailto:support@SCOPEinsight.com\">support@SCOPEinsight.com</a></span> for further assistance.</p><p translate=\"\" ng-if=\"projects.length > 1\">We’ve noticed that the organization \'{{assessee}}\' currently has an ongoing assessment in the projects <span ng-repeat=\"project in projects\">\'{{project}}\'{{$last ? \'. \' : \', \'}}</span><br>Please contact support at <span><a href=\"mailto:support@SCOPEinsight.com\">support@SCOPEinsight.com</a></span> for further assistance.</p></form></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" ng-click=\"cancel()\" translate=\"\">OK</a></div>");
$templateCache.put("projects/templates/modals/shareProject.html","<div class=\"share-project-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Share project</translate>&nbsp;-&nbsp;{{ $ctrl.project.name | capitalize }}</h3></div><div class=\"modal-body\"><p><translate>Please enter a user’s email address of the organization you want to share your project with. The project, including assessment details, data and reports, will be shared as a ‘read only’ with all users who can access the SCOPE Dashboard of the organization you are sharing your project with.</translate></p><form name=\"shareProjectForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Email address</translate><label class=\"text-danger\" ng-show=\"shareProjectForm.email.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"email\" ng-model-options=\"{debounce: 500}\" ng-change=\"$ctrl.checkEmailAvailability($ctrl.email, shareProjectForm)\" name=\"email\" class=\"form-control\" ng-model=\"$ctrl.email\" required=\"\"> <span class=\"text-danger bold\" ng-show=\"shareProjectForm.email.$dirty && !$ctrl.dashboardAccess\" translate=\"\">This user doesn\'t have access to a SCOPE Dashboard.</span></div></div></form></div><div class=\"modal-footer\"><span ng-show=\"shareProjectForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <a class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</a> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.save($ctrl.email)\" value=\"{{ \'Share\' | translate }}\" ng-disabled=\"shareProjectForm.$invalid\"></div></div>");
$templateCache.put("projects/templates/modals/unAssignAllAssessors.html","<article class=\"unassign-assessor-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Unassign Assessor</translate></h3></div><div class=\"modal-body\">Are you sure you want to unassign all assessors?</div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\"><translate>Cancel</translate></button> <button class=\"btn btn-danger\" ng-click=\"save()\" ng-disabled=\"isSubmitDisabled()\"><translate>Send Cancellation</translate></button></div></article>");
$templateCache.put("projects/templates/modals/unAssignAssessor.html","<article class=\"unassign-assessor-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\"><translate>Unassign Assessor</translate></h3></div><div class=\"modal-body\"><form class=\"form form-horizontal\"><div class=\"form-group unassign-assessor-modal__assessor\" ng-if=\"!chosenAssessors.length\"><label class=\"control-label col-sm-4\"><translate>Assessor</translate></label><div class=\"col-sm-8 unassign-assessor-modal__assessor-info\"><div translate=\"\">Not assigned</div></div></div><div class=\"form-group unassign-assessor-modal__assessor\" ng-repeat=\"assessor in chosenAssessors\"><label class=\"control-label col-sm-4\"><translate>Assessor</translate></label><div class=\"col-sm-8 unassign-assessor-modal__assessor-info\"><div ng-bind=\"assessor.assessor.user.first_name + \' \' + assessor.assessor.user.last_name\"></div><label for=\"unassign-ass{{$index}}\"><input id=\"unassign-ass{{$index}}\" type=\"checkbox\" ng-change=\"unassignAssessor(assessor, shouldBeAdded)\" ng-model=\"shouldBeAdded\"><translate>Unassign</translate></label></div></div><div class=\"form-group unassign-assessor-modal__assessor\" ng-if=\"!chosenSpecialists.length && assessment.tool.type.requires_accountant\"><label class=\"control-label col-sm-4\"><translate>Financial Specialist</translate></label><div class=\"col-sm-8 unassign-assessor-modal__assessor-info\"><div translate=\"\">Not assigned</div></div></div><div class=\"form-group\" ng-repeat=\"assessor in chosenSpecialists\"><label class=\"control-label col-sm-4\"><translate>Financial Specialist</translate></label><div class=\"col-sm-8 unassign-assessor-modal__assessor-info\"><div ng-bind=\"assessor.assessor.user.first_name + \' \' + assessor.assessor.user.last_name\"></div><label for=\"unassign-fin{{$index}}\"><input id=\"unassign-fin{{$index}}\" type=\"checkbox\" ng-change=\"unassignAssessor(assessor, shouldBeAdded)\" ng-model=\"shouldBeAdded\"><translate>Unassign</translate></label></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\"><translate>Cancel</translate></button> <button class=\"btn btn-danger\" ng-click=\"save()\" ng-disabled=\"isSubmitDisabled()\"><translate>Send Cancellation</translate></button></div></article>");
$templateCache.put("projects/templates/partials/projectListTableDashboard.html","<table class=\"table table-hover dataTable\"><thead><tr><th sort-column=\"\" sort-name=\"name\" style=\"width: 20%\" translate=\"\">Name</th><th sort-column=\"\" sort-name=\"customer__name\" style=\"width: 16%\" translate=\"\">Project owner</th><th sort-column=\"\" sort-name=\"start_date\" style=\"width: 16%\" translate=\"\">Start date</th><th sort-column=\"\" sort-name=\"deadline\" style=\"width: 16%\" translate=\"\">End date</th><th sort-column=\"\" sort-name=\"number_of_assessments\" style=\"width: 16%\" translate=\"\"># of Assessments</th><th sort-column=\"\" sort-name=\"progress\" style=\"width: 16%\" translate=\"\">Completion</th><th translate=\"\" ng-if=\"$state.current.name === \'base.projects-draft\'\">Customer Submitted</th><th translate=\"\" ng-if=\"$state.current.name === \'base.projects-draft\'\">Employee Approval</th></tr></thead><tbody><tr ng-repeat=\"p in projects.results track by $index\"><td class=\"project-title\"><a ng-click=\"goToDetailView(p)\">{{ p.name }}</a></td><td><a ui-sref=\"base.clients-detail({ id: p.customer.id})\" class=\"text-navy\" ng-if=\"me.is_employee\">{{ p.customer.name | capitalize }}</a> <span ng-if=\"!me.is_employee\">{{ p.customer.name | capitalize }}</span></td><td>{{ p.start_date | date:\'dd-MM-yyyy\' }}</td><td>{{ p.deadline | date:\'dd-MM-yyyy\' }}</td><td>{{ p.number_of_assessments }}</td><td class=\"project-completion\"><small><translate>Final reports</translate>: {{ p.progress }}%</small><div class=\"progress progress-mini\"><div style=\"width: {{ p.progress }}%;\" class=\"progress-bar\"></div></div></td><td ng-if=\"$state.current.name === \'base.projects-draft\'\"><span translate=\"\" ng-if=\"p.submitted_for_approval && !p.declined\" class=\"text-success\">Pending</span> <span translate=\"\" ng-if=\"!p.submitted_for_approval && !p.declined\" class=\"text-warning\">Not Submitted</span> <span translate=\"\" ng-if=\"p.declined\" class=\"text-danger\">Declined</span></td><td ng-if=\"$state.current.name === \'base.projects-draft\'\"><span translate=\"\" class=\"text-info\" ng-if=\"p.submitted_for_approval && !p.declined\">Awaiting Approval</span> <span translate=\"\" class=\"text-warning\" ng-if=\"!p.submitted_for_approval && !p.declined\">Not Submitted for Approval</span> <span translate=\"\" class=\"text-danger\" ng-if=\"p.declined\">Declined</span></td></tr></tbody></table>");
$templateCache.put("projects/templates/partials/projectListTableWebsite.html","<table class=\"table table-hover\"><theader><tr><th translate=\"\">Name</th><th translate=\"\">PO\'s</th><th translate=\"\">Countries</th><th translate=\"\">Deadline</th><th translate=\"\">Progress</th><th translate=\"\">Project Status</th><th translate=\"\">Scope Status</th><th translate=\"\" class=\"text-center\">Actions</th></tr></theader><tbody><tr ng-repeat=\"p in projects.results track by $index\"><td class=\"project-title\"><a ng-click=\"goToDetailView(p)\">{{ p.name }}</a></td><td><span ng-bind=\"p.draft_assessments.objects.length\"></span></td><td class=\"project-people\">{{ p.customer.producing_organization.country }}</td><td><translate>Deadline</translate>: {{ p.deadline | date:\'dd-MM-yyyy\' }}</td><td class=\"project-completion\"><small><translate>Completion with</translate>: {{ p.progress }}%</small><div class=\"progress progress-mini\"><div style=\"width: {{ p.progress }}%;\" class=\"progress-bar\"></div></div></td><td><span translate=\"\" ng-if=\"p.submitted_for_approval && p.is_draft\" class=\"text-info\">Pending</span> <span translate=\"\" ng-if=\"!p.submitted_for_approval && p.is_draft && !p.declined\" class=\"text-warning\">Not Submitted</span> <span translate=\"\" ng-if=\"!p.is_draft && !p.declined\" class=\"text-success\">Approved</span> <span translate=\"\" ng-if=\"p.declined\" class=\"text-danger\">Declined</span></td><td><span translate=\"\" class=\"text-info\" ng-if=\"p.submitted_for_approval && p.is_draft\">Awaiting Approval</span> <span translate=\"\" class=\"text-warning\" ng-if=\"!p.submitted_for_approval && p.is_draft && !p.declined\">Awaiting Submission</span> <span translate=\"\" ng-if=\"!p.is_draft && !p.declined\" class=\"text-success\">Approved</span> <span translate=\"\" ng-if=\"p.declined\" class=\"text-danger\">Declined</span></td><td class=\"project-actions\"><div class=\"dropdown\" uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><translate>Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" style=\"color: white;\"><li><a ng-click=\"goToDetailView(p)\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-folder\"></i><translate>View</translate></a></li><li><a ng-show=\"user.employee\" ui-sref=\"base.projects-edit({id: p.id})\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-pencil\"></i><translate>Edit</translate></a></li><li ng-if=\"!p.submitted_for_approval\"><a ui-sref=\"base.projects-add-assessment({id: p.id})\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i><translate>Add assessment</translate></a></li><li><a ng-click=\"deleteProject(p)\" class=\"btn btn-danger btn-sm\"><i class=\"fa fa-trash\"></i><translate>Delete</translate></a></li></ul></div></td></tr></tbody></table>");
$templateCache.put("projects/templates/partials/projectProgressSteps.html","<div class=\"progress-steps\"><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 1, \'state-active\': progressCtrl.step === 1 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 1, \'state-active\': progressCtrl.step === 1 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 1}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 1}\">1</span></div><p class=\"progress__step-txt\" translate=\"\">Create Project</p></div><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 2, \'state-active\': progressCtrl.step === 2 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 2, \'state-active\': progressCtrl.step === 2 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 2}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 2}\">2</span></div><p class=\"progress__step-txt\" translate=\"\">Add assessment</p></div><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 3, \'state-active\': progressCtrl.step === 3 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 3, \'state-active\': progressCtrl.step === 3 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 3}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 3}\">3</span></div><p class=\"progress__step-txt\" translate=\"\">Submitted for Approval</p></div><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 4, \'state-active\': progressCtrl.step === 4 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 4, \'state-active\': progressCtrl.step === 4 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 4}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 4}\">4</span></div><p class=\"progress__step-txt\" translate=\"\">Assessment Execution</p></div><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 5, \'state-active\': progressCtrl.step === 5 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 5, \'state-active\': progressCtrl.step === 5 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 5}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 5}\">5</span></div><p class=\"progress__step-txt\" translate=\"\">Report Delivery</p></div><div class=\"progress__step col-lg-2\" ng-class=\"{ \'state-done\': progressCtrl.step > 6, \'state-active\': progressCtrl.step === 6 }\"><div class=\"progress__step-circle\" ng-class=\"{ \'state-done\': progressCtrl.step > 6, \'state-active\': progressCtrl.step === 6 }\"><span ng-class=\"{\'state-hidden\': progressCtrl.step <= 6}\"><i class=\"fa fa-check\"></i></span> <span ng-class=\"{\'state-hidden\': progressCtrl.step > 6}\">6</span></div><p class=\"progress__step-txt\" translate=\"\">Project Completed</p></div></div>");
$templateCache.put("projects/templates/projectAnalytics/dataQualityView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Data Quality &amp; Completeness</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Data Quality &amp; Completeness</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Project:</span> {{project.name || \'…\'}}</h5><div class=\"analytics-topbar-actions\"><button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><div class=\"alert alert-danger\" ng-if=\"loadFailed\" role=\"alert\"><strong translate=\"\">This tab could not be loaded.</strong> <span translate=\"\">The figures below are not shown because the request failed, not because the project has no data.</span> <button class=\"btn btn-default btn-xs\" ng-click=\"applyFilters()\" translate=\"\">Retry</button></div><div class=\"empty-state\" ng-if=\"!isLoading && !loadFailed && data && data.population.fo_count === 0\"><h4 translate=\"\">No FOs match the current filters.</h4><p translate=\"\">The filters are still applied. Clear them to see the whole project.</p><button class=\"btn btn-default btn-sm\" ng-click=\"clearFilters()\" translate=\"\">Clear all filters</button></div><div ng-if=\"!loadFailed && data && data.population.fo_count > 0\"><div class=\"kpi-row\"><div class=\"kpi-card\" ng-repeat=\"kpi in data.kpis\"><div class=\"kpi-card__label\">{{kpi.label | translate}}</div><div class=\"kpi-card__value\" ng-class=\"{\'kpi-card__value--not-applicable\': kpi.percentage === null}\"><span ng-if=\"kpi.percentage !== null\">{{kpi.available}} / {{kpi.expected}}</span> <span ng-if=\"kpi.percentage === null\" translate=\"\">No applicable FOs</span></div><div class=\"kpi-card__sub\" ng-if=\"kpi.percentage !== null\">{{kpi.percentage}}%</div><div class=\"kpi-card__year\" ng-if=\"kpi.fiscal_year\"><span translate=\"\">Fiscal year</span> {{kpi.fiscal_year}}</div></div></div><p class=\"section-intro\" ng-if=\"data.reporting_period.kpi_fiscal_year\"><translate>Figures cover the three fiscal years ending at the KPI fiscal year, which is derived from the latest assessment year in this population. A year with no records reports Missing; it is never filled from an earlier year.</translate></p><div class=\"table-card\" ng-repeat=\"section in availabilitySections\"><div class=\"table-card__title\">{{section.title | translate}}</div><div class=\"table-scroll\"><table class=\"table\"><thead><tr><th translate=\"\">Fiscal year</th><th ng-repeat=\"(metric, value) in section.rows[0].metrics\">{{metric}}</th><th class=\"col-boundary\" translate=\"\">Applicable FOs</th></tr></thead><tbody><tr ng-repeat=\"year in section.rows\"><td>{{year.year}}</td><td ng-repeat=\"(metric, value) in year.metrics\"><span ng-if=\"value.percentage !== null\">{{value.available}} / {{value.expected}} ({{value.percentage}}%)</span> <span ng-if=\"value.percentage === null\" class=\"value--not-applicable\" translate=\"\">No applicable FOs</span> <button type=\"button\" class=\"btn btn-link btn-xs dq-link\" ng-if=\"value.missing\" id=\"missing-{{section.key}}-{{metric}}-{{year.year}}\" ng-click=\"openDrilldown(\'missing_fos\', {category: section.key, metric: metric, year: year.year}, \'missing-\' + section.key + \'-\' + metric + \'-\' + year.year)\"><span translate=\"\">View missing</span> ({{value.missing}})</button></td><td class=\"col-boundary\">{{year.expected_fo_count}}</td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Collateral and insurance</div><div class=\"table-card__note\" translate=\"\">Current status, from each FO\'s latest assessment.</div><table class=\"table\"><thead><tr><th translate=\"\">Section</th><th translate=\"\">With</th><th translate=\"\">Without</th><th translate=\"\">Missing</th><th class=\"col-boundary\" translate=\"\">Response coverage</th></tr></thead><tbody><tr ng-repeat=\"row in yesNoRows\"><td>{{row.label | translate}}</td><td>{{row.data.with_count}}</td><td>{{row.data.without_count}}</td><td class=\"value--missing\">{{row.data.missing_count}}</td><td class=\"col-boundary\">{{coverageLabel(row.data.response_coverage)}}</td></tr></tbody></table></div><div class=\"table-card quality-section\"><div class=\"table-card__title\" translate=\"\">Quality checks</div><table class=\"table\"><thead><tr><th translate=\"\">Check</th><th translate=\"\">Category</th><th translate=\"\">Severity</th><th translate=\"\">Affected FOs</th><th translate=\"\">Affected records</th><th class=\"col-boundary\" translate=\"\">Applicable FOs</th><th></th></tr></thead><tbody><tr ng-repeat=\"check in data.quality_checks\" ng-class=\"{\'row--severity-error\': check.severity === \'error\'}\"><td>{{check.name | translate}}</td><td>{{check.category | translate}}</td><td><span class=\"severity-badge severity-badge--{{check.severity}}\">{{check.severity | translate}}</span></td><td>{{check.affected_fo_count}} <span ng-if=\"check.affected_fo_percentage !== null\">({{check.affected_fo_percentage}}%)</span> <span ng-if=\"check.affected_fo_percentage === null\" class=\"value--not-applicable\" translate=\"\">No applicable FOs</span></td><td>{{check.affected_record_count}}</td><td class=\"col-boundary\">{{check.applicable_fo_count}}</td><td><button type=\"button\" class=\"btn btn-link btn-xs dq-link\" ng-if=\"check.affected_record_count\" id=\"check-{{check.code}}\" ng-click=\"openDrilldown(\'quality_issue\', {check_code: check.code}, \'check-\' + check.code)\" translate=\"\">View quality issues</button> <span ng-if=\"!check.affected_record_count\" class=\"text-muted\" translate=\"\">No FOs or records trigger this check</span></td></tr></tbody></table></div></div><div class=\"drilldown-panel\" id=\"dq-drilldown\" ng-if=\"drilldown\" role=\"region\" aria-labelledby=\"dq-drilldown-title\" tabindex=\"-1\"><div class=\"drilldown-panel__header\"><strong id=\"dq-drilldown-title\" translate=\"\">Drill-down</strong> <button type=\"button\" class=\"close\" ng-click=\"closeDrilldown()\" aria-label=\"Close\">&times;</button></div><div class=\"alert alert-danger\" ng-if=\"drilldown.failed\" role=\"alert\"><span translate=\"\">This table could not be loaded.</span> <button class=\"btn btn-default btn-xs\" ng-click=\"loadDrilldownPage(drilldown.page)\" translate=\"\">Retry</button></div><div ng-if=\"!drilldown.failed && drilldown.result\"><div class=\"drilldown-panel__count\"><strong>{{drilldown.result.count}}</strong> <span translate=\"\">rows</span></div><p ng-if=\"!drilldown.result.count\" translate=\"\">No FOs or records trigger this check.</p><div class=\"table-scroll\" ng-if=\"drilldown.result.count\"><table class=\"table\"><thead><tr><th translate=\"\">Assessee</th><th translate=\"\">Fiscal year</th><th translate=\"\">Field</th><th translate=\"\">Reported value</th><th translate=\"\">Assessment</th></tr></thead><tbody><tr ng-repeat=\"row in drilldown.result.results\"><td>{{row.fo_name || \'–\'}} <span class=\"text-muted\" ng-if=\"row.fo_id\">&nbsp;(ID&nbsp;{{row.fo_id}})</span></td><td>{{row.fiscal_year || row.year || \'–\'}}</td><td>{{row.affected_field || row.metric || \'–\'}}</td><td>{{row.reported_value !== undefined && row.reported_value !== null ? row.reported_value : (row.status || \'–\')}}</td><td><a ng-if=\"row.report_id\" class=\"dq-link\" ui-sref=\"base.reports-detail.summary({id: row.report_id})\" target=\"_blank\" translate=\"\">Open assessment</a> <span class=\"text-muted\" ng-if=\"!row.report_id\" translate=\"\">No report</span></td></tr></tbody></table></div><div class=\"drilldown-panel__paging\" ng-if=\"drilldown.result.count > drilldown.result.page_size\"><button class=\"btn btn-default btn-xs\" ng-disabled=\"drilldown.page <= 1\" ng-click=\"loadDrilldownPage(drilldown.page - 1)\" translate=\"\">Previous</button> <span>{{drilldown.page}}</span> <button class=\"btn btn-default btn-xs\" ng-disabled=\"drilldown.page * drilldown.result.page_size >= drilldown.result.count\" ng-click=\"loadDrilldownPage(drilldown.page + 1)\" translate=\"\">Next</button></div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/demographicsView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Demographics</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Demographics</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Project:</span> {{project.name || \'…\'}}</h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportDemographicsCSV()\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading || !isPageLoaded\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><div class=\"section-intro\"><translate>Board, management, staff, membership and outgrowers of the filtered FOs, one record per FO taken from its latest finalised assessment within this project. Totals are summed across the FOs that reported a figure, and a reported zero counts; minimum, average and maximum are per FO. Gender shares are taken over the FOs that recorded both genders.</translate></div><div ng-if=\"isLoading\" class=\"loading-note\" translate=\"\">Loading demographics…</div><div ng-if=\"!isLoading && loadFailed\" class=\"empty-hint\" translate=\"\">Demographics could not be loaded. Change a filter or reload the page to try again.</div><div ng-if=\"!isLoading && isPageLoaded\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">FOs</div><div class=\"metric-value\">{{charts.num(demographics.numberOfFOs)}}</div><div class=\"metric-note\">{{charts.num(demographics.totalAssessments)}} <span translate=\"\">assessments</span> <span ng-if=\"project.customer.name\">· <span translate=\"\">Project owner: {{project.customer.name}}</span></span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Countries</div><div class=\"metric-value metric-value--text\" ng-class=\"{\'value-missing\': !demographics.countryList.length}\">{{demographics.countries}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Average Total Score</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': demographics.averageScore === null}\">{{demographics.averageScore === null ? \'--\' : demographics.averageScore}}</div><div class=\"metric-note\" ng-if=\"demographics.averageScore === null\" translate=\"\">No scored assessments</div></article><article class=\"metric-card\" ng-repeat=\"indicator in headlines\"><div class=\"metric-title\">{{indicator.label | translate}}</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(indicator.rows[0].value)}\">{{charts.num(indicator.rows[0].value)}}</div><div class=\"metric-note\" ng-if=\"indicator.data.gender.female_share !== null\"><span translate=\"\">Female {{charts.pct(indicator.data.gender.female_share)}} · {{indicator.data.gender.fo_count}} FOs with both genders</span></div><div class=\"metric-note\" ng-if=\"indicator.payloadKey === \'membership\' && indicator.data.active_member_percentage !== null\"><span translate=\"\">Active: {{charts.pct(indicator.data.active_member_percentage)}} of members</span></div><div class=\"metric-note\" ng-if=\"!indicator.rows[0].n\" translate=\"\">Not reported by any FO</div></article></div><div class=\"table-card\" ng-repeat=\"section in sections\"><div class=\"table-card__title\">{{section.title | translate}}</div><div class=\"table-card__hint\"><translate>N is the number of FOs behind each figure. The bars split by gender over the FOs that recorded both genders; an FO with one gender missing is in the total but not in the split.</translate></div><div id=\"{{section.chartId}}\" class=\"chart-body chart-body--auto\"></div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Indicator</th><th translate=\"\">Series</th><th class=\"numeric\" translate=\"\">Total</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Min per FO</th><th class=\"numeric\" translate=\"\">Average per FO</th><th class=\"numeric\" translate=\"\">Max per FO</th><th class=\"numeric\" translate=\"\">Female share</th></tr></thead><tbody ng-repeat=\"indicator in section.indicators\"><tr ng-repeat=\"row in indicator.rows\" ng-class=\"{\'row--first\': row.first}\"><td><strong ng-if=\"row.first\">{{indicator.label | translate}}</strong></td><td>{{row.series | translate}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.value)}\">{{charts.num(row.value)}}</td><td class=\"numeric\">{{row.n}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.min)}\">{{charts.num(row.min)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.avg)}\">{{charts.num(row.avg, 1)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.max)}\">{{charts.num(row.max)}}</td><td class=\"numeric\"><span ng-if=\"row.first\" ng-class=\"{\'value-missing\': indicator.data.gender.female_share === null}\">{{charts.pct(indicator.data.gender.female_share)}} <span class=\"metric-note\" ng-if=\"indicator.data.gender.fo_count\">(N={{indicator.data.gender.fo_count}})</span></span></td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Demographics Drill-Down Filters</div><div class=\"table-card__hint\" translate=\"\">These filters narrow the table below only. The project filters on the right rebuild the whole tab.</div><div class=\"table-filters\"><div class=\"table-filters__group\"><label for=\"demoNameFilter\" translate=\"\">FO</label><select id=\"demoNameFilter\" multiple=\"\" ng-model=\"local.name\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.name\"></select></div><div class=\"table-filters__group\"><label for=\"demoCountryFilter\" translate=\"\">Country</label><select id=\"demoCountryFilter\" multiple=\"\" ng-model=\"local.country\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.country\"></select></div><div class=\"table-filters__group\"><label for=\"demoToolFilter\" translate=\"\">Tool</label><select id=\"demoToolFilter\" multiple=\"\" ng-model=\"local.tool\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.tool\"></select></div><div class=\"table-filters__group\"><label for=\"demoLegalFilter\" translate=\"\">Legal status</label><select id=\"demoLegalFilter\" multiple=\"\" ng-model=\"local.legal_status\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.legal_status\"></select></div><div class=\"table-filters__group\"><label>&nbsp;</label> <button class=\"btn btn-default btn-sm\" ng-click=\"clearLocalFilters()\" translate=\"\">Clear table filters</button></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Demographics Drill-Down</div><div class=\"table-card__hint\">{{visibleRecords.length}} / {{records.length}} {{\'FOs, from the latest finalised assessment of each. \"--\" means not reported; a reported zero shows as 0.\' | translate}}</div><div class=\"analytics-topbar-actions\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportDrilldownCSV()\" ng-disabled=\"!visibleRecords.length\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export table</span></button></div><div class=\"demographics-drilldown\"><table class=\"analytics-table\"><thead><tr><th ng-repeat=\"column in drilldownColumns track by column.key\" ng-class=\"{numeric: column.numeric}\" ng-click=\"sort.toggle(column.key)\">{{column.label | translate}} {{sort.indicator(column.key)}}</th></tr></thead><tbody><tr ng-repeat=\"row in visibleRecords | orderBy:sort.expression():sort.descending track by row.assessment_id\"><td ng-repeat=\"column in drilldownColumns track by column.key\" ng-class=\"{numeric: column.numeric, \'value-missing\': row[column.key] === null}\"><span ng-if=\"!column.numeric || column.plain\">{{row[column.key] === null ? \'--\' : row[column.key]}}</span> <span ng-if=\"column.numeric && !column.plain\">{{column.score ? charts.num(row[column.key], 2) : charts.num(row[column.key])}}</span></td></tr><tr ng-if=\"!visibleRecords.length\"><td colspan=\"{{drilldownColumns.length}}\" class=\"empty-hint\" translate=\"\">No FOs match the table filters.</td></tr></tbody></table></div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/financeHistoryView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Finance History</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Finance History</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Project:</span> {{project.name || \'…\'}}</h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportCSV()\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><div class=\"section-intro\"><translate>External financing recorded by the filtered FOs. Facility counts and the number of FOs holding them are reported separately, funding shares are based on amounts rather than transaction counts, and repayment status is shown for loans only. Facility years come from the recorded start date.</translate></div><div ng-if=\"isLoading\" class=\"loading-note\" translate=\"\">Loading finance history…</div><div ng-if=\"!isLoading\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Total Funding Amount</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(data.total_funding_amount)}\">{{charts.money(data.total_funding_amount, population.currency)}}</div><div class=\"metric-note\"><span translate=\"\">Loans, grants and pre-finance in {{population.currency}}</span></div></article><article class=\"metric-card\" ng-repeat=\"type in types\"><div class=\"metric-title\"><span translate=\"\">Number of {{type.plural}}</span></div><div class=\"metric-value\">{{data[type.key].kpis.count}}</div><div class=\"metric-note\">{{data[type.key].kpis.fo_count}} <span translate=\"\">FOs hold these facilities</span></div><div class=\"metric-note\"><translate>Average</translate>: {{charts.money(data[type.key].kpis.average_amount, population.currency)}} · N = {{data[type.key].kpis.n}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Total Loan Amount</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(data.loans.kpis.total_amount)}\">{{charts.money(data.loans.kpis.total_amount, population.currency)}}</div><div class=\"metric-note\">N = {{data.loans.kpis.n}} <span translate=\"\">loan records with an amount</span></div></article></div><div class=\"charts-row\"><div class=\"chart-card\"><div class=\"chart-card__title\"><span translate=\"\">Average Loan by Year ({{population.currency}})</span></div><div class=\"chart-card__hint\"><translate>Year comes from the loan start date — these records carry no year field. Hover for the number of loans and the number of FOs receiving them.</translate></div><div id=\"financeLoanByYearChart\" class=\"chart-body\"></div></div></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Share of Funding Amount by Type</div><div class=\"chart-card__hint\" translate=\"\">Amount-based, not a share of transaction counts.</div><div id=\"financeFundingTypeChart\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\"><span translate=\"\">Loan Purpose ({{population.currency}})</span></div><div class=\"chart-card__hint\" translate=\"\">Loans without a recorded purpose appear as \"Not reported\".</div><div id=\"financeLoanPurposeChart\" class=\"chart-body\"></div></div></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\"><span translate=\"\">Type of Financier for Loan ({{population.currency}})</span></div><div class=\"chart-card__hint\" translate=\"\">From the assessment\'s type-of-financier dropdown, for loan records only - it does not describe grants or pre-finance.</div><div id=\"financeFinancierTypeChart\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Loan Repayment Status</div><div class=\"chart-card__hint\" translate=\"\">Share of loan records by status — counts, not amounts.</div><div id=\"financeRepaymentChart\" class=\"chart-body\"></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Finance Drill-Down Filters</div><div class=\"table-card__hint\" translate=\"\">These table filters apply to all three tables below; the finance type is the table itself. The project filters on the right rebuild the whole tab.</div><div class=\"table-filters\"><div class=\"table-filters__group\"><label for=\"fhFoFilter\" translate=\"\">FO</label><select id=\"fhFoFilter\" multiple=\"\" ng-model=\"local.fo\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.fo\"></select></div><div class=\"table-filters__group\"><label for=\"fhYearFilter\" translate=\"\">Year</label><select id=\"fhYearFilter\" multiple=\"\" ng-model=\"local.year\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.year\"></select></div><div class=\"table-filters__group\"><label for=\"fhFinancierFilter\" translate=\"\">Financier type</label><select id=\"fhFinancierFilter\" multiple=\"\" ng-model=\"local.financier_type\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.financier_type\"></select></div><div class=\"table-filters__group\"><label>&nbsp;</label> <button class=\"btn btn-default btn-sm\" ng-click=\"clearLocalFilters()\" translate=\"\">Clear table filters</button></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Loan Drill-Down</div><div class=\"table-card__hint\">{{visible.loans.length}} <span translate=\"\">of</span> {{data.loans.records.length}} <span translate=\"\">loan records shown</span></div><table class=\"analytics-table\" ng-if=\"visible.loans.length\"><thead><tr><th ng-click=\"sort.loans.toggle(\'fo_name\')\"><span translate=\"\">FO</span> {{sort.loans.indicator(\'fo_name\')}}</th><th class=\"numeric\" ng-click=\"sort.loans.toggle(\'amount\')\"><span translate=\"\">Amount</span> {{sort.loans.indicator(\'amount\')}}</th><th translate=\"\">Currency</th><th class=\"numeric\" ng-click=\"sort.loans.toggle(\'year\')\"><span translate=\"\">Year</span> {{sort.loans.indicator(\'year\')}}</th><th translate=\"\">Repayment status</th><th translate=\"\">Financier</th><th translate=\"\">Financier type</th><th translate=\"\">Purpose</th></tr></thead><tbody><tr ng-repeat=\"row in visible.loans | orderBy:sort.loans.expression():sort.loans.descending\"><td>{{row.fo_name || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.amount)}\">{{charts.num(row.amount)}}</td><td>{{row.currency}}<span ng-if=\"row.original_currency && row.original_currency !== row.currency\">&nbsp;({{row.original_currency}})</span></td><td class=\"numeric\" ng-class=\"{\'value-missing\': row.year === null}\">{{yearLabel(row.year)}}</td><td>{{row.repayment_status || \'--\'}}</td><td>{{row.financier_name || \'--\'}}</td><td>{{row.financier_type || \'--\'}}</td><td>{{row.purpose || \'--\'}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!visible.loans.length\" translate=\"\">No loan records match the current filters.</div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Grant Drill-Down</div><div class=\"table-card__hint\">{{visible.grants.length}} <span translate=\"\">of</span> {{data.grants.records.length}} <span translate=\"\">grant records shown. Repayment status does not apply to grants.</span></div><table class=\"analytics-table\" ng-if=\"visible.grants.length\"><thead><tr><th ng-click=\"sort.grants.toggle(\'fo_name\')\"><span translate=\"\">FO</span> {{sort.grants.indicator(\'fo_name\')}}</th><th class=\"numeric\" ng-click=\"sort.grants.toggle(\'amount\')\"><span translate=\"\">Amount</span> {{sort.grants.indicator(\'amount\')}}</th><th translate=\"\">Currency</th><th class=\"numeric\" ng-click=\"sort.grants.toggle(\'year\')\"><span translate=\"\">Year</span> {{sort.grants.indicator(\'year\')}}</th><th translate=\"\">Donor / funder</th><th translate=\"\">Funder type</th><th translate=\"\">Cash or in kind</th><th translate=\"\">Purpose</th></tr></thead><tbody><tr ng-repeat=\"row in visible.grants | orderBy:sort.grants.expression():sort.grants.descending\"><td>{{row.fo_name || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.amount)}\">{{charts.num(row.amount)}}</td><td>{{row.currency}}<span ng-if=\"row.original_currency && row.original_currency !== row.currency\">&nbsp;({{row.original_currency}})</span></td><td class=\"numeric\" ng-class=\"{\'value-missing\': row.year === null}\">{{yearLabel(row.year)}}</td><td>{{row.financier_name || \'--\'}}</td><td>{{row.financier_type || \'--\'}}</td><td>{{row.in_cash_or_in_kind || \'--\'}}</td><td>{{row.purpose || \'--\'}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!visible.grants.length\" translate=\"\">No grant records match the current filters.</div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Pre-finance Drill-Down</div><div class=\"table-card__hint\">{{visible.pre_finance.length}} <span translate=\"\">of</span> {{data.pre_finance.records.length}} <span translate=\"\">pre-finance records shown</span></div><table class=\"analytics-table\" ng-if=\"visible.pre_finance.length\"><thead><tr><th ng-click=\"sort.pre_finance.toggle(\'fo_name\')\"><span translate=\"\">FO</span> {{sort.pre_finance.indicator(\'fo_name\')}}</th><th class=\"numeric\" ng-click=\"sort.pre_finance.toggle(\'amount\')\"><span translate=\"\">Amount</span> {{sort.pre_finance.indicator(\'amount\')}}</th><th translate=\"\">Currency</th><th class=\"numeric\" ng-click=\"sort.pre_finance.toggle(\'year\')\"><span translate=\"\">Year</span> {{sort.pre_finance.indicator(\'year\')}}</th><th translate=\"\">Provider</th><th translate=\"\">Provider type</th><th translate=\"\">Repayment modality</th><th translate=\"\">Purpose</th></tr></thead><tbody><tr ng-repeat=\"row in visible.pre_finance | orderBy:sort.pre_finance.expression():sort.pre_finance.descending\"><td>{{row.fo_name || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.amount)}\">{{charts.num(row.amount)}}</td><td>{{row.currency}}<span ng-if=\"row.original_currency && row.original_currency !== row.currency\">&nbsp;({{row.original_currency}})</span></td><td class=\"numeric\" ng-class=\"{\'value-missing\': row.year === null}\">{{yearLabel(row.year)}}</td><td>{{row.financier_name || \'--\'}}</td><td>{{row.financier_type || \'--\'}}</td><td>{{row.repayment_modality || \'--\'}}</td><td>{{row.purpose || \'--\'}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!visible.pre_finance.length\" translate=\"\">No pre-finance records match the current filters.</div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/financialView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Financial Information</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Financial Information</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Project:</span> {{project.name || \'…\'}}</h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportCSV()\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><div class=\"section-intro\"><translate>Latest financial position of the filtered FOs, one record per FO taken from its finalised assessment within this project. Portfolio margins are weighted by turnover; every figure states the number of FOs behind it. Figures use the reporting year, not the assessment date year.</translate><span ng-if=\"kpis.fiscal_year\">&nbsp;</span><span ng-if=\"kpis.fiscal_year\" translate=\"\">Every KPI card below is calculated on fiscal year {{kpis.fiscal_year}} — the year most FOs last reported. Changing the reporting currency changes the monetary values only; the fiscal years covered stay the same.</span></div><div ng-if=\"isLoading\" class=\"loading-note\" translate=\"\">Loading financial analytics…</div><div ng-if=\"!isLoading\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\"><span translate=\"\">Average Turnover</span> <span class=\"metric-fiscal-year\" ng-if=\"kpis.fiscal_year\">FY {{kpis.fiscal_year}}</span></div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(kpis.average_turnover.value)}\">{{charts.money(kpis.average_turnover.value, population.currency)}}</div><div class=\"metric-note\">N = {{kpis.average_turnover.n}} <span translate=\"\">of</span> {{population.fo_count}} <span translate=\"\">FOs</span></div><div class=\"metric-note metric-note--warning\" ng-if=\"isThin(kpis.average_turnover.n)\"><translate>Sample materially below the filtered FO population</translate></div></article><article class=\"metric-card\"><div class=\"metric-title\"><span translate=\"\">Portfolio Gross Margin</span> <span class=\"metric-fiscal-year\" ng-if=\"kpis.fiscal_year\">FY {{kpis.fiscal_year}}</span></div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(kpis.portfolio_gross_margin_pct.value)}\">{{charts.pct(kpis.portfolio_gross_margin_pct.value)}}</div><div class=\"metric-note\"><span translate=\"\">Weighted: total gross profit ÷ total turnover · N = {{kpis.portfolio_gross_margin_pct.n}}</span></div><div class=\"metric-note metric-note--secondary\"><translate>Average FO Gross Margin</translate>: {{charts.pct(kpis.average_fo_gross_margin_pct.value)}}</div></article><article class=\"metric-card\"><div class=\"metric-title\"><span translate=\"\">Portfolio Net Margin</span> <span class=\"metric-fiscal-year\" ng-if=\"kpis.fiscal_year\">FY {{kpis.fiscal_year}}</span></div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(kpis.portfolio_net_margin_pct.value)}\">{{charts.pct(kpis.portfolio_net_margin_pct.value)}}</div><div class=\"metric-note\"><span translate=\"\">Weighted: total net profit ÷ total turnover · N = {{kpis.portfolio_net_margin_pct.n}}</span></div><div class=\"metric-note metric-note--secondary\"><translate>Average FO Net Margin</translate>: {{charts.pct(kpis.average_fo_net_margin_pct.value)}}</div></article><article class=\"metric-card\"><div class=\"metric-title\"><span translate=\"\">Highest Turnover FO</span> <span class=\"metric-fiscal-year\" ng-if=\"kpis.fiscal_year\">FY {{kpis.fiscal_year}}</span></div><div class=\"metric-value\" ng-if=\"kpis.top_turnover_fos.length\">{{kpis.top_turnover_fos[0].fo_name || \'--\'}}</div><div class=\"metric-value value-missing\" ng-if=\"!kpis.top_turnover_fos.length\">--</div><div class=\"metric-note\" ng-if=\"kpis.top_turnover_fos.length\">{{charts.money(kpis.top_turnover_fos[0].turnover, kpis.top_turnover_fos[0].currency)}} <span translate=\"\">· financial year {{kpis.top_turnover_fos[0].financial_year}}</span></div></article><article class=\"metric-card\"><div class=\"metric-title\"><span translate=\"\">Profitable FOs</span> <span class=\"metric-fiscal-year\" ng-if=\"kpis.fiscal_year\">FY {{kpis.fiscal_year}}</span></div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(kpis.profitable_fos.pct)}\">{{charts.pct(kpis.profitable_fos.pct)}}</div><div class=\"metric-note\">{{kpis.profitable_fos.count}} <span translate=\"\">of</span> {{kpis.profitable_fos.valid_n}} <span translate=\"\">FOs with net profit data</span></div><div class=\"metric-note\"><span translate=\"\">Break-even: {{kpis.profitable_fos.break_even}} · Loss-making: {{kpis.profitable_fos.loss_making}} · Missing: {{kpis.profitable_fos.missing}}</span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Reporting currency</div><div class=\"metric-value\">{{population.currency}}</div><div class=\"metric-note\"><translate>Values are never combined across currencies. Switching this changes the monetary values only — never the fiscal years or the FOs covered.</translate></div></article></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Average Turnover by Financial Year</div><div class=\"chart-card__hint\"><translate>Sum of turnover ÷ number of distinct FOs reporting turnover that year.</translate></div><div id=\"financialTurnoverChart\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Average Gross Profit by Financial Year</div><div class=\"chart-card__hint\"><translate>Uses its own denominator: FOs reporting gross profit, not turnover.</translate></div><div id=\"financialGrossProfitChart\" class=\"chart-body\"></div></div></div><div class=\"charts-row\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Top FOs by Turnover</div><div class=\"chart-card__hint\"><translate>Latest valid record per FO. Ties at third place are all shown.</translate></div><div id=\"financialTopFOsChart\" class=\"chart-body chart-body--short\"></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Three-Year Financial Data Completion</div><div class=\"table-card__hint\"><translate>Counted separately per metric: a single \"FOs with data\" number would hide records where turnover exists but profit fields are missing. The denominator is the filtered FO population. Counted on what each FO reported, in its own currency, so these figures are the same in every reporting currency.</translate></div><table class=\"analytics-table\" ng-if=\"completeness.length\"><thead><tr><th translate=\"\">Year</th><th class=\"numeric\" translate=\"\">FOs expected</th><th class=\"numeric\" translate=\"\">Turnover</th><th class=\"numeric\" translate=\"\">Turnover %</th><th class=\"numeric\" translate=\"\">Gross profit</th><th class=\"numeric\" translate=\"\">Gross %</th><th class=\"numeric\" translate=\"\">Net profit</th><th class=\"numeric\" translate=\"\">Net %</th></tr></thead><tbody><tr ng-repeat=\"row in completeness\"><td>{{row.year}}</td><td class=\"numeric\">{{row.expected_n}}</td><td class=\"numeric\">{{row.turnover_n}}</td><td class=\"numeric\">{{charts.pct(row.turnover_pct)}}</td><td class=\"numeric\">{{row.gross_n}}</td><td class=\"numeric\">{{charts.pct(row.gross_pct)}}</td><td class=\"numeric\">{{row.net_n}}</td><td class=\"numeric\">{{charts.pct(row.net_pct)}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!completeness.length\" translate=\"\">No financial years available for the current filters.</div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Financial Drill-Down</div><div class=\"table-card__hint\"><translate>Table filters below narrow only this table; the project filters in the panel on the right rebuild the whole tab. Each statement is shown in the currency it was reported in, so the reporting-currency selector does not change which rows are listed. Statements reporting no turnover, gross profit or net profit are not listed at all.</translate></div><div class=\"table-filters\"><div class=\"table-filters__group\"><label for=\"finFoFilter\" translate=\"\">FO</label><select id=\"finFoFilter\" multiple=\"\" ng-model=\"local.fo\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.fo\"></select></div><div class=\"table-filters__group\"><label for=\"finYearFilter\" translate=\"\">Financial year</label><select id=\"finYearFilter\" multiple=\"\" ng-model=\"local.year\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.year\"></select></div><div class=\"table-filters__group\"><label for=\"finCountryFilter\" translate=\"\">Country</label><select id=\"finCountryFilter\" multiple=\"\" ng-model=\"local.country\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.country\"></select></div><div class=\"table-filters__group\"><label for=\"finChainFilter\" translate=\"\">Value chain</label><select id=\"finChainFilter\" multiple=\"\" ng-model=\"local.value_chain\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.value_chain\"></select></div><div class=\"table-filters__group\"><label for=\"finCurrencyFilter\" translate=\"\">Currency</label><select id=\"finCurrencyFilter\" multiple=\"\" ng-model=\"local.currency\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.currency\"></select></div><div class=\"table-filters__group\"><label>&nbsp;</label> <button class=\"btn btn-default btn-sm\" ng-click=\"clearLocalFilters()\" translate=\"\">Clear table filters</button></div></div><div class=\"table-card__hint\">{{visibleRecords.length}} <span translate=\"\">of</span> {{records.length}} <span translate=\"\">statements shown. Hold Ctrl (Windows) or Cmd (Mac) to select multiple.</span></div><table class=\"analytics-table\" ng-if=\"visibleRecords.length\"><thead><tr><th ng-click=\"sort.toggle(\'fo_name\')\"><span translate=\"\">FO</span> {{sort.indicator(\'fo_name\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'assessment_id\')\"><span translate=\"\">Assessment ID</span> {{sort.indicator(\'assessment_id\')}}</th><th ng-click=\"sort.toggle(\'assessment_date\')\"><span translate=\"\">Assessment date</span> {{sort.indicator(\'assessment_date\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'financial_year\')\"><span translate=\"\">Financial year</span> {{sort.indicator(\'financial_year\')}}</th><th ng-click=\"sort.toggle(\'currency\')\"><span translate=\"\">Currency</span> {{sort.indicator(\'currency\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'turnover\')\"><span translate=\"\">Turnover</span> {{sort.indicator(\'turnover\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'gross_profit\')\"><span translate=\"\">Gross profit</span> {{sort.indicator(\'gross_profit\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'gross_margin_pct\')\"><span translate=\"\">Gross margin %</span> {{sort.indicator(\'gross_margin_pct\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'net_profit\')\"><span translate=\"\">Net profit</span> {{sort.indicator(\'net_profit\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'net_margin_pct\')\"><span translate=\"\">Net margin %</span> {{sort.indicator(\'net_margin_pct\')}}</th><th translate=\"\">Data status</th></tr></thead><tbody><tr ng-repeat=\"row in visibleRecords | orderBy:sort.expression():sort.descending\"><td>{{row.fo_name || \'--\'}}</td><td class=\"numeric\">{{row.assessment_id}}</td><td>{{row.assessment_date || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-invalid\': hasFlag(row, \'missing_financial_year\')}\">{{row.financial_year || \'--\'}}</td><td ng-class=\"{\'value-invalid\': hasFlag(row, \'missing_currency\')}\">{{row.currency || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.turnover), \'value-invalid\': hasFlag(row, \'negative_turnover\')}\">{{charts.num(row.turnover)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.gross_profit), \'value-invalid\': hasFlag(row, \'gross_profit_exceeds_turnover\')}\">{{charts.num(row.gross_profit)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.gross_margin_pct), \'value-invalid\': hasFlag(row, \'gross_margin_out_of_range\')}\">{{charts.pct(row.gross_margin_pct)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.net_profit)}\">{{charts.num(row.net_profit)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.net_margin_pct), \'value-invalid\': hasFlag(row, \'net_margin_out_of_range\')}\">{{charts.pct(row.net_margin_pct)}}</td><td><span class=\"flag-badge\" ng-repeat=\"flag in row.data_status\">{{flagLabel(flag)}}</span> <span ng-if=\"!row.data_status.length\">—</span></td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!visibleRecords.length\" translate=\"\">No financial statements match the current filters.</div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/productionSalesView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Production &amp; Sales</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Production &amp; Sales</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Project:</span> {{project.name || \'…\'}}</h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportCSV()\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><div class=\"section-intro\"><translate>Volumes purchased from members, purchased from others, sold, and purchased as inputs. Volumes are reported per unit and never summed across units — there is no approved conversion table, so kilograms, litres and bags stay separate. Purchased and sold volumes carry their own units and are never assumed to share one. Primary and secondary products come from the explicit product importance. Reporting years come from the production records.</translate></div><div ng-if=\"isLoading\" class=\"loading-note\" translate=\"\">Loading production analytics…</div><div ng-if=\"!isLoading\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Products Covered</div><div class=\"metric-value\">{{data.products_covered.count}}</div><div class=\"metric-note\" translate=\"\">Distinct products after normalising spelling and casing</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Units Reported</div><div class=\"metric-value\">{{units.length || \'--\'}}</div><div class=\"metric-note\"><span ng-if=\"units.length\">{{units.join(\', \')}}</span> <span ng-if=\"!units.length\" translate=\"\">No units reported</span></div></article><article class=\"metric-card\" ng-repeat=\"ratio in sourcingRatio\"><div class=\"metric-title\"><span translate=\"\">Member Sourcing Ratio ({{ratio.unit}})</span></div><div class=\"metric-value\" ng-class=\"{\'value-missing\': charts.isMissing(ratio.pct)}\">{{charts.pct(ratio.pct)}}</div><div class=\"metric-note\"><span translate=\"\">Weighted within this unit · N = {{ratio.n}}</span></div></article></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Volumes by Unit</div><div class=\"table-card__hint\" translate=\"\">Each row is one unit. These figures are deliberately not totalled: adding kilograms to litres would be meaningless.</div><table class=\"analytics-table\" ng-if=\"byUnit.length\"><thead><tr><th translate=\"\">Unit</th><th class=\"numeric\" translate=\"\">Purchased from members</th><th class=\"numeric\" translate=\"\">Purchased from others</th><th class=\"numeric\" translate=\"\">Produce sold</th><th class=\"numeric\" translate=\"\">FOs</th></tr></thead><tbody><tr ng-repeat=\"row in byUnit\"><td><strong>{{row.unit}}</strong></td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_purchased_from_members)}\">{{charts.num(row.volume_purchased_from_members)}}<div class=\"metric-note\">N = {{row.volume_purchased_from_members_n}}</div></td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_purchased_from_others)}\">{{charts.num(row.volume_purchased_from_others)}}<div class=\"metric-note\">N = {{row.volume_purchased_from_others_n}}</div></td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_sold)}\">{{charts.num(row.volume_sold)}}<div class=\"metric-note\">N = {{row.volume_sold_n}}</div></td><td class=\"numeric\">{{row.n}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!byUnit.length\" translate=\"\">No production volumes with both a unit and a reporting year for the current filters.</div></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">FO Distribution by Primary Product</div><div class=\"chart-card__hint\" translate=\"\">Share of FOs, not production volume. Taken from the explicit product importance.</div><div id=\"productionPrimaryChart\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">FO Distribution by Secondary Product</div><div class=\"chart-card__hint\" translate=\"\">An FO may report several secondary products, so these shares can exceed 100%.</div><div id=\"productionSecondaryChart\" class=\"chart-body\"></div></div></div><div ng-repeat=\"unit in units\"><div class=\"charts-row\"><div class=\"chart-card\"><div class=\"chart-card__title\"><span translate=\"\">Top Three Products by Sold Volume — {{unit}}</span></div><div class=\"chart-card__hint\" translate=\"\">Ranked by sold volume within this unit only. Volumes in different units are never compared.</div><div id=\"productionTopChart{{$index}}\" class=\"chart-body\"></div></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Production &amp; Sales Drill-Down</div><div class=\"table-card__hint\" translate=\"\">Table filters below narrow only this table; the project filters on the right rebuild the whole tab. Rows missing a unit or reporting year are shown and flagged, but are excluded from the totals above.</div><div class=\"table-filters\"><div class=\"table-filters__group\"><label for=\"prodFoFilter\" translate=\"\">FO</label><select id=\"prodFoFilter\" multiple=\"\" ng-model=\"local.fo\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.fo\"></select></div><div class=\"table-filters__group\"><label for=\"prodYearFilter\" translate=\"\">Reporting year</label><select id=\"prodYearFilter\" multiple=\"\" ng-model=\"local.year\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.year\"></select></div><div class=\"table-filters__group\"><label for=\"prodCountryFilter\" translate=\"\">Country</label><select id=\"prodCountryFilter\" multiple=\"\" ng-model=\"local.country\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.country\"></select></div><div class=\"table-filters__group\"><label for=\"prodProductFilter\" translate=\"\">Product</label><select id=\"prodProductFilter\" multiple=\"\" ng-model=\"local.product\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.product\"></select></div><div class=\"table-filters__group\"><label for=\"prodUnitFilter\" translate=\"\">Unit</label><select id=\"prodUnitFilter\" multiple=\"\" ng-model=\"local.unit\" ng-change=\"applyLocalFilters()\" ng-options=\"option as option for option in options.unit\"></select></div><div class=\"table-filters__group\"><label>&nbsp;</label> <button class=\"btn btn-default btn-sm\" ng-click=\"clearLocalFilters()\" translate=\"\">Clear table filters</button></div></div><div class=\"table-card__hint\">{{visibleRecords.length}} <span translate=\"\">of</span> {{records.length}} <span translate=\"\">rows shown. Hold Ctrl (Windows) or Cmd (Mac) to select multiple.</span></div><table class=\"analytics-table\" ng-if=\"visibleRecords.length\"><thead><tr><th ng-click=\"sort.toggle(\'fo_name\')\"><span translate=\"\">FO</span> {{sort.indicator(\'fo_name\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'year\')\"><span translate=\"\">Reporting year</span> {{sort.indicator(\'year\')}}</th><th ng-click=\"sort.toggle(\'country\')\"><span translate=\"\">Country</span> {{sort.indicator(\'country\')}}</th><th ng-click=\"sort.toggle(\'product_name\')\"><span translate=\"\">Product</span> {{sort.indicator(\'product_name\')}}</th><th ng-click=\"sort.toggle(\'product_importance\')\"><span translate=\"\">Importance</span> {{sort.indicator(\'product_importance\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'volume_purchased_from_members\')\"><span translate=\"\">From members</span> {{sort.indicator(\'volume_purchased_from_members\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'volume_purchased_from_others\')\"><span translate=\"\">From others</span> {{sort.indicator(\'volume_purchased_from_others\')}}</th><th ng-click=\"sort.toggle(\'purchased_from_members_unit\')\"><span translate=\"\">Purchase unit</span> {{sort.indicator(\'purchased_from_members_unit\')}}</th><th class=\"numeric\" ng-click=\"sort.toggle(\'volume_sold\')\"><span translate=\"\">Sold</span> {{sort.indicator(\'volume_sold\')}}</th><th ng-click=\"sort.toggle(\'sold_unit\')\"><span translate=\"\">Sold unit</span> {{sort.indicator(\'sold_unit\')}}</th><th translate=\"\">Data status</th></tr></thead><tbody><tr ng-repeat=\"row in visibleRecords | orderBy:sort.expression():sort.descending\"><td>{{row.fo_name || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-invalid\': !row.year}\">{{row.year || \'--\'}}</td><td>{{row.country || \'--\'}}</td><td ng-class=\"{\'value-invalid\': !row.product_name}\">{{row.product_name || \'--\'}}</td><td>{{roleLabel(row.product_importance)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_purchased_from_members)}\">{{charts.num(row.volume_purchased_from_members)}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_purchased_from_others)}\">{{charts.num(row.volume_purchased_from_others)}}</td><td ng-class=\"{\'value-invalid\': !purchaseUnit(row)}\">{{purchaseUnit(row) || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': charts.isMissing(row.volume_sold)}\">{{charts.num(row.volume_sold)}}</td><td ng-class=\"{\'value-invalid\': !row.sold_unit}\">{{row.sold_unit || \'--\'}}</td><td><span class=\"flag-badge\" ng-repeat=\"flag in row.data_status\">{{flagLabel(flag)}}</span> <span ng-if=\"!row.data_status.length\">—</span></td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!visibleRecords.length\" translate=\"\">No production rows match the current filters.</div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/projectAnalyticsView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab overview-page\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"{{\'Toggle filters\' | translate}}\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"ov-page-head\"><div><h2 translate=\"\">Project Analytics</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li class=\"active\"><strong translate=\"\">Analytics</strong></li></ol></div><div class=\"ov-buttons\"><button type=\"button\" class=\"btn btn-sm ar-btn ar-btn--primary\" ng-click=\"exportCSV()\" ng-disabled=\"isLoading || !assessees.length\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"toggleDarkMode()\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> <span ng-if=\"!ui.darkMode\" translate=\"\">Dark Mode</span> <span ng-if=\"ui.darkMode\" translate=\"\">Light Mode</span></button></div></header><div class=\"ov-project-bar\"><div><div class=\"ov-project-name\" translate=\"\">Project: {{project.name || \'…\'}}</div><div class=\"ov-project-note\"><span ng-if=\"project.customer.name\" translate=\"\">Project owner: {{project.customer.name}}</span> <span ng-if=\"project.customer.name && overview.countries.length\">&nbsp;·&nbsp;</span> <span ng-if=\"overview.countries.length\" translate=\"\">Countries represented: {{overview.countries.join(\', \')}}</span></div></div><button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"openCustomize()\" translate=\"\">Customize overview</button></div><div class=\"ov-scope\"><span class=\"ov-dot\" aria-hidden=\"true\"></span> <span translate=\"\"><strong>Population rule:</strong> only finalised assessments in this project are included, using each FO\'s latest one. All overview metrics respond to the filters in Controls &amp; Insights.</span></div><div ng-if=\"isLoading && !overview\" class=\"loading-note\" translate=\"\">Loading the project overview…</div><div ng-if=\"loadFailed\" class=\"empty-hint\" role=\"alert\" translate=\"\">The overview could not be loaded. Reload the page to try again.</div><div ng-if=\"overview\" ng-class=\"{\'ov-stale\': isLoading}\"><section class=\"ov-section\"><div class=\"ov-section-head\"><h3 translate=\"\">Project snapshot</h3><div class=\"ov-sub\" translate=\"\">Project scale and the filtered assessment population</div></div><div class=\"ov-snapshot\"><article class=\"ov-card ov-metric\"><div class=\"ov-label\" translate=\"\">Finalised assessments</div><div class=\"ov-value\">{{population.assessment_count}}</div><div class=\"ov-detail\">{{toolBreakdown}}</div></article><article class=\"ov-card ov-metric\"><div class=\"ov-label\" translate=\"\">Assessed FOs</div><div class=\"ov-value\">{{population.fo_count}}</div><div class=\"ov-detail\" translate=\"\">Distinct producing organisations</div></article><article class=\"ov-card ov-metric\"><div class=\"ov-label\" translate=\"\">Countries</div><div class=\"ov-value\">{{overview.countries.length}}</div><div class=\"ov-detail\">{{overview.countries.join(\' · \') || \'–\'}}</div></article><article class=\"ov-card ov-metric\"><div class=\"ov-label\" translate=\"\">Assessment period</div><div class=\"ov-value ov-value--small\" ng-if=\"overview.assessment_period.first\">{{overview.assessment_period.first | date:\'d MMM yyyy\'}} – {{overview.assessment_period.last | date:\'d MMM yyyy\'}}</div><div class=\"ov-value ov-value--small\" ng-if=\"!overview.assessment_period.first\">–</div><div class=\"ov-detail\" translate=\"\">Earliest to latest matching assessment</div></article></div></section><div class=\"empty-hint\" ng-if=\"!population.fo_count\" translate=\"\">No finalised assessments match the current filters. Widen or clear the filters to see this project\'s analytics.</div><div ng-if=\"population.fo_count\"><section class=\"ov-section\"><div class=\"ov-section-head\"><h3 translate=\"\">Assessment tools</h3><div class=\"ov-sub\" translate=\"\">The filters define the population. Select one tool below for score analysis: scores from different tools are never combined.</div></div><div class=\"ov-tools\"><button type=\"button\" class=\"ov-card ov-tool\" ng-repeat=\"card in toolCards\" ng-class=\"{\'active\': card.name === scoreTool.name, \'disabled\': !card.count}\" ng-disabled=\"!card.count\" ng-click=\"selectTool(card)\" aria-pressed=\"{{card.name === scoreTool.name}}\"><span class=\"ov-symbol\" aria-hidden=\"true\">{{toolSymbol(card.name)}}</span> <span class=\"ov-tool-text\"><span class=\"ov-tool-name\">{{card.name}}</span> <span class=\"ov-sub\" ng-if=\"card.name === scoreTool.name\" translate=\"\">Selected for scores and dimensions</span> <span class=\"ov-sub\" ng-if=\"card.name !== scoreTool.name && card.count\" translate=\"\">Select to view its scores</span> <span class=\"ov-sub\" ng-if=\"!card.count\" translate=\"\">No finalised assessments in the filtered population</span></span> <span class=\"ov-tool-count\">{{card.count}}<small translate=\"\">assessments</small></span></button></div></section><div class=\"empty-hint\" ng-if=\"overview.tool_state !== \'tool_selected\'\" translate=\"\">Select an assessment tool above to see its scores.</div><div ng-if=\"overview.tool_state === \'tool_selected\'\"><section class=\"ov-section\"><div class=\"ov-section-head\"><h3 translate=\"\">{{overview.selected_tool}} performance</h3><div class=\"ov-sub\" translate=\"\">Calculated from {{overview.scored_assessment_count}} finalised assessments, using each FO\'s latest finalised assessment</div></div><div class=\"ov-analysis\" ng-class=\"{\'ov-analysis--single\': !layout.subdimensions}\"><article class=\"ov-card ov-panel\" ng-if=\"layout.totalScore || layout.a2fScore || layout.dimensionChart\"><div class=\"ov-panel-title\" translate=\"\">Average dimension scores</div><div class=\"ov-sub\" translate=\"\">Dimensions and subdimensions come from the selected assessment tool</div><div class=\"ov-score-strip\" ng-if=\"layout.totalScore || layout.a2fScore\"><div class=\"ov-score\" ng-if=\"layout.totalScore\"><span translate=\"\">Average total score</span> <strong>{{formatScore(overview.average_total_score)}}</strong></div><div class=\"ov-score\" ng-if=\"layout.a2fScore\"><span translate=\"\">Average A2F score</span> <strong>{{formatScore(overview.average_a2f_score)}}</strong></div></div><div ng-if=\"layout.dimensionChart\"><div class=\"ov-chart\" ng-if=\"dimensions.length\" role=\"list\"><div class=\"ov-bar-wrap\" ng-repeat=\"dimension in dimensions\" role=\"listitem\"><div class=\"ov-bar-score\">{{formatScore(dimension.average_score)}}</div><button type=\"button\" class=\"ov-bar\" ng-class=\"{\'active\': dimension === selectedDimension}\" ng-style=\"{height: (dimension.average_score || 0) * 40 + \'px\', background: \'var(--chart-\' + ($index % 8 + 1) + \')\'}\" ng-click=\"selectDimension(dimension)\" aria-label=\"{{dimension.subdimension}} {{formatScore(dimension.average_score)}}\"></button></div></div><div class=\"ov-bar-labels\" ng-if=\"dimensions.length\"><div class=\"ov-bar-label\" ng-repeat=\"dimension in dimensions\">{{dimension.subdimension}}</div></div><div class=\"ov-axis-note\" ng-if=\"dimensions.length\" translate=\"\">Scores use the 1 to 5 assessment scale. Select a bar for its subdimensions.</div><div class=\"empty-hint\" ng-if=\"!dimensions.length\" translate=\"\">No dimension in this population has been scored.</div></div></article><article class=\"ov-card ov-panel\" ng-if=\"layout.subdimensions && selectedDimension\"><div class=\"ov-sub-head\"><div class=\"ov-panel-title\">{{selectedDimension.subdimension}}</div><div class=\"ov-sub\" translate=\"\">Subdimension averages</div><div class=\"ov-sub-score\">{{formatScore(selectedDimension.average_score)}}</div></div><div class=\"ov-sub-list\"><div class=\"ov-sub-row\" ng-repeat=\"item in selectedSubdimensions\"><div><div class=\"ov-sub-name\">{{item.subdimension}}</div><div class=\"ov-track\"><div class=\"ov-fill\" ng-style=\"{width: (item.average_score || 0) * 20 + \'%\'}\"></div></div></div><div class=\"ov-sub-value\">{{formatScore(item.average_score)}}</div></div><div class=\"ov-sub\" ng-if=\"!selectedSubdimensions.length\" translate=\"\">No subdimension scores for this dimension.</div></div><span class=\"ov-tag\" translate=\"\">Coverage: {{selectedDimension.applicable_fo_count}} of {{selectedDimension.population_fo_count}} FOs</span></article></div></section><section class=\"ov-section\" ng-if=\"layout.maturityReach\"><div class=\"ov-two\"><article class=\"ov-card ov-panel\"><div class=\"ov-panel-title\" translate=\"\">Maturity-level distribution</div><div class=\"ov-sub\" translate=\"\">Shows the spread behind the average score</div><div class=\"ov-stacked\" ng-if=\"overview.maturity_distribution.total_fo_count\"><div class=\"ov-seg\" ng-repeat=\"level in maturityLevels\" ng-if=\"level.count\" ng-style=\"{width: level.percentage + \'%\', background: level.colour}\" title=\"{{level.name}}: {{level.percentage}}%\">{{level.percentage >= 6 ? (level.percentage | number:0) + \'%\' : \'\'}}</div></div><div class=\"ov-sub ov-gap-top\" ng-if=\"!overview.maturity_distribution.total_fo_count\" translate=\"\">No scored FOs in this population.</div><div class=\"ov-legend\"><div class=\"ov-legend-item\" ng-repeat=\"level in maturityLevels\"><div class=\"ov-legend-name\"><span class=\"ov-square\" ng-style=\"{background: level.colour}\"></span>{{level.name}}</div><div class=\"ov-legend-value\" translate=\"\">{{level.count}} FOs</div></div></div></article><article class=\"ov-card ov-panel\"><div class=\"ov-panel-title\" translate=\"\">Project reach</div><div class=\"ov-sub\" translate=\"\">Member and workforce figures across the filtered population, all tools</div><div class=\"ov-reach-grid\"><div class=\"ov-reach\"><strong>{{formatNumber(overview.reach.total_members)}}</strong><span translate=\"\">Total members</span></div><div class=\"ov-reach\"><strong>{{formatNumber(overview.reach.active_members)}}</strong><span translate=\"\">Active members</span></div><div class=\"ov-reach\"><strong>{{overview.reach.active_member_percentage === null ? \'–\' : (overview.reach.active_member_percentage | number:0) + \'%\'}}</strong> <span translate=\"\">Active membership</span></div><div class=\"ov-reach\"><strong>{{formatNumber(overview.reach.total_fte)}}</strong><span translate=\"\">Total FTE</span></div></div><div class=\"ov-sub ov-gap-top\" translate=\"\">Detailed gender, management and workforce indicators remain in <a ui-sref=\"base.projects-analytics.demographic({id: $state.params.id})\">Demographic</a>.</div></article></div></section><section class=\"ov-section\"><div class=\"ov-section-head\"><h3 translate=\"\">Strengths and gaps</h3><div class=\"ov-sub\" translate=\"\">Top five subdimensions, ranked within the selected tool and filtered population</div></div><div class=\"ov-two\"><article class=\"ov-card ov-insight\"><div class=\"ov-panel-title\" translate=\"\">Strengths</div><div class=\"ov-sub\" translate=\"\">Highest average score with at least 70% applicable-FO coverage</div><div class=\"ov-list\"><div class=\"ov-row\" ng-repeat=\"item in overview.strengths\"><span class=\"ov-rank\">{{$index + 1}}</span><div><div class=\"ov-row-name\">{{item.subdimension}}</div><div class=\"ov-meta\" translate=\"\">Applicable {{item.applicable_fo_count}}/{{item.population_fo_count}} · {{item.strong_fo_percentage | number:0}}% strong</div></div><span class=\"ov-chip\">{{formatScore(item.average_score)}}</span></div></div><p class=\"ov-sub ov-gap-top\" ng-if=\"!overview.strengths.length && overview.strengths_empty_reason === \'insufficient_coverage\'\" translate=\"\">No subdimension has enough data to report a strength.</p><p class=\"ov-sub ov-gap-top\" ng-if=\"!overview.strengths.length && overview.strengths_empty_reason === \'no_scored_subdimensions\'\" translate=\"\">No subdimension in this population has been scored.</p></article><article class=\"ov-card ov-insight\"><div class=\"ov-panel-title\" translate=\"\">Gaps</div><div class=\"ov-sub\" translate=\"\">Average below 2.5 or at least 50% of applicable FOs below 2.5</div><div class=\"ov-list\"><div class=\"ov-row\" ng-repeat=\"item in overview.gaps\"><span class=\"ov-rank\">{{$index + 1}}</span><div><div class=\"ov-row-name\">{{item.subdimension}}</div><div class=\"ov-meta\" translate=\"\">Applicable {{item.applicable_fo_count}}/{{item.population_fo_count}} · {{item.weak_fo_percentage | number:0}}% weak · {{item.weak_fo_count}} affected</div></div><span class=\"ov-chip ov-chip--low\">{{formatScore(item.average_score)}}</span></div></div><p class=\"ov-sub ov-gap-top\" ng-if=\"!overview.gaps.length && overview.gaps_empty_reason === \'no_gaps_identified\'\" translate=\"\">No gaps identified.</p><p class=\"ov-sub ov-gap-top\" ng-if=\"!overview.gaps.length && overview.gaps_empty_reason === \'no_scored_subdimensions\'\" translate=\"\">No subdimension in this population has been scored.</p></article></div></section><section class=\"ov-section\" ng-if=\"coverageMetrics.length\"><article class=\"ov-card ov-panel\"><div class=\"ov-panel-title\" translate=\"\">Data coverage</div><div class=\"ov-sub\" ng-if=\"overview.data_coverage.fiscal_year\" translate=\"\">FOs in the selected tool reporting each figure, fiscal year {{overview.data_coverage.fiscal_year}}. Detailed completeness is on the Data Quality tab.</div><div class=\"ov-sub\" ng-if=\"!overview.data_coverage.fiscal_year\" translate=\"\">FOs in the selected tool reporting each figure. Detailed completeness is on the Data Quality tab.</div><div class=\"ov-coverage\"><div class=\"ov-coverage-row\" ng-repeat=\"metric in coverageMetrics\"><span>{{metric.label | translate}}</span><div class=\"ov-track\"><div class=\"ov-fill ov-fill--teal\" ng-style=\"{width: (metric.percentage || 0) + \'%\'}\"></div></div><span class=\"ov-cover-count\">{{metric.available}}/{{metric.expected}} <span ng-if=\"metric.percentage !== null\">({{metric.percentage | number:0}}%)</span></span></div></div></article></section><section class=\"ov-section\"><div class=\"ov-section-head\"><h3 translate=\"\">Assessee list</h3><div class=\"ov-sub\" translate=\"\">Each FO\'s latest finalised assessment, limited to the selected assessment tool</div></div><div class=\"ov-card ov-table-card\"><div class=\"ov-table-toolbar\"><div class=\"ov-sub\" translate=\"\">Showing {{(assessees | filter:matchesAssesseeSearch).length}} of {{assessees.length}} assessees</div><input class=\"ar-control ov-search\" type=\"search\" ng-model=\"assesseeSearch.text\" placeholder=\"{{\'Search FO name or location\' | translate}}\" aria-label=\"{{\'Search FO name or location\' | translate}}\"></div><div class=\"ov-table-wrap\"><table class=\"ov-table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Tool</th><th translate=\"\">Country</th><th translate=\"\">City</th><th translate=\"\">Legal status</th><th translate=\"\">Inc year</th><th translate=\"\">Assessment date</th><th class=\"numeric\" translate=\"\">Total score</th><th class=\"numeric\" translate=\"\">A2F</th><th class=\"numeric\" translate=\"\">Members</th><th class=\"numeric\" translate=\"\">Active</th></tr></thead><tbody><tr ng-repeat=\"row in assessees | filter:matchesAssesseeSearch track by row.assessment_id\"><td>{{row.name || \'–\'}}</td><td><span class=\"ov-pill\">{{row.tool}}</span></td><td>{{row.country || \'–\'}}</td><td>{{row.city || \'–\'}}</td><td>{{row.legal_status || \'–\'}}</td><td>{{row.year_of_incorporation || \'–\'}}</td><td>{{row.assessment_date || \'–\'}}</td><td class=\"numeric\">{{formatScore(row.total_score)}}</td><td class=\"numeric\">{{formatScore(row.a2f_score)}}</td><td class=\"numeric\">{{formatNumber(row.number_of_members)}}</td><td class=\"numeric\">{{formatNumber(row.number_of_active_members)}}</td></tr></tbody></table><div class=\"ov-sub ov-empty-row\" ng-if=\"!(assessees | filter:matchesAssesseeSearch).length\" translate=\"\">No matching assessees.</div></div></div></section></div></div></div><footer class=\"ov-disclaimer\"><p translate=\"\"><strong>Disclaimer:</strong> The data and information presented in this dashboard are derived from assessments conducted using SCOPEinsight tools and from information provided by the assessed organisations or other data contributors. SCOPEinsight does not independently verify all information and does not guarantee its accuracy, completeness, timeliness or suitability for any particular purpose.</p><p translate=\"\">This dashboard is provided for informational and analytical purposes only. It should not be used as the sole basis for investment, financing, procurement, partnership, operational or other decisions. Users are responsible for independently validating the information and conducting their own due diligence before taking any action.</p><p translate=\"\">To the maximum extent permitted by applicable law, SCOPEinsight accepts no liability or responsibility for any loss, damage, decision or consequence arising from the use of, reliance on, or inability to use the data or information presented in this dashboard. Any decisions made based on this information are made entirely at the user\'s own risk.</p></footer></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/partials/analyticsFilters.html\'\"></div></div><div class=\"ov-modal-overlay\" ng-if=\"ui.customizeOpen\" ng-click=\"closeCustomize()\"><div class=\"ov-modal\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"ov-customize-title\" ng-click=\"$event.stopPropagation()\"><div class=\"ov-modal-head\"><div><h3 id=\"ov-customize-title\" translate=\"\">Customize overview indicators</h3><p class=\"ov-sub\" translate=\"\">Show or hide optional indicators and panels on the overview page. Saved in this browser.</p></div><button type=\"button\" class=\"ov-modal-close\" ng-click=\"closeCustomize()\" aria-label=\"{{\'Close\' | translate}}\">&times;</button></div><div class=\"ov-modal-body\"><label class=\"ov-toggle\"><input type=\"checkbox\" ng-model=\"layout.totalScore\" ng-change=\"saveLayout()\"> <span><strong translate=\"\">Average total score metric</strong><span translate=\"\">Displays the average total score in the performance panel</span></span></label> <label class=\"ov-toggle\"><input type=\"checkbox\" ng-model=\"layout.a2fScore\" ng-change=\"saveLayout()\"> <span><strong translate=\"\">Average A2F score metric</strong><span translate=\"\">Displays the Access to Finance (A2F) score</span></span></label> <label class=\"ov-toggle\"><input type=\"checkbox\" ng-model=\"layout.dimensionChart\" ng-change=\"saveLayout()\"> <span><strong translate=\"\">Dimension averages chart</strong><span translate=\"\">Displays the interactive dimension score bar chart</span></span></label> <label class=\"ov-toggle\"><input type=\"checkbox\" ng-model=\"layout.subdimensions\" ng-change=\"saveLayout()\"> <span><strong translate=\"\">Subdimension averages panel</strong><span translate=\"\">Displays the breakdown for the selected dimension</span></span></label> <label class=\"ov-toggle\"><input type=\"checkbox\" ng-model=\"layout.maturityReach\" ng-change=\"saveLayout()\"> <span><strong translate=\"\">Maturity distribution &amp; project reach</strong><span translate=\"\">Displays the maturity level spread and member reach</span></span></label></div><div class=\"ov-modal-foot\"><button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"resetLayout()\" translate=\"\">Reset to default</button> <button type=\"button\" class=\"btn btn-sm ar-btn ar-btn--primary\" ng-click=\"closeCustomize()\" translate=\"\">Done</button></div></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/reassessmentView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab reassessment-page\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Reassessment &amp; Progress</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Reassessment &amp; Progress</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Projects:</span> <span ng-if=\"applied.projects.length === 1\">{{projectName(applied.projects[0])}}</span> <span ng-if=\"applied.projects.length > 1\">{{applied.projects.length}} {{\'selected\' | translate}}</span></h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportCsv(\'summary\')\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading || !payloads[ui.tab]\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export CSV</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><nav class=\"rea-subtabs\" role=\"tablist\"><button type=\"button\" role=\"tab\" class=\"rea-subtab\" ng-repeat=\"tab in tabs\" ng-class=\"{\'rea-subtab--active\': ui.tab === tab.id}\" aria-selected=\"{{ui.tab === tab.id}}\" ng-click=\"selectTab(tab.id)\">{{tab.label | translate}}</button></nav><div class=\"rea-context\" ng-if=\"context\"><span class=\"rea-context__item\" title=\"{{context.method_description | translate}}\"><strong translate=\"\">Method</strong> {{context.method_label | translate}} <i class=\"fa fa-question-circle-o rea-muted\"></i></span> <span class=\"rea-context__item\" ng-if=\"context.score_tool\"><strong translate=\"\">Score tool</strong> {{context.score_tool}} <span class=\"rea-muted\" translate=\"\">(all versions)</span></span> <span class=\"rea-context__item\" ng-if=\"context.period\"><strong translate=\"\">Baseline</strong> {{context.period.baseline_from}} – {{context.period.baseline_to}}</span> <span class=\"rea-context__item\" ng-if=\"context.period\"><strong translate=\"\">Comparison</strong> {{context.period.comparison_from}} – {{context.period.comparison_to}}</span> <span class=\"rea-context__item\" title=\"{{\'Pairs are baseline-comparison assessment pairs; with Consecutive rounds one FO gives a pair per step.\' | translate}}\"><strong>N</strong>{{context.sample.pair_n}} {{\'pairs\' | translate}} · {{context.sample.fo_n}} {{\'FOs\' | translate}}</span></div><div class=\"rea-insight\" ng-if=\"payloads[ui.tab] && insights[ui.tab]\" ng-class=\"{\'rea-insight--empty\': insights[ui.tab].empty}\"><i class=\"fa\" ng-class=\"insights[ui.tab].empty ? \'fa-info-circle\' : \'fa-lightbulb-o\'\" aria-hidden=\"true\"></i> <span>{{insights[ui.tab].text}}</span> <span class=\"rea-lown\" ng-if=\"insights[ui.tab].lowN\" translate=\"\">Small sample: read with care</span></div><div ng-if=\"isLoading && !payloads[ui.tab]\" class=\"loading-note\" translate=\"\">Loading reassessment analytics…</div><div ng-if=\"!isLoading && loadFailed\" class=\"empty-hint\" translate=\"\">The comparison could not be loaded. Change the selection or reload the page to try again.</div><div ng-if=\"payloads[ui.tab]\" ng-switch=\"ui.tab\"><div ng-switch-when=\"overview\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/overview.html\'\"></div></div><div ng-switch-when=\"scores\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/scores.html\'\"></div></div><div ng-switch-when=\"demographics\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/demographics.html\'\"></div></div><div ng-switch-when=\"financials\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/financials.html\'\"></div></div><div ng-switch-when=\"finance-history\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/financeHistory.html\'\"></div></div><div ng-switch-when=\"production\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/production.html\'\"></div></div><div ng-switch-when=\"explorer\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/explorer.html\'\"></div></div><div ng-switch-when=\"coverage\"><div ng-include=\"\'projects/templates/projectAnalytics/reassessment/coverage.html\'\"></div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/reassessment/rail.html\'\"></div></div></main></si-page>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysisView.html","<si-page is-columnar=\"true\" class=\"analytics-page analytics-tab score-analysis-page\" ng-attr-data-theme=\"{{ui.darkMode ? \'dark\' : \'light\'}}\"><main><div class=\"analytics-shell\" ng-class=\"{\'analytics-shell--rail-closed\': ui.rightbarClosed}\"><button ng-click=\"toggleRightbar()\" class=\"rightbar-toggle-btn\" title=\"Toggle filters\"><i class=\"fa\" ng-class=\"ui.rightbarClosed ? \'fa-angle-left\' : \'fa-angle-right\'\"></i></button><div class=\"analytics-main\"><si-analytics-loader></si-analytics-loader><header class=\"si-page__header analytics-tab__header\"><h2 translate=\"\">Detailed Score Analysis</h2><ol class=\"breadcrumb analytics-breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li><a ui-sref=\"base.projects-analytics({id: $state.params.id})\" translate=\"\">Analytics</a></li><li class=\"active\"><strong translate=\"\">Detailed Score Analysis</strong></li></ol></header><div class=\"analytics-tab__topbar\"><h5><span translate=\"\">Projects:</span> <span>{{applied.projects.length}} {{\'selected\' | translate}}</span> <span class=\"sa-muted\" ng-if=\"context.tool\">· {{context.tool}} v{{context.version}} · {{context.population.question_count}} {{\'questions\' | translate}}</span></h5><div class=\"analytics-topbar-actions\"><button ng-click=\"exportCsv(\'questions\')\" class=\"btn btn-primary btn-sm\" ng-disabled=\"isLoading || !payloads.overview\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export results</span></button> <button ng-click=\"exportCsv(\'fo_scores\')\" class=\"btn btn-default btn-sm\" ng-disabled=\"isLoading || !payloads.overview\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export FO scores</span></button> <button ng-click=\"toggleDarkMode()\" class=\"btn btn-default btn-sm\"><i class=\"fa\" ng-class=\"ui.darkMode ? \'fa-sun-o\' : \'fa-moon-o\'\"></i> {{ui.darkMode ? \'Light Mode\' : \'Dark Mode\'}}</button></div></div><section class=\"table-card sa-tool-choice\"><div class=\"sa-tool-choice__fields\"><div><label class=\"ar-label\" for=\"sa-tool\" translate=\"\">Assessment tool</label><select id=\"sa-tool\" class=\"form-control input-sm\" ng-model=\"staged.tool\" ng-change=\"chooseTool()\" ng-options=\"tool.tool_type as tool.tool_type for tool in options.tools\"><option value=\"\" translate=\"\">Select an assessment tool</option></select></div><div ng-if=\"versionsFor(applied.tool).length > 1\"><label class=\"ar-label\" for=\"sa-version\" translate=\"\">Tool version</label><select id=\"sa-version\" class=\"form-control input-sm\" ng-model=\"staged.version\" ng-change=\"apply()\" ng-options=\"v.major as (\'v\' + v.major + \' · \' + v.fo_count + \' FOs\') for v in versionsFor(applied.tool)\"></select></div></div><p class=\"table-card__hint\" translate=\"\">Choose a tool to explore its dimensions, subdimensions, questions and scores. Basic, Pro and Rapid, and different major versions, are analysed separately.</p><p class=\"table-card__hint\" ng-if=\"context.population.other_version_fo_count\">{{context.population.other_version_fo_count}} {{\'FOs assessed only on another version of this tool are not included.\' | translate}}</p></section><div ng-if=\"!applied.tool\" class=\"empty-hint\" translate=\"\">Select an assessment tool. Questions, subdimensions and scoring cannot be combined across tools.</div><div ng-if=\"isLoading && !payloads.overview && applied.tool\" class=\"loading-note\" translate=\"\">Loading score analysis…</div><div ng-if=\"!isLoading && loadFailed\" class=\"empty-hint\" translate=\"\">The analysis could not be loaded. Change the selection or reload the page to try again.</div><div ng-if=\"payloads.overview\" ng-init=\"o = payloads.overview\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Farmer organisations</div><div class=\"metric-value\">{{payloads.overview.kpis.fo_count}}</div><div class=\"metric-note\">{{payloads.overview.context.tool}} v{{payloads.overview.context.version}} · {{\'latest finalised assessment each\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Mean overall score</div><div class=\"metric-value\">{{charts.two(payloads.overview.kpis.overall.mean)}}</div><div class=\"metric-note\">{{\'Median\' | translate}} {{charts.two(payloads.overview.kpis.overall.median)}} · N={{payloads.overview.kpis.overall.n}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">FOs below 2.5 overall</div><div class=\"metric-value\">{{charts.pct(payloads.overview.kpis.overall.weak_pct, 0)}}</div><div class=\"metric-note\">{{payloads.overview.kpis.overall.weak_n}} / {{payloads.overview.kpis.overall.n}} {{\'scored FOs\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Weak questions</div><div class=\"metric-value metric-value--text\">{{payloads.overview.kpis.weak_questions}} / {{payloads.overview.kpis.question_count}}</div><div class=\"metric-note\" translate=\"\">Questions with a mean below 2.5</div></article></div><nav class=\"sa-views\" role=\"tablist\"><button type=\"button\" role=\"tab\" class=\"sa-view\" ng-repeat=\"view in views\" ng-class=\"{\'sa-view--active\': ui.view === view.id}\" aria-selected=\"{{ui.view === view.id}}\" ng-click=\"selectView(view.id)\">{{view.label | translate}}</button></nav><div ng-switch=\"ui.view\"><div ng-switch-when=\"explorer\"><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/explorer.html\'\"></div></div><div ng-switch-when=\"priorities\"><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/priorities.html\'\"></div></div><div ng-switch-when=\"segments\"><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/segments.html\'\"></div></div><div ng-switch-when=\"heatmap\"><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/heatmap.html\'\"></div></div><div ng-switch-when=\"progress\"><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/progress.html\'\"></div></div></div></div></div><div class=\"analytics-rail\" ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/rail.html\'\"></div></div><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/drawer.html\'\"></div><div ng-include=\"\'projects/templates/projectAnalytics/scoreAnalysis/foProfile.html\'\"></div></main></si-page>");
$templateCache.put("projects/templates/website/projectCreateWebsite.html","<div class=\"col-lg-10\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"row\"><project-progress-steps step=\"1\"></project-progress-steps></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">New Project</h5><div class=\"ibox-tools\"><span class=\"label label-danger\" translate=\"\">Draft</span></div></div><div class=\"ibox-content\"><form name=\"projectForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><translate>Project Name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"project.name\" name=\"name\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"customers.results.length > 1\"><label class=\"col-sm-2 control-label\"><translate>Client Name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><select class=\"form-control\" chosen=\"\" ng-model=\"project.customer\" ng-options=\"customer.url as (customer.name) for customer in customers.results\" style=\"width: 100%\" ng-change=\"updateContacts()\" required=\"\"><option value=\"project.customer.url\">{{ project.customer.name }}</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><translate>Project Owner</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><select class=\"form-control\" chosen=\"\" ng-model=\"project.contact\" ng-options=\"contact.url as (contact.user | username) for contact in contacts.results\" style=\"width: 100%\" required=\"\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"\">Project Members</label><div class=\"col-sm-10\"><select chosen=\"\" multiple=\"\" ng-options=\"contact as (contact.user | username) for contact in contacts.results\" ng-model=\"project.customer_members\" style=\"width: 100%\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><translate>Start date</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><si-datepicker name=\"start_date\" ng-model=\"project.start_date\" is-required=\"true\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><translate>Deadline</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><si-datepicker name=\"deadline\" ng-model=\"project.deadline\" is-required=\"true\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><translate>Description</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-10\"><textarea class=\"form-control\" ng-model=\"project.description\" name=\"description\"></textarea></div></div><div class=\"form-group\"><div class=\"col-sm-10 col-sm-offset-2\"><span ng-show=\"projectForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveProject()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"projectForm.$invalid\"> <a class=\"btn btn-default\" ui-sref=\"base.projects\" translate=\"\">Cancel</a></div></div></form></div></div></div></div></div></div>");
$templateCache.put("projects/templates/website/projectDetailWebsite.html","<div class=\"col-lg-11\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"row\"><project-progress-steps step=\"project.step\"></project-progress-steps></div><div class=\"row\"><div class=\"col-sm-12 col-lg-8\"><section class=\"ibox\"><header class=\"ibox-title\"><h5 translate=\"\">Project Details</h5></header><main class=\"ibox-content\"><table class=\"project-details-table table table-hover\"><tbody><tr><th translate=\"\">Project Name</th><td ng-bind=\"project.name\"></td></tr><tr><th translate=\"\">Status</th><td ng-if=\"project.draft_assessments.objects.length < 0 && project.is_draft\">Add assessments</td><td ng-if=\"project.draft_assessments.objects.length > 0 && project.is_draft && !project.submitted_for_approval\" translate=\"\">Ready for Approval</td><td ng-if=\"project.is_draft && project.submitted_for_approval\" translate=\"\">Submitted for Approval</td><td ng-if=\"!project.is_draft && !project.declined\" translate=\"\">Approved</td><td ng-if=\"!project.is_draft && project.declined\" translate=\"\">Declined</td></tr><tr><th translate=\"\">Deadline</th><td>{{ project.deadline | date:\'dd-MM-yyyy\' }}</td></tr><tr ng-if=\"project.members.objects.length\"><th translate=\"\">Members</th><td><div ng-repeat=\"member in project.members.objects\" class=\"text-navy\">{{ member.user | username}}<span ng-if=\"!$last\">,</span></div></td></tr></tbody></table></main></section></div><div class=\"col-sm-12 col-lg-4\" style=\"margin-bottom: 5px;\" ng-if=\"!project.submitted_for_approval\"><a class=\"btn btn-danger\" ng-click=\"deleteProject()\"><i class=\"fa fa-trash\"></i><translate>Delete project</translate></a></div><div class=\"col-sm-12 col-lg-4\" ng-if=\"project.draft_assessments.objects.length && !project.submitted_for_approval\"><a class=\"btn btn-primary\" ng-click=\"submitProject()\"><i class=\"fa fa-send\"></i><translate>Submit project</translate></a></div></div><div class=\"row\"><div class=\"col-sm-12\"><section class=\"ibox\"><header class=\"ibox-title\"><h5 translate=\"\">Assessments</h5><div class=\"ibox-tools\" ng-if=\"!project.submitted_for_approval\"><a class=\"btn btn-primary btn-xs\" ui-sref=\"base.projects-add-assessment({id: project.id})\"><i class=\"fa fa-plus\"></i><translate>Add assessment</translate></a></div></header><main class=\"ibox-content\"><table class=\"table table-hover\" ng-if=\"project.is_draft && !project.declined\"><thead><tr><th translate=\"\">Producer Organization Name</th><th translate=\"\">Country</th><th translate=\"\">Global Region</th><th translate=\"\" class=\"text-center\">Planned Assessment Date</th><th translate=\"\" class=\"text-center\">Progress</th></tr></thead><tbody><tr ng-repeat=\"assessment in project.draft_assessments.objects\"><td ng-bind=\"assessment.producing_organization_name\"></td><td ng-bind=\"assessment.country\"></td><td ng-bind=\"assessment.global_region\"></td><td ng-bind=\"assessment.deadline\"></td><td><small><translate>Completion with</translate>: <span ng-if=\"project.is_draft\">0</span></small><div class=\"progress progress-mini\"><div ng-if=\"project.is_draft\" class=\"progress-bar\" style=\"width: 1%;\"></div></div></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"!project.is_draft && !project.declined\"><thead><tr><th translate=\"\">Producer Organization Name</th><th translate=\"\" class=\"text-center\">Date</th><th translate=\"\" class=\"text-center\">Progress</th><th translate=\"\" class=\"text-center\" ng-if=\"!project.is_draft && assessment.report.objects\">View</th></tr></thead><tbody><tr ng-repeat=\"assessment in project.assessments.objects\"><td ng-bind=\"assessment.producing_organization_name\"></td><td ng-bind=\"assessment.date\"></td><td><small><translate>Completion with</translate>: <span ng-if=\"!project.is_draft\" ng-bind=\"assessment.progress\"></span></small><div class=\"progress progress-mini\"><div ng-if=\"!project.is_draft\" class=\"progress-bar\" style=\"width: {{assessment.progress}}%;\"></div></div></td><td class=\"project-actions\" ng-if=\"!project.is_draft && assessment.report.objects\"><div class=\"dropdown\" uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"><translate>Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" style=\"color: white;\"><li ng-if=\"!assessment.report.finalization_requested\"><a class=\"btn btn-info btn-sm\" ng-click=\"submitReportFinalization(assessment.report)\"><i class=\"fa fa-send\"></i><translate>Submit Report</translate></a></li><li><a class=\"btn btn-warning btn-sm\" ng-click=\"$state.go(\'base.reports-detail.summary\',({id: assessment.reports.id}))\"><i class=\"fa fa-pie-chart\"></i><translate>View Report</translate></a></li></ul></div></td></tr></tbody></table></main></section></div></div><div class=\"row\"><div class=\"col-sm-12\"><paginated items=\"assesments\" items-per-page=\"10\"></paginated></div></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/partials/analyticsFilters.html","<aside class=\"rightbar analytics-rightbar ar\" ng-class=\"{\'rightbar--closed\': ui.rightbarClosed}\"><h4 class=\"ar-title\" translate=\"\">Controls &amp; Insights</h4><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'filters\')\" aria-expanded=\"{{rail.filters}}\"><span translate=\"\">Filters</span> <i class=\"fa\" ng-class=\"rail.filters ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.filters\"><div class=\"ar-group\"><label class=\"ar-label\" for=\"ar-min-score\" translate=\"\">Score range</label><div class=\"ar-range\"><input id=\"ar-min-score\" class=\"ar-control\" type=\"number\" min=\"1\" max=\"5\" step=\"0.1\" ng-model=\"filters.currentMinRange\" aria-label=\"{{\'Minimum score\' | translate}}\"> <span aria-hidden=\"true\">-</span> <input class=\"ar-control\" type=\"number\" min=\"1\" max=\"5\" step=\"0.1\" ng-model=\"filters.currentMaxRange\" aria-label=\"{{\'Maximum score\' | translate}}\"></div><div class=\"ar-scale\" aria-hidden=\"true\"><div class=\"ar-scale__fill\" ng-style=\"{left: ((filters.currentMinRange || 1) - 1) * 25 + \'%\', right: (5 - (filters.currentMaxRange || 5)) * 25 + \'%\'}\"></div></div><div class=\"ar-hint\" translate=\"\">Assessments without a score are excluded when this range is narrowed.</div></div><div class=\"ar-group\"><label class=\"ar-label\" translate=\"\">Assessment date range</label><div class=\"ar-dates\"><input class=\"ar-control\" type=\"date\" ng-model=\"filters.startDate\" aria-label=\"{{\'Start date\' | translate}}\"> <input class=\"ar-control\" type=\"date\" ng-model=\"filters.endDate\" aria-label=\"{{\'End date\' | translate}}\"></div></div><div class=\"ar-group\" ng-if=\"toolTypeOptions.length\"><label class=\"ar-label\" translate=\"\">Tool type</label><div class=\"ar-checks\"><label class=\"ar-check\" ng-repeat=\"option in toolTypeOptions\"><input type=\"checkbox\" ng-checked=\"isFilterValueSelected(\'tool_type\', option)\" ng-click=\"toggleFilterValue(\'tool_type\', option)\"> <span>{{option}}</span> <span class=\"ar-count\" ng-if=\"toolTypeCounts[option] !== undefined\">{{toolTypeCounts[option]}}</span></label></div><div class=\"ar-hint\" translate=\"\">None ticked means every tool. Filters the shared project population; score analysis remains separated by tool.</div></div><div class=\"ar-group\" ng-if=\"countryOptions.length > 1\"><label class=\"ar-label\" translate=\"\">Country</label><div class=\"ar-checks\"><label class=\"ar-check\" ng-repeat=\"option in countryOptions\"><input type=\"checkbox\" ng-checked=\"isFilterValueSelected(\'country\', option)\" ng-click=\"toggleFilterValue(\'country\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\" ng-if=\"valueChainOptions.length > 1\"><label class=\"ar-label\" translate=\"\">Value chain</label><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"option in valueChainOptions\"><input type=\"checkbox\" ng-checked=\"isFilterValueSelected(\'value_chain\', option)\" ng-click=\"toggleFilterValue(\'value_chain\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\"><label class=\"ar-label\" translate=\"\">Quick score filters</label><div class=\"ar-quick\"><button type=\"button\" ng-class=\"{\'active\': isQuickLevelActive(null)}\" ng-click=\"setQuickLevel(null)\" translate=\"\">All data</button> <button type=\"button\" ng-repeat=\"level in quickLevels\" ng-class=\"{\'active\': isQuickLevelActive(level.value)}\" ng-click=\"setQuickLevel(level.value)\" title=\"{{level.title}}\">{{level.label}}</button></div><div class=\"ar-hint\" translate=\"\">A score of exactly 2, 3 or 4 belongs to the higher level.</div></div><div class=\"ar-group\" ng-if=\"showCurrencyFilter\"><label class=\"ar-label\" translate=\"\">Reporting currency</label><select class=\"ar-control\" ng-model=\"filters.currency\" ng-options=\"currency as currency for currency in availableCurrencies\"></select><div class=\"ar-hint\" translate=\"\">Changes how monetary values are expressed. Records not available in the selected currency are excluded and reported on the tab.</div></div><div class=\"ar-errors\" ng-if=\"filterErrorList.length\" role=\"alert\"><div ng-repeat=\"message in filterErrorList\">{{message}}</div></div><div class=\"ar-actions\"><button type=\"button\" class=\"btn btn-sm ar-btn ar-btn--primary\" ng-click=\"applyFilters()\" ng-disabled=\"isLoading\">&#10003; <span translate=\"\">Apply filters</span></button> <button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"clearFilters()\" ng-disabled=\"isLoading\">&times; <span translate=\"\">Clear</span></button></div><div class=\"ar-status\" ng-if=\"railNotice\" role=\"status\" translate=\"\">Filters applied across all analytics tabs.</div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'population\')\" aria-expanded=\"{{rail.population}}\"><span translate=\"\">Population</span> <i class=\"fa\" ng-class=\"rail.population ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.population\"><div class=\"ar-pop\"><span translate=\"\">FOs matching filters</span> <strong>{{population ? population.fo_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Finalised assessments</span> <strong>{{population ? population.assessment_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Tools represented</span> <strong>{{population && population.tool_types ? population.tool_types.length : \'–\'}}</strong></div><div class=\"ar-pop\" ng-if=\"showCurrencyFilter && population\"><span translate=\"\">Reporting currency</span> <strong>{{population.currency}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Active filters</span> <strong ng-if=\"!filterChips.length\" translate=\"\">All data</strong> <strong ng-if=\"filterChips.length\">{{filterChips.length}}</strong></div><div class=\"ar-chips\" ng-if=\"filterChips.length\"><span class=\"ar-chip\" ng-repeat=\"chip in filterChips\">{{chip.label}} <button type=\"button\" ng-click=\"removeFilterChip(chip)\" aria-label=\"{{\'Remove filter\' | translate}} {{chip.label}}\">&times;</button></span></div></div></section><section class=\"ar-box\" ng-if=\"dataQualityHints.length\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'hints\')\" aria-expanded=\"{{rail.hints}}\"><span translate=\"\">Data quality hints</span> <i class=\"fa\" ng-class=\"rail.hints ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.hints\"><div class=\"ar-hint ar-hint--plain\" ng-repeat=\"hint in dataQualityHints\">{{hint}}</div></div></section><section class=\"ar-box\" ng-if=\"tabDefinition\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'definition\')\" aria-expanded=\"{{rail.definition}}\"><span translate=\"\">Definition</span> <i class=\"fa\" ng-class=\"rail.definition ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.definition\"><div class=\"ar-hint ar-hint--plain\">{{tabDefinition | translate}}</div></div></section></aside>");
$templateCache.put("projects/templates/projectAnalytics/partials/analyticsLoader.html","<div class=\"pa-loader pa-loader--hidden\" role=\"presentation\"><div class=\"pa-loader__flash\"></div><section class=\"pa-loader__overlay\" aria-busy=\"true\"><div class=\"pa-loader__shell\"><div class=\"pa-loader__stage\"><canvas class=\"pa-loader__scene\" aria-hidden=\"true\"></canvas><div class=\"pa-loader__hud\" style=\"--p:0\"><div class=\"pa-loader__ticks\" aria-hidden=\"true\"></div><div class=\"pa-loader__arc\" aria-hidden=\"true\"></div><div class=\"pa-loader__arc-head\" aria-hidden=\"true\"></div><div class=\"pa-loader__core\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\"><div class=\"pa-loader__percentage\" aria-hidden=\"true\"><span class=\"pa-loader__value\">0</span>%</div><div class=\"pa-loader__headline\"></div><div class=\"pa-loader__steps\" aria-hidden=\"true\"></div></div></div></div><div class=\"pa-loader__subcopy\"></div><div class=\"pa-loader__note\" translate=\"\">This may take a few moments for larger projects.</div><div class=\"pa-loader__sr\" aria-live=\"polite\"></div></div></section></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/coverage.html","<div ng-init=\"p = payloads.coverage\"><div class=\"kpi-row metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Unique FOs</div><div class=\"metric-value\">{{p.coverage.total_fos}}</div><div class=\"metric-note\">{{p.coverage.assessment_count}} {{\'finalised assessments\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Assessed once / reassessed</div><div class=\"metric-value metric-value--text\">{{p.coverage.single_assessment_fos}} / {{p.coverage.reassessed_fos}}</div><div class=\"metric-note\">{{charts.pct(p.coverage.reassessment_coverage_pct)}} {{\'reassessed\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Comparable on scores</div><div class=\"metric-value\">{{p.coverage.score_comparable_fos}}</div><div class=\"metric-note\">{{\'FOs\' | translate}} · {{p.coverage.score_comparable_pairs}} {{\'pairs\' | translate}} · {{p.coverage.score_tool || \'--\'}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Compared across tool versions</div><div class=\"metric-value\">{{p.coverage.cross_version_fos}}</div><div class=\"metric-note\">{{\'FOs, compared normally\' | translate}} · {{p.coverage.mixed_tool_fos}} {{\'FOs assessed with more than one tool type\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">FOs in several selected projects</div><div class=\"metric-value\">{{p.coverage.cross_project_fos}}</div><div class=\"metric-note\" translate=\"\">Counted once</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Excluded assessments</div><div class=\"metric-value\">{{p.coverage.excluded_assessment_count}}</div><div class=\"metric-note\">{{p.coverage.duplicate_records}} {{\'duplicates\' | translate}} · {{p.coverage.missing_sequence_records}} {{\'without a date\' | translate}}</div></article></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Score availability and comparability</div><div class=\"table-card__hint\" translate=\"\">Availability counts every valid score; comparability needs the same tool type and a valid score at both ends. A version difference is shown, never excluded.</div><table class=\"analytics-table\"><tbody><tr><td translate=\"\">Assessments in the score tool</td><td class=\"numeric\">{{p.scores.assessment_n}}</td></tr><tr><td translate=\"\">… with a valid score</td><td class=\"numeric\">{{p.scores.scored_assessment_n}}</td></tr><tr><td translate=\"\">Pairs in the score tool</td><td class=\"numeric\">{{p.scores.pair_n}}</td></tr><tr><td translate=\"\">… with a valid score at both ends</td><td class=\"numeric\">{{p.scores.scored_pair_n}}</td></tr><tr><td><strong translate=\"\">Comparable score pairs</strong></td><td class=\"numeric\"><strong>{{p.scores.comparable_pair_n}}</strong> <span class=\"rea-muted\">{{p.scores.comparable_fo_n}} {{\'FOs\' | translate}}</span></td></tr><tr><td translate=\"\">… of which across tool versions (informational)</td><td class=\"numeric\">{{p.scores.cross_version_pair_n}}</td></tr><tr ng-repeat=\"row in p.scores.excluded\"><td>{{\'Not a score pair\' | translate}}: {{reasonLabel(row.reason)}}</td><td class=\"numeric\">{{row.pairs}}</td></tr></tbody></table></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Data completeness by domain</div><div class=\"chart-card__hint\" translate=\"\">Share of comparison pairs with data on both sides.</div><div id=\"reaCoverageDomains\" class=\"chart-body chart-body--short\"></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FOs by number of rounds</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Rounds</th><th class=\"numeric\" translate=\"\">FOs</th></tr></thead><tbody><tr ng-repeat=\"row in p.coverage.fos_by_rounds\"><td>{{row.rounds}}</td><td class=\"numeric\">{{row.fo_count}}</td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Missing baseline and follow-up data</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Domain</th><th class=\"numeric\" translate=\"\">Pairs</th><th class=\"numeric\" translate=\"\">Both sides</th><th class=\"numeric\" translate=\"\">Baseline missing</th><th class=\"numeric\" translate=\"\">Follow-up missing</th><th class=\"numeric\" translate=\"\">Complete</th></tr></thead><tbody><tr ng-repeat=\"d in p.domains\"><td>{{d.label | translate}}</td><td class=\"numeric\">{{d.pairs}}</td><td class=\"numeric\">{{d.both}}</td><td class=\"numeric\">{{d.baseline_missing}}</td><td class=\"numeric\">{{d.comparison_missing}}</td><td class=\"numeric\">{{charts.pct(d.both_pct)}}</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Sample size per indicator</div><div class=\"analytics-topbar-actions rea-table-actions\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'summary\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export</span></button></div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Domain</th><th translate=\"\">Indicator</th><th class=\"numeric\">N</th></tr></thead><tbody><tr ng-repeat=\"row in p.indicators\" ng-class=\"{\'rea-lown-row\': lowN(row.n)}\"><td>{{row.domain | translate}}</td><td>{{row.indicator | translate}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': !row.n}\">{{row.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.n)\" translate=\"\">Small N</span></td></tr></tbody></table></div><div class=\"table-card\" ng-if=\"p.cross_version_pairs.length\"><div class=\"table-card__title\">{{\'Pairs compared across tool versions\' | translate}} ({{p.cross_version_pairs.length}})</div><div class=\"table-card__hint\" translate=\"\">Informational: these pairs are in every score figure.</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">FO</th><th translate=\"\">Rounds</th><th translate=\"\">Versions</th></tr></thead><tbody><tr ng-repeat=\"row in p.cross_version_pairs | limitTo: 200\"><td><a class=\"dq-link\" ng-click=\"selectTab(\'explorer\'); openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.step}}</td><td>v{{row.baseline_version}} → v{{row.comparison_version}}</td></tr></tbody></table></div><div class=\"table-card\" ng-if=\"p.coverage.pair_exclusions.length || p.incompatible_pairs.length\"><div class=\"table-card__title\" translate=\"\">Pairs not compared on scores</div><div class=\"table-card__hint\"><span ng-repeat=\"r in p.coverage.pair_exclusions\">{{reasonLabel(r.reason)}}: {{r.fo_count}} {{\'FOs\' | translate}}<span ng-if=\"!$last\">·</span></span></div><table class=\"analytics-table\"><thead><tr><th translate=\"\">FO</th><th translate=\"\">Rounds</th><th translate=\"\">Versions</th><th translate=\"\">Reasons</th></tr></thead><tbody><tr ng-repeat=\"row in p.incompatible_pairs\"><td><a class=\"dq-link\" ng-click=\"selectTab(\'explorer\'); openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.step}}</td><td>{{row.baseline_version}} → {{row.comparison_version}}</td><td><span class=\"flag-badge\" ng-repeat=\"reason in row.reasons\">{{reasonLabel(reason)}}</span></td></tr></tbody></table></div><div class=\"charts-row charts-row--two\"><div class=\"table-card\"><div class=\"table-card__title\">{{\'Missing financial years\' | translate}} ({{p.missing_fiscal_years.length}})</div><table class=\"analytics-table\"><tbody><tr ng-repeat=\"row in p.missing_fiscal_years | limitTo: 100\"><td><a class=\"dq-link\" ng-click=\"selectTab(\'explorer\'); openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.step}}</td><td>{{reasonLabel(row.reason)}}</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\">{{\'No comparable production year\' | translate}} ({{p.missing_production_years.length}})</div><table class=\"analytics-table\"><tbody><tr ng-repeat=\"row in p.missing_production_years | limitTo: 100\"><td><a class=\"dq-link\" ng-click=\"selectTab(\'explorer\'); openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.step}}</td></tr></tbody></table></div></div><div class=\"table-card\" ng-if=\"p.unit_review.length || p.section_review.length\"><div class=\"table-card__title\" translate=\"\">Data-quality review</div><div class=\"table-card__hint\" translate=\"\">Units and sections the normalisation could not settle on its own. Records are never changed.</div><div class=\"analytics-topbar-actions rea-table-actions\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'review\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export review list</span></button></div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Area</th><th translate=\"\">Item</th><th translate=\"\">Issue</th><th translate=\"\">Detail</th></tr></thead><tbody><tr ng-repeat=\"u in p.unit_review\"><td translate=\"\">Unit</td><td>{{u.unit || \'--\'}}</td><td><span class=\"flag-badge\">{{reasonLabel(u.review)}}</span></td><td class=\"rea-muted\">{{u.note}} ({{u.records}} {{\'records\' | translate}})</td></tr><tr ng-repeat=\"r in p.section_review\"><td translate=\"\">Section</td><td>{{r.title}}</td><td><span class=\"flag-badge\">{{reasonLabel(r.issue)}}</span></td><td class=\"rea-muted\"><span ng-if=\"r.assessment_id\">#{{r.assessment_id}}</span>{{(r.source_titles || []).join(\', \')}}</td></tr></tbody></table></div><div class=\"charts-row charts-row--two\"><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Incomplete sales totals</div><div class=\"table-card__hint\" translate=\"\">Pairs whose sales total is left out because a component could not be valued.</div><table class=\"analytics-table\"><tbody><tr ng-repeat=\"c in p.sales_value_incomplete.causes\"><td>{{reasonLabel(c.cause)}}</td><td class=\"numeric\">{{c.pairs}}</td></tr><tr ng-if=\"!p.sales_value_incomplete.causes.length\"><td class=\"empty-hint\" translate=\"\">Every sales total is complete.</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Youth share, baseline side</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Indicator</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Reported</th><th class=\"numeric\" translate=\"\">Missing</th><th class=\"numeric\" translate=\"\">Not applicable</th><th class=\"numeric\" translate=\"\">Invalid</th></tr></thead><tbody><tr ng-repeat=\"row in p.youth_states\"><td>{{row.label | translate}}</td><td class=\"numeric\">{{row.n}}</td><td class=\"numeric\">{{row.states.baseline.reported}}</td><td class=\"numeric\">{{row.states.baseline.missing}}</td><td class=\"numeric\">{{row.states.baseline.not_applicable}}</td><td class=\"numeric\">{{row.states.baseline.invalid}}</td></tr></tbody></table></div></div></div><div class=\"table-card\"><div class=\"table-card__title\">{{\'Excluded assessments\' | translate}} ({{p.excluded.length}})</div><div class=\"table-card__hint\"><span ng-repeat=\"r in p.coverage.excluded_by_reason\">{{r.label | translate}}: {{r.count}}<span ng-if=\"!$last\">·</span></span></div><div class=\"analytics-topbar-actions rea-table-actions\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'excluded\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export excluded</span></button></div><table class=\"analytics-table\"><thead><tr><th class=\"numeric\" translate=\"\">Assessment</th><th translate=\"\">FO</th><th translate=\"\">Project</th><th translate=\"\">Date</th><th translate=\"\">Tool</th><th translate=\"\">Reason</th></tr></thead><tbody><tr ng-repeat=\"row in p.excluded | limitTo: 200\"><td class=\"numeric\">#{{row.assessment_id}}</td><td><a class=\"dq-link\" ng-if=\"row.fo_id\" ng-href=\"{{foHref(row.fo_id)}}\" target=\"_blank\">{{row.fo_name}}</a></td><td>{{row.project_name}}</td><td>{{row.date || \'--\'}}</td><td>{{row.tool_type}}</td><td>{{row.label | translate}}</td></tr></tbody></table></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/demographics.html","<div ng-init=\"p = payloads.demographics\"><div class=\"section-intro\"><span translate=\"\">Totals are summed over the pairs that reported the indicator in both assessments, so baseline and latest cover the same FOs. A reported zero counts. Percentage change is not shown from a zero baseline; the female and youth shares change in percentage points.</span> <span translate=\"\">A youth share counts only where it was reported at both ends: 0% is reported, a missing share is not, and a category of size 0 has no share (not applicable).</span></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Totals, baseline vs latest</div><div id=\"reaDemographicsTotals\" class=\"chart-body\"></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Demographic indicators</div><div class=\"table-card__hint\" translate=\"\">Every N is in pairs, and each series has its own N.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Indicator</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline total</th><th class=\"numeric\" translate=\"\">Latest total</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\" translate=\"\">Change %</th><th class=\"numeric\" translate=\"\">Female</th><th class=\"numeric\" translate=\"\">Male</th><th class=\"numeric\" translate=\"\">Female share (pp)</th><th class=\"numeric\" translate=\"\">Youth share (pp)</th><th translate=\"\">Youth share at baseline</th><th translate=\"\">Average by round (all rounds)</th></tr></thead><tbody><tr ng-repeat=\"row in p.indicators\" ng-class=\"{\'rea-lown-row\': lowN(row.total.n)}\"><td><strong>{{row.label | translate}}</strong></td><td class=\"numeric\">{{row.total.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.total.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.num(row.total.baseline_total)}}</td><td class=\"numeric\">{{charts.num(row.total.latest_total)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.total.mean_change)\">{{fmt.signed(row.total.total_change, 0)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.total.total_change_pct)\">{{fmt.signed(row.total.total_change_pct, 1, \'%\')}}</td><td class=\"numeric\">{{fmt.signed(row.female.total_change, 0)}} <span class=\"rea-muted\">N={{row.female.n}}</span></td><td class=\"numeric\">{{fmt.signed(row.male.total_change, 0)}} <span class=\"rea-muted\">N={{row.male.n}}</span></td><td class=\"numeric\">{{fmt.signed(row.female_share_pp.mean_change, 1, \' pp\')}} <span class=\"rea-muted\">N={{row.female_share_pp.n}}</span></td><td class=\"numeric\">{{fmt.signed(row.youth_pct_pp.mean_change, 1, \' pp\')}} <span class=\"rea-muted\">N={{row.youth_pct_pp.n}}</span><span class=\"rea-lown\" ng-if=\"lowN(row.youth_pct_pp.n)\" translate=\"\">Small N</span></td><td class=\"rea-trend\"><span ng-repeat=\"(state, count) in row.youth_states.baseline\" ng-if=\"count\">{{reasonLabel(state)}}: {{count}}<span ng-if=\"!$last\">·</span></span></td><td class=\"rea-trend\"><span ng-repeat=\"point in row.trend\">R{{point.round}} {{charts.num(point.mean)}} (N={{point.n}})<span ng-if=\"!$last\">·</span></span></td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FO comparisons</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables.demographics.search\" ng-change=\"tables.demographics.page = 0\" placeholder=\"{{\'Search FO, country or value chain\' | translate}}\"></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'fos\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export FOs</span></button></div></div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'demographics\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'demographics\', \'fo_name\')\"></i></th><th translate=\"\">Compared</th><th class=\"numeric rea-sortable\" ng-repeat=\"row in p.indicators\" ng-click=\"sortTable(\'demographics\', row.key + \'.change\')\"><span>{{row.label | translate}}</span><i class=\"fa\" ng-class=\"sortClass(\'demographics\', row.key + \'.change\')\"></i></th><th class=\"numeric\" translate=\"\">Members youth %</th></tr></thead><tbody><tr ng-repeat=\"fo in pageRows(\'demographics\', p.fos) track by $index\"><td class=\"rea-fo\"><a class=\"dq-link\" title=\"{{fo.fo_name}}\" ng-click=\"selectTab(\'explorer\'); openFo(fo.fo_id)\">{{fo.fo_name}}</a></td><td class=\"rea-muted\">{{fo.baseline_date}} → {{fo.comparison_date}}</td><td class=\"numeric\" ng-repeat=\"row in p.indicators\"><span ng-if=\"fo[row.key].change !== null\" ng-class=\"fmt.changeClass(fo[row.key].change)\">{{charts.num(fo[row.key].baseline)}} → {{charts.num(fo[row.key].latest)}}</span> <span ng-if=\"fo[row.key].change === null\" class=\"value-missing\">--</span></td><td class=\"numeric\"><span ng-if=\"fo.membership.youth_change_pp !== null\">{{charts.pct(fo.membership.youth_baseline)}} → {{charts.pct(fo.membership.youth_latest)}}</span> <span ng-if=\"fo.membership.youth_change_pp === null\" class=\"value-missing\" title=\"{{reasonLabel(fo.membership.youth_state_baseline)}} → {{reasonLabel(fo.membership.youth_state_latest)}}\">--</span></td></tr><tr ng-if=\"!pageInfo(\'demographics\', p.fos).total\"><td colspan=\"12\" class=\"empty-hint\" translate=\"\">No FO matches.</td></tr></tbody></table></div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'demographics\', p.fos).from}}–{{pageInfo(\'demographics\', p.fos).to}} / {{pageInfo(\'demographics\', p.fos).total}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'demographics\', -1, p.fos)\" ng-disabled=\"!pageInfo(\'demographics\', p.fos).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'demographics\', 1, p.fos)\" ng-disabled=\"pageInfo(\'demographics\', p.fos).page >= pageInfo(\'demographics\', p.fos).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/explorer.html","<div ng-init=\"p = payloads.explorer\"><div class=\"table-card\" ng-if=\"!explorer.detail\"><div class=\"table-card__title\" translate=\"\">FOs</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables.explorer.search\" ng-change=\"tables.explorer.page = 0\" placeholder=\"{{\'Search FO, country or value chain\' | translate}}\"></div><div class=\"table-filters__group\"><select class=\"form-control input-sm\" ng-model=\"explorer.direction\" ng-change=\"tables.explorer.page = 0\"><option value=\"\" translate=\"\">All FOs</option><option value=\"improved\" translate=\"\">Improved</option><option value=\"unchanged\" translate=\"\">Unchanged</option><option value=\"declined\" translate=\"\">Declined</option><option value=\"not_comparable\" translate=\"\">Not comparable on scores</option><option value=\"version_differs\" translate=\"\">Compared across tool versions</option></select></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'summary\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export</span></button></div></div><div class=\"table-card__hint\">{{tableRows(\'explorer\', explorerRows()).length}} / {{p.fos.length}} {{\'FOs\' | translate}} · {{\'Scores in\' | translate}} {{p.context.score_tool || \'--\'}}</div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'explorer\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'explorer\', \'fo_name\')\"></i></th><th class=\"rea-sortable\" ng-click=\"sortTable(\'explorer\', \'country\')\"><span translate=\"\">Country</span><i class=\"fa\" ng-class=\"sortClass(\'explorer\', \'country\')\"></i></th><th translate=\"\">Value chain</th><th translate=\"\">Projects</th><th class=\"numeric rea-sortable\" ng-click=\"sortTable(\'explorer\', \'rounds\')\"><span translate=\"\">Rounds</span><i class=\"fa\" ng-class=\"sortClass(\'explorer\', \'rounds\')\"></i></th><th translate=\"\">Assessed</th><th translate=\"\">Tools</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric rea-sortable\" ng-click=\"sortTable(\'explorer\', \'score_change\')\"><span translate=\"\">Change</span><i class=\"fa\" ng-class=\"sortClass(\'explorer\', \'score_change\')\"></i></th><th translate=\"\">Maturity</th><th translate=\"\">Notes</th></tr></thead><tbody><tr ng-repeat=\"row in pageRows(\'explorer\', explorerRows()) track by row.fo_id\"><td class=\"rea-fo\"><a class=\"dq-link\" title=\"{{row.fo_name}}\" ng-click=\"openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.country || \'--\'}}</td><td>{{row.value_chain || \'--\'}}</td><td>{{row.projects.join(\', \')}}</td><td class=\"numeric\">{{row.rounds}}</td><td class=\"rea-muted\">{{row.first_date}}<span ng-if=\"row.rounds > 1\">→ {{row.latest_date}}</span></td><td>{{row.tools.join(\', \')}}</td><td class=\"numeric\">{{charts.two(row.baseline_score)}}</td><td class=\"numeric\">{{charts.two(row.latest_score)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.score_change)\">{{fmt.signed(row.score_change, 2)}}</td><td><span ng-if=\"row.score_comparable\">{{maturityLabel(row.baseline_maturity) | translate}} → {{maturityLabel(row.latest_maturity) | translate}}</span></td><td><span class=\"flag-badge\" ng-repeat=\"issue in row.issues\">{{reasonLabel(issue)}}</span> <span class=\"flag-badge flag-badge--info\" ng-if=\"row.tool_version_differs\" title=\"v{{row.baseline_version}} → v{{row.latest_version}}\">{{reasonLabel(\'tool_version_differs\')}}</span></td></tr><tr ng-if=\"!pageInfo(\'explorer\', explorerRows()).total\"><td colspan=\"12\" class=\"empty-hint\" translate=\"\">No FO matches.</td></tr></tbody></table></div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'explorer\', explorerRows()).from}}–{{pageInfo(\'explorer\', explorerRows()).to}} / {{pageInfo(\'explorer\', explorerRows()).total}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'explorer\', -1, explorerRows())\" ng-disabled=\"!pageInfo(\'explorer\', explorerRows()).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'explorer\', 1, explorerRows())\" ng-disabled=\"pageInfo(\'explorer\', explorerRows()).page >= pageInfo(\'explorer\', explorerRows()).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div><div class=\"loading-note\" ng-if=\"explorer.detailLoading\" translate=\"\">Loading FO…</div><div ng-if=\"explorer.detail\" ng-init=\"d = explorer.detail\"><div class=\"rea-detail-head\"><button class=\"btn btn-default btn-sm\" ng-click=\"closeFo()\"><i class=\"fa fa-arrow-left\"></i> <span translate=\"\">All FOs</span></button><h3>{{explorer.detail.fo.fo_name}}</h3><span class=\"rea-muted\">{{explorer.detail.fo.country}} · {{explorer.detail.fo.value_chain || \'--\'}}</span> <a class=\"dq-link\" ng-href=\"{{foHref(explorer.detail.fo.fo_id)}}\" target=\"_blank\" translate=\"\">Assessee and original assessments</a> <a class=\"dq-link\" ng-href=\"{{foInsightsHref(explorer.detail.fo.fo_id)}}\" target=\"_blank\" translate=\"\">Assessee insights</a></div><div class=\"rea-context\"><span class=\"rea-context__item\"><strong translate=\"\">Rounds</strong>{{explorer.detail.summary.rounds}}</span> <span class=\"rea-context__item\"><strong translate=\"\">Score change</strong><span ng-class=\"fmt.changeClass(explorer.detail.summary.score_change)\">{{fmt.signed(explorer.detail.summary.score_change, 2)}}</span></span> <span class=\"rea-context__item\" ng-if=\"explorer.detail.summary.score_comparable\"><strong translate=\"\">Maturity</strong>{{maturityLabel(explorer.detail.summary.baseline_maturity) | translate}} → {{maturityLabel(explorer.detail.summary.latest_maturity) | translate}}</span> <span class=\"rea-context__item\"><strong translate=\"\">Comparable on scores</strong>{{explorer.detail.summary.score_comparable ? (\'Yes\' | translate) : (\'No\' | translate)}}</span> <span class=\"flag-badge\" ng-repeat=\"issue in explorer.detail.summary.issues\">{{reasonLabel(issue)}}</span> <span class=\"flag-badge flag-badge--info\" ng-if=\"explorer.detail.summary.tool_version_differs\">{{reasonLabel(\'tool_version_differs\')}}: v{{explorer.detail.summary.baseline_version}} → v{{explorer.detail.summary.latest_version}}</span></div><div class=\"charts-row charts-row--two\"><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Assessment history</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Round</th><th translate=\"\">Date</th><th translate=\"\">Project</th><th translate=\"\">Tool</th><th class=\"numeric\" translate=\"\">Score</th><th translate=\"\">Maturity</th><th class=\"numeric\" translate=\"\">Assessment</th></tr></thead><tbody><tr ng-repeat=\"e in explorer.detail.entries\"><td>{{e.round}}</td><td>{{e.date}}</td><td>{{e.project_name}}</td><td>{{e.tool_type}} v{{e.tool_version}}</td><td class=\"numeric\">{{charts.two(e.score)}}</td><td>{{maturityLabel(e.maturity_level) | translate}}</td><td class=\"numeric rea-muted\">#{{e.assessment_id}}</td></tr></tbody></table></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Overall score progression</div><div id=\"reaFoScores\" class=\"chart-body chart-body--short\"></div></div></div><div class=\"table-card\" ng-if=\"explorer.detail.dimensions.length\"><div class=\"table-card__title\" translate=\"\">Dimensions and subdimensions</div><div class=\"table-card__hint\" translate=\"\">Canonical names; hover a row for the titles and versions it was read from. \"Not in this round\" means the assessment has no such section, which is not a score of zero.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Dimension</th><th class=\"numeric\" ng-repeat=\"e in explorer.detail.entries\">{{\'Round\' | translate}} {{e.round}} <span class=\"rea-muted\">v{{e.tool_version}}</span></th></tr></thead><tbody ng-repeat=\"dim in explorer.detail.dimensions track by dim.key\"><tr class=\"row--first\"><td title=\"{{dim.source_titles.join(\', \')}} · {{dim.versions.join(\', \')}}\"><strong>{{dim.title}}</strong> <span class=\"flag-badge\" ng-if=\"!dim.mapped\" translate=\"\">Unmapped</span></td><td class=\"numeric\" ng-repeat=\"score in dim.scores track by $index\"><span ng-if=\"dim.present[$index]\">{{charts.two(score)}}</span> <span ng-if=\"!dim.present[$index]\" class=\"value-missing\" translate=\"\">Not in this round</span></td></tr><tr class=\"rea-subrow\" ng-repeat=\"sub in dim.subdimensions track by sub.key\"><td title=\"{{sub.source_titles.join(\', \')}}\">{{sub.title}}</td><td class=\"numeric\" ng-repeat=\"score in sub.scores track by $index\"><span ng-if=\"sub.present[$index]\">{{charts.two(score)}}</span> <span ng-if=\"!sub.present[$index]\" class=\"value-missing\">–</span></td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Demographics</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Indicator</th><th class=\"numeric\" ng-repeat=\"e in explorer.detail.entries\">{{\'Round\' | translate}} {{e.round}}</th></tr></thead><tbody><tr ng-repeat=\"row in explorer.detail.demographics\"><td>{{row.label | translate}}</td><td class=\"numeric\" ng-repeat=\"value in row.values track by $index\" ng-class=\"{\'value-missing\': value === null}\">{{charts.num(value)}} <span class=\"rea-muted\" ng-if=\"row.female_share[$index] !== null\">({{charts.pct(row.female_share[$index])}} ♀)</span> <span class=\"rea-muted\" ng-if=\"row.youth_pct[$index] !== null\">· {{charts.pct(row.youth_pct[$index])}} {{\'youth\' | translate}}</span> <span class=\"rea-muted\" ng-if=\"row.youth_pct[$index] === null && value !== null\" title=\"{{\'Youth share\' | translate}}\">· {{reasonLabel(row.youth_state[$index])}}</span></td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\">{{\'Financial performance\' | translate}} ({{explorer.detail.currency}})</div><table class=\"analytics-table\" ng-if=\"explorer.detail.financial_years.length\"><thead><tr><th translate=\"\">Fiscal year</th><th class=\"numeric\" translate=\"\">Turnover</th><th class=\"numeric\" translate=\"\">Cost of goods sold</th><th class=\"numeric\" translate=\"\">Gross profit</th><th class=\"numeric\" translate=\"\">Operating expenses</th><th class=\"numeric\" translate=\"\">Net profit</th><th class=\"numeric\" translate=\"\">Gross margin</th><th class=\"numeric\" translate=\"\">Net margin</th><th translate=\"\">From round</th></tr></thead><tbody><tr ng-repeat=\"y in explorer.detail.financial_years\"><td>{{y.year}}</td><td class=\"numeric\">{{charts.num(y.revenue)}}</td><td class=\"numeric\">{{charts.num(y.cost_of_sales)}}</td><td class=\"numeric\">{{charts.num(y.gross_profit)}}</td><td class=\"numeric\">{{charts.num(y.operating_expenses)}}</td><td class=\"numeric\">{{charts.num(y.net_profit)}}</td><td class=\"numeric\">{{charts.pct(y.gross_margin_pct)}}</td><td class=\"numeric\">{{charts.pct(y.net_margin_pct)}}</td><td>{{y.round}}</td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!explorer.detail.financial_years.length\" translate=\"\">No financial statements reported.</div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Finance history</div><table class=\"analytics-table\" ng-if=\"explorer.detail.facilities.length\"><thead><tr><th translate=\"\">Type</th><th translate=\"\">Financier</th><th translate=\"\">Start</th><th class=\"numeric\" translate=\"\">Amount</th><th translate=\"\">First reported</th><th translate=\"\">Originated</th></tr></thead><tbody><tr ng-repeat=\"f in explorer.detail.facilities\"><td>{{f.finance_type_label | translate}}</td><td>{{f.financier_name || f.financier_type || \'--\'}}</td><td>{{f.start_date || \'--\'}}</td><td class=\"numeric\">{{charts.num(f.amount)}}</td><td>{{\'Round\' | translate}} {{f.first_round}}</td><td><span ng-if=\"f.origination_round\">{{\'Round\' | translate}} {{f.origination_round}}</span> <span ng-if=\"!f.origination_known\" class=\"value-missing\" translate=\"\">Unknown (no start date)</span></td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!explorer.detail.facilities.length\" translate=\"\">No financing recorded.</div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Production and sales</div><table class=\"analytics-table\" ng-if=\"explorer.detail.production.length\"><thead><tr><th translate=\"\">Product</th><th translate=\"\">Unit</th><th translate=\"\">Year</th><th class=\"numeric\" translate=\"\">Production</th><th class=\"numeric\" translate=\"\">Purchased (members)</th><th class=\"numeric\" translate=\"\">Purchased (others)</th><th class=\"numeric\" translate=\"\">Sold</th><th class=\"numeric\" translate=\"\">Sales value</th></tr></thead><tbody><tr ng-repeat=\"r in explorer.detail.production\"><td>{{r.product}}</td><td title=\"{{\'Reported as\' | translate}}: {{r.source_units.join(\', \')}}\">{{r.unit}} <span class=\"rea-muted\" ng-if=\"r.source_units.length\">({{r.source_units.join(\', \')}})</span></td><td>{{r.year}}</td><td class=\"numeric\">{{charts.num(r.production)}}</td><td class=\"numeric\">{{charts.num(r.purchased_members)}}</td><td class=\"numeric\">{{charts.num(r.purchased_others)}}</td><td class=\"numeric\">{{charts.num(r.sold)}}</td><td class=\"numeric\"><span ng-if=\"r.sold_value !== null && r.sold_value !== undefined\">{{charts.num(r.sold_value)}}</span> <span ng-if=\"r.sold_value_complete === false\" class=\"value-missing\" title=\"{{\'Partial subtotal, not a total\' | translate}}: {{charts.num(r.sold_value_partial)}}\"><span class=\"flag-badge\" ng-repeat=\"cause in r.sold_value_causes\">{{reasonLabel(cause)}}</span></span></td></tr></tbody></table><div class=\"empty-hint\" ng-if=\"!explorer.detail.production.length\" translate=\"\">No production or sales reported.</div></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/financeHistory.html","<div ng-init=\"p = payloads[\'finance-history\']\"><div class=\"section-intro\"><span translate=\"\">A facility restated in a later assessment is the same facility and is counted once. Access is the share of matched pairs reporting at least one facility in the assessment.</span> <span translate=\"\">Newly reported: first recorded in a later assessment, whenever it started. Newly originated: its start date is after the baseline assessment and on or before the comparison assessment. Without a start date, origination is unknown and never counted as new.</span> <strong>{{\'Currency\' | translate}}: {{p.currency}}</strong></div><div class=\"metrics-grid\"><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.access.n)}\"><div class=\"metric-title\" translate=\"\">Pairs with a facility</div><div class=\"metric-value metric-value--text\">{{charts.pct(p.access.baseline_pct)}} → {{charts.pct(p.access.latest_pct)}}</div><div class=\"metric-note\">{{fmt.signed(p.access.change_pp, 1, \' pp\')}} · N={{p.access.n}} {{\'pairs\' | translate}}<span class=\"rea-lown\" ng-if=\"lowN(p.access.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Gained access</div><div class=\"metric-value delta--up\">{{p.access.gained}}</div><div class=\"metric-note\" translate=\"\">Pairs with no facility at baseline and at least one at the comparison · N={{p.access.n}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Newly reported facilities</div><div class=\"metric-value\">{{p.newly_reported.count}}</div><div class=\"metric-note\">{{p.newly_reported.fo_count}} {{\'FOs\' | translate}} · {{charts.money(p.newly_reported.amount, p.currency)}} (N={{p.newly_reported.amount_n}})</div><div class=\"metric-note\" translate=\"\">Of which started before the baseline: {{p.newly_reported.started_before_baseline}}; start date unknown: {{p.newly_reported.origination_unknown}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Newly originated facilities</div><div class=\"metric-value\">{{p.newly_originated.count}}</div><div class=\"metric-note\">{{p.newly_originated.fo_count}} {{\'FOs\' | translate}} · {{charts.money(p.newly_originated.amount, p.currency)}} (N={{p.newly_originated.amount_n}})</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Facilities recorded</div><div class=\"metric-value\">{{p.facility_count}}</div><div class=\"metric-note\" translate=\"\">Each facility once, across all rounds</div></article></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Access by type, % of pairs</div><div id=\"reaFinanceAccess\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Facilities recorded, by start year</div><div id=\"reaFinanceByYear\" class=\"chart-body\"></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">By financing type</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Type</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Access baseline</th><th class=\"numeric\" translate=\"\">Access latest</th><th class=\"numeric\" translate=\"\">Change (pp)</th><th class=\"numeric\" translate=\"\">Amount baseline</th><th class=\"numeric\" translate=\"\">Amount latest</th><th class=\"numeric\" translate=\"\">Newly reported</th><th class=\"numeric\" translate=\"\">Newly reported amount</th><th class=\"numeric\" translate=\"\">Newly originated</th><th class=\"numeric\" translate=\"\">Newly originated amount</th></tr></thead><tbody><tr ng-repeat=\"t in p.types\" ng-class=\"{\'rea-lown-row\': lowN(t.access.n)}\"><td>{{t.label | translate}}</td><td class=\"numeric\">{{t.access.n}}<span class=\"rea-lown\" ng-if=\"lowN(t.access.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.pct(t.access.baseline_pct)}}</td><td class=\"numeric\">{{charts.pct(t.access.latest_pct)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(t.access.change_pp)\">{{fmt.signed(t.access.change_pp, 1)}}</td><td class=\"numeric\">{{charts.num(t.amount.baseline_total)}}</td><td class=\"numeric\">{{charts.num(t.amount.latest_total)}}</td><td class=\"numeric\">{{t.newly_reported.count}}</td><td class=\"numeric\">{{charts.num(t.newly_reported.amount)}} <span class=\"rea-muted\" ng-if=\"t.newly_reported.count\">N={{t.newly_reported.amount_n}}</span></td><td class=\"numeric\">{{t.newly_originated.count}}</td><td class=\"numeric\">{{charts.num(t.newly_originated.amount)}} <span class=\"rea-muted\" ng-if=\"t.newly_originated.count\">N={{t.newly_originated.amount_n}}</span></td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FO financing histories</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables[\'finance-history\'].search\" ng-change=\"tables[\'finance-history\'].page = 0\" placeholder=\"{{\'Search FO\' | translate}}\"></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'fos\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export facilities</span></button></div></div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'finance-history\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'finance-history\', \'fo_name\')\"></i></th><th translate=\"\">Type</th><th translate=\"\">Financier</th><th translate=\"\">Start</th><th class=\"numeric\" translate=\"\">Amount</th><th translate=\"\">First reported</th><th translate=\"\">Originated</th></tr></thead><tbody ng-repeat=\"h in pageRows(\'finance-history\', p.histories) track by h.fo_id\"><tr ng-repeat=\"f in h.facilities\" ng-class=\"{\'row--first\': $first}\"><td class=\"rea-fo\"><a ng-if=\"$first\" class=\"dq-link\" title=\"{{h.fo_name}}\" ng-click=\"selectTab(\'explorer\'); openFo(h.fo_id)\">{{h.fo_name}}</a></td><td>{{f.finance_type_label | translate}}</td><td>{{f.financier_name || f.financier_type || \'--\'}}</td><td>{{f.start_date || \'--\'}}</td><td class=\"numeric\" ng-class=\"{\'value-missing\': f.amount === null}\">{{charts.num(f.amount)}}</td><td>{{\'Round\' | translate}} {{f.first_round}} <span class=\"flag-badge\" ng-if=\"f.first_round > 1\" translate=\"\">newly reported</span></td><td><span ng-if=\"f.origination_round\">{{\'Round\' | translate}} {{f.origination_round}}</span> <span ng-if=\"!f.origination_known\" class=\"value-missing\" translate=\"\">Unknown (no start date)</span> <span ng-if=\"f.origination_known && !f.origination_round\" class=\"rea-muted\" translate=\"\">After the latest round</span></td></tr></tbody></table></div><div class=\"empty-hint\" ng-if=\"!p.histories.length\" translate=\"\">No financing recorded for the matched FOs.</div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'finance-history\', p.histories).from}}–{{pageInfo(\'finance-history\', p.histories).to}} / {{pageInfo(\'finance-history\', p.histories).total}} {{\'FOs\' | translate}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'finance-history\', -1, p.histories)\" ng-disabled=\"!pageInfo(\'finance-history\', p.histories).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'finance-history\', 1, p.histories)\" ng-disabled=\"pageInfo(\'finance-history\', p.histories).page >= pageInfo(\'finance-history\', p.histories).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/financials.html","<div ng-init=\"p = payloads.financials\"><div class=\"section-intro\"><span ng-if=\"!p.selected_years.baseline_year\" translate=\"\">Each FO compares the latest fiscal year reported in its baseline assessment with the latest fiscal year reported in its comparison assessment, which must be later.</span> <span ng-if=\"p.selected_years.baseline_year\">{{\'Fiscal year\' | translate}} {{p.selected_years.baseline_year}} {{\'compared with\' | translate}} {{p.selected_years.comparison_year}}.</span> <span translate=\"\">A year restated in a later assessment takes the later figure and is counted once. Margins change in percentage points.</span> <strong>{{\'Currency\' | translate}}: {{p.currency}}</strong></div><div class=\"metrics-grid\"><article class=\"metric-card\" ng-repeat=\"m in p.measures\" ng-class=\"{\'rea-lown-card\': lowN(m.n)}\"><div class=\"metric-title\">{{m.label | translate}}</div><div class=\"metric-value\" ng-class=\"fmt.changeClass(m.total_change_pct, m.key === \'cost_of_sales\' || m.key === \'operating_expenses\')\">{{fmt.signed(m.total_change_pct, 1, \'%\')}}</div><div class=\"metric-note\">{{charts.money(m.baseline_total, p.currency)}} → {{charts.money(m.latest_total, p.currency)}} · N={{m.n}}<span class=\"rea-lown\" ng-if=\"lowN(m.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\" ng-repeat=\"m in p.margins\" ng-class=\"{\'rea-lown-card\': lowN(m.n)}\"><div class=\"metric-title\">{{m.label | translate}}</div><div class=\"metric-value\" ng-class=\"fmt.changeClass(m.mean_change)\">{{fmt.signed(m.mean_change, 1, \' pp\')}}</div><div class=\"metric-note\">{{charts.pct(m.baseline_mean)}} → {{charts.pct(m.latest_mean)}} · N={{m.n}}<span class=\"rea-lown\" ng-if=\"lowN(m.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Profitable FOs</div><div class=\"metric-value metric-value--text\">{{p.profitable_fos.baseline}} → {{p.profitable_fos.latest}}</div><div class=\"metric-note\">N={{p.profitable_fos.n}}</div></article></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Average per FO, baseline vs latest</div><div id=\"reaFinancialMeasures\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Average turnover by fiscal year</div><div class=\"chart-card__hint\" translate=\"\">Matched FOs, one figure per FO and year; N in the tooltip.</div><div id=\"reaFinancialTrend\" class=\"chart-body\"></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Paired comparison</div><div class=\"table-card__hint\" translate=\"\">N is the pairs reporting the measure for both compared fiscal years. Figures are recorded values, not adjusted for inflation.</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Measure</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline total</th><th class=\"numeric\" translate=\"\">Latest total</th><th class=\"numeric\" translate=\"\">Change %</th><th class=\"numeric\" translate=\"\">Average change per FO</th><th class=\"numeric\" translate=\"\">Improved</th><th class=\"numeric\" translate=\"\">Declined</th></tr></thead><tbody><tr ng-repeat=\"m in p.measures\" ng-class=\"{\'rea-lown-row\': lowN(m.n)}\"><td>{{m.label | translate}}</td><td class=\"numeric\">{{m.n}}<span class=\"rea-lown\" ng-if=\"lowN(m.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.num(m.baseline_total)}}</td><td class=\"numeric\">{{charts.num(m.latest_total)}}</td><td class=\"numeric\">{{fmt.signed(m.total_change_pct, 1, \'%\')}}</td><td class=\"numeric\">{{fmt.signed(m.mean_change, 0)}}</td><td class=\"numeric\">{{charts.pct(m.improved_pct)}}</td><td class=\"numeric\">{{charts.pct(m.declined_pct)}}</td></tr><tr ng-repeat=\"m in p.margins\" ng-class=\"{\'rea-lown-row\': lowN(m.n)}\"><td>{{m.label | translate}}</td><td class=\"numeric\">{{m.n}}<span class=\"rea-lown\" ng-if=\"lowN(m.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.pct(m.baseline_mean)}}</td><td class=\"numeric\">{{charts.pct(m.latest_mean)}}</td><td class=\"numeric rea-muted\">pp</td><td class=\"numeric\">{{fmt.signed(m.mean_change, 1, \' pp\')}}</td><td class=\"numeric\">{{charts.pct(m.improved_pct)}}</td><td class=\"numeric\">{{charts.pct(m.declined_pct)}}</td></tr></tbody></table><div class=\"table-card__hint\" ng-if=\"p.excluded.length\">{{\'Pairs not compared:\' | translate}} <span ng-repeat=\"e in p.excluded\">{{reasonLabel(e.reason)}} ({{e.count}})<span ng-if=\"!$last\">,</span></span></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Year over year</div><div class=\"table-card__hint\" translate=\"\">Each step over the FOs reporting both years.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Years</th><th class=\"numeric\" ng-repeat=\"m in p.measures\">{{m.label | translate}}</th></tr></thead><tbody><tr ng-repeat=\"step in p.year_over_year\"><td>{{step.from_year}} → {{step.to_year}}</td><td class=\"numeric\" ng-repeat=\"m in p.measures\">{{fmt.signed(step[m.key].total_change_pct, 1, \'%\')}} <span class=\"rea-muted\">N={{step[m.key].n}}</span></td></tr><tr ng-if=\"!p.year_over_year.length\"><td colspan=\"6\" class=\"empty-hint\" translate=\"\">Fewer than two fiscal years reported.</td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Reporting coverage by fiscal year</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Fiscal year</th><th class=\"numeric\" ng-repeat=\"m in p.measures\">{{m.label | translate}} (N)</th></tr></thead><tbody><tr ng-repeat=\"year in p.by_year\"><td>{{year.year}}</td><td class=\"numeric\" ng-repeat=\"m in p.measures\">{{charts.num(year[m.key].total)}} <span class=\"rea-muted\">N={{year[m.key].n}}</span></td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FO comparisons</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables.financials.search\" ng-change=\"tables.financials.page = 0\" placeholder=\"{{\'Search FO, country or value chain\' | translate}}\"></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'fos\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export FOs</span></button></div></div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'financials\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'financials\', \'fo_name\')\"></i></th><th translate=\"\">Fiscal years</th><th class=\"numeric rea-sortable\" ng-repeat=\"m in p.measures\" ng-click=\"sortTable(\'financials\', m.key + \'.change_pct\')\"><span>{{m.label | translate}}</span><i class=\"fa\" ng-class=\"sortClass(\'financials\', m.key + \'.change_pct\')\"></i></th><th class=\"numeric\" ng-repeat=\"m in p.margins\">{{m.label | translate}}</th></tr></thead><tbody><tr ng-repeat=\"fo in pageRows(\'financials\', p.fos) track by $index\"><td class=\"rea-fo\"><a class=\"dq-link\" title=\"{{fo.fo_name}}\" ng-click=\"selectTab(\'explorer\'); openFo(fo.fo_id)\">{{fo.fo_name}}</a></td><td><span ng-if=\"!fo.excluded_reason\">{{fo.baseline_year}} → {{fo.comparison_year}}</span> <span ng-if=\"fo.excluded_reason\" class=\"flag-badge\">{{reasonLabel(fo.excluded_reason)}}</span></td><td class=\"numeric\" ng-repeat=\"m in p.measures\" ng-class=\"fmt.changeClass(fo[m.key].change, m.key === \'cost_of_sales\' || m.key === \'operating_expenses\')\">{{fmt.signed(fo[m.key].change_pct, 1, \'%\')}}</td><td class=\"numeric\" ng-repeat=\"m in p.margins\">{{fmt.signed(fo[m.key].change, 1, \' pp\')}}</td></tr><tr ng-if=\"!pageInfo(\'financials\', p.fos).total\"><td colspan=\"9\" class=\"empty-hint\" translate=\"\">No FO matches.</td></tr></tbody></table></div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'financials\', p.fos).from}}–{{pageInfo(\'financials\', p.fos).to}} / {{pageInfo(\'financials\', p.fos).total}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'financials\', -1, p.fos)\" ng-disabled=\"!pageInfo(\'financials\', p.fos).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'financials\', 1, p.fos)\" ng-disabled=\"pageInfo(\'financials\', p.fos).page >= pageInfo(\'financials\', p.fos).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/overview.html","<div ng-init=\"p = payloads.overview\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Unique FOs</div><div class=\"metric-value\">{{charts.num(p.kpis.total_fos)}}</div><div class=\"metric-note\">{{charts.num(p.kpis.reassessed_fos)}} {{\'reassessed\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Reassessment coverage</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': p.kpis.reassessment_coverage_pct === null}\">{{charts.pct(p.kpis.reassessment_coverage_pct)}}</div><div class=\"metric-note\">{{p.kpis.score_comparable_fos}} {{\'FOs comparable on scores\' | translate}}</div></article><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.kpis.score.n)}\"><div class=\"metric-title\" translate=\"\">Average score</div><div class=\"metric-value metric-value--text\">{{charts.two(p.kpis.score.baseline_mean)}} → {{charts.two(p.kpis.score.latest_mean)}}</div><div class=\"metric-note\">N={{p.kpis.score.n}} {{\'pairs\' | translate}} · {{p.context.score_tool || \'--\'}}<span class=\"rea-lown\" ng-if=\"lowN(p.kpis.score.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.kpis.score.n)}\"><div class=\"metric-title\" translate=\"\">Average score change</div><div class=\"metric-value\" ng-class=\"fmt.changeClass(p.kpis.score.mean_change)\">{{fmt.signed(p.kpis.score.mean_change, 2)}}</div><div class=\"metric-note\">{{\'Median\' | translate}} {{fmt.signed(p.kpis.score.median_change, 2)}}</div></article><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.kpis.score.n)}\"><div class=\"metric-title\" translate=\"\">Improved / unchanged / declined</div><div class=\"metric-value metric-value--text\"><span class=\"delta--up\">{{charts.pct(p.kpis.score.improved_pct)}}</span> / <span class=\"delta--flat\">{{charts.pct(p.kpis.score.unchanged_pct)}}</span> / <span class=\"delta--down\">{{charts.pct(p.kpis.score.declined_pct)}}</span></div><div class=\"metric-note\">N={{p.kpis.score.n}} {{\'pairs\' | translate}} · {{\'unchanged within ±0.05\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Average interval</div><div class=\"metric-value\" ng-class=\"{\'value-missing\': p.kpis.average_interval_months === null}\">{{charts.one(p.kpis.average_interval_months)}}</div><div class=\"metric-note\">{{\'months between compared assessments\' | translate}} · N={{p.kpis.interval_n}}</div></article></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Score by project</div><div class=\"chart-card__hint\" translate=\"\">Average SCOPE score by project, based on the latest eligible assessment per FO in each project.</div><div id=\"reaOverviewProjects\" class=\"chart-body chart-body--auto\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Distribution of score changes</div><div class=\"chart-card__hint\">N={{p.kpis.score.n}}</div><div id=\"reaOverviewDistribution\" class=\"chart-body\"></div></div></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Maturity levels, baseline vs latest</div><div class=\"chart-card__hint\">N={{p.maturity_distribution.n}}</div><div id=\"reaOverviewMaturity\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Average score by assessment round</div><div class=\"chart-card__hint\" translate=\"\">Descriptive: every round of FOs with at least two in the score tool, not only the matched pairs; N per round in the tooltip.</div><div id=\"reaOverviewTrend\" class=\"chart-body\"></div></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Maturity level flows</div><div class=\"chart-card__hint\"><span translate=\"\">Baseline level on the left, latest level on the right; each flow is as wide as its count. The same counts as the transition table below.</span> <span ng-if=\"p.maturity_transition.fo_n !== p.maturity_transition.n\" translate=\"\">Counts are comparison pairs ({{p.maturity_transition.fo_n}} FOs): with this comparison method an FO can contribute more than one pair.</span> <span ng-if=\"p.maturity_transition.fo_n === p.maturity_transition.n\" translate=\"\">One pair per FO: counts are FOs.</span> N={{p.maturity_transition.n}}<span class=\"rea-lown\" ng-if=\"lowN(p.maturity_transition.n)\" translate=\"\">Small N</span></div><div id=\"reaOverviewSankey\" class=\"chart-body\"></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Maturity level transitions</div><div class=\"table-card__hint\">{{\'Rows are the baseline level, columns the latest level.\' | translate}} N={{p.maturity_transition.n}} · <span class=\"delta--up\">{{p.maturity_transition.moved_up}} {{\'moved up\' | translate}}</span> · {{p.maturity_transition.stayed}} {{\'stayed\' | translate}} · <span class=\"delta--down\">{{p.maturity_transition.moved_down}} {{\'moved down\' | translate}}</span></div><table class=\"analytics-table rea-matrix\"><thead><tr><th translate=\"\">Baseline \\ Latest</th><th class=\"numeric\" ng-repeat=\"level in p.maturity_transition.levels\">{{level.label | translate}}</th><th class=\"numeric\" translate=\"\">Total</th></tr></thead><tbody><tr ng-repeat=\"row in p.maturity_transition.rows\" ng-init=\"rowIndex = $index\"><th>{{p.maturity_transition.levels[rowIndex].label | translate}}</th><td class=\"numeric rea-matrix__cell\" ng-repeat=\"cell in row.cells\" ng-class=\"{\'rea-matrix__cell--up\': $index > rowIndex && cell.count, \'rea-matrix__cell--down\': $index < rowIndex && cell.count, \'rea-matrix__cell--same\': $index === rowIndex && cell.count}\">{{cell.count}}</td><td class=\"numeric\"><strong>{{row.total}}</strong></td></tr></tbody></table></div><div class=\"table-card\" ng-repeat=\"group in progressGroups track by group.key\"><div class=\"table-card__title\">{{group.title | translate}}</div><div class=\"table-card__hint\">{{p.context.attribution | translate}}</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Name</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\" translate=\"\">Improved</th><th class=\"numeric\" translate=\"\">Declined</th></tr></thead><tbody><tr ng-repeat=\"row in p[group.key]\" ng-class=\"{\'rea-lown-row\': lowN(row.n)}\"><td>{{row.name}}</td><td class=\"numeric\">{{row.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.two(row.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(row.latest_mean)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.mean_change)\">{{fmt.signed(row.mean_change, 2)}}</td><td class=\"numeric\">{{charts.pct(row.improved_pct)}}</td><td class=\"numeric\">{{charts.pct(row.declined_pct)}}</td></tr><tr ng-if=\"!p[group.key].length\"><td colspan=\"7\" class=\"empty-hint\" translate=\"\">No matched FOs.</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Assessments by year</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Year</th><th class=\"numeric\" translate=\"\">Assessments</th><th class=\"numeric\" translate=\"\">Of which reassessments</th></tr></thead><tbody><tr ng-repeat=\"row in p.reassessments_by_year\"><td>{{row.year}}</td><td class=\"numeric\">{{row.assessments}}</td><td class=\"numeric\">{{row.reassessments}}</td></tr></tbody></table></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/production.html","<div ng-init=\"p = payloads.production\"><div class=\"section-intro\"><span translate=\"\">A product is compared when an FO reports it in the same unit in both assessments, for a later reporting year. Weights are converted to {{p.weight_unit}} (bags, tonnes, pounds…); area, volume and length stay in their own unit and are never added to weight.</span> <span translate=\"\">Sales value is volume × unit price in the reporting currency. An FO\'s sales total counts only when every sold product is valued in full on both sides.</span> <strong>{{\'Currency\' | translate}}: {{p.currency}}</strong></div><div class=\"metrics-grid\"><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.sales_value.n)}\"><div class=\"metric-title\" translate=\"\">Sales value</div><div class=\"metric-value\" ng-class=\"fmt.changeClass(p.sales_value.total_change_pct)\">{{fmt.signed(p.sales_value.total_change_pct, 1, \'%\')}}</div><div class=\"metric-note\">{{charts.money(p.sales_value.baseline_total, p.currency)}} → {{charts.money(p.sales_value.latest_total, p.currency)}} · N={{p.sales_value.n}} {{\'pairs\' | translate}}<span class=\"rea-lown\" ng-if=\"lowN(p.sales_value.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Pairs with higher sales value</div><div class=\"metric-value\">{{charts.pct(p.sales_value.improved_pct)}}</div><div class=\"metric-note\">{{p.sales_value.improved}} / {{p.sales_value.n}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Incomplete sales totals</div><div class=\"metric-value\" ng-class=\"{\'metric-value--warning\': p.sales_value_incomplete.fo_pairs}\">{{p.sales_value_incomplete.fo_pairs}}</div><div class=\"metric-note\"><span ng-repeat=\"c in p.sales_value_incomplete.causes\">{{reasonLabel(c.cause)}}: {{c.pairs}}<span ng-if=\"!$last\">·</span></span><span ng-if=\"!p.sales_value_incomplete.causes.length\" translate=\"\">Every sales total is complete</span></div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Product × unit combinations compared</div><div class=\"metric-value\">{{p.products.length}}</div><div class=\"metric-note\">{{p.not_comparable_product_years}} {{\'product records without a later year\' | translate}}</div></article></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Sales value by country, baseline vs latest</div><div class=\"chart-card__hint\" translate=\"\">Pairs with a complete sales value only.</div><div id=\"reaProductionCountries\" class=\"chart-body\"></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Products</div><div class=\"table-card__hint\" translate=\"\">Each cell is a paired comparison with its own N (pairs). Hover a unit for the units as reported.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Product</th><th translate=\"\">Category</th><th translate=\"\">Unit</th><th class=\"numeric\" translate=\"\">Production</th><th class=\"numeric\" translate=\"\">Purchased from members</th><th class=\"numeric\" translate=\"\">Purchased from others</th><th class=\"numeric\" translate=\"\">Sales volume</th><th class=\"numeric\" translate=\"\">Sales value</th></tr></thead><tbody><tr ng-repeat=\"row in p.products\"><td><strong>{{row.product}}</strong></td><td>{{row.category || \'--\'}}</td><td title=\"{{\'Reported as\' | translate}}: {{row.source_units.join(\', \')}}\">{{row.unit}}</td><td class=\"numeric\" ng-repeat=\"key in productMeasures track by $index\" ng-class=\"{\'rea-lown-value\': lowN(row[key].n)}\"><span ng-if=\"row[key].n\">{{charts.num(row[key].baseline_total)}} → {{charts.num(row[key].latest_total)}} <span ng-class=\"fmt.changeClass(row[key].total_change_pct)\">({{fmt.signed(row[key].total_change_pct, 1, \'%\')}})</span> <span class=\"rea-muted\">N={{row[key].n}}</span></span> <span ng-if=\"!row[key].n\" class=\"value-missing\">--</span></td></tr><tr ng-if=\"!p.products.length\"><td colspan=\"8\" class=\"empty-hint\" translate=\"\">No product is reported in a comparable unit and later year.</td></tr></tbody></table></div></div><div class=\"table-card\" ng-repeat=\"group in productionGroups track by group.key\"><div class=\"table-card__title\">{{group.title | translate}}</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Name</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline sales value</th><th class=\"numeric\" translate=\"\">Latest sales value</th><th class=\"numeric\" translate=\"\">Change %</th></tr></thead><tbody><tr ng-repeat=\"row in p[group.key]\" ng-class=\"{\'rea-lown-row\': lowN(row.n)}\"><td>{{row.name}}</td><td class=\"numeric\">{{row.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.num(row.baseline_total)}}</td><td class=\"numeric\">{{charts.num(row.latest_total)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.total_change_pct)\">{{fmt.signed(row.total_change_pct, 1, \'%\')}}</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Multi-year trend by product</div><div class=\"table-card__hint\" translate=\"\">Portfolio totals per reporting year, one figure per FO, product and year. Each measure adds only the FOs that reported it; N is those FOs, and a missing figure is never counted as zero.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Product</th><th translate=\"\">Unit</th><th ng-repeat=\"m in trendMeasures\">{{m.label | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in p.trend\"><td>{{row.product}}</td><td>{{row.unit}}</td><td class=\"rea-trend\" ng-repeat=\"m in trendMeasures\"><span ng-repeat=\"y in row.years\" ng-if=\"y[m.key].n\">{{y.year}}: {{charts.num(y[m.key].total)}} (N={{y[m.key].n}})<span ng-if=\"!$last\">·</span></span></td></tr></tbody></table></div></div><div class=\"table-card\" ng-if=\"p.units.length\"><div class=\"table-card__title\" translate=\"\">Units as reported</div><div class=\"table-card__hint\" translate=\"\">How every reported unit is read. Flagged units need a check; tons and quintals are read as metric until confirmed.</div><div class=\"analytics-topbar-actions rea-table-actions\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'units\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export units</span></button></div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Reported unit</th><th translate=\"\">Category</th><th translate=\"\">Reported as</th><th class=\"numeric\" translate=\"\">kg per unit</th><th class=\"numeric\" translate=\"\">Records</th><th translate=\"\">Review</th></tr></thead><tbody><tr ng-repeat=\"u in p.units\"><td>{{u.unit || \'--\'}}</td><td>{{u.category}}</td><td>{{u.reported_as || \'--\'}}</td><td class=\"numeric\">{{u.kg_factor}}</td><td class=\"numeric\">{{u.records}}</td><td><span class=\"flag-badge\" ng-if=\"u.review\" title=\"{{u.note}}\">{{reasonLabel(u.review)}}</span></td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FO comparisons</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables.production.search\" ng-change=\"tables.production.page = 0\" placeholder=\"{{\'Search FO, country or value chain\' | translate}}\"></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'fos\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export FOs</span></button></div></div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'production\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'production\', \'fo_name\')\"></i></th><th translate=\"\">Compared</th><th class=\"numeric\" translate=\"\">Products compared</th><th class=\"numeric\" translate=\"\">Sales value</th><th class=\"numeric rea-sortable\" ng-click=\"sortTable(\'production\', \'sales_value_change_pct\')\"><span translate=\"\">Change %</span><i class=\"fa\" ng-class=\"sortClass(\'production\', \'sales_value_change_pct\')\"></i></th></tr></thead><tbody><tr ng-repeat=\"fo in pageRows(\'production\', p.fos) track by $index\"><td class=\"rea-fo\"><a class=\"dq-link\" title=\"{{fo.fo_name}}\" ng-click=\"selectTab(\'explorer\'); openFo(fo.fo_id)\">{{fo.fo_name}}</a></td><td class=\"rea-muted\">{{fo.baseline_date}} → {{fo.comparison_date}}</td><td class=\"numeric\">{{fo.products_compared}}</td><td class=\"numeric\"><span ng-if=\"fo.sales_value_complete\">{{charts.num(fo.sales_value_baseline)}} → {{charts.num(fo.sales_value_latest)}}</span> <span ng-if=\"fo.sales_value_partial\" class=\"value-missing\" title=\"{{\'Partial subtotal, not a total\' | translate}}: {{charts.num(fo.sales_value_partial.baseline)}} → {{charts.num(fo.sales_value_partial.latest)}}\"><span class=\"flag-badge\" ng-repeat=\"cause in fo.sales_value_causes\">{{reasonLabel(cause)}}</span></span> <span ng-if=\"!fo.products_sold\" class=\"value-missing\">--</span></td><td class=\"numeric\" ng-class=\"fmt.changeClass(fo.sales_value_change_pct)\">{{fmt.signed(fo.sales_value_change_pct, 1, \'%\')}}</td></tr><tr ng-if=\"!pageInfo(\'production\', p.fos).total\"><td colspan=\"5\" class=\"empty-hint\" translate=\"\">No FO matches.</td></tr></tbody></table></div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'production\', p.fos).from}}–{{pageInfo(\'production\', p.fos).to}} / {{pageInfo(\'production\', p.fos).total}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'production\', -1, p.fos)\" ng-disabled=\"!pageInfo(\'production\', p.fos).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'production\', 1, p.fos)\" ng-disabled=\"pageInfo(\'production\', p.fos).page >= pageInfo(\'production\', p.fos).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div></div>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/rail.html","<aside class=\"rightbar analytics-rightbar ar\" ng-class=\"{\'rightbar--closed\': ui.rightbarClosed}\"><h4 class=\"ar-title\" translate=\"\">Controls &amp; Insights</h4><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'selection\')\" aria-expanded=\"{{rail.selection}}\"><span translate=\"\">Projects &amp; comparison</span> <i class=\"fa\" ng-class=\"rail.selection ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.selection\"><div class=\"ar-group\"><label class=\"ar-label\" for=\"rea-project-search\" translate=\"\">Projects</label> <input id=\"rea-project-search\" class=\"ar-control\" type=\"search\" ng-model=\"options.projectSearch\" placeholder=\"{{\'Search projects\' | translate}}\"><div class=\"rea-select-all\"><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"selectAllProjects(true)\" translate=\"\">Select all</button> <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"selectAllProjects(false)\" translate=\"\">None</button> <span class=\"ar-count\">{{staged.projects.length}} / {{options.projects.length}}</span></div><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"project in visibleProjects() track by project.id\"><input type=\"checkbox\" ng-checked=\"isProjectSelected(project.id)\" ng-click=\"toggleProject(project.id)\"> <span>{{project.name}}<span class=\"rea-muted\" ng-if=\"project.customer\">· {{project.customer}}</span></span> <span class=\"ar-count\" title=\"{{\'FOs\' | translate}}\">{{project.fo_count}}</span></label></div><div class=\"ar-hint\" translate=\"\">Only projects you can access are listed. An FO assessed in several selected projects is counted once.</div></div><div class=\"ar-group\"><label class=\"ar-label\" translate=\"\">Comparison method</label><div class=\"rea-radios\"><label class=\"ar-check\" ng-repeat=\"method in options.methods\" title=\"{{method.description | translate}}\"><input type=\"radio\" name=\"rea-method\" ng-model=\"staged.method\" ng-value=\"method.value\"> <span>{{method.label | translate}}</span></label></div><div class=\"ar-hint\" ng-repeat=\"method in options.methods\" ng-if=\"method.value === staged.method\">{{method.description | translate}}</div></div><div class=\"ar-group\" ng-if=\"options.tools.length\"><label class=\"ar-label\" for=\"rea-score-tool\" translate=\"\">Score tool</label><select id=\"rea-score-tool\" class=\"ar-control\" ng-model=\"staged.score_tool\" ng-options=\"tool.tool_type as (tool.tool_type + \' (\' + tool.reassessed_fo_count + \')\') for tool in options.tools\"><option value=\"\" translate=\"\">Most reassessed tool</option></select><div class=\"ar-hint\" translate=\"\">Basic, Pro and Rapid scores are never compared with each other; every version of the chosen tool type is. The count is FOs reassessed with the tool.</div></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'filters\')\" aria-expanded=\"{{rail.filters}}\"><span translate=\"\">Filters</span> <i class=\"fa\" ng-class=\"rail.filters ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.filters\"><div class=\"ar-group\"><label class=\"ar-label\" translate=\"\">Assessment date range</label><div class=\"ar-dates\"><input class=\"ar-control\" type=\"date\" ng-model=\"staged.startDate\" aria-label=\"{{\'Start date\' | translate}}\"> <input class=\"ar-control\" type=\"date\" ng-model=\"staged.endDate\" aria-label=\"{{\'End date\' | translate}}\"></div><div class=\"ar-hint\" translate=\"\">Only assessments inside the range enter an FO\'s history.</div></div><div class=\"ar-group\" ng-if=\"options.tools.length > 1\"><label class=\"ar-label\" translate=\"\">Assessment tool</label><div class=\"ar-checks\"><label class=\"ar-check\" ng-repeat=\"tool in options.tools\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'tool_type\', tool.tool_type)\" ng-click=\"toggleValue(\'tool_type\', tool.tool_type)\"> <span>{{tool.tool_type}}</span> <span class=\"ar-count\">{{tool.fo_count}}</span></label></div></div><div class=\"ar-group\" ng-if=\"options.countries.length > 1\"><label class=\"ar-label\" translate=\"\">Country</label><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"option in options.countries\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'country\', option)\" ng-click=\"toggleValue(\'country\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\" ng-if=\"options.valueChains.length > 1\"><label class=\"ar-label\" translate=\"\">Value chain</label><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"option in options.valueChains\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'value_chain\', option)\" ng-click=\"toggleValue(\'value_chain\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\" ng-if=\"options.maturityLevels.length\"><label class=\"ar-label\" translate=\"\">Starting maturity level</label><div class=\"ar-checks\"><label class=\"ar-check\" ng-repeat=\"level in options.maturityLevels\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'maturity_level\', level.value)\" ng-click=\"toggleValue(\'maturity_level\', level.value)\"> <span>{{level.label | translate}}</span></label></div><div class=\"ar-hint\" translate=\"\">The level of the FO\'s baseline score.</div></div><div class=\"ar-group\" ng-if=\"ui.tab === \'financials\' || ui.tab === \'finance-history\' || ui.tab === \'production\'\"><label class=\"ar-label\" translate=\"\">Reporting currency</label><select class=\"ar-control\" ng-model=\"staged.currency\" ng-options=\"currency as currency for currency in options.currencies\"></select></div><div class=\"ar-group\" ng-if=\"ui.tab === \'production\'\"><label class=\"ar-label\" for=\"rea-weight-unit\" translate=\"\">Weight unit</label><select id=\"rea-weight-unit\" class=\"ar-control\" ng-model=\"staged.weight_unit\"><option value=\"kg\" translate=\"\">Kilograms (kg)</option><option value=\"mt\" translate=\"\">Metric tonnes (MT)</option></select><div class=\"ar-hint\" translate=\"\">Every weight is converted; area, volume and length keep their own unit.</div></div><div class=\"ar-group\" ng-if=\"ui.tab === \'financials\' && options.fiscalYears.length > 1\"><label class=\"ar-label\" translate=\"\">Fiscal years</label><div class=\"ar-dates\"><select class=\"ar-control\" ng-model=\"staged.baseline_year\" ng-options=\"year as year for year in options.fiscalYears\" aria-label=\"{{\'Baseline fiscal year\' | translate}}\"><option value=\"\" translate=\"\">Baseline: each FO\'s own</option></select><select class=\"ar-control\" ng-model=\"staged.comparison_year\" ng-options=\"year as year for year in options.fiscalYears\" aria-label=\"{{\'Comparison fiscal year\' | translate}}\"><option value=\"\" translate=\"\">Latest: each FO\'s own</option></select></div><div class=\"ar-hint\" translate=\"\">Fiscal years are the years the figures report, not the assessment dates.</div></div><div class=\"ar-errors\" ng-if=\"errors.length\" role=\"alert\"><div ng-repeat=\"message in errors\">{{message | translate}}</div></div><div class=\"ar-actions\"><button type=\"button\" class=\"btn btn-sm ar-btn ar-btn--primary\" ng-click=\"apply()\" ng-disabled=\"isLoading\">&#10003; <span translate=\"\">Apply</span></button> <button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"reset()\" ng-disabled=\"isLoading\">&times; <span translate=\"\">Reset</span></button></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'population\')\" aria-expanded=\"{{rail.population}}\"><span translate=\"\">Population</span> <i class=\"fa\" ng-class=\"rail.population ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.population\"><div class=\"ar-pop\"><span translate=\"\">Projects</span><strong>{{applied.projects.length}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Unique FOs</span><strong>{{context ? context.population.fo_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Reassessed FOs</span><strong>{{context ? context.population.reassessed_fo_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Finalised assessments</span><strong>{{context ? context.population.assessment_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Comparison pairs</span><strong>{{context ? context.population.pair_n : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">FOs with a pair</span><strong>{{context ? context.population.paired_fo_n : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Comparable score pairs</span><strong>{{context ? context.population.score_comparable_pair_n : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Excluded assessments</span><strong>{{context ? context.population.excluded_assessment_n : \'–\'}}</strong></div><div class=\"ar-pop\" ng-if=\"context.population.tool_types.length\"><span translate=\"\">Tools</span><strong>{{context.population.tool_types.join(\', \')}}</strong></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'rules\')\" aria-expanded=\"{{rail.rules}}\"><span translate=\"\">Comparison rules</span> <i class=\"fa\" ng-class=\"rail.rules ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.rules\"><ul class=\"rea-rules\"><li translate=\"\">Only finalised, valid assessments are compared.</li><li translate=\"\">Changes are paired: an FO counts only when it has a value in both periods, and N is shown with every figure.</li><li translate=\"\">An FO assessed in several projects, or merged into another, is one FO.</li><li translate=\"\">Basic, Pro and Rapid are analysed separately. Scores compare across versions of one tool type when both assessments have a valid score; a version difference is shown as a note.</li><li translate=\"\">Dimensions and subdimensions are matched on canonical names, so a renamed section stays one row. A section missing in one round is not a change.</li><li translate=\"\">Zero is data. Missing and Not Relevant values are left out.</li><li translate=\"\">No percentage change from a zero baseline. Margins and shares change in percentage points; maturity as level moves.</li><li translate=\"\">Financial and production figures compare fiscal years, each year counted once per FO.</li><li translate=\"\">A money total is shown only when every component could be valued; otherwise it is left out and the cause is listed.</li><li translate=\"\">Results over fewer than 5 observations are marked \"Small N\". They are shown, not hidden, and nothing is tested for significance.</li><li translate=\"\">Figures describe observed change between assessments, not the effect of any intervention.</li></ul></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'definitions\')\" aria-expanded=\"{{rail.definitions}}\"><span translate=\"\">Definitions</span> <i class=\"fa\" ng-class=\"rail.definitions ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.definitions\"><dl class=\"rea-defs\"><dt translate=\"\">FO</dt><dd translate=\"\">One organisation, counted once even when assessed in several projects or merged into another record.</dd><dt translate=\"\">Pair</dt><dd translate=\"\">A baseline and a comparison assessment of one FO. With Consecutive rounds an FO gives one pair per step.</dd><dt translate=\"\">N</dt><dd translate=\"\">The pairs with a value at both ends for that figure. Each figure has its own N.</dd><dt translate=\"\">Baseline / Latest</dt><dd translate=\"\">The earlier and later assessment of a pair, as the comparison method defines them.</dd><dt translate=\"\">Full historical trend</dt><dd translate=\"\">Headline figures compare the first and last rounds; the by-round trends include every eligible round.</dd><dt translate=\"\">Fiscal year</dt><dd translate=\"\">The year a financial or production figure reports, not the assessment date.</dd><dt translate=\"\">Newly reported facility</dt><dd translate=\"\">First recorded in a later assessment, whenever it started.</dd><dt translate=\"\">Newly originated facility</dt><dd translate=\"\">Started after the baseline assessment and on or before the comparison assessment.</dd><dt translate=\"\">Product × unit</dt><dd translate=\"\">A product in one normalised unit; the same product in kilograms and in litres is two rows.</dd><dt translate=\"\">Group summaries</dt><dd translate=\"\">A pair is grouped under the project, country and value chain of its comparison assessment.</dd></dl></div></section></aside>");
$templateCache.put("projects/templates/projectAnalytics/reassessment/scores.html","<div ng-init=\"p = payloads.scores\"><div class=\"section-intro\"><span translate=\"\">Scores of {{p.context.score_tool || \'--\'}} assessments, compared across every version of the tool type when both assessments have a valid score.</span> <span translate=\"\">Pairs compared across versions: {{p.cross_version_pairs}}. Pairs left out: {{p.excluded_pairs}}.</span> <span translate=\"\">Dimensions and subdimensions are matched on canonical names, so a renamed section stays one row; a section scored on one side only is not a change.</span></div><div class=\"metrics-grid\"><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.overall.n)}\"><div class=\"metric-title\" translate=\"\">Overall score</div><div class=\"metric-value metric-value--text\">{{charts.two(p.overall.baseline_mean)}} → {{charts.two(p.overall.latest_mean)}}</div><div class=\"metric-note\">N={{p.overall.n}} {{\'pairs\' | translate}}<span class=\"rea-lown\" ng-if=\"lowN(p.overall.n)\" translate=\"\">Small N</span></div></article><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.overall.n)}\"><div class=\"metric-title\" translate=\"\">Average change</div><div class=\"metric-value\" ng-class=\"fmt.changeClass(p.overall.mean_change)\">{{fmt.signed(p.overall.mean_change, 2)}}</div><div class=\"metric-note\">{{\'Median\' | translate}} {{fmt.signed(p.overall.median_change, 2)}}</div></article><article class=\"metric-card\" ng-class=\"{\'rea-lown-card\': lowN(p.overall.n)}\"><div class=\"metric-title\" translate=\"\">Improved / unchanged / regressed</div><div class=\"metric-value metric-value--text\"><span class=\"delta--up\">{{p.overall.improved}}</span> / <span class=\"delta--flat\">{{p.overall.unchanged}}</span> / <span class=\"delta--down\">{{p.overall.declined}}</span></div><div class=\"metric-note\">N={{p.overall.n}} {{\'pairs\' | translate}}</div></article></div><div class=\"charts-row charts-row--two\"><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Dimensions, baseline vs latest</div><div class=\"chart-card__hint\" translate=\"\">Matched pairs scored on the dimension at both ends.</div><div id=\"reaScoresDimensions\" class=\"chart-body\"></div></div><div class=\"chart-card\"><div class=\"chart-card__title\" translate=\"\">Overall score by assessment round</div><div class=\"chart-card__hint\" translate=\"\">Descriptive: every round of FOs with at least two, not only the matched pairs. N per round in the tooltip.</div><div id=\"reaScoresTrend\" class=\"chart-body\"></div></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Dimensions and subdimensions</div><div class=\"table-card__hint\" translate=\"\">Click a dimension to show its subdimensions. N is the pairs scored on the section in both assessments; \"One side\" counts pairs where only one assessment has the section.</div><div class=\"rea-scroll\"><table class=\"analytics-table\"><thead><tr><th translate=\"\">Dimension / subdimension</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\" translate=\"\">Improved</th><th class=\"numeric\" translate=\"\">Unchanged</th><th class=\"numeric\" translate=\"\">Regressed</th><th class=\"numeric\" translate=\"\">One side</th><th translate=\"\">By round (all rounds)</th></tr></thead><tbody ng-repeat=\"dimension in p.dimensions track by dimension.key\"><tr class=\"row--first rea-clickable\" ng-click=\"scores.expanded[dimension.key] = !scores.expanded[dimension.key]\" ng-class=\"{\'rea-lown-row\': lowN(dimension.n)}\"><td title=\"{{\'Source titles\' | translate}}: {{dimension.source_titles.join(\', \')}} · {{\'Versions\' | translate}}: {{dimension.versions.join(\', \')}}\"><i class=\"fa\" ng-class=\"scores.expanded[dimension.key] ? \'fa-caret-down\' : \'fa-caret-right\'\"></i> <strong>{{dimension.title}}</strong> <span class=\"flag-badge\" ng-if=\"!dimension.mapped\" translate=\"\">Unmapped</span></td><td class=\"numeric\">{{dimension.n}}<span class=\"rea-lown\" ng-if=\"lowN(dimension.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.two(dimension.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(dimension.latest_mean)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(dimension.mean_change)\">{{fmt.signed(dimension.mean_change, 2)}}</td><td class=\"numeric\">{{charts.pct(dimension.improved_pct)}}</td><td class=\"numeric\">{{charts.pct(dimension.unchanged_pct)}}</td><td class=\"numeric\">{{charts.pct(dimension.declined_pct)}}</td><td class=\"numeric rea-muted\">{{dimension.one_side_only}}</td><td class=\"rea-trend\"><span ng-repeat=\"point in dimension.trend\">R{{point.round}} {{charts.two(point.mean)}} (N={{point.n}})<span ng-if=\"!$last\">·</span></span></td></tr><tr ng-repeat=\"sub in dimension.subdimensions track by sub.key\" ng-if=\"scores.expanded[dimension.key]\" class=\"rea-subrow\" ng-class=\"{\'rea-lown-row\': lowN(sub.n)}\"><td title=\"{{\'Source titles\' | translate}}: {{sub.source_titles.join(\', \')}}\">{{sub.title}}</td><td class=\"numeric\">{{sub.n}}<span class=\"rea-lown\" ng-if=\"lowN(sub.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.two(sub.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(sub.latest_mean)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(sub.mean_change)\">{{fmt.signed(sub.mean_change, 2)}}</td><td class=\"numeric\">{{charts.pct(sub.improved_pct)}}</td><td class=\"numeric\">{{charts.pct(sub.unchanged_pct)}}</td><td class=\"numeric\">{{charts.pct(sub.declined_pct)}}</td><td class=\"numeric rea-muted\">{{sub.one_side_only}}</td><td class=\"rea-trend\"><span ng-repeat=\"point in sub.trend\">R{{point.round}} {{charts.two(point.mean)}} (N={{point.n}})<span ng-if=\"!$last\">·</span></span></td></tr></tbody></table></div><div class=\"empty-hint\" ng-if=\"!p.dimensions.length\" translate=\"\">No dimension scores for the matched FOs.</div><div class=\"table-card__hint\" ng-if=\"p.section_review.length\"><span translate=\"\">Sections to review: {{p.section_review.length}}. See Coverage &amp; Data Quality.</span></div></div><div class=\"charts-row charts-row--two\"><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Most improved subdimensions</div><div class=\"table-card__hint\" translate=\"\">Up to 15 subdimensions with the largest average gain over the matched pairs.</div><table class=\"analytics-table\"><thead><tr><th>#</th><th translate=\"\">Subdimension</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th></tr></thead><tbody><tr ng-repeat=\"row in p.top_improved track by $index\" ng-class=\"{\'rea-lown-row\': lowN(row.n)}\"><td class=\"rea-muted\">{{$index + 1}}</td><td>{{row.title}} <span class=\"rea-muted\">{{row.parent}}</span></td><td class=\"numeric\">{{row.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.two(row.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(row.latest_mean)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.mean_change)\">{{fmt.signed(row.mean_change, 2)}}</td></tr><tr ng-if=\"!p.top_improved.length\"><td colspan=\"6\" class=\"empty-hint\" translate=\"\">No subdimension improved on average.</td></tr></tbody></table></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Most deteriorated subdimensions</div><div class=\"table-card__hint\" translate=\"\">Up to 15 subdimensions with the largest average fall over the matched pairs.</div><table class=\"analytics-table\"><thead><tr><th>#</th><th translate=\"\">Subdimension</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th></tr></thead><tbody><tr ng-repeat=\"row in p.top_deteriorated track by $index\" ng-class=\"{\'rea-lown-row\': lowN(row.n)}\"><td class=\"rea-muted\">{{$index + 1}}</td><td>{{row.title}} <span class=\"rea-muted\">{{row.parent}}</span></td><td class=\"numeric\">{{row.n}}<span class=\"rea-lown\" ng-if=\"lowN(row.n)\" translate=\"\">Small N</span></td><td class=\"numeric\">{{charts.two(row.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(row.latest_mean)}}</td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.mean_change)\">{{fmt.signed(row.mean_change, 2)}}</td></tr><tr ng-if=\"!p.top_deteriorated.length\"><td colspan=\"6\" class=\"empty-hint\" translate=\"\">No subdimension declined on average.</td></tr></tbody></table></div></div><div class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Individual FO score progression</div><div class=\"table-filters\"><div class=\"table-filters__group\"><input class=\"form-control input-sm\" type=\"search\" ng-model=\"tables.scores.search\" ng-change=\"tables.scores.page = 0\" placeholder=\"{{\'Search FO, country or value chain\' | translate}}\"></div><div class=\"table-filters__group\"><button class=\"btn btn-default btn-sm\" ng-click=\"exportCsv(\'fos\')\"><i class=\"fa fa-download\"></i> <span translate=\"\">Export FOs</span></button></div></div><div class=\"rea-scroll\"><table class=\"analytics-table rea-fo-table\"><thead><tr><th class=\"rea-fo rea-sortable\" ng-click=\"sortTable(\'scores\', \'fo_name\')\"><span translate=\"\">FO</span><i class=\"fa\" ng-class=\"sortClass(\'scores\', \'fo_name\')\"></i></th><th translate=\"\">Rounds</th><th class=\"rea-sortable\" ng-click=\"sortTable(\'scores\', \'baseline.score\')\"><span translate=\"\">Baseline</span><i class=\"fa\" ng-class=\"sortClass(\'scores\', \'baseline.score\')\"></i></th><th class=\"rea-sortable\" ng-click=\"sortTable(\'scores\', \'comparison.score\')\"><span translate=\"\">Latest</span><i class=\"fa\" ng-class=\"sortClass(\'scores\', \'comparison.score\')\"></i></th><th class=\"numeric rea-sortable\" ng-click=\"sortTable(\'scores\', \'change\')\"><span translate=\"\">Change</span><i class=\"fa\" ng-class=\"sortClass(\'scores\', \'change\')\"></i></th><th translate=\"\">History</th><th translate=\"\">Note</th></tr></thead><tbody><tr ng-repeat=\"row in pageRows(\'scores\', p.fos) track by $index\"><td class=\"rea-fo\"><a class=\"dq-link\" title=\"{{row.fo_name}}\" ng-click=\"selectTab(\'explorer\'); openFo(row.fo_id)\">{{row.fo_name}}</a></td><td>{{row.step}}</td><td>{{charts.two(row.baseline.score)}} <span class=\"rea-muted\">{{row.baseline.date}} · v{{row.baseline.tool_version}}</span></td><td>{{charts.two(row.comparison.score)}} <span class=\"rea-muted\">{{row.comparison.date}} · v{{row.comparison.tool_version}}</span></td><td class=\"numeric\" ng-class=\"fmt.changeClass(row.change)\">{{fmt.signed(row.change, 2)}}</td><td class=\"rea-trend\"><span ng-repeat=\"point in row.history\">{{charts.two(point.score)}}<span ng-if=\"!$last\">→</span></span></td><td><span class=\"flag-badge\" ng-repeat=\"reason in row.exclusion_reasons\">{{reasonLabel(reason)}}</span> <span class=\"flag-badge flag-badge--info\" ng-if=\"row.tool_version_differs\">{{reasonLabel(\'tool_version_differs\')}}</span></td></tr><tr ng-if=\"!pageInfo(\'scores\', p.fos).total\"><td colspan=\"7\" class=\"empty-hint\" translate=\"\">No FO matches.</td></tr></tbody></table></div><div class=\"rea-pager\"><span class=\"rea-muted\">{{pageInfo(\'scores\', p.fos).from}}–{{pageInfo(\'scores\', p.fos).to}} / {{pageInfo(\'scores\', p.fos).total}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'scores\', -1, p.fos)\" ng-disabled=\"!pageInfo(\'scores\', p.fos).page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePage(\'scores\', 1, p.fos)\" ng-disabled=\"pageInfo(\'scores\', p.fos).page >= pageInfo(\'scores\', p.fos).pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div></div></div>");
$templateCache.put("score-builder/partials/score-builder-questions/check-box/check-box.html","<article><aside class=\"weight__subquestion\"><p><span><input type=\"text\" ng-model=\"questionCtrl.question.displayWeight\"></span> <span>%</span></p></aside><main class=\"subquestion subquestion--ticketbox\"><span class=\"close\" ng-click=\"questionCtrl.removeQuestion()\">&times;</span><header class=\"subquestion__header\"><h3><input type=\"text\" placeholder=\"{{\'Title\' | translate}}\" ng-disabled=\"!questionCtrl.question.id\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionTitle()\" ng-model=\"questionCtrl.question.title\"></h3><textarea cols=\"30\" rows=\"2\" class=\"form-control\" placeholder=\"{{\'Question Description\' | translate}}\" ng-disabled=\"!questionCtrl.question.id\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionDescription()\" ng-model=\"questionCtrl.question.description\">\n            </textarea></header><div class=\"checkbox subquestion__question\" ng-repeat=\"option in questionCtrl.question.options.objects track by $index\"><span ng-if=\"option.title !== \'N/R\'\" class=\"close\" ng-click=\"questionCtrl.removeQuestionOption(option, $index)\">&times;</span> <label><input type=\"checkbox\"> <input ng-if=\"option.title !== \'N/R\'\" id=\"part--{{$index}}\" type=\"text\" class=\"form-control\" ng-model=\"option.title\" ng-model-options=\"{updateOn: \'blur\'}\" ng-disabled=\"option.disabled\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></label> <label style=\"display: flex; align-items:center; margin-top:5px;\"><span style=\"text-wrap: nowrap; margin-right: 5px;\">A2F Score</span> <input type=\"text\" class=\"form-control\" ng-model=\"option.a2f_score\" ng-disabled=\"option.disabled\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></label><div class=\"form-group\" ng-if=\"questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Applicable Tool Types</label><select class=\"form-control\" chosen=\"\" multiple=\"\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as (item.name) for item in questionCtrl.toolTypes.results\" ng-model=\"option.active_in\" style=\"width: 100%\"><option></option></select></div><option-condition ng-if=\"!questionCtrl.isCanonicalTree\" option=\"option\"></option-condition><div class=\"form-group\" ng-if=\"!questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Canonical Option</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as item.title for item in questionCtrl.canonicalOptions\" ng-model=\"option.canonical\" style=\"width: 100%\"><option></option></select></div></div><br><div class=\"subquestion__footer\"><div class=\"subquestion__options-add\"><label for=\"none-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"none-{{questionCtrl.index}}\" ng-change=\"questionCtrl.updateQuestion(\'can_be_none_of_the_above\')\" ng-model=\"questionCtrl.question.can_be_none_of_the_above\"> &nbsp;Add \"None of the Above\" Option</label> <label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'can_be_not_relevant\')\" ng-model=\"questionCtrl.question.can_be_not_relevant\"> &nbsp;Add \"N/R\" Option</label> <label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'comment_mandatory\')\" ng-model=\"questionCtrl.question.comment_mandatory\"> &nbsp;Comment Mandatory</label></div><div class=\"subquestion__option\" ng-show=\"questionCtrl.question.id\" ng-click=\"questionCtrl.addQuestionOption()\"><span class=\"subquestion__option__label\" translate=\"\">Add Question Option</span> <span class=\"subquestion__option__input\"><p>+</p></span></div></div><div class=\"form-group\" ng-if=\"questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Applicable Tool Types</label><select class=\"form-control\" chosen=\"\" multiple=\"\" ng-change=\"questionCtrl.updateQuestion(\'active_in\', \'{{questionCtrl.question.active_in}}\')\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as (item.name) for item in questionCtrl.toolTypes.results\" ng-model=\"questionCtrl.question.active_in\" style=\"width: 100%\"><option></option></select></div><div class=\"form-group\" ng-if=\"!questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Canonical Subquestion</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateCanonicalOptions()\" data-placeholder-text-single=\"\'select canonical subquestion\' | translate\" ng-options=\"item.url as item.display_position + \' \' + item.title for item in questionCtrl.canonicalSubquestions.results | orderBy: \'display_position\'\" ng-model=\"questionCtrl.question.canonical\" style=\"width: 100%\"><option></option></select></div></main><conditional-on question=\"questionCtrl.question\" questions=\"questionCtrl.questions\" update-fct=\"questionCtrl.updateFct()\" index=\"questionCtrl.index\"></conditional-on></article>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/drawer.html","<aside class=\"sa-drawer\" ng-if=\"drawer.open && drawer.node\" role=\"complementary\" aria-label=\"{{\'Selected result analysis\' | translate}}\"><div class=\"sa-drawer__bar\"><span class=\"sa-muted\">{{context.tool}} v{{context.version}} · {{payloads.overview.kpis.fo_count}} {{\'FOs\' | translate}}</span> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"closeDrawer()\" translate=\"\">Close</button></div><div class=\"sa-muted\"><span ng-if=\"drawer.node.level === \'dimension\'\" translate=\"\">Dimension</span> <span ng-if=\"drawer.node.level === \'subdimension\'\" translate=\"\">Subdimension</span> <span ng-if=\"drawer.node.level === \'question\'\" translate=\"\">Question</span> <span ng-if=\"drawer.node.parent && node(drawer.node.parent)\">· <a class=\"dq-link\" ng-if=\"drawer.node.level === \'question\' && node(node(drawer.node.parent).parent)\" ng-click=\"openNode(node(drawer.node.parent).parent)\">{{node(drawer.node.parent).parent}} {{node(node(drawer.node.parent).parent).title}}</a> <span ng-if=\"drawer.node.level === \'question\' && node(node(drawer.node.parent).parent)\">/</span> <a class=\"dq-link\" ng-click=\"openNode(drawer.node.parent)\">{{drawer.node.parent}} {{node(drawer.node.parent).title}}</a></span></div><h3 class=\"sa-drawer__title\"><span class=\"sa-key\">{{drawer.node.id}}</span> {{drawer.node.title}}</h3><div class=\"sa-drawer__head\"><span class=\"sa-big\">{{charts.two(drawer.node.stats.mean)}}</span> <span class=\"sa-muted\">{{\'mean of\' | translate}} {{drawer.node.stats.n}} {{\'scored FOs\' | translate}}</span> <span class=\"sa-band\" ng-if=\"drawer.node.stats.mean !== null\" ng-style=\"{\'border-left-color\': api.BAND_COLORS[bandOf(drawer.node.stats.mean)]}\">{{bandLabel(bandOf(drawer.node.stats.mean)) | translate}}</span></div><div class=\"sa-stats\"><div class=\"sa-stat\"><strong>{{charts.two(drawer.node.stats.median)}}</strong><span translate=\"\">Median</span></div><div class=\"sa-stat\"><strong>{{charts.two(drawer.node.stats.min)}} – {{charts.two(drawer.node.stats.max)}}</strong><span translate=\"\">Min – max</span></div><div class=\"sa-stat\"><strong>{{charts.two(drawer.node.stats.sd)}}</strong><span translate=\"\">Spread (SD)</span></div><div class=\"sa-stat\"><strong>{{charts.two(drawer.node.stats.q1)}} – {{charts.two(drawer.node.stats.q3)}}</strong><span translate=\"\">Middle 50%</span></div><div class=\"sa-stat\"><strong>{{charts.pct(drawer.node.stats.weak_pct, 0)}}</strong><span>{{\'Weak\' | translate}} · {{drawer.node.stats.weak_n}}</span></div><div class=\"sa-stat\"><strong>{{charts.pct(drawer.node.stats.strong_pct, 0)}}</strong><span>{{\'Strong\' | translate}} · {{drawer.node.stats.strong_n}}</span></div><div class=\"sa-stat\"><strong>{{drawer.node.stats.n}} / {{drawer.node.stats.eligible}}</strong><span translate=\"\">Scored / eligible</span></div><div class=\"sa-stat\"><strong>{{drawer.node.stats.not_relevant}} · {{drawer.node.stats.missing}}</strong><span translate=\"\">Not relevant · missing</span></div></div><div class=\"sa-callout\" ng-if=\"drawer.node.level === \'question\'\"><strong>{{\'Association with the overall score\' | translate}}: r = {{drawer.node.stats.association === null ? \'--\' : drawer.node.stats.association}}</strong> <span class=\"sa-muted\" translate=\"\">How closely the question moves with FOs\' overall scores. Below 0.2 it separates FOs weakly. Needs 10 or more scored FOs.</span></div><h4 class=\"sa-sub-h\" ng-if=\"drawer.node.level === \'question\'\" translate=\"\">Answer distribution, scores 1 to 5</h4><h4 class=\"sa-sub-h\" ng-if=\"drawer.node.level !== \'question\'\" translate=\"\">FOs by score band</h4><div ng-if=\"drawer.node.level === \'question\'\"><div class=\"sa-bar-row sa-bar-row--static sa-bar-row--four\" ng-repeat=\"count in drawer.node.stats.options track by $index\"><span class=\"sa-lab\">{{\'Score\' | translate}} {{$index + 1}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: (drawer.node.stats.n ? count / drawer.node.stats.n * 100 : 0) + \'%\', background: api.OPTION_COLORS[$index]}\"></span></span> <strong class=\"numeric\">{{count}}</strong> <span class=\"numeric sa-muted\">{{charts.pct(drawer.node.stats.n ? count / drawer.node.stats.n * 100 : null, 0)}}</span></div><p class=\"sa-note\" translate=\"\">Valid answers only. A question averaged over several subquestions is counted at the nearest whole score.</p></div><div ng-if=\"drawer.node.level !== \'question\'\"><div class=\"sa-bar-row sa-bar-row--static sa-bar-row--four\" ng-repeat=\"b in drawer.node.stats.bands track by b.key\"><span class=\"sa-lab\">{{bandLabel(b.key) | translate}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: (drawer.node.stats.n ? b.count / drawer.node.stats.n * 100 : 0) + \'%\', background: api.BAND_COLORS[b.key]}\"></span></span> <strong class=\"numeric\">{{b.count}}</strong> <span class=\"numeric sa-muted\">{{charts.pct(drawer.node.stats.n ? b.count / drawer.node.stats.n * 100 : null, 0)}}</span></div></div><div ng-if=\"drawer.children.length\"><h4 class=\"sa-sub-h\"><span ng-if=\"drawer.node.level === \'dimension\'\" translate=\"\">Subdimensions, lowest first</span> <span ng-if=\"drawer.node.level !== \'dimension\'\" translate=\"\">Questions, lowest first</span></h4><button type=\"button\" class=\"sa-bar-row\" ng-repeat=\"child in drawer.children track by child.id\" ng-click=\"openNode(child.id)\"><span class=\"sa-lab\"><span class=\"sa-key\">{{child.id}}</span> {{child.title}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: api.scale(child.stats.mean) + \'%\', background: api.BAND_COLORS[bandOf(child.stats.mean)]}\"></span></span> <strong class=\"numeric\">{{charts.two(child.stats.mean)}}</strong></button></div><div ng-if=\"drawer.payload.breakdowns\"><h4 class=\"sa-sub-h\" translate=\"\">Breakdowns</h4><div class=\"sa-breakdown\" ng-repeat=\"key in [\'maturity\', \'country\', \'value_chain\'] track by key\" ng-init=\"b = drawer.payload.breakdowns[key]\"><div class=\"sa-breakdown__head\"><span ng-if=\"key === \'maturity\'\" translate=\"\">By FO maturity level (a rising gradient is expected)</span> <span ng-if=\"key === \'country\'\" translate=\"\">By country</span> <span ng-if=\"key === \'value_chain\'\" translate=\"\">By value chain</span> <span class=\"sa-muted\" ng-if=\"drawer.payload.breakdowns[key].gap !== null\">{{\'Gap\' | translate}} {{charts.two(drawer.payload.breakdowns[key].gap)}}</span></div><div class=\"sa-bar-row sa-bar-row--static\" ng-repeat=\"g in drawer.payload.breakdowns[key].groups track by g.label\" ng-class=\"{\'sa-faded\': g.small}\"><span class=\"sa-lab\">{{g.label | translate}} <span class=\"sa-muted\">N={{g.n}}</span></span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: api.scale(g.mean) + \'%\'}\"></span></span> <strong class=\"numeric\">{{charts.two(g.mean)}}</strong></div></div><p class=\"sa-note\" translate=\"\">Faded groups have fewer than 10 scored FOs. The gap compares the other groups only.</p></div><h4 class=\"sa-sub-h\"><span translate=\"\">FOs behind this result</span> <span class=\"sa-muted\">{{drawer.payload.total}} · {{\'lowest first\' | translate}}</span></h4><div class=\"table-filters\"><div class=\"table-filters__group\"><select class=\"form-control input-sm\" ng-model=\"drawer.only\" ng-change=\"drawer.page = 0; loadDrawer()\" ng-options=\"o.value as (o.label | translate) for o in drawerFilters\"></select></div></div><div class=\"loading-note\" ng-if=\"drawer.loading\" translate=\"\">Loading FOs…</div><table class=\"analytics-table\" ng-if=\"drawer.payload\"><thead><tr><th translate=\"\">FO</th><th class=\"numeric\" translate=\"\">Score</th><th translate=\"\">Band</th><th class=\"numeric\" translate=\"\">Overall</th><th></th></tr></thead><tbody><tr ng-repeat=\"fo in drawer.payload.fos track by fo.fo_id\"><td class=\"sa-wrap\"><a class=\"dq-link\" ng-click=\"openFo(fo.fo_id)\">{{fo.fo_name}}</a><div class=\"sa-muted\">{{fo.country || \'--\'}} · {{fo.value_chain || \'--\'}} · {{maturityLabel(fo.maturity_level) | translate}} · {{fo.date}}</div></td><td class=\"numeric\"><strong ng-if=\"fo.state === \'valid\'\">{{charts.two(fo.value)}}</strong> <span class=\"flag-badge\" ng-if=\"fo.state === \'not_relevant\'\" translate=\"\">Not relevant</span> <span class=\"flag-badge\" ng-if=\"fo.state === \'missing\'\" translate=\"\">Missing</span></td><td><span class=\"sa-band\" ng-if=\"fo.band\" ng-style=\"{\'border-left-color\': api.BAND_COLORS[fo.band]}\">{{bandLabel(fo.band) | translate}}</span></td><td class=\"numeric\">{{charts.two(fo.overall)}}</td><td><a class=\"dq-link\" ng-if=\"fo.can_open\" ng-href=\"{{assessmentHref(fo.assessment_id)}}\" target=\"_blank\" translate=\"\">Open assessment</a></td></tr><tr ng-if=\"!drawer.payload.fos.length\"><td colspan=\"5\" class=\"empty-hint\" translate=\"\">No FOs.</td></tr></tbody></table><div class=\"sa-pager\" ng-if=\"drawer.payload.pages > 1\"><span class=\"sa-muted\">{{\'Page\' | translate}} {{drawer.payload.page + 1}} / {{drawer.payload.pages}}</span> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-disabled=\"drawer.payload.page === 0\" ng-click=\"drawer.page = drawer.payload.page - 1; loadDrawer()\" translate=\"\">Previous</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-disabled=\"drawer.payload.page >= drawer.payload.pages - 1\" ng-click=\"drawer.page = drawer.payload.page + 1; loadDrawer()\" translate=\"\">Next</button></div></aside>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/explorer.html","<div class=\"sa-stack\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Two separate interpretations of scores</div><div class=\"table-card__hint\" translate=\"\">Score bands describe a score; maturity levels classify an FO. The names and ranges are different on purpose.</div><div class=\"sa-two\"><div><strong translate=\"\">Score bands</strong><div class=\"sa-legend\"><span ng-repeat=\"band in context.bands\"><i ng-style=\"{background: api.BAND_COLORS[band.key]}\"></i>{{band.label | translate}} ({{band.min}}–{{band.max}})</span></div><p class=\"sa-note\" translate=\"\">Used for score colours, labels, strengths and weaknesses. Below 2.5 is weak; 3.0 or above is strong.</p></div><div><strong translate=\"\">FO maturity levels</strong><div class=\"sa-legend\"><span ng-repeat=\"level in context.maturity_levels\"><i ng-style=\"{background: api.MATURITY_COLORS[level.key]}\"></i>{{level.label | translate}} ({{level.min}}–{{level.max}})</span></div><p class=\"sa-note\" translate=\"\">Used to classify FOs and for maturity distributions.</p></div></div></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Average score by dimension</div><div class=\"table-card__hint\" translate=\"\">Mean on the 1–5 scale, coloured by score band. The dashed line is the weak threshold (2.5). Click a dimension for its analysis.</div><div class=\"sa-score-row sa-score-row--head\"><span translate=\"\">Dimension</span> <span class=\"sa-axis\"><span ng-repeat=\"tick in [1,2,3,4,5] track by $index\" ng-style=\"{left: api.scale(tick) + \'%\'}\">{{tick}}</span></span> <span class=\"numeric\" translate=\"\">Mean</span> <span class=\"numeric\">N</span></div><button type=\"button\" class=\"sa-score-row\" ng-repeat=\"dim in dimensions track by dim.id\" ng-class=\"{\'sa-selected\': drawer.open && drawer.node.id === dim.id}\" ng-click=\"openNode(dim.id)\"><span><span class=\"sa-key\">{{dim.id}}</span> {{dim.title}}</span> <span class=\"sa-line\"><span class=\"sa-line__fill\" ng-style=\"{width: api.scale(dim.stats.mean) + \'%\', background: api.BAND_COLORS[bandOf(dim.stats.mean)]}\"></span> <span class=\"sa-line__threshold\"></span></span> <strong class=\"numeric\">{{charts.two(dim.stats.mean)}}</strong> <span class=\"numeric sa-muted\">{{dim.stats.n}}</span></button></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Distribution of FO scores by dimension</div><div class=\"table-card__hint\" translate=\"\">Percentage of farmer organizations in each score band, based on their dimension scores.</div><div class=\"sa-scroll\"><table class=\"analytics-table sa-matrix\"><thead><tr><th translate=\"\">Score band</th><th class=\"numeric\" ng-repeat=\"dim in dimensions track by dim.id\" title=\"{{dim.title}}\">{{dim.id}}<br><span class=\"sa-muted\">{{dim.title}}</span></th></tr></thead><tbody><tr ng-repeat=\"band in context.bands track by band.key\"><th><i class=\"sa-swatch\" ng-style=\"{background: api.BAND_COLORS[band.key]}\"></i>{{band.label | translate}} <span class=\"sa-muted\">{{bandRange(band)}}</span></th><td class=\"numeric sa-matrix__cell\" ng-repeat=\"dim in dimensions track by dim.id\" ng-style=\"{background: bandPct(dim, band.key) ? api.BAND_COLORS[band.key] + (bandPct(dim, band.key) >= 45 ? \'cc\' : \'55\') : \'\'}\" title=\"{{dim.title}} · {{band.label | translate}}: {{bandCount(dim, band.key)}} / {{dim.stats.n}} {{\'FOs\' | translate}}\">{{bandPct(dim, band.key) === null ? \'--\' : bandPct(dim, band.key) + \'%\'}}</td></tr><tr class=\"sa-matrix__n\"><th>N <span class=\"sa-muted\" translate=\"\">FOs with a valid score</span></th><td class=\"numeric\" ng-repeat=\"dim in dimensions track by dim.id\"><strong>{{dim.stats.n}}</strong></td></tr></tbody></table></div><p class=\"sa-note\" translate=\"\">Score bands describe a dimension score; they are not the FO\'s overall maturity level. Each column is 100% of that dimension\'s N; rounding can make it differ by a point.</p></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Strongest and weakest subdimensions</div><div class=\"table-card__hint\" translate=\"\">Top 10 of each.</div><div class=\"table-card__hint\">{{\'Ranked over subdimensions with at least\' | translate}} {{payloads.overview.min_rank_n}} {{\'scored FOs.\' | translate}}</div><div class=\"sa-two\"><div><strong translate=\"\">Weakest</strong> <button type=\"button\" class=\"sa-rank\" ng-repeat=\"id in payloads.overview.insights.weakest_subdimensions track by id\" ng-click=\"openNode(id)\"><span><span class=\"sa-key\">{{id}}</span> {{node(id).title}}</span> <strong class=\"numeric\" ng-style=\"{color: api.BAND_COLORS[bandOf(node(id).stats.mean)]}\">{{charts.two(node(id).stats.mean)}}</strong> <span class=\"sa-muted numeric\">{{charts.pct(node(id).stats.weak_pct, 0)}} {{\'weak\' | translate}} · N={{node(id).stats.n}}</span></button></div><div><strong translate=\"\">Strongest</strong> <button type=\"button\" class=\"sa-rank\" ng-repeat=\"id in payloads.overview.insights.strongest_subdimensions track by id\" ng-click=\"openNode(id)\"><span><span class=\"sa-key\">{{id}}</span> {{node(id).title}}</span> <strong class=\"numeric\" ng-style=\"{color: api.BAND_COLORS[bandOf(node(id).stats.mean)]}\">{{charts.two(node(id).stats.mean)}}</strong> <span class=\"sa-muted numeric\">{{charts.pct(node(id).stats.strong_pct, 0)}} {{\'strong\' | translate}} · N={{node(id).stats.n}}</span></button></div></div></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Automatic question insights</div><div class=\"table-card__hint\">{{\'Rankings over the filtered population · questions with at least\' | translate}} {{payloads.overview.min_rank_n}} {{\'scored FOs · select a question to investigate\' | translate}}</div><div class=\"sa-chips\"><button type=\"button\" class=\"btn btn-sm\" ng-repeat=\"mode in insightModes track by mode.value\" ng-class=\"explorer.insight === mode.value ? \'btn-primary\' : \'btn-default\'\" ng-click=\"explorer.insight = mode.value; refreshExplorer()\">{{mode.label | translate}}</button></div><table class=\"analytics-table\"><thead><tr><th>#</th><th translate=\"\">Question</th><th translate=\"\">Subdimension</th><th class=\"numeric\" translate=\"\">Mean</th><th class=\"numeric\" translate=\"\">Weak FOs</th><th class=\"numeric\" translate=\"\">NR %</th><th class=\"numeric\">SD</th><th class=\"numeric\">N</th></tr></thead><tbody><tr ng-repeat=\"q in explorer.insightRows track by q.id\" class=\"sa-clickable\" ng-click=\"openNode(q.id)\"><td>{{$index + 1}}</td><td class=\"sa-wrap\"><span class=\"sa-key\">{{q.id}}</span> {{q.title}}</td><td class=\"sa-muted\">{{node(q.parent).title}}</td><td class=\"numeric\"><strong>{{charts.two(q.stats.mean)}}</strong></td><td class=\"numeric\">{{q.stats.weak_n}} ({{charts.pct(q.stats.weak_pct, 0)}})</td><td class=\"numeric\">{{charts.pct(q.stats.not_relevant_pct, 0)}}</td><td class=\"numeric\">{{charts.two(q.stats.sd)}}</td><td class=\"numeric\">{{q.stats.n}}</td></tr><tr ng-if=\"!explorer.insightRows.length\"><td colspan=\"8\" class=\"empty-hint\" translate=\"\">Not enough scored FOs to rank questions.</td></tr></tbody></table><p class=\"sa-note\" translate=\"\">Not Relevant is not missing: a high rate may be right for some types of organisation. Findings are descriptive, not causal.</p></section><section class=\"table-card\"><div class=\"sa-card-head\"><div><div class=\"table-card__title\" translate=\"\">Question explorer</div><div class=\"table-card__hint\" translate=\"\">The whole questionnaire by hierarchy or as one ranked table. Select a row to open its analysis.</div></div><div class=\"analytics-topbar-actions\"><button type=\"button\" class=\"btn btn-sm\" ng-class=\"explorer.mode === \'grouped\' ? \'btn-primary\' : \'btn-default\'\" ng-click=\"explorer.mode = \'grouped\'\" translate=\"\">Grouped hierarchy</button> <button type=\"button\" class=\"btn btn-sm\" ng-class=\"explorer.mode === \'flat\' ? \'btn-primary\' : \'btn-default\'\" ng-click=\"explorer.mode = \'flat\'\" translate=\"\">All questions, ranked</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"expandAll()\" ng-disabled=\"explorer.mode === \'flat\' || explorer.filtering\" translate=\"\">Expand all</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"collapseAll()\" ng-disabled=\"explorer.mode === \'flat\' || explorer.filtering\" translate=\"\">Collapse all</button></div></div><div class=\"table-filters\"><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-search\" translate=\"\">Search all questions</label> <input id=\"sa-search\" class=\"form-control input-sm\" type=\"search\" ng-model=\"explorer.search\" ng-change=\"refreshExplorer()\" ng-model-options=\"{debounce: 200}\" placeholder=\"{{\'Question, subdimension or ID\' | translate}}\"></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-sort\" translate=\"\">Sort</label><select id=\"sa-sort\" class=\"form-control input-sm\" ng-model=\"explorer.sort\" ng-change=\"refreshExplorer()\" ng-options=\"o.value as (o.label | translate) for o in sortOptions\"></select></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-show\" translate=\"\">Show</label><select id=\"sa-show\" class=\"form-control input-sm\" ng-model=\"explorer.show\" ng-change=\"refreshExplorer()\" ng-options=\"o.value as (o.label | translate) for o in showOptions\"></select></div></div><div class=\"sa-scroll sa-scroll--tall\"><table class=\"analytics-table sa-tree\"><thead><tr><th translate=\"\">Dimension / subdimension / question</th><th class=\"numeric\" translate=\"\">Mean</th><th class=\"numeric\" translate=\"\">Median</th><th class=\"numeric\" translate=\"\">Min–max</th><th translate=\"\">Score band</th><th translate=\"\">Distribution</th><th class=\"numeric\" translate=\"\">Weak %</th><th class=\"numeric\" translate=\"\">Strong %</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Coverage</th><th class=\"numeric\" translate=\"\">NR / missing</th></tr></thead><tbody><tr ng-repeat=\"n in (explorer.mode === \'flat\' ? explorer.ranked : explorer.rows) track by n.id\" class=\"sa-clickable sa-depth-{{explorer.mode === \'flat\' ? 2 : n.depth}}\" ng-class=\"{\'sa-selected\': drawer.open && drawer.node.id === n.id}\" ng-click=\"openNode(n.id)\"><td class=\"sa-wrap\"><span class=\"sa-indent\" ng-style=\"{\'padding-left\': (explorer.mode === \'flat\' ? 0 : n.depth * 18) + \'px\'}\"><button type=\"button\" class=\"sa-toggle\" ng-if=\"explorer.mode === \'grouped\' && n.level !== \'question\' && !explorer.filtering\" ng-click=\"toggleNode(n, $event)\" aria-expanded=\"{{!!explorer.expanded[n.id]}}\">{{explorer.expanded[n.id] ? \'−\' : \'+\'}}</button> <span class=\"sa-key\">{{n.id}}</span> <span>{{n.title}}</span></span><div class=\"sa-muted\" ng-if=\"explorer.mode === \'flat\'\">{{node(n.dimension).title}} / {{node(n.parent).title}}</div></td><td class=\"numeric\"><strong>{{charts.two(n.stats.mean)}}</strong></td><td class=\"numeric\">{{charts.two(n.stats.median)}}</td><td class=\"numeric sa-muted\">{{charts.two(n.stats.min)}}–{{charts.two(n.stats.max)}}</td><td><span class=\"sa-band\" ng-if=\"n.stats.mean !== null\" ng-style=\"{\'border-left-color\': api.BAND_COLORS[bandOf(n.stats.mean)]}\">{{bandLabel(bandOf(n.stats.mean)) | translate}}</span></td><td><span class=\"sa-strip\" ng-if=\"n.level === \'question\'\" title=\"{{\'Answers scored 1 to 5\' | translate}}\"><span ng-repeat=\"count in n.stats.options track by $index\" ng-style=\"{width: (n.stats.n ? count / n.stats.n * 100 : 0) + \'%\', background: api.OPTION_COLORS[$index]}\" title=\"{{\'Score\' | translate}} {{$index + 1}}: {{count}}\"></span></span> <span class=\"sa-strip\" ng-if=\"n.level !== \'question\'\" title=\"{{\'FOs by score band\' | translate}}\"><span ng-repeat=\"b in n.stats.bands track by b.key\" ng-style=\"{width: (n.stats.n ? b.count / n.stats.n * 100 : 0) + \'%\', background: api.BAND_COLORS[b.key]}\" title=\"{{bandLabel(b.key)}}: {{b.count}}\"></span></span></td><td class=\"numeric\">{{charts.pct(n.stats.weak_pct, 0)}}</td><td class=\"numeric\">{{charts.pct(n.stats.strong_pct, 0)}}</td><td class=\"numeric\">{{n.stats.n}}</td><td class=\"numeric\">{{charts.pct(n.stats.coverage_pct, 0)}}</td><td class=\"numeric sa-muted\">{{n.stats.not_relevant}} / {{n.stats.missing}}</td></tr><tr ng-if=\"!(explorer.mode === \'flat\' ? explorer.ranked : explorer.rows).length\"><td colspan=\"11\" class=\"empty-hint\" translate=\"\">No questions match the search and filters.</td></tr></tbody></table></div><p class=\"sa-note\"><span ng-if=\"explorer.filtering\">{{explorer.matched}} / {{questions.length}} {{\'questions match.\' | translate}}</span> {{\'Weak: share of scored FOs below 2.5. Strong: 3.0 or above. Coverage: scored FOs of those whose questionnaire has the item. Distribution: score bands for dimensions and subdimensions, answers 1 to 5 for questions. Not Relevant and missing answers are excluded from every average.\' | translate}}</p></section></div>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/foProfile.html","<div class=\"sa-modal\" ng-if=\"profile.open && profile.payload\" role=\"dialog\" aria-modal=\"true\" ng-click=\"closeFo()\"><div class=\"sa-modal__card\" ng-click=\"$event.stopPropagation()\" ng-init=\"p = profile.payload\"><div class=\"sa-card-head\"><div><div class=\"sa-muted\">{{\'FO profile\' | translate}} · {{profile.payload.context.tool}} v{{profile.payload.fo.tool_version}}</div><h3 class=\"sa-drawer__title\">{{profile.payload.fo.fo_name}}</h3><div class=\"sa-muted\">{{profile.payload.fo.country || \'--\'}} · {{profile.payload.fo.value_chain || \'--\'}} · {{\'Maturity\' | translate}}: {{maturityLabel(profile.payload.fo.maturity_level) | translate}} · {{profile.payload.fo.project_name}} · {{\'Assessed\' | translate}} {{profile.payload.fo.date}}</div></div><div class=\"analytics-topbar-actions\"><a class=\"btn btn-default btn-sm\" ng-if=\"profile.payload.fo.can_open\" ng-href=\"{{assessmentHref(profile.payload.fo.assessment_id)}}\" target=\"_blank\" translate=\"\">Open assessment</a> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"closeFo()\" translate=\"\">Close</button></div></div><div class=\"sa-stats\"><div class=\"sa-stat\"><strong>{{charts.two(profile.payload.fo.overall)}}</strong><span translate=\"\">Overall score</span></div><div class=\"sa-stat\"><strong ng-class=\"api.changeClass(profile.payload.against_population)\">{{api.signed(profile.payload.against_population, 1)}}</strong><span translate=\"\">Against the population mean</span></div><div class=\"sa-stat\"><strong>{{profile.payload.answers.valid}}</strong><span translate=\"\">Scored questions</span></div><div class=\"sa-stat\"><strong>{{profile.payload.answers.not_relevant}} · {{profile.payload.answers.missing}}</strong><span translate=\"\">Not relevant · missing</span></div></div><h4 class=\"sa-sub-h\"><span translate=\"\">Dimension scores against the population</span> <span class=\"sa-muted\" translate=\"\">bar: this FO · mark: population mean</span></h4><div class=\"sa-bar-row sa-bar-row--static sa-bar-row--four\" ng-repeat=\"n in profile.payload.nodes | filter: {level: \'dimension\'} track by n.id\"><span class=\"sa-lab\"><span class=\"sa-key\">{{n.id}}</span> {{node(n.id).title}}</span> <span class=\"sa-track sa-track--marked\"><span class=\"sa-track__fill\" ng-style=\"{width: api.scale(n.value) + \'%\', background: api.BAND_COLORS[bandOf(n.value)]}\"></span> <span class=\"sa-track__tick\" ng-if=\"n.population_mean !== null\" ng-style=\"{left: api.scale(n.population_mean) + \'%\'}\" title=\"{{\'Population mean\' | translate}} {{charts.two(n.population_mean)}}\"></span></span> <strong class=\"numeric\">{{charts.two(n.value)}}</strong> <span class=\"numeric\" ng-class=\"api.changeClass(n.difference)\">{{api.signed(n.difference, 1)}}</span></div><div class=\"sa-two\"><div><h4 class=\"sa-sub-h\" translate=\"\">Furthest below the population</h4><table class=\"analytics-table\"><thead><tr><th translate=\"\">Question</th><th class=\"numeric\">FO</th><th class=\"numeric\" translate=\"\">Population</th><th class=\"numeric\" translate=\"\">Difference</th></tr></thead><tbody><tr ng-repeat=\"q in profile.payload.furthest_below track by q.id\"><td class=\"sa-wrap\"><span class=\"sa-key\">{{q.id}}</span> {{node(q.id).title}}</td><td class=\"numeric\"><strong>{{charts.two(q.value)}}</strong></td><td class=\"numeric\">{{charts.two(q.population_mean)}}</td><td class=\"numeric\" ng-class=\"api.changeClass(q.difference)\">{{api.signed(q.difference, 1)}}</td></tr></tbody></table></div><div><h4 class=\"sa-sub-h\" translate=\"\">Furthest above the population</h4><table class=\"analytics-table\"><thead><tr><th translate=\"\">Question</th><th class=\"numeric\">FO</th><th class=\"numeric\" translate=\"\">Population</th><th class=\"numeric\" translate=\"\">Difference</th></tr></thead><tbody><tr ng-repeat=\"q in profile.payload.furthest_above track by q.id\"><td class=\"sa-wrap\"><span class=\"sa-key\">{{q.id}}</span> {{node(q.id).title}}</td><td class=\"numeric\"><strong>{{charts.two(q.value)}}</strong></td><td class=\"numeric\">{{charts.two(q.population_mean)}}</td><td class=\"numeric\" ng-class=\"api.changeClass(q.difference)\">{{api.signed(q.difference, 1)}}</td></tr></tbody></table></div></div><div ng-if=\"profile.payload.change\"><h4 class=\"sa-sub-h\"><span translate=\"\">Change since baseline</span> <span class=\"sa-muted\">{{profile.payload.change.baseline_date}} → {{profile.payload.change.latest_date}} · {{\'overall\' | translate}} {{charts.two(profile.payload.change.overall_baseline)}} → {{charts.two(profile.payload.change.overall_latest)}}</span></h4><div class=\"sa-bar-row sa-bar-row--static\" ng-repeat=\"d in profile.payload.change.dimensions track by d.id\"><span class=\"sa-lab\"><span class=\"sa-key\">{{d.id}}</span> {{node(d.id).title}}</span> <span class=\"sa-muted\">{{charts.two(d.baseline)}} → {{charts.two(d.latest)}}</span> <strong class=\"numeric\" ng-class=\"api.changeClass(d.change)\">{{api.signed(d.change, 1)}}</strong></div></div><p class=\"sa-note\" ng-if=\"!profile.payload.change\" translate=\"\">No earlier assessment of this FO on the same tool version in the selected projects.</p><p class=\"sa-note\" translate=\"\">Questions are ranked by their difference from the population mean, so they show where this FO lags its peers. Open the assessment to review the answers.</p></div></div>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/heatmap.html","<section class=\"table-card\"><div class=\"sa-card-head\"><div><div class=\"table-card__title\" translate=\"\">FO heatmap</div><div class=\"table-card__hint\" translate=\"\">Each cell is an FO\'s score, coloured by score band. Not Relevant and missing answers are marked, never coloured as a low score. Click an FO for its profile, a column for its analysis.</div></div><div class=\"table-filters\"><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-heat-level\" translate=\"\">Columns</label><select id=\"sa-heat-level\" class=\"form-control input-sm\" ng-model=\"heat.level\" ng-change=\"heat.page = 0; loadHeatmap()\"><option value=\"subdimension\" translate=\"\">Subdimensions</option><option value=\"dimension\" translate=\"\">Dimensions</option><option value=\"question\" translate=\"\">Questions of one subdimension</option></select></div><div class=\"table-filters__group\" ng-if=\"heat.level === \'question\'\"><label class=\"ar-label\" for=\"sa-heat-parent\" translate=\"\">Subdimension</label><select id=\"sa-heat-parent\" class=\"form-control input-sm\" ng-model=\"heat.parent\" ng-change=\"heat.page = 0; loadHeatmap()\" ng-options=\"s.id as (s.id + \' \' + s.title) for s in subParents\"></select></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-heat-order\" translate=\"\">Order FOs by</label><select id=\"sa-heat-order\" class=\"form-control input-sm\" ng-model=\"heat.order\" ng-change=\"heat.page = 0; loadHeatmap()\"><option value=\"low\" translate=\"\">Lowest overall first</option><option value=\"high\" translate=\"\">Highest overall first</option><option value=\"name\" translate=\"\">FO name</option></select></div></div></div><div class=\"sa-fo-picker\"><div class=\"sa-card-head\"><div><strong translate=\"\">Find and select FOs</strong><div class=\"table-card__hint\"><span ng-if=\"heat.fos.length\">{{heat.fos.length}} {{\'selected · the heatmap shows only these\' | translate}}</span> <span ng-if=\"!heat.fos.length\" translate=\"\">None selected · the heatmap shows every FO</span></div></div><a class=\"dq-link\" ng-click=\"clearHeatFos()\" ng-if=\"heat.fos.length\" translate=\"\">Clear selection</a></div><input class=\"form-control input-sm\" type=\"search\" ng-model=\"heat.search\" placeholder=\"{{\'Search FO name\' | translate}}\"><div class=\"sa-fo-picker__list\"><label class=\"ar-check\" ng-repeat=\"fo in heatFoOptions() | limitTo: 200 track by fo.fo_id\"><input type=\"checkbox\" ng-checked=\"heat.fos.indexOf(fo.fo_id) > -1\" ng-click=\"toggleHeatFo(fo.fo_id)\"> <span>{{fo.fo_name}}</span></label></div></div><div class=\"sa-scroll\" ng-if=\"payloads.heatmap\"><table class=\"sa-heat\"><thead><tr><th class=\"sa-heat__fo\" translate=\"\">FO</th><th translate=\"\">Overall</th><th ng-repeat=\"c in payloads.heatmap.columns track by c.id\" class=\"sa-heat__col sa-clickable\" title=\"{{c.title}}\" ng-click=\"selectView(\'explorer\'); openNode(c.id)\">{{c.id}}<br><span class=\"sa-muted\">{{c.title | limitTo: 40}}</span></th></tr></thead><tbody><tr ng-repeat=\"row in payloads.heatmap.rows track by row.fo_id\"><td class=\"sa-heat__fo sa-clickable\" ng-click=\"openFo(row.fo_id)\"><strong>{{row.fo_name}}</strong><br><span class=\"sa-muted\">{{row.country || \'--\'}} · {{row.value_chain || \'--\'}}</span></td><td class=\"numeric\"><strong>{{charts.two(row.overall)}}</strong></td><td ng-repeat=\"cell in row.cells track by $index\" class=\"sa-heat__cell sa-heat__cell--{{cell.state}}\" ng-style=\"cell.state === \'valid\' ? {background: api.BAND_COLORS[cell.band]} : {}\" title=\"{{row.fo_name}} · {{payloads.heatmap.columns[$index].id}}: {{cell.state === \'valid\' ? charts.two(cell.value) : cell.state}}\" ng-click=\"openFo(row.fo_id)\"><span ng-if=\"cell.state === \'valid\'\">{{charts.two(cell.value)}}</span> <span ng-if=\"cell.state === \'not_relevant\'\">NR</span> <span ng-if=\"cell.state === \'missing\'\">?</span> <span ng-if=\"cell.state === \'not_in_tool\'\">·</span></td></tr><tr ng-if=\"!payloads.heatmap.rows.length\"><td colspan=\"{{payloads.heatmap.columns.length + 2}}\" class=\"empty-hint\" translate=\"\">No FOs match.</td></tr></tbody></table></div><div class=\"sa-legend\"><span ng-repeat=\"band in context.bands track by band.key\"><i ng-style=\"{background: api.BAND_COLORS[band.key]}\"></i>{{band.label | translate}}</span> <span><i class=\"sa-heat__cell--not_relevant\"></i>{{\'NR · Not Relevant\' | translate}}</span> <span><i class=\"sa-heat__cell--missing\"></i>{{\'? · missing answer\' | translate}}</span> <span><i class=\"sa-heat__cell--not_in_tool\"></i>{{\'· not in this FO\\\'s questionnaire\' | translate}}</span></div><div class=\"sa-pager\" ng-if=\"payloads.heatmap\"><label class=\"ar-label\">{{\'Rows per page\' | translate}}<select class=\"form-control input-sm\" ng-model=\"heat.pageSize\" ng-change=\"heat.page = 0; loadHeatmap()\" ng-options=\"size for size in [10, 25, 50, 100, 250]\"></select></label> <span class=\"sa-muted\">{{payloads.heatmap.total ? payloads.heatmap.page * payloads.heatmap.page_size + 1 : 0}}–{{payloads.heatmap.page * payloads.heatmap.page_size + payloads.heatmap.rows.length}} / {{payloads.heatmap.total}}</span> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-disabled=\"payloads.heatmap.page === 0\" ng-click=\"heat.page = payloads.heatmap.page - 1; loadHeatmap()\" translate=\"\">Previous</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-disabled=\"payloads.heatmap.page >= payloads.heatmap.pages - 1\" ng-click=\"heat.page = payloads.heatmap.page + 1; loadHeatmap()\" translate=\"\">Next</button></div></section>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/priorities.html","<div class=\"sa-stack\" ng-if=\"payloads.priorities\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Score-based priorities</div><div class=\"table-card__hint\">{{\'Subdimensions ranked by how many FOs score below 2.5 · at least\' | translate}} {{payloads.priorities.min_rank_n}} {{\'scored FOs each\' | translate}}</div><p class=\"sa-note\" translate=\"\">Check applicability, the FO\'s own objectives and root causes before setting technical assistance priorities.</p></section><div class=\"sa-two\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Most widespread weaknesses</div><div class=\"table-card__hint\" translate=\"\">Share of scored FOs below 2.5</div><button type=\"button\" class=\"sa-rank sa-rank--bar\" ng-repeat=\"row in payloads.priorities.widespread_weaknesses track by row.id\" ng-click=\"selectView(\'explorer\'); openNode(row.id)\"><span><span class=\"sa-key\">{{row.id}}</span> {{node(row.id).title}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: (row.weak_pct || 0) + \'%\', background: api.BAND_COLORS.weak}\"></span></span> <strong class=\"numeric\">{{charts.pct(row.weak_pct, 0)}}</strong> <span class=\"sa-muted numeric\">{{\'mean\' | translate}} {{charts.two(row.mean)}} · N={{row.n}}</span></button></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Strongest capabilities</div><div class=\"table-card__hint\" translate=\"\">Share of scored FOs at 3.0 or above</div><button type=\"button\" class=\"sa-rank sa-rank--bar\" ng-repeat=\"row in payloads.priorities.strongest_capabilities track by row.id\" ng-click=\"selectView(\'explorer\'); openNode(row.id)\"><span><span class=\"sa-key\">{{row.id}}</span> {{node(row.id).title}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: (row.strong_pct || 0) + \'%\', background: api.BAND_COLORS.strong}\"></span></span> <strong class=\"numeric\">{{charts.pct(row.strong_pct, 0)}}</strong> <span class=\"sa-muted numeric\">{{\'mean\' | translate}} {{charts.two(row.mean)}} · N={{row.n}}</span></button></section></div><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">How many areas are weak for each FO?</div><div class=\"table-card__hint\">{{\'Number of the\' | translate}} {{payloads.priorities.weak_breadth.subdimension_count}} {{\'subdimensions in which an FO scores below 2.5\' | translate}}</div><div class=\"sa-bar-row sa-bar-row--static\" ng-repeat=\"bin in payloads.priorities.weak_breadth.bins track by bin.label\"><span class=\"sa-lab\">{{bin.label === \'None\' ? (\'No weak subdimensions\' | translate) : bin.label}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-style=\"{width: (payloads.overview.kpis.fo_count ? bin.fo_count / payloads.overview.kpis.fo_count * 100 : 0) + \'%\'}\"></span></span> <strong class=\"numeric\">{{bin.fo_count}}</strong></div><p class=\"sa-note\">{{\'The median FO is weak in\' | translate}} {{payloads.priorities.weak_breadth.median === null ? \'--\' : payloads.priorities.weak_breadth.median}} {{\'subdimensions. The kind of support needed comes from the FO assessment and its context.\' | translate}}</p></section><section class=\"table-card\"><div class=\"sa-card-head\"><div><div class=\"table-card__title\" translate=\"\">Which weaknesses occur together?</div><div class=\"table-card__hint\" translate=\"\">Pairs of subdimensions where the same FOs score below 2.5 in both. Eligible pairs: {{payloads.priorities.co_occurring_paging.total}}.</div></div><div class=\"table-filters\"><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-pairs\" translate=\"\">Include pairs</label><select id=\"sa-pairs\" class=\"form-control input-sm\" ng-model=\"prio.pairs\" ng-change=\"reloadPairs()\"><option value=\"cross\" translate=\"\">Across different dimensions</option><option value=\"all\" translate=\"\">All subdimension pairs</option></select></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-pair-sort\" translate=\"\">Sort by</label><select id=\"sa-pair-sort\" class=\"form-control input-sm\" ng-model=\"prio.sort\" ng-change=\"reloadPairs()\" ng-options=\"o.value as (o.label | translate) for o in pairSorts\"></select></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-pair-limit\" translate=\"\">Show</label><select id=\"sa-pair-limit\" class=\"form-control input-sm\" ng-model=\"prio.limit\" ng-change=\"reloadPairs()\" ng-options=\"o.value as (o.label | translate) for o in pairLimits\"></select></div></div></div><div class=\"sa-scroll\" ng-if=\"payloads.priorities.co_occurring.length\"><table class=\"analytics-table\"><thead><tr><th>#</th><th translate=\"\">First weakness</th><th translate=\"\">Second weakness</th><th class=\"numeric\" title=\"{{\'FOs scoring below 2.5 in both subdimensions\' | translate}}\" translate=\"\">FOs weak in both</th><th class=\"numeric\" title=\"{{\'FOs weak in both, as a share of the comparable FOs\' | translate}}\" translate=\"\">% of comparable FOs</th><th class=\"numeric\" title=\"{{\'FOs with a valid score in both subdimensions: every percentage, Lift and Phi is over these FOs\' | translate}}\" translate=\"\">Comparable FOs (N)</th><th class=\"numeric\" title=\"{{\'FOs weak in both if the two weaknesses were independent: weak in the first × weak in the second ÷ N\' | translate}}\" translate=\"\">Expected if independent</th><th class=\"numeric\" title=\"{{\'Lift = P(A and B) / (P(A) × P(B)). Above 1: the two weaknesses occur together more often than if they were independent; 1: as expected under independence; below 1: less often.\' | translate}}\" translate=\"\">Lift</th><th class=\"numeric\" title=\"{{\'Phi: correlation of the two weak / not weak indicators, from −1 to 1. Undefined (--) when every comparable FO, or none, is weak in one of the two.\' | translate}}\" translate=\"\">Phi</th><th></th></tr></thead><tbody><tr ng-repeat=\"pair in payloads.priorities.co_occurring track by $index\" ng-class=\"{\'sa-selected\': prio.focus === pair}\"><td class=\"sa-muted\">{{payloads.priorities.co_occurring_paging.offset + $index + 1}}</td><td><span class=\"sa-key\">{{pair.a}}</span> {{node(pair.a).title}} <span class=\"sa-muted\">({{pair.a_weak}} {{\'weak\' | translate}})</span></td><td><span class=\"sa-key\">{{pair.b}}</span> {{node(pair.b).title}} <span class=\"sa-muted\">({{pair.b_weak}} {{\'weak\' | translate}})</span></td><td class=\"numeric\"><strong>{{pair.fo_count}}</strong></td><td class=\"numeric\">{{charts.pct(pair.pct, 0)}}</td><td class=\"numeric\">{{pair.comparable}}</td><td class=\"numeric sa-muted\">{{charts.num(pair.expected_fo_count, 1)}}</td><td class=\"numeric\" ng-class=\"{\'delta--down\': pair.lift > 1, \'sa-muted\': pair.lift === null}\"><strong>{{charts.two(pair.lift)}}</strong></td><td class=\"numeric\" ng-class=\"{\'sa-muted\': pair.phi === null}\">{{api.signed(pair.phi, 2)}}</td><td><a class=\"dq-link\" ng-click=\"focusPair(pair)\">{{prio.focus === pair ? (\'Hide FOs\' | translate) : (\'View FOs\' | translate)}}</a></td></tr></tbody></table></div><div class=\"rea-pager\" ng-if=\"payloads.priorities.co_occurring_paging.pages > 1\"><span class=\"sa-muted\">{{payloads.priorities.co_occurring_paging.offset + 1}}–{{payloads.priorities.co_occurring_paging.offset + payloads.priorities.co_occurring.length}} / {{payloads.priorities.co_occurring_paging.total}} {{\'pairs\' | translate}}</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePairPage(-1)\" ng-disabled=\"!payloads.priorities.co_occurring_paging.page\"><i class=\"fa fa-angle-left\"></i></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"movePairPage(1)\" ng-disabled=\"payloads.priorities.co_occurring_paging.page >= payloads.priorities.co_occurring_paging.pages - 1\"><i class=\"fa fa-angle-right\"></i></button></div><div class=\"empty-hint\" ng-if=\"!payloads.priorities.co_occurring.length\" translate=\"\">No pair has enough comparable and affected FOs.</div><div ng-if=\"prio.focus\"><h4 class=\"sa-sub-h\">{{\'FOs weak in both\' | translate}}: {{node(prio.focus.a).title}} · {{node(prio.focus.b).title}}</h4><table class=\"analytics-table\"><thead><tr><th translate=\"\">FO</th><th class=\"numeric\">{{prio.focus.a}}</th><th class=\"numeric\">{{prio.focus.b}}</th></tr></thead><tbody><tr ng-repeat=\"fo in prio.focus.fos track by fo.fo_id\"><td><a class=\"dq-link\" ng-click=\"openFo(fo.fo_id)\">{{fo.fo_name}}</a></td><td class=\"numeric\">{{charts.two(fo.a)}}</td><td class=\"numeric\">{{charts.two(fo.b)}}</td></tr></tbody></table></div><p class=\"sa-note\" translate=\"\">Percentages, Lift and Phi use only FOs scored on both subdimensions. \"Most FOs affected\" favours weaknesses that are common on their own; Lift and Phi show pairs that go together more than their frequency explains. Association is not causation: these pairs show shared gaps, not that one weakness causes the other.</p></section></div>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/progress.html","<div class=\"sa-stack\" ng-if=\"payloads.progress\" ng-init=\"p = payloads.progress\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Progress between assessments</div><div class=\"table-card__hint\">{{\'Each FO\\\'s first and latest assessments on\' | translate}} {{context.tool}} v{{context.version}} {{\'in the selected projects. Pairs on another version are never compared. Unchanged means within ±0.05.\' | translate}}</div></section><div class=\"empty-hint\" ng-if=\"!payloads.progress.paired_fo_count\" translate=\"\">No FO in this population has an earlier assessment on the same tool version.</div><div ng-if=\"payloads.progress.paired_fo_count\"><div class=\"metrics-grid\"><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Paired FOs</div><div class=\"metric-value\">{{payloads.progress.paired_fo_count}}</div><div class=\"metric-note\" translate=\"\">Baseline and latest, same tool version</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">Mean change overall</div><div class=\"metric-value\" ng-class=\"api.changeClass(payloads.progress.overall.mean_change)\">{{api.signed(payloads.progress.overall.mean_change, 2)}}</div><div class=\"metric-note\">{{charts.two(payloads.progress.overall.baseline_mean)}} → {{charts.two(payloads.progress.overall.latest_mean)}} · N={{payloads.progress.overall.n}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">FOs improved</div><div class=\"metric-value delta--up\">{{charts.pct(payloads.progress.overall.improved_pct, 0)}}</div><div class=\"metric-note\">{{payloads.progress.overall.improved}} {{\'FOs\' | translate}}</div></article><article class=\"metric-card\"><div class=\"metric-title\" translate=\"\">FOs declined</div><div class=\"metric-value delta--down\">{{charts.pct(payloads.progress.overall.declined_pct, 0)}}</div><div class=\"metric-note\">{{payloads.progress.overall.declined}} {{\'FOs\' | translate}} · {{payloads.progress.overall.unchanged}} {{\'unchanged\' | translate}}</div></article></div><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Change by dimension</div><div class=\"table-card__hint\" translate=\"\">Baseline (ring) to latest (dot) on the 1–5 scale, paired FOs only.</div><div class=\"sa-dumbbell sa-dumbbell--head\"><span translate=\"\">Dimension</span><span translate=\"\">Baseline to latest</span><span class=\"numeric\" translate=\"\">Means</span><span class=\"numeric\" translate=\"\">Change</span><span class=\"numeric\" translate=\"\">Improved</span><span class=\"numeric\">N</span></div><div class=\"sa-dumbbell sa-clickable\" ng-repeat=\"d in payloads.progress.dimensions track by d.id\" ng-click=\"selectView(\'explorer\'); openNode(d.id)\"><span><span class=\"sa-key\">{{d.id}}</span> {{node(d.id).title}}</span> <span class=\"sa-db\"><span class=\"sa-db__rail\"></span> <span class=\"sa-db__span\" ng-if=\"d.n\" ng-style=\"dumbbell(d)\"></span> <span class=\"sa-db__base\" ng-if=\"d.n\" ng-style=\"{left: api.scale(d.baseline_mean) + \'%\'}\"></span> <span class=\"sa-db__latest\" ng-if=\"d.n\" ng-style=\"{left: api.scale(d.latest_mean) + \'%\'}\"></span></span> <span class=\"numeric sa-muted\">{{charts.two(d.baseline_mean)}} → {{charts.two(d.latest_mean)}}</span> <strong class=\"numeric\" ng-class=\"api.changeClass(d.mean_change)\">{{api.signed(d.mean_change, 2)}}</strong> <span class=\"numeric\">{{charts.pct(d.improved_pct, 0)}}</span> <span class=\"numeric sa-muted\">{{d.n}}</span></div></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Change by subdimension</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Subdimension</th><th class=\"numeric\">N</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\" translate=\"\">Improved</th><th class=\"numeric\" translate=\"\">Declined</th><th class=\"numeric\" translate=\"\">Weak at both</th></tr></thead><tbody><tr ng-repeat=\"s in payloads.progress.subdimensions track by s.id\" class=\"sa-clickable\" ng-click=\"selectView(\'explorer\'); openNode(s.id)\"><td><span class=\"sa-key\">{{s.id}}</span> {{node(s.id).title}}</td><td class=\"numeric\">{{s.n}}</td><td class=\"numeric\">{{charts.two(s.baseline_mean)}}</td><td class=\"numeric\">{{charts.two(s.latest_mean)}}</td><td class=\"numeric\" ng-class=\"api.changeClass(s.mean_change)\">{{api.signed(s.mean_change, 2)}}</td><td class=\"numeric\">{{charts.pct(s.improved_pct, 0)}}</td><td class=\"numeric\">{{charts.pct(s.declined_pct, 0)}}</td><td class=\"numeric\">{{s.persistent_weak}}</td></tr></tbody></table></section><div class=\"sa-two\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">How individual FOs changed</div><div class=\"table-card__hint\" translate=\"\">Change in overall score</div><div class=\"sa-bar-row sa-bar-row--static\" ng-repeat=\"b in payloads.progress.change_distribution track by b.key\"><span class=\"sa-lab\">{{changeBuckets[b.key] | translate}}</span> <span class=\"sa-track\"><span class=\"sa-track__fill\" ng-class=\"\'sa-change--\' + b.key\" ng-style=\"{width: (payloads.progress.overall.n ? b.count / payloads.progress.overall.n * 100 : 0) + \'%\'}\"></span></span> <strong class=\"numeric\">{{b.count}}</strong></div><p class=\"sa-note\" translate=\"\">An average gain can hide FOs that declined; the list below names them.</p></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Maturity level transitions</div><div class=\"table-card__hint\">N={{payloads.progress.maturity_transition.n}} · <span class=\"delta--up\">{{payloads.progress.maturity_transition.moved_up}} {{\'up\' | translate}}</span> · {{payloads.progress.maturity_transition.stayed}} {{\'stayed\' | translate}} · <span class=\"delta--down\">{{payloads.progress.maturity_transition.moved_down}} {{\'down\' | translate}}</span></div><table class=\"analytics-table sa-matrix\"><thead><tr><th translate=\"\">Baseline \\ Latest</th><th class=\"numeric\" ng-repeat=\"l in payloads.progress.maturity_transition.levels track by l.key\">{{l.label | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in payloads.progress.maturity_transition.rows track by row.baseline\" ng-init=\"r = $index\"><th>{{payloads.progress.maturity_transition.levels[r].label | translate}}</th><td class=\"numeric\" ng-repeat=\"cell in row.cells track by cell.latest\" ng-class=\"{\'sa-seg-cell--up\': $index > r && cell.count, \'sa-seg-cell--down\': $index < r && cell.count}\">{{cell.count}}</td></tr></tbody></table></section></div><div class=\"sa-two\"><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Largest gains</div><div class=\"table-card__hint\" translate=\"\">Up to 15 questions with the highest mean change · at least {{payloads.progress.min_rank_n}} paired FOs</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Question</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\" translate=\"\">Latest mean</th><th class=\"numeric\">N</th></tr></thead><tbody><tr ng-repeat=\"q in payloads.progress.largest_gains track by q.id\" class=\"sa-clickable\" ng-click=\"selectView(\'explorer\'); openNode(q.id)\"><td class=\"sa-wrap\"><span class=\"sa-key\">{{q.id}}</span> {{node(q.id).title}}</td><td class=\"numeric delta--up\">{{api.signed(q.mean_change, 2)}}</td><td class=\"numeric\">{{charts.two(q.latest_mean)}}</td><td class=\"numeric\">{{q.n}}</td></tr></tbody></table></section><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">Persistent weaknesses</div><div class=\"table-card__hint\" translate=\"\">Up to 15 questions weak (below 2.5) at baseline and latest for the same FOs, by share of comparable FOs. N: FOs with a valid score at both.</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">Question</th><th class=\"numeric\" translate=\"\">Weak at both</th><th class=\"numeric\" translate=\"\">Change</th><th class=\"numeric\">N</th></tr></thead><tbody><tr ng-repeat=\"q in payloads.progress.persistent_gaps track by q.id\" class=\"sa-clickable\" ng-click=\"selectView(\'explorer\'); openNode(q.id)\"><td class=\"sa-wrap\"><span class=\"sa-key\">{{q.id}}</span> {{node(q.id).title}}</td><td class=\"numeric delta--down\">{{q.persistent_weak}} ({{charts.pct(q.persistent_weak_pct, 0)}})</td><td class=\"numeric\" ng-class=\"api.changeClass(q.mean_change)\">{{api.signed(q.mean_change, 2)}}</td><td class=\"numeric\">{{q.n}}</td></tr><tr ng-if=\"!payloads.progress.persistent_gaps.length\"><td colspan=\"4\" class=\"empty-hint\" translate=\"\">No question is weak at both assessments.</td></tr></tbody></table></section></div><section class=\"table-card\"><div class=\"table-card__title\" translate=\"\">FOs: improved, unchanged and declined</div><div class=\"table-card__hint\" translate=\"\">Largest decline first</div><table class=\"analytics-table\"><thead><tr><th translate=\"\">FO</th><th translate=\"\">Assessments</th><th class=\"numeric\" translate=\"\">Baseline</th><th class=\"numeric\" translate=\"\">Latest</th><th class=\"numeric\" translate=\"\">Change</th><th translate=\"\">Maturity</th></tr></thead><tbody><tr ng-repeat=\"fo in payloads.progress.fos track by fo.fo_id\"><td><a class=\"dq-link\" ng-click=\"openFo(fo.fo_id)\">{{fo.fo_name}}</a></td><td class=\"sa-muted\">{{fo.baseline_date}} → {{fo.latest_date}}</td><td class=\"numeric\">{{charts.two(fo.baseline)}}</td><td class=\"numeric\">{{charts.two(fo.latest)}}</td><td class=\"numeric\" ng-class=\"api.changeClass(fo.change)\"><strong>{{api.signed(fo.change, 2)}}</strong></td><td>{{maturityLabel(fo.baseline_maturity) | translate}} → {{maturityLabel(fo.latest_maturity) | translate}}</td></tr></tbody></table></section></div></div>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/rail.html","<aside class=\"rightbar analytics-rightbar ar\" ng-class=\"{\'rightbar--closed\': ui.rightbarClosed}\"><h4 class=\"ar-title\" translate=\"\">Controls &amp; Insights</h4><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'selection\')\" aria-expanded=\"{{rail.selection}}\"><span translate=\"\">Projects</span> <i class=\"fa\" ng-class=\"rail.selection ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.selection\"><div class=\"ar-group\"><input class=\"ar-control\" type=\"search\" ng-model=\"options.projectSearch\" placeholder=\"{{\'Search projects\' | translate}}\" aria-label=\"{{\'Search projects\' | translate}}\"><div class=\"sa-select-all\"><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"selectAllProjects(true)\" translate=\"\">Select all</button> <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"selectAllProjects(false)\" translate=\"\">None</button> <span class=\"ar-count\">{{staged.projects.length}} / {{options.projects.length}}</span></div><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"project in visibleProjects() track by project.id\"><input type=\"checkbox\" ng-checked=\"isProjectSelected(project.id)\" ng-click=\"toggleProject(project.id)\"> <span>{{project.name}}<span class=\"sa-muted\" ng-if=\"project.customer\">· {{project.customer}}</span></span> <span class=\"ar-count\">{{project.fo_count}}</span></label></div><div class=\"ar-hint\" translate=\"\">Starts with the current project. Add projects for a combined portfolio view; an FO in several projects counts once.</div></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'filters\')\" aria-expanded=\"{{rail.filters}}\"><span translate=\"\">Filters</span> <i class=\"fa\" ng-class=\"rail.filters ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.filters\"><div class=\"ar-group\"><label class=\"ar-label\" translate=\"\">Assessment date range</label><div class=\"ar-dates\"><input class=\"ar-control\" type=\"date\" ng-model=\"staged.startDate\" aria-label=\"{{\'Start date\' | translate}}\"> <input class=\"ar-control\" type=\"date\" ng-model=\"staged.endDate\" aria-label=\"{{\'End date\' | translate}}\"></div></div><div class=\"ar-group\" ng-if=\"options.countries.length > 1\"><label class=\"ar-label\" translate=\"\">Country</label><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"option in options.countries\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'country\', option)\" ng-click=\"toggleValue(\'country\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\" ng-if=\"options.valueChains.length > 1\"><label class=\"ar-label\" translate=\"\">Value chain</label><div class=\"ar-checks ar-checks--scroll\"><label class=\"ar-check\" ng-repeat=\"option in options.valueChains\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'value_chain\', option)\" ng-click=\"toggleValue(\'value_chain\', option)\"> <span>{{option}}</span></label></div></div><div class=\"ar-group\" ng-if=\"options.maturityLevels.length\"><label class=\"ar-label\" translate=\"\">FO maturity level</label><div class=\"ar-checks\"><label class=\"ar-check\" ng-repeat=\"level in options.maturityLevels\"><input type=\"checkbox\" ng-checked=\"isValueSelected(\'maturity_level\', level.value)\" ng-click=\"toggleValue(\'maturity_level\', level.value)\"> <span>{{level.label | translate}}</span></label></div><div class=\"ar-hint\" translate=\"\">From the overall score of the assessment analysed.</div></div><div class=\"ar-errors\" ng-if=\"errors.length\" role=\"alert\"><div ng-repeat=\"message in errors\">{{message | translate}}</div></div><div class=\"ar-actions\"><button type=\"button\" class=\"btn btn-sm ar-btn ar-btn--primary\" ng-click=\"apply()\" ng-disabled=\"isLoading\">&#10003; <span translate=\"\">Apply</span></button> <button type=\"button\" class=\"btn btn-sm ar-btn\" ng-click=\"reset()\" ng-disabled=\"isLoading\">&times; <span translate=\"\">Reset</span></button></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'population\')\" aria-expanded=\"{{rail.population}}\"><span translate=\"\">Population</span> <i class=\"fa\" ng-class=\"rail.population ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.population\"><div class=\"ar-pop\"><span translate=\"\">Projects</span><strong>{{applied.projects.length}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Farmer organisations</span><strong>{{context ? context.population.fo_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Tool</span><strong>{{context.tool ? context.tool + \' v\' + context.version : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Questions</span><strong>{{context ? context.population.question_count : \'–\'}}</strong></div><div class=\"ar-pop\"><span translate=\"\">Population rule</span><strong translate=\"\">Latest · finalised</strong></div><div class=\"ar-pop\" ng-if=\"context.population.other_version_fo_count\"><span translate=\"\">On another version</span><strong>{{context.population.other_version_fo_count}}</strong></div></div></section><section class=\"ar-box\"><button type=\"button\" class=\"ar-head\" ng-click=\"toggleRailBox(\'help\')\" aria-expanded=\"{{rail.help}}\"><span translate=\"\">How scores are interpreted</span> <i class=\"fa\" ng-class=\"rail.help ? \'fa-angle-up\' : \'fa-angle-down\'\" aria-hidden=\"true\"></i></button><div class=\"ar-body\" ng-show=\"rail.help\"><ul class=\"sa-rules\"><li translate=\"\">Score bands describe a score at question, subdimension and dimension level: Weak (1 to below 2.5), Developing (2.5 to below 3), Strong (3 to below 4), Very strong (4 to 5).</li><li translate=\"\">Maturity levels classify an FO\'s overall score. An FO at a higher level can still have weak scores.</li><li translate=\"\">Each FO contributes its latest finalised, valid assessment on the selected tool version. Progress compares assessments of the same FO on that version.</li><li translate=\"\">Not Relevant and missing answers are counted separately and excluded from averages.</li><li translate=\"\">Scores are the stored official scores. Mean is the average; median the middle value. Findings are descriptive and do not establish cause and effect.</li></ul></div></section></aside>");
$templateCache.put("projects/templates/projectAnalytics/scoreAnalysis/segments.html","<div class=\"sa-stack\"><section class=\"table-card\"><div class=\"sa-card-head\"><div><div class=\"table-card__title\" translate=\"\">Segment comparison</div><div class=\"table-card__hint\" translate=\"\">Group mean and its difference from the mean of everyone analysed. Means of groups with fewer than 5 scored FOs are withheld.</div></div><div class=\"table-filters\"><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-seg-by\" translate=\"\">Compare by</label><select id=\"sa-seg-by\" class=\"form-control input-sm\" ng-model=\"segment.by\" ng-change=\"segment.by !== \'group\' && loadSegments()\"><option value=\"country\" translate=\"\">Country</option><option value=\"value_chain\" translate=\"\">Value chain</option><option value=\"maturity\" translate=\"\">Maturity level</option><option value=\"group\" translate=\"\">Selected FOs vs the rest</option></select></div><div class=\"table-filters__group\"><label class=\"ar-label\" for=\"sa-seg-level\" translate=\"\">Level</label><select id=\"sa-seg-level\" class=\"form-control input-sm\" ng-model=\"segment.level\" ng-change=\"loadSegments()\"><option value=\"dimension\" translate=\"\">Dimensions</option><option value=\"subdimension\" translate=\"\">Subdimensions</option></select></div></div></div><div ng-if=\"segment.by === \'group\'\" class=\"sa-fo-picker\"><strong translate=\"\">Choose the FOs in the group</strong><div class=\"sa-fo-picker__list\"><label class=\"ar-check\" ng-repeat=\"fo in payloads.overview.fo_options track by fo.fo_id\"><input type=\"checkbox\" ng-checked=\"segment.fos.indexOf(fo.fo_id) > -1\" ng-click=\"toggleSegmentFo(fo.fo_id)\"> <span>{{fo.fo_name}}</span></label></div><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"loadSegments()\" ng-disabled=\"!segment.fos.length\">{{\'Compare\' | translate}} {{segment.fos.length}} {{\'FOs\' | translate}}</button></div><div ng-if=\"payloads.segments\"><div id=\"saSegmentsChart\" class=\"chart-body\"></div><div class=\"sa-scroll\"><table class=\"analytics-table\"><thead><tr><th>{{payloads.segments.level === \'dimension\' ? (\'Dimension\' | translate) : (\'Subdimension\' | translate)}}</th><th class=\"numeric\" translate=\"\">All</th><th class=\"numeric\" ng-repeat=\"g in payloads.segments.groups track by g.label\">{{g.label | translate}}<br><span class=\"sa-muted\">{{g.fo_count}} {{\'FOs\' | translate}}</span></th><th class=\"numeric\" translate=\"\">Range</th></tr></thead><tbody><tr ng-repeat=\"n in payloads.segments.nodes track by n.id\" ng-init=\"row = $index\" class=\"sa-clickable\" ng-click=\"selectView(\'explorer\'); openNode(n.id)\"><td><span class=\"sa-key\">{{n.id}}</span> {{n.title}}</td><td class=\"numeric\">{{charts.two(n.population_mean)}} <span class=\"sa-muted\">N={{n.population_n}}</span></td><td class=\"numeric sa-seg-cell\" ng-repeat=\"g in payloads.segments.groups track by g.label\" ng-class=\"{\'sa-seg-cell--up\': g.values[row].difference > 0.05, \'sa-seg-cell--down\': g.values[row].difference < -0.05}\" title=\"N={{g.values[row].n}}\"><span ng-if=\"g.values[row].mean !== null\"><strong>{{charts.two(g.values[row].mean)}}</strong> <span class=\"sa-muted\">{{api.signed(g.values[row].difference, 2)}}</span></span> <span ng-if=\"g.values[row].mean === null\" class=\"sa-muted\">-- <small>N={{g.values[row].n}}</small></span></td><td class=\"numeric\"><strong>{{charts.two(n.range)}}</strong></td></tr></tbody></table></div><div class=\"sa-legend\"><span><i class=\"sa-seg-cell--up\"></i>{{\'Above the mean of everyone analysed\' | translate}}</span> <span><i class=\"sa-seg-cell--down\"></i>{{\'Below it\' | translate}}</span> <span>{{\'-- fewer than 5 scored FOs\' | translate}}</span></div></div></section><section class=\"table-card\" ng-if=\"payloads.segments && payloads.segments.by !== \'maturity\'\"><div class=\"table-card__title\" translate=\"\">Group composition</div><div class=\"table-card__hint\" translate=\"\">Share of each group\'s FOs in each maturity level. Groups with more advanced FOs score higher; compare like with like before attributing a difference to the group.</div><div class=\"sa-bar-row sa-bar-row--static\" ng-repeat=\"g in payloads.segments.groups track by g.label\"><span class=\"sa-lab\">{{g.label | translate}}</span> <span class=\"sa-strip sa-strip--wide sa-strip--labelled\"><span ng-repeat=\"m in g.maturity track by m.key\" ng-style=\"{width: (g.fo_count ? m.count / g.fo_count * 100 : 0) + \'%\', background: api.MATURITY_COLORS[m.key]}\" title=\"{{maturityLabel(m.key) | translate}}: {{m.count}} ({{charts.pct(g.fo_count ? m.count / g.fo_count * 100 : null, 0)}})\"><span ng-if=\"g.fo_count && m.count / g.fo_count >= 0.08\">{{charts.pct(m.count / g.fo_count * 100, 0)}}</span></span></span> <span class=\"numeric sa-muted\">N={{g.fo_count}}</span></div><div class=\"sa-legend\"><span ng-repeat=\"level in context.maturity_levels track by level.key\"><i ng-style=\"{background: api.MATURITY_COLORS[level.key]}\"></i>{{level.label | translate}}</span></div></section></div>");
$templateCache.put("score-builder/partials/score-builder-questions/multiple-choice/multiple-choice.html","<article><aside class=\"weight__subquestion\"><p><span><input type=\"text\" ng-model=\"questionCtrl.question.displayWeight\"></span> <span>%</span></p></aside><main class=\"subquestion subquestion--mpc\"><span class=\"close\" ng-click=\"questionCtrl.removeQuestion()\">&times;</span><header class=\"subquestion__header\"><h3><input type=\"text\" placeholder=\"{{\'Title\' | translate}}\" ng-model-options=\"{updateOn: \'blur\'}\" ng-disabled=\"!questionCtrl.question.id\" ng-change=\"questionCtrl.updateQuestionTitle()\" ng-model=\"questionCtrl.question.title\"></h3><textarea cols=\"30\" rows=\"2\" class=\"form-control\" ng-disabled=\"!questionCtrl.question.id\" placeholder=\"{{\'Question Description\' | translate}}\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionDescription()\" ng-model=\"questionCtrl.question.description\">\n            </textarea></header><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!questionCtrl.question.scores_are_valid\"><strong translate=\"\">Scores are invalid</strong>:<translate>Scores need to be between 1 and 5 and at least include a 1 or a 5.</translate></div><div class=\"radio subquestion__question\" ng-repeat=\"option in questionCtrl.question.options.objects track by $index\"><span ng-if=\"option.title !== \'N/R\'\" class=\"close\" ng-click=\"questionCtrl.removeQuestionOption(option, $index)\">&times;</span> <label><input type=\"radio\"> <input ng-if=\"option.title !== \'N/R\'\" id=\"part--{{$index}}\" type=\"text\" class=\"form-control\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"option.title\" ng-disabled=\"option.disabled\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></label> <label style=\"display: flex; align-items:center; margin-top:5px;\"><span style=\"text-wrap: nowrap; margin-right: 5px;\">A2F Score</span> <input type=\"text\" class=\"form-control\" ng-model=\"option.a2f_score\" ng-disabled=\"option.disabled\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></label> <label><translate>Option Score</translate><input type=\"text\" class=\"form-control\" ng-model=\"option.score\" ng-model-options=\"{updateOn: \'blur\'}\" ng-disabled=\"option.disabled\" ng-class=\"{error: option.scoreInvalid || !questionCtrl.question.scores_are_valid}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></label><div class=\"form-group\" ng-if=\"questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Applicable Tool Types</label><select class=\"form-control\" chosen=\"\" multiple=\"\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as (item.name) for item in questionCtrl.toolTypes.results\" ng-model=\"option.active_in\" style=\"width: 100%\"><option></option></select></div><option-condition ng-if=\"!questionCtrl.isCanonicalTree\" option=\"option\"></option-condition><div class=\"form-group\" ng-if=\"!questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Canonical Option</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as item.title for item in questionCtrl.canonicalOptions\" ng-model=\"option.canonical\" style=\"width: 100%\"><option></option></select></div><br></div><div class=\"subquestion__footer\"><div class=\"subquestion__options-add\"><label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'can_be_not_relevant\')\" ng-model=\"questionCtrl.question.can_be_not_relevant\"> &nbsp;Add \"N/R\" Option</label> <label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'comment_mandatory\')\" ng-model=\"questionCtrl.question.comment_mandatory\"> &nbsp;Comment Mandatory</label></div><div class=\"subquestion__option\" ng-show=\"questionCtrl.question.id\" ng-click=\"questionCtrl.addQuestionOption()\"><span class=\"subquestion__option__label\" translate=\"\">Add Question Option</span> <span class=\"subquestion__option__input\"><p>+</p></span></div></div><div class=\"form-group\" ng-if=\"questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Applicable Tool Types</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as (item.name) for item in questionCtrl.toolTypes.results\" ng-change=\"questionCtrl.updateQuestion(\'active_in\', \'{{questionCtrl.question.active_in}}\')\" ng-model=\"questionCtrl.question.active_in\" style=\"width: 100%\"><option></option></select></div><div class=\"form-group\" ng-if=\"!questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Canonical Subquestion</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateCanonicalOptions()\" data-placeholder-text-single=\"\'select canonical subquestion\' | translate\" ng-options=\"item.url as item.display_position + \' \' + item.title for item in questionCtrl.canonicalSubquestions.results | orderBy: \'display_position\'\" ng-model=\"questionCtrl.question.canonical\" style=\"width: 100%\"><option></option></select></div></main><conditional-on question=\"questionCtrl.question\" questions=\"questionCtrl.questions\" update-fct=\"questionCtrl.updateFct()\" index=\"questionCtrl.index\"></conditional-on></article>");
$templateCache.put("score-builder/partials/score-builder-questions/numeric/numeric.html","<div><article class=\"subquestion__wrapper\"><aside class=\"weight__subquestion\"><p><span><input type=\"text\" ng-model=\"questionCtrl.question.displayWeight\"></span> <span>%</span></p></aside><main class=\"subquestion subquestion--numeric\"><span class=\"close\" ng-click=\"questionCtrl.removeQuestion()\">&times;</span><header class=\"subquestion__header\"><h3><input type=\"text\" placeholder=\"{{\'Title\' | translate}}\" ng-disabled=\"!questionCtrl.question.id\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionTitle()\" ng-model=\"questionCtrl.question.title\"></h3><textarea cols=\"30\" rows=\"2\" class=\"form-control\" ng-disabled=\"!questionCtrl.question.id\" placeholder=\"{{\'Question Description\' | translate}}\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionDescription()\" ng-model=\"questionCtrl.question.description\">\n                </textarea></header><div class=\"table-responsive\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!questionCtrl.question.scores_are_valid\"><strong translate=\"\">Score Error:</strong><translate>Scores need to be between 1 and 5 and at least include a 1 or a 5.</translate></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!questionCtrl.question.range_is_valid\"><strong translate=\"\">Range Error:</strong><translate>Range is invalid.</translate></div><table class=\"table\"><thead><tr><th translate=\"\">Range</th><th translate=\"\">From</th><th translate=\"\">To</th><th translate=\"\">Score</th><th translate=\"\" ng-if=\"!questionCtrl.isCanonicalTree\">Canonical Option</th></tr></thead><tbody ng-class=\"{error: !questionCtrl.question.range_is_valid || !questionCtrl.question.scores_are_valid}\"><tr ng-repeat=\"option in questionCtrl.question.options.objects track by $index\"><th><input type=\"text\" class=\"form-control\" ng-model=\"option.title\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></th><td><input type=\"text\" class=\"form-control\" ng-model=\"option.range_min\" ng-disabled=\"option.disabled\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></td><td><input type=\"text\" class=\"form-control\" ng-disabled=\"option.disabled\" ng-model=\"option.range_max\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"option.score\" ng-disabled=\"option.disabled\" ng-model-options=\"{updateOn: \'blur\'}\" ng-class=\"{error: option.scoreInvalid}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></td><td style=\"display: flex; align-items:center; margin-top:5px;\"><span style=\"margin-right: 5px; text-wrap:nowrap\">A2F Score</span> <input type=\"text\" class=\"form-control\" ng-model=\"option.a2f_score\" ng-disabled=\"option.disabled\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\"></td><td ng-if=\"!questionCtrl.isCanonicalTree\"><div class=\"form-group\"><label class=\"control-label\" translate=\"\">Canonical Option</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateQuestionOption(option, $index)\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as item.title for item in questionCtrl.canonicalOptions\" ng-model=\"option.canonical\" style=\"width: 100%\"><option></option></select></div></td><td ng-if=\"option.title !== \'N/R\'\" class=\"close\" ng-click=\"questionCtrl.removeQuestionOption(option, $index)\">&times;</td></tr></tbody></table></div><div class=\"subquestion__footer\"><div class=\"subquestion__options-add\"><label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'can_be_not_relevant\')\" ng-model=\"questionCtrl.question.can_be_not_relevant\"> &nbsp;Add \"N/R\" Option</label> <label for=\"nr-{{questionCtrl.index}}\"><input type=\"checkbox\" id=\"nr-{{questionCtrl.index}}\" ng-disabled=\"questionCtrl.question.is_conditional\" ng-change=\"questionCtrl.updateQuestion(\'comment_mandatory\')\" ng-model=\"questionCtrl.question.comment_mandatory\"> &nbsp;Comment Mandatory</label></div><div class=\"subquestion__option\" ng-show=\"questionCtrl.question.id\" ng-click=\"questionCtrl.addQuestionOption()\"><span class=\"subquestion__option__label\" translate=\"\">Add Question Option</span> <span class=\"subquestion__option__input\"><p>+</p></span></div></div><div class=\"form-group\" ng-if=\"questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Applicable Tool Types</label><select class=\"form-control\" chosen=\"\" multiple=\"\" ng-change=\"questionCtrl.updateQuestion(\'active_in\')\" data-placeholder-text-single=\"\'select applicable tool type\' | translate\" ng-options=\"item.url as (item.name) for item in questionCtrl.toolTypes.results\" ng-model=\"questionCtrl.question.active_in\" style=\"width: 100%\"><option></option></select></div><div class=\"form-group\" ng-if=\"!questionCtrl.isCanonicalTree\"><label class=\"control-label\" translate=\"\">Canonical Subquestion</label><select class=\"form-control\" chosen=\"\" ng-change=\"questionCtrl.updateCanonicalOptions()\" data-placeholder-text-single=\"\'select canonical subquestion\' | translate\" ng-options=\"item.url as item.display_position + \' \' + item.title for item in questionCtrl.canonicalSubquestions.results | orderBy: \'display_position\'\" ng-model=\"questionCtrl.question.canonical\" style=\"width: 100%\"><option></option></select></div></main></article><conditional-on question=\"questionCtrl.question\" questions=\"questionCtrl.questions\" update-fct=\"questionCtrl.updateFct()\" index=\"questionCtrl.index\"></conditional-on></div>");
$templateCache.put("alerts/alertDetailView.html","<si-page><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><hr><h5 translate=\"\">Alert Types</h5><ul class=\"folder-list\" style=\"padding: 0\"><li><a ui-sref=\"base.alerts\" ng-class=\"{\'active\': type == \'\'}\"><i class=\"fa fa-inbox\"></i><translate>All alerts</translate></a></li><li ng-repeat=\"alertType in alertTypes\"><a ui-sref=\"base.alerts-filter({type:alertType.name})\" ng-class=\"{\'active\': type === alertType.name}\"><i class=\"fa fa-inbox\"></i>{{ alertType.display_name | capitalize }}</a></li><li><a ui-sref=\"base.alerts-filter({type: \'archive\'})\" ng-class=\"{\'active\': type === \'archive\'}\"><i class=\"fa fa-trash\"></i><translate>Trash</translate></a></li></ul></div></div></div><div class=\"col-lg-9\"><div class=\"mail-box-header\"><div class=\"pull-right tooltip-demo\"><button ng-click=\"archive()\" ng-show=\"!alert.archived_by_to_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Move to trash\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-trash-o\"></i><translate>Remove</translate></button> <button ng-click=\"archive()\" ng-show=\"alert.archived_by_to_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Move to inbox\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-inbox\"></i><translate>To inbox</translate></button></div><h2 translate=\"\">View Alert</h2><div class=\"mail-tools tooltip-demo m-t-md\"><h3><span class=\"font-normal\"></span>{{ alert.subject }}</h3><h5><span class=\"pull-right font-noraml\" uib-tooltip=\"{{ alert.created_at_readable | date: \'dd-MM-yyyy\' }}\"><span am-time-ago=\"alert.created_at\"></span></span> <span class=\"font-noraml\"><translate>From</translate>:&nbsp;</span>{{ alert.from_user | username }} &bull; <span class=\"font-noraml\"><translate>To</translate>:&nbsp;</span>{{ alert.to_user | username }}</h5></div></div><div class=\"mail-box\"><div class=\"alert alert-warning m-l m-r\" ng-show=\"alert.archived_by_to_user\" translate=\"\">This message is archived and won\'t show up in your inbox.</div><div class=\"mail-body\" style=\"white-space: pre-wrap;\" ng-bind-html=\"alert.body\"></div><div class=\"mail-body text-right tooltip-demo\"><button ng-click=\"archive()\" ng-show=\"!alert.archived_by_to_user\" uib-tooltip=\"{{\'Move to trash\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-trash-o\"></i><translate>Remove</translate></button> <button ng-click=\"archive()\" ng-show=\"alert.archived_by_to_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Move to inbox\' | translate }}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-inbox\"></i><translate>To inbox</translate></button></div><div class=\"clearfix\"></div></div></div></si-page>");
$templateCache.put("alerts/alertsListView.html","<si-page><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><hr><h5 translate=\"\">Alert Types</h5><ul class=\"folder-list\" style=\"padding: 0\"><li><a ui-sref=\"base.alerts\" ng-class=\"{\'active\': type == \'\'}\"><i class=\"fa fa-inbox\"></i><translate>All alerts</translate></a></li><li ng-repeat=\"alertType in alertTypes\"><a ui-sref=\"base.alerts-filter({type:alertType.name})\" ng-class=\"{\'active\': type === alertType.name}\"><i class=\"fa fa-inbox\"></i>{{ alertType.display_name | capitalize }}</a></li><li><a ui-sref=\"base.alerts-filter({type: \'archive\'})\" ng-class=\"{\'active\': type === \'archive\'}\"><i class=\"fa fa-trash\"></i><translate>Trash</translate></a></li></ul></div></div><label class=\"control-label\"><input type=\"checkbox\" name=\"clientQC\" ng-model=\"user.email_notifications_on\" ng-change=\"updateEmailNotifications()\"><translate>&nbsp; Receive Email Notifications</translate></label></div><div class=\"col-lg-9 animated fadeInRight\"><div class=\"mail-box-header\"><form method=\"get\" ng-submit=\"refresh()\" class=\"pull-right mail-search\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" name=\"search\" ng-model=\"search\" placeholder=\"{{ \'Search alerts\' | translate }}\"><div class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-sm btn-primary\" translate=\"\">Search</button></div></div></form><button class=\"btn btn-white btn-sm pull-right m-r\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Refresh inbox\' | translate}}\" ng-click=\"refresh()\"><i class=\"fa fa-refresh\"></i><translate>Refresh</translate></button><h2 translate=\"\">Your Alerts</h2></div><div class=\"mail-box\"><button style=\"margin-left: 10px;\" class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-click=\"markAsRead()\"><i class=\"fa fa-envelope-open\"></i></button> <button class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-click=\"markAsUnread()\"><i class=\"fa fa-envelope\"></i></button> <button class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-if=\"type !== \'archive\'\" ng-click=\"archiveSelected()\"><i class=\"fa fa-trash\"></i></button><table class=\"table table-hover table-mail\"><thead><th><input type=\"checkbox\" ng-model=\"messages.allSelected\" ng-change=\"toggleAllSelected(messages.allSelected)\"></th><th translate=\"\">From</th><th translate=\"\">To</th><th translate=\"\">Subject</th><th translate=\"\">Created</th></thead><tbody><tr ui-sref=\"base.alert-detail({id: alert.id})\" style=\"cursor: pointer;\" ng-class=\"{\'unread\': !alert.read_by_to_user, \'read\': alert.read_by_to_user }\" ng-repeat=\"alert in alerts.results | orderBy:\'-created_at\' track by alert.id\"><td ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-model=\"alert.selected\" ng-change=\"checkAllSelected()\"></td><td class=\"mail-ontact\"><span ng-if=\"alert.from_user.id === me.id\" translate=\"\">You</span> <span ng-if=\"alert.from_user.id !== me.id\">{{ alert.from_user | username }}</span></td><td class=\"mail-ontact\"><span ng-if=\"alert.to_user.id === me.id\" translate=\"\">You</span> <span ng-if=\"alert.to_user.id !== me.id\">{{ alert.to_user | username }}</span></td><td class=\"mail-subject\">{{ alert.subject }}</td><td class=\"text-right mail-date\" tooltip-placement=\"left\" uib-tooltip=\"{{ alert.created_at | date: \'dd-MM-yyyy\' }}\"><span am-time-ago=\"alert.created_at\"></span></td></tr><tr ng-if=\"alerts.results.length == 0\"><td colspan=\"5\"><div class=\"well well-sm\" translate=\"\">No alerts here. Looks like you\'re all done!</div></td></tr></tbody></table><paginated items=\"alerts\" items-per-page=\"10\"></paginated></div></div></si-page>");
$templateCache.put("alerts/newsDetailView.html","<si-page><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><h5 translate=\"\">News</h5><ul class=\"folder-list\" style=\"padding: 0\"><li><a ui-sref=\"base.alerts-news({type:\'news\'})\" ng-class=\"{\'active\': type == \'news\'}\"><i class=\"fa fa-inbox\"></i><translate>News</translate></a></li></ul><hr></div></div></div><div class=\"col-lg-9\"><div class=\"mail-box-header\"><div class=\"pull-right tooltip-demo\"><button ng-click=\"archive()\" ng-show=\"!alert.archived_by_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Move to trash\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-trash-o\"></i><translate>Remove</translate></button> <button ng-click=\"archive()\" ng-show=\"alert.archived_by_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Move to inbox\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-inbox\"></i><translate>To inbox</translate></button></div><h2 translate=\"\">View News</h2><div class=\"mail-tools tooltip-demo m-t-md\"><h3><span class=\"font-normal\"></span>{{ news.blog.subject }}</h3><h5><span class=\"pull-right font-noraml\" uib-tooltip=\"{{ news.created_at_readable | date: \'dd-MM-yyyy\' }}\"><span am-time-ago=\"alert.created_at\"></span></span></h5></div></div><div class=\"mail-box\"><div class=\"alert alert-warning m-l m-r\" ng-show=\"news.archived_by_user\" translate=\"\">This message is archived and won\'t show up in your inbox.</div><div class=\"mail-body\" style=\"white-space: pre-wrap;\" ng-bind-html=\"news.blog.body\"></div><div class=\"mail-body text-right tooltip-demo\"><button ng-click=\"archive()\" ng-show=\"!news.archived_by_user\" uib-tooltip=\"{{\'Move to trash\' | translate}}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-trash-o\"></i><translate>Remove</translate></button> <button ng-click=\"archive()\" ng-show=\"news.archived_by_user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Move to inbox\' | translate }}\" class=\"btn btn-sm btn-white\"><i class=\"fa fa-inbox\"></i><translate>To inbox</translate></button></div><div class=\"clearfix\"></div></div></div></si-page>");
$templateCache.put("alerts/newsListView.html","<si-page><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><h5 translate=\"\">News</h5><ul class=\"folder-list\" style=\"padding: 0\"><li><a ui-sref=\"base.alerts-news({type:\'news\'})\" ng-class=\"{\'active\': type == \'news\'}\"><i class=\"fa fa-inbox\"></i><translate>News</translate></a></li></ul><hr></div></div></div><div class=\"col-lg-9 animated fadeInRight\"><div class=\"mail-box-header\"><button class=\"btn btn-white btn-sm pull-right m-r\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Refresh inbox\' | translate}}\" ng-click=\"refresh()\"><i class=\"fa fa-refresh\"></i><translate>Refresh</translate></button><h2 translate=\"\">Your News</h2></div><div class=\"mail-box\"><button style=\"margin-left: 10px;\" class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-click=\"markAsRead()\"><i class=\"fa fa-envelope-open\"></i></button> <button class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-click=\"markAsUnread()\"><i class=\"fa fa-envelope\"></i></button> <button class=\"btn btn-default btn-xs\" ng-disabled=\"!messagesSelected\" ng-if=\"type !== \'archive\'\" ng-click=\"archiveSelected()\"><i class=\"fa fa-trash\"></i></button><table class=\"table table-hover table-mail\"><thead><th><input type=\"checkbox\" ng-model=\"messages.allSelected\" ng-change=\"toggleAllSelected(messages.allSelected)\"></th><th translate=\"\">Subject</th></thead><tbody><tr ui-sref=\"base.news-detail({id: item.id})\" style=\"cursor: pointer;\" ng-class=\"{\'unread\': !item.read_by_user, \'read\': item.read_by_user }\" ng-repeat=\"item in news.results track by item.id\"><td ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-model=\"item.selected\" ng-change=\"checkAllSelected()\"></td><td class=\"mail-subject\"><translate>Updated SCOPEinsight News:&nbsp;</translate>{{ item.created_at | date }}</td></tr><tr ng-if=\"news.results.length == 0\"><td colspan=\"5\"><div class=\"well well-sm\" translate=\"\">No news here. Looks like you\'re all done!</div></td></tr></tbody></table><paginated items=\"alerts\" items-per-page=\"10\"></paginated></div></div></si-page>");
$templateCache.put("assessments/assessmentAITABuilder.html","<!DOCTYPE html><html><head><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><style>\n        .instruction-box{\n            padding:20px;\n        }\n       \n        .instruction-card {\n        background: #ffffff;\n        border-left: 5px solid #00af8c;\n        border-radius: 4px;\n        padding: 30px;\n        margin-bottom: 30px;\n        box-shadow: 0 3px 6px rgba(0,0,0,0.06);\n        }\n\n        .instruction-card h2 {\n        font-size: 20px;\n        color: #2c3e50;\n        margin-bottom: 10px;\n        font-weight: bolder;\n        }\n\n        .instruction-card h3 {\n        font-size: 16px;\n        color: #00af8c;\n        margin-top: 25px;\n        margin-bottom: 10px;\n        border-bottom: 1px solid #e1e1e1;\n        padding-bottom: 5px;\n        }\n\n        .instruction-card ul {\n        padding-left: 20px;\n        margin-top: 10px;\n        margin-bottom: 20px;\n        line-height: 1.6;\n        }\n\n        .instruction-card li::marker {\n        color: #00af8c;\n        }\n\n        .instruction-card li {\n        margin-bottom: 8px;\n        }\n\n        .instruction-card .warning {\n        color: #b94a48;\n        font-weight: 600;\n        background: #fcebea;\n        border: 1px solid #f5c6cb;\n        padding: 8px 12px;\n        border-radius: 4px;\n        margin-top: 10px;\n        }\n\n        .btn {\n        display: inline-block;\n        padding: 8px 14px;\n        font-size: 13px;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n        margin-right: 10px;\n        }\n\n        .btn-excel { background-color: #28a745; color: #fff; }\n        .btn-html { background-color: #f39c12; color: #fff; }\n        .btn-pdf { background-color: #e74c3c; color: #fff; }\n        .btn-generate { background-color: #00af8c; color: #fff; margin: 15px 0; }\n\n       \n\n        .btn-delete {\n        background-color: #e74c3c;\n        color: white;\n        border: none;\n        padding: 6px 10px;\n        border-radius: 3px;\n        cursor: pointer;\n        }\n\n        .instruction-card .disclaimer {\n        \n        border: 1px solid #ed1704;\n        color: #010101;\n        font-size: 13px;\n        padding: 12px;\n        margin-top: 20px;\n        border-radius: 4px;\n        line-height: 1.5;\n        }\n        .red-text {\n        color: #e74c3c;\n        }\n\n        .switch {\n            position: relative;\n            display: inline-block;\n            width: 32px;\n            height: 19px;\n        }\n\n        .switch input {\n            opacity: 0;\n            width: 0;\n            height: 0;\n        }\n\n        input[type=\'number\'] {\n            width: 100%;\n        }\n        .slider {\n            position: absolute;\n            cursor: pointer;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: #ccc;\n            -webkit-transition: 0.4s;\n            transition: 0.4s;\n        }\n\n        .slider:before {\n            position: absolute;\n            content: \'\';\n            height: 12px;\n            width: 12px;\n            left: 4px;\n            bottom: 4px;\n            background-color: white;\n            -webkit-transition: 0.4s;\n            transition: 0.4s;\n        }\n\n        input:checked + .slider {\n            background-color: #2196f3;\n        }\n\n        input:focus + .slider {\n            box-shadow: 0 0 1px #2196f3;\n        }\n\n        input:checked + .slider:before {\n            -webkit-transform: translateX(12px);\n            -ms-transform: translateX(12px);\n            transform: translateX(12px);\n        }\n\n        /* Rounded sliders */\n        .slider.round {\n            border-radius: 34px;\n        }\n\n        .slider.round:before {\n            border-radius: 50%;\n        }\n\n        .btn-export{\n            color:white;\n            font-weight: bold;\n        }\n        .excel-btn{\n            background-color: #28a745;\n            border-color: #28a745;\n        }\n\n        .btn-add{\n            background-color: #28a745;\n            border-color: #28a745;\n        }\n\n        .pdf-btn {\n            background-color: #f40f02;\n        }\n\n        .mrg-btn{\n            color:black;\n            background-color: lightgray;\n        }\n \n        .html-btn {\n            background-color: #e44d26;\n        }\n\n        .table th, .table td {\n        max-width: 155px; \n        overflow: hidden;\n\n        }\n\n        td div{\n        padding: 5px;\n        }\n\n        .page-content{\n            display: flex;\n            flex-direction: column;\n        }\n\n        .filterContainer{\n            display: flex;\n            flex-wrap: wrap;\n            gap:20px;\n        }\n\n        @media (max-width: 1400px){\n            .filterOption {\n            flex: 1 1 calc(25% - 20px); /* 25% width minus gap */\n            min-width: calc(25% - 20px);\n            box-sizing: border-box;\n            white-space: nowrap;\n            }\n        }\n\n        @media (max-width: 800px) { /* Adjust this breakpoint as needed */\n            .filterOption {\n                flex: 1 1 calc(50% - 20px);\n                min-width: calc(50% - 20px);\n            }\n        }\n\n        @media (max-width: 500px) { /* Adjust this breakpoint as needed */\n            .filterOption {\n                flex: 1 1 100%;\n                min-width: 100%;\n            }\n        }\n\n\n        @media screen and (max-width: 767px) {\n        .table-responsive>.table>tbody>tr>td, .table-responsive>.table>tbody>tr>th, .table-responsive>.table>tfoot>tr>td, .table-responsive>.table>tfoot>tr>th, .table-responsive>.table>thead>tr>td, .table-responsive>.table>thead>tr>th {\n            white-space: wrap !important;\n        }\n\n        .custom-control-switch{\n            cursor:pointer;\n        }\n}\n    </style><body ng-controller=\"assessmentAITABuidlerController\"><div ng-if=\"global_loader\"><div class=\"instruction-box\" ng-if=\"!loaded\"><div class=\"instruction-card\"><h2>Welcome to SCOPE AI Technical Assistance Plan Builder</h2><p>The AI TA Builder will automatically generate a <strong>Technical Assistance (TA) Plan</strong> based on assessment results and identified areas that need improvement.</p><h3>How to Use the TA Plan Builder</h3><ul><li>Click on the <strong>\"Generate TA Plan\"</strong> button below to generate your TA Plan.</li><li>Review the activities carefully and make changes if needed.</li><li>Select the activities that are feasible within your time and budget.</li><li>You can also <strong>add a row with your own desired support areas and activities</strong> if they are not generated automatically.</li><li><strong>Cost, Start Time and End Time</strong> of activities should be added manually.</li></ul><div class=\"warning\">Generating the TA Plan may take a few minutes. Please do not close the page.</div><h3>Tips for Best Use</h3><ul><li>Always align selected activities with the FO’s strategy and capacity.</li><li>Start with the most critical or high-impact activities if resources are limited.</li><li>Prioritize key areas such as Internal Management, Financial Management, Production Base, and Operations.</li><li>Ensure selected activities are aligned with the overall project objectives and intended outcomes.</li><li>Make sure there is access to training, coaching, or other support mechanisms needed for implementation.</li></ul><h3><span class=\"red-text\">Disclaimer</span></h3><div class=\"disclaimer\">The content generated by the AI may not be entirely factual or may contain inaccuracies. It is the user\'s responsibility to carefully review, verify, and modify the suggested activities and outputs as needed. Use the generated Technical Assistance Plan at your own discretion and responsibility.</div></div><button class=\"btn btn-generate\" ng-click=\"generate()\"><i class=\"fa fa-cog\"></i> Generate TA Plan</button> <button class=\"btn btn-generate\" ng-click=\"loadFromAzure(false)\" ng-if=\"builder_exists\"><svg style=\"margin-right: 5px; position:relative; top:1px; filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(146deg) brightness(101%) contrast(102%);\" width=\"14\" height=\"14\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 512 512\"><path d=\"M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-112 174.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L128 288l0-224zm0 224l0 48L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0zM512 128l-128 0L384 0 512 128z\"></path></svg>Load Last Saved</button></div><div ng-if=\"loaded\"><div class=\"container-fluid page-content\"><div class=\"col-lg-12\"><div class=\"card shadow-sm border-0 animate__animated animate__fadeIn\"><div class=\"card-body\"><div style=\"display: flex; flex-direction: row; align-items: center;\"><svg width=\"18\" height=\"18\" viewbox=\"0 0 576 512\"><path d=\"M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 128-168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0 0 112c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM384 336l0-48 110.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L384 336zm0-208l-128 0L256 0 384 128z\"></path></svg><h3 style=\"position: relative; top:3px; margin-left: 5px;\">Export Options</h3></div><div style=\"display:flex; flex-direction:row; justify-content:space-between\"><div><button class=\"btn btn-export excel-btn\" ng-click=\"exportToExcel()\"><i class=\"fa fa-file-excel-o\"></i> Export to Excel</button> <button class=\"btn btn-export html-btn\" ng-click=\"exportToHTML()\"><i class=\"fa fa-code\"></i> Export to HTML</button> <button class=\"btn btn-export pdf-btn\" ng-click=\"downloadTAReport()\"><i class=\"fa fa-file-pdf-o\"></i> Export to PDF</button></div><div><button class=\"btn btn-export excel-btn\" ng-click=\"uploadToAzure()\"><i class=\"fa fa-cloud-upload\"></i> Save selection</button></div></div><hr class=\"my-4\"><div class=\"form-group\"><div class=\"custom-control custom-switch\"><label class=\"switch\"><input type=\"checkbox\" class=\"custom-control-input\" id=\"selectAll\" ng-model=\"selectAll\" ng-click=\"toggleSelectAll()\"> <span class=\"slider round\"></span></label> <label style=\"cursor: pointer;\" for=\"selectAll\">Select/Deselect All Rows</label></div></div><div class=\"stats mt-4\"><label>Selected {{ getSelectedCount() }} out of {{ getTotalElements() }} elements</label></div><hr class=\"my-4\"><div class=\"filterContainer\"><div ng-repeat=\"filter in filterOptions\" class=\"filterOption\" ng-if=\"shouldDisplayFilter(filter.label)\"><input type=\"checkbox\" id=\"{{filter.key}}\" ng-model=\"filters[filter.key]\" ng-click=\"toggleFilter(filter.key, !filters[filter.key])\"> <label for=\"{{filter.key}}\" style=\"cursor: pointer;\">{{filter.label}}</label></div></div><hr class=\"my-4\"><button ng-click=\"renderTable()\" class=\"btn mrg-btn\">{{ merged ? \'Show Individual Items\' : \'Merge by Subdimension\' }}</button><hr class=\"my-4\"><div class=\"top-buttons__actions\"><button class=\"btn btn-export btn-add\" ng-click=\"addRow()\"><i class=\"fa fa-plus\"></i> Add</button><div><span><translate>Selected Currency:&nbsp;</translate><span ng-bind=\"global_currency\"></span></span><select chosen=\"\" ng-model=\"global_currency\" ng-change=\"updateCurrency(global_currency)\" ng-options=\"k as (k + \': \' + v.name) for (k, v) in currencies\"><option></option></select></div></div></div></div><br><div class=\"col-lg-12\"><div class=\"card shadow-sm border-0 animate__animated animate__fadeIn\" ng-if=\"tableData.length > 0\"><div class=\"table-responsive\"><table class=\"table table-hover dataTable\"><thead><tr><th></th><th translate=\"\">Dimension</th><th translate=\"\">Dimension score</th><th translate=\"\">Subdimension</th><th translate=\"\">Subdimension score</th><th translate=\"\">Problem</th><th translate=\"\">Activity</th><th translate=\"\">Expected outcome</th><th translate=\"\">Start date</th><th translate=\"\">End date</th><th translate=\"\">Cost</th><th></th></tr></thead><tbody><tr ng-if=\"!merged\" ng-repeat=\"row in tableData | filter:{shouldDisplay:true} track by row.id\" ng-class=\"{\'selected-row\': row.selected}\"><td><input type=\"checkbox\" ng-model=\"row.selected\"></td><td><div contenteditable=\"true\" class=\"editable-cell\" ng-model=\"row.dimension\" ng-bind=\"row.dimension\" ng-blur=\"updateCell(row.id, \'dimension\', $event)\"></div></td><td><div ng-if=\"!row.manuallyAdded\" ng-model=\"row.dimension_score\" ng-bind=\"row.dimension_score\"></div><input ng-if=\"row.manuallyAdded\" style=\"width: 70%; padding-top: 5px;padding-bottom: 5px;\" type=\"text\" step=\"0.001\" ng-model=\"row.dimension_score\" max-decimal-points=\"1\" min-value=\"0\" max-value=\"5\"></td><td><div contenteditable=\"true\" class=\"editable-cell\" ng-model=\"row.subdimension\" ng-bind=\"row.subdimension\" ng-blur=\"updateCell(row.id, \'subdimension\', $event)\"></div></td><td><div ng-if=\"!row.manuallyAdded\" ng-model=\"row.subdimension_score\" ng-bind=\"row.subdimension_score\"></div><input ng-if=\"row.manuallyAdded\" style=\"width: 70%; padding-top: 5px;padding-bottom: 5px;\" type=\"text\" step=\"0.001\" max-decimal-points=\"1\" min-value=\"0\" max-value=\"5\" ng-model=\"row.subdimension_score\"></td><td><div contenteditable=\"true\" class=\"editable-cell\" ng-model=\"row.problem\" ng-bind=\"row.problem\" ng-blur=\"updateCell(row.id, \'problem\', $event)\"></div></td><td><div contenteditable=\"true\" class=\"editable-cell\" ng-model=\"row.activity\" ng-bind=\"row.activity\" ng-blur=\"updateCell(row.id, \'activity\', $event)\"></div></td><td><div contenteditable=\"true\" class=\"editable-cell\" ng-model=\"row.expected_outcome\" ng-bind=\"row.expected_outcome\" ng-blur=\"updateCell(row.id, \'expected_outcome\', $event)\"></div></td><td style=\"overflow: visible; min-width: 150px;\"><si-datepicker ng-model=\"row.start_date\" max_date=\"row.end_date\"></si-datepicker></td><td style=\"overflow: visible; min-width: 150px;\"><si-datepicker ng-model=\"row.end_date\" min_date=\"row.start_date\"></si-datepicker></td><td><input style=\"width: 70%; padding-top: 5px; padding-bottom: 5px; top: 1px; position: relative; min-width: 90px;\" type=\"text\" ng-model=\"row.cost\" name=\"cost\" min=\"0\" ng-keydown=\"keydown($event)\" ng-change=\"updateAmount(row)\"> {{global_currency}}</td><td style=\"padding-left:0; padding-right: 0;\"><div><a ng-click=\"deleteRow(row.id)\" class=\"btn-lg\" style=\"padding-left:0; padding-right: 0;\"><i class=\"fa fa-trash\" style=\"color:rgb(235, 72, 72)\"></i></a></div></td></tr><tr ng-if=\"merged\" ng-repeat=\"row in mergedData | filter:{shouldDisplay:true} track by $index\" ng-class=\"{\'selected-row\': row.selected}\"><td><input type=\"checkbox\" ng-model=\"row.selected\"></td><td><div contenteditable=\"true\" ng-bind=\"row.dimension\" ng-blur=\"updateCellNewRowWhenMerged(row, \'dimension\', $event)\"></div></td><td><div>{{row.dimension_score}}</div></td><td><div contenteditable=\"true\" ng-bind=\"row.subdimension\" ng-blur=\"updateCellNewRowWhenMerged(row, \'subdimension\', $event)\"></div></td><td><div>{{row.subdimension_score}}</div></td><td><div ng-if=\"!row.manuallyAdded\" style=\"white-space: pre-line;\" contenteditable=\"true\" ng-bind=\"row.problem\" ng-blur=\"updateProblem(row, $event)\"></div><div ng-if=\"row.manuallyAdded\" contenteditable=\"true\" ng-bind=\"row.problem\" ng-blur=\"updateProblemNewlyCreated(row, $event)\"></div></td><td><div ng-if=\"!row.manuallyAdded\" style=\"white-space: pre-line;\" contenteditable=\"true\" ng-bind=\"row.activity\" ng-blur=\"updateActivity(row, $event)\"></div><div ng-if=\"row.manuallyAdded\" contenteditable=\"true\" ng-bind=\"row.activity\" ng-blur=\"updateActivityNewlyCreated(row, $event)\"></div></td><td><div ng-if=\"!row.manuallyAdded\" style=\"white-space: pre-line;\" contenteditable=\"true\" ng-bind=\"row.outcome\" ng-blur=\"updateOutcome(row, $event)\"></div><div ng-if=\"row.manuallyAdded\" contenteditable=\"true\" ng-bind=\"row.outcome\" ng-blur=\"updateOutcomeNewlyCreated(row, $event)\"></div></td><td style=\"overflow: visible; min-width: 150px;\"><si-datepicker ng-if=\"!row.manuallyAdded\" ng-model=\"row.start_date\" max_date=\"row.end_date\"></si-datepicker><si-datepicker ng-if=\"row.manuallyAdded\" ng-model=\"row.start_date\" max_date=\"row.end_date\"></si-datepicker></td><td style=\"overflow: visible; min-width: 150px;\"><si-datepicker ng-if=\"!row.manuallyAdded\" ng-model=\"row.end_date\" min_date=\"row.start_date\"></si-datepicker><si-datepicker ng-if=\"row.manuallyAdded\" ng-model=\"row.end_date\" min_date=\"row.start_date\"></si-datepicker></td><td><div ng-if=\"!row.manuallyAdded\" style=\"padding-top: 0;\"><input style=\"width: 70%; padding-top: 5px; padding-bottom: 5px; top: 1px; position: relative; min-width: 90px;\" type=\"text\" ng-model=\"row.cost\" name=\"cost\" min=\"0\" ng-keydown=\"keydown($event)\" ng-change=\"updateAmountForMergedRow(row)\"> {{global_currency}}</div><div ng-if=\"row.manuallyAdded\" style=\"padding-top: 0px;\"><input style=\"width: 70%; padding-top: 5px; padding-bottom: 5px; top: 1px; position: relative; min-width: 90px;\" type=\"text\" ng-model=\"row.cost\" name=\"cost\" min=\"0\" ng-keydown=\"keydown($event)\" ng-change=\"updateAmountForMergedNewlyAddedRow(row)\"> {{global_currency}}</div></td><td style=\"padding-left:0; padding-right: 0;\"><div><a ng-click=\"deleteMegredRow($index)\" class=\"btn-lg\" style=\"padding-left:0; padding-right: 0;\"><i class=\"fa fa-trash\" style=\"color:rgb(235, 72, 72)\"></i></a></div></td></tr></tbody></table></div></div></div></div></div><footer class=\"footer mt-5 py-3\"><div class=\"container text-center\"><span class=\"text-muted\">© 2025 Technical Assistance Builder</span></div></footer></div></div></body></html>");
$templateCache.put("assessments/assessmentAssignmentDetailView.html","<si-page class=\"si-assessment-details\" search=\"true\"><div class=\"si-page__wrapper\" ng-show=\"isLoaded\"><header class=\"si-page__header\"><div class=\"alert red-bg\" ng-if=\"isAssessmentInGodMode(assessment)\"><strong>WARNING</strong> Assessment is in Admin Mode</div><h2>{{ assessment.producing_organization.customer.name | capitalize}} -<translate>Assessment</translate>- {{ assignment.assessment.tool.type.name | capitalize }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.assessments-assignments\" translate=\"\">Assessments</a></li><li class=\"active\"><strong>{{ assessment.producing_organization.customer.name | capitalize}} -<translate>Assessment</translate>- {{ assessment.tool.type.name | capitalize }}</strong></li></ol></header><div class=\"si-assessment-details__wrapper\"><main class=\"si-assessment-details__main\"><div class=\"row m-b\"><div class=\"col-xs-12\"><p class=\"p-xxs label label-warning\"><translate>Assessment Language</translate>- <span class=\"badge\" ng-bind=\"assessment.language || \'English\'\"></span></p></div></div><div class=\"row m-b\"><div class=\"col-xs-12\" ng-if=\"!isViewOnly(assignment)\"><div ng-if=\"canUserSwitchAssignments()\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"changeUser(\'assessor\')\"><i class=\"fa fa-user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Assessor\' | translate}}\"></i></button> <button class=\"btn btn-info\" type=\"button\" ng-click=\"changeUser(\'financial_specialist\')\"><i class=\"fa fa-dollar\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'Financial Specialist\' | translate}}\"></i></button></div><div ng-show=\"assessment.tool.type.is_rapid && !assessment.rapid_finalized\" style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\"><span><span ng-show=\"isRapidFinalizeBlocked()\" class=\"text-muted finalize-offline-note\" role=\"note\"><i class=\"fa fa-exclamation-triangle\"></i> {{ rapidFinalizeOfflineMessage() | translate }}</span></span> <span><button ng-click=\"confirmSendFeedbackToQualityControllers()\" ng-disabled=\"isRapidFinalizeBlocked()\" title=\"{{ isRapidFinalizeBlocked() ? (rapidFinalizeOfflineMessage() | translate) : \'\' }}\" class=\"btn btn-success\"><i class=\"fa fa-send\"></i> <span><translate>Finalize assessment</translate></span></button></span></div><div ng-show=\"assessment.tool.type.is_rapid && assessment.rapid_finalized && isUserAllowedOnState(\'base.admin\')\" style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\"><span></span> <span><a ng-click=\"updateExistingReport(assessment)\" class=\"btn btn-success\"><i class=\"fa fa-send\"></i> <span><translate>Update Report and Exit admin mode</translate></span></a></span></div><div ng-if=\"(me.employee || assessment.project.can_edit_assessments) && app !== \'smartclient\' && !isAssessmentInGodMode(assessment)\"><span ng-if=\"isUserAllowed()\"><a ng-if=\"assessment.can_make_reports && !assessment.reports.objects.length\" ng-click=\"generateDraftReport(assessment)\" ng-class=\"{ disabled: !canGenerateDraftReport(assessment) }\" ng-attr-title=\"{{ draftReportBlockedReason(assessment) || undefined }}\" class=\"btn btn-success\"><i class=\"fa fa-clipboard\"></i><translate>Generate Draft Report</translate></a> <a ng-if=\"assessment.can_make_reports && assessment.reports.objects.length\" ng-click=\"generateNewDraftReport(assessment, \'newReport\')\" ng-class=\"{ disabled: !canGenerateDraftReport(assessment) }\" ng-attr-title=\"{{ draftReportBlockedReason(assessment) || undefined }}\" class=\"btn btn-success\"><i class=\"fa fa-clipboard\"></i><translate>Generate New Draft Report</translate></a><span ng-if=\"assessment.can_make_reports && draftReportBlockedReason(assessment)\" class=\"text-danger draft-report-blocked-reason\">{{ draftReportBlockedReason(assessment) }}</span></span> <span class=\"pull-right\"><span ng-hide=\"assessment.tool.type.is_rapid\"><a ng-if=\"!assignment.locked_for_employee\" ng-click=\"confirmSendFeedbackToAssessors()\" class=\"btn btn-success\"><i class=\"fa fa-send\"></i> <span ng-show=\"assignment.assigned_as === \'assessor\'\"><translate>Send Feedback to Assessors</translate></span> <span ng-hide=\"assignment.assigned_as === \'assessor\'\"><translate>Send Financial Feedback</translate></span></a> <a ng-if=\"assignment.locked_for_employee\" ng-hide=\"isDashboardUserAdmin\" ng-click=\"updateAssessmentLocks({locked_for_employee: false, locked_for_assessor: true})\" class=\"btn btn-primary\"><i class=\"fa fa-unlock\"></i><translate>Unlock Assessment</translate></a></span></span></div><div ng-if=\"me.employee && isAssessmentInGodMode(assessment) && app !== \'smartclient\'\"><span class=\"pull-right\"><a ng-if=\"assessment.can_make_reports && assessment.reports.objects.length && assessment.tool_name !== \'SCOPE Rapid\'\" ng-click=\"updateExistingReport(assessment)\" class=\"btn btn-primary\"><i class=\"fa fa-clipboard\"></i><translate>Update Report and Exit Admin Mode</translate></a></span></div><div ng-if=\"isSmartClient && !assignment.locked_for_assessor && !isOffline && !isAssessmentInGodMode(assessment) && !assessment.tool.type.is_rapid\" class=\"pull-right\"><button ng-hide=\"assignment.tool.tool_name === \'SCOPE Basic\'\" ng-click=\"confirmSendFeedbackToQualityControllers()\" class=\"btn btn-success\"><i class=\"fa fa-send\"></i> <span ng-show=\"assessment.tool.type.is_rapid && assignment.assigned_as === \'assessor\'\"><translate>Finalize assessment</translate></span> <span ng-show=\"!assessment.tool.type.is_rapid && assignment.assigned_as === \'assessor\'\"><translate>Send to Quality Control</translate></span> <span ng-hide=\"assignment.assigned_as === \'assessor\'\"><translate>Send Financials to Quality Control</translate></span></button></div></div></div><div class=\"ibox\" ng-if=\"(isAssessmentLocked(assignment, assesment, assessment) && !isAssessmentInGodMode(assessment)) || (assessment.tool.type.is_rapid && assessment.rapid_finalized && !isUserAllowedOnState(\'base.admin\'))\"><div class=\"ibox-content\"><div class=\"well\" translate=\"\">The assessment has been locked. Editing of the assessment is not allowed at this point. Employees can unlock this assessment.</div></div></div><div class=\"panel white-bg no-borders\" ng-if=\"(!isAssessmentLocked(assignment, assesment, assessment) || isAssessmentInGodMode(assessment)) && !(isSmartClient && assessment.tool.type.is_rapid && assessment.rapid_finalized && !isUserAllowedOnState(\'base.admin\'))\"><div class=\"panel-heading no-padding\"><ul class=\"nav nav-tabs\"><li ng-if=\"shouldShowTab(\'organizational_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.organization\'}\"><a ui-sref=\"base.assessments-assignment-detail.organization(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-if=\"!assessment.tool.type.agent\"><span ng-show=\"assessment.organizational_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.organizational_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.organizational_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.organizational_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.organizational_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.organizational_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span> <span ng-if=\"assessment.tool.type.agent\"><span ng-show=\"assessment.agent_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.agent_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.agent_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.agent_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.agent_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.agent_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"!assessment.tool.type.agent\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.organizational_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.organizational_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span> <span ng-if=\"assessment.tool.type.agent\"><span ng-if=\"assessment.agent_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.agent_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span></span> <span ng-if=\"!assessment.tool.type.agent\" translate=\"\">Organization</span> <span ng-if=\"assessment.tool.type.agent\" translate=\"\">Agent</span></a></li><li ng-if=\"shouldShowTab(\'documentation_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.documentation\'}\"><a ui-sref=\"base.assessments-assignment-detail.documentation(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required\"><span ng-show=\"assessment.documents_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.documents_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.documents_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.documents_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.documents_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.documents_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span><span ng-if=\"assessment.documents_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.documents_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span></span><translate>Documentation</translate></a></li><li ng-if=\"shouldShowTab(\'assessment_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.assessment\'}\"><a ui-sref=\"base.assessments-assignment-detail.assessment(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.assessment_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.assessment_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.assessment_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.assessment_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.assessment_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.assessment_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.assessment_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.assessment_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Assessment</translate></a></li><li ng-if=\"shouldShowTab(\'questionnaire_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.questionnaire\'}\"><a ui-sref=\"base.assessments-assignment-detail.questionnaire(assessment.id)\"><span ng-if=\"isSmartClient && assessment.completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.isQuestionnaireDone && assignment.submitted_at_least_once && assessment.isQuestionnaireAccepted\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"assessment.isQuestionnaireDone && assignment.submitted_at_least_once && !assessment.isQuestionnaireAccepted\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!assessment.isQuestionnaireDone && assignment.submitted_at_least_once\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span><span ng-if=\"assessment.isQuestionnaireDone && !assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!assessment.isQuestionnaireDone && !assignment.submitted_at_least_once && !showTabWarnings\"><i class=\"fa fa-circle-o\"></i></span> <span ng-if=\"!assessment.isQuestionnaireDone && !assignment.submitted_at_least_once && showTabWarnings\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.isQuestionnaireDone\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.isQuestionnaireDone\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Questionnaire</translate></a></li><li ng-if=\"shouldShowTab(\'observations_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.observations\'}\"><a ui-sref=\"base.assessments-assignment-detail.observations(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.observations_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.observations_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.observations_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.observations_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.observations_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.observations_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.observations_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.observations_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Observations</translate></a></li><li ng-if=\"shouldShowTab(\'qc_tab\')\" ng-hide=\"hideQCLogTab\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.qc-logs\'}\"><a ui-sref=\"base.assessments-assignment-detail.qc-logs(assessment.id)\"><span><i class=\"fa fa-check-circle text-success\"></i></span><translate>QC Log</translate></a></li><li ng-if=\"shouldShowTab(\'terms_tab\') && assessment.with_terms_and_conditions\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.terms\'}\"><a ui-sref=\"base.assessments-assignment-detail.terms(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.data_sharing_consent_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.data_sharing_consent_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.data_sharing_consent_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.data_sharing_consent_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.data_sharing_consent_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.data_sharing_consent_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.data_sharing_consent_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.data_sharing_consent_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Data Sharing Consent(s)</translate></a></li><li ng-if=\"shouldShowTab(\'value_chain_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.valuechain\'}\"><a ui-sref=\"base.assessments-assignment-detail.valuechain(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.value_chain_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.value_chain_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.value_chain_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.value_chain_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.value_chain_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.value_chain_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.value_chain_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.value_chain_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Value Chain</translate></a></li><li ng-if=\"shouldShowTab(\'production_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.production\'}\"><a ui-sref=\"base.assessments-assignment-detail.production(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.production_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.production_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.production_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.production_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.production_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.production_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.production_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.production_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span> <span ng-if=\"assessment.tool.type.input_retailer\"><translate>Products Sold</translate></span> <span ng-if=\"assessment.tool.type.agent\"><translate>Production</translate></span> <span ng-if=\"!assessment.tool.type.input_retailer && !assessment.tool.type.agent\"><span ng-bind=\"\'Production & Sales\' | translate\"></span></span></a></li><li ng-if=\"shouldShowTab(\'finance_history_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.finance-history\'}\"><a ui-sref=\"base.assessments-assignment-detail.finance-history(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.finance_history_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.finance_history_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.finance_history_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_history_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.finance_history_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_history_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.finance_history_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.finance_history_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Finance History</translate></a></li><li ng-if=\"shouldShowTab(\'finance_overview_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.finance-overview\'}\"><a ui-sref=\"base.assessments-assignment-detail.finance-overview(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.finance_overview_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.finance_overview_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.finance_overview_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_overview_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.finance_overview_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_overview_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.finance_overview_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.finance_overview_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Finance Overview</translate></a></li><li ng-if=\"shouldShowTab(\'profit_loss_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.profit-loss\'}\"><a ui-sref=\"base.assessments-assignment-detail.profit-loss(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><span ng-show=\"assessment.profit_loss_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.profit_loss_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.profit_loss_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.profit_loss_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.profit_loss_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.profit_loss_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><span ng-if=\"assessment.profit_loss_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.profit_loss_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Profit / Loss</translate></a></li><li ng-if=\"shouldShowTab(\'balancesheet_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.balancesheet\'}\"><a ui-sref=\"base.assessments-assignment-detail.balancesheet(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><span ng-show=\"assessment.balance_sheet_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.balance_sheet_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.balance_sheet_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.balance_sheet_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.balance_sheet_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.balance_sheet_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><span ng-if=\"assessment.balance_sheet_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.balance_sheet_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Balancesheet</translate></a></li><li ng-if=\"shouldShowTab(\'cashflow_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.cashflow\'}\"><a ui-sref=\"base.assessments-assignment-detail.cashflow(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><span ng-show=\"assessment.cash_flow_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.cash_flow_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.cash_flow_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.cash_flow_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.cash_flow_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.cash_flow_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><span ng-if=\"assessment.cash_flow_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.cash_flow_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Cashflow</translate></a></li><li ng-if=\"shouldShowTab(\'financial_performance_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.financial-performance\'}\"><a ng-click=\"updateRatiosAndGoToTab(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><span ng-show=\"assessment.finance_performance_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.finance_performance_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.finance_performance_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_performance_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.finance_performance_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_performance_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><span ng-if=\"assessment.finance_performance_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.finance_performance_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'assessor\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><translate>Financial Performance</translate></a></li><li ng-if=\"shouldShowTab(\'finance_and_product_tab\')\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.finance-product\'}\"><a ui-sref=\"base.assessments-assignment-detail.finance-product(assessment.id)\"><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'assessor\'\"><span ng-show=\"assessment.finance_product_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-hide=\"assessment.finance_product_tab_accepted && assignment.submitted_at_least_once\"><span ng-hide=\"showTabWarnings\"><span ng-show=\"assessment.finance_product_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_product_tab_completed\"><i class=\"fa fa-circle-o\"></i></span></span> <span ng-show=\"showTabWarnings\"><span ng-show=\"assessment.finance_product_tab_completed\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.finance_product_tab_completed\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></span></span><span ng-if=\"isSmartClient && assessment.full_completion_check_required && assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span><span ng-if=\"isDashboard && assessment.full_completion_check_required && isViewOnly(assignment)\"><i class=\"fa fa-lock text-warning\"></i></span> <span ng-if=\"isDashboard && assessment.full_completion_check_required && !isViewOnly(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\"><span ng-if=\"assessment.finance_product_tab_accepted && assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"!assessment.finance_product_tab_accepted\"><i class=\"fa fa-check-circle text-success\"></i></span></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><i class=\"fa fa-lock text-warning\"></i></span></span><span ng-bind=\"\'Finance & Product\' | translate\"></span></a></li><li ng-if=\"!isOffline\" ng-class=\"{\'active\': $state.current.name === \'base.assessments-assignment-detail.qc-dashboard\'}\"><a ui-sref=\"base.assessments-assignment-detail.qc-dashboard(assessment.id)\"><span ng-bind=\"\'QC Dashboard\' | translate\"></span></a></li></ul><div ng-if=\"isLoaded\" class=\"tab-content\" ui-view=\"tabContent\"></div></div></div></main><fieldset ng-disabled=\"isCommentBoxDisabled($state.current, assignment.assigned_as)\"><si-sidebar ng-show=\"!assessment.tool.type.is_rapid && $state.current.name === \'base.assessments-assignment-detail.questionnaire\' && $state.current.name !== \'base.assessments-assignment-detail.qc-logs\' && assessment.project.can_edit_assessments && !isAssessmentLocked(assignment, assesment)\"><si-comment-box ng-show=\"active_response\"><h4><i class=\"fa fa-comments-o\">{{ active_response.question_title }}</i></h4><div class=\"feed-element\"><p ng-repeat=\"comment in active_response.comments.objects\"><i>{{ comment.contents }}</i><br><translate>on</translate>&nbsp;{{ comment.created_at | date }}<br><translate>by</translate>&nbsp; <a href=\"#\">{{ comment.user | username }}</a></p></div><div><textarea class=\"form-control\" ng-model=\"user.comments\" style=\"resize: vertical; min-height: 100px\"></textarea><br><a class=\"btn btn-primary\" ng-disabled=\"!user.comments\" ng-click=\"saveResponseComment(active_response, user.comments)\" translate=\"\">Add Comment</a></div></si-comment-box></si-sidebar><si-sidebar ng-show=\"shouldShowTab(\'qc_tab\')&&($state.current.name !== \'base.assessments-assignment-detail.questionnaire\' && $state.current.name !== \'base.assessments-assignment-detail.qc-logs\' && assessment.project.can_edit_assessments && !isAssessmentLocked(assignment, assesment))\"><si-comment-box><h4><i class=\"fa fa-comments-o\"></i><translate>QC feedback</translate><br><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.assessment\'\" translate=\"\">Assessment</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.organization\'\" translate=\"\">Organization</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.valuechain\'\" translate=\"\">Value Chain</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.finance\'\" translate=\"\">Finance</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.finance-history\'\" translate=\"\">Finance History</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.finance-overview\'\" translate=\"\">Finance Overview</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.profit-loss\'\" translate=\"\">Profit / Loss</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.balancesheet\'\" translate=\"\">Balancesheet</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.cashflow\'\" translate=\"\">Cash Flow</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.financial-performance\'\" translate=\"\">Financial Performance</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.production\'\" translate=\"\">Production</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.production_monthly\'\" translate=\"\">Monthly Production</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.governance\'\" translate=\"\">Governance</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.observations\'\" translate=\"\">Observations</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.documentation\'\" translate=\"\">Documentation</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.terms\'\" translate=\"\">Data Sharing Consent</p><p ng-if=\"$state.current.name === \'base.assessments-assignment-detail.finance-product\'\"><span ng-bind=\"\'Finance & Product\' | translate\"></span></p></h4><div class=\"feed-element\"><tab-comments assessment=\"assessment\" state=\"$state.current\" assignment=\"assignment\"></tab-comments></div><div><textarea class=\"form-control\" ng-model=\"user.comments\" id=\"QCfeedback\" style=\"resize: vertical; min-height: 100px\">\n                            </textarea> <button class=\"btn btn-primary\" ng-disabled=\"!user.comments\" ng-click=\"saveQCfeedback(assessment,user.comments)\" translate=\"\">Add Feedback</button></div></si-comment-box></si-sidebar></fieldset></div></div></si-page>");
$templateCache.put("assessments/assessmentListView.html","<si-page class=\"si-assessments\" search=\"true\" background=\"grey\"><div class=\"si-page__wrapper\"><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h4 translate=\"\">All assessments</h4><div><button ng-if=\"isEmployee && !isSmartClient\" class=\"btn btn-success btn-xs\" ng-click=\"transferAssessments()\"><i class=\"fa fa-gears\"></i><translate>Transfer Selected Assessments</translate></button><button ng-if=\"!isSmartClient\" class=\"btn btn-info btn-xs\" ng-click=\"downloadReports()\"><i class=\"fa fa-download\"></i><translate>Download Selected Reports</translate></button></div></header><div class=\"si-page__main__content assessments-view\" ng-class=\"{\'assessments-view--query-params-set\': queryParamsSet}\"><p ng-if=\"assessments.results.length === 0\" translate=\"\">No assessments found.</p><table class=\"table table-hover dataTable\" ng-if=\"assignments.length > 0\"><thead><tr><th ng-if=\"isSmartClient\">&nbsp;</th><th ng-if=\"!isSmartClient\" class=\"table__th__checkbox\"><input type=\"checkbox\" ng-model=\"selectAll\" ng-click=\"selectAllReportsForDownload(selectAll, assignments)\"></th><th>&nbsp;</th><th translate=\"\" class=\"table__th__user\">User</th><th sort-column=\"\" sort-name=\"project__name\" translate=\"\">Project</th><th sort-column=\"\" sort-name=\"producing_organization__customer__name\" translate=\"\">Assessee</th><th sort-column=\"\" sort-name=\"assessor_full_name\" ng-if=\"app === \'dashboard\'\"><span class=\"text-warning\"><translate>Invited</translate></span> / <span class=\"text-success\"><translate>Accepted</translate></span></th><th sort-column=\"\" sort-name=\"date\" translate=\"\">Date</th><th sort-column=\"\" sort-name=\"tool__title\" translate=\"\">Tool</th><th sort-column=\"\" sort-name=\"language\" translate=\"\">Language</th><th sort-column=\"\" sort-name=\"status\" translate=\"\">Status</th><th sort-column=\"\" sort-name=\"last_status_update\" translate=\"\">Last status update</th><th sort-column=\"\" ng-if=\"app !== \'smartclient\'\" sort-name=\"counter_QR_to_assessor\" translate=\"\">QC Count</th><th sort-column=\"\" ng-if=\"app !== \'smartclient\'\" sort-name=\"display_quality_reviewer__full_name\" translate=\"\">QC Reviewer</th><th ng-if=\"$state.current.name === \'base.assessments-list-final\' && app !== \'smartclient\'\" sort-column=\"\" sort-name=\"status\" translate=\"\">Actions</th></tr></thead><tbody><tr ng-repeat=\"assignment in assignments\" class=\"assessment-view__row\" ng-class=\"{\'asssessment-view__row__last\': assignment.isLast}\"><td ng-if=\"!isSmartClient\"><input type=\"checkbox\" ng-show=\"assignment.assigned_as === \'assessor\'\" ng-model=\"assignment.reportSelected\"></td><td><i ng-show=\"assignment.assessment.offline === true\" class=\"fa fa-cloud-download\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Available offline\' | translate }}\"></i></td><td ng-if=\"isSmartClient\" class=\"text-center\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><i class=\"fa\" ng-class=\"{\'fa-lock\': isAssessmentLocked(assignment), \'fa-unlock\': !isAssessmentLocked(assignment)}\"></i></a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\" class=\"badge text-success\"><i class=\"fa fa-user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Assessor\' | translate }}\"></i></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\" class=\"badge text-info\"><i class=\"fa fa-dollar\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Financial Specialist\' | translate }}\"></i></span></a></td><td class=\"assessment-view__row__project-name\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span ng-bind=\"assignment.assessment.project.name\"></span></a></td><td class=\"assessment-view__row__poname\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{getNameToShow(assignment.assessment)}}</span></a></td><td ng-if=\"app === \'dashboard\'\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span ng-class=\"{\'text-success\': assignment.type !== \'invitation\', \'text-warning\': assignment.type === \'invitation\'}\">{{ assignment.name }}</span></a></td><td class=\"assessment-view__row__date\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{ assignment.assessment.date | date: \'dd-MM-yyyy\' }}</span></a></td><td class=\"assessment-view__row__tool\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{ assignment.assessment.tool_title }}</span></a></td><td class=\"assessment-view__row__language\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span ng-bind=\"assignment.assessment.language | language\"></span></a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\">{{ assignment.display_status | capitalize }}</a></td><td class=\"assessment-view__row__date\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{ assignment.assessment.last_status_update | date: \'dd-MM-yyyy, HH:mm\' }}</span></a></td><td class=\"assessment-view__row__language\" ng-if=\"app !== \'smartclient\'\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{ assignment.assessment.counter_QR_to_assessor }}</span></a></td><td ng-if=\"app !== \'smartclient\'\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); clickRow(assignment)\"><span>{{ assignment.assessment.display_quality_reviewer_name }}</span></a></td><td class=\"text-right\" ng-if=\"$state.current.name === \'base.assessments-list-final\' && app !== \'smartclient\'\"><div class=\"dropdown\" uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"><translate>Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\" style=\"color: white;\"><li><a class=\"btn btn-sm btn-info\" ng-click=\"downloadPDF(assignment.assessment)\"><i class=\"fa fa-download\"></i><translate>Download Report</translate></a></li><li ng-if=\"assignment.assessment.tool_name === \'SCOPE Pro\' || assignment.assessment.tool_name === \'SCOPE Pro SME\'\"><a class=\"btn btn-sm btn-info\" ng-click=\"downloadProfile(assignment.assessment)\"><i class=\"fa fa-download\"></i><translate>Download Profile</translate></a></li></ul></div></td></tr></tbody></table><paginated items=\"assessments\" items-per-page=\"20\"></paginated><div ng-show=\"assessments.count > 0\">Number of items is : {{ assessments.count }}</div></div></main></div><search class=\"si-assessments__search\"><search-filters><search-filter ng-if=\"assessments.filters.page_size.length > 1\" name=\"{{ \'Page size\' | translate }}\"><dropdown-checkbox-filter display_name=\"Page size\" options-key=\"page_size\" filters=\"assessments.filters.page_size\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.statuses.length > 1\" name=\"{{ \'Status\' | translate }}\"><dropdown-checkbox-filter display_name=\"Status\" options-key=\"status\" filters=\"assessments.filters.statuses\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.countries.length > 1\" name=\"{{ \'Country\' | translate }}\"><dropdown-checkbox-filter display_name=\"Country\" options-key=\"countries\" filters=\"assessments.filters.countries\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.project.length > 1\" name=\"{{ \'Project\' | translate }}\"><dropdown-checkbox-filter display_name=\"Project\" options-key=\"project_name\" filters=\"assessments.filters.project\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.results.length > 1\" name=\"{{ \'Assessment Date Range\' | translate }}\"><date-range-filter display-name=\"Assessment Date Range\" max=\"assessments.filters.date.max\" min=\"assessments.filters.date.min\" max-name=\"max_date\" min-name=\"min_date\" search=\"search(filter, filterDisplay)\"></date-range-filter></search-filter><search-filter ng-if=\"assessments.filters.tool_types.length > 1\" name=\"{{ \'Tools\' | translate }}\"><dropdown-checkbox-filter display_name=\"Tool Type\" options-key=\"tool_type\" filters=\"assessments.filters.tool_types\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.languages.length > 1\" name=\"{{ \'Language\' | translate }}\"><dropdown-checkbox-filter display_name=\"Language\" options-key=\"language\" filters=\"assessments.filters.languages\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.assessors.length > 1\" name=\"{{ \'Assessor\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"assessor_name\" filters=\"assessments.filters.assessors\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.financial_specialists.length > 1\" name=\"{{ \'Financial Specialist\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"financial_specialist\" filters=\"assessments.filters.financial_specialists\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.quality_reviewers.length > 1\" name=\"{{ \'Quality Reviewer\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"quality_reviewer\" filters=\"assessments.filters.quality_reviewers\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"assessments.filters.financial_quality_reviewers.length > 1\" name=\"{{ \'Financial Quality Reviewer\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"financial_quality_reviewer\" filters=\"assessments.filters.financial_quality_reviewers\"></dropdown-checkbox-filter></search-filter><search-filter-choices remove-filter=\"removeFilter(filter)\" filter-options=\"assessments.filters\" filters=\"filters\"></search-filter-choices></search-filters></search></si-page>");
$templateCache.put("assessments/assessmentRapidSummaryView.html","<si-page search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-report-details__header\"><div class=\"breadcrumb\"><h2>{{ assessment.producing_organization.customer.name }}</h2><si-breadcrumbs breadcrumbs=\"breadcrumbs\"></si-breadcrumbs></div><div class=\"si-report-details__actions\" ng-if=\"assessment.status === \'has_final\'\"><div ng-if=\"(app === \'dashboard\') && me.is_employee\" class=\"btn-group\" ng-class=\"{\'open\': pdfDropdown}\"><button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-click=\"pdfDropdown = !pdfDropdown\">PDF <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"pdfDropdown=false;toPDF(assessment)\" translate=\"\">PDF Report</a></li></ul></div><span ng-show=\"!isDashboardUserAdmin && assessment.project.can_edit_assessments\"><button ng-click=\"adminMode(assessment)\" ng-show=\"isEmployee\" class=\"btn-danger btn\" translate=\"\">Admin mode</button></span> <span ng-show=\"!isDashboardUserAdmin && assessment.project.can_edit_assessments\"><button ng-click=\"reviseModal(assessment)\" ng-show=\"isEmployee\" class=\"btn-danger btn\" translate=\"\">Revise Rapid</button></span></div></header><div class=\"ibox\" ng-if=\"!(assessment.status === \'has_final\')\"><div class=\"ibox-content\"><div class=\"well\" translate=\"\">The assessment is still in progress. Summary view is disabled until the assessment is finalized.</div></div></div><main class=\"si-report-details__main\" ng-if=\"assessment.status === \'has_final\'\"><ul class=\"nav nav-tabs\"><li><a ui-sref=\"base.assessments-rapid-final.summary(id)\"><translate>Summary</translate></a></li><li ng-repeat=\"item in assessment.section_responses.objects\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.section({id: assessment.id, section: item.id})\">{{ item.section_title }} <span class=\"badge pull-right\">{{ item.score | number:1 }}</span></a></li><li ng-hide=\"isDashboardUserAdmin\"><a ng-if=\"!assessment.tool.type.agent\" ui-sref=\"base.assessments-rapid-final.organizational(id)\"><translate>Organizational</translate></a> <a ng-if=\"assessment.tool.type.agent\" ui-sref=\"base.assessments-rapid-final.organizational(id)\"><translate>Agent</translate></a></li><li ng-if=\"assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.finance-product(id)\"><translate>Finance & Product</translate></a></li><li ng-if=\"!assessment.tool.type.agent\"><a ui-sref=\"base.assessments-rapid-final.finance(id)\"><translate>Finance</translate></a></li><li ng-if=\"tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.financial-performance(id)\"><translate>Financial Performance</translate><span class=\"badge pull-right\" ng-bind=\"assessment.ratio_scores.total_score | number:1\"></span></a></li><li ng-if=\"assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.profit-loss(id)\"><translate>Profit / Loss</translate></a></li><li ng-if=\"assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.balancesheet(id)\"><translate>Balancesheet</translate></a></li><li ng-if=\"assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.cashflow(id)\"><translate>Cashflow</translate></a></li><li ng-if=\"!assessment.tool.type.agent\"><a ui-sref=\"base.assessments-rapid-final.production(id)\"><translate>Production & Sales</translate></a></li><li ng-if=\"!assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.monthly-production(id)\"><translate>Monthly Production</translate></a></li><li ng-if=\"!assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.assessments-rapid-final.governance(id)\"><translate>Governance</translate></a></li><li ng-if=\"assessment.with_terms_and_conditions\"><a ui-sref=\"base.assessments-rapid-final.terms(id)\"><translate>Terms and Conditions</translate></a></li></ul><div class=\"tab-content\" ui-view=\"tabContent\"></div></main></div></si-page>");
$templateCache.put("comments/commentsView.html","");
$templateCache.put("faq/faqView.html","<si-page><div style=\"width: 100%\"><iframe style=\"width: 100%; height: 100%\" ng-src=\"https://scopeinsight.freshdesk.com/en/support/home\" title=\"FAQ\"></iframe></div></si-page>");
$templateCache.put("hrm/hrmUserView.html","<si-page search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\" ng-if=\"!createUser\">Edit User</h2><h2 translate=\"\" ng-if=\"createUser\">Create User</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.hrm-users\" translate=\"\">User</a></li><li class=\"active\" ng-if=\"!createUser\"><strong>{{ user | username }}</strong></li><li class=\"active\" ng-if=\"createUser\"><strong>Create User</strong></li></ol></header><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h2><i class=\"fa fa-user\"></i> &nbsp;<translate>User</translate>&nbsp;- <span ng-if=\"!createUser\" ng-bind=\"user | username\"></span> <span ng-if=\"createUser\">Create User</span></h2><button ng-show=\"me.employee\" ng-click=\"hideUser(user)\" class=\"btn-danger btn\" translate=\"\">Hide</button></header><div class=\"si-page__main__content\"><form name=\"userForm\" class=\"form form-horizontal\" ng-submit=\"crudUser(user, userForm)\"><div class=\"form-group\" ng-if=\"!createUser\"><label class=\"col-sm-3 control-label\"><translate>Active account</translate></label><div class=\"col-sm-3\"><input type=\"checkbox\" class=\"single-checkbox\" ng-model=\"user.is_active\" name=\"is_active\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>First name</translate><label class=\"text-danger\" ng-show=\"userForm.first_name.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"user.first_name\" name=\"first_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Last name</translate><label class=\"text-danger\" ng-show=\"userForm.last_name.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"user.last_name\" name=\"last_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Organization</translate><label class=\"text-danger\" for=\"organization\" ng-show=\"userForm.organization.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" id=\"organization\" name=\"organization\" required=\"\" ng-disabled=\"isDashboardAdmin\" class=\"form-control\" data-placeholder-text-single=\"\'Select an organization\' | translate\" ng-options=\"customer.url as (customer.name | capitalize) for customer in customers\" ng-model=\"user.organization\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>City</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"user.city\" name=\"city\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"country\"><translate>Country</translate><label class=\"text-danger\" ng-show=\"userForm.country.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" class=\"form-control\" id=\"country\" name=\"country\" required=\"\" data-placeholder-text-single=\"\'Select a country\' | translate\" ng-options=\"country as country for country in countries\" ng-model=\"user.country\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Email</translate><label class=\"text-danger\" ng-show=\"userForm.email.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" ng-model=\"user.email\" name=\"email\" required=\"\" ng-change=\"checkEmailAvailability(user.email, userForm)\" ng-model-options=\"{updateOn: \'blur\'}\"> <b><small class=\"text-danger\" ng-show=\"userForm.email.$dirty && !emailValid\" translate=\"\">Invalid email</small> <small class=\"text-success\" ng-show=\"userForm.email.$dirty && emailValid && emailAvailable === true\" translate=\"\">Email Available</small> <small class=\"text-danger\" ng-show=\"userForm.email.$dirty && emailValid && emailAvailable === false\" style=\"font-style:bold\" translate=\"\">User with this email address already exists</small></b></div></div><div class=\"form-group\" ng-if=\"!createUser\"><label class=\"control-label col-sm-3\"><translate>Request Password</translate></label><div class=\"col-sm-9\"><button type=\"button\" ng-click=\"requestPasswordReset(user.email)\" class=\"btn btn-primary\"><translate>Request Password Reset</translate></button></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>UI Language</translate><label class=\"text-danger\" ng-show=\"userForm.language.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" name=\"language\" id=\"laguage\" ng-options=\"language.code as language.name for language in languages\" ng-change=\"updateLanguage(user.language, user.url)\" ng-model=\"user.language\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"!isDashboardAdmin\"><label class=\"control-label col-sm-3\"><translate>Applications</translate><label class=\"text-danger\" ng-show=\"userForm.applications.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" name=\"applications\" required=\"\" ng-options=\"app as (app.name | capitalize) for app in applications track by app.app\" ng-change=\"updateApplications(user)\" ng-model=\"user.allowed_frontends\"><option value=\"\"></option></select></div></div><div ng-if=\"isAuthorized(user.allowed_frontends, \'dashboard\')\"><h2>AgriGRADE</h2><div class=\"form-group\" ng-if=\"me.is_employee\"><label class=\"col-sm-3 control-label\"><translate>AgriGRADE User</translate></label><div class=\"col-sm-9\"><input type=\"checkbox\" class=\"single-checkbox\" ng-model=\"user.is_agri_grade_user\" name=\"is_agri_grade_user\" ng-change=\"toggleAgriGradeUser(user.is_agri_grade_user)\"></div></div><div class=\"form-group\" ng-if=\"user.is_agri_grade_user\"><label class=\"control-label col-sm-3\"><translate>AgriGRADE Projects</translate></label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" name=\"agri_grade_projects\" data-placeholder-text-single=\"\'Select Projects\' | translate\" ng-options=\"project as project.name for project in agriGradeProjects track by project.id\" ng-change=\"updateAgriProjects(user.url)\" ng-model=\"user.agri_grade_projects\"><option value=\"\"></option></select></div></div></div><div ng-if=\"isAuthorized(user.allowed_frontends, \'dashboard\')\"><h2>SCOPE Dashboard</h2><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Dashboard role</translate><label class=\"text-danger\" ng-show=\"userForm.role.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" name=\"role\" required=\"\" ng-options=\"role as (role.name | capitalize) for role in dashboardRoles track by role.name\" ng-change=\"updateDashboardRole(user.roles.dashboard)\" ng-model=\"user.roles.dashboard\"><option value=\"\"></option></select></div></div></div><div ng-if=\"isAuthorized(user.allowed_frontends, \'smartclient\')\"><h2>SCOPE App</h2><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Skills</translate><label class=\"text-danger\" ng-show=\"userForm.skill.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" name=\"skill\" required=\"\" ng-class=\"{\'localytics-chosen--no-edit\': isDashboardAdmin}\" ng-disabled=\"isDashboardAdmin\" data-placeholder-text-single=\"\'Select a skill\' | translate\" ng-options=\"skill as (skill.name | translate) for skill in skills track by skill.key\" ng-change=\"updateAssessorSkills(selectedSkills)\" ng-model=\"selectedSkills\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Tools</translate><label class=\"text-danger\" ng-show=\"userForm.tools.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" required=\"\" ng-class=\"{\'localytics-chosen--no-edit\': isDashboardAdmin}\" ng-disabled=\"isDashboardAdmin\" name=\"tools\" data-placeholder-text-single=\"\'Select a Tool\' | translate\" ng-options=\"tool.url as (tool.name | capitalize) for tool in tools.results\" ng-change=\"updateAssessorTools(assessor.tools, assessor.url)\" ng-model=\"assessor.tools\"><option></option></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Languages spoken</translate><label class=\"text-danger\" ng-show=\"userForm.languages.$error.required\">*</label></label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" name=\"languages\" required=\"\" ng-class=\"{\'localytics-chosen--no-edit\': isDashboardAdmin}\" ng-disabled=\"isDashboardAdmin\" data-placeholder-text-single=\"\'Select a Language\' | translate\" ng-options=\"language.code as language.name for language in languages\" ng-change=\"updateSpokenLanguage(user.languages_spoken, user.url)\" ng-model=\"user.languages_spoken\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"isAssessor\"><label class=\"control-label col-sm-3\"><translate>Assessor Expiration Date</translate></label><div class=\"col-sm-3\"><si-datepicker ng-model=\"assessor.expiration_date_assessor\" is-disabled=\"true\" name=\"expiration_date_assessor\"></si-datepicker></div></div><div class=\"form-group\" ng-if=\"isFinancialSpecialist\"><label class=\"control-label col-sm-3\"><translate>Financial Specialist Expiration Date</translate></label><div class=\"col-sm-3\"><si-datepicker ng-model=\"assessor.expiration_date_financial_specialist\" is-disabled=\"true\" name=\"expiration_date_financial_specialist\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Available to all Clients</translate><label class=\"text-danger\" ng-show=\"userForm.available_to_all_organizations.$error.required\">*</label></label><div class=\"col-sm-9\"><label class=\"radio-inline\"><input type=\"radio\" name=\"available_to_all_organizations\" ng-value=\"true\" required=\"\" ng-model=\"assessor.available_to_all_organizations\" ng-disabled=\"isDashboardAdmin\"> Yes</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"available_to_all_organizations\" ng-value=\"false\" required=\"\" ng-model=\"assessor.available_to_all_organizations\" ng-disabled=\"isDashboardAdmin\"> No</label></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Access to Trainee</translate></label><div class=\"col-sm-9\"><label class=\"radio-inline\"><input type=\"radio\" name=\"can_access_trainee\" ng-value=\"true\" ng-model=\"user.can_access_trainee\" ng-disabled=\"true\"> Yes</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"can_access_trainee\" ng-value=\"false\" ng-model=\"user.can_access_trainee\" ng-disabled=\"true\"> No</label></div></div></div><div ng-if=\"isAuthorized(user.allowed_frontends, \'smartclient\') && user.assessor\"><h2>SCOPE Training</h2><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Assessor Training</translate></label><div class=\"col-sm-9\"><training-table table-data=\"allAssessorTrainings.assessor\" table-type=\"assessor\" create-training=\"createTraining(training)\" delete-training=\"deleteTraining(training)\" update-training=\"updateTraining(training)\"></training-table></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Financial Specialist Training</translate></label><div class=\"col-sm-9\"><training-table table-data=\"allAssessorTrainings.financial_specialist\" table-type=\"financial\" create-training=\"createTraining(training)\" delete-training=\"deleteTraining(training)\" update-training=\"updateTraining(training)\"></training-table></div></div></div><div ng-if=\"isAuthorized(user.allowed_frontends, \'website\')\"><h2>SCOPE Portal</h2><div class=\"form-group\"><label class=\"control-label col-sm-3\"><translate>Portal License</translate></label><div class=\"col-sm-9\"><training-table table-data=\"portalLicenses\" table-type=\"portal\" create-training=\"createLicense(training)\" delete-training=\"deleteLicense(training)\" update-training=\"updateLicense(training)\"></training-table></div></div></div><div class=\"form-group\" ng-if=\"!createUser\"><div class=\"col-sm-9 col-sm-offset-3\"><button type=\"button\" class=\"btn btn-primary\" ng-hide=\"me.is_customer_user || me.is_customer_admin\" ng-disabled=\"userForm.$invalid\" ng-click=\"sendToTraining(user)\"><translate>Send to training</translate></button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"userForm.$invalid\" ng-show=\"me.is_employee\" ng-click=\"registerAtLearnworlds(user)\"><translate>Register user on Learnworlds</translate></button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"user.assessor && isAuthorized(user.allowed_frontends, \'smartclient\')\" ng-hide=\"me.is_customer_user || me.is_customer_admin\" ng-disabled=\"userForm.$invalid\" ng-click=\"graduate(user)\"><translate>Graduate</translate></button></div></div><div class=\"form-group\"><div class=\"col-sm-9 col-sm-offset-3\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"userForm.$invalid\"><span ng-if=\"createUser && isAuthorized(user.allowed_frontends, \'smartclient\')\"><translate>Save and proceed to training details</translate></span> <span ng-if=\"createUser && !isAuthorized(user.allowed_frontends, \'smartclient\')\"><translate>Save</translate></span> <span ng-if=\"!createUser\"><translate>Save</translate></span></button> <button type=\"button\" class=\"btn btn-default\" ui-sref=\"base.hrm-users\"><translate>Cancel</translate></button> <span ng-show=\"userForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <button type=\"button\" class=\"btn btn-danger pull-right\" ng-if=\"!createUser\" ng-click=\"deleteUser(user)\"><translate>Delete User</translate></button></div></div></form></div></main></div></si-page>");
$templateCache.put("hrm/hrmUsersListView.html","<si-page search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\">Users</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li class=\"active\"><strong translate=\"\">Users</strong></li></ol></header><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h3><i class=\"fa fa-users\"></i>&nbsp;<translate>Users List</translate></h3><a ui-sref=\"base.hrm-user({id: \'create\'})\" ng-if=\"isUserAllowedOnState(\'base.hrm-user\')\" class=\"btn btn-xs btn-success pull-right\" translate=\"\">Create User</a></header><div class=\"si-page__main__content\"><table class=\"table table-hover dataTable\"><thead><tr><th sort-column=\"\" sort-name=\"id\" translate=\"\">ID</th><th sort-column=\"\" sort-name=\"last_name\" translate=\"\">Last Name</th><th sort-column=\"\" sort-name=\"first_name\" translate=\"\">First Name</th><th sort-column=\"\" sort-name=\"country\" translate=\"\">Country</th><th sort-column=\"\" sort-name=\"organization\" translate=\"\">Organization</th><th sort-column=\"\" sort-name=\"email\" translate=\"\">Email</th><th sort-column=\"\" sort-name=\"has_valid_license\" translate=\"\">Licensed</th><th sort-column=\"\" sort-name=\"is_active\" translate=\"\">Active</th><th sort-column=\"\" sort-name=\"can_access_prod\" translate=\"\">Prod</th><th sort-column=\"\" sort-name=\"can_access_trainee\" translate=\"\">Trainee</th><th ng-if=\"isUserAllowedOnState(\'base.hrm-user\')\" class=\"text-center\" translate=\"\">Actions</th></tr></thead><tbody><tr ng-repeat=\"user in users.results\" style=\"cursor: pointer\" ui-sref-disabled=\"!isUserAllowedOnState(\'base.hrm-user\')\"><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.id }}</td><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.last_name }}</td><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.first_name }}</td><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.country }}</td><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.organization_name }}</td><td ui-sref=\"base.hrm-user({id: user.id})\">{{ user.email }}</td><td class=\"text-center\"><i class=\"fa\" ng-class=\"{\'fa-check\': user.has_valid_license}\"></i></td><td class=\"text-center\"><i class=\"fa\" ng-class=\"{\'fa-check\': user.is_active}\"></i></td><td class=\"text-center\"><i class=\"fa\" ng-class=\"{\'fa-check\': user.can_access_prod}\"></i></td><td class=\"text-center\"><i class=\"fa\" ng-class=\"{\'fa-check\': user.can_access_trainee}\"></i></td><td class=\"text-center\" ng-if=\"isUserAllowedOnState(\'base.hrm-user\')\"><div class=\"dropdown\" uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"><translate>Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li><a ui-sref=\"base.hrm-user({id: user.id})\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-pencil\"></i><translate>Edit</translate></a></li><li><a ng-click=\"deleteUser(user)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i><translate>Delete</translate></a></li></ul></div></td></tr></tbody></table><paginated items=\"users\" items-per-page=\"10\"></paginated></div></main></div><div class=\"si-page__search\"><search><search-filters><search-filter ng-if=\"users.filters.roles.length > 1\" name=\"{{\'User role\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"roles\" display-name=\"{{\'User role\' | translate}}\" filters=\"users.filters.roles\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"users.filters.country.length > 1\" name=\"{{\'Country\' | translate}}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"country\" display-name=\"{{\'Country\' | translate}}\" filters=\"users.filters.country\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"users.filters.organization.length > 1\" name=\"{{ \'Organization\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"organization\" display-name=\"{{ \'Organization\' | translate }}\" filters=\"users.filters.organization\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"users.filters.is_active.length > 1 && isScopeEmploye()\" name=\"{{ \'Active\' | translate }}\"><radio-button-filter search=\"search(filter, filterDisplay)\" name=\"is_active\" display-name=\"{{ \'Active\' | translate }}\" filters=\"users.filters.is_active\"></radio-button-filter></search-filter><search-filter ng-if=\"users.filters.skills.length > 1\" name=\"{{\'Skills\' | translate}}\"><dropdown-filter search=\"search(filter, filterDisplay)\" name=\"skills\" display-name=\"{{\'Skills\' | translate}}\" placeholder=\"{{\'Skills\' | translate}}\" filters=\"users.filters.skills\"></dropdown-filter></search-filter><search-filter ng-if=\"users.filters.languages_spoken.length > 1\" name=\"{{\'Languages spoken\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"languages_spoken\" display-name=\"{{\'Languages spoken\' | translate }}\" filters=\"users.filters.languages_spoken\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"users.filters.tools.length > 1\" name=\"{{\'Tools\' | translate }}\"><dropdown-checkbox-filter search=\"search(filter, filterDisplay)\" options-key=\"tools\" display-name=\"{{\'Tools\' | translate }}\" filters=\"users.filters.tools\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"users.results.length >= 1\" name=\"{{\'Expiration Date\' | translate}}\"><date-range-filter display-name=\"{{\'Expiration Date\' | translate}}\" max=\"users.filters.expiration_date.max\" min=\"users.filters.expiration_date.min\" max-name=\"max_date\" min-name=\"min_date\" search=\"search(filter, filterDisplay)\"></date-range-filter></search-filter><search-filter-choices remove-filter=\"removeFilter(filter)\" filter-options=\"users.filters\" filters=\"filters\"></search-filter-choices></search-filters></search></div></si-page>");
$templateCache.put("reports/reportsCreateView.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2 translate=\"\">Create Report</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.reports\" translate=\"\">Reports</a></li><li class=\"active\"><strong translate=\"\">New</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"row animated fadeInRight\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"file-manager\"><h5 translate=\"\">File</h5><div class=\"hr-line-dashed\"></div><div class=\"hr-line-dashed\"></div><div ng-file-drop=\"\" ng-model=\"reportFile\" class=\"drop-box\" drag-over-class=\"{accept:\'dragover\', reject:\'dragover-err\', delay:100}\" multiple=\"false\" allow-dir=\"true\"></div><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-lg-9\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 translate=\"\">Create Report</h5></div><div class=\"ibox-content\"><form class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"assessment\"><translate>Assessment</translate><small class=\"text-info\" translate=\"\">Required</small></label><div class=\"col-sm-9\"><select id=\"assessment\" data-placeholder-text-single=\"\'Select an assessment\' | translate\" ng-options=\"a.url as (\'Assessment #\' + a.id) for a in assessments.results\" ng-model=\"report.assessment\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"customer\"><translate>Customer</translate></label><div class=\"col-sm-9\"><select id=\"customer\" data-placeholder-text-single=\"\'Select a customer\' | translate\" ng-options=\"c.url as c.name for c in customers.results\" ng-model=\"report.customers\" chosen=\"\"><option value=\"\"></option></select></div></div></form><div class=\"row\"><div class=\"col-sm-12\"><a class=\"btn btn-primary pull-right\" ng-click=\"save(report)\" translate=\"\">Save</a></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("reports/reportsDetailView.html","<si-page search=\"true\" class=\"si-report-details\"><div class=\"si-page__wrapper\" ng-show=\"report\"><header class=\"si-report-details__header\"><div class=\"si-report-details__title\"><h2>{{ report.assessment.producing_organization.customer.name }}</h2><si-breadcrumbs breadcrumbs=\"breadcrumbs\"></si-breadcrumbs></div><div class=\"si-report-details__actions\"><div class=\"btn-group\" ng-class=\"{\'open\': taDropdown}\" ng-if=\"isDashboard\"><button ng-if=\"report.assessment.project.available_for_ta && isEmployee\" type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-click=\"taDropdownFunc()\">Generate Action Plan <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"taDropdown=false;downloadActionPlan(report)\" translate=\"\">General TA</a></li><li><a ng-click=\"taDropdown=false;downloadA2fPlan(report)\" translate=\"\">Access to Finance</a></li><li><a ng-click=\"taDropdown=false;AITABuilder(report)\" translate=\"\">AI TA Builder</a></li></ul></div><div class=\"btn-group\" ng-class=\"{\'open\': pdfDropdown}\"><button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-click=\"openCustomPDFModal(report)\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Custom Report <span class=\"caret\"></span></button> <button ng-show=\"true\" type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-click=\"pdfDropdown = !pdfDropdown\">PDF <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"!(report.pdf_styles.length > 1)\"><a ng-click=\"pdfDropdown=false;toPDF(report)\" translate=\"\">PDF Report</a></li><li ng-if=\"report.pdf_styles.length > 1\"><a ng-click=\"pdfDropdown=false;toPDF(report, \'classic\')\" translate=\"\">PDF Report (classic)</a></li><li ng-if=\"report.pdf_styles.length > 1\"><a ng-click=\"pdfDropdown=false;toPDF(report, \'v2\')\" translate=\"\">PDF Report (new design)</a></li><li ng-if=\"report.tool_type === \'SCOPE Basic\' && report.status === \'final\'\"><a ng-click=\"pdfDropdown=false;toSummarizedPDF(report)\" translate=\"\">Executive Summary Report</a></li><li ng-if=\"report.assessment.tool.type.has_profile\"><a ng-click=\"pdfDropdown=false;toProfilePDF(report)\" translate=\"\">PDF Profile</a></li><li ng-if=\"report.assessment.tool.type.has_summary\"><a ng-click=\"pdfDropdown=false;toExecutiveSummaryPDF(report)\" translate=\"\">Executive Summary Report</a></li><li ng-if=\"report.tool_type === \'SCOPE SACCO\'\"><a ng-click=\"pdfDropdown=false;toAmharicSummaryPDF(report)\" translate=\"\">Executive Summary Report (Amharic)</a></li></ul></div><span ng-show=\"!isDashboardUserAdmin && report.assessment.project.can_edit_assessments\"><button ng-if=\"report.assessment.can_make_reports\" ng-show=\"report.status === \'draft\'\" ng-click=\"finalizeReport(report)\" class=\"btn-primary btn\" translate=\"\">Finalize report</button><div class=\"btn-group\" ng-show=\"report.status === \'final\'\" ng-class=\"{\'open\': publishDropdown}\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\"><button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-click=\"publishDropdown = !publishDropdown\">Publish <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li class=\"p-xxs\"><input id=\"publish-report\" type=\"checkbox\" name=\"Publish PDF Report\" ng-change=\"togglePublish(\'report\')\" ng-model=\"report.report_published\"><label for=\"publish-report\" class=\"m-l-sm\">Publish PDF Report</label></li><li class=\"p-xxs\"><input id=\"publish-profile\" type=\"checkbox\" name=\"Publish PDF Report\" ng-change=\"togglePublish(\'profile\')\" ng-model=\"report.profile_published\"><label for=\"publish-profile\" class=\"m-l-sm\">Publish PDF Profile</label></li><li class=\"p-xxs\"><input id=\"publish-summary\" type=\"checkbox\" name=\"Publish PDF Report\" ng-change=\"togglePublish(\'summary\')\" ng-model=\"report.summary_published\"><label for=\"publish-summary\" class=\"m-l-sm\">Publish PDF Summary</label></li><li ng-if=\"isEmployee\"><a ng-click=\"publishDropdown=false;exportToJSON(report)\" translate=\"\">Export Assessment to JSON</a></li></ul></div><button ng-show=\"!ax_invalidated\" ng-disabled=\"report.status != \'final\'\" ng-click=\"invalidateAssessment(report)\" class=\"btn-danger btn\" translate=\"\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Invalidate</button> <button ng-show=\"ax_invalidated\" ng-disabled=\"report.status != \'final\'\" ng-click=\"validateAssessment(report)\" class=\"btn-danger btn\" translate=\"\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Revalidate</button> <button ng-click=\"reviseModal(report)\" class=\"btn-danger btn\" translate=\"\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Revise report</button> <button ng-click=\"reviseModal(report)\" class=\"btn-danger btn\" translate=\"\" ng-if=\"report.tool_type === \'SCOPE Rapid\'\">Revise rapid</button> <button ng-click=\"adminMode(report)\" ng-show=\"isEmployee\" class=\"btn-danger btn\" translate=\"\">Admin mode</button></span></div></header><main class=\"si-report-details__main\"><h3 class=\"text-center\" translate=\"\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Report Status</h3><step-circles steps=\"stepCircles\" active=\"{{activeStep}}\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\"></step-circles><ul class=\"nav nav-tabs\"><li><a ui-sref=\"base.reports-detail.summary(report.id)\"><translate>Summary</translate></a></li><li ng-show=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.dashboard-documentation(report.id)\"><translate>Documentation</translate></a></li><li ng-show=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.dashboard-attachments(report.id)\"><translate>Attachments</translate></a></li><li ng-hide=\"isDashboardUserAdmin || report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.benchmarking(report.id)\"><translate>Benchmarking</translate><span class=\"badge pull-right\">{{ report.assessment.score | number:1 }}</span></a></li><li ng-hide=\"isDashboardUserAdmin || report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.scores(report.id)\"><translate>Scores summary</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin || report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.observations(report.id)\"><translate>Observations</translate></a></li><li ng-repeat=\"item in report.assessment.section_responses.objects\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.section({id: report.id, section: item.id})\">{{ item.section_title }} <span class=\"badge pull-right\">{{ item.score | number:1 }}</span></a></li><li ng-hide=\"isDashboardUserAdmin\"><a ng-if=\"!report.assessment.tool.type.agent\" ui-sref=\"base.reports-detail.organizational(report.id)\"><translate>Organizational</translate></a> <a ng-if=\"report.assessment.tool.type.agent\" ui-sref=\"base.reports-detail.organizational(report.id)\"><translate>Agent</translate></a></li><li ng-if=\"report.assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.finance-product(report.id)\"><translate>Finance & Product</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin || report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.valuechain(report.id)\"><translate>Value Chain</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"!report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.finance(report.id)\"><translate>Finance</translate></a></li><li ng-if=\"report.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.financial-performance(report.id)\"><translate>Financial Performance</translate><span class=\"badge pull-right\" ng-bind=\"report.assessment.ratio_scores.total_score | number:1\"></span></a></li><li ng-if=\"report.assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.profit-loss(report.id)\"><translate>Profit / Loss</translate></a></li><li ng-if=\"report.assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.balancesheet(report.id)\"><translate>Balancesheet</translate></a></li><li ng-if=\"report.assessment.tool.type.pro\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.cashflow(report.id)\"><translate>Cashflow</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"!report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.production(report.id)\"><translate>Production & Sales</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.monthly-production(report.id)\"><translate>Monthly Production</translate></a></li><li ng-if=\"!report.assessment.tool.type.agent\" ng-hide=\"isDashboardUserAdmin\"><a ui-sref=\"base.reports-detail.governance(report.id)\"><translate>Governance</translate></a></li><li ng-hide=\"isDashboardUserAdmin || report.tool_type === \'SCOPE Rapid\'\"><a ui-sref=\"base.reports-detail.documentation(report.id)\"><translate>Documentation</translate></a></li><li ng-if=\"report.assessment.with_terms_and_conditions\"><a ui-sref=\"base.reports-detail.terms(report.id)\"><translate>Terms and Conditions</translate></a></li></ul><div class=\"tab-content\" ui-view=\"tabContent\"></div></main></div></si-page>");
$templateCache.put("assessments/modals/add-cost-of-sales.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add New Cost of Sales</h3></div><div class=\"modal-body\"><form name=\"form\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Cost Of Sales</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input class=\"form-control\" type=\"text\" name=\"cost\" ng-model=\"$ctrl.costOfSales\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <button class=\"btn btn-primary\" ng-click=\"$ctrl.save()\" ng-disabled=\"form.$invalid\" translate=\"\">Save</button> <button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/add-expenses.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add New Expense</h3></div><div class=\"modal-body\"><form name=\"form\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Expense</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input class=\"form-control\" type=\"text\" name=\"expenses\" ng-model=\"$ctrl.expenses\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <button class=\"btn btn-primary\" ng-click=\"$ctrl.save()\" ng-disabled=\"form.$invalid\" translate=\"\">Save</button> <button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addBankAccount.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Bank Account</h3></div><div class=\"modal-body\"><form name=\"bankAccountForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Bank</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><input type=\"text\" name=\"bank\" id=\"bank\" class=\"form-control\" ng-model=\"object.bank\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Bank type</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"type\" name=\"type\" data-placeholder-text-single=\"\'Select a bank type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.banktype_options.objects\" ng-model=\"object.bank_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Active since</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"object.active_since\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Current balance</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.current_balance\" name=\"current_balance\"></money-field></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"bankAccountForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addCapitalRequirement.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Capital Requirement</h3></div><div class=\"modal-body\"><form name=\"capitalRequirementForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Capital amount</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" name=\"capital_amount\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Share type</translate><small class=\"text-danger\" ng-show=\"capitalRequirementForm.shareType.$error.required\" translate=\"\">Required</small></label><div class=\"col-sm-8\"><select id=\"shareType\" name=\"shareType\" data-placeholder-text-single=\"\'Select a share type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.capitalrequirementssharetype_options.objects\" ng-model=\"object.share_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Status</translate><small class=\"text-danger\" ng-show=\"capitalRequirementForm.status.$error.required\" translate=\"\">Required</small></label><div class=\"col-sm-8\"><select id=\"status\" name=\"status\" data-placeholder-text-single=\"\'Select a status\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.capitalrequirementsstatus_options.objects\" ng-model=\"object.status\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Description</translate></label><div class=\"col-sm-8\"><textarea type=\"text\" name=\"description\" id=\"comment\" class=\"form-control\" ng-model=\"object.description\"></textarea></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comments</translate></label><div class=\"col-sm-8\"><textarea type=\"text\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"capitalRequirementForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addCollateralAsset.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Collateral Asset</h3></div><div class=\"modal-body\"><form name=\"collateralAssetForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Type</translate></label><div class=\"col-sm-8\"><select id=\"certification\" name=\"certification\" data-placeholder-text-single=\"\'Select a Type\' | translate\" ng-options=\"assetTypeOption.name as (assetTypeOption.display_name | capitalize) for assetTypeOption in dropdown.assettype_options.objects\" ng-model=\"object.type\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Description</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"description\" id=\"description\" class=\"form-control\" ng-model=\"object.description\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Age (years)</translate><small class=\"text-danger\" ng-show=\"loanApplicationForm.age_in_years.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"loanApplicationForm.age_in_years.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"age_in_years\" id=\"age_in_years\" class=\"form-control\" ng-model=\"object.age_in_years\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Estimated value</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><money-field ng-model=\"object.estimated_value\" min=\"0\" required=\"true\" name=\"estimated_value\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>External valuation?</translate></label><div class=\"col-sm-8\"><select id=\"external_valuation_done\" name=\"external_valuation_done\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-options=\"(external_valuation_done | translate) for external_valuation_done in external_valuation_done\" ng-model=\"object.external_valuation_done\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>External valuation by</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"external_valuation_by\" id=\"external_valuation_by\" class=\"form-control\" ng-model=\"object.external_valuation_by\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Valuation proof?</translate></label><div class=\"col-sm-8\"><input type=\"checkbox\" name=\"valuation_proof_available\" id=\"valuation_proof_available\" class=\"form-control\" ng-checked=\"object.valuation_proof_available\" ng-model=\"object.valuation_proof_available\"></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"collateralAssetForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addContact.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span translate=\"\">Add new contact to</span>&nbsp; <span ng-bind=\"customer.name | capitalize\"></span></h3></div><div class=\"modal-body\"><form name=\"contactForm\" class=\"form form-horizontal\"><h3 translate=\"\">Create/Edit a Contact</h3><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>First name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.first_name\" name=\"first_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Last name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.last_name\" name=\"last_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Position</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.position\" name=\"position\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Email</translate><small class=\"text-danger\" ng-show=\"contactForm.email.$invalid\" translate=\"\">Invalid email</small></label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" ng-model=\"contact.email\" name=\"email\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Phone Number</translate><small class=\"text-danger\" ng-show=\"contactForm.phone_number.$invalid\" translate=\"\">Invalid Number</small></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.phone_number\" name=\"phone_number\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(contact)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"contactForm.$invalid || !contactForm.$dirty\"> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("assessments/modals/addFinancialInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Financial Information</h3></div><div class=\"modal-body\"><form name=\"financialInformationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" range=\"5\" ng-model=\"object.year\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Turnover</translate><small class=\"text-danger\" ng-show=\"financialInformationForm.turnover.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.turnover\" name=\"turnover\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Cost of Sales</translate><small class=\"text-danger\" ng-show=\"financialInformationForm.cost_of_sales.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.cost_of_sales\" name=\"cost_of_sales\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Net Profit</translate><small class=\"text-danger\" ng-show=\"financialInformationForm.net_profit.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.net_profit\" name=\"net_profit\"></money-field></div></div><div class=\"form-group\" ng-if=\"assessment.tool.type.basic_sme\"><label class=\"col-sm-4 control-label\"><translate>Shareholder\'s Equity</translate><small class=\"text-danger\" ng-show=\"financialInformationForm.shareholders_equity.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.shareholders_equity\" name=\"shareholders_equity\"></money-field></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger mr\" ng-show=\"financialInformationForm.$invalid\" translate=\"\">Correct errors above</span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"financialInformationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addGovernanceStructure.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add/Edit Governance Structure</h3></div><div class=\"modal-body\"><p translate=\"\">Governance Structure Name <span class=\"text-danger\">*</span></p><input type=\"text\" class=\"form-control\" ng-model=\"object.name\"></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"add(object)\" translate=\"\" ng-disabled=\"!object.name\">Add</button></div>");
$templateCache.put("assessments/modals/addGrantHistory.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Grant History</h3></div><div class=\"modal-body\"><form name=\"grantHistoryForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" translate=\"\">Amount <span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" min=\"0\" name=\"grant_amount\" is-required=\"true\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>In Cash / In Kind</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"in_cash_in_kind\" name=\"in_cash_in_kind\" data-placeholder-text-single=\"\'Select a cash / in kind type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.cashkind_options.objects\" ng-model=\"object.in_cash_in_kind\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name of funder</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><input type=\"text\" name=\"funder\" class=\"form-control\" ng-model=\"object.funder\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Funder type</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"funder_type\" name=\"funder_type\" data-placeholder-text-single=\"\'Select a funder type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.banktype_options.objects\" ng-model=\"object.funder_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Start date</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><si-datepicker ng-model=\"object.start_date\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" translate=\"\">Purpose</label><div class=\"col-sm-8\"><input type=\"text\" name=\"purpose\" class=\"form-control\" ng-model=\"object.purpose\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" translate=\"\">Comment</label><div class=\"col-sm-8\"><textarea type=\"text\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"grantHistoryForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addIncomeFromAgent.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Income from Agent</h3></div><div class=\"modal-body\"><form name=\"IncomefromAgentForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><span class=\"text-danger\">&nbsp;*</span></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Income</translate><span class=\"text-danger\">&nbsp;*</span> <small class=\"text-danger\" ng-show=\"IncomefromAgentForm.income.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.income\" name=\"income\" required=\"\"></money-field></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger mr\" ng-show=\"IncomefromAgentForm.$invalid\" translate=\"\">Correct errors above</span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"IncomefromAgentForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addInputPurchaseInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Input Purchase Information</h3></div><div class=\"modal-body\"><form name=\"inputPurchaseForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\" ng-show=\"false\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-model=\"object.name\"></div><div class=\"col-sm-8\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a agrochemical option\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.agrochemical_options.objects\" ng-model=\"object.name\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-show=\"object.agrochemical_options==\'Other\'\"><label class=\"col-sm-4 control-label\"><translate>Other</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"other\" id=\"other\" class=\"form-control\" ng-model=\"object.other\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" last-fiscal=\"true\" range=\"2\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"inputPurchaseForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"inputPurchaseForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"object.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label> <label class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.units.$error.required\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"object.unit\" chosen=\"\" required=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label ng-if=\"!assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price per unit</translate><small class=\"text-danger\" ng-show=\"inputPurchaseForm.price.$invalid\" translate=\"\">Enter a number</small></label> <label ng-if=\"assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price</translate><small class=\"text-danger\" ng-show=\"inputPurchaseForm.price.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.price\" min=\"0\" name=\"unit_price\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent certified</translate><small class=\"text-danger\" ng-show=\"inputPurchaseForm.percent_certified.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"inputPurchaseForm.percent_certified.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"inputPurchaseForm.percent_certified.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_certified\" id=\"percent_certified\" class=\"form-control\" ng-model=\"object.percent_certified\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"inputPurchaseForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addInsurance.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Insurance</h3></div><div class=\"modal-body\"><form name=\"insuranceForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Type</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"type\" id=\"type\" class=\"form-control\" ng-model=\"object.type\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Insurance company</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"insurance_company\" id=\"insurance_company\" class=\"form-control\" ng-model=\"object.insurance_company\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Policy effective date</translate><span class=\"text-danger\">*</span> <small class=\"text-danger\" ng-show=\"insuranceForm.policy_effictive_date.$error.largerThan\" translate=\"\">Expected to be smaller than end</small></label><div class=\"col-sm-8\"><si-datepicker name=\"policy_effictive_date\" ng-model=\"object.policy_effictive_date\" larger-than=\"{{ object.policy_end_date }}\" larger-than-comparison-function=\"Date.parse\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Policy end date</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><si-datepicker name=\"policy_end_date\" ng-model=\"object.policy_end_date\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Indemnity limit</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.indemnity_limit\" name=\"indemnity_limit\" min=\"0\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comments</translate></label><div class=\"col-sm-8\"><textarea type=\"text\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"insuranceForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addLoanApplication.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Loan Application</h3></div><div class=\"modal-body\"><form name=\"loanApplicationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Loan amount</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" min=\"0\" name=\"loan_amount\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Duration (months)</translate><small class=\"text-danger\" ng-show=\"loanApplicationForm.duration_in_months.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"loanApplicationForm.duration_in_months.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"duration_in_months\" id=\"duration_in_months\" class=\"form-control\" ng-model=\"object.duration_in_months\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Potential financer</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"potential_financier\" id=\"potential_financier\" class=\"form-control\" ng-model=\"object.potential_financier\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Purpose</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"purpose\" name=\"purpose\" data-placeholder-text-single=\"\'Select a loan purpose\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.loanpurpose_options.objects\" ng-model=\"object.purpose\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Status</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"status\" id=\"status\" class=\"form-control\" ng-model=\"object.status\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comment</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"comment\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"loanApplicationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addLoanHistory.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Loan History</h3></div><div class=\"modal-body\"><form name=\"loanHistoryForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><span translate=\"\">Loan amount</span> <span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" min=\"0\" name=\"loanAmount\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><span ng-if=\"assessment.is_new_basic_tool\"><translate>Type of financier</translate></span> <span ng-if=\"!assessment.is_new_basic_tool\"><translate>Financier</translate></span> <span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"financier\" name=\"financier\" data-placeholder-text-single=\"\'Select a financier\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.banktype_options.objects\" ng-model=\"object.financier\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div ng-if=\"assessment.is_new_basic_tool\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name of financier</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"financier_name\" class=\"form-control\" ng-model=\"object.financier_name\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Start date</translate><span class=\"text-danger\">*</span> <small class=\"text-danger\" ng-show=\"loanHistoryForm.start_date.$error.largerThan\" translate=\"\">Expected to be smaller than end</small></label><div class=\"col-sm-8\"><si-datepicker name=\"start_date\" ng-model=\"object.start_date\" larger-than=\"{{ object.end_date }}\" larger-than-comparison-function=\"Date.parse\" required=\"\"></si-datepicker></div></div><div ng-if=\"!assessment.is_new_basic_tool\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>End date</translate></label><div class=\"col-sm-8\"><si-datepicker name=\"end_date\" ng-model=\"object.end_date\"></si-datepicker></div></div><div ng-if=\"assessment.is_new_basic_tool\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Duration (months)</translate><small class=\"text-danger\" ng-show=\"loanHistoryForm.duration.$error.number\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" to-fixed=\"2\" name=\"duration\" id=\"duration\" class=\"form-control\" ng-model=\"object.duration\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Annual interest rate</translate><small class=\"text-danger\" ng-show=\"loanHistoryForm.annual_interest_rate.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"loanHistoryForm.annual_interest_rate.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"loanHistoryForm.annual_interest_rate.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"annual_interest_rate\" id=\"annual_interest_rate\" class=\"form-control\" ng-model=\"object.annual_interest_rate\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Repayment status</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"repayment_status\" name=\"repayment_status\" data-placeholder-text-single=\"\'Select a repayment status\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.repaymentstatus_options.objects\" ng-model=\"object.repayment_status\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Purpose</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"loan_purpose\" name=\"loan_purpose\" data-placeholder-text-single=\"\'Select a loan purpose\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.loanpurpose_options.objects\" ng-model=\"object.purpose\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comments</translate></label><div class=\"col-sm-8\"><textarea type=\"text\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"loanHistoryForm.$invalid || object.amount.currency == \'-\'\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addLoanRequirement.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Loan Requirement</h3></div><div class=\"modal-body\"><form name=\"loanRequirementForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Loan amount</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" min=\"0\" name=\"loan_amount\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Duration (months)</translate><small class=\"text-danger\" ng-show=\"loanRequirementForm.duration_in_months.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"loanRequirementForm.duration_in_months.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"duration_in_months\" id=\"duration_in_months\" class=\"form-control\" ng-model=\"object.duration_in_months\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Expected interest rate (annual)</translate><small class=\"text-danger\" ng-show=\"loanRequirementForm.expected_annual_interest_percentage.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"loanRequirementForm.expected_annual_interest_percentage.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"loanRequirementForm.expected_annual_interest_percentage.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"expected_annual_interest_percentage\" id=\"expected_annual_interest_percentage\" class=\"form-control\" ng-model=\"object.expected_annual_interest_percentage\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Purpose</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><select id=\"loan_purpose\" name=\"loan_purpose\" data-placeholder-text-single=\"\'Select a loan purpose\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.loanpurpose_options.objects\" ng-model=\"object.purpose\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Description</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"loan_description\" id=\"loan_description\" class=\"form-control\" ng-model=\"object.description\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comment</translate></label><div class=\"col-sm-8\"><textarea name=\"accountant_comments\" id=\"accountant_comments\" class=\"form-control\" ng-model=\"object.comment\" spellcheck=\"true\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"loanRequirementForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addMarginInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Margin Information</h3></div><div class=\"modal-body\"><form name=\"marginForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Margin</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"marginForm.margin.$invalid\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><money-field ng-model=\"object.margin\" name=\"margin\"></money-field></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"marginForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addMonthlyIncomeActivity.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span ng-if=\"!object.id\" translate=\"\">Add Activity</span> <span ng-if=\"object.id\" translate=\"\">Edit Activity</span></h3></div><div class=\"modal-body\"><form name=\"activityForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" for=\"activity\"><translate>Activity</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><input type=\"text\" name=\"activity\" id=\"activity\" class=\"form-control\" ng-model=\"object.activity\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-disabled=\"activityForm.$invalid\" ng-click=\"add(object)\"><span ng-if=\"!object.id\" translate=\"\">Add Activity</span> <span ng-if=\"object.id\" translate=\"\">Save</span></button></div>");
$templateCache.put("assessments/modals/addMonthlyProductionActivity.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span ng-if=\"!object.id\" translate=\"\">Add Activity</span> <span ng-if=\"object.id\" translate=\"\">Edit Activity</span></h3></div><div class=\"modal-body\"><yes-no-bool label=\"\'Custom activity\' | translate\" label-width=\"4\" wrapper=\"row\" model=\"object.customActivity\" update-fct=\"object.activity = null; object.customActivity = model\"></yes-no-bool><form-select ng-if=\"!object.customActivity\" label=\"\'Activity\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"true\" model=\"object.activity\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.monthlyactivity_options.objects\" update-fct=\"object.activity = model\" option-value=\"display_name\"></form-select><form-input ng-if=\"object.customActivity\" label=\"\'Activity\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"true\" model=\"object.activity\" update-fct=\"object.activity = model\" type=\"text\"></form-input></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"add(object)\" ng-disabled=\"!object.activity\"><span ng-if=\"!object.id\" translate=\"\">Add Activity</span> <span ng-if=\"object.id\" translate=\"\">Save</span></button></div>");
$templateCache.put("assessments/modals/addOtherProductionPurchaseInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Production Purchase Information</h3></div><div class=\"modal-body\"><form name=\"productionOtherPurchaseInformationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" last-fiscal=\"true\" range=\"2\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"productionOtherPurchaseInformationForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionOtherPurchaseInformationForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"object.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"object.unit\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label ng-if=\"!assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price per unit</translate></label> <label ng-if=\"assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.price\" min=\"0\" name=\"price\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent certified</translate><small class=\"text-danger\" ng-show=\"productionOtherPurchaseInformationForm.percent_certified.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionOtherPurchaseInformationForm.percent_certified.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionOtherPurchaseInformationForm.percent_certified.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_certified\" id=\"percent_certified\" class=\"form-control\" ng-model=\"object.percent_certified\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"productionOtherPurchaseInformationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addPreFinanceHistory.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Pre-Finance History</h3></div><div class=\"modal-body\"><form name=\"preFinanceHistoryForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Amount</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><money-field ng-model=\"object.amount\" min=\"0\" name=\"pre_fin_amount\" is-required=\"true\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><span><translate>Type of provider</translate><label class=\"text-danger\">*</label></span></label><div class=\"col-sm-8\"><select id=\"provider\" name=\"provider\" data-placeholder-text-single=\"\'Select a provider\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.typeofprovider_options.objects\" ng-model=\"object.provider\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name of provider</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"provider_name\" class=\"form-control\" ng-model=\"object.provider_name\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Start date</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"preFinanceHistoryForm.start_date.$error.largerThan\" translate=\"\">Expected to be smaller than end</small></label><div class=\"col-sm-8\"><si-datepicker name=\"start_date\" ng-model=\"object.start_date\" larger-than=\"{{ object.end_date }}\" larger-than-comparison-function=\"Date.parse\" required=\"\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Duration (months)</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"preFinanceHistoryForm.duration.$error.number\" translate=\"\">Enter a number</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" to-fixed=\"2\" name=\"duration\" id=\"duration\" class=\"form-control\" ng-model=\"object.duration\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Annual interest rate</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"preFinanceHistoryForm.annual_interest_rate.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"preFinanceHistoryForm.annual_interest_rate.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"preFinanceHistoryForm.annual_interest_rate.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"annual_interest_rate\" id=\"annual_interest_rate\" class=\"form-control\" ng-model=\"object.annual_interest_rate\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Repayment modality</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"repayment_modality\" name=\"repayment_modality\" data-placeholder-text-single=\"\'Select a repayment status\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.repaymentmodality_options.objects\" ng-model=\"object.repayment_modality\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Purpose</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"prefinance_purpose\" name=\"prefinance_purpose\" data-placeholder-text-single=\"\'Select a loan purpose\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.prefinancepurpose_options.objects\" ng-model=\"object.purpose\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Comments</translate></label><div class=\"col-sm-8\"><textarea type=\"text\" id=\"comment\" class=\"form-control\" ng-model=\"object.comment\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"preFinanceHistoryForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addProduceSoldAgent.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Production Sales Information</h3></div><div class=\"modal-body\"><form name=\"produceSoldForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" ng-model=\"row.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"produceSoldForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"produceSoldForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"row.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"row.unit\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Price</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"row.price\" name=\"price\"></money-field></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"produceSoldForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addProductAgent.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Product</h3></div><div class=\"modal-body\"><form name=\"productForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Product</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select name=\"type\" data-placeholder-text-single=\"\'Select a product\' | translate\" ng-options=\"productOption.name as (productOption.display_name | capitalize) for productOption in dropdown.product_options.objects\" ng-model=\"product.name\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(product)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"produceSoldForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addProductInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Product Information</h3></div><div class=\"modal-body\"><form name=\"productInfoForm\" class=\"form form-horizontal\"><div class=\"form-group\" ng-if=\"!assessment.tool.type.input_retailer\"><label class=\"col-sm-6 control-label\"><translate>Product category</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><select name=\"type\" data-placeholder-text-single=\"\'Select product category\' | translate\" ng-options=\"productCategoryOption.name as (productCategoryOption.display_name | capitalize) for productCategoryOption in globalProductTypes\" ng-model=\"product.global_product_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"!assessment.tool.type.input_retailer\"><label class=\"col-sm-6 control-label\"><translate>Product name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><select name=\"type\" data-placeholder-text-single=\"\'Select a product\' | translate\" ng-options=\"productPerTypeOption.name as (productPerTypeOption.display_name | capitalize) for productPerTypeOption in getRelatedList(product.global_product_type, globalProductTypes)\" ng-model=\"product.name\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Crop importance</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a priority option\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.priority_options.objects\" ng-model=\"product.priority\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"(assessment.tool.type.input_retailer)&&(!assessment.tool.type.is_rapid)\"><label class=\"col-sm-6 control-label\"><translate>Product type</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><select name=\"type\" data-placeholder-text-single=\"\'Select product type\' | translate\" ng-options=\"productTypeOption.name as (productTypeOption.display_name | capitalize) for productTypeOption in dropdown.producttype_options.objects\" ng-model=\"product.name\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div ng-if=\"(!assessment.tool.type.input_retailer)&&(!assessment.tool.type.is_rapid)\"><div class=\"form-group\" ng-if=\"assessment.tool.type.basic_sme || assessment.tool.type.pro_sme\"><label class=\"col-sm-6 control-label\"><translate>Is the SME involved in primary production?</translate></label><div class=\"col-sm-6\"><label><input type=\"radio\" ng-model=\"product.primary_production\" ng-value=\"true\"><translate>Yes</translate></label> <label><input type=\"radio\" ng-model=\"product.primary_production\" ng-value=\"false\"><translate>No</translate></label></div></div><div ng-show=\"assessment.tool.type.basic || assessment.tool.type.pro || product.primary_production === true\"><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Estimated yearly average yield</translate><small ng-show=\"productInfoForm.average_yield.$touched && productInfoForm.average_yield.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.average_yield.$touched && productInfoForm.average_yield.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-3\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"average_yield\" id=\"average_yield\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.average_yield\"></div><div class=\"col-sm-3\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a volume unit\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.unit_options.objects\" ng-model=\"product.average_yield_unit\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>How much land is under production by the entire member base?</translate><small ng-show=\"productInfoForm.land_size_under_production.$touched && productInfoForm.land_size_under_production.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.land_size_under_production.$touched && productInfoForm.land_size_under_production.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-3\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"land_size_under_production\" id=\"land_size_under_production\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.land_size_under_production\"></div><div class=\"col-sm-3\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a volume unit\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.landunderproduction_options.objects\" ng-model=\"product.land_size_under_production_unit\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Total production by members (estimated)</translate><small ng-show=\"productInfoForm.total_prod_members.$touched && productInfoForm.total_prod_members.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.total_prod_members.$touched && productInfoForm.total_prod_members.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-3\"><input type=\"number\" string-to-number=\"\" name=\"total_prod_members\" id=\"total_prod_members\" class=\"form-control\" ng-model=\"product.total_prod_members\"></div><div class=\"col-sm-3\" style=\"line-height: 34px\"><span>{{ product.average_yield_unit | capitalize }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><div ng-if=\"!assessment.tool.type.input_retailer\"><translate>Number of production units used for production</translate></div><div ng-if=\"assessment.tool.type.input_retailer\"><translate>Land used for product</translate></div><small ng-show=\"productInfoForm.land_used_for_product.$touched && productInfoForm.land_used_for_product.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.land_used_for_product.$touched && productInfoForm.land_used_for_product.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-3\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"land_used_for_product\" id=\"land_used_for_product\" class=\"form-control\" to-fixed=\"2\" ng-model=\"product.land_used_for_product\"></div><div class=\"col-sm-3\" style=\"line-height: 34px\"><span>{{product.land_unit | capitalize}}</span></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Number of production units</translate><small ng-show=\"productInfoForm.num_production_units.$touched && productInfoForm.num_production_units.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.num_production_units.$touched && productInfoForm.num_production_units.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"num_production_units\" id=\"num_production_units\" to-fixed=\"\" class=\"form-control\" ng-model=\"product.number_of_production_units\"></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Average age of production units (yrs)</translate><small ng-show=\"productInfoForm.avg_age_production_units.$touched && productInfoForm.avg_age_production_units.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.avg_age_production_units.$touched && productInfoForm.avg_age_production_units.$error.min\" class=\"text-danger\">Excpected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"avg_age_production_units\" id=\"avg_age_production_units\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.average_age_of_production_unit\"></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Average production unit lifetime</translate><small ng-show=\"productInfoForm.avg_production_unit_lifetime.$touched && productInfoForm.avg_production_unit_lifetime.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.avg_production_unit_lifetime.$touched && productInfoForm.avg_production_unit_lifetime.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"avg_production_unit_lifetime\" id=\"avg_production_unit_lifetime\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.average_production_unit_lifetime\"></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Percent dead or diseased production units</translate><small ng-show=\"productInfoForm.perc_dead_diseased_production_units.$touched && productInfoForm.perc_dead_diseased_production_units.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.perc_dead_diseased_production_units.$touched && productInfoForm.perc_dead_diseased_production_units.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"percent_dead_diseased_production_units\" id=\"percent_dead_diseased_production_units\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.percent_dead_diseased_production_units\"></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Operational months</translate></label><div class=\"col-sm-6\"><select chosen=\"\" multiple=\"\" data-placeholder-text-single=\"\'Select a month\' | translate\" ng-options=\"month as (month | translate | capitalize) for month in months\" ng-model=\"product.operational_months\"><option value=\"\"></option></select></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Number of harvest cycles per year</translate><small ng-show=\"productInfoForm.num_harvest_cycles_per_year.$touched && productInfoForm.num_harvest_cycles_per_year.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.num_harvest_cycles_per_year.$touched && productInfoForm.num_harvest_cycles_per_year.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" name=\"num_harvest_cycles_per_year\" id=\"num_harvest_cycles_per_year\" to-fixed=\"\" class=\"form-control\" ng-model=\"product.number_of_harvest_cycles_per_year\" min=\"0\"></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Percent irrigated</translate><small ng-show=\"productInfoForm.perc_irrigated.$touched && productInfoForm.perc_irrigated.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.perc_irrigated.$touched && productInfoForm.perc_irrigated.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"perc_irrigated\" id=\"perc_irrigated\" to-fixed=\"2\" class=\"form-control\" ng-model=\"product.percent_irrigated\"></div></div></div><div class=\"form-group\" ng-if=\"!assessment.tool.type.basic_sme && !assessment.tool.type.pro_sme\"><label class=\"col-sm-6 control-label\"><translate>Part of member production sold to organization</translate><small ng-show=\"productInfoForm.est_perc_member_outgrower_production_sold_to_po.$touched && productInfoForm.est_perc_member_outgrower_production_sold_to_po.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.est_perc_member_outgrower_production_sold_to_po.$touched && productInfoForm.est_perc_member_outgrower_production_sold_to_po.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small> <small ng-show=\"productInfoForm.est_perc_member_outgrower_production_sold_to_po.$touched && productInfoForm.est_perc_member_outgrower_production_sold_to_po.$error.max\" class=\"text-danger\" translate=\"\">Expected < 100</small></label> <span class=\"col-sm-5\"><input type=\"number\" string-to-number=\"\" name=\"est_perc_member_outgrower_production_sold_to_po\" id=\"est_perc_member_outgrower_production_sold_to_po\" to-fixed=\"\" class=\"form-control\" ng-model=\"product.percent_of_members_or_outgrowers_production_sold_to_producing_organization\" min=\"0\" max=\"100\"></span> <span class=\"col-sm-1 control-label\">%</span></div></div><section ng-if=\"!assessment.tool.type.is_rapid\"><article ng-repeat=\"certification in product.certifications.objects track by $index\"><hr><button class=\"btn btn-danger\" ng-click=\"removeCertification($index)\"><i class=\"fa fa-trash\"></i></button><h3 class=\"text-center\"><translate>Certification</translate>&nbsp;- <span ng-bind=\"$index + 1\"></span></h3><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Certification</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><select id=\"certification\" name=\"certification\" data-placeholder-text-single=\"\'Select a certification type\' | translate\" ng-options=\"certificationOption.name as (certificationOption.display_name | capitalize) for certificationOption in dropdown.certification_options.objects\" ng-model=\"certification.name\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Certification start date year</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"productInfoForm.certification_start_year.$error.largerThan\" translate=\"\">Expected to be smaller or equal to end</small></label><div class=\"col-sm-6\"><year-dropdown default-range=\"true\" ng-model=\"certification.start_year\" name=\"certification_start_year\" required=\"true\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Certification end year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-6\"><year-dropdown symmetric-range=\"true\" range=\"10\" is-old-to-new=\"true\" ng-model=\"certification.end_year\" name=\"certification_end_year\" required=\"true\"></year-dropdown></div></div><div ng-if=\"!assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-6 control-label\"><translate>Percentage of crop that is certified</translate><small ng-show=\"productInfoForm.percent_certified_crop.$touched && productInfoForm.percent_certified_crop.$error.number\" class=\"text-danger\" translate=\"\">Enter a number</small> <small ng-show=\"productInfoForm.percent_certified_crop.$touched && productInfoForm.percent_certified_crop.$error.min\" class=\"text-danger\" translate=\"\">Expected > 0</small> <small ng-show=\"productInfoForm.percent_certified_crop.$touched && productInfoForm.percent_certified_crop.$error.max\" class=\"text-danger\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-6\"><input type=\"number\" string-to-number=\"\" ng-min=\"0\" ng-max=\"100\" name=\"percent_certified_crop\" id=\"percent_certified_crop\" to-fixed=\"2\" class=\"form-control\" ng-model=\"certification.percent_certified_crop\"></div></div></article><button class=\"btn btn-primary btn-block\" type=\"button\" translate=\"\" ng-click=\"addCertification()\">Add Certification</button></section><br><hr><br><span class=\"text-danger\">*<translate>fields are required</translate></span> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(product)\" ng-disabled=\"productInfoForm.$error.required || productInfoForm.$error.max || productInfoForm.$error.min\" translate=\"\">Save</button> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></form></div>");
$templateCache.put("assessments/modals/addProductionInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Production Information</h3></div><div class=\"modal-body\"><form name=\"productionInformationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"productionInformationForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionInformationForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"object.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"object.unit\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent certified</translate><small class=\"text-danger\" ng-show=\"productionInformationForm.percent_certified.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionInformationForm.percent_certified.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionInformationForm.percent_certified.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_certified\" id=\"percent_certified\" class=\"form-control\" ng-model=\"object.percent_certified\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent loss</translate><small class=\"text-danger\" ng-show=\"productionInformationForm.percent_loss.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionInformationForm.percent_loss.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionInformationForm.percent_loss.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_loss\" id=\"percent_loss\" class=\"form-control\" ng-model=\"object.percent_loss\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"Save\' | translate }}\" ng-disabled=\"productionInformationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addProductionPurchaseInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Production Purchase Information</h3></div><div class=\"modal-body\"><form name=\"productionPurchaseInformationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" last-fiscal=\"true\" range=\"2\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"object.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"object.unit\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label ng-if=\"!assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price per unit</translate></label> <label ng-if=\"assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.price\" min=\"0\" name=\"price\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent certified</translate><small class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.percent_certified.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.percent_certified.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionPurchaseInformationForm.percent_certified.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_certified\" id=\"percent_certified\" class=\"form-control\" ng-model=\"object.percent_certified\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"productionPurchaseInformationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addProductionSalesInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Production Sales Information</h3></div><div class=\"modal-body\"><form name=\"productionSalesInformationForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown future-range=\"false\" last-fiscal=\"true\" range=\"2\" ng-model=\"object.year\" required=\"\"></year-dropdown></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.volume.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.volume.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" to-fixed=\"2\" name=\"volume\" id=\"volume\" class=\"form-control\" ng-model=\"object.volume\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Volume Units</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"unit\" name=\"unit\" data-placeholder-text-single=\"\'Select a unit\' | translate\" ng-options=\"unit as unit for unit in productionUnits\" ng-model=\"object.unit\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label ng-if=\"!assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price per unit</translate></label> <label ng-if=\"assessment.tool.type.input_retailer\" class=\"col-sm-4 control-label\"><translate>Price</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.price\" name=\"price\"></money-field></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Gross margin (%)</translate><small class=\"text-danger\" ng-show=\"productionSalesInformationForm.gross_margin.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.gross_margin.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.gross_margin.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"gross_margin\" id=\"gross_margin\" class=\"form-control\" ng-model=\"object.gross_margin\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent certified</translate><small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_certified.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_certified.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_certified.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_certified\" id=\"percent_certified\" class=\"form-control\" ng-model=\"object.percent_certified\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Percent exported</translate><small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_exported.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_exported.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"productionSalesInformationForm.percent_exported.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_exported\" id=\"percent_exported\" class=\"form-control\" ng-model=\"object.percent_exported\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"productionSalesInformationForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addRepresentative.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span translate=\"\">Add new representative to</span>&nbsp; <span ng-bind=\"customer.name | capitalize\"></span></h3></div><div class=\"modal-body\"><form name=\"contactForm\" class=\"form form-horizontal\"><h3 translate=\"\">Create/Edit a Representative</h3><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>First name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.first_name\" name=\"first_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Last name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.last_name\" name=\"last_name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Position</translate></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" ng-model=\"contact.position\" name=\"position\"></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(contact)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"contactForm.$invalid || !contactForm.$dirty\"> <a class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</a></div>");
$templateCache.put("assessments/modals/addShareholder.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Principal Shareholder</h3></div><div class=\"modal-body\"><form name=\"insuranceForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-model=\"object.name\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Relation</translate></label><div class=\"col-sm-8\"><input type=\"text\" name=\"relation_to_producing_organization\" id=\"relation_to_producing_organization\" class=\"form-control\" ng-model=\"object.relation_to_producing_organization\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>% shares</translate><small class=\"text-danger\" ng-show=\"insuranceForm.percent_of_shares.$error.number\" translate=\"\">Enter a percentage</small> <small class=\"text-danger\" ng-show=\"insuranceForm.percent_of_shares.$error.min\" translate=\"\">Expected > 0</small> <small class=\"text-danger\" ng-show=\"insuranceForm.percent_of_shares.$error.max\" translate=\"\">Expected < 100</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" max=\"100\" to-fixed=\"2\" name=\"percent_of_shares\" id=\"percent_of_shares\" class=\"form-control\" ng-model=\"object.percent_of_shares\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Shareholder since</translate></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"object.shareholder_since_year\"></year-dropdown></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"insuranceForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/addSoldToFarmersInfo.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Sales to Farmers</h3></div><div class=\"modal-body\"><form name=\"soldToFarmersForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Product Type</translate></label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" ng-model=\"product.display_name\" disabled=\"\"></div></div><div class=\"form-group\" ng-if=\"getDropdown(product.name).length\"><label class=\"col-sm-4 control-label\"><translate>Product Sub-Type</translate></label><div class=\"col-sm-6\"><select name=\"type\" data-placeholder-text-single=\"\'Select product sub-type\' | translate\" ng-options=\"essentialsOption.name as (essentialsOption.display_name | capitalize) for essentialsOption in getDropdown(product.name)\" ng-model=\"object.product_subtype\" ng-required=\"getDropdown(product.name).length\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Product Specification</translate><br><translate>(e.g. brand, product name, variety, etc)</translate></label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"object.specification\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Sales Amount</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"object.sales_amount\" name=\"sales_amount\"></money-field></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Sales Trend</translate></label><div class=\"col-sm-6\"><select name=\"type\" data-placeholder-text-single=\"\'Select an option\' | translate\" ng-options=\"salesTrendOption.name as (salesTrendOption.display_name | capitalize) for salesTrendOption in dropdown.salestrend_options.objects\" ng-model=\"object.sales_trend\" chosen=\"\"><option value=\"\"></option></select></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(object)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"soldToFarmersForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/assessmentDetailModal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Quality Control Comment</h3></div><div class=\"modal-body\"><form-input label=\"\'Project\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.project.name\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Assessee\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_name\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Assessee ID\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_customer_id\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Date\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.date | date:\'dd-MM-yyyy\'\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Language\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.language | language\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Status\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.display_status | capitalize\" type=\"text\" disabled=\"true\"></form-input><form-input label=\"\'Last status update\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.last_status_update | date: \'dd-MM-yyyy, HH:mm\'\" type=\"text\" disabled=\"true\"></form-input><div class=\"row\"><div class=\"col-md-3\"><b translate=\"\">Assessors</b></div><div class=\"col-md-9\"><div class=\"well\" ng-if=\"assessment.assignments.length === 0\">No assessor assigned</div><div ng-repeat=\"assignment in assessment.assignments\" ng-if=\"assignment.type === \'assignment\' && assignment.assigned_as==\'assessor\'\">{{assignment.name}}</div></div><br><div ng-if=\"assessment.tool_type == \'SCOPE Pro\' || assessment.tool_type == \'SCOPE Pro SME\'\"><div class=\"col-md-3\"><b translate=\"\">Finacial Specialist</b></div><div class=\"col-md-9\"><div class=\"well\" ng-if=\"assessment.assignments.length === 0\">No assessor assigned</div><div ng-repeat=\"assignment in assessment.assignments\" ng-if=\"assignment.type === \'assignment\' && assignment.assigned_as==\'financial_specialist\'\">{{assignment.name}}</div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Close</button></div>");
$templateCache.put("assessments/modals/commentModal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Assessment Question Comment</h3></div><div class=\"modal-body\"><p></p><textarea class=\"form-control\" ng-model=\"comment\" style=\"resize: vertical; min-height: 200px\"></textarea></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok()\" translate=\"\">Comment</button></div>");
$templateCache.put("assessments/modals/editValueChainPlayer.html","<div class=\"modal-header\"><h3 class=\"modal-title\" ng-if=\"player.id\" translate=\"\">Edit Entry</h3><h3 class=\"modal-title\" ng-if=\"!player.id\" translate=\"\">Add New Entry</h3></div><div class=\"modal-body\"><form name=\"valueChainPlayerForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a client\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.client_options.objects\" ng-model=\"player.customer\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"player.customer==\'OTHER\'\"><label class=\"col-sm-4 control-label\"><translate>Other</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"other\" id=\"other\" class=\"form-control\" ng-model=\"player.other\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" ng-if=\"!assessment.tool.type.input_retailer\"><translate>Organizational type</translate><label class=\"text-danger\">*</label></label> <label class=\"col-sm-4 control-label\" ng-if=\"assessment.tool.type.input_retailer\"><translate>Type of supplier</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"type\" name=\"type\" data-placeholder-text-single=\"\'Select customer type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.customertype_options.objects\" ng-model=\"player.customer_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div ng-if=\"assessment.tool.type.input_retailer\"><h3 translate=\"\">Relation with supplier</h3></div><div class=\"form-group\" ng-if=\"!assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Type of service</translate></label><div class=\"col-sm-8\"><select name=\"type\" data-placeholder-text-single=\"\'Select relation type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in relationdropdown\" ng-model=\"player.relation_to_producing_organization\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Number years in relation</translate><small class=\"text-danger\" ng-show=\"valueChainPlayerForm.number_of_years_in_relation.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"valueChainPlayerForm.number_of_years_in_relation.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"number_of_years_in_relation\" id=\"number_of_years_in_relation\" class=\"form-control\" ng-model=\"player.number_of_years_in_relation\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contract in place</translate></label><div class=\"col-sm-8\"><label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'Yes\'\" ng-required=\"!player.contract_in_place\"><translate>Yes</translate></label> <label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'No\'\" ng-required=\"!player.contract_in_place\"><translate>No</translate></label> <label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'In Process\'\" ng-required=\"!player.contract_in_place\"><translate>In Process</translate></label></div></div><div class=\"form-group\" ng-show=\"player.contract_in_place == \'Yes\'\"><label class=\"col-sm-4 control-label\"><translate>Contract start year</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"valueChainPlayerForm.contract_start_year.$error.largerThan\" translate=\"\">Expected to be smaller than end</small></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"player.contract_start_year\" ng-required=\"player.contract_in_place == \'Yes\'\"></year-dropdown></div></div><div class=\"form-group\" ng-show=\"player.contract_in_place == \'Yes\'\"><label class=\"col-sm-4 control-label\"><translate>Contract end year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown symmetric-range=\"true\" range=\"10\" is-old-to-new=\"true\" ng-model=\"player.contract_end_year\" ng-required=\"player.contract_in_place == \'Yes\'\"></year-dropdown></div></div><div class=\"form-group\" ng-if=\"assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Payment method</translate></label><div class=\"col-sm-8\"><select id=\"type\" name=\"type\" data-placeholder-text-single=\"\'Select payment method\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.paymentmethod_options.objects\" ng-model=\"player.payment_method\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" translate=\"\">Description of agreement/relation</label><div class=\"col-sm-8\"><textarea id=\"description_of_agreement\" class=\"form-control\" ng-model=\"player.description_of_agreement\">\n                </textarea></div></div><div class=\"form-group\" ng-if=\"assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Amount purchased in most recent full year</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"player.amount_purchased\" name=\"amount_purchased\" min=\"0\"></money-field></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Product types purchased</translate></label><div class=\"col-sm-8\" style=\"padding-left: 35px;\"><label class=\"checkbox\" ng-repeat=\"checkbox in productTypes\"><input type=\"checkbox\" name=\"checkbox\" ng-value=\"checkbox\" ng-click=\"addUrlToProductTypes(checkbox)\" ng-checked=\"isChecked(checkbox.url)\"> <span ng-bind=\"checkbox.display_name\"></span></label></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(player)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"valueChainPlayerForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/editValueChainPlayerSupportingOrganization.html","<div class=\"modal-header\"><h3 class=\"modal-title\" ng-if=\"player.id\" translate=\"\">Edit Entry</h3><h3 class=\"modal-title\" ng-if=\"!player.id\" translate=\"\">Add New Entry</h3></div><div class=\"modal-body\"><form name=\"valueChainPlayerForm\" class=\"form form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Name</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"average_yield_unit\" name=\"average_yield_unit\" data-placeholder-text-single=\"\'Select a client\' | translate\" ng-options=\"UnitOption.name as (UnitOption.display_name | capitalize) for UnitOption in dropdown.serviceprovider_options.objects\" ng-model=\"player.customer\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-if=\"player.customer==\'OTHER\'\"><label class=\"col-sm-4 control-label\"><translate>Other</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><input type=\"text\" name=\"other\" id=\"other\" class=\"form-control\" ng-model=\"player.other\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" ng-if=\"!assessment.tool.type.input_retailer\"><translate>Organizational type</translate><label class=\"text-danger\">*</label></label> <label class=\"col-sm-4 control-label\" ng-if=\"assessment.tool.type.input_retailer\"><translate>Type of supplier</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><select id=\"type\" name=\"type\" data-placeholder-text-single=\"\'Select customer type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.customertype_options.objects\" ng-model=\"player.customer_type\" required=\"\" chosen=\"\"><option value=\"\"></option></select></div></div><div ng-if=\"assessment.tool.type.input_retailer\"><h3 translate=\"\">Relation with supplier</h3></div><div class=\"form-group\" ng-if=\"!assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Type of service</translate></label><div class=\"col-sm-8\"><select name=\"type\" data-placeholder-text-single=\"\'Select relation type\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in relationdropdown\" ng-model=\"player.relation_to_producing_organization\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Number years in relation</translate><small class=\"text-danger\" ng-show=\"valueChainPlayerForm.number_of_years_in_relation.$error.number\" translate=\"\">Enter a number</small> <small class=\"text-danger\" ng-show=\"valueChainPlayerForm.number_of_years_in_relation.$error.min\" translate=\"\">Expected > 0</small></label><div class=\"col-sm-8\"><input type=\"number\" string-to-number=\"\" min=\"0\" name=\"number_of_years_in_relation\" id=\"number_of_years_in_relation\" class=\"form-control\" ng-model=\"player.number_of_years_in_relation\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Contract in place</translate></label><div class=\"col-sm-8\"><label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'Yes\'\"><translate>Yes</translate></label> <label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'No\'\"><translate>No</translate></label> <label><input type=\"radio\" ng-model=\"player.contract_in_place\" ng-value=\"\'In Process\'\"><translate>In Process</translate></label></div></div><div class=\"form-group\" ng-show=\"player.contract_in_place == \'Yes\'\"><label class=\"col-sm-4 control-label\"><translate>Contract start year</translate><label class=\"text-danger\">*</label> <small class=\"text-danger\" ng-show=\"valueChainPlayerForm.contract_start_year.$error.largerThan\" translate=\"\">Expected to be smaller than end</small></label><div class=\"col-sm-8\"><year-dropdown default-range=\"true\" ng-model=\"player.contract_start_year\" ng-required=\"player.contract_in_place == \'Yes\'\"></year-dropdown></div></div><div class=\"form-group\" ng-show=\"player.contract_in_place == \'Yes\'\"><label class=\"col-sm-4 control-label\"><translate>Contract end year</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-8\"><year-dropdown symmetric-range=\"true\" range=\"10\" is-old-to-new=\"true\" ng-model=\"player.contract_end_year\" ng-required=\"player.contract_in_place == \'Yes\'\"></year-dropdown></div></div><div class=\"form-group\" ng-if=\"assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Payment method</translate></label><div class=\"col-sm-8\"><select id=\"type\" name=\"type\" data-placeholder-text-single=\"\'Select payment method\' | translate\" ng-options=\"s.name as (s.display_name | capitalize) for s in dropdown.paymentmethod_options.objects\" ng-model=\"player.payment_method\" chosen=\"\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\" translate=\"\">Description of agreement/relation</label><div class=\"col-sm-8\"><textarea id=\"description_of_agreement\" class=\"form-control\" ng-model=\"player.description_of_agreement\">\n                </textarea></div></div><div class=\"form-group\" ng-if=\"assessment.tool.type.input_retailer\"><label class=\"col-sm-4 control-label\"><translate>Amount purchased in most recent full year</translate></label><div class=\"col-sm-8\"><money-field ng-model=\"player.amount_purchased\" name=\"amount_purchased\" min=\"0\"></money-field></div></div><div ng-if=\"assessment.tool.type.input_retailer\" class=\"form-group\"><label class=\"col-sm-4 control-label\"><translate>Product types purchased</translate></label><div class=\"col-sm-8\" style=\"padding-left: 35px;\"><label class=\"checkbox\" ng-repeat=\"checkbox in productTypes\"><input type=\"checkbox\" name=\"checkbox\" ng-value=\"checkbox\" ng-click=\"addUrlToProductTypes(checkbox)\" ng-checked=\"isChecked(checkbox.url)\"> <span ng-bind=\"checkbox.display_name\"></span></label></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(player)\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"valueChainPlayerForm.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/ratingModal.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Assessor Performance Rating</h3></div><div class=\"modal-body performance-rating-modal\"><style>\n        .performance-rating-modal .pr-info {\n            border: 1px solid #d1dade;\n            background: #f3f6fb;\n            border-radius: 4px;\n            padding: 12px 15px;\n            margin-bottom: 18px;\n            font-size: 13px;\n        }\n        .performance-rating-modal .pr-criterion {\n            border: 1px solid #e7eaec;\n            border-radius: 4px;\n            padding: 15px;\n            margin-bottom: 12px;\n        }\n        .performance-rating-modal .pr-criterion-title {\n            font-weight: 600;\n            margin: 0 0 4px;\n        }\n        .performance-rating-modal .pr-criterion-desc {\n            color: #676a6c;\n            font-size: 12px;\n            margin: 0;\n        }\n        .performance-rating-modal .pr-guide {\n            font-size: 11px;\n            color: #676a6c;\n            line-height: 1.6;\n        }\n        .performance-rating-modal .pr-guide b { color: #333; }\n        .performance-rating-modal .pr-scale {\n            display: flex;\n            border: 1px solid #1ab394;\n            border-radius: 4px;\n            overflow: hidden;\n            max-width: 260px;\n        }\n        .performance-rating-modal .pr-scale .pr-step {\n            flex: 1;\n            text-align: center;\n            padding: 8px 0;\n            cursor: pointer;\n            background: #fff;\n            border-right: 1px solid #1ab394;\n            font-weight: 600;\n            color: #1ab394;\n            user-select: none;\n            transition: .12s ease;\n        }\n        .performance-rating-modal .pr-scale .pr-step:last-child { border-right: 0; }\n        .performance-rating-modal .pr-scale .pr-step:hover { background: #e8f7f3; }\n        .performance-rating-modal .pr-scale .pr-step.pr-active {\n            background: #1ab394;\n            color: #fff;\n        }\n        .performance-rating-modal .pr-scale-labels {\n            display: flex;\n            justify-content: space-between;\n            max-width: 260px;\n            font-size: 10px;\n            color: #999;\n            margin-top: 4px;\n        }\n        .performance-rating-modal .pr-auto-card {\n            background: #f8fbff;\n            border: 1px solid #e7eaec;\n            border-radius: 4px;\n            padding: 10px 14px;\n        }\n        .performance-rating-modal .pr-auto-value {\n            font-size: 20px;\n            font-weight: 700;\n            color: #1ab394;\n        }\n        .performance-rating-modal .pr-auto-note { font-size: 11px; color: #676a6c; }\n        .performance-rating-modal .pr-badge {\n            display: inline-block;\n            background: #eef4ff;\n            color: #2f5daa;\n            border-radius: 10px;\n            padding: 1px 8px;\n            font-size: 10px;\n            font-weight: 600;\n            margin-top: 3px;\n        }\n        .performance-rating-modal .pr-preview {\n            border: 1px solid #1ab394;\n            background: #f2fbf8;\n            border-radius: 4px;\n            padding: 14px;\n            text-align: center;\n        }\n        .performance-rating-modal .pr-preview-score {\n            font-size: 28px;\n            font-weight: 800;\n            color: #128a72;\n            margin: 2px 0;\n        }\n        .performance-rating-modal .pr-preview-sub { font-size: 11px; color: #676a6c; }\n        .performance-rating-modal .pr-required { color: #ed5565; }\n    </style><form name=\"ratingForm\"><div class=\"pr-info\"><strong translate=\"\">Rate the criteria from 1 (Unsatisfactory) to 5 (Excellent).</strong><div translate=\"\">The final score is the average of the five criteria, rounded to one decimal place. QC rounds and response timeliness are calculated automatically.</div></div><div class=\"pr-criterion row\"><div class=\"col-sm-4\"><p class=\"pr-criterion-title\" translate=\"\">1. QC Rounds</p><p class=\"pr-criterion-desc\" translate=\"\">Automatically scored from the number of QC rounds recorded for the assessment.</p></div><div class=\"col-sm-4\"><div class=\"pr-auto-card\"><div class=\"pr-auto-value\">{{ evaluation.qc_rounds_score }} / 5</div><div class=\"pr-auto-note\"><span translate=\"\">Based on</span> {{ evaluation.qc_rounds || 0 }} <span translate=\"\">QC round(s)</span></div><span class=\"pr-badge\" translate=\"\">Recorded automatically</span></div></div><div class=\"col-sm-4 pr-guide\"><div><b>5:</b> <span translate=\"\">0-1 QC rounds</span></div><div><b>4:</b> <span translate=\"\">2 QC rounds</span></div><div><b>3:</b> <span translate=\"\">3 QC rounds</span></div><div><b>2:</b> <span translate=\"\">4 QC rounds</span></div><div><b>1:</b> <span translate=\"\">5+ QC rounds</span></div></div></div><div class=\"pr-criterion row\"><div class=\"col-sm-4\"><p class=\"pr-criterion-title\"><span translate=\"\">2. Incorporation of QC Feedback</span> <span class=\"pr-required\">*</span></p><p class=\"pr-criterion-desc\" translate=\"\">How well the assessor incorporated QC feedback.</p></div><div class=\"col-sm-4\"><div class=\"pr-scale\"><div class=\"pr-step\" ng-repeat=\"n in [1,2,3,4,5]\" ng-class=\"{\'pr-active\': evaluation.incorporation_of_qc_feedback === n}\" ng-click=\"evaluation.incorporation_of_qc_feedback = n\">{{ n }}</div></div><div class=\"pr-scale-labels\"><span translate=\"\">Unsatisfactory</span><span translate=\"\">Excellent</span></div></div><div class=\"col-sm-4 pr-guide\"><div><b>5:</b> <span translate=\"\">Not applicable, correct from the start</span></div><div><b>4:</b> <span translate=\"\">Fully incorporates feedback</span></div><div><b>3:</b> <span translate=\"\">Incorporates properly but partially</span></div><div><b>2:</b> <span translate=\"\">Partially or inconsistently</span></div><div><b>1:</b> <span translate=\"\">Ignores QC feedback</span></div></div></div><div class=\"pr-criterion row\"><div class=\"col-sm-4\"><p class=\"pr-criterion-title\" translate=\"\">3. Response Timeliness</p><p class=\"pr-criterion-desc\" translate=\"\">Automatically scored from the assessor\'s response time to QC feedback (business days).</p></div><div class=\"col-sm-4\"><div class=\"pr-auto-card\"><div class=\"pr-auto-value\"><span ng-if=\"timelinessMeasured()\">{{ evaluation.response_timeliness_score }} / 5</span> <span ng-if=\"!timelinessMeasured()\" translate=\"\">n/a</span></div><div class=\"pr-auto-note\"><span ng-if=\"evaluation.response_business_days !== null && evaluation.response_business_days !== undefined\"><span translate=\"\">Avg</span> {{ evaluation.response_business_days }} <span translate=\"\">business day(s)</span></span><span ng-if=\"!timelinessMeasured() && !hadQcRounds()\" translate=\"\">No QC round required</span> <span ng-if=\"!timelinessMeasured() && hadQcRounds()\" translate=\"\">Response time not recorded - excluded from the score</span></div><span class=\"pr-badge\" translate=\"\">Recorded automatically</span></div></div><div class=\"col-sm-4 pr-guide\"><div><b>5:</b> <span translate=\"\">No QC round or &le;2 business days</span></div><div><b>4:</b> <span translate=\"\">&le;3 business days</span></div><div><b>3:</b> <span translate=\"\">&le;5 business days</span></div><div><b>2:</b> <span translate=\"\">&le;7 business days</span></div><div><b>1:</b> <span translate=\"\">&gt;7 business days</span></div></div></div><div class=\"pr-criterion row\"><div class=\"col-sm-4\"><p class=\"pr-criterion-title\"><span translate=\"\">4. Quality of Notes / Context / Evidence</span> <span class=\"pr-required\">*</span></p><p class=\"pr-criterion-desc\" translate=\"\">Quality and depth of notes, context and supporting evidence.</p></div><div class=\"col-sm-4\"><div class=\"pr-scale\"><div class=\"pr-step\" ng-repeat=\"n in [1,2,3,4,5]\" ng-class=\"{\'pr-active\': evaluation.notes_context_evidence_score === n}\" ng-click=\"evaluation.notes_context_evidence_score = n\">{{ n }}</div></div><div class=\"pr-scale-labels\"><span translate=\"\">Unsatisfactory</span><span translate=\"\">Excellent</span></div></div><div class=\"col-sm-4 pr-guide\"><div><b>5:</b> <span translate=\"\">Detailed, rich context and evidence</span></div><div><b>4:</b> <span translate=\"\">Clear notes, sufficient evidence</span></div><div><b>3:</b> <span translate=\"\">Limited context, minimal evidence</span></div><div><b>2:</b> <span translate=\"\">Superficial or insufficient</span></div><div><b>1:</b> <span translate=\"\">Missing or very poor</span></div></div></div><div class=\"pr-criterion row\"><div class=\"col-sm-4\"><p class=\"pr-criterion-title\"><span translate=\"\">5. Accuracy / Completeness</span> <span class=\"pr-required\">*</span></p><p class=\"pr-criterion-desc\" translate=\"\">Accuracy of information and completeness of answers and comments.</p></div><div class=\"col-sm-4\"><div class=\"pr-scale\"><div class=\"pr-step\" ng-repeat=\"n in [1,2,3,4,5]\" ng-class=\"{\'pr-active\': evaluation.accuracy_completeness_score === n}\" ng-click=\"evaluation.accuracy_completeness_score = n\">{{ n }}</div></div><div class=\"pr-scale-labels\"><span translate=\"\">Unsatisfactory</span><span translate=\"\">Excellent</span></div></div><div class=\"col-sm-4 pr-guide\"><div><b>5:</b> <span translate=\"\">Accurate and comprehensive</span></div><div><b>4:</b> <span translate=\"\">Minor errors only</span></div><div><b>3:</b> <span translate=\"\">Some errors or data gaps</span></div><div><b>2:</b> <span translate=\"\">Significant errors or missing data</span></div><div><b>1:</b> <span translate=\"\">Major errors, missing answers/comments</span></div></div></div><div class=\"row\" style=\"margin-top: 6px;\"><div class=\"col-sm-8\"><label translate=\"\">Main Issue Identified</label> <span class=\"pr-required\">*</span><p class=\"pr-criterion-desc\" translate=\"\">What was the primary issue with this assessment?</p><select class=\"form-control\" name=\"mainIssue\" ng-model=\"evaluation.main_issue_identified\" ng-options=\"option.value as (option.label | translate) for option in mainIssueOptions\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">{{ \'Select an issue\' | translate }}</option></select></div></div><div class=\"row\" style=\"margin-top: 12px;\" ng-if=\"evaluation.main_issue_identified === \'other\'\"><div class=\"col-sm-8\"><label><span translate=\"\">Additional Comments</span> <small class=\"text-muted\">(<span translate=\"\">required for Other</span>)</small></label> <textarea class=\"form-control\" name=\"additionalComments\" maxlength=\"500\" ng-model=\"evaluation.additional_comments\" ng-required=\"evaluation.main_issue_identified === \'other\'\" placeholder=\"{{ \'Please describe the main issue identified...\' | translate }}\"></textarea></div></div><div class=\"row\" style=\"margin-top: 16px;\"><div class=\"col-sm-4 col-sm-offset-4\"><div class=\"pr-preview\"><div translate=\"\">Final Score Preview</div><div class=\"pr-preview-score\"><span ng-if=\"isComplete()\">{{ previewScore() }} / 5</span> <span ng-if=\"!isComplete()\">&mdash; / 5</span></div><div class=\"pr-preview-sub\" ng-if=\"isComplete() && timelinessMeasured()\" translate=\"\">This score will be saved with the assessment.</div><div class=\"pr-preview-sub\" ng-if=\"isComplete() && !timelinessMeasured()\" translate=\"\">Averaged over four criteria - response time could not be measured.</div><div class=\"pr-preview-sub\" ng-if=\"!isComplete()\" translate=\"\">Rate all manual criteria to calculate the score.</div></div></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"submit(evaluation)\" value=\"{{ \'Save & Continue\' | translate }}\" ng-disabled=\"ratingForm.$invalid || !isComplete()\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("assessments/modals/transferAssessments.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span translate=\"\">Transfer Assessments</span></h3></div><div class=\"modal-body\"><div ng-if=\"selected.length\" ng-repeat=\"project in projects\"><h3 translate=\"\">Current Project</h3><p ng-bind=\"project.name\"></p><div ng-if=\"s.assessment.project.id === project.id\" ng-repeat=\"s in selected\" ng-style=\"{marginBottom:\'20px\' }\"><div><h3 translate=\"\">Assessment information</h3><p>{{s.assessment.producing_organization_name}} - {{s.assessment.date | date: \'dd-MM-yyyy\' }} - {{s.assessment.tool_name}}.{{s.assessment.tool_version_major}}.{{s.assessment.tool_version_minor}}.{{s.assessment.tool_version_revision}}</p><select name=\"project\" data-placeholder-text-single=\"\'Select a new project\' | translate\" ng-options=\"project.url as (project.name) for project in allProjects\" ng-model=\"s.new_project\" chosen=\"\"><option></option></select></div></div><hr></div><div ng-if=\"!selected.length\"><h4 translate=\"\">No assessments have been selected for transfer.</h4></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button ng-if=\"selected.length\" class=\"btn btn-primary\" ng-click=\"save()\"><span translate=\"\">Save</span></button></div>");
$templateCache.put("assessments/partials/assessmentTabView.html","<form name=\"assessmentForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.assessment_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"assessment_tab_accepted\" is-completed=\"assessment_tab_completed\" is-disabled=\"assessmentForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Assessment\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"assessmentForm.$invalid\" is-completed=\"assessment_tab_completed\" is-form-completed=\"assessmentForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Tool</translate>:</strong></div><div class=\"col-sm-9\">{{ assessment.tool_name | capitalize }}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Version</translate>:</strong></div><div class=\"col-sm-9\">v{{ assessment.tool_version_major }}.{{ assessment.tool_version_minor }}.{{ assessment.tool_version_revision }}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Planned assessment date</translate>:</strong></div><div class=\"col-sm-9\">{{ assessment.date | date: \'dd-MM-yyyy\'}}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Assessee ID</translate>:</strong></div><div class=\"col-sm-9\">{{ assessment.producing_organization.customer.id }}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Assessment ID</translate>:</strong></div><div class=\"col-sm-9\">{{ assessment.id }}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>SCOPE ID</translate>:</strong></div><div class=\"col-sm-9\">{{ assessment.producing_organization.scope_id }}</div></div><div class=\"row\"><div class=\"col-sm-3\"><strong><translate>Count of submissions to the assessor</translate>:</strong></div><div class=\"col-sm-9\" ng-if=\"counter_QR_to_assessor\">{{ counter_QR_to_assessor }}</div><div id=\"qc_counter\" class=\"col-sm-9\" ng-if=\"!counter_QR_to_assessor\">{{ assessment.counter_QR_to_assessor }}</div></div></div><div class=\"col-md-8\"><dl class=\"dl-horizontal dl-small\"><h5 translate=\"\">Assignments</h5><table class=\"table table-hover table-bordered\"><thead><tr><th translate=\"\">Assessor</th><th translate=\"\">Planned assessment date</th><th translate=\"\" ng-if=\"assessment.tool_name === \'SCOPE Rapid\'\">Finalization Date</th></tr></thead><tbody><tr style=\"cursor: pointer;\" ui-sref=\"base.hrm-assessors-detail({ id: assignment.assessor_id })\" ng-repeat=\"assignment in assessment.assessmentassignments.objects\" ng-class=\"{\'active\': assignment.id == $state.params.id}\"><td>{{ assignment.assessor.user | username }}</td><td>{{ assignment.deadline | date: \'dd-MM-yyyy\'}}</td><td ng-if=\"assessment.tool_name === \'SCOPE Rapid\'\">{{ assessment.rapid_finalization_date }}</td></tr></tbody></table></dl></div></div><br><hr><br><div class=\"row\"><div class=\"col-md-3\" ng-if=\"shouldShowSection(\'assessment_tab.purposes\') && !assessment.tool.type.is_rapid\"><form-checkboxes heading=\"\'Purpose of Assessment\' | translate\" form-name=\"purposes\" required=\"true\" checkboxes=\"purposes.results\" info-text-key=\"info_assessment_tab_purpose_of_assessment\" assessment=\"assessment\" checked-items=\"assessment.purposes.objects\" is-valid=\"assessment.purposes.objects.length\" should-validate=\"(assessment.assessment_tab_accepted && !assignment.submitted_at_least_once) || (!assessment.assessment_tab_accepted && assignment.submitted_at_least_once)\" show-error=\"showTabWarnings\" update-fct=\"toggleChecklist({url}, assessment.purposes.objects, \'purposes\', assessment.url)\"></form-checkboxes></div><div class=\"col-md-4\"><form-input label=\"\'Assessment start date\' | translate\" label-size=\"large\" is-date=\"true\" form-name=\"startDate\" required=\"true\" info-text-key=\"info_assessment_tab_assessment_start_date\" assessment=\"assessment\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment, \'start_date\', model, {assessmentForm: assessmentForm})\" model=\"assessment.start_date\" date-options=\"{initDate: assessment.date}\"></form-input><form-textarea ng-if=\"shouldShowSection(\'assessment_tab.description\')\" label=\"\'Assessee Background\' | translate\" label-size=\"large\" info-text-key=\"info_assessment_tab_assessee_background\" assessment=\"assessment\" name=\"description\" required=\"true\" update-fct=\"updateFormElement(assessment.producing_organization, \'description\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization.description\"></form-textarea></div><div class=\"col-md-5\"><form-textarea label=\"\'Representatives Present and Positions\' | translate\" label-size=\"large\" ng-if=\"!assessment.is_new_basic_tool\" ng-disabled=\"!assessment.is_new_basic_tool\" info-text-key=\"info_assessment_tab_representatives_present_and_positions\" assessment=\"assessment\" form-name=\"present_representatives\" required=\"true\" update-fct=\"updateFormElement(assessment, \'present_representatives\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.present_representatives\"></form-textarea><div ng-if=\"assessment.is_new_basic_tool\"><si-info-text-display ng-if=\"assessment.tool.type.input_retailer\" assessment=\"assessment\" key=\"info_assessment_tab_staff_present_and_positions\"><h3 class=\"m-b-md\" translate=\"\">Staff Present and Positions</h3></si-info-text-display><si-info-text-display ng-if=\"!assessment.tool.type.input_retailer\" assessment=\"assessment\" key=\"info_assessment_tab_representatives_present_and_positions\"><h3 class=\"m-b-md\" translate=\"\">Representatives Present and Positions</h3></si-info-text-display><si-contacts is-organization-tab=\"false\" contacts=\"assessment.producing_organization.customer.representatives\" add-contact=\"addRepresentative(contact)\" edit-contact=\"editRepresentative(contact)\" delete-contact=\"deleteRepresentative(contact)\"></si-contacts></div></div></div><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on assessment\' | translate\" label-size=\"large\" info-text-key=\"info_assessment_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_assessment\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_assessment\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_assessment\', assessment.assessor_comments_assessment, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></div></form>");
$templateCache.put("assessments/partials/balanceSheetTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><form name=\"balanceSheetForm\" class=\"above-seperator\" form-to-tab-validator=\"\" is-accepted=\"assessment.balancesheet_tab_accepted\" assessment=\"assessment\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchFinancialTab(name, value, \'balance_sheet_tab_completed\')\" is-accepted=\"balance_sheet_tab_accepted\" is-completed=\"balance_sheet_tab_completed\" is-disabled=\"balanceSheetForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Balance Sheet\" assessment=\"assessment\" reopen-text=\"{{ financialTabs.reopenText }}\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"balanceSheetForm.$invalid\" is-completed=\"balance_sheet_tab_completed\" is-form-completed=\"balanceSheetForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><input type=\"checkbox\" ng-show=\"false\" required=\"\" name=\"hidden\" ng-model=\"assessment.balance_sheet_tab_completed\" ng-checked=\"assessment.balance_sheet_tab_completed\"> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.full_completion_check_required\" ng-click=\"markBalanceSheetTabDone(\'balance_sheet_tab_completed\')\" ng-disabled=\"!canConfirm()\"><translate>Completed</translate><span ng-if=\"assessment.balance_sheet_tab_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button><fieldset ng-disabled=\"assessment.balance_sheet_tab_completed\"><div class=\"top-buttons\"><div class=\"top-buttons__heading\"><si-info-text-display assessment=\"assessment\" key=\"info_balance_sheet_tab_main\"><h3 class=\"p-t\" translate=\"\">Balance Sheet</h3></si-info-text-display><h4 class=\"label label-primary\" translate=\"\">Maximum of 5 years and minimum of 3 years allowed.</h4></div><div class=\"top-buttons__actions\"><span><translate>Selected Currency:&nbsp;</translate><span ng-bind=\"global_currency\"></span></span></div></div><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Assets</th><th style=\"width: 150px;\" ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"setYear(item.year)\"></span></th></tr><tr><th translate=\"\">No Data</th><th style=\"width: 150px\" ng-repeat=\"bs in assessment.balancesheets.objects\"><input type=\"checkbox\" ng-model=\"bs.no_data\" ng-change=\"toggleNoData(bs)\"></th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Current assets</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Cash and cash equivalents</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><span style=\"position: relative\"><form-number model=\"item.cash.amount\" update-fct=\"saveBalanceSheet(item, model, \'cash\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></span></div></td></tr><tr><td translate=\"\">Account receivables</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.account_receivables.amount\" update-fct=\"saveBalanceSheet(item, model, \'account_receivables\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other receivables</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_receivables.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_receivables\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Inventories</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.inventories.amount\" update-fct=\"saveBalanceSheet(item, model, \'inventories\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other current assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_current_assets.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_current_assets\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total current assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_current_assets.amount | number\"></span> <span ng-if=\"!item.total_current_assets.amount\">0</span></td></tr><tr class=\"sub\"><td translate=\"\">Non-current assets</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Fixed assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.fixed_assets.amount\" update-fct=\"saveBalanceSheet(item, model, \'fixed_assets\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Intangible assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.intangible_assets.amount\" update-fct=\"saveBalanceSheet(item, model, \'intangible_assets\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Goodwill</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.goodwill.amount\" update-fct=\"saveBalanceSheet(item, model, \'goodwill\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other non-current assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_non_current_assets.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_non_current_assets\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total non-current assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_non_current_assets.amount | number\"></span> <span ng-if=\"!item.total_non_current_assets.amount\">0</span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_assets.amount | number\"></span> <span ng-if=\"!item.total_assets.amount\">0</span></td></tr></tbody><thead><tr><th translate=\"\">Liabilities</th><th ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"setYear(item.year)\"></span></th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Current liabilities</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Accounts payable</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.accounts_payable.amount\" update-fct=\"saveBalanceSheet(item, model, \'accounts_payable\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Short term loans</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.short_term_loans.amount\" update-fct=\"saveBalanceSheet(item, model, \'short_term_loans\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Overdrafts</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.overdrafts.amount\" update-fct=\"saveBalanceSheet(item, model, \'overdrafts\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Income tax payable</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.income_tax_payable.amount\" update-fct=\"saveBalanceSheet(item, model, \'income_tax_payable\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Short term provisions</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.short_term_provisions.amount\" update-fct=\"saveBalanceSheet(item, model, \'short_term_provisions\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other current liabilities</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_current_liabilities.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_current_liabilities\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total current liabilities</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_current_liabilities.amount | number\"></span> <span ng-if=\"!item.total_current_liabilities.amount\">0</span></td></tr><tr class=\"sub\"><td translate=\"\">Non-current liabilities</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Long term loans</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.long_term_loans.amount\" update-fct=\"saveBalanceSheet(item, model, \'long_term_loans\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Deferred tax</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.deferred_tax.amount\" update-fct=\"saveBalanceSheet(item, model, \'deferred_tax\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Provisions</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.provisions.amount\" update-fct=\"saveBalanceSheet(item, model, \'provisions\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other non-current liabilities</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_non_current_liabilities.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_non_current_liabilities\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total non-current liabilities</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_non_current_liabilities.amount | number\"></span> <span ng-if=\"!item.total_non_current_liabilities.amount\">0</span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total liabilities</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_liabilities.amount | number\"></span> <span ng-if=\"!item.total_liabilities.amount\">0</span></td></tr><tr class=\"sub group\"><td translate=\"\">NET ASSETS</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.net_assets.amount | number\"></span> <span ng-if=\"!item.net_assets.amount\">0</span></td></tr></tbody><thead><tr><th translate=\"\">Equity</th><th ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"setYear(item.year)\"></span></th></tr></thead><tbody><tr><td translate=\"\">Share capital</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.share_capital.amount\" update-fct=\"saveBalanceSheet(item, model, \'share_capital\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Share premium</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.share_premium.amount\" update-fct=\"saveBalanceSheet(item, model, \'share_premium\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Retained earnings</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.retained_earnings.amount\" update-fct=\"saveBalanceSheet(item, model, \'retained_earnings\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Grants (seed capital)</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.grants.amount\" update-fct=\"saveBalanceSheet(item, model, \'grants\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Statutory/legal reserves</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.statutory_legal_reserves.amount\" update-fct=\"saveBalanceSheet(item, model, \'statutory_legal_reserves\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other reserves</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other_reserves.amount\" update-fct=\"saveBalanceSheet(item, model, \'other_reserves\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.other.amount\" update-fct=\"saveBalanceSheet(item, model, \'other\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total equity</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"item.total_equity.amount | number\"></span> <span ng-if=\"!item.total_equity.amount\">0</span></td></tr></tbody></table><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Verifications</th><th style=\"width: 150px\" ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"setYear(item.year)\"></span></th></tr></thead><tbody><tr><td translate=\"\">Total Assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><form-number model=\"item.manual_total_assets.amount\" update-fct=\"saveBalanceSheet(item, model, \'manual_total_assets\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></td></tr><tr><td translate=\"\">Check Assets</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><si-compare-values is-disabled=\"item.no_data\" compare-to=\"item.total_assets.amount\" value=\"item.manual_total_assets.amount\"></si-compare-values></td></tr><tr><td translate=\"\">Check Assets = Liabilities + Equity</td><td ng-repeat=\"item in assessment.balancesheets.objects\"><si-compare-values is-disabled=\"item.no_data\" compare-to=\"item.total_assets.amount\" value=\"addValues([item.total_equity.amount, item.total_liabilities.amount])\"></si-compare-values></td></tr></tbody></table><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Working capital and inventory</th><th style=\"width: 150px\" ng-repeat=\"item in assessment.balancesheets.objects\"><span ng-bind=\"setYear(item.year)\"></span></th></tr></thead><tbody><tr><td translate=\"\">Net working capital throughout the year</td><td ng-repeat=\"item in assessment.balancesheets.objects\" ng-class=\"{\'gray-bg\': $index === (assessment.balancesheets.objects.length - 1)}\"><span ng-bind=\"(item.net_working_capital.amount || 0) | number\" ng-if=\"!($index === (assessment.balancesheets.objects.length - 1))\"></span></td></tr><tr><td translate=\"\">Average inventory throughout the year</td><td ng-repeat=\"item in assessment.balancesheets.objects\" ng-class=\"{\'gray-bg\': $index === (assessment.balancesheets.objects.length - 1)}\"><span ng-bind=\"item.average_inventory.amount | number\"></span></td></tr><tr><td translate=\"\">Average receivable throughout the year</td><td ng-repeat=\"item in assessment.balancesheets.objects\" ng-class=\"{\'gray-bg\': $index === (assessment.balancesheets.objects.length - 1)}\"><span ng-bind=\"item.average_receivables.amount | number\"></span></td></tr></tbody></table></fieldset></fieldset></form><fieldset ng-disabled=\"(assessment.balance_sheet_tab_accepted && assignment.submitted_at_least_once && assessment.full_completion_check_required) || assignment.assigned_as !== \'financial_specialist\'\"><fieldset ng-disabled=\"assessment.balance_sheet_tab_completed\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\" class=\"comment-label\">Accountant notes on Cash Flow Statement</label> <textarea name=\"accountant_comments_balancesheet\" id=\"accountant_comments_balancesheet\" assessment=\"assessment\" spellcheck=\"true\" cols=\"30\" rows=\"10\" ng-change=\"updateTextareas(assessment.accountant_comments_balancesheet, \'accountant_comments_balancesheet\', assessment)\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"assessment.accountant_comments_balancesheet\" class=\"form-control\">\n                    </textarea></div></div></fieldset></fieldset><div class=\"source_of_data_container\"><form-select label=\"\'Select source of data:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"!assessment.balance_sheet_tab_completed\" options=\"dropdown\" option-value=\"display_name\" disabled=\"assessment.balance_sheet_tab_completed\" model=\"assessment.balance_sheet_source_of_data_source\" update-fct=\"assessment.balance_sheet_source_of_data_source = model\"></form-select></div><file-upload-component assessment-id=\"assessment.id\" file-type=\"balance_sheet\" current-file-name=\"assessment.balance_sheet_source_of_data_file_name\" source-of-data=\"assessment.balance_sheet_source_of_data_source\" is-disabled=\"assessment.balance_sheet_tab_completed\" file-input-id=\"balance_sheet_file_input\" on-files-change=\"handleFilesChange(files, fileType, isRequired, hasFiles)\"></file-upload-component></div></div>");
$templateCache.put("assessments/partials/cashflowStatementTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><form name=\"cashflowForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.cashflow_tab_accepted\" assessment=\"assessment\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchFinancialTab(name, value, \'cash_flow_tab_completed\')\" is-accepted=\"cash_flow_tab_accepted\" is-completed=\"cash_flow_tab_completed\" is-disabled=\"cashflowForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Cashflow\" assessment=\"assessment\" reopen-text=\"{{financialTabs.reopenText}}\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"cashflowForm.$invalid\" is-completed=\"cash_flow_tab_completed\" is-form-completed=\"cashflowForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><input type=\"checkbox\" ng-show=\"false\" required=\"\" name=\"hidden\" ng-model=\"assessment.cash_flow_tab_completed\" ng-checked=\"assessment.cash_flow_tab_completed\"> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.full_completion_check_required\" ng-click=\"markCashFlowTabDone(\'cash_flow_tab_completed\')\" ng-disabled=\"!canConfirm()\"><translate>Completed</translate><span ng-if=\"assessment.cash_flow_tab_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button><fieldset ng-disabled=\"assessment.cash_flow_tab_completed\"><div class=\"top-buttons\"><div class=\"top-buttons__heading\"><si-info-text-display assessment=\"assessment\" key=\"info_cashflow_tab_main\"><h3 translate=\"\">Cashflow Statement</h3></si-info-text-display><h4 class=\"label label-primary\" translate=\"\">Maximum of 5 years and minimum of 3 years allowed.</h4></div><div class=\"top-buttons__actions\"><span><translate>Selected Currency:&nbsp;</translate><span ng-bind=\"global_currency\"></span></span></div></div><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Cashflow statement</th><th style=\"width: 150px\" ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.year\"></span></th></tr><tr><th translate=\"\">No Data</th><th style=\"width: 150px\" ng-repeat=\"cf in assessment.cashflowstatements.objects\"><input type=\"checkbox\" ng-model=\"cf.no_data\" ng-change=\"toggleNoData(cf)\"></th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Cash flow from operating activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Net income</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.net_income.amount\" update-fct=\"saveCashFlowStatement(item, model, \'net_income\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Adjustment for tax</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.adjustment_for_tax.amount\" update-fct=\"saveCashFlowStatement(item, model, \'adjustment_for_tax\')\" allow-negative=\"true\" is-disabled=\"item.no_data\"></form-number></div></td></tr><tr class=\"sub\"><td translate=\"\">Adjustments for non-cash items</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Depreciation and amortization</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.depreciation_and_amortization.amount\" update-fct=\"saveCashFlowStatement(item, model, \'depreciation_and_amortization\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Investment income</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.investment_income.amount\" update-fct=\"saveCashFlowStatement(item, model, \'investment_income\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Interest expense</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.interest_expense.amount\" update-fct=\"saveCashFlowStatement(item, model, \'interest_expense\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Profit / (loss) on sale of PP/E</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.profit_on_sale_of_ppe.amount\" update-fct=\"saveCashFlowStatement(item, model, \'profit_on_sale_of_ppe\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Working capital changes</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.working_capital_changes.amount\" update-fct=\"saveCashFlowStatement(item, model, \'working_capital_changes\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">(increase)/decrease in trade and other receivables</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.decrease_in_trade_and_other_receivables.amount\" update-fct=\"saveCashFlowStatement(item, model, \'decrease_in_trade_and_other_receivables\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">(Increase)/decrease in inventories</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.increase_in_inventoriese.amount\" update-fct=\"saveCashFlowStatement(item, model, \'increase_in_inventories\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">increase/(decrease) in trade payables and other payables</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.increase_in_trade_and_other_payables.amount\" update-fct=\"saveCashFlowStatement(item, model, \'increase_in_trade_and_other_payables\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Cash generated from operations</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.cash_generated_from_operations.amount | number\"></span> <span ng-if=\"!item.cash_generated_from_operations.amount\">0</span></td></tr><tr class=\"sub\"><td translate=\"\">Interest paid</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.interest_paid.amount\" update-fct=\"saveCashFlowStatement(item, model, \'interest_paid\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub\"><td translate=\"\">Income taxes paid</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.income_taxes_paid.amount\" update-fct=\"saveCashFlowStatement(item, model, \'income_taxes_paid\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">NET CASH FROM OPERATING ACTIVITIES</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.net_cash_from_operating_activities.amount | number\"></span> <span ng-if=\"!item.net_cash_from_operating_activities.amount\">0</span></td></tr><tr class=\"sub\"><td translate=\"\">Cash flows from investing activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Purchases of property, plant and equipment (PPE)</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.purchases_of_property_plant_and_equipment.amount\" update-fct=\"saveCashFlowStatement(item, model, \'purchases_of_property_plant_and_equipment\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Proceed from sale of PPE</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.proceeds_from_sale_of_PPE.amount\" update-fct=\"saveCashFlowStatement(item, model, \'proceeds_from_sale_of_PPE\')\" is-disabled=\"item.no_data\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Purchases of intangible assets</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.purchases_of_intangible_assets.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'purchases_of_intangible_assets\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Purchases of financial assets</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.purchases_of_financial_assets.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'purchases_of_financial_assets\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Loans granted to associates or subsidiaries</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.loans_granted_to_associates_or_subsidiaries.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'loans_granted_to_associates_or_subsidiaries\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Loan repayments received from associates or subsidiaries</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.loan_repayments_received_from_associates_or_subsidiaries.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'loan_repayments_received_from_associates_or_subsidiaries\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Interest received</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.interest_received.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'interest_received\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Dividends received</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.dividends_received.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'dividends_received\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.investing_other.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'investing_other\')\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Net cash used in investing activities</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.net_cash_used_in_investing_activities.amount | number\"></span> <span ng-if=\"!item.net_cash_used_in_investing_activities.amount\">0</span></td></tr><tr class=\"sub\"><td translate=\"\">Cash flows from financing activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Proceeds from sale of ordinary shares</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.proceeds_from_sale_of_ordinary_shares.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'proceeds_from_sale_of_ordinary_shares\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Purchase of treasury shares</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.purchase_of_treasury_shares.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'purchase_of_treasury_shares\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Proceeds from borrowings</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.proceeds_from_borrowings.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'proceeds_from_borrowings\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Repayments from borrowings</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.repayments_from_borrowingse.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'repayments_from_borrowings\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Proceeds from loan from subsidiary undertaking</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.proceeds_from_loan_from_subsidiary_undertaking.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'proceeds_from_loan_from_subsidiary_undertaking\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Dividends paid to organizations shareholders</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.dividends_paid_to_organizations_shareholders.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'dividends_paid_to_organizations_shareholders\')\" allow-negative=\"true\"></form-number></div></td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.financing_other.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'financing_other\')\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Net cash used in financing activities</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.net_cash_used_in_financing_activities.amount | number\"></span> <span ng-if=\"!item.net_cash_used_in_financing_activities.amount\">0</span></td></tr><tr class=\"sub group\"><td translate=\"\">NET CASH FLOW</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.net_cash_flow.amount | number\"></span> <span ng-if=\"!item.net_cash_flow.amount\">0</span></td></tr><tr><td translate=\"\">Cash at beginning of period</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.cash_at_beginning_of_period.amount\" is-disabled=\"item.no_data\" update-fct=\"saveCashFlowStatement(item, model, \'cash_at_beginning_of_period\')\" allow-negative=\"true\"></form-number></div></td></tr><tr class=\"sub-total group\"><td translate=\"\">Cash at end of period</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.cash_at_end_of_period.amount | number\"></span> <span ng-if=\"!item.cash_at_end_of_period.amount\">0</span></td></tr></tbody></table></fieldset></fieldset></form><fieldset ng-disabled=\"assessment.cash_flow_tab_completed\"><div class=\"above-seperator\"><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Verifications</th><th style=\"width: 150px\" ng-repeat=\"item in assessment.cashflowstatements.objects\"><span ng-bind=\"item.year\"></span></th></tr></thead><tbody><tr><td translate=\"\">Check cash and cash equivalents = Cash at end of period</td><td ng-repeat=\"item in assessment.cashflowstatements.objects\"><si-compare-values compare-to=\"item.cash_at_end_of_period.amount || 0\" value=\"assessment.balancesheets.objects[$index].cash.amount\"></si-compare-values></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\" class=\"comment-label\">Accountant notes on Cash Flow Statement</label> <textarea name=\"accountant_comments_cashflow\" id=\"accountant_comments_cashflow\" assessment=\"assessment\" spellcheck=\"true\" cols=\"30\" rows=\"10\" ng-change=\"updateTextareas(assessment.accountant_comments_cashflow, \'accountant_comments_cashflow\', assessment)\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"assessment.accountant_comments_cashflow\" class=\"form-control\">\n                    </textarea></div></div></fieldset><div class=\"source_of_data_container\"><form-select label=\"\'Select source of data:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"!assessment.cash_flow_tab_completed\" options=\"dropdown\" option-value=\"display_name\" disabled=\"assessment.cash_flow_tab_completed\" model=\"assessment.cashflow_source_of_data_source\" update-fct=\"assessment.cashflow_source_of_data_source = model\"></form-select></div><file-upload-component assessment-id=\"assessment.id\" file-type=\"cashflow\" current-file-name=\"assessment.cashflow_source_of_data_file_name\" source-of-data=\"assessment.cashflow_source_of_data_source\" is-disabled=\"assessment.cash_flow_tab_completed\" file-input-id=\"cashflow_file_input\" on-files-change=\"handleFilesChange(files, fileType, isRequired, hasFiles)\"></file-upload-component></div></div>");
$templateCache.put("assessments/partials/consentDocumentPreview.html","<div class=\"consent-preview\"><div class=\"consent-preview__head\"><i class=\"fa fa-file-text-o consent-preview__icon\" aria-hidden=\"true\"></i><div class=\"consent-preview__title\"><div class=\"consent-preview__name\" ng-bind=\"fileName()\"></div><div class=\"consent-preview__meta\" ng-bind=\"typeLabel()\"></div></div><div class=\"consent-preview__actions\"><a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-if=\"ui.state === \'ready\'\" ng-click=\"toggleFullscreen()\" ng-keydown=\"onKey($event, toggleFullscreen)\" title=\"{{ \'Full screen\' | translate }}\" aria-label=\"{{ \'Full screen\' | translate }}\"><i class=\"fa fa-expand\" aria-hidden=\"true\"></i></a> <a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-click=\"download()\" ng-keydown=\"onKey($event, download)\" title=\"{{ \'Download\' | translate }}\" aria-label=\"{{ \'Download\' | translate }}\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></a> <button type=\"button\" class=\"consent-preview__action consent-preview__delete\" ng-click=\"onDelete()\" title=\"{{ \'Delete\' | translate }}\" aria-label=\"{{ \'Delete\' | translate }}\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></div></div><div class=\"consent-preview__toolbar\" ng-if=\"ui.state === \'ready\'\"><span class=\"consent-preview__label\" translate=\"\">Document preview</span> <span class=\"consent-preview__pager\" ng-if=\"ui.kind === \'pdf\' && ui.pages > 1\"><a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-class=\"{\'is-disabled\': ui.page <= 1}\" ng-click=\"previousPage()\" ng-keydown=\"onKey($event, previousPage)\" aria-label=\"{{ \'Previous page\' | translate }}\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></a> <span class=\"consent-preview__page\" translate=\"\">Page {{ ui.page }} of {{ ui.pages }}</span> <a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-class=\"{\'is-disabled\': ui.page >= ui.pages}\" ng-click=\"nextPage()\" ng-keydown=\"onKey($event, nextPage)\" aria-label=\"{{ \'Next page\' | translate }}\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></a></span> <span class=\"consent-preview__zoom\"><a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-class=\"{\'is-disabled\': !canZoomOut()}\" ng-click=\"zoomOut()\" ng-keydown=\"onKey($event, zoomOut)\" aria-label=\"{{ \'Zoom out\' | translate }}\"><i class=\"fa fa-search-minus\" aria-hidden=\"true\"></i></a> <span class=\"consent-preview__zoom-value\">{{ ui.zoom * 100 | number:0 }}%</span> <a class=\"consent-preview__action\" role=\"button\" tabindex=\"0\" ng-class=\"{\'is-disabled\': !canZoomIn()}\" ng-click=\"zoomIn()\" ng-keydown=\"onKey($event, zoomIn)\" aria-label=\"{{ \'Zoom in\' | translate }}\"><i class=\"fa fa-search-plus\" aria-hidden=\"true\"></i></a></span></div><div class=\"consent-preview__viewport\" ng-class=\"\'consent-preview__viewport--\' + ui.state\"><div class=\"consent-preview__status\" ng-if=\"ui.state === \'loading\'\" role=\"status\"><i class=\"fa fa-circle-o-notch fa-spin\" aria-hidden=\"true\"></i> <span translate=\"\">Loading preview…</span></div><canvas class=\"consent-preview__canvas\" ng-show=\"ui.state === \'ready\' && ui.kind === \'pdf\'\"></canvas><img class=\"consent-preview__image\" ng-if=\"ui.state === \'ready\' && ui.kind === \'image\'\" ng-src=\"{{ ui.imageUrl }}\" alt=\"{{ fileName() }}\" ng-style=\"{\'width\': (ui.zoom * 100) + \'%\'}\"><div class=\"consent-preview__status consent-preview__status--message\" ng-if=\"ui.state === \'unsupported\'\"><p translate=\"\">A preview is not available for this file type. Download the document to view it.</p><a class=\"btn btn-default btn-sm\" role=\"button\" tabindex=\"0\" ng-click=\"download()\" ng-keydown=\"onKey($event, download)\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> <span translate=\"\">Download</span></a></div><div class=\"consent-preview__status consent-preview__status--message\" ng-if=\"ui.state === \'error\'\" role=\"alert\"><p>{{ ui.errorMessage }} <span translate=\"\">You can still download the document.</span></p><a class=\"btn btn-default btn-sm\" role=\"button\" tabindex=\"0\" ng-click=\"download()\" ng-keydown=\"onKey($event, download)\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> <span translate=\"\">Download</span></a> <a class=\"btn btn-link btn-sm\" role=\"button\" tabindex=\"0\" ng-if=\"!isOffline\" ng-click=\"retry()\" ng-keydown=\"onKey($event, retry)\" translate=\"\">Try again</a></div></div></div>");
$templateCache.put("assessments/partials/documentationTabView.html","<form name=\"documentationForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.documents_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"documents_tab_accepted\" is-completed=\"documents_tab_completed\" is-disabled=\"documentationForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Documentation\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"documentationForm.$invalid\" is-completed=\"documents_tab_completed\" is-form-completed=\"documentationForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><si-info-text-display assessment=\"assessment\" key=\"info_documentation_tab_main\"><h3 class=\"m-b-md\" translate=\"\">Documentation</h3></si-info-text-display><table class=\"table table-striped\"><tr><th translate=\"\">Document type</th><th translate=\"\">Upload Documentation</th><th><translate>Availability</translate><span class=\"text-danger\">*</span></th><th translate=\"\">Comments</th></tr><tr ng-repeat=\"row in assessment.document_availability_responses.objects\"><td ng-bind=\"row.question_title\"></td><td><base-sixty-four-document-upload label=\"{{\'Add Documents\'|translate}}\" offline-label=\"{{ \'Disabled in offline mode\' | translate }}\" ng-model=\"row\" name=\"documentavailabilityresponse\" ng-multiple=\"true\" create-function=\"documentAvailabilityResponseDocumentCreate(data)\" is-disabled=\"isOffline\"></base-sixty-four-document-upload><div class=\"delete-files\" ng-repeat=\"document in row.documents.objects track by $index\"><span ng-bind=\"document.file_name\"></span>&nbsp; <a ng-href=\"{{ document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span ng-bind=\"document.file_name\"></span></a><br><a class=\"btn btn-sm btn-danger\" ng-click=\"removeDocumentAvailabilityResponseDocument(document, row.documents.objects)\"><i class=\"fa fa-trash\"></i><translate>Delete</translate></a></div></td><td><yes-no-bool update-fct=\"saveDocumentAvailability({available: model, url: row.url}, row, {documentationForm: documentationForm})\" can-have-blank=\"true\" yes-value=\"yes\" no-value=\"no\" empty-string=\"\'not relevant\'\" show-error=\"showTabWarnings\" form-name=\"{{row.id}}\" required=\"true\" parent-form=\"documentationForm\" model=\"row.available\"></yes-no-bool></td><td><textarea class=\"form-control\" blur=\"saveDocumentAvailabilityComment\" ng-model=\"row.comment\" question=\"row\" spellcheck=\"true\" style=\"resize: vertical; min-height: 50px\">\n                            </textarea></td></tr></table><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on documentation\' | translate\" label-size=\"large\" info-text-key=\"info_documentation_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_documents\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_documents\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_documents\', assessment.assessor_comments_documents, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></div></form>");
$templateCache.put("assessments/partials/financeHistoryTabView.html","<form name=\"financeForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.finance_history_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"finance_history_tab_accepted\" is-completed=\"finance_history_tab_completed\" is-disabled=\"financeForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Finance\" assessment=\"assessment\" reopen-text=\"{{financialTabs.reopenText}}\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"financeForm.$invalid\" is-completed=\"finance_history_tab_completed\" is-form-completed=\"financeForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\" ng-if=\"reloadTables\"><table-comp heading=\"{{ \'Bank Accounts\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_bank_accounts\" table-data=\"assessment\" key=\"bank_accounts\" tab-title=\"$index\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"bankAccountsRows\" table-complete=\"bank_accounts_completed\" no-info=\"bank_accounts_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"bank_accounts_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"saveBankAccount(assessment)\" update-fct=\"saveBankAccount(assessment, row)\" delete-fct=\"removeBankAccount(row)\" is-table-disabled=\"{{isFormDisabled()}}\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><table-comp heading=\"{{ \'Collateral\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_collateral\" table-data=\"assessment\" key=\"collateral_assets\" tab-title=\"$index\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"collateralAssetsRows\" table-complete=\"collateral_assets_completed\" no-info=\"collateral_assets_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"collateral_assets_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"saveCollateralAsset(assessment)\" update-fct=\"saveCollateralAsset(assessment, row)\" delete-fct=\"removeCollateralAsset(row)\" is-table-disabled=\"{{isFormDisabled()}}\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><table-comp heading=\"{{ \'Loan History\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_loan_history\" table-data=\"assessment\" key=\"loan_histories\" tab-title=\"row.display_financier\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"loanHistoriesRows\" table-complete=\"loan_histories_completed\" no-info=\"loan_histories_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"loan_histories_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"saveLoanHistory(assessment)\" update-fct=\"saveLoanHistory(assessment, row)\" delete-fct=\"removeLoanHistory(row)\" is-table-disabled=\"{{isFormDisabled()}}\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><table-comp heading=\"{{ \'Pre-Finance History\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_pre_finance_history\" table-data=\"assessment\" key=\"pre_finance_histories\" tab-title=\"row.display_provider\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"preFinanceHistoriesRows\" table-complete=\"pre_finance_histories_completed\" no-info=\"pre_finance_histories_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"pre_finance_histories_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"savePreFinanceHistory(assessment)\" update-fct=\"savePreFinanceHistory(assessment, row)\" delete-fct=\"removePreFinanceHistory(row)\" is-table-disabled=\"{{isFormDisabled()}}\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><table-comp heading=\"{{ \'Grant History\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_grant_history\" table-data=\"assessment\" key=\"grant_histories\" tab-title=\"row.funder\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"grantHistoriesRows\" table-complete=\"grant_histories_completed\" no-info=\"grant_histories_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"grant_histories_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"saveGrantHistory(assessment)\" update-fct=\"saveGrantHistory(assessment, row)\" delete-fct=\"removeGrantHistory(row)\" is-table-disabled=\"isFormDisabled()\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><table-comp heading=\"{{ \'Insurance\' | translate }}\" assessment=\"assessment\" info-text-key=\"info_finance_tab_insurance\" table-data=\"assessment\" key=\"insurances\" tab-title=\"$index\" show-error=\"showTabWarnings\" tab-accepted-field=\"finance_history_tab_accepted\" field-map=\"insurancesRows\" table-complete=\"insurances_completed\" no-info=\"insurances_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"insurances_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"saveInsurance(assessment)\" update-fct=\"saveInsurance(assessment, row)\" delete-fct=\"removeInsurance(row)\" is-table-disabled=\"isFormDisabled()\" is-disabled=\"assessment.finance_history_tab_accepted && isDashboard\"></table-comp><form-input ng-if=\"shouldShowSection(\'finance_tab.auditing_firm\')\" update-fct=\"updateFormElement(assessment, \'auditing_firm\', model, {financeForm: financeForm})\" model=\"assessment.auditing_firm\" label=\"\'Name of Auditing Firm\' | translate\" info-text-key=\"info_finance_tab_name_of_auditing_firm\" assessment=\"assessment\"></form-input><form-textarea form-name=\"assessor_commFents_finance\" model=\"assessment.assessor_comments_finance\" update-fct=\"updateFormElement(assessment, \'assessor_comments_finance\', model, {financeForm: financeForm})\" label=\"\'Assessor notes on Finance History\' | translate\" label-size=\"large\" info-text-key=\"info_finance_tab_comments\" assessment=\"assessment\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_finance\', assessment.assessor_comments_finance, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></fieldset></div></div></form>");
$templateCache.put("assessments/partials/financeOverviewTabView.html","<form name=\"financeForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.finance_overview_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"finance_overview_tab_accepted\" is-completed=\"finance_overview_tab_completed\" is-disabled=\"financeForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Finance\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"financeForm.$invalid\" is-completed=\"finance_overview_tab_completed\" is-form-completed=\"financeForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-if=\"reloadTables\"><table-comp-basic-profit-loss table-data=\"assessment.basicprofitlossstatements.objects\" show-error=\"showTabWarnings\" assessment=\"assessment\" global-currency=\"global_currency\" objects-exist=\"basicProfitLossExists()\" table-complete=\"basic_profit_loss_completed\" no-info=\"basic_profit_loss_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"basic_profit_loss_no_info_reason\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\" create-fct=\"createBasicProfitLoss(assessment, {year:year})\" update-fct=\"saveBasicProfitLoss(assessment, row, key)\" update-currency=\"updateCurrency(currency)\" source-of-data-dropdown-options=\"dropdown\"></table-comp-basic-profit-loss></fieldset><fieldset ng-disabled=\"isFormDisabled()\" ng-if=\"reloadTables\"><div ng-if=\"!assessment.tool.type.is_rapid\"><table-financial-strategy assessment=\"assessment\" no-info-reason=\"true\" no-info-reason-key=\"financial_strategy_no_info_reason\" mark-table-done=\"markFinancialStrategyDone(type, other)\" mark-row-no-info=\"markFinancialStrategyFieldsDone(type, model)\" update-form=\"updateFormElement(obj, key, val, {financeForm: financeForm})\"></table-financial-strategy></div><form-textarea form-name=\"assessor_comments_finance_overview\" model=\"assessment.assessor_comments_finance_overview\" update-fct=\"updateFormElement(assessment, \'assessor_comments_finance_overview\', model, {financeForm: financeForm})\" label=\"\'Assessor notes on Finance Overview\' | translate\" label-size=\"large\" info-text-key=\"info_finance_tab_comments\" assessment=\"assessment\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_finance_overview\', assessment.assessor_comments_finance_overview, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></fieldset></div></div></form>");
$templateCache.put("assessments/partials/financeProductTabView.html","<form name=\"financeProductionForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.finance_product_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\" style=\"min-height:100px\"><h3 class=\"m-b-md\" translate=\"\">Finance and Product</h3><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"finance_product_tab_accepted\" is-completed=\"finance_product_tab_completed\" is-disabled=\"financeProductionForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Finance Production\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"financeProductionForm.$invalid\" is-completed=\"finance_product_tab_completed\" is-form-completed=\"financeProductionForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><div class=\"row\"><div class=\"col-md-12\"><si-info-text-display assessment=\"assessment\" key=\"info_finance_product_tab_bank_account_loan_history\"><h3 ng-bind=\"\'Bank account & loan history\' | translate\"></h3></si-info-text-display><table class=\"table table-striped\"><tr><td><yes-no-bool label=\"\'Bank account with financial institution\' | translate\" label-width=\"6\" wrapper=\"td\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.agent_bank_account_loan_history.has_bank_account\" update-fct=\"saveBankAccountLoanHistory({has_bank_account: model}, {financeProductionForm: financeProductionForm})\"></yes-no-bool></td></tr><tr><td><yes-no-bool label=\"\'Account with mobile operator\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.agent_bank_account_loan_history.has_mobile_account\" update-fct=\"saveBankAccountLoanHistory({has_mobile_account: model}, {financeProductionForm: financeProductionForm})\"></yes-no-bool></td></tr><tr><td><yes-no-bool label=\"\'Has had loans in the past\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.agent_bank_account_loan_history.has_loan_history\" update-fct=\"saveBankAccountLoanHistory({has_loan_history: model}, {financeProductionForm: financeProductionForm})\"></yes-no-bool></td></tr><tr><td><yes-no-bool label=\"\'All loans were paid back\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.agent_bank_account_loan_history.has_paid_back_loans\" update-fct=\"saveBankAccountLoanHistory({has_paid_back_loans: model}, {financeProductionForm: financeProductionForm})\"></yes-no-bool></td></tr></table></div></div><br><table-comp heading=\"{{\'Income from Agent role\' | translate}}\" key=\"agent_income\" assessment=\"assessment\" info-text-key=\"info_finance_product_tab_income_from_agent_role\" table-data=\"assessment\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"agentIncomeRows\" no-info=\"agent_income_no_information_available\" table-complete=\"agent_income_completed\" update-form=\"updateFormElement(obj, key, val, {financeProductionForm: financeProductionForm})\" create-fct=\"saveIncomefromAgent(assessment)\" update-fct=\"saveIncomefromAgent(assessment, row)\" is-table-disabled=\"isFormDisabled()\" delete-fct=\"removeIncomefromAgent(row)\" is-disabled=\"assessment.finance_history_tab_accepted\"></table-comp><br><si-info-text-display assessment=\"assessment\" key=\"info_finance_product_tab_products\"><h3 translate=\"\"><span ng-bind=\"\'Products\' | translate\"></span> &nbsp; <span ng-show=\"assessment.products_completed && assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.products_completed && showTabWarnings && assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></h3></si-info-text-display><uib-tabset class=\"tabs-left\" ng-form=\"\" name=\"productsForm\"><uib-tab ng-repeat=\"product in assessment.products.objects\" active=\"$first\"><uib-tab-heading><span ng-bind=\"product.display_name\"></span> &nbsp; <span ng-show=\"productsForm[parseName(product.name)].$valid && assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"productsForm[parseName(product.name)].$invalid && showTabWarnings && assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></uib-tab-heading><div ng-form=\"\" name=\"{{parseName(product.name)}}\"><table-comp heading=\"{{\'Produce Sold\' | translate}}\" key=\"productionsales\" assessment=\"assessment\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"agentProduceSoldRows\" no-info=\"productionsales_no_information_available\" table-complete=\"productionsales_completed\" update-form=\"updateFormElement(obj, key, val, {financeProductionForm: financeProductionForm})\" create-fct=\"saveProduceSold(assessment, product)\" update-fct=\"saveProduceSold(assessment, product, row)\" is-table-disabled=\"isFormDisabled()\" delete-fct=\"removeProduceSold(product, row)\" is-disabled=\"assessment.finance_history_tab_accepted\"></table-comp><button type=\"button\" ng-click=\"removeProduct(product)\" class=\"btn btn-xs btn-danger\">\'<i class=\"f\\a fa-time\'\"></i><translate>Remove Product</translate></button></div></uib-tab><button type=\"button btn-horizontal\" ng-click=\"addProduct(assessment)\" class=\"btn btn-primary btn-horizontal\"><i class=\"fa fa-plus\"></i> <span translate=\"\">Add</span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.products.objects.length === 0 && assessment.full_completion_check_required\" ng-click=\"markProductsDone(\'products_completed\')\"><translate>No information</translate><span ng-if=\"assessment.products_completed && assessment.full_completion_check_required\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.products.objects.length !== 0 && assessment.full_completion_check_required\" ng-click=\"markProductsDone(\'products_completed\')\"><translate>Complete</translate><span ng-if=\"assessment.products_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button></uib-tabset><input type=\"checkbox\" required=\"\" ng-show=\"false\" name=\"products_completed\" ng-checked=\"assessment.products_completed\" ng-model=\"assessment.products_completed\"><br></fieldset></div><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on finance and product\' | translate\" label-size=\"large\" info-text-key=\"info_finance_product_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_finance_product\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_finance_product\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_finance_product\', assessment.assessor_comments_finance_product, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></div></form>\'\\\\\'\'\\\\\'\'\\\\\'\'\\\\\'\'\\\\\'\'\\\\\'");
$templateCache.put("assessments/partials/financialPerformanceTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><form name=\"financialPerformanceForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.finance_performance_tab_accepted\" assessment=\"assessment\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchFinancialTab(name, value, \'finance_performance_tab_completed\')\" is-accepted=\"finance_performance_tab_accepted\" is-completed=\"finance_performance_tab_completed\" is-disabled=\"financialPerformanceForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Financial Performance\" assessment=\"assessment\" reopen-text=\"{{financialTabs.reopenText}}\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"financialPerformanceForm.$invalid\" is-completed=\"finance_performance_tab_completed\" is-form-completed=\"financialPerformanceForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><div><translate>Selected Currency:</translate><span ng-bind=\"global_currency\"></span></div><input type=\"checkbox\" ng-show=\"false\" required=\"\" name=\"hidden\" ng-model=\"assessment.finance_performance_tab_completed\" ng-checked=\"assessment.finance_performance_tab_completed\"> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.full_completion_check_required\" ng-click=\"markFinancialPerformanceTabDone(\'finance_performance_tab_completed\')\"><translate>Completed</translate><span ng-if=\"assessment.finance_performance_tab_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button><fieldset ng-disabled=\"assessment.finance_performance_tab_completed\"><si-info-text-display assessment=\"assessment\" key=\"info_financial_performance_tab_financial_ratios\"><h3 translate=\"\">Financial Ratios</h3></si-info-text-display><span ng-show=\"isOffline\" class=\"text-danger\" translate=\"\">Results may not be calculated or outdated due to offline mode</span><div class=\"above-seperator\"><table class=\"table table-bordered financial\"><thead><tr><th translate=\"\">Metric</th><th style=\"width: 110px\" ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"setYear(item.year)\"></span></th><th class=\"divider\"></th><th translate=\"\"></th><th style=\"width: 110px\" class=\"rotated\"><div translate=\"\">Status</div></th><th style=\"width: 110px\" class=\"rotated\"><div translate=\"\">Trend</div></th><th style=\"width: 110px\" class=\"rotated\"><div translate=\"\">Volatility</div></th><th style=\"width: 110px\" class=\"rotated\"><div translate=\"\">Total score</div></th></tr></thead><tbody ng-model-options=\"{updateOn: \'blur\'}\"><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Growth</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.growth }}</td></tr><tr><td translate=\"\">Revenue growth</td><td ng-if=\"!$last\" ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.revenue_growth | number:1 | percentage\"></span></td><td ng-if=\"$last\" style=\"background-color:#eeeeee\" ng-repeat=\"item in assessment.financial_ratios.objects\"></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.revenue_growth.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.revenue_growth)\" class=\"form-control\"></td><td><input disabled=\"\" type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.revenue_growth.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.revenue_growth)\" class=\"form-control\"></td><td><input disabled=\"\" type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.revenue_growth.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.revenue_growth)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.revenue_growth.total_score }}</td></tr><tr><td translate=\"\">Net profit growth</td><td ng-if=\"!$last\" ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.net_profit_growth | number:1 | percentage\"></span></td><td ng-if=\"$last\" style=\"background-color:#eeeeee\" ng-repeat=\"item in assessment.financial_ratios.objects\"></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_growth.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_growth)\" class=\"form-control\"></td><td><input disabled=\"\" type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_growth.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_growth)\" class=\"form-control\"></td><td><input disabled=\"\" type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_growth.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_growth)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.net_profit_growth.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Profitability</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.profitability }}</td></tr><tr><td translate=\"\">Gross margin</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.gross_margin | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.gross_margin.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.gross_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.gross_margin.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.gross_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.gross_margin.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.gross_margin)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.gross_margin.total_score }}</td></tr><tr><td translate=\"\">Operating profit margin</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.operating_profit_margin | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.operating_profit_margin.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.operating_profit_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.operating_profit_margin.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.operating_profit_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.operating_profit_margin.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.operating_profit_margin)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.operating_profit_margin.total_score }}</td></tr><tr><td translate=\"\">Net profit margin</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.net_profit_margin | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_margin.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_margin.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_margin)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.net_profit_margin.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.net_profit_margin)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.net_profit_margin.total_score }}</td></tr><tr><td translate=\"\">Return on equity (ROE)</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.return_on_equity | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_equity.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_equity)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_equity.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_equity)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_equity.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_equity)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.return_on_equity.total_score }}</td></tr><tr><td translate=\"\">Return on assets (ROA)</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.return_on_assets | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_assets.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_assets)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_assets.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_assets)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.return_on_assets.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.return_on_assets)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.return_on_assets.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Productivity</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.productivity }}</td></tr><tr><td translate=\"\">Asset turnover</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.asset_turnover | number:1\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.asset_turnover.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.asset_turnover)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.asset_turnover.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.asset_turnover)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.asset_turnover.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.asset_turnover)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.asset_turnover.total_score }}</td></tr><tr><td translate=\"\">Working capital turnover</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.working_capital_turnover | number:1\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.working_capital_turnover.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.working_capital_turnover)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.working_capital_turnover.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.working_capital_turnover)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.working_capital_turnover.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.working_capital_turnover)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.working_capital_turnover.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Solvency / Gearing</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.solvency }}</td></tr><tr><td translate=\"\">Debt-to-assets ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.debt_to_assets_ratio | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_assets_ratio.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_assets_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_assets_ratio.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_assets_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_assets_ratio.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_assets_ratio)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.debt_to_assets_ratio.total_score }}</td></tr><tr><td translate=\"\">Debt-to-equity ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.debt_to_equity_ratio | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_equity_ratio.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_equity_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_equity_ratio.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_equity_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_to_equity_ratio.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_to_equity_ratio)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.debt_to_equity_ratio.total_score }}</td></tr><tr><td translate=\"\">Debt to EBIT ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.debt_coverage_ratio | number:1 | percentage\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_coverage_ratio.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_coverage_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_coverage_ratio.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_coverage_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_coverage_ratio.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_coverage_ratio)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.debt_coverage_ratio.total_score }}</td></tr><tr><td translate=\"\">Interest coverage ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.debt_servicing | number:1\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_servicing.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_servicing)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_servicing.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_servicing)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.debt_servicing.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.debt_servicing)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.debt_servicing.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Liquidity</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.liquidity }}</td></tr><tr><td translate=\"\">Current ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.current_ratio | number:1\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.current_ratio.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.current_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.current_ratio.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.current_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.current_ratio.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.current_ratio)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.current_ratio.total_score }}</td></tr><tr><td translate=\"\">Quick ratio</td><td ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.quick_ratio | number:1\"></span></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.quick_ratio.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.quick_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.quick_ratio.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.quick_ratio)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.quick_ratio.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.quick_ratio)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.quick_ratio.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Working capital management</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.working_capital }}</td></tr><tr><td translate=\"\">Days inventory outstanding</td><td ng-if=\"!$last\" ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.days_inventory_outstanding | number\"></span></td><td ng-if=\"$last\" style=\"background-color:#eeeeee\" ng-repeat=\"item in assessment.financial_ratios.objects\"></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_inventory_outstanding.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_inventory_outstanding)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_inventory_outstanding.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_inventory_outstanding)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_inventory_outstanding.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_inventory_outstanding)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.days_inventory_outstanding.total_score }}</td></tr><tr><td translate=\"\">Days sales outstanding</td><td ng-if=\"!$last\" ng-repeat=\"item in assessment.financial_ratios.objects\"><span ng-bind=\"item.days_sales_outstanding | number\"></span></td><td ng-if=\"$last\" style=\"background-color:#eeeeee\" ng-repeat=\"item in assessment.financial_ratios.objects\"></td><td class=\"divider\"></td><td></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_sales_outstanding.status\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_sales_outstanding)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_sales_outstanding.trend\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_sales_outstanding)\" class=\"form-control\"></td><td><input type=\"number\" string-to-number=\"\" min=\"1\" max=\"5\" to-fixed=\"\" step=\"1\" ng-model=\"assessment.financial_scores.days_sales_outstanding.volatility\" ng-change=\"saveFinancialPerformance(assessment.financial_scores.days_sales_outstanding)\" class=\"form-control\"></td><td>{{ assessment.financial_scores.days_sales_outstanding.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Total Score</td><td class=\"divider\"></td><td colspan=\"4\"></td><td>{{ assessment.ratio_scores.total_score }}</td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\" class=\"comment-label\">Accountant notes on Financial Performance</label> <textarea name=\"accountantNotes\" id=\"accountantNotes\" spellcheck=\"true\" cols=\"30\" rows=\"10\" ng-change=\"saveRatioScores(assessment.ratio_scores)\" ng-model=\"assessment.ratio_scores.accountant_notes\" class=\"form-control\">\n                            </textarea></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"(assessment.tool.type.pro || assessment.tool.type.pro_sme) && assessment.with_general_checks\"><table class=\"table table-bordered financial statements\"><thead><tr><th translate=\"\">General checks</th><th translate=\"\">Available</th><th translate=\"\">Quality</th></tr></thead><tbody><tr class=\"group\"><td colspan=\"3\" translate=\"\">Financial</td></tr><tr><td translate=\"\">Balance sheet</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.balance_sheet.available\" ng-model=\"assessment.general_checks.balance_sheet.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.balance_sheet, \'available\')\" ng-checked=\"assessment.general_checks.balance_sheet.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.balance_sheet.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.balance_sheet, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Profit / Loss</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.profit_and_loss.available\" ng-model=\"assessment.general_checks.profit_and_loss.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.profit_and_loss, \'available\')\" ng-checked=\"assessment.general_checks.profit_and_loss.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.profit_and_loss.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.profit_and_loss, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Cash flow</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.cash_flow.available\" ng-model=\"assessment.general_checks.cash_flow.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.cash_flow, \'available\')\" ng-checked=\"assessment.general_checks.cash_flow.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.cash_flow.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.cash_flow, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Cash flow projections</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.cash_flow_projections.available\" ng-model=\"assessment.general_checks.cash_flow_projections.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.cash_flow_projections, \'available\')\" ng-checked=\"assessment.general_checks.cash_flow_projections.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.cash_flow_projections.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.cash_flow_projections, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Accepted format</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.accepted_format.available\" ng-model=\"assessment.general_checks.accepted_format.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.accepted_format, \'available\')\" ng-checked=\"assessment.general_checks.accepted_format.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.accepted_format.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.accepted_format, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Audited</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.audited.available\" ng-model=\"assessment.general_checks.audited.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.audited, \'available\')\" ng-checked=\"assessment.general_checks.audited.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.audited.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.audited, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Bank statements</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.bank_statements.available\" ng-model=\"assessment.general_checks.bank_statements.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.bank_statements, \'available\')\" ng-checked=\"assessment.general_checks.bank_statements.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.bank_statements.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.bank_statements, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Collateral</td></tr><tr><td translate=\"\">Asset register</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.asset_register.available\" ng-model=\"assessment.general_checks.asset_register.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.asset_register, \'available\')\" ng-checked=\"assessment.general_checks.asset_register.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.asset_register.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.asset_register, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Depreciation policy</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.depreciation_policy.available\" ng-model=\"assessment.general_checks.depreciation_policy.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.depreciation_policy, \'available\')\" ng-checked=\"assessment.general_checks.depreciation_policy.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.depreciation_policy.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.depreciation_policy, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">External valuation</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.external_valuation.available\" ng-model=\"assessment.general_checks.external_valuation.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.external_valuation, \'available\')\" ng-checked=\"assessment.general_checks.external_valuation.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.external_valuation.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.external_valuation, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Record keeping</td></tr><tr><td translate=\"\">Software system</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.software_system.available\" ng-model=\"assessment.general_checks.software_system.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.software_system, \'available\')\" ng-checked=\"assessment.general_checks.software_system.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.software_system.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.software_system, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Loan history</td></tr><tr><td translate=\"\">Recorded in financial statement</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.loan_recorded_in_financial_statement.available\" ng-model=\"assessment.general_checks.loan_recorded_in_financial_statement.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.loan_recorded_in_financial_statement, \'available\')\" ng-checked=\"assessment.general_checks.loan_recorded_in_financial_statement.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.loan_recorded_in_financial_statement.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.loan_recorded_in_financial_statement, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr><td translate=\"\">Default known</td><td><label><input type=\"checkbox\" name=\"assessment.general_checks.loan_default_known.available\" ng-model=\"assessment.general_checks.loan_default_known.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.loan_default_known, \'available\')\" ng-checked=\"assessment.general_checks.loan_default_known.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.loan_default_known.quality\" ng-change=\"saveGeneralChecks(assessment.general_checks.loan_default_known, \'quality\')\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Grants</td></tr><tr><td translate=\"\">Recorded in financial statement</td><td class=\"text-center\"><label><input type=\"checkbox\" name=\"assessment.general_checks.grants_recorded_in_financial_statement.available\" ng-model=\"assessment.general_checks.grants_recorded_in_financial_statement.available\" ng-change=\"saveGeneralChecks(assessment.general_checks.grants_recorded_in_financial_statement, \'available\')\" ng-checked=\"assessment.general_checks.grants_recorded_in_financial_statement.available\"></label></td><td><select chosen=\"\" data-placeholder-text-single=\"\'Select an Option\' | translate\" ng-model=\"assessment.general_checks.grants_recorded_in_financial_statement.quality\" ng-options=\"option.value as (option.name | translate | capitalize) for option in dropdowns\" ng-change=\"saveGeneralChecks(assessment.general_checks.grants_recorded_in_financial_statement, \'quality\')\" class=\"input input-full-width\"><option value=\"\"></option></select></td></tr></tbody></table></div></div></fieldset></fieldset></form></div></div>");
$templateCache.put("assessments/partials/observationsTabView.html","<form name=\"observationsForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.observations_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"observations_tab_accepted\" is-completed=\"observations_tab_completed\" is-disabled=\"observationsForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Observations\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"observationsForm.$invalid\" is-completed=\"observations_tab_completed\" is-form-completed=\"observationsForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><si-info-text-display assessment=\"assessment\" key=\"info_observations_tab_main\"><h3 class=\"m-b-md\" translate=\"\">Observations</h3></si-info-text-display><div class=\"tab-content observations-tab\"><div class=\"row observations-row\" ng-repeat=\"section in assessment.section_responses.objects track by $index\"><div class=\"col-md-2\"><si-info-text-display assessment=\"assessment\" key=\"{{observationsInfoKeys[section.section_title]}}\"><span>{{ section.section_title }} <span class=\"text-danger\">*</span></span></si-info-text-display></div><div class=\"col-md-5\" ng-repeat=\"response in section.unscored_responses.objects\"><p><strong>{{ response.question_title }}</strong></p><form-textarea form-name=\"unscored_section_responses\" update-fct=\"updateFormElement(response, \'answer\', model, {observationsForm: observationsForm})\" required=\"true\" show-error=\"showTabWarnings\" model=\"response.answer\"></form-textarea></div><button ng-disabled=\"!assessment.isQuestionnaireDone\" class=\"btn btn-primary\" ng-click=\"generateWithAi(section.id, section)\" translate=\"\"><translate>Generate by AI</translate></button> <span class=\"text-danger\" translate=\"\">Disclaimer: The content generated by AI in this application may be incorrect, incomplete, or unintended. Users should verify information and use it at their own discretion.</span></div><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on observations\' | translate\" label-size=\"large\" info-text-key=\"info_observations_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_observations\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_observations\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_observations\', assessment.assessor_comments_observations, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></div></fieldset></div></form>");
$templateCache.put("assessments/partials/organizationalTabView.html","<form name=\"organizationForm\" form-to-tab-validator=\"\" is-accepted=\"!assessment.tool.type.agent ? assessment.organizational_tab_accepted : assessment.agent_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><div ng-if=\"!assessment.tool.type.agent\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"organizational_tab_accepted\" is-completed=\"organizational_tab_completed\" is-disabled=\"organizationForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Organization\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"organizationForm.$invalid\" is-completed=\"organizational_tab_completed\" is-form-completed=\"organizationForm.$valid\" assessment=\"assessment\"></axr-complete-tab></div><div ng-if=\"assessment.tool.type.agent\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"agent_tab_accepted\" is-completed=\"agent_tab_completed\" is-disabled=\"organizationForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Agent\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"organizationForm.$invalid\" is-completed=\"agent_tab_completed\" is-form-completed=\"organizationForm.$valid\" assessment=\"assessment\"></axr-complete-tab></div><fieldset ng-disabled=\"isFormDisabled()\"><div class=\"row\"><div class=\"col-lg-6\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_basic_and_contact_details\"><h3 translate=\"\">Basic and Contact Details</h3></si-info-text-display><div class=\"row\"><label ng-if=\"!assessment.tool.type.input_retailer && !assessment.tool.type.is_sacco\" class=\"col-md-3 control-label\" translate=\"\">Name</label> <label ng-if=\"assessment.tool.type.is_sacco\" class=\"col-md-3 control-label\" translate=\"\">Savings and Credit Cooperative</label> <label ng-if=\"assessment.tool.type.input_retailer\" class=\"col-md-3 control-label\" translate=\"\">Business Name</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" disabled=\"\" ng-model=\"assessment.producing_organization.customer.name\"></div></div><form-input ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.name_owner\')\" label=\"\'Owner Name\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.name_owner\" type=\"text\" minlength=\"1\" form-name=\"name_owner\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'name_owner\', model, {organizationForm: organizationForm})\"></form-input><form-input ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.abbreviation\')\" label=\"\'Abbreviation\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.abbreviation\" type=\"text\" minlength=\"1\" form-name=\"abbreviation\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'abbreviation\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Street\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.street\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'street\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Street no.\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.street_number\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'street_number\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Zipcode\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.zipcode\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'zipcode\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'City\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.city\" type=\"text\" minlength=\"1\" required=\"true\" form-name=\"city\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment.producing_organization, \'city\', model, {organizationForm: organizationForm})\"></form-input><form-input disabled=\"true\" label=\"\'Region\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.global_region\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'second_region\', model, {organizationForm: organizationForm})\"></form-input><form-select label=\"\'Country\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.country\" options=\"dropdowns.countryOptions\" option-value=\"name\" minlength=\"1\" required=\"true\" ng-if=\"!isFormDisabled()&&!disableCountry()\" form-name=\"country\" show-error=\"showTabWarnings\" placeholder=\"\'Select an Option\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization, \'country\', model, {organizationForm: organizationForm}, getRegions)\"></form-select><div ng-if=\"assessment.tool.type.is_sacco && assessment.producing_organization.country==\'Ethiopia\'\"><form-input label=\"\'Kebele\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.kebele\" type=\"text\" minlength=\"1\" required=\"true\" form-name=\"kebele\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment.producing_organization, \'kebele\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Woreda\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.woreda\" type=\"text\" minlength=\"1\" required=\"true\" form-name=\"woreda\" show-error=\"showTabWarnings\" update-fct=\"updateFormElement(assessment.producing_organization, \'woreda\', model, {organizationForm: organizationForm})\"></form-input></div><div class=\"row\" ng-if=\"isFormDisabled()||disableCountry()\"><label class=\"col-md-3 control-label\" translate=\"\">Country</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" disabled=\"\" ng-model=\"assessment.producing_organization.country\"></div></div><form-select label=\"\'Region (ISO)\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.region_iso\" options=\"regions\" option-value=\"value\" minlength=\"1\" form-name=\"region_iso\" placeholder=\"\'Select an Option\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization, \'region_iso\', model, {organizationForm: organizationForm})\"></form-select><form-gps label=\"\'GPS Code\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"true\" form-name=\"gps_location\" show-error=\"showTabWarnings\" is-offline=\"isOffline\" model=\"assessment.producing_organization.gps_location\" update-fct=\"updateFormElement(assessment.producing_organization, \'gps_location\', model, {organizationForm: organizationForm})\"></form-gps><form-input conditional-label=\"assessment.tool.type.agent ? 1 : 2\" conditional-label-1=\"\'Phone Number\' | translate\" conditional-label-2=\"\'Office Phone Number\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.phone_number\" type=\"text\" minlength=\"1\" show-error=\"showTabWarnings\" form-name=\"phone_number\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'phone_number\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Email Address\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.email\" type=\"email\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'email\', model, {organizationForm: organizationForm})\"></form-input><form-select ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.gender\')\" label=\"\'Gender\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.gender\" options=\"genders\" disabled=\"!assessment.tool.type.agent ? assessment.organizational_tab_accepted && assignment.submitted_at_least_once && assessment.full_completion_check_required : assessment.agent_tab_accepted && assignment.submitted_at_least_once && assessment.full_completion_check_required\" option-value=\"value\" placeholder=\"\'Select an Option\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'gender\', model, {organizationForm: organizationForm})\"></form-select><form-number ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.age\')\" label=\"\'Age\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.age\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'age\', model, {organizationForm: organizationForm})\"></form-number><form-number ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.household_members\')\" label=\"\'# of Household Members\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.household_members\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'household_members\', model, {organizationForm: organizationForm})\"></form-number><form-input ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.languages_spoken\')\" label=\"\'Languages spoken\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.languages_spoken\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'languages_spoken\', model, {organizationForm: organizationForm})\"></form-input><form-input ng-if=\"shouldShowSection(\'organizational_tab.basic_contact.website\')\" label=\"\'Website\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.customer.website\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'website\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Affiliated Organization Name\' | translate\" label-width=\"3\" info-text-key=\"info_affiliated_organization_name\" assessment=\"assessment\" max=\"100\" wrapper=\"row\" model=\"assessment.producing_organization.customer.affiliated_organization_name\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'affiliated_organization_name\', model, {organizationForm: organizationForm})\"></form-input><div ng-if=\"shouldShowSection(\'organizational_tab.additional_details\')\"><hr><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_additional_details\"><h3 translate=\"\">Additional details</h3></si-info-text-display><yes-no-bool label=\"\'Member of a cooperative\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization.customer.member_of_cooperative\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'member_of_cooperative\', model, {organizationForm: organizationForm})\"></yes-no-bool><form-number label=\"\'Duration of membership\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.customer.duration_of_cooperative_membership\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'duration_of_cooperative_membership\', model, {organizationForm: organizationForm})\"></form-number><yes-no-bool label=\"\'Member of other group\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization.customer.member_of_other_group\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'member_of_other_group\', model, {organizationForm: organizationForm})\"></yes-no-bool><form-number label=\"\'Duration of membership\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.customer.duration_of_other_group_membership\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'duration_of_other_group_membership\', model, {organizationForm: organizationForm})\"></form-number><yes-no-bool label=\"\'Owner of farm land\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization.customer.owner_of_farmland\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'owner_of_farmland\', model, {organizationForm: organizationForm})\"></yes-no-bool><form-input label=\"\'Name of buyer(s)\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.customer.name_of_buyers\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization.customer, \'name_of_buyers\', model, {organizationForm: organizationForm})\"></form-input></div><div ng-if=\"shouldShowSection(\'organizational_tab.contacts\')\"><hr><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_contacts\"><h3 translate=\"\">Contacts</h3></si-info-text-display><si-contacts is-organization-tab=\"true\" contacts=\"assessment.producing_organization.customer.representatives\" is-contact-person=\"true\" add-contact=\"addRepresentative(contact)\" edit-contact=\"editRepresentative(contact)\" delete-contact=\"deleteRepresentative(contact)\"></si-contacts></div></div><div class=\"col-lg-6\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_assessee_image\"><h3 translate=\"\">Assessee Image</h3></si-info-text-display><si-assessee-image-upload images=\"assessment.images.objects\" assessment=\"assessment.url\" edit-image=\"editImage(image)\" add-image=\"addImage(image, assessment)\" is-offline=\"isOffline\"><hr></si-assessee-image-upload></div><div class=\"col-lg-6\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_sectors_and_activities\"><h3 ng-if=\"assessment.tool.type.input_retailer || assessment.tool.type.agent\"><translate>Sectors and Activities</translate><label class=\"text-danger\">*</label></h3><h3 ng-if=\"!(assessment.tool.type.input_retailer || assessment.tool.type.agent)\"><translate>Sectors</translate><label class=\"text-danger\">*</label></h3></si-info-text-display><form-checkboxes form-name=\"sectors\" required=\"true\" checkboxes=\"sectors.results\" checked-items=\"assessment.producing_organization.sectors.objects\" is-valid=\"assessment.producing_organization.sectors.objects.length\" should-validate=\"(assessment.organizational_tab_accepted && !assignment.submitted_at_least_once) || (!assessment.organizational_tab_accepted && assignment.submitted_at_least_once)\" show-error=\"showTabWarnings\" update-fct=\"toggleChecklist({url}, assessment.producing_organization.sectors.objects, \'sectors\', assessment.producing_organization.url)\"></form-checkboxes><hr><div ng-if=\"shouldShowSection(\'organizational_tab.activities\') && !assessment.tool.type.is_sacco\"><form-checkboxes heading=\"\'Services/Activities\' | translate\" info-text-key=\"info_organizational_tab_services_activities\" assessment=\"assessment\" form-name=\"activities\" required=\"true\" checkboxes=\"activities.results\" checked-items=\"assessment.producing_organization.activities.objects\" is-valid=\"assessment.producing_organization.activities.objects.length || (assessment.other_activities && assessment.other_activities !== \'\')\" should-validate=\"(assessment.organizational_tab_accepted && !assignment.submitted_at_least_once) || (!assessment.organizational_tab_accepted && assignment.submitted_at_least_once)\" show-error=\"showTabWarnings\" has-other=\"otherActivities\" has-other-checked=\"assessment.other_activities\" has-other-update-fct=\"patchAssessment(\'other_activities\', {value})\" update-fct=\"toggleChecklist({url}, assessment.producing_organization.activities.objects, \'activities\', assessment.producing_organization.url)\"></form-checkboxes><hr></div><div ng-if=\"shouldShowSection(\'organizational_tab.mission_vision\') && !assessment.tool.type.is_rapid\"><form-textarea label=\"\'Mission\' | translate\" label-size=\"large\" info-text-key=\"info_organizational_tab_mission\" assessment=\"assessment\" wrapper=\"row\" minlength=\"1\" required=\"true\" form-name=\"mission\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.mission\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'mission\', model, {organizationForm: organizationForm})\"></form-textarea><hr><form-textarea label=\"\'Vision\' | translate\" label-size=\"large\" info-text-key=\"info_organizational_tab_vision\" assessment=\"assessment\" wrapper=\"row\" minlength=\"1\" required=\"true\" form-name=\"vision\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.vision\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'vision\', model, {organizationForm: organizationForm})\"></form-textarea><hr><small translate=\"\">* in case the Vision or Mission are not available please indicate above: \"The mission (vision) is not available\"</small></div><div ng-if=\"shouldShowSection(\'organizational_tab.related_farmers\')\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_related_farmers\"><h3 translate=\"\">Related farmers</h3></si-info-text-display><form-number label=\"\'Number of male farmers under supervision\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_male_farmers_under_supervision\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_farmers_under_supervision\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_farmers_under_supervision\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'Number of female farmers under supervision\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_female_farmers_under_supervision\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_farmers_under_supervision\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_farmers_under_supervision\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'Number of potential male farmers\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_potential_male_farmers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_potential_male_farmers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_potential_male_farmers\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'Number of potential female farmers\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_potential_female_farmers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_potential_female_farmers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_potential_female_farmers\', model, {organizationForm: organizationForm})\"></form-number><hr></div><div ng-if=\"assessment.tool.type.input_retailer && shouldShowSection(\'organizational_tab.employees\')\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_employees\"><h3 translate=\"\">Employees</h3></si-info-text-display><form-number label=\"\'# of male full-time employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_male_full_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_full_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_full_time_employees\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'# of female full-time employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_female_full_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_full_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_full_time_employees\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'# of male part-time employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_male_part_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_part_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_part_time_employees\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'# of female part-time employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_female_part_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_part_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_part_time_employees\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'# of male seasonal employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_male_seasonal_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_seasonal_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_seasonal_employees\', model, {organizationForm: organizationForm})\"></form-number><form-number label=\"\'# of female seasonal employees\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization_details.number_of_female_seasonal_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_seasonal_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_seasonal_employees\', model, {organizationForm: organizationForm})\"></form-number></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div ng-if=\"shouldShowSection(\'organizational_tab.incorporation\')\"><hr><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_incorporation\"><h3 translate=\"\">Incorporation</h3></si-info-text-display><form-select label=\"\'Legal Status\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.legal_status\" options=\"dropdowns.legalStatusOptions\" option-value=\"url\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"legal_status\" placeholder=\"\'Select an Option\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization, \'legal_status\', model, {organizationForm: organizationForm})\"><span ng-if=\"legal_status.$valid\">valid</span></form-select><form-input label=\"\'Specification\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.legal_status_specification\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'legal_status_specification\', model, {organizationForm: organizationForm})\"></form-input><form-select label=\"\'Year of incorporation\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" ng-disabled=\"isFormDisabled()\" model=\"assessment.producing_organization.year_of_incorporation\" options=\"years\" option-value=\"name\" show-error=\"showTabWarnings\" form-name=\"year_of_incorporation\" placeholder=\"\'Select a Year\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization, \'year_of_incorporation\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.in_operation_since\')\" label=\"\'In operation since\' | translate\" label-width=\"6\" wrapper=\"row\" required=\"true\" disabled=\"!assessment.tool.type.agent ? assessment.organizational_tab_accepted && assessment.submitted_at_least_once && assessment.full_completion_check_required : assessment.agent_tab_accepted && assessment.submitted_at_least_once && assessment.full_completion_check_required\" model=\"assessment.producing_organization.in_operation_since\" options=\"years\" option-value=\"name\" show-error=\"showTabWarnings\" form-name=\"in_operation_since\" placeholder=\"\'Select a Year\' | translate\" update-fct=\"updateFormElement(assessment.producing_organization, \'in_operation_since\', model, {organizationForm: organizationForm})\"><span ng-if=\"in_operation_since.$valid\">valid</span></form-select><form-input label=\"\'Registration/Business license number\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.business_license_number\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'business_license_number\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Tax identification number\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.tax_identification_number\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'tax_identification_number\', model, {organizationForm: organizationForm})\"></form-input><div ng-show=\"!assessment.tool.type.input_retailer\"><form-number label=\"\'Number of Shareholders\' | translate\" label-width=\"6\" wrapper=\"row\" model=\"assessment.producing_organization.number_of_shareholders\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization, \'number_of_shareholders\', model)\"></form-number></div></div></div><div class=\"col-lg-6\"><section ng-if=\"shouldShowSection(\'organizational_tab.representing_organization\')\"><hr><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_umbrella_representing_organization\"><h3 translate=\"\">Umbrella/Representing Organization</h3></si-info-text-display><form-input label=\"\'Cooperative\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.cooperative\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'cooperative\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Union\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.union\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'union\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Federation\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.federation\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'federation\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Apex Organization\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.apex_organization\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'apex_organization\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'SACCO\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.sacco\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'sacco\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Other\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization_details.other_representing_organizations\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'other_representing_organizations\', model, {organizationForm: organizationForm})\"></form-input></section></div></div><div class=\"row\" ng-if=\"!assessment.tool.type.input_retailer && !assessment.tool.type.agent\"><table class=\"table table-bordered soft\"><thead><tr><th style=\"width: 380px\"></th><th style=\"width: 120px\" translate=\"\">Male</th><th style=\"width: 120px\" translate=\"\">Female</th><th style=\"width: 100px\" translate=\"\">Total</th><th style=\"width: 120px\" translate=\"\">Estimated % of total under the age of 30</th><th translate=\"\">Comment</th></tr></thead><tbody><div ng-if=\"shouldShowSection(\'organizational_tab.board_and_management\')\"><tr class=\"sub\"><td colspan=\"5\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_board_and_management\"><span translate=\"\">Board and management</span></si-info-text-display></td></tr><tr><td><translate>Board member</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_non_executives\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_non_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_non_executives\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_non_executives\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_non_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_non_executives\', model, {organizationForm: organizationForm})\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_non_executives + assessment.producing_organization_details.number_of_female_non_executives | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_non_executives_under_30\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_non_executives\" max=\"100\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_non_executives_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_non_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_non_executives\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_non_executives\"></form-textarea></td></tr><tr><td><translate>Manager / key staff</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_executives\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_executives\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_executives\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_executives\', model, {organizationForm: organizationForm})\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_executives + assessment.producing_organization_details.number_of_female_executives | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_executives_under_30\" allow-negative=\"false\" max=\"100\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"percent_of_executives_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_executives_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_executives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_executives\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_executives\"></form-textarea></td></tr></div><div ng-if=\"shouldShowSection(\'organizational_tab.employees\')\"><tr class=\"sub\"><td colspan=\"5\" translate=\"\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_employees\"><span translate=\"\">Employees</span></si-info-text-display></td></tr><tr><td><translate>Full-time employee</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_full_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_full_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_full_time_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_full_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_full_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_full_time_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_full_time_employees + assessment.producing_organization_details.number_of_female_full_time_employees | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_full_time_employees_under_30\" max=\"100\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"percent_of_full_time_employees_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_full_time_employees_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_full_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_full_time_employees\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_full_time_employees\"></form-textarea></td></tr><tr><td><translate>Part-time employee</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_part_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_part_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_part_time_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_part_time_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_part_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_part_time_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_part_time_employees + assessment.producing_organization_details.number_of_female_part_time_employees | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_part_time_employees_under_30\" allow-negative=\"false\" max=\"100\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"percent_of_part_time_employees_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_part_time_employees_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_part_time_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_part_time_employees\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_part_time_employees\"></form-textarea></td></tr><tr><td><translate ng-if=\"!assessment.tool.type.is_sacco\">Seasonal employee</translate><translate ng-if=\"assessment.tool.type.is_sacco\">Volunteer</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_seasonal_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_seasonal_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_seasonal_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_seasonal_employees\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_seasonal_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_seasonal_employees\', model, {organizationForm: organizationForm})\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_seasonal_employees+assessment.producing_organization_details.number_of_female_seasonal_employees | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_seasonal_employees_under_30\" allow-negative=\"false\" required=\"true\" max=\"100\" show-error=\"showTabWarnings\" form-name=\"percent_of_seasonal_employees_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_seasonal_employees_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_seasonal_employees\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_seasonal_employees\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_seasonal_employees\"></form-textarea></td></tr></div><div ng-if=\"shouldShowSection(\'organizational_tab.members_suppliers\')\"><tr class=\"sub\"><td colspan=\"5\"><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_members\"><span ng-if=\"!assessment.tool.type.basic_sme && !assessment.tool.type.pro_sme && !assessment.tool.type.is_sacco\" translate=\"\">Membership and outgrowers</span> <span ng-if=\"assessment.tool.type.is_sacco\" translate=\"\">Membership</span> <span ng-if=\"assessment.tool.type.basic_sme || assessment.tool.type.pro_sme\" translate=\"\">Suppliers</span></si-info-text-display></td></tr><tr><td><span ng-if=\"!assessment.tool.type.basic_sme && !assessment.tool.type.pro_sme\"><translate>Member</translate><span class=\"text-danger\">*</span></span> <span ng-if=\"assessment.tool.type.basic_sme || assessment.tool.type.pro_sme\" translate=\"\">Individual Suppliers <span class=\"text-danger\">*</span></span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_members\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_members\', model, {organizationForm: organizationForm})\" min=\"assessment.producing_organization_details.number_of_male_active_members\" out-of-bounds-error-msg=\"\'Number of male members can not be less than number of active male members!\'\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_members\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_members\', model, {organizationForm: organizationForm})\" min=\"assessment.producing_organization_details.number_of_female_active_members\" out-of-bounds-error-msg=\"\'Number of female members can not be less than number of active female members!\'\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_members+assessment.producing_organization_details.number_of_female_members | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_members_under_30\" min=\"0\" max=\"100\" required=\"false\" show-error=\"showTabWarnings\" form-name=\"percent_of_members_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_members_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_members\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_members\"></form-textarea></td></tr><tr ng-if=\"assessment.tool.type.pro || assessment.tool.type.basic\"><td><translate>Active member</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_active_members\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_active_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_active_members\', model, {organizationForm: organizationForm})\" max=\"assessment.producing_organization_details.number_of_male_members\" out-of-bounds-error-msg=\"\'Number of active male members can not be more than total number of male members!\'\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_active_members\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_active_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_active_members\', model, {organizationForm: organizationForm})\" max=\"assessment.producing_organization_details.number_of_female_members\" out-of-bounds-error-msg=\"\'Number of active female members can not be more than total number of female members!\'\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_active_members+assessment.producing_organization_details.number_of_female_active_members | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_active_members_under_30\" allow-negative=\"false\" required=\"true\" max=\"100\" show-error=\"showTabWarnings\" form-name=\"percent_of_active_members_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_active_members_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_active_members\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_active_members\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_active_members\"></form-textarea></td></tr></div><tr ng-if=\"shouldShowSection(\'organizational_tab.outgrowers\') && !assessment.tool.type.is_sacco\"><td><translate>Outgrower</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_outgrowers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_outgrowers\', model, {organizationForm: organizationForm})\" min=\"assessment.producing_organization_details.number_of_male_active_outgrowers\" out-of-bounds-error-msg=\"\'Number of male outgrowers can not be less than number of active male outgrowers!\'\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_outgrowers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_outgrowers\', model, {organizationForm: organizationForm})\" min=\"assessment.producing_organization_details.number_of_female_active_outgrowers\" out-of-bounds-error-msg=\"\'Number of female outgrowers can not be less than number of active female outgrowers!\'\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_outgrowers+assessment.producing_organization_details.number_of_female_outgrowers | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_outgrowers_under_30\" allow-negative=\"false\" max=\"100\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"percent_of_outgrowers_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_outgrowers_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_outgrowers\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_outgrowers\"></form-textarea></td></tr><tr ng-if=\"shouldShowSection(\'organizational_tab.outgrowers\') && !assessment.tool.type.is_sacco\"><td><translate>Active outgrower</translate><span class=\"text-danger\">*</span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_male_active_outgrowers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_male_active_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_male_active_outgrowers\', model, {organizationForm: organizationForm})\" max=\"assessment.producing_organization_details.number_of_male_outgrowers\" out-of-bounds-error-msg=\"\'Number of active male outgrowers can not be more than total number of male outgrowers!\'\"></form-number></div></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_female_active_outgrowers\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_female_active_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_female_active_outgrowers\', model, {organizationForm: organizationForm})\" max=\"assessment.producing_organization_details.number_of_female_outgrowers\" out-of-bounds-error-msg=\"\'Number of active female outgrowers can not be more than total number of female outgrowers!\'\"></form-number></div></td><td class=\"data-cell\">{{assessment.producing_organization_details.number_of_male_active_outgrowers+assessment.producing_organization_details.number_of_female_active_outgrowers | number }}</td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.percent_of_active_outgrowers_under_30\" allow-negative=\"false\" max=\"100\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"percent_of_active_outgrowers_under_30\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'percent_of_active_outgrowers_under_30\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_active_outgrowers\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_active_outgrowers\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_active_outgrowers\"></form-textarea></td></tr></tbody></table><br><table ng-if=\"!assessment.tool.type.is_sacco\" class=\"table table-bordered soft\"><thead><tr><th style=\"width: 380px\"></th><th style=\"width: 300px\" translate=\"\">Total</th><th translate=\"\">Comment</th></tr></thead><tbody><tr><td><span ng-if=\"assessment.tool.type.pro || assessment.tool.type.basic\"><translate>Member cooperatives</translate><span class=\"text-danger\">*</span></span> <span ng-if=\"assessment.tool.type.pro_sme || assessment.tool.type.basic_sme\"><translate>Supplier cooperatives</translate><span class=\"text-danger\">*</span></span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_member_cooperatives\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_member_cooperatives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_member_cooperatives\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_member_cooperatives\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_member_cooperatives\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_member_cooperatives\"></form-textarea></td></tr><tr><td><span ng-if=\"assessment.tool.type.pro || assessment.tool.type.basic\"><translate>Member unions</translate><span class=\"text-danger\">*</span></span> <span ng-if=\"assessment.tool.type.pro_sme || assessment.tool.type.basic_sme\"><translate>Supplier unions</translate><span class=\"text-danger\">*</span></span></td><td><div class=\"col-sm-12\"><form-number model=\"assessment.producing_organization_details.number_of_member_unions\" allow-negative=\"false\" required=\"true\" show-error=\"showTabWarnings\" form-name=\"number_of_member_unions\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'number_of_member_unions\', model, {organizationForm: organizationForm})\"></form-number></div></td><td><form-textarea assessment=\"assessment\" form-name=\"comment_number_of_member_unions\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'comment_number_of_member_unions\', model, {assessmentForm: assessmentForm})\" show-error=\"showTabWarnings\" model=\"assessment.producing_organization_details.comment_number_of_member_unions\"></form-textarea></td></tr></tbody></table></div><hr><div class=\"row\" ng-if=\"!assessment.tool.type.is_rapid\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-form=\"\" name=\"governanceStructure\"><si-info-text-display assessment=\"assessment\" key=\"info_governance_tab_governance_structure\"><h3><span translate=\"\">Governance Structure</span> <span ng-show=\"assessment.governance_structure_completed && assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!assessment.governance_structure_completed && showTabWarnings && assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></h3></si-info-text-display><fieldset ng-disabled=\"assessment.governance_structure_completed && assessment.full_completion_check_required\"><table class=\"table table-striped\"><thead><tr><th></th><th><translate>Present</translate><span class=\"text-danger\">*</span></th><th><translate>Number of People</translate><span class=\"text-danger\">*</span></th><th><translate>Description</translate><span class=\"text-danger\">*</span></th><th translate=\"\">Remove</th></tr></thead><tbody ng-form=\"\" name=\"governanceStructures\"><tr ng-repeat=\"gov in assessment.governance_set.objects\" ng-form=\"\" name=\"{{parseName(gov.name)}}\"><th width=\"20%\"><translate>{{ gov.name }}</translate></th><td><yes-no-bool form-name=\"bool_{{parseName(gov.name)}}\" wrapper=\"row\" model=\"gov.present\" required=\"true\" show-error=\"showTabWarnings\" update-fct=\"updateGovernanceSet($index, {present: model})\"></yes-no-bool></td><td><form-number form-name=\"input_{{parseName(gov.name)}}\" wrapper=\"row\" model=\"gov.number_of_people\" allow-negative=\"false\" required=\"gov.present\" show-error=\"showTabWarnings\" update-fct=\"updateGovernanceSet($index, {number_of_people: model})\"></form-number></td><td><form-textarea form-name=\"textarea_{{parseName(gov.name)}}\" update-fct=\"updateGovernanceSet($index, {description: model})\" minlength=\"{{gov.present ? 1 : 0}}\" required=\"gov.present\" show-error=\"showTabWarnings\" model=\"gov.description\"></form-textarea></td><td><button ng-if=\"!gov.auto_created\" type=\"button\" ng-click=\"editGovernanceStructure(gov)\" class=\"btn btn-xs center\"><i class=\"fa fa-pencil\"></i></button> <button ng-if=\"!gov.auto_created\" type=\"button\" ng-click=\"removeGovernance(gov)\" class=\"btn btn-xs btn-danger center\"><i class=\"fa fa-times\"></i></button></td></tr><tr><td colspan=\"13\"><button class=\"btn btn-primary\" translate=\"\" ng-click=\"addGovernanceStructure()\">Add New Governance Structure</button></td></tr></tbody></table></fieldset><span ng-if=\"assessment.full_completion_check_required\"><input type=\"checkbox\" name=\"governance_structure_completed\" ng-model=\"assessment.governance_structure_completed\" ng-checked=\"assessment.governance_structure_completed\" ng-show=\"false\" required=\"\"><button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.governance_set.objects.length === 0\" ng-click=\"markGovernanceStructureDone(\'governance_structure_no_information_available\')\"><translate>No information</translate><span ng-if=\"assessment.governance_structure_no_information_available\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.governance_set.objects.length !== 0\" ng-disabled=\"governanceStructures.$invalid && !assessment.governance_structure_completed\" ng-click=\"markGovernanceStructureDone(\'governance_structure_completed\')\"><translate>Complete</translate><span ng-if=\"assessment.governance_structure_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button></span></div></div><hr><div class=\"row\"><div class=\"col-md-6\" ng-if=\"shouldShowSection(\'organizational_tab.infrastructure_information\')\"><h3 ng-if=\"assessment.tool.type.agent\" translate=\"\">Infrastructure and Transport</h3><si-info-text-display assessment=\"assessment\" key=\"info_organizational_tab_infrastructure_information\"><h3 ng-if=\"!assessment.tool.type.agent\" translate=\"\">Infrastructure information</h3></si-info-text-display><form-select ng-if=\"shouldShowSection(\'organizational_tab.personal_transportation\')\" label=\"\'Personal transportation\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"personal_transportation\" model=\"assessment.producing_organization_details.personal_transportation\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.personaltransportation_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'personal_transportation\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.access_roads\')\" label=\"\'Access roads\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"access_roads\" model=\"assessment.producing_organization_details.access_roads\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.access_roads_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'access_roads\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.distance_to_hub\')\" label=\"\'Distance to hub\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"distance_to_hub\" model=\"assessment.producing_organization_details.distance_to_hub\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.distance_to_hub_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'distance_to_hub\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.demonstration_plot\')\" label=\"\'Demonstration plot\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"demonstration_plot\" model=\"assessment.producing_organization_details.demonstration_plot\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.demonstration_plot_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'demonstration_plot\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.training_space\')\" label=\"\'Training space\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"training_space\" model=\"assessment.producing_organization_details.training_space\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.training_space_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'training_space\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.public_transportation\')\" label=\"\'Public transportation\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" show-error=\"showTabWarnings\" ng-disabled=\"isFormDisabled()\" form-name=\"public_transportation\" model=\"assessment.producing_organization_details.public_transportation\" placeholder=\"\'Select an option\' | translate\" options=\"dropdown.publictransportation_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'public_transportation\', model, {organizationForm: organizationForm})\"></form-select><form-select label=\"\'Power / electricity\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"power_electricity\" model=\"assessment.producing_organization_details.power_electricity\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.power_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'power_electricity\', model, {organizationForm: organizationForm})\"></form-select><form-select ng-if=\"shouldShowSection(\'organizational_tab.computer_access\')\" label=\"\'Computer access\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"computer_access\" model=\"assessment.producing_organization_details.computer_access\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.computeraccess_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'computer_access\', model, {organizationForm: organizationForm})\"></form-select><form-select label=\"\'Internet access\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"internet_access\" model=\"assessment.producing_organization_details.internet_access\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.internet_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'internet_access\', model, {organizationForm: organizationForm})\"></form-select><form-select label=\"\'Mobile network coverage\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"mobile_network_coverage\" model=\"assessment.producing_organization_details.mobile_network_coverage\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.mobilenetworkcoverage_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'mobile_network_coverage\', model, {organizationForm: organizationForm})\"></form-select><form-select label=\"\'Running water\' | translate\" label-width=\"6\" wrapper=\"row\" minlength=\"1\" required=\"true\" ng-disabled=\"isFormDisabled()\" show-error=\"showTabWarnings\" form-name=\"running_water\" model=\"assessment.producing_organization_details.running_water\" placeholder=\"\'Select an Option\' | translate\" options=\"dropdown.runningwater_options.objects\" option-value=\"name\" update-fct=\"updateFormElement(assessment.producing_organization_details, \'running_water\', model, {organizationForm: organizationForm})\"></form-select></div><div class=\"col-md-6\"><div ng-if=\"shouldShowSection(\'organizational_tab.management_body\') && assessment.with_management_body\"><hr><h3 translate=\"\">Management Body</h3><form-input label=\"\'Founder\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.founder\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'founder\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Entrepreneur\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.entrepreneur\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'entrepreneur\', model, {organizationForm: organizationForm})\"></form-input><form-input label=\"\'Managing Director\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.managing_director\" type=\"text\" update-fct=\"updateFormElement(assessment.producing_organization, \'managing_director\', model, {organizationForm: organizationForm})\"></form-input><form-number label=\"\'Number of Shareholders\' | translate\" label-width=\"3\" wrapper=\"row\" model=\"assessment.producing_organization.number_of_shareholders\" allow-negative=\"false\" update-fct=\"updateFormElement(assessment.producing_organization, \'number_of_shareholders\', model, {organizationForm: organizationForm})\"></form-number></div></div></div><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on organization\' | translate\" label-size=\"large\" info-text-key=\"info_organizational_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_organizational\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_organizational\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_organizational\', assessment.assessor_comments_organizational, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></div></form>");
$templateCache.put("assessments/partials/productionTabView.html","<form name=\"productionForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.production_tab_accepted\" is-not-valid=\"isProductionTabNotValid(assessment)\" assessment=\"assessment\"><div class=\"panel-body\" style=\"min-height:100px\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"production_tab_accepted\" is-disabled=\"isProductionTabNotValid(assessment)\" is-completed=\"production_tab_completed\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Production\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"productionForm.$invalid\" is-completed=\"production_tab_completed\" is-form-completed=\"productionForm.$valid\" assessment=\"assessment\"></axr-complete-tab><si-info-text-display assessment=\"assessment\" key=\"info_production_tab_main\"><span ng-if=\"assessment.tool.type.input_retailer\"><h3 class=\"m-b-md\" translate=\"\">Products Sold</h3></span> <span ng-if=\"assessment.tool.type.agent\"><h3 class=\"m-b-md\" translate=\"\">Production</h3></span> <span ng-if=\"!assessment.tool.type.input_retailer && !assessment.tool.type.input_retailer\"><h3 class=\"m-b-md\" translate=\"\">Production &amp; Sales</h3></span></si-info-text-display><fieldset ng-disabled=\"isFormDisabled()\"><div ng-hide=\"assessment.products_no_information_available\"><p ng-if=\"assessment.products.objects.length === 0\" translate=\"\">Add a product or indicate no information is available.</p><p ng-if=\"assessment.products.objects.length > 0\" translate=\"\">Select a product below to see and modify the production details on the right.</p></div><div ng-show=\"assessment.products_no_information_available\"><p translate=\"\">No product information available.</p></div><input type=\"checkbox\" ng-show=\"false\" required=\"\" name=\"hidden\" ng-model=\"assessment.production_tab_completed\" ng-checked=\"assessment.production_tab_completed\"><uib-tabset class=\"tabs-left\" ng-form=\"\" name=\"innerProductionForm\" active=\"active\"><uib-tab ng-repeat=\"product in assessment.products.objects\"><uib-tab-heading><span ng-bind=\"product.display_name\"></span> &nbsp; <span ng-show=\"innerProductionForm[parseName(product.name)].$valid && assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"showTabWarnings && assessment.full_completion_check_required\"><span ng-show=\"innerProductionForm[parseName(product.name)].$invalid\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></uib-tab-heading><div class=\"row\" ng-form=\"\" name=\"{{ parseName(product.name) }}\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><div ng-if=\"assessment.tool.type.input_retailer\"></div><div ng-if=\"!assessment.tool.type.input_retailer\"><si-info-text-display assessment=\"assessment\" key=\"info_production_tab_product_information\"><h3 translate=\"\">Product Information</h3></si-info-text-display><dl class=\"dl-vertical\"><div><dt translate=\"\">Product category</dt><dd>{{ product.global_product_type }}</dd><dt translate=\"\">Product name</dt><dd>{{ product.display_name }}</dd><dt translate=\"\">Crop importance</dt><dd>{{ product.priority }}</dd><div ng-if=\"!assessment.tool.type.is_rapid\"><dt ng-if=\"assessment.tool.type.input_retailer\"><translate>Type</translate></dt><dd>{{ product.display_type }}</dd><div ng-if=\"shouldShowSection(\'production_tab.quality\')\"><dt ng-if=\"assessment.tool.type.input_retailer\"><translate>Quality</translate></dt><dd>{{ product.quality }}</dd></div></div></div><div ng-if=\"!assessment.tool.type.is_rapid\"><div ng-if=\"shouldShowSection(\'production_tab.primary_production\')\"><dt translate=\"\">Primary Production</dt><dd>{{ product.primary_production ? \"Yes\" : product.primary_production == false ? \"No\" : (\"N/A\" | translate) }}</dd></div><div ng-if=\"product.primary_production !== false\"><div ng-if=\"assessment.tool.type.input_retailer\"><dt><translate>Land used for product</translate></dt><dd>{{ product.land_used_for_product }}</dd></div><div ng-if=\"assessment.tool.type.input_retailer\"><dt translate=\"\"># of production units</dt><dd>{{ product.number_of_production_unit | number }}</dd></div><dt ng-if=\"!assessment.tool.type.input_retailer\"><translate>Estimated yearly average yield</translate><dd>{{ product.average_yield | number }} {{ product.display_average_yield_unit | capitalize}}</dd><dt ng-if=\"!assessment.tool.type.input_retailer\"><translate>How much land is under production by the entire member base</translate><dd>{{ product.land_size_under_production | number }}</dd></dt><dt ng-if=\"!assessment.tool.type.input_retailer\"><translate>Number of production units used for production</translate><dd>{{ product.land_used_for_product | number }} {{ product.display_land_unit | capitalize}}</dd></dt><dt ng-if=\"!assessment.tool.type.input_retailer\"><translate>Total production by members (estimated)</translate><dd>{{ product.total_prod_members | number }} {{ product.display_average_yield_unit | capitalize}}</dd></dt><div ng-if=\"assessment.tool.type.input_retailer\"><dt translate=\"\">Avg. age production unit (years)</dt><dd>{{ product.average_age_of_production_unit }}</dd></div></dt></div></div></dl><dl class=\"dl-vertical\"><div ng-if=\"(product.primary_production !== false)&&(!assessment.tool.type.is_rapid)\"><div ng-if=\"assessment.tool.type.input_retailer\"><dt translate=\"\">Avg. production unit lifetime(years)</dt><dd>{{ product.average_production_unit_lifetime }}</dd><dt translate=\"\">Dead/Diseased production units(%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_dead_diseased_production_units }} %;\" class=\"progress-bar\"></div></div>{{ product.percent_dead_diseased_production_units }}</dd><div><dt translate=\"\">harvest cycles per year</dt><dd>{{ product.number_of_harvest_cycles_per_year }}</dd></div><dt translate=\"\">Operational months</dt><dd><span class=\"label\" style=\"display:inline-block\" ng-repeat=\"month in product.operational_months\">{{ month | translate }}</span></dd><dt translate=\"\">Irrigated (%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_irrigated }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_irrigated }}</dd></div><dt translate=\"\">Production unit</dt><dd>{{ product.display_production_unit }}</dd><div ng-if=\"!assessment.tool.type.basic_sme && !assessment.tool.type.pro_sme\"><dt translate=\"\">Part of member production sold to organization</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization | number }}</dd></div><div ng-if=\"shouldShowSection(\'production_tab.certifications\')\"><dt translate=\"\">Certification(s)</dt><dd ng-if=\"product.certifications.objects.length\" ng-repeat=\"certification in product.certifications.objects track by $index\" ng-bind=\"certification.name\"></dd><dd ng-if=\"!product.certifications.objects.length\" translate=\"\">None</dd></div></div></dl></div><span ng-if=\"assessment.project.can_edit_assessments\"><fieldset ng-disabled=\"(assessment.products_no_information_available || assessment.production_tab_completed) && assessment.full_completion_check_required\"><button type=\"button\" ng-click=\"saveProduct(assessment, product)\" class=\"btn btn-xs\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"removeProduct(product)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-times\"></i></button></fieldset></span></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><fieldset ng-disabled=\"(assessment.products_no_information_available || assessment.production_tab_completed) && assessment.full_completion_check_required && !assessment.project.can_edit_assessments\"><table-comp ng-if=\"shouldShowSection(\'production_tab.productionpurchases\')\" heading=\"{{ \'Produce purchased from members\' | translate }}\" key=\"productionpurchases\" assessment=\"assessment\" info-text-key=\"info_production_tab_produce_purchased\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionPurchaseInfoRows\" no-info=\"productionpurchases_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionpurchases_no_info_reason\" table-complete=\"productionpurchases_completed\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveProductionPurchaseInfo(assessment, product)\" update-fct=\"saveProductionPurchaseInfo(assessment, product, row)\" is-table-disabled=\"{{isFormDisabled()}}\" delete-fct=\"removeProductionPurchaseInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.otherproductionpurchases\')\" heading=\"{{ \'Produce purchased from others\' | translate }}\" key=\"otherproductionpurchases\" assessment=\"assessment\" info-text-key=\"info_production_tab_other_produce_purchased\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionPurchaseInfoRows\" no-info=\"otherproductionpurchases_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"otherproductionpurchases_no_info_reason\" table-complete=\"otherproductionpurchases_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveOtherProductionPurchaseInfo(assessment, product)\" update-fct=\"saveOtherProductionPurchaseInfo(assessment, product, row)\" delete-fct=\"removeOtherProductionPurchaseInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.productionfigures\')\" heading=\"{{ titles.productionFigures | translate }}\" key=\"productionfigures\" assessment=\"assessment\" info-text-key=\"info_production_tab_production_figures\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionFiguresRows\" no-info=\"productionfigures_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionfigures_no_info_reason\" table-complete=\"productionfigures_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveProductionInfo(assessment, product)\" update-fct=\"saveProductionInfo(assessment, product, row)\" delete-fct=\"removeProductionInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.productionsales\')\" heading=\"{{ \'Produce sold\' | translate }}\" key=\"productionsales\" assessment=\"assessment\" info-text-key=\"info_production_tab_produce_sold\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionSalesRows\" no-info=\"productionsales_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionsales_no_info_reason\" table-complete=\"productionsales_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveProductionSalesInfo(assessment, product)\" update-fct=\"saveProductionSalesInfo(assessment, product, row)\" delete-fct=\"removeProductionSalesInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.productionmargins\') && assessment.with_margins_raw_materials\" heading=\"{{ \'Margins\' | translate }}\" key=\"productionmargins\" assessment=\"assessment\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionMarginsRows\" no-info=\"productionmargins_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionmargins_no_info_reason\" table-complete=\"productionmargins_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveMarginInfo(assessment, product)\" update-fct=\"saveMarginInfo(assessment, product, row)\" delete-fct=\"removeMarginInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.input_purchases\') || assessment.with_margins_raw_materials\" heading=\"{{ titles.inputPurchases | translate }}\" key=\"input_purchases\" assessment=\"assessment\" info-text-key=\"info_production_tab_inputs_purchased\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionInputPurchasesRows\" no-info=\"input_purchases_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"input_purchases_no_info_reason\" table-complete=\"input_purchases_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveInputPurchaseInfo(assessment, product)\" update-fct=\"saveInputPurchaseInfo(assessment, product, row)\" delete-fct=\"removeInputPurchaseInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp></fieldset></div><div class=\"clearfix\"></div><div class=\"row\"><fieldset ng-disabled=\"(assessment.products_no_information_available || assessment.production_tab_completed) && assessment.full_completion_check_required && !assessment.project.can_edit_assessments\" class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 m-l-md\"><table-comp ng-if=\"shouldShowSection(\'production_tab.sold_to_farmers\') && hasSubType(product)\" heading=\"{{ \'Sales to Farmers\' | translate }}\" key=\"sold_to_farmers\" assessment=\"assessment\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionSoldToFarmersRows\" no-info=\"sold_to_farmers_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionmargins_no_info_reason\" table-complete=\"sold_to_farmers_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveSoldToFarmersInfo(assessment, product)\" update-fct=\"saveSoldToFarmersInfo(assessment, product, row)\" delete-fct=\"removeSoldToFarmersInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp><table-comp ng-if=\"shouldShowSection(\'production_tab.sold_to_farmers\') && !hasSubType(product)\" heading=\"{{ \'Sales to Farmers\' | translate }}\" key=\"sold_to_farmers\" assessment=\"assessment\" info-text-key=\"info_production_tab_sales_to_farmers\" table-data=\"product\" is-flat=\"true\" show-error=\"showTabWarnings\" field-map=\"productionSoldToFarmersRowsNoSub\" no-info=\"sold_to_farmers_no_information_available\" no-info-reason=\"true\" no-info-reason-key=\"productionmargins_no_info_reason\" table-complete=\"sold_to_farmers_completed\" is-table-disabled=\"{{isFormDisabled()}}\" update-form=\"updateFormElement(obj, key, val, {productionForm: productionForm})\" create-fct=\"saveSoldToFarmersInfo(assessment, product)\" update-fct=\"saveSoldToFarmersInfo(assessment, product, row)\" delete-fct=\"removeSoldToFarmersInfo(product, row)\" is-disabled=\"assessment.production_tab_completed\"></table-comp></fieldset></div></div></uib-tab><span ng-if=\"assessment.project.can_edit_assessments\"><button type=\"button\" ng-click=\"saveProduct(assessment)\" ng-disabled=\"(assessment.production_tab_completed || assessment.products_no_information_available) && assessment.full_completion_check_required\" class=\"btn btn-primary btn-horizontal\"><i class=\"fa fa-plus\"></i> <span translate=\"\">Add</span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"shouldShowNoInfoButton(assessment)\" ng-click=\"markProductTabDone(\'products_no_information_available\')\" ng-disabled=\"assessment.production_tab_accepted && app === \'dashboard\'\"><translate>No information</translate><span ng-if=\"assessment.products_no_information_available\">&nbsp; <i class=\"fa fa-check\"></i></span></button><button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"(assessment.products.objects.length !== 0 && assessment.full_completion_check_required) || (assessment.production_tab_completed && products_no_information_available)\" ng-disabled=\"!canConfirm()\" ng-click=\"markProductTabDone(\'production_tab_completed\')\"><translate>Complete</translate><span ng-if=\"assessment.production_tab_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button><div ng-if=\"assessment.products_no_information_available\"><form-select label=\"\'Select why information is not available:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"!assessment.production_tab_accepted && assessment.products_no_information_available\" show-error=\"showTabWarnings\" model=\"assessment.productionsales_no_product_no_info_reason\" options=\"noInfoReasonDropdown\" option-value=\"name\" disabled=\"assessment.production_tab_accepted && app === \'dashboard\'\" update-fct=\"updateFormElement(assessment, \'productionsales_no_product_no_info_reason\', model, {productionForm: productionForm})\"><span ng-if=\"noInfoReasonKey.$valid\">valid</span></form-select></div></span></uib-tabset><div class=\"clearfix\"></div></fieldset><div class=\"source_of_data_container\" ng-if=\"!assessment.products_no_information_available && assessment.products.objects.length > 0\"><form-select label=\"\'Select source of data:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"!assessment.production_tab_completed\" options=\"source_of_data_dropdown\" option-value=\"display_name\" disabled=\"assessment.production_tab_completed\" model=\"assessment.production_and_sales_source_of_data_source\" update-fct=\"assessment.production_and_sales_source_of_data_source = model\"></form-select></div><file-upload-component ng-if=\"!assessment.products_no_information_available && assessment.products.objects.length > 0\" assessment-id=\"assessment.id\" file-type=\"production_and_sales\" current-file-name=\"assessment.production_and_sales_source_of_data_file_name\" source-of-data=\"assessment.production_and_sales_source_of_data_source\" is-disabled=\"assessment.production_tab_completed\" file-input-id=\"production_and_sales_file_input\" on-files-change=\"handleFilesChange(files, fileType, isRequired, hasFiles)\"></file-upload-component><br><fieldset ng-disabled=\"isFormDisabled()\"><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on production & sales\' | translate\" label-size=\"large\" info-text-key=\"info_production_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_production\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_production\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_production\', assessment.assessor_comments_production, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></form>");
$templateCache.put("assessments/partials/profitLossTabView.html","<div class=\"panel-body assessment__profit-loss\"><div class=\"tab-content\"><form name=\"profitLossForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.profit_loss_tab_accepted\" assessment=\"assessment\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchFinancialTab(name, value, \'profit_loss_tab_completed\')\" is-accepted=\"profit_loss_tab_accepted\" is-completed=\"profit_loss_tab_completed\" is-disabled=\"profitLossForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Profit / Loss\" assessment=\"assessment\" reopen-text=\"{{financialTabs.reopenText}}\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"profitLossForm.$invalid\" is-completed=\"profit_loss_tab_completed\" is-form-completed=\"profitLossForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><input type=\"checkbox\" ng-show=\"false\" required=\"\" name=\"hidden\" ng-model=\"assessment.profit_loss_tab_completed\" ng-checked=\"assessment.profit_loss_tab_completed\"> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"assessment.full_completion_check_required\" ng-click=\"markProfitLossTabDone(\'profit_loss_tab_completed\', \'profit_loss_tab_accepted\')\" ng-disabled=\"!canConfirm()\"><translate>Completed</translate><span ng-if=\"assessment.profit_loss_tab_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button><div class=\"top-buttons\"><div class=\"top-buttons__heading\"><si-info-text-display assessment=\"assessment\" key=\"info_profit_loss_tab_main\"><h3 translate=\"\">Profit / Loss Statement</h3></si-info-text-display><h4 class=\"label label-primary\" translate=\"\">Maximum of 5 years and minimum of 3 years allowed.</h4></div><div class=\"top-buttons__actions\"><div><span><translate>Selected Currency:&nbsp;</translate><span ng-bind=\"global_currency\"></span></span><select chosen=\"\" ng-model=\"global_currency\" ng-disabled=\"assessment.profit_loss_tab_completed\" ng-change=\"updateCurrency(global_currency)\" ng-options=\"k as (k + \': \' + v.name) for (k, v) in currencies\"><option></option></select></div><div><translate>End of Book Year:</translate><month-dropdown ng-model=\"assessment.end_of_bookyear\" is-disabled=\"assessment.profit_loss_tab_completed\" placeholder=\"\'Select an Option\' | translate\" update=\"updateAssessment(\'end_of_bookyear\')\"></month-dropdown></div><fieldset ng-disabled=\"assessment.profit_loss_tab_completed\"><div uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"><translate>Year Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" style=\"color: white;\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-if=\"assessment.profitlossstatements.objects.length === 0\"><a ng-click=\"addPLYear()\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-plus\"></i><translate>Add Year</translate></a></li><li role=\"menuitem\" ng-if=\"assessment.profitlossstatements.objects.length < 5 && assessment.profitlossstatements.objects.length > 0\"><a ng-click=\"addPLYear(\'highest\')\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-plus\"></i><translate>Add Higher Year</translate></a></li><li role=\"menuitem\" ng-if=\"assessment.profitlossstatements.objects.length < 5 && assessment.profitlossstatements.objects.length > 0\"><a ng-click=\"addPLYear(\'lowest\')\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-plus\"></i><translate>Add Lower Year</translate></a></li><li role=\"menuitem\" ng-if=\"assessment.profitlossstatements.objects.length > 3 && assessment.profitlossstatements.objects.length > 0\"><a ng-click=\"removePLYear(\'highest\')\" class=\"btn btn-danger btn-sm\"><i class=\"fa fa-minus\"></i><translate>Remove Highest Year</translate></a></li><li role=\"menuitem\" ng-if=\"assessment.profitlossstatements.objects.length > 3 && assessment.profitlossstatements.objects.length > 0\"><a ng-click=\"removePLYear(\'lowest\')\" class=\"btn btn-danger btn-sm\"><i class=\"fa fa-minus\"></i><translate>Remove Lowest Year</translate></a></li></ul></div></fieldset></div></div><fieldset ng-disabled=\"assessment.profit_loss_tab_completed\"><table class=\"table table-bordered financial flow\"><thead class=\"table__header-controls\"><tr><th translate=\"\">Profit / Loss Statement</th><th style=\"width: 150px\" ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><button ng-if=\"$first\" class=\"btn btn-outline\" ng-disabled=\"assessment.profitlossstatements.objects.length === 5\" ng-click=\"addPLYear(\'highest\')\"><i class=\"fa fa-plus\" ng-class=\"{\'text-navy\': assessment.profitlossstatements.objects.length < 5, \'text-muted\': assessment.profitlossstatements.objects.length === 5}\"></i></button> <button ng-if=\"$last\" class=\"btn btn-outline\" ng-disabled=\"assessment.profitlossstatements.objects.length <= 3\" ng-click=\"removePLYear(\'lowest\')\"><i class=\"fa fa-trash\" ng-class=\"{\'text-danger\': assessment.profitlossstatements.objects.length > 3, \'text-muted\': assessment.profitlossstatements.objects.length <= 3}\"></i></button> <span ng-bind=\"pl.year\"></span> <button ng-if=\"$first\" class=\"btn btn-outline\" ng-disabled=\"assessment.profitlossstatements.objects.length <= 3\" ng-click=\"removePLYear(\'highest\')\"><i class=\"fa fa-trash\" ng-class=\"{\'text-danger\': assessment.profitlossstatements.objects.length > 3, \'text-muted\': assessment.profitlossstatements.objects.length <= 3}\"></i></button> <button ng-if=\"$last\" class=\"btn btn-outline\" ng-disabled=\"assessment.profitlossstatements.objects.length === 5\" ng-click=\"addPLYear(\'lowest\')\"><i class=\"fa fa-plus\" ng-class=\"{\'text-navy\': assessment.profitlossstatements.objects.length < 5, \'text-muted\': assessment.profitlossstatements.objects.length === 5}\"></i></button></th></tr><tr><th translate=\"\">No Data</th><th style=\"width: 150px\" ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><input type=\"checkbox\" ng-model=\"pl.no_data\" ng-change=\"toggleNoData(pl)\"></th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Sales</td><td colspan=\"{{ assessment.profitlossstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Direct sales</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.direct_sales.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'direct_sales\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Indirect sales</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.indirect_sales.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'indirect_sales\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr class=\"group sub-total\"><td translate=\"\">Total sales</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.total_sales.amount | number\"></span> <span ng-if=\"!pl.total_sales.amount\">0</span></td></tr><tr class=\"sub\"><td colspan=\"{{ assessment.profitlossstatements.objects.length }}\" translate=\"\">Cost of sales</td><td colspan=\"{{ assessment.profitlossstatements.objects.length }}\"></td></tr><tr ng-repeat=\"(name, obj) in assessment.all_costs_of_sales track by $index\"><td><span translate=\"\" ng-bind=\"name\"></span> <button class=\"btn btn-xs btn-danger btn-horizontal pull-right\" ng-click=\"removeRow(assessment.all_costs_of_sales, name)\"><i class=\"fa fa-times\"></i></button> <button class=\"btn btn-xs btn-horizontal pull-right\" ng-click=\"addCostOfSales(name)\"><i class=\"fa fa-pencil\"></i></button></td><td ng-repeat=\"item in obj\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.value.amount\" update-fct=\"saveAllCostsOfSales(assessment.all_costs_of_sales, model, name, $index)\" allow-negative=\"true\" is-disabled=\"assessment.profitlossstatements.objects[$index].no_data\"></form-number></div></td></tr><tr><td colspan=\"{{ assessment.profitlossstatements.objects.length + 1 }}\"><button class=\"btn btn-primary\" ng-click=\"addCostOfSales()\" translate=\"\">Add</button></td></tr><tr class=\"group sub-total\"><td translate=\"\">Total cost of sales</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.total_cost_of_sales.amount | number\"></span> <span ng-if=\"!pl.total_cost_of_sales.amount\">0</span></td></tr><tr class=\"group total\"><td translate=\"\">Gross profit</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.gross_profit.amount | number\"></span> <span ng-if=\"!pl.gross_profit.amount\">0</span></td></tr><tr class=\"sub\"><td colspan=\"{{ assessment.profitlossstatements.objects.length + 1 }}\" translate=\"\">Selling, general and administrative expense</td></tr><tr ng-repeat=\"(name, obj) in assessment.all_expenses track by $index\"><td><span translate=\"\" ng-bind=\"name\"></span> <button class=\"btn btn-xs btn-danger btn-horizontal pull-right\" ng-click=\"removeRow(assessment.all_expenses, name)\"><i class=\"fa fa-times\"></i></button> <button class=\"btn btn-xs btn-horizontal pull-right\" ng-click=\"addExpense(name)\"><i class=\"fa fa-pencil\"></i></button></td><td ng-repeat=\"item in obj\"><div class=\"col-sm-12 expand-input\"><form-number model=\"item.value.amount\" update-fct=\"saveAllExpenses(assessment.all_expenses, model, name, $index)\" allow-negative=\"true\" is-disabled=\"assessment.profitlossstatements.objects[$index].no_data\"></form-number></div></td></tr><tr><td colspan=\"{{ assessment.profitlossstatements.objects.length + 1 }}\"><button class=\"btn btn-primary\" ng-click=\"addExpense()\" translate=\"\">Add</button></td></tr><tr><td translate=\"\">Other income</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.other_income.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'other_income\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr class=\"group total\"><td translate=\"\">EBITDA</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.ebitda.amount | number\"></span> <span ng-if=\"!pl.ebitda.amount\">0</span></td></tr><tr><td translate=\"\">Depreciation and amortization</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.depreciation_and_amortization.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'depreciation_and_amortization\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr class=\"group total\"><td translate=\"\">EBIT</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.ebit.amount | number\"></span> <span ng-if=\"!pl.ebit.amount\">0</span></td></tr><tr><td translate=\"\">Interest expense</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.interest_expense.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'interest_expense\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr><td translate=\"\">Income tax expense</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.income_tax_expense.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'income_tax_expense\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr class=\"group total\"><td translate=\"\">Income from continuing operations</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.income_from_continuing_operations.amount | number\"></span> <span ng-if=\"!pl.income_from_continuing_operations.amount\">0</span></td></tr><tr><td translate=\"\">Earnings (losses) from discontinued operations (net of tax)</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><div class=\"col-sm-12 expand-input\"><form-number model=\"pl.earnings_from_discontinued_operations.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'earnings_from_discontinued_operations\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></div></td></tr><tr class=\"group total\"><td>Net Profit</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.net_profit.amount | number\"></span></td></tr></tbody></table></fieldset><fieldset ng-disabled=\"assessment.profit_loss_tab_completed\"><div class=\"above-seperator\"><table class=\"table table-bordered financial\"><thead><tr><th translate=\"\">Verifications</th><th style=\"width: 150px\" ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><span ng-bind=\"pl.year\"></span></th></tr></thead><tbody><tr><td translate=\"\">Net Profit</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><form-number model=\"pl.manual_net_profit.amount\" update-fct=\"saveProfitLossStatement(pl, model, \'manual_net_profit\')\" allow-negative=\"true\" is-disabled=\"pl.no_data\"></form-number></td></tr><tr><td translate=\"\">Check Net profit</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><si-compare-values compare-to=\"pl.net_profit.amount\" value=\"pl.manual_net_profit.amount\" is-disabled=\"pl.no_data\"></si-compare-values></td></tr><tr class=\"group sub-total\"><td translate=\"\">Are accounts audited?</td><td ng-repeat=\"pl in assessment.profitlossstatements.objects track by $index\"><input type=\"checkbox\" ng-model=\"pl.audited\" ng-change=\"toggleAudited(pl)\"></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\" class=\"comment-label\">Accountant notes on Profit and Loss</label> <textarea name=\"accountant_comments_profitloss\" id=\"accountant_comments_profitloss\" assessment=\"assessment\" spellcheck=\"true\" cols=\"30\" rows=\"10\" ng-change=\"updateTextareas(assessment.accountant_comments_profitloss, \'accountant_comments_profitloss\', assessment)\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"assessment.accountant_comments_profitloss\" class=\"form-control\">\n                            </textarea></div></div></fieldset></fieldset><br><div class=\"source_of_data_container\"><form-select label=\"\'Select source of data:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"4\" wrapper=\"row\" required=\"!assessment.profit_loss_tab_completed\" options=\"dropdown\" option-value=\"display_name\" disabled=\"assessment.profit_loss_tab_completed\" model=\"assessment.profit_loss_source_of_data_source\" update-fct=\"assessment.profit_loss_source_of_data_source = model\"></form-select></div><br></form><file-upload-component assessment-id=\"assessment.id\" file-type=\"profit_loss\" current-file-name=\"assessment.profit_loss_source_of_data_file_name\" source-of-data=\"assessment.profit_loss_source_of_data_source\" is-disabled=\"assessment.profit_loss_tab_completed\" file-input-id=\"profit_loss_file_input\" on-files-change=\"handleFilesChange(files, fileType, isRequired, hasFiles)\"></file-upload-component></div></div>");
$templateCache.put("assessments/partials/qcDashboardTabView.html","<div ng-if=\"!loading\" class=\"qc-dashboard-container\"><header class=\"qc-header\"><div><h1>Data Quality Dashboard</h1><br><h3 ng-if=\"standalonePage\">{{assessment.producing_organization_name}}</h3></div><style>\n            :root {\n                --bg: #f5f7fb;\n                --bg-card: #ffffff;\n                --border-soft: #e1e4ec;\n                --text-main: #111827;\n                --text-muted: #6b7280;\n                --accent: #2563eb;\n                --success: #16a34a;\n                --warning: #f97316;\n                --error: #ef4444;\n                --critical: #b91c1c;\n                --radius-lg: 16px;\n                --shadow-soft: 0 10px 26px rgba(15, 23, 42, 0.08);\n                --font-main: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n            }\n            .qc-dashboard-container {\n                font-family: var(--font-main);\n                color: var(--text-main);\n                padding: 24px;\n                line-height: 1.6;\n                margin: 0 auto;\n                }\n\n                .qc-header {\n                display: flex;\n                justify-content: space-between;\n                align-items: flex-start;\n                gap: 16px;\n                margin-bottom: 16px;\n                }\n\n                .qc-header h1 {\n                font-size: 24px;\n                font-weight: 600;\n                margin: 0;\n                }\n\n                .summary-cards {\n                display: grid;\n                grid-template-columns: repeat(3, minmax(0, 1fr));\n                gap: 16px;\n                margin-bottom: 20px;\n                }\n\n                .card-metric {\n                background: var(--bg-card);\n                border-radius: 18px;\n                padding: 14px 16px;\n                box-shadow: var(--shadow-soft);\n                border: 1px solid var(--border-soft);\n                display: flex;\n                flex-direction: column;\n                gap: 6px;\n                position: relative;\n                overflow: hidden;\n                }\n\n                .card-metric::before {\n                content: \"\";\n                position: absolute;\n                inset: 0;\n                pointer-events: none;\n                background: radial-gradient(circle at top right, rgba(37, 99, 235, 0.12), transparent 55%);\n                opacity: 0.7;\n                }\n\n                .card-metric-inner {\n                position: relative;\n                z-index: 1;\n                display: flex;\n                flex-direction: column;\n                gap: 6px;\n                }\n\n                .card-label {\n                font-size: 12px;\n                text-transform: uppercase;\n                letter-spacing: 0.05em;\n                color: var(--text-muted);\n                font-weight: 600;\n                }\n\n                .card-value {\n                font-size: 22px;\n                font-weight: 600;\n                }\n\n                .card-meta {\n                font-size: 12px;\n                color: var(--text-muted);\n                }\n\n                .chip {\n                font-size: 11px;\n                padding: 2px 8px;\n                border-radius: 999px;\n                display: inline-flex;\n                align-items: center;\n                gap: 4px;\n                border: 1px solid rgba(148, 163, 184, 0.5);\n                background: rgba(249, 250, 251, 0.9);\n                color: var(--text-muted);\n                width: fit-content;\n                }\n\n                .chip.success {\n                background: #dcfce7;\n                color: var(--success);\n                border-color: transparent;\n                }\n\n                .chip.warning {\n                background: #ffedd5;\n                color: var(--warning);\n                border-color: transparent;\n                }\n\n                .chip.error {\n                background: #fee2e2;\n                color: var(--error);\n                border-color: transparent;\n                }\n\n                .chip.critical {\n                background: #fecaca;\n                color: var(--critical);\n                border-color: transparent;\n                }\n\n                .chip-dot {\n                width: 8px;\n                height: 8px;\n                border-radius: 999px;\n                background: currentColor;\n                }\n\n                /* Filters */\n                .filters-row {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 10px;\n                margin-bottom: 22px;\n                align-items: flex-start;\n                }\n\n                .filters-row label {\n                font-size: 11px;\n                text-transform: uppercase;\n                letter-spacing: 0.04em;\n                color: var(--text-muted);\n                font-weight: 600;\n                display: block;\n                margin-bottom: 8px;\n                }\n\n                .filter-group {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                }\n\n                .pill-filter-group {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 6px;\n                }\n\n                .pill {\n                padding: 4px 10px;\n                border-radius: 999px;\n                border: 1px solid var(--border-soft);\n                font-size: 12px;\n                cursor: pointer;\n                background: #f9fafb;\n                color: var(--text-muted);\n                transition: all 0.2s ease;\n                }\n\n                .pill:hover {\n                border-color: var(--accent);\n                background: #f0f7ff;\n                }\n\n                .pill.active {\n                background: var(--accent);\n                color: white;\n                border-color: var(--accent);\n                }\n\n                .search-input {\n                padding: 6px 10px;\n                border-radius: 999px;\n                border: 1px solid var(--border-soft);\n                font-size: 13px;\n                outline: none;\n                background: #f9fafb;\n                font-family: var(--font-main);\n                min-width: 220px;\n                transition: all 0.2s ease;\n                }\n\n                .search-input:focus {\n                border-color: var(--accent);\n                background: #ffffff;\n                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n                }\n\n                /* Category sections */\n                .category-section {\n                margin-bottom: 28px;\n                }\n\n                .category-header {\n                display: flex;\n                justify-content: space-between;\n                align-items: baseline;\n                gap: 12px;\n                margin-bottom: 8px;\n                flex-wrap: wrap;\n                }\n\n                .category-title {\n                font-size: 16px;\n                font-weight: 600;\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                }\n\n                .category-subtitle {\n                font-size: 13px;\n                color: var(--text-muted);\n                }\n\n                .category-stat {\n                font-size: 12px;\n                color: var(--text-muted);\n                }\n\n                .category-stat strong {\n                color: var(--text-main);\n                font-weight: 600;\n                }\n\n                .tag {\n                font-size: 11px;\n                padding: 2px 6px;\n                border-radius: 999px;\n                background: #f3f4f6;\n                border: 1px solid #e5e7eb;\n                }\n\n                .category-table-wrapper {\n                border-radius: 14px;\n                border: 1px solid var(--border-soft);\n                overflow: hidden;\n                background: var(--bg-card);\n                box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n                overflow-x: auto;\n                }\n\n                table {\n                width: 100%;\n                border-collapse: collapse;\n                font-size: 13px;\n                }\n\n                thead {\n                background: #f3f4f6;\n                }\n\n                th,\n                td {\n                padding: 8px 12px;\n                text-align: left;\n                border-bottom: 1px solid #edf0f5;\n                vertical-align: top;\n                }\n\n                th {\n                font-size: 11px;\n                text-transform: uppercase;\n                letter-spacing: 0.05em;\n                color: var(--text-muted);\n                white-space: nowrap;\n                font-weight: 600;\n                }\n\n                tr:last-child td {\n                border-bottom: none;\n                }\n\n                tbody tr {\n                transition: background 0.12s ease;\n                }\n\n                tbody tr:hover {\n                background: #f9fafb;\n                }\n\n                .severity-pill {\n                display: inline-flex;\n                align-items: center;\n                gap: 4px;\n                font-size: 11px;\n                padding: 2px 8px;\n                border-radius: 999px;\n                font-weight: 500;\n                white-space: nowrap;\n                }\n\n                .severity-pill.warning {\n                background: #ffedd5;\n                color: var(--warning);\n                }\n\n                .severity-pill.error {\n                background: #fee2e2;\n                color: var(--error);\n                }\n\n                .severity-pill.critical {\n                background: #fecaca;\n                color: var(--critical);\n                }\n\n                .severity-dot {\n                width: 8px;\n                height: 8px;\n                border-radius: 999px;\n                background: currentColor;\n                }\n\n                .col-observed {\n                max-width: 260px;\n                }\n\n                @media (max-width: 1024px) {\n                .summary-cards {\n                    grid-template-columns: repeat(2, minmax(0, 1fr));\n                }\n                }\n\n                @media (max-width: 720px) {\n                .qc-dashboard-container {\n                    padding: 16px;\n                }\n\n                .qc-header {\n                    flex-direction: column;\n                    align-items: flex-start;\n                }\n\n                .summary-cards {\n                    grid-template-columns: 1fr;\n                }\n\n                .filters-row {\n                    flex-direction: column;\n                    align-items: stretch;\n                }\n\n                .filter-group {\n                    width: 100%;\n                }\n\n                .search-input {\n                    width: 100%;\n                    min-width: unset;\n                }\n                }\n        </style></header><section class=\"summary-cards\"><article class=\"card-metric\"><div class=\"card-metric-inner\"><div class=\"card-label\">Warnings</div><div class=\"card-value\">{{summary.warnings}}</div><div class=\"card-meta\"></div><span class=\"chip warning\"><span class=\"chip-dot\"></span>Review trend and outlier checks</span></div></article><article class=\"card-metric\"><div class=\"card-metric-inner\"><div class=\"card-label\">Errors</div><div class=\"card-value\">{{summary.errors}}</div><div class=\"card-meta\"></div><span class=\"chip error\"><span class=\"chip-dot\"></span>Blocking issues in financials and volumes</span></div></article><article class=\"card-metric\"><div class=\"card-metric-inner\"><div class=\"card-label\">Critical</div><div class=\"card-value\">{{summary.critical}}</div><div class=\"card-meta\">Suspected copy paste or impossible patterns</div><span class=\"chip critical\"><span class=\"chip-dot\"></span>Escalation needed for investigation</span></div></article></section><section class=\"filters-row\"><div class=\"filter-group\"><label>Severity</label><div class=\"pill-filter-group\"><button class=\"pill\" ng-class=\"{\'active\': filters.severity === \'All\'}\" ng-click=\"filterBySeverity(\'All\')\">All</button> <button class=\"pill\" ng-class=\"{\'active\': filters.severity === \'warning\'}\" ng-click=\"filterBySeverity(\'warning\')\">Warnings</button> <button class=\"pill\" ng-class=\"{\'active\': filters.severity === \'error\'}\" ng-click=\"filterBySeverity(\'error\')\">Errors</button> <button class=\"pill\" ng-class=\"{\'active\': filters.severity === \'critical\'}\" ng-click=\"filterBySeverity(\'critical\')\">Critical</button></div></div><div class=\"filter-group\"><label>Category</label><div class=\"pill-filter-group\"><button class=\"pill\" ng-class=\"{\'active\': filters.category === cat}\" ng-repeat=\"cat in categories\" ng-click=\"filterByCategory(cat)\">{{cat}}</button></div></div><div class=\"filter-group\"><label>QC Type</label><div class=\"pill-filter-group\"><button class=\"pill\" ng-class=\"{\'active\': filters.qcType === type}\" ng-repeat=\"type in qcTypes\" ng-click=\"filterByQcType(type)\">{{type}}</button></div></div><div class=\"filter-group\" style=\"margin-left: auto;\"><label for=\"search\">Search</label> <input id=\"search\" type=\"text\" class=\"search-input\" placeholder=\"Search in rules, indicators, notes\" ng-model=\"filters.searchText\" ng-change=\"applyFilters()\"></div></section><section class=\"category-section\" ng-repeat=\"category in categoriesData\" ng-show=\"isCategoryVisible(category)\"><div class=\"category-header\"><div><div class=\"category-title\">{{category.name}} <span class=\"tag\">{{category.checks.length}} checks</span></div><div class=\"category-subtitle\">{{category.description}}</div></div><div class=\"category-stat\"><strong>{{getCategoryStats(category)}}</strong> currently configured</div></div><div class=\"category-table-wrapper\"><table><thead><tr><th>Indicator</th><th>QC type</th><th class=\"col-observed\">Observed</th><th>Flag</th></tr></thead><tbody><tr ng-repeat=\"check in category.checks\" ng-show=\"isCheckVisible(check)\"><td>{{check.indicator}}</td><td>{{check.qcType}}</td><td class=\"col-observed\">{{check.observed}}</td><td><span class=\"severity-pill\" ng-class=\"check.severity\"><span class=\"severity-dot\"></span>{{check.severity | capitalize}}</span></td></tr></tbody></table></div></section></div>");
$templateCache.put("assessments/partials/qcLogTabView.html","<div class=\"panel-body\"><si-info-text-display assessment=\"assessment\" key=\"info_qc_log_tab_main\"><h3 class=\"m-b-md\" translate=\"\">QC Log</h3></si-info-text-display><h3 translate=\"\">Adjustments Made during Quality Control:</h3><si-page><div class=\"si-page__main__content\" style=\"flex: 1\"><table class=\"table table-bordered soft\"><thead><tr><th style=\"width:5%\" translate=\"\">Date</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:10%\" translate=\"\">User</th><th style=\"width:30%\" translate=\"\">Location</th><th style=\"width:30%\" translate=\"\">Field</th><th style=\"width:10%\" translate=\"\">Initial Value</th><th style=\"width:5%\" translate=\"\">New Value</th></tr></thead><tbody><tr ng-repeat=\"log in qcLogs.results\"><td>{{ log.created_at | date: \"dd-MM-yyyy, H:mm\" }}</td><td>{{ log.action | capitalize }}</td><td>{{ log.actor | username }}</td><td>{{ log.target_model }}</td><td>{{ log.changed_field }}</td><td>{{ log.previous_data }}</td><td>{{ log.updated_data }}</td></tr></tbody></table><paginated items=\"qcLogs\" items-per-page=\"10\"></paginated></div><div class=\"si-page__search\" style=\"margin-left: auto\"><search><search-filters><search-filter ng-if=\"qcLogs.filters.status_changes.length > 1\" name=\"{{ statusChangesText }}\"><radio-button-filter search=\"search(filter, filterDisplay)\" name=\"status_changes\" filters=\"qcLogs.filters.status_changes\"></radio-button-filter></search-filter><search-filter-choices remove-filter=\"removeFilter(filter)\" filter-options=\"qcLogs.filters\" filters=\"filters\"></search-filter-choices></search-filters></search></div></si-page></div>");
$templateCache.put("assessments/partials/questionnaireSectionView.html","<fieldset ng-class=\"{well: assignment.assigned_as === \'financial_specialist\'}\"><uib-accordion close-others=\"false\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-if=\"section.isShown\" ng-repeat=\"section in section.children.objects\"><uib-accordion-heading><span ng-if=\"assessment.completion_check_required && app === \'dashboard\'\"><span><i ng-if=\"section.accepted\" class=\"fa fa-check-circle text-info\"></i></span> <span><i ng-if=\"!section.accepted && !showTabWarnings\" class=\"fa fa-check-circle text-success\"></i></span> <span><i ng-if=\"!section.accepted && section.isDone && showTabWarnings\" class=\"fa fa-check-circle text-success\"></i></span> <span><i ng-if=\"!section.accepted && !section.isDone && showTabWarnings\" class=\"fa fa-exclamation-circle text-danger\"></i></span></span> <span ng-if=\"assessment.completion_check_required && app === \'smartclient\'\"><span ng-if=\"section.isDone && assignment.submitted_at_least_once && section.accepted\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"section.isDone && assignment.submitted_at_least_once && !section.accepted\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!section.isDone && assignment.submitted_at_least_once\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span><span ng-if=\"section.isDone && !assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!section.isDone && !assignment.submitted_at_least_once && !showTabWarnings\"><i class=\"fa fa-circle-o\"></i></span> <span ng-if=\"!section.isDone && !assignment.submitted_at_least_once && showTabWarnings\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span> <span ng-bind=\"section.section_display_position\"></span> <span>{{section.section_title | translate}}</span> <span ng-if=\"isDashboard\" class=\"pull-right\"><i class=\"fa fa-star\"></i> <strong ng-if=\"section.score < 1\"><translate>N/R</translate></strong> <span ng-if=\"section.score > 0\" ng-bind=\"section.score | number:1\"></span></span></uib-accordion-heading><div ng-if=\"responseApplicable(response, assessment)\" in-view=\"responseInView(response, $inview, $inviewpart)\" in-view-options=\"{\'debounce\': 75, \'offsetBottom\': 300, \'offsetTop\': 300}\" class=\"ibox-content assessment__question\" ng-click=\"responseInView(response, true, \'both\')\" ng-repeat=\"response in section.responses.objects\" ng-class=\"{\'ibox-heading\': response.id === active_response.id}\"><div class=\"row\" ng-class=\"{well: assignment.submitted_at_least_once && response.accepted && isSmartClient}\"><div class=\"text-center\" ng-if=\"assignment.submitted_at_least_once && response.accepted && isSmartClient\"><i class=\"fa fa-check text-success\"></i> <span translate=\"\">Your response has been accepted.</span></div><span class=\"pull-right\"><i class=\"fa fa-comment\"></i> {{ response.comments.objects.length }}</span><div class=\"col-md-6 col-xs-12\"><p><span ng-bind=\"response.question_display_position\"></span> <strong ng-bind=\"response.question_title\"></strong></p><p>{{ response.question_description }}</p><div ng-if=\"response.subresponses.objects.length == 0\"><div class=\"text-center\" ng-if=\"isDashboard\"><i class=\"fa fa-star\"></i> <strong ng-if=\"response.score > 0\">{{ response.score | number:0 }}</strong> <strong ng-if=\"response.score < 1\"><translate>N/R</translate></strong></div><input type=\"range\" ng-model=\"response.score\" min=\"0\" max=\"5\" steps=\"1\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveResponse(response.score, response)\"> <input ng-if=\"response.question_scale_type == \'open\'\" type=\"text\"></div><div ng-if=\"response.subresponses.objects.length > 0\" ng-init=\"parseDecimals(response.subresponses.objects)\" ng-repeat=\"subresponse in response.subresponses.objects\"><si-conditional-question question=\"subresponse\" questions=\"response.subresponses.objects\" update-fct=\"saveSubResponse(question)\" reset-fct=\"saveNullResponse(question, response)\"><p><div class=\"pull-right\" ng-if=\"isDashboard\"><i class=\"fa fa-star\"></i> <strong ng-if=\"subresponse.score > 0\">{{ subresponse.score | number:0 }}</strong> <strong ng-if=\"subresponse.score < 1\"><translate>N/R</translate></strong></div><strong ng-bind=\"subresponse.subquestion.title\"></strong></p><p ng-bind=\"subresponse.subquestion.description\"></p><div ng-if=\"subresponse.subquestion.type === \'checkbox\'\"><div class=\"checkbox\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><label for=\"cb-{{subresponse.subquestion.title}}-{{option.title}}-{{option.id}}\" uib-tooltip=\"{{option.disable_reasons[0]}}\" tooltip-enable=\"option.is_disabled\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><input type=\"checkbox\" id=\"cb-{{subresponse.subquestion.title}}-{{option.title}}-{{option.id}}\" value=\"{{option.title}}\" ng-init=\"initializeQuestion(option, subresponse)\" ng-checked=\"option.checked\" ng-model=\"option.checked\" ng-disabled=\"isOptionDisabled(option, subresponse, response)\" ng-change=\"saveSubResponse(subresponse)\"> {{option.title}} <i ng-if=\"option.is_disabled\" class=\"fa fa-lock text-warning\"></i></label></div><div class=\"checkbox\" ng-if=\"subresponse.subquestion.can_be_none_of_the_above\"><label for=\"checkbox-none-{{subresponse.subquestion.title}}\"><input type=\"checkbox\" id=\"checkbox-none-{{subresponse.subquestion.title}}\" name=\"{{subresponse.subquestion.id}}\" ng-checked=\"subresponse.none_of_the_above\" ng-model=\"subresponse.none_of_the_above\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNoneAboveResponse(subresponse, response)\"><translate>None of the Above</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div><div class=\"checkbox\" ng-if=\"subresponse.subquestion.can_be_not_relevant && !subresponse.subquestion.not_relevant_is_hidden\"><label for=\"checkbox-nr-{{subresponse.subquestion.title}}\"><input type=\"checkbox\" id=\"checkbox-nr-{{subresponse.subquestion.title}}\" name=\"{{subresponse.subquestion.id}}\" ng-checked=\"subresponse.not_relevant\" ng-model=\"subresponse.not_relevant\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNullResponse(subresponse, response)\"><translate>Not Relevant</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div></div>{{subresonse.subquestion.is_conditional}}<div ng-if=\"subresponse.subquestion.type === \'mpc\' && !subresonse.subquestion.is_conditional\"><div class=\"radio\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><label for=\"radio-{{subresponse.subquestion.title}}-{{option.title}}-{{option.id}}\" uib-tooltip=\"{{option.disable_reasons[0]}}\" tooltip-enable=\"option.is_disabled\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><input type=\"radio\" id=\"radio-{{subresponse.subquestion.title}}-{{option.title}}-{{option.id}}\" name=\"{{subresponse.subquestion.id}}\" value=\"{{option.title}}\" ng-checked=\"subresponse.selected_option === option.url\" ng-model=\"subresponse.subquestion.checked\" ng-disabled=\"isOptionDisabled(option, subresponse, response)\" ng-change=\"saveSubResponse(subresponse)\"> {{option.title}} <i ng-if=\"option.is_disabled\" class=\"fa fa-lock text-warning\"></i></label></div><div class=\"radio\" ng-if=\"subresponse.subquestion.can_be_none_of_the_above\"><label for=\"radio-none-{{subresponse.subquestion.title}}\"><input type=\"radio\" id=\"radio-none-{{subresponse.subquestion.title}}\" name=\"{{subresponse.subquestion.id}}\" ng-value=\"true\" ng-model=\"subresponse.none_of_the_above\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNoneAboveResponse(subresponse, response)\"><translate>None of the Above</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div><div class=\"radio\" ng-if=\"subresponse.subquestion.can_be_not_relevant && !subresponse.subquestion.not_relevant_is_hidden\"><label for=\"radio-nr-{{subresponse.subquestion.title}}\"><input type=\"radio\" id=\"radio-nr-{{subresponse.subquestion.title}}\" name=\"{{subresponse.subquestion.id}}_NR\" ng-value=\"true\" ng-model=\"subresponse.not_relevant\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNullResponse(subresponse, response)\"><translate>Not Relevant</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div></div><div ng-if=\"subresponse.subquestion.type === \'numeric\'\"><label><input class=\"form-control\" ng-class=\"{\'ng-invalid\': subresponse.invalidRange }\" type=\"text\" pattern=\"[\\d+-]*\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Integers only\' | translate }}\" min=\"{{subresonse.min_value}}\" max=\"{{subresonse.max_value}}\" ng-model=\"subresponse.value\" ng-model-options=\"{debounce: 300}\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveSubResponse(subresponse)\"></label><div ng-show=\"subresponse.invalidRange||(isPercentageQuestion(subresponse))\" class=\"text-danger\">Input is outside the range of accepted values.</div><div class=\"checkbox\" ng-if=\"subresponse.subquestion.can_be_not_relevant && !subresponse.subquestion.not_relevant_is_hidden\"><label for=\"numeric-nr-{{subresponse.subquestion.title}}-{{option.id}}\"><input type=\"checkbox\" id=\"numeric-nr-{{subresponse.subquestion.title}}-{{option.id}}\" ng-checked=\"subresponse.not_relevant\" ng-model=\"subresponse.not_relevant\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNullResponse(subresponse, response)\"><translate>Not Relevant</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div></div><div ng-if=\"subresponse.subquestion.type === \'percent\'\"><label><input class=\"form-control\" ng-class=\"{\'ng-invalid\': subresponse.invalidRange }\" type=\"text\" pattern=\"[\\d+-]*\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Integers only\' | translate }}\" min=\"0\" max=\"100\" ng-model=\"subresponse.value\" ng-model-options=\"{debounce: 300}\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveSubResponse(subresponse)\"></label><div class=\"checkbox\" ng-if=\"subresponse.subquestion.can_be_not_relevant && !subresponse.subquestion.not_relevant_is_hidden\"><label for=\"numeric-nr-{{subresponse.subquestion.title}}-{{option.id}}\"><input type=\"checkbox\" id=\"numeric-nr-{{subresponse.subquestion.title}}-{{option.id}}\" ng-checked=\"subresponse.not_relevant\" ng-model=\"subresponse.not_relevant\" ng-disabled=\"assignment.submitted_at_least_once && response.accepted\" ng-change=\"saveNullResponse(subresponse, response)\"><translate>Not Relevant</translate><span class=\"text-danger\" ng-if=\"subresponse.subquestion.comment_mandatory\">&nbsp;<translate>(Comment is mandatory for this question if this option is selected)</translate></span></label></div></div></si-conditional-question></div><textarea class=\"assessment__comment-box form-control\" blur=\"saveQuestionExplanationComment\" question=\"response\" ng-model=\"response.comment\" spellcheck=\"true\" placeholder=\"{{\'Comments...\' | translate}}\" ng-disabled=\"assignment.assigned_as === \'financial_specialist\' || (assignment.submitted_at_least_once && response.accepted)\" style=\"resize: vertical; min-height: 150px\">\n                        </textarea> <button ng-click=\"aiSpellcheckComment(response.comment, response)\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></button></div><div ng-if=\"isSmartClient\"><div class=\"col-md-6 col-xs-12\" ng-if=\"shouldShowDocuments(assignment.submitted_at_least_once, response.accepted)\"><h5 translate=\"\">More Information</h5><p ng-hide=\"response.show_info\" style=\"overflow : hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;\">{{ response.question_explanation }}</p><p ng-show=\"response.show_info\" style=\"white-space: pre-wrap\">{{ response.question_explanation }}</p><a class=\"btn btn-sm btn-block btn-default\" ng-click=\"response.show_info = !response.show_info\"><span>[...]</span></a><div ng-if=\"response.subresponses.objects.length === 0\"><a class=\"btn btn-sm btn-block btn-default\" ng-click=\"response.show_scoring_info = !response.show_scoring_info\"><i class=\"fa fa-check\"></i> <span translate=\"\">Scoring indicators</span></a><p ng-show=\"response.show_scoring_info\" style=\"white-space: pre-wrap\">{{ response.question_scoring_indicators }}</p></div><hr><h5 translate=\"\" style=\"display: none\">Evidence</h5><table class=\"table\" ng-show=\"response.documents.objects.length > 0\"><tbody><tr ng-repeat=\"document in response.documents.objects track by $index\"><td><a ng-href=\"{{ document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> {{ document.file_name }}</a></td><td><a class=\"btn btn-sm btn-danger\" ng-click=\"removeResponseDocument(document, response.documents.objects, $index)\"><i class=\"fa fa-trash\"></i> Delete</a></td></tr></tbody></table><base-sixty-four-document-upload label=\"{{\'Add Documents\' | translate}}\" offline-label=\"{{ \'Disabled in offline mode\' | translate }}\" ng-model=\"response\" name=\"response\" ng-multiple=\"true\" create-function=\"responseDocumentCreate(data)\" is-disabled=\"isOffline\" style=\"display: none\"></base-sixty-four-document-upload></div></div></div><div class=\"row\" ng-if=\"isDashboard && assessment.project.can_edit_assessments\"><a ng-if=\"assignment.submitted_at_least_once && response.accepted\" ng-click=\"toggleAcceptResponse(response)\" class=\"btn btn-warning pull-right\" translate=\"\">Re-open Response</a> <a ng-if=\"assignment.submitted_at_least_once && !response.accepted\" ng-click=\"toggleAcceptResponse(response)\" class=\"btn btn-success pull-right\" translate=\"\">Accept Response</a></div><div class=\"hr-line-dashed\"></div></div><ng-include src=\"\'assessments/partials/questionnaireSectionView.html\'\"></ng-include></div></uib-accordion></fieldset>");
$templateCache.put("assessments/partials/questionnaireTabView.html","<div class=\"panel-body\"><si-info-text-display assessment=\"assessment\" key=\"info_questionnaire_tab_main\"><h3 class=\"m-b-md\" translate=\"\">Questionnaire</h3></si-info-text-display><div class=\"tab-content\"><div class=\"row text-right m-b-sm\" ng-if=\"isDashboard && assessment.project.can_edit_assessments && !canViewOnly()\"><button ng-click=\"reopenAllModal()\" class=\"btn btn-success\" translate=\"\">Re-open all</button> <button ng-click=\"acceptAllModal()\" class=\"btn btn-success\" translate=\"\">Accept all</button></div><uib-accordion close-others=\"false\" class=\"assessment\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"section in assessment.section_responses.objects\"><uib-accordion-heading><span ng-if=\"assessment.completion_check_required && app === \'dashboard\'\"><span><i ng-if=\"section.accepted\" class=\"fa fa-check-circle text-info\"></i></span> <span><i ng-if=\"!section.accepted && !showTabWarnings\" class=\"fa fa-check-circle text-success\"></i></span> <span><i ng-if=\"!section.accepted && section.isDone && showTabWarnings\" class=\"fa fa-check-circle text-success\"></i></span> <span><i ng-if=\"!section.accepted && !section.isDone && showTabWarnings\" class=\"fa fa-exclamation-circle text-danger\"></i></span></span> <span ng-if=\"assessment.completion_check_required && app === \'smartclient\'\"><span ng-if=\"section.isDone && assignment.submitted_at_least_once && section.accepted\"><i class=\"fa fa-check-circle text-info\"></i></span> <span ng-if=\"section.isDone && assignment.submitted_at_least_once && !section.accepted\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!section.isDone && assignment.submitted_at_least_once\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span><span ng-if=\"section.isDone && !assignment.submitted_at_least_once\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-if=\"!section.isDone && !assignment.submitted_at_least_once && !showTabWarnings\"><i class=\"fa fa-circle-o\"></i></span> <span ng-if=\"!section.isDone && !assignment.submitted_at_least_once && showTabWarnings\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span> <span ng-bind=\"section.section_display_position\"></span> <span>{{section.section_title | translate}}</span> <span class=\"pull-right\" ng-if=\"isDashboard\"><i class=\"fa fa-star\"></i> <span ng-if=\"section.score < 1\"><translate>N/R</translate></span> <span ng-if=\"section.score > 0\"><span ng-bind=\"section.score | number:1\"></span></span></span></uib-accordion-heading><ng-include src=\"\'assessments/partials/questionnaireSectionView.html\'\"></ng-include></div></uib-accordion></div></div>");
$templateCache.put("assessments/partials/termsTabView.html","<form name=\"termsForm\" class=\"assessment\" form-to-tab-validator=\"\" is-accepted=\"assessment.data_sharing_consent_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"data_sharing_consent_tab_accepted\" is-completed=\"data_sharing_consent_tab_completed\" is-disabled=\"termsForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Documentation\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"termsForm.$invalid\" is-accepted=\"data_sharing_consent_tab_accepted\" is-completed=\"data_sharing_consent_tab_completed\" is-form-completed=\"termsForm.$valid\" assessment=\"assessment\"></axr-complete-tab><si-info-text-display assessment=\"assessment\" key=\"info_terms_and_conditions_tab_main\"><h3 class=\"m-b-md\" translate=\"\">Data Sharing Consent(s)</h3></si-info-text-display><div class=\"tab-content\"><fieldset ng-disabled=\"isFormDisabled()\"><div class=\"form-group\" ng-form=\"\" name=\"termsForm\"><label for=\"agreement\"><input id=\"agreement\" name=\"checkbox\" ng-model=\"assessment.terms_and_conditions.objects[0].signed\" ng-disabled=\"!assessment.terms_and_conditions.objects.length\" ng-change=\"toggleSigned(assessment.terms_and_conditions.objects[0])\" required=\"\" type=\"checkbox\"> <span ng-bind=\"agreementText | translate\"></span> <label class=\"text-danger\">*</label></label></div><div ng-if=\"!assessment.terms_and_conditions.objects.length\"><base-sixty-four-document-upload label=\"{{\'Add Documents\'|translate}}\" asterisk=\"true\" offline-label=\"{{ \'Disabled in offline mode\' | translate }}\" ng-model=\"assessment.terms_and_conditions\" name=\"termsavailabilityresponse\" id=\"termsavailabilityresponse\" ng-multiple=\"true\" create-function=\"termsAvailabilityResponseDocumentCreate(data)\" is-disabled=\"isOffline\"></base-sixty-four-document-upload></div><div class=\"consent-preview-list\" ng-if=\"assessment.terms_and_conditions.objects.length\"><consent-document-preview ng-repeat=\"document in assessment.terms_and_conditions.objects track by document.url\" document=\"document\" is-offline=\"isOffline\" on-delete=\"removeTermsDoc(document.url)\"></consent-document-preview></div><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on Data Sharing Consent(s)\' | translate\" label-size=\"large\" info-text-key=\"info_terms_and_conditions_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_terms_and_conditions\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_terms_and_conditions\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_terms_and_conditions\', assessment.assessor_comments_terms_and_conditions, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></div></form>");
$templateCache.put("assessments/partials/valueChainTabView.html","<form name=\"valueChainForm\" form-to-tab-validator=\"\" is-accepted=\"assessment.value_chain_tab_accepted\" assessment=\"assessment\"><div class=\"panel-body\"><div class=\"tab-content\"><qc-review-tab ng-if=\"app === \'dashboard\' && assessment.full_completion_check_required && assessment.project.can_edit_assessments && !canViewOnly()\" update-fct=\"patchAssessment(name, value)\" is-accepted=\"value_chain_tab_accepted\" is-completed=\"value_chain_tab_completed\" is-disabled=\"valueChainForm.$invalid\" show-tab-warnings=\"toggleTabWarnings()\" name=\"Value Chain\" assessment=\"assessment\"></qc-review-tab><axr-complete-tab ng-if=\"app === \'smartclient\' && assessment.full_completion_check_required\" update-fct=\"patchAssessment(name, value)\" is-disabled=\"valueChainForm.$invalid\" is-completed=\"value_chain_tab_completed\" is-form-completed=\"valueChainForm.$valid\" assessment=\"assessment\"></axr-complete-tab><fieldset ng-disabled=\"isFormDisabled()\"><table-comp ng-if=\"shouldShowSection(\'value_chain_tab.value_chain_players\')\" heading=\"{{\'Clients\' | translate}}\" table-data=\"assessment\" info-text-key=\"info_value_chain_tab_clients\" assessment=\"assessment\" key=\"valuechainplayers\" tab-title=\"row.customer\" show-error=\"showTabWarnings\" field-map=\"valuechainPlayerRows\" no-info=\"value_chain_players_no_information_available\" table-complete=\"value_chain_players_completed\" is-table-disabled=\"isFormDisabled()\" update-form=\"updateFormElement(obj, key, val, {valueChainForm: valueChainForm})\" create-fct=\"savePlayer(\'valuechainplayers\')\" update-fct=\"savePlayer(\'valuechainplayers\', row)\" delete-fct=\"removePlayer(\'valuechainplayers\', row)\" is-disabled=\"assessment.finance_history_tab_accepted\"></table-comp><table-comp ng-if=\"shouldShowSection(\'value_chain_tab.enabling_players\')\" heading=\"{{\'Service providers and Supporting organizations\' | translate}}\" info-text-key=\"info_value_chain_tab_service_providers\" table-data=\"assessment\" assessment=\"assessment\" key=\"enablingplayers\" tab-title=\"row.customer\" show-error=\"showTabWarnings\" field-map=\"enablingPlayerRows\" no-info=\"enabling_players_no_information_available\" table-complete=\"enabling_players_completed\" is-table-disabled=\"isFormDisabled()\" update-form=\"updateFormElement(obj, key, val, {valueChainForm: valueChainForm})\" create-fct=\"savePlayer(\'enablingplayers\')\" update-fct=\"savePlayer(\'enablingplayers\', row)\" delete-fct=\"removePlayer(\'enablingplayers\', row)\" is-disabled=\"assessment.finance_history_tab_accepted\"></table-comp><table-comp ng-if=\"shouldShowSection(\'value_chain_tab.supplier\')\" heading=\"{{\'Supplier\' | translate}}\" table-data=\"assessment\" info-text-key=\"info_value_chain_tab_supplier\" assessment=\"assessment\" key=\"suppliers\" tab-title=\"row.customer\" show-error=\"showTabWarnings\" field-map=\"supplierRows\" no-info=\"supplier_no_information_available\" table-complete=\"supplier_completed\" is-table-disabled=\"isFormDisabled()\" update-form=\"updateFormElement(obj, key, val, {valueChainForm: valueChainForm})\" create-fct=\"savePlayer(\'suppliers\')\" update-fct=\"savePlayer(\'suppliers\', row)\" delete-fct=\"removePlayer(\'suppliers\', row)\" is-disabled=\"assessment.finance_history_tab_accepted\"></table-comp><div class=\"row\"><div class=\"col-md-12\"><form-textarea label=\"\'Assessor notes on value chain\' | translate\" label-size=\"large\" info-text-key=\"info_value_chain_tab_assessor_notes\" assessment=\"assessment\" form-name=\"observations\" update-fct=\"updateFormElement(assessment, \'assessor_comments_value_chain\', model, {assessmentForm: assessmentForm})\" model=\"assessment.assessor_comments_value_chain\"></form-textarea><a ng-click=\"aiSpellcheckFeedback(assessment, \'assessor_comments_value_chain\', assessment.assessor_comments_value_chain, {assessmentForm: assessmentForm})\" class=\"btn btn-primary\" style=\"margin-top: 5px\" ng-disabled=\"isOffline\"><translate>Enhance the Comment by AI</translate></a></div></div></fieldset></div></div></form>");
$templateCache.put("authentication/authentication/authentication.html","<section class=\"authentication\" ng-class=\"{\'authentication--light\': app === \'smartclient\'}\"><nav class=\"authentication__nav navbar\" role=\"navigation\"><ul class=\"nav navbar-right\" style=\"display: flex;\"><li ng-if=\"app === \'smartclient\' && authCtrl.isLogin()\" class=\"dropdown\"><a ng-if=\"!isTrainee\" class=\"dropdown-toggle\" ng-click=\"authCtrl.goToRegister()\"><span><translate>Register as Applicant</translate></span></a></li><li class=\"dropdown\" uib-dropdown=\"\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Change your default language\' | translate }}\" uib-dropdown-toggle=\"\"><span><translate>Language</translate>:&nbsp;</span><span ng-bind=\"authCtrl.chosenLanguage\"></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"(code, language) in authCtrl.languages\"><a ng-click=\"authCtrl.changeLanguage(code)\"><span ng-class=\"{\'font-bold\': authCtrl.language === code}\" ng-bind=\"language\"></span></a></li></ul></li></ul></nav><div ui-view=\"childState\"></div></section>");
$templateCache.put("authentication/login/login.html","<article class=\"login\" ng-class=\"{\'login--light\': app === \'smartclient\'}\"><header class=\"login__header\"><h1><img alt=\"image\" ng-hide=\"!hideSignup\" src=\"assets/img/{{ loginCtrl.logo_file }}\"></h1></header><main class=\"login__main\"><form name=\"loginForm\" ng-submit=\"loginCtrl.login()\" ng-hide=\"loginCtrl.progress||!hideSignup\"><div class=\"form-group\"><input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" placeholder=\"{{ \'Username\' | translate }}\" ng-model-options=\"{updateOn: blur}\" ng-model=\"loginCtrl.email\" required=\"\"></div><div class=\"form-group\"><input type=\"password\" name=\"password\" id=\"password\" class=\"form-control\" placeholder=\"{{ \'Password\' | translate }}\" ng-model-options=\"{updateOn: blur}\" ng-model=\"loginCtrl.password\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width\" ng-disabled=\"loginForm.$invalid\" translate=\"\">Login</button><div class=\"login__forgot\" ng-click=\"loginCtrl.forgotPassword()\"><translate>Forgot Your Password?</translate></div></form><br><div class=\"login__alert alert alert-danger block full-width\" ng-if=\"loginCtrl.error\">{{ loginCtrl.error }}&nbsp;<div ng-if=\"loginCtrl.error === \'You currently do not have access to this environment.\'\"><translate>Please login</translate>&nbsp; <a ng-if=\"isTrainee\" href=\"https://app.scopeinsight.com/#/login\">here</a> <a ng-if=\"!isDev && !isTest && !isTrainee\" href=\"https://trainee.scopeinsight.com/#/login\">here</a> <a ng-if=\"isDev\" href=\"https://test.app.scope.stamkracht.com/#/login\">here</a> <a ng-if=\"isTest\" href=\"https://dev.app.scope.stamkracht.com/#/login\">here</a></div></div><div class=\"login__progress progress progress-mini\" ng-hide=\"!loginCtrl.progress\"><span class=\"progress-bar\" style=\"width:{{ loginCtrl.progress }}%;\"></span></div></main><footer class=\"login__footer\"><small>&copy; SCOPE<em>insight</em> B.V.<translate>All rights reserved</translate></small></footer></article>");
$templateCache.put("authentication/login/reset.html","<article class=\"login\" ng-class=\"{\'login--light\': app === \'smartclient\'}\"><header class=\"login__header\"><h1><img alt=\"image\" src=\"assets/img/{{ loginCtrl.logo_file }}\"></h1></header><main class=\"login__main\"><form name=\"forgotPasswordForm\" ng-submit=\"loginCtrl.sendResetLink(forgotPasswordForm)\"><p class=\"login__message\" translate=\"\">Please fill in your registered email address to receive a password reset link.</p><div class=\"form-group\"><input type=\"email\" name=\"email\" id=\"reset\" class=\"form-control\" placeholder=\"{{ \'Email\' | translate }}\" ng-model-options=\"{updateOn: blur}\" ng-model=\"loginCtrl.email\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width\" ng-disabled=\"forgotPasswordForm.$invalid\" translate=\"\">Request Reset Link</button><div class=\"login__alert alert alert-danger\" ng-if=\"loginCtrl.error\" ng-bind=\"loginCtrl.error\"></div></form><article class=\"login__reset-sent\" ng-if=\"loginCtrl.isPasswordResetSent\"><div class=\"login__alert alert alert-info\"><p translate=\"\">Password reset request has been sent.</p><p translate=\"\">Please check your email for the password reset link.</p></div></article><div class=\"login__forgot\" ng-click=\"loginCtrl.showLogin()\"><translate>Login</translate></div><div class=\"login__progress progress progress-mini\" ng-hide=\"!loginCtrl.progress\"><span class=\"progress-bar\" style=\"width:{{ loginCtrl.progress }}%;\"></span></div></main><footer class=\"login__footer\"><small>&copy; SCOPE<em>insight</em> B.V.<translate>All rights reserved</translate></small></footer></article>");
$templateCache.put("authentication/register/register.html","<article class=\"register\" ng-class=\"{\'login--light\': app === \'smartclient\'}\"><header class=\"login__header\"><h1><img alt=\"image\" src=\"assets/img/{{ registerCtrl.logo_file }}\"></h1></header><main class=\"login__main\"><form name=\"userForm\" ng-if=\"app === \'smartclient\'\" class=\"registerForm\"><div class=\"form-group\"><label class=\"control-label\"><translate>First name</translate><label class=\"text-danger\" ng-show=\"userForm.first_name.$error.required\">*</label></label><div><input id=\"first_name\" type=\"text\" class=\"form-control\" ng-model=\"user.first_name\" name=\"first_name\" required=\"\" placeholder=\"First Name\"></div></div><div class=\"form-group\"><label class=\"control-label\"><translate>Last name</translate><label class=\"text-danger\" ng-show=\"userForm.last_name.$error.required\">*</label></label><div><input id=\"last_name\" type=\"text\" class=\"form-control\" ng-model=\"user.last_name\" name=\"last_name\" required=\"\" placeholder=\"Last Name\"></div></div><div class=\"form-group\"><label class=\"control-label\"><translate>City</translate><label class=\"text-danger\" ng-show=\"userForm.city.$error.required\">*</label></label><div><input id=\"city\" type=\"text\" class=\"form-control\" ng-model=\"user.city\" name=\"city\" required=\"\" placeholder=\"City\"></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"country\"><translate>Country</translate><label class=\"text-danger\" ng-show=\"userForm.country.$error.required\">*</label></label><div><select chosen=\"\" class=\"form-control\" id=\"country\" name=\"country\" required=\"\" data-placeholder-text-single=\"\'Select a country\' | translate\" ng-options=\"country as country for country in countries\" ng-model=\"user.country\" ng-change=\"getOrganizations()\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"control-label\"><translate>Organization</translate><label class=\"text-danger\" for=\"organization\" ng-show=\"userForm.organization.$error.required\">*</label></label><div><select chosen=\"\" id=\"organization\" name=\"organization\" ng-disabled=\"isDashboardAdmin\" class=\"form-control\" data-placeholder-text-single=\"\'Select an organization\' | translate\" ng-options=\"customer.id as (customer.name | capitalize) for customer in customers\" ng-model=\"user.organization\" ng-change=\"test()\" required=\"\"><option value=\"\"></option></select></div><div class=\"orgText\"><div style=\"display: flex; justify-content: center; align-items: center\"><button class=\"btn btn-default\" ng-click=\"openAssesseeWarningModal()\" type=\"button\">Create new Organization Profile</button></div></div></div><div class=\"form-group\"><label class=\"control-label\"><translate>Email</translate><label class=\"text-danger\" ng-show=\"userForm.email.$error.required\">*</label></label><div><input id=\"email\" type=\"email\" class=\"form-control\" ng-model=\"user.email\" name=\"email\" required=\"\" ng-change=\"checkEmailAvailability(user.email, userForm)\" ng-model-options=\"{updateOn: \'blur\'}\" placeholder=\"Email\"> <b><small class=\"text-danger\" ng-show=\"userForm.email.$dirty && !emailValid\" translate=\"\">Invalid email</small></b></div></div><div class=\"form-group\"><label class=\"control-label\"><translate>Password</translate><label class=\"text-danger\" for=\"organization\" ng-show=\"userForm.password.$error.required\">*</label></label> <input type=\"password\" name=\"password\" id=\"password\" class=\"form-control\" placeholder=\"{{ \'Password\' | translate }}\" ng-model-options=\"{updateOn: blur}\" ng-model=\"user.password\" required=\"\"></div><div class=\"form-group\"><label class=\"control-label\"><translate>Confirm password</translate><label class=\"text-danger\" for=\"organization\" ng-show=\"userForm.passwordConfirm.$error.required\">*</label></label> <input type=\"password\" name=\"passwordConfirm\" id=\"passwordConfirm\" class=\"form-control\" placeholder=\"{{ \'Confirm password\' | translate }}\" ng-model-options=\"{updateOn: blur}\" ng-model=\"user.passwordConfirm\" required=\"\"></div><div class=\"form-group\"><label class=\"control-label\"><translate>UI Language</translate><label class=\"text-danger\" ng-show=\"userForm.language.$error.required\">*</label></label><div><select chosen=\"\" name=\"language\" id=\"laguage\" ng-options=\"language.code as language.name for language in languages\" ng-change=\"updateLanguage(user.language, user.url)\" ng-model=\"user.language\" required=\"\"><option value=\"\"></option></select></div></div><button type=\"submit\" class=\"btn btn-primary block full-width register-button\" ng-disabled=\"userForm.$invalid\" ng-click=\"register()\" translate=\"\">Register</button></form></main></article>");
$templateCache.put("authentication/set/set.html","<article class=\"login\"><div ng-if=\"setCtrl.isLoaded && !setCtrl.validToken\"><header class=\"login__header\"><h1><img alt=\"image\" src=\"assets/img/{{ setCtrl.logo_file }}\"></h1></header><translate>You have already used the password reset link once to reset your password. Please request for another reset link.</translate><div class=\"login__forgot\" ng-click=\"setCtrl.requestToken()\"><translate>Send New Link</translate></div></div><div ng-if=\"setCtrl.isLoaded && setCtrl.validToken\"><header class=\"login__header\"><h1><img alt=\"image\" src=\"assets/img/{{ setCtrl.logo_file }}\"></h1></header><main class=\"login__main\"><form name=\"setCtrl.resetForm\" ng-show=\"!setCtrl.progress\" ng-submit=\"setCtrl.sendPassword()\"><div class=\"form-group\"><input type=\"{{ setCtrl.form.password.type }}\" name=\"password\" id=\"password\" class=\"form-control\" placeholder=\"{{ \'Password\' | translate }}\" ng-minlength=\"8\" ng-maxlength=\"20\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"setCtrl.password\" ng-change=\"setCtrl.checkValidity(setCtrl.password)\" required=\"\"> <i class=\"fa\" ng-class=\"{\'fa-eye\': !setCtrl.form.password.isVisible, \'fa-eye-slash\': setCtrl.form.password.isVisible}\" ng-click=\"setCtrl.flipVisibility(\'password\')\"></i></div><div class=\"form-group\"><input type=\"{{ setCtrl.form.confirm.type }}\" name=\"confirm\" id=\"confirm\" class=\"form-control\" ng-minlength=\"8\" ng-maxlength=\"20\" pattern=\"{{ setCtrl.parsePassword(setCtrl.password) }}\" placeholder=\"{{ \'Confirm Password\' | translate }}\" ng-model=\"setCtrl.confirm\" required=\"\"> <i class=\"fa\" ng-class=\"{\'fa-eye\': !setCtrl.form.confirm.isVisible, \'fa-eye-slash\': setCtrl.form.confirm.isVisible}\" ng-click=\"setCtrl.flipVisibility(\'confirm\')\"></i></div><button type=\"submit\" class=\"btn btn-primary block full-width\" ng-disabled=\"setCtrl.resetForm.$invalid\" translate=\"\">Set Password</button><div class=\"login__alert alert alert-info\"><p ng-class=\"{\'text-danger\': setCtrl.resetForm.password.$error.minlength}\" translate=\"\">Passwords must be a minimum of 8 characters and no longer than 20.</p><p ng-class=\"{\'text-danger\': setCtrl.resetForm.password.$error.specialCharacters}\" translate=\"\">Passwords must contain at least one of: 0-9 or @, #, $</p><p ng-class=\"{\'text-danger\': setCtrl.resetForm.password.$error.caseCharacters}\" translate=\"\">Passwords must contain a mix of uppercase and lowercase letters.</p><p ng-class=\"{\'text-danger\': setCtrl.resetForm.confirm.$error.pattern}\" translate=\"\">Passwords must match.</p></div><div class=\"login__alert alert alert-danger\" ng-if=\"setCtrl.error\" ng-bind=\"setCtrl.error\"></div><div class=\"login__forgot\" ng-click=\"setCtrl.showLogin()\"><translate>Go to Login</translate></div></form><div class=\"login__progress progress progress-mini\" ng-hide=\"!setCtrl.progress\"><span class=\"progress-bar\" style=\"width:{{ setCtrl.progress }}%;\"></span></div></main><footer class=\"login__footer\"><small>&copy; SCOPE<em>insight</em> B.V.<translate>All rights reserved</translate></small></footer></div></article>");
$templateCache.put("components/basesixtyfour-document-upload/basesixtyfour-document-upload.html","<form><label class=\"btn btn-primary\" ng-disabled=\"$ctrl.isDisabled\" title=\"{{ $ctrl.isDisabled ? offlineLabel : label }}\"><i ng-show=\"$ctrl.isUploading\" class=\"fa fa-circle-o-notch fa-spin\"></i> <span ng-if=\"!$ctrl.isDisabled\">{{ $ctrl.label }}</span> <span ng-if=\"$ctrl.asterisk\" class=\"text-danger\">*</span> <span ng-if=\"$ctrl.isDisabled\">{{ $ctrl.offlineLabel }}</span> <input class=\"hidden\" id=\"upload-file-input\" type=\"file\" multiple=\"ngMultiple\" ng-disabled=\"$ctrl.isDisabled\"></label></form>");
$templateCache.put("components/breadcrumbs/breadcrumbs.html","<ol class=\"breadcrumb\"><li ng-repeat=\"crumb in $ctrl.breadcrumbs\" ng-class=\"{active: $last}\"><a ng-if=\"!$last\" ui-sref=\"{{crumb.url}}\" ng-bind=\"crumb.name | translate\"></a> <strong ng-if=\"$last\"><span ng-bind=\"crumb.name | translate\"></span> #<span ng-bind=\"crumb.id\"></span></strong></li></ol>");
$templateCache.put("components/edit-options-list/edit-options-list.html","<div class=\"ibox\"><div class=\"ibox-title\"><h5 ng-bind=\"$ctrl.label\"></h5></div><div class=\"ibox-title\"><label><input type=\"checkbox\" ng-model=\"$ctrl.sortModel\" ng-change=\"$ctrl.toggleSortAlpha($ctrl.sortModel)\">&nbsp;<translate>Always Sort Alphabetical</translate></label></div><div class=\"ibox-content no-padding\" ng-if=\"!$ctrl.isRelatedList && !$ctrl.isMainList\"><ul class=\"list-group limited\" dnd-list=\"$ctrl.list\"><li class=\"list-group-item draggable\" dnd-draggable=\"item\" dnd-moved=\"$ctrl.movedIteam($index, item)\" dnd-effect-allowed=\"move\" dnd-selected=\"$ctrl.selected = item\" ng-class=\"{\'selected\': $ctrl.selected === item}\" ng-repeat=\"item in $ctrl.list | orderBy:sortorder\"><dnd-nodrag><span ng-mouseenter=\"$ctrl.mouseEnter(item)\" ng-mouseleave=\"$ctrl.mouseLeave(item)\"><i class=\"fa fa-th\" dnd-handle=\"\" ng-class=\"{\'hiden-handle\': $ctrl.hover!==item,\'handle-cursor\':true}\"></i> <span ng-bind=\"item.name\"></span></span> <a class=\"pull-right\" ng-click=\"$ctrl.removeItem(item)\"><i class=\"fa fa-trash text-danger\"></i></a></dnd-nodrag></li><li class=\"list-group-item muted\" ng-show=\"!$ctrl.list.length\">No items found</li><li class=\"list-group-item muted append\"><form ng-submit=\"$ctrl.addItem()\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newItem\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\">add</button></span></div><div class=\"text-danger\" ng-show=\"$ctrl.isDefined\">Item is already in the list</div></form></li></ul></div></div>");
$templateCache.put("components/exception-handler/curl-template.html","<div class=\"well well-lg\"><div class=\"text-danger\" ng-if=\"$ctrl.is500\">500 Server Response</div><br>curl&nbsp;\'<span ng-bind=\"$ctrl.exception.error.config.url\"></span>\' <span ng-if=\"$ctrl.exception.error.config.method\">&nbsp;-X&nbsp;<span ng-bind=\"$ctrl.exception.error.config.method\"></span></span> &nbsp;-H&nbsp;\'Accept: <span ng-bind=\"$ctrl.exception.error.config.headers.Accept\"></span>\' &nbsp;-H&nbsp;\'Referer: <span ng-bind=\"$ctrl.origin\"></span>\' &nbsp;-H&nbsp;\'Origin: <span ng-bind=\"$ctrl.origin\"></span>\' &nbsp;-H&nbsp;\'Authorization: <span style=\"overflow-wrap: break-word;\" ng-bind=\"$ctrl.exception.error.config.headers.Authorization\"></span>\' &nbsp;-H&nbsp;\'Content-Type: <span ng-bind=\"$ctrl.exception.error.config.headers[\'Content-Type\']\"></span>\' --data-binary \'{<span style=\"overflow-wrap: break-word;\" ng-repeat=\"item in $ctrl.data\">\"<span ng-bind=\"item.key\"></span>\":<span style=\"overflow-wrap: break-word;\" ng-bind=\"item.value\"></span><span ng-if=\"!$last\">,</span></span>}\' --compressed</div>");
$templateCache.put("components/exception-handler/exceptionHandlerView.html","<div class=\"modal-header\" ng-init=\"\'isCollapsed = false\'\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i>&nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\">&nbsp;<span translate=\"\">Well this is embarrasing...</span></h3></div><div class=\"modal-body\"><div class=\"well well-lg danger\" ng-if=\"exception.error.data\"><p ng-repeat=\"(field, fieldMessages) in exception.error.data track by $index\">\"<span ng-bind=\"field | capitalize\"></span>\" - <span ng-if=\"getType(fieldMessages) === \'object\'\" ng-repeat=\"message in fieldMessages track by $index\" ng-bind=\"message\"></span> <span ng-if=\"getType(fieldMessages) !== \'object\'\" ng-bind=\"fieldMessages\"></span><br></p></div><div uib-collapse=\"isCollapsed\" ng-if=\"!exception.noCurl\"><h5><translate>Send to ScopeInsight</translate>- <a href=\"mailto:info@scopeinsight.com\">info@scopeinsight.com</a></h5><curl exception=\"exception\"></curl></div></div><div class=\"modal-footer\" ng-if=\"!exception.noCurl\"><button class=\"btn btn-default\" ng-show=\"isCollapsed\" ng-click=\"toggleCurl()\" translate=\"\">Show Curl</button> <button class=\"btn btn-default\" ng-show=\"!isCollapsed\" ng-click=\"toggleCurl()\" translate=\"\">Hide Curl</button> <button class=\"btn btn-primary\" ng-click=\"$uibModalInstance.close()\" translate=\"\">Dismiss</button></div>");
$templateCache.put("components/file-upload-component/file-upload-component.html","<div ng-show=\"$ctrl.sourceOfData\" class=\"panel panel-default\"><div class=\"panel-heading\"><strong>{{$ctrl.title || \'Source of Data Files\'}}</strong> <span ng-if=\"$ctrl.isRequired\" class=\"text-danger\">*</span></div><div class=\"panel-body\"><form name=\"uploadForm\" class=\"form form-horizontal\" novalidate=\"\"><div class=\"form-group\" style=\"margin-bottom: 12px; min-height: 35px; margin-left: 0;\"><div class=\"col-sm-12\" style=\"padding-left: 0px;\"><form><label class=\"btn btn-primary\" ng-disabled=\"$ctrl.isDisabled || $ctrl.isUploading\" title=\"{{ $ctrl.isDisabled ? offlineLabel : label }}\"><span>{{$ctrl.isUploading ? \'Uploading...\' : \'Select files\'}}</span> <input class=\"btn btn-primary hidden\" type=\"file\" id=\"{{$ctrl.fileInputId}}\" multiple=\"\" accept=\"{{ $ctrl.acceptedFileTypes }}\" ng-reqired=\"$ctrl.isRequired\"></label></form><div ng-if=\"$ctrl.selectedFiles.length && !$ctrl.isUploading\" class=\"alert alert-info\" style=\"margin-top:10px;\"><i class=\"fa fa-files-o\"></i> <strong>{{$ctrl.selectedFiles.length}}</strong> file(s) ready to upload<ul style=\"margin:6px 0 0 18px;\"><li ng-repeat=\"f in $ctrl.selectedFiles track by f.name\">{{f.name}} <span class=\"text-muted\">({{f.size | number}} bytes)</span></li></ul></div></div></div></form><div ng-if=\"$ctrl.files.length\" class=\"table-responsive col-sm-12\" style=\"padding-left: 0;\"><div ng-if=\"$ctrl.loadingFiles\">Loading files, please wait...</div><table ng-if=\"!$ctrl.loadingFiles\" class=\"table table-striped table-condensed\"><thead><tr><th style=\"width: 50%;\">File name</th><th style=\"width: 20%;\">Size</th><th style=\"width: 30%;\" class=\"text-right\">Actions</th></tr></thead><tbody><tr ng-repeat=\"file in $ctrl.files | orderBy:\'name\'\"><td title=\"{{file.name}}\">{{file.name}}</td><td>{{file.size | number}} B</td><td class=\"text-right\"><button class=\"btn btn-xs btn-link\" ng-click=\"$ctrl.downloadFile(file.name)\" ng-disabled=\"$ctrl.isDownloading || $ctrl.isUploading || $ctrl.isDeleting[file.name]\"><i class=\"fa fa-download\"></i> {{$ctrl.downloadButtonText}}</button> <button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.deleteFile(file.name)\" ng-disabled=\"$ctrl.isDisabled || $ctrl.isDeleting[file.name] || $ctrl.isUploading || $ctrl.isDownloading\"><i class=\"fa fa-trash\"></i> <span ng-if=\"!$ctrl.isDeleting[file.name]\">Delete</span> <span ng-if=\"$ctrl.isDeleting[file.name]\">Deleting…</span></button></td></tr></tbody></table></div><div ng-if=\"!$ctrl.files.length\" class=\"alert alert-warning\" style=\"margin-top:10px;\"><i class=\"fa fa-exclamation-triangle\"></i> {{$ctrl.noFileMessage}}</div></div></div>");
$templateCache.put("components/footer/footerView.html","<div class=\"si-footer\" ng-class=\"{\'footer-dark\': shouldUseDarkTheme()}\"><strong translate=\"\">Copyright</strong> SCOPE<em>insight</em> B.V. &copy; <span ng-bind=\"date\"></span></div>");
$templateCache.put("components/header/headerView.html","<div class=\"border-bottom\"><nav class=\"navbar navbar-static-top\" ng-class=\"{\'header-dark\': shouldUseDarkTheme()}\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimalize-sidebar=\"\"><a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary\"><i class=\"fa fa-bars\"></i></a></span></div><span class=\"navbar-minimalize minimalize-styl-2 alert red-bg dropdown\" ng-if=\"impersonated\"><strong>WARNING</strong> Currently impersonating an user!</span> <span class=\"navbar-minimalize minimalize-styl-2 alert banner-bg dropdown\" ng-bind-html=\"tBannerText\" ng-if=\"bannerEnabled\"></span><ul class=\"nav navbar-top-links navbar-right\"><li class=\"dropdown\"><a class=\"dropwdown\" ng-show=\"syncErrors\" ng-click=\"syncErrorsModal()\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Errors\' | translate}}\"><i class=\"fa fa-asterisk text-danger\"></i></a></li><li class=\"dropdown\"><a class=\"dropdown\"><i class=\"fa fa-user\"></i> <span class=\"font-bold\">{{ me | username }}</span></a></li><li class=\"dropdown\"><a class=\"dropwdown\" ng-show=\"isOffline\" uib-tooltip=\"{{ \'You are currently offline\' | translate}}\"><i class=\"fa fa-exclamation-triangle text-danger\"></i></a></li><li class=\"dropdown\" ng-show=\"numberPendingRequests > 0\"><a class=\"dropdown count-info\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Pending requests\' | translate }}\"><i class=\"fa fa-refresh\"></i> <span class=\"label label-warning\">{{ numberPendingRequests }}</span></a></li><li class=\"dropdown\" uib-dropdown=\"\"><a class=\"dropdown-toggle count-info\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Unread alerts\' | translate }}\"><i class=\"fa fa-bell\"></i> <span class=\"label label-success\" ng-if=\"unreadAlerts.results.length > 0 || unreadNews.results.length > 0\">{{ unreadAlerts.results.length }}</span></a><ul class=\"dropdown-menu dropdown-alerts\" uib-dropdown-menu=\"\"><li ng-repeat=\"alert in unreadAlerts.results | orderBy:\'-created_at\' track by $index\"><a ui-sref=\"base.alert-detail({id: alert.id})\"><div><span class=\"pull-right text-muted small\" am-time-ago=\"alert.created_at\"></span> {{ alert.subject }}</div></a></li><li><div class=\"text-center link-block\"><a ui-sref=\"base.alerts\"><strong translate=\"\">Go to your alerts</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li class=\"dropdown\" uib-dropdown=\"\" ng-class=\"{\'hidden\': !me.language}\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Change your default language\' | translate }}\" uib-dropdown-toggle=\"\" ng-bind=\"languages[me.language]\"></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"(code, language) in languages\"><a ng-click=\"changeLanguage(code)\"><span ng-class=\"{\'font-bold\': me.language === code}\" ng-bind=\"language\"></span></a></li></ul></li><li ng-if=\"!isOffline && !me.is_employee_lite\"><a ng-click=\"clearFileCache()\"><i class=\"fa fa-trash\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Clear local data\' | translate }}\"></i></a></li><li ng-if=\"!isOffline && me.is_employee && !impersonated\"><a ng-click=\"impersonate()\"><i class=\"fa fa-eye\" tooltip-placement=\"bottom\" ng-if=\"isSmartClient\" uib-tooltip=\"{{ \'See app as another user\' | translate }}\"></i> <i class=\"fa fa-eye\" tooltip-placement=\"bottom\" ng-if=\"!isSmartClient\" uib-tooltip=\"{{ \'See dashboard as another user\' | translate }}\"></i></a></li><li ng-if=\"impersonated\"><a ng-click=\"undoImpersonate()\"><i class=\"fa fa-eye text-danger\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Switch back to original user\' | translate }}\"></i></a></li><li ng-if=\"isOffline\"><a ng-click=\"isOffline || clearFileCache()\" ng-disabled=\"isOffline\"><i class=\"fa fa-trash\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Clear local data disabled\' | translate }}\"></i></a></li><li ng-if=\"!isOffline\"><a ng-click=\"logout()\"><i class=\"fa fa-sign-out\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Logout\' | translate }}\"></i></a></li><li ng-if=\"isOffline\"><a ng-click=\"isOffline || logout()\" ng-disabled=\"isOffline\"><i ng-if=\"isOffline\" class=\"fa fa-sign-out\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Logout disabled\' | translate }}\"></i></a></li></ul></nav></div><div class=\"alert alert-success toaster\" ng-show=\"toaster\" translate=\"\">Changes saved successfully...</div>");
$templateCache.put("components/money-field/money-field-template.html","<div class=\"row money-field\" ng-form=\"\" name=\"$ctrl.form[{{$ctrl.name}}]\"><div class=\"col-sm-6\" ng-hide=\"$ctrl.amountOnly\" ng-class=\"{\'money-field__currency--required\': $ctrl.isCurrencyRequired}\"><input class=\"money-field__hidden-currency\" type=\"checkbox\" name=\"hiddenCurrency\" ng-model=\"$ctrl.hiddenCurrency\" ng-required=\"$ctrl.checkCurrencyRequired()\"><select class=\"form-control\" chosen=\"\" ng-disabled=\"$ctrl.isDisabled\" name=\"currency\" ng-model=\"$ctrl.currency\" ng-change=\"$ctrl.updateCurrency()\" ng-options=\"k as $ctrl.getName(k,v) for (k, v) in $ctrl.currencies\"><option value=\"\"></option></select></div><div class=\"number-presentation\" ng-class=\"{\'col-md-12\': $ctrl.amountOnly, \'col-sm-6\': !$ctrl.amountOnly, \'money-field__amount--required\': $ctrl.isAmountRequired}\"><input type=\"text\" class=\"form-control\" data-placeholder-text-single=\"\'Amount in numbers\' | translate\" ng-model=\"$ctrl.amount\" ng-required=\"$ctrl.checkAmountRequired()\" ng-disabled=\"$ctrl.isDisabled\" name=\"amount\" step=\"any\" min=\"{{ $ctrl.min }}\" max=\"{{ $ctrl.max }}\" ng-keydown=\"$ctrl.keydown($event)\" ng-focus=\"$ctrl.focus()\" ng-change=\"$ctrl.updateAmount()\"> <span class=\"tooltip__numbers\" ng-class=\"{active: $ctrl.isActive}\">Only whole numbers are allowed</span></div></div>");
$templateCache.put("components/qc-review-tab/qc-review-tab-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\"><span ng-bind=\"name\"></span>&nbsp;Tab Error</h3></div><div class=\"modal-body\">Please make sure the tab is complete before you accept it.</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("components/qc-review-tab/qc-review-tab.html","<article class=\"review-tab\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\"><button class=\"btn btn-warning\" type=\"button\" ng-if=\"$ctrl.assessment[$ctrl.isAccepted]\" ng-click=\"$ctrl.updateTab(!$ctrl.assessment[$ctrl.isAccepted])\">{{$ctrl.reopenText}}</button> <button class=\"btn btn-success\" type=\"button\" ng-if=\"!$ctrl.assessment[$ctrl.isAccepted]\" ng-click=\"$ctrl.updateTab(!$ctrl.assessment[$ctrl.isAccepted])\">{{$ctrl.acceptedText}}</button></article>");
$templateCache.put("components/rating/rating.html","<div><span name=\"rating\" ng-model=\"$ctrl.ngModel\" ng-required=\"$ctrl.isRequired\" min=\"{{ $ctrl.min }}\" max=\"{{ $ctrl.max }}\" uib-rating=\"\" on-hover=\"hoveringOver(value)\"></span></div>");
$templateCache.put("components/search/searchTemplate.html","<si-sidebar><si-comment-box><h3><i class=\"fa fa-search\"></i>&nbsp;<translate>Search</translate></h3><form class=\"form\" ng-submit=\"$ctrl.getResults()\"><div class=\"form-group\"><div class=\"input-icon\"><input type=\"text\" id=\"searchString\" name=\"searchString\" class=\"form-control\" tabindex=\"1\" ng-model=\"$ctrl.search\" ng-disable=\"$ctrl.isOffline\"> <i class=\"fa fa-times text-muted\" ng-click=\"$ctrl.clearSearch()\"></i></div></div></form><br><article ng-transclude=\"\" class=\"filters\"></article></si-comment-box></si-sidebar>");
$templateCache.put("components/si-assessee-image-upload/si-assessee-image-upload-modal-edit.html","<div class=\"assessee-image-upload-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Upload Assessee Image</h3></div><div class=\"modal-body\"><div class=\"background-image-full\" ng-style=\"{\'background-image\':\'url(\' + $ctrl.image.file + \')\'}\"></div><p ng-if=\"$ctrl.image.file_name\"><i class=\"fa fa-paperclip\"></i> {{$ctrl.image.file_name}}</p><p>Short description of the image</p><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.image.title\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"$ctrl.save()\">Save</button> <button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\">Cancel</button></div></div>");
$templateCache.put("components/si-assessee-image-upload/si-assessee-image-upload-modal.html","<div class=\"assessee-image-upload-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Upload Assessee Image</h3></div><div class=\"modal-body\"><div ng-if=\"$ctrl.image.file\" class=\"background-image-full\" ng-style=\"{\'background-image\':\'url(\' + $ctrl.image.file + \')\'}\"></div><p ng-if=\"$ctrl.image.file_name\"><i class=\"fa fa-paperclip\"></i> {{$ctrl.image.file_name}}</p><label class=\"btn btn-primary\"><i ng-show=\"$ctrl.isUploading\" class=\"fa fa-circle-o-notch fa-spin\"></i><translate>Select Image to Upload</translate><input class=\"hidden\" id=\"upload-image-input\" type=\"file\" accept=\".jpg, .jpeg, .png\"></label><p>Short description of the image <span class=\"text-danger\">*</span></p><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.title\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.title || !$ctrl.image.file\" ng-click=\"$ctrl.save()\">Save</button> <button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\">Cancel</button></div></div>");
$templateCache.put("components/si-assessee-image-upload/si-assessee-image-upload.html","<article class=\"assessee-image-upload\"><ul><li ng-repeat=\"image in $ctrl.images\" class=\"well well-sm\"><span>{{image.title}}</span> <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.expand(image)\"><i class=\"fa fa-expand\"></i></button> <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.remove(image)\"><i class=\"fa fa-close\"></i></button></li></ul><button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.openAddImageModal()\" ng-disabled=\"$ctrl.isOffline\"><i class=\"fa fa-plus\"></i><translate>Add Image</translate></button></article>");
$templateCache.put("components/si-compare-values/si-compare-values.html","<div class=\"si-compare-values\" ng-show=\"$ctrl.value\"><i ng-if=\"$ctrl.success\" class=\"fa fa-check text-info\"></i> <span class=\"text-danger\" ng-if=\"!$ctrl.success\">{{$ctrl.difference | number}} <i class=\"fa fa-times\"></i></span></div>");
$templateCache.put("components/si-contacts/si-contacts.html","<div><div ng-repeat=\"contact in $ctrl.displayContacts\"><div ng-if=\"contact.is_contact_person\"><div class=\"row\"><h4 class=\"col-md-9\" ng-if=\"$ctrl.isContactPerson\"><translate>Contact Person</translate>&nbsp;<span ng-bind=\"$index + 1\"></span></h4><div class=\"col-md-3 text-right\"><button class=\"btn btn-xs btn- m-b-sm\" type=\"button\" ng-click=\"$ctrl.editContact({contact})\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-xs btn-danger m-b-sm\" type=\"button\" ng-click=\"$ctrl.deleteContact({contact})\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"row\"><label class=\"col-md-3 control-label\" translate=\"\">Name</label><div class=\"col-md-9 control-label\">{{ contact.first_name }} {{ contact.last_name }}</div></div><div class=\"row\"><label class=\"col-md-3 control-label\" translate=\"\">Position</label><div class=\"col-md-9 control-label\">{{ contact.position }}</div></div><div class=\"row\"><label class=\"col-md-3 control-label\" translate=\"\">Phone Number</label><div class=\"col-md-9 control-label\">{{ contact.phone_number }}</div></div><div class=\"row\"><label class=\"col-md-3 control-label\" translate=\"\">Email Address</label><div class=\"col-md-9 control-label\"><span ng-if=\"!isGenerated(contact.email)\">{{ contact.email }}</span></div></div><hr></div><div ng-if=\"!$ctrl.isContactPerson\"><div class=\"row\"><div class=\"col-md-9 control-label\">{{ contact.first_name }} {{ contact.last_name }}</div><div class=\"col-md-3\"><button class=\"btn btn-xs btn- m-b-sm\" type=\"button\" ng-click=\"$ctrl.editContact({contact})\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-xs btn-danger m-b-sm\" type=\"button\" ng-click=\"$ctrl.deleteContact({contact})\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"row\"><div class=\"col-md-9 control-label\">{{ contact.position }}</div></div><hr></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.addContact()\" ng-disabled=\"($ctrl.isOrganizationTab) && ($ctrl.displayContacts.length>2)\" type=\"button\"><i class=\"fa fa-plus\"></i>&nbsp; <span translate=\"\">Add Contact</span></button></div>");
$templateCache.put("components/si-datepicker/si-datepicker.html","<article class=\"si-datepicker input-group\"><div class=\"input-group-addon\" ng-click=\"$ctrl.open($event)\"><i class=\"fa fa-calendar\"></i></div><input type=\"text\" class=\"form-control\" name=\"{{ $ctrl.name }}\" ng-click=\"$ctrl.open($event)\" uib-datepicker-popup=\"{{ $ctrl.format }}\" datepicker-options=\"$ctrl.options\" ng-model=\"$ctrl.ngModel\" is-open=\"$ctrl.opened\" ng-change=\"$ctrl.formatDate()\" ng-required=\"$ctrl.isRequired\" ng-disabled=\"$ctrl.isDisabled\" placeholder=\"{{ $ctrl.placeholder }}\" show-button-bar=\"false\" min-date=\"$ctrl.options.minDate\" max-date=\"$ctrl.options.maxDate\"><div ng-messages=\"$ctrl.ngModelCtrl.$error\" ng-if=\"$ctrl.ngModelCtrl.$touched\"><div ng-message=\"minDate\">Date is before the minimum allowed date</div><div ng-message=\"maxDate\">Date is after the maximum allowed date</div></div></article>");
$templateCache.put("components/si-global-dropdown/si-global-dropdown.html","<div class=\"panel-body\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-sm-9\"><div class=\"col-md-6\"><h3 ng-bind=\"$ctrl.mainListName\"></h3><div class=\"no-padding\"><h4 ng-bind=\"$ctrl.label\"></h4><div class=\"ibox-title\"></div><ul dnd-list=\"$ctrl.optionsList\"><li class=\"list-group-item draggable\" dnd-draggable=\"item\" dnd-moved=\"$ctrl.movedIteam($index, item)\" dnd-effect-allowed=\"move\" dnd-selected=\"$ctrl.selected = item\" ng-class=\"{\'selected\': $ctrl.selected === item}\" ng-repeat=\"item in $ctrl.optionsList | orderBy:sortorder\"><dnd-nodrag><span ng-mouseenter=\"$ctrl.mouseEnter(item)\" ng-mouseleave=\"$ctrl.mouseLeave(item)\"><i class=\"fa fa-th\" dnd-handle=\"\" ng-class=\"{\'hiden-handle\': $ctrl.hover!==item,\'handle-cursor\':true}\"></i> <span ng-bind=\"item.name\"></span></span> <a class=\"pull-right\" ng-click=\"$ctrl.removeItem(item)\"><i class=\"fa fa-trash text-danger\"></i></a></dnd-nodrag></li><li class=\"list-group-item muted\" ng-show=\"!$ctrl.optionsList.length\">No items found</li><li class=\"list-group-item muted append\"><form ng-submit=\"$ctrl.addItem()\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newItem\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\">add</button></span></div><div class=\"text-danger\" ng-show=\"$ctrl.isDefined\">Item is already in the list</div></form></li></ul></div></div></div></div></div></div>");
$templateCache.put("components/si-info-text/si-info-text-display.html","<article class=\"si-info-text-display\"><ng-transclude></ng-transclude><div class=\"si-info-text-display__icon\" ng-if=\"$ctrl.text\"><i class=\"fa fa-info-circle\"></i><div class=\"si-info-text-display__text\" ng-bind-html=\"$ctrl.text\"></div></div></article>");
$templateCache.put("components/si-info-text/si-info-text.html","<div class=\"panel-body\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-md-4 m-r-xl\"><ul class=\"m-b-md list-unstyled\"><li class=\"m-b-md\" ng-repeat=\"tab in $ctrl.tabs\" ng-if=\"$ctrl.shouldShowTab(tab)\"><h3>{{tab.name | translate}}</h3><ul class=\"list-group list-unstyled\"><li><a class=\"list-group-item\" ng-repeat=\"section in tab.sections\" ng-if=\"$ctrl.shouldShowSection(section)\" ng-class=\"{active: $ctrl.section.key === section.key}\" ng-click=\"$ctrl.setInfoText(section)\">{{section.name | translate}}</a></li></ul></li></ul></div><div class=\"col-md-4\"></div><div class=\"col-md-4 p-sm\"><div class=\"row\"><confirm-navigation check-value=\"$ctrl.infoText\" save-fct=\"$ctrl.save()\" save-text=\"{{\'You have unsaved changes which will be lost, do you want to continue?\' | translate}}\"><summernote config=\"wysiwig_options\" ng-model=\"$ctrl.infoText\" ng-model-options=\"{updateOn: \'default\'}\"></summernote></confirm-navigation></div><div class=\"row ibox-tools\"><button class=\"btn btn-info\" ng-click=\"$ctrl.save()\">SaveTEST</button> <button class=\"btn btn-default\">Cancel</button></div></div></div></div></div>");
$templateCache.put("components/si-page/si-page.html","<section class=\"si-page\" ng-class=\"{\'si-page--columnar\': $ctrl.isColumnar, \'si-page--search\': $ctrl.search, \'si-page--bg-grey\': $ctrl.background === \'grey\'}\" ng-transclude=\"\"></section>");
$templateCache.put("components/si-product-type-options/edit-category-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Edit Category</h3></div><div class=\"modal-body\"><form name=\"form\"><div class=\"row\"><div class=\"form-group\"><label class=\"control-label col-lg-4\" translate=\"\">Name</label><div class=\"col-lg-8\"><input type=\"text\" id=\"name\" name=\"name\" class=\"form-control\" ng-model=\"name\"></div></div></div></form></div><div class=\"modal-footer\"><p translate=\"\" class=\"text-danger\" style=\"text-align: left;\">You are only allowed to delete an empty category</p><div><button ng-disabled=\"!canDelete\" class=\"btn btn-danger pull-left\" ng-click=\"delete()\" translate=\"\">Delete Category</button> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" value=\"{{ \'Save\' | translate }}\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div></div>");
$templateCache.put("components/si-product-type-options/si-product-type-options.html","<div class=\"panel-body si-product-type-options\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-sm-12\"><h5 translate=\"\">Current lists apply to all tools and versions</h5><hr></div><div class=\"col-sm-3\"><h3 translate=\"\">Product Categories</h3><form ng-submit=\"$ctrl.addNewCategory($ctrl.newCategory)\" style=\"margin-bottom: 10px;\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCategory\" required=\"\" placeholder=\"New category name\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" translate=\"\">add</button></span></div><div class=\"text-danger\" ng-show=\"$ctrl.isDefined\">Item is already in the list</div></form><div class=\"ibox-content no-padding si-product-type-options__categories\"><ul class=\"list-groups\"><div ng-repeat=\"item in $ctrl.optionsList | orderBy:sortorder\" class=\"list-group-item list-group-item-action\" ng-class=\"{active: $ctrl.mainListName === item.name}\" ng-click=\"$ctrl.loadRelatedList(item.name)\"><span ng-bind=\"item.name\"></span></div><li class=\"list-group-item muted\" ng-show=\"!$ctrl.optionsList.length\">No items found</li></ul></div></div><div class=\"col-sm-9\"><div class=\"col-md-6\"><header class=\"si-product-type-options__options-header\"><h3 ng-bind=\"$ctrl.mainListName\"></h3><span ng-click=\"$ctrl.openEditModal()\"><i class=\"fa fa-pencil text-danger\"></i></span></header><div style=\"margin-bottom: 10px;\"><form ng-submit=\"$ctrl.addItem()\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newItem\" required=\"\" placeholder=\"New product name\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" translate=\"\">add</button></span></div><div class=\"text-danger\" ng-show=\"$ctrl.isDefined\">Item is already in the list</div></form></div><div class=\"ibox-content no-padding\"><ul><div ng-if=\"$ctrl.relatedList.length\"><li class=\"list-group-item draggable\" data-position=\"{{item.position}}\" ng-repeat=\"item in $ctrl.relatedList | orderBy:sortorder\"><i class=\"fa fa-th draggable-handle\"></i> <span ng-bind=\"item.name\"></span> <a class=\"pull-right\" ng-click=\"$ctrl.removeItem(item)\"><i class=\"fa fa-trash text-danger\"></i></a></li></div><li class=\"list-group-item muted\" ng-show=\"!$ctrl.relatedList.length\">No items found</li></ul></div></div></div></div></div></div>");
$templateCache.put("components/sidebar/sidebar.html","<article class=\"sidebar\" ng-class=\"{\'sidebar--collapse\': $ctrl.collapse}\"><div class=\"sidebar__collapse\"><i class=\"fa fa-bars\" ng-click=\"$ctrl.collapse = !$ctrl.collapse\"></i></div><ng-transclude ng-transclude-slot=\"content\"></ng-transclude></article>");
$templateCache.put("components/step-circles/step-circles.html","<ul class=\"c-steps\"><li class=\"step\" ng-repeat=\"step in $ctrl.steps\" ng-class=\"{active: step === $ctrl.active}\"><span class=\"step__number\" ng-bind=\"$index + 1\"></span> <span class=\"step__name\" ng-bind=\"step | translate\"></span></li></ul>");
$templateCache.put("components/table-comp/tableCompTemplate.html","<article ng-form=\"\" novalidate=\"\" name=\"{{ $ctrl.key }}\"><input ng-show=\"false\" type=\"text\" name=\"hidden\" ng-model=\"$ctrl.hiddenForm\" required=\"\"><br><h3 ng-if=\"$ctrl.heading\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"{{ $ctrl.infoTextKey }}\"><span><span>{{ $ctrl.heading }}</span> <span ng-show=\"$ctrl.isFormValid && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!$ctrl.isFormValid && $ctrl.showError && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></span></si-info-text-display></h3><span ng-if=\"!$ctrl.isFlat\"><div class=\"well text-right\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length === 0\" ng-disabled=\"$ctrl.assessment.project.can_edit_assessments\"><span class=\"pull-left\" ng-if=\"!$ctrl.tableData[$ctrl.noInfo]\" translate=\"\">Add a record or indicate no information is available.</span> <span class=\"pull-left\" ng-if=\"$ctrl.tableData[$ctrl.noInfo]\" translate=\"\">No information available.</span> <button type=\"button\" ng-click=\"$ctrl.createRow()\" ng-disabled=\"($ctrl.tableData[$ctrl.tableComplete] || $ctrl.tableData[$ctrl.noInfo]) && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> <span translate=\"\">Add</span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length === 0 && $ctrl.assessment.full_completion_check_required\" ng-click=\"$ctrl.markDone($ctrl.noInfo)\"><translate>No information</translate><span ng-if=\"$ctrl.tableData[$ctrl.noInfo]\">&nbsp; <i class=\"fa fa-check\"></i></span></button></div><div class=\"row\"><div class=\"col-sm-8\" ng-if=\"$ctrl.tableData[$ctrl.noInfo] && $ctrl.noInfoReason && $ctrl.assessment.with_no_info_reason\"><form-select label=\"\'Select why information is not available:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"5\" wrapper=\"row\" required=\"$ctrl.tableData[$ctrl.noInfo]\" show-error=\"showTabWarnings\" form-name=\"{{ $ctrl.noInfoReasonKey }}\" model=\"$ctrl.tableData[$ctrl.noInfoReasonKey]\" options=\"$ctrl.dropdown\" option-value=\"name\" disabled=\"$ctrl.isDisabled\" update-fct=\"$ctrl.updateNoInfoReason($ctrl.assessment, $ctrl.noInfoReasonKey, model)\"><span ng-if=\"$ctrl.noInfoReasonKey.$valid\">valid</span></form-select></div></div><uib-tabset class=\"tabs-left\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length !== 0\"><uib-tab ng-repeat=\"row in $ctrl.tableData[$ctrl.key].objects\" active=\"$first\"><uib-tab-heading><span ng-bind=\"$ctrl.tabTitle === \'$index\' ? $index + 1 : $ctrl.getValue({key: $ctrl.tabTitle}, row)\"></span> <i class=\"pull-right fa fa-chevron-right\"></i></uib-tab-heading><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped\"><tr ng-repeat=\"field in $ctrl.fieldMap\" ng-if=\"$ctrl.showField(field, row)\"><th width=\"20%\">{{ field.label | translate }}</th><td>{{ $ctrl.getValue(field, row) }}</td></tr><tr><td colspan=\"2\"><div ng-if=\"$ctrl.assessment.project.can_edit_assessments\"><button type=\"button\" ng-click=\"$ctrl.updateRow(row)\" ng-disabled=\"$ctrl.tableData[$ctrl.tableComplete] && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-xs\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"$ctrl.deleteRow(row)\" ng-disabled=\"$ctrl.tableData[$ctrl.tableComplete] && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-times\"></i></button></div></td></tr></table></div></div></uib-tab><button type=\"button\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\" ng-click=\"$ctrl.createRow()\" ng-disabled=\"($ctrl.tableData[$ctrl.tableComplete] || $ctrl.tableData[$ctrl.noInfo]) && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-primary btn-horizontal\"><i class=\"fa fa-plus\"></i> <span translate=\"\">Add</span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length !== 0 && $ctrl.assessment.full_completion_check_required && $ctrl.assessment.project.can_edit_assessments\" ng-click=\"$ctrl.markDone($ctrl.tableComplete)\"><translate>Complete</translate><span ng-if=\"$ctrl.tableData[$ctrl.tableComplete]\">&nbsp; <i class=\"fa fa-check\"></i></span></button></uib-tabset><br></span><span ng-if=\"$ctrl.isFlat\"><br><div class=\"well\" ng-show=\"$ctrl.tableData[$ctrl.key].objects.length === 0\"><span ng-if=\"!$ctrl.tableData[$ctrl.noInfo]\" translate=\"\">Add a record or indicate no information is available.</span> <span ng-if=\"$ctrl.tableData[$ctrl.noInfo]\" translate=\"\">No information available.</span></div><table class=\"table table-striped\" ng-show=\"$ctrl.tableData[$ctrl.key].objects.length > 0\"><tr><th ng-repeat=\"field in $ctrl.fieldMap\" ng-if=\"$ctrl.showField(field, row)\" ng-bind=\"field.label | translate\"></th><th></th></tr><tr ng-repeat=\"row in $ctrl.tableData[$ctrl.key].objects\"><td ng-repeat=\"field in $ctrl.fieldMap\" ng-if=\"$ctrl.showField(field, row)\"><div class=\"flat-table\">{{ $ctrl.getValue(field, row) }}</div></td><td class=\"text-right\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\"><button type=\"button\" ng-click=\"$ctrl.updateRow(row)\" ng-disabled=\"$ctrl.tableData[$ctrl.tableComplete] && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-xs\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"$ctrl.deleteRow(row)\" ng-disabled=\"$ctrl.tableData[$ctrl.tableComplete] && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-times\"></i></button></td></tr></table><button type=\"button\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\" ng-click=\"$ctrl.createRow()\" ng-disabled=\"($ctrl.tableData[$ctrl.tableComplete] || $ctrl.tableData[$ctrl.noInfo]) && $ctrl.assessment.full_completion_check_required\" class=\"btn btn-primary pull-left\"><i class=\"fa fa-plus\"></i> <span translate=\"\">Add</span></button><div class=\"btn-align\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\"><button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length === 0 && $ctrl.assessment.full_completion_check_required\" ng-click=\"$ctrl.markDone($ctrl.noInfo)\" ng-disabled=\"$ctrl.isDisabled\"><translate>No information</translate><span ng-if=\"$ctrl.tableData[$ctrl.noInfo]\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"$ctrl.tableData[$ctrl.key].objects.length !== 0 && $ctrl.assessment.full_completion_check_required\" ng-click=\"$ctrl.markDone($ctrl.tableComplete)\"><translate>Complete</translate><span ng-if=\"$ctrl.tableData[$ctrl.tableComplete]\">&nbsp; <i class=\"fa fa-check\"></i></span></button></div><br><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.tableData[$ctrl.noInfo] && $ctrl.noInfoReason && $ctrl.assessment.with_no_info_reason\"><form-select label=\"\'Select why information is not available:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"3\" wrapper=\"row\" required=\"$ctrl.tableData[$ctrl.noInfo]\" show-error=\"showTabWarnings\" form-name=\"{{ $ctrl.noInfoReasonKey }}\" model=\"$ctrl.tableData[$ctrl.noInfoReasonKey]\" options=\"$ctrl.dropdown\" option-value=\"name\" disabled=\"$ctrl.isDisabled\" update-fct=\"$ctrl.updateNoInfoReason($ctrl.tableData, $ctrl.noInfoReasonKey, model)\"><span ng-if=\"$ctrl.noInfoReasonKey.$valid\">valid</span></form-select></div></div><div class=\"clearfix\"></div><br></span></article><hr style=\"height: 1px\"><br>");
$templateCache.put("components/table-comp-basic-profit-loss/tableCompBasicProfitLossTemplate.html","<article ng-form=\"\" class=\"basicProfitLossTable\" name=\"$ctrl.basicProfitLossForm\"><input ng-show=\"false\" type=\"text\" name=\"hidden\" ng-model=\"$ctrl.hiddenForm\" required=\"\"><div class=\"top-buttons\"><div class=\"top-buttons__heading\"><si-info-text-display assessment=\"$ctrl.assessment\" key=\"info_finance_tab_basic_profitloss\"><h3><span translate=\"\">Financial Information</span> <span ng-show=\"$ctrl.isFormValid && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!$ctrl.isFormValid && $ctrl.showError && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></h3></si-info-text-display></div><div class=\"top-buttons__actions\"><div><span><translate>Selected MA Currency:&nbsp;</translate><span class=\"text-danger\">*</span> <span ng-bind=\"$ctrl.global_currency\"></span></span><select chosen=\"\" ng-model=\"$ctrl.global_currency\" ng-disabled=\"($ctrl.global_currency) && ($ctrl.assessment.basic_profit_loss_completed || $ctrl.assessment.basic_profit_loss_no_information_available)\" ng-required=\"$ctrl.basicProfitLossExists()\" ng-change=\"$ctrl.updateCurrency({currency: $ctrl.global_currency})\" ng-options=\"k as (k + \': \' + v.name) for (k, v) in $ctrl.currencies\"><option></option></select></div></div></div><fieldset ng-disabled=\"$ctrl.assessment[$ctrl.noInfo] || $ctrl.assessment[$ctrl.tableComplete]\"><div ng-form=\"\" name=\"$ctrl.innerForm\"><table class=\"table table-bordered soft\"><thead><tr><th></th><th style=\"width: 250px; font-weight: normal;\" ng-repeat=\"data in $ctrl.tableData\"><div style=\"display: flex; align-items: center;\"><year-dropdown last-fiscal=\"true\" style=\"width: 100%\" future-range=\"false\" range=\"2\" ng-model=\"data.year\" disabled-years=\"$ctrl.usedYears\" is-disabled=\"$ctrl.assessment[$ctrl.noInfo] || $ctrl.assessment[$ctrl.tableComplete]\" update=\"$ctrl.changeYear(data, year)\"></year-dropdown><span style=\"cursor: pointer; border-radius: 25px; background-color: rgb(228, 102, 102); color:white; padding: 1px 5px; margin-left: 2px;\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.deleteColumn(data)\" ng-if=\"data.id\">X</span></div></th></tr></thead><tbody><tr><td translate=\"\">Turnover<div ng-if=\"$ctrl.assessment.is_sacco\">(Income)</div></td><td ng-repeat=\"profit in $ctrl.tableData\"><div class=\"row money-field\"><div class=\"number-presentation\" ng-class=\"{\'col-md-12\': true}\"><input class=\"form-control\" ng-model=\"profit.turnover.amount\" name=\"turnover\" ng-required=\"$ctrl.isRequired(profit, \'turnover\')\" ng-disabled=\"!profit.id\" ng-change=\"$ctrl.updateRow(profit, \'turnover\')\" step=\"any\" type=\"text\"></div></div></td></tr><tr><td translate=\"\">Cost of Sales</td><td ng-repeat=\"profit in $ctrl.tableData\"><div class=\"row money-field\"><div class=\"number-presentation\" ng-class=\"{\'col-md-12\': true}\"><input class=\"form-control\" ng-model=\"profit.cost_of_sales.amount\" name=\"cost_of_sales\" ng-required=\"$ctrl.isRequired(profit, \'cost_of_sales\')\" ng-disabled=\"!profit.id\" ng-change=\"$ctrl.updateRow(profit, \'cost_of_sales\')\" step=\"any\" type=\"text\"></div></div></td></tr><tr class=\"calc-row\"><td translate=\"\">Gross Profit</td><td ng-repeat=\"profit in $ctrl.tableData\"><div>{{ profit.turnover.amount - profit.cost_of_sales.amount | number}}</div></td></tr><tr class=\"calc-row\"><td translate=\"\">Gross Margin</td><td ng-repeat=\"profit in $ctrl.tableData\"><div>{{ (((profit.turnover.amount - profit.cost_of_sales.amount) / profit.turnover.amount) * 100).toFixed(1) | number}} %</div></td></tr><tr><td translate=\"\">Operational Costs</td><td ng-repeat=\"profit in $ctrl.tableData\"><div class=\"row money-field\"><div class=\"number-presentation\" ng-class=\"{\'col-md-12\': true}\"><input class=\"form-control\" ng-model=\"profit.operational_costs.amount\" name=\"operational_costs\" ng-required=\"$ctrl.isRequired(profit, \'operational_costs\')\" ng-disabled=\"!profit.id\" ng-change=\"$ctrl.updateRow(profit, \'operational_costs\')\" step=\"any\" type=\"text\"></div></div></td></tr><tr class=\"calc-row\"><td translate=\"\">Net Profit</td><td ng-repeat=\"profit in $ctrl.tableData\"><div>{{profit.turnover.amount - profit.cost_of_sales.amount - profit.operational_costs.amount | number}}</div></td></tr><tr class=\"calc-row\"><td translate=\"\">Profit Margin</td><td ng-repeat=\"profit in $ctrl.tableData\"><div>{{ (((profit.turnover.amount - profit.cost_of_sales.amount - profit.operational_costs.amount) / profit.turnover.amount ) * 100).toFixed(1) | number}} %</div></td></tr></tbody></table></div></fieldset><div class=\"yoy-summary\" ng-if=\"$ctrl.yoyComparisons.length > 0 && $ctrl.yoyComparisons[0].comparisons.length > 0\"><h4 translate=\"\">Year-over-Year Comparison</h4><table class=\"table table-bordered table-condensed yoy-summary-table\"><thead><tr><th translate=\"\">Indicator</th><th ng-repeat-start=\"comp in $ctrl.yoyComparisons[0].comparisons\" translate=\"\">Period</th><th ng-repeat-end=\"\" translate=\"\">Change</th></tr></thead><tbody><tr ng-repeat=\"indicator in $ctrl.yoyComparisons\"><td><strong>{{ indicator.label }}</strong></td><td ng-repeat-start=\"comp in indicator.comparisons\">{{ comp.period }}</td><td ng-repeat-end=\"\" ng-class=\"{\'yoy-summary-cell--red\': comp.highlighted}\"><span ng-if=\"comp.change !== null && comp.change > 0\">+</span> <span ng-if=\"comp.change !== null\">{{ comp.change | number:1 }}%</span> <span ng-if=\"comp.change === null\">-</span> <span ng-if=\"comp.highlighted\" class=\"yoy-dot\">&#9679;</span></td></tr></tbody></table></div><div class=\"source_of_data_container\" ng-if=\"!$ctrl.assessment.basic_profit_loss_no_information_available && !$ctrl.innerForm.$invalid && $ctrl.shouldShowSourceOfData()\"><form-select label=\"\'Select source of data:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"6\" wrapper=\"row source_of_data_row\" required=\"!($ctrl.assessment.basic_profit_loss_completed || $ctrl.assessment.basic_profit_loss_no_information_available)\" options=\"$ctrl.sourceOfDataDropdownOptions\" option-value=\"display_name\" disabled=\"$ctrl.assessment.basic_profit_loss_completed || $ctrl.assessment.basic_profit_loss_no_information_available\" model=\"$ctrl.assessment.financial_information_source_of_data_source\" update-fct=\"$ctrl.updateSourceOfData(model)\" reset-fct=\"$ctrl.clearSourceOfData()\" display-clear-button=\"true\"></form-select></div><file-upload-component ng-if=\"!$ctrl.innerForm.$invalid && $ctrl.shouldShowSourceOfData()\" assessment-id=\"$ctrl.assessment.id\" file-type=\"financial_information\" current-file-name=\"$ctrl.assessment.financial_information_source_of_data_file_name\" source-of-data=\"$ctrl.assessment.financial_information_source_of_data_source\" is-disabled=\"$ctrl.assessment.basic_profit_loss_completed || $ctrl.assessment.basic_profit_loss_no_information_available\" file-input-id=\"financial_information_file_input\" on-files-change=\"$ctrl.handleFilesChange(files, fileType, isRequired, hasFiles)\"></file-upload-component><div class=\"btn-align\" ng-if=\"$ctrl.assessment.project.can_edit_assessments\"><button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"!$ctrl.objectsExist && $ctrl.assessment.full_completion_check_required\" ng-click=\"$ctrl.markDone($ctrl.noInfo)\" ng-disabled=\"$ctrl.noInfoDisabled()\"><translate>No information</translate><span ng-if=\"$ctrl.assessment[$ctrl.noInfo]\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-disabled=\"!$ctrl.canComplete()\" ng-if=\"$ctrl.objectsExist && $ctrl.assessment.full_completion_check_required\" ng-click=\"$ctrl.markDone($ctrl.tableComplete)\"><translate>Complete</translate><span ng-if=\"$ctrl.assessment[$ctrl.tableComplete]\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <span><i class=\"fa fa-info-circle\" ng-if=\"!$ctrl.objectsExist && $ctrl.assessment.full_completion_check_required && $ctrl.questionnaierShouldDisableNoInfo()\" tooltip-placement=\"bottom\" uib-tooltip=\"You have selected \'Reports are audited externally\' or \'At least 3 years\' annual accounts are available\' in the questionnaire (Question 2.3.1). Please complete the entire table.\"></i></span></div><div class=\"row\"><div class=\"col-sm-8\" ng-if=\"$ctrl.assessment[$ctrl.noInfo] && $ctrl.noInfoReason && ($ctrl.dropdown.length>0) && !$ctrl.questionnaierShouldDisableNoInfo()\"><form-select label=\"\'Select why information is not available:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"5\" wrapper=\"row\" required=\"$ctrl.assessment[$ctrl.noInfo] && ($ctrl.dropdown.length>0)\" show-error=\"showTabWarnings\" form-name=\"$ctrl.noInfoReasonKey\" model=\"$ctrl.assessment[$ctrl.noInfoReasonKey]\" options=\"$ctrl.dropdown\" option-value=\"name\" update-fct=\"$ctrl.updateFormElement($ctrl.assessment, $ctrl.noInfoReasonKey, model, {financeForm: financeForm})\" disabled=\"$ctrl.noInfoReasonDisabled()\"><span ng-if=\"$ctrl.noInfoReasonKey.$valid\">valid</span></form-select></div></div><div ng-if=\"$ctrl.objectsExist && $ctrl.assessment.full_completion_check_required && !$ctrl.globalCurrency\" translate=\"\" class=\"text-danger\">Please choose a currency.</div><div ng-show=\"$ctrl.isNetProfitOverflow\" translate=\"\" class=\"text-danger\">You have entered a Net Profit value higher than Gross Profit.</div></article><hr style=\"height: 1px\">");
$templateCache.put("components/table-financial-strategy/table-financial-strategy.html","<article ng-form=\"\" novalidate=\"\" name=\"financial_strategy\"><div><div><si-info-text-display assessment=\"$ctrl.assessment\" key=\"info_finance_tab_financial_strategy\"><h3 class=\"p-t\"><span translate=\"\">Finance Strategy</span> <span ng-show=\"$ctrl.assessment.financial_strategy_completed && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-check-circle text-success\"></i></span> <span ng-show=\"!ctrl.assessment.financial_strategy_completed && $ctrl.showError && $ctrl.assessment.full_completion_check_required\"><i class=\"fa fa-exclamation-circle text-danger\"></i></span></h3></si-info-text-display></div></div><fieldset ng-disabled=\"$ctrl.assessment.financial_strategy_completed\"><table class=\"table table-bordered soft\"><tbody ng-form=\"\" name=\"$ctrl.financeStrategyForm\"><tr><td colspan=\"4\"><span translate=\"\">Outline in percentages (rough estimates) how the FO is financed in the current fiscal year</span></td></tr><colgroup><col><col style=\"width: 20%\"><col style=\"width: 5%\"><col style=\"width: 20%\"></colgroup><tr class=\"data-row\" ng-repeat=\"row in $ctrl.rows\"><td class=\"bold\">{{ row.name | translate }}</td><td><div><form-number name=\"{{row.model}}\" model=\"$ctrl.assessment.financial_strategy[row.model]\" allow-negative=\"false\" assessment=\"$ctrl.assessment\" form-name=\"row.model\" is-disabled=\"$ctrl.assessment.financial_strategy[row.noInfo]\" update-fct=\"$ctrl.update(row.model, model)\" max=\"100\"></form-number></div></td><td class=\"text-center\">%</td><td><div class=\"text-center\"><label><input type=\"checkbox\" ng-checked=\"$ctrl.assessment.financial_strategy[row.noInfo]\" ng-disabled=\"$ctrl.assessment.financial_strategy_completed\" ng-click=\"$ctrl.markRowNoInfo({type:row.noInfo, model: row.model})\"> &nbsp;<translate>No information</translate></label></div></td></tr><tr class=\"calc-row\"><td translate=\"\">Total</td><td ng-class=\"{\'calc-row--danger\': $ctrl.getTotal($ctrl.rows) > 100}\">{{ $ctrl.getTotal($ctrl.rows) }}</td><td ng-style=\"{\'text-align\': \'left\'}\">%</td><td></td></tr></tbody></table></fieldset><span ng-if=\"$ctrl.assessment.full_completion_check_required\"><input type=\"text\" name=\"hidden\" ng-model=\"$ctrl.hiddenForm\" ng-show=\"false\" required=\"\"><button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"!$ctrl.areValuesDefined()\" ng-click=\"$ctrl.markTableDone({type: \'financial_strategy_no_information_available\', other: \'financial_strategy_completed\' })\"><translate>No information</translate><span ng-if=\"$ctrl.assessment.financial_strategy_no_information_available\">&nbsp; <i class=\"fa fa-check\"></i></span></button> <button class=\"btn btn-success btn-horizontal\" type=\"button\" ng-if=\"$ctrl.areValuesDefined()\" ng-disabled=\"$ctrl.assessment.financial_strategy_no_information_available || $ctrl.isFinancialStrategyOver()\" ng-click=\"$ctrl.markTableDone({type: \'financial_strategy_completed\', other: \'financial_strategy_no_information_available\'})\"><translate>Complete</translate><span ng-if=\"$ctrl.assessment.financial_strategy_completed\">&nbsp; <i class=\"fa fa-check\"></i></span></button></span><div class=\"row\"><div class=\"col-sm-8\" ng-if=\"$ctrl.assessment.financial_strategy_no_information_available && ($ctrl.dropdown.length>0)\"><form-select label=\"\'Select why information is not available:\' | translate\" placeholder=\"\'Select an Option\' | translate\" label-width=\"5\" wrapper=\"row\" required=\"$ctrl.assessment.financial_strategy_no_information_available && ($ctrl.dropdown.length>0)\" show-error=\"showTabWarnings\" form-name=\"$ctrl.noInfoReasonKey\" model=\"$ctrl.assessment.financial_strategy_no_info_reason\" options=\"$ctrl.dropdown\" option-value=\"name\" update-fct=\"$ctrl.updateFormElement($ctrl.assessment, \'financial_strategy_no_info_reason\', model, {financeForm: financeForm})\"><span ng-if=\"$ctrl.noInfoReasonKey.$valid\">valid</span></form-select></div></div><br></article><hr style=\"height: 1px\">");
$templateCache.put("directives/paginated/paginated-component.html","<ul uib-pagination=\"\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" ng-model=\"currentPage\" total-items=\"totalItems\" boundary-links=\"true\" max-size=\"10\" items-per-page=\"itemsPerPage\" num-pages=\"numPages\" ng-change=\"pageChange()\" rotate=\"true\" first-text=\"{{first | translate}}\" last-text=\"{{last| translate}}\" ng-show=\"hasPages\"></ul>");
$templateCache.put("hrm/component/trainingTableComponent.html","<article class=\"form-group\"><div class=\"well\" ng-show=\"$ctrl.tableData.length === 0\"><span translate=\"\">Add a record</span></div><table class=\"table table-striped\" ng-show=\"$ctrl.tableData.length > 0\"><tr><th>{{$ctrl.tableType == \'portal\' ? \'Subscription Date\' : ($ctrl.tableType == \'dashboard\' ? \'License Date\' : \'Training Date\') }}</th><th>{{$ctrl.dealNumberText}}</th><th>Certification Valid Until</th><th></th></tr><tr ng-repeat=\"row in $ctrl.tableData\"><td>{{row.training_start_date | date: \'dd-MM-yyyy\'}}</td><td>{{row.deal_number}}</td><td>{{row.certification_valid_until | date: \'dd-MM-yyyy\'}}</td><td class=\"text-right\"><button type=\"button\" ng-click=\"$ctrl.updateRow(row)\" class=\"btn btn-xs\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"$ctrl.deleteTraining({training:row})\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-times\"></i></button></td></tr></table><button type=\"button\" ng-click=\"$ctrl.openModal()\" class=\"btn btn-primary pull-left\"><i class=\"fa fa-plus\"></i> <span translate=\"\">{{$ctrl.addButton}}</span></button></article>");
$templateCache.put("hrm/modals/addTraining.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Add Training Data</h3></div><div class=\"modal-body\"><form name=\"trainingForm\" class=\"form form-horizontal\" ng-submit=\"save()\"><div class=\"form-group\" data-testid=\"start_date\"><label class=\"col-sm-4 control-label\">{{startDateText}} <span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><si-datepicker ng-model=\"training.training_start_date\" required=\"\" data-testid=\"start_date_picker\"></si-datepicker></div></div><div class=\"form-group\" data-testid=\"deal_number\"><label class=\"col-sm-4 control-label\">{{dealNumberText}} <span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"training.deal_number\" required=\"\" data-testid=\"deal_number_input\"></div></div><div class=\"form-group\" data-testid=\"end_date\"><label class=\"col-sm-4 control-label\"><translate>Certification Valid Until</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-8\"><si-datepicker ng-model=\"training.certification_valid_until\" required=\"\" data-testid=\"end_date_picker\"></si-datepicker></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"trainingForm.$invalid\" translate=\"\">Save</button></div>");
$templateCache.put("hrm/modals/suggestAssessor.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Suggest a New Assessor.</h3></div><div class=\"modal-body\"><form name=\"activityForm\" class=\"form form-horizontal\" ng-submit=\"add(email)\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" for=\"email\"><translate>Email</translate></label><div class=\"col-sm-8\"><input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" ng-model=\"email\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"add(email)\" translate=\"\">Suggest Assessor</button></div>");
$templateCache.put("modals/templates/question-not-done.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Question Error</h3></div><div class=\"modal-body\">Please make sure the question is complete before accepting it.</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("modals/templates/questionnaire-not-done.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Questionnaire Error</h3></div><div class=\"modal-body\">Please make sure the questionnaire is complete before accepting all questions.</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("projects/templates/assessmentTabView.html","<div class=\"assessments-view panel-body\" ng-class=\"{\'assessments-view--query-params-set\': queryParamsSet}\"><div class=\"tab-content\"><h3>Project Objectives</h3><div style=\"display: flex; flex-wrap: wrap;\"><span ng-repeat=\"objective in projectObjectives track by $index\" style=\"white-space: nowrap; margin-left: 5px;\"><input type=\"checkbox\" ng-change=\"updateProjectObjectives(objective)\" ng-model=\"objective.isSelected\"> {{ objective.name }}</span> <span style=\"white-space: nowrap; margin-left: 5px;\"><input type=\"checkbox\" ng-model=\"otherChecked\"> Other</span></div><div ng-show=\"otherChecked\" style=\"display: flex; margin-top: 10px; margin-bottom: 10px;\"><input class=\"form-control\" style=\"margin-right: 20px;\" type=\"text\" ng-model=\"project.objective_other\" placeholder=\"Other...\"> <button ng-click=\"updateOtherObjective()\" class=\"btn btn-primary\">Save Objectives</button></div><div class=\"row\"><div class=\"pull-right stacked-barchart__header\"><translate>Total assessments</translate>: {{ assessments.count }}</div></div><div class=\"row\"><div class=\"stacked-barchart__progress\"><div ng-style=\"{width: barchartWidth(assessments.status_counts.created)}\" class=\"progress-bar bar-1\">{{ assessments.status_counts.created }}</div><div ng-style=\"{width: barchartWidth(assessments.status_counts.in_progress)}\" class=\"progress-bar bar-5\">{{ assessments.status_counts.in_progress }}</div><div ng-style=\"{width: barchartWidth(assessments.status_counts.qc_assessor)}\" class=\"progress-bar bar-6\">{{ assessments.status_counts.qc_assessor }}</div><div ng-style=\"{width: barchartWidth(assessments.status_counts.qc_quality_review)}\" class=\"progress-bar bar-2\">{{ assessments.status_counts.qc_quality_review }}</div><div ng-style=\"{width: barchartWidth(assessments.status_counts.has_draft)}\" class=\"progress-bar bar-3\">{{ assessments.status_counts.has_draft }}</div><div ng-style=\"{width: barchartWidth(assessments.status_counts.has_final)}\" class=\"progress-bar bar-4\">{{ assessments.status_counts.has_final }}</div></div></div><div class=\"assessments-view__barchart stacked-barchart\"><center class=\"row\"><p><i class=\"fa fa-square\" style=\"color:#201F4B\"></i> <span><translate>Created</translate></span></p><p><i class=\"fa fa-square\" style=\"color:#1D6970\"></i> <span><translate>In progress</translate></span></p><p><i class=\"fa fa-square\" style=\"color:#1ab394\"></i> <span><translate>QC Assessor</translate></span></p><p><i class=\"fa fa-square\" style=\"color:#90D0CF\"></i> <span><translate>QC Quality Review</translate></span></p><p><i class=\"fa fa-square\" style=\"color:#58C0D0\"></i> <span><translate>Draft</translate></span></p><p><i class=\"fa fa-square\" style=\"color:#00A1AF\"></i> <span><translate>Final</translate></span></p></center></div><div class=\"row\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"assessmentErrorMessage\"><strong translate=\"\">Tool Not Accepted:</strong> <span ng-bind=\"assessmentErrorMessage\"></span></div><div class=\"well\" ng-if=\"assessments.results.length === 0\" translate=\"\">This project has no assessments yet..</div><div uib-dropdown=\"\" style=\"display: flex; flex-direction: row; justify-content: flex-end; margin-bottom: 20px; width: 100%; padding:8px;\"><a ng-if=\"project.can_edit_assessments\" class=\"btn btn-primary\" ng-click=\"addAssessment()\" translate=\"\" style=\"margin-right: 10px;\">Add Assessment</a> <button ng-if=\"isDashboardUserAdminOrEmployee()\" class=\"btn btn-default dropdown-toggle-right\" uib-dropdown-toggle=\"\" type=\"button\" id=\"dropdownMenu1\" aria-haspopup=\"true\" aria-expanded=\"true\" ng-disabled=\"numberOfSelectedAssigments() === 0\"><translate>Group actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"unassignedAssessmentSelected() > 0\"><a ng-click=\"assignAllSelectedAssessments()\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-user\"></i><translate>Assign</translate></a></li><li ng-if=\"assignedAssessmentSelected() > 0\"><a ng-click=\"unassignAllSelectedAssessments()\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-user\"></i><translate>Unassign</translate></a></li><li ng-if=\"numberOfDeletableSelectedAssessments() > 0\"><a class=\"btn btn-sm btn-danger\" ng-click=\"deleteSelectedAssessmentsFromProject()\"><i class=\"fa fa-trash\"></i><translate>Delete</translate></a></li><li><a class=\"btn btn-sm btn-primary\" ng-click=\"changeQualityReviewerForSelectedAssessments()\"><i class=\"fa fa-user\"></i><translate>Change Quality Reviewer</translate></a></li></ul></div><table class=\"table table-hover dataTable\" ng-if=\"assessments.results.length > 0\"><thead><tr><th ng-if=\"isSmartClient\">&nbsp;</th><th class=\"table__th__checkbox\"><input type=\"checkbox\" ng-model=\"selectAll\" ng-click=\"selectAllReportsForDownload(selectAll, assignments)\"></th><th class=\"table__th__user\" translate=\"\">User</th><th sort-column=\"\" sort-name=\"producing_organization__customer__name\" translate=\"\">Assessee</th><th sort-column=\"\" sort-name=\"tool__title\" translate=\"\">Tool</th><th sort-column=\"\" sort-name=\"assessor_full_name\"><span class=\"text-warning\"><translate>Invited</translate></span> / <span class=\"text-success\"><translate>Accepted</translate></span></th><th sort-column=\"\" sort-name=\"display_quality_reviewer__full_name\" translate=\"\">Quality Reviewer</th><th sort-column=\"\" sort-name=\"date\" translate=\"\">Date</th><th sort-column=\"\" sort-name=\"status\" translate=\"\">Status</th><th sort-column=\"\" sort-name=\"last_status_update\" translate=\"\">Last status update</th><th sort-column=\"\" sort-name=\"display_language\" translate=\"\">Language</th><th class=\"text-center table__th__actions\" translate=\"\" ng-if=\"project.can_edit_assessments\">Actions</th></tr></thead><tbody><tr class=\"assessment-view__row\" ng-repeat=\"assignment in assignments\" ng-class=\"{\'asssessment-view__row__last\': assignment.isLast}\"><td><input type=\"checkbox\" ng-show=\"assignment.assigned_as === \'assessor\'\" ng-model=\"assignment.reportSelected\"></td><td ng-if=\"isSmartClient\" class=\"text-center\"><i class=\"fa\" ng-class=\"{\'fa-lock\': assignment.locked_for_assessor, \'fa-unlock\': !assignment.locked_for_assessor}\"></i></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\" class=\"badge text-success\"><i class=\"fa fa-user\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Assessor\' | translate }}\"></i></span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\" class=\"badge text-info\"><i class=\"fa fa-dollar\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ \'Financial Specialist\' | translate }}\"></i></span></a></td><td class=\"assessment-view__row__poname\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span ng-bind=\"assignment.assessment.producing_organization_name\"></span></a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span ng-if=\"assignment.assigned_as === \'assessor\'\">{{ assignment.assessment.tool_title }}</span> <span ng-if=\"assignment.assigned_as === \'financial_specialist\'\">Financial</span></a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span ng-hide=\"assignment.assessment.assignments.length > 0\"><i><translate>No assessor assigned</translate></i></span> <span ng-class=\"{\'text-success\': assignment.type !== \'invitation\', \'text-warning\': assignment.type === \'invitation\'}\">{{ assignment.name }}</span></a></td><td ng-if=\"assignment.assigned_as === \'assessor\'\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\">{{ assignment.assessment.display_quality_reviewer | username }}</a></td><td ng-if=\"assignment.assigned_as === \'financial_specialist\'\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\">{{ assignment.assessment.display_financial_quality_reviewer | username }}</a></td><td class=\"assessment-view__row__date\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span>{{ assignment.assessment.date | date: \'dd-MM-yyyy\' }}</span></a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\">{{ assignment.display_status | capitalize }}</a></td><td><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\">{{ assignment.assessment.last_status_update | date: \'dd-MM-yyyy, HH:mm\' }}</a></td><td class=\"assessment-view__row__language\"><a href=\"{{ getAssignmentHref(assignment) }}\" class=\"assessment-row-link\" ng-click=\"$event.preventDefault(); gotoAssessment(assignment)\"><span ng-bind=\"assignment.assessment.language | language | translate\"></span></a></td><td class=\"text-right assessment-view__row__action\" ng-if=\"project.can_edit_assessments\"><div class=\"dropdown\" uib-dropdown=\"\"><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle=\"\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"><translate>Actions</translate><span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"assignment.assessment.hasUnassigned\"><a ng-click=\"openStep2Modal(assignment.assessment)\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-user\"></i><translate>Assign</translate></a></li><li ng-if=\"assignment.assessment.assignments.length\"><a ng-click=\"openUnassignModal(assignment.assessment)\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-user\"></i><translate>Unassign</translate></a></li><li><a class=\"btn btn-sm btn-info\" ng-click=\"editAssessment(assignment.assessment)\"><i class=\"fa fa-edit\"></i><translate>Edit</translate></a></li><li ng-if=\"isSmartClient && !assignment.assessment.locked_for_assessor\"><a class=\"btn btn-sm btn-info\" ng-click=\"editAssessment(assignment.assessment)\"><i class=\"fa fa-edit\"></i><translate>Edit</translate></a></li><li ng-if=\"assignment.assessment.assignments.length === 0\"><a class=\"btn btn-sm btn-danger\" ng-click=\"deleteAssessmentFromProject(assignment.assessment)\"><i class=\"fa fa-trash\"></i><translate>Delete</translate></a></li><li><a class=\"btn btn-sm btn-primary\" ng-click=\"changeQualityReviewerForAssessment(assignment.assessment)\"><i class=\"fa fa-user\"></i><translate>Change Quality Reviewer</translate></a></li><li><a class=\"btn btn-sm btn-info\" ng-click=\"goToAssessmentDashboard(assignment)\"><i class=\"fa fa-tachometer\"></i><translate>QC Dashboard</translate></a></li></ul></div></td></tr></tbody></table><paginated items=\"assessments\" items-per-page=\"25\"></paginated></div></div></div>");
$templateCache.put("projects/templates/memberTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><div class=\"row\"><div class=\"well\" ng-if=\"project.members.objects.length === 0\"><translate>This project has no members yet...</translate></div><div class=\"col-lg-12\" ng-repeat=\"member in project.members.objects\"><div class=\"contact-box clearfix\" style=\"cursor:pointer;\" ui-sref=\"base.hrm-employees-detail({id: member.id})\"><div class=\"col-sm-4\"><div class=\"text-center\"><img alt=\"image\" class=\"people-small img-circle\" src=\"/assets/img/profile_jem.jpg\"></div></div><div class=\"col-sm-8\"><h3><strong>{{ member.user | username }}</strong></h3><address><abbr title=\"Phone\">P:</abbr> {{ member.user.phone_number }}<br><abbr title=\"Email\">E:</abbr> {{ member.user.email }}<br></address></div></div></div><a class=\"btn btn-primary pull-right\" ng-click=\"addMember()\"><translate>Add Member</translate></a></div></div></div>");
$templateCache.put("projects/templates/projectAddAssessmentView.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-12\"><h2 translate=\"\">Add Assessment to Project</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li class=\"active\" translate=\"\">Add assessment</li></ol></div></div><div class=\"row\"><project-progress-steps step=\"2\"></project-progress-steps></div><div class=\"row\"><div class=\"col-lg-10\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">Create a New Assessment</h5><div class=\"ibox-tools\"><span class=\"label label-danger\" translate=\"\">Draft</span></div></div><div class=\"ibox-content\"><form name=\"projectForm\" ng-submit=\"addAssessment()\"><div class=\"form-group row\"><div class=\"col-sm-12 checkbox\"><label><input ng-model=\"poIsUnknown\" type=\"checkbox\" name=\"poIsUnknown\"><translate>Producer Organization is Unknown</translate></label></div></div><div class=\"form-group row\" ng-if=\"!poIsUnknown\"><label class=\"col-sm-12 control-label\"><translate>Producer Organization</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-12\"><select class=\"form-control\" name=\"producing_organization\" chosen=\"\" data-placeholder-text-single=\"\'Select a Producing Organisation\'|translate\" ng-model=\"assessment.producing_organization_name\" required=\"\" ng-options=\"po.name as po.name for po in producing_organizations.results track by po.url\" style=\"width: 100%\"><option value=\"\"></option></select></div></div><div class=\"form-group row\" ng-if=\"poIsUnknown\"><label class=\"col-sm-12 control-label\"><translate>Full name of producer organization</translate><span class=\"text-danger\">*</span></label><div class=\"col-sm-12\"><input class=\"form-control\" ng-model=\"assessment.producing_organization_name\" type=\"text\" name=\"name\" required=\"\"></div></div><div class=\"form-group row\" ng-if=\"poIsUnknown\"><div class=\"col-sm-12\"><label class=\"control-label\"><translate>Primary contact person for PO</translate><span class=\"text-danger\">*</span></label></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>First Name</translate><label class=\"text-danger\">*</label></label> <input class=\"form-control\" ng-model=\"assessment.producing_organization_contact_first_name\" type=\"text\" name=\"name\" required=\"\"></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Last Name</translate><label class=\"text-danger\">*</label></label> <input class=\"form-control\" ng-model=\"assessment.producing_organization_contact_last_name\" type=\"text\" name=\"name\" required=\"\"></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Phone number</translate></label> <input type=\"text\" class=\"form-control\" ng-model=\"assessment.producing_organization_contact_phone_number\" name=\"name\"></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>E-mail</translate></label> <input class=\"form-control\" ng-model=\"assessment.producing_organization_contact_email\" type=\"text\" name=\"name\"></div></div><div class=\"form-group row\"><div class=\"col-sm-12\"><label class=\"control-label\" translate=\"\">Type of assessment</label></div><div ng-repeat=\"tool in tools.results\" class=\"assessment-circle-container col-sm-3\"><div class=\"assessment-circle\" ng-class=\"{ \'assessment-circle--3\': tool.name === \'basic\' || tool.name === \'basic sme\', \'assessment-circle--4\': tool.name === \'pro\'}\"><input ng-model=\"assessment.tool_type\" type=\"radio\" name=\"radio\" value=\"{{tool.url}}\" ng-change=\"isToolPro(tool)\"> <label ng-bind=\"tool.name\"></label> <span class=\"hint\" ng-bind-html=\"tool.description\"></span></div></div></div><div class=\"form-group row\"><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Global Region</translate><label class=\"text-danger\" translate=\"\">(Auto Filled)</label></label><div class=\"form-control\" ng-bind=\"globalRegion\"></div></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Region</translate><label class=\"text-danger\">*</label></label><select chosen=\"\" class=\"form-control\" ng-options=\"option.name as (option.display_name | capitalize) for option in dropdown.regionOptions track by option.display_name\" ng-model=\"assessment.local_region\"><option></option></select></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Country</translate><label class=\"text-danger\">*</label></label><select chosen=\"\" class=\"form-control\" ng-options=\"option.name as (option.display_name | capitalize) for option in dropdown.countryOptions track by option.display_name\" ng-change=\"updateGlobalRegion()\" ng-model=\"assessment.country\"><option value=\"\"></option></select></div><div class=\"col-sm-3\"><label class=\"control-label\"><translate>Language</translate><label class=\"text-danger\">*</label></label><select chosen=\"\" class=\"form-control\" ng-options=\"language.id as (language.name | capitalize) for language in languages\" ng-model=\"assessment.language\"><option value=\"\"></option></select></div></div><div class=\"form-group row\"><label class=\"col-sm-12 control-label\"><translate>Deadline for assessment</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-12\"><si-datepicker name=\"deadline\" ng-model=\"assessment.deadline\" is-required=\"true\"></si-datepicker></div></div><div class=\"form-group row\"><label class=\"col-sm-12 control-label\"><translate>Name of Proposed Assessor</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-12\"><select chosen=\"\" name=\"assessors\" class=\"form-control\" data-placeholder-text-single=\"\'Select an Assessor\'|translate\" required=\"\" ng-options=\"assessor.url as (assessor.user | name) for assessor in assessors.results track by assessor.user.url\" ng-model=\"assessment.assessor\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group row\" ng-if=\"requiresAccountant\"><label class=\"col-sm-12 control-label\"><translate>Name of Accountant</translate><label class=\"text-danger\">*</label></label><div class=\"col-sm-12\"><select chosen=\"\" name=\"assessors\" class=\"form-control\" data-placeholder-text-single=\"\'Select an Accountant\'|translate\" required=\"\" ng-options=\"accountant.url as (accountant.user | name) for accountant in accountants.results track by accountant.user.url\" ng-model=\"assessment.accountant\" style=\"width: 100%\"><option></option></select></div></div><button class=\"btn btn-primary\" type=\"submit\"><translate>Create assessment</translate></button></form></div></div></div></div></div></div></div>");
$templateCache.put("projects/templates/projectCreateView.html","<si-page><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 translate=\"\">Create Project</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li class=\"active\" translate=\"\">New</li></ol></header><main><project-create-dashboard ng-if=\"app === \'dashboard\'\"></project-create-dashboard><project-create-website ng-if=\"app === \'website\'\"></project-create-website></main></div></si-page>");
$templateCache.put("projects/templates/projectDetailView.html","<project-detail-dashboard ng-if=\"app === \'dashboard\'\"></project-detail-dashboard><project-detail-website ng-if=\"app === \'website\'\"></project-detail-website>");
$templateCache.put("projects/templates/projectEditView.html","<si-page is-columnar=\"true\"><header class=\"si-page__header\"><h2 translate=\"\">Edit Project</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li><a ui-sref=\"base.projects\" translate=\"\">Projects</a></li><li class=\"active\"><strong translate=\"\">Edit</strong></li></ol></header><main ng-if=\"isPageLoaded\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">Edit Project</h5><div class=\"m-b-md\"><a ng-if=\"me.employee\" ng-click=\"deleteProject()\" class=\"btn btn-danger btn-xs pull-right\" style=\"margin-left: 5px\" translate=\"\">Delete project</a></div></div><div class=\"ibox-content\"><form name=\"projectForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>Project name</translate><label class=\"text-danger\" ng-show=\"projectForm.name.$error.required\">*</label></label><div class=\"col-sm-9\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"project.name\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"!isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Deal number</translate></label><div class=\"col-sm-9\"><input type=\"number\" name=\"deal\" class=\"form-control\" ng-model=\"project.deal_number\"></div></div><div class=\"form-group\" ng-if=\"!isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\" translate=\"\">Project owner</label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" ng-options=\"customer.url as customer.name for customer in customers.results\" data-placeholder-text-single=\"\'Select a customer\' | translate\" ng-model=\"project.customer.url\" ng-change=\"changeProjectOwner()\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\" ng-if=\"!isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Project Partner</translate></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" data-placeholder-text-single=\"\'Select Project Partner\' | translate\" style=\"width: 100%\" ng-model=\"project.partner\" ng-options=\"customer.url as customer.name for customer in customers.results\"><option></option></select></div></div><div class=\"form-group\" ng-if=\"!isDashboardUserAdmin\"><label class=\"col-sm-3 control-label\"><translate>Project Donor</translate></label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" data-placeholder-text-single=\"\'Select Project Donor\' | translate\" style=\"width: 100%\" ng-model=\"project.donor\" ng-options=\"customer.url as customer.name for customer in customers.results\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Project lead</label><div class=\"col-sm-9\"><select class=\"form-control\" chosen=\"\" ng-options=\"contact.url as contact.username for contact in contacts\" data-placeholder-text-single=\"\'Select a contact\' | translate\" ng-model=\"project.contact.url\" ng-change=\"updateQRList(project.customer_performs_qc)\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Project members</label><div class=\"col-sm-9\"><select chosen=\"\" multiple=\"\" data-placeholder-text-single=\"\'Select members\' | translate\" ng-options=\"contact as contact.username for contact in contacts\" ng-model=\"project.customer_members.objects\" ng-change=\"updateQRList(project.customer_performs_qc)\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>(Planned) start date</translate><label class=\"text-danger\" ng-show=\"projectForm.start_date.$error.required\">*</label></label><div class=\"col-sm-9\"><si-datepicker name=\"start_date\" ng-model=\"project.start_date\" is-required=\"true\"></si-datepicker></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\"><translate>(Planned) end date</translate></label><div class=\"col-sm-9\"><si-datepicker name=\"deadline\" ng-model=\"project.deadline\"></si-datepicker></div></div><div class=\"form-group\" style=\"display: flex; align-items: center;\" ng-if=\"isEmployee\"><label class=\"col-sm-3 control-label\"><translate>Client performs QC</translate></label><div class=\"col-sm-9\"><div class=\"input-group\"><input type=\"checkbox\" name=\"clientQC\" ng-disabled=\"!project.customer && !project.contact.url\" ng-change=\"updateQRList(project.customer_performs_qc)\" ng-model=\"project.customer_performs_qc\" ng-checked=\"project.customer_performs_qc\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Quality Reviewer</label><div class=\"col-sm-9\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in qualityReviewers.results track by reviewer.url\" ng-model=\"project.quality_reviewer\" ng-disabled=\"isDashboardUserAdmin && !project.customer_performs_qc\" ng-change=\"assignQualityReviewer(project.quality_reviewer)\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" translate=\"\">Financial Quality Reviewer</label><div class=\"col-sm-9\"><select chosen=\"\" data-placeholder-text-single=\"\'Select Financial Quality Reviewer\' | translate\" ng-options=\"reviewer as (reviewer | username) for reviewer in qualityReviewers.results track by reviewer.url\" ng-model=\"project.financial_quality_reviewer\" ng-disabled=\"isDashboardUserAdmin && !project.customer_performs_qc\" ng-change=\"assignFinancialQualityReviewer(project.financial_quality_reviewer)\" style=\"width: 100%\"><option></option></select></div></div><div class=\"form-group\" style=\"display:flex;align-items: center;\" ng-if=\"isEmployee\"><label class=\"col-sm-3 control-label\"><translate>Is AgriGRADE?</translate></label><div class=\"col-sm-9\"><div class=\"input-group\"><input type=\"checkbox\" name=\"isAgriGRADE\" ng-model=\"project.is_agri_grade\" ng-checked=\"project.is_agri_grade\"></div></div></div><div class=\"form-group\"><div class=\"col-sm-9 col-sm-offset-3\"><span ng-show=\"projectForm.$invalid\" class=\"text-danger\">*<translate>fields are required</translate></span> <input type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveProject()\" value=\"{{ \'Save\' | translate }}\" ng-disabled=\"projectForm.$invalid\"> <a class=\"btn btn-default\" ui-sref=\"base.projects-detail({id: project.id})\" translate=\"\">Cancel</a></div></div></form></div></div></main></si-page>");
$templateCache.put("projects/templates/projectsListView.html","<si-page class=\"si-projects\" search=\"true\"><div class=\"si-page__wrapper\"><header class=\"si-page__header\"><h2 ng-if=\"$state.current.name !== \'base.projects-draft\'\" translate=\"\">Projects List</h2><h2 ng-if=\"$state.current.name === \'base.projects-draft\'\" translate=\"\">Draft Projects List</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.home\" translate=\"\">Home</a></li><li class=\"active\"><strong ng-if=\"$state.current.name !== \'base.projects-draft\'\" translate=\"\">Projects</strong> <strong ng-if=\"$state.current.name === \'base.projects-draft\'\" translate=\"\">Draft Projects</strong></li></ol></header><main class=\"si-page__main\"><header class=\"si-page__main__header\"><h4 translate=\"\">All projects assigned to this account</h4><a ui-sref=\"base.projects-create\" class=\"btn btn-primary btn-xs\" ng-if=\"isUserAllowedOnState(\'base.projects-create\')\"><i class=\"fa fa-plus\"></i><translate>Create project</translate></a></header><div class=\"project-list\"><ng-include ng-if=\"app === \'dashboard\'\" src=\"\'projects/templates/partials/projectListTableDashboard.html\'\"></ng-include><ng-include ng-if=\"app === \'website\'\" src=\"\'projects/templates/partials/projectListTableWebsite.html\'\"></ng-include><paginated items=\"projects\" items-per-page=\"10\"></paginated></div></main></div><search><search-filters><search-filter ng-if=\"projects.filters.project_owners.length > 1\" name=\"{{\'Project Owner\' | translate}}\"><dropdown-checkbox-filter display_name=\"Project Owner\" options-key=\"customer_name\" filters=\"projects.filters.project_owners\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"projects.filters.project_quality_reviewers.length > 1\" name=\"{{\'Project Quality Reviewer\' | translate}}\"><dropdown-checkbox-filter display_name=\"Project Quality Reviewer\" options-key=\"project_quality_reviewer\" filters=\"projects.filters.project_quality_reviewers\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"projects.filters.project_financial_quality_reviewers.length > 1\" name=\"{{\'Project Financial Quality Reviewer\' | translate}}\"><dropdown-checkbox-filter display_name=\"Project Financial Quality Reviewer\" options-key=\"project_financial_quality_reviewer\" filters=\"projects.filters.project_financial_quality_reviewers\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter ng-if=\"projects.filters.deal_numbers.length > 1\" name=\"{{\'Deal Number\' | translate}}\"><dropdown-checkbox-filter display_name=\"Deal Number\" options-key=\"deal_number\" filters=\"projects.filters.deal_numbers\" search=\"search(filter, filterDisplay)\"></dropdown-checkbox-filter></search-filter><search-filter name=\"{{\'Project Start Date Range\' | translate}}\"><date-range-filter display-name=\"Project Start Date Range\" max=\"projects.filters.start_date.max\" min=\"projects.filters.start_date.min\" max-name=\"max_start_date\" min-name=\"min_start_date\" search=\"search(filter, filterDisplay)\"></date-range-filter></search-filter><search-filter name=\"{{\'Project End Date Range\' | translate}}\"><date-range-filter display-name=\"Project End Date Range\" max=\"projects.filters.deadline.max\" min=\"projects.filters.deadline.min\" max-name=\"max_deadline\" min-name=\"min_deadline\" search=\"search(filter, filterDisplay)\"></date-range-filter></search-filter><search-filter name=\"{{\'# of Assessments\' | translate}}\"><slider-filter display-name=\"# of Assessments\" max=\"projects.filters.number_of_assessments.max\" min=\"projects.filters.number_of_assessments.min\" max-name=\"max_number_of_assessments\" min-name=\"min_number_of_assessments\" search=\"search(filter, filterDisplay)\"></slider-filter></search-filter><search-filter name=\"{{\'% Level of Completion\' | translate}}\"><slider-filter display-name=\"% Level of Completion\" max=\"projects.filters.completion_percentage.max\" min=\"projects.filters.completion_percentage.min\" max-name=\"max_completion_percentage\" min-name=\"min_completion_percentage\" search=\"search(filter, filterDisplay)\"></slider-filter></search-filter><search-filter-choices remove-filter=\"removeFilter(filter)\" filter-options=\"projects.filters\" filters=\"filters\"></search-filter-choices></search-filters></search></si-page>");
$templateCache.put("reports/modals/accessReport.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Access List Report</h3></div><div class=\"modal-body\"><p translate=\"\">The report can be seen by the following clients. Please select the clients you want to give access to the report to.</p><table class=\"table table-hover\"><tr><th translate=\"\">Name</th></tr><tr ng-repeat=\"customer in customers.results\"><td><label><input type=\"checkbox\" name=\"{{ \'client_\' + customer.name }}\" value=\"{{ customer.url }}\" ng-checked=\"customerInList(report.customers.objects, customer).length > 0\" ng-click=\"toggle(report, customer)\"> {{ customer.name }}</label></td></tr></table></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"save()\" translate=\"\">Save</button> <button class=\"btn\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("reports/modals/customPDFModal.html","<div class=\"modal-header\"><h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Please select the sections you\'re interested in and press generate.</h3></div><div class=\"modal-body\"><form name=\"customPDFModalForm\" class=\"form form-horizontal\"><div class=\"row form-group\"><div ng-repeat=\"obj in report.report_sections\"><si-info-text-display assessment=\"report.assessment\" key=\"obj.label\" hardcodedtext=\"obj.full_description\"><label><input type=\"checkbox\" ng-model=\"obj.value\"> {{ obj.label }}</label></si-info-text-display></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"generateReport()\" value=\"{{ \'Generate Custom Report\' | translate }}\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("reports/modals/invalidateAssessmentModal.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Please provide a reason for invalidation</h3></div><div class=\"modal-body\"><p><translate>Why are you invalidating this report?</translate></p><form name=\"invalidationForm\" class=\"form form-horizontal\"><div class=\"row form-group\"><span class=\"col-sm-2\"><translate>Reason</translate><label class=\"text-danger\">*</label></span><div class=\"col-sm-10\"><textarea type=\"text\" id=\"invalidation_reason\" name=\"invalidation_reason\" class=\"form-control\" ng-model=\"report.assessment.invalidation_reason\" required=\"\">\n            </textarea></div></div><div class=\"row form-group\"><div class=\"col-sm-12\"><label for=\"agreement\"><input type=\"checkbox\" id=\"agreement\" name=\"checkbox\" ng-model=\"report.assessment.is_invalidated\" required=\"\"> <span translate=\"\">I understand that by invalidating this assessment it may not be included in future benchmarking or data analysis</span> <label class=\"text-danger\">*</label></label></div></div></form></div><div class=\"modal-footer\"><input ng-disabled=\"invalidationForm.$invalid\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"invalidate()\" value=\"{{ \'Invalidate\' | translate }}\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("reports/modals/reviseModal.html","<div class=\"modal-header\"><i class=\"text-danger fa fa-2x fa-exclamation-circle\"></i> &nbsp;<h3 class=\"modal-title\" style=\"display: inline-block;\" translate=\"\">Please provide a reason for revision</h3></div><div class=\"modal-body\"><form name=\"form\"><p><translate>Why are you revising this report?</translate></p><div class=\"row\"><span class=\"col-sm-2 control-label\"><translate>Reason</translate><label class=\"text-danger\">*</label></span><div class=\"col-sm-10\"><textarea type=\"text\" class=\"form-control\" ng-model=\"report_revision_reason\" required=\"\"></textarea></div></div></form></div><div class=\"modal-footer\"><input type=\"submit\" class=\"btn btn-primary\" ng-click=\"revise()\" value=\"{{ \'Revise\' | translate }}\" ng-disabled=\"form.$invalid\"> <button class=\"btn btn-default\" ng-click=\"cancel()\" translate=\"\">Cancel</button></div>");
$templateCache.put("reports/modals/sendReport.html","<div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"\">Send Report</h3></div><div class=\"modal-body\"><p translate=\"\">The report can be sent to the following recipients. Please select the people you want to send the report to.</p><h3 translate=\"\">Clients</h3><table class=\"table table-hover\"><tr><th translate=\"\">Name</th><th translate=\"\">Email</th><th translate=\"\" class=\"text-right\">Send</th></tr><tbody ng-repeat=\"customer in report.customers.objects\"><tr ng-repeat=\"contact in customer.contacts.objects\"><td>{{ contact.user|username }}</td><td>{{ contact.user.email }}</td><td class=\"text-right\"><a ng-click=\"alertCustomer(report, contact)\" class=\"btn btn-xs btn-primary\" translate=\"\" change-class-color=\"\" add-class=\"btn-danger\" remove-class=\"btn-primary\" inner-text=\"Report Sent\" inner-text-selector=\"span\" kill-after-click=\"true\">Send report</a></td></tr></tbody></table><h3 translate=\"\">Producing Organization</h3><table class=\"table table-hover\"><tr><th translate=\"\">Name</th><th translate=\"\">Email</th><th translate=\"\" class=\"text-right\">Send</th></tr><tr ng-repeat=\"contact in report.assessment.producing_organization.customer.contacts.objects\"><td>{{ contact.user|username }}</td><td>{{ contact.user.email }}</td><td class=\"text-right\"><a ng-click=\"alertCustomer(report, contact)\" class=\"btn btn-xs btn-primary\" translate=\"\" change-class-color=\"\" add-class=\"btn-danger\" remove-class=\"btn-primary\" inner-text=\"Report Sent\" inner-text-selector=\"span\" kill-after-click=\"true\">Send report</a></td></tr></table></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"cancel()\" translate=\"\">Done</button></div>");
$templateCache.put("reports/reports-tabs/aboutBasic.html","<h2 translate=\"\">About this report</h2><p translate-comment=\"please ignore <br><strong></strong><em></em> &copy;\" translate=\"\">The SCOPE Basic Report gives the results of a SCOPE Basic Assessment. This Report is a strengths and weaknesses analysis. It can be used for self-improvement, capacity building, monitoring and evaluation.<br><br>This Basic report is not meant to be due diligence and it is not sufficient to assess whether an organization is bankable.<br><br>A Basic Assessment is carried out by a second party, usually an organization that has a prior relationship with the producer organization. Note, therefore, that it is not an independent, third party assessment (such as the SCOPE Pro assessment).<br><br>All data and information was collected during interviews with executives and non-executives of the organization.<br><br><strong>Contents</strong><br>This Basic Report contains the following items:<br><br><em>> Chapter 1: assessment results</em><br>- scores per dimension and per topic, and comparison to previous assessments (if relevant)<br>- scores per dimension benchmarked against previous Basic Assessments of the same organization (if relevant)<br>- scores benchmarked against other producer organizations (if available)<br>- summary descriptions by the assessor of strong and weak areas per dimension<br>- detailed assessor comments and scores for each question per dimension<br><br><em>> Chapter 2: producer organization characteristics</em><br>- organization details: location, core products and activities, members, etcetera<br>- governance: the executive and non-executive board<br>- value chain: key customers and business development service providers<br>- financial information: loan history, grant history, etcetera<br>- production information: data on productivity, land use, production volumes, purchase volumes, etcetera<br><br><em>> Chapter 3: documentation check</em><br>The list shows which documents the producer organization has available<br><br><strong>Scoring system</strong><br>The SCOPE Basic has a scoring system from 1 to 5, 1 being the lowest and 5 being the highest score.<br>Score 1: very immature organization<br>Score 2: immature organization<br>Score 3: maturing organization<br>Score 4: professional organization<br>Score 5: very professional organization<br>N/A: Not available<br>N/R: Not relevant (not applicable)<br>N/D: Not disclosed<br><br>Note: although the scale is the same, a SCOPE Basic score is not the same as a SCOPE Pro score. The Pro methodology assumes a higher level of professionalism. The Pro scores are P1 - P5<br><br>A producer organization that is considering access to markets and access to finance, and that scores a Basic 4 or higher, can be eligible for a SCOPE Pro assessment. The Basic methodology is aligned with the Pro methodology on dimensions in order to faciliate graduation to the Pro level.<br><br><strong>Contact</strong><br>www.scopeinsight.com<br>support@scopeinsight.com<br><br>SCOPEInsight does not involve in financing or capacity building Producer Organizations itself, in order to ensure impartial and independent assessments.<br><br>Disclaimer: This report and any attachments are confidential and may not be copied or distributed to anyone who is not the rightful recipient. If you are not the intended recipient, you must not copy this document or attachment and you may not disclose the contents to any other person.<br><br>No rights whatsoever may be derived from this document other than the rights stipulated in an agreement between SCOPEinsight B.V. and the entitled party. &copy; SCOPEinsight b.v., 2014</p>");
$templateCache.put("reports/reports-tabs/balanceSheetTab.html","<div class=\"panel-body\"><span><translate>Selected Currency:</translate><span ng-bind=\"global_currency\"></span></span><div class=\"tab-content\"><h3 class=\"p-t\" translate=\"\">Balance Sheet</h3><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Assets</th><th style=\"width: 150px\" ng-repeat=\"item in report.assessment.balancesheets.objects\">{{ item.year }}</th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Current assets</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Cash and cash equivalents</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.cash.amount | number:2\"></span></td></tr><tr><span ng-bind=\"item.account_receivables.amount | number:2\"></span><td translate=\"\">Account receivables</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.account_receivables.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other receivables</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_receivables.amount | number:2\"></span></td></tr><tr><td translate=\"\">Inventories</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.inventories.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other current assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_current_assets.amount | number:2\"></span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total current assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.total_current_assets.amount | number:2\"></span></td></tr><tr class=\"sub\"><td translate=\"\">Non-current assets</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Fixed assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.fixed_assets.amount | number:2\"></span></td></tr><tr><td translate=\"\">Intangible assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.intangible_assets.amount | number:2\"></span></td></tr><tr><td translate=\"\">Goodwill</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.goodwill.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other non-current assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_non_current_assets.amount | number:2\"></span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total non-current assets</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.total_non_current_assets.amount | number:2\"></span></td></tr></tbody><thead><tr><th translate=\"\">Liabilities</th><th ng-repeat=\"item in report.assessment.balancesheets.objects\">{{ item.year }}</th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Current liabilities</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Accounts payable</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.accounts_payable.amount | number:2\"></span></td></tr><tr><td translate=\"\">Short term loans</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.short_term_loans.amount | number:2\"></span></td></tr><tr><td translate=\"\">Overdrafts</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.overdrafts.amount | number:2\"></span></td></tr><tr><td translate=\"\">Income tax payable</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.income_tax_payable.amount | number:2\"></span></td></tr><tr><td translate=\"\">Short term provisions</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.liabilities.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other current liabilities</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_current_liabilities.amount | number:2\"></span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total current liabilities</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.total_current_liabilities.amount | number:2\"></span></td></tr><tr class=\"sub\"><td translate=\"\">Non current liabilities</td><td colspan=\"{{ assessment.balancesheets.objects.length }}\"></td></tr><tr><td translate=\"\">Long term loans</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.long_term_loans.amount | number:2\"></span></td></tr><tr><td translate=\"\">Deferred tax</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.deferred_tax.amount | number:2\"></span></td></tr><tr><td translate=\"\">Provisions</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.provisions.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other non-current liabilities</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_non_current_liabilities.amount | number:2\"></span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total non-current liabilities</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.total_non_current_liabilities.amount | number:2\"></span></td></tr><tr class=\"sub group\"><td translate=\"\">NET ASSETS</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.net_assets.amount | number:2\"></span></td></tr></tbody><tr class=\"group sub-total\"><td translate=\"\">Are accounts audited?</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\" class=\"text-center\"><span ng-if=\"pl.audited\" translate=\"\">Yes</span></td></tr><thead><tr><th translate=\"\">Equity</th><th ng-repeat=\"item in report.assessment.balancesheets.objects\">{{ item.year }}</th></tr></thead><tbody><tr><td translate=\"\">Share capital</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.share_capital.amount | number:2\"></span></td></tr><tr><td translate=\"\">Share premium</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.share_premium.amount | number:2\"></span></td></tr><tr><td translate=\"\">Retained earnings</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.retained_earnings.amount | number:2\"></span></td></tr><tr><td translate=\"\">Grants (seed capital)</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.grants.amount | number:2\"></span></td></tr><tr><td translate=\"\">Statutory/legal reserves</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.statutory_legal_reserves.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other reserves</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other_reserves.amount | number:2\"></span></td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.other.amount | number:2\"></span></td></tr><tr class=\"sub-total group\"><td translate=\"\">Total equity</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.total_equity.amount | number:2\"></span></td></tr></tbody><thead><tr><th translate=\"\">Working capital and inventory</th><th ng-repeat=\"item in report.assessment.balancesheets.objects\">{{ item.year }}</th></tr></thead><tbody><tr><td translate=\"\">Net working capital throughout the year</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.net_working_capital.amount | number:2\" ng-if=\"!($index === (report.assessment.balancesheets.objects.length - 1))\"></span></td></tr><tr><td translate=\"\">Average inventory throughout the year</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.average_inventory.amount | number:2\"></span></td></tr><tr><td translate=\"\">Average receivable throughout the year</td><td ng-repeat=\"item in report.assessment.balancesheets.objects\"><span ng-bind=\"item.average_receivables.amount | number:2\"></span></td></tr></tbody></table></div></div>");
$templateCache.put("reports/reports-tabs/benchmarkingTab.html","<p translate=\"\">This page shows you benchmarking information of the assessment with other assessment data from the SCOPEinsight assessment database.</p><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">Your Organization\'s Scores.</h5></div><div class=\"ibox-content\"><p translate=\"\">Take regular assessments and you can see your progress over time.</p><div class=\"background-image-full\" ng-style=\"{\'background-image\':\'url(\' + poUrl + \')\'}\"></div><hr><h3 translate=\"\">Your organization\'s scores compared to your peers.</h3><p translate=\"\">How are you performing compared to others?</p><div class=\"background-image-full\" ng-style=\"{\'background-image\':\'url(\' + benchMarkUrl + \')\'}\"></div></div></div><hr><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">About This Report</h5></div><div class=\"ibox-content\"><p translate=\"\">The SCOPE Basic Report gives the results of a SCOPE Basic Assessment. This Report is a strengths and weaknesses analysis. It can be used for self-improvement, capacity building, monitoring and evaluation.</p><p translate=\"\">This Basic report is not meant to be due diligence and it is not sufficient to assess whether an organization is bankable.</p><p translate=\"\">A Basic Assessment is carried out by a second party, usually an organization that has a prior relationship with the producer organization. Note, therefore, that it is not an independent, third party assessment (such as the SCOPE Pro assessment).</p><p translate=\"\">All data and information was collected during interviews with executives and non-executives of the organization.</p><p><strong translate=\"\">Contents</strong></p><p translate=\"\">This Basic Report contains the following items:</p><p><em translate=\"\">Chapter 1: assessment results</em></p><ul><li translate=\"\">scores per dimension and per topic, and comparison to previous assessments (if relevant)</li><li translate=\"\">scores per dimension benchmarked against previous Basic Assessments of the same organization (if relevant)</li><li translate=\"\">scores benchmarked against other producer organizations (if available)</li><li translate=\"\">summary descriptions by the assessor of strong and weak areas per dimension</li><li translate=\"\">detailed assessor comments and scores for each question per dimension</li></ul><p><em translate=\"\">Chapter 2: producer organization characteristics</em></p><ul><li translate=\"\">organization details: location, core products and activities, members, etcetera</li><li translate=\"\">governance: the executive and non-executive board</li><li translate=\"\">value chain: key customers and business development service providers</li><li translate=\"\">financial information: loan history, grant history, etc.</li><li translate=\"\">production information: data on productivity, land use, production volumes, purchase volumes, etcetera</li></ul><p><em translate=\"\">Chapter 3: documentation check</em></p><p translate=\"\">The list shows which documents the producer organization has available</p><p><strong translate=\"\">Scoring System</strong></p><p translate=\"\">The SCOPE Basic has a scoring system from 1 to 5, 1 being the lowest and 5 being the highest score.</p><p translate=\"\">Score 1: Very immature organization N/A Not Available</p><p translate=\"\">Score 2: Immature organization N/R Not Relevant (not applicable)</p><p translate=\"\">Score 3: Maturing organization N/D Not disclosed</p><p translate=\"\">Score 4: Professional Organization</p><p translate=\"\">Score 5: Very Professional Organization</p><p translate=\"\">Note: although the scale is the same, a SCOPE Basic score is not the same as a SCOPE Pro score. The Pro methodology assumes a higher level of professionalism. The Pro scores are P1 - P5</p><p translate=\"\">A producer organization that is considering access to markets and access to finance, and that scores a Basic 4 or higher, can be eligible for a SCOPE Pro assessment. The Basic methodology is aligned with the Pro methodology on dimensions in order to faciliate graduation to the Pro level.</p><p translate=\"\">SCOPEInsight does not involve itself in financing or capacity building Producer Organizations, in order to ensure impartial and independent assessments.</p><p translate=\"\">Disclaimer: This report and any attachments are confidential and may not be copied or distributed to anyone who is not the rightful recipient. If you are not the intended recipient, you must not copy this document or attachment and you may not disclose the contents to any other person.</p><p translate=\"\">No rights whatsoever may be derived from this document other than the rights stipulated in an agreement between SCOPEinsight B.V. and the entitled party.</p></div></div>");
$templateCache.put("reports/reports-tabs/cashflowStatementTab.html","<div class=\"panel-body\"><div class=\"tab-content\"><h3 class=\"p-t\" translate=\"\">Cashflow Statement</h3><table class=\"table table-bordered financial flow\"><thead><tr><th translate=\"\">Cashflow statement</th><th style=\"width: 150px\" ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.year }}</th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Cash flow from operating activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Net income</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.net_income.amount | number:2}}</td></tr><tr><td translate=\"\">Adjustment for tax</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.adjustment_for_tax.amount | number:2}}</td></tr><tr class=\"sub\"><td translate=\"\">Adjustments for non-cash items</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Depreciation and amortization</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.depreciation_and_amortization.amount | number:2}}</td></tr><tr><td translate=\"\">Investment income</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.investment_income.amount | number:2}}</td></tr><tr><td translate=\"\">Interest expense</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.interest_expense.amount | number:2}}</td></tr><tr><td translate=\"\">Profit / (loss) on sale of PP/E</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.profit_on_sale_of_ppe.amount | number:2}}</td></tr><tr><td translate=\"\">Working capital changes</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.working_capital_changes.amount | number:2}}</td></tr><tr><td translate=\"\">(increase)/decrease in trade and other receivables</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.decrease_in_trade_and_other_receivables.amount | number:2}}</td></tr><tr><td translate=\"\">(Increase)/decrease in inventories</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.increase_in_inventories.amount | number:2}}</td></tr><tr><td translate=\"\">increase/(decrease) in trade payables and other payables</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.increase_in_trade_and_other_payables.amount | number:2}}</td></tr><tr class=\"sub-total group\"><td translate=\"\">Cash generated from operations</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.cash_generated_from_operations.amount | number:2}}</td></tr><tr class=\"sub\"><td translate=\"\">Interest paid</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.interest_paid.amount | number:2}}</td></tr><tr class=\"sub\"><td translate=\"\">Income taxes paid</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.income_taxes_paid.amount | number:2}}</td></tr><tr class=\"sub-total group\"><td translate=\"\">NET CASH FROM OPERATING ACTIVITIES</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.net_cash_from_operating_activities.amount | number:2}}</td></tr><tr class=\"sub\"><td translate=\"\">Cash flows from investing activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Purchases of property, plant and equipment (PPE)</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.purchases_of_property_plant_and_equipment.amount | number:2}}</td></tr><tr><td translate=\"\">Proceed from sale of PPE</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.proceeds_from_sale_of_PPE.amount | number:2}}</td></tr><tr><td translate=\"\">Purchases of intangible assets</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.purchases_of_intangible_assets.amount | number:2}}</td></tr><tr><td translate=\"\">Purchases of financial assets</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.purchases_of_financial_assets.amount | number:2}}</td></tr><tr><td translate=\"\">Loans granted to associates or subsidiaries</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.loans_granted_to_associates_or_subsidiaries.amount | number:2}}</td></tr><tr><td translate=\"\">Loan repayments received from associates or subsidiaries</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.loan_repayments_received_from_associates_or_subsidiaries.amount | number:2}}</td></tr><tr><td translate=\"\">Interest received</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.interest_received.amount | number:2}}</td></tr><tr><td translate=\"\">Dividends received</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.dividends_received.amount | number:2}}</td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.investing_other.amount | number:2}}</td></tr><tr class=\"sub-total group\"><td translate=\"\">Net cash used in investing activities</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.net_cash_used_in_investing_activities.amount | number:2}}</td></tr><tr class=\"sub\"><td translate=\"\">Cash flows from financing activities</td><td colspan=\"{{ assessment.cashflowstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Proceeds from sale of ordinary shares</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.proceeds_from_sale_of_ordinary_shares.amount | number:2}}</td></tr><tr><td translate=\"\">Purchase of treasury shares</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.purchase_of_treasury_shares.amount | number:2}}</td></tr><tr><td translate=\"\">Proceeds from borrowings</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.proceeds_from_borrowings.amount | number:2}}</td></tr><tr><td translate=\"\">Repayments from borrowings</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.repayments_from_borrowings.amount | number:2 }}</td></tr><tr><td translate=\"\">Proceeds from loan from subsidiary undertaking</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.proceeds_from_loan_from_subsidiary_undertaking.amount | number:2}}</td></tr><tr><td translate=\"\">Dividends paid to organizations shareholders</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.dividends_paid_to_organizations_shareholders.amount | number:2}}</td></tr><tr><td translate=\"\">Other</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.financing_other.amount | number:2}}</td></tr><tr class=\"sub-total group\"><td translate=\"\">Net cash used in financing activities</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.net_cash_used_in_financing_activities.amount | number:2}}</td></tr><tr class=\"sub group\"><td translate=\"\">NET CASH FLOW</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.net_cash_flow.amount | number:2}}</td></tr><tr><td translate=\"\">Cash at beginning of period</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.cash_at_beginning_of_period.amount | number:2}}</td></tr><tr class=\"sub-total group\"><td translate=\"\">Cash at end of period</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\">{{ item.cash_at_end_of_period.amount | number:2}}</td></tr><tr class=\"group sub-total\"><td translate=\"\">Are accounts audited?</td><td ng-repeat=\"item in report.assessment.cashflowstatements.objects\" class=\"text-center\"><span class=\"fa\" ng-class=\"{\'fa-check\': pl.audited}\"></span></td></tr></tbody></table></div></div>");
$templateCache.put("reports/reports-tabs/dashboardUsersAttachmentsTab.html","<section class=\"reports-attachments\"><p translate=\"\">Below list contains all assessment attachments.</p><div class=\"tab-content\"><table class=\"table table-striped reports-attachments__table\"><thead class=\"reports-attachments__table-header\"><tr><th translate=\"\">Question</th><th translate=\"\">Filename</th><th translate=\"\">Action</th></tr></thead><tbody><tr ng-repeat=\"document in documents\"><td>{{ document.response.question_display_position }} {{ document.response.question_title }}</td><td>{{ document.document.file_name }}</td><td><a class=\"btn btn-primary\" ng-href=\"{{ document.document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td></tr></tbody></table></div></section>");
$templateCache.put("reports/reports-tabs/dashboardUsersDocumentationTab.html","<p translate=\"\">Below list indicates what kind of documentation the organization has available.</p><div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Question</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-repeat=\"row in report.assessment.document_availability_responses.objects\"><td ng-bind=\"row.question_title\"></td><td><div ng-repeat=\"document in row.documents.objects track by $index\"><a class=\"btn btn-primary\" ng-href=\"{{ document.file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></div></td><td><p>{{ row.comment }}</p></td></tr></table></div>");
$templateCache.put("reports/reports-tabs/documentationTab.html","<p translate=\"\">Below list indicates what kind of documentation the organization has available.</p><div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document type</th><th style=\"width:10%\" translate=\"\">Availability</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-show=\"row.available !== null\" ng-repeat=\"row in report.assessment.document_availability_responses.objects\"><td>{{ row.question_title }}</td><td><span class=\"label label-success\" ng-show=\"row.available === true\" translate=\"\">Yes</span> <span class=\"label label-warning\" ng-show=\"row.available === false\" translate=\"\">No</span> <span class=\"label\" ng-show=\"row.available === null\" translate=\"\">N/R</span></td><td><p>{{ row.comment }}</p></td></tr></table></div>");
$templateCache.put("reports/reports-tabs/financeProductTabView.html","<div class=\"panel-body\" style=\"min-height:100px\"><div class=\"row\"><div class=\"col-md-12\"><h3 ng-bind=\"\'Bank account & loan history\' | translate\"></h3><table class=\"table table-striped\"><tr><td class=\"col-md-5\"><label translate=\"\">Bank account with financial institution</label></td><td><yes-no-bool label=\"\" label-width=\"6\" wrapper=\"row\" model=\"report.assessment.agent_bank_account_loan_history.has_bank_account\" update-fct=\"saveBankAccountLoanHistory({has_bank_account: model})\"></yes-no-bool></td></tr><tr><td class=\"col-md-5\"><label translate=\"\">Account with mobile operator</label></td><td><yes-no-bool label=\"\" label-width=\"6\" wrapper=\"row\" model=\"report.assessment.agent_bank_account_loan_history.has_mobile_account\" update-fct=\"saveBankAccountLoanHistory({has_mobile_account: model})\"></yes-no-bool></td></tr><tr><td class=\"col-md-5\"><label translate=\"\">Has had loans in the past</label></td><td><yes-no-bool label=\"\" label-width=\"6\" wrapper=\"row\" model=\"report.assessment.agent_bank_account_loan_history.has_loan_history\" update-fct=\"saveBankAccountLoanHistory({has_loan_history: model})\"></yes-no-bool></td></tr><tr><td class=\"col-md-5\"><label translate=\"\">All loans were paid back</label></td><td><yes-no-bool label=\"\" label-width=\"6\" wrapper=\"row\" model=\"report.assessment.agent_bank_account_loan_history.has_paid_back_loans\" update-fct=\"saveBankAccountLoanHistory({has_paid_back_loans: model})\"></yes-no-bool></td></tr></table></div></div><br><h3 translate=\"\">Income from Agent role</h3><div class=\"well\" ng-show=\"report.assessment.agent_income.objects.length === 0\"><translate>No records were found...</translate></div><table class=\"table table-striped\" ng-show=\"report.assessment.agent_income.objects.length !== 0\"><tr><th translate=\"\" style=\"width:28%\">Year</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in report.assessment.agent_income.objects track by row.id\"><td>{{ row.year }}</td><td>{{ row.income.amount | currency:row.income.currency+\" \":0 }}</td></tr></table><br><hr><br><h3 translate=\"\">Produce Sold</h3><div class=\"well\" ng-show=\"report.assessment.products.objects.length === 0\"><translate>No records were found...</translate></div><table class=\"table table-striped\" ng-show=\"report.assessment.products.objects.length !== 0\"><tr><th translate=\"\" style=\"width:28%\">Product</th><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"product in report.assessment.products.objects\"><td style=\"word-wrap: break-word;\">{{ product.display_name }}</td><td>{{ product.productionsales.objects[0].year }}</td><td>{{ product.unit | capitalize}}</td><td>{{ product.productionsales.objects[0].volume }}</td><td>{{ product.productionsales.objects[0].price.amount | currency:product.productionsales.objects[0].price.currency+\" \":0 }}</td></tr></table><br></div>");
$templateCache.put("reports/reports-tabs/financeTab.html","<p translate=\"\">Here you see some key financial information provided by the organization.</p><div class=\"tab-content\"><h3 translate=\"\">Financial Data</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Turnover</th><th translate=\"\">Cost of sales</th><th translate=\"\">Net profit</th><th translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Shareholder\'s Equity</th></tr><tr ng-repeat=\"row in report.assessment.basic_financial_infos.objects\"><td>{{ row.year }}</td><td>{{ row.turnover.amount | currency:row.turnover.currency+\" \":0 }}</td><td>{{ row.cost_of_sales.amount | currency:row.cost_of_sales.currency+\" \":0 }}</td><td>{{ row.net_profit.amount | currency:row.net_profit.currency+\" \":0 }}</td><td ng-if=\"report.assessment.tool.type.basic_sme\">{{ row.shareholders_equity.amount | currency:row.shareholders_equity.currency+\" \":0 }}</td></tr></table><hr><h3 translate=\"\">Bank Accounts</h3><table class=\"table table-striped\"><tr><th translate=\"\">Bank</th><th translate=\"\">Type</th><th translate=\"\">Active since</th><th translate=\"\">Current balance</th></tr><tr ng-repeat=\"row in report.assessment.bank_accounts.objects\"><td>{{ row.bank }}</td><td>{{ row.display_bank_type }}</td><td>{{ row.active_since }}</td><td>{{ row.current_balance.amount | currency:row.current_balance.currency+\" \":0 }}</td></tr></table><hr ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><h3 translate=\"\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\">Collateral</h3><table class=\"table table-striped\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><tr><th translate=\"\">Type</th><th translate=\"\">Description</th><th translate=\"\">Age</th><th translate=\"\">Estimated Value</th><th translate=\"\">External valuation done?</th><th translate=\"\">External valuation by</th><th translate=\"\">Valuation proof available?</th><th></th></tr><tr ng-repeat=\"row in report.assessment.collateral_assets.objects\"><td>{{ row.type }}</td><td>{{ row.description }}</td><td><span ng-if=\"row.age_in_years\"><span ng-bind=\"row.age_in_years\"></span><translate>years</translate></span> <span ng-if=\"!row.age_in_years\">N.A.</span></td><td>{{ row.estimated_value.amount | currency:row.estimated_value.currency+\" \":0 }}</td><td><span ng-if=\"row.external_valuation_done\"><translate>Yes</translate></span> <span ng-if=\"!row.external_valuation_done\"><translate>No</translate></span></td><td><span ng-if=\"row.external_valuation_by\" ng-bind=\"row.external_valuation_by\"></span> <span ng-if=\"!row.external_valuation_by\"><translate>N.A.</translate></span></td><td><span ng-if=\"row.valuation_proof_available\"><translate>Yes</translate></span> <span ng-if=\"!row.valuation_proof_available\"><translate>No</translate></span></td><td class=\"text-right\"><a ng-click=\"saveCollateralAsset(assessment, row)\" class=\"btn btn-xs\"><i class=\"fa fa-pencil\"></i></a> <a ng-click=\"removeCollateralAsset(row)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-times\"></i></a></td></tr></table><h3 translate=\"\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\">Loan Requirements</h3><table class=\"table table-striped\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><tr><th translate=\"\">Loan amount</th><th translate=\"\">Duration (months)</th><th><translate>Expected Interest rate</translate><br>(<translate>annual</translate>)</th><th translate=\"\">Purpose</th><th translate=\"\">Description</th><th translate=\"\">Accountant Comments</th></tr><tr ng-repeat=\"row in report.assessment.loan_requirements.objects\"><td>{{ row.amount.amount | currency:row.amount.currency+\" \":0 }}</td><td>{{ row.duration_in_months }}</td><td>{{ row.expected_annual_interest_percentage }}</td><td class=\"text-center\">{{ row.purpose }}</td><td class=\"text-center\">{{ row.description }}</td><td class=\"text-right\">{{ row.comment}}</td></tr></table><hr ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><h3 translate=\"\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\">Loan History</h3><table class=\"table table-striped\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><tr><th translate=\"\">Loan amount</th><th translate=\"\">Financier</th><th translate=\"\">Start date</th><th translate=\"\">End date</th><th><translate>Interest rate</translate><br>(<translate>annual</translate>)</th><th translate=\"\">Repayment status</th><th translate=\"\">Purpose</th><th translate=\"\">Comments</th></tr><tr ng-repeat=\"row in report.assessment.loan_histories.objects\"><td>{{ row.amount.amount | currency:row.amount.currency+\" \":0 }}</td><td>{{ row.display_financier }}</td><td>{{ row.start_date | date: \'dd-MM-yyyy\' }}</td><td>{{ row.end_date | date: \'dd-MM-yyyy\' }}</td><td>{{ row.interest_rate }}</td><td>{{ row.display_repayment_status }}</td><td>{{ row.display_purpose }}</td><td>{{ row.comments }}</td></tr></table><hr ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><h3 translate=\"\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\">Pre-Finance History</h3><hr ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><h3 translate=\"\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\">Grant History</h3><table class=\"table table-striped\" ng-hide=\"report.tool_type === \'SCOPE Rapid\'\"><tr><th translate=\"\">Grant amount</th><th translate=\"\">In cash / in kind</th><th translate=\"\">Name of funder</th><th translate=\"\">Funder type</th><th translate=\"\">Start date</th><th translate=\"\">Purpose</th><th translate=\"\">Comments</th></tr><tr ng-repeat=\"row in report.assessment.load_histories.objects\"><td>{{ row.amount.amount | currency:row.amount.currency+\" \":0 }}</td><td>{{ row.in_cash_in_kind }}</td><td>{{ row.funder }}</td><td>{{ row.funder_type }}</td><td>{{ row.start_date | date: \'dd-MM-yyyy\' }}</td><td>{{ row.purpose }}</td><td>{{ row.comments }}</td></tr></table><hr><h3 translate=\"\">Comments</h3><p>{{ report.assessment.assessor_comments_finance }}</p></div>");
$templateCache.put("reports/reports-tabs/financialPerformanceTab.html","<div class=\"panel-body\"><div class=\"tab-content\"><h3 translate=\"\">Financial Ratios</h3><table class=\"table table-bordered financial\"><thead><tr><th translate=\"\">Metric</th><th style=\"width: 150px\" ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.year }}</th><th class=\"divider\"></th><th translate=\"\"></th><th class=\"rotated\"><div translate=\"\">Status</div></th><th class=\"rotated\"><div translate=\"\">Trend</div></th><th class=\"rotated\"><div translate=\"\">Volatility</div></th><th class=\"rotated\"><div translate=\"\">Total score</div></th></tr></thead><tbody><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Growth</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Revenue growth</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.revenue_growth | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.revenue_growth.status }}</td><td>{{ report.assessment.financial_scores.revenue_growth.trend }}</td><td>{{ report.assessment.financial_scores.revenue_growth.volatility }}</td><td>{{ report.assessment.financial_scores.revenue_growth.total_score }}</td></tr><tr><td translate=\"\">Net profit growth</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.net_profit_growth | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.net_profit_growth.status }}</td><td>{{ report.assessment.financial_scores.net_profit_growth.trend }}</td><td>{{ report.assessment.financial_scores.net_profit_growth.volatility }}</td><td>{{ report.assessment.financial_scores.net_profit_growth.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Profitability</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Operating profit margin</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.operating_profit_margin | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.operating_profit_margin.status }}</td><td>{{ report.assessment.financial_scores.operating_profit_margin.trend }}</td><td>{{ report.assessment.financial_scores.operating_profit_margin.volatility }}</td><td>{{ report.assessment.financial_scores.operating_profit_margin.total_score }}</td></tr><tr><td translate=\"\">Net profit margin</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.net_profit_margin | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.net_profit_margin.status }}</td><td>{{ report.assessment.financial_scores.net_profit_margin.trend }}</td><td>{{ report.assessment.financial_scores.net_profit_margin.volatility }}</td><td>{{ report.assessment.financial_scores.net_profit_margin.total_score }}</td></tr><tr><td translate=\"\">Return on capital</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.return_on_capital | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.return_on_capital.status }}</td><td>{{ report.assessment.financial_scores.return_on_capital.trend }}</td><td>{{ report.assessment.financial_scores.return_on_capital.volatility }}</td><td>{{ report.assessment.financial_scores.return_on_capital.total_score }}</td></tr><tr><td translate=\"\">Return on equity (ROE)</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.return_on_equity | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.return_on_equity.status }}</td><td>{{ report.assessment.financial_scores.return_on_equity.trend }}</td><td>{{ report.assessment.financial_scores.return_on_equity.volatility }}</td><td>{{ report.assessment.financial_scores.return_on_equity.total_score }}</td></tr><tr><td translate=\"\">Return on assets (ROA)</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.return_on_assets | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.return_on_assets.status }}</td><td>{{ report.assessment.financial_scores.return_on_assets.trend }}</td><td>{{ report.assessment.financial_scores.return_on_assets.volatility }}</td><td>{{ report.assessment.financial_scores.return_on_assets.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Productivity</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Asset turnover</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.asset_turnover | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.asset_turnover.status }}</td><td>{{ report.assessment.financial_scores.asset_turnover.trend }}</td><td>{{ report.assessment.financial_scores.asset_turnover.volatility }}</td><td>{{ report.assessment.financial_scores.asset_turnover.total_score }}</td></tr><tr><td translate=\"\">Working capital turnover</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.working_capital_turnover | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.working_capital_turnover.status }}</td><td>{{ report.assessment.financial_scores.working_capital_turnover.trend }}</td><td>{{ report.assessment.financial_scores.working_capital_turnover.volatility }}</td><td>{{ report.assessment.financial_scores.working_capital_turnover.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Solvency / Gearing</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Debt-to-assets ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.debt_to_assets_ratio | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.debt_to_assets_ratio.status }}</td><td>{{ report.assessment.financial_scores.debt_to_assets_ratio.trend }}</td><td>{{ report.assessment.financial_scores.debt_to_assets_ratio.volatility }}</td><td>{{ report.assessment.financial_scores.debt_to_assets_ratio.total_score }}</td></tr><tr><td translate=\"\">Debt-to-equity ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.debt_to_equity_ratio | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.debt_to_equity_ratio.status }}</td><td>{{ report.assessment.financial_scores.debt_to_equity_ratio.trend }}</td><td>{{ report.assessment.financial_scores.debt_to_equity_ratio.volatility }}</td><td>{{ report.assessment.financial_scores.debt_to_equity_ratio.total_score }}</td></tr><tr><td translate=\"\">Debt to EBIT ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.debt_coverage_ratio | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.debt_coverage_ratio.status }}</td><td>{{ report.assessment.financial_scores.debt_coverage_ratio.trend }}</td><td>{{ report.assessment.financial_scores.debt_coverage_ratio.volatility }}</td><td>{{ report.assessment.financial_scores.debt_coverage_ratio.total_score }}</td></tr><tr><td translate=\"\">Interest coverage ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.debt_servicing | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.debt_servicing.status }}</td><td>{{ report.assessment.financial_scores.debt_servicing.trend }}</td><td>{{ report.assessment.financial_scores.debt_servicing.volatility }}</td><td>{{ report.assessment.financial_scores.debt_servicing.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Liquidity</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Current ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.current_ratio | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.current_ratio.status }}</td><td>{{ report.assessment.financial_scores.current_ratio.trend }}</td><td>{{ report.assessment.financial_scores.current_ratio.volatility }}</td><td>{{ report.assessment.financial_scores.current_ratio.total_score }}</td></tr><tr><td translate=\"\">Quick ratio</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.quick_ratio | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.quick_ratio.status }}</td><td>{{ report.assessment.financial_scores.quick_ratio.trend }}</td><td>{{ report.assessment.financial_scores.quick_ratio.volatility }}</td><td>{{ report.assessment.financial_scores.quick_ratio.total_score }}</td></tr><tr class=\"group\"><td colspan=\"{{ report.assessment.financial_ratios.objects.length + 1 }}\" translate=\"\">Working capital management</td><td class=\"divider\"></td><td colspan=\"5\"></td></tr><tr><td translate=\"\">Days inventory outstanding</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.days_inventory_outstanding | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.days_inventory_outstanding.status }}</td><td>{{ report.assessment.financial_scores.days_inventory_outstanding.trend }}</td><td>{{ report.assessment.financial_scores.days_inventory_outstanding.volatility }}</td><td>{{ report.assessment.financial_scores.days_inventory_outstanding.total_score }}</td></tr><tr><td translate=\"\">Days sales outstanding</td><td ng-repeat=\"item in report.assessment.financial_ratios.objects\">{{ item.days_sales_outstanding | number:2}}</td><td class=\"divider\"></td><td></td><td>{{ report.assessment.financial_scores.days_sales_outstanding.status }}</td><td>{{ report.assessment.financial_scores.days_sales_outstanding.trend }}</td><td>{{ report.assessment.financial_scores.days_sales_outstanding.volatility }}</td><td>{{ report.assessment.financial_scores.days_sales_outstanding.total_score }}</td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6\"><table class=\"table table-bordered financial\"><thead><tr><th colspan=\"2\" translate=\"\">Ratio scores</th></tr></thead><tbody><tr><td translate=\"\">Growth</td><td>{{ report.assessment.ratio_scores.growth }}</td></tr><tr><td translate=\"\">Profitability</td><td>{{ report.assessment.ratio_scores.profitability }}</td></tr><tr><td translate=\"\">Productivity</td><td>{{ report.assessment.ratio_scores.productivity }}</td></tr><tr><td translate=\"\">Solvency</td><td>{{ report.assessment.ratio_scores.solvency }}</td></tr><tr><td translate=\"\">Liquidity</td><td>{{ report.assessment.ratio_scores.liquidity }}</td></tr><tr><td translate=\"\">Working capital</td><td>{{ report.assessment.ratio_scores.working_capital }}</td></tr><tr><td translate=\"\">Financial Performance</td><td>{{ report.assessment.ratio_scores.total_score }}</td></tr></tbody></table><table class=\"table table-bordered financial\" style=\"height: 435px\"><thead><tr><th translate=\"\">Accountant notes</th></tr></thead><tbody><tr><td><p>{{ report.assessment.ratio_scores.accountant_notes }}</p></td></tr></tbody></table></div><div class=\"col-md-6\"><table class=\"table table-bordered financial\"><thead><tr><th translate=\"\">General checks</th><th translate=\"\">Available</th><th translate=\"\">Quality</th></tr></thead><tbody><tr class=\"group\"><td colspan=\"3\" translate=\"\">Financial statements</td></tr><tr><td translate=\"\">Balance sheet</td><td>{{ report.assessment.general_checks.balance_sheet.available }}</td><td>{{ report.assessment.general_checks.balance_sheet.quality }}</td></tr><tr><td translate=\"\">Profit / Loss</td><td>{{ report.assessment.general_checks.profit_and_loss.available }}</td><td>{{ report.assessment.general_checks.profit_and_loss.quality }}</td></tr><tr><td translate=\"\">Cash flow</td><td>{{ report.assessment.general_checks.cash_flow.available }}</td><td>{{ report.assessment.general_checks.cash_flow.quality }}</td></tr><tr><td translate=\"\">Cash flow projections</td><td>{{ report.assessment.general_checks.cash_flow_projections.available }}</td><td>{{ report.assessment.general_checks.cash_flow_projections.quality }}</td></tr><tr><td translate=\"\">Accepted format</td><td>{{ report.assessment.general_checks.accepted_format.available }}</td><td>{{ report.assessment.general_checks.accepted_format.quality }}</td></tr><tr><td translate=\"\">Audited</td><td>{{ report.assessment.general_checks.audited.available }}</td><td>{{ report.assessment.general_checks.audited.quality }}</td></tr><tr><td translate=\"\">Bank statements</td><td>{{ report.assessment.general_checks.bank_statements.available }}</td><td>{{ report.assessment.general_checks.bank_statements.quality }}</td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Collateral</td></tr><tr><td translate=\"\">Asset register</td><td>{{ report.assessment.general_checks.asset_register.available }}</td><td>{{ report.assessment.general_checks.asset_register.quality }}</td></tr><tr><td translate=\"\">Depreciation policy</td><td>{{ report.assessment.general_checks.depreciation_policy.available }}</td><td>{{ report.assessment.general_checks.depreciation_policy.quality }}</td></tr><tr><td translate=\"\">External valuation</td><td>{{ report.assessment.general_checks.external_valuation.available }}</td><td>{{ report.assessment.general_checks.external_valuation.quality }}</td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Record keeping</td></tr><tr><td translate=\"\">Software system</td><td>{{ report.assessment.general_checks.software_system.available }}</td><td>{{ report.assessment.general_checks.software_system.quality }}</td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Loan history</td></tr><tr><td translate=\"\">Recorded in financial statement</td><td>{{ report.assessment.general_checks.loan_recorded_in_financial_statement.available }}</td><td>{{ report.assessment.general_checks.loan_recorded_in_financial_statement.quality }}</td></tr><tr><td translate=\"\">Default known</td><td>{{ report.assessment.general_checks.loan_default_known.available }}</td><td>{{ report.assessment.general_checks.loan_default_known.quality }}</td></tr><tr class=\"group\"><td colspan=\"3\" translate=\"\">Grants</td></tr><tr><td translate=\"\">Recorded in financial statement</td><td>{{ report.assessment.general_checks.grants_recorded_in_financial_statement.available }}</td><td>{{ report.assessment.general_checks.grants_recorded_in_financial_statement.quality }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("reports/reports-tabs/governanceTabView.html","<div class=\"panel-body\"><div class=\"tab-content\"><h3 translate=\"\">Executives</h3><div class=\"well text-right\" ng-if=\"report.assessment.executive_set.objects.length == 0\"><span class=\"pull-left\" translate=\"\">No records were found..</span></div><uib-tabset class=\"tabs-left\" ng-if=\"report.assessment.executive_set.objects.length !== 0\"><uib-tab ng-repeat=\"executive in report.assessment.executive_set.objects\" active=\"$first\"><tab-heading>{{ executive.name }} <i class=\"pull-right fa fa-chevron-right\"></i><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped\"><tr><th width=\"20%\" translate=\"\">Name</th><td ng-bind=\"executive.name\"></td></tr><tr><th translate=\"\">Function</th><td ng-bind=\"executive.function\"></td></tr><tr><th translate=\"\">Gender</th><td ng-bind=\"executive.male_female\"></td></tr><tr><th translate=\"\">Years in Function</th><td ng-bind=\"executive.years_in_function\"></td></tr><tr><th translate=\"\">Years in Organization</th><td ng-bind=\"executive.years_in_organization\"></td></tr><tr><th translate=\"\">Years in Sector</th><td ng-bind=\"executive.years_in_sector\"></td></tr><tr><th translate=\"\">Year of Birth</th><td ng-bind=\"executive.year_of_birth\"></td></tr><tr><th translate=\"\">End of Term</th><td ng-bind=\"executive.end_of_term\"></td></tr><tr><th translate=\"\">Shareholder of Organization</th><td ng-bind=\"executive.shareholder\"></td></tr><tr><th translate=\"\">Qualifications</th><td ng-bind=\"executive.qualifications\"></td></tr></table></div></div></tab-heading></uib-tab></uib-tabset><hr><h3 translate=\"\">Non-Executives</h3><div class=\"well text-right\" ng-if=\"report.assessment.nonexecutive_set.objects.length == 0\"><span class=\"pull-left\" translate=\"\">No records were found...</span></div><uib-tabset class=\"tabs-left\" ng-if=\"report.assessment.nonexecutive_set.objects.length !== 0\"><uib-tab ng-repeat=\"nonexecutive in report.assessment.nonexecutive_set.objects\" active=\"$first\"><tab-heading>{{ nonexecutive.name }} <i class=\"pull-right fa fa-chevron-right\"></i><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped\"><tr><th width=\"20%\" translate=\"\">Name</th><td ng-bind=\"nonexecutive.name\"></td></tr><tr><th translate=\"\">Function</th><td ng-bind=\"nonexecutive.function\"></td></tr><tr><th translate=\"\">Gender</th><td ng-bind=\"nonexecutive.male_female\"></td></tr><tr><th translate=\"\">Years in Function</th><td ng-bind=\"nonexecutive.years_in_function\"></td></tr><tr><th translate=\"\">Years in Organization</th><td ng-bind=\"nonexecutive.years_in_organization\"></td></tr><tr><th translate=\"\">Years in Sector</th><td ng-bind=\"nonexecutive.years_in_sector\"></td></tr><tr><th translate=\"\">Year of Birth</th><td ng-bind=\"nonexecutive.year_of_birth\"></td></tr><tr><th translate=\"\">End of Term</th><td ng-bind=\"nonexecutive.end_of_term\"></td></tr><tr><th translate=\"\">Shareholder of Organization</th><td ng-bind=\"nonexecutive.shareholder\"></td></tr><tr><th translate=\"\">Qualifications</th><td ng-bind=\"nonexecutive.qualifications\"></td></tr></table></div></div></tab-heading></uib-tab></uib-tabset><hr><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 translate=\"\">Governance Structure</h3><table class=\"table table-striped\"><thead><tr><th></th><th translate=\"\">Present</th><th translate=\"\">Nr of People</th><th translate=\"\">Description</th></tr></thead><tbody><tr ng-repeat=\"gov in report.assessment.governance_set.objects\"><th width=\"20%\">{{gov.name | translate}}</th><td><span ng-if=\"gov.present === true\"><translate>Yes</translate></span> <span ng-if=\"gov.present === false\"><translate>No</translate></span></td><td ng-bind=\"gov.number_of_people\"></td><td ng-bind=\"gov.description\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("reports/reports-tabs/monthlyProductionTab.html","<div class=\"panel-body\"><div class=\"tab-content\"><form><h3 translate=\"\">Monthly Cash Flow Projections</h3><table class=\"table table-bordered financial flow\"><tr><th translate=\"\">Income</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr ng-repeat=\"item in report.assessment.monthlyincomeprojection_set.objects\"><td style=\"width: 150px;\"><span ng-bind=\"item.activity\" translate=\"\"></span> <span ng-bind=\"item.year\" translate=\"\"></span></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.january.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.february.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.march.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.april.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.may.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.june.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.july.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.august.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.september.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.october.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.november.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.december.amount\"></td></tr><tr><td translate=\"\">Total Cash In</td><td class=\"text-center\" ng-repeat=\"sub in subTotal.income track by $index\" ng-bind=\"sub\"></td></tr><tr><th style=\"min-width: 150px\" translate=\"\">Expense</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr ng-repeat=\"item in report.assessment.monthlyexpensesprojection_set.objects\"><td style=\"width: 150px;\"><span ng-bind=\"item.activity\" translate=\"\"></span> <span ng-bind=\"item.year\" translate=\"\"></span></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.january.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.february.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.march.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.april.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.may.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.june.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.july.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.august.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.september.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.october.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.november.amount\"></td><td class=\"text-center\"><input type=\"text\" style=\"width: 50px;\" ng-model=\"item.december.amount\"></td></tr><tr><td translate=\"\">Total Cash Out</td><td class=\"text-center\" ng-repeat=\"sub in subTotal.expenses track by $index\" ng-bind=\"sub\"></td></tr><tr><th style=\"min-width: 150px\" translate=\"\">Net Cash In (Out)</th><th style=\"width: 50px\" class=\"text-center\" ng-repeat=\"month in months track by $index\">{{month | translate}}</th></tr><tr><td translate=\"\">Net Cash</td><td class=\"text-center\" ng-repeat=\"net in subTotal.net track by $index\" ng-bind=\"net\"></td></tr></table></form></div></div>");
$templateCache.put("reports/reports-tabs/observationsTab.html","<div class=\"tab-content\"><div class=\"row\" ng-repeat=\"section in report.assessment.section_responses.objects\"><div class=\"col-sm-3\"><h4>{{ section.section_title }}</h4></div><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-6\" ng-repeat=\"response in section.unscored_responses.objects\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ response.question_title }}</h5></div><div class=\"ibox-content\"><p ng-bind-html=\"formatObservation(response.answer)\"></p></div></div></div></div></div></div></div>");
$templateCache.put("reports/reports-tabs/organizationalTab.html","<form><div class=\"panel-body\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-lg-6\"><h3 translate=\"\">Basic and Contact Details</h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Name</label><div class=\"col-md-9\"><span>{{ report.assessment.producing_organization.customer.name }}</span></div></div><div class=\"row\" ng-if=\"!report.assessment.tool.type.agent\"><label class=\"col-md-3\" translate=\"\">Abbreviation</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.customer.abbreviation\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Street</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.street\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Street no.</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.street_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Zipcode</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.zipcode\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">City</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.city\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Global Region</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.display_global_region\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Region</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.global_region\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Country</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.display_country\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">GPRS Code</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.gps_location\"></span></div></div><div class=\"row\"><label class=\"col-md-3 control-label\" ng-bind=\"report.assessment.tool.type.agent ? \'Phone Number\' : \'Office Phone Number\' | translate\"></label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.customer.phone_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.customer.email\"></span></div></div><div class=\"row\" ng-if=\"report.assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Gender</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.gender\"></span></div></div><div class=\"row\" ng-if=\"report.assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Age</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.age\"></span></div></div><div class=\"row\" ng-if=\"report.assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\"># of Household Members</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.household_members\"></span></div></div><div class=\"row\" ng-if=\"report.assessment.tool.type.agent\"><label class=\"col-md-3 control-label\" translate=\"\">Languages spoken</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.languages_spoken\"></span></div></div><div class=\"row\" ng-if=\"!report.assessment.tool.type.agent\"><label class=\"col-md-3\" translate=\"\">Website</label><div class=\"col-md-9\"><span ng-bind=\"report.assessment.producing_organization.customer.website\"></span></div></div><hr><div ng-if=\"report.assessment.tool.type.agent\"><hr><h3 translate=\"\">Additional details</h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.member_of_cooperative\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.duration_of_cooperative_membership\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.member_of_other_group\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.duration_of_other_group_membership\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.owner_of_farmland\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"assessment.producing_organization.customer.name_of_buyers\"></span></div></div></div><div ng-repeat=\"contact in report.assessment.producing_organization.customer.contacts.objects\" ng-if=\"!report.assessment.tool.type.agent\"><h3><translate>Contact Person</translate><span ng-bind=\"$index + 1\"></span></h3><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Position</label><div class=\"col-md-9\"><span ng-bind=\"contact.position\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Phone Number</label><div class=\"col-md-9\"><span ng-bind=\"contact.user.phone_number\"></span></div></div><div class=\"row\"><label class=\"col-md-3\" translate=\"\">Email Address</label><div class=\"col-md-9\"><span ng-bind=\"contact.user.email\"></span></div></div><hr ng-if=\"!$last\"></div><hr><div ng-if=\"!report.assessment.tool.type.agent\"><h3 translate=\"\">Incorporation</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Legal Status</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.legal_status.display_name\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Specification</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.legal_status_specification\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Year of incorporation</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.year_of_incorporation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">In operation since</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.in_operation_since\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Registration/Business license number</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.business_license_number\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Tax identification number</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.tax_identification_number\"></span></div></div><div class=\"row\" ng-if=\"report.assessment.tool.type.basic_sme\"><label class=\"col-md-6\" translate=\"\">For Profit?</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.for_profit ? \'Yes\' : \'No\'\"></span></div></div></div><section ng-if=\"report.assessment.tool.type.basic_sme\"><hr><h3 translate=\"\">Management body</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Founder</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.founder\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Entrepreneur</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.entrepreneur\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Managing Director</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.managing_director\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of Shareholders</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization.number_of_shareholders\"></span></div></div></section><hr><h3 translate=\"\">Umbrella/Representing Organization</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Cooperative</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.cooperative\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Union</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.union\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Federation</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.federation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Apex Organization</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.apex_organization\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">SACCO</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.sacco\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Other</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.other_representing_organizations\"></span></div></div><hr><div ng-if=\"!report.assessment.tool.type.agent\"><h3 ng-if=\"!report.assessment.tool.type.basic_sme\" translate=\"\">Members</h3><h3 ng-if=\"report.assessment.tool.type.basic_sme\" translate=\"\">Suppliers</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Female members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Female Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Male members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Male Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Active female members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Active Female Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_active_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Active male members</label> <label class=\"col-md-6\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Active Male Suppliers</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_active_members\"></span></div></div><div class=\"row\"><label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Member cooperatives</label> <label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Suppliers Cooperatives</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_member_cooperatives\"></span></div></div><div class=\"row\"><label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Member unions</label> <label class=\"col-md-6 control-label\" translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Suppliers Unions</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_member_unions\"></span></div></div></div></div><div class=\"col-lg-6\"><h3 translate=\"\">Sectors and activities</h3><h3 translate=\"\">Sectors</h3><ul><li ng-repeat=\"sector in report.assessment.producing_organization.sectors.objects\" ng-bind=\"sector.display_name\"></li></ul><hr><h3 translate=\"\">Activities</h3><ul><li ng-repeat=\"activity in report.assessment.producing_organization.activities.objects\" ng-bind=\"activity.display_name\"></li></ul><div ng-if=\"report.assessment.tool.type.agent\"><h3 translate=\"\">Related farmers</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of male farmers under supervision</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_male_farmers_under_supervision\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of female farmers under supervision</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_female_farmers_under_supervision\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of potential male farmers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_potential_male_farmers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Number of potential female farmers</label><div class=\"col-md-6\"><span ng-bind=\"assessment.producing_organization_details.number_of_potential_female_farmers\"></span></div></div></div><div ng-if=\"!report.assessment.tool.type.agent\"><hr><h3 translate=\"\">Mission</h3><textarea class=\"form-control\" disabled=\"\" ng-model=\"report.assessment.producing_organization_details.mission\">\n                      </textarea><hr><h3 translate=\"\">Vision</h3><textarea class=\"form-control\" disabled=\"\" ng-model=\"report.assessment.producing_organization_details.vision\">\n                      </textarea><hr><h3 translate=\"\">Officials</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male executives</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female executives</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male non-executives</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_non_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female non-executives</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_non_executives\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Male Advisors</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_advisors\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Female Advisors</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_advisors\"></span></div></div><hr><h3 translate=\"\">Employees</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of male full-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_full_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female full-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_full_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male part-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_part_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female part-time employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_part_time_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male seasonal employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_seasonal_employees\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of female seasonal employees</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_seasonal_employees\"></span></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><h3 translate=\"\">Sharecroppers</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of female sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active female sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_active_sharecroppers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active male sharecroppers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_active_sharecroppers\"></span></div></div><hr><h3 ng-if=\"!report.assessment.tool.type.basic_sme\" translate=\"\">Services to members/outgrowers</h3><h3 ng-if=\"report.assessment.tool.type.basic_sme\" translate=\"\">Services to Suppliers</h3><ul><li ng-repeat=\"service in report.assessment.producing_organization_details.services.objects\" ng-bind=\"service.display_name\"></li></ul></div><div class=\"col-md-6\"><div ng-if=\"!report.assessment.tool.type.agent\"><h3 translate=\"\">Outgrowers</h3><div class=\"row\"><label class=\"col-md-6\"><translate># of female outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of male outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active female outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_female_active_outgrowers\"></span></div></div><div class=\"row\"><label class=\"col-md-6\"><translate># of active male outgrowers</translate></label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.number_of_male_active_outgrowers\"></span></div></div><hr></div><h3 translate=\"\">Infrastructure Information</h3><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Access roads</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_access_roads\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Distance to hub</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.distance_to_hub\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Demonstration plot</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.demonstration_plot\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Training space</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.training_space\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Warehousing</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.warehousing\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Public transportation</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_public_transportation\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Power / electricity</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_power_electricity\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Internet access</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_internet_access\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Mobile network coverage</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_mobile_network_coverage\"></span></div></div><div class=\"row\"><label class=\"col-md-6\" translate=\"\">Running water</label><div class=\"col-md-6\"><span ng-bind=\"report.assessment.producing_organization_details.display_running_water\"></span></div></div></div></div></div></div></form>");
$templateCache.put("reports/reports-tabs/productionTab.html","<p translate=\"\">Here you find some key production related information provided by the organization.</p><div class=\"tab-content\"><h2 translate=\"\">Production Information</h2><div ng-repeat=\"product in report.assessment.products.objects\"><h2>{{ product.display_type | capitalize}}</h2><h3 translate=\"\">Product Information</h3><div class=\"row\"><div class=\"col-md-6\"><dl class=\"dl-vertical\"><dt translate=\"\">Product:</dt><dd>{{ product.display_name }}</dd><dt translate=\"\">Type:</dt><dd>{{ product.display_type }}</dd><div ng-if=\"!report.assessment.tool.type.basic_sme || !report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\">Quality</dt><dd>{{ product.quality }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\">Land used for product</dt><dd>{{ product.land_used_for_product }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\">Land unit</dt><dd>{{ product.display_land_unit }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt><translate>Production unit</translate>**</dt><dd>{{ product.type.production_unit }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\"># of production units</dt><dd>{{ product.number_of_production_units }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt><translate>Avg. age production unit</translate>(<translate>years</translate>)**</dt><dd>{{ product.average_age_of_production_unit }}</dd></div></dl></div><div class=\"col-md-6\"><dl class=\"dl-vertical\"><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt><translate>Avg. production unit lifetime</translate>(<translate>years</translate>)**:</dt><dd>{{ product.average_production_unit_lifetime }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt><translate>Dead/Diseased production units</translate>** (%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_dead_diseased_production_units }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_dead_diseased_production_units }}</dd></div><dt ng-if=\"report.assessment.tool.type.basic_sme\" translate=\"\">Operational months</dt><dd ng-if=\"report.assessment.tool.type.basic_sme\"><span class=\"label\" ng-repeat=\"month in product.operational_months\">{{ translateMonth(month) }}</span></dd><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt>#<translate>harvest cycles per year</translate></dt><dd>{{ product.number_of_harvest_cycles_per_year }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt><translate>Irrigated</translate>(%)</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_irrigated }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_irrigated }}</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\">Sustainable production?</dt><dd>{{ product.sustainable_production ? \'Yes\' : product.sustainable_production == false ? \'No\' : \'N/A\' | translate }}</dd></div><div ng-if=\"!report.assessment.tool.type.basic_sme || !report.tool_type ===\'SCOPE Rapid\'\"><dt translate=\"\">Certification(s)</dt><dd ng-if=\"product.certifications.objects.length\" ng-repeat=\"certification in product.certifications.objects\" ng-bind=\"certification.name\"></dd><dd ng-if=\"!product.certifications.objects.length\" translate=\"\">None</dd></div><div ng-if=\"!report.tool_type === \'SCOPE Rapid\'\"><dt translate=\"\">Estimated % of member/outgrower production sold to P.O.</dt><dd><div class=\"progress progress-mini\"><div style=\"width: {{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization }}%;\" class=\"progress-bar\"></div></div>{{ product.percent_of_members_or_outgrowers_production_sold_to_producing_organization }}</dd></div></dl></div></div><h3 translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Produce purchased from members</h3><h3 translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Produce Purchased From Suppliers</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.productionpurchases.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}%</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr><h3 translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Produce purchased from others</h3><h3 translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Produce Purchased From Suppliers</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.otherproductionpurchases.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}%</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr><h3 translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Production figures</h3><h3 translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Production/Processing Figures</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">% certified</th><th translate=\"\">% loss</th></tr><tr ng-repeat=\"row in product.productionfigures.objects\"><td>{{ row.year }}</td><td>{{ row.unit | capitalize}}</td><td>{{ row.volume }}</td><td>{{ row.percent_certified }}</td><td>{{ row.percent_loss }}</td></tr></table><hr><h3 translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Production sales</h3><h3 translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Produce Sold</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.productionsales.objects\"><td>{{ row.year }}</td><td>{{ product.type.production_unit }}</td><td>{{ row.volume }}</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr><div ng-if=\"report.assessment.tool.type.basic_sme\"><h3 translate=\"\">Margins</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Currency</th><th translate=\"\">Margin</th></tr><tr ng-repeat=\"row in product.productionmargins.objects\"><td>{{ row.year }}</td><td>{{ row.margin.currency }}</td><td>{{ row.margin.amount }}</td></tr></table><hr></div><h3 translate=\"\" ng-if=\"!report.assessment.tool.type.basic_sme\">Inputs Purchased</h3><h3 translate=\"\" ng-if=\"report.assessment.tool.type.basic_sme\">Raw Materials</h3><table class=\"table table-striped\"><tr><th translate=\"\">Year</th><th translate=\"\">Unit</th><th translate=\"\">Volume</th><th translate=\"\">Price</th></tr><tr ng-repeat=\"row in product.inputpurchases.objects\"><td>{{ row.year }}</td><td>{{ row.product.type.unit }}</td><td>{{ row.volume }}</td><td>{{ row.price.amount | currency:row.price.currency+\" \":0 }}</td></tr></table><hr></div></div>");
$templateCache.put("reports/reports-tabs/profitLossTab.html","<div class=\"panel-body\"><div class=\"tab-content\"><h3 class=\"p-t\"><translate>Profit / Loss Statement</translate></h3><table class=\"table table-bordered financial flow\"><thead><tr><th><translate>Profit / Loss Statement</translate></th><th style=\"width: 150px\" ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.year | date : \'yyyy\' }}</th></tr></thead><tbody><tr class=\"sub\"><td translate=\"\">Sales</td><td colspan=\"{{ report.assessment.profitlossstatements.objects.length }}\"></td></tr><tr><td translate=\"\">Direct sales</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.direct_sales.currency }} {{ pl.direct_sales.amount | number:2}}</td></tr><tr><td translate=\"\">Indirect sales</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.indirect_sales.currency }} {{ pl.indirect_sales.amount | number:2}}</td></tr><tr class=\"group sub-total\"><td translate=\"\">Total sales</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.total_sales.currency }} {{ pl.total_sales.amount | number:2}}</td></tr><tr class=\"sub\"><td colspan=\"{{ report.assessment.profitlossstatements.objects.length + 1 }}\" translate=\"\">Cost of sales</td></tr><tr ng-repeat=\"(name, obj) in report.assessment.all_costs_of_sales\"><td translate=\"\" ng-bind=\"name\"></td><td ng-repeat=\"item in obj\">{{ item.currency }} {{ item.amount | number:2}}</td></tr><tr class=\"group sub-total\"><td translate=\"\">Total cost of sales</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.total_cost_of_sales.currency }} {{ pl.total_cost_of_sales.amount | number:2}}</td></tr><tr class=\"group total\"><td translate=\"\">Gross profit</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.gross_profit.currency }} {{ pl.gross_profit.amount | number:2}}</td></tr><tr class=\"sub\"><td colspan=\"{{ report.assessment.profitlossstatements.objects.length + 1 }}\" translate=\"\">Selling, general and administrative expense</td></tr><tr ng-repeat=\"(name, obj) in report.assessment.all_expenses\"><td translate=\"\" ng-bind=\"name\"></td><td ng-repeat=\"item in obj\">{{ item.value.currency }} {{ item.value.amount | number:2}}</td></tr><tr><td translate=\"\">Other income</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.other_income.currency }} {{ pl.other_income.amount | number:2}}</td></tr><tr class=\"group total\"><td translate=\"\">EBITDA</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.ebitda.currency }} {{ pl.ebitda.amount | number:2}}</td></tr><tr><td translate=\"\">Depreciation and amortization</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.depreciation_and_amortization.currency }} {{ pl.depreciation_and_amortization.amount | number:2}}</td></tr><tr class=\"group total\"><td translate=\"\">EBIT</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.ebit.currency }} {{ pl.ebit.amount | number:2}}</td></tr><tr><td translate=\"\">Interest expense</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.interest_expense.currency }} {{ pl.interest_expense.amount | number:2}}</td></tr><tr><td translate=\"\">Income tax expense</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.income_tax_expense.currency }} {{ pl.income_tax_expense.amount | number:2}}</td></tr><tr class=\"group total\"><td translate=\"\">Income from continuing operations</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.income_from_continuing_operations.currency }} {{ pl.income_from_continuing_operations.amount | number:2}}</td></tr><tr><td translate=\"\">Earnings (losses) from discontinued operations (net of tax)</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.earnings_from_discontinued_operations.currency }} {{ pl.earnings_from_discontinued_operations.amount | number:2}}</td></tr><tr class=\"group total\"><td translate=\"\">Net profit</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\">{{ pl.net_profit.currency }} {{ pl.net_profit.amount | number:2}}</td></tr><tr class=\"group sub-total\"><td translate=\"\">Are accounts audited?</td><td ng-repeat=\"pl in report.assessment.profitlossstatements.objects\" class=\"text-center\"><span class=\"fa\" ng-class=\"{\'fa-check\': pl.audited == true}\"></span></td></tr></tbody></table></div></div>");
$templateCache.put("reports/reports-tabs/questionnaireSectionTab.html","<p translate=\"\">Below you see all the details of this chapter: scores, comments and requirements per question of the assessment, based on information and survey responses provided by the organization.</p><div class=\"ibox\"><ng-include src=\"\'reports/reports-tabs/questionnaireSectionView.html\'\"></ng-include></div>");
$templateCache.put("reports/reports-tabs/questionnaireSectionView.html","<table class=\"table\" ng-if=\"section.section_title.length > 0\" ng-style=\"{\'margin-bottom\': 0}\"><tr><th style=\"width: 4%;\" ng-bind=\"section.section_display_position\"></th><th style=\"width: 50%\" ng-style=\"{\'font-size\': depth}\" ng-bind=\"section.section_title\"></th><th style=\"width: 46%\"><span class=\"pull-right\" ng-if=\"section.score\"><i class=\"fa fa-star\"></i> {{ section.score | number:1 }}</span></th></tr></table><ng-include src=\"\'reports/reports-tabs/questionnaireSectionView.html\'\" ng-init=\"depth = tmpDepth - 2\" ng-repeat=\"section in section.children.objects\"></ng-include><table class=\"table table-striped\" ng-if=\"section.responses.objects.length > 0\"><thead><tr><th style=\"width: 4%\"></th><th style=\"width: 50%\" translate=\"\">Topic</th><th style=\"width: 5%\" translate=\"\">Score</th><th style=\"width: 41%\" translate=\"\">Comments</th></tr></thead><tbody><tr ng-repeat=\"response in section.responses.objects\" ng-if=\"responseApplicable(response, report.assessment)\"><td>{{ response.question_display_position }}</td><td>{{ response.question_title }} <a class=\"btn btn-xs btn-default pull-right\" ng-click=\"response.show_info = !response.show_info\"><i class=\"fa fa-info\"></i></a><div ng-show=\"response.show_info\"><hr><p style=\"white-space: pre-wrap\">{{ response.question_explanation }}</p><hr></div><div ng-if=\"response.subresponses.objects.length > 0\" ng-repeat=\"subresponse in response.subresponses.objects\"><div><br><h5 style=\"font-style: italic;\">{{ subresponse.subquestion.title }}</h5><p><translate>Score</translate>:<span class=\"label label-primary\" ng-bind=\"subresponse.score | number: 0\"></span></p><p>{{ subresponse.subquestion.description }}</p><div ng-if=\"subresponse.subquestion.type === \'checkbox\'\"><div class=\"checkbox\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><span class=\"fa\" ng-class=\"subresponse.checked_options.objects.indexOf(option.url) > -1 ? \'fa-check-square\' : \'fa-square-o\'\"></span> {{option.title}}</div><div ng-if=\"subresponse.not_relevant\"><div class=\"checkbox\"><span class=\"fa fa-check-square\" translate=\"\">N/R</span></div></div></div><div ng-if=\"subresponse.subquestion.type === \'mpc\'\"><div class=\"checkbox\" ng-repeat=\"option in subresponse.subquestion.options.objects\"><span class=\"fa\" ng-class=\"subresponse.selected_option === option.url ? \'fa-check-circle\' : \'fa-circle-o\'\"></span> {{option.title}}</div><div ng-if=\"!subresponse.selected_option\"><div class=\"checkbox\"><span class=\"fa fa-check-circle\" translate=\"\">N/R</span></div></div></div><div ng-if=\"subresponse.subquestion.type === \'numeric\'\"><p ng-if=\"!subresponse.not_relevant\"><span class=\"badge badge-info\">{{ subresponse.value | number }}</span></p><p ng-if=\"subresponse.not_relevant\"><span class=\"badge badge-info\" translate=\"\">N/R</span></p></div></div></div></td><td><div><span class=\"label label-primary\" ng-show=\"response.score\">{{ response.score | number:1 }}</span> <span class=\"label\" ng-show=\"!response.score\" translate=\"\">N/A</span> <span class=\"label\" ng-show=\"response.score === 0\" translate=\"\">N/R</span></div></td><td>{{ response.comment }}<div ng-show=\"response.documents.objects.length > 0\"><h5 translate=\"\">Evidence</h5><ul class=\"list-unstyled\" ng-repeat=\"document in response.documents.objects track by document.url\"><li class=\"\"><a ng-href=\"{{ document.file }}\"><i class=\"fa fa-paperclip\"></i> {{ document.file_name }}</a></li></ul></div></td></tr></tbody></table>");
$templateCache.put("reports/reports-tabs/scoreSummaryTab.html","<div ng-show=\"!!report.assessment.section_responses.objects[0].children\"><p translate=\"\">Here you find a summary of the assessment score per chapter and sub-chapter. More details can be found under each of the chapter tabs on the left.</p><div class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">Scores Summary</h5></div><div class=\"ibox-content\"><table class=\"table table-striped\"><caption><h3>{{ section.title }}</h3></caption><thead><tr><th style=\"width: 85%\" translate=\"\">Dimension</th><th style=\"width: 15%\" class=\"text-right\" translate=\"\">Score</th></tr></thead><tbody ng-repeat=\"chapter in report.assessment.section_responses.objects\"><tr><td>{{ chapter.section_title }}</td><td class=\"text-right\"><span class=\"label label-primary\">{{ chapter.score | number:1 }}</span></td></tr><tr ng-repeat=\"section in chapter.children.objects\"><td>{{ section.section_title }}</td><td class=\"text-right\"><span class=\"label label-primary\">{{ section.score | number:1 }}</span></td></tr></tbody><tbody ng-if=\"report.assessment.tool.type.pro\"><tr><td translate=\"\">Financial Performance</td><td class=\"text-right\"><span class=\"label label-primary\" ng-bind=\"report.assessment.ratio_scores.total_score | number:1\"></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("reports/reports-tabs/summaryTab.html","<div class=\"row\"><div class=\"col-sm-8\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ report.assessment.producing_organization.customer.name }}</h5></div><div class=\"ibox-content no-padding\"><div class=\"row\"><div class=\"col-sm-4\"><table class=\"table\"><tr><th translate=\"\">Location</th></tr><tr><td><p>{{ report.assessment.producing_organization.street }} {{ report.assessment.producing_organization.street_number }}<br>{{ report.assessment.producing_organization.zipcode }}<br>{{ report.assessment.producing_organization.city }}<br>{{ report.assessment.producing_organization.display_country }}</p></td></tr><tr><th translate=\"\">Activities</th></tr><tr><td><div ng-repeat=\"activity in report.assessment.producing_organization.activities.objects\"><span class=\"fa fa-check\"></span> {{ activity.display_name }}</div></td></tr></table></div><div class=\"col-sm-8\"><table class=\"table table-hover\"><tr><th translate=\"\">Legal Status</th><td><p>{{ report.assessment.producing_organization.legal_status.display_name }}</p></td></tr><tr><th>#<translate>of Members</translate></th><td><p>{{ report.assessment.producing_organization_details.number_of_members }}</p></td></tr><tr><th translate=\"\">Products</th><td><p ng-repeat=\"p in report.assessment.products.objects\">{{ p.display_type | capitalize}}</p></td></tr><tr><th translate=\"\">Assessors</th><td><p ng-repeat=\"a in report.assessment.assessmentassignments.objects\">{{ a.assessor.user | username }}</p></td></tr><tr><th translate=\"\">Assessment Date</th><td><p>{{ report.assessment.date | date:\'dd-MM-yyyy\' }}</p></td></tr><tr><th translate=\"\">Finalization Date</th><td><p ng-if=\"report.status === \'final\'\">{{ report.finalized_at | date:\'dd-MM-yyyy\' }}</p><p ng-if=\"report.status !== \'final\'\">-</p></td></tr><tr><th translate=\"\">Assessment ID</th><td><p>{{ report.assessment.id }}</p></td></tr><tr><th translate=\"\">SCOPE ID</th><td><p>{{ report.assessment.producing_organization.scope_id }}</p></td></tr></table></div></div></div></div><div class=\"ibox\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\"><div class=\"ibox-title\"><h5 translate=\"\" ng-click=\"testing(report.scores)\">Summary</h5></div><div class=\"ibox-content\" ng-if=\"language() === \'en\'\"><object ng-if=\"report.assessment.tool.type.agent\" type=\"image/svg+xml\" data=\"/assets/tools/agent.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"(report.assessment.tool.type.basic || report.assessment.tool.type.basic_sme) && !report.assessment.tool.type.is_sacco\" type=\"image/svg+xml\" data=\"/assets/tools/basic.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"report.assessment.tool.type.is_sacco\" type=\"image/svg+xml\" data=\"/assets/tools/sacco.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"report.assessment.tool.type.pro || report.assessment.tool.type.pro_sme\" type=\"image/svg+xml\" data=\"/assets/tools/pro.svg\" svgtextreplace=\"\" scores=\"report.scores\" total-score=\"report.assessment.ratio_scores.total_score\" style=\"max-width: 100%\"></object></div><div class=\"ibox-content\" ng-if=\"language() === \'fr\'\"><object ng-if=\"report.assessment.tool.type.agent\" type=\"image/svg+xml\" data=\"/assets/tools/agent_fr.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"(report.assessment.tool.type.basic || report.assessment.tool.type.basic_sme) && !report.assessment.tool.type.is_sacco\" type=\"image/svg+xml\" data=\"/assets/tools/basic_fr.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"report.assessment.tool.type.pro || report.assessment.tool.type.pro_sme\" type=\"image/svg+xml\" data=\"/assets/tools/pro_fr.svg\" svgtextreplace=\"\" scores=\"report.scores\" total-score=\"report.assessment.ratio_scores.total_score\" style=\"max-width: 100%\"></object></div><div class=\"ibox-content\" ng-if=\"language() === \'es\'\"><object ng-if=\"report.assessment.tool.type.agent\" type=\"image/svg+xml\" data=\"/assets/tools/agent_es.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"(report.assessment.tool.type.basic || report.assessment.tool.type.basic_sme) && !report.assessment.tool.type.is_sacco\" type=\"image/svg+xml\" data=\"/assets/tools/basic_es.svg\" svgtextreplace=\"\" scores=\"report.scores\" style=\"max-width: 100%\"></object><object ng-if=\"report.assessment.tool.type.pro || report.assessment.tool.type.pro_sme\" type=\"image/svg+xml\" data=\"/assets/tools/pro_es.svg\" svgtextreplace=\"\" scores=\"report.scores\" total-score=\"report.assessment.ratio_scores.total_score\" style=\"max-width: 100%\"></object></div></div></div><div class=\"col-sm-4\"><div class=\"widget lazur-bg m-t-none\"><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-shield fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span translate=\"\">Report version</span><h2 class=\"font-bold\">{{ report.assessment.tool.type.name | capitalize }} {{ report.assessment.tool_version_major }}.{{ report.assessment.tool_version_minor }}.{{ report.assessment.tool_version_revision }}</h2></div></div></div><p class=\"well well-sm\" translate=\"\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\">Here you find a summary of the assessment scores and the organization, plus some information about the assessment itself.</p><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\"><div class=\"ibox-title\"><h5 translate=\"\">General comments by assessor</h5></div><div class=\"ibox-content\"><p ng-repeat=\"comment in report.assessment.tool_responses\">{{ comment.answer }}</p></div></div><div class=\"ibox\" ng-show=\"report.asssessment.tool.type.basic\"><div class=\"ibox-content\"><img src=\"/assets/img/ifc_logo.jpg\" style=\"max-width: 100%\"></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\"><div class=\"ibox-title\"><translate>PO Representatives</translate></div><div class=\"ibox-content\"><p class=\"prewrap\">{{ report.assessment.present_representatives }}</p></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\"><div class=\"ibox-title\"><translate>Score summary</translate></div><div class=\"ibox-content\"><table class=\"table table-striped\"><thead><tr><th style=\"width: 85%\" translate=\"\">Dimension</th><th style=\"width: 15%\" class=\"text-right\" translate=\"\">Score</th></tr></thead><tbody><tr ng-repeat=\"chapter in report.assessment.section_responses.objects\"><td>{{ chapter.section_title }}</td><td class=\"text-right\"><span class=\"label label-primary\">{{ chapter.score | number:1 }}</span></td></tr><tr ng-if=\"report.assessment.tool.type.pro\"><td translate=\"\">Financial Performance</td><td class=\"text-right\"><span class=\"label label-primary\" ng-bind=\"report.assessment.ratio_scores.total_score | number:1\"></span></td></tr></tbody></table></div></div><div class=\"ibox\" ng-if=\"report.tool_type === \'SCOPE Rapid\'\"><div class=\"ibox-title\"><translate>Level Summary</translate></div><div class=\"ibox-content\"><table class=\"table table-striped\"><thead><tr><th style=\"width: 85%\" translate=\"\">Level</th><th style=\"width: 15%\" class=\"text-right\" translate=\"\">{{ report.assessment.rapid_level }}</th></tr></thead></table></div></div><div ng-hide=\"isDashboardUserAdmin\" class=\"ibox\" ng-if=\"!(report.tool_type === \'SCOPE Rapid\')\"><div class=\"ibox-title\"><translate>PO Contacts</translate></div><div class=\"ibox-content\"><table class=\"table table-striped\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">Contactdetails</th></tr></thead><tbody><tr ng-repeat=\"contact in report.assessment.producing_organization.customer.contacts.objects\"><td>{{ contact.user | username }}</td><td><span ng-if=\"contact.user.email.endsWith(\'@scopeinsight.com\') == true\">-</span> <span ng-if=\"contact.user.email.endsWith(\'@scopeinsight.com\') == false\">{{ contact.user.email }}</span><br>{{ contact.user.phone_number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("reports/reports-tabs/termsTab.html","<div class=\"tab-content\"><table class=\"table table-striped\"><tr><th style=\"width:40%\" translate=\"\">Document Name</th><th style=\"width:10%\" translate=\"\">Action</th><th style=\"width:50%\" translate=\"\">Comments</th></tr><tr ng-show=\"report.assessment.terms_and_conditions.objects[0]\"><td>{{ report.assessment.terms_and_conditions.objects[0].file_name }}</td><td><a class=\"btn btn-primary\" ng-href=\"{{ report.assessment.terms_and_conditions.objects[0].file }}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> <span><translate>Download document</translate></span></a></td><td><p translate=\"\">The assessor has explained the Terms and Conditions to the assessee and uploaded the signed document.</p></td></tr></table></div>");
$templateCache.put("reports/reports-tabs/valueChainTab.html","<p translate=\"\">This page provides information about the organization\'s value chain partners, as provided by the organization.</p><div class=\"tab-content\"><h2 translate=\"\">Value Chain</h2><h3 translate=\"\">Customers, Clients, Offtakers, and Agents</h3><table class=\"table table-striped\"><tr><th translate=\"\">Name</th><th translate=\"\">Relation to PO</th><th translate=\"\">Description of relation</th><th>#<translate>years in relation</translate></th><th ng-if=\"report.assessment.tool.type.basic_sme\">&percnt;<translate>sold to customer</translate></th></tr><tr ng-repeat=\"player in report.assessment.valuechainplayers.objects\"><td>{{ player.customer === \'OTHER\' ? player.other : player.customer }}</td><td>{{ player.display_relation_to_producing_organization }}</td><td>{{ player.description_of_relation }}</td><td>{{ player.number_of_years_in_relation }}</td><td ng-if=\"report.assessment.tool.type.basic_sme\">{{ player.percent_sold_to_customer }}</td></tr></table><hr><h3 translate=\"\">Promotor, NGO, Capacity Builder, BDS provider</h3><table class=\"table table-striped\"><tr><th translate=\"\">Name</th><th translate=\"\">Relation to PO</th><th translate=\"\">Description of relation</th><th>#<translate>years in relation</translate></th></tr><tr ng-repeat=\"player in report.assessment.enablingplayers.objects\"><td>{{ player.customer === \'OTHER\' ? player.other : player.customer }}</td><td>{{ player.display_relation_to_producing_organization }}</td><td>{{ player.description_of_relation }}</td><td>{{ player.number_of_years_in_relation }}</td></tr></table></div>");
$templateCache.put("score-builder/partials/conditional-on.html","<article class=\"conditionalOn\" ng-if=\"$ctrl.questions.length\"><label for=\"conditional-{{$ctrl.index}}\"><input type=\"checkbox\" id=\"conditional-{{$ctrl.index}}\" ng-change=\"$ctrl.updateQuestion(\'is_conditional\')\" ng-model=\"$ctrl.question.is_conditional\"> &nbsp;<translate>Is conditional on</translate></label><select class=\"form-control\" ng-model=\"$ctrl.selectedQuestion\" ng-change=\"$ctrl.updateOptions()\" ng-options=\"question as question.title for question in $ctrl.questions\" ng-disabled=\"!$ctrl.question.is_conditional\"><option value=\"\" selected=\"\" translate=\"\">Question</option></select><div translate=\"\">Having Value</div><select class=\"form-control\" ng-model=\"$ctrl.question.conditional_subquestion_option\" ng-change=\"$ctrl.updateQuestion(\'conditional_subquestion_option\')\" ng-options=\"option.url as option.title for option in $ctrl.options.objects\" ng-disabled=\"!$ctrl.options.objects.length\"><option value=\"\" selected=\"\" translate=\"\">Options</option></select><div><label for=\"conditional-{{$ctrl.index}}\"><input type=\"checkbox\" id=\"conditional-{{$ctrl.index}}\" ng-change=\"$ctrl.updateQuestion(\'not_relevant_is_hidden\')\" ng-model=\"$ctrl.question.not_relevant_is_hidden\"> &nbsp;<translate>\"N/R\" Option hidden</translate></label></div></article>");
$templateCache.put("score-builder/partials/option-condition.html","<div class=\"option-condition\"><label><input type=\"checkbox\" ng-model=\"$ctrl.enabled\" ng-change=\"$ctrl.toggle()\" ng-disabled=\"!$ctrl.option.id || $ctrl.saving\"> &nbsp;<span translate=\"\">Is conditional on</span></label><div class=\"option-condition__fields\" ng-if=\"$ctrl.enabled\"><div class=\"form-group\"><label class=\"control-label\" translate=\"\">Source question</label><select class=\"form-control\" ng-model=\"$ctrl.sourceQuestionId\" ng-change=\"$ctrl.onSourceQuestionChange()\" ng-options=\"question.id as $ctrl.questionLabel(question) for question in $ctrl.questions\" ng-disabled=\"$ctrl.saving || $ctrl.loadingSources\"><option value=\"\" translate=\"\">Select a question</option></select><p class=\"text-danger\" ng-if=\"$ctrl.errors.source_question_id\">{{ $ctrl.errors.source_question_id[0] || $ctrl.errors.source_question_id }}</p></div><div class=\"form-group\"><label class=\"control-label\" translate=\"\">Rule</label><select class=\"form-control\" ng-model=\"$ctrl.rule\" ng-change=\"$ctrl.save()\" ng-options=\"rule.value as rule.label for rule in $ctrl.rules\" ng-disabled=\"$ctrl.saving\"></select><p class=\"text-danger\" ng-if=\"$ctrl.errors.rule\">{{ $ctrl.errors.rule[0] || $ctrl.errors.rule }}</p></div><div class=\"form-group\"><label class=\"control-label\" translate=\"\">Source answer option</label><select class=\"form-control\" ng-model=\"$ctrl.sourceOptionId\" ng-change=\"$ctrl.save()\" ng-options=\"option.id as option.title for option in $ctrl.sourceOptions()\" ng-disabled=\"!$ctrl.sourceQuestionId || $ctrl.saving || $ctrl.loadingSources\"><option value=\"\" translate=\"\">Select an answer option</option></select><p class=\"text-danger\" ng-if=\"$ctrl.errors.source_option_id\">{{ $ctrl.errors.source_option_id[0] || $ctrl.errors.source_option_id }}</p></div><p class=\"text-warning\" ng-if=\"$ctrl.hasUnsavedChange()\"><translate>Pick an answer option to save this change. The previous condition still applies.</translate></p></div><p class=\"text-danger\" ng-if=\"$ctrl.errors.detail\">{{ $ctrl.errors.detail }}</p></div>");
$templateCache.put("score-builder/partials/questionSelectorView.html","<section class=\"subquestion-container subquestion-container--animate-add clearfix\" ng-class=\"{deleting: selectorCtrl.deleting}\"><multiple-choice-question ng-if=\"selectorCtrl.question.type === \'mpc\'\" index=\"selectorCtrl.index\" update-fct=\"selectorCtrl.updateFct()\" questions=\"selectorCtrl.questions\" question=\"selectorCtrl.question\" is-canonical-tree=\"selectorCtrl.isCanonicalTree\" tool-types=\"selectorCtrl.toolTypes\" canonical-subquestions=\"selectorCtrl.canonicalSubquestions\" canonical-subquestion-options=\"selectorCtrl.canonicalSubquestionOptions\"></multiple-choice-question><numeric-question ng-if=\"selectorCtrl.question.type === \'numeric\'\" index=\"selectorCtrl.index\" update-fct=\"selectorCtrl.updateFct()\" questions=\"selectorCtrl.questions\" question=\"selectorCtrl.question\" is-canonical-tree=\"selectorCtrl.isCanonicalTree\" tool-types=\"selectorCtrl.toolTypes\" canonical-subquestions=\"selectorCtrl.canonicalSubquestions\" canonical-subquestion-options=\"selectorCtrl.canonicalSubquestionOptions\"></numeric-question><check-box-question ng-if=\"selectorCtrl.question.type === \'checkbox\'\" index=\"selectorCtrl.index\" update-fct=\"selectorCtrl.updateFct()\" questions=\"selectorCtrl.questions\" question=\"selectorCtrl.question\" is-canonical-tree=\"selectorCtrl.isCanonicalTree\" tool-types=\"selectorCtrl.toolTypes\" canonical-subquestions=\"selectorCtrl.canonicalSubquestions\" canonical-subquestion-options=\"selectorCtrl.canonicalSubquestionOptions\"></check-box-question></section>");
$templateCache.put("score-builder/partials/scoreBuilderView.html","<section class=\"row scorebuilder\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"scoreBuilderCtrl.weightOver\"><strong translate=\"\">Weight Error:</strong><translate>Score builder must have a cumulative score of 100%.</translate></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"scoreBuilderCtrl.saveQuestionError\"><strong translate=\"\">Question Error:</strong><translate>Please create and save a question before making subquestions.</translate></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"scoreBuilderCtrl.questionTypeError\"><strong translate=\"\">Type Error:</strong><translate>Score can only be built with a \'scaled\' question type.</translate></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"scoreBuilderCtrl.questionRangeError\"><strong translate=\"\">Question Range Error:</strong><translate>Range is incorrect.</translate></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"scoreBuilderCtrl.scoreInvalid\"><strong translate=\"\">Question Score Error:</strong><translate>Score needs to be between 1 and 5.</translate></div><aside class=\"col-sm-1\"><div class=\"weight__total\" ng-class=\"{over: scoreBuilderCtrl.weightOver}\"><p><span ng-bind=\"scoreBuilderCtrl.totalWeight\"></span> <span>%</span></p></div></aside><main class=\"col-sm-11\"><question-selector ng-repeat=\"question in scoreBuilderCtrl.questions.objects\" index=\"{{ $index }}\" update-fct=\"scoreBuilderCtrl.updateQuestion\" questions=\"scoreBuilderCtrl.questions.objects\" question=\"question\" is-canonical-tree=\"isCanonicalTree\" tool-types=\"toolTypes\" canonical-subquestions=\"canonicalSubquestions\" canonical-subquestion-options=\"canonicalSubquestionOptions\"></question-selector><div class=\"subquestion-container clearfix\"><div class=\"weight__subquestion weight__subquestion--add\" ng-click=\"scoreBuilderCtrl.add()\"><p>+</p></div><div class=\"subquestion__select\"><select class=\"form-control\" ng-model=\"scoreBuilderCtrl.newQuestionType\" ng-model-options=\"{ debounce: { default: 0 } }\" data-placeholder-text-single=\"\'select subquestion\' | translate\" ng-change=\"scoreBuilderCtrl.add()\" ng-options=\"type.display_name for type in scoreBuilderCtrl.questionTypes track by type.type\"></select></div></div></main></section>");}]);
angular.module("scope.ngConstants",[]).constant("apiUrl","https://api.staging.scopeinsight.com").constant("frontendUrls",{dashboard:"https://dashboard.staging.scopeinsight.com",smartclient:"https://app.staging.scopeinsight.com",portal:"https://app.scopeinsight.dunavnet.eu/"});
(function () {

    'use strict';

    angular.module('scope.smartclient.modals', []);

}());

(function() {
    'use strict';

    angular.module('scope.smartclient.modals').factory('allocationsModals', allocationsModals);

    allocationsModals.$inject = [
        '$rootScope',
        '$state',
        '$uibModal',
        '$log',
        'modalFactory',
        'siScope',
        'gettext',
        'EVENT_LOADER',
        'toastr'
    ];

    function allocationsModals(
        $rootScope,
        $state,
        $uibModal,
        $log,
        modalFactory,
        siScope,
        gettext,
        EVENT_LOADER,
        toastr
    ) {
        const service = this;

        service.acceptInvitation = acceptInvitation;
        service.declineInvitation = declineInvitation;

        return service;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function acceptInvitation(invite) {
            let message = gettext('Are you sure you want to accept the invite for the following assessment?');
            let highlight = `${invite.producing_organization_name} - ${invite.tool_type}`;
            return modalFactory.ConfirmModal({
                message,
                highlight,
                actions: [
                    {
                        label: gettext('Yes'),
                        fn: function() {
                            $rootScope.$broadcast(EVENT_LOADER.show);

                            return siScope
                                .post({ url: `${invite.url}accept/` })
                                .catch(err => toastr.error('Error Accepting Invite - ', err))
                                .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide));
                        }
                    }
                ]
            });
        }

        function declineModal(invite) {
            return {
                templateUrl: 'modals/allocations/declineModal.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'invite',
                    function($scope, $uibModalInstance, invite) {
                        $scope.invite = invite;

                        $scope.save = () => $uibModalInstance.close($scope.invite);
                        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    }
                ],
                resolve: {
                    invite: () => invite
                }
            };
        }

        function declineInvitation(invite) {
            return $uibModal.open(declineModal(invite)).result.then(invite => {
                $rootScope.$broadcast(EVENT_LOADER.show);

                const patch = {
                    url: invite.url,
                    status: 'declined',
                    status_reason: invite.status_reason
                };

                return siScope
                    .patch(patch)
                    .catch(err => toastr.error('Error Declining Invite - ', err))
                    .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide));
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.organization', ['ui.router', 'scope.constants']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('base.organization-history', {
            url: '/history/{page:[0-9]*}',
            views: {
                'contentView@base': {
                    templateUrl: 'organization/historyView.html',
                    controller: 'historyController'
                }
            }
        });

        $stateProvider.state('base.organization-details', {
            url: '/organization/{page:[0-9]*}',
            views: {
                'contentView@base': {
                    templateUrl: 'organization/organizationDetailsView.html',
                    controller: 'organizationDetailsController'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.smartclient.organization')
        .controller('organizationDetailsController', organizationDetailsController);

    organizationDetailsController.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$uibModal',
        '$timeout',
        '$window',
        '$q',
        '$sce',
        'gettext',
        '$log',
        'apiUrl',
        'siHrm',
        'siScope',
        'siProducts',
        'siAccounts',
        'siCustomers',
        'EVENT_LOADER',
        'toastr'
    ];

    function organizationDetailsController(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $uibModal,
        $timeout,
        $window,
        $q,
        $sce,
        gettext,
        $log,
        apiUrl,
        siHrm,
        siScope,
        siProducts,
        siAccounts,
        siCustomers,
        EVENT_LOADER,
        toastr
    ) {
        var state = $state.current.name;
        $scope.isSubscriberView = state === 'subscriber-detail';
        // Initially set the customer.producing_organization to show the correct titles while waiting
        $scope.customer = { producing_organization: $state.params.isPo };
        $scope.newComment = { contents: '' };
        $scope.applications = [
            { app: 'dashboard', name: 'SCOPE App' },
            { app: 'smartclient', name: 'SCOPE Dashboard' },
            { app: 'website', name: 'SCOPE Portal' }
        ];
        $scope.changeDirections = [
            { name: 'Increment', value: '+' },
            { name: 'Decrement', value: '-' }
        ];

        var org = $rootScope.me.organization.split('/'); // organization is just a url string
        var orgId = org[org.length - 2]; // trailing dash makes the id the second to last element in the array

        var params = {
            id: orgId,
            fields: [
                // 'state',
                'main_contact',
                'contacts',
                'contacts__user',
                'representatives',
                'duplicate_of',
                'duplicates',
                'is_duplicate',
                'has_duplicates',
                'producing_organization',
                // 'reports__assessment',
                // 'reports__assessment__project',
                'users'
            ]
        };

        var poParams = {
            fields: ['state', 'main_contact', 'main_contact__user', 'producing_organization'],
            producing_organization: true,
            page_size: 999,
            page: $state.params.page || 1
        };

        var customerPromise = siCustomers.getCustomers_Id(params),
            userPromise = siHrm.getUsers(),
            statusesPromise = siProducts.getLegalStatusOptions(),
            sectorsPromise = siCustomers.getSectors(),
            dropdownsPromise = siProducts.getDropDowns();

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([customerPromise, userPromise, statusesPromise, sectorsPromise, dropdownsPromise])
            .then(function(promises) {
                $scope.customer = promises[0];
                $scope.customer.duplicate_bool = !!(
                    $scope.customer &&
                    $scope.customer.duplicate_of &&
                    $scope.customer.duplicate_of.id
                );
                $scope.users = promises[1];
                $scope.statuses = promises[2];
                $scope.sectors = promises[3];
                $scope.dropdown = promises[4];
                //Setup map url
                if ($scope.customer.producing_organization) {
                    $scope.mapurl = $sce.trustAsResourceUrl(
                        'https://www.google.com/maps/embed/v1/place?q=' +
                            $scope.customer.producing_organization.street +
                            ' ' +
                            $scope.customer.producing_organization.street_number +
                            ',+' +
                            $scope.customer.producing_organization.city +
                            ',+' +
                            $scope.customer.producing_organization.country +
                            '&key=AIzaSyB5cGuPodFRQ6g_qT9kHGtIqlJaDcTeBcA'
                    );
                    // Initial run of this method to display the Global region from the start
                    $scope.updateGlobalRegion();
                }
                $scope.customer = setUpUserRoles($scope.customer);

                $rootScope.$broadcast(EVENT_LOADER.hide);

                console.log('Customer - ', $scope.customer);
                console.log('Promises - ', promises);
            })
            .catch(function(err) {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                toastr.error('Error setting up clients detail view controller');
            });

        $scope.$state = $state;
        $scope.saveCustomer = saveCustomer;
        $scope.countries = countries();
        $scope.updateGlobalRegion = updateGlobalRegion;
        $scope.removeReferenceId = removeReferenceId;
        $scope.saveCustomerAndPo = saveCustomerAndPo;
        $scope.saveProducingOrganization = saveProducingOrganization;
        $scope.isChecked = isChecked;
        $scope.setDuplicateAssessee = setDuplicateAssessee;
        $scope.disableCountry = disableCountry;

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
        function disableCountry(param) {
            let check = param || !JSON.parse(localStorage.getItem('ngStorage-user')).info.is_assessor;
            if ($rootScope.app == 'dashboard') {
                check = false;
            }
            return check;
        }

        function setDuplicateAssessee(customerId, activeAssesseeId) {
            if (customerId == activeAssesseeId) {
                return;
            }
            var updatedCustomer = {
                url: apiUrl + '/customers/customers/' + customerId + '/',
                duplicate_of: apiUrl + '/customers/customers/' + activeAssesseeId + '/'
            };

            siScope
                .patch(updatedCustomer)
                .then(function() {
                    _.extend($scope.customer, updatedCustomer);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    toastr.error('Error Saving Customer - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        // function addReferenceId() {
        //     const referenceModal = $uibModal.open({
        //         templateUrl: 'clients/modals/addReference.html',
        //         controller: [
        //             '$uibModalInstance',
        //             'referenceTypes',
        //             function($uibModalInstance, referenceTypes) {
        //                 var vm = this;
        //                 vm.referenceTypes = referenceTypes;
        //                 vm.save = reference => $uibModalInstance.close(reference);
        //                 vm.cancel = () => $uibModalInstance.dismiss('cancel');
        //             }
        //         ],
        //         resolve: {
        //             referenceTypes: () => $scope.referenceTypes
        //         },
        //         controllerAs: '$ctrl'
        //     });

        //     referenceModal.result.then(reference => {
        //         console.log(reference);
        //         $scope.referenceIds.push(reference);
        //         //TODO: save ref.
        //     });
        // }

        function removeReferenceId(id) {
            $scope.referenceIds = $scope.referenceIds.filter(ref => ref.id !== id);
        }

        function isChecked(customer) {
            return customer && customer.duplicate_of && customer.duplicate_of.id;
        }

        function saveCustomer() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            $scope.customer.duplicate_of = $scope.customer.duplicate_bool
                ? `${apiUrl}/customers/customers/${$scope.customer.duplicate_of.id}/`
                : null;

            siScope
                .patch($scope.customer, null, { params: { fields: ['duplicate_of'] } })
                .then(customer => {
                    _.extend($scope.customer, customer);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                })
                .catch(err => {
                    toastr.error('Error Saving Customer - ', err);
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function updateGlobalRegion() {
            var url = $scope.dropdown.countryOptions
                .filter(country => country.display_name === $scope.customer.producing_organization.country)
                .reduce((memo, country) => {
                    $scope.regions = country.subdivisions;
                    return country.global_region;
                }, '');

            var selectedOption = $scope.dropdown.continentOptions.filter(function(continent) {
                return continent.url === url;
            });

            $scope.globalRegion = selectedOption.reduce(function(memo, continent) {
                return continent.display_name;
            }, '');

            $scope.customer.producing_organization.global_region = selectedOption.reduce(function(memo, continent) {
                return continent.name;
            }, '');
        }

        function saveCustomerAndPo() {
            return $q.all([saveCustomer(), saveProducingOrganization()]).catch(() => {
                toastr.error('Error while saving customer and producing organization, please contact administration');
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function saveProducingOrganization() {
            $rootScope.$broadcast(EVENT_LOADER.show);

            siScope.patch($scope.customer.producing_organization).then(updatedInfo => {
                _.extend($scope.customer.producing_organization, updatedInfo);
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });
        }

        function setUpUserRoles(customer) {
            customer.users.forEach(x => {
                x.roles = '';
                x.is_assessor && (x.roles += 'Assessor; ');
                x.is_contact && (x.roles += 'Contact; ');
                x.is_customer_admin && (x.roles += 'Customer Admin; ');
                x.is_customer_user && (x.roles += 'Customer User; ');
                x.is_data_collector && (x.roles += 'Data Collector; ');
                x.is_employee && (x.roles += 'Employee; ');
                x.is_financial_specialist && (x.roles += 'Financial Specialist; ');
                x.is_quality_reviewer && (x.roles += 'Quality Reviewer; ');
                x.is_scope_employee && (x.roles += 'Scope Employee; ');
                x.is_superuser && (x.roles += 'Superuser; ');
            });
            return customer;
        }

        function countries() {
            return [
                'Afghanistan',
                'Aland Islands',
                'Albania',
                'Algeria',
                'American Samoa',
                'Andorra',
                'Angola',
                'Anguilla',
                'Antarctica',
                'Antigua And Barbuda',
                'Argentina',
                'Armenia',
                'Aruba',
                'Australia',
                'Austria',
                'Azerbaijan',
                'Bahamas',
                'Bahrain',
                'Bangladesh',
                'Barbados',
                'Belarus',
                'Belgium',
                'Belize',
                'Benin',
                'Bermuda',
                'Bhutan',
                'Bolivia, Plurinational State of',
                'Bonaire, Sint Eustatius and Saba',
                'Bosnia and Herzegovina',
                'Botswana',
                'Bouvet Island',
                'Brazil',
                'British Indian Ocean Territory',
                'Brunei Darussalam',
                'Bulgaria',
                'Burkina Faso',
                'Burundi',
                'Cambodia',
                'Cameroon',
                'Canada',
                'Cape Verde',
                'Cayman Islands',
                'Central African Republic',
                'Chad',
                'Chile',
                'China',
                'Christmas Island',
                'Cocos (Keeling) Islands',
                'Colombia',
                'Comoros',
                'Congo',
                'Congo, the Democratic Republic of the',
                'Cook Islands',
                'Costa Rica',
                "Côte d'Ivoire",
                'Croatia',
                'Cuba',
                'Cyprus',
                'Czech Republic',
                'Denmark',
                'Djibouti',
                'Dominica',
                'Dominican Republic',
                'Ecuador',
                'Egypt',
                'El Salvador',
                'Equatorial Guinea',
                'Eritrea',
                'Estonia',
                'Ethiopia',
                'Falkland Islands (Malvinas)',
                'Faroe Islands',
                'Fiji',
                'Finland',
                'France',
                'French Guiana',
                'French Polynesia',
                'French Southern Territories',
                'Gabon',
                'Gambia',
                'Georgia',
                'Germany',
                'Ghana',
                'Gibraltar',
                'Greece',
                'Greenland',
                'Grenada',
                'Guadeloupe',
                'Guam',
                'Guatemala',
                'Guernsey',
                'Guinea',
                'Guinea-Bissau',
                'Guyana',
                'Haiti',
                'Heard Island and McDonald Islands',
                'Holy See (Vatican City State)',
                'Honduras',
                'Hong Kong',
                'Hungary',
                'Iceland',
                'India',
                'Indonesia',
                'Iran, Islamic Republic of',
                'Iraq',
                'Ireland',
                'Isle of Man',
                'Israel',
                'Italy',
                'Jamaica',
                'Japan',
                'Jersey',
                'Jordan',
                'Kazakhstan',
                'Kenya',
                'Kiribati',
                "Korea, Democratic People's Republic of",
                'Korea, Republic of',
                'Kuwait',
                'Kyrgyzstan',
                "Lao People's Democratic Republic",
                'Latvia',
                'Lebanon',
                'Lesotho',
                'Liberia',
                'Libya',
                'Liechtenstein',
                'Lithuania',
                'Luxembourg',
                'Macao',
                'Macedonia, The Former Yugoslav Republic Of',
                'Madagascar',
                'Malawi',
                'Malaysia',
                'Maldives',
                'Mali',
                'Malta',
                'Marshall Islands',
                'Martinique',
                'Mauritania',
                'Mauritius',
                'Mayotte',
                'Mexico',
                'Micronesia, Federated States of',
                'Moldova, Republic of',
                'Monaco',
                'Mongolia',
                'Montenegro',
                'Montserrat',
                'Morocco',
                'Mozambique',
                'Myanmar',
                'Namibia',
                'Nauru',
                'Nepal',
                'Netherlands',
                'New Caledonia',
                'New Zealand',
                'Nicaragua',
                'Niger',
                'Nigeria',
                'Niue',
                'Norfolk Island',
                'Northern Mariana Islands',
                'Norway',
                'Oman',
                'Pakistan',
                'Palau',
                'Palestinian Territory, Occupied',
                'Panama',
                'Papua New Guinea',
                'Paraguay',
                'Peru',
                'Philippines',
                'Pitcairn',
                'Poland',
                'Portugal',
                'Puerto Rico',
                'Qatar',
                'Reunion',
                'Romania',
                'Russian Federation',
                'Rwanda',
                'Saint Barthelemy',
                'Saint Helena, Ascension and Tristan da Cunha',
                'Saint Kitts and Nevis',
                'Saint Lucia',
                'Saint Martin (French Part)',
                'Saint Pierre and Miquelon',
                'Saint Vincent and the Grenadines',
                'Samoa',
                'San Marino',
                'Sao Tome and Principe',
                'Saudi Arabia',
                'Senegal',
                'Serbia',
                'Seychelles',
                'Sierra Leone',
                'Singapore',
                'Sint Maarten (Dutch Part)',
                'Slovakia',
                'Slovenia',
                'Solomon Islands',
                'Somalia',
                'South Africa',
                'South Georgia and the South Sandwich Islands',
                'South Sudan',
                'Spain',
                'Sri Lanka',
                'Sudan',
                'Suriname',
                'Svalbard and Jan Mayen',
                'Swaziland',
                'Sweden',
                'Switzerland',
                'Syrian Arab Republic',
                'Taiwan, Province of China',
                'Tajikistan',
                'Tanzania, United Republic of',
                'Thailand',
                'Timor-Leste',
                'Togo',
                'Tokelau',
                'Tonga',
                'Trinidad and Tobago',
                'Tunisia',
                'Turkey',
                'Turkmenistan',
                'Turks and Caicos Islands',
                'Tuvalu',
                'Uganda',
                'Ukraine',
                'United Arab Emirates',
                'United Kingdom',
                'United States',
                'United States Minor Outlying Islands',
                'Uruguay',
                'Uzbekistan',
                'Vanuatu',
                'Venezuela, Bolivarian Republic of',
                'Viet Nam',
                'Virgin Islands, British',
                'Virgin Islands, U.S.',
                'Wallis and Futuna',
                'Western Sahara',
                'Yemen',
                'Zambia',
                'Zimbabwe'
            ];
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.organization').controller('historyController', historyController);

    historyController.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$uibModal',
        '$timeout',
        '$window',
        '$q',
        '$sce',
        'gettext',
        '$log',
        'apiUrl',
        'siHrm',
        'siScope',
        'siProducts',
        'siAccounts',
        'siCustomers',
        'EVENT_LOADER',
        'toastr'
    ];

    function historyController(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $uibModal,
        $timeout,
        $window,
        $q,
        $sce,
        gettext,
        $log,
        apiUrl,
        siHrm,
        siScope,
        siProducts,
        siAccounts,
        siCustomers,
        EVENT_LOADER,
        toastr
    ) {
        var state = $state.current.name;
        // Initially set the customer.producing_organization to show the correct titles while waiting
        $scope.customer = { producing_organization: $state.params.isPo };

        var org = $rootScope.me.organization.split('/'); // organization is just a url string
        var orgId = org[org.length - 2]; // trailing dash makes the id the second to last element in the array
        var params = {
            id: orgId,
            fields: [
                // 'state',
                // 'main_contact',
                // 'contacts',
                // 'contacts__user',
                // 'representatives',
                // 'duplicate_of',
                // 'duplicates',
                // 'is_duplicate',
                // 'has_duplicates',
                // 'producing_organization',
                // 'projects'
                // 'projects__owner',
                // 'projects__owner__user',
                'reports'
                // 'reports__assessment',
                // 'reports__assessment__project'
                // 'comments',
                // 'comments__user',
                // 'assessments'
                // 'users'
            ],
            page: 1,
            page_size: 20
        };

        var customerPromise = siCustomers.getCustomers_Id(params);

        $rootScope.$broadcast(EVENT_LOADER.show);

        $q.all([customerPromise])
            .then(function(promises) {
                $scope.customer = promises[0];
                $scope.customer.duplicate_bool = !!(
                    $scope.customer &&
                    $scope.customer.duplicate_of &&
                    $scope.customer.duplicate_of.id
                );

                $rootScope.$broadcast(EVENT_LOADER.hide);

                console.log('Customer - ', $scope.customer);
                console.log('Promises - ', promises);
            })
            .catch(function(err) {
                $rootScope.$broadcast(EVENT_LOADER.hide);
                toastr.error('Error setting up Organization History');
            });

        function gotoAssignment(assessment) {
            if (assessment.assignment_id.length) {
                $state.go('base.assessments-assignment-detail.assessment', { id: assessment.assignment_id[0] });
            }
        }
    }
})();

(function () {

    'use strict';

    angular.module('scope.smartclient.navigation', ['ui.router'])
        .config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('navigation', {
                url: '/navigation',
                templateUrl: 'navigation/navigationView.html'
            });
    }

}());

(function() {
    'use strict';

    angular.module('scope.smartclient.home', ['ui.router', 'scope.constants']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('base.home', {
            url: '/home/{page:[0-9]*}',
            views: {
                'contentView@base': {
                    templateUrl: 'home/homeView.html',
                    controller: 'homeController'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.home').controller('homeController', homeController);

    homeController.$inject = [
        '$rootScope',
        '$scope',
        '$log',
        '$state',
        'toastr',
        'allocationsModals',
        'offline',
        'EVENT_LOADER',
        'siAssessments',
        '$uibModal',
        'siScope',
        'apiUrl',
        'modalFactory',
        'gettext',
        '$window'
    ];

    function homeController(
        $rootScope,
        $scope,
        $log,
        $state,
        toastr,
        allocationsModals,
        offline,
        EVENT_LOADER,
        siAssessments,
        $uibModal,
        siScope,
        apiUrl,
        modalFactory,
        gettext,
        $window
    ) {
        $scope.getInvitations = getInvitations;
        $scope.clickRow = clickRow;

        var id = $rootScope.me ? $rootScope.me.id : null;

        var params = {
            assessor_user_id: id,
            ordering: 'id',
            filter: {
                //todo: implement filtering in API by Erwin
                deadline_at__gte: Date.now()
            },
            page: $state.params.page || 1
        };

        $scope.assignments = {};
        $scope.allocationsModals = allocationsModals;

        $rootScope.$broadcast(EVENT_LOADER.show);

        siAssessments
            .getAssessments(params)
            .then((assignments = { results: [] }) => {
                $rootScope.$broadcast(EVENT_LOADER.hide);

                if (assignments.results.length === 0 && offline.isOffline) {
                    toastr.error(
                        'You are working currently offline and information on this page has not been downloaded.'
                    );
                    return;
                }

                $scope.assignments.results = assignments.results;
            })
            .catch(function() {
                toastr.error('Error while fetching assessments.');
                $rootScope.$broadcast(EVENT_LOADER.hide);
            });

        // Get invitations when loading page
        $scope.getInvitations();

        function getInvitations() {
            // get open invitations
            return siAssessments
                .getAssessmentInvitations({
                    status: 'new',
                    page_size: 50,
                    ordering: '-id'
                })
                .then(function(res) {
                    $scope.pendingInvitations = res;
                });
        }

        $scope.acceptInvite = function(invite) {
            allocationsModals
                .acceptInvitation(invite)
                .result.then(function(res) {
                    $scope.assignments.results.push(res);
                    $scope.getInvitations().then(function() {
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                })
                .catch(() => {
                    toastr.error('Error while accepting invite.');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        $scope.declineInvite = function(invite) {
            allocationsModals
                .declineInvitation(invite)
                .then(function() {
                    $scope.getInvitations().then(function() {
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                })
                .catch(() => {
                    toastr.error('Error while declining invite.');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        $scope.addSelfAssessment = assessment => {
            // $scope.assessmentErrorMessage = false;
            // if ($scope.project.customer.assessments_count > $scope.project.customer.maximum_number_of_assessments) {
            //     alert(
            //         'You have reached the maximum number of assessments available in your account. To continue using our service, please reach out to your account manager to purchase additional assessments. They will be happy to assist you in finding the best plan for your needs.'
            //     );
            //     return;
            // }
            console.log($rootScope.me);
            if (selfAssessmentsCap()) {
                toastr.warning('You have reached the maximum number of self assessments for your organization.');
            } else {
                $uibModal
                    .open({
                        templateUrl: 'home/modals/addSelfAssessmentView.html',
                        controller: 'addSelfAssessmentController',
                        size: 'lg',
                        resolve: {
                            project: () => $scope.project,
                            assessment: () => assessment,
                            tools: () => $scope.tools,
                            countries: () => $scope.dropdowns
                        }
                    })
                    .result.then(ax => {
                        $rootScope.$broadcast(EVENT_LOADER.show);
                        createNewAssessment(ax);
                    });
            }
        };

        function selfAssessmentsCap() {
            const myAssessments = $rootScope.me.assessor.assessmentinvitations.length;
            return myAssessments >= $rootScope.me.self_assessments_limit;
        }

        function createNewAssessment(assessment) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            assessment.project = assessment.project.url;
            console.log($scope.me);

            return siScope
                .create(assessment, assessment.url, {
                    params: {
                        fields: ['producing_organization', 'tool', 'tool__type']
                    }
                })
                .then(assessment => {
                    let invite = {
                        assessment: assessment.url,
                        assessor: $scope.me.assessor.url,
                        assigned_as: 'assessor',
                        url: apiUrl + '/assessments/assessment_invitations/'
                    };

                    siScope.post(invite).then(res => {
                        $rootScope.$broadcast(EVENT_LOADER.hide);

                        modalFactory.ConfirmModal({
                            message: gettext(
                                'Your Rapid check has been successfully created. Please note that it may take a moment for the invitation to appear in your account. Kindly refresh your page after a few minutes.'
                            ),
                            actions: [
                                {
                                    label: gettext('Ok'),
                                    fn: function() {
                                        $window.location.reload();
                                    }
                                }
                            ]
                        });
                    });
                })
                .catch(err => {
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                    toastr.error(err.data.detail);
                    $window.location.reload();
                });
        }

        //COPIED clickRow and handleReportRedirect from assessmentListController
        //in order to redirect to report if assessment status is has_final or has_draft
        function clickRow(assignment) {
            console.log(assignment);
            const { status, id } = assignment;
            if ($rootScope.app === 'smartclient') {
                if (status === 'has_final' || status === 'has_draft') {
                    return handleReportRedirect(assignment.assessment);
                }

                return $state.go('base.assessments-assignment-detail.assessment', {
                    id
                });
            }
        }

        function handleReportRedirect(assessment) {
            // if (assessment.tool_type === 'SCOPE Rapid') {
            //     $state.go('base.assessments-rapid-final.summary', { id: assessment.id });
            // } else {
            const url = assessment.reports[0];
            const id = /(\d+)(?!.*\d)/.exec(url)[1];
            // Statuses Draft & Final
            //SOme hacky code to fix assessments that might have been "hacked" unlocked.
            if (!assessment.locked_for_employee || !assessment.locked_for_assessor) {
                siScope.patch({
                    url: assessment.url,
                    locked_for_employee: true,
                    locked_for_assessor: true
                });
            }

            $state.go('base.reports-detail.summary', { id: id });
            // }
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.home').controller('addSelfAssessmentController', addSelfAssessmentController);

    addSelfAssessmentController.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$uibModal',
        'project',
        'tools',
        'EVENT_LOADER',
        '$log',
        'apiUrl',
        '$timeout',
        'siCustomers',
        'siProducts',
        'siProjects',
        'countries',
        'LANGUAGES',
        'assessment',
        'siScope',
        'toastr',
        'me'
    ];

    function addSelfAssessmentController(
        $scope,
        $rootScope,
        $uibModalInstance,
        $uibModal,
        project,
        tools,
        EVENT_LOADER,
        $log,
        apiUrl,
        $timeout,
        siCustomers,
        siProducts,
        siProjects,
        countries,
        LANGUAGES,
        assessment,
        siScope,
        toastr,
        me
    ) {
        console.log('Assessment - ', assessment);

        $scope.project = project;
        $scope.tools = tools;
        $scope.countries = countries;
        $scope.assessment = {
            second_party: false,
            producing_organization: {}
        };
        $scope.languages = LANGUAGES;
        $scope.showInfo = false;
        $scope.showSearchResults = false;
        $scope.assessee = {};

        $scope.save = save;
        $scope.cancel = cancel;
        $scope.isPast = isPast;
        $scope.doSearch = doSearch;
        $scope.toggleSelectPO = toggleSelectPO;
        $scope.resetSelection = resetSelection;
        // $scope.addUser = addUser;
        $scope.isPOSelected = isPOSelected;
        $scope.hasProjectSelected = hasProjectSelected;

        if (assessment && assessment.id) {
            $scope.assessee = assessment.id
                ? { name: assessment.producing_organization.name, country: assessment.producing_organization.country }
                : {};
            $scope.assessment = assessment;
            doSearch($scope.assessee);
        }

        // Init functions
        getWhitelistedTools();
        getSelfOrganization();

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Method Declarations
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        function getWhitelistedTools() {
            $rootScope.$broadcast(EVENT_LOADER.show);
            try {
                siProducts.getTools({ page_size: 9999, visible: 1, whitelisted: true }).then(res => {
                    $scope.tools = res.results;
                    getProjects();
                });
            } catch (error) {
                toastr.error('Error while fetching whitelisted tools');
            }
        }

        function getSelfOrganization() {
            return siScope.getItem($scope.me.organization).then(res => {
                $scope.selfOrganization = res.producing_organization;
            });
        }

        function getProjects(params) {
            siProjects.projects
                .one()
                .get({ whitelisted: true })
                .then(function(res) {
                    $scope.projects = res.results;
                    console.log($scope.projects);
                })
                .then(() => {
                    setUpAssessmentObject();
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        }

        function setUpAssessmentObject() {
            $scope.assessment = {
                language: $scope.languages[2],
                tool: $scope.tools[0]
            };
        }

        function save(assessment) {
            //timeout as the model from ui-bootstrap is a slow fuck to update
            $timeout(() => {
                if (isPast(assessment.date)) {
                    return;
                }

                if (!$scope.selfOrganization) {
                    toastr.error('Your organization is not an Assessee, please contact administration');
                    return;
                }

                var create = {
                    date: assessment.date,
                    language: assessment.language.id,
                    url: `${apiUrl}/assessments/assessments/`,
                    producing_organization: $scope.selfOrganization,
                    project: assessment.project
                };

                // if (!create.id) {
                //     delete create.id;
                // }

                // if ($scope.isUserAdded) {
                //     create.isUserAdded = true;
                // }

                const assessmentObject = _.extend(create, { tool: assessment.tool });

                $uibModalInstance.close(assessmentObject);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function isPast(d) {
            return moment(d).isBefore(moment().format('YYYY-MM-DD'));
        }

        function isPOSelected(po) {
            return $scope.assessment.producing_organization.id === po.id;
        }

        function toggleSelectPO(po) {
            $scope.assessment.producing_organization = isPOSelected(po) ? {} : po;
        }

        function hasProjectSelected(assessment) {
            return Object.keys(assessment.project).length > 0;
        }

        function resetSelection(assessment) {
            $scope.showSearchResults = false;
            assessment.producing_organization = {};
        }

        // function addUser() {
        //     if ($scope.isUserAdded) {
        //         return ($scope.isUserAdded = false);
        //     }
        //     $scope.assessment.producing_organization = {};

        //     $rootScope.$broadcast(EVENT_LOADER.show);
        //     siCustomers
        //         .getPOs({
        //             name: $scope.assessee.name,
        //             country: $scope.assessee.country,
        //             fields: ['customer']
        //         })
        //         .then(res => {
        //             $rootScope.$broadcast(EVENT_LOADER.hide);

        //             if (res && res.results && res.results.length) {
        //                 duplicateUserModal(res.results[0]);
        //             } else {
        //                 adddUserModal();
        //             }
        //             //User is new
        //         });
        // }

        // function duplicateUserModal(duplicate) {
        //     $uibModal
        //         .open({
        //             templateUrl: 'projects/templates/modals/duplicateAssessee.html',
        //             controller: 'duplicateUserController',
        //             resolve: {
        //                 tools: () => $scope.tools,
        //                 assessee: () => Object.assign({}, $scope.assessee),
        //                 duplicate: () => duplicate,
        //                 assessment: () => $scope.assessment,
        //                 modal1: () => $uibModalInstance
        //             }
        //         })
        //         .result.then(adddUserModal);
        // }

        // function adddUserModal() {
        //     $uibModal
        //         .open({
        //             templateUrl: 'projects/templates/modals/addAssesseeDetailModal(1b).html',
        //             controller: 'addAssesseeDetailController',
        //             resolve: {
        //                 assessee: () => Object.assign({}, $scope.assessee),
        //                 countries: () => $scope.countries,
        //                 modal1: () => $uibModalInstance
        //             }
        //         })
        //         .result.then(assessee => {
        //             $scope.isUserAdded = true;
        //             $scope.assessee = assessee;
        //             $scope.assessment.producing_organization = assessee;

        //             // Automatically continue to step 2 if step 1 is complete
        //             if ($scope.assessmentForm.$valid && hasPOSelected($scope.assessment)) {
        //                 save($scope.assessment);
        //             }
        //         });
        // }

        function doSearch(search) {
            $scope.isUserAdded = false;
            if (!search.country) {
                return;
            }

            const debouncedSearch = _.debounce(
                () => {
                    siCustomers.getPOs(params).then(res => {
                        $scope.showSearchResults = true;
                        $scope.pos = res.results;
                    });
                },
                250,
                { maxWait: 1000 }
            );

            const params = Object.assign(search, {
                fields: ['customer'],
                page_size: 20
            });

            return debouncedSearch();
        }
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.downloads', ['ui.router']).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('base.downloads', {
            url: '/downloads/{page:[0-9]*}',
            views: {
                'contentView@base': {
                    templateUrl: 'downloads/downloads-view.html',
                    controller: 'DownloadsController',
                    controllerAs: '$ctrl'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope.smartclient.downloads').controller('DownloadsController', DownloadsController);

    DownloadsController.$inject = ['me', '$uibModal', '$http', 'siScope', 'apiUrl', 'toastr'];

    function DownloadsController(me, $uibModal, $http, siScope, apiUrl, toastr) {
        const vm = this;

        siScope.getList(`${apiUrl}/files/fileset/?fields=files`).then(files => {
            if (!files) {
                return toastr.error(
                    'You are working currently offline and information on this page has not been downloaded.'
                );
            }
            return me.getMe().then(({ language } = 'en') => {
                vm.documents = files.results.map(document => {
                    document.displayFile = getDefaultDoc(document, language);
                    return document;
                });
            });
        });

        function getDefaultDoc(document, language) {
            return document.files.objects
                .filter(file => file.language === language)
                .reduce((memo, file) => file, document.files[0]);
        }

        vm.download = document => {
            if (document.objects.length > 1) {
                const modal = $uibModal.open({
                    templateUrl: 'downloads/downloads-modal.html',
                    controller: [
                        '$uibModalInstance',
                        'document',
                        function($uibModalInstance, document) {
                            const vm = this;
                            vm.document = document;
                            vm.download = document => $uibModalInstance.close(document);
                            vm.cancel = () => $uibModalInstance.dismiss();
                        }
                    ],
                    controllerAs: '$ctrl',
                    resolve: {
                        document: () => document
                    }
                });

                modal.result.then(document => downloadFile(document));
            } else {
                downloadFile(document.objects[0]);
            }
        };

        function downloadFile({ file, file_name, mime_type }) {
            $http({
                method: 'GET',
                url: file,
                responseType: 'arraybuffer',
                params: { noAuth: true }
            })
                .then(({ data }) => {
                    try {
                        const blob = new Blob([data], { type: mime_type });
                        saveAs(blob, file_name);
                    } catch (e) {
                        console.log(e);
                    }
                })
                .catch(data => toastr.error('Error while downloading file.'));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('scope.base', ['ui.router'])
        .config(config)
        .run(run);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('base', {
            url: '',
            abstract: true,
            views: {
                '': {
                    templateUrl: 'base/base.html'
                },
                'headerView@base': {
                    templateUrl: 'components/header/headerView.html',
                    controller: 'headerController'
                },
                'navigationView@base': {
                    templateUrl: 'navigation/navigationView.html'
                },

                'footerView@base': {
                    templateUrl: 'components/footer/footerView.html',
                    controller: 'footerController'
                }
            }
        });
    }

    run.$inject = [
        '$rootScope',
        '$state',
        '$localStorage',
        '$timeout',
        'defaultLocalStorageValue',
        'authenticationService',
        'me',
        'APP',
        'offline',
        'toastr',
        'siServiceWorker'
    ];

    function run(
        $rootScope,
        $state,
        $localStorage,
        $timeout,
        defaultLocalStorageValue,
        authenticationService,
        me,
        APP,
        offline,
        toastr,
        siServiceWorker
    ) {
        console.time('START APP');

        $rootScope.$state = $state;
        $rootScope.app = 'smartclient';
        $rootScope.isSmartClient = true;
        $rootScope.title = 'SCOPE App';
        $rootScope.isOffline = !navigator.onLine;
        $rootScope.toaster = false;
        $rootScope.sw = {};
        $rootScope.isOffline = offline.isOffline;

        $rootScope.isLocal = location.href.indexOf('localhost') > -1;
        $rootScope.isTrainee = location.href.indexOf('trainee') > -1;
        $rootScope.isDev = location.href.indexOf('dev') > -1;
        $rootScope.isTest = location.href.indexOf('test') > -1;

        if (location.protocol === 'http:' && location.hostname !== 'localhost') {
            location = 'https://' + location.host + '/' + location.hash;
        }

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $rootScope.$on(APP.offline, function() {
            $rootScope.isOffline = true;
            toastr.error('Working in offline mode', 'Application Status');
        });
        $rootScope.$on(APP.online, function() {
            $rootScope.isOffline = false;
            toastr.success('Working in online mode', 'Application Status');
        });

        $localStorage.$default(defaultLocalStorageValue);

        authenticationService.startListeners();

        $rootScope.appready = true;

        if (location.protocol === 'https:' && location.hostname !== 'localhost') {
            siServiceWorker.startWorking();
        }

        console.timeEnd('START APP');
    }
})();

(function () {

    'use strict';

    angular.module('scope.smartclient.allocations', [])
        .config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('base.allocations', {
                url: '/allocations',
                views: {
                    'contentView@base': {
                        templateUrl: 'allocations/allocationsView.html',
                        controller: 'allocationsController'
                    }
                }
            })
            .state('base.allocations-invitations-decline', {
                url: '/allocations/invitations/decline/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'allocations/allocationsInvitationsDeclineView.html',
                        controller: 'allocationsController',
                    }
                }
            })
            .state('base.allocations-invitations-accept', {
                url: '/allocations/invitations/accept/{id:[0-9]+}',
                views: {
                    'contentView@base': {
                        templateUrl: 'allocations/allocationsInvitationsAcceptView.html',
                        controller: 'allocationsController'
                    }
                }
            });
    }

}());

(function() {
    'use strict';

    angular.module('scope.smartclient.allocations').controller('allocationsController', allocationsController);

    allocationsController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$q',
        '$log',
        '$stateParams',
        'offline',
        'toastr',
        'EVENT_LOADER',
        'APP',
        'siScope',
        'siAssessments',
        'siAllocations',
        'allocationsModals',
        'apiUrl'
    ];

    function allocationsController(
        $rootScope,
        $scope,
        $state,
        $q,
        $log,
        $stateParams,
        offline,
        toastr,
        EVENT_LOADER,
        APP,
        siScope,
        siAssessments,
        siAllocations,
        allocationsModals,
        apiUrl
    ) {
        $rootScope.$broadcast(EVENT_LOADER.show);

        $scope.isOffline = offline.isOffline;
        $scope.allocationsModals = allocationsModals;

        const pending = {
            page_size: 50,
            status: 'new',
            ordering: '-id'
        };

        const past = {
            page_size: 50,
            method: 'exclude',
            status: 'new',
            ordering: '-id'
        };

        const invitationParams = {
            id: $stateParams.id
        };

        const invitePromise = siAllocations.getInvitations(invitationParams),
            pendingInvitePromise = siAllocations.getInvitations(pending),
            pastInvitePromise = siAllocations.getInvitations(past);

        $q.all([invitePromise, pendingInvitePromise, pastInvitePromise])
            .then(promises => {
                if (!promises[1] || !promises[2]) {
                    toastr.error(
                        'You are working currently offline and information on this page has not been downloaded.'
                    );
                }
                $scope.invite = promises[0];
                $scope.pendingInvitations = promises[1];
                $scope.pastInvitations = promises[2];

                console.log('Allocations - ', promises);
            })
            .catch(err => toastr.error('Error loading allocations - ', err))
            .finally(() => $rootScope.$broadcast(EVENT_LOADER.hide));

        $scope.acceptInvite = function(invite) {
            allocationsModals
                .acceptInvitation(invite)
                .result.then(() => {
                    invite.status = 'accepted';
                    $scope.pastInvitations.results.push(invite);
                    siAllocations.getInvitations(pending).then(invitations => {
                        $scope.pendingInvitations = invitations;
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                })
                .catch(() => {
                    toastr.error('Error while accepting invite.');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        $scope.declineInvite = function(invite) {
            $rootScope.$broadcast(EVENT_LOADER.show);
            allocationsModals
                .declineInvitation(invite)
                .then(() => {
                    invite.status = 'declined';
                    $scope.pastInvitations.results.push(invite);
                    siAllocations.getInvitations(pending).then(invitations => {
                        $scope.pendingInvitations = invitations;
                        $rootScope.$broadcast(EVENT_LOADER.hide);
                    });
                })
                .catch(() => {
                    toastr.error('Error while declining invite.');
                    $rootScope.$broadcast(EVENT_LOADER.hide);
                });
        };

        /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Event Listeners
         ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

        $scope.$on(APP.online, function() {
            $scope.isOffline = false;
        });

        $scope.$on(APP.offline, function() {
            $scope.isOffline = true;
        });
    }
})();

(function() {
    'use strict';

    angular.module('scope', [
        //3rd Party
        'ui.bootstrap',
        'ui.router',
        'localytics.directives',
        'angular-inview',
        'angularMoment',
        'gettext',
        'ngStorage',
        'angular-jwt',
        'restangular',
        'angularMoment',
        'ngAnimate',
        'toastr',
        'ngRaven',
        // angularDragula(angular),

        //Config
        'scope.config',
        'scope.templates',
        'scope.base',

        //Constants
        'scope.ngConstants',

        //Modules
        'scope.smartclient.modals',
        'scope.smartclient.allocations',
        'scope.smartclient.home',
        'scope.smartclient.navigation',
        'scope.smartclient.downloads',
        'scope.smartclient.organization',

        //Shared Components/Containers
        'scope.commons'
    ]);
})();

(function() {
    angular.module('scope.config', ['scope.ngConstants']).config(config);

    config.$inject = ['$urlRouterProvider', '$interpolateProvider', 'RestangularProvider', 'apiUrl', 'toastrConfig'];

    function config($urlRouterProvider, $interpolateProvider, RestangularProvider, apiUrl, toastrConfig) {
        RestangularProvider.setBaseUrl(apiUrl);
        RestangularProvider.setRequestSuffix('/');

        //TODO: fix for when we get data from the local filesystem weird situation where there is no response.header and restangular gets very upset
        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
            response.headers = response.headers ? response.headers : angular.noop;
            if (response.status >= 400) {
                return deferred.reject(data);
            }
            return data;
        });

        angular.extend(toastrConfig, {
            positionClass: 'toast-top-center'
        });

        $urlRouterProvider.otherwise(function($injector) {
            var authenticationService = $injector.get('authenticationService');
            return authenticationService.isLoggedIn() ? '/home/' : '/login';
        });
    }
})();
